webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return epsilon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return epsilon2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return pi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return halfPi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return quarterPi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return tau; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return degrees; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return radians; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return abs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return atan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return atan2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return cos; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return ceil; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return exp; });
/* unused harmony export floor */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return log; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return pow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return sin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return sign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return sqrt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return tan; });
/* harmony export (immutable) */ __webpack_exports__["r"] = acos;
/* harmony export (immutable) */ __webpack_exports__["f"] = asin;
/* harmony export (immutable) */ __webpack_exports__["u"] = haversin;
var epsilon = 1e-6;
var epsilon2 = 1e-12;
var pi = Math.PI;
var halfPi = pi / 2;
var quarterPi = pi / 4;
var tau = pi * 2;

var degrees = 180 / pi;
var radians = pi / 180;

var abs = Math.abs;
var atan = Math.atan;
var atan2 = Math.atan2;
var cos = Math.cos;
var ceil = Math.ceil;
var exp = Math.exp;
var floor = Math.floor;
var log = Math.log;
var pow = Math.pow;
var sin = Math.sin;
var sign = Math.sign || function(x) { return x > 0 ? 1 : x < 0 ? -1 : 0; };
var sqrt = Math.sqrt;
var tan = Math.tan;

function acos(x) {
  return x > 1 ? 0 : x < -1 ? pi : Math.acos(x);
}

function asin(x) {
  return x > 1 ? halfPi : x < -1 ? -halfPi : Math.asin(x);
}

function haversin(x) {
  return (x = sin(x / 2)) * x;
}


/***/ }),
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return UserAuthenticationMessage; });
/* unused harmony export INACTIVITY_TIMEOUT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UserService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_router__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__aws_environment__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__aws_sdk__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mqtt_mqtt_service__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__publisher_message__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__publisher_publisher_service__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__preferences_service__ = __webpack_require__(136);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();







var UserAuthenticationMessageType;
(function (UserAuthenticationMessageType) {
    UserAuthenticationMessageType[UserAuthenticationMessageType["LOGIN"] = 0] = "LOGIN";
    UserAuthenticationMessageType[UserAuthenticationMessageType["LOGOUT"] = 1] = "LOGOUT";
})(UserAuthenticationMessageType || (UserAuthenticationMessageType = {}));
var UserAuthenticationMessage = /** @class */ (function (_super) {
    __extends(UserAuthenticationMessage, _super);
    function UserAuthenticationMessage(user, type) {
        var _this = _super.call(this, user) || this;
        _this.user = user;
        _this.type = type;
        return _this;
    }
    UserAuthenticationMessage.Type = UserAuthenticationMessageType;
    return UserAuthenticationMessage;
}(__WEBPACK_IMPORTED_MODULE_4__publisher_message__["a" /* Message */]));

var INACTIVITY_TIMEOUT = 2 * 60 * 60 * 1000;
var UserService = /** @class */ (function () {
    function UserService(awsEnv, awsSdk, preferencesService, mqtt, router, publisher) {
        this.awsEnv = awsEnv;
        this.awsSdk = awsSdk;
        this.preferencesService = preferencesService;
        this.mqtt = mqtt;
        this.router = router;
        this.publisher = publisher;
        this.sessionStorage = window.sessionStorage;
        this.userAuthenticationChannel = this.publisher.createChannel('user-authentication');
    }
    UserService.prototype.logOut = function () {
        this.currentUser = null;
        this.userAuthenticationChannel.next(new UserAuthenticationMessage(null, UserAuthenticationMessage.Type.LOGOUT));
        if (this.renewCredentialsTimer) {
            clearTimeout(this.renewCredentialsTimer);
            this.renewCredentialsTimer = null;
        }
        this.disableLogoutForInactivity();
        this.clearCredentials();
        this.router.navigate(['/login']);
    };
    UserService.prototype.getCurrentUser = function () {
        return this.currentUser;
    };
    UserService.prototype.updatePreferencesOnCurrentUser = function () {
        return this.preferencesService.update(this.getCurrentUser());
    };
    UserService.prototype.setCurrentUser = function (user, isTrial) {
        var _this = this;
        return this.awsSdk.getTempCredentials(user.Email, user.RoleArn, user.Cognito.Token)
            .then(function (data) {
            _this.currentUser = user;
            _this.setAwsCredentials(data);
            _this.updatePreferencesOnCurrentUser().subscribe(function (result) { });
            _this.sessionStorage.setItem('currentUser', JSON.stringify(_this.currentUser));
            _this.connectToMQTT();
            _this.enableLogoutForInactivity();
            _this.userAuthenticationChannel.next(new UserAuthenticationMessage(user, UserAuthenticationMessage.Type.LOGIN));
        })
            .catch(function (error) {
            console.error('Cannot get aws credentials ' + error);
            throw error;
        });
    };
    UserService.prototype.connectToMQTT = function () {
        // this.mqtt.connect(this.crtUser).subscribe(
        //     (connected: boolean) => { },
        //     (error: string) => {
        //         //try to reconnect on error
        //         setTimeout(() => {
        //             if (this.isLoggedIn()) {
        //                 this.connectToMQTT();
        //             }
        //         }, 1000);
        //     },
        //     () => {
        //     });
    };
    UserService.prototype.isLoggedIn = function () {
        return this.currentUser != null;
    };
    UserService.prototype.getApiUrl = function () {
        var baseUrl = this.currentUser.ApiServiceUrl;
        return baseUrl + "/" + this.currentUser.Cognito.IdentityId;
    };
    UserService.prototype.updateFromStorage = function () {
        var storageCrtUser = JSON.parse(this.sessionStorage.getItem('currentUser'));
        var storageCredentials = JSON.parse(this.sessionStorage.getItem('credentials'));
        if (storageCrtUser && storageCredentials) {
            this.currentUser = storageCrtUser;
            this.awsEnv.setCredentials(storageCredentials.accessKeyId, storageCredentials.secretAccessKey, storageCredentials.sessionToken, new Date(storageCredentials.expireDate));
            this.scheduleToRenewAwsCredentials();
            /* TODO: maybe use the same setCurrentUser? Unify storage and normal login */
            this.connectToMQTT();
            this.enableLogoutForInactivity();
            return true;
        }
        return false;
    };
    UserService.prototype.setAwsCredentials = function (responseData) {
        this.awsEnv.setCredentials(responseData.Credentials.AccessKeyId, responseData.Credentials.SecretAccessKey, responseData.Credentials.SessionToken, responseData.Credentials.Expiration);
        this.sessionStorage.setItem('credentials', JSON.stringify(this.awsEnv.getCredentials()));
        this.scheduleToRenewAwsCredentials();
    };
    UserService.prototype.scheduleToRenewAwsCredentials = function () {
        var _this = this;
        if (!this.awsEnv.getCredentials() || !this.currentUser) {
            return;
        }
        var timeLeft = this.awsEnv.getCredentials().expireDate.getTime() - new Date().getTime();
        if (timeLeft < 0) {
            console.error('[UserService] - credentilas expired, too late to renew, logging out');
            this.logOut();
        }
        else if (timeLeft < 30 * 60 * 1000) {
            console.log('[UserService] - Starting AWS credentials renewal' + new Date());
            return this.awsSdk.renewCredentials(this.currentUser.Email, this.currentUser.RoleArn, this.awsEnv.getCredentials())
                .then(function (data) {
                _this.setAwsCredentials(data);
                console.info('[UserService] - AWS credentials were renewed' + new Date());
            })
                .catch(function (error) {
                console.error('[UserService] - Cannot renew aws credentials ' + error);
                _this.logOut();
            });
        }
        else {
            this.renewCredentialsTimer = setTimeout(function () { _this.scheduleToRenewAwsCredentials(); }, 60 * 1000);
        }
    };
    UserService.prototype.clearCredentials = function () {
        // at this moment only credentials we keep on window
        this.sessionStorage.clear();
        this.awsEnv.clearCredentials();
    };
    UserService.prototype.enableLogoutForInactivity = function () {
        var _this = this;
        UserService.resetInactivityTimer(this);
        // DOM Events
        document.onmousedown = (function () { return UserService.resetInactivityTimer(_this); });
        document.onkeypress = (function () { return UserService.resetInactivityTimer(_this); });
    };
    UserService.prototype.disableLogoutForInactivity = function () {
        if (UserService.inactivityTimer) {
            clearTimeout(UserService.inactivityTimer);
            UserService.inactivityTimer = null;
        }
        // DOM Events
        document.onmousedown = null;
        document.onkeypress = null;
    };
    UserService.resetInactivityTimer = function (userService) {
        if (UserService.inactivityTimer) {
            clearTimeout(UserService.inactivityTimer);
            UserService.inactivityTimer = null;
        }
        UserService.inactivityTimer = setTimeout(function () {
            console.info('[UserService] - Logging out due to inactivity' + new Date());
            userService.logOut();
        }, INACTIVITY_TIMEOUT);
    };
    UserService.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_1__aws_environment__["a" /* AwsEnvironment */] }, { type: __WEBPACK_IMPORTED_MODULE_2__aws_sdk__["a" /* AwsSdk */] }, { type: __WEBPACK_IMPORTED_MODULE_6__preferences_service__["a" /* UserPreferencesService */] }, { type: __WEBPACK_IMPORTED_MODULE_3__mqtt_mqtt_service__["a" /* MQTTService */] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_router__["a" /* Router */] }, { type: __WEBPACK_IMPORTED_MODULE_5__publisher_publisher_service__["a" /* PublisherService */] }]; };
    UserService.inactivityTimer = null;
    return UserService;
}());

//# sourceMappingURL=user.service.js.map

/***/ }),
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_creator__ = __webpack_require__(253);
/* unused harmony reexport creator */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_local__ = __webpack_require__(986);
/* unused harmony reexport local */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_matcher__ = __webpack_require__(431);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_2__src_matcher__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_mouse__ = __webpack_require__(987);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__src_mouse__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_namespace__ = __webpack_require__(254);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_4__src_namespace__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_namespaces__ = __webpack_require__(255);
/* unused harmony reexport namespaces */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_point__ = __webpack_require__(157);
/* unused harmony reexport clientPoint */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_select__ = __webpack_require__(988);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_7__src_select__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_selectAll__ = __webpack_require__(989);
/* unused harmony reexport selectAll */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_selection_index__ = __webpack_require__(43);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_9__src_selection_index__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_selector__ = __webpack_require__(257);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_10__src_selector__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_selectorAll__ = __webpack_require__(435);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_11__src_selectorAll__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_selection_style__ = __webpack_require__(434);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_12__src_selection_style__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_touch__ = __webpack_require__(1016);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_13__src_touch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_touches__ = __webpack_require__(1017);
/* unused harmony reexport touches */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__src_window__ = __webpack_require__(259);
/* unused harmony reexport window */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__src_selection_on__ = __webpack_require__(256);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_16__src_selection_on__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_16__src_selection_on__["b"]; });



















/***/ }),
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AwsEnvironment; });
/* harmony export (immutable) */ __webpack_exports__["b"] = createAwsEnv;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__credentials__ = __webpack_require__(570);

var AwsEnvironment = /** @class */ (function () {
    function AwsEnvironment() {
    }
    AwsEnvironment.prototype.load = function () {
        var _this = this;
        var xhr = new XMLHttpRequest();
        xhr.onload = function (ev) {
            if (xhr.readyState == 4) {
                if (xhr.status == 200) {
                    var response = JSON.parse(xhr.responseText);
                    _this.iotRegion = response['iot-region'];
                    _this.apiRegion = response['apigateway-region'];
                    _this.registrationUrl = 'https://' + response.registrationUrl;
                    _this.apiUrl = 'https://' + response.apiUrl;
                    _this.defaultSourceRegion = response['default-source-region'];
                    _this.signupUrl = response['signup-url'];
                    _this.forgotPasswordUrl = response['forgot-password-url'];
                    _this.enableIpValidation = response['enable-ip-validation'];
                    _this.showFreeTrial = response['show-free-trial'];
                    _this.showRegCode = response['show-reg-code'];
                    _this.showPromoCode = response['show-promo-code'];
                }
                else {
                    console.error(xhr.statusText);
                }
            }
        };
        xhr.onerror = function (ev) {
            console.error(xhr.statusText);
        };
        xhr.open('GET', 'aws-env.json', false);
        xhr.send();
    };
    AwsEnvironment.prototype.getRegistrationUrl = function () {
        return this.registrationUrl;
    };
    AwsEnvironment.prototype.getApiUrl = function () {
        return this.apiUrl;
    };
    AwsEnvironment.prototype.getIotRegion = function () {
        return this.iotRegion;
    };
    AwsEnvironment.prototype.getApiRegion = function () {
        return this.apiRegion;
    };
    AwsEnvironment.prototype.getDefaultSourceRegion = function () {
        return this.defaultSourceRegion;
    };
    AwsEnvironment.prototype.getCredentials = function () {
        return this.credentials;
    };
    AwsEnvironment.prototype.isProduction = function () {
        return (window.location.hostname === 'breakingpoint.cloud' || window.location.hostname === 'www.breakingpoint.cloud');
    };
    /*
    isSandbox(): boolean {
        return (window.location.hostname === 'ixia-sandbox.cloud' || window.location.hostname === 'www.ixia-sandbox.cloud')
    }
    */
    AwsEnvironment.prototype.setCredentials = function (accessKeyId, secretAccessKey, sessionToken, expireDate) {
        this.credentials = new __WEBPACK_IMPORTED_MODULE_0__credentials__["a" /* Credentials */]();
        this.credentials.accessKeyId = accessKeyId;
        this.credentials.secretAccessKey = secretAccessKey;
        this.credentials.sessionToken = sessionToken;
        this.credentials.expireDate = expireDate;
    };
    AwsEnvironment.prototype.clearCredentials = function () {
        this.credentials = null;
    };
    AwsEnvironment.prototype.getSignupUrl = function () {
        return this.signupUrl;
    };
    AwsEnvironment.prototype.getForgotPasswordUrl = function () {
        return this.forgotPasswordUrl;
    };
    AwsEnvironment.prototype.isIpValidationEnabled = function () {
        return this.enableIpValidation;
    };
    AwsEnvironment.prototype.getShowFreeTrial = function () {
        return this.showFreeTrial;
    };
    AwsEnvironment.prototype.getShowRegCode = function () {
        return this.showRegCode;
    };
    AwsEnvironment.prototype.getShowPromoCode = function () {
        return this.showPromoCode;
    };
    return AwsEnvironment;
}());

function createAwsEnv() {
    var awsEnv = new AwsEnvironment();
    awsEnv.load();
    return awsEnv;
}
;
//# sourceMappingURL=environment.js.map

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = newInterval;
var t0 = new Date,
    t1 = new Date;

function newInterval(floori, offseti, count, field) {

  function interval(date) {
    return floori(date = new Date(+date)), date;
  }

  interval.floor = interval;

  interval.ceil = function(date) {
    return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
  };

  interval.round = function(date) {
    var d0 = interval(date),
        d1 = interval.ceil(date);
    return date - d0 < d1 - date ? d0 : d1;
  };

  interval.offset = function(date, step) {
    return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
  };

  interval.range = function(start, stop, step) {
    var range = [], previous;
    start = interval.ceil(start);
    step = step == null ? 1 : Math.floor(step);
    if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
    do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
    while (previous < start && start < stop);
    return range;
  };

  interval.filter = function(test) {
    return newInterval(function(date) {
      if (date >= date) while (floori(date), !test(date)) date.setTime(date - 1);
    }, function(date, step) {
      if (date >= date) {
        if (step < 0) while (++step <= 0) {
          while (offseti(date, -1), !test(date)) {} // eslint-disable-line no-empty
        } else while (--step >= 0) {
          while (offseti(date, +1), !test(date)) {} // eslint-disable-line no-empty
        }
      }
    });
  };

  if (count) {
    interval.count = function(start, end) {
      t0.setTime(+start), t1.setTime(+end);
      floori(t0), floori(t1);
      return Math.floor(count(t0, t1));
    };

    interval.every = function(step) {
      step = Math.floor(step);
      return !isFinite(step) || !(step > 0) ? null
          : !(step > 1) ? interval
          : interval.filter(field
              ? function(d) { return field(d) % step === 0; }
              : function(d) { return interval.count(0, d) % step === 0; });
    };
  }

  return interval;
}


/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return styles; });
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */
var styles = ['html[_ngcontent-%COMP%] {\n  font-family: sans-serif;\n  -webkit-text-size-adjust: 100%;\n      -ms-text-size-adjust: 100%;\n}\nbody[_ngcontent-%COMP%] {\n  margin: 0;\n}\narticle[_ngcontent-%COMP%], aside[_ngcontent-%COMP%], details[_ngcontent-%COMP%], figcaption[_ngcontent-%COMP%], figure[_ngcontent-%COMP%], footer[_ngcontent-%COMP%], header[_ngcontent-%COMP%], hgroup[_ngcontent-%COMP%], main[_ngcontent-%COMP%], menu[_ngcontent-%COMP%], nav[_ngcontent-%COMP%], section[_ngcontent-%COMP%], summary[_ngcontent-%COMP%] {\n  display: block;\n}\naudio[_ngcontent-%COMP%], canvas[_ngcontent-%COMP%], progress[_ngcontent-%COMP%], video[_ngcontent-%COMP%] {\n  display: inline-block;\n  vertical-align: baseline;\n}\naudio[_ngcontent-%COMP%]:not([controls]) {\n  display: none;\n  height: 0;\n}\n[hidden][_ngcontent-%COMP%], template[_ngcontent-%COMP%] {\n  display: none;\n}\na[_ngcontent-%COMP%] {\n  background-color: transparent;\n}\na[_ngcontent-%COMP%]:active, a[_ngcontent-%COMP%]:hover {\n  outline: 0;\n}\nabbr[title][_ngcontent-%COMP%] {\n  border-bottom: 1px dotted;\n}\nb[_ngcontent-%COMP%], strong[_ngcontent-%COMP%] {\n  font-weight: bold;\n}\ndfn[_ngcontent-%COMP%] {\n  font-style: italic;\n}\nh1[_ngcontent-%COMP%] {\n  margin: .67em 0;\n  font-size: 2em;\n}\nmark[_ngcontent-%COMP%] {\n  color: #000;\n  background: #ff0;\n}\nsmall[_ngcontent-%COMP%] {\n  font-size: 80%;\n}\nsub[_ngcontent-%COMP%], sup[_ngcontent-%COMP%] {\n  position: relative;\n  font-size: 75%;\n  line-height: 0;\n  vertical-align: baseline;\n}\nsup[_ngcontent-%COMP%] {\n  top: -.5em;\n}\nsub[_ngcontent-%COMP%] {\n  bottom: -.25em;\n}\nimg[_ngcontent-%COMP%] {\n  border: 0;\n}\nsvg[_ngcontent-%COMP%]:not(:root) {\n  overflow: hidden;\n}\nfigure[_ngcontent-%COMP%] {\n  margin: 1em 40px;\n}\nhr[_ngcontent-%COMP%] {\n  height: 0;\n  -webkit-box-sizing: content-box;\n     -moz-box-sizing: content-box;\n          box-sizing: content-box;\n}\npre[_ngcontent-%COMP%] {\n  overflow: auto;\n}\ncode[_ngcontent-%COMP%], kbd[_ngcontent-%COMP%], pre[_ngcontent-%COMP%], samp[_ngcontent-%COMP%] {\n  font-family: monospace, monospace;\n  font-size: 1em;\n}\nbutton[_ngcontent-%COMP%], input[_ngcontent-%COMP%], optgroup[_ngcontent-%COMP%], select[_ngcontent-%COMP%], textarea[_ngcontent-%COMP%] {\n  margin: 0;\n  font: inherit;\n  color: inherit;\n}\nbutton[_ngcontent-%COMP%] {\n  overflow: visible;\n}\nbutton[_ngcontent-%COMP%], select[_ngcontent-%COMP%] {\n  text-transform: none;\n}\nbutton[_ngcontent-%COMP%], html[_ngcontent-%COMP%]   input[type="button"][_ngcontent-%COMP%], input[type="reset"][_ngcontent-%COMP%], input[type="submit"][_ngcontent-%COMP%] {\n  -webkit-appearance: button;\n  cursor: pointer;\n}\nbutton[disabled][_ngcontent-%COMP%], html[_ngcontent-%COMP%]   input[disabled][_ngcontent-%COMP%] {\n  cursor: default;\n}\nbutton[_ngcontent-%COMP%]::-moz-focus-inner, input[_ngcontent-%COMP%]::-moz-focus-inner {\n  padding: 0;\n  border: 0;\n}\ninput[_ngcontent-%COMP%] {\n  line-height: normal;\n}\ninput[type="checkbox"][_ngcontent-%COMP%], input[type="radio"][_ngcontent-%COMP%] {\n  -webkit-box-sizing: border-box;\n     -moz-box-sizing: border-box;\n          box-sizing: border-box;\n  padding: 0;\n}\ninput[type="number"][_ngcontent-%COMP%]::-webkit-inner-spin-button, input[type="number"][_ngcontent-%COMP%]::-webkit-outer-spin-button {\n  height: auto;\n}\ninput[type="search"][_ngcontent-%COMP%] {\n  -webkit-box-sizing: content-box;\n     -moz-box-sizing: content-box;\n          box-sizing: content-box;\n  -webkit-appearance: textfield;\n}\ninput[type="search"][_ngcontent-%COMP%]::-webkit-search-cancel-button, input[type="search"][_ngcontent-%COMP%]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\nfieldset[_ngcontent-%COMP%] {\n  padding: .35em .625em .75em;\n  margin: 0 2px;\n  border: 1px solid #c0c0c0;\n}\nlegend[_ngcontent-%COMP%] {\n  padding: 0;\n  border: 0;\n}\ntextarea[_ngcontent-%COMP%] {\n  overflow: auto;\n}\noptgroup[_ngcontent-%COMP%] {\n  font-weight: bold;\n}\ntable[_ngcontent-%COMP%] {\n  border-spacing: 0;\n  border-collapse: collapse;\n}\ntd[_ngcontent-%COMP%], th[_ngcontent-%COMP%] {\n  padding: 0;\n}\n\n@media print {\n  *[_ngcontent-%COMP%], *[_ngcontent-%COMP%]:before, *[_ngcontent-%COMP%]:after {\n    color: #000 !important;\n    text-shadow: none !important;\n    background: transparent !important;\n    -webkit-box-shadow: none !important;\n            box-shadow: none !important;\n  }\n  a[_ngcontent-%COMP%], a[_ngcontent-%COMP%]:visited {\n    text-decoration: underline;\n  }\n  a[href][_ngcontent-%COMP%]:after {\n    content: " (" attr(href) ")";\n  }\n  abbr[title][_ngcontent-%COMP%]:after {\n    content: " (" attr(title) ")";\n  }\n  a[href^="#"][_ngcontent-%COMP%]:after, a[href^="javascript:"][_ngcontent-%COMP%]:after {\n    content: "";\n  }\n  pre[_ngcontent-%COMP%], blockquote[_ngcontent-%COMP%] {\n    border: 1px solid #999;\n\n    page-break-inside: avoid;\n  }\n  thead[_ngcontent-%COMP%] {\n    display: table-header-group;\n  }\n  tr[_ngcontent-%COMP%], img[_ngcontent-%COMP%] {\n    page-break-inside: avoid;\n  }\n  img[_ngcontent-%COMP%] {\n    max-width: 100% !important;\n  }\n  p[_ngcontent-%COMP%], h2[_ngcontent-%COMP%], h3[_ngcontent-%COMP%] {\n    orphans: 3;\n    widows: 3;\n  }\n  h2[_ngcontent-%COMP%], h3[_ngcontent-%COMP%] {\n    page-break-after: avoid;\n  }\n  .navbar[_ngcontent-%COMP%] {\n    display: none;\n  }\n  .btn[_ngcontent-%COMP%]    > .caret[_ngcontent-%COMP%], .dropup[_ngcontent-%COMP%]    > .btn[_ngcontent-%COMP%]    > .caret[_ngcontent-%COMP%] {\n    border-top-color: #000 !important;\n  }\n  .label[_ngcontent-%COMP%] {\n    border: 1px solid #000;\n  }\n  .table[_ngcontent-%COMP%] {\n    border-collapse: collapse !important;\n  }\n  .table[_ngcontent-%COMP%]   td[_ngcontent-%COMP%], .table[_ngcontent-%COMP%]   th[_ngcontent-%COMP%] {\n    background-color: #fff !important;\n  }\n  .table-bordered[_ngcontent-%COMP%]   th[_ngcontent-%COMP%], .table-bordered[_ngcontent-%COMP%]   td[_ngcontent-%COMP%] {\n    border: 1px solid #ddd !important;\n  }\n}\n@font-face {\n  font-family: \'Glyphicons Halflings\';\n\n  src: url(\'../fonts/glyphicons-halflings-regular.eot\');\n  src: url(\'../fonts/glyphicons-halflings-regular.eot?#iefix\') format(\'embedded-opentype\'), url(\'../fonts/glyphicons-halflings-regular.woff2\') format(\'woff2\'), url(\'../fonts/glyphicons-halflings-regular.woff\') format(\'woff\'), url(\'../fonts/glyphicons-halflings-regular.ttf\') format(\'truetype\'), url(\'../fonts/glyphicons-halflings-regular.svg#glyphicons_halflingsregular\') format(\'svg\');\n}\n.glyphicon[_ngcontent-%COMP%] {\n  position: relative;\n  top: 1px;\n  display: inline-block;\n  font-family: \'Glyphicons Halflings\';\n  font-style: normal;\n  font-weight: normal;\n  line-height: 1;\n\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n.glyphicon-asterisk[_ngcontent-%COMP%]:before {\n  content: "\\002a";\n}\n.glyphicon-plus[_ngcontent-%COMP%]:before {\n  content: "\\002b";\n}\n.glyphicon-euro[_ngcontent-%COMP%]:before, .glyphicon-eur[_ngcontent-%COMP%]:before {\n  content: "\\20ac";\n}\n.glyphicon-minus[_ngcontent-%COMP%]:before {\n  content: "\\2212";\n}\n.glyphicon-cloud[_ngcontent-%COMP%]:before {\n  content: "\\2601";\n}\n.glyphicon-envelope[_ngcontent-%COMP%]:before {\n  content: "\\2709";\n}\n.glyphicon-pencil[_ngcontent-%COMP%]:before {\n  content: "\\270f";\n}\n.glyphicon-glass[_ngcontent-%COMP%]:before {\n  content: "\\e001";\n}\n.glyphicon-music[_ngcontent-%COMP%]:before {\n  content: "\\e002";\n}\n.glyphicon-search[_ngcontent-%COMP%]:before {\n  content: "\\e003";\n}\n.glyphicon-heart[_ngcontent-%COMP%]:before {\n  content: "\\e005";\n}\n.glyphicon-star[_ngcontent-%COMP%]:before {\n  content: "\\e006";\n}\n.glyphicon-star-empty[_ngcontent-%COMP%]:before {\n  content: "\\e007";\n}\n.glyphicon-user[_ngcontent-%COMP%]:before {\n  content: "\\e008";\n}\n.glyphicon-film[_ngcontent-%COMP%]:before {\n  content: "\\e009";\n}\n.glyphicon-th-large[_ngcontent-%COMP%]:before {\n  content: "\\e010";\n}\n.glyphicon-th[_ngcontent-%COMP%]:before {\n  content: "\\e011";\n}\n.glyphicon-th-list[_ngcontent-%COMP%]:before {\n  content: "\\e012";\n}\n.glyphicon-ok[_ngcontent-%COMP%]:before {\n  content: "\\e013";\n}\n.glyphicon-remove[_ngcontent-%COMP%]:before {\n  content: "\\e014";\n}\n.glyphicon-zoom-in[_ngcontent-%COMP%]:before {\n  content: "\\e015";\n}\n.glyphicon-zoom-out[_ngcontent-%COMP%]:before {\n  content: "\\e016";\n}\n.glyphicon-off[_ngcontent-%COMP%]:before {\n  content: "\\e017";\n}\n.glyphicon-signal[_ngcontent-%COMP%]:before {\n  content: "\\e018";\n}\n.glyphicon-cog[_ngcontent-%COMP%]:before {\n  content: "\\e019";\n}\n.glyphicon-trash[_ngcontent-%COMP%]:before {\n  content: "\\e020";\n}\n.glyphicon-home[_ngcontent-%COMP%]:before {\n  content: "\\e021";\n}\n.glyphicon-file[_ngcontent-%COMP%]:before {\n  content: "\\e022";\n}\n.glyphicon-time[_ngcontent-%COMP%]:before {\n  content: "\\e023";\n}\n.glyphicon-road[_ngcontent-%COMP%]:before {\n  content: "\\e024";\n}\n.glyphicon-download-alt[_ngcontent-%COMP%]:before {\n  content: "\\e025";\n}\n.glyphicon-download[_ngcontent-%COMP%]:before {\n  content: "\\e026";\n}\n.glyphicon-upload[_ngcontent-%COMP%]:before {\n  content: "\\e027";\n}\n.glyphicon-inbox[_ngcontent-%COMP%]:before {\n  content: "\\e028";\n}\n.glyphicon-play-circle[_ngcontent-%COMP%]:before {\n  content: "\\e029";\n}\n.glyphicon-repeat[_ngcontent-%COMP%]:before {\n  content: "\\e030";\n}\n.glyphicon-refresh[_ngcontent-%COMP%]:before {\n  content: "\\e031";\n}\n.glyphicon-list-alt[_ngcontent-%COMP%]:before {\n  content: "\\e032";\n}\n.glyphicon-lock[_ngcontent-%COMP%]:before {\n  content: "\\e033";\n}\n.glyphicon-flag[_ngcontent-%COMP%]:before {\n  content: "\\e034";\n}\n.glyphicon-headphones[_ngcontent-%COMP%]:before {\n  content: "\\e035";\n}\n.glyphicon-volume-off[_ngcontent-%COMP%]:before {\n  content: "\\e036";\n}\n.glyphicon-volume-down[_ngcontent-%COMP%]:before {\n  content: "\\e037";\n}\n.glyphicon-volume-up[_ngcontent-%COMP%]:before {\n  content: "\\e038";\n}\n.glyphicon-qrcode[_ngcontent-%COMP%]:before {\n  content: "\\e039";\n}\n.glyphicon-barcode[_ngcontent-%COMP%]:before {\n  content: "\\e040";\n}\n.glyphicon-tag[_ngcontent-%COMP%]:before {\n  content: "\\e041";\n}\n.glyphicon-tags[_ngcontent-%COMP%]:before {\n  content: "\\e042";\n}\n.glyphicon-book[_ngcontent-%COMP%]:before {\n  content: "\\e043";\n}\n.glyphicon-bookmark[_ngcontent-%COMP%]:before {\n  content: "\\e044";\n}\n.glyphicon-print[_ngcontent-%COMP%]:before {\n  content: "\\e045";\n}\n.glyphicon-camera[_ngcontent-%COMP%]:before {\n  content: "\\e046";\n}\n.glyphicon-font[_ngcontent-%COMP%]:before {\n  content: "\\e047";\n}\n.glyphicon-bold[_ngcontent-%COMP%]:before {\n  content: "\\e048";\n}\n.glyphicon-italic[_ngcontent-%COMP%]:before {\n  content: "\\e049";\n}\n.glyphicon-text-height[_ngcontent-%COMP%]:before {\n  content: "\\e050";\n}\n.glyphicon-text-width[_ngcontent-%COMP%]:before {\n  content: "\\e051";\n}\n.glyphicon-align-left[_ngcontent-%COMP%]:before {\n  content: "\\e052";\n}\n.glyphicon-align-center[_ngcontent-%COMP%]:before {\n  content: "\\e053";\n}\n.glyphicon-align-right[_ngcontent-%COMP%]:before {\n  content: "\\e054";\n}\n.glyphicon-align-justify[_ngcontent-%COMP%]:before {\n  content: "\\e055";\n}\n.glyphicon-list[_ngcontent-%COMP%]:before {\n  content: "\\e056";\n}\n.glyphicon-indent-left[_ngcontent-%COMP%]:before {\n  content: "\\e057";\n}\n.glyphicon-indent-right[_ngcontent-%COMP%]:before {\n  content: "\\e058";\n}\n.glyphicon-facetime-video[_ngcontent-%COMP%]:before {\n  content: "\\e059";\n}\n.glyphicon-picture[_ngcontent-%COMP%]:before {\n  content: "\\e060";\n}\n.glyphicon-map-marker[_ngcontent-%COMP%]:before {\n  content: "\\e062";\n}\n.glyphicon-adjust[_ngcontent-%COMP%]:before {\n  content: "\\e063";\n}\n.glyphicon-tint[_ngcontent-%COMP%]:before {\n  content: "\\e064";\n}\n.glyphicon-edit[_ngcontent-%COMP%]:before {\n  content: "\\e065";\n}\n.glyphicon-share[_ngcontent-%COMP%]:before {\n  content: "\\e066";\n}\n.glyphicon-check[_ngcontent-%COMP%]:before {\n  content: "\\e067";\n}\n.glyphicon-move[_ngcontent-%COMP%]:before {\n  content: "\\e068";\n}\n.glyphicon-step-backward[_ngcontent-%COMP%]:before {\n  content: "\\e069";\n}\n.glyphicon-fast-backward[_ngcontent-%COMP%]:before {\n  content: "\\e070";\n}\n.glyphicon-backward[_ngcontent-%COMP%]:before {\n  content: "\\e071";\n}\n.glyphicon-play[_ngcontent-%COMP%]:before {\n  content: "\\e072";\n}\n.glyphicon-pause[_ngcontent-%COMP%]:before {\n  content: "\\e073";\n}\n.glyphicon-stop[_ngcontent-%COMP%]:before {\n  content: "\\e074";\n}\n.glyphicon-forward[_ngcontent-%COMP%]:before {\n  content: "\\e075";\n}\n.glyphicon-fast-forward[_ngcontent-%COMP%]:before {\n  content: "\\e076";\n}\n.glyphicon-step-forward[_ngcontent-%COMP%]:before {\n  content: "\\e077";\n}\n.glyphicon-eject[_ngcontent-%COMP%]:before {\n  content: "\\e078";\n}\n.glyphicon-chevron-left[_ngcontent-%COMP%]:before {\n  content: "\\e079";\n}\n.glyphicon-chevron-right[_ngcontent-%COMP%]:before {\n  content: "\\e080";\n}\n.glyphicon-plus-sign[_ngcontent-%COMP%]:before {\n  content: "\\e081";\n}\n.glyphicon-minus-sign[_ngcontent-%COMP%]:before {\n  content: "\\e082";\n}\n.glyphicon-remove-sign[_ngcontent-%COMP%]:before {\n  content: "\\e083";\n}\n.glyphicon-ok-sign[_ngcontent-%COMP%]:before {\n  content: "\\e084";\n}\n.glyphicon-question-sign[_ngcontent-%COMP%]:before {\n  content: "\\e085";\n}\n.glyphicon-info-sign[_ngcontent-%COMP%]:before {\n  content: "\\e086";\n}\n.glyphicon-screenshot[_ngcontent-%COMP%]:before {\n  content: "\\e087";\n}\n.glyphicon-remove-circle[_ngcontent-%COMP%]:before {\n  content: "\\e088";\n}\n.glyphicon-ok-circle[_ngcontent-%COMP%]:before {\n  content: "\\e089";\n}\n.glyphicon-ban-circle[_ngcontent-%COMP%]:before {\n  content: "\\e090";\n}\n.glyphicon-arrow-left[_ngcontent-%COMP%]:before {\n  content: "\\e091";\n}\n.glyphicon-arrow-right[_ngcontent-%COMP%]:before {\n  content: "\\e092";\n}\n.glyphicon-arrow-up[_ngcontent-%COMP%]:before {\n  content: "\\e093";\n}\n.glyphicon-arrow-down[_ngcontent-%COMP%]:before {\n  content: "\\e094";\n}\n.glyphicon-share-alt[_ngcontent-%COMP%]:before {\n  content: "\\e095";\n}\n.glyphicon-resize-full[_ngcontent-%COMP%]:before {\n  content: "\\e096";\n}\n.glyphicon-resize-small[_ngcontent-%COMP%]:before {\n  content: "\\e097";\n}\n.glyphicon-exclamation-sign[_ngcontent-%COMP%]:before {\n  content: "\\e101";\n}\n.glyphicon-gift[_ngcontent-%COMP%]:before {\n  content: "\\e102";\n}\n.glyphicon-leaf[_ngcontent-%COMP%]:before {\n  content: "\\e103";\n}\n.glyphicon-fire[_ngcontent-%COMP%]:before {\n  content: "\\e104";\n}\n.glyphicon-eye-open[_ngcontent-%COMP%]:before {\n  content: "\\e105";\n}\n.glyphicon-eye-close[_ngcontent-%COMP%]:before {\n  content: "\\e106";\n}\n.glyphicon-warning-sign[_ngcontent-%COMP%]:before {\n  content: "\\e107";\n}\n.glyphicon-plane[_ngcontent-%COMP%]:before {\n  content: "\\e108";\n}\n.glyphicon-calendar[_ngcontent-%COMP%]:before {\n  content: "\\e109";\n}\n.glyphicon-random[_ngcontent-%COMP%]:before {\n  content: "\\e110";\n}\n.glyphicon-comment[_ngcontent-%COMP%]:before {\n  content: "\\e111";\n}\n.glyphicon-magnet[_ngcontent-%COMP%]:before {\n  content: "\\e112";\n}\n.glyphicon-chevron-up[_ngcontent-%COMP%]:before {\n  content: "\\e113";\n}\n.glyphicon-chevron-down[_ngcontent-%COMP%]:before {\n  content: "\\e114";\n}\n.glyphicon-retweet[_ngcontent-%COMP%]:before {\n  content: "\\e115";\n}\n.glyphicon-shopping-cart[_ngcontent-%COMP%]:before {\n  content: "\\e116";\n}\n.glyphicon-folder-close[_ngcontent-%COMP%]:before {\n  content: "\\e117";\n}\n.glyphicon-folder-open[_ngcontent-%COMP%]:before {\n  content: "\\e118";\n}\n.glyphicon-resize-vertical[_ngcontent-%COMP%]:before {\n  content: "\\e119";\n}\n.glyphicon-resize-horizontal[_ngcontent-%COMP%]:before {\n  content: "\\e120";\n}\n.glyphicon-hdd[_ngcontent-%COMP%]:before {\n  content: "\\e121";\n}\n.glyphicon-bullhorn[_ngcontent-%COMP%]:before {\n  content: "\\e122";\n}\n.glyphicon-bell[_ngcontent-%COMP%]:before {\n  content: "\\e123";\n}\n.glyphicon-certificate[_ngcontent-%COMP%]:before {\n  content: "\\e124";\n}\n.glyphicon-thumbs-up[_ngcontent-%COMP%]:before {\n  content: "\\e125";\n}\n.glyphicon-thumbs-down[_ngcontent-%COMP%]:before {\n  content: "\\e126";\n}\n.glyphicon-hand-right[_ngcontent-%COMP%]:before {\n  content: "\\e127";\n}\n.glyphicon-hand-left[_ngcontent-%COMP%]:before {\n  content: "\\e128";\n}\n.glyphicon-hand-up[_ngcontent-%COMP%]:before {\n  content: "\\e129";\n}\n.glyphicon-hand-down[_ngcontent-%COMP%]:before {\n  content: "\\e130";\n}\n.glyphicon-circle-arrow-right[_ngcontent-%COMP%]:before {\n  content: "\\e131";\n}\n.glyphicon-circle-arrow-left[_ngcontent-%COMP%]:before {\n  content: "\\e132";\n}\n.glyphicon-circle-arrow-up[_ngcontent-%COMP%]:before {\n  content: "\\e133";\n}\n.glyphicon-circle-arrow-down[_ngcontent-%COMP%]:before {\n  content: "\\e134";\n}\n.glyphicon-globe[_ngcontent-%COMP%]:before {\n  content: "\\e135";\n}\n.glyphicon-wrench[_ngcontent-%COMP%]:before {\n  content: "\\e136";\n}\n.glyphicon-tasks[_ngcontent-%COMP%]:before {\n  content: "\\e137";\n}\n.glyphicon-filter[_ngcontent-%COMP%]:before {\n  content: "\\e138";\n}\n.glyphicon-briefcase[_ngcontent-%COMP%]:before {\n  content: "\\e139";\n}\n.glyphicon-fullscreen[_ngcontent-%COMP%]:before {\n  content: "\\e140";\n}\n.glyphicon-dashboard[_ngcontent-%COMP%]:before {\n  content: "\\e141";\n}\n.glyphicon-paperclip[_ngcontent-%COMP%]:before {\n  content: "\\e142";\n}\n.glyphicon-heart-empty[_ngcontent-%COMP%]:before {\n  content: "\\e143";\n}\n.glyphicon-link[_ngcontent-%COMP%]:before {\n  content: "\\e144";\n}\n.glyphicon-phone[_ngcontent-%COMP%]:before {\n  content: "\\e145";\n}\n.glyphicon-pushpin[_ngcontent-%COMP%]:before {\n  content: "\\e146";\n}\n.glyphicon-usd[_ngcontent-%COMP%]:before {\n  content: "\\e148";\n}\n.glyphicon-gbp[_ngcontent-%COMP%]:before {\n  content: "\\e149";\n}\n.glyphicon-sort[_ngcontent-%COMP%]:before {\n  content: "\\e150";\n}\n.glyphicon-sort-by-alphabet[_ngcontent-%COMP%]:before {\n  content: "\\e151";\n}\n.glyphicon-sort-by-alphabet-alt[_ngcontent-%COMP%]:before {\n  content: "\\e152";\n}\n.glyphicon-sort-by-order[_ngcontent-%COMP%]:before {\n  content: "\\e153";\n}\n.glyphicon-sort-by-order-alt[_ngcontent-%COMP%]:before {\n  content: "\\e154";\n}\n.glyphicon-sort-by-attributes[_ngcontent-%COMP%]:before {\n  content: "\\e155";\n}\n.glyphicon-sort-by-attributes-alt[_ngcontent-%COMP%]:before {\n  content: "\\e156";\n}\n.glyphicon-unchecked[_ngcontent-%COMP%]:before {\n  content: "\\e157";\n}\n.glyphicon-expand[_ngcontent-%COMP%]:before {\n  content: "\\e158";\n}\n.glyphicon-collapse-down[_ngcontent-%COMP%]:before {\n  content: "\\e159";\n}\n.glyphicon-collapse-up[_ngcontent-%COMP%]:before {\n  content: "\\e160";\n}\n.glyphicon-log-in[_ngcontent-%COMP%]:before {\n  content: "\\e161";\n}\n.glyphicon-flash[_ngcontent-%COMP%]:before {\n  content: "\\e162";\n}\n.glyphicon-log-out[_ngcontent-%COMP%]:before {\n  content: "\\e163";\n}\n.glyphicon-new-window[_ngcontent-%COMP%]:before {\n  content: "\\e164";\n}\n.glyphicon-record[_ngcontent-%COMP%]:before {\n  content: "\\e165";\n}\n.glyphicon-save[_ngcontent-%COMP%]:before {\n  content: "\\e166";\n}\n.glyphicon-open[_ngcontent-%COMP%]:before {\n  content: "\\e167";\n}\n.glyphicon-saved[_ngcontent-%COMP%]:before {\n  content: "\\e168";\n}\n.glyphicon-import[_ngcontent-%COMP%]:before {\n  content: "\\e169";\n}\n.glyphicon-export[_ngcontent-%COMP%]:before {\n  content: "\\e170";\n}\n.glyphicon-send[_ngcontent-%COMP%]:before {\n  content: "\\e171";\n}\n.glyphicon-floppy-disk[_ngcontent-%COMP%]:before {\n  content: "\\e172";\n}\n.glyphicon-floppy-saved[_ngcontent-%COMP%]:before {\n  content: "\\e173";\n}\n.glyphicon-floppy-remove[_ngcontent-%COMP%]:before {\n  content: "\\e174";\n}\n.glyphicon-floppy-save[_ngcontent-%COMP%]:before {\n  content: "\\e175";\n}\n.glyphicon-floppy-open[_ngcontent-%COMP%]:before {\n  content: "\\e176";\n}\n.glyphicon-credit-card[_ngcontent-%COMP%]:before {\n  content: "\\e177";\n}\n.glyphicon-transfer[_ngcontent-%COMP%]:before {\n  content: "\\e178";\n}\n.glyphicon-cutlery[_ngcontent-%COMP%]:before {\n  content: "\\e179";\n}\n.glyphicon-header[_ngcontent-%COMP%]:before {\n  content: "\\e180";\n}\n.glyphicon-compressed[_ngcontent-%COMP%]:before {\n  content: "\\e181";\n}\n.glyphicon-earphone[_ngcontent-%COMP%]:before {\n  content: "\\e182";\n}\n.glyphicon-phone-alt[_ngcontent-%COMP%]:before {\n  content: "\\e183";\n}\n.glyphicon-tower[_ngcontent-%COMP%]:before {\n  content: "\\e184";\n}\n.glyphicon-stats[_ngcontent-%COMP%]:before {\n  content: "\\e185";\n}\n.glyphicon-sd-video[_ngcontent-%COMP%]:before {\n  content: "\\e186";\n}\n.glyphicon-hd-video[_ngcontent-%COMP%]:before {\n  content: "\\e187";\n}\n.glyphicon-subtitles[_ngcontent-%COMP%]:before {\n  content: "\\e188";\n}\n.glyphicon-sound-stereo[_ngcontent-%COMP%]:before {\n  content: "\\e189";\n}\n.glyphicon-sound-dolby[_ngcontent-%COMP%]:before {\n  content: "\\e190";\n}\n.glyphicon-sound-5-1[_ngcontent-%COMP%]:before {\n  content: "\\e191";\n}\n.glyphicon-sound-6-1[_ngcontent-%COMP%]:before {\n  content: "\\e192";\n}\n.glyphicon-sound-7-1[_ngcontent-%COMP%]:before {\n  content: "\\e193";\n}\n.glyphicon-copyright-mark[_ngcontent-%COMP%]:before {\n  content: "\\e194";\n}\n.glyphicon-registration-mark[_ngcontent-%COMP%]:before {\n  content: "\\e195";\n}\n.glyphicon-cloud-download[_ngcontent-%COMP%]:before {\n  content: "\\e197";\n}\n.glyphicon-cloud-upload[_ngcontent-%COMP%]:before {\n  content: "\\e198";\n}\n.glyphicon-tree-conifer[_ngcontent-%COMP%]:before {\n  content: "\\e199";\n}\n.glyphicon-tree-deciduous[_ngcontent-%COMP%]:before {\n  content: "\\e200";\n}\n.glyphicon-cd[_ngcontent-%COMP%]:before {\n  content: "\\e201";\n}\n.glyphicon-save-file[_ngcontent-%COMP%]:before {\n  content: "\\e202";\n}\n.glyphicon-open-file[_ngcontent-%COMP%]:before {\n  content: "\\e203";\n}\n.glyphicon-level-up[_ngcontent-%COMP%]:before {\n  content: "\\e204";\n}\n.glyphicon-copy[_ngcontent-%COMP%]:before {\n  content: "\\e205";\n}\n.glyphicon-paste[_ngcontent-%COMP%]:before {\n  content: "\\e206";\n}\n.glyphicon-alert[_ngcontent-%COMP%]:before {\n  content: "\\e209";\n}\n.glyphicon-equalizer[_ngcontent-%COMP%]:before {\n  content: "\\e210";\n}\n.glyphicon-king[_ngcontent-%COMP%]:before {\n  content: "\\e211";\n}\n.glyphicon-queen[_ngcontent-%COMP%]:before {\n  content: "\\e212";\n}\n.glyphicon-pawn[_ngcontent-%COMP%]:before {\n  content: "\\e213";\n}\n.glyphicon-bishop[_ngcontent-%COMP%]:before {\n  content: "\\e214";\n}\n.glyphicon-knight[_ngcontent-%COMP%]:before {\n  content: "\\e215";\n}\n.glyphicon-baby-formula[_ngcontent-%COMP%]:before {\n  content: "\\e216";\n}\n.glyphicon-tent[_ngcontent-%COMP%]:before {\n  content: "\\26fa";\n}\n.glyphicon-blackboard[_ngcontent-%COMP%]:before {\n  content: "\\e218";\n}\n.glyphicon-bed[_ngcontent-%COMP%]:before {\n  content: "\\e219";\n}\n.glyphicon-apple[_ngcontent-%COMP%]:before {\n  content: "\\f8ff";\n}\n.glyphicon-erase[_ngcontent-%COMP%]:before {\n  content: "\\e221";\n}\n.glyphicon-hourglass[_ngcontent-%COMP%]:before {\n  content: "\\231b";\n}\n.glyphicon-lamp[_ngcontent-%COMP%]:before {\n  content: "\\e223";\n}\n.glyphicon-duplicate[_ngcontent-%COMP%]:before {\n  content: "\\e224";\n}\n.glyphicon-piggy-bank[_ngcontent-%COMP%]:before {\n  content: "\\e225";\n}\n.glyphicon-scissors[_ngcontent-%COMP%]:before {\n  content: "\\e226";\n}\n.glyphicon-bitcoin[_ngcontent-%COMP%]:before {\n  content: "\\e227";\n}\n.glyphicon-btc[_ngcontent-%COMP%]:before {\n  content: "\\e227";\n}\n.glyphicon-xbt[_ngcontent-%COMP%]:before {\n  content: "\\e227";\n}\n.glyphicon-yen[_ngcontent-%COMP%]:before {\n  content: "\\00a5";\n}\n.glyphicon-jpy[_ngcontent-%COMP%]:before {\n  content: "\\00a5";\n}\n.glyphicon-ruble[_ngcontent-%COMP%]:before {\n  content: "\\20bd";\n}\n.glyphicon-rub[_ngcontent-%COMP%]:before {\n  content: "\\20bd";\n}\n.glyphicon-scale[_ngcontent-%COMP%]:before {\n  content: "\\e230";\n}\n.glyphicon-ice-lolly[_ngcontent-%COMP%]:before {\n  content: "\\e231";\n}\n.glyphicon-ice-lolly-tasted[_ngcontent-%COMP%]:before {\n  content: "\\e232";\n}\n.glyphicon-education[_ngcontent-%COMP%]:before {\n  content: "\\e233";\n}\n.glyphicon-option-horizontal[_ngcontent-%COMP%]:before {\n  content: "\\e234";\n}\n.glyphicon-option-vertical[_ngcontent-%COMP%]:before {\n  content: "\\e235";\n}\n.glyphicon-menu-hamburger[_ngcontent-%COMP%]:before {\n  content: "\\e236";\n}\n.glyphicon-modal-window[_ngcontent-%COMP%]:before {\n  content: "\\e237";\n}\n.glyphicon-oil[_ngcontent-%COMP%]:before {\n  content: "\\e238";\n}\n.glyphicon-grain[_ngcontent-%COMP%]:before {\n  content: "\\e239";\n}\n.glyphicon-sunglasses[_ngcontent-%COMP%]:before {\n  content: "\\e240";\n}\n.glyphicon-text-size[_ngcontent-%COMP%]:before {\n  content: "\\e241";\n}\n.glyphicon-text-color[_ngcontent-%COMP%]:before {\n  content: "\\e242";\n}\n.glyphicon-text-background[_ngcontent-%COMP%]:before {\n  content: "\\e243";\n}\n.glyphicon-object-align-top[_ngcontent-%COMP%]:before {\n  content: "\\e244";\n}\n.glyphicon-object-align-bottom[_ngcontent-%COMP%]:before {\n  content: "\\e245";\n}\n.glyphicon-object-align-horizontal[_ngcontent-%COMP%]:before {\n  content: "\\e246";\n}\n.glyphicon-object-align-left[_ngcontent-%COMP%]:before {\n  content: "\\e247";\n}\n.glyphicon-object-align-vertical[_ngcontent-%COMP%]:before {\n  content: "\\e248";\n}\n.glyphicon-object-align-right[_ngcontent-%COMP%]:before {\n  content: "\\e249";\n}\n.glyphicon-triangle-right[_ngcontent-%COMP%]:before {\n  content: "\\e250";\n}\n.glyphicon-triangle-left[_ngcontent-%COMP%]:before {\n  content: "\\e251";\n}\n.glyphicon-triangle-bottom[_ngcontent-%COMP%]:before {\n  content: "\\e252";\n}\n.glyphicon-triangle-top[_ngcontent-%COMP%]:before {\n  content: "\\e253";\n}\n.glyphicon-console[_ngcontent-%COMP%]:before {\n  content: "\\e254";\n}\n.glyphicon-superscript[_ngcontent-%COMP%]:before {\n  content: "\\e255";\n}\n.glyphicon-subscript[_ngcontent-%COMP%]:before {\n  content: "\\e256";\n}\n.glyphicon-menu-left[_ngcontent-%COMP%]:before {\n  content: "\\e257";\n}\n.glyphicon-menu-right[_ngcontent-%COMP%]:before {\n  content: "\\e258";\n}\n.glyphicon-menu-down[_ngcontent-%COMP%]:before {\n  content: "\\e259";\n}\n.glyphicon-menu-up[_ngcontent-%COMP%]:before {\n  content: "\\e260";\n}\n*[_ngcontent-%COMP%] {\n  -webkit-box-sizing: border-box;\n     -moz-box-sizing: border-box;\n          box-sizing: border-box;\n}\n*[_ngcontent-%COMP%]:before, *[_ngcontent-%COMP%]:after {\n  -webkit-box-sizing: border-box;\n     -moz-box-sizing: border-box;\n          box-sizing: border-box;\n}\nhtml[_ngcontent-%COMP%] {\n  font-size: 10px;\n\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\nbody[_ngcontent-%COMP%] {\n  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;\n  font-size: 14px;\n  line-height: 1.42857143;\n  color: #333;\n  background-color: #fff;\n}\ninput[_ngcontent-%COMP%], button[_ngcontent-%COMP%], select[_ngcontent-%COMP%], textarea[_ngcontent-%COMP%] {\n  font-family: inherit;\n  font-size: inherit;\n  line-height: inherit;\n}\na[_ngcontent-%COMP%] {\n  color: #337ab7;\n  text-decoration: none;\n}\na[_ngcontent-%COMP%]:hover, a[_ngcontent-%COMP%]:focus {\n  color: #23527c;\n  text-decoration: underline;\n}\na[_ngcontent-%COMP%]:focus {\n  outline: 5px auto -webkit-focus-ring-color;\n  outline-offset: -2px;\n}\nfigure[_ngcontent-%COMP%] {\n  margin: 0;\n}\nimg[_ngcontent-%COMP%] {\n  vertical-align: middle;\n}\n.img-responsive[_ngcontent-%COMP%], .thumbnail[_ngcontent-%COMP%]    > img[_ngcontent-%COMP%], .thumbnail[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]    > img[_ngcontent-%COMP%], .carousel-inner[_ngcontent-%COMP%]    > .item[_ngcontent-%COMP%]    > img[_ngcontent-%COMP%], .carousel-inner[_ngcontent-%COMP%]    > .item[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%]    > img[_ngcontent-%COMP%] {\n  display: block;\n  max-width: 100%;\n  height: auto;\n}\n.img-rounded[_ngcontent-%COMP%] {\n  border-radius: 6px;\n}\n.img-thumbnail[_ngcontent-%COMP%] {\n  display: inline-block;\n  max-width: 100%;\n  height: auto;\n  padding: 4px;\n  line-height: 1.42857143;\n  background-color: #fff;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  -webkit-transition: all .2s ease-in-out;\n       -o-transition: all .2s ease-in-out;\n          transition: all .2s ease-in-out;\n}\n.img-circle[_ngcontent-%COMP%] {\n  border-radius: 50%;\n}\nhr[_ngcontent-%COMP%] {\n  margin-top: 20px;\n  margin-bottom: 20px;\n  border: 0;\n  border-top: 1px solid #eee;\n}\n.sr-only[_ngcontent-%COMP%] {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  border: 0;\n}\n.sr-only-focusable[_ngcontent-%COMP%]:active, .sr-only-focusable[_ngcontent-%COMP%]:focus {\n  position: static;\n  width: auto;\n  height: auto;\n  margin: 0;\n  overflow: visible;\n  clip: auto;\n}\n[role="button"][_ngcontent-%COMP%] {\n  cursor: pointer;\n}\nh1[_ngcontent-%COMP%], h2[_ngcontent-%COMP%], h3[_ngcontent-%COMP%], h4[_ngcontent-%COMP%], h5[_ngcontent-%COMP%], h6[_ngcontent-%COMP%], .h1[_ngcontent-%COMP%], .h2[_ngcontent-%COMP%], .h3[_ngcontent-%COMP%], .h4[_ngcontent-%COMP%], .h5[_ngcontent-%COMP%], .h6[_ngcontent-%COMP%] {\n  font-family: inherit;\n  font-weight: 500;\n  line-height: 1.1;\n  color: inherit;\n}\nh1[_ngcontent-%COMP%]   small[_ngcontent-%COMP%], h2[_ngcontent-%COMP%]   small[_ngcontent-%COMP%], h3[_ngcontent-%COMP%]   small[_ngcontent-%COMP%], h4[_ngcontent-%COMP%]   small[_ngcontent-%COMP%], h5[_ngcontent-%COMP%]   small[_ngcontent-%COMP%], h6[_ngcontent-%COMP%]   small[_ngcontent-%COMP%], .h1[_ngcontent-%COMP%]   small[_ngcontent-%COMP%], .h2[_ngcontent-%COMP%]   small[_ngcontent-%COMP%], .h3[_ngcontent-%COMP%]   small[_ngcontent-%COMP%], .h4[_ngcontent-%COMP%]   small[_ngcontent-%COMP%], .h5[_ngcontent-%COMP%]   small[_ngcontent-%COMP%], .h6[_ngcontent-%COMP%]   small[_ngcontent-%COMP%], h1[_ngcontent-%COMP%]   .small[_ngcontent-%COMP%], h2[_ngcontent-%COMP%]   .small[_ngcontent-%COMP%], h3[_ngcontent-%COMP%]   .small[_ngcontent-%COMP%], h4[_ngcontent-%COMP%]   .small[_ngcontent-%COMP%], h5[_ngcontent-%COMP%]   .small[_ngcontent-%COMP%], h6[_ngcontent-%COMP%]   .small[_ngcontent-%COMP%], .h1[_ngcontent-%COMP%]   .small[_ngcontent-%COMP%], .h2[_ngcontent-%COMP%]   .small[_ngcontent-%COMP%], .h3[_ngcontent-%COMP%]   .small[_ngcontent-%COMP%], .h4[_ngcontent-%COMP%]   .small[_ngcontent-%COMP%], .h5[_ngcontent-%COMP%]   .small[_ngcontent-%COMP%], .h6[_ngcontent-%COMP%]   .small[_ngcontent-%COMP%] {\n  font-weight: normal;\n  line-height: 1;\n  color: #777;\n}\nh1[_ngcontent-%COMP%], .h1[_ngcontent-%COMP%], h2[_ngcontent-%COMP%], .h2[_ngcontent-%COMP%], h3[_ngcontent-%COMP%], .h3[_ngcontent-%COMP%] {\n  margin-top: 20px;\n  margin-bottom: 10px;\n}\nh1[_ngcontent-%COMP%]   small[_ngcontent-%COMP%], .h1[_ngcontent-%COMP%]   small[_ngcontent-%COMP%], h2[_ngcontent-%COMP%]   small[_ngcontent-%COMP%], .h2[_ngcontent-%COMP%]   small[_ngcontent-%COMP%], h3[_ngcontent-%COMP%]   small[_ngcontent-%COMP%], .h3[_ngcontent-%COMP%]   small[_ngcontent-%COMP%], h1[_ngcontent-%COMP%]   .small[_ngcontent-%COMP%], .h1[_ngcontent-%COMP%]   .small[_ngcontent-%COMP%], h2[_ngcontent-%COMP%]   .small[_ngcontent-%COMP%], .h2[_ngcontent-%COMP%]   .small[_ngcontent-%COMP%], h3[_ngcontent-%COMP%]   .small[_ngcontent-%COMP%], .h3[_ngcontent-%COMP%]   .small[_ngcontent-%COMP%] {\n  font-size: 65%;\n}\nh4[_ngcontent-%COMP%], .h4[_ngcontent-%COMP%], h5[_ngcontent-%COMP%], .h5[_ngcontent-%COMP%], h6[_ngcontent-%COMP%], .h6[_ngcontent-%COMP%] {\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\nh4[_ngcontent-%COMP%]   small[_ngcontent-%COMP%], .h4[_ngcontent-%COMP%]   small[_ngcontent-%COMP%], h5[_ngcontent-%COMP%]   small[_ngcontent-%COMP%], .h5[_ngcontent-%COMP%]   small[_ngcontent-%COMP%], h6[_ngcontent-%COMP%]   small[_ngcontent-%COMP%], .h6[_ngcontent-%COMP%]   small[_ngcontent-%COMP%], h4[_ngcontent-%COMP%]   .small[_ngcontent-%COMP%], .h4[_ngcontent-%COMP%]   .small[_ngcontent-%COMP%], h5[_ngcontent-%COMP%]   .small[_ngcontent-%COMP%], .h5[_ngcontent-%COMP%]   .small[_ngcontent-%COMP%], h6[_ngcontent-%COMP%]   .small[_ngcontent-%COMP%], .h6[_ngcontent-%COMP%]   .small[_ngcontent-%COMP%] {\n  font-size: 75%;\n}\nh1[_ngcontent-%COMP%], .h1[_ngcontent-%COMP%] {\n  font-size: 36px;\n}\nh2[_ngcontent-%COMP%], .h2[_ngcontent-%COMP%] {\n  font-size: 30px;\n}\nh3[_ngcontent-%COMP%], .h3[_ngcontent-%COMP%] {\n  font-size: 24px;\n}\nh4[_ngcontent-%COMP%], .h4[_ngcontent-%COMP%] {\n  font-size: 18px;\n}\nh5[_ngcontent-%COMP%], .h5[_ngcontent-%COMP%] {\n  font-size: 14px;\n}\nh6[_ngcontent-%COMP%], .h6[_ngcontent-%COMP%] {\n  font-size: 12px;\n}\np[_ngcontent-%COMP%] {\n  margin: 0 0 10px;\n}\n.lead[_ngcontent-%COMP%] {\n  margin-bottom: 20px;\n  font-size: 16px;\n  font-weight: 300;\n  line-height: 1.4;\n}\n@media (min-width: 768px) {\n  .lead[_ngcontent-%COMP%] {\n    font-size: 21px;\n  }\n}\nsmall[_ngcontent-%COMP%], .small[_ngcontent-%COMP%] {\n  font-size: 85%;\n}\nmark[_ngcontent-%COMP%], .mark[_ngcontent-%COMP%] {\n  padding: .2em;\n  background-color: #fcf8e3;\n}\n.text-left[_ngcontent-%COMP%] {\n  text-align: left;\n}\n.text-right[_ngcontent-%COMP%] {\n  text-align: right;\n}\n.text-center[_ngcontent-%COMP%] {\n  text-align: center;\n}\n.text-justify[_ngcontent-%COMP%] {\n  text-align: justify;\n}\n.text-nowrap[_ngcontent-%COMP%] {\n  white-space: nowrap;\n}\n.text-lowercase[_ngcontent-%COMP%] {\n  text-transform: lowercase;\n}\n.text-uppercase[_ngcontent-%COMP%] {\n  text-transform: uppercase;\n}\n.text-capitalize[_ngcontent-%COMP%] {\n  text-transform: capitalize;\n}\n.text-muted[_ngcontent-%COMP%] {\n  color: #777;\n}\n.text-primary[_ngcontent-%COMP%] {\n  color: #337ab7;\n}\na.text-primary[_ngcontent-%COMP%]:hover, a.text-primary[_ngcontent-%COMP%]:focus {\n  color: #286090;\n}\n.text-success[_ngcontent-%COMP%] {\n  color: #3c763d;\n}\na.text-success[_ngcontent-%COMP%]:hover, a.text-success[_ngcontent-%COMP%]:focus {\n  color: #2b542c;\n}\n.text-info[_ngcontent-%COMP%] {\n  color: #31708f;\n}\na.text-info[_ngcontent-%COMP%]:hover, a.text-info[_ngcontent-%COMP%]:focus {\n  color: #245269;\n}\n.text-warning[_ngcontent-%COMP%] {\n  color: #8a6d3b;\n}\na.text-warning[_ngcontent-%COMP%]:hover, a.text-warning[_ngcontent-%COMP%]:focus {\n  color: #66512c;\n}\n.text-danger[_ngcontent-%COMP%] {\n  color: #a94442;\n}\na.text-danger[_ngcontent-%COMP%]:hover, a.text-danger[_ngcontent-%COMP%]:focus {\n  color: #843534;\n}\n.bg-primary[_ngcontent-%COMP%] {\n  color: #fff;\n  background-color: #337ab7;\n}\na.bg-primary[_ngcontent-%COMP%]:hover, a.bg-primary[_ngcontent-%COMP%]:focus {\n  background-color: #286090;\n}\n.bg-success[_ngcontent-%COMP%] {\n  background-color: #dff0d8;\n}\na.bg-success[_ngcontent-%COMP%]:hover, a.bg-success[_ngcontent-%COMP%]:focus {\n  background-color: #c1e2b3;\n}\n.bg-info[_ngcontent-%COMP%] {\n  background-color: #d9edf7;\n}\na.bg-info[_ngcontent-%COMP%]:hover, a.bg-info[_ngcontent-%COMP%]:focus {\n  background-color: #afd9ee;\n}\n.bg-warning[_ngcontent-%COMP%] {\n  background-color: #fcf8e3;\n}\na.bg-warning[_ngcontent-%COMP%]:hover, a.bg-warning[_ngcontent-%COMP%]:focus {\n  background-color: #f7ecb5;\n}\n.bg-danger[_ngcontent-%COMP%] {\n  background-color: #f2dede;\n}\na.bg-danger[_ngcontent-%COMP%]:hover, a.bg-danger[_ngcontent-%COMP%]:focus {\n  background-color: #e4b9b9;\n}\n.page-header[_ngcontent-%COMP%] {\n  padding-bottom: 9px;\n  margin: 40px 0 20px;\n  border-bottom: 1px solid #eee;\n}\nul[_ngcontent-%COMP%], ol[_ngcontent-%COMP%] {\n  margin-top: 0;\n  margin-bottom: 10px;\n}\nul[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%], ol[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%], ul[_ngcontent-%COMP%]   ol[_ngcontent-%COMP%], ol[_ngcontent-%COMP%]   ol[_ngcontent-%COMP%] {\n  margin-bottom: 0;\n}\n.list-unstyled[_ngcontent-%COMP%] {\n  padding-left: 0;\n  list-style: none;\n}\n.list-inline[_ngcontent-%COMP%] {\n  padding-left: 0;\n  margin-left: -5px;\n  list-style: none;\n}\n.list-inline[_ngcontent-%COMP%]    > li[_ngcontent-%COMP%] {\n  display: inline-block;\n  padding-right: 5px;\n  padding-left: 5px;\n}\ndl[_ngcontent-%COMP%] {\n  margin-top: 0;\n  margin-bottom: 20px;\n}\ndt[_ngcontent-%COMP%], dd[_ngcontent-%COMP%] {\n  line-height: 1.42857143;\n}\ndt[_ngcontent-%COMP%] {\n  font-weight: bold;\n}\ndd[_ngcontent-%COMP%] {\n  margin-left: 0;\n}\n@media (min-width: 768px) {\n  .dl-horizontal[_ngcontent-%COMP%]   dt[_ngcontent-%COMP%] {\n    float: left;\n    width: 160px;\n    overflow: hidden;\n    clear: left;\n    text-align: right;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n  .dl-horizontal[_ngcontent-%COMP%]   dd[_ngcontent-%COMP%] {\n    margin-left: 180px;\n  }\n}\nabbr[title][_ngcontent-%COMP%], abbr[data-original-title][_ngcontent-%COMP%] {\n  cursor: help;\n  border-bottom: 1px dotted #777;\n}\n.initialism[_ngcontent-%COMP%] {\n  font-size: 90%;\n  text-transform: uppercase;\n}\nblockquote[_ngcontent-%COMP%] {\n  padding: 10px 20px;\n  margin: 0 0 20px;\n  font-size: 17.5px;\n  border-left: 5px solid #eee;\n}\nblockquote[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]:last-child, blockquote[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]:last-child, blockquote[_ngcontent-%COMP%]   ol[_ngcontent-%COMP%]:last-child {\n  margin-bottom: 0;\n}\nblockquote[_ngcontent-%COMP%]   footer[_ngcontent-%COMP%], blockquote[_ngcontent-%COMP%]   small[_ngcontent-%COMP%], blockquote[_ngcontent-%COMP%]   .small[_ngcontent-%COMP%] {\n  display: block;\n  font-size: 80%;\n  line-height: 1.42857143;\n  color: #777;\n}\nblockquote[_ngcontent-%COMP%]   footer[_ngcontent-%COMP%]:before, blockquote[_ngcontent-%COMP%]   small[_ngcontent-%COMP%]:before, blockquote[_ngcontent-%COMP%]   .small[_ngcontent-%COMP%]:before {\n  content: \'\\2014 \\00A0\';\n}\n.blockquote-reverse[_ngcontent-%COMP%], blockquote.pull-right[_ngcontent-%COMP%] {\n  padding-right: 15px;\n  padding-left: 0;\n  text-align: right;\n  border-right: 5px solid #eee;\n  border-left: 0;\n}\n.blockquote-reverse[_ngcontent-%COMP%]   footer[_ngcontent-%COMP%]:before, blockquote.pull-right[_ngcontent-%COMP%]   footer[_ngcontent-%COMP%]:before, .blockquote-reverse[_ngcontent-%COMP%]   small[_ngcontent-%COMP%]:before, blockquote.pull-right[_ngcontent-%COMP%]   small[_ngcontent-%COMP%]:before, .blockquote-reverse[_ngcontent-%COMP%]   .small[_ngcontent-%COMP%]:before, blockquote.pull-right[_ngcontent-%COMP%]   .small[_ngcontent-%COMP%]:before {\n  content: \'\';\n}\n.blockquote-reverse[_ngcontent-%COMP%]   footer[_ngcontent-%COMP%]:after, blockquote.pull-right[_ngcontent-%COMP%]   footer[_ngcontent-%COMP%]:after, .blockquote-reverse[_ngcontent-%COMP%]   small[_ngcontent-%COMP%]:after, blockquote.pull-right[_ngcontent-%COMP%]   small[_ngcontent-%COMP%]:after, .blockquote-reverse[_ngcontent-%COMP%]   .small[_ngcontent-%COMP%]:after, blockquote.pull-right[_ngcontent-%COMP%]   .small[_ngcontent-%COMP%]:after {\n  content: \'\\00A0 \\2014\';\n}\naddress[_ngcontent-%COMP%] {\n  margin-bottom: 20px;\n  font-style: normal;\n  line-height: 1.42857143;\n}\ncode[_ngcontent-%COMP%], kbd[_ngcontent-%COMP%], pre[_ngcontent-%COMP%], samp[_ngcontent-%COMP%] {\n  font-family: Menlo, Monaco, Consolas, "Courier New", monospace;\n}\ncode[_ngcontent-%COMP%] {\n  padding: 2px 4px;\n  font-size: 90%;\n  color: #c7254e;\n  background-color: #f9f2f4;\n  border-radius: 4px;\n}\nkbd[_ngcontent-%COMP%] {\n  padding: 2px 4px;\n  font-size: 90%;\n  color: #fff;\n  background-color: #333;\n  border-radius: 3px;\n  -webkit-box-shadow: inset 0 -1px 0 rgba(0, 0, 0, .25);\n          box-shadow: inset 0 -1px 0 rgba(0, 0, 0, .25);\n}\nkbd[_ngcontent-%COMP%]   kbd[_ngcontent-%COMP%] {\n  padding: 0;\n  font-size: 100%;\n  font-weight: bold;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\npre[_ngcontent-%COMP%] {\n  display: block;\n  padding: 9.5px;\n  margin: 0 0 10px;\n  font-size: 13px;\n  line-height: 1.42857143;\n  color: #333;\n  word-break: break-all;\n  word-wrap: break-word;\n  background-color: #f5f5f5;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\npre[_ngcontent-%COMP%]   code[_ngcontent-%COMP%] {\n  padding: 0;\n  font-size: inherit;\n  color: inherit;\n  white-space: pre-wrap;\n  background-color: transparent;\n  border-radius: 0;\n}\n.pre-scrollable[_ngcontent-%COMP%] {\n  max-height: 340px;\n  overflow-y: scroll;\n}\n.container[_ngcontent-%COMP%] {\n  padding-right: 15px;\n  padding-left: 15px;\n  margin-right: auto;\n  margin-left: auto;\n}\n@media (min-width: 768px) {\n  .container[_ngcontent-%COMP%] {\n    width: 750px;\n  }\n}\n@media (min-width: 992px) {\n  .container[_ngcontent-%COMP%] {\n    width: 970px;\n  }\n}\n@media (min-width: 1200px) {\n  .container[_ngcontent-%COMP%] {\n    width: 1170px;\n  }\n}\n.container-fluid[_ngcontent-%COMP%] {\n  padding-right: 15px;\n  padding-left: 15px;\n  margin-right: auto;\n  margin-left: auto;\n}\n.row[_ngcontent-%COMP%] {\n  margin-right: -15px;\n  margin-left: -15px;\n}\n.col-xs-1[_ngcontent-%COMP%], .col-sm-1[_ngcontent-%COMP%], .col-md-1[_ngcontent-%COMP%], .col-lg-1[_ngcontent-%COMP%], .col-xs-2[_ngcontent-%COMP%], .col-sm-2[_ngcontent-%COMP%], .col-md-2[_ngcontent-%COMP%], .col-lg-2[_ngcontent-%COMP%], .col-xs-3[_ngcontent-%COMP%], .col-sm-3[_ngcontent-%COMP%], .col-md-3[_ngcontent-%COMP%], .col-lg-3[_ngcontent-%COMP%], .col-xs-4[_ngcontent-%COMP%], .col-sm-4[_ngcontent-%COMP%], .col-md-4[_ngcontent-%COMP%], .col-lg-4[_ngcontent-%COMP%], .col-xs-5[_ngcontent-%COMP%], .col-sm-5[_ngcontent-%COMP%], .col-md-5[_ngcontent-%COMP%], .col-lg-5[_ngcontent-%COMP%], .col-xs-6[_ngcontent-%COMP%], .col-sm-6[_ngcontent-%COMP%], .col-md-6[_ngcontent-%COMP%], .col-lg-6[_ngcontent-%COMP%], .col-xs-7[_ngcontent-%COMP%], .col-sm-7[_ngcontent-%COMP%], .col-md-7[_ngcontent-%COMP%], .col-lg-7[_ngcontent-%COMP%], .col-xs-8[_ngcontent-%COMP%], .col-sm-8[_ngcontent-%COMP%], .col-md-8[_ngcontent-%COMP%], .col-lg-8[_ngcontent-%COMP%], .col-xs-9[_ngcontent-%COMP%], .col-sm-9[_ngcontent-%COMP%], .col-md-9[_ngcontent-%COMP%], .col-lg-9[_ngcontent-%COMP%], .col-xs-10[_ngcontent-%COMP%], .col-sm-10[_ngcontent-%COMP%], .col-md-10[_ngcontent-%COMP%], .col-lg-10[_ngcontent-%COMP%], .col-xs-11[_ngcontent-%COMP%], .col-sm-11[_ngcontent-%COMP%], .col-md-11[_ngcontent-%COMP%], .col-lg-11[_ngcontent-%COMP%], .col-xs-12[_ngcontent-%COMP%], .col-sm-12[_ngcontent-%COMP%], .col-md-12[_ngcontent-%COMP%], .col-lg-12[_ngcontent-%COMP%] {\n  position: relative;\n  min-height: 1px;\n  padding-right: 15px;\n  padding-left: 15px;\n}\n.col-xs-1[_ngcontent-%COMP%], .col-xs-2[_ngcontent-%COMP%], .col-xs-3[_ngcontent-%COMP%], .col-xs-4[_ngcontent-%COMP%], .col-xs-5[_ngcontent-%COMP%], .col-xs-6[_ngcontent-%COMP%], .col-xs-7[_ngcontent-%COMP%], .col-xs-8[_ngcontent-%COMP%], .col-xs-9[_ngcontent-%COMP%], .col-xs-10[_ngcontent-%COMP%], .col-xs-11[_ngcontent-%COMP%], .col-xs-12[_ngcontent-%COMP%] {\n  float: left;\n}\n.col-xs-12[_ngcontent-%COMP%] {\n  width: 100%;\n}\n.col-xs-11[_ngcontent-%COMP%] {\n  width: 91.66666667%;\n}\n.col-xs-10[_ngcontent-%COMP%] {\n  width: 83.33333333%;\n}\n.col-xs-9[_ngcontent-%COMP%] {\n  width: 75%;\n}\n.col-xs-8[_ngcontent-%COMP%] {\n  width: 66.66666667%;\n}\n.col-xs-7[_ngcontent-%COMP%] {\n  width: 58.33333333%;\n}\n.col-xs-6[_ngcontent-%COMP%] {\n  width: 50%;\n}\n.col-xs-5[_ngcontent-%COMP%] {\n  width: 41.66666667%;\n}\n.col-xs-4[_ngcontent-%COMP%] {\n  width: 33.33333333%;\n}\n.col-xs-3[_ngcontent-%COMP%] {\n  width: 25%;\n}\n.col-xs-2[_ngcontent-%COMP%] {\n  width: 16.66666667%;\n}\n.col-xs-1[_ngcontent-%COMP%] {\n  width: 8.33333333%;\n}\n.col-xs-pull-12[_ngcontent-%COMP%] {\n  right: 100%;\n}\n.col-xs-pull-11[_ngcontent-%COMP%] {\n  right: 91.66666667%;\n}\n.col-xs-pull-10[_ngcontent-%COMP%] {\n  right: 83.33333333%;\n}\n.col-xs-pull-9[_ngcontent-%COMP%] {\n  right: 75%;\n}\n.col-xs-pull-8[_ngcontent-%COMP%] {\n  right: 66.66666667%;\n}\n.col-xs-pull-7[_ngcontent-%COMP%] {\n  right: 58.33333333%;\n}\n.col-xs-pull-6[_ngcontent-%COMP%] {\n  right: 50%;\n}\n.col-xs-pull-5[_ngcontent-%COMP%] {\n  right: 41.66666667%;\n}\n.col-xs-pull-4[_ngcontent-%COMP%] {\n  right: 33.33333333%;\n}\n.col-xs-pull-3[_ngcontent-%COMP%] {\n  right: 25%;\n}\n.col-xs-pull-2[_ngcontent-%COMP%] {\n  right: 16.66666667%;\n}\n.col-xs-pull-1[_ngcontent-%COMP%] {\n  right: 8.33333333%;\n}\n.col-xs-pull-0[_ngcontent-%COMP%] {\n  right: auto;\n}\n.col-xs-push-12[_ngcontent-%COMP%] {\n  left: 100%;\n}\n.col-xs-push-11[_ngcontent-%COMP%] {\n  left: 91.66666667%;\n}\n.col-xs-push-10[_ngcontent-%COMP%] {\n  left: 83.33333333%;\n}\n.col-xs-push-9[_ngcontent-%COMP%] {\n  left: 75%;\n}\n.col-xs-push-8[_ngcontent-%COMP%] {\n  left: 66.66666667%;\n}\n.col-xs-push-7[_ngcontent-%COMP%] {\n  left: 58.33333333%;\n}\n.col-xs-push-6[_ngcontent-%COMP%] {\n  left: 50%;\n}\n.col-xs-push-5[_ngcontent-%COMP%] {\n  left: 41.66666667%;\n}\n.col-xs-push-4[_ngcontent-%COMP%] {\n  left: 33.33333333%;\n}\n.col-xs-push-3[_ngcontent-%COMP%] {\n  left: 25%;\n}\n.col-xs-push-2[_ngcontent-%COMP%] {\n  left: 16.66666667%;\n}\n.col-xs-push-1[_ngcontent-%COMP%] {\n  left: 8.33333333%;\n}\n.col-xs-push-0[_ngcontent-%COMP%] {\n  left: auto;\n}\n.col-xs-offset-12[_ngcontent-%COMP%] {\n  margin-left: 100%;\n}\n.col-xs-offset-11[_ngcontent-%COMP%] {\n  margin-left: 91.66666667%;\n}\n.col-xs-offset-10[_ngcontent-%COMP%] {\n  margin-left: 83.33333333%;\n}\n.col-xs-offset-9[_ngcontent-%COMP%] {\n  margin-left: 75%;\n}\n.col-xs-offset-8[_ngcontent-%COMP%] {\n  margin-left: 66.66666667%;\n}\n.col-xs-offset-7[_ngcontent-%COMP%] {\n  margin-left: 58.33333333%;\n}\n.col-xs-offset-6[_ngcontent-%COMP%] {\n  margin-left: 50%;\n}\n.col-xs-offset-5[_ngcontent-%COMP%] {\n  margin-left: 41.66666667%;\n}\n.col-xs-offset-4[_ngcontent-%COMP%] {\n  margin-left: 33.33333333%;\n}\n.col-xs-offset-3[_ngcontent-%COMP%] {\n  margin-left: 25%;\n}\n.col-xs-offset-2[_ngcontent-%COMP%] {\n  margin-left: 16.66666667%;\n}\n.col-xs-offset-1[_ngcontent-%COMP%] {\n  margin-left: 8.33333333%;\n}\n.col-xs-offset-0[_ngcontent-%COMP%] {\n  margin-left: 0;\n}\n@media (min-width: 768px) {\n  .col-sm-1[_ngcontent-%COMP%], .col-sm-2[_ngcontent-%COMP%], .col-sm-3[_ngcontent-%COMP%], .col-sm-4[_ngcontent-%COMP%], .col-sm-5[_ngcontent-%COMP%], .col-sm-6[_ngcontent-%COMP%], .col-sm-7[_ngcontent-%COMP%], .col-sm-8[_ngcontent-%COMP%], .col-sm-9[_ngcontent-%COMP%], .col-sm-10[_ngcontent-%COMP%], .col-sm-11[_ngcontent-%COMP%], .col-sm-12[_ngcontent-%COMP%] {\n    float: left;\n  }\n  .col-sm-12[_ngcontent-%COMP%] {\n    width: 100%;\n  }\n  .col-sm-11[_ngcontent-%COMP%] {\n    width: 91.66666667%;\n  }\n  .col-sm-10[_ngcontent-%COMP%] {\n    width: 83.33333333%;\n  }\n  .col-sm-9[_ngcontent-%COMP%] {\n    width: 75%;\n  }\n  .col-sm-8[_ngcontent-%COMP%] {\n    width: 66.66666667%;\n  }\n  .col-sm-7[_ngcontent-%COMP%] {\n    width: 58.33333333%;\n  }\n  .col-sm-6[_ngcontent-%COMP%] {\n    width: 50%;\n  }\n  .col-sm-5[_ngcontent-%COMP%] {\n    width: 41.66666667%;\n  }\n  .col-sm-4[_ngcontent-%COMP%] {\n    width: 33.33333333%;\n  }\n  .col-sm-3[_ngcontent-%COMP%] {\n    width: 25%;\n  }\n  .col-sm-2[_ngcontent-%COMP%] {\n    width: 16.66666667%;\n  }\n  .col-sm-1[_ngcontent-%COMP%] {\n    width: 8.33333333%;\n  }\n  .col-sm-pull-12[_ngcontent-%COMP%] {\n    right: 100%;\n  }\n  .col-sm-pull-11[_ngcontent-%COMP%] {\n    right: 91.66666667%;\n  }\n  .col-sm-pull-10[_ngcontent-%COMP%] {\n    right: 83.33333333%;\n  }\n  .col-sm-pull-9[_ngcontent-%COMP%] {\n    right: 75%;\n  }\n  .col-sm-pull-8[_ngcontent-%COMP%] {\n    right: 66.66666667%;\n  }\n  .col-sm-pull-7[_ngcontent-%COMP%] {\n    right: 58.33333333%;\n  }\n  .col-sm-pull-6[_ngcontent-%COMP%] {\n    right: 50%;\n  }\n  .col-sm-pull-5[_ngcontent-%COMP%] {\n    right: 41.66666667%;\n  }\n  .col-sm-pull-4[_ngcontent-%COMP%] {\n    right: 33.33333333%;\n  }\n  .col-sm-pull-3[_ngcontent-%COMP%] {\n    right: 25%;\n  }\n  .col-sm-pull-2[_ngcontent-%COMP%] {\n    right: 16.66666667%;\n  }\n  .col-sm-pull-1[_ngcontent-%COMP%] {\n    right: 8.33333333%;\n  }\n  .col-sm-pull-0[_ngcontent-%COMP%] {\n    right: auto;\n  }\n  .col-sm-push-12[_ngcontent-%COMP%] {\n    left: 100%;\n  }\n  .col-sm-push-11[_ngcontent-%COMP%] {\n    left: 91.66666667%;\n  }\n  .col-sm-push-10[_ngcontent-%COMP%] {\n    left: 83.33333333%;\n  }\n  .col-sm-push-9[_ngcontent-%COMP%] {\n    left: 75%;\n  }\n  .col-sm-push-8[_ngcontent-%COMP%] {\n    left: 66.66666667%;\n  }\n  .col-sm-push-7[_ngcontent-%COMP%] {\n    left: 58.33333333%;\n  }\n  .col-sm-push-6[_ngcontent-%COMP%] {\n    left: 50%;\n  }\n  .col-sm-push-5[_ngcontent-%COMP%] {\n    left: 41.66666667%;\n  }\n  .col-sm-push-4[_ngcontent-%COMP%] {\n    left: 33.33333333%;\n  }\n  .col-sm-push-3[_ngcontent-%COMP%] {\n    left: 25%;\n  }\n  .col-sm-push-2[_ngcontent-%COMP%] {\n    left: 16.66666667%;\n  }\n  .col-sm-push-1[_ngcontent-%COMP%] {\n    left: 8.33333333%;\n  }\n  .col-sm-push-0[_ngcontent-%COMP%] {\n    left: auto;\n  }\n  .col-sm-offset-12[_ngcontent-%COMP%] {\n    margin-left: 100%;\n  }\n  .col-sm-offset-11[_ngcontent-%COMP%] {\n    margin-left: 91.66666667%;\n  }\n  .col-sm-offset-10[_ngcontent-%COMP%] {\n    margin-left: 83.33333333%;\n  }\n  .col-sm-offset-9[_ngcontent-%COMP%] {\n    margin-left: 75%;\n  }\n  .col-sm-offset-8[_ngcontent-%COMP%] {\n    margin-left: 66.66666667%;\n  }\n  .col-sm-offset-7[_ngcontent-%COMP%] {\n    margin-left: 58.33333333%;\n  }\n  .col-sm-offset-6[_ngcontent-%COMP%] {\n    margin-left: 50%;\n  }\n  .col-sm-offset-5[_ngcontent-%COMP%] {\n    margin-left: 41.66666667%;\n  }\n  .col-sm-offset-4[_ngcontent-%COMP%] {\n    margin-left: 33.33333333%;\n  }\n  .col-sm-offset-3[_ngcontent-%COMP%] {\n    margin-left: 25%;\n  }\n  .col-sm-offset-2[_ngcontent-%COMP%] {\n    margin-left: 16.66666667%;\n  }\n  .col-sm-offset-1[_ngcontent-%COMP%] {\n    margin-left: 8.33333333%;\n  }\n  .col-sm-offset-0[_ngcontent-%COMP%] {\n    margin-left: 0;\n  }\n}\n@media (min-width: 992px) {\n  .col-md-1[_ngcontent-%COMP%], .col-md-2[_ngcontent-%COMP%], .col-md-3[_ngcontent-%COMP%], .col-md-4[_ngcontent-%COMP%], .col-md-5[_ngcontent-%COMP%], .col-md-6[_ngcontent-%COMP%], .col-md-7[_ngcontent-%COMP%], .col-md-8[_ngcontent-%COMP%], .col-md-9[_ngcontent-%COMP%], .col-md-10[_ngcontent-%COMP%], .col-md-11[_ngcontent-%COMP%], .col-md-12[_ngcontent-%COMP%] {\n    float: left;\n  }\n  .col-md-12[_ngcontent-%COMP%] {\n    width: 100%;\n  }\n  .col-md-11[_ngcontent-%COMP%] {\n    width: 91.66666667%;\n  }\n  .col-md-10[_ngcontent-%COMP%] {\n    width: 83.33333333%;\n  }\n  .col-md-9[_ngcontent-%COMP%] {\n    width: 75%;\n  }\n  .col-md-8[_ngcontent-%COMP%] {\n    width: 66.66666667%;\n  }\n  .col-md-7[_ngcontent-%COMP%] {\n    width: 58.33333333%;\n  }\n  .col-md-6[_ngcontent-%COMP%] {\n    width: 50%;\n  }\n  .col-md-5[_ngcontent-%COMP%] {\n    width: 41.66666667%;\n  }\n  .col-md-4[_ngcontent-%COMP%] {\n    width: 33.33333333%;\n  }\n  .col-md-3[_ngcontent-%COMP%] {\n    width: 25%;\n  }\n  .col-md-2[_ngcontent-%COMP%] {\n    width: 16.66666667%;\n  }\n  .col-md-1[_ngcontent-%COMP%] {\n    width: 8.33333333%;\n  }\n  .col-md-pull-12[_ngcontent-%COMP%] {\n    right: 100%;\n  }\n  .col-md-pull-11[_ngcontent-%COMP%] {\n    right: 91.66666667%;\n  }\n  .col-md-pull-10[_ngcontent-%COMP%] {\n    right: 83.33333333%;\n  }\n  .col-md-pull-9[_ngcontent-%COMP%] {\n    right: 75%;\n  }\n  .col-md-pull-8[_ngcontent-%COMP%] {\n    right: 66.66666667%;\n  }\n  .col-md-pull-7[_ngcontent-%COMP%] {\n    right: 58.33333333%;\n  }\n  .col-md-pull-6[_ngcontent-%COMP%] {\n    right: 50%;\n  }\n  .col-md-pull-5[_ngcontent-%COMP%] {\n    right: 41.66666667%;\n  }\n  .col-md-pull-4[_ngcontent-%COMP%] {\n    right: 33.33333333%;\n  }\n  .col-md-pull-3[_ngcontent-%COMP%] {\n    right: 25%;\n  }\n  .col-md-pull-2[_ngcontent-%COMP%] {\n    right: 16.66666667%;\n  }\n  .col-md-pull-1[_ngcontent-%COMP%] {\n    right: 8.33333333%;\n  }\n  .col-md-pull-0[_ngcontent-%COMP%] {\n    right: auto;\n  }\n  .col-md-push-12[_ngcontent-%COMP%] {\n    left: 100%;\n  }\n  .col-md-push-11[_ngcontent-%COMP%] {\n    left: 91.66666667%;\n  }\n  .col-md-push-10[_ngcontent-%COMP%] {\n    left: 83.33333333%;\n  }\n  .col-md-push-9[_ngcontent-%COMP%] {\n    left: 75%;\n  }\n  .col-md-push-8[_ngcontent-%COMP%] {\n    left: 66.66666667%;\n  }\n  .col-md-push-7[_ngcontent-%COMP%] {\n    left: 58.33333333%;\n  }\n  .col-md-push-6[_ngcontent-%COMP%] {\n    left: 50%;\n  }\n  .col-md-push-5[_ngcontent-%COMP%] {\n    left: 41.66666667%;\n  }\n  .col-md-push-4[_ngcontent-%COMP%] {\n    left: 33.33333333%;\n  }\n  .col-md-push-3[_ngcontent-%COMP%] {\n    left: 25%;\n  }\n  .col-md-push-2[_ngcontent-%COMP%] {\n    left: 16.66666667%;\n  }\n  .col-md-push-1[_ngcontent-%COMP%] {\n    left: 8.33333333%;\n  }\n  .col-md-push-0[_ngcontent-%COMP%] {\n    left: auto;\n  }\n  .col-md-offset-12[_ngcontent-%COMP%] {\n    margin-left: 100%;\n  }\n  .col-md-offset-11[_ngcontent-%COMP%] {\n    margin-left: 91.66666667%;\n  }\n  .col-md-offset-10[_ngcontent-%COMP%] {\n    margin-left: 83.33333333%;\n  }\n  .col-md-offset-9[_ngcontent-%COMP%] {\n    margin-left: 75%;\n  }\n  .col-md-offset-8[_ngcontent-%COMP%] {\n    margin-left: 66.66666667%;\n  }\n  .col-md-offset-7[_ngcontent-%COMP%] {\n    margin-left: 58.33333333%;\n  }\n  .col-md-offset-6[_ngcontent-%COMP%] {\n    margin-left: 50%;\n  }\n  .col-md-offset-5[_ngcontent-%COMP%] {\n    margin-left: 41.66666667%;\n  }\n  .col-md-offset-4[_ngcontent-%COMP%] {\n    margin-left: 33.33333333%;\n  }\n  .col-md-offset-3[_ngcontent-%COMP%] {\n    margin-left: 25%;\n  }\n  .col-md-offset-2[_ngcontent-%COMP%] {\n    margin-left: 16.66666667%;\n  }\n  .col-md-offset-1[_ngcontent-%COMP%] {\n    margin-left: 8.33333333%;\n  }\n  .col-md-offset-0[_ngcontent-%COMP%] {\n    margin-left: 0;\n  }\n}\n@media (min-width: 1200px) {\n  .col-lg-1[_ngcontent-%COMP%], .col-lg-2[_ngcontent-%COMP%], .col-lg-3[_ngcontent-%COMP%], .col-lg-4[_ngcontent-%COMP%], .col-lg-5[_ngcontent-%COMP%], .col-lg-6[_ngcontent-%COMP%], .col-lg-7[_ngcontent-%COMP%], .col-lg-8[_ngcontent-%COMP%], .col-lg-9[_ngcontent-%COMP%], .col-lg-10[_ngcontent-%COMP%], .col-lg-11[_ngcontent-%COMP%], .col-lg-12[_ngcontent-%COMP%] {\n    float: left;\n  }\n  .col-lg-12[_ngcontent-%COMP%] {\n    width: 100%;\n  }\n  .col-lg-11[_ngcontent-%COMP%] {\n    width: 91.66666667%;\n  }\n  .col-lg-10[_ngcontent-%COMP%] {\n    width: 83.33333333%;\n  }\n  .col-lg-9[_ngcontent-%COMP%] {\n    width: 75%;\n  }\n  .col-lg-8[_ngcontent-%COMP%] {\n    width: 66.66666667%;\n  }\n  .col-lg-7[_ngcontent-%COMP%] {\n    width: 58.33333333%;\n  }\n  .col-lg-6[_ngcontent-%COMP%] {\n    width: 50%;\n  }\n  .col-lg-5[_ngcontent-%COMP%] {\n    width: 41.66666667%;\n  }\n  .col-lg-4[_ngcontent-%COMP%] {\n    width: 33.33333333%;\n  }\n  .col-lg-3[_ngcontent-%COMP%] {\n    width: 25%;\n  }\n  .col-lg-2[_ngcontent-%COMP%] {\n    width: 16.66666667%;\n  }\n  .col-lg-1[_ngcontent-%COMP%] {\n    width: 8.33333333%;\n  }\n  .col-lg-pull-12[_ngcontent-%COMP%] {\n    right: 100%;\n  }\n  .col-lg-pull-11[_ngcontent-%COMP%] {\n    right: 91.66666667%;\n  }\n  .col-lg-pull-10[_ngcontent-%COMP%] {\n    right: 83.33333333%;\n  }\n  .col-lg-pull-9[_ngcontent-%COMP%] {\n    right: 75%;\n  }\n  .col-lg-pull-8[_ngcontent-%COMP%] {\n    right: 66.66666667%;\n  }\n  .col-lg-pull-7[_ngcontent-%COMP%] {\n    right: 58.33333333%;\n  }\n  .col-lg-pull-6[_ngcontent-%COMP%] {\n    right: 50%;\n  }\n  .col-lg-pull-5[_ngcontent-%COMP%] {\n    right: 41.66666667%;\n  }\n  .col-lg-pull-4[_ngcontent-%COMP%] {\n    right: 33.33333333%;\n  }\n  .col-lg-pull-3[_ngcontent-%COMP%] {\n    right: 25%;\n  }\n  .col-lg-pull-2[_ngcontent-%COMP%] {\n    right: 16.66666667%;\n  }\n  .col-lg-pull-1[_ngcontent-%COMP%] {\n    right: 8.33333333%;\n  }\n  .col-lg-pull-0[_ngcontent-%COMP%] {\n    right: auto;\n  }\n  .col-lg-push-12[_ngcontent-%COMP%] {\n    left: 100%;\n  }\n  .col-lg-push-11[_ngcontent-%COMP%] {\n    left: 91.66666667%;\n  }\n  .col-lg-push-10[_ngcontent-%COMP%] {\n    left: 83.33333333%;\n  }\n  .col-lg-push-9[_ngcontent-%COMP%] {\n    left: 75%;\n  }\n  .col-lg-push-8[_ngcontent-%COMP%] {\n    left: 66.66666667%;\n  }\n  .col-lg-push-7[_ngcontent-%COMP%] {\n    left: 58.33333333%;\n  }\n  .col-lg-push-6[_ngcontent-%COMP%] {\n    left: 50%;\n  }\n  .col-lg-push-5[_ngcontent-%COMP%] {\n    left: 41.66666667%;\n  }\n  .col-lg-push-4[_ngcontent-%COMP%] {\n    left: 33.33333333%;\n  }\n  .col-lg-push-3[_ngcontent-%COMP%] {\n    left: 25%;\n  }\n  .col-lg-push-2[_ngcontent-%COMP%] {\n    left: 16.66666667%;\n  }\n  .col-lg-push-1[_ngcontent-%COMP%] {\n    left: 8.33333333%;\n  }\n  .col-lg-push-0[_ngcontent-%COMP%] {\n    left: auto;\n  }\n  .col-lg-offset-12[_ngcontent-%COMP%] {\n    margin-left: 100%;\n  }\n  .col-lg-offset-11[_ngcontent-%COMP%] {\n    margin-left: 91.66666667%;\n  }\n  .col-lg-offset-10[_ngcontent-%COMP%] {\n    margin-left: 83.33333333%;\n  }\n  .col-lg-offset-9[_ngcontent-%COMP%] {\n    margin-left: 75%;\n  }\n  .col-lg-offset-8[_ngcontent-%COMP%] {\n    margin-left: 66.66666667%;\n  }\n  .col-lg-offset-7[_ngcontent-%COMP%] {\n    margin-left: 58.33333333%;\n  }\n  .col-lg-offset-6[_ngcontent-%COMP%] {\n    margin-left: 50%;\n  }\n  .col-lg-offset-5[_ngcontent-%COMP%] {\n    margin-left: 41.66666667%;\n  }\n  .col-lg-offset-4[_ngcontent-%COMP%] {\n    margin-left: 33.33333333%;\n  }\n  .col-lg-offset-3[_ngcontent-%COMP%] {\n    margin-left: 25%;\n  }\n  .col-lg-offset-2[_ngcontent-%COMP%] {\n    margin-left: 16.66666667%;\n  }\n  .col-lg-offset-1[_ngcontent-%COMP%] {\n    margin-left: 8.33333333%;\n  }\n  .col-lg-offset-0[_ngcontent-%COMP%] {\n    margin-left: 0;\n  }\n}\ntable[_ngcontent-%COMP%] {\n  background-color: transparent;\n}\ncaption[_ngcontent-%COMP%] {\n  padding-top: 8px;\n  padding-bottom: 8px;\n  color: #777;\n  text-align: left;\n}\nth[_ngcontent-%COMP%] {\n  text-align: left;\n}\n.table[_ngcontent-%COMP%] {\n  width: 100%;\n  max-width: 100%;\n  margin-bottom: 20px;\n}\n.table[_ngcontent-%COMP%]    > thead[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]    > th[_ngcontent-%COMP%], .table[_ngcontent-%COMP%]    > tbody[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]    > th[_ngcontent-%COMP%], .table[_ngcontent-%COMP%]    > tfoot[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]    > th[_ngcontent-%COMP%], .table[_ngcontent-%COMP%]    > thead[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]    > td[_ngcontent-%COMP%], .table[_ngcontent-%COMP%]    > tbody[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]    > td[_ngcontent-%COMP%], .table[_ngcontent-%COMP%]    > tfoot[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]    > td[_ngcontent-%COMP%] {\n  padding: 8px;\n  line-height: 1.42857143;\n  vertical-align: top;\n  border-top: 1px solid #ddd;\n}\n.table[_ngcontent-%COMP%]    > thead[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]    > th[_ngcontent-%COMP%] {\n  vertical-align: bottom;\n  border-bottom: 2px solid #ddd;\n}\n.table[_ngcontent-%COMP%]    > caption[_ngcontent-%COMP%]    + thead[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]:first-child    > th[_ngcontent-%COMP%], .table[_ngcontent-%COMP%]    > colgroup[_ngcontent-%COMP%]    + thead[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]:first-child    > th[_ngcontent-%COMP%], .table[_ngcontent-%COMP%]    > thead[_ngcontent-%COMP%]:first-child    > tr[_ngcontent-%COMP%]:first-child    > th[_ngcontent-%COMP%], .table[_ngcontent-%COMP%]    > caption[_ngcontent-%COMP%]    + thead[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]:first-child    > td[_ngcontent-%COMP%], .table[_ngcontent-%COMP%]    > colgroup[_ngcontent-%COMP%]    + thead[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]:first-child    > td[_ngcontent-%COMP%], .table[_ngcontent-%COMP%]    > thead[_ngcontent-%COMP%]:first-child    > tr[_ngcontent-%COMP%]:first-child    > td[_ngcontent-%COMP%] {\n  border-top: 0;\n}\n.table[_ngcontent-%COMP%]    > tbody[_ngcontent-%COMP%]    + tbody[_ngcontent-%COMP%] {\n  border-top: 2px solid #ddd;\n}\n.table[_ngcontent-%COMP%]   .table[_ngcontent-%COMP%] {\n  background-color: #fff;\n}\n.table-condensed[_ngcontent-%COMP%]    > thead[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]    > th[_ngcontent-%COMP%], .table-condensed[_ngcontent-%COMP%]    > tbody[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]    > th[_ngcontent-%COMP%], .table-condensed[_ngcontent-%COMP%]    > tfoot[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]    > th[_ngcontent-%COMP%], .table-condensed[_ngcontent-%COMP%]    > thead[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]    > td[_ngcontent-%COMP%], .table-condensed[_ngcontent-%COMP%]    > tbody[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]    > td[_ngcontent-%COMP%], .table-condensed[_ngcontent-%COMP%]    > tfoot[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]    > td[_ngcontent-%COMP%] {\n  padding: 5px;\n}\n.table-bordered[_ngcontent-%COMP%] {\n  border: 1px solid #ddd;\n}\n.table-bordered[_ngcontent-%COMP%]    > thead[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]    > th[_ngcontent-%COMP%], .table-bordered[_ngcontent-%COMP%]    > tbody[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]    > th[_ngcontent-%COMP%], .table-bordered[_ngcontent-%COMP%]    > tfoot[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]    > th[_ngcontent-%COMP%], .table-bordered[_ngcontent-%COMP%]    > thead[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]    > td[_ngcontent-%COMP%], .table-bordered[_ngcontent-%COMP%]    > tbody[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]    > td[_ngcontent-%COMP%], .table-bordered[_ngcontent-%COMP%]    > tfoot[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]    > td[_ngcontent-%COMP%] {\n  border: 1px solid #ddd;\n}\n.table-bordered[_ngcontent-%COMP%]    > thead[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]    > th[_ngcontent-%COMP%], .table-bordered[_ngcontent-%COMP%]    > thead[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]    > td[_ngcontent-%COMP%] {\n  border-bottom-width: 2px;\n}\n.table-striped[_ngcontent-%COMP%]    > tbody[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]:nth-of-type(odd) {\n  background-color: #f9f9f9;\n}\n.table-hover[_ngcontent-%COMP%]    > tbody[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]:hover {\n  background-color: #f5f5f5;\n}\ntable[_ngcontent-%COMP%]   col[class*="col-"][_ngcontent-%COMP%] {\n  position: static;\n  display: table-column;\n  float: none;\n}\ntable[_ngcontent-%COMP%]   td[class*="col-"][_ngcontent-%COMP%], table[_ngcontent-%COMP%]   th[class*="col-"][_ngcontent-%COMP%] {\n  position: static;\n  display: table-cell;\n  float: none;\n}\n.table[_ngcontent-%COMP%]    > thead[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]    > td.active[_ngcontent-%COMP%], .table[_ngcontent-%COMP%]    > tbody[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]    > td.active[_ngcontent-%COMP%], .table[_ngcontent-%COMP%]    > tfoot[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]    > td.active[_ngcontent-%COMP%], .table[_ngcontent-%COMP%]    > thead[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]    > th.active[_ngcontent-%COMP%], .table[_ngcontent-%COMP%]    > tbody[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]    > th.active[_ngcontent-%COMP%], .table[_ngcontent-%COMP%]    > tfoot[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]    > th.active[_ngcontent-%COMP%], .table[_ngcontent-%COMP%]    > thead[_ngcontent-%COMP%]    > tr.active[_ngcontent-%COMP%]    > td[_ngcontent-%COMP%], .table[_ngcontent-%COMP%]    > tbody[_ngcontent-%COMP%]    > tr.active[_ngcontent-%COMP%]    > td[_ngcontent-%COMP%], .table[_ngcontent-%COMP%]    > tfoot[_ngcontent-%COMP%]    > tr.active[_ngcontent-%COMP%]    > td[_ngcontent-%COMP%], .table[_ngcontent-%COMP%]    > thead[_ngcontent-%COMP%]    > tr.active[_ngcontent-%COMP%]    > th[_ngcontent-%COMP%], .table[_ngcontent-%COMP%]    > tbody[_ngcontent-%COMP%]    > tr.active[_ngcontent-%COMP%]    > th[_ngcontent-%COMP%], .table[_ngcontent-%COMP%]    > tfoot[_ngcontent-%COMP%]    > tr.active[_ngcontent-%COMP%]    > th[_ngcontent-%COMP%] {\n  background-color: #f5f5f5;\n}\n.table-hover[_ngcontent-%COMP%]    > tbody[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]    > td.active[_ngcontent-%COMP%]:hover, .table-hover[_ngcontent-%COMP%]    > tbody[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]    > th.active[_ngcontent-%COMP%]:hover, .table-hover[_ngcontent-%COMP%]    > tbody[_ngcontent-%COMP%]    > tr.active[_ngcontent-%COMP%]:hover    > td[_ngcontent-%COMP%], .table-hover[_ngcontent-%COMP%]    > tbody[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]:hover    > .active[_ngcontent-%COMP%], .table-hover[_ngcontent-%COMP%]    > tbody[_ngcontent-%COMP%]    > tr.active[_ngcontent-%COMP%]:hover    > th[_ngcontent-%COMP%] {\n  background-color: #e8e8e8;\n}\n.table[_ngcontent-%COMP%]    > thead[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]    > td.success[_ngcontent-%COMP%], .table[_ngcontent-%COMP%]    > tbody[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]    > td.success[_ngcontent-%COMP%], .table[_ngcontent-%COMP%]    > tfoot[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]    > td.success[_ngcontent-%COMP%], .table[_ngcontent-%COMP%]    > thead[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]    > th.success[_ngcontent-%COMP%], .table[_ngcontent-%COMP%]    > tbody[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]    > th.success[_ngcontent-%COMP%], .table[_ngcontent-%COMP%]    > tfoot[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]    > th.success[_ngcontent-%COMP%], .table[_ngcontent-%COMP%]    > thead[_ngcontent-%COMP%]    > tr.success[_ngcontent-%COMP%]    > td[_ngcontent-%COMP%], .table[_ngcontent-%COMP%]    > tbody[_ngcontent-%COMP%]    > tr.success[_ngcontent-%COMP%]    > td[_ngcontent-%COMP%], .table[_ngcontent-%COMP%]    > tfoot[_ngcontent-%COMP%]    > tr.success[_ngcontent-%COMP%]    > td[_ngcontent-%COMP%], .table[_ngcontent-%COMP%]    > thead[_ngcontent-%COMP%]    > tr.success[_ngcontent-%COMP%]    > th[_ngcontent-%COMP%], .table[_ngcontent-%COMP%]    > tbody[_ngcontent-%COMP%]    > tr.success[_ngcontent-%COMP%]    > th[_ngcontent-%COMP%], .table[_ngcontent-%COMP%]    > tfoot[_ngcontent-%COMP%]    > tr.success[_ngcontent-%COMP%]    > th[_ngcontent-%COMP%] {\n  background-color: #dff0d8;\n}\n.table-hover[_ngcontent-%COMP%]    > tbody[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]    > td.success[_ngcontent-%COMP%]:hover, .table-hover[_ngcontent-%COMP%]    > tbody[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]    > th.success[_ngcontent-%COMP%]:hover, .table-hover[_ngcontent-%COMP%]    > tbody[_ngcontent-%COMP%]    > tr.success[_ngcontent-%COMP%]:hover    > td[_ngcontent-%COMP%], .table-hover[_ngcontent-%COMP%]    > tbody[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]:hover    > .success[_ngcontent-%COMP%], .table-hover[_ngcontent-%COMP%]    > tbody[_ngcontent-%COMP%]    > tr.success[_ngcontent-%COMP%]:hover    > th[_ngcontent-%COMP%] {\n  background-color: #d0e9c6;\n}\n.table[_ngcontent-%COMP%]    > thead[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]    > td.info[_ngcontent-%COMP%], .table[_ngcontent-%COMP%]    > tbody[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]    > td.info[_ngcontent-%COMP%], .table[_ngcontent-%COMP%]    > tfoot[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]    > td.info[_ngcontent-%COMP%], .table[_ngcontent-%COMP%]    > thead[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]    > th.info[_ngcontent-%COMP%], .table[_ngcontent-%COMP%]    > tbody[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]    > th.info[_ngcontent-%COMP%], .table[_ngcontent-%COMP%]    > tfoot[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]    > th.info[_ngcontent-%COMP%], .table[_ngcontent-%COMP%]    > thead[_ngcontent-%COMP%]    > tr.info[_ngcontent-%COMP%]    > td[_ngcontent-%COMP%], .table[_ngcontent-%COMP%]    > tbody[_ngcontent-%COMP%]    > tr.info[_ngcontent-%COMP%]    > td[_ngcontent-%COMP%], .table[_ngcontent-%COMP%]    > tfoot[_ngcontent-%COMP%]    > tr.info[_ngcontent-%COMP%]    > td[_ngcontent-%COMP%], .table[_ngcontent-%COMP%]    > thead[_ngcontent-%COMP%]    > tr.info[_ngcontent-%COMP%]    > th[_ngcontent-%COMP%], .table[_ngcontent-%COMP%]    > tbody[_ngcontent-%COMP%]    > tr.info[_ngcontent-%COMP%]    > th[_ngcontent-%COMP%], .table[_ngcontent-%COMP%]    > tfoot[_ngcontent-%COMP%]    > tr.info[_ngcontent-%COMP%]    > th[_ngcontent-%COMP%] {\n  background-color: #d9edf7;\n}\n.table-hover[_ngcontent-%COMP%]    > tbody[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]    > td.info[_ngcontent-%COMP%]:hover, .table-hover[_ngcontent-%COMP%]    > tbody[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]    > th.info[_ngcontent-%COMP%]:hover, .table-hover[_ngcontent-%COMP%]    > tbody[_ngcontent-%COMP%]    > tr.info[_ngcontent-%COMP%]:hover    > td[_ngcontent-%COMP%], .table-hover[_ngcontent-%COMP%]    > tbody[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]:hover    > .info[_ngcontent-%COMP%], .table-hover[_ngcontent-%COMP%]    > tbody[_ngcontent-%COMP%]    > tr.info[_ngcontent-%COMP%]:hover    > th[_ngcontent-%COMP%] {\n  background-color: #c4e3f3;\n}\n.table[_ngcontent-%COMP%]    > thead[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]    > td.warning[_ngcontent-%COMP%], .table[_ngcontent-%COMP%]    > tbody[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]    > td.warning[_ngcontent-%COMP%], .table[_ngcontent-%COMP%]    > tfoot[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]    > td.warning[_ngcontent-%COMP%], .table[_ngcontent-%COMP%]    > thead[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]    > th.warning[_ngcontent-%COMP%], .table[_ngcontent-%COMP%]    > tbody[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]    > th.warning[_ngcontent-%COMP%], .table[_ngcontent-%COMP%]    > tfoot[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]    > th.warning[_ngcontent-%COMP%], .table[_ngcontent-%COMP%]    > thead[_ngcontent-%COMP%]    > tr.warning[_ngcontent-%COMP%]    > td[_ngcontent-%COMP%], .table[_ngcontent-%COMP%]    > tbody[_ngcontent-%COMP%]    > tr.warning[_ngcontent-%COMP%]    > td[_ngcontent-%COMP%], .table[_ngcontent-%COMP%]    > tfoot[_ngcontent-%COMP%]    > tr.warning[_ngcontent-%COMP%]    > td[_ngcontent-%COMP%], .table[_ngcontent-%COMP%]    > thead[_ngcontent-%COMP%]    > tr.warning[_ngcontent-%COMP%]    > th[_ngcontent-%COMP%], .table[_ngcontent-%COMP%]    > tbody[_ngcontent-%COMP%]    > tr.warning[_ngcontent-%COMP%]    > th[_ngcontent-%COMP%], .table[_ngcontent-%COMP%]    > tfoot[_ngcontent-%COMP%]    > tr.warning[_ngcontent-%COMP%]    > th[_ngcontent-%COMP%] {\n  background-color: #fcf8e3;\n}\n.table-hover[_ngcontent-%COMP%]    > tbody[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]    > td.warning[_ngcontent-%COMP%]:hover, .table-hover[_ngcontent-%COMP%]    > tbody[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]    > th.warning[_ngcontent-%COMP%]:hover, .table-hover[_ngcontent-%COMP%]    > tbody[_ngcontent-%COMP%]    > tr.warning[_ngcontent-%COMP%]:hover    > td[_ngcontent-%COMP%], .table-hover[_ngcontent-%COMP%]    > tbody[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]:hover    > .warning[_ngcontent-%COMP%], .table-hover[_ngcontent-%COMP%]    > tbody[_ngcontent-%COMP%]    > tr.warning[_ngcontent-%COMP%]:hover    > th[_ngcontent-%COMP%] {\n  background-color: #faf2cc;\n}\n.table[_ngcontent-%COMP%]    > thead[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]    > td.danger[_ngcontent-%COMP%], .table[_ngcontent-%COMP%]    > tbody[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]    > td.danger[_ngcontent-%COMP%], .table[_ngcontent-%COMP%]    > tfoot[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]    > td.danger[_ngcontent-%COMP%], .table[_ngcontent-%COMP%]    > thead[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]    > th.danger[_ngcontent-%COMP%], .table[_ngcontent-%COMP%]    > tbody[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]    > th.danger[_ngcontent-%COMP%], .table[_ngcontent-%COMP%]    > tfoot[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]    > th.danger[_ngcontent-%COMP%], .table[_ngcontent-%COMP%]    > thead[_ngcontent-%COMP%]    > tr.danger[_ngcontent-%COMP%]    > td[_ngcontent-%COMP%], .table[_ngcontent-%COMP%]    > tbody[_ngcontent-%COMP%]    > tr.danger[_ngcontent-%COMP%]    > td[_ngcontent-%COMP%], .table[_ngcontent-%COMP%]    > tfoot[_ngcontent-%COMP%]    > tr.danger[_ngcontent-%COMP%]    > td[_ngcontent-%COMP%], .table[_ngcontent-%COMP%]    > thead[_ngcontent-%COMP%]    > tr.danger[_ngcontent-%COMP%]    > th[_ngcontent-%COMP%], .table[_ngcontent-%COMP%]    > tbody[_ngcontent-%COMP%]    > tr.danger[_ngcontent-%COMP%]    > th[_ngcontent-%COMP%], .table[_ngcontent-%COMP%]    > tfoot[_ngcontent-%COMP%]    > tr.danger[_ngcontent-%COMP%]    > th[_ngcontent-%COMP%] {\n  background-color: #f2dede;\n}\n.table-hover[_ngcontent-%COMP%]    > tbody[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]    > td.danger[_ngcontent-%COMP%]:hover, .table-hover[_ngcontent-%COMP%]    > tbody[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]    > th.danger[_ngcontent-%COMP%]:hover, .table-hover[_ngcontent-%COMP%]    > tbody[_ngcontent-%COMP%]    > tr.danger[_ngcontent-%COMP%]:hover    > td[_ngcontent-%COMP%], .table-hover[_ngcontent-%COMP%]    > tbody[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]:hover    > .danger[_ngcontent-%COMP%], .table-hover[_ngcontent-%COMP%]    > tbody[_ngcontent-%COMP%]    > tr.danger[_ngcontent-%COMP%]:hover    > th[_ngcontent-%COMP%] {\n  background-color: #ebcccc;\n}\n.table-responsive[_ngcontent-%COMP%] {\n  min-height: .01%;\n  overflow-x: auto;\n}\n@media screen and (max-width: 767px) {\n  .table-responsive[_ngcontent-%COMP%] {\n    width: 100%;\n    margin-bottom: 15px;\n    overflow-y: hidden;\n    -ms-overflow-style: -ms-autohiding-scrollbar;\n    border: 1px solid #ddd;\n  }\n  .table-responsive[_ngcontent-%COMP%]    > .table[_ngcontent-%COMP%] {\n    margin-bottom: 0;\n  }\n  .table-responsive[_ngcontent-%COMP%]    > .table[_ngcontent-%COMP%]    > thead[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]    > th[_ngcontent-%COMP%], .table-responsive[_ngcontent-%COMP%]    > .table[_ngcontent-%COMP%]    > tbody[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]    > th[_ngcontent-%COMP%], .table-responsive[_ngcontent-%COMP%]    > .table[_ngcontent-%COMP%]    > tfoot[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]    > th[_ngcontent-%COMP%], .table-responsive[_ngcontent-%COMP%]    > .table[_ngcontent-%COMP%]    > thead[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]    > td[_ngcontent-%COMP%], .table-responsive[_ngcontent-%COMP%]    > .table[_ngcontent-%COMP%]    > tbody[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]    > td[_ngcontent-%COMP%], .table-responsive[_ngcontent-%COMP%]    > .table[_ngcontent-%COMP%]    > tfoot[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]    > td[_ngcontent-%COMP%] {\n    white-space: nowrap;\n  }\n  .table-responsive[_ngcontent-%COMP%]    > .table-bordered[_ngcontent-%COMP%] {\n    border: 0;\n  }\n  .table-responsive[_ngcontent-%COMP%]    > .table-bordered[_ngcontent-%COMP%]    > thead[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]    > th[_ngcontent-%COMP%]:first-child, .table-responsive[_ngcontent-%COMP%]    > .table-bordered[_ngcontent-%COMP%]    > tbody[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]    > th[_ngcontent-%COMP%]:first-child, .table-responsive[_ngcontent-%COMP%]    > .table-bordered[_ngcontent-%COMP%]    > tfoot[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]    > th[_ngcontent-%COMP%]:first-child, .table-responsive[_ngcontent-%COMP%]    > .table-bordered[_ngcontent-%COMP%]    > thead[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]    > td[_ngcontent-%COMP%]:first-child, .table-responsive[_ngcontent-%COMP%]    > .table-bordered[_ngcontent-%COMP%]    > tbody[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]    > td[_ngcontent-%COMP%]:first-child, .table-responsive[_ngcontent-%COMP%]    > .table-bordered[_ngcontent-%COMP%]    > tfoot[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]    > td[_ngcontent-%COMP%]:first-child {\n    border-left: 0;\n  }\n  .table-responsive[_ngcontent-%COMP%]    > .table-bordered[_ngcontent-%COMP%]    > thead[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]    > th[_ngcontent-%COMP%]:last-child, .table-responsive[_ngcontent-%COMP%]    > .table-bordered[_ngcontent-%COMP%]    > tbody[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]    > th[_ngcontent-%COMP%]:last-child, .table-responsive[_ngcontent-%COMP%]    > .table-bordered[_ngcontent-%COMP%]    > tfoot[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]    > th[_ngcontent-%COMP%]:last-child, .table-responsive[_ngcontent-%COMP%]    > .table-bordered[_ngcontent-%COMP%]    > thead[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]    > td[_ngcontent-%COMP%]:last-child, .table-responsive[_ngcontent-%COMP%]    > .table-bordered[_ngcontent-%COMP%]    > tbody[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]    > td[_ngcontent-%COMP%]:last-child, .table-responsive[_ngcontent-%COMP%]    > .table-bordered[_ngcontent-%COMP%]    > tfoot[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]    > td[_ngcontent-%COMP%]:last-child {\n    border-right: 0;\n  }\n  .table-responsive[_ngcontent-%COMP%]    > .table-bordered[_ngcontent-%COMP%]    > tbody[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]:last-child    > th[_ngcontent-%COMP%], .table-responsive[_ngcontent-%COMP%]    > .table-bordered[_ngcontent-%COMP%]    > tfoot[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]:last-child    > th[_ngcontent-%COMP%], .table-responsive[_ngcontent-%COMP%]    > .table-bordered[_ngcontent-%COMP%]    > tbody[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]:last-child    > td[_ngcontent-%COMP%], .table-responsive[_ngcontent-%COMP%]    > .table-bordered[_ngcontent-%COMP%]    > tfoot[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]:last-child    > td[_ngcontent-%COMP%] {\n    border-bottom: 0;\n  }\n}\nfieldset[_ngcontent-%COMP%] {\n  min-width: 0;\n  padding: 0;\n  margin: 0;\n  border: 0;\n}\nlegend[_ngcontent-%COMP%] {\n  display: block;\n  width: 100%;\n  padding: 0;\n  margin-bottom: 20px;\n  font-size: 21px;\n  line-height: inherit;\n  color: #333;\n  border: 0;\n  border-bottom: 1px solid #e5e5e5;\n}\nlabel[_ngcontent-%COMP%] {\n  display: inline-block;\n  max-width: 100%;\n  margin-bottom: 5px;\n  font-weight: bold;\n}\ninput[type="search"][_ngcontent-%COMP%] {\n  -webkit-box-sizing: border-box;\n     -moz-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[type="radio"][_ngcontent-%COMP%], input[type="checkbox"][_ngcontent-%COMP%] {\n  margin: 4px 0 0;\n  margin-top: 1px \\9;\n  line-height: normal;\n}\ninput[type="file"][_ngcontent-%COMP%] {\n  display: block;\n}\ninput[type="range"][_ngcontent-%COMP%] {\n  display: block;\n  width: 100%;\n}\nselect[multiple][_ngcontent-%COMP%], select[size][_ngcontent-%COMP%] {\n  height: auto;\n}\ninput[type="file"][_ngcontent-%COMP%]:focus, input[type="radio"][_ngcontent-%COMP%]:focus, input[type="checkbox"][_ngcontent-%COMP%]:focus {\n  outline: 5px auto -webkit-focus-ring-color;\n  outline-offset: -2px;\n}\noutput[_ngcontent-%COMP%] {\n  display: block;\n  padding-top: 7px;\n  font-size: 14px;\n  line-height: 1.42857143;\n  color: #555;\n}\n.form-control[_ngcontent-%COMP%] {\n  display: block;\n  width: 100%;\n  height: 34px;\n  padding: 6px 12px;\n  font-size: 14px;\n  line-height: 1.42857143;\n  color: #555;\n  background-color: #fff;\n  background-image: none;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075);\n          box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075);\n  -webkit-transition: border-color ease-in-out .15s, -webkit-box-shadow ease-in-out .15s;\n       -o-transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;\n          transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;\n}\n.form-control[_ngcontent-%COMP%]:focus {\n  border-color: #66afe9;\n  outline: 0;\n  -webkit-box-shadow: inset 0 1px 1px rgba(0,0,0,.075), 0 0 8px rgba(102, 175, 233, .6);\n          box-shadow: inset 0 1px 1px rgba(0,0,0,.075), 0 0 8px rgba(102, 175, 233, .6);\n}\n.form-control[_ngcontent-%COMP%]::-moz-placeholder {\n  color: #999;\n  opacity: 1;\n}\n.form-control[_ngcontent-%COMP%]:-ms-input-placeholder {\n  color: #999;\n}\n.form-control[_ngcontent-%COMP%]::-webkit-input-placeholder {\n  color: #999;\n}\n.form-control[_ngcontent-%COMP%]::-ms-expand {\n  background-color: transparent;\n  border: 0;\n}\n.form-control[disabled][_ngcontent-%COMP%], .form-control[readonly][_ngcontent-%COMP%], fieldset[disabled][_ngcontent-%COMP%]   .form-control[_ngcontent-%COMP%] {\n  background-color: #eee;\n  opacity: 1;\n}\n.form-control[disabled][_ngcontent-%COMP%], fieldset[disabled][_ngcontent-%COMP%]   .form-control[_ngcontent-%COMP%] {\n  cursor: not-allowed;\n}\ntextarea.form-control[_ngcontent-%COMP%] {\n  height: auto;\n}\ninput[type="search"][_ngcontent-%COMP%] {\n  -webkit-appearance: none;\n}\n@media screen and (-webkit-min-device-pixel-ratio: 0) {\n  input[type="date"].form-control[_ngcontent-%COMP%], input[type="time"].form-control[_ngcontent-%COMP%], input[type="datetime-local"].form-control[_ngcontent-%COMP%], input[type="month"].form-control[_ngcontent-%COMP%] {\n    line-height: 34px;\n  }\n  input[type="date"].input-sm[_ngcontent-%COMP%], input[type="time"].input-sm[_ngcontent-%COMP%], input[type="datetime-local"].input-sm[_ngcontent-%COMP%], input[type="month"].input-sm[_ngcontent-%COMP%], .input-group-sm[_ngcontent-%COMP%]   input[type="date"][_ngcontent-%COMP%], .input-group-sm[_ngcontent-%COMP%]   input[type="time"][_ngcontent-%COMP%], .input-group-sm[_ngcontent-%COMP%]   input[type="datetime-local"][_ngcontent-%COMP%], .input-group-sm[_ngcontent-%COMP%]   input[type="month"][_ngcontent-%COMP%] {\n    line-height: 30px;\n  }\n  input[type="date"].input-lg[_ngcontent-%COMP%], input[type="time"].input-lg[_ngcontent-%COMP%], input[type="datetime-local"].input-lg[_ngcontent-%COMP%], input[type="month"].input-lg[_ngcontent-%COMP%], .input-group-lg[_ngcontent-%COMP%]   input[type="date"][_ngcontent-%COMP%], .input-group-lg[_ngcontent-%COMP%]   input[type="time"][_ngcontent-%COMP%], .input-group-lg[_ngcontent-%COMP%]   input[type="datetime-local"][_ngcontent-%COMP%], .input-group-lg[_ngcontent-%COMP%]   input[type="month"][_ngcontent-%COMP%] {\n    line-height: 46px;\n  }\n}\n.form-group[_ngcontent-%COMP%] {\n  margin-bottom: 15px;\n}\n.radio[_ngcontent-%COMP%], .checkbox[_ngcontent-%COMP%] {\n  position: relative;\n  display: block;\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n.radio[_ngcontent-%COMP%]   label[_ngcontent-%COMP%], .checkbox[_ngcontent-%COMP%]   label[_ngcontent-%COMP%] {\n  min-height: 20px;\n  padding-left: 20px;\n  margin-bottom: 0;\n  font-weight: normal;\n  cursor: pointer;\n}\n.radio[_ngcontent-%COMP%]   input[type="radio"][_ngcontent-%COMP%], .radio-inline[_ngcontent-%COMP%]   input[type="radio"][_ngcontent-%COMP%], .checkbox[_ngcontent-%COMP%]   input[type="checkbox"][_ngcontent-%COMP%], .checkbox-inline[_ngcontent-%COMP%]   input[type="checkbox"][_ngcontent-%COMP%] {\n  position: absolute;\n  margin-top: 4px \\9;\n  margin-left: -20px;\n}\n.radio[_ngcontent-%COMP%]    + .radio[_ngcontent-%COMP%], .checkbox[_ngcontent-%COMP%]    + .checkbox[_ngcontent-%COMP%] {\n  margin-top: -5px;\n}\n.radio-inline[_ngcontent-%COMP%], .checkbox-inline[_ngcontent-%COMP%] {\n  position: relative;\n  display: inline-block;\n  padding-left: 20px;\n  margin-bottom: 0;\n  font-weight: normal;\n  vertical-align: middle;\n  cursor: pointer;\n}\n.radio-inline[_ngcontent-%COMP%]    + .radio-inline[_ngcontent-%COMP%], .checkbox-inline[_ngcontent-%COMP%]    + .checkbox-inline[_ngcontent-%COMP%] {\n  margin-top: 0;\n  margin-left: 10px;\n}\ninput[type="radio"][disabled][_ngcontent-%COMP%], input[type="checkbox"][disabled][_ngcontent-%COMP%], input[type="radio"].disabled[_ngcontent-%COMP%], input[type="checkbox"].disabled[_ngcontent-%COMP%], fieldset[disabled][_ngcontent-%COMP%]   input[type="radio"][_ngcontent-%COMP%], fieldset[disabled][_ngcontent-%COMP%]   input[type="checkbox"][_ngcontent-%COMP%] {\n  cursor: not-allowed;\n}\n.radio-inline.disabled[_ngcontent-%COMP%], .checkbox-inline.disabled[_ngcontent-%COMP%], fieldset[disabled][_ngcontent-%COMP%]   .radio-inline[_ngcontent-%COMP%], fieldset[disabled][_ngcontent-%COMP%]   .checkbox-inline[_ngcontent-%COMP%] {\n  cursor: not-allowed;\n}\n.radio.disabled[_ngcontent-%COMP%]   label[_ngcontent-%COMP%], .checkbox.disabled[_ngcontent-%COMP%]   label[_ngcontent-%COMP%], fieldset[disabled][_ngcontent-%COMP%]   .radio[_ngcontent-%COMP%]   label[_ngcontent-%COMP%], fieldset[disabled][_ngcontent-%COMP%]   .checkbox[_ngcontent-%COMP%]   label[_ngcontent-%COMP%] {\n  cursor: not-allowed;\n}\n.form-control-static[_ngcontent-%COMP%] {\n  min-height: 34px;\n  padding-top: 7px;\n  padding-bottom: 7px;\n  margin-bottom: 0;\n}\n.form-control-static.input-lg[_ngcontent-%COMP%], .form-control-static.input-sm[_ngcontent-%COMP%] {\n  padding-right: 0;\n  padding-left: 0;\n}\n.input-sm[_ngcontent-%COMP%] {\n  height: 30px;\n  padding: 5px 10px;\n  font-size: 12px;\n  line-height: 1.5;\n  border-radius: 3px;\n}\nselect.input-sm[_ngcontent-%COMP%] {\n  height: 30px;\n  line-height: 30px;\n}\ntextarea.input-sm[_ngcontent-%COMP%], select[multiple].input-sm[_ngcontent-%COMP%] {\n  height: auto;\n}\n.form-group-sm[_ngcontent-%COMP%]   .form-control[_ngcontent-%COMP%] {\n  height: 30px;\n  padding: 5px 10px;\n  font-size: 12px;\n  line-height: 1.5;\n  border-radius: 3px;\n}\n.form-group-sm[_ngcontent-%COMP%]   select.form-control[_ngcontent-%COMP%] {\n  height: 30px;\n  line-height: 30px;\n}\n.form-group-sm[_ngcontent-%COMP%]   textarea.form-control[_ngcontent-%COMP%], .form-group-sm[_ngcontent-%COMP%]   select[multiple].form-control[_ngcontent-%COMP%] {\n  height: auto;\n}\n.form-group-sm[_ngcontent-%COMP%]   .form-control-static[_ngcontent-%COMP%] {\n  height: 30px;\n  min-height: 32px;\n  padding: 6px 10px;\n  font-size: 12px;\n  line-height: 1.5;\n}\n.input-lg[_ngcontent-%COMP%] {\n  height: 46px;\n  padding: 10px 16px;\n  font-size: 18px;\n  line-height: 1.3333333;\n  border-radius: 6px;\n}\nselect.input-lg[_ngcontent-%COMP%] {\n  height: 46px;\n  line-height: 46px;\n}\ntextarea.input-lg[_ngcontent-%COMP%], select[multiple].input-lg[_ngcontent-%COMP%] {\n  height: auto;\n}\n.form-group-lg[_ngcontent-%COMP%]   .form-control[_ngcontent-%COMP%] {\n  height: 46px;\n  padding: 10px 16px;\n  font-size: 18px;\n  line-height: 1.3333333;\n  border-radius: 6px;\n}\n.form-group-lg[_ngcontent-%COMP%]   select.form-control[_ngcontent-%COMP%] {\n  height: 46px;\n  line-height: 46px;\n}\n.form-group-lg[_ngcontent-%COMP%]   textarea.form-control[_ngcontent-%COMP%], .form-group-lg[_ngcontent-%COMP%]   select[multiple].form-control[_ngcontent-%COMP%] {\n  height: auto;\n}\n.form-group-lg[_ngcontent-%COMP%]   .form-control-static[_ngcontent-%COMP%] {\n  height: 46px;\n  min-height: 38px;\n  padding: 11px 16px;\n  font-size: 18px;\n  line-height: 1.3333333;\n}\n.has-feedback[_ngcontent-%COMP%] {\n  position: relative;\n}\n.has-feedback[_ngcontent-%COMP%]   .form-control[_ngcontent-%COMP%] {\n  padding-right: 42.5px;\n}\n.form-control-feedback[_ngcontent-%COMP%] {\n  position: absolute;\n  top: 0;\n  right: 0;\n  z-index: 2;\n  display: block;\n  width: 34px;\n  height: 34px;\n  line-height: 34px;\n  text-align: center;\n  pointer-events: none;\n}\n.input-lg[_ngcontent-%COMP%]    + .form-control-feedback[_ngcontent-%COMP%], .input-group-lg[_ngcontent-%COMP%]    + .form-control-feedback[_ngcontent-%COMP%], .form-group-lg[_ngcontent-%COMP%]   .form-control[_ngcontent-%COMP%]    + .form-control-feedback[_ngcontent-%COMP%] {\n  width: 46px;\n  height: 46px;\n  line-height: 46px;\n}\n.input-sm[_ngcontent-%COMP%]    + .form-control-feedback[_ngcontent-%COMP%], .input-group-sm[_ngcontent-%COMP%]    + .form-control-feedback[_ngcontent-%COMP%], .form-group-sm[_ngcontent-%COMP%]   .form-control[_ngcontent-%COMP%]    + .form-control-feedback[_ngcontent-%COMP%] {\n  width: 30px;\n  height: 30px;\n  line-height: 30px;\n}\n.has-success[_ngcontent-%COMP%]   .help-block[_ngcontent-%COMP%], .has-success[_ngcontent-%COMP%]   .control-label[_ngcontent-%COMP%], .has-success[_ngcontent-%COMP%]   .radio[_ngcontent-%COMP%], .has-success[_ngcontent-%COMP%]   .checkbox[_ngcontent-%COMP%], .has-success[_ngcontent-%COMP%]   .radio-inline[_ngcontent-%COMP%], .has-success[_ngcontent-%COMP%]   .checkbox-inline[_ngcontent-%COMP%], .has-success.radio[_ngcontent-%COMP%]   label[_ngcontent-%COMP%], .has-success.checkbox[_ngcontent-%COMP%]   label[_ngcontent-%COMP%], .has-success.radio-inline[_ngcontent-%COMP%]   label[_ngcontent-%COMP%], .has-success.checkbox-inline[_ngcontent-%COMP%]   label[_ngcontent-%COMP%] {\n  color: #3c763d;\n}\n.has-success[_ngcontent-%COMP%]   .form-control[_ngcontent-%COMP%] {\n  border-color: #3c763d;\n  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075);\n          box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075);\n}\n.has-success[_ngcontent-%COMP%]   .form-control[_ngcontent-%COMP%]:focus {\n  border-color: #2b542c;\n  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 6px #67b168;\n          box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 6px #67b168;\n}\n.has-success[_ngcontent-%COMP%]   .input-group-addon[_ngcontent-%COMP%] {\n  color: #3c763d;\n  background-color: #dff0d8;\n  border-color: #3c763d;\n}\n.has-success[_ngcontent-%COMP%]   .form-control-feedback[_ngcontent-%COMP%] {\n  color: #3c763d;\n}\n.has-warning[_ngcontent-%COMP%]   .help-block[_ngcontent-%COMP%], .has-warning[_ngcontent-%COMP%]   .control-label[_ngcontent-%COMP%], .has-warning[_ngcontent-%COMP%]   .radio[_ngcontent-%COMP%], .has-warning[_ngcontent-%COMP%]   .checkbox[_ngcontent-%COMP%], .has-warning[_ngcontent-%COMP%]   .radio-inline[_ngcontent-%COMP%], .has-warning[_ngcontent-%COMP%]   .checkbox-inline[_ngcontent-%COMP%], .has-warning.radio[_ngcontent-%COMP%]   label[_ngcontent-%COMP%], .has-warning.checkbox[_ngcontent-%COMP%]   label[_ngcontent-%COMP%], .has-warning.radio-inline[_ngcontent-%COMP%]   label[_ngcontent-%COMP%], .has-warning.checkbox-inline[_ngcontent-%COMP%]   label[_ngcontent-%COMP%] {\n  color: #8a6d3b;\n}\n.has-warning[_ngcontent-%COMP%]   .form-control[_ngcontent-%COMP%] {\n  border-color: #8a6d3b;\n  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075);\n          box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075);\n}\n.has-warning[_ngcontent-%COMP%]   .form-control[_ngcontent-%COMP%]:focus {\n  border-color: #66512c;\n  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 6px #c0a16b;\n          box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 6px #c0a16b;\n}\n.has-warning[_ngcontent-%COMP%]   .input-group-addon[_ngcontent-%COMP%] {\n  color: #8a6d3b;\n  background-color: #fcf8e3;\n  border-color: #8a6d3b;\n}\n.has-warning[_ngcontent-%COMP%]   .form-control-feedback[_ngcontent-%COMP%] {\n  color: #8a6d3b;\n}\n.has-error[_ngcontent-%COMP%]   .help-block[_ngcontent-%COMP%], .has-error[_ngcontent-%COMP%]   .control-label[_ngcontent-%COMP%], .has-error[_ngcontent-%COMP%]   .radio[_ngcontent-%COMP%], .has-error[_ngcontent-%COMP%]   .checkbox[_ngcontent-%COMP%], .has-error[_ngcontent-%COMP%]   .radio-inline[_ngcontent-%COMP%], .has-error[_ngcontent-%COMP%]   .checkbox-inline[_ngcontent-%COMP%], .has-error.radio[_ngcontent-%COMP%]   label[_ngcontent-%COMP%], .has-error.checkbox[_ngcontent-%COMP%]   label[_ngcontent-%COMP%], .has-error.radio-inline[_ngcontent-%COMP%]   label[_ngcontent-%COMP%], .has-error.checkbox-inline[_ngcontent-%COMP%]   label[_ngcontent-%COMP%] {\n  color: #a94442;\n}\n.has-error[_ngcontent-%COMP%]   .form-control[_ngcontent-%COMP%] {\n  border-color: #a94442;\n  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075);\n          box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075);\n}\n.has-error[_ngcontent-%COMP%]   .form-control[_ngcontent-%COMP%]:focus {\n  border-color: #843534;\n  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 6px #ce8483;\n          box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 6px #ce8483;\n}\n.has-error[_ngcontent-%COMP%]   .input-group-addon[_ngcontent-%COMP%] {\n  color: #a94442;\n  background-color: #f2dede;\n  border-color: #a94442;\n}\n.has-error[_ngcontent-%COMP%]   .form-control-feedback[_ngcontent-%COMP%] {\n  color: #a94442;\n}\n.has-feedback[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]    ~ .form-control-feedback[_ngcontent-%COMP%] {\n  top: 25px;\n}\n.has-feedback[_ngcontent-%COMP%]   label.sr-only[_ngcontent-%COMP%]    ~ .form-control-feedback[_ngcontent-%COMP%] {\n  top: 0;\n}\n.help-block[_ngcontent-%COMP%] {\n  display: block;\n  margin-top: 5px;\n  margin-bottom: 10px;\n  color: #737373;\n}\n@media (min-width: 768px) {\n  .form-inline[_ngcontent-%COMP%]   .form-group[_ngcontent-%COMP%] {\n    display: inline-block;\n    margin-bottom: 0;\n    vertical-align: middle;\n  }\n  .form-inline[_ngcontent-%COMP%]   .form-control[_ngcontent-%COMP%] {\n    display: inline-block;\n    width: auto;\n    vertical-align: middle;\n  }\n  .form-inline[_ngcontent-%COMP%]   .form-control-static[_ngcontent-%COMP%] {\n    display: inline-block;\n  }\n  .form-inline[_ngcontent-%COMP%]   .input-group[_ngcontent-%COMP%] {\n    display: inline-table;\n    vertical-align: middle;\n  }\n  .form-inline[_ngcontent-%COMP%]   .input-group[_ngcontent-%COMP%]   .input-group-addon[_ngcontent-%COMP%], .form-inline[_ngcontent-%COMP%]   .input-group[_ngcontent-%COMP%]   .input-group-btn[_ngcontent-%COMP%], .form-inline[_ngcontent-%COMP%]   .input-group[_ngcontent-%COMP%]   .form-control[_ngcontent-%COMP%] {\n    width: auto;\n  }\n  .form-inline[_ngcontent-%COMP%]   .input-group[_ngcontent-%COMP%]    > .form-control[_ngcontent-%COMP%] {\n    width: 100%;\n  }\n  .form-inline[_ngcontent-%COMP%]   .control-label[_ngcontent-%COMP%] {\n    margin-bottom: 0;\n    vertical-align: middle;\n  }\n  .form-inline[_ngcontent-%COMP%]   .radio[_ngcontent-%COMP%], .form-inline[_ngcontent-%COMP%]   .checkbox[_ngcontent-%COMP%] {\n    display: inline-block;\n    margin-top: 0;\n    margin-bottom: 0;\n    vertical-align: middle;\n  }\n  .form-inline[_ngcontent-%COMP%]   .radio[_ngcontent-%COMP%]   label[_ngcontent-%COMP%], .form-inline[_ngcontent-%COMP%]   .checkbox[_ngcontent-%COMP%]   label[_ngcontent-%COMP%] {\n    padding-left: 0;\n  }\n  .form-inline[_ngcontent-%COMP%]   .radio[_ngcontent-%COMP%]   input[type="radio"][_ngcontent-%COMP%], .form-inline[_ngcontent-%COMP%]   .checkbox[_ngcontent-%COMP%]   input[type="checkbox"][_ngcontent-%COMP%] {\n    position: relative;\n    margin-left: 0;\n  }\n  .form-inline[_ngcontent-%COMP%]   .has-feedback[_ngcontent-%COMP%]   .form-control-feedback[_ngcontent-%COMP%] {\n    top: 0;\n  }\n}\n.form-horizontal[_ngcontent-%COMP%]   .radio[_ngcontent-%COMP%], .form-horizontal[_ngcontent-%COMP%]   .checkbox[_ngcontent-%COMP%], .form-horizontal[_ngcontent-%COMP%]   .radio-inline[_ngcontent-%COMP%], .form-horizontal[_ngcontent-%COMP%]   .checkbox-inline[_ngcontent-%COMP%] {\n  padding-top: 7px;\n  margin-top: 0;\n  margin-bottom: 0;\n}\n.form-horizontal[_ngcontent-%COMP%]   .radio[_ngcontent-%COMP%], .form-horizontal[_ngcontent-%COMP%]   .checkbox[_ngcontent-%COMP%] {\n  min-height: 27px;\n}\n.form-horizontal[_ngcontent-%COMP%]   .form-group[_ngcontent-%COMP%] {\n  margin-right: -15px;\n  margin-left: -15px;\n}\n@media (min-width: 768px) {\n  .form-horizontal[_ngcontent-%COMP%]   .control-label[_ngcontent-%COMP%] {\n    padding-top: 7px;\n    margin-bottom: 0;\n    text-align: right;\n  }\n}\n.form-horizontal[_ngcontent-%COMP%]   .has-feedback[_ngcontent-%COMP%]   .form-control-feedback[_ngcontent-%COMP%] {\n  right: 15px;\n}\n@media (min-width: 768px) {\n  .form-horizontal[_ngcontent-%COMP%]   .form-group-lg[_ngcontent-%COMP%]   .control-label[_ngcontent-%COMP%] {\n    padding-top: 11px;\n    font-size: 18px;\n  }\n}\n@media (min-width: 768px) {\n  .form-horizontal[_ngcontent-%COMP%]   .form-group-sm[_ngcontent-%COMP%]   .control-label[_ngcontent-%COMP%] {\n    padding-top: 6px;\n    font-size: 12px;\n  }\n}\n.btn[_ngcontent-%COMP%] {\n  display: inline-block;\n  padding: 6px 12px;\n  margin-bottom: 0;\n  font-size: 14px;\n  font-weight: normal;\n  line-height: 1.42857143;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: middle;\n  -ms-touch-action: manipulation;\n      touch-action: manipulation;\n  cursor: pointer;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  background-image: none;\n  border: 1px solid transparent;\n  border-radius: 4px;\n}\n.btn[_ngcontent-%COMP%]:focus, .btn[_ngcontent-%COMP%]:active:focus, .btn.active[_ngcontent-%COMP%]:focus, .btn.focus[_ngcontent-%COMP%], .btn[_ngcontent-%COMP%]:active.focus, .btn.active.focus[_ngcontent-%COMP%] {\n  outline: 5px auto -webkit-focus-ring-color;\n  outline-offset: -2px;\n}\n.btn[_ngcontent-%COMP%]:hover, .btn[_ngcontent-%COMP%]:focus, .btn.focus[_ngcontent-%COMP%] {\n  color: #333;\n  text-decoration: none;\n}\n.btn[_ngcontent-%COMP%]:active, .btn.active[_ngcontent-%COMP%] {\n  background-image: none;\n  outline: 0;\n  -webkit-box-shadow: inset 0 3px 5px rgba(0, 0, 0, .125);\n          box-shadow: inset 0 3px 5px rgba(0, 0, 0, .125);\n}\n.btn.disabled[_ngcontent-%COMP%], .btn[disabled][_ngcontent-%COMP%], fieldset[disabled][_ngcontent-%COMP%]   .btn[_ngcontent-%COMP%] {\n  cursor: not-allowed;\n  filter: alpha(opacity=65);\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  opacity: .65;\n}\na.btn.disabled[_ngcontent-%COMP%], fieldset[disabled][_ngcontent-%COMP%]   a.btn[_ngcontent-%COMP%] {\n  pointer-events: none;\n}\n.btn-default[_ngcontent-%COMP%] {\n  color: #333;\n  background-color: #fff;\n  border-color: #ccc;\n}\n.btn-default[_ngcontent-%COMP%]:focus, .btn-default.focus[_ngcontent-%COMP%] {\n  color: #333;\n  background-color: #e6e6e6;\n  border-color: #8c8c8c;\n}\n.btn-default[_ngcontent-%COMP%]:hover {\n  color: #333;\n  background-color: #e6e6e6;\n  border-color: #adadad;\n}\n.btn-default[_ngcontent-%COMP%]:active, .btn-default.active[_ngcontent-%COMP%], .open[_ngcontent-%COMP%]    > .dropdown-toggle.btn-default[_ngcontent-%COMP%] {\n  color: #333;\n  background-color: #e6e6e6;\n  border-color: #adadad;\n}\n.btn-default[_ngcontent-%COMP%]:active:hover, .btn-default.active[_ngcontent-%COMP%]:hover, .open[_ngcontent-%COMP%]    > .dropdown-toggle.btn-default[_ngcontent-%COMP%]:hover, .btn-default[_ngcontent-%COMP%]:active:focus, .btn-default.active[_ngcontent-%COMP%]:focus, .open[_ngcontent-%COMP%]    > .dropdown-toggle.btn-default[_ngcontent-%COMP%]:focus, .btn-default[_ngcontent-%COMP%]:active.focus, .btn-default.active.focus[_ngcontent-%COMP%], .open[_ngcontent-%COMP%]    > .dropdown-toggle.btn-default.focus[_ngcontent-%COMP%] {\n  color: #333;\n  background-color: #d4d4d4;\n  border-color: #8c8c8c;\n}\n.btn-default[_ngcontent-%COMP%]:active, .btn-default.active[_ngcontent-%COMP%], .open[_ngcontent-%COMP%]    > .dropdown-toggle.btn-default[_ngcontent-%COMP%] {\n  background-image: none;\n}\n.btn-default.disabled[_ngcontent-%COMP%]:hover, .btn-default[disabled][_ngcontent-%COMP%]:hover, fieldset[disabled][_ngcontent-%COMP%]   .btn-default[_ngcontent-%COMP%]:hover, .btn-default.disabled[_ngcontent-%COMP%]:focus, .btn-default[disabled][_ngcontent-%COMP%]:focus, fieldset[disabled][_ngcontent-%COMP%]   .btn-default[_ngcontent-%COMP%]:focus, .btn-default.disabled.focus[_ngcontent-%COMP%], .btn-default[disabled].focus[_ngcontent-%COMP%], fieldset[disabled][_ngcontent-%COMP%]   .btn-default.focus[_ngcontent-%COMP%] {\n  background-color: #fff;\n  border-color: #ccc;\n}\n.btn-default[_ngcontent-%COMP%]   .badge[_ngcontent-%COMP%] {\n  color: #fff;\n  background-color: #333;\n}\n.btn-primary[_ngcontent-%COMP%] {\n  color: #fff;\n  background-color: #337ab7;\n  border-color: #2e6da4;\n}\n.btn-primary[_ngcontent-%COMP%]:focus, .btn-primary.focus[_ngcontent-%COMP%] {\n  color: #fff;\n  background-color: #286090;\n  border-color: #122b40;\n}\n.btn-primary[_ngcontent-%COMP%]:hover {\n  color: #fff;\n  background-color: #286090;\n  border-color: #204d74;\n}\n.btn-primary[_ngcontent-%COMP%]:active, .btn-primary.active[_ngcontent-%COMP%], .open[_ngcontent-%COMP%]    > .dropdown-toggle.btn-primary[_ngcontent-%COMP%] {\n  color: #fff;\n  background-color: #286090;\n  border-color: #204d74;\n}\n.btn-primary[_ngcontent-%COMP%]:active:hover, .btn-primary.active[_ngcontent-%COMP%]:hover, .open[_ngcontent-%COMP%]    > .dropdown-toggle.btn-primary[_ngcontent-%COMP%]:hover, .btn-primary[_ngcontent-%COMP%]:active:focus, .btn-primary.active[_ngcontent-%COMP%]:focus, .open[_ngcontent-%COMP%]    > .dropdown-toggle.btn-primary[_ngcontent-%COMP%]:focus, .btn-primary[_ngcontent-%COMP%]:active.focus, .btn-primary.active.focus[_ngcontent-%COMP%], .open[_ngcontent-%COMP%]    > .dropdown-toggle.btn-primary.focus[_ngcontent-%COMP%] {\n  color: #fff;\n  background-color: #204d74;\n  border-color: #122b40;\n}\n.btn-primary[_ngcontent-%COMP%]:active, .btn-primary.active[_ngcontent-%COMP%], .open[_ngcontent-%COMP%]    > .dropdown-toggle.btn-primary[_ngcontent-%COMP%] {\n  background-image: none;\n}\n.btn-primary.disabled[_ngcontent-%COMP%]:hover, .btn-primary[disabled][_ngcontent-%COMP%]:hover, fieldset[disabled][_ngcontent-%COMP%]   .btn-primary[_ngcontent-%COMP%]:hover, .btn-primary.disabled[_ngcontent-%COMP%]:focus, .btn-primary[disabled][_ngcontent-%COMP%]:focus, fieldset[disabled][_ngcontent-%COMP%]   .btn-primary[_ngcontent-%COMP%]:focus, .btn-primary.disabled.focus[_ngcontent-%COMP%], .btn-primary[disabled].focus[_ngcontent-%COMP%], fieldset[disabled][_ngcontent-%COMP%]   .btn-primary.focus[_ngcontent-%COMP%] {\n  background-color: #337ab7;\n  border-color: #2e6da4;\n}\n.btn-primary[_ngcontent-%COMP%]   .badge[_ngcontent-%COMP%] {\n  color: #337ab7;\n  background-color: #fff;\n}\n.btn-success[_ngcontent-%COMP%] {\n  color: #fff;\n  background-color: #5cb85c;\n  border-color: #4cae4c;\n}\n.btn-success[_ngcontent-%COMP%]:focus, .btn-success.focus[_ngcontent-%COMP%] {\n  color: #fff;\n  background-color: #449d44;\n  border-color: #255625;\n}\n.btn-success[_ngcontent-%COMP%]:hover {\n  color: #fff;\n  background-color: #449d44;\n  border-color: #398439;\n}\n.btn-success[_ngcontent-%COMP%]:active, .btn-success.active[_ngcontent-%COMP%], .open[_ngcontent-%COMP%]    > .dropdown-toggle.btn-success[_ngcontent-%COMP%] {\n  color: #fff;\n  background-color: #449d44;\n  border-color: #398439;\n}\n.btn-success[_ngcontent-%COMP%]:active:hover, .btn-success.active[_ngcontent-%COMP%]:hover, .open[_ngcontent-%COMP%]    > .dropdown-toggle.btn-success[_ngcontent-%COMP%]:hover, .btn-success[_ngcontent-%COMP%]:active:focus, .btn-success.active[_ngcontent-%COMP%]:focus, .open[_ngcontent-%COMP%]    > .dropdown-toggle.btn-success[_ngcontent-%COMP%]:focus, .btn-success[_ngcontent-%COMP%]:active.focus, .btn-success.active.focus[_ngcontent-%COMP%], .open[_ngcontent-%COMP%]    > .dropdown-toggle.btn-success.focus[_ngcontent-%COMP%] {\n  color: #fff;\n  background-color: #398439;\n  border-color: #255625;\n}\n.btn-success[_ngcontent-%COMP%]:active, .btn-success.active[_ngcontent-%COMP%], .open[_ngcontent-%COMP%]    > .dropdown-toggle.btn-success[_ngcontent-%COMP%] {\n  background-image: none;\n}\n.btn-success.disabled[_ngcontent-%COMP%]:hover, .btn-success[disabled][_ngcontent-%COMP%]:hover, fieldset[disabled][_ngcontent-%COMP%]   .btn-success[_ngcontent-%COMP%]:hover, .btn-success.disabled[_ngcontent-%COMP%]:focus, .btn-success[disabled][_ngcontent-%COMP%]:focus, fieldset[disabled][_ngcontent-%COMP%]   .btn-success[_ngcontent-%COMP%]:focus, .btn-success.disabled.focus[_ngcontent-%COMP%], .btn-success[disabled].focus[_ngcontent-%COMP%], fieldset[disabled][_ngcontent-%COMP%]   .btn-success.focus[_ngcontent-%COMP%] {\n  background-color: #5cb85c;\n  border-color: #4cae4c;\n}\n.btn-success[_ngcontent-%COMP%]   .badge[_ngcontent-%COMP%] {\n  color: #5cb85c;\n  background-color: #fff;\n}\n.btn-info[_ngcontent-%COMP%] {\n  color: #fff;\n  background-color: #5bc0de;\n  border-color: #46b8da;\n}\n.btn-info[_ngcontent-%COMP%]:focus, .btn-info.focus[_ngcontent-%COMP%] {\n  color: #fff;\n  background-color: #31b0d5;\n  border-color: #1b6d85;\n}\n.btn-info[_ngcontent-%COMP%]:hover {\n  color: #fff;\n  background-color: #31b0d5;\n  border-color: #269abc;\n}\n.btn-info[_ngcontent-%COMP%]:active, .btn-info.active[_ngcontent-%COMP%], .open[_ngcontent-%COMP%]    > .dropdown-toggle.btn-info[_ngcontent-%COMP%] {\n  color: #fff;\n  background-color: #31b0d5;\n  border-color: #269abc;\n}\n.btn-info[_ngcontent-%COMP%]:active:hover, .btn-info.active[_ngcontent-%COMP%]:hover, .open[_ngcontent-%COMP%]    > .dropdown-toggle.btn-info[_ngcontent-%COMP%]:hover, .btn-info[_ngcontent-%COMP%]:active:focus, .btn-info.active[_ngcontent-%COMP%]:focus, .open[_ngcontent-%COMP%]    > .dropdown-toggle.btn-info[_ngcontent-%COMP%]:focus, .btn-info[_ngcontent-%COMP%]:active.focus, .btn-info.active.focus[_ngcontent-%COMP%], .open[_ngcontent-%COMP%]    > .dropdown-toggle.btn-info.focus[_ngcontent-%COMP%] {\n  color: #fff;\n  background-color: #269abc;\n  border-color: #1b6d85;\n}\n.btn-info[_ngcontent-%COMP%]:active, .btn-info.active[_ngcontent-%COMP%], .open[_ngcontent-%COMP%]    > .dropdown-toggle.btn-info[_ngcontent-%COMP%] {\n  background-image: none;\n}\n.btn-info.disabled[_ngcontent-%COMP%]:hover, .btn-info[disabled][_ngcontent-%COMP%]:hover, fieldset[disabled][_ngcontent-%COMP%]   .btn-info[_ngcontent-%COMP%]:hover, .btn-info.disabled[_ngcontent-%COMP%]:focus, .btn-info[disabled][_ngcontent-%COMP%]:focus, fieldset[disabled][_ngcontent-%COMP%]   .btn-info[_ngcontent-%COMP%]:focus, .btn-info.disabled.focus[_ngcontent-%COMP%], .btn-info[disabled].focus[_ngcontent-%COMP%], fieldset[disabled][_ngcontent-%COMP%]   .btn-info.focus[_ngcontent-%COMP%] {\n  background-color: #5bc0de;\n  border-color: #46b8da;\n}\n.btn-info[_ngcontent-%COMP%]   .badge[_ngcontent-%COMP%] {\n  color: #5bc0de;\n  background-color: #fff;\n}\n.btn-warning[_ngcontent-%COMP%] {\n  color: #fff;\n  background-color: #f0ad4e;\n  border-color: #eea236;\n}\n.btn-warning[_ngcontent-%COMP%]:focus, .btn-warning.focus[_ngcontent-%COMP%] {\n  color: #fff;\n  background-color: #ec971f;\n  border-color: #985f0d;\n}\n.btn-warning[_ngcontent-%COMP%]:hover {\n  color: #fff;\n  background-color: #ec971f;\n  border-color: #d58512;\n}\n.btn-warning[_ngcontent-%COMP%]:active, .btn-warning.active[_ngcontent-%COMP%], .open[_ngcontent-%COMP%]    > .dropdown-toggle.btn-warning[_ngcontent-%COMP%] {\n  color: #fff;\n  background-color: #ec971f;\n  border-color: #d58512;\n}\n.btn-warning[_ngcontent-%COMP%]:active:hover, .btn-warning.active[_ngcontent-%COMP%]:hover, .open[_ngcontent-%COMP%]    > .dropdown-toggle.btn-warning[_ngcontent-%COMP%]:hover, .btn-warning[_ngcontent-%COMP%]:active:focus, .btn-warning.active[_ngcontent-%COMP%]:focus, .open[_ngcontent-%COMP%]    > .dropdown-toggle.btn-warning[_ngcontent-%COMP%]:focus, .btn-warning[_ngcontent-%COMP%]:active.focus, .btn-warning.active.focus[_ngcontent-%COMP%], .open[_ngcontent-%COMP%]    > .dropdown-toggle.btn-warning.focus[_ngcontent-%COMP%] {\n  color: #fff;\n  background-color: #d58512;\n  border-color: #985f0d;\n}\n.btn-warning[_ngcontent-%COMP%]:active, .btn-warning.active[_ngcontent-%COMP%], .open[_ngcontent-%COMP%]    > .dropdown-toggle.btn-warning[_ngcontent-%COMP%] {\n  background-image: none;\n}\n.btn-warning.disabled[_ngcontent-%COMP%]:hover, .btn-warning[disabled][_ngcontent-%COMP%]:hover, fieldset[disabled][_ngcontent-%COMP%]   .btn-warning[_ngcontent-%COMP%]:hover, .btn-warning.disabled[_ngcontent-%COMP%]:focus, .btn-warning[disabled][_ngcontent-%COMP%]:focus, fieldset[disabled][_ngcontent-%COMP%]   .btn-warning[_ngcontent-%COMP%]:focus, .btn-warning.disabled.focus[_ngcontent-%COMP%], .btn-warning[disabled].focus[_ngcontent-%COMP%], fieldset[disabled][_ngcontent-%COMP%]   .btn-warning.focus[_ngcontent-%COMP%] {\n  background-color: #f0ad4e;\n  border-color: #eea236;\n}\n.btn-warning[_ngcontent-%COMP%]   .badge[_ngcontent-%COMP%] {\n  color: #f0ad4e;\n  background-color: #fff;\n}\n.btn-danger[_ngcontent-%COMP%] {\n  color: #fff;\n  background-color: #d9534f;\n  border-color: #d43f3a;\n}\n.btn-danger[_ngcontent-%COMP%]:focus, .btn-danger.focus[_ngcontent-%COMP%] {\n  color: #fff;\n  background-color: #c9302c;\n  border-color: #761c19;\n}\n.btn-danger[_ngcontent-%COMP%]:hover {\n  color: #fff;\n  background-color: #c9302c;\n  border-color: #ac2925;\n}\n.btn-danger[_ngcontent-%COMP%]:active, .btn-danger.active[_ngcontent-%COMP%], .open[_ngcontent-%COMP%]    > .dropdown-toggle.btn-danger[_ngcontent-%COMP%] {\n  color: #fff;\n  background-color: #c9302c;\n  border-color: #ac2925;\n}\n.btn-danger[_ngcontent-%COMP%]:active:hover, .btn-danger.active[_ngcontent-%COMP%]:hover, .open[_ngcontent-%COMP%]    > .dropdown-toggle.btn-danger[_ngcontent-%COMP%]:hover, .btn-danger[_ngcontent-%COMP%]:active:focus, .btn-danger.active[_ngcontent-%COMP%]:focus, .open[_ngcontent-%COMP%]    > .dropdown-toggle.btn-danger[_ngcontent-%COMP%]:focus, .btn-danger[_ngcontent-%COMP%]:active.focus, .btn-danger.active.focus[_ngcontent-%COMP%], .open[_ngcontent-%COMP%]    > .dropdown-toggle.btn-danger.focus[_ngcontent-%COMP%] {\n  color: #fff;\n  background-color: #ac2925;\n  border-color: #761c19;\n}\n.btn-danger[_ngcontent-%COMP%]:active, .btn-danger.active[_ngcontent-%COMP%], .open[_ngcontent-%COMP%]    > .dropdown-toggle.btn-danger[_ngcontent-%COMP%] {\n  background-image: none;\n}\n.btn-danger.disabled[_ngcontent-%COMP%]:hover, .btn-danger[disabled][_ngcontent-%COMP%]:hover, fieldset[disabled][_ngcontent-%COMP%]   .btn-danger[_ngcontent-%COMP%]:hover, .btn-danger.disabled[_ngcontent-%COMP%]:focus, .btn-danger[disabled][_ngcontent-%COMP%]:focus, fieldset[disabled][_ngcontent-%COMP%]   .btn-danger[_ngcontent-%COMP%]:focus, .btn-danger.disabled.focus[_ngcontent-%COMP%], .btn-danger[disabled].focus[_ngcontent-%COMP%], fieldset[disabled][_ngcontent-%COMP%]   .btn-danger.focus[_ngcontent-%COMP%] {\n  background-color: #d9534f;\n  border-color: #d43f3a;\n}\n.btn-danger[_ngcontent-%COMP%]   .badge[_ngcontent-%COMP%] {\n  color: #d9534f;\n  background-color: #fff;\n}\n.btn-link[_ngcontent-%COMP%] {\n  font-weight: normal;\n  color: #337ab7;\n  border-radius: 0;\n}\n.btn-link[_ngcontent-%COMP%], .btn-link[_ngcontent-%COMP%]:active, .btn-link.active[_ngcontent-%COMP%], .btn-link[disabled][_ngcontent-%COMP%], fieldset[disabled][_ngcontent-%COMP%]   .btn-link[_ngcontent-%COMP%] {\n  background-color: transparent;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n.btn-link[_ngcontent-%COMP%], .btn-link[_ngcontent-%COMP%]:hover, .btn-link[_ngcontent-%COMP%]:focus, .btn-link[_ngcontent-%COMP%]:active {\n  border-color: transparent;\n}\n.btn-link[_ngcontent-%COMP%]:hover, .btn-link[_ngcontent-%COMP%]:focus {\n  color: #23527c;\n  text-decoration: underline;\n  background-color: transparent;\n}\n.btn-link[disabled][_ngcontent-%COMP%]:hover, fieldset[disabled][_ngcontent-%COMP%]   .btn-link[_ngcontent-%COMP%]:hover, .btn-link[disabled][_ngcontent-%COMP%]:focus, fieldset[disabled][_ngcontent-%COMP%]   .btn-link[_ngcontent-%COMP%]:focus {\n  color: #777;\n  text-decoration: none;\n}\n.btn-lg[_ngcontent-%COMP%], .btn-group-lg[_ngcontent-%COMP%]    > .btn[_ngcontent-%COMP%] {\n  padding: 10px 16px;\n  font-size: 18px;\n  line-height: 1.3333333;\n  border-radius: 6px;\n}\n.btn-sm[_ngcontent-%COMP%], .btn-group-sm[_ngcontent-%COMP%]    > .btn[_ngcontent-%COMP%] {\n  padding: 5px 10px;\n  font-size: 12px;\n  line-height: 1.5;\n  border-radius: 3px;\n}\n.btn-xs[_ngcontent-%COMP%], .btn-group-xs[_ngcontent-%COMP%]    > .btn[_ngcontent-%COMP%] {\n  padding: 1px 5px;\n  font-size: 12px;\n  line-height: 1.5;\n  border-radius: 3px;\n}\n.btn-block[_ngcontent-%COMP%] {\n  display: block;\n  width: 100%;\n}\n.btn-block[_ngcontent-%COMP%]    + .btn-block[_ngcontent-%COMP%] {\n  margin-top: 5px;\n}\ninput[type="submit"].btn-block[_ngcontent-%COMP%], input[type="reset"].btn-block[_ngcontent-%COMP%], input[type="button"].btn-block[_ngcontent-%COMP%] {\n  width: 100%;\n}\n.fade[_ngcontent-%COMP%] {\n  opacity: 0;\n  -webkit-transition: opacity .15s linear;\n       -o-transition: opacity .15s linear;\n          transition: opacity .15s linear;\n}\n.fade.in[_ngcontent-%COMP%] {\n  opacity: 1;\n}\n.collapse[_ngcontent-%COMP%] {\n  display: none;\n}\n.collapse.in[_ngcontent-%COMP%] {\n  display: block;\n}\ntr.collapse.in[_ngcontent-%COMP%] {\n  display: table-row;\n}\ntbody.collapse.in[_ngcontent-%COMP%] {\n  display: table-row-group;\n}\n.collapsing[_ngcontent-%COMP%] {\n  position: relative;\n  height: 0;\n  overflow: hidden;\n  -webkit-transition-timing-function: ease;\n       -o-transition-timing-function: ease;\n          transition-timing-function: ease;\n  -webkit-transition-duration: .35s;\n       -o-transition-duration: .35s;\n          transition-duration: .35s;\n  -webkit-transition-property: height, visibility;\n       -o-transition-property: height, visibility;\n          transition-property: height, visibility;\n}\n.caret[_ngcontent-%COMP%] {\n  display: inline-block;\n  width: 0;\n  height: 0;\n  margin-left: 2px;\n  vertical-align: middle;\n  border-top: 4px dashed;\n  border-top: 4px solid \\9;\n  border-right: 4px solid transparent;\n  border-left: 4px solid transparent;\n}\n.dropup[_ngcontent-%COMP%], .dropdown[_ngcontent-%COMP%] {\n  position: relative;\n}\n.dropdown-toggle[_ngcontent-%COMP%]:focus {\n  outline: 0;\n}\n.dropdown-menu[_ngcontent-%COMP%] {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  z-index: 1000;\n  display: none;\n  float: left;\n  min-width: 160px;\n  padding: 5px 0;\n  margin: 2px 0 0;\n  font-size: 14px;\n  text-align: left;\n  list-style: none;\n  background-color: #fff;\n  -webkit-background-clip: padding-box;\n          background-clip: padding-box;\n  border: 1px solid #ccc;\n  border: 1px solid rgba(0, 0, 0, .15);\n  border-radius: 4px;\n  -webkit-box-shadow: 0 6px 12px rgba(0, 0, 0, .175);\n          box-shadow: 0 6px 12px rgba(0, 0, 0, .175);\n}\n.dropdown-menu.pull-right[_ngcontent-%COMP%] {\n  right: 0;\n  left: auto;\n}\n.dropdown-menu[_ngcontent-%COMP%]   .divider[_ngcontent-%COMP%] {\n  height: 1px;\n  margin: 9px 0;\n  overflow: hidden;\n  background-color: #e5e5e5;\n}\n.dropdown-menu[_ngcontent-%COMP%]    > li[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%] {\n  display: block;\n  padding: 3px 20px;\n  clear: both;\n  font-weight: normal;\n  line-height: 1.42857143;\n  color: #333;\n  white-space: nowrap;\n}\n.dropdown-menu[_ngcontent-%COMP%]    > li[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%]:hover, .dropdown-menu[_ngcontent-%COMP%]    > li[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%]:focus {\n  color: #262626;\n  text-decoration: none;\n  background-color: #f5f5f5;\n}\n.dropdown-menu[_ngcontent-%COMP%]    > .active[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%], .dropdown-menu[_ngcontent-%COMP%]    > .active[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%]:hover, .dropdown-menu[_ngcontent-%COMP%]    > .active[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%]:focus {\n  color: #fff;\n  text-decoration: none;\n  background-color: #337ab7;\n  outline: 0;\n}\n.dropdown-menu[_ngcontent-%COMP%]    > .disabled[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%], .dropdown-menu[_ngcontent-%COMP%]    > .disabled[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%]:hover, .dropdown-menu[_ngcontent-%COMP%]    > .disabled[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%]:focus {\n  color: #777;\n}\n.dropdown-menu[_ngcontent-%COMP%]    > .disabled[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%]:hover, .dropdown-menu[_ngcontent-%COMP%]    > .disabled[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%]:focus {\n  text-decoration: none;\n  cursor: not-allowed;\n  background-color: transparent;\n  background-image: none;\n  filter: progid:DXImageTransform.Microsoft.gradient(enabled = false);\n}\n.open[_ngcontent-%COMP%]    > .dropdown-menu[_ngcontent-%COMP%] {\n  display: block;\n}\n.open[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%] {\n  outline: 0;\n}\n.dropdown-menu-right[_ngcontent-%COMP%] {\n  right: 0;\n  left: auto;\n}\n.dropdown-menu-left[_ngcontent-%COMP%] {\n  right: auto;\n  left: 0;\n}\n.dropdown-header[_ngcontent-%COMP%] {\n  display: block;\n  padding: 3px 20px;\n  font-size: 12px;\n  line-height: 1.42857143;\n  color: #777;\n  white-space: nowrap;\n}\n.dropdown-backdrop[_ngcontent-%COMP%] {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 990;\n}\n.pull-right[_ngcontent-%COMP%]    > .dropdown-menu[_ngcontent-%COMP%] {\n  right: 0;\n  left: auto;\n}\n.dropup[_ngcontent-%COMP%]   .caret[_ngcontent-%COMP%], .navbar-fixed-bottom[_ngcontent-%COMP%]   .dropdown[_ngcontent-%COMP%]   .caret[_ngcontent-%COMP%] {\n  content: "";\n  border-top: 0;\n  border-bottom: 4px dashed;\n  border-bottom: 4px solid \\9;\n}\n.dropup[_ngcontent-%COMP%]   .dropdown-menu[_ngcontent-%COMP%], .navbar-fixed-bottom[_ngcontent-%COMP%]   .dropdown[_ngcontent-%COMP%]   .dropdown-menu[_ngcontent-%COMP%] {\n  top: auto;\n  bottom: 100%;\n  margin-bottom: 2px;\n}\n@media (min-width: 768px) {\n  .navbar-right[_ngcontent-%COMP%]   .dropdown-menu[_ngcontent-%COMP%] {\n    right: 0;\n    left: auto;\n  }\n  .navbar-right[_ngcontent-%COMP%]   .dropdown-menu-left[_ngcontent-%COMP%] {\n    right: auto;\n    left: 0;\n  }\n}\n.btn-group[_ngcontent-%COMP%], .btn-group-vertical[_ngcontent-%COMP%] {\n  position: relative;\n  display: inline-block;\n  vertical-align: middle;\n}\n.btn-group[_ngcontent-%COMP%]    > .btn[_ngcontent-%COMP%], .btn-group-vertical[_ngcontent-%COMP%]    > .btn[_ngcontent-%COMP%] {\n  position: relative;\n  float: left;\n}\n.btn-group[_ngcontent-%COMP%]    > .btn[_ngcontent-%COMP%]:hover, .btn-group-vertical[_ngcontent-%COMP%]    > .btn[_ngcontent-%COMP%]:hover, .btn-group[_ngcontent-%COMP%]    > .btn[_ngcontent-%COMP%]:focus, .btn-group-vertical[_ngcontent-%COMP%]    > .btn[_ngcontent-%COMP%]:focus, .btn-group[_ngcontent-%COMP%]    > .btn[_ngcontent-%COMP%]:active, .btn-group-vertical[_ngcontent-%COMP%]    > .btn[_ngcontent-%COMP%]:active, .btn-group[_ngcontent-%COMP%]    > .btn.active[_ngcontent-%COMP%], .btn-group-vertical[_ngcontent-%COMP%]    > .btn.active[_ngcontent-%COMP%] {\n  z-index: 2;\n}\n.btn-group[_ngcontent-%COMP%]   .btn[_ngcontent-%COMP%]    + .btn[_ngcontent-%COMP%], .btn-group[_ngcontent-%COMP%]   .btn[_ngcontent-%COMP%]    + .btn-group[_ngcontent-%COMP%], .btn-group[_ngcontent-%COMP%]   .btn-group[_ngcontent-%COMP%]    + .btn[_ngcontent-%COMP%], .btn-group[_ngcontent-%COMP%]   .btn-group[_ngcontent-%COMP%]    + .btn-group[_ngcontent-%COMP%] {\n  margin-left: -1px;\n}\n.btn-toolbar[_ngcontent-%COMP%] {\n  margin-left: -5px;\n}\n.btn-toolbar[_ngcontent-%COMP%]   .btn[_ngcontent-%COMP%], .btn-toolbar[_ngcontent-%COMP%]   .btn-group[_ngcontent-%COMP%], .btn-toolbar[_ngcontent-%COMP%]   .input-group[_ngcontent-%COMP%] {\n  float: left;\n}\n.btn-toolbar[_ngcontent-%COMP%]    > .btn[_ngcontent-%COMP%], .btn-toolbar[_ngcontent-%COMP%]    > .btn-group[_ngcontent-%COMP%], .btn-toolbar[_ngcontent-%COMP%]    > .input-group[_ngcontent-%COMP%] {\n  margin-left: 5px;\n}\n.btn-group[_ngcontent-%COMP%]    > .btn[_ngcontent-%COMP%]:not(:first-child):not(:last-child):not(.dropdown-toggle) {\n  border-radius: 0;\n}\n.btn-group[_ngcontent-%COMP%]    > .btn[_ngcontent-%COMP%]:first-child {\n  margin-left: 0;\n}\n.btn-group[_ngcontent-%COMP%]    > .btn[_ngcontent-%COMP%]:first-child:not(:last-child):not(.dropdown-toggle) {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.btn-group[_ngcontent-%COMP%]    > .btn[_ngcontent-%COMP%]:last-child:not(:first-child), .btn-group[_ngcontent-%COMP%]    > .dropdown-toggle[_ngcontent-%COMP%]:not(:first-child) {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.btn-group[_ngcontent-%COMP%]    > .btn-group[_ngcontent-%COMP%] {\n  float: left;\n}\n.btn-group[_ngcontent-%COMP%]    > .btn-group[_ngcontent-%COMP%]:not(:first-child):not(:last-child)    > .btn[_ngcontent-%COMP%] {\n  border-radius: 0;\n}\n.btn-group[_ngcontent-%COMP%]    > .btn-group[_ngcontent-%COMP%]:first-child:not(:last-child)    > .btn[_ngcontent-%COMP%]:last-child, .btn-group[_ngcontent-%COMP%]    > .btn-group[_ngcontent-%COMP%]:first-child:not(:last-child)    > .dropdown-toggle[_ngcontent-%COMP%] {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.btn-group[_ngcontent-%COMP%]    > .btn-group[_ngcontent-%COMP%]:last-child:not(:first-child)    > .btn[_ngcontent-%COMP%]:first-child {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.btn-group[_ngcontent-%COMP%]   .dropdown-toggle[_ngcontent-%COMP%]:active, .btn-group.open[_ngcontent-%COMP%]   .dropdown-toggle[_ngcontent-%COMP%] {\n  outline: 0;\n}\n.btn-group[_ngcontent-%COMP%]    > .btn[_ngcontent-%COMP%]    + .dropdown-toggle[_ngcontent-%COMP%] {\n  padding-right: 8px;\n  padding-left: 8px;\n}\n.btn-group[_ngcontent-%COMP%]    > .btn-lg[_ngcontent-%COMP%]    + .dropdown-toggle[_ngcontent-%COMP%] {\n  padding-right: 12px;\n  padding-left: 12px;\n}\n.btn-group.open[_ngcontent-%COMP%]   .dropdown-toggle[_ngcontent-%COMP%] {\n  -webkit-box-shadow: inset 0 3px 5px rgba(0, 0, 0, .125);\n          box-shadow: inset 0 3px 5px rgba(0, 0, 0, .125);\n}\n.btn-group.open[_ngcontent-%COMP%]   .dropdown-toggle.btn-link[_ngcontent-%COMP%] {\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n.btn[_ngcontent-%COMP%]   .caret[_ngcontent-%COMP%] {\n  margin-left: 0;\n}\n.btn-lg[_ngcontent-%COMP%]   .caret[_ngcontent-%COMP%] {\n  border-width: 5px 5px 0;\n  border-bottom-width: 0;\n}\n.dropup[_ngcontent-%COMP%]   .btn-lg[_ngcontent-%COMP%]   .caret[_ngcontent-%COMP%] {\n  border-width: 0 5px 5px;\n}\n.btn-group-vertical[_ngcontent-%COMP%]    > .btn[_ngcontent-%COMP%], .btn-group-vertical[_ngcontent-%COMP%]    > .btn-group[_ngcontent-%COMP%], .btn-group-vertical[_ngcontent-%COMP%]    > .btn-group[_ngcontent-%COMP%]    > .btn[_ngcontent-%COMP%] {\n  display: block;\n  float: none;\n  width: 100%;\n  max-width: 100%;\n}\n.btn-group-vertical[_ngcontent-%COMP%]    > .btn-group[_ngcontent-%COMP%]    > .btn[_ngcontent-%COMP%] {\n  float: none;\n}\n.btn-group-vertical[_ngcontent-%COMP%]    > .btn[_ngcontent-%COMP%]    + .btn[_ngcontent-%COMP%], .btn-group-vertical[_ngcontent-%COMP%]    > .btn[_ngcontent-%COMP%]    + .btn-group[_ngcontent-%COMP%], .btn-group-vertical[_ngcontent-%COMP%]    > .btn-group[_ngcontent-%COMP%]    + .btn[_ngcontent-%COMP%], .btn-group-vertical[_ngcontent-%COMP%]    > .btn-group[_ngcontent-%COMP%]    + .btn-group[_ngcontent-%COMP%] {\n  margin-top: -1px;\n  margin-left: 0;\n}\n.btn-group-vertical[_ngcontent-%COMP%]    > .btn[_ngcontent-%COMP%]:not(:first-child):not(:last-child) {\n  border-radius: 0;\n}\n.btn-group-vertical[_ngcontent-%COMP%]    > .btn[_ngcontent-%COMP%]:first-child:not(:last-child) {\n  border-top-left-radius: 4px;\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.btn-group-vertical[_ngcontent-%COMP%]    > .btn[_ngcontent-%COMP%]:last-child:not(:first-child) {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 4px;\n  border-bottom-left-radius: 4px;\n}\n.btn-group-vertical[_ngcontent-%COMP%]    > .btn-group[_ngcontent-%COMP%]:not(:first-child):not(:last-child)    > .btn[_ngcontent-%COMP%] {\n  border-radius: 0;\n}\n.btn-group-vertical[_ngcontent-%COMP%]    > .btn-group[_ngcontent-%COMP%]:first-child:not(:last-child)    > .btn[_ngcontent-%COMP%]:last-child, .btn-group-vertical[_ngcontent-%COMP%]    > .btn-group[_ngcontent-%COMP%]:first-child:not(:last-child)    > .dropdown-toggle[_ngcontent-%COMP%] {\n  border-bottom-right-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.btn-group-vertical[_ngcontent-%COMP%]    > .btn-group[_ngcontent-%COMP%]:last-child:not(:first-child)    > .btn[_ngcontent-%COMP%]:first-child {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n.btn-group-justified[_ngcontent-%COMP%] {\n  display: table;\n  width: 100%;\n  table-layout: fixed;\n  border-collapse: separate;\n}\n.btn-group-justified[_ngcontent-%COMP%]    > .btn[_ngcontent-%COMP%], .btn-group-justified[_ngcontent-%COMP%]    > .btn-group[_ngcontent-%COMP%] {\n  display: table-cell;\n  float: none;\n  width: 1%;\n}\n.btn-group-justified[_ngcontent-%COMP%]    > .btn-group[_ngcontent-%COMP%]   .btn[_ngcontent-%COMP%] {\n  width: 100%;\n}\n.btn-group-justified[_ngcontent-%COMP%]    > .btn-group[_ngcontent-%COMP%]   .dropdown-menu[_ngcontent-%COMP%] {\n  left: auto;\n}\n[data-toggle="buttons"][_ngcontent-%COMP%]    > .btn[_ngcontent-%COMP%]   input[type="radio"][_ngcontent-%COMP%], [data-toggle="buttons"][_ngcontent-%COMP%]    > .btn-group[_ngcontent-%COMP%]    > .btn[_ngcontent-%COMP%]   input[type="radio"][_ngcontent-%COMP%], [data-toggle="buttons"][_ngcontent-%COMP%]    > .btn[_ngcontent-%COMP%]   input[type="checkbox"][_ngcontent-%COMP%], [data-toggle="buttons"][_ngcontent-%COMP%]    > .btn-group[_ngcontent-%COMP%]    > .btn[_ngcontent-%COMP%]   input[type="checkbox"][_ngcontent-%COMP%] {\n  position: absolute;\n  clip: rect(0, 0, 0, 0);\n  pointer-events: none;\n}\n.input-group[_ngcontent-%COMP%] {\n  position: relative;\n  display: table;\n  border-collapse: separate;\n}\n.input-group[class*="col-"][_ngcontent-%COMP%] {\n  float: none;\n  padding-right: 0;\n  padding-left: 0;\n}\n.input-group[_ngcontent-%COMP%]   .form-control[_ngcontent-%COMP%] {\n  position: relative;\n  z-index: 2;\n  float: left;\n  width: 100%;\n  margin-bottom: 0;\n}\n.input-group[_ngcontent-%COMP%]   .form-control[_ngcontent-%COMP%]:focus {\n  z-index: 3;\n}\n.input-group-lg[_ngcontent-%COMP%]    > .form-control[_ngcontent-%COMP%], .input-group-lg[_ngcontent-%COMP%]    > .input-group-addon[_ngcontent-%COMP%], .input-group-lg[_ngcontent-%COMP%]    > .input-group-btn[_ngcontent-%COMP%]    > .btn[_ngcontent-%COMP%] {\n  height: 46px;\n  padding: 10px 16px;\n  font-size: 18px;\n  line-height: 1.3333333;\n  border-radius: 6px;\n}\nselect.input-group-lg[_ngcontent-%COMP%]    > .form-control[_ngcontent-%COMP%], select.input-group-lg[_ngcontent-%COMP%]    > .input-group-addon[_ngcontent-%COMP%], select.input-group-lg[_ngcontent-%COMP%]    > .input-group-btn[_ngcontent-%COMP%]    > .btn[_ngcontent-%COMP%] {\n  height: 46px;\n  line-height: 46px;\n}\ntextarea.input-group-lg[_ngcontent-%COMP%]    > .form-control[_ngcontent-%COMP%], textarea.input-group-lg[_ngcontent-%COMP%]    > .input-group-addon[_ngcontent-%COMP%], textarea.input-group-lg[_ngcontent-%COMP%]    > .input-group-btn[_ngcontent-%COMP%]    > .btn[_ngcontent-%COMP%], select[multiple].input-group-lg[_ngcontent-%COMP%]    > .form-control[_ngcontent-%COMP%], select[multiple].input-group-lg[_ngcontent-%COMP%]    > .input-group-addon[_ngcontent-%COMP%], select[multiple].input-group-lg[_ngcontent-%COMP%]    > .input-group-btn[_ngcontent-%COMP%]    > .btn[_ngcontent-%COMP%] {\n  height: auto;\n}\n.input-group-sm[_ngcontent-%COMP%]    > .form-control[_ngcontent-%COMP%], .input-group-sm[_ngcontent-%COMP%]    > .input-group-addon[_ngcontent-%COMP%], .input-group-sm[_ngcontent-%COMP%]    > .input-group-btn[_ngcontent-%COMP%]    > .btn[_ngcontent-%COMP%] {\n  height: 30px;\n  padding: 5px 10px;\n  font-size: 12px;\n  line-height: 1.5;\n  border-radius: 3px;\n}\nselect.input-group-sm[_ngcontent-%COMP%]    > .form-control[_ngcontent-%COMP%], select.input-group-sm[_ngcontent-%COMP%]    > .input-group-addon[_ngcontent-%COMP%], select.input-group-sm[_ngcontent-%COMP%]    > .input-group-btn[_ngcontent-%COMP%]    > .btn[_ngcontent-%COMP%] {\n  height: 30px;\n  line-height: 30px;\n}\ntextarea.input-group-sm[_ngcontent-%COMP%]    > .form-control[_ngcontent-%COMP%], textarea.input-group-sm[_ngcontent-%COMP%]    > .input-group-addon[_ngcontent-%COMP%], textarea.input-group-sm[_ngcontent-%COMP%]    > .input-group-btn[_ngcontent-%COMP%]    > .btn[_ngcontent-%COMP%], select[multiple].input-group-sm[_ngcontent-%COMP%]    > .form-control[_ngcontent-%COMP%], select[multiple].input-group-sm[_ngcontent-%COMP%]    > .input-group-addon[_ngcontent-%COMP%], select[multiple].input-group-sm[_ngcontent-%COMP%]    > .input-group-btn[_ngcontent-%COMP%]    > .btn[_ngcontent-%COMP%] {\n  height: auto;\n}\n.input-group-addon[_ngcontent-%COMP%], .input-group-btn[_ngcontent-%COMP%], .input-group[_ngcontent-%COMP%]   .form-control[_ngcontent-%COMP%] {\n  display: table-cell;\n}\n.input-group-addon[_ngcontent-%COMP%]:not(:first-child):not(:last-child), .input-group-btn[_ngcontent-%COMP%]:not(:first-child):not(:last-child), .input-group[_ngcontent-%COMP%]   .form-control[_ngcontent-%COMP%]:not(:first-child):not(:last-child) {\n  border-radius: 0;\n}\n.input-group-addon[_ngcontent-%COMP%], .input-group-btn[_ngcontent-%COMP%] {\n  width: 1%;\n  white-space: nowrap;\n  vertical-align: middle;\n}\n.input-group-addon[_ngcontent-%COMP%] {\n  padding: 6px 12px;\n  font-size: 14px;\n  font-weight: normal;\n  line-height: 1;\n  color: #555;\n  text-align: center;\n  background-color: #eee;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\n.input-group-addon.input-sm[_ngcontent-%COMP%] {\n  padding: 5px 10px;\n  font-size: 12px;\n  border-radius: 3px;\n}\n.input-group-addon.input-lg[_ngcontent-%COMP%] {\n  padding: 10px 16px;\n  font-size: 18px;\n  border-radius: 6px;\n}\n.input-group-addon[_ngcontent-%COMP%]   input[type="radio"][_ngcontent-%COMP%], .input-group-addon[_ngcontent-%COMP%]   input[type="checkbox"][_ngcontent-%COMP%] {\n  margin-top: 0;\n}\n.input-group[_ngcontent-%COMP%]   .form-control[_ngcontent-%COMP%]:first-child, .input-group-addon[_ngcontent-%COMP%]:first-child, .input-group-btn[_ngcontent-%COMP%]:first-child    > .btn[_ngcontent-%COMP%], .input-group-btn[_ngcontent-%COMP%]:first-child    > .btn-group[_ngcontent-%COMP%]    > .btn[_ngcontent-%COMP%], .input-group-btn[_ngcontent-%COMP%]:first-child    > .dropdown-toggle[_ngcontent-%COMP%], .input-group-btn[_ngcontent-%COMP%]:last-child    > .btn[_ngcontent-%COMP%]:not(:last-child):not(.dropdown-toggle), .input-group-btn[_ngcontent-%COMP%]:last-child    > .btn-group[_ngcontent-%COMP%]:not(:last-child)    > .btn[_ngcontent-%COMP%] {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.input-group-addon[_ngcontent-%COMP%]:first-child {\n  border-right: 0;\n}\n.input-group[_ngcontent-%COMP%]   .form-control[_ngcontent-%COMP%]:last-child, .input-group-addon[_ngcontent-%COMP%]:last-child, .input-group-btn[_ngcontent-%COMP%]:last-child    > .btn[_ngcontent-%COMP%], .input-group-btn[_ngcontent-%COMP%]:last-child    > .btn-group[_ngcontent-%COMP%]    > .btn[_ngcontent-%COMP%], .input-group-btn[_ngcontent-%COMP%]:last-child    > .dropdown-toggle[_ngcontent-%COMP%], .input-group-btn[_ngcontent-%COMP%]:first-child    > .btn[_ngcontent-%COMP%]:not(:first-child), .input-group-btn[_ngcontent-%COMP%]:first-child    > .btn-group[_ngcontent-%COMP%]:not(:first-child)    > .btn[_ngcontent-%COMP%] {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.input-group-addon[_ngcontent-%COMP%]:last-child {\n  border-left: 0;\n}\n.input-group-btn[_ngcontent-%COMP%] {\n  position: relative;\n  font-size: 0;\n  white-space: nowrap;\n}\n.input-group-btn[_ngcontent-%COMP%]    > .btn[_ngcontent-%COMP%] {\n  position: relative;\n}\n.input-group-btn[_ngcontent-%COMP%]    > .btn[_ngcontent-%COMP%]    + .btn[_ngcontent-%COMP%] {\n  margin-left: -1px;\n}\n.input-group-btn[_ngcontent-%COMP%]    > .btn[_ngcontent-%COMP%]:hover, .input-group-btn[_ngcontent-%COMP%]    > .btn[_ngcontent-%COMP%]:focus, .input-group-btn[_ngcontent-%COMP%]    > .btn[_ngcontent-%COMP%]:active {\n  z-index: 2;\n}\n.input-group-btn[_ngcontent-%COMP%]:first-child    > .btn[_ngcontent-%COMP%], .input-group-btn[_ngcontent-%COMP%]:first-child    > .btn-group[_ngcontent-%COMP%] {\n  margin-right: -1px;\n}\n.input-group-btn[_ngcontent-%COMP%]:last-child    > .btn[_ngcontent-%COMP%], .input-group-btn[_ngcontent-%COMP%]:last-child    > .btn-group[_ngcontent-%COMP%] {\n  z-index: 2;\n  margin-left: -1px;\n}\n.nav[_ngcontent-%COMP%] {\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n.nav[_ngcontent-%COMP%]    > li[_ngcontent-%COMP%] {\n  position: relative;\n  display: block;\n}\n.nav[_ngcontent-%COMP%]    > li[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%] {\n  position: relative;\n  display: block;\n  padding: 10px 15px;\n}\n.nav[_ngcontent-%COMP%]    > li[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%]:hover, .nav[_ngcontent-%COMP%]    > li[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%]:focus {\n  text-decoration: none;\n  background-color: #eee;\n}\n.nav[_ngcontent-%COMP%]    > li.disabled[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%] {\n  color: #777;\n}\n.nav[_ngcontent-%COMP%]    > li.disabled[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%]:hover, .nav[_ngcontent-%COMP%]    > li.disabled[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%]:focus {\n  color: #777;\n  text-decoration: none;\n  cursor: not-allowed;\n  background-color: transparent;\n}\n.nav[_ngcontent-%COMP%]   .open[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%], .nav[_ngcontent-%COMP%]   .open[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%]:hover, .nav[_ngcontent-%COMP%]   .open[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%]:focus {\n  background-color: #eee;\n  border-color: #337ab7;\n}\n.nav[_ngcontent-%COMP%]   .nav-divider[_ngcontent-%COMP%] {\n  height: 1px;\n  margin: 9px 0;\n  overflow: hidden;\n  background-color: #e5e5e5;\n}\n.nav[_ngcontent-%COMP%]    > li[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%]    > img[_ngcontent-%COMP%] {\n  max-width: none;\n}\n.nav-tabs[_ngcontent-%COMP%] {\n  border-bottom: 1px solid #ddd;\n}\n.nav-tabs[_ngcontent-%COMP%]    > li[_ngcontent-%COMP%] {\n  float: left;\n  margin-bottom: -1px;\n}\n.nav-tabs[_ngcontent-%COMP%]    > li[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%] {\n  margin-right: 2px;\n  line-height: 1.42857143;\n  border: 1px solid transparent;\n  border-radius: 4px 4px 0 0;\n}\n.nav-tabs[_ngcontent-%COMP%]    > li[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%]:hover {\n  border-color: #eee #eee #ddd;\n}\n.nav-tabs[_ngcontent-%COMP%]    > li.active[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%], .nav-tabs[_ngcontent-%COMP%]    > li.active[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%]:hover, .nav-tabs[_ngcontent-%COMP%]    > li.active[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%]:focus {\n  color: #555;\n  cursor: default;\n  background-color: #fff;\n  border: 1px solid #ddd;\n  border-bottom-color: transparent;\n}\n.nav-tabs.nav-justified[_ngcontent-%COMP%] {\n  width: 100%;\n  border-bottom: 0;\n}\n.nav-tabs.nav-justified[_ngcontent-%COMP%]    > li[_ngcontent-%COMP%] {\n  float: none;\n}\n.nav-tabs.nav-justified[_ngcontent-%COMP%]    > li[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%] {\n  margin-bottom: 5px;\n  text-align: center;\n}\n.nav-tabs.nav-justified[_ngcontent-%COMP%]    > .dropdown[_ngcontent-%COMP%]   .dropdown-menu[_ngcontent-%COMP%] {\n  top: auto;\n  left: auto;\n}\n@media (min-width: 768px) {\n  .nav-tabs.nav-justified[_ngcontent-%COMP%]    > li[_ngcontent-%COMP%] {\n    display: table-cell;\n    width: 1%;\n  }\n  .nav-tabs.nav-justified[_ngcontent-%COMP%]    > li[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%] {\n    margin-bottom: 0;\n  }\n}\n.nav-tabs.nav-justified[_ngcontent-%COMP%]    > li[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%] {\n  margin-right: 0;\n  border-radius: 4px;\n}\n.nav-tabs.nav-justified[_ngcontent-%COMP%]    > .active[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%], .nav-tabs.nav-justified[_ngcontent-%COMP%]    > .active[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%]:hover, .nav-tabs.nav-justified[_ngcontent-%COMP%]    > .active[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%]:focus {\n  border: 1px solid #ddd;\n}\n@media (min-width: 768px) {\n  .nav-tabs.nav-justified[_ngcontent-%COMP%]    > li[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%] {\n    border-bottom: 1px solid #ddd;\n    border-radius: 4px 4px 0 0;\n  }\n  .nav-tabs.nav-justified[_ngcontent-%COMP%]    > .active[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%], .nav-tabs.nav-justified[_ngcontent-%COMP%]    > .active[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%]:hover, .nav-tabs.nav-justified[_ngcontent-%COMP%]    > .active[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%]:focus {\n    border-bottom-color: #fff;\n  }\n}\n.nav-pills[_ngcontent-%COMP%]    > li[_ngcontent-%COMP%] {\n  float: left;\n}\n.nav-pills[_ngcontent-%COMP%]    > li[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%] {\n  border-radius: 4px;\n}\n.nav-pills[_ngcontent-%COMP%]    > li[_ngcontent-%COMP%]    + li[_ngcontent-%COMP%] {\n  margin-left: 2px;\n}\n.nav-pills[_ngcontent-%COMP%]    > li.active[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%], .nav-pills[_ngcontent-%COMP%]    > li.active[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%]:hover, .nav-pills[_ngcontent-%COMP%]    > li.active[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%]:focus {\n  color: #fff;\n  background-color: #337ab7;\n}\n.nav-stacked[_ngcontent-%COMP%]    > li[_ngcontent-%COMP%] {\n  float: none;\n}\n.nav-stacked[_ngcontent-%COMP%]    > li[_ngcontent-%COMP%]    + li[_ngcontent-%COMP%] {\n  margin-top: 2px;\n  margin-left: 0;\n}\n.nav-justified[_ngcontent-%COMP%] {\n  width: 100%;\n}\n.nav-justified[_ngcontent-%COMP%]    > li[_ngcontent-%COMP%] {\n  float: none;\n}\n.nav-justified[_ngcontent-%COMP%]    > li[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%] {\n  margin-bottom: 5px;\n  text-align: center;\n}\n.nav-justified[_ngcontent-%COMP%]    > .dropdown[_ngcontent-%COMP%]   .dropdown-menu[_ngcontent-%COMP%] {\n  top: auto;\n  left: auto;\n}\n@media (min-width: 768px) {\n  .nav-justified[_ngcontent-%COMP%]    > li[_ngcontent-%COMP%] {\n    display: table-cell;\n    width: 1%;\n  }\n  .nav-justified[_ngcontent-%COMP%]    > li[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%] {\n    margin-bottom: 0;\n  }\n}\n.nav-tabs-justified[_ngcontent-%COMP%] {\n  border-bottom: 0;\n}\n.nav-tabs-justified[_ngcontent-%COMP%]    > li[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%] {\n  margin-right: 0;\n  border-radius: 4px;\n}\n.nav-tabs-justified[_ngcontent-%COMP%]    > .active[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%], .nav-tabs-justified[_ngcontent-%COMP%]    > .active[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%]:hover, .nav-tabs-justified[_ngcontent-%COMP%]    > .active[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%]:focus {\n  border: 1px solid #ddd;\n}\n@media (min-width: 768px) {\n  .nav-tabs-justified[_ngcontent-%COMP%]    > li[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%] {\n    border-bottom: 1px solid #ddd;\n    border-radius: 4px 4px 0 0;\n  }\n  .nav-tabs-justified[_ngcontent-%COMP%]    > .active[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%], .nav-tabs-justified[_ngcontent-%COMP%]    > .active[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%]:hover, .nav-tabs-justified[_ngcontent-%COMP%]    > .active[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%]:focus {\n    border-bottom-color: #fff;\n  }\n}\n.tab-content[_ngcontent-%COMP%]    > .tab-pane[_ngcontent-%COMP%] {\n  display: none;\n}\n.tab-content[_ngcontent-%COMP%]    > .active[_ngcontent-%COMP%] {\n  display: block;\n}\n.nav-tabs[_ngcontent-%COMP%]   .dropdown-menu[_ngcontent-%COMP%] {\n  margin-top: -1px;\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n.navbar[_ngcontent-%COMP%] {\n  position: relative;\n  min-height: 50px;\n  margin-bottom: 20px;\n  border: 1px solid transparent;\n}\n@media (min-width: 768px) {\n  .navbar[_ngcontent-%COMP%] {\n    border-radius: 4px;\n  }\n}\n@media (min-width: 768px) {\n  .navbar-header[_ngcontent-%COMP%] {\n    float: left;\n  }\n}\n.navbar-collapse[_ngcontent-%COMP%] {\n  padding-right: 15px;\n  padding-left: 15px;\n  overflow-x: visible;\n  -webkit-overflow-scrolling: touch;\n  border-top: 1px solid transparent;\n  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, .1);\n          box-shadow: inset 0 1px 0 rgba(255, 255, 255, .1);\n}\n.navbar-collapse.in[_ngcontent-%COMP%] {\n  overflow-y: auto;\n}\n@media (min-width: 768px) {\n  .navbar-collapse[_ngcontent-%COMP%] {\n    width: auto;\n    border-top: 0;\n    -webkit-box-shadow: none;\n            box-shadow: none;\n  }\n  .navbar-collapse.collapse[_ngcontent-%COMP%] {\n    display: block !important;\n    height: auto !important;\n    padding-bottom: 0;\n    overflow: visible !important;\n  }\n  .navbar-collapse.in[_ngcontent-%COMP%] {\n    overflow-y: visible;\n  }\n  .navbar-fixed-top[_ngcontent-%COMP%]   .navbar-collapse[_ngcontent-%COMP%], .navbar-static-top[_ngcontent-%COMP%]   .navbar-collapse[_ngcontent-%COMP%], .navbar-fixed-bottom[_ngcontent-%COMP%]   .navbar-collapse[_ngcontent-%COMP%] {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n.navbar-fixed-top[_ngcontent-%COMP%]   .navbar-collapse[_ngcontent-%COMP%], .navbar-fixed-bottom[_ngcontent-%COMP%]   .navbar-collapse[_ngcontent-%COMP%] {\n  max-height: 340px;\n}\n@media (max-device-width: 480px) and (orientation: landscape) {\n  .navbar-fixed-top[_ngcontent-%COMP%]   .navbar-collapse[_ngcontent-%COMP%], .navbar-fixed-bottom[_ngcontent-%COMP%]   .navbar-collapse[_ngcontent-%COMP%] {\n    max-height: 200px;\n  }\n}\n.container[_ngcontent-%COMP%]    > .navbar-header[_ngcontent-%COMP%], .container-fluid[_ngcontent-%COMP%]    > .navbar-header[_ngcontent-%COMP%], .container[_ngcontent-%COMP%]    > .navbar-collapse[_ngcontent-%COMP%], .container-fluid[_ngcontent-%COMP%]    > .navbar-collapse[_ngcontent-%COMP%] {\n  margin-right: -15px;\n  margin-left: -15px;\n}\n@media (min-width: 768px) {\n  .container[_ngcontent-%COMP%]    > .navbar-header[_ngcontent-%COMP%], .container-fluid[_ngcontent-%COMP%]    > .navbar-header[_ngcontent-%COMP%], .container[_ngcontent-%COMP%]    > .navbar-collapse[_ngcontent-%COMP%], .container-fluid[_ngcontent-%COMP%]    > .navbar-collapse[_ngcontent-%COMP%] {\n    margin-right: 0;\n    margin-left: 0;\n  }\n}\n.navbar-static-top[_ngcontent-%COMP%] {\n  z-index: 1000;\n  border-width: 0 0 1px;\n}\n@media (min-width: 768px) {\n  .navbar-static-top[_ngcontent-%COMP%] {\n    border-radius: 0;\n  }\n}\n.navbar-fixed-top[_ngcontent-%COMP%], .navbar-fixed-bottom[_ngcontent-%COMP%] {\n  position: fixed;\n  right: 0;\n  left: 0;\n  z-index: 1030;\n}\n@media (min-width: 768px) {\n  .navbar-fixed-top[_ngcontent-%COMP%], .navbar-fixed-bottom[_ngcontent-%COMP%] {\n    border-radius: 0;\n  }\n}\n.navbar-fixed-top[_ngcontent-%COMP%] {\n  top: 0;\n  border-width: 0 0 1px;\n}\n.navbar-fixed-bottom[_ngcontent-%COMP%] {\n  bottom: 0;\n  margin-bottom: 0;\n  border-width: 1px 0 0;\n}\n.navbar-brand[_ngcontent-%COMP%] {\n  float: left;\n  height: 50px;\n  padding: 15px 15px;\n  font-size: 18px;\n  line-height: 20px;\n}\n.navbar-brand[_ngcontent-%COMP%]:hover, .navbar-brand[_ngcontent-%COMP%]:focus {\n  text-decoration: none;\n}\n.navbar-brand[_ngcontent-%COMP%]    > img[_ngcontent-%COMP%] {\n  display: block;\n}\n@media (min-width: 768px) {\n  .navbar[_ngcontent-%COMP%]    > .container[_ngcontent-%COMP%]   .navbar-brand[_ngcontent-%COMP%], .navbar[_ngcontent-%COMP%]    > .container-fluid[_ngcontent-%COMP%]   .navbar-brand[_ngcontent-%COMP%] {\n    margin-left: -15px;\n  }\n}\n.navbar-toggle[_ngcontent-%COMP%] {\n  position: relative;\n  float: right;\n  padding: 9px 10px;\n  margin-top: 8px;\n  margin-right: 15px;\n  margin-bottom: 8px;\n  background-color: transparent;\n  background-image: none;\n  border: 1px solid transparent;\n  border-radius: 4px;\n}\n.navbar-toggle[_ngcontent-%COMP%]:focus {\n  outline: 0;\n}\n.navbar-toggle[_ngcontent-%COMP%]   .icon-bar[_ngcontent-%COMP%] {\n  display: block;\n  width: 22px;\n  height: 2px;\n  border-radius: 1px;\n}\n.navbar-toggle[_ngcontent-%COMP%]   .icon-bar[_ngcontent-%COMP%]    + .icon-bar[_ngcontent-%COMP%] {\n  margin-top: 4px;\n}\n@media (min-width: 768px) {\n  .navbar-toggle[_ngcontent-%COMP%] {\n    display: none;\n  }\n}\n.navbar-nav[_ngcontent-%COMP%] {\n  margin: 7.5px -15px;\n}\n.navbar-nav[_ngcontent-%COMP%]    > li[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%] {\n  padding-top: 10px;\n  padding-bottom: 10px;\n  line-height: 20px;\n}\n@media (max-width: 767px) {\n  .navbar-nav[_ngcontent-%COMP%]   .open[_ngcontent-%COMP%]   .dropdown-menu[_ngcontent-%COMP%] {\n    position: static;\n    float: none;\n    width: auto;\n    margin-top: 0;\n    background-color: transparent;\n    border: 0;\n    -webkit-box-shadow: none;\n            box-shadow: none;\n  }\n  .navbar-nav[_ngcontent-%COMP%]   .open[_ngcontent-%COMP%]   .dropdown-menu[_ngcontent-%COMP%]    > li[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%], .navbar-nav[_ngcontent-%COMP%]   .open[_ngcontent-%COMP%]   .dropdown-menu[_ngcontent-%COMP%]   .dropdown-header[_ngcontent-%COMP%] {\n    padding: 5px 15px 5px 25px;\n  }\n  .navbar-nav[_ngcontent-%COMP%]   .open[_ngcontent-%COMP%]   .dropdown-menu[_ngcontent-%COMP%]    > li[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%] {\n    line-height: 20px;\n  }\n  .navbar-nav[_ngcontent-%COMP%]   .open[_ngcontent-%COMP%]   .dropdown-menu[_ngcontent-%COMP%]    > li[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%]:hover, .navbar-nav[_ngcontent-%COMP%]   .open[_ngcontent-%COMP%]   .dropdown-menu[_ngcontent-%COMP%]    > li[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%]:focus {\n    background-image: none;\n  }\n}\n@media (min-width: 768px) {\n  .navbar-nav[_ngcontent-%COMP%] {\n    float: left;\n    margin: 0;\n  }\n  .navbar-nav[_ngcontent-%COMP%]    > li[_ngcontent-%COMP%] {\n    float: left;\n  }\n  .navbar-nav[_ngcontent-%COMP%]    > li[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%] {\n    padding-top: 15px;\n    padding-bottom: 15px;\n  }\n}\n.navbar-form[_ngcontent-%COMP%] {\n  padding: 10px 15px;\n  margin-top: 8px;\n  margin-right: -15px;\n  margin-bottom: 8px;\n  margin-left: -15px;\n  border-top: 1px solid transparent;\n  border-bottom: 1px solid transparent;\n  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, .1), 0 1px 0 rgba(255, 255, 255, .1);\n          box-shadow: inset 0 1px 0 rgba(255, 255, 255, .1), 0 1px 0 rgba(255, 255, 255, .1);\n}\n@media (min-width: 768px) {\n  .navbar-form[_ngcontent-%COMP%]   .form-group[_ngcontent-%COMP%] {\n    display: inline-block;\n    margin-bottom: 0;\n    vertical-align: middle;\n  }\n  .navbar-form[_ngcontent-%COMP%]   .form-control[_ngcontent-%COMP%] {\n    display: inline-block;\n    width: auto;\n    vertical-align: middle;\n  }\n  .navbar-form[_ngcontent-%COMP%]   .form-control-static[_ngcontent-%COMP%] {\n    display: inline-block;\n  }\n  .navbar-form[_ngcontent-%COMP%]   .input-group[_ngcontent-%COMP%] {\n    display: inline-table;\n    vertical-align: middle;\n  }\n  .navbar-form[_ngcontent-%COMP%]   .input-group[_ngcontent-%COMP%]   .input-group-addon[_ngcontent-%COMP%], .navbar-form[_ngcontent-%COMP%]   .input-group[_ngcontent-%COMP%]   .input-group-btn[_ngcontent-%COMP%], .navbar-form[_ngcontent-%COMP%]   .input-group[_ngcontent-%COMP%]   .form-control[_ngcontent-%COMP%] {\n    width: auto;\n  }\n  .navbar-form[_ngcontent-%COMP%]   .input-group[_ngcontent-%COMP%]    > .form-control[_ngcontent-%COMP%] {\n    width: 100%;\n  }\n  .navbar-form[_ngcontent-%COMP%]   .control-label[_ngcontent-%COMP%] {\n    margin-bottom: 0;\n    vertical-align: middle;\n  }\n  .navbar-form[_ngcontent-%COMP%]   .radio[_ngcontent-%COMP%], .navbar-form[_ngcontent-%COMP%]   .checkbox[_ngcontent-%COMP%] {\n    display: inline-block;\n    margin-top: 0;\n    margin-bottom: 0;\n    vertical-align: middle;\n  }\n  .navbar-form[_ngcontent-%COMP%]   .radio[_ngcontent-%COMP%]   label[_ngcontent-%COMP%], .navbar-form[_ngcontent-%COMP%]   .checkbox[_ngcontent-%COMP%]   label[_ngcontent-%COMP%] {\n    padding-left: 0;\n  }\n  .navbar-form[_ngcontent-%COMP%]   .radio[_ngcontent-%COMP%]   input[type="radio"][_ngcontent-%COMP%], .navbar-form[_ngcontent-%COMP%]   .checkbox[_ngcontent-%COMP%]   input[type="checkbox"][_ngcontent-%COMP%] {\n    position: relative;\n    margin-left: 0;\n  }\n  .navbar-form[_ngcontent-%COMP%]   .has-feedback[_ngcontent-%COMP%]   .form-control-feedback[_ngcontent-%COMP%] {\n    top: 0;\n  }\n}\n@media (max-width: 767px) {\n  .navbar-form[_ngcontent-%COMP%]   .form-group[_ngcontent-%COMP%] {\n    margin-bottom: 5px;\n  }\n  .navbar-form[_ngcontent-%COMP%]   .form-group[_ngcontent-%COMP%]:last-child {\n    margin-bottom: 0;\n  }\n}\n@media (min-width: 768px) {\n  .navbar-form[_ngcontent-%COMP%] {\n    width: auto;\n    padding-top: 0;\n    padding-bottom: 0;\n    margin-right: 0;\n    margin-left: 0;\n    border: 0;\n    -webkit-box-shadow: none;\n            box-shadow: none;\n  }\n}\n.navbar-nav[_ngcontent-%COMP%]    > li[_ngcontent-%COMP%]    > .dropdown-menu[_ngcontent-%COMP%] {\n  margin-top: 0;\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n.navbar-fixed-bottom[_ngcontent-%COMP%]   .navbar-nav[_ngcontent-%COMP%]    > li[_ngcontent-%COMP%]    > .dropdown-menu[_ngcontent-%COMP%] {\n  margin-bottom: 0;\n  border-top-left-radius: 4px;\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.navbar-btn[_ngcontent-%COMP%] {\n  margin-top: 8px;\n  margin-bottom: 8px;\n}\n.navbar-btn.btn-sm[_ngcontent-%COMP%] {\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n.navbar-btn.btn-xs[_ngcontent-%COMP%] {\n  margin-top: 14px;\n  margin-bottom: 14px;\n}\n.navbar-text[_ngcontent-%COMP%] {\n  margin-top: 15px;\n  margin-bottom: 15px;\n}\n@media (min-width: 768px) {\n  .navbar-text[_ngcontent-%COMP%] {\n    float: left;\n    margin-right: 15px;\n    margin-left: 15px;\n  }\n}\n@media (min-width: 768px) {\n  .navbar-left[_ngcontent-%COMP%] {\n    float: left !important;\n  }\n  .navbar-right[_ngcontent-%COMP%] {\n    float: right !important;\n    margin-right: -15px;\n  }\n  .navbar-right[_ngcontent-%COMP%]    ~ .navbar-right[_ngcontent-%COMP%] {\n    margin-right: 0;\n  }\n}\n.navbar-default[_ngcontent-%COMP%] {\n  background-color: #f8f8f8;\n  border-color: #e7e7e7;\n}\n.navbar-default[_ngcontent-%COMP%]   .navbar-brand[_ngcontent-%COMP%] {\n  color: #777;\n}\n.navbar-default[_ngcontent-%COMP%]   .navbar-brand[_ngcontent-%COMP%]:hover, .navbar-default[_ngcontent-%COMP%]   .navbar-brand[_ngcontent-%COMP%]:focus {\n  color: #5e5e5e;\n  background-color: transparent;\n}\n.navbar-default[_ngcontent-%COMP%]   .navbar-text[_ngcontent-%COMP%] {\n  color: #777;\n}\n.navbar-default[_ngcontent-%COMP%]   .navbar-nav[_ngcontent-%COMP%]    > li[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%] {\n  color: #777;\n}\n.navbar-default[_ngcontent-%COMP%]   .navbar-nav[_ngcontent-%COMP%]    > li[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%]:hover, .navbar-default[_ngcontent-%COMP%]   .navbar-nav[_ngcontent-%COMP%]    > li[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%]:focus {\n  color: #333;\n  background-color: transparent;\n}\n.navbar-default[_ngcontent-%COMP%]   .navbar-nav[_ngcontent-%COMP%]    > .active[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%], .navbar-default[_ngcontent-%COMP%]   .navbar-nav[_ngcontent-%COMP%]    > .active[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%]:hover, .navbar-default[_ngcontent-%COMP%]   .navbar-nav[_ngcontent-%COMP%]    > .active[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%]:focus {\n  color: #555;\n  background-color: #e7e7e7;\n}\n.navbar-default[_ngcontent-%COMP%]   .navbar-nav[_ngcontent-%COMP%]    > .disabled[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%], .navbar-default[_ngcontent-%COMP%]   .navbar-nav[_ngcontent-%COMP%]    > .disabled[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%]:hover, .navbar-default[_ngcontent-%COMP%]   .navbar-nav[_ngcontent-%COMP%]    > .disabled[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%]:focus {\n  color: #ccc;\n  background-color: transparent;\n}\n.navbar-default[_ngcontent-%COMP%]   .navbar-toggle[_ngcontent-%COMP%] {\n  border-color: #ddd;\n}\n.navbar-default[_ngcontent-%COMP%]   .navbar-toggle[_ngcontent-%COMP%]:hover, .navbar-default[_ngcontent-%COMP%]   .navbar-toggle[_ngcontent-%COMP%]:focus {\n  background-color: #ddd;\n}\n.navbar-default[_ngcontent-%COMP%]   .navbar-toggle[_ngcontent-%COMP%]   .icon-bar[_ngcontent-%COMP%] {\n  background-color: #888;\n}\n.navbar-default[_ngcontent-%COMP%]   .navbar-collapse[_ngcontent-%COMP%], .navbar-default[_ngcontent-%COMP%]   .navbar-form[_ngcontent-%COMP%] {\n  border-color: #e7e7e7;\n}\n.navbar-default[_ngcontent-%COMP%]   .navbar-nav[_ngcontent-%COMP%]    > .open[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%], .navbar-default[_ngcontent-%COMP%]   .navbar-nav[_ngcontent-%COMP%]    > .open[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%]:hover, .navbar-default[_ngcontent-%COMP%]   .navbar-nav[_ngcontent-%COMP%]    > .open[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%]:focus {\n  color: #555;\n  background-color: #e7e7e7;\n}\n@media (max-width: 767px) {\n  .navbar-default[_ngcontent-%COMP%]   .navbar-nav[_ngcontent-%COMP%]   .open[_ngcontent-%COMP%]   .dropdown-menu[_ngcontent-%COMP%]    > li[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%] {\n    color: #777;\n  }\n  .navbar-default[_ngcontent-%COMP%]   .navbar-nav[_ngcontent-%COMP%]   .open[_ngcontent-%COMP%]   .dropdown-menu[_ngcontent-%COMP%]    > li[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%]:hover, .navbar-default[_ngcontent-%COMP%]   .navbar-nav[_ngcontent-%COMP%]   .open[_ngcontent-%COMP%]   .dropdown-menu[_ngcontent-%COMP%]    > li[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%]:focus {\n    color: #333;\n    background-color: transparent;\n  }\n  .navbar-default[_ngcontent-%COMP%]   .navbar-nav[_ngcontent-%COMP%]   .open[_ngcontent-%COMP%]   .dropdown-menu[_ngcontent-%COMP%]    > .active[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%], .navbar-default[_ngcontent-%COMP%]   .navbar-nav[_ngcontent-%COMP%]   .open[_ngcontent-%COMP%]   .dropdown-menu[_ngcontent-%COMP%]    > .active[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%]:hover, .navbar-default[_ngcontent-%COMP%]   .navbar-nav[_ngcontent-%COMP%]   .open[_ngcontent-%COMP%]   .dropdown-menu[_ngcontent-%COMP%]    > .active[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%]:focus {\n    color: #555;\n    background-color: #e7e7e7;\n  }\n  .navbar-default[_ngcontent-%COMP%]   .navbar-nav[_ngcontent-%COMP%]   .open[_ngcontent-%COMP%]   .dropdown-menu[_ngcontent-%COMP%]    > .disabled[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%], .navbar-default[_ngcontent-%COMP%]   .navbar-nav[_ngcontent-%COMP%]   .open[_ngcontent-%COMP%]   .dropdown-menu[_ngcontent-%COMP%]    > .disabled[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%]:hover, .navbar-default[_ngcontent-%COMP%]   .navbar-nav[_ngcontent-%COMP%]   .open[_ngcontent-%COMP%]   .dropdown-menu[_ngcontent-%COMP%]    > .disabled[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%]:focus {\n    color: #ccc;\n    background-color: transparent;\n  }\n}\n.navbar-default[_ngcontent-%COMP%]   .navbar-link[_ngcontent-%COMP%] {\n  color: #777;\n}\n.navbar-default[_ngcontent-%COMP%]   .navbar-link[_ngcontent-%COMP%]:hover {\n  color: #333;\n}\n.navbar-default[_ngcontent-%COMP%]   .btn-link[_ngcontent-%COMP%] {\n  color: #777;\n}\n.navbar-default[_ngcontent-%COMP%]   .btn-link[_ngcontent-%COMP%]:hover, .navbar-default[_ngcontent-%COMP%]   .btn-link[_ngcontent-%COMP%]:focus {\n  color: #333;\n}\n.navbar-default[_ngcontent-%COMP%]   .btn-link[disabled][_ngcontent-%COMP%]:hover, fieldset[disabled][_ngcontent-%COMP%]   .navbar-default[_ngcontent-%COMP%]   .btn-link[_ngcontent-%COMP%]:hover, .navbar-default[_ngcontent-%COMP%]   .btn-link[disabled][_ngcontent-%COMP%]:focus, fieldset[disabled][_ngcontent-%COMP%]   .navbar-default[_ngcontent-%COMP%]   .btn-link[_ngcontent-%COMP%]:focus {\n  color: #ccc;\n}\n.navbar-inverse[_ngcontent-%COMP%] {\n  background-color: #222;\n  border-color: #080808;\n}\n.navbar-inverse[_ngcontent-%COMP%]   .navbar-brand[_ngcontent-%COMP%] {\n  color: #9d9d9d;\n}\n.navbar-inverse[_ngcontent-%COMP%]   .navbar-brand[_ngcontent-%COMP%]:hover, .navbar-inverse[_ngcontent-%COMP%]   .navbar-brand[_ngcontent-%COMP%]:focus {\n  color: #fff;\n  background-color: transparent;\n}\n.navbar-inverse[_ngcontent-%COMP%]   .navbar-text[_ngcontent-%COMP%] {\n  color: #9d9d9d;\n}\n.navbar-inverse[_ngcontent-%COMP%]   .navbar-nav[_ngcontent-%COMP%]    > li[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%] {\n  color: #9d9d9d;\n}\n.navbar-inverse[_ngcontent-%COMP%]   .navbar-nav[_ngcontent-%COMP%]    > li[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%]:hover, .navbar-inverse[_ngcontent-%COMP%]   .navbar-nav[_ngcontent-%COMP%]    > li[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%]:focus {\n  color: #fff;\n  background-color: transparent;\n}\n.navbar-inverse[_ngcontent-%COMP%]   .navbar-nav[_ngcontent-%COMP%]    > .active[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%], .navbar-inverse[_ngcontent-%COMP%]   .navbar-nav[_ngcontent-%COMP%]    > .active[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%]:hover, .navbar-inverse[_ngcontent-%COMP%]   .navbar-nav[_ngcontent-%COMP%]    > .active[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%]:focus {\n  color: #fff;\n  background-color: #080808;\n}\n.navbar-inverse[_ngcontent-%COMP%]   .navbar-nav[_ngcontent-%COMP%]    > .disabled[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%], .navbar-inverse[_ngcontent-%COMP%]   .navbar-nav[_ngcontent-%COMP%]    > .disabled[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%]:hover, .navbar-inverse[_ngcontent-%COMP%]   .navbar-nav[_ngcontent-%COMP%]    > .disabled[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%]:focus {\n  color: #444;\n  background-color: transparent;\n}\n.navbar-inverse[_ngcontent-%COMP%]   .navbar-toggle[_ngcontent-%COMP%] {\n  border-color: #333;\n}\n.navbar-inverse[_ngcontent-%COMP%]   .navbar-toggle[_ngcontent-%COMP%]:hover, .navbar-inverse[_ngcontent-%COMP%]   .navbar-toggle[_ngcontent-%COMP%]:focus {\n  background-color: #333;\n}\n.navbar-inverse[_ngcontent-%COMP%]   .navbar-toggle[_ngcontent-%COMP%]   .icon-bar[_ngcontent-%COMP%] {\n  background-color: #fff;\n}\n.navbar-inverse[_ngcontent-%COMP%]   .navbar-collapse[_ngcontent-%COMP%], .navbar-inverse[_ngcontent-%COMP%]   .navbar-form[_ngcontent-%COMP%] {\n  border-color: #101010;\n}\n.navbar-inverse[_ngcontent-%COMP%]   .navbar-nav[_ngcontent-%COMP%]    > .open[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%], .navbar-inverse[_ngcontent-%COMP%]   .navbar-nav[_ngcontent-%COMP%]    > .open[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%]:hover, .navbar-inverse[_ngcontent-%COMP%]   .navbar-nav[_ngcontent-%COMP%]    > .open[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%]:focus {\n  color: #fff;\n  background-color: #080808;\n}\n@media (max-width: 767px) {\n  .navbar-inverse[_ngcontent-%COMP%]   .navbar-nav[_ngcontent-%COMP%]   .open[_ngcontent-%COMP%]   .dropdown-menu[_ngcontent-%COMP%]    > .dropdown-header[_ngcontent-%COMP%] {\n    border-color: #080808;\n  }\n  .navbar-inverse[_ngcontent-%COMP%]   .navbar-nav[_ngcontent-%COMP%]   .open[_ngcontent-%COMP%]   .dropdown-menu[_ngcontent-%COMP%]   .divider[_ngcontent-%COMP%] {\n    background-color: #080808;\n  }\n  .navbar-inverse[_ngcontent-%COMP%]   .navbar-nav[_ngcontent-%COMP%]   .open[_ngcontent-%COMP%]   .dropdown-menu[_ngcontent-%COMP%]    > li[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%] {\n    color: #9d9d9d;\n  }\n  .navbar-inverse[_ngcontent-%COMP%]   .navbar-nav[_ngcontent-%COMP%]   .open[_ngcontent-%COMP%]   .dropdown-menu[_ngcontent-%COMP%]    > li[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%]:hover, .navbar-inverse[_ngcontent-%COMP%]   .navbar-nav[_ngcontent-%COMP%]   .open[_ngcontent-%COMP%]   .dropdown-menu[_ngcontent-%COMP%]    > li[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%]:focus {\n    color: #fff;\n    background-color: transparent;\n  }\n  .navbar-inverse[_ngcontent-%COMP%]   .navbar-nav[_ngcontent-%COMP%]   .open[_ngcontent-%COMP%]   .dropdown-menu[_ngcontent-%COMP%]    > .active[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%], .navbar-inverse[_ngcontent-%COMP%]   .navbar-nav[_ngcontent-%COMP%]   .open[_ngcontent-%COMP%]   .dropdown-menu[_ngcontent-%COMP%]    > .active[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%]:hover, .navbar-inverse[_ngcontent-%COMP%]   .navbar-nav[_ngcontent-%COMP%]   .open[_ngcontent-%COMP%]   .dropdown-menu[_ngcontent-%COMP%]    > .active[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%]:focus {\n    color: #fff;\n    background-color: #080808;\n  }\n  .navbar-inverse[_ngcontent-%COMP%]   .navbar-nav[_ngcontent-%COMP%]   .open[_ngcontent-%COMP%]   .dropdown-menu[_ngcontent-%COMP%]    > .disabled[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%], .navbar-inverse[_ngcontent-%COMP%]   .navbar-nav[_ngcontent-%COMP%]   .open[_ngcontent-%COMP%]   .dropdown-menu[_ngcontent-%COMP%]    > .disabled[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%]:hover, .navbar-inverse[_ngcontent-%COMP%]   .navbar-nav[_ngcontent-%COMP%]   .open[_ngcontent-%COMP%]   .dropdown-menu[_ngcontent-%COMP%]    > .disabled[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%]:focus {\n    color: #444;\n    background-color: transparent;\n  }\n}\n.navbar-inverse[_ngcontent-%COMP%]   .navbar-link[_ngcontent-%COMP%] {\n  color: #9d9d9d;\n}\n.navbar-inverse[_ngcontent-%COMP%]   .navbar-link[_ngcontent-%COMP%]:hover {\n  color: #fff;\n}\n.navbar-inverse[_ngcontent-%COMP%]   .btn-link[_ngcontent-%COMP%] {\n  color: #9d9d9d;\n}\n.navbar-inverse[_ngcontent-%COMP%]   .btn-link[_ngcontent-%COMP%]:hover, .navbar-inverse[_ngcontent-%COMP%]   .btn-link[_ngcontent-%COMP%]:focus {\n  color: #fff;\n}\n.navbar-inverse[_ngcontent-%COMP%]   .btn-link[disabled][_ngcontent-%COMP%]:hover, fieldset[disabled][_ngcontent-%COMP%]   .navbar-inverse[_ngcontent-%COMP%]   .btn-link[_ngcontent-%COMP%]:hover, .navbar-inverse[_ngcontent-%COMP%]   .btn-link[disabled][_ngcontent-%COMP%]:focus, fieldset[disabled][_ngcontent-%COMP%]   .navbar-inverse[_ngcontent-%COMP%]   .btn-link[_ngcontent-%COMP%]:focus {\n  color: #444;\n}\n.breadcrumb[_ngcontent-%COMP%] {\n  padding: 8px 15px;\n  margin-bottom: 20px;\n  list-style: none;\n  background-color: #f5f5f5;\n  border-radius: 4px;\n}\n.breadcrumb[_ngcontent-%COMP%]    > li[_ngcontent-%COMP%] {\n  display: inline-block;\n}\n.breadcrumb[_ngcontent-%COMP%]    > li[_ngcontent-%COMP%]    + li[_ngcontent-%COMP%]:before {\n  padding: 0 5px;\n  color: #ccc;\n  content: "/\\00a0";\n}\n.breadcrumb[_ngcontent-%COMP%]    > .active[_ngcontent-%COMP%] {\n  color: #777;\n}\n.pagination[_ngcontent-%COMP%] {\n  display: inline-block;\n  padding-left: 0;\n  margin: 20px 0;\n  border-radius: 4px;\n}\n.pagination[_ngcontent-%COMP%]    > li[_ngcontent-%COMP%] {\n  display: inline;\n}\n.pagination[_ngcontent-%COMP%]    > li[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%], .pagination[_ngcontent-%COMP%]    > li[_ngcontent-%COMP%]    > span[_ngcontent-%COMP%] {\n  position: relative;\n  float: left;\n  padding: 6px 12px;\n  margin-left: -1px;\n  line-height: 1.42857143;\n  color: #337ab7;\n  text-decoration: none;\n  background-color: #fff;\n  border: 1px solid #ddd;\n}\n.pagination[_ngcontent-%COMP%]    > li[_ngcontent-%COMP%]:first-child    > a[_ngcontent-%COMP%], .pagination[_ngcontent-%COMP%]    > li[_ngcontent-%COMP%]:first-child    > span[_ngcontent-%COMP%] {\n  margin-left: 0;\n  border-top-left-radius: 4px;\n  border-bottom-left-radius: 4px;\n}\n.pagination[_ngcontent-%COMP%]    > li[_ngcontent-%COMP%]:last-child    > a[_ngcontent-%COMP%], .pagination[_ngcontent-%COMP%]    > li[_ngcontent-%COMP%]:last-child    > span[_ngcontent-%COMP%] {\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 4px;\n}\n.pagination[_ngcontent-%COMP%]    > li[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%]:hover, .pagination[_ngcontent-%COMP%]    > li[_ngcontent-%COMP%]    > span[_ngcontent-%COMP%]:hover, .pagination[_ngcontent-%COMP%]    > li[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%]:focus, .pagination[_ngcontent-%COMP%]    > li[_ngcontent-%COMP%]    > span[_ngcontent-%COMP%]:focus {\n  z-index: 2;\n  color: #23527c;\n  background-color: #eee;\n  border-color: #ddd;\n}\n.pagination[_ngcontent-%COMP%]    > .active[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%], .pagination[_ngcontent-%COMP%]    > .active[_ngcontent-%COMP%]    > span[_ngcontent-%COMP%], .pagination[_ngcontent-%COMP%]    > .active[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%]:hover, .pagination[_ngcontent-%COMP%]    > .active[_ngcontent-%COMP%]    > span[_ngcontent-%COMP%]:hover, .pagination[_ngcontent-%COMP%]    > .active[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%]:focus, .pagination[_ngcontent-%COMP%]    > .active[_ngcontent-%COMP%]    > span[_ngcontent-%COMP%]:focus {\n  z-index: 3;\n  color: #fff;\n  cursor: default;\n  background-color: #337ab7;\n  border-color: #337ab7;\n}\n.pagination[_ngcontent-%COMP%]    > .disabled[_ngcontent-%COMP%]    > span[_ngcontent-%COMP%], .pagination[_ngcontent-%COMP%]    > .disabled[_ngcontent-%COMP%]    > span[_ngcontent-%COMP%]:hover, .pagination[_ngcontent-%COMP%]    > .disabled[_ngcontent-%COMP%]    > span[_ngcontent-%COMP%]:focus, .pagination[_ngcontent-%COMP%]    > .disabled[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%], .pagination[_ngcontent-%COMP%]    > .disabled[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%]:hover, .pagination[_ngcontent-%COMP%]    > .disabled[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%]:focus {\n  color: #777;\n  cursor: not-allowed;\n  background-color: #fff;\n  border-color: #ddd;\n}\n.pagination-lg[_ngcontent-%COMP%]    > li[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%], .pagination-lg[_ngcontent-%COMP%]    > li[_ngcontent-%COMP%]    > span[_ngcontent-%COMP%] {\n  padding: 10px 16px;\n  font-size: 18px;\n  line-height: 1.3333333;\n}\n.pagination-lg[_ngcontent-%COMP%]    > li[_ngcontent-%COMP%]:first-child    > a[_ngcontent-%COMP%], .pagination-lg[_ngcontent-%COMP%]    > li[_ngcontent-%COMP%]:first-child    > span[_ngcontent-%COMP%] {\n  border-top-left-radius: 6px;\n  border-bottom-left-radius: 6px;\n}\n.pagination-lg[_ngcontent-%COMP%]    > li[_ngcontent-%COMP%]:last-child    > a[_ngcontent-%COMP%], .pagination-lg[_ngcontent-%COMP%]    > li[_ngcontent-%COMP%]:last-child    > span[_ngcontent-%COMP%] {\n  border-top-right-radius: 6px;\n  border-bottom-right-radius: 6px;\n}\n.pagination-sm[_ngcontent-%COMP%]    > li[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%], .pagination-sm[_ngcontent-%COMP%]    > li[_ngcontent-%COMP%]    > span[_ngcontent-%COMP%] {\n  padding: 5px 10px;\n  font-size: 12px;\n  line-height: 1.5;\n}\n.pagination-sm[_ngcontent-%COMP%]    > li[_ngcontent-%COMP%]:first-child    > a[_ngcontent-%COMP%], .pagination-sm[_ngcontent-%COMP%]    > li[_ngcontent-%COMP%]:first-child    > span[_ngcontent-%COMP%] {\n  border-top-left-radius: 3px;\n  border-bottom-left-radius: 3px;\n}\n.pagination-sm[_ngcontent-%COMP%]    > li[_ngcontent-%COMP%]:last-child    > a[_ngcontent-%COMP%], .pagination-sm[_ngcontent-%COMP%]    > li[_ngcontent-%COMP%]:last-child    > span[_ngcontent-%COMP%] {\n  border-top-right-radius: 3px;\n  border-bottom-right-radius: 3px;\n}\n.pager[_ngcontent-%COMP%] {\n  padding-left: 0;\n  margin: 20px 0;\n  text-align: center;\n  list-style: none;\n}\n.pager[_ngcontent-%COMP%]   li[_ngcontent-%COMP%] {\n  display: inline;\n}\n.pager[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%], .pager[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]    > span[_ngcontent-%COMP%] {\n  display: inline-block;\n  padding: 5px 14px;\n  background-color: #fff;\n  border: 1px solid #ddd;\n  border-radius: 15px;\n}\n.pager[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%]:hover, .pager[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%]:focus {\n  text-decoration: none;\n  background-color: #eee;\n}\n.pager[_ngcontent-%COMP%]   .next[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%], .pager[_ngcontent-%COMP%]   .next[_ngcontent-%COMP%]    > span[_ngcontent-%COMP%] {\n  float: right;\n}\n.pager[_ngcontent-%COMP%]   .previous[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%], .pager[_ngcontent-%COMP%]   .previous[_ngcontent-%COMP%]    > span[_ngcontent-%COMP%] {\n  float: left;\n}\n.pager[_ngcontent-%COMP%]   .disabled[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%], .pager[_ngcontent-%COMP%]   .disabled[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%]:hover, .pager[_ngcontent-%COMP%]   .disabled[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%]:focus, .pager[_ngcontent-%COMP%]   .disabled[_ngcontent-%COMP%]    > span[_ngcontent-%COMP%] {\n  color: #777;\n  cursor: not-allowed;\n  background-color: #fff;\n}\n.label[_ngcontent-%COMP%] {\n  display: inline;\n  padding: .2em .6em .3em;\n  font-size: 75%;\n  font-weight: bold;\n  line-height: 1;\n  color: #fff;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  border-radius: .25em;\n}\na.label[_ngcontent-%COMP%]:hover, a.label[_ngcontent-%COMP%]:focus {\n  color: #fff;\n  text-decoration: none;\n  cursor: pointer;\n}\n.label[_ngcontent-%COMP%]:empty {\n  display: none;\n}\n.btn[_ngcontent-%COMP%]   .label[_ngcontent-%COMP%] {\n  position: relative;\n  top: -1px;\n}\n.label-default[_ngcontent-%COMP%] {\n  background-color: #777;\n}\n.label-default[href][_ngcontent-%COMP%]:hover, .label-default[href][_ngcontent-%COMP%]:focus {\n  background-color: #5e5e5e;\n}\n.label-primary[_ngcontent-%COMP%] {\n  background-color: #337ab7;\n}\n.label-primary[href][_ngcontent-%COMP%]:hover, .label-primary[href][_ngcontent-%COMP%]:focus {\n  background-color: #286090;\n}\n.label-success[_ngcontent-%COMP%] {\n  background-color: #5cb85c;\n}\n.label-success[href][_ngcontent-%COMP%]:hover, .label-success[href][_ngcontent-%COMP%]:focus {\n  background-color: #449d44;\n}\n.label-info[_ngcontent-%COMP%] {\n  background-color: #5bc0de;\n}\n.label-info[href][_ngcontent-%COMP%]:hover, .label-info[href][_ngcontent-%COMP%]:focus {\n  background-color: #31b0d5;\n}\n.label-warning[_ngcontent-%COMP%] {\n  background-color: #f0ad4e;\n}\n.label-warning[href][_ngcontent-%COMP%]:hover, .label-warning[href][_ngcontent-%COMP%]:focus {\n  background-color: #ec971f;\n}\n.label-danger[_ngcontent-%COMP%] {\n  background-color: #d9534f;\n}\n.label-danger[href][_ngcontent-%COMP%]:hover, .label-danger[href][_ngcontent-%COMP%]:focus {\n  background-color: #c9302c;\n}\n.badge[_ngcontent-%COMP%] {\n  display: inline-block;\n  min-width: 10px;\n  padding: 3px 7px;\n  font-size: 12px;\n  font-weight: bold;\n  line-height: 1;\n  color: #fff;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: middle;\n  background-color: #777;\n  border-radius: 10px;\n}\n.badge[_ngcontent-%COMP%]:empty {\n  display: none;\n}\n.btn[_ngcontent-%COMP%]   .badge[_ngcontent-%COMP%] {\n  position: relative;\n  top: -1px;\n}\n.btn-xs[_ngcontent-%COMP%]   .badge[_ngcontent-%COMP%], .btn-group-xs[_ngcontent-%COMP%]    > .btn[_ngcontent-%COMP%]   .badge[_ngcontent-%COMP%] {\n  top: 0;\n  padding: 1px 5px;\n}\na.badge[_ngcontent-%COMP%]:hover, a.badge[_ngcontent-%COMP%]:focus {\n  color: #fff;\n  text-decoration: none;\n  cursor: pointer;\n}\n.list-group-item.active[_ngcontent-%COMP%]    > .badge[_ngcontent-%COMP%], .nav-pills[_ngcontent-%COMP%]    > .active[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%]    > .badge[_ngcontent-%COMP%] {\n  color: #337ab7;\n  background-color: #fff;\n}\n.list-group-item[_ngcontent-%COMP%]    > .badge[_ngcontent-%COMP%] {\n  float: right;\n}\n.list-group-item[_ngcontent-%COMP%]    > .badge[_ngcontent-%COMP%]    + .badge[_ngcontent-%COMP%] {\n  margin-right: 5px;\n}\n.nav-pills[_ngcontent-%COMP%]    > li[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%]    > .badge[_ngcontent-%COMP%] {\n  margin-left: 3px;\n}\n.jumbotron[_ngcontent-%COMP%] {\n  padding-top: 30px;\n  padding-bottom: 30px;\n  margin-bottom: 30px;\n  color: inherit;\n  background-color: #eee;\n}\n.jumbotron[_ngcontent-%COMP%]   h1[_ngcontent-%COMP%], .jumbotron[_ngcontent-%COMP%]   .h1[_ngcontent-%COMP%] {\n  color: inherit;\n}\n.jumbotron[_ngcontent-%COMP%]   p[_ngcontent-%COMP%] {\n  margin-bottom: 15px;\n  font-size: 21px;\n  font-weight: 200;\n}\n.jumbotron[_ngcontent-%COMP%]    > hr[_ngcontent-%COMP%] {\n  border-top-color: #d5d5d5;\n}\n.container[_ngcontent-%COMP%]   .jumbotron[_ngcontent-%COMP%], .container-fluid[_ngcontent-%COMP%]   .jumbotron[_ngcontent-%COMP%] {\n  padding-right: 15px;\n  padding-left: 15px;\n  border-radius: 6px;\n}\n.jumbotron[_ngcontent-%COMP%]   .container[_ngcontent-%COMP%] {\n  max-width: 100%;\n}\n@media screen and (min-width: 768px) {\n  .jumbotron[_ngcontent-%COMP%] {\n    padding-top: 48px;\n    padding-bottom: 48px;\n  }\n  .container[_ngcontent-%COMP%]   .jumbotron[_ngcontent-%COMP%], .container-fluid[_ngcontent-%COMP%]   .jumbotron[_ngcontent-%COMP%] {\n    padding-right: 60px;\n    padding-left: 60px;\n  }\n  .jumbotron[_ngcontent-%COMP%]   h1[_ngcontent-%COMP%], .jumbotron[_ngcontent-%COMP%]   .h1[_ngcontent-%COMP%] {\n    font-size: 63px;\n  }\n}\n.thumbnail[_ngcontent-%COMP%] {\n  display: block;\n  padding: 4px;\n  margin-bottom: 20px;\n  line-height: 1.42857143;\n  background-color: #fff;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  -webkit-transition: border .2s ease-in-out;\n       -o-transition: border .2s ease-in-out;\n          transition: border .2s ease-in-out;\n}\n.thumbnail[_ngcontent-%COMP%]    > img[_ngcontent-%COMP%], .thumbnail[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]    > img[_ngcontent-%COMP%] {\n  margin-right: auto;\n  margin-left: auto;\n}\na.thumbnail[_ngcontent-%COMP%]:hover, a.thumbnail[_ngcontent-%COMP%]:focus, a.thumbnail.active[_ngcontent-%COMP%] {\n  border-color: #337ab7;\n}\n.thumbnail[_ngcontent-%COMP%]   .caption[_ngcontent-%COMP%] {\n  padding: 9px;\n  color: #333;\n}\n.alert[_ngcontent-%COMP%] {\n  padding: 15px;\n  margin-bottom: 20px;\n  border: 1px solid transparent;\n  border-radius: 4px;\n}\n.alert[_ngcontent-%COMP%]   h4[_ngcontent-%COMP%] {\n  margin-top: 0;\n  color: inherit;\n}\n.alert[_ngcontent-%COMP%]   .alert-link[_ngcontent-%COMP%] {\n  font-weight: bold;\n}\n.alert[_ngcontent-%COMP%]    > p[_ngcontent-%COMP%], .alert[_ngcontent-%COMP%]    > ul[_ngcontent-%COMP%] {\n  margin-bottom: 0;\n}\n.alert[_ngcontent-%COMP%]    > p[_ngcontent-%COMP%]    + p[_ngcontent-%COMP%] {\n  margin-top: 5px;\n}\n.alert-dismissable[_ngcontent-%COMP%], .alert-dismissible[_ngcontent-%COMP%] {\n  padding-right: 35px;\n}\n.alert-dismissable[_ngcontent-%COMP%]   .close[_ngcontent-%COMP%], .alert-dismissible[_ngcontent-%COMP%]   .close[_ngcontent-%COMP%] {\n  position: relative;\n  top: -2px;\n  right: -21px;\n  color: inherit;\n}\n.alert-success[_ngcontent-%COMP%] {\n  color: #3c763d;\n  background-color: #dff0d8;\n  border-color: #d6e9c6;\n}\n.alert-success[_ngcontent-%COMP%]   hr[_ngcontent-%COMP%] {\n  border-top-color: #c9e2b3;\n}\n.alert-success[_ngcontent-%COMP%]   .alert-link[_ngcontent-%COMP%] {\n  color: #2b542c;\n}\n.alert-info[_ngcontent-%COMP%] {\n  color: #31708f;\n  background-color: #d9edf7;\n  border-color: #bce8f1;\n}\n.alert-info[_ngcontent-%COMP%]   hr[_ngcontent-%COMP%] {\n  border-top-color: #a6e1ec;\n}\n.alert-info[_ngcontent-%COMP%]   .alert-link[_ngcontent-%COMP%] {\n  color: #245269;\n}\n.alert-warning[_ngcontent-%COMP%] {\n  color: #8a6d3b;\n  background-color: #fcf8e3;\n  border-color: #faebcc;\n}\n.alert-warning[_ngcontent-%COMP%]   hr[_ngcontent-%COMP%] {\n  border-top-color: #f7e1b5;\n}\n.alert-warning[_ngcontent-%COMP%]   .alert-link[_ngcontent-%COMP%] {\n  color: #66512c;\n}\n.alert-danger[_ngcontent-%COMP%] {\n  color: #a94442;\n  background-color: #f2dede;\n  border-color: #ebccd1;\n}\n.alert-danger[_ngcontent-%COMP%]   hr[_ngcontent-%COMP%] {\n  border-top-color: #e4b9c0;\n}\n.alert-danger[_ngcontent-%COMP%]   .alert-link[_ngcontent-%COMP%] {\n  color: #843534;\n}\n@-webkit-keyframes progress-bar-stripes {\n  from {\n    background-position: 40px 0;\n  }\n  to {\n    background-position: 0 0;\n  }\n}\n@-o-keyframes progress-bar-stripes {\n  from {\n    background-position: 40px 0;\n  }\n  to {\n    background-position: 0 0;\n  }\n}\n@keyframes progress-bar-stripes {\n  from {\n    background-position: 40px 0;\n  }\n  to {\n    background-position: 0 0;\n  }\n}\n.progress[_ngcontent-%COMP%] {\n  height: 20px;\n  margin-bottom: 20px;\n  overflow: hidden;\n  background-color: #f5f5f5;\n  border-radius: 4px;\n  -webkit-box-shadow: inset 0 1px 2px rgba(0, 0, 0, .1);\n          box-shadow: inset 0 1px 2px rgba(0, 0, 0, .1);\n}\n.progress-bar[_ngcontent-%COMP%] {\n  float: left;\n  width: 0;\n  height: 100%;\n  font-size: 12px;\n  line-height: 20px;\n  color: #fff;\n  text-align: center;\n  background-color: #337ab7;\n  -webkit-box-shadow: inset 0 -1px 0 rgba(0, 0, 0, .15);\n          box-shadow: inset 0 -1px 0 rgba(0, 0, 0, .15);\n  -webkit-transition: width .6s ease;\n       -o-transition: width .6s ease;\n          transition: width .6s ease;\n}\n.progress-striped[_ngcontent-%COMP%]   .progress-bar[_ngcontent-%COMP%], .progress-bar-striped[_ngcontent-%COMP%] {\n  background-image: -webkit-linear-gradient(45deg, rgba(255, 255, 255, .15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .15) 50%, rgba(255, 255, 255, .15) 75%, transparent 75%, transparent);\n  background-image:      -o-linear-gradient(45deg, rgba(255, 255, 255, .15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .15) 50%, rgba(255, 255, 255, .15) 75%, transparent 75%, transparent);\n  background-image:         linear-gradient(45deg, rgba(255, 255, 255, .15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .15) 50%, rgba(255, 255, 255, .15) 75%, transparent 75%, transparent);\n  -webkit-background-size: 40px 40px;\n          background-size: 40px 40px;\n}\n.progress.active[_ngcontent-%COMP%]   .progress-bar[_ngcontent-%COMP%], .progress-bar.active[_ngcontent-%COMP%] {\n  -webkit-animation: progress-bar-stripes 2s linear infinite;\n       -o-animation: progress-bar-stripes 2s linear infinite;\n          animation: progress-bar-stripes 2s linear infinite;\n}\n.progress-bar-success[_ngcontent-%COMP%] {\n  background-color: #5cb85c;\n}\n.progress-striped[_ngcontent-%COMP%]   .progress-bar-success[_ngcontent-%COMP%] {\n  background-image: -webkit-linear-gradient(45deg, rgba(255, 255, 255, .15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .15) 50%, rgba(255, 255, 255, .15) 75%, transparent 75%, transparent);\n  background-image:      -o-linear-gradient(45deg, rgba(255, 255, 255, .15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .15) 50%, rgba(255, 255, 255, .15) 75%, transparent 75%, transparent);\n  background-image:         linear-gradient(45deg, rgba(255, 255, 255, .15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .15) 50%, rgba(255, 255, 255, .15) 75%, transparent 75%, transparent);\n}\n.progress-bar-info[_ngcontent-%COMP%] {\n  background-color: #5bc0de;\n}\n.progress-striped[_ngcontent-%COMP%]   .progress-bar-info[_ngcontent-%COMP%] {\n  background-image: -webkit-linear-gradient(45deg, rgba(255, 255, 255, .15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .15) 50%, rgba(255, 255, 255, .15) 75%, transparent 75%, transparent);\n  background-image:      -o-linear-gradient(45deg, rgba(255, 255, 255, .15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .15) 50%, rgba(255, 255, 255, .15) 75%, transparent 75%, transparent);\n  background-image:         linear-gradient(45deg, rgba(255, 255, 255, .15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .15) 50%, rgba(255, 255, 255, .15) 75%, transparent 75%, transparent);\n}\n.progress-bar-warning[_ngcontent-%COMP%] {\n  background-color: #f0ad4e;\n}\n.progress-striped[_ngcontent-%COMP%]   .progress-bar-warning[_ngcontent-%COMP%] {\n  background-image: -webkit-linear-gradient(45deg, rgba(255, 255, 255, .15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .15) 50%, rgba(255, 255, 255, .15) 75%, transparent 75%, transparent);\n  background-image:      -o-linear-gradient(45deg, rgba(255, 255, 255, .15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .15) 50%, rgba(255, 255, 255, .15) 75%, transparent 75%, transparent);\n  background-image:         linear-gradient(45deg, rgba(255, 255, 255, .15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .15) 50%, rgba(255, 255, 255, .15) 75%, transparent 75%, transparent);\n}\n.progress-bar-danger[_ngcontent-%COMP%] {\n  background-color: #d9534f;\n}\n.progress-striped[_ngcontent-%COMP%]   .progress-bar-danger[_ngcontent-%COMP%] {\n  background-image: -webkit-linear-gradient(45deg, rgba(255, 255, 255, .15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .15) 50%, rgba(255, 255, 255, .15) 75%, transparent 75%, transparent);\n  background-image:      -o-linear-gradient(45deg, rgba(255, 255, 255, .15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .15) 50%, rgba(255, 255, 255, .15) 75%, transparent 75%, transparent);\n  background-image:         linear-gradient(45deg, rgba(255, 255, 255, .15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .15) 50%, rgba(255, 255, 255, .15) 75%, transparent 75%, transparent);\n}\n.media[_ngcontent-%COMP%] {\n  margin-top: 15px;\n}\n.media[_ngcontent-%COMP%]:first-child {\n  margin-top: 0;\n}\n.media[_ngcontent-%COMP%], .media-body[_ngcontent-%COMP%] {\n  overflow: hidden;\n  zoom: 1;\n}\n.media-body[_ngcontent-%COMP%] {\n  width: 10000px;\n}\n.media-object[_ngcontent-%COMP%] {\n  display: block;\n}\n.media-object.img-thumbnail[_ngcontent-%COMP%] {\n  max-width: none;\n}\n.media-right[_ngcontent-%COMP%], .media[_ngcontent-%COMP%]    > .pull-right[_ngcontent-%COMP%] {\n  padding-left: 10px;\n}\n.media-left[_ngcontent-%COMP%], .media[_ngcontent-%COMP%]    > .pull-left[_ngcontent-%COMP%] {\n  padding-right: 10px;\n}\n.media-left[_ngcontent-%COMP%], .media-right[_ngcontent-%COMP%], .media-body[_ngcontent-%COMP%] {\n  display: table-cell;\n  vertical-align: top;\n}\n.media-middle[_ngcontent-%COMP%] {\n  vertical-align: middle;\n}\n.media-bottom[_ngcontent-%COMP%] {\n  vertical-align: bottom;\n}\n.media-heading[_ngcontent-%COMP%] {\n  margin-top: 0;\n  margin-bottom: 5px;\n}\n.media-list[_ngcontent-%COMP%] {\n  padding-left: 0;\n  list-style: none;\n}\n.list-group[_ngcontent-%COMP%] {\n  padding-left: 0;\n  margin-bottom: 20px;\n}\n.list-group-item[_ngcontent-%COMP%] {\n  position: relative;\n  display: block;\n  padding: 10px 15px;\n  margin-bottom: -1px;\n  background-color: #fff;\n  border: 1px solid #ddd;\n}\n.list-group-item[_ngcontent-%COMP%]:first-child {\n  border-top-left-radius: 4px;\n  border-top-right-radius: 4px;\n}\n.list-group-item[_ngcontent-%COMP%]:last-child {\n  margin-bottom: 0;\n  border-bottom-right-radius: 4px;\n  border-bottom-left-radius: 4px;\n}\na.list-group-item[_ngcontent-%COMP%], button.list-group-item[_ngcontent-%COMP%] {\n  color: #555;\n}\na.list-group-item[_ngcontent-%COMP%]   .list-group-item-heading[_ngcontent-%COMP%], button.list-group-item[_ngcontent-%COMP%]   .list-group-item-heading[_ngcontent-%COMP%] {\n  color: #333;\n}\na.list-group-item[_ngcontent-%COMP%]:hover, button.list-group-item[_ngcontent-%COMP%]:hover, a.list-group-item[_ngcontent-%COMP%]:focus, button.list-group-item[_ngcontent-%COMP%]:focus {\n  color: #555;\n  text-decoration: none;\n  background-color: #f5f5f5;\n}\nbutton.list-group-item[_ngcontent-%COMP%] {\n  width: 100%;\n  text-align: left;\n}\n.list-group-item.disabled[_ngcontent-%COMP%], .list-group-item.disabled[_ngcontent-%COMP%]:hover, .list-group-item.disabled[_ngcontent-%COMP%]:focus {\n  color: #777;\n  cursor: not-allowed;\n  background-color: #eee;\n}\n.list-group-item.disabled[_ngcontent-%COMP%]   .list-group-item-heading[_ngcontent-%COMP%], .list-group-item.disabled[_ngcontent-%COMP%]:hover   .list-group-item-heading[_ngcontent-%COMP%], .list-group-item.disabled[_ngcontent-%COMP%]:focus   .list-group-item-heading[_ngcontent-%COMP%] {\n  color: inherit;\n}\n.list-group-item.disabled[_ngcontent-%COMP%]   .list-group-item-text[_ngcontent-%COMP%], .list-group-item.disabled[_ngcontent-%COMP%]:hover   .list-group-item-text[_ngcontent-%COMP%], .list-group-item.disabled[_ngcontent-%COMP%]:focus   .list-group-item-text[_ngcontent-%COMP%] {\n  color: #777;\n}\n.list-group-item.active[_ngcontent-%COMP%], .list-group-item.active[_ngcontent-%COMP%]:hover, .list-group-item.active[_ngcontent-%COMP%]:focus {\n  z-index: 2;\n  color: #fff;\n  background-color: #337ab7;\n  border-color: #337ab7;\n}\n.list-group-item.active[_ngcontent-%COMP%]   .list-group-item-heading[_ngcontent-%COMP%], .list-group-item.active[_ngcontent-%COMP%]:hover   .list-group-item-heading[_ngcontent-%COMP%], .list-group-item.active[_ngcontent-%COMP%]:focus   .list-group-item-heading[_ngcontent-%COMP%], .list-group-item.active[_ngcontent-%COMP%]   .list-group-item-heading[_ngcontent-%COMP%]    > small[_ngcontent-%COMP%], .list-group-item.active[_ngcontent-%COMP%]:hover   .list-group-item-heading[_ngcontent-%COMP%]    > small[_ngcontent-%COMP%], .list-group-item.active[_ngcontent-%COMP%]:focus   .list-group-item-heading[_ngcontent-%COMP%]    > small[_ngcontent-%COMP%], .list-group-item.active[_ngcontent-%COMP%]   .list-group-item-heading[_ngcontent-%COMP%]    > .small[_ngcontent-%COMP%], .list-group-item.active[_ngcontent-%COMP%]:hover   .list-group-item-heading[_ngcontent-%COMP%]    > .small[_ngcontent-%COMP%], .list-group-item.active[_ngcontent-%COMP%]:focus   .list-group-item-heading[_ngcontent-%COMP%]    > .small[_ngcontent-%COMP%] {\n  color: inherit;\n}\n.list-group-item.active[_ngcontent-%COMP%]   .list-group-item-text[_ngcontent-%COMP%], .list-group-item.active[_ngcontent-%COMP%]:hover   .list-group-item-text[_ngcontent-%COMP%], .list-group-item.active[_ngcontent-%COMP%]:focus   .list-group-item-text[_ngcontent-%COMP%] {\n  color: #c7ddef;\n}\n.list-group-item-success[_ngcontent-%COMP%] {\n  color: #3c763d;\n  background-color: #dff0d8;\n}\na.list-group-item-success[_ngcontent-%COMP%], button.list-group-item-success[_ngcontent-%COMP%] {\n  color: #3c763d;\n}\na.list-group-item-success[_ngcontent-%COMP%]   .list-group-item-heading[_ngcontent-%COMP%], button.list-group-item-success[_ngcontent-%COMP%]   .list-group-item-heading[_ngcontent-%COMP%] {\n  color: inherit;\n}\na.list-group-item-success[_ngcontent-%COMP%]:hover, button.list-group-item-success[_ngcontent-%COMP%]:hover, a.list-group-item-success[_ngcontent-%COMP%]:focus, button.list-group-item-success[_ngcontent-%COMP%]:focus {\n  color: #3c763d;\n  background-color: #d0e9c6;\n}\na.list-group-item-success.active[_ngcontent-%COMP%], button.list-group-item-success.active[_ngcontent-%COMP%], a.list-group-item-success.active[_ngcontent-%COMP%]:hover, button.list-group-item-success.active[_ngcontent-%COMP%]:hover, a.list-group-item-success.active[_ngcontent-%COMP%]:focus, button.list-group-item-success.active[_ngcontent-%COMP%]:focus {\n  color: #fff;\n  background-color: #3c763d;\n  border-color: #3c763d;\n}\n.list-group-item-info[_ngcontent-%COMP%] {\n  color: #31708f;\n  background-color: #d9edf7;\n}\na.list-group-item-info[_ngcontent-%COMP%], button.list-group-item-info[_ngcontent-%COMP%] {\n  color: #31708f;\n}\na.list-group-item-info[_ngcontent-%COMP%]   .list-group-item-heading[_ngcontent-%COMP%], button.list-group-item-info[_ngcontent-%COMP%]   .list-group-item-heading[_ngcontent-%COMP%] {\n  color: inherit;\n}\na.list-group-item-info[_ngcontent-%COMP%]:hover, button.list-group-item-info[_ngcontent-%COMP%]:hover, a.list-group-item-info[_ngcontent-%COMP%]:focus, button.list-group-item-info[_ngcontent-%COMP%]:focus {\n  color: #31708f;\n  background-color: #c4e3f3;\n}\na.list-group-item-info.active[_ngcontent-%COMP%], button.list-group-item-info.active[_ngcontent-%COMP%], a.list-group-item-info.active[_ngcontent-%COMP%]:hover, button.list-group-item-info.active[_ngcontent-%COMP%]:hover, a.list-group-item-info.active[_ngcontent-%COMP%]:focus, button.list-group-item-info.active[_ngcontent-%COMP%]:focus {\n  color: #fff;\n  background-color: #31708f;\n  border-color: #31708f;\n}\n.list-group-item-warning[_ngcontent-%COMP%] {\n  color: #8a6d3b;\n  background-color: #fcf8e3;\n}\na.list-group-item-warning[_ngcontent-%COMP%], button.list-group-item-warning[_ngcontent-%COMP%] {\n  color: #8a6d3b;\n}\na.list-group-item-warning[_ngcontent-%COMP%]   .list-group-item-heading[_ngcontent-%COMP%], button.list-group-item-warning[_ngcontent-%COMP%]   .list-group-item-heading[_ngcontent-%COMP%] {\n  color: inherit;\n}\na.list-group-item-warning[_ngcontent-%COMP%]:hover, button.list-group-item-warning[_ngcontent-%COMP%]:hover, a.list-group-item-warning[_ngcontent-%COMP%]:focus, button.list-group-item-warning[_ngcontent-%COMP%]:focus {\n  color: #8a6d3b;\n  background-color: #faf2cc;\n}\na.list-group-item-warning.active[_ngcontent-%COMP%], button.list-group-item-warning.active[_ngcontent-%COMP%], a.list-group-item-warning.active[_ngcontent-%COMP%]:hover, button.list-group-item-warning.active[_ngcontent-%COMP%]:hover, a.list-group-item-warning.active[_ngcontent-%COMP%]:focus, button.list-group-item-warning.active[_ngcontent-%COMP%]:focus {\n  color: #fff;\n  background-color: #8a6d3b;\n  border-color: #8a6d3b;\n}\n.list-group-item-danger[_ngcontent-%COMP%] {\n  color: #a94442;\n  background-color: #f2dede;\n}\na.list-group-item-danger[_ngcontent-%COMP%], button.list-group-item-danger[_ngcontent-%COMP%] {\n  color: #a94442;\n}\na.list-group-item-danger[_ngcontent-%COMP%]   .list-group-item-heading[_ngcontent-%COMP%], button.list-group-item-danger[_ngcontent-%COMP%]   .list-group-item-heading[_ngcontent-%COMP%] {\n  color: inherit;\n}\na.list-group-item-danger[_ngcontent-%COMP%]:hover, button.list-group-item-danger[_ngcontent-%COMP%]:hover, a.list-group-item-danger[_ngcontent-%COMP%]:focus, button.list-group-item-danger[_ngcontent-%COMP%]:focus {\n  color: #a94442;\n  background-color: #ebcccc;\n}\na.list-group-item-danger.active[_ngcontent-%COMP%], button.list-group-item-danger.active[_ngcontent-%COMP%], a.list-group-item-danger.active[_ngcontent-%COMP%]:hover, button.list-group-item-danger.active[_ngcontent-%COMP%]:hover, a.list-group-item-danger.active[_ngcontent-%COMP%]:focus, button.list-group-item-danger.active[_ngcontent-%COMP%]:focus {\n  color: #fff;\n  background-color: #a94442;\n  border-color: #a94442;\n}\n.list-group-item-heading[_ngcontent-%COMP%] {\n  margin-top: 0;\n  margin-bottom: 5px;\n}\n.list-group-item-text[_ngcontent-%COMP%] {\n  margin-bottom: 0;\n  line-height: 1.3;\n}\n.panel[_ngcontent-%COMP%] {\n  margin-bottom: 20px;\n  background-color: #fff;\n  border: 1px solid transparent;\n  border-radius: 4px;\n  -webkit-box-shadow: 0 1px 1px rgba(0, 0, 0, .05);\n          box-shadow: 0 1px 1px rgba(0, 0, 0, .05);\n}\n.panel-body[_ngcontent-%COMP%] {\n  padding: 15px;\n}\n.panel-heading[_ngcontent-%COMP%] {\n  padding: 10px 15px;\n  border-bottom: 1px solid transparent;\n  border-top-left-radius: 3px;\n  border-top-right-radius: 3px;\n}\n.panel-heading[_ngcontent-%COMP%]    > .dropdown[_ngcontent-%COMP%]   .dropdown-toggle[_ngcontent-%COMP%] {\n  color: inherit;\n}\n.panel-title[_ngcontent-%COMP%] {\n  margin-top: 0;\n  margin-bottom: 0;\n  font-size: 16px;\n  color: inherit;\n}\n.panel-title[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%], .panel-title[_ngcontent-%COMP%]    > small[_ngcontent-%COMP%], .panel-title[_ngcontent-%COMP%]    > .small[_ngcontent-%COMP%], .panel-title[_ngcontent-%COMP%]    > small[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%], .panel-title[_ngcontent-%COMP%]    > .small[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%] {\n  color: inherit;\n}\n.panel-footer[_ngcontent-%COMP%] {\n  padding: 10px 15px;\n  background-color: #f5f5f5;\n  border-top: 1px solid #ddd;\n  border-bottom-right-radius: 3px;\n  border-bottom-left-radius: 3px;\n}\n.panel[_ngcontent-%COMP%]    > .list-group[_ngcontent-%COMP%], .panel[_ngcontent-%COMP%]    > .panel-collapse[_ngcontent-%COMP%]    > .list-group[_ngcontent-%COMP%] {\n  margin-bottom: 0;\n}\n.panel[_ngcontent-%COMP%]    > .list-group[_ngcontent-%COMP%]   .list-group-item[_ngcontent-%COMP%], .panel[_ngcontent-%COMP%]    > .panel-collapse[_ngcontent-%COMP%]    > .list-group[_ngcontent-%COMP%]   .list-group-item[_ngcontent-%COMP%] {\n  border-width: 1px 0;\n  border-radius: 0;\n}\n.panel[_ngcontent-%COMP%]    > .list-group[_ngcontent-%COMP%]:first-child   .list-group-item[_ngcontent-%COMP%]:first-child, .panel[_ngcontent-%COMP%]    > .panel-collapse[_ngcontent-%COMP%]    > .list-group[_ngcontent-%COMP%]:first-child   .list-group-item[_ngcontent-%COMP%]:first-child {\n  border-top: 0;\n  border-top-left-radius: 3px;\n  border-top-right-radius: 3px;\n}\n.panel[_ngcontent-%COMP%]    > .list-group[_ngcontent-%COMP%]:last-child   .list-group-item[_ngcontent-%COMP%]:last-child, .panel[_ngcontent-%COMP%]    > .panel-collapse[_ngcontent-%COMP%]    > .list-group[_ngcontent-%COMP%]:last-child   .list-group-item[_ngcontent-%COMP%]:last-child {\n  border-bottom: 0;\n  border-bottom-right-radius: 3px;\n  border-bottom-left-radius: 3px;\n}\n.panel[_ngcontent-%COMP%]    > .panel-heading[_ngcontent-%COMP%]    + .panel-collapse[_ngcontent-%COMP%]    > .list-group[_ngcontent-%COMP%]   .list-group-item[_ngcontent-%COMP%]:first-child {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n.panel-heading[_ngcontent-%COMP%]    + .list-group[_ngcontent-%COMP%]   .list-group-item[_ngcontent-%COMP%]:first-child {\n  border-top-width: 0;\n}\n.list-group[_ngcontent-%COMP%]    + .panel-footer[_ngcontent-%COMP%] {\n  border-top-width: 0;\n}\n.panel[_ngcontent-%COMP%]    > .table[_ngcontent-%COMP%], .panel[_ngcontent-%COMP%]    > .table-responsive[_ngcontent-%COMP%]    > .table[_ngcontent-%COMP%], .panel[_ngcontent-%COMP%]    > .panel-collapse[_ngcontent-%COMP%]    > .table[_ngcontent-%COMP%] {\n  margin-bottom: 0;\n}\n.panel[_ngcontent-%COMP%]    > .table[_ngcontent-%COMP%]   caption[_ngcontent-%COMP%], .panel[_ngcontent-%COMP%]    > .table-responsive[_ngcontent-%COMP%]    > .table[_ngcontent-%COMP%]   caption[_ngcontent-%COMP%], .panel[_ngcontent-%COMP%]    > .panel-collapse[_ngcontent-%COMP%]    > .table[_ngcontent-%COMP%]   caption[_ngcontent-%COMP%] {\n  padding-right: 15px;\n  padding-left: 15px;\n}\n.panel[_ngcontent-%COMP%]    > .table[_ngcontent-%COMP%]:first-child, .panel[_ngcontent-%COMP%]    > .table-responsive[_ngcontent-%COMP%]:first-child    > .table[_ngcontent-%COMP%]:first-child {\n  border-top-left-radius: 3px;\n  border-top-right-radius: 3px;\n}\n.panel[_ngcontent-%COMP%]    > .table[_ngcontent-%COMP%]:first-child    > thead[_ngcontent-%COMP%]:first-child    > tr[_ngcontent-%COMP%]:first-child, .panel[_ngcontent-%COMP%]    > .table-responsive[_ngcontent-%COMP%]:first-child    > .table[_ngcontent-%COMP%]:first-child    > thead[_ngcontent-%COMP%]:first-child    > tr[_ngcontent-%COMP%]:first-child, .panel[_ngcontent-%COMP%]    > .table[_ngcontent-%COMP%]:first-child    > tbody[_ngcontent-%COMP%]:first-child    > tr[_ngcontent-%COMP%]:first-child, .panel[_ngcontent-%COMP%]    > .table-responsive[_ngcontent-%COMP%]:first-child    > .table[_ngcontent-%COMP%]:first-child    > tbody[_ngcontent-%COMP%]:first-child    > tr[_ngcontent-%COMP%]:first-child {\n  border-top-left-radius: 3px;\n  border-top-right-radius: 3px;\n}\n.panel[_ngcontent-%COMP%]    > .table[_ngcontent-%COMP%]:first-child    > thead[_ngcontent-%COMP%]:first-child    > tr[_ngcontent-%COMP%]:first-child   td[_ngcontent-%COMP%]:first-child, .panel[_ngcontent-%COMP%]    > .table-responsive[_ngcontent-%COMP%]:first-child    > .table[_ngcontent-%COMP%]:first-child    > thead[_ngcontent-%COMP%]:first-child    > tr[_ngcontent-%COMP%]:first-child   td[_ngcontent-%COMP%]:first-child, .panel[_ngcontent-%COMP%]    > .table[_ngcontent-%COMP%]:first-child    > tbody[_ngcontent-%COMP%]:first-child    > tr[_ngcontent-%COMP%]:first-child   td[_ngcontent-%COMP%]:first-child, .panel[_ngcontent-%COMP%]    > .table-responsive[_ngcontent-%COMP%]:first-child    > .table[_ngcontent-%COMP%]:first-child    > tbody[_ngcontent-%COMP%]:first-child    > tr[_ngcontent-%COMP%]:first-child   td[_ngcontent-%COMP%]:first-child, .panel[_ngcontent-%COMP%]    > .table[_ngcontent-%COMP%]:first-child    > thead[_ngcontent-%COMP%]:first-child    > tr[_ngcontent-%COMP%]:first-child   th[_ngcontent-%COMP%]:first-child, .panel[_ngcontent-%COMP%]    > .table-responsive[_ngcontent-%COMP%]:first-child    > .table[_ngcontent-%COMP%]:first-child    > thead[_ngcontent-%COMP%]:first-child    > tr[_ngcontent-%COMP%]:first-child   th[_ngcontent-%COMP%]:first-child, .panel[_ngcontent-%COMP%]    > .table[_ngcontent-%COMP%]:first-child    > tbody[_ngcontent-%COMP%]:first-child    > tr[_ngcontent-%COMP%]:first-child   th[_ngcontent-%COMP%]:first-child, .panel[_ngcontent-%COMP%]    > .table-responsive[_ngcontent-%COMP%]:first-child    > .table[_ngcontent-%COMP%]:first-child    > tbody[_ngcontent-%COMP%]:first-child    > tr[_ngcontent-%COMP%]:first-child   th[_ngcontent-%COMP%]:first-child {\n  border-top-left-radius: 3px;\n}\n.panel[_ngcontent-%COMP%]    > .table[_ngcontent-%COMP%]:first-child    > thead[_ngcontent-%COMP%]:first-child    > tr[_ngcontent-%COMP%]:first-child   td[_ngcontent-%COMP%]:last-child, .panel[_ngcontent-%COMP%]    > .table-responsive[_ngcontent-%COMP%]:first-child    > .table[_ngcontent-%COMP%]:first-child    > thead[_ngcontent-%COMP%]:first-child    > tr[_ngcontent-%COMP%]:first-child   td[_ngcontent-%COMP%]:last-child, .panel[_ngcontent-%COMP%]    > .table[_ngcontent-%COMP%]:first-child    > tbody[_ngcontent-%COMP%]:first-child    > tr[_ngcontent-%COMP%]:first-child   td[_ngcontent-%COMP%]:last-child, .panel[_ngcontent-%COMP%]    > .table-responsive[_ngcontent-%COMP%]:first-child    > .table[_ngcontent-%COMP%]:first-child    > tbody[_ngcontent-%COMP%]:first-child    > tr[_ngcontent-%COMP%]:first-child   td[_ngcontent-%COMP%]:last-child, .panel[_ngcontent-%COMP%]    > .table[_ngcontent-%COMP%]:first-child    > thead[_ngcontent-%COMP%]:first-child    > tr[_ngcontent-%COMP%]:first-child   th[_ngcontent-%COMP%]:last-child, .panel[_ngcontent-%COMP%]    > .table-responsive[_ngcontent-%COMP%]:first-child    > .table[_ngcontent-%COMP%]:first-child    > thead[_ngcontent-%COMP%]:first-child    > tr[_ngcontent-%COMP%]:first-child   th[_ngcontent-%COMP%]:last-child, .panel[_ngcontent-%COMP%]    > .table[_ngcontent-%COMP%]:first-child    > tbody[_ngcontent-%COMP%]:first-child    > tr[_ngcontent-%COMP%]:first-child   th[_ngcontent-%COMP%]:last-child, .panel[_ngcontent-%COMP%]    > .table-responsive[_ngcontent-%COMP%]:first-child    > .table[_ngcontent-%COMP%]:first-child    > tbody[_ngcontent-%COMP%]:first-child    > tr[_ngcontent-%COMP%]:first-child   th[_ngcontent-%COMP%]:last-child {\n  border-top-right-radius: 3px;\n}\n.panel[_ngcontent-%COMP%]    > .table[_ngcontent-%COMP%]:last-child, .panel[_ngcontent-%COMP%]    > .table-responsive[_ngcontent-%COMP%]:last-child    > .table[_ngcontent-%COMP%]:last-child {\n  border-bottom-right-radius: 3px;\n  border-bottom-left-radius: 3px;\n}\n.panel[_ngcontent-%COMP%]    > .table[_ngcontent-%COMP%]:last-child    > tbody[_ngcontent-%COMP%]:last-child    > tr[_ngcontent-%COMP%]:last-child, .panel[_ngcontent-%COMP%]    > .table-responsive[_ngcontent-%COMP%]:last-child    > .table[_ngcontent-%COMP%]:last-child    > tbody[_ngcontent-%COMP%]:last-child    > tr[_ngcontent-%COMP%]:last-child, .panel[_ngcontent-%COMP%]    > .table[_ngcontent-%COMP%]:last-child    > tfoot[_ngcontent-%COMP%]:last-child    > tr[_ngcontent-%COMP%]:last-child, .panel[_ngcontent-%COMP%]    > .table-responsive[_ngcontent-%COMP%]:last-child    > .table[_ngcontent-%COMP%]:last-child    > tfoot[_ngcontent-%COMP%]:last-child    > tr[_ngcontent-%COMP%]:last-child {\n  border-bottom-right-radius: 3px;\n  border-bottom-left-radius: 3px;\n}\n.panel[_ngcontent-%COMP%]    > .table[_ngcontent-%COMP%]:last-child    > tbody[_ngcontent-%COMP%]:last-child    > tr[_ngcontent-%COMP%]:last-child   td[_ngcontent-%COMP%]:first-child, .panel[_ngcontent-%COMP%]    > .table-responsive[_ngcontent-%COMP%]:last-child    > .table[_ngcontent-%COMP%]:last-child    > tbody[_ngcontent-%COMP%]:last-child    > tr[_ngcontent-%COMP%]:last-child   td[_ngcontent-%COMP%]:first-child, .panel[_ngcontent-%COMP%]    > .table[_ngcontent-%COMP%]:last-child    > tfoot[_ngcontent-%COMP%]:last-child    > tr[_ngcontent-%COMP%]:last-child   td[_ngcontent-%COMP%]:first-child, .panel[_ngcontent-%COMP%]    > .table-responsive[_ngcontent-%COMP%]:last-child    > .table[_ngcontent-%COMP%]:last-child    > tfoot[_ngcontent-%COMP%]:last-child    > tr[_ngcontent-%COMP%]:last-child   td[_ngcontent-%COMP%]:first-child, .panel[_ngcontent-%COMP%]    > .table[_ngcontent-%COMP%]:last-child    > tbody[_ngcontent-%COMP%]:last-child    > tr[_ngcontent-%COMP%]:last-child   th[_ngcontent-%COMP%]:first-child, .panel[_ngcontent-%COMP%]    > .table-responsive[_ngcontent-%COMP%]:last-child    > .table[_ngcontent-%COMP%]:last-child    > tbody[_ngcontent-%COMP%]:last-child    > tr[_ngcontent-%COMP%]:last-child   th[_ngcontent-%COMP%]:first-child, .panel[_ngcontent-%COMP%]    > .table[_ngcontent-%COMP%]:last-child    > tfoot[_ngcontent-%COMP%]:last-child    > tr[_ngcontent-%COMP%]:last-child   th[_ngcontent-%COMP%]:first-child, .panel[_ngcontent-%COMP%]    > .table-responsive[_ngcontent-%COMP%]:last-child    > .table[_ngcontent-%COMP%]:last-child    > tfoot[_ngcontent-%COMP%]:last-child    > tr[_ngcontent-%COMP%]:last-child   th[_ngcontent-%COMP%]:first-child {\n  border-bottom-left-radius: 3px;\n}\n.panel[_ngcontent-%COMP%]    > .table[_ngcontent-%COMP%]:last-child    > tbody[_ngcontent-%COMP%]:last-child    > tr[_ngcontent-%COMP%]:last-child   td[_ngcontent-%COMP%]:last-child, .panel[_ngcontent-%COMP%]    > .table-responsive[_ngcontent-%COMP%]:last-child    > .table[_ngcontent-%COMP%]:last-child    > tbody[_ngcontent-%COMP%]:last-child    > tr[_ngcontent-%COMP%]:last-child   td[_ngcontent-%COMP%]:last-child, .panel[_ngcontent-%COMP%]    > .table[_ngcontent-%COMP%]:last-child    > tfoot[_ngcontent-%COMP%]:last-child    > tr[_ngcontent-%COMP%]:last-child   td[_ngcontent-%COMP%]:last-child, .panel[_ngcontent-%COMP%]    > .table-responsive[_ngcontent-%COMP%]:last-child    > .table[_ngcontent-%COMP%]:last-child    > tfoot[_ngcontent-%COMP%]:last-child    > tr[_ngcontent-%COMP%]:last-child   td[_ngcontent-%COMP%]:last-child, .panel[_ngcontent-%COMP%]    > .table[_ngcontent-%COMP%]:last-child    > tbody[_ngcontent-%COMP%]:last-child    > tr[_ngcontent-%COMP%]:last-child   th[_ngcontent-%COMP%]:last-child, .panel[_ngcontent-%COMP%]    > .table-responsive[_ngcontent-%COMP%]:last-child    > .table[_ngcontent-%COMP%]:last-child    > tbody[_ngcontent-%COMP%]:last-child    > tr[_ngcontent-%COMP%]:last-child   th[_ngcontent-%COMP%]:last-child, .panel[_ngcontent-%COMP%]    > .table[_ngcontent-%COMP%]:last-child    > tfoot[_ngcontent-%COMP%]:last-child    > tr[_ngcontent-%COMP%]:last-child   th[_ngcontent-%COMP%]:last-child, .panel[_ngcontent-%COMP%]    > .table-responsive[_ngcontent-%COMP%]:last-child    > .table[_ngcontent-%COMP%]:last-child    > tfoot[_ngcontent-%COMP%]:last-child    > tr[_ngcontent-%COMP%]:last-child   th[_ngcontent-%COMP%]:last-child {\n  border-bottom-right-radius: 3px;\n}\n.panel[_ngcontent-%COMP%]    > .panel-body[_ngcontent-%COMP%]    + .table[_ngcontent-%COMP%], .panel[_ngcontent-%COMP%]    > .panel-body[_ngcontent-%COMP%]    + .table-responsive[_ngcontent-%COMP%], .panel[_ngcontent-%COMP%]    > .table[_ngcontent-%COMP%]    + .panel-body[_ngcontent-%COMP%], .panel[_ngcontent-%COMP%]    > .table-responsive[_ngcontent-%COMP%]    + .panel-body[_ngcontent-%COMP%] {\n  border-top: 1px solid #ddd;\n}\n.panel[_ngcontent-%COMP%]    > .table[_ngcontent-%COMP%]    > tbody[_ngcontent-%COMP%]:first-child    > tr[_ngcontent-%COMP%]:first-child   th[_ngcontent-%COMP%], .panel[_ngcontent-%COMP%]    > .table[_ngcontent-%COMP%]    > tbody[_ngcontent-%COMP%]:first-child    > tr[_ngcontent-%COMP%]:first-child   td[_ngcontent-%COMP%] {\n  border-top: 0;\n}\n.panel[_ngcontent-%COMP%]    > .table-bordered[_ngcontent-%COMP%], .panel[_ngcontent-%COMP%]    > .table-responsive[_ngcontent-%COMP%]    > .table-bordered[_ngcontent-%COMP%] {\n  border: 0;\n}\n.panel[_ngcontent-%COMP%]    > .table-bordered[_ngcontent-%COMP%]    > thead[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]    > th[_ngcontent-%COMP%]:first-child, .panel[_ngcontent-%COMP%]    > .table-responsive[_ngcontent-%COMP%]    > .table-bordered[_ngcontent-%COMP%]    > thead[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]    > th[_ngcontent-%COMP%]:first-child, .panel[_ngcontent-%COMP%]    > .table-bordered[_ngcontent-%COMP%]    > tbody[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]    > th[_ngcontent-%COMP%]:first-child, .panel[_ngcontent-%COMP%]    > .table-responsive[_ngcontent-%COMP%]    > .table-bordered[_ngcontent-%COMP%]    > tbody[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]    > th[_ngcontent-%COMP%]:first-child, .panel[_ngcontent-%COMP%]    > .table-bordered[_ngcontent-%COMP%]    > tfoot[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]    > th[_ngcontent-%COMP%]:first-child, .panel[_ngcontent-%COMP%]    > .table-responsive[_ngcontent-%COMP%]    > .table-bordered[_ngcontent-%COMP%]    > tfoot[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]    > th[_ngcontent-%COMP%]:first-child, .panel[_ngcontent-%COMP%]    > .table-bordered[_ngcontent-%COMP%]    > thead[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]    > td[_ngcontent-%COMP%]:first-child, .panel[_ngcontent-%COMP%]    > .table-responsive[_ngcontent-%COMP%]    > .table-bordered[_ngcontent-%COMP%]    > thead[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]    > td[_ngcontent-%COMP%]:first-child, .panel[_ngcontent-%COMP%]    > .table-bordered[_ngcontent-%COMP%]    > tbody[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]    > td[_ngcontent-%COMP%]:first-child, .panel[_ngcontent-%COMP%]    > .table-responsive[_ngcontent-%COMP%]    > .table-bordered[_ngcontent-%COMP%]    > tbody[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]    > td[_ngcontent-%COMP%]:first-child, .panel[_ngcontent-%COMP%]    > .table-bordered[_ngcontent-%COMP%]    > tfoot[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]    > td[_ngcontent-%COMP%]:first-child, .panel[_ngcontent-%COMP%]    > .table-responsive[_ngcontent-%COMP%]    > .table-bordered[_ngcontent-%COMP%]    > tfoot[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]    > td[_ngcontent-%COMP%]:first-child {\n  border-left: 0;\n}\n.panel[_ngcontent-%COMP%]    > .table-bordered[_ngcontent-%COMP%]    > thead[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]    > th[_ngcontent-%COMP%]:last-child, .panel[_ngcontent-%COMP%]    > .table-responsive[_ngcontent-%COMP%]    > .table-bordered[_ngcontent-%COMP%]    > thead[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]    > th[_ngcontent-%COMP%]:last-child, .panel[_ngcontent-%COMP%]    > .table-bordered[_ngcontent-%COMP%]    > tbody[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]    > th[_ngcontent-%COMP%]:last-child, .panel[_ngcontent-%COMP%]    > .table-responsive[_ngcontent-%COMP%]    > .table-bordered[_ngcontent-%COMP%]    > tbody[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]    > th[_ngcontent-%COMP%]:last-child, .panel[_ngcontent-%COMP%]    > .table-bordered[_ngcontent-%COMP%]    > tfoot[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]    > th[_ngcontent-%COMP%]:last-child, .panel[_ngcontent-%COMP%]    > .table-responsive[_ngcontent-%COMP%]    > .table-bordered[_ngcontent-%COMP%]    > tfoot[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]    > th[_ngcontent-%COMP%]:last-child, .panel[_ngcontent-%COMP%]    > .table-bordered[_ngcontent-%COMP%]    > thead[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]    > td[_ngcontent-%COMP%]:last-child, .panel[_ngcontent-%COMP%]    > .table-responsive[_ngcontent-%COMP%]    > .table-bordered[_ngcontent-%COMP%]    > thead[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]    > td[_ngcontent-%COMP%]:last-child, .panel[_ngcontent-%COMP%]    > .table-bordered[_ngcontent-%COMP%]    > tbody[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]    > td[_ngcontent-%COMP%]:last-child, .panel[_ngcontent-%COMP%]    > .table-responsive[_ngcontent-%COMP%]    > .table-bordered[_ngcontent-%COMP%]    > tbody[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]    > td[_ngcontent-%COMP%]:last-child, .panel[_ngcontent-%COMP%]    > .table-bordered[_ngcontent-%COMP%]    > tfoot[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]    > td[_ngcontent-%COMP%]:last-child, .panel[_ngcontent-%COMP%]    > .table-responsive[_ngcontent-%COMP%]    > .table-bordered[_ngcontent-%COMP%]    > tfoot[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]    > td[_ngcontent-%COMP%]:last-child {\n  border-right: 0;\n}\n.panel[_ngcontent-%COMP%]    > .table-bordered[_ngcontent-%COMP%]    > thead[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]:first-child    > td[_ngcontent-%COMP%], .panel[_ngcontent-%COMP%]    > .table-responsive[_ngcontent-%COMP%]    > .table-bordered[_ngcontent-%COMP%]    > thead[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]:first-child    > td[_ngcontent-%COMP%], .panel[_ngcontent-%COMP%]    > .table-bordered[_ngcontent-%COMP%]    > tbody[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]:first-child    > td[_ngcontent-%COMP%], .panel[_ngcontent-%COMP%]    > .table-responsive[_ngcontent-%COMP%]    > .table-bordered[_ngcontent-%COMP%]    > tbody[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]:first-child    > td[_ngcontent-%COMP%], .panel[_ngcontent-%COMP%]    > .table-bordered[_ngcontent-%COMP%]    > thead[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]:first-child    > th[_ngcontent-%COMP%], .panel[_ngcontent-%COMP%]    > .table-responsive[_ngcontent-%COMP%]    > .table-bordered[_ngcontent-%COMP%]    > thead[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]:first-child    > th[_ngcontent-%COMP%], .panel[_ngcontent-%COMP%]    > .table-bordered[_ngcontent-%COMP%]    > tbody[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]:first-child    > th[_ngcontent-%COMP%], .panel[_ngcontent-%COMP%]    > .table-responsive[_ngcontent-%COMP%]    > .table-bordered[_ngcontent-%COMP%]    > tbody[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]:first-child    > th[_ngcontent-%COMP%] {\n  border-bottom: 0;\n}\n.panel[_ngcontent-%COMP%]    > .table-bordered[_ngcontent-%COMP%]    > tbody[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]:last-child    > td[_ngcontent-%COMP%], .panel[_ngcontent-%COMP%]    > .table-responsive[_ngcontent-%COMP%]    > .table-bordered[_ngcontent-%COMP%]    > tbody[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]:last-child    > td[_ngcontent-%COMP%], .panel[_ngcontent-%COMP%]    > .table-bordered[_ngcontent-%COMP%]    > tfoot[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]:last-child    > td[_ngcontent-%COMP%], .panel[_ngcontent-%COMP%]    > .table-responsive[_ngcontent-%COMP%]    > .table-bordered[_ngcontent-%COMP%]    > tfoot[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]:last-child    > td[_ngcontent-%COMP%], .panel[_ngcontent-%COMP%]    > .table-bordered[_ngcontent-%COMP%]    > tbody[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]:last-child    > th[_ngcontent-%COMP%], .panel[_ngcontent-%COMP%]    > .table-responsive[_ngcontent-%COMP%]    > .table-bordered[_ngcontent-%COMP%]    > tbody[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]:last-child    > th[_ngcontent-%COMP%], .panel[_ngcontent-%COMP%]    > .table-bordered[_ngcontent-%COMP%]    > tfoot[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]:last-child    > th[_ngcontent-%COMP%], .panel[_ngcontent-%COMP%]    > .table-responsive[_ngcontent-%COMP%]    > .table-bordered[_ngcontent-%COMP%]    > tfoot[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]:last-child    > th[_ngcontent-%COMP%] {\n  border-bottom: 0;\n}\n.panel[_ngcontent-%COMP%]    > .table-responsive[_ngcontent-%COMP%] {\n  margin-bottom: 0;\n  border: 0;\n}\n.panel-group[_ngcontent-%COMP%] {\n  margin-bottom: 20px;\n}\n.panel-group[_ngcontent-%COMP%]   .panel[_ngcontent-%COMP%] {\n  margin-bottom: 0;\n  border-radius: 4px;\n}\n.panel-group[_ngcontent-%COMP%]   .panel[_ngcontent-%COMP%]    + .panel[_ngcontent-%COMP%] {\n  margin-top: 5px;\n}\n.panel-group[_ngcontent-%COMP%]   .panel-heading[_ngcontent-%COMP%] {\n  border-bottom: 0;\n}\n.panel-group[_ngcontent-%COMP%]   .panel-heading[_ngcontent-%COMP%]    + .panel-collapse[_ngcontent-%COMP%]    > .panel-body[_ngcontent-%COMP%], .panel-group[_ngcontent-%COMP%]   .panel-heading[_ngcontent-%COMP%]    + .panel-collapse[_ngcontent-%COMP%]    > .list-group[_ngcontent-%COMP%] {\n  border-top: 1px solid #ddd;\n}\n.panel-group[_ngcontent-%COMP%]   .panel-footer[_ngcontent-%COMP%] {\n  border-top: 0;\n}\n.panel-group[_ngcontent-%COMP%]   .panel-footer[_ngcontent-%COMP%]    + .panel-collapse[_ngcontent-%COMP%]   .panel-body[_ngcontent-%COMP%] {\n  border-bottom: 1px solid #ddd;\n}\n.panel-default[_ngcontent-%COMP%] {\n  border-color: #ddd;\n}\n.panel-default[_ngcontent-%COMP%]    > .panel-heading[_ngcontent-%COMP%] {\n  color: #333;\n  background-color: #f5f5f5;\n  border-color: #ddd;\n}\n.panel-default[_ngcontent-%COMP%]    > .panel-heading[_ngcontent-%COMP%]    + .panel-collapse[_ngcontent-%COMP%]    > .panel-body[_ngcontent-%COMP%] {\n  border-top-color: #ddd;\n}\n.panel-default[_ngcontent-%COMP%]    > .panel-heading[_ngcontent-%COMP%]   .badge[_ngcontent-%COMP%] {\n  color: #f5f5f5;\n  background-color: #333;\n}\n.panel-default[_ngcontent-%COMP%]    > .panel-footer[_ngcontent-%COMP%]    + .panel-collapse[_ngcontent-%COMP%]    > .panel-body[_ngcontent-%COMP%] {\n  border-bottom-color: #ddd;\n}\n.panel-primary[_ngcontent-%COMP%] {\n  border-color: #337ab7;\n}\n.panel-primary[_ngcontent-%COMP%]    > .panel-heading[_ngcontent-%COMP%] {\n  color: #fff;\n  background-color: #337ab7;\n  border-color: #337ab7;\n}\n.panel-primary[_ngcontent-%COMP%]    > .panel-heading[_ngcontent-%COMP%]    + .panel-collapse[_ngcontent-%COMP%]    > .panel-body[_ngcontent-%COMP%] {\n  border-top-color: #337ab7;\n}\n.panel-primary[_ngcontent-%COMP%]    > .panel-heading[_ngcontent-%COMP%]   .badge[_ngcontent-%COMP%] {\n  color: #337ab7;\n  background-color: #fff;\n}\n.panel-primary[_ngcontent-%COMP%]    > .panel-footer[_ngcontent-%COMP%]    + .panel-collapse[_ngcontent-%COMP%]    > .panel-body[_ngcontent-%COMP%] {\n  border-bottom-color: #337ab7;\n}\n.panel-success[_ngcontent-%COMP%] {\n  border-color: #d6e9c6;\n}\n.panel-success[_ngcontent-%COMP%]    > .panel-heading[_ngcontent-%COMP%] {\n  color: #3c763d;\n  background-color: #dff0d8;\n  border-color: #d6e9c6;\n}\n.panel-success[_ngcontent-%COMP%]    > .panel-heading[_ngcontent-%COMP%]    + .panel-collapse[_ngcontent-%COMP%]    > .panel-body[_ngcontent-%COMP%] {\n  border-top-color: #d6e9c6;\n}\n.panel-success[_ngcontent-%COMP%]    > .panel-heading[_ngcontent-%COMP%]   .badge[_ngcontent-%COMP%] {\n  color: #dff0d8;\n  background-color: #3c763d;\n}\n.panel-success[_ngcontent-%COMP%]    > .panel-footer[_ngcontent-%COMP%]    + .panel-collapse[_ngcontent-%COMP%]    > .panel-body[_ngcontent-%COMP%] {\n  border-bottom-color: #d6e9c6;\n}\n.panel-info[_ngcontent-%COMP%] {\n  border-color: #bce8f1;\n}\n.panel-info[_ngcontent-%COMP%]    > .panel-heading[_ngcontent-%COMP%] {\n  color: #31708f;\n  background-color: #d9edf7;\n  border-color: #bce8f1;\n}\n.panel-info[_ngcontent-%COMP%]    > .panel-heading[_ngcontent-%COMP%]    + .panel-collapse[_ngcontent-%COMP%]    > .panel-body[_ngcontent-%COMP%] {\n  border-top-color: #bce8f1;\n}\n.panel-info[_ngcontent-%COMP%]    > .panel-heading[_ngcontent-%COMP%]   .badge[_ngcontent-%COMP%] {\n  color: #d9edf7;\n  background-color: #31708f;\n}\n.panel-info[_ngcontent-%COMP%]    > .panel-footer[_ngcontent-%COMP%]    + .panel-collapse[_ngcontent-%COMP%]    > .panel-body[_ngcontent-%COMP%] {\n  border-bottom-color: #bce8f1;\n}\n.panel-warning[_ngcontent-%COMP%] {\n  border-color: #faebcc;\n}\n.panel-warning[_ngcontent-%COMP%]    > .panel-heading[_ngcontent-%COMP%] {\n  color: #8a6d3b;\n  background-color: #fcf8e3;\n  border-color: #faebcc;\n}\n.panel-warning[_ngcontent-%COMP%]    > .panel-heading[_ngcontent-%COMP%]    + .panel-collapse[_ngcontent-%COMP%]    > .panel-body[_ngcontent-%COMP%] {\n  border-top-color: #faebcc;\n}\n.panel-warning[_ngcontent-%COMP%]    > .panel-heading[_ngcontent-%COMP%]   .badge[_ngcontent-%COMP%] {\n  color: #fcf8e3;\n  background-color: #8a6d3b;\n}\n.panel-warning[_ngcontent-%COMP%]    > .panel-footer[_ngcontent-%COMP%]    + .panel-collapse[_ngcontent-%COMP%]    > .panel-body[_ngcontent-%COMP%] {\n  border-bottom-color: #faebcc;\n}\n.panel-danger[_ngcontent-%COMP%] {\n  border-color: #ebccd1;\n}\n.panel-danger[_ngcontent-%COMP%]    > .panel-heading[_ngcontent-%COMP%] {\n  color: #a94442;\n  background-color: #f2dede;\n  border-color: #ebccd1;\n}\n.panel-danger[_ngcontent-%COMP%]    > .panel-heading[_ngcontent-%COMP%]    + .panel-collapse[_ngcontent-%COMP%]    > .panel-body[_ngcontent-%COMP%] {\n  border-top-color: #ebccd1;\n}\n.panel-danger[_ngcontent-%COMP%]    > .panel-heading[_ngcontent-%COMP%]   .badge[_ngcontent-%COMP%] {\n  color: #f2dede;\n  background-color: #a94442;\n}\n.panel-danger[_ngcontent-%COMP%]    > .panel-footer[_ngcontent-%COMP%]    + .panel-collapse[_ngcontent-%COMP%]    > .panel-body[_ngcontent-%COMP%] {\n  border-bottom-color: #ebccd1;\n}\n.embed-responsive[_ngcontent-%COMP%] {\n  position: relative;\n  display: block;\n  height: 0;\n  padding: 0;\n  overflow: hidden;\n}\n.embed-responsive[_ngcontent-%COMP%]   .embed-responsive-item[_ngcontent-%COMP%], .embed-responsive[_ngcontent-%COMP%]   iframe[_ngcontent-%COMP%], .embed-responsive[_ngcontent-%COMP%]   embed[_ngcontent-%COMP%], .embed-responsive[_ngcontent-%COMP%]   object[_ngcontent-%COMP%], .embed-responsive[_ngcontent-%COMP%]   video[_ngcontent-%COMP%] {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  border: 0;\n}\n.embed-responsive-16by9[_ngcontent-%COMP%] {\n  padding-bottom: 56.25%;\n}\n.embed-responsive-4by3[_ngcontent-%COMP%] {\n  padding-bottom: 75%;\n}\n.well[_ngcontent-%COMP%] {\n  min-height: 20px;\n  padding: 19px;\n  margin-bottom: 20px;\n  background-color: #f5f5f5;\n  border: 1px solid #e3e3e3;\n  border-radius: 4px;\n  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, .05);\n          box-shadow: inset 0 1px 1px rgba(0, 0, 0, .05);\n}\n.well[_ngcontent-%COMP%]   blockquote[_ngcontent-%COMP%] {\n  border-color: #ddd;\n  border-color: rgba(0, 0, 0, .15);\n}\n.well-lg[_ngcontent-%COMP%] {\n  padding: 24px;\n  border-radius: 6px;\n}\n.well-sm[_ngcontent-%COMP%] {\n  padding: 9px;\n  border-radius: 3px;\n}\n.close[_ngcontent-%COMP%] {\n  float: right;\n  font-size: 21px;\n  font-weight: bold;\n  line-height: 1;\n  color: #000;\n  text-shadow: 0 1px 0 #fff;\n  filter: alpha(opacity=20);\n  opacity: .2;\n}\n.close[_ngcontent-%COMP%]:hover, .close[_ngcontent-%COMP%]:focus {\n  color: #000;\n  text-decoration: none;\n  cursor: pointer;\n  filter: alpha(opacity=50);\n  opacity: .5;\n}\nbutton.close[_ngcontent-%COMP%] {\n  -webkit-appearance: none;\n  padding: 0;\n  cursor: pointer;\n  background: transparent;\n  border: 0;\n}\n.modal-open[_ngcontent-%COMP%] {\n  overflow: hidden;\n}\n.modal[_ngcontent-%COMP%] {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1050;\n  display: none;\n  overflow: hidden;\n  -webkit-overflow-scrolling: touch;\n  outline: 0;\n}\n.modal.fade[_ngcontent-%COMP%]   .modal-dialog[_ngcontent-%COMP%] {\n  -webkit-transition: -webkit-transform .3s ease-out;\n       -o-transition:      -o-transform .3s ease-out;\n          transition:         transform .3s ease-out;\n  -webkit-transform: translate(0, -25%);\n      -ms-transform: translate(0, -25%);\n       -o-transform: translate(0, -25%);\n          transform: translate(0, -25%);\n}\n.modal.in[_ngcontent-%COMP%]   .modal-dialog[_ngcontent-%COMP%] {\n  -webkit-transform: translate(0, 0);\n      -ms-transform: translate(0, 0);\n       -o-transform: translate(0, 0);\n          transform: translate(0, 0);\n}\n.modal-open[_ngcontent-%COMP%]   .modal[_ngcontent-%COMP%] {\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n.modal-dialog[_ngcontent-%COMP%] {\n  position: relative;\n  width: auto;\n  margin: 10px;\n}\n.modal-content[_ngcontent-%COMP%] {\n  position: relative;\n  background-color: #fff;\n  -webkit-background-clip: padding-box;\n          background-clip: padding-box;\n  border: 1px solid #999;\n  border: 1px solid rgba(0, 0, 0, .2);\n  border-radius: 6px;\n  outline: 0;\n  -webkit-box-shadow: 0 3px 9px rgba(0, 0, 0, .5);\n          box-shadow: 0 3px 9px rgba(0, 0, 0, .5);\n}\n.modal-backdrop[_ngcontent-%COMP%] {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1040;\n  background-color: #000;\n}\n.modal-backdrop.fade[_ngcontent-%COMP%] {\n  filter: alpha(opacity=0);\n  opacity: 0;\n}\n.modal-backdrop.in[_ngcontent-%COMP%] {\n  filter: alpha(opacity=50);\n  opacity: .5;\n}\n.modal-header[_ngcontent-%COMP%] {\n  padding: 15px;\n  border-bottom: 1px solid #e5e5e5;\n}\n.modal-header[_ngcontent-%COMP%]   .close[_ngcontent-%COMP%] {\n  margin-top: -2px;\n}\n.modal-title[_ngcontent-%COMP%] {\n  margin: 0;\n  line-height: 1.42857143;\n}\n.modal-body[_ngcontent-%COMP%] {\n  position: relative;\n  padding: 15px;\n}\n.modal-footer[_ngcontent-%COMP%] {\n  padding: 15px;\n  text-align: right;\n  border-top: 1px solid #e5e5e5;\n}\n.modal-footer[_ngcontent-%COMP%]   .btn[_ngcontent-%COMP%]    + .btn[_ngcontent-%COMP%] {\n  margin-bottom: 0;\n  margin-left: 5px;\n}\n.modal-footer[_ngcontent-%COMP%]   .btn-group[_ngcontent-%COMP%]   .btn[_ngcontent-%COMP%]    + .btn[_ngcontent-%COMP%] {\n  margin-left: -1px;\n}\n.modal-footer[_ngcontent-%COMP%]   .btn-block[_ngcontent-%COMP%]    + .btn-block[_ngcontent-%COMP%] {\n  margin-left: 0;\n}\n.modal-scrollbar-measure[_ngcontent-%COMP%] {\n  position: absolute;\n  top: -9999px;\n  width: 50px;\n  height: 50px;\n  overflow: scroll;\n}\n@media (min-width: 768px) {\n  .modal-dialog[_ngcontent-%COMP%] {\n    width: 600px;\n    margin: 30px auto;\n  }\n  .modal-content[_ngcontent-%COMP%] {\n    -webkit-box-shadow: 0 5px 15px rgba(0, 0, 0, .5);\n            box-shadow: 0 5px 15px rgba(0, 0, 0, .5);\n  }\n  .modal-sm[_ngcontent-%COMP%] {\n    width: 300px;\n  }\n}\n@media (min-width: 992px) {\n  .modal-lg[_ngcontent-%COMP%] {\n    width: 900px;\n  }\n}\n.tooltip[_ngcontent-%COMP%] {\n  position: absolute;\n  z-index: 1070;\n  display: block;\n  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: normal;\n  line-height: 1.42857143;\n  text-align: left;\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  word-spacing: normal;\n  word-wrap: normal;\n  white-space: normal;\n  filter: alpha(opacity=0);\n  opacity: 0;\n\n  line-break: auto;\n}\n.tooltip.in[_ngcontent-%COMP%] {\n  filter: alpha(opacity=90);\n  opacity: .9;\n}\n.tooltip.top[_ngcontent-%COMP%] {\n  padding: 5px 0;\n  margin-top: -3px;\n}\n.tooltip.right[_ngcontent-%COMP%] {\n  padding: 0 5px;\n  margin-left: 3px;\n}\n.tooltip.bottom[_ngcontent-%COMP%] {\n  padding: 5px 0;\n  margin-top: 3px;\n}\n.tooltip.left[_ngcontent-%COMP%] {\n  padding: 0 5px;\n  margin-left: -3px;\n}\n.tooltip-inner[_ngcontent-%COMP%] {\n  max-width: 200px;\n  padding: 3px 8px;\n  color: #fff;\n  text-align: center;\n  background-color: #000;\n  border-radius: 4px;\n}\n.tooltip-arrow[_ngcontent-%COMP%] {\n  position: absolute;\n  width: 0;\n  height: 0;\n  border-color: transparent;\n  border-style: solid;\n}\n.tooltip.top[_ngcontent-%COMP%]   .tooltip-arrow[_ngcontent-%COMP%] {\n  bottom: 0;\n  left: 50%;\n  margin-left: -5px;\n  border-width: 5px 5px 0;\n  border-top-color: #000;\n}\n.tooltip.top-left[_ngcontent-%COMP%]   .tooltip-arrow[_ngcontent-%COMP%] {\n  right: 5px;\n  bottom: 0;\n  margin-bottom: -5px;\n  border-width: 5px 5px 0;\n  border-top-color: #000;\n}\n.tooltip.top-right[_ngcontent-%COMP%]   .tooltip-arrow[_ngcontent-%COMP%] {\n  bottom: 0;\n  left: 5px;\n  margin-bottom: -5px;\n  border-width: 5px 5px 0;\n  border-top-color: #000;\n}\n.tooltip.right[_ngcontent-%COMP%]   .tooltip-arrow[_ngcontent-%COMP%] {\n  top: 50%;\n  left: 0;\n  margin-top: -5px;\n  border-width: 5px 5px 5px 0;\n  border-right-color: #000;\n}\n.tooltip.left[_ngcontent-%COMP%]   .tooltip-arrow[_ngcontent-%COMP%] {\n  top: 50%;\n  right: 0;\n  margin-top: -5px;\n  border-width: 5px 0 5px 5px;\n  border-left-color: #000;\n}\n.tooltip.bottom[_ngcontent-%COMP%]   .tooltip-arrow[_ngcontent-%COMP%] {\n  top: 0;\n  left: 50%;\n  margin-left: -5px;\n  border-width: 0 5px 5px;\n  border-bottom-color: #000;\n}\n.tooltip.bottom-left[_ngcontent-%COMP%]   .tooltip-arrow[_ngcontent-%COMP%] {\n  top: 0;\n  right: 5px;\n  margin-top: -5px;\n  border-width: 0 5px 5px;\n  border-bottom-color: #000;\n}\n.tooltip.bottom-right[_ngcontent-%COMP%]   .tooltip-arrow[_ngcontent-%COMP%] {\n  top: 0;\n  left: 5px;\n  margin-top: -5px;\n  border-width: 0 5px 5px;\n  border-bottom-color: #000;\n}\n.popover[_ngcontent-%COMP%] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 1060;\n  display: none;\n  max-width: 276px;\n  padding: 1px;\n  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: normal;\n  line-height: 1.42857143;\n  text-align: left;\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  word-spacing: normal;\n  word-wrap: normal;\n  white-space: normal;\n  background-color: #fff;\n  -webkit-background-clip: padding-box;\n          background-clip: padding-box;\n  border: 1px solid #ccc;\n  border: 1px solid rgba(0, 0, 0, .2);\n  border-radius: 6px;\n  -webkit-box-shadow: 0 5px 10px rgba(0, 0, 0, .2);\n          box-shadow: 0 5px 10px rgba(0, 0, 0, .2);\n\n  line-break: auto;\n}\n.popover.top[_ngcontent-%COMP%] {\n  margin-top: -10px;\n}\n.popover.right[_ngcontent-%COMP%] {\n  margin-left: 10px;\n}\n.popover.bottom[_ngcontent-%COMP%] {\n  margin-top: 10px;\n}\n.popover.left[_ngcontent-%COMP%] {\n  margin-left: -10px;\n}\n.popover-title[_ngcontent-%COMP%] {\n  padding: 8px 14px;\n  margin: 0;\n  font-size: 14px;\n  background-color: #f7f7f7;\n  border-bottom: 1px solid #ebebeb;\n  border-radius: 5px 5px 0 0;\n}\n.popover-content[_ngcontent-%COMP%] {\n  padding: 9px 14px;\n}\n.popover[_ngcontent-%COMP%]    > .arrow[_ngcontent-%COMP%], .popover[_ngcontent-%COMP%]    > .arrow[_ngcontent-%COMP%]:after {\n  position: absolute;\n  display: block;\n  width: 0;\n  height: 0;\n  border-color: transparent;\n  border-style: solid;\n}\n.popover[_ngcontent-%COMP%]    > .arrow[_ngcontent-%COMP%] {\n  border-width: 11px;\n}\n.popover[_ngcontent-%COMP%]    > .arrow[_ngcontent-%COMP%]:after {\n  content: "";\n  border-width: 10px;\n}\n.popover.top[_ngcontent-%COMP%]    > .arrow[_ngcontent-%COMP%] {\n  bottom: -11px;\n  left: 50%;\n  margin-left: -11px;\n  border-top-color: #999;\n  border-top-color: rgba(0, 0, 0, .25);\n  border-bottom-width: 0;\n}\n.popover.top[_ngcontent-%COMP%]    > .arrow[_ngcontent-%COMP%]:after {\n  bottom: 1px;\n  margin-left: -10px;\n  content: " ";\n  border-top-color: #fff;\n  border-bottom-width: 0;\n}\n.popover.right[_ngcontent-%COMP%]    > .arrow[_ngcontent-%COMP%] {\n  top: 50%;\n  left: -11px;\n  margin-top: -11px;\n  border-right-color: #999;\n  border-right-color: rgba(0, 0, 0, .25);\n  border-left-width: 0;\n}\n.popover.right[_ngcontent-%COMP%]    > .arrow[_ngcontent-%COMP%]:after {\n  bottom: -10px;\n  left: 1px;\n  content: " ";\n  border-right-color: #fff;\n  border-left-width: 0;\n}\n.popover.bottom[_ngcontent-%COMP%]    > .arrow[_ngcontent-%COMP%] {\n  top: -11px;\n  left: 50%;\n  margin-left: -11px;\n  border-top-width: 0;\n  border-bottom-color: #999;\n  border-bottom-color: rgba(0, 0, 0, .25);\n}\n.popover.bottom[_ngcontent-%COMP%]    > .arrow[_ngcontent-%COMP%]:after {\n  top: 1px;\n  margin-left: -10px;\n  content: " ";\n  border-top-width: 0;\n  border-bottom-color: #fff;\n}\n.popover.left[_ngcontent-%COMP%]    > .arrow[_ngcontent-%COMP%] {\n  top: 50%;\n  right: -11px;\n  margin-top: -11px;\n  border-right-width: 0;\n  border-left-color: #999;\n  border-left-color: rgba(0, 0, 0, .25);\n}\n.popover.left[_ngcontent-%COMP%]    > .arrow[_ngcontent-%COMP%]:after {\n  right: 1px;\n  bottom: -10px;\n  content: " ";\n  border-right-width: 0;\n  border-left-color: #fff;\n}\n.carousel[_ngcontent-%COMP%] {\n  position: relative;\n}\n.carousel-inner[_ngcontent-%COMP%] {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n}\n.carousel-inner[_ngcontent-%COMP%]    > .item[_ngcontent-%COMP%] {\n  position: relative;\n  display: none;\n  -webkit-transition: .6s ease-in-out left;\n       -o-transition: .6s ease-in-out left;\n          transition: .6s ease-in-out left;\n}\n.carousel-inner[_ngcontent-%COMP%]    > .item[_ngcontent-%COMP%]    > img[_ngcontent-%COMP%], .carousel-inner[_ngcontent-%COMP%]    > .item[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%]    > img[_ngcontent-%COMP%] {\n  line-height: 1;\n}\n@media all and (transform-3d), (-webkit-transform-3d) {\n  .carousel-inner[_ngcontent-%COMP%]    > .item[_ngcontent-%COMP%] {\n    -webkit-transition: -webkit-transform .6s ease-in-out;\n         -o-transition:      -o-transform .6s ease-in-out;\n            transition:         transform .6s ease-in-out;\n\n    -webkit-backface-visibility: hidden;\n            backface-visibility: hidden;\n    -webkit-perspective: 1000px;\n            perspective: 1000px;\n  }\n  .carousel-inner[_ngcontent-%COMP%]    > .item.next[_ngcontent-%COMP%], .carousel-inner[_ngcontent-%COMP%]    > .item.active.right[_ngcontent-%COMP%] {\n    left: 0;\n    -webkit-transform: translate3d(100%, 0, 0);\n            transform: translate3d(100%, 0, 0);\n  }\n  .carousel-inner[_ngcontent-%COMP%]    > .item.prev[_ngcontent-%COMP%], .carousel-inner[_ngcontent-%COMP%]    > .item.active.left[_ngcontent-%COMP%] {\n    left: 0;\n    -webkit-transform: translate3d(-100%, 0, 0);\n            transform: translate3d(-100%, 0, 0);\n  }\n  .carousel-inner[_ngcontent-%COMP%]    > .item.next.left[_ngcontent-%COMP%], .carousel-inner[_ngcontent-%COMP%]    > .item.prev.right[_ngcontent-%COMP%], .carousel-inner[_ngcontent-%COMP%]    > .item.active[_ngcontent-%COMP%] {\n    left: 0;\n    -webkit-transform: translate3d(0, 0, 0);\n            transform: translate3d(0, 0, 0);\n  }\n}\n.carousel-inner[_ngcontent-%COMP%]    > .active[_ngcontent-%COMP%], .carousel-inner[_ngcontent-%COMP%]    > .next[_ngcontent-%COMP%], .carousel-inner[_ngcontent-%COMP%]    > .prev[_ngcontent-%COMP%] {\n  display: block;\n}\n.carousel-inner[_ngcontent-%COMP%]    > .active[_ngcontent-%COMP%] {\n  left: 0;\n}\n.carousel-inner[_ngcontent-%COMP%]    > .next[_ngcontent-%COMP%], .carousel-inner[_ngcontent-%COMP%]    > .prev[_ngcontent-%COMP%] {\n  position: absolute;\n  top: 0;\n  width: 100%;\n}\n.carousel-inner[_ngcontent-%COMP%]    > .next[_ngcontent-%COMP%] {\n  left: 100%;\n}\n.carousel-inner[_ngcontent-%COMP%]    > .prev[_ngcontent-%COMP%] {\n  left: -100%;\n}\n.carousel-inner[_ngcontent-%COMP%]    > .next.left[_ngcontent-%COMP%], .carousel-inner[_ngcontent-%COMP%]    > .prev.right[_ngcontent-%COMP%] {\n  left: 0;\n}\n.carousel-inner[_ngcontent-%COMP%]    > .active.left[_ngcontent-%COMP%] {\n  left: -100%;\n}\n.carousel-inner[_ngcontent-%COMP%]    > .active.right[_ngcontent-%COMP%] {\n  left: 100%;\n}\n.carousel-control[_ngcontent-%COMP%] {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  width: 15%;\n  font-size: 20px;\n  color: #fff;\n  text-align: center;\n  text-shadow: 0 1px 2px rgba(0, 0, 0, .6);\n  background-color: rgba(0, 0, 0, 0);\n  filter: alpha(opacity=50);\n  opacity: .5;\n}\n.carousel-control.left[_ngcontent-%COMP%] {\n  background-image: -webkit-linear-gradient(left, rgba(0, 0, 0, .5) 0%, rgba(0, 0, 0, .0001) 100%);\n  background-image:      -o-linear-gradient(left, rgba(0, 0, 0, .5) 0%, rgba(0, 0, 0, .0001) 100%);\n  background-image: -webkit-gradient(linear, left top, right top, from(rgba(0, 0, 0, .5)), to(rgba(0, 0, 0, .0001)));\n  background-image:         linear-gradient(to right, rgba(0, 0, 0, .5) 0%, rgba(0, 0, 0, .0001) 100%);\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr=\'#80000000\', endColorstr=\'#00000000\', GradientType=1);\n  background-repeat: repeat-x;\n}\n.carousel-control.right[_ngcontent-%COMP%] {\n  right: 0;\n  left: auto;\n  background-image: -webkit-linear-gradient(left, rgba(0, 0, 0, .0001) 0%, rgba(0, 0, 0, .5) 100%);\n  background-image:      -o-linear-gradient(left, rgba(0, 0, 0, .0001) 0%, rgba(0, 0, 0, .5) 100%);\n  background-image: -webkit-gradient(linear, left top, right top, from(rgba(0, 0, 0, .0001)), to(rgba(0, 0, 0, .5)));\n  background-image:         linear-gradient(to right, rgba(0, 0, 0, .0001) 0%, rgba(0, 0, 0, .5) 100%);\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr=\'#00000000\', endColorstr=\'#80000000\', GradientType=1);\n  background-repeat: repeat-x;\n}\n.carousel-control[_ngcontent-%COMP%]:hover, .carousel-control[_ngcontent-%COMP%]:focus {\n  color: #fff;\n  text-decoration: none;\n  filter: alpha(opacity=90);\n  outline: 0;\n  opacity: .9;\n}\n.carousel-control[_ngcontent-%COMP%]   .icon-prev[_ngcontent-%COMP%], .carousel-control[_ngcontent-%COMP%]   .icon-next[_ngcontent-%COMP%], .carousel-control[_ngcontent-%COMP%]   .glyphicon-chevron-left[_ngcontent-%COMP%], .carousel-control[_ngcontent-%COMP%]   .glyphicon-chevron-right[_ngcontent-%COMP%] {\n  position: absolute;\n  top: 50%;\n  z-index: 5;\n  display: inline-block;\n  margin-top: -10px;\n}\n.carousel-control[_ngcontent-%COMP%]   .icon-prev[_ngcontent-%COMP%], .carousel-control[_ngcontent-%COMP%]   .glyphicon-chevron-left[_ngcontent-%COMP%] {\n  left: 50%;\n  margin-left: -10px;\n}\n.carousel-control[_ngcontent-%COMP%]   .icon-next[_ngcontent-%COMP%], .carousel-control[_ngcontent-%COMP%]   .glyphicon-chevron-right[_ngcontent-%COMP%] {\n  right: 50%;\n  margin-right: -10px;\n}\n.carousel-control[_ngcontent-%COMP%]   .icon-prev[_ngcontent-%COMP%], .carousel-control[_ngcontent-%COMP%]   .icon-next[_ngcontent-%COMP%] {\n  width: 20px;\n  height: 20px;\n  font-family: serif;\n  line-height: 1;\n}\n.carousel-control[_ngcontent-%COMP%]   .icon-prev[_ngcontent-%COMP%]:before {\n  content: \'\\2039\';\n}\n.carousel-control[_ngcontent-%COMP%]   .icon-next[_ngcontent-%COMP%]:before {\n  content: \'\\203a\';\n}\n.carousel-indicators[_ngcontent-%COMP%] {\n  position: absolute;\n  bottom: 10px;\n  left: 50%;\n  z-index: 15;\n  width: 60%;\n  padding-left: 0;\n  margin-left: -30%;\n  text-align: center;\n  list-style: none;\n}\n.carousel-indicators[_ngcontent-%COMP%]   li[_ngcontent-%COMP%] {\n  display: inline-block;\n  width: 10px;\n  height: 10px;\n  margin: 1px;\n  text-indent: -999px;\n  cursor: pointer;\n  background-color: #000 \\9;\n  background-color: rgba(0, 0, 0, 0);\n  border: 1px solid #fff;\n  border-radius: 10px;\n}\n.carousel-indicators[_ngcontent-%COMP%]   .active[_ngcontent-%COMP%] {\n  width: 12px;\n  height: 12px;\n  margin: 0;\n  background-color: #fff;\n}\n.carousel-caption[_ngcontent-%COMP%] {\n  position: absolute;\n  right: 15%;\n  bottom: 20px;\n  left: 15%;\n  z-index: 10;\n  padding-top: 20px;\n  padding-bottom: 20px;\n  color: #fff;\n  text-align: center;\n  text-shadow: 0 1px 2px rgba(0, 0, 0, .6);\n}\n.carousel-caption[_ngcontent-%COMP%]   .btn[_ngcontent-%COMP%] {\n  text-shadow: none;\n}\n@media screen and (min-width: 768px) {\n  .carousel-control[_ngcontent-%COMP%]   .glyphicon-chevron-left[_ngcontent-%COMP%], .carousel-control[_ngcontent-%COMP%]   .glyphicon-chevron-right[_ngcontent-%COMP%], .carousel-control[_ngcontent-%COMP%]   .icon-prev[_ngcontent-%COMP%], .carousel-control[_ngcontent-%COMP%]   .icon-next[_ngcontent-%COMP%] {\n    width: 30px;\n    height: 30px;\n    margin-top: -10px;\n    font-size: 30px;\n  }\n  .carousel-control[_ngcontent-%COMP%]   .glyphicon-chevron-left[_ngcontent-%COMP%], .carousel-control[_ngcontent-%COMP%]   .icon-prev[_ngcontent-%COMP%] {\n    margin-left: -10px;\n  }\n  .carousel-control[_ngcontent-%COMP%]   .glyphicon-chevron-right[_ngcontent-%COMP%], .carousel-control[_ngcontent-%COMP%]   .icon-next[_ngcontent-%COMP%] {\n    margin-right: -10px;\n  }\n  .carousel-caption[_ngcontent-%COMP%] {\n    right: 20%;\n    left: 20%;\n    padding-bottom: 30px;\n  }\n  .carousel-indicators[_ngcontent-%COMP%] {\n    bottom: 20px;\n  }\n}\n.clearfix[_ngcontent-%COMP%]:before, .clearfix[_ngcontent-%COMP%]:after, .dl-horizontal[_ngcontent-%COMP%]   dd[_ngcontent-%COMP%]:before, .dl-horizontal[_ngcontent-%COMP%]   dd[_ngcontent-%COMP%]:after, .container[_ngcontent-%COMP%]:before, .container[_ngcontent-%COMP%]:after, .container-fluid[_ngcontent-%COMP%]:before, .container-fluid[_ngcontent-%COMP%]:after, .row[_ngcontent-%COMP%]:before, .row[_ngcontent-%COMP%]:after, .form-horizontal[_ngcontent-%COMP%]   .form-group[_ngcontent-%COMP%]:before, .form-horizontal[_ngcontent-%COMP%]   .form-group[_ngcontent-%COMP%]:after, .btn-toolbar[_ngcontent-%COMP%]:before, .btn-toolbar[_ngcontent-%COMP%]:after, .btn-group-vertical[_ngcontent-%COMP%]    > .btn-group[_ngcontent-%COMP%]:before, .btn-group-vertical[_ngcontent-%COMP%]    > .btn-group[_ngcontent-%COMP%]:after, .nav[_ngcontent-%COMP%]:before, .nav[_ngcontent-%COMP%]:after, .navbar[_ngcontent-%COMP%]:before, .navbar[_ngcontent-%COMP%]:after, .navbar-header[_ngcontent-%COMP%]:before, .navbar-header[_ngcontent-%COMP%]:after, .navbar-collapse[_ngcontent-%COMP%]:before, .navbar-collapse[_ngcontent-%COMP%]:after, .pager[_ngcontent-%COMP%]:before, .pager[_ngcontent-%COMP%]:after, .panel-body[_ngcontent-%COMP%]:before, .panel-body[_ngcontent-%COMP%]:after, .modal-header[_ngcontent-%COMP%]:before, .modal-header[_ngcontent-%COMP%]:after, .modal-footer[_ngcontent-%COMP%]:before, .modal-footer[_ngcontent-%COMP%]:after {\n  display: table;\n  content: " ";\n}\n.clearfix[_ngcontent-%COMP%]:after, .dl-horizontal[_ngcontent-%COMP%]   dd[_ngcontent-%COMP%]:after, .container[_ngcontent-%COMP%]:after, .container-fluid[_ngcontent-%COMP%]:after, .row[_ngcontent-%COMP%]:after, .form-horizontal[_ngcontent-%COMP%]   .form-group[_ngcontent-%COMP%]:after, .btn-toolbar[_ngcontent-%COMP%]:after, .btn-group-vertical[_ngcontent-%COMP%]    > .btn-group[_ngcontent-%COMP%]:after, .nav[_ngcontent-%COMP%]:after, .navbar[_ngcontent-%COMP%]:after, .navbar-header[_ngcontent-%COMP%]:after, .navbar-collapse[_ngcontent-%COMP%]:after, .pager[_ngcontent-%COMP%]:after, .panel-body[_ngcontent-%COMP%]:after, .modal-header[_ngcontent-%COMP%]:after, .modal-footer[_ngcontent-%COMP%]:after {\n  clear: both;\n}\n.center-block[_ngcontent-%COMP%] {\n  display: block;\n  margin-right: auto;\n  margin-left: auto;\n}\n.pull-right[_ngcontent-%COMP%] {\n  float: right !important;\n}\n.pull-left[_ngcontent-%COMP%] {\n  float: left !important;\n}\n.hide[_ngcontent-%COMP%] {\n  display: none !important;\n}\n.show[_ngcontent-%COMP%] {\n  display: block !important;\n}\n.invisible[_ngcontent-%COMP%] {\n  visibility: hidden;\n}\n.text-hide[_ngcontent-%COMP%] {\n  font: 0/0 a;\n  color: transparent;\n  text-shadow: none;\n  background-color: transparent;\n  border: 0;\n}\n.hidden[_ngcontent-%COMP%] {\n  display: none !important;\n}\n.affix[_ngcontent-%COMP%] {\n  position: fixed;\n}\n@-ms-viewport {\n  width: device-width;\n}\n.visible-xs[_ngcontent-%COMP%], .visible-sm[_ngcontent-%COMP%], .visible-md[_ngcontent-%COMP%], .visible-lg[_ngcontent-%COMP%] {\n  display: none !important;\n}\n.visible-xs-block[_ngcontent-%COMP%], .visible-xs-inline[_ngcontent-%COMP%], .visible-xs-inline-block[_ngcontent-%COMP%], .visible-sm-block[_ngcontent-%COMP%], .visible-sm-inline[_ngcontent-%COMP%], .visible-sm-inline-block[_ngcontent-%COMP%], .visible-md-block[_ngcontent-%COMP%], .visible-md-inline[_ngcontent-%COMP%], .visible-md-inline-block[_ngcontent-%COMP%], .visible-lg-block[_ngcontent-%COMP%], .visible-lg-inline[_ngcontent-%COMP%], .visible-lg-inline-block[_ngcontent-%COMP%] {\n  display: none !important;\n}\n@media (max-width: 767px) {\n  .visible-xs[_ngcontent-%COMP%] {\n    display: block !important;\n  }\n  table.visible-xs[_ngcontent-%COMP%] {\n    display: table !important;\n  }\n  tr.visible-xs[_ngcontent-%COMP%] {\n    display: table-row !important;\n  }\n  th.visible-xs[_ngcontent-%COMP%], td.visible-xs[_ngcontent-%COMP%] {\n    display: table-cell !important;\n  }\n}\n@media (max-width: 767px) {\n  .visible-xs-block[_ngcontent-%COMP%] {\n    display: block !important;\n  }\n}\n@media (max-width: 767px) {\n  .visible-xs-inline[_ngcontent-%COMP%] {\n    display: inline !important;\n  }\n}\n@media (max-width: 767px) {\n  .visible-xs-inline-block[_ngcontent-%COMP%] {\n    display: inline-block !important;\n  }\n}\n@media (min-width: 768px) and (max-width: 991px) {\n  .visible-sm[_ngcontent-%COMP%] {\n    display: block !important;\n  }\n  table.visible-sm[_ngcontent-%COMP%] {\n    display: table !important;\n  }\n  tr.visible-sm[_ngcontent-%COMP%] {\n    display: table-row !important;\n  }\n  th.visible-sm[_ngcontent-%COMP%], td.visible-sm[_ngcontent-%COMP%] {\n    display: table-cell !important;\n  }\n}\n@media (min-width: 768px) and (max-width: 991px) {\n  .visible-sm-block[_ngcontent-%COMP%] {\n    display: block !important;\n  }\n}\n@media (min-width: 768px) and (max-width: 991px) {\n  .visible-sm-inline[_ngcontent-%COMP%] {\n    display: inline !important;\n  }\n}\n@media (min-width: 768px) and (max-width: 991px) {\n  .visible-sm-inline-block[_ngcontent-%COMP%] {\n    display: inline-block !important;\n  }\n}\n@media (min-width: 992px) and (max-width: 1199px) {\n  .visible-md[_ngcontent-%COMP%] {\n    display: block !important;\n  }\n  table.visible-md[_ngcontent-%COMP%] {\n    display: table !important;\n  }\n  tr.visible-md[_ngcontent-%COMP%] {\n    display: table-row !important;\n  }\n  th.visible-md[_ngcontent-%COMP%], td.visible-md[_ngcontent-%COMP%] {\n    display: table-cell !important;\n  }\n}\n@media (min-width: 992px) and (max-width: 1199px) {\n  .visible-md-block[_ngcontent-%COMP%] {\n    display: block !important;\n  }\n}\n@media (min-width: 992px) and (max-width: 1199px) {\n  .visible-md-inline[_ngcontent-%COMP%] {\n    display: inline !important;\n  }\n}\n@media (min-width: 992px) and (max-width: 1199px) {\n  .visible-md-inline-block[_ngcontent-%COMP%] {\n    display: inline-block !important;\n  }\n}\n@media (min-width: 1200px) {\n  .visible-lg[_ngcontent-%COMP%] {\n    display: block !important;\n  }\n  table.visible-lg[_ngcontent-%COMP%] {\n    display: table !important;\n  }\n  tr.visible-lg[_ngcontent-%COMP%] {\n    display: table-row !important;\n  }\n  th.visible-lg[_ngcontent-%COMP%], td.visible-lg[_ngcontent-%COMP%] {\n    display: table-cell !important;\n  }\n}\n@media (min-width: 1200px) {\n  .visible-lg-block[_ngcontent-%COMP%] {\n    display: block !important;\n  }\n}\n@media (min-width: 1200px) {\n  .visible-lg-inline[_ngcontent-%COMP%] {\n    display: inline !important;\n  }\n}\n@media (min-width: 1200px) {\n  .visible-lg-inline-block[_ngcontent-%COMP%] {\n    display: inline-block !important;\n  }\n}\n@media (max-width: 767px) {\n  .hidden-xs[_ngcontent-%COMP%] {\n    display: none !important;\n  }\n}\n@media (min-width: 768px) and (max-width: 991px) {\n  .hidden-sm[_ngcontent-%COMP%] {\n    display: none !important;\n  }\n}\n@media (min-width: 992px) and (max-width: 1199px) {\n  .hidden-md[_ngcontent-%COMP%] {\n    display: none !important;\n  }\n}\n@media (min-width: 1200px) {\n  .hidden-lg[_ngcontent-%COMP%] {\n    display: none !important;\n  }\n}\n.visible-print[_ngcontent-%COMP%] {\n  display: none !important;\n}\n@media print {\n  .visible-print[_ngcontent-%COMP%] {\n    display: block !important;\n  }\n  table.visible-print[_ngcontent-%COMP%] {\n    display: table !important;\n  }\n  tr.visible-print[_ngcontent-%COMP%] {\n    display: table-row !important;\n  }\n  th.visible-print[_ngcontent-%COMP%], td.visible-print[_ngcontent-%COMP%] {\n    display: table-cell !important;\n  }\n}\n.visible-print-block[_ngcontent-%COMP%] {\n  display: none !important;\n}\n@media print {\n  .visible-print-block[_ngcontent-%COMP%] {\n    display: block !important;\n  }\n}\n.visible-print-inline[_ngcontent-%COMP%] {\n  display: none !important;\n}\n@media print {\n  .visible-print-inline[_ngcontent-%COMP%] {\n    display: inline !important;\n  }\n}\n.visible-print-inline-block[_ngcontent-%COMP%] {\n  display: none !important;\n}\n@media print {\n  .visible-print-inline-block[_ngcontent-%COMP%] {\n    display: inline-block !important;\n  }\n}\n@media print {\n  .hidden-print[_ngcontent-%COMP%] {\n    display: none !important;\n  }\n}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3NyYy91aS9ub2RlX21vZHVsZXMvYm9vdHN0cmFwL2Rpc3QvY3NzL2Jvb3RzdHJhcC5jc3Muc2hpbS5uZ3N0eWxlLnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vc3JjL3VpL25vZGVfbW9kdWxlcy9ib290c3RyYXAvZGlzdC9jc3MvYm9vdHN0cmFwLmNzcyJdLCJzb3VyY2VzQ29udGVudCI6WyIgIl0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7In0=
//# sourceMappingURL=bootstrap.css.shim.ngstyle.js.map

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_bisect__ = __webpack_require__(377);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__src_bisect__["a"]; });
/* unused harmony reexport bisectRight */
/* unused harmony reexport bisectLeft */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_ascending__ = __webpack_require__(105);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_1__src_ascending__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_bisector__ = __webpack_require__(378);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_2__src_bisector__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_cross__ = __webpack_require__(802);
/* unused harmony reexport cross */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_descending__ = __webpack_require__(803);
/* unused harmony reexport descending */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_deviation__ = __webpack_require__(379);
/* unused harmony reexport deviation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_extent__ = __webpack_require__(380);
/* unused harmony reexport extent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_histogram__ = __webpack_require__(804);
/* unused harmony reexport histogram */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_threshold_freedmanDiaconis__ = __webpack_require__(814);
/* unused harmony reexport thresholdFreedmanDiaconis */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_threshold_scott__ = __webpack_require__(815);
/* unused harmony reexport thresholdScott */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_threshold_sturges__ = __webpack_require__(384);
/* unused harmony reexport thresholdSturges */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_max__ = __webpack_require__(806);
/* unused harmony reexport max */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_mean__ = __webpack_require__(807);
/* unused harmony reexport mean */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_median__ = __webpack_require__(808);
/* unused harmony reexport median */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_merge__ = __webpack_require__(809);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_14__src_merge__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__src_min__ = __webpack_require__(381);
/* unused harmony reexport min */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__src_pairs__ = __webpack_require__(382);
/* unused harmony reexport pairs */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__src_permute__ = __webpack_require__(810);
/* unused harmony reexport permute */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__src_quantile__ = __webpack_require__(229);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_18__src_quantile__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__src_range__ = __webpack_require__(383);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_19__src_range__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__src_scan__ = __webpack_require__(811);
/* unused harmony reexport scan */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__src_shuffle__ = __webpack_require__(812);
/* unused harmony reexport shuffle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__src_sum__ = __webpack_require__(813);
/* unused harmony reexport sum */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__src_ticks__ = __webpack_require__(385);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_23__src_ticks__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_23__src_ticks__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_23__src_ticks__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__src_transpose__ = __webpack_require__(386);
/* unused harmony reexport transpose */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__src_variance__ = __webpack_require__(387);
/* unused harmony reexport variance */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__src_zip__ = __webpack_require__(816);
/* unused harmony reexport zip */





























/***/ }),
/* 30 */,
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PublisherService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Subject__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Subject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs_Subject__);

var PublisherService = /** @class */ (function () {
    function PublisherService() {
        this.channelMap = new Map();
    }
    PublisherService.prototype.createChannel = function (channelName) {
        var _this = this;
        var newSubject = new __WEBPACK_IMPORTED_MODULE_0_rxjs_Subject__["Subject"]();
        this.channelMap.set(channelName, newSubject);
        newSubject.subscribe(null, null, function () {
            /* when the channel is completed, remove it from the map */
            _this.channelMap.delete(channelName);
        });
        return newSubject;
    };
    PublisherService.prototype.subscribeToChannel = function (channelName) {
        /* subscribers sees only observables */
        return this.channelMap.get(channelName).asObservable();
    };
    PublisherService.prototype.sendToChannel = function (channelName, message) {
        /* maybe an issue that you can send to a channel even if your are not subscribed ? */
        if (!this.channelMap.has(channelName)) {
            throw new Error('Channel does not exist or it has been closed');
        }
        this.channelMap.get(channelName).next(message);
        return true;
    };
    PublisherService.ctorParameters = function () { return []; };
    return PublisherService;
}());

//# sourceMappingURL=publisher.service.js.map

/***/ }),
/* 32 */,
/* 33 */,
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ConfigService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__attack_attack_service__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_BehaviorSubject__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_BehaviorSubject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs_BehaviorSubject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__publisher_publisher_service__ = __webpack_require__(31);



var ConfigService = /** @class */ (function () {
    function ConfigService(attackService, publisherService) {
        var _this = this;
        this.attackService = attackService;
        this.publisherService = publisherService;
        this.availableAttackProfilesSubject = new __WEBPACK_IMPORTED_MODULE_1_rxjs_BehaviorSubject__["BehaviorSubject"]([]);
        this.currentAttackSubject = new __WEBPACK_IMPORTED_MODULE_1_rxjs_BehaviorSubject__["BehaviorSubject"]({ ID: '', Status: 'Unknown', FailReason: '', CreationDate: '', StartDate: '', StopDate: '', AttackParams: { TargetIpAddress: '', TargetPortNumber: 80, AttackProfile: 'udp-flood-512B', AttackSize: 'small', Duration: 600, SourceRegionName: '' }, Metrics: { TxFrameRate: 0, Attacks: 0, AttackRate: 0, TxDataRate: 0, TxFrames: 0, TxData: 0 } });
        this.historySubject = new __WEBPACK_IMPORTED_MODULE_1_rxjs_BehaviorSubject__["BehaviorSubject"]([]);
        var me = this;
        this.userAuthenticationChannel = this.publisherService.subscribeToChannel('user-authentication');
        this.userAuthenticationChannel.subscribe(function (newUser) {
            me.history = [];
            me.history.length = 15;
            me.historySubject.next(me.history);
        });
        this.attackService.currentAttack.subscribe(function (attack) {
            _this.currentAttackSubject.next(attack);
        });
        this.attackService.getAvailableProfiles().subscribe(function (profiles) {
            _this.availableAttackProfilesSubject.next(profiles);
        });
        // Get the original history when starting up, then push the next attack to the array as its running.
        this.attackService.allAttacks.subscribe(function (attacks) {
            attacks.sort(function (a, b) { return -a.CreationDate.localeCompare(b.CreationDate); });
            me.history = attacks;
            me.history.length = 15;
            me.historySubject.next(me.history);
            _this.attackService.currentAttack.subscribe(function (attack) {
                if (!attack) {
                    return;
                }
                var itemIndex = _this.history.findIndex(function (item) { return (item != null) && item.ID == attack.ID; });
                if (itemIndex >= 0) {
                    me.history[itemIndex] = attack;
                }
                else {
                    me.history.splice(0, 0, attack);
                }
                me.historySubject.next(me.history);
            });
        });
    }
    ConfigService.prototype.convertSecondsToHHMMSS = function (seconds) {
        if (seconds < 0) {
            seconds = 0;
        }
        var hours = ("0" + Math.floor(seconds / 3600)).slice(-2);
        var mins = ("0" + Math.floor((seconds - (+hours * 3600)) / 60)).slice(-2);
        var secs = ("0" + Math.floor(seconds % 60)).slice(-2);
        return hours + ':' + mins + ':' + secs;
    };
    ConfigService.prototype.formatDateTime = function (rawDateTime) {
        var formattedDateTime = '';
        var formattedMonth = '';
        var formattedDay = '';
        var formattedHour = '';
        var formattedMin = '';
        var formattedSec = '';
        var date = new Date(Date.parse(rawDateTime));
        var day = date.getDate();
        if (day <= 9) {
            formattedDay = '0' + day;
        }
        else {
            formattedDay = '' + day;
        }
        var monthIndex = date.getMonth();
        var month = date.getMonth() + 1;
        if (month <= 9) {
            formattedMonth = '0' + month;
        }
        else {
            formattedMonth = '' + month;
        }
        var year = date.getFullYear();
        var minutes = date.getMinutes();
        if (minutes <= 9) {
            formattedMin = '0' + minutes;
        }
        else {
            formattedMin = '' + minutes;
        }
        var hours = date.getHours();
        if (hours <= 9) {
            formattedHour = '0' + hours;
        }
        else {
            formattedHour = '' + hours;
        }
        var seconds = date.getSeconds();
        if (seconds <= 9) {
            formattedSec = '0' + seconds;
        }
        else {
            formattedSec = '' + seconds;
        }
        formattedDateTime = formattedMonth + "." + formattedDay + "." + year + " " + formattedHour + ":" + formattedMin + ":" + formattedSec;
        if (!isNaN(Date.parse(rawDateTime))) {
            return formattedDateTime;
        }
        else {
            return 'N/A';
        }
    };
    ConfigService.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_0__attack_attack_service__["a" /* AttackService */] }, { type: __WEBPACK_IMPORTED_MODULE_2__publisher_publisher_service__["a" /* PublisherService */] }]; };
    return ConfigService;
}());

//# sourceMappingURL=config.service.js.map

/***/ }),
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TrialService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_http__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__restapi_error_handler__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__user_user_service__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__aws_environment__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_Rx__ = __webpack_require__(1106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_Rx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_rxjs_Rx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs_Subject__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs_Subject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_rxjs_Subject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__aws_http__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rxjs_BehaviorSubject__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rxjs_BehaviorSubject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_rxjs_BehaviorSubject__);








var TrialService = /** @class */ (function () {
    function TrialService(errorHandler, awsEnv, http, awsHTTP, userService) {
        this.errorHandler = errorHandler;
        this.awsEnv = awsEnv;
        this.http = http;
        this.awsHTTP = awsHTTP;
        this.userService = userService;
        this.createAccountCredentials = new __WEBPACK_IMPORTED_MODULE_5_rxjs_Subject__["Subject"]();
        this.trialStatusChanged = new __WEBPACK_IMPORTED_MODULE_7_rxjs_BehaviorSubject__["BehaviorSubject"]({ trialMode: false, trialModeExpired: false, trialData: '', max: '' });
        this.thresholdExceeded = new __WEBPACK_IMPORTED_MODULE_5_rxjs_Subject__["Subject"]();
        this.trialMode = false;
        this.trialModeExpired = false;
    }
    TrialService.prototype.postTrialRegistration = function (registrationParams) {
        var _this = this;
        var headers = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["l" /* Headers */]({
            'Content-Type': 'application/json'
        });
        var baseRegistrationUrl = this.awsEnv.getRegistrationUrl();
        var url = baseRegistrationUrl + "/account/create";
        return this.http
            .post(url, JSON.stringify(registrationParams), { headers: headers })
            .map(function (response) { return response.json(); })
            .catch(function (response) { return _this.errorHandler.throwError(response); });
    };
    TrialService.prototype.pollTrialRegistration = function (reqID) {
        var _this = this;
        var headers = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["l" /* Headers */]({
            'Content-Type': 'application/json'
        });
        var params = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["m" /* URLSearchParams */](reqID);
        var baseRegistrationUrl = this.awsEnv.getRegistrationUrl();
        var url = baseRegistrationUrl + "/account/create?ReqId=" + reqID;
        var obs = __WEBPACK_IMPORTED_MODULE_4_rxjs_Rx__["Observable"].interval(5000)
            .switchMap(function () { return _this.http.get(url, { headers: headers }); }).map(function (data) { return data.json(); })
            .subscribe(function (data) {
            //console.log(data);// see console you get output every 5 sec
            if (data === 'CREATED' || data === 'FAILED' || data === 'DELETED') {
                obs.unsubscribe(); //stop polling
                _this.createAccountCredentials.next(data);
            }
        });
    };
    TrialService.prototype.accountActivation = function (email, code) {
        var _this = this;
        var headers = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["l" /* Headers */]({
            'Content-Type': 'application/json'
        });
        var params = {
            Email: email,
            PromoCode: code
        };
        var baseRegistrationUrl = this.userService.getApiUrl();
        var url = baseRegistrationUrl + "/account/activate";
        return this.awsHTTP
            .post(url, JSON.stringify(params), { headers: headers })
            .map(function (response) { return response.json(); })
            .catch(function (response) { return _this.errorHandler.throwError(response); });
    };
    TrialService.prototype.accountStatus = function (email) {
        var _this = this;
        var headers = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["l" /* Headers */]({
            'Content-Type': 'application/json'
        });
        var params = {
            Email: email
        };
        var baseRegistrationUrl = this.userService.getApiUrl();
        var url = baseRegistrationUrl + "/account/status";
        return this.awsHTTP
            .get(url, { headers: headers })
            .map(function (response) { return response.json(); })
            .catch(function (response) { return _this.errorHandler.throwError(response); });
    };
    TrialService.prototype.getAccountStatus = function (email) {
        var _this = this;
        this.accountStatus(email)
            .subscribe(function (response) {
            var trialStatus = {};
            if (response.trial) {
                _this.trialMode = response.trial;
                _this.max = response.max;
                trialStatus = {
                    trialMode: response.trial,
                    trialModeExpired: response.expired,
                    trialData: _this.bytesToSize(response.remaining),
                    max: response.max
                };
            }
            else {
                _this.consume = parseFloat(((response.consume / 1000000) / 1000).toFixed(2));
                _this.threshold = parseFloat(((response.threshold / 1000000) / 1000).toFixed(2));
                trialStatus = {
                    trialMode: response.trial,
                    consume: _this.consume,
                    threshold: _this.threshold
                };
            }
            _this.trialStatusChanged.next(trialStatus);
            _this.determineThresholdExceeded();
        }, function (error) {
            console.log(error);
            _this.trialMode = false;
        });
    };
    TrialService.prototype.updateAccount = function (email) {
        var _this = this;
        var headers = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["l" /* Headers */]({
            'Content-Type': 'application/json'
        });
        var baseRegistrationUrl = this.userService.getApiUrl();
        var url = baseRegistrationUrl + "/account/update";
        return this.awsHTTP
            .post(url, '', { headers: headers })
            .map(function (response) { return response.json(); })
            .catch(function (response) { return _this.errorHandler.throwError(response); });
    };
    TrialService.prototype.bytesToSize = function (size) {
        var i = Math.floor(Math.log(size) / Math.log(1000));
        if (size === 0) {
            return '0 GB';
        }
        return +(size / Math.pow(1000, i)).toFixed(2) * 1 + ' ' + ['B', 'kB', 'MB', 'GB', 'TB'][i];
    };
    ;
    TrialService.prototype.setEstimatedOutboundData = function (value) {
        this.estimatedOutboundData = parseFloat(value);
        this.determineThresholdExceeded();
    };
    TrialService.prototype.determineThresholdExceeded = function () {
        if (!this.trialMode && this.estimatedOutboundData && this.consume && this.threshold) {
            if (this.estimatedOutboundData + this.consume > this.threshold) {
                this.thresholdExceeded.next(true);
            }
            else {
                this.thresholdExceeded.next(false);
            }
        }
    };
    TrialService.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_1__restapi_error_handler__["a" /* ErrorHandler */] }, { type: __WEBPACK_IMPORTED_MODULE_3__aws_environment__["a" /* AwsEnvironment */] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_http__["i" /* Http */] }, { type: __WEBPACK_IMPORTED_MODULE_6__aws_http__["a" /* AwsHttp */] }, { type: __WEBPACK_IMPORTED_MODULE_2__user_user_service__["a" /* UserService */] }]; };
    return TrialService;
}());

//# sourceMappingURL=trial.service.js.map

/***/ }),
/* 40 */,
/* 41 */,
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_value__ = __webpack_require__(248);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_value__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_array__ = __webpack_require__(417);
/* unused harmony reexport interpolateArray */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_basis__ = __webpack_require__(247);
/* unused harmony reexport interpolateBasis */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_basisClosed__ = __webpack_require__(418);
/* unused harmony reexport interpolateBasisClosed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_date__ = __webpack_require__(420);
/* unused harmony reexport interpolateDate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_number__ = __webpack_require__(154);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_5__src_number__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_object__ = __webpack_require__(421);
/* unused harmony reexport interpolateObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_round__ = __webpack_require__(926);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_7__src_round__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_string__ = __webpack_require__(423);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_8__src_string__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_transform_index__ = __webpack_require__(928);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_9__src_transform_index__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_9__src_transform_index__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_zoom__ = __webpack_require__(930);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_10__src_zoom__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_rgb__ = __webpack_require__(422);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_11__src_rgb__["a"]; });
/* unused harmony reexport interpolateRgbBasis */
/* unused harmony reexport interpolateRgbBasisClosed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_hsl__ = __webpack_require__(923);
/* unused harmony reexport interpolateHsl */
/* unused harmony reexport interpolateHslLong */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_lab__ = __webpack_require__(924);
/* unused harmony reexport interpolateLab */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_hcl__ = __webpack_require__(922);
/* unused harmony reexport interpolateHcl */
/* unused harmony reexport interpolateHclLong */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__src_cubehelix__ = __webpack_require__(921);
/* unused harmony reexport interpolateCubehelix */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_15__src_cubehelix__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__src_quantize__ = __webpack_require__(925);
/* unused harmony reexport quantize */



















/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return root; });
/* harmony export (immutable) */ __webpack_exports__["a"] = Selection;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__select__ = __webpack_require__(1011);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selectAll__ = __webpack_require__(1012);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__filter__ = __webpack_require__(1000);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data__ = __webpack_require__(994);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__enter__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__exit__ = __webpack_require__(999);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__merge__ = __webpack_require__(1004);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__order__ = __webpack_require__(1007);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__sort__ = __webpack_require__(1014);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__call__ = __webpack_require__(992);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__nodes__ = __webpack_require__(1006);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__node__ = __webpack_require__(1005);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__size__ = __webpack_require__(1013);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__empty__ = __webpack_require__(998);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__each__ = __webpack_require__(997);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__attr__ = __webpack_require__(991);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__style__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__property__ = __webpack_require__(1008);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__classed__ = __webpack_require__(993);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__text__ = __webpack_require__(1015);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__html__ = __webpack_require__(1001);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__raise__ = __webpack_require__(1009);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__lower__ = __webpack_require__(1003);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__append__ = __webpack_require__(990);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__insert__ = __webpack_require__(1002);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__remove__ = __webpack_require__(1010);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__datum__ = __webpack_require__(995);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__on__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__dispatch__ = __webpack_require__(996);






























var root = [null];

function Selection(groups, parents) {
  this._groups = groups;
  this._parents = parents;
}

function selection() {
  return new Selection([[document.documentElement]], root);
}

Selection.prototype = selection.prototype = {
  constructor: Selection,
  select: __WEBPACK_IMPORTED_MODULE_0__select__["a" /* default */],
  selectAll: __WEBPACK_IMPORTED_MODULE_1__selectAll__["a" /* default */],
  filter: __WEBPACK_IMPORTED_MODULE_2__filter__["a" /* default */],
  data: __WEBPACK_IMPORTED_MODULE_3__data__["a" /* default */],
  enter: __WEBPACK_IMPORTED_MODULE_4__enter__["a" /* default */],
  exit: __WEBPACK_IMPORTED_MODULE_5__exit__["a" /* default */],
  merge: __WEBPACK_IMPORTED_MODULE_6__merge__["a" /* default */],
  order: __WEBPACK_IMPORTED_MODULE_7__order__["a" /* default */],
  sort: __WEBPACK_IMPORTED_MODULE_8__sort__["a" /* default */],
  call: __WEBPACK_IMPORTED_MODULE_9__call__["a" /* default */],
  nodes: __WEBPACK_IMPORTED_MODULE_10__nodes__["a" /* default */],
  node: __WEBPACK_IMPORTED_MODULE_11__node__["a" /* default */],
  size: __WEBPACK_IMPORTED_MODULE_12__size__["a" /* default */],
  empty: __WEBPACK_IMPORTED_MODULE_13__empty__["a" /* default */],
  each: __WEBPACK_IMPORTED_MODULE_14__each__["a" /* default */],
  attr: __WEBPACK_IMPORTED_MODULE_15__attr__["a" /* default */],
  style: __WEBPACK_IMPORTED_MODULE_16__style__["a" /* default */],
  property: __WEBPACK_IMPORTED_MODULE_17__property__["a" /* default */],
  classed: __WEBPACK_IMPORTED_MODULE_18__classed__["a" /* default */],
  text: __WEBPACK_IMPORTED_MODULE_19__text__["a" /* default */],
  html: __WEBPACK_IMPORTED_MODULE_20__html__["a" /* default */],
  raise: __WEBPACK_IMPORTED_MODULE_21__raise__["a" /* default */],
  lower: __WEBPACK_IMPORTED_MODULE_22__lower__["a" /* default */],
  append: __WEBPACK_IMPORTED_MODULE_23__append__["a" /* default */],
  insert: __WEBPACK_IMPORTED_MODULE_24__insert__["a" /* default */],
  remove: __WEBPACK_IMPORTED_MODULE_25__remove__["a" /* default */],
  datum: __WEBPACK_IMPORTED_MODULE_26__datum__["a" /* default */],
  on: __WEBPACK_IMPORTED_MODULE_27__on__["c" /* default */],
  dispatch: __WEBPACK_IMPORTED_MODULE_28__dispatch__["a" /* default */]
};

/* harmony default export */ __webpack_exports__["c"] = (selection);


/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CREATED */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SCHEDULED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return STARTING; });
/* unused harmony export STARTED */
/* unused harmony export RUNNING */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ENDED; });
/* harmony export (immutable) */ __webpack_exports__["g"] = init;
/* harmony export (immutable) */ __webpack_exports__["e"] = set;
/* harmony export (immutable) */ __webpack_exports__["f"] = get;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_dispatch__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_timer__ = __webpack_require__(163);



var emptyOn = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_dispatch__["a" /* dispatch */])("start", "end", "interrupt");
var emptyTween = [];

var CREATED = 0;
var SCHEDULED = 1;
var STARTING = 2;
var STARTED = 3;
var RUNNING = 4;
var ENDING = 5;
var ENDED = 6;

/* harmony default export */ __webpack_exports__["h"] = (function(node, name, id, index, group, timing) {
  var schedules = node.__transition;
  if (!schedules) node.__transition = {};
  else if (id in schedules) return;
  create(node, id, {
    name: name,
    index: index, // For context during callback.
    group: group, // For context during callback.
    on: emptyOn,
    tween: emptyTween,
    time: timing.time,
    delay: timing.delay,
    duration: timing.duration,
    ease: timing.ease,
    timer: null,
    state: CREATED
  });
});

function init(node, id) {
  var schedule = get(node, id);
  if (schedule.state > CREATED) throw new Error("too late; already scheduled");
  return schedule;
}

function set(node, id) {
  var schedule = get(node, id);
  if (schedule.state > STARTING) throw new Error("too late; already started");
  return schedule;
}

function get(node, id) {
  var schedule = node.__transition;
  if (!schedule || !(schedule = schedule[id])) throw new Error("transition not found");
  return schedule;
}

function create(node, id, self) {
  var schedules = node.__transition,
      tween;

  // Initialize the self timer when the transition is created.
  // Note the actual delay is not known until the first callback!
  schedules[id] = self;
  self.timer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_timer__["a" /* timer */])(schedule, 0, self.time);

  function schedule(elapsed) {
    self.state = SCHEDULED;
    self.timer.restart(start, self.delay, self.time);

    // If the elapsed delay is less than our first sleep, start immediately.
    if (self.delay <= elapsed) start(elapsed - self.delay);
  }

  function start(elapsed) {
    var i, j, n, o;

    // If the state is not SCHEDULED, then we previously errored on start.
    if (self.state !== SCHEDULED) return stop();

    for (i in schedules) {
      o = schedules[i];
      if (o.name !== self.name) continue;

      // While this element already has a starting transition during this frame,
      // defer starting an interrupting transition until that transition has a
      // chance to tick (and possibly end); see d3/d3-transition#54!
      if (o.state === STARTED) return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_timer__["b" /* timeout */])(start);

      // Interrupt the active transition, if any.
      // Dispatch the interrupt event.
      if (o.state === RUNNING) {
        o.state = ENDED;
        o.timer.stop();
        o.on.call("interrupt", node, node.__data__, o.index, o.group);
        delete schedules[i];
      }

      // Cancel any pre-empted transitions. No interrupt event is dispatched
      // because the cancelled transitions never started. Note that this also
      // removes this transition from the pending list!
      else if (+i < id) {
        o.state = ENDED;
        o.timer.stop();
        delete schedules[i];
      }
    }

    // Defer the first tick to end of the current frame; see d3/d3#1576.
    // Note the transition may be canceled after start and before the first tick!
    // Note this must be scheduled before the start event; see d3/d3-transition#16!
    // Assuming this is successful, subsequent callbacks go straight to tick.
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_timer__["b" /* timeout */])(function() {
      if (self.state === STARTED) {
        self.state = RUNNING;
        self.timer.restart(tick, self.delay, self.time);
        tick(elapsed);
      }
    });

    // Dispatch the start event.
    // Note this must be done before the tween are initialized.
    self.state = STARTING;
    self.on.call("start", node, node.__data__, self.index, self.group);
    if (self.state !== STARTING) return; // interrupted
    self.state = STARTED;

    // Initialize the tween, deleting null tween.
    tween = new Array(n = self.tween.length);
    for (i = 0, j = -1; i < n; ++i) {
      if (o = self.tween[i].value.call(node, node.__data__, self.index, self.group)) {
        tween[++j] = o;
      }
    }
    tween.length = j + 1;
  }

  function tick(elapsed) {
    var t = elapsed < self.duration ? self.ease.call(null, elapsed / self.duration) : (self.timer.restart(stop), self.state = ENDING, 1),
        i = -1,
        n = tween.length;

    while (++i < n) {
      tween[i].call(null, t);
    }

    // Dispatch the end event.
    if (self.state === ENDING) {
      self.on.call("end", node, node.__data__, self.index, self.group);
      stop();
    }
  }

  function stop() {
    self.state = ENDED;
    self.timer.stop();
    delete schedules[id];
    for (var i in schedules) return; // eslint-disable-line no-unused-vars
    delete node.__transition;
  }
}


/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TargetValidationService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_http__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_router__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__aws_http__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__publisher_publisher_service__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__restapi_error_handler__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__user_user_service__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__target_validation_dialog_component__ = __webpack_require__(188);







var Subscription = /** @class */ (function () {
    function Subscription() {
    }
    return Subscription;
}());
var TargetValidationService = /** @class */ (function () {
    function TargetValidationService(router, http, errorHandler, userService, publisherService) {
        var _this = this;
        this.router = router;
        this.http = http;
        this.errorHandler = errorHandler;
        this.userService = userService;
        this.publisherService = publisherService;
        router.events
            .filter(function (event) { return event instanceof __WEBPACK_IMPORTED_MODULE_1__angular_router__["y" /* NavigationEnd */]; })
            .map(function (event) { return event; })
            .subscribe(function (event) {
            var url = _this.createUrl(window.location.origin + event.url);
            var searchParams = _this.getSearchParams(url.search);
            var targetValidation = _this.getSearchParam(searchParams, TargetValidationService.URL_PARAM);
            var lastAuthzOk = _this.getSearchParam(searchParams, TargetValidationService.URL_PARAM_OK);
            var lastAuthzErrorCode = _this.getSearchParam(searchParams, TargetValidationService.URL_PARAM_ERROR);
            if (targetValidation && targetValidation.toLowerCase() === 'true') {
                _this.showDialog2(!!lastAuthzOk, lastAuthzErrorCode);
            }
        });
    }
    Object.defineProperty(TargetValidationService.prototype, "baseUrl", {
        get: function () {
            return this.userService.getApiUrl() + "/subscriptions";
        },
        enumerable: true,
        configurable: true
    });
    TargetValidationService.prototype.getSearchParams = function (search) {
        var queryString = (search || '').substring(1);
        var searchParams = {};
        queryString.split('&').forEach(function (paramString) {
            var parts = paramString.split('=');
            var param = decodeURIComponent(parts[0]);
            if (param.length > 0) {
                var values = searchParams[param] = searchParams[param] || [];
                var value = parts[1];
                if (value !== undefined) {
                    value = decodeURIComponent(value);
                }
                values.push(value);
            }
        });
        return searchParams;
    };
    TargetValidationService.prototype.getSearchParam = function (searchParams, param) {
        var values = searchParams[param];
        return values && values[0];
    };
    TargetValidationService.prototype.createSearchString = function (searchParams) {
        searchParams = searchParams || {};
        var queryString = Object.keys(searchParams)
            .filter(function (param) { return param.length > 0; })
            .reduce(function (paramStrings, param) { return paramStrings.concat(searchParams[param].map(function (value) { return value === undefined ? param : param + "=" + value; })); }, [])
            .join('&');
        return queryString.length > 0 ? ('?' + queryString) : '';
    };
    TargetValidationService.prototype.createUrl = function (url, base) {
        var iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        document.body.appendChild(iframe);
        var iframeDocument = iframe.contentWindow.document;
        if (base) {
            var baseElement = iframeDocument.createElement('base');
            baseElement.href = base;
            iframeDocument.head.appendChild(baseElement);
        }
        var aElement = iframeDocument.createElement('a');
        aElement.href = url;
        aElement = iframeDocument.body.appendChild(aElement);
        document.body.removeChild(iframe);
        return aElement;
    };
    TargetValidationService.prototype.fromSubscription = function (subscription) {
        return {
            id: subscription.ID,
            name: subscription.Name,
            user: subscription.UserName,
            valid: subscription.Valid
        };
    };
    TargetValidationService.prototype.getCleanUrl = function () {
        var url = this.createUrl(window.location.href);
        var searchParams = this.getSearchParams(url.search);
        delete searchParams[TargetValidationService.URL_PARAM];
        delete searchParams[TargetValidationService.URL_PARAM_OK];
        delete searchParams[TargetValidationService.URL_PARAM_ERROR];
        var search = this.createSearchString(searchParams);
        return "" + url.pathname + search + url.hash;
    };
    TargetValidationService.prototype.registerDialog = function (dialog) {
        this.dialog = dialog;
    };
    TargetValidationService.prototype.showDialog = function () {
        this.showDialog2(true);
    };
    TargetValidationService.prototype.showDialog2 = function (lastAuthzOk, lastAuthzErrorCode) {
        var _this = this;
        setTimeout(function () {
            var args = new __WEBPACK_IMPORTED_MODULE_6__target_validation_dialog_component__["a" /* TargetValidationDialogArgs */]();
            args.LastAuthzOK = lastAuthzOk;
            args.LastAuthzErrorCode = lastAuthzErrorCode;
            _this.dialog.showDialog(args);
        });
    };
    TargetValidationService.prototype.getSubscriptions = function () {
        var _this = this;
        var headers = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["l" /* Headers */]({
            'Accept': 'application/json'
        });
        return this.http
            .get(this.baseUrl, { headers: headers })
            .map(function (response) { return response.json().map(_this.fromSubscription); })
            .catch(function (response) { return _this.errorHandler.throwError(response); });
    };
    TargetValidationService.prototype.addSubscription = function (subscriptionId) {
        var _this = this;
        var headers = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["l" /* Headers */]({
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        });
        return this.http
            .post(this.baseUrl, JSON.stringify({
            ID: subscriptionId.trim()
        }), { headers: headers })
            .map(function (response) { return _this.fromSubscription(response.json()); })
            .catch(function (response) { return _this.errorHandler.throwError(response); });
    };
    TargetValidationService.prototype.removeSubscription = function (subscription) {
        var _this = this;
        var headers = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["l" /* Headers */]({
            'Accept': 'application/json'
        });
        var url = this.baseUrl + "/" + subscription.id;
        return this.http
            .delete(url, { headers: headers })
            .map(function () { return subscription; })
            .catch(function (response) { return _this.errorHandler.throwError(response); });
    };
    TargetValidationService.prototype.authorizeSubscription = function (subscription, returnUrl, adminConsent) {
        var _this = this;
        var headers = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["l" /* Headers */]({
            'Accept': 'application/json'
        });
        var qparams = '';
        if (adminConsent) {
            qparams = '?admin=true';
        }
        var url = this.baseUrl + "/" + subscription.id + "/auth" + qparams;
        return this.http
            .get(url, {
            headers: headers
        }).map(function (response) { return response.json().authorization_uri; })
            .catch(function (response) { return _this.errorHandler.throwError(response); });
    };
    TargetValidationService.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_router__["a" /* Router */] }, { type: __WEBPACK_IMPORTED_MODULE_2__aws_http__["a" /* AwsHttp */] }, { type: __WEBPACK_IMPORTED_MODULE_4__restapi_error_handler__["a" /* ErrorHandler */] }, { type: __WEBPACK_IMPORTED_MODULE_5__user_user_service__["a" /* UserService */] }, { type: __WEBPACK_IMPORTED_MODULE_3__publisher_publisher_service__["a" /* PublisherService */] }]; };
    TargetValidationService.URL_PARAM = 'targetValidation';
    TargetValidationService.URL_PARAM_OK = 'ok';
    TargetValidationService.URL_PARAM_ERROR = 'error';
    return TargetValidationService;
}());

//# sourceMappingURL=target-validation.service.js.map

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SystemInformationService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_http__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__aws_http__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__restapi_error_handler__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__user_user_service__ = __webpack_require__(12);




var SystemInformationService = /** @class */ (function () {
    function SystemInformationService(http, errorHandler, userService) {
        this.http = http;
        this.errorHandler = errorHandler;
        this.userService = userService;
    }
    SystemInformationService.prototype.getSystemInformation = function () {
        var _this = this;
        var headers = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["l" /* Headers */]({
            'Content-Type': 'application/json'
        });
        var baseUrl = this.userService.getApiUrl();
        var url = baseUrl + "/systeminformation";
        return this.http
            .get(url, { headers: headers })
            .map(function (response) { return response.json(); })
            .catch(function (response) { return _this.errorHandler.throwError(response); });
    };
    SystemInformationService.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_1__aws_http__["a" /* AwsHttp */] }, { type: __WEBPACK_IMPORTED_MODULE_2__restapi_error_handler__["a" /* ErrorHandler */] }, { type: __WEBPACK_IMPORTED_MODULE_3__user_user_service__["a" /* UserService */] }]; };
    return SystemInformationService;
}());

//# sourceMappingURL=systeminformation.service.js.map

/***/ }),
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_color__ = __webpack_require__(231);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_color__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_0__src_color__["h"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__src_color__["g"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_lab__ = __webpack_require__(837);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_1__src_lab__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__src_lab__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_cubehelix__ = __webpack_require__(836);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__src_cubehelix__["a"]; });





/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = projection;
/* harmony export (immutable) */ __webpack_exports__["b"] = projectionMutator;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__clip_antimeridian__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__clip_circle__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__clip_rectangle__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__compose__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__identity__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__math__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__rotation__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__transform__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__fit__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__resample__ = __webpack_require__(896);











var transformRadians = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__transform__["a" /* transformer */])({
  point: function(x, y) {
    this.stream.point(x * __WEBPACK_IMPORTED_MODULE_5__math__["g" /* radians */], y * __WEBPACK_IMPORTED_MODULE_5__math__["g" /* radians */]);
  }
});

function transformRotate(rotate) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__transform__["a" /* transformer */])({
    point: function(x, y) {
      var r = rotate(x, y);
      return this.stream.point(r[0], r[1]);
    }
  });
}

function projection(project) {
  return projectionMutator(function() { return project; })();
}

function projectionMutator(projectAt) {
  var project,
      k = 150, // scale
      x = 480, y = 250, // translate
      dx, dy, lambda = 0, phi = 0, // center
      deltaLambda = 0, deltaPhi = 0, deltaGamma = 0, rotate, projectRotate, // rotate
      theta = null, preclip = __WEBPACK_IMPORTED_MODULE_0__clip_antimeridian__["a" /* default */], // clip angle
      x0 = null, y0, x1, y1, postclip = __WEBPACK_IMPORTED_MODULE_4__identity__["a" /* default */], // clip extent
      delta2 = 0.5, projectResample = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__resample__["a" /* default */])(projectTransform, delta2), // precision
      cache,
      cacheStream;

  function projection(point) {
    point = projectRotate(point[0] * __WEBPACK_IMPORTED_MODULE_5__math__["g" /* radians */], point[1] * __WEBPACK_IMPORTED_MODULE_5__math__["g" /* radians */]);
    return [point[0] * k + dx, dy - point[1] * k];
  }

  function invert(point) {
    point = projectRotate.invert((point[0] - dx) / k, (dy - point[1]) / k);
    return point && [point[0] * __WEBPACK_IMPORTED_MODULE_5__math__["h" /* degrees */], point[1] * __WEBPACK_IMPORTED_MODULE_5__math__["h" /* degrees */]];
  }

  function projectTransform(x, y) {
    return x = project(x, y), [x[0] * k + dx, dy - x[1] * k];
  }

  projection.stream = function(stream) {
    return cache && cacheStream === stream ? cache : cache = transformRadians(transformRotate(rotate)(preclip(projectResample(postclip(cacheStream = stream)))));
  };

  projection.preclip = function(_) {
    return arguments.length ? (preclip = _, theta = undefined, reset()) : preclip;
  };

  projection.postclip = function(_) {
    return arguments.length ? (postclip = _, x0 = y0 = x1 = y1 = null, reset()) : postclip;
  };

  projection.clipAngle = function(_) {
    return arguments.length ? (preclip = +_ ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__clip_circle__["a" /* default */])(theta = _ * __WEBPACK_IMPORTED_MODULE_5__math__["g" /* radians */]) : (theta = null, __WEBPACK_IMPORTED_MODULE_0__clip_antimeridian__["a" /* default */]), reset()) : theta * __WEBPACK_IMPORTED_MODULE_5__math__["h" /* degrees */];
  };

  projection.clipExtent = function(_) {
    return arguments.length ? (postclip = _ == null ? (x0 = y0 = x1 = y1 = null, __WEBPACK_IMPORTED_MODULE_4__identity__["a" /* default */]) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__clip_rectangle__["a" /* default */])(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reset()) : x0 == null ? null : [[x0, y0], [x1, y1]];
  };

  projection.scale = function(_) {
    return arguments.length ? (k = +_, recenter()) : k;
  };

  projection.translate = function(_) {
    return arguments.length ? (x = +_[0], y = +_[1], recenter()) : [x, y];
  };

  projection.center = function(_) {
    return arguments.length ? (lambda = _[0] % 360 * __WEBPACK_IMPORTED_MODULE_5__math__["g" /* radians */], phi = _[1] % 360 * __WEBPACK_IMPORTED_MODULE_5__math__["g" /* radians */], recenter()) : [lambda * __WEBPACK_IMPORTED_MODULE_5__math__["h" /* degrees */], phi * __WEBPACK_IMPORTED_MODULE_5__math__["h" /* degrees */]];
  };

  projection.rotate = function(_) {
    return arguments.length ? (deltaLambda = _[0] % 360 * __WEBPACK_IMPORTED_MODULE_5__math__["g" /* radians */], deltaPhi = _[1] % 360 * __WEBPACK_IMPORTED_MODULE_5__math__["g" /* radians */], deltaGamma = _.length > 2 ? _[2] % 360 * __WEBPACK_IMPORTED_MODULE_5__math__["g" /* radians */] : 0, recenter()) : [deltaLambda * __WEBPACK_IMPORTED_MODULE_5__math__["h" /* degrees */], deltaPhi * __WEBPACK_IMPORTED_MODULE_5__math__["h" /* degrees */], deltaGamma * __WEBPACK_IMPORTED_MODULE_5__math__["h" /* degrees */]];
  };

  projection.precision = function(_) {
    return arguments.length ? (projectResample = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__resample__["a" /* default */])(projectTransform, delta2 = _ * _), reset()) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__math__["n" /* sqrt */])(delta2);
  };

  projection.fitExtent = function(extent, object) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__fit__["a" /* fitExtent */])(projection, extent, object);
  };

  projection.fitSize = function(size, object) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__fit__["b" /* fitSize */])(projection, size, object);
  };

  projection.fitWidth = function(width, object) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__fit__["c" /* fitWidth */])(projection, width, object);
  };

  projection.fitHeight = function(height, object) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__fit__["d" /* fitHeight */])(projection, height, object);
  };

  function recenter() {
    projectRotate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__compose__["a" /* default */])(rotate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__rotation__["b" /* rotateRadians */])(deltaLambda, deltaPhi, deltaGamma), project);
    var center = project(lambda, phi);
    dx = x - center[0] * k;
    dy = y + center[1] * k;
    return reset();
  }

  function reset() {
    cache = cacheStream = null;
    return projection;
  }

  return function() {
    project = projectAt.apply(this, arguments);
    projection.invert = project.invert && invert;
    return recenter();
  };
}


/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AttackMessage */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AttackService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_http__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_Subject__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_Subject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs_Subject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__aws_http__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__publisher_message__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__publisher_publisher_service__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__restapi_error_handler__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__user_user_service__ = __webpack_require__(12);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();








var AttackMessageType;
(function (AttackMessageType) {
    AttackMessageType[AttackMessageType["START"] = 0] = "START";
    AttackMessageType[AttackMessageType["STOP"] = 1] = "STOP";
})(AttackMessageType || (AttackMessageType = {}));
var AttackMessage = /** @class */ (function (_super) {
    __extends(AttackMessage, _super);
    function AttackMessage(attack, type) {
        var _this = _super.call(this, attack) || this;
        _this.attack = attack;
        _this.type = type;
        return _this;
    }
    AttackMessage.Type = AttackMessageType;
    return AttackMessage;
}(__WEBPACK_IMPORTED_MODULE_4__publisher_message__["a" /* Message */]));

var AttackService = /** @class */ (function () {
    function AttackService(http, errorHandler, userService, publisherService) {
        this.http = http;
        this.errorHandler = errorHandler;
        this.userService = userService;
        this.publisherService = publisherService;
        this.allAttacks = new __WEBPACK_IMPORTED_MODULE_2_rxjs_Subject__["Subject"]();
        this.userAuthenticationChannel = this.publisherService.subscribeToChannel('user-authentication');
        this.attackChannel = this.publisherService.createChannel('attacks');
        this.currentAttack = this.pollCurrentAttack().share();
    }
    AttackService.prototype.getAvailableProfiles = function () {
        var headers = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["l" /* Headers */]({
            'Content-Type': 'application/json'
        });
        var baseUrl = this.userService.getApiUrl();
        var url = baseUrl + "/attackparameters/profiles";
        return this.http
            .get(url, { headers: headers })
            .map(function (response) { return response.json(); });
    };
    AttackService.prototype.start = function (attackParams) {
        var _this = this;
        var headers = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["l" /* Headers */]({
            'Content-Type': 'application/json'
        });
        var baseUrl = this.userService.getApiUrl();
        var url = baseUrl + "/attacks";
        return this.http
            .post(url, JSON.stringify(attackParams), { headers: headers })
            .map(function (response) { return response.json(); })
            .catch(function (response) { return _this.errorHandler.throwError(response); })
            .do(function (attack) {
            _this.attackChannel.next(new AttackMessage(attack, AttackMessage.Type.START));
        });
    };
    AttackService.prototype.stop = function (attackId) {
        var _this = this;
        var headers = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["l" /* Headers */]({
            'Content-Type': 'application/json'
        });
        var baseUrl = this.userService.getApiUrl();
        var url = baseUrl + "/attacks/" + attackId + "/operations/stop";
        return this.http
            .post(url, null, { headers: headers })
            .map(function (response) { return response.json(); })
            .catch(function (response) { return _this.errorHandler.throwError(response); })
            .do(function (attack) {
            _this.attackChannel.next(new AttackMessage(attack, AttackMessage.Type.STOP));
        });
    };
    AttackService.prototype.getAttack = function (attackId) {
        var _this = this;
        var headers = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["l" /* Headers */]({
            'Content-Type': 'application/json'
        });
        var baseUrl = this.userService.getApiUrl();
        var url = baseUrl + "/attacks/" + attackId;
        return this.http
            .get(url, { headers: headers })
            .map(function (response) { return response.json(); })
            .catch(function (response) { return _this.errorHandler.throwError(response); });
    };
    AttackService.prototype.getAllActiveAttacks = function () {
        var _this = this;
        var headers = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["l" /* Headers */]({
            'Content-Type': 'application/json'
        });
        var baseUrl = this.userService.getApiUrl();
        var url = baseUrl + "/attacks";
        return this.http
            .get(url, { headers: headers })
            .map(function (response) { return response.json(); })
            .catch(function (response) { return _this.errorHandler.throwError(response); });
    };
    AttackService.prototype.getLatestAttack = function () {
        var me = this;
        return this.getAllActiveAttacks().map(function (attacks) {
            attacks.forEach(function (attack) {
                // console.log(attack);
            });
            attacks.sort(function (a, b) { return -a.CreationDate.localeCompare(b.CreationDate); });
            me.allAttacks.next(attacks);
            return attacks.length ? attacks[0] : null;
        });
    };
    AttackService.prototype.pollCurrentAttack = function (providedAttack) {
        var _this = this;
        var attackGetObservable;
        if (providedAttack) {
            attackGetObservable = __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"].of(providedAttack);
        }
        else if (!this.userService.currentUser) {
            attackGetObservable = __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"].of(null);
        }
        else if (this.currentAttackObject) {
            attackGetObservable = this.getAttack(this.currentAttackObject.ID);
        }
        else {
            attackGetObservable = this.getLatestAttack();
        }
        return attackGetObservable
            .catch(function (e) {
            console.error(e);
            return __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"].of(null);
        })
            .do(function (attack) { return _this.currentAttackObject = attack; })
            .switchMap(function (attack) {
            var shouldPoll = _this.userService.currentUser && attack && ['Stopped', 'Failed'].indexOf(attack.Status) < 0;
            var pollingObservable = shouldPoll ? __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"].timer(5000).map(function () { return null; }) : __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"].empty();
            var nextUpdateObservable = __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"].merge(pollingObservable, _this.userAuthenticationChannel
                .filter(function (message) { return message.type === __WEBPACK_IMPORTED_MODULE_7__user_user_service__["b" /* UserAuthenticationMessage */].Type.LOGIN || message.type === __WEBPACK_IMPORTED_MODULE_7__user_user_service__["b" /* UserAuthenticationMessage */].Type.LOGOUT; })
                .map(function () { return null; }), _this.attackChannel
                .filter(function (message) { return message.type === AttackMessage.Type.START || message.type === AttackMessage.Type.STOP; })
                .map(function (message) { return message.attack; })).first();
            return nextUpdateObservable
                .switchMap(function (attack) { return _this.pollCurrentAttack(attack); })
                .startWith(attack);
        });
    };
    AttackService.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_3__aws_http__["a" /* AwsHttp */] }, { type: __WEBPACK_IMPORTED_MODULE_6__restapi_error_handler__["a" /* ErrorHandler */] }, { type: __WEBPACK_IMPORTED_MODULE_7__user_user_service__["a" /* UserService */] }, { type: __WEBPACK_IMPORTED_MODULE_5__publisher_publisher_service__["a" /* PublisherService */] }]; };
    return AttackService;
}());

//# sourceMappingURL=attack.service.js.map

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ErrorHandler; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__);

var ErrorHandler = /** @class */ (function () {
    function ErrorHandler() {
    }
    ErrorHandler.prototype.parseResponse = function (response) {
        var errMsg = 'Internal Server Error';
        if (response['json'] && response.json() && response.json().hasOwnProperty('errorMessage')) {
            errMsg = response.json().errorMessage;
        }
        else if (response['message']) {
            errMsg = response.message;
        }
        return errMsg;
    };
    ErrorHandler.prototype.throwError = function (response, formatter) {
        var errMsg = this.parseResponse(response);
        console.error('Backend error: ' + errMsg);
        if (formatter) {
            errMsg = formatter(errMsg);
        }
        return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].throw(errMsg);
    };
    return ErrorHandler;
}());

//# sourceMappingURL=error-handler.js.map

/***/ }),
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return durationSecond; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return durationMinute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return durationHour; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return durationDay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return durationWeek; });
var durationSecond = 1e3;
var durationMinute = 6e4;
var durationHour = 36e5;
var durationDay = 864e5;
var durationWeek = 6048e5;


/***/ }),
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AbstractControlDirective */
/* unused harmony export AbstractFormGroupDirective */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return CheckboxControlValueAccessor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return ControlContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return NG_VALUE_ACCESSOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return COMPOSITION_BUFFER_MODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return DefaultValueAccessor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return NgControl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return NgControlStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return NgControlStatusGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return NgForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return NgModel; });
/* unused harmony export NgModelGroup */
/* unused harmony export RadioControlValueAccessor */
/* unused harmony export FormControlDirective */
/* unused harmony export FormControlName */
/* unused harmony export FormGroupDirective */
/* unused harmony export FormArrayName */
/* unused harmony export FormGroupName */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return NgSelectOption; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return SelectControlValueAccessor; });
/* unused harmony export SelectMultipleControlValueAccessor */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return CheckboxRequiredValidator; });
/* unused harmony export EmailValidator */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return MaxLengthValidator; });
/* unused harmony export MinLengthValidator */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return PatternValidator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return RequiredValidator; });
/* unused harmony export FormBuilder */
/* unused harmony export AbstractControl */
/* unused harmony export FormArray */
/* unused harmony export FormControl */
/* unused harmony export FormGroup */
/* unused harmony export NG_ASYNC_VALIDATORS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return NG_VALIDATORS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Validators; });
/* unused harmony export VERSION */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FormsModule; });
/* unused harmony export ReactiveFormsModule */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return InternalFormsSharedModule; });
/* unused harmony export ɵz */
/* unused harmony export ɵx */
/* unused harmony export ɵy */
/* unused harmony export ɵa */
/* unused harmony export ɵb */
/* unused harmony export ɵc */
/* unused harmony export ɵd */
/* unused harmony export ɵe */
/* unused harmony export ɵf */
/* unused harmony export ɵg */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return NgNoValidate; });
/* unused harmony export ɵbb */
/* unused harmony export ɵbc */
/* unused harmony export ɵh */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RadioControlRegistry; });
/* unused harmony export ɵbd */
/* unused harmony export ɵbe */
/* unused harmony export ɵj */
/* unused harmony export ɵk */
/* unused harmony export ɵl */
/* unused harmony export ɵn */
/* unused harmony export ɵm */
/* unused harmony export ɵo */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return NgSelectMultipleOption; });
/* unused harmony export ɵp */
/* unused harmony export ɵs */
/* unused harmony export ɵt */
/* unused harmony export ɵv */
/* unused harmony export ɵu */
/* unused harmony export ɵw */
/* unused harmony export ɵr */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_observable_forkJoin__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_observable_forkJoin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs_observable_forkJoin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_observable_fromPromise__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_observable_fromPromise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rxjs_observable_fromPromise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_operator_map__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_operator_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_rxjs_operator_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__angular_platform_browser__ = __webpack_require__(38);

/**
 * @license Angular v4.4.4
 * (c) 2010-2017 Google, Inc. https://angular.io/
 * License: MIT
 */





/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Base class for control directives.
 *
 * Only used internally in the forms module.
 *
 * \@stable
 * @abstract
 */
var AbstractControlDirective = (function () {
    function AbstractControlDirective() {
    }
    /**
     * The {\@link FormControl}, {\@link FormGroup}, or {\@link FormArray}
     * that backs this directive. Most properties fall through to that
     * instance.
     * @abstract
     * @return {?}
     */
    AbstractControlDirective.prototype.control = function () { };
    Object.defineProperty(AbstractControlDirective.prototype, "value", {
        /**
         * The value of the control.
         * @return {?}
         */
        get: function () { return this.control ? this.control.value : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "valid", {
        /**
         * A control is `valid` when its `status === VALID`.
         *
         * In order to have this status, the control must have passed all its
         * validation checks.
         * @return {?}
         */
        get: function () { return this.control ? this.control.valid : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "invalid", {
        /**
         * A control is `invalid` when its `status === INVALID`.
         *
         * In order to have this status, the control must have failed
         * at least one of its validation checks.
         * @return {?}
         */
        get: function () { return this.control ? this.control.invalid : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "pending", {
        /**
         * A control is `pending` when its `status === PENDING`.
         *
         * In order to have this status, the control must be in the
         * middle of conducting a validation check.
         * @return {?}
         */
        get: function () { return this.control ? this.control.pending : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "disabled", {
        /**
         * A control is `disabled` when its `status === DISABLED`.
         *
         * Disabled controls are exempt from validation checks and
         * are not included in the aggregate value of their ancestor
         * controls.
         * @return {?}
         */
        get: function () { return this.control ? this.control.disabled : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "enabled", {
        /**
         * A control is `enabled` as long as its `status !== DISABLED`.
         *
         * In other words, it has a status of `VALID`, `INVALID`, or
         * `PENDING`.
         * @return {?}
         */
        get: function () { return this.control ? this.control.enabled : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "errors", {
        /**
         * Returns any errors generated by failing validation. If there
         * are no errors, it will return null.
         * @return {?}
         */
        get: function () { return this.control ? this.control.errors : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "pristine", {
        /**
         * A control is `pristine` if the user has not yet changed
         * the value in the UI.
         *
         * Note that programmatic changes to a control's value will
         * *not* mark it dirty.
         * @return {?}
         */
        get: function () { return this.control ? this.control.pristine : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "dirty", {
        /**
         * A control is `dirty` if the user has changed the value
         * in the UI.
         *
         * Note that programmatic changes to a control's value will
         * *not* mark it dirty.
         * @return {?}
         */
        get: function () { return this.control ? this.control.dirty : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "touched", {
        /**
         * A control is marked `touched` once the user has triggered
         * a `blur` event on it.
         * @return {?}
         */
        get: function () { return this.control ? this.control.touched : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "untouched", {
        /**
         * A control is `untouched` if the user has not yet triggered
         * a `blur` event on it.
         * @return {?}
         */
        get: function () { return this.control ? this.control.untouched : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "statusChanges", {
        /**
         * Emits an event every time the validation status of the control
         * is re-calculated.
         * @return {?}
         */
        get: function () {
            return this.control ? this.control.statusChanges : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "valueChanges", {
        /**
         * Emits an event every time the value of the control changes, in
         * the UI or programmatically.
         * @return {?}
         */
        get: function () {
            return this.control ? this.control.valueChanges : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "path", {
        /**
         * Returns an array that represents the path from the top-level form
         * to this control. Each index is the string name of the control on
         * that level.
         * @return {?}
         */
        get: function () { return null; },
        enumerable: true,
        configurable: true
    });
    /**
     * Resets the form control. This means by default:
     *
     * * it is marked as `pristine`
     * * it is marked as `untouched`
     * * value is set to null
     *
     * For more information, see {\@link AbstractControl}.
     * @param {?=} value
     * @return {?}
     */
    AbstractControlDirective.prototype.reset = function (value) {
        if (value === void 0) { value = undefined; }
        if (this.control)
            this.control.reset(value);
    };
    /**
     * Returns true if the control with the given path has the error specified. Otherwise
     * returns false.
     *
     * If no path is given, it checks for the error on the present control.
     * @param {?} errorCode
     * @param {?=} path
     * @return {?}
     */
    AbstractControlDirective.prototype.hasError = function (errorCode, path) {
        return this.control ? this.control.hasError(errorCode, path) : false;
    };
    /**
     * Returns error data if the control with the given path has the error specified. Otherwise
     * returns null or undefined.
     *
     * If no path is given, it checks for the error on the present control.
     * @param {?} errorCode
     * @param {?=} path
     * @return {?}
     */
    AbstractControlDirective.prototype.getError = function (errorCode, path) {
        return this.control ? this.control.getError(errorCode, path) : null;
    };
    return AbstractControlDirective;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * A directive that contains multiple {\@link NgControl}s.
 *
 * Only used by the forms module.
 *
 * \@stable
 * @abstract
 */
var ControlContainer = (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](ControlContainer, _super);
    function ControlContainer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(ControlContainer.prototype, "formDirective", {
        /**
         * Get the form to which this container belongs.
         * @return {?}
         */
        get: function () { return null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ControlContainer.prototype, "path", {
        /**
         * Get the path to this container.
         * @return {?}
         */
        get: function () { return null; },
        enumerable: true,
        configurable: true
    });
    return ControlContainer;
}(AbstractControlDirective));
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @param {?} value
 * @return {?}
 */
function isEmptyInputValue(value) {
    // we don't check for string here so it also works with arrays
    return value == null || value.length === 0;
}
/**
 * Providers for validators to be used for {\@link FormControl}s in a form.
 *
 * Provide this using `multi: true` to add validators.
 *
 * \@stable
 */
var NG_VALIDATORS = new __WEBPACK_IMPORTED_MODULE_1__angular_core__["InjectionToken"]('NgValidators');
/**
 * Providers for asynchronous validators to be used for {\@link FormControl}s
 * in a form.
 *
 * Provide this using `multi: true` to add validators.
 *
 * See {\@link NG_VALIDATORS} for more details.
 *
 * \@stable
 */
var NG_ASYNC_VALIDATORS = new __WEBPACK_IMPORTED_MODULE_1__angular_core__["InjectionToken"]('NgAsyncValidators');
var EMAIL_REGEXP = /^(?=.{1,254}$)(?=.{1,64}@)[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+(\.[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+)*@[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?(\.[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?)*$/;
/**
 * Provides a set of validators used by form controls.
 *
 * A validator is a function that processes a {\@link FormControl} or collection of
 * controls and returns a map of errors. A null map means that validation has passed.
 *
 * ### Example
 *
 * ```typescript
 * var loginControl = new FormControl("", Validators.required)
 * ```
 *
 * \@stable
 */
var Validators = (function () {
    function Validators() {
    }
    /**
     * Validator that requires controls to have a value greater than a number.
     * @param {?} min
     * @return {?}
     */
    Validators.min = function (min) {
        return function (control) {
            if (isEmptyInputValue(control.value) || isEmptyInputValue(min)) {
                return null; // don't validate empty values to allow optional controls
            }
            var /** @type {?} */ value = parseFloat(control.value);
            // Controls with NaN values after parsing should be treated as not having a
            // minimum, per the HTML forms spec: https://www.w3.org/TR/html5/forms.html#attr-input-min
            return !isNaN(value) && value < min ? { 'min': { 'min': min, 'actual': control.value } } : null;
        };
    };
    /**
     * Validator that requires controls to have a value less than a number.
     * @param {?} max
     * @return {?}
     */
    Validators.max = function (max) {
        return function (control) {
            if (isEmptyInputValue(control.value) || isEmptyInputValue(max)) {
                return null; // don't validate empty values to allow optional controls
            }
            var /** @type {?} */ value = parseFloat(control.value);
            // Controls with NaN values after parsing should be treated as not having a
            // maximum, per the HTML forms spec: https://www.w3.org/TR/html5/forms.html#attr-input-max
            return !isNaN(value) && value > max ? { 'max': { 'max': max, 'actual': control.value } } : null;
        };
    };
    /**
     * Validator that requires controls to have a non-empty value.
     * @param {?} control
     * @return {?}
     */
    Validators.required = function (control) {
        return isEmptyInputValue(control.value) ? { 'required': true } : null;
    };
    /**
     * Validator that requires control value to be true.
     * @param {?} control
     * @return {?}
     */
    Validators.requiredTrue = function (control) {
        return control.value === true ? null : { 'required': true };
    };
    /**
     * Validator that performs email validation.
     * @param {?} control
     * @return {?}
     */
    Validators.email = function (control) {
        return EMAIL_REGEXP.test(control.value) ? null : { 'email': true };
    };
    /**
     * Validator that requires controls to have a value of a minimum length.
     * @param {?} minLength
     * @return {?}
     */
    Validators.minLength = function (minLength) {
        return function (control) {
            if (isEmptyInputValue(control.value)) {
                return null; // don't validate empty values to allow optional controls
            }
            var /** @type {?} */ length = control.value ? control.value.length : 0;
            return length < minLength ?
                { 'minlength': { 'requiredLength': minLength, 'actualLength': length } } :
                null;
        };
    };
    /**
     * Validator that requires controls to have a value of a maximum length.
     * @param {?} maxLength
     * @return {?}
     */
    Validators.maxLength = function (maxLength) {
        return function (control) {
            var /** @type {?} */ length = control.value ? control.value.length : 0;
            return length > maxLength ?
                { 'maxlength': { 'requiredLength': maxLength, 'actualLength': length } } :
                null;
        };
    };
    /**
     * Validator that requires a control to match a regex to its value.
     * @param {?} pattern
     * @return {?}
     */
    Validators.pattern = function (pattern) {
        if (!pattern)
            return Validators.nullValidator;
        var /** @type {?} */ regex;
        var /** @type {?} */ regexStr;
        if (typeof pattern === 'string') {
            regexStr = "^" + pattern + "$";
            regex = new RegExp(regexStr);
        }
        else {
            regexStr = pattern.toString();
            regex = pattern;
        }
        return function (control) {
            if (isEmptyInputValue(control.value)) {
                return null; // don't validate empty values to allow optional controls
            }
            var /** @type {?} */ value = control.value;
            return regex.test(value) ? null :
                { 'pattern': { 'requiredPattern': regexStr, 'actualValue': value } };
        };
    };
    /**
     * No-op validator.
     * @param {?} c
     * @return {?}
     */
    Validators.nullValidator = function (c) { return null; };
    /**
     * @param {?} validators
     * @return {?}
     */
    Validators.compose = function (validators) {
        if (!validators)
            return null;
        var /** @type {?} */ presentValidators = (validators.filter(isPresent));
        if (presentValidators.length == 0)
            return null;
        return function (control) {
            return _mergeErrors(_executeValidators(control, presentValidators));
        };
    };
    /**
     * @param {?} validators
     * @return {?}
     */
    Validators.composeAsync = function (validators) {
        if (!validators)
            return null;
        var /** @type {?} */ presentValidators = (validators.filter(isPresent));
        if (presentValidators.length == 0)
            return null;
        return function (control) {
            var /** @type {?} */ observables = _executeAsyncValidators(control, presentValidators).map(toObservable);
            return __WEBPACK_IMPORTED_MODULE_4_rxjs_operator_map__["map"].call(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_rxjs_observable_forkJoin__["forkJoin"])(observables), _mergeErrors);
        };
    };
    return Validators;
}());
/**
 * @param {?} o
 * @return {?}
 */
function isPresent(o) {
    return o != null;
}
/**
 * @param {?} r
 * @return {?}
 */
function toObservable(r) {
    var /** @type {?} */ obs = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵisPromise"])(r) ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_rxjs_observable_fromPromise__["fromPromise"])(r) : r;
    if (!(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵisObservable"])(obs))) {
        throw new Error("Expected validator to return Promise or Observable.");
    }
    return obs;
}
/**
 * @param {?} control
 * @param {?} validators
 * @return {?}
 */
function _executeValidators(control, validators) {
    return validators.map(function (v) { return v(control); });
}
/**
 * @param {?} control
 * @param {?} validators
 * @return {?}
 */
function _executeAsyncValidators(control, validators) {
    return validators.map(function (v) { return v(control); });
}
/**
 * @param {?} arrayOfErrors
 * @return {?}
 */
function _mergeErrors(arrayOfErrors) {
    var /** @type {?} */ res = arrayOfErrors.reduce(function (res, errors) {
        return errors != null ? Object.assign({}, /** @type {?} */ ((res)), errors) : ((res));
    }, {});
    return Object.keys(res).length === 0 ? null : res;
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Used to provide a {\@link ControlValueAccessor} for form controls.
 *
 * See {\@link DefaultValueAccessor} for how to implement one.
 * \@stable
 */
var NG_VALUE_ACCESSOR = new __WEBPACK_IMPORTED_MODULE_1__angular_core__["InjectionToken"]('NgValueAccessor');
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var CHECKBOX_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["forwardRef"])(function () { return CheckboxControlValueAccessor; }),
    multi: true,
};
/**
 * The accessor for writing a value and listening to changes on a checkbox input element.
 *
 *  ### Example
 *  ```
 *  <input type="checkbox" name="rememberLogin" ngModel>
 *  ```
 *
 *  \@stable
 */
var CheckboxControlValueAccessor = (function () {
    /**
     * @param {?} _renderer
     * @param {?} _elementRef
     */
    function CheckboxControlValueAccessor(_renderer, _elementRef) {
        this._renderer = _renderer;
        this._elementRef = _elementRef;
        this.onChange = function (_) { };
        this.onTouched = function () { };
    }
    /**
     * @param {?} value
     * @return {?}
     */
    CheckboxControlValueAccessor.prototype.writeValue = function (value) {
        this._renderer.setProperty(this._elementRef.nativeElement, 'checked', value);
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    CheckboxControlValueAccessor.prototype.registerOnChange = function (fn) { this.onChange = fn; };
    /**
     * @param {?} fn
     * @return {?}
     */
    CheckboxControlValueAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    CheckboxControlValueAccessor.prototype.setDisabledState = function (isDisabled) {
        this._renderer.setProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
    };
    return CheckboxControlValueAccessor;
}());
CheckboxControlValueAccessor.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"], args: [{
                selector: 'input[type=checkbox][formControlName],input[type=checkbox][formControl],input[type=checkbox][ngModel]',
                host: { '(change)': 'onChange($event.target.checked)', '(blur)': 'onTouched()' },
                providers: [CHECKBOX_VALUE_ACCESSOR]
            },] },
];
/**
 * @nocollapse
 */
CheckboxControlValueAccessor.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Renderer2"], },
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["ElementRef"], },
]; };
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var DEFAULT_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["forwardRef"])(function () { return DefaultValueAccessor; }),
    multi: true
};
/**
 * We must check whether the agent is Android because composition events
 * behave differently between iOS and Android.
 * @return {?}
 */
function _isAndroid() {
    var /** @type {?} */ userAgent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__angular_platform_browser__["ɵgetDOM"])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__angular_platform_browser__["ɵgetDOM"])().getUserAgent() : '';
    return /android (\d+)/.test(userAgent.toLowerCase());
}
/**
 * Turn this mode on if you want form directives to buffer IME input until compositionend
 * \@experimental
 */
var COMPOSITION_BUFFER_MODE = new __WEBPACK_IMPORTED_MODULE_1__angular_core__["InjectionToken"]('CompositionEventMode');
/**
 * The default accessor for writing a value and listening to changes that is used by the
 * {\@link NgModel}, {\@link FormControlDirective}, and {\@link FormControlName} directives.
 *
 *  ### Example
 *  ```
 *  <input type="text" name="searchQuery" ngModel>
 *  ```
 *
 *  \@stable
 */
var DefaultValueAccessor = (function () {
    /**
     * @param {?} _renderer
     * @param {?} _elementRef
     * @param {?} _compositionMode
     */
    function DefaultValueAccessor(_renderer, _elementRef, _compositionMode) {
        this._renderer = _renderer;
        this._elementRef = _elementRef;
        this._compositionMode = _compositionMode;
        this.onChange = function (_) { };
        this.onTouched = function () { };
        /**
         * Whether the user is creating a composition string (IME events).
         */
        this._composing = false;
        if (this._compositionMode == null) {
            this._compositionMode = !_isAndroid();
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    DefaultValueAccessor.prototype.writeValue = function (value) {
        var /** @type {?} */ normalizedValue = value == null ? '' : value;
        this._renderer.setProperty(this._elementRef.nativeElement, 'value', normalizedValue);
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    DefaultValueAccessor.prototype.registerOnChange = function (fn) { this.onChange = fn; };
    /**
     * @param {?} fn
     * @return {?}
     */
    DefaultValueAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    DefaultValueAccessor.prototype.setDisabledState = function (isDisabled) {
        this._renderer.setProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
    };
    /**
     * \@internal
     * @param {?} value
     * @return {?}
     */
    DefaultValueAccessor.prototype._handleInput = function (value) {
        if (!this._compositionMode || (this._compositionMode && !this._composing)) {
            this.onChange(value);
        }
    };
    /**
     * \@internal
     * @return {?}
     */
    DefaultValueAccessor.prototype._compositionStart = function () { this._composing = true; };
    /**
     * \@internal
     * @param {?} value
     * @return {?}
     */
    DefaultValueAccessor.prototype._compositionEnd = function (value) {
        this._composing = false;
        this._compositionMode && this.onChange(value);
    };
    return DefaultValueAccessor;
}());
DefaultValueAccessor.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"], args: [{
                selector: 'input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]',
                // TODO: vsavkin replace the above selector with the one below it once
                // https://github.com/angular/angular/issues/3011 is implemented
                // selector: '[ngModel],[formControl],[formControlName]',
                host: {
                    '(input)': '_handleInput($event.target.value)',
                    '(blur)': 'onTouched()',
                    '(compositionstart)': '_compositionStart()',
                    '(compositionend)': '_compositionEnd($event.target.value)'
                },
                providers: [DEFAULT_VALUE_ACCESSOR]
            },] },
];
/**
 * @nocollapse
 */
DefaultValueAccessor.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Renderer2"], },
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["ElementRef"], },
    { type: undefined, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"], args: [COMPOSITION_BUFFER_MODE,] },] },
]; };
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @param {?} validator
 * @return {?}
 */
function normalizeValidator(validator) {
    if (((validator)).validate) {
        return function (c) { return ((validator)).validate(c); };
    }
    else {
        return (validator);
    }
}
/**
 * @param {?} validator
 * @return {?}
 */
function normalizeAsyncValidator(validator) {
    if (((validator)).validate) {
        return function (c) { return ((validator)).validate(c); };
    }
    else {
        return (validator);
    }
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var NUMBER_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["forwardRef"])(function () { return NumberValueAccessor; }),
    multi: true
};
/**
 * The accessor for writing a number value and listening to changes that is used by the
 * {\@link NgModel}, {\@link FormControlDirective}, and {\@link FormControlName} directives.
 *
 *  ### Example
 *  ```
 *  <input type="number" [(ngModel)]="age">
 *  ```
 */
var NumberValueAccessor = (function () {
    /**
     * @param {?} _renderer
     * @param {?} _elementRef
     */
    function NumberValueAccessor(_renderer, _elementRef) {
        this._renderer = _renderer;
        this._elementRef = _elementRef;
        this.onChange = function (_) { };
        this.onTouched = function () { };
    }
    /**
     * @param {?} value
     * @return {?}
     */
    NumberValueAccessor.prototype.writeValue = function (value) {
        // The value needs to be normalized for IE9, otherwise it is set to 'null' when null
        var /** @type {?} */ normalizedValue = value == null ? '' : value;
        this._renderer.setProperty(this._elementRef.nativeElement, 'value', normalizedValue);
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    NumberValueAccessor.prototype.registerOnChange = function (fn) {
        this.onChange = function (value) { fn(value == '' ? null : parseFloat(value)); };
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    NumberValueAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    NumberValueAccessor.prototype.setDisabledState = function (isDisabled) {
        this._renderer.setProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
    };
    return NumberValueAccessor;
}());
NumberValueAccessor.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"], args: [{
                selector: 'input[type=number][formControlName],input[type=number][formControl],input[type=number][ngModel]',
                host: {
                    '(change)': 'onChange($event.target.value)',
                    '(input)': 'onChange($event.target.value)',
                    '(blur)': 'onTouched()'
                },
                providers: [NUMBER_VALUE_ACCESSOR]
            },] },
];
/**
 * @nocollapse
 */
NumberValueAccessor.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Renderer2"], },
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["ElementRef"], },
]; };
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @return {?}
 */
function unimplemented() {
    throw new Error('unimplemented');
}
/**
 * A base class that all control directive extend.
 * It binds a {\@link FormControl} object to a DOM element.
 *
 * Used internally by Angular forms.
 *
 * \@stable
 * @abstract
 */
var NgControl = (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](NgControl, _super);
    function NgControl() {
        var _this = _super.apply(this, arguments) || this;
        /**
         * \@internal
         */
        _this._parent = null;
        _this.name = null;
        _this.valueAccessor = null;
        /**
         * \@internal
         */
        _this._rawValidators = [];
        /**
         * \@internal
         */
        _this._rawAsyncValidators = [];
        return _this;
    }
    Object.defineProperty(NgControl.prototype, "validator", {
        /**
         * @return {?}
         */
        get: function () { return (unimplemented()); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgControl.prototype, "asyncValidator", {
        /**
         * @return {?}
         */
        get: function () { return (unimplemented()); },
        enumerable: true,
        configurable: true
    });
    /**
     * @abstract
     * @param {?} newValue
     * @return {?}
     */
    NgControl.prototype.viewToModelUpdate = function (newValue) { };
    return NgControl;
}(AbstractControlDirective));
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var RADIO_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["forwardRef"])(function () { return RadioControlValueAccessor; }),
    multi: true
};
/**
 * Internal class used by Angular to uncheck radio buttons with the matching name.
 */
var RadioControlRegistry = (function () {
    function RadioControlRegistry() {
        this._accessors = [];
    }
    /**
     * @param {?} control
     * @param {?} accessor
     * @return {?}
     */
    RadioControlRegistry.prototype.add = function (control, accessor) {
        this._accessors.push([control, accessor]);
    };
    /**
     * @param {?} accessor
     * @return {?}
     */
    RadioControlRegistry.prototype.remove = function (accessor) {
        for (var /** @type {?} */ i = this._accessors.length - 1; i >= 0; --i) {
            if (this._accessors[i][1] === accessor) {
                this._accessors.splice(i, 1);
                return;
            }
        }
    };
    /**
     * @param {?} accessor
     * @return {?}
     */
    RadioControlRegistry.prototype.select = function (accessor) {
        var _this = this;
        this._accessors.forEach(function (c) {
            if (_this._isSameGroup(c, accessor) && c[1] !== accessor) {
                c[1].fireUncheck(accessor.value);
            }
        });
    };
    /**
     * @param {?} controlPair
     * @param {?} accessor
     * @return {?}
     */
    RadioControlRegistry.prototype._isSameGroup = function (controlPair, accessor) {
        if (!controlPair[0].control)
            return false;
        return controlPair[0]._parent === accessor._control._parent &&
            controlPair[1].name === accessor.name;
    };
    return RadioControlRegistry;
}());
RadioControlRegistry.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Injectable"] },
];
/**
 * @nocollapse
 */
RadioControlRegistry.ctorParameters = function () { return []; };
/**
 * \@whatItDoes Writes radio control values and listens to radio control changes.
 *
 * Used by {\@link NgModel}, {\@link FormControlDirective}, and {\@link FormControlName}
 * to keep the view synced with the {\@link FormControl} model.
 *
 * \@howToUse
 *
 * If you have imported the {\@link FormsModule} or the {\@link ReactiveFormsModule}, this
 * value accessor will be active on any radio control that has a form directive. You do
 * **not** need to add a special selector to activate it.
 *
 * ### How to use radio buttons with form directives
 *
 * To use radio buttons in a template-driven form, you'll want to ensure that radio buttons
 * in the same group have the same `name` attribute.  Radio buttons with different `name`
 * attributes do not affect each other.
 *
 * {\@example forms/ts/radioButtons/radio_button_example.ts region='TemplateDriven'}
 *
 * When using radio buttons in a reactive form, radio buttons in the same group should have the
 * same `formControlName`. You can also add a `name` attribute, but it's optional.
 *
 * {\@example forms/ts/reactiveRadioButtons/reactive_radio_button_example.ts region='Reactive'}
 *
 *  * **npm package**: `\@angular/forms`
 *
 *  \@stable
 */
var RadioControlValueAccessor = (function () {
    /**
     * @param {?} _renderer
     * @param {?} _elementRef
     * @param {?} _registry
     * @param {?} _injector
     */
    function RadioControlValueAccessor(_renderer, _elementRef, _registry, _injector) {
        this._renderer = _renderer;
        this._elementRef = _elementRef;
        this._registry = _registry;
        this._injector = _injector;
        this.onChange = function () { };
        this.onTouched = function () { };
    }
    /**
     * @return {?}
     */
    RadioControlValueAccessor.prototype.ngOnInit = function () {
        this._control = this._injector.get(NgControl);
        this._checkName();
        this._registry.add(this._control, this);
    };
    /**
     * @return {?}
     */
    RadioControlValueAccessor.prototype.ngOnDestroy = function () { this._registry.remove(this); };
    /**
     * @param {?} value
     * @return {?}
     */
    RadioControlValueAccessor.prototype.writeValue = function (value) {
        this._state = value === this.value;
        this._renderer.setProperty(this._elementRef.nativeElement, 'checked', this._state);
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    RadioControlValueAccessor.prototype.registerOnChange = function (fn) {
        var _this = this;
        this._fn = fn;
        this.onChange = function () {
            fn(_this.value);
            _this._registry.select(_this);
        };
    };
    /**
     * @param {?} value
     * @return {?}
     */
    RadioControlValueAccessor.prototype.fireUncheck = function (value) { this.writeValue(value); };
    /**
     * @param {?} fn
     * @return {?}
     */
    RadioControlValueAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    RadioControlValueAccessor.prototype.setDisabledState = function (isDisabled) {
        this._renderer.setProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
    };
    /**
     * @return {?}
     */
    RadioControlValueAccessor.prototype._checkName = function () {
        if (this.name && this.formControlName && this.name !== this.formControlName) {
            this._throwNameError();
        }
        if (!this.name && this.formControlName)
            this.name = this.formControlName;
    };
    /**
     * @return {?}
     */
    RadioControlValueAccessor.prototype._throwNameError = function () {
        throw new Error("\n      If you define both a name and a formControlName attribute on your radio button, their values\n      must match. Ex: <input type=\"radio\" formControlName=\"food\" name=\"food\">\n    ");
    };
    return RadioControlValueAccessor;
}());
RadioControlValueAccessor.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"], args: [{
                selector: 'input[type=radio][formControlName],input[type=radio][formControl],input[type=radio][ngModel]',
                host: { '(change)': 'onChange()', '(blur)': 'onTouched()' },
                providers: [RADIO_VALUE_ACCESSOR]
            },] },
];
/**
 * @nocollapse
 */
RadioControlValueAccessor.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Renderer2"], },
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["ElementRef"], },
    { type: RadioControlRegistry, },
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Injector"], },
]; };
RadioControlValueAccessor.propDecorators = {
    'name': [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"] },],
    'formControlName': [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"] },],
    'value': [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"] },],
};
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var RANGE_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["forwardRef"])(function () { return RangeValueAccessor; }),
    multi: true
};
/**
 * The accessor for writing a range value and listening to changes that is used by the
 * {\@link NgModel}, {\@link FormControlDirective}, and {\@link FormControlName} directives.
 *
 *  ### Example
 *  ```
 *  <input type="range" [(ngModel)]="age" >
 *  ```
 */
var RangeValueAccessor = (function () {
    /**
     * @param {?} _renderer
     * @param {?} _elementRef
     */
    function RangeValueAccessor(_renderer, _elementRef) {
        this._renderer = _renderer;
        this._elementRef = _elementRef;
        this.onChange = function (_) { };
        this.onTouched = function () { };
    }
    /**
     * @param {?} value
     * @return {?}
     */
    RangeValueAccessor.prototype.writeValue = function (value) {
        this._renderer.setProperty(this._elementRef.nativeElement, 'value', parseFloat(value));
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    RangeValueAccessor.prototype.registerOnChange = function (fn) {
        this.onChange = function (value) { fn(value == '' ? null : parseFloat(value)); };
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    RangeValueAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    RangeValueAccessor.prototype.setDisabledState = function (isDisabled) {
        this._renderer.setProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
    };
    return RangeValueAccessor;
}());
RangeValueAccessor.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"], args: [{
                selector: 'input[type=range][formControlName],input[type=range][formControl],input[type=range][ngModel]',
                host: {
                    '(change)': 'onChange($event.target.value)',
                    '(input)': 'onChange($event.target.value)',
                    '(blur)': 'onTouched()'
                },
                providers: [RANGE_VALUE_ACCESSOR]
            },] },
];
/**
 * @nocollapse
 */
RangeValueAccessor.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Renderer2"], },
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["ElementRef"], },
]; };
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var SELECT_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["forwardRef"])(function () { return SelectControlValueAccessor; }),
    multi: true
};
/**
 * @param {?} id
 * @param {?} value
 * @return {?}
 */
function _buildValueString(id, value) {
    if (id == null)
        return "" + value;
    if (value && typeof value === 'object')
        value = 'Object';
    return (id + ": " + value).slice(0, 50);
}
/**
 * @param {?} valueString
 * @return {?}
 */
function _extractId(valueString) {
    return valueString.split(':')[0];
}
/**
 * \@whatItDoes Writes values and listens to changes on a select element.
 *
 * Used by {\@link NgModel}, {\@link FormControlDirective}, and {\@link FormControlName}
 * to keep the view synced with the {\@link FormControl} model.
 *
 * \@howToUse
 *
 * If you have imported the {\@link FormsModule} or the {\@link ReactiveFormsModule}, this
 * value accessor will be active on any select control that has a form directive. You do
 * **not** need to add a special selector to activate it.
 *
 * ### How to use select controls with form directives
 *
 * To use a select in a template-driven form, simply add an `ngModel` and a `name`
 * attribute to the main `<select>` tag.
 *
 * If your option values are simple strings, you can bind to the normal `value` property
 * on the option.  If your option values happen to be objects (and you'd like to save the
 * selection in your form as an object), use `ngValue` instead:
 *
 * {\@example forms/ts/selectControl/select_control_example.ts region='Component'}
 *
 * In reactive forms, you'll also want to add your form directive (`formControlName` or
 * `formControl`) on the main `<select>` tag. Like in the former example, you have the
 * choice of binding to the  `value` or `ngValue` property on the select's options.
 *
 * {\@example forms/ts/reactiveSelectControl/reactive_select_control_example.ts region='Component'}
 *
 * ### Caveat: Option selection
 *
 * Angular uses object identity to select option. It's possible for the identities of items
 * to change while the data does not. This can happen, for example, if the items are produced
 * from an RPC to the server, and that RPC is re-run. Even if the data hasn't changed, the
 * second response will produce objects with different identities.
 *
 * To customize the default option comparison algorithm, `<select>` supports `compareWith` input.
 * `compareWith` takes a **function** which has two arguments: `option1` and `option2`.
 * If `compareWith` is given, Angular selects option by the return value of the function.
 *
 * #### Syntax
 *
 * ```
 * <select [compareWith]="compareFn"  [(ngModel)]="selectedCountries">
 *     <option *ngFor="let country of countries" [ngValue]="country">
 *         {{country.name}}
 *     </option>
 * </select>
 *
 * compareFn(c1: Country, c2: Country): boolean {
 *     return c1 && c2 ? c1.id === c2.id : c1 === c2;
 * }
 * ```
 *
 * Note: We listen to the 'change' event because 'input' events aren't fired
 * for selects in Firefox and IE:
 * https://bugzilla.mozilla.org/show_bug.cgi?id=1024350
 * https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/4660045/
 *
 * * **npm package**: `\@angular/forms`
 *
 * \@stable
 */
var SelectControlValueAccessor = (function () {
    /**
     * @param {?} _renderer
     * @param {?} _elementRef
     */
    function SelectControlValueAccessor(_renderer, _elementRef) {
        this._renderer = _renderer;
        this._elementRef = _elementRef;
        /**
         * \@internal
         */
        this._optionMap = new Map();
        /**
         * \@internal
         */
        this._idCounter = 0;
        this.onChange = function (_) { };
        this.onTouched = function () { };
        this._compareWith = __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵlooseIdentical"];
    }
    Object.defineProperty(SelectControlValueAccessor.prototype, "compareWith", {
        /**
         * @param {?} fn
         * @return {?}
         */
        set: function (fn) {
            if (typeof fn !== 'function') {
                throw new Error("compareWith must be a function, but received " + JSON.stringify(fn));
            }
            this._compareWith = fn;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} value
     * @return {?}
     */
    SelectControlValueAccessor.prototype.writeValue = function (value) {
        this.value = value;
        var /** @type {?} */ id = this._getOptionId(value);
        if (id == null) {
            this._renderer.setProperty(this._elementRef.nativeElement, 'selectedIndex', -1);
        }
        var /** @type {?} */ valueString = _buildValueString(id, value);
        this._renderer.setProperty(this._elementRef.nativeElement, 'value', valueString);
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    SelectControlValueAccessor.prototype.registerOnChange = function (fn) {
        var _this = this;
        this.onChange = function (valueString) {
            _this.value = _this._getOptionValue(valueString);
            fn(_this.value);
        };
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    SelectControlValueAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    SelectControlValueAccessor.prototype.setDisabledState = function (isDisabled) {
        this._renderer.setProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
    };
    /**
     * \@internal
     * @return {?}
     */
    SelectControlValueAccessor.prototype._registerOption = function () { return (this._idCounter++).toString(); };
    /**
     * \@internal
     * @param {?} value
     * @return {?}
     */
    SelectControlValueAccessor.prototype._getOptionId = function (value) {
        for (var _i = 0, _a = Array.from(this._optionMap.keys()); _i < _a.length; _i++) {
            var id = _a[_i];
            if (this._compareWith(this._optionMap.get(id), value))
                return id;
        }
        return null;
    };
    /**
     * \@internal
     * @param {?} valueString
     * @return {?}
     */
    SelectControlValueAccessor.prototype._getOptionValue = function (valueString) {
        var /** @type {?} */ id = _extractId(valueString);
        return this._optionMap.has(id) ? this._optionMap.get(id) : valueString;
    };
    return SelectControlValueAccessor;
}());
SelectControlValueAccessor.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"], args: [{
                selector: 'select:not([multiple])[formControlName],select:not([multiple])[formControl],select:not([multiple])[ngModel]',
                host: { '(change)': 'onChange($event.target.value)', '(blur)': 'onTouched()' },
                providers: [SELECT_VALUE_ACCESSOR]
            },] },
];
/**
 * @nocollapse
 */
SelectControlValueAccessor.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Renderer2"], },
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["ElementRef"], },
]; };
SelectControlValueAccessor.propDecorators = {
    'compareWith': [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"] },],
};
/**
 * \@whatItDoes Marks `<option>` as dynamic, so Angular can be notified when options change.
 *
 * \@howToUse
 *
 * See docs for {\@link SelectControlValueAccessor} for usage examples.
 *
 * \@stable
 */
var NgSelectOption = (function () {
    /**
     * @param {?} _element
     * @param {?} _renderer
     * @param {?} _select
     */
    function NgSelectOption(_element, _renderer, _select) {
        this._element = _element;
        this._renderer = _renderer;
        this._select = _select;
        if (this._select)
            this.id = this._select._registerOption();
    }
    Object.defineProperty(NgSelectOption.prototype, "ngValue", {
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            if (this._select == null)
                return;
            this._select._optionMap.set(this.id, value);
            this._setElementValue(_buildValueString(this.id, value));
            this._select.writeValue(this._select.value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgSelectOption.prototype, "value", {
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._setElementValue(value);
            if (this._select)
                this._select.writeValue(this._select.value);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * \@internal
     * @param {?} value
     * @return {?}
     */
    NgSelectOption.prototype._setElementValue = function (value) {
        this._renderer.setProperty(this._element.nativeElement, 'value', value);
    };
    /**
     * @return {?}
     */
    NgSelectOption.prototype.ngOnDestroy = function () {
        if (this._select) {
            this._select._optionMap.delete(this.id);
            this._select.writeValue(this._select.value);
        }
    };
    return NgSelectOption;
}());
NgSelectOption.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"], args: [{ selector: 'option' },] },
];
/**
 * @nocollapse
 */
NgSelectOption.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["ElementRef"], },
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Renderer2"], },
    { type: SelectControlValueAccessor, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Host"] },] },
]; };
NgSelectOption.propDecorators = {
    'ngValue': [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"], args: ['ngValue',] },],
    'value': [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"], args: ['value',] },],
};
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var SELECT_MULTIPLE_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["forwardRef"])(function () { return SelectMultipleControlValueAccessor; }),
    multi: true
};
/**
 * @param {?} id
 * @param {?} value
 * @return {?}
 */
function _buildValueString$1(id, value) {
    if (id == null)
        return "" + value;
    if (typeof value === 'string')
        value = "'" + value + "'";
    if (value && typeof value === 'object')
        value = 'Object';
    return (id + ": " + value).slice(0, 50);
}
/**
 * @param {?} valueString
 * @return {?}
 */
function _extractId$1(valueString) {
    return valueString.split(':')[0];
}
/**
 * The accessor for writing a value and listening to changes on a select element.
 *
 *  ### Caveat: Options selection
 *
 * Angular uses object identity to select options. It's possible for the identities of items
 * to change while the data does not. This can happen, for example, if the items are produced
 * from an RPC to the server, and that RPC is re-run. Even if the data hasn't changed, the
 * second response will produce objects with different identities.
 *
 * To customize the default option comparison algorithm, `<select multiple>` supports `compareWith`
 * input. `compareWith` takes a **function** which has two arguments: `option1` and `option2`.
 * If `compareWith` is given, Angular selects options by the return value of the function.
 *
 * #### Syntax
 *
 * ```
 * <select multiple [compareWith]="compareFn"  [(ngModel)]="selectedCountries">
 *     <option *ngFor="let country of countries" [ngValue]="country">
 *         {{country.name}}
 *     </option>
 * </select>
 *
 * compareFn(c1: Country, c2: Country): boolean {
 *     return c1 && c2 ? c1.id === c2.id : c1 === c2;
 * }
 * ```
 *
 * \@stable
 */
var SelectMultipleControlValueAccessor = (function () {
    /**
     * @param {?} _renderer
     * @param {?} _elementRef
     */
    function SelectMultipleControlValueAccessor(_renderer, _elementRef) {
        this._renderer = _renderer;
        this._elementRef = _elementRef;
        /**
         * \@internal
         */
        this._optionMap = new Map();
        /**
         * \@internal
         */
        this._idCounter = 0;
        this.onChange = function (_) { };
        this.onTouched = function () { };
        this._compareWith = __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵlooseIdentical"];
    }
    Object.defineProperty(SelectMultipleControlValueAccessor.prototype, "compareWith", {
        /**
         * @param {?} fn
         * @return {?}
         */
        set: function (fn) {
            if (typeof fn !== 'function') {
                throw new Error("compareWith must be a function, but received " + JSON.stringify(fn));
            }
            this._compareWith = fn;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} value
     * @return {?}
     */
    SelectMultipleControlValueAccessor.prototype.writeValue = function (value) {
        var _this = this;
        this.value = value;
        var /** @type {?} */ optionSelectedStateSetter;
        if (Array.isArray(value)) {
            // convert values to ids
            var /** @type {?} */ ids_1 = value.map(function (v) { return _this._getOptionId(v); });
            optionSelectedStateSetter = function (opt, o) { opt._setSelected(ids_1.indexOf(o.toString()) > -1); };
        }
        else {
            optionSelectedStateSetter = function (opt, o) { opt._setSelected(false); };
        }
        this._optionMap.forEach(optionSelectedStateSetter);
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    SelectMultipleControlValueAccessor.prototype.registerOnChange = function (fn) {
        var _this = this;
        this.onChange = function (_) {
            var /** @type {?} */ selected = [];
            if (_.hasOwnProperty('selectedOptions')) {
                var /** @type {?} */ options = _.selectedOptions;
                for (var /** @type {?} */ i = 0; i < options.length; i++) {
                    var /** @type {?} */ opt = options.item(i);
                    var /** @type {?} */ val = _this._getOptionValue(opt.value);
                    selected.push(val);
                }
            }
            else {
                var /** @type {?} */ options = (_.options);
                for (var /** @type {?} */ i = 0; i < options.length; i++) {
                    var /** @type {?} */ opt = options.item(i);
                    if (opt.selected) {
                        var /** @type {?} */ val = _this._getOptionValue(opt.value);
                        selected.push(val);
                    }
                }
            }
            _this.value = selected;
            fn(selected);
        };
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    SelectMultipleControlValueAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    SelectMultipleControlValueAccessor.prototype.setDisabledState = function (isDisabled) {
        this._renderer.setProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
    };
    /**
     * \@internal
     * @param {?} value
     * @return {?}
     */
    SelectMultipleControlValueAccessor.prototype._registerOption = function (value) {
        var /** @type {?} */ id = (this._idCounter++).toString();
        this._optionMap.set(id, value);
        return id;
    };
    /**
     * \@internal
     * @param {?} value
     * @return {?}
     */
    SelectMultipleControlValueAccessor.prototype._getOptionId = function (value) {
        for (var _i = 0, _a = Array.from(this._optionMap.keys()); _i < _a.length; _i++) {
            var id = _a[_i];
            if (this._compareWith(/** @type {?} */ ((this._optionMap.get(id)))._value, value))
                return id;
        }
        return null;
    };
    /**
     * \@internal
     * @param {?} valueString
     * @return {?}
     */
    SelectMultipleControlValueAccessor.prototype._getOptionValue = function (valueString) {
        var /** @type {?} */ id = _extractId$1(valueString);
        return this._optionMap.has(id) ? ((this._optionMap.get(id)))._value : valueString;
    };
    return SelectMultipleControlValueAccessor;
}());
SelectMultipleControlValueAccessor.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"], args: [{
                selector: 'select[multiple][formControlName],select[multiple][formControl],select[multiple][ngModel]',
                host: { '(change)': 'onChange($event.target)', '(blur)': 'onTouched()' },
                providers: [SELECT_MULTIPLE_VALUE_ACCESSOR]
            },] },
];
/**
 * @nocollapse
 */
SelectMultipleControlValueAccessor.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Renderer2"], },
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["ElementRef"], },
]; };
SelectMultipleControlValueAccessor.propDecorators = {
    'compareWith': [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"] },],
};
/**
 * Marks `<option>` as dynamic, so Angular can be notified when options change.
 *
 * ### Example
 *
 * ```
 * <select multiple name="city" ngModel>
 *   <option *ngFor="let c of cities" [value]="c"></option>
 * </select>
 * ```
 */
var NgSelectMultipleOption = (function () {
    /**
     * @param {?} _element
     * @param {?} _renderer
     * @param {?} _select
     */
    function NgSelectMultipleOption(_element, _renderer, _select) {
        this._element = _element;
        this._renderer = _renderer;
        this._select = _select;
        if (this._select) {
            this.id = this._select._registerOption(this);
        }
    }
    Object.defineProperty(NgSelectMultipleOption.prototype, "ngValue", {
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            if (this._select == null)
                return;
            this._value = value;
            this._setElementValue(_buildValueString$1(this.id, value));
            this._select.writeValue(this._select.value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgSelectMultipleOption.prototype, "value", {
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            if (this._select) {
                this._value = value;
                this._setElementValue(_buildValueString$1(this.id, value));
                this._select.writeValue(this._select.value);
            }
            else {
                this._setElementValue(value);
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * \@internal
     * @param {?} value
     * @return {?}
     */
    NgSelectMultipleOption.prototype._setElementValue = function (value) {
        this._renderer.setProperty(this._element.nativeElement, 'value', value);
    };
    /**
     * \@internal
     * @param {?} selected
     * @return {?}
     */
    NgSelectMultipleOption.prototype._setSelected = function (selected) {
        this._renderer.setProperty(this._element.nativeElement, 'selected', selected);
    };
    /**
     * @return {?}
     */
    NgSelectMultipleOption.prototype.ngOnDestroy = function () {
        if (this._select) {
            this._select._optionMap.delete(this.id);
            this._select.writeValue(this._select.value);
        }
    };
    return NgSelectMultipleOption;
}());
NgSelectMultipleOption.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"], args: [{ selector: 'option' },] },
];
/**
 * @nocollapse
 */
NgSelectMultipleOption.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["ElementRef"], },
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Renderer2"], },
    { type: SelectMultipleControlValueAccessor, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Host"] },] },
]; };
NgSelectMultipleOption.propDecorators = {
    'ngValue': [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"], args: ['ngValue',] },],
    'value': [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"], args: ['value',] },],
};
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @param {?} name
 * @param {?} parent
 * @return {?}
 */
function controlPath(name, parent) {
    return ((parent.path)).concat([name]);
}
/**
 * @param {?} control
 * @param {?} dir
 * @return {?}
 */
function setUpControl(control, dir) {
    if (!control)
        _throwError(dir, 'Cannot find control with');
    if (!dir.valueAccessor)
        _throwError(dir, 'No value accessor for form control with');
    control.validator = Validators.compose([/** @type {?} */ ((control.validator)), dir.validator]);
    control.asyncValidator = Validators.composeAsync([/** @type {?} */ ((control.asyncValidator)), dir.asyncValidator]); /** @type {?} */
    ((dir.valueAccessor)).writeValue(control.value); /** @type {?} */
    ((
    // view -> model
    dir.valueAccessor)).registerOnChange(function (newValue) {
        dir.viewToModelUpdate(newValue);
        control.markAsDirty();
        control.setValue(newValue, { emitModelToViewChange: false });
    }); /** @type {?} */
    ((
    // touched
    dir.valueAccessor)).registerOnTouched(function () { return control.markAsTouched(); });
    control.registerOnChange(function (newValue, emitModelEvent) {
        ((
        // control -> view
        dir.valueAccessor)).writeValue(newValue);
        // control -> ngModel
        if (emitModelEvent)
            dir.viewToModelUpdate(newValue);
    });
    if (((dir.valueAccessor)).setDisabledState) {
        control.registerOnDisabledChange(function (isDisabled) { /** @type {?} */ ((((dir.valueAccessor)).setDisabledState))(isDisabled); });
    }
    // re-run validation when validator binding changes, e.g. minlength=3 -> minlength=4
    dir._rawValidators.forEach(function (validator) {
        if (((validator)).registerOnValidatorChange)
            ((((validator)).registerOnValidatorChange))(function () { return control.updateValueAndValidity(); });
    });
    dir._rawAsyncValidators.forEach(function (validator) {
        if (((validator)).registerOnValidatorChange)
            ((((validator)).registerOnValidatorChange))(function () { return control.updateValueAndValidity(); });
    });
}
/**
 * @param {?} control
 * @param {?} dir
 * @return {?}
 */
function cleanUpControl(control, dir) {
    ((dir.valueAccessor)).registerOnChange(function () { return _noControlError(dir); }); /** @type {?} */
    ((dir.valueAccessor)).registerOnTouched(function () { return _noControlError(dir); });
    dir._rawValidators.forEach(function (validator) {
        if (validator.registerOnValidatorChange) {
            validator.registerOnValidatorChange(null);
        }
    });
    dir._rawAsyncValidators.forEach(function (validator) {
        if (validator.registerOnValidatorChange) {
            validator.registerOnValidatorChange(null);
        }
    });
    if (control)
        control._clearChangeFns();
}
/**
 * @param {?} control
 * @param {?} dir
 * @return {?}
 */
function setUpFormContainer(control, dir) {
    if (control == null)
        _throwError(dir, 'Cannot find control with');
    control.validator = Validators.compose([control.validator, dir.validator]);
    control.asyncValidator = Validators.composeAsync([control.asyncValidator, dir.asyncValidator]);
}
/**
 * @param {?} dir
 * @return {?}
 */
function _noControlError(dir) {
    return _throwError(dir, 'There is no FormControl instance attached to form control element with');
}
/**
 * @param {?} dir
 * @param {?} message
 * @return {?}
 */
function _throwError(dir, message) {
    var /** @type {?} */ messageEnd;
    if (((dir.path)).length > 1) {
        messageEnd = "path: '" + ((dir.path)).join(' -> ') + "'";
    }
    else if (((dir.path))[0]) {
        messageEnd = "name: '" + dir.path + "'";
    }
    else {
        messageEnd = 'unspecified name attribute';
    }
    throw new Error(message + " " + messageEnd);
}
/**
 * @param {?} validators
 * @return {?}
 */
function composeValidators(validators) {
    return validators != null ? Validators.compose(validators.map(normalizeValidator)) : null;
}
/**
 * @param {?} validators
 * @return {?}
 */
function composeAsyncValidators(validators) {
    return validators != null ? Validators.composeAsync(validators.map(normalizeAsyncValidator)) :
        null;
}
/**
 * @param {?} changes
 * @param {?} viewModel
 * @return {?}
 */
function isPropertyUpdated(changes, viewModel) {
    if (!changes.hasOwnProperty('model'))
        return false;
    var /** @type {?} */ change = changes['model'];
    if (change.isFirstChange())
        return true;
    return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵlooseIdentical"])(viewModel, change.currentValue);
}
var BUILTIN_ACCESSORS = [
    CheckboxControlValueAccessor,
    RangeValueAccessor,
    NumberValueAccessor,
    SelectControlValueAccessor,
    SelectMultipleControlValueAccessor,
    RadioControlValueAccessor,
];
/**
 * @param {?} valueAccessor
 * @return {?}
 */
function isBuiltInAccessor(valueAccessor) {
    return BUILTIN_ACCESSORS.some(function (a) { return valueAccessor.constructor === a; });
}
/**
 * @param {?} dir
 * @param {?} valueAccessors
 * @return {?}
 */
function selectValueAccessor(dir, valueAccessors) {
    if (!valueAccessors)
        return null;
    var /** @type {?} */ defaultAccessor = undefined;
    var /** @type {?} */ builtinAccessor = undefined;
    var /** @type {?} */ customAccessor = undefined;
    valueAccessors.forEach(function (v) {
        if (v.constructor === DefaultValueAccessor) {
            defaultAccessor = v;
        }
        else if (isBuiltInAccessor(v)) {
            if (builtinAccessor)
                _throwError(dir, 'More than one built-in value accessor matches form control with');
            builtinAccessor = v;
        }
        else {
            if (customAccessor)
                _throwError(dir, 'More than one custom value accessor matches form control with');
            customAccessor = v;
        }
    });
    if (customAccessor)
        return customAccessor;
    if (builtinAccessor)
        return builtinAccessor;
    if (defaultAccessor)
        return defaultAccessor;
    _throwError(dir, 'No valid value accessor for form control with');
    return null;
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * This is a base class for code shared between {\@link NgModelGroup} and {\@link FormGroupName}.
 *
 * \@stable
 */
var AbstractFormGroupDirective = (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](AbstractFormGroupDirective, _super);
    function AbstractFormGroupDirective() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @return {?}
     */
    AbstractFormGroupDirective.prototype.ngOnInit = function () {
        this._checkParentType(); /** @type {?} */
        ((this.formDirective)).addFormGroup(this);
    };
    /**
     * @return {?}
     */
    AbstractFormGroupDirective.prototype.ngOnDestroy = function () {
        if (this.formDirective) {
            this.formDirective.removeFormGroup(this);
        }
    };
    Object.defineProperty(AbstractFormGroupDirective.prototype, "control", {
        /**
         * Get the {\@link FormGroup} backing this binding.
         * @return {?}
         */
        get: function () { return ((this.formDirective)).getFormGroup(this); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractFormGroupDirective.prototype, "path", {
        /**
         * Get the path to this control group.
         * @return {?}
         */
        get: function () { return controlPath(this.name, this._parent); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractFormGroupDirective.prototype, "formDirective", {
        /**
         * Get the {\@link Form} to which this group belongs.
         * @return {?}
         */
        get: function () { return this._parent ? this._parent.formDirective : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractFormGroupDirective.prototype, "validator", {
        /**
         * @return {?}
         */
        get: function () { return composeValidators(this._validators); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractFormGroupDirective.prototype, "asyncValidator", {
        /**
         * @return {?}
         */
        get: function () {
            return composeAsyncValidators(this._asyncValidators);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * \@internal
     * @return {?}
     */
    AbstractFormGroupDirective.prototype._checkParentType = function () { };
    return AbstractFormGroupDirective;
}(ControlContainer));
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var AbstractControlStatus = (function () {
    /**
     * @param {?} cd
     */
    function AbstractControlStatus(cd) {
        this._cd = cd;
    }
    Object.defineProperty(AbstractControlStatus.prototype, "ngClassUntouched", {
        /**
         * @return {?}
         */
        get: function () { return this._cd.control ? this._cd.control.untouched : false; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlStatus.prototype, "ngClassTouched", {
        /**
         * @return {?}
         */
        get: function () { return this._cd.control ? this._cd.control.touched : false; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlStatus.prototype, "ngClassPristine", {
        /**
         * @return {?}
         */
        get: function () { return this._cd.control ? this._cd.control.pristine : false; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlStatus.prototype, "ngClassDirty", {
        /**
         * @return {?}
         */
        get: function () { return this._cd.control ? this._cd.control.dirty : false; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlStatus.prototype, "ngClassValid", {
        /**
         * @return {?}
         */
        get: function () { return this._cd.control ? this._cd.control.valid : false; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlStatus.prototype, "ngClassInvalid", {
        /**
         * @return {?}
         */
        get: function () { return this._cd.control ? this._cd.control.invalid : false; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlStatus.prototype, "ngClassPending", {
        /**
         * @return {?}
         */
        get: function () { return this._cd.control ? this._cd.control.pending : false; },
        enumerable: true,
        configurable: true
    });
    return AbstractControlStatus;
}());
var ngControlStatusHost = {
    '[class.ng-untouched]': 'ngClassUntouched',
    '[class.ng-touched]': 'ngClassTouched',
    '[class.ng-pristine]': 'ngClassPristine',
    '[class.ng-dirty]': 'ngClassDirty',
    '[class.ng-valid]': 'ngClassValid',
    '[class.ng-invalid]': 'ngClassInvalid',
    '[class.ng-pending]': 'ngClassPending',
};
/**
 * Directive automatically applied to Angular form controls that sets CSS classes
 * based on control status. The following classes are applied as the properties
 * become true:
 *
 * * ng-valid
 * * ng-invalid
 * * ng-pending
 * * ng-pristine
 * * ng-dirty
 * * ng-untouched
 * * ng-touched
 *
 * \@stable
 */
var NgControlStatus = (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](NgControlStatus, _super);
    /**
     * @param {?} cd
     */
    function NgControlStatus(cd) {
        return _super.call(this, cd) || this;
    }
    return NgControlStatus;
}(AbstractControlStatus));
NgControlStatus.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"], args: [{ selector: '[formControlName],[ngModel],[formControl]', host: ngControlStatusHost },] },
];
/**
 * @nocollapse
 */
NgControlStatus.ctorParameters = function () { return [
    { type: NgControl, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Self"] },] },
]; };
/**
 * Directive automatically applied to Angular form groups that sets CSS classes
 * based on control status (valid/invalid/dirty/etc).
 *
 * \@stable
 */
var NgControlStatusGroup = (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](NgControlStatusGroup, _super);
    /**
     * @param {?} cd
     */
    function NgControlStatusGroup(cd) {
        return _super.call(this, cd) || this;
    }
    return NgControlStatusGroup;
}(AbstractControlStatus));
NgControlStatusGroup.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"], args: [{
                selector: '[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]',
                host: ngControlStatusHost
            },] },
];
/**
 * @nocollapse
 */
NgControlStatusGroup.ctorParameters = function () { return [
    { type: ControlContainer, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Self"] },] },
]; };
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Indicates that a FormControl is valid, i.e. that no errors exist in the input value.
 */
var VALID = 'VALID';
/**
 * Indicates that a FormControl is invalid, i.e. that an error exists in the input value.
 */
var INVALID = 'INVALID';
/**
 * Indicates that a FormControl is pending, i.e. that async validation is occurring and
 * errors are not yet available for the input value.
 */
var PENDING = 'PENDING';
/**
 * Indicates that a FormControl is disabled, i.e. that the control is exempt from ancestor
 * calculations of validity or value.
 */
var DISABLED = 'DISABLED';
/**
 * @param {?} control
 * @param {?} path
 * @param {?} delimiter
 * @return {?}
 */
function _find(control, path, delimiter) {
    if (path == null)
        return null;
    if (!(path instanceof Array)) {
        path = ((path)).split(delimiter);
    }
    if (path instanceof Array && (path.length === 0))
        return null;
    return ((path)).reduce(function (v, name) {
        if (v instanceof FormGroup) {
            return v.controls[name] || null;
        }
        if (v instanceof FormArray) {
            return v.at(/** @type {?} */ (name)) || null;
        }
        return null;
    }, control);
}
/**
 * @param {?=} validator
 * @return {?}
 */
function coerceToValidator(validator) {
    return Array.isArray(validator) ? composeValidators(validator) : validator || null;
}
/**
 * @param {?=} asyncValidator
 * @return {?}
 */
function coerceToAsyncValidator(asyncValidator) {
    return Array.isArray(asyncValidator) ? composeAsyncValidators(asyncValidator) :
        asyncValidator || null;
}
/**
 * \@whatItDoes This is the base class for {\@link FormControl}, {\@link FormGroup}, and
 * {\@link FormArray}.
 *
 * It provides some of the shared behavior that all controls and groups of controls have, like
 * running validators, calculating status, and resetting state. It also defines the properties
 * that are shared between all sub-classes, like `value`, `valid`, and `dirty`. It shouldn't be
 * instantiated directly.
 *
 * \@stable
 * @abstract
 */
var AbstractControl = (function () {
    /**
     * @param {?} validator
     * @param {?} asyncValidator
     */
    function AbstractControl(validator, asyncValidator) {
        this.validator = validator;
        this.asyncValidator = asyncValidator;
        /**
         * \@internal
         */
        this._onCollectionChange = function () { };
        this._pristine = true;
        this._touched = false;
        /**
         * \@internal
         */
        this._onDisabledChange = [];
    }
    Object.defineProperty(AbstractControl.prototype, "value", {
        /**
         * The value of the control.
         * @return {?}
         */
        get: function () { return this._value; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "parent", {
        /**
         * The parent control.
         * @return {?}
         */
        get: function () { return this._parent; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "status", {
        /**
         * The validation status of the control. There are four possible
         * validation statuses:
         *
         * * **VALID**:  control has passed all validation checks
         * * **INVALID**: control has failed at least one validation check
         * * **PENDING**: control is in the midst of conducting a validation check
         * * **DISABLED**: control is exempt from validation checks
         *
         * These statuses are mutually exclusive, so a control cannot be
         * both valid AND invalid or invalid AND disabled.
         * @return {?}
         */
        get: function () { return this._status; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "valid", {
        /**
         * A control is `valid` when its `status === VALID`.
         *
         * In order to have this status, the control must have passed all its
         * validation checks.
         * @return {?}
         */
        get: function () { return this._status === VALID; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "invalid", {
        /**
         * A control is `invalid` when its `status === INVALID`.
         *
         * In order to have this status, the control must have failed
         * at least one of its validation checks.
         * @return {?}
         */
        get: function () { return this._status === INVALID; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "pending", {
        /**
         * A control is `pending` when its `status === PENDING`.
         *
         * In order to have this status, the control must be in the
         * middle of conducting a validation check.
         * @return {?}
         */
        get: function () { return this._status == PENDING; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "disabled", {
        /**
         * A control is `disabled` when its `status === DISABLED`.
         *
         * Disabled controls are exempt from validation checks and
         * are not included in the aggregate value of their ancestor
         * controls.
         * @return {?}
         */
        get: function () { return this._status === DISABLED; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "enabled", {
        /**
         * A control is `enabled` as long as its `status !== DISABLED`.
         *
         * In other words, it has a status of `VALID`, `INVALID`, or
         * `PENDING`.
         * @return {?}
         */
        get: function () { return this._status !== DISABLED; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "errors", {
        /**
         * Returns any errors generated by failing validation. If there
         * are no errors, it will return null.
         * @return {?}
         */
        get: function () { return this._errors; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "pristine", {
        /**
         * A control is `pristine` if the user has not yet changed
         * the value in the UI.
         *
         * Note that programmatic changes to a control's value will
         * *not* mark it dirty.
         * @return {?}
         */
        get: function () { return this._pristine; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "dirty", {
        /**
         * A control is `dirty` if the user has changed the value
         * in the UI.
         *
         * Note that programmatic changes to a control's value will
         * *not* mark it dirty.
         * @return {?}
         */
        get: function () { return !this.pristine; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "touched", {
        /**
         * A control is marked `touched` once the user has triggered
         * a `blur` event on it.
         * @return {?}
         */
        get: function () { return this._touched; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "untouched", {
        /**
         * A control is `untouched` if the user has not yet triggered
         * a `blur` event on it.
         * @return {?}
         */
        get: function () { return !this._touched; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "valueChanges", {
        /**
         * Emits an event every time the value of the control changes, in
         * the UI or programmatically.
         * @return {?}
         */
        get: function () { return this._valueChanges; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "statusChanges", {
        /**
         * Emits an event every time the validation status of the control
         * is re-calculated.
         * @return {?}
         */
        get: function () { return this._statusChanges; },
        enumerable: true,
        configurable: true
    });
    /**
     * Sets the synchronous validators that are active on this control.  Calling
     * this will overwrite any existing sync validators.
     * @param {?} newValidator
     * @return {?}
     */
    AbstractControl.prototype.setValidators = function (newValidator) {
        this.validator = coerceToValidator(newValidator);
    };
    /**
     * Sets the async validators that are active on this control. Calling this
     * will overwrite any existing async validators.
     * @param {?} newValidator
     * @return {?}
     */
    AbstractControl.prototype.setAsyncValidators = function (newValidator) {
        this.asyncValidator = coerceToAsyncValidator(newValidator);
    };
    /**
     * Empties out the sync validator list.
     * @return {?}
     */
    AbstractControl.prototype.clearValidators = function () { this.validator = null; };
    /**
     * Empties out the async validator list.
     * @return {?}
     */
    AbstractControl.prototype.clearAsyncValidators = function () { this.asyncValidator = null; };
    /**
     * Marks the control as `touched`.
     *
     * This will also mark all direct ancestors as `touched` to maintain
     * the model.
     * @param {?=} opts
     * @return {?}
     */
    AbstractControl.prototype.markAsTouched = function (opts) {
        if (opts === void 0) { opts = {}; }
        this._touched = true;
        if (this._parent && !opts.onlySelf) {
            this._parent.markAsTouched(opts);
        }
    };
    /**
     * Marks the control as `untouched`.
     *
     * If the control has any children, it will also mark all children as `untouched`
     * to maintain the model, and re-calculate the `touched` status of all parent
     * controls.
     * @param {?=} opts
     * @return {?}
     */
    AbstractControl.prototype.markAsUntouched = function (opts) {
        if (opts === void 0) { opts = {}; }
        this._touched = false;
        this._forEachChild(function (control) { control.markAsUntouched({ onlySelf: true }); });
        if (this._parent && !opts.onlySelf) {
            this._parent._updateTouched(opts);
        }
    };
    /**
     * Marks the control as `dirty`.
     *
     * This will also mark all direct ancestors as `dirty` to maintain
     * the model.
     * @param {?=} opts
     * @return {?}
     */
    AbstractControl.prototype.markAsDirty = function (opts) {
        if (opts === void 0) { opts = {}; }
        this._pristine = false;
        if (this._parent && !opts.onlySelf) {
            this._parent.markAsDirty(opts);
        }
    };
    /**
     * Marks the control as `pristine`.
     *
     * If the control has any children, it will also mark all children as `pristine`
     * to maintain the model, and re-calculate the `pristine` status of all parent
     * controls.
     * @param {?=} opts
     * @return {?}
     */
    AbstractControl.prototype.markAsPristine = function (opts) {
        if (opts === void 0) { opts = {}; }
        this._pristine = true;
        this._forEachChild(function (control) { control.markAsPristine({ onlySelf: true }); });
        if (this._parent && !opts.onlySelf) {
            this._parent._updatePristine(opts);
        }
    };
    /**
     * Marks the control as `pending`.
     * @param {?=} opts
     * @return {?}
     */
    AbstractControl.prototype.markAsPending = function (opts) {
        if (opts === void 0) { opts = {}; }
        this._status = PENDING;
        if (this._parent && !opts.onlySelf) {
            this._parent.markAsPending(opts);
        }
    };
    /**
     * Disables the control. This means the control will be exempt from validation checks and
     * excluded from the aggregate value of any parent. Its status is `DISABLED`.
     *
     * If the control has children, all children will be disabled to maintain the model.
     * @param {?=} opts
     * @return {?}
     */
    AbstractControl.prototype.disable = function (opts) {
        if (opts === void 0) { opts = {}; }
        this._status = DISABLED;
        this._errors = null;
        this._forEachChild(function (control) { control.disable({ onlySelf: true }); });
        this._updateValue();
        if (opts.emitEvent !== false) {
            this._valueChanges.emit(this._value);
            this._statusChanges.emit(this._status);
        }
        this._updateAncestors(!!opts.onlySelf);
        this._onDisabledChange.forEach(function (changeFn) { return changeFn(true); });
    };
    /**
     * Enables the control. This means the control will be included in validation checks and
     * the aggregate value of its parent. Its status is re-calculated based on its value and
     * its validators.
     *
     * If the control has children, all children will be enabled.
     * @param {?=} opts
     * @return {?}
     */
    AbstractControl.prototype.enable = function (opts) {
        if (opts === void 0) { opts = {}; }
        this._status = VALID;
        this._forEachChild(function (control) { control.enable({ onlySelf: true }); });
        this.updateValueAndValidity({ onlySelf: true, emitEvent: opts.emitEvent });
        this._updateAncestors(!!opts.onlySelf);
        this._onDisabledChange.forEach(function (changeFn) { return changeFn(false); });
    };
    /**
     * @param {?} onlySelf
     * @return {?}
     */
    AbstractControl.prototype._updateAncestors = function (onlySelf) {
        if (this._parent && !onlySelf) {
            this._parent.updateValueAndValidity();
            this._parent._updatePristine();
            this._parent._updateTouched();
        }
    };
    /**
     * @param {?} parent
     * @return {?}
     */
    AbstractControl.prototype.setParent = function (parent) { this._parent = parent; };
    /**
     * Sets the value of the control. Abstract method (implemented in sub-classes).
     * @abstract
     * @param {?} value
     * @param {?=} options
     * @return {?}
     */
    AbstractControl.prototype.setValue = function (value, options) { };
    /**
     * Patches the value of the control. Abstract method (implemented in sub-classes).
     * @abstract
     * @param {?} value
     * @param {?=} options
     * @return {?}
     */
    AbstractControl.prototype.patchValue = function (value, options) { };
    /**
     * Resets the control. Abstract method (implemented in sub-classes).
     * @abstract
     * @param {?=} value
     * @param {?=} options
     * @return {?}
     */
    AbstractControl.prototype.reset = function (value, options) { };
    /**
     * Re-calculates the value and validation status of the control.
     *
     * By default, it will also update the value and validity of its ancestors.
     * @param {?=} opts
     * @return {?}
     */
    AbstractControl.prototype.updateValueAndValidity = function (opts) {
        if (opts === void 0) { opts = {}; }
        this._setInitialStatus();
        this._updateValue();
        if (this.enabled) {
            this._cancelExistingSubscription();
            this._errors = this._runValidator();
            this._status = this._calculateStatus();
            if (this._status === VALID || this._status === PENDING) {
                this._runAsyncValidator(opts.emitEvent);
            }
        }
        if (opts.emitEvent !== false) {
            this._valueChanges.emit(this._value);
            this._statusChanges.emit(this._status);
        }
        if (this._parent && !opts.onlySelf) {
            this._parent.updateValueAndValidity(opts);
        }
    };
    /**
     * \@internal
     * @param {?=} opts
     * @return {?}
     */
    AbstractControl.prototype._updateTreeValidity = function (opts) {
        if (opts === void 0) { opts = { emitEvent: true }; }
        this._forEachChild(function (ctrl) { return ctrl._updateTreeValidity(opts); });
        this.updateValueAndValidity({ onlySelf: true, emitEvent: opts.emitEvent });
    };
    /**
     * @return {?}
     */
    AbstractControl.prototype._setInitialStatus = function () { this._status = this._allControlsDisabled() ? DISABLED : VALID; };
    /**
     * @return {?}
     */
    AbstractControl.prototype._runValidator = function () {
        return this.validator ? this.validator(this) : null;
    };
    /**
     * @param {?=} emitEvent
     * @return {?}
     */
    AbstractControl.prototype._runAsyncValidator = function (emitEvent) {
        var _this = this;
        if (this.asyncValidator) {
            this._status = PENDING;
            var /** @type {?} */ obs = toObservable(this.asyncValidator(this));
            this._asyncValidationSubscription =
                obs.subscribe(function (errors) { return _this.setErrors(errors, { emitEvent: emitEvent }); });
        }
    };
    /**
     * @return {?}
     */
    AbstractControl.prototype._cancelExistingSubscription = function () {
        if (this._asyncValidationSubscription) {
            this._asyncValidationSubscription.unsubscribe();
        }
    };
    /**
     * Sets errors on a form control.
     *
     * This is used when validations are run manually by the user, rather than automatically.
     *
     * Calling `setErrors` will also update the validity of the parent control.
     *
     * ### Example
     *
     * ```
     * const login = new FormControl("someLogin");
     * login.setErrors({
     *   "notUnique": true
     * });
     *
     * expect(login.valid).toEqual(false);
     * expect(login.errors).toEqual({"notUnique": true});
     *
     * login.setValue("someOtherLogin");
     *
     * expect(login.valid).toEqual(true);
     * ```
     * @param {?} errors
     * @param {?=} opts
     * @return {?}
     */
    AbstractControl.prototype.setErrors = function (errors, opts) {
        if (opts === void 0) { opts = {}; }
        this._errors = errors;
        this._updateControlsErrors(opts.emitEvent !== false);
    };
    /**
     * Retrieves a child control given the control's name or path.
     *
     * Paths can be passed in as an array or a string delimited by a dot.
     *
     * To get a control nested within a `person` sub-group:
     *
     * * `this.form.get('person.name');`
     *
     * -OR-
     *
     * * `this.form.get(['person', 'name']);`
     * @param {?} path
     * @return {?}
     */
    AbstractControl.prototype.get = function (path) { return _find(this, path, '.'); };
    /**
     * Returns error data if the control with the given path has the error specified. Otherwise
     * returns null or undefined.
     *
     * If no path is given, it checks for the error on the present control.
     * @param {?} errorCode
     * @param {?=} path
     * @return {?}
     */
    AbstractControl.prototype.getError = function (errorCode, path) {
        var /** @type {?} */ control = path ? this.get(path) : this;
        return control && control._errors ? control._errors[errorCode] : null;
    };
    /**
     * Returns true if the control with the given path has the error specified. Otherwise
     * returns false.
     *
     * If no path is given, it checks for the error on the present control.
     * @param {?} errorCode
     * @param {?=} path
     * @return {?}
     */
    AbstractControl.prototype.hasError = function (errorCode, path) { return !!this.getError(errorCode, path); };
    Object.defineProperty(AbstractControl.prototype, "root", {
        /**
         * Retrieves the top-level ancestor of this control.
         * @return {?}
         */
        get: function () {
            var /** @type {?} */ x = this;
            while (x._parent) {
                x = x._parent;
            }
            return x;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * \@internal
     * @param {?} emitEvent
     * @return {?}
     */
    AbstractControl.prototype._updateControlsErrors = function (emitEvent) {
        this._status = this._calculateStatus();
        if (emitEvent) {
            this._statusChanges.emit(this._status);
        }
        if (this._parent) {
            this._parent._updateControlsErrors(emitEvent);
        }
    };
    /**
     * \@internal
     * @return {?}
     */
    AbstractControl.prototype._initObservables = function () {
        this._valueChanges = new __WEBPACK_IMPORTED_MODULE_1__angular_core__["EventEmitter"]();
        this._statusChanges = new __WEBPACK_IMPORTED_MODULE_1__angular_core__["EventEmitter"]();
    };
    /**
     * @return {?}
     */
    AbstractControl.prototype._calculateStatus = function () {
        if (this._allControlsDisabled())
            return DISABLED;
        if (this._errors)
            return INVALID;
        if (this._anyControlsHaveStatus(PENDING))
            return PENDING;
        if (this._anyControlsHaveStatus(INVALID))
            return INVALID;
        return VALID;
    };
    /**
     * \@internal
     * @abstract
     * @return {?}
     */
    AbstractControl.prototype._updateValue = function () { };
    /**
     * \@internal
     * @abstract
     * @param {?} cb
     * @return {?}
     */
    AbstractControl.prototype._forEachChild = function (cb) { };
    /**
     * \@internal
     * @abstract
     * @param {?} condition
     * @return {?}
     */
    AbstractControl.prototype._anyControls = function (condition) { };
    /**
     * \@internal
     * @abstract
     * @return {?}
     */
    AbstractControl.prototype._allControlsDisabled = function () { };
    /**
     * \@internal
     * @param {?} status
     * @return {?}
     */
    AbstractControl.prototype._anyControlsHaveStatus = function (status) {
        return this._anyControls(function (control) { return control.status === status; });
    };
    /**
     * \@internal
     * @return {?}
     */
    AbstractControl.prototype._anyControlsDirty = function () {
        return this._anyControls(function (control) { return control.dirty; });
    };
    /**
     * \@internal
     * @return {?}
     */
    AbstractControl.prototype._anyControlsTouched = function () {
        return this._anyControls(function (control) { return control.touched; });
    };
    /**
     * \@internal
     * @param {?=} opts
     * @return {?}
     */
    AbstractControl.prototype._updatePristine = function (opts) {
        if (opts === void 0) { opts = {}; }
        this._pristine = !this._anyControlsDirty();
        if (this._parent && !opts.onlySelf) {
            this._parent._updatePristine(opts);
        }
    };
    /**
     * \@internal
     * @param {?=} opts
     * @return {?}
     */
    AbstractControl.prototype._updateTouched = function (opts) {
        if (opts === void 0) { opts = {}; }
        this._touched = this._anyControlsTouched();
        if (this._parent && !opts.onlySelf) {
            this._parent._updateTouched(opts);
        }
    };
    /**
     * \@internal
     * @param {?} formState
     * @return {?}
     */
    AbstractControl.prototype._isBoxedValue = function (formState) {
        return typeof formState === 'object' && formState !== null &&
            Object.keys(formState).length === 2 && 'value' in formState && 'disabled' in formState;
    };
    /**
     * \@internal
     * @param {?} fn
     * @return {?}
     */
    AbstractControl.prototype._registerOnCollectionChange = function (fn) { this._onCollectionChange = fn; };
    return AbstractControl;
}());
/**
 * \@whatItDoes Tracks the value and validation status of an individual form control.
 *
 * It is one of the three fundamental building blocks of Angular forms, along with
 * {\@link FormGroup} and {\@link FormArray}.
 *
 * \@howToUse
 *
 * When instantiating a {\@link FormControl}, you can pass in an initial value as the
 * first argument. Example:
 *
 * ```ts
 * const ctrl = new FormControl('some value');
 * console.log(ctrl.value);     // 'some value'
 * ```
 *
 * You can also initialize the control with a form state object on instantiation,
 * which includes both the value and whether or not the control is disabled.
 * You can't use the value key without the disabled key; both are required
 * to use this way of initialization.
 *
 * ```ts
 * const ctrl = new FormControl({value: 'n/a', disabled: true});
 * console.log(ctrl.value);     // 'n/a'
 * console.log(ctrl.status);   // 'DISABLED'
 * ```
 *
 * To include a sync validator (or an array of sync validators) with the control,
 * pass it in as the second argument. Async validators are also supported, but
 * have to be passed in separately as the third arg.
 *
 * ```ts
 * const ctrl = new FormControl('', Validators.required);
 * console.log(ctrl.value);     // ''
 * console.log(ctrl.status);   // 'INVALID'
 * ```
 *
 * See its superclass, {\@link AbstractControl}, for more properties and methods.
 *
 * * **npm package**: `\@angular/forms`
 *
 * \@stable
 */
var FormControl = (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](FormControl, _super);
    /**
     * @param {?=} formState
     * @param {?=} validator
     * @param {?=} asyncValidator
     */
    function FormControl(formState, validator, asyncValidator) {
        if (formState === void 0) { formState = null; }
        var _this = _super.call(this, coerceToValidator(validator), coerceToAsyncValidator(asyncValidator)) || this;
        /**
         * \@internal
         */
        _this._onChange = [];
        _this._applyFormState(formState);
        _this.updateValueAndValidity({ onlySelf: true, emitEvent: false });
        _this._initObservables();
        return _this;
    }
    /**
     * Set the value of the form control to `value`.
     *
     * If `onlySelf` is `true`, this change will only affect the validation of this `FormControl`
     * and not its parent component. This defaults to false.
     *
     * If `emitEvent` is `true`, this
     * change will cause a `valueChanges` event on the `FormControl` to be emitted. This defaults
     * to true (as it falls through to `updateValueAndValidity`).
     *
     * If `emitModelToViewChange` is `true`, the view will be notified about the new value
     * via an `onChange` event. This is the default behavior if `emitModelToViewChange` is not
     * specified.
     *
     * If `emitViewToModelChange` is `true`, an ngModelChange event will be fired to update the
     * model.  This is the default behavior if `emitViewToModelChange` is not specified.
     * @param {?} value
     * @param {?=} options
     * @return {?}
     */
    FormControl.prototype.setValue = function (value, options) {
        var _this = this;
        if (options === void 0) { options = {}; }
        this._value = value;
        if (this._onChange.length && options.emitModelToViewChange !== false) {
            this._onChange.forEach(function (changeFn) { return changeFn(_this._value, options.emitViewToModelChange !== false); });
        }
        this.updateValueAndValidity(options);
    };
    /**
     * Patches the value of a control.
     *
     * This function is functionally the same as {\@link FormControl#setValue} at this level.
     * It exists for symmetry with {\@link FormGroup#patchValue} on `FormGroups` and `FormArrays`,
     * where it does behave differently.
     * @param {?} value
     * @param {?=} options
     * @return {?}
     */
    FormControl.prototype.patchValue = function (value, options) {
        if (options === void 0) { options = {}; }
        this.setValue(value, options);
    };
    /**
     * Resets the form control. This means by default:
     *
     * * it is marked as `pristine`
     * * it is marked as `untouched`
     * * value is set to null
     *
     * You can also reset to a specific form state by passing through a standalone
     * value or a form state object that contains both a value and a disabled state
     * (these are the only two properties that cannot be calculated).
     *
     * Ex:
     *
     * ```ts
     * this.control.reset('Nancy');
     *
     * console.log(this.control.value);  // 'Nancy'
     * ```
     *
     * OR
     *
     * ```
     * this.control.reset({value: 'Nancy', disabled: true});
     *
     * console.log(this.control.value);  // 'Nancy'
     * console.log(this.control.status);  // 'DISABLED'
     * ```
     * @param {?=} formState
     * @param {?=} options
     * @return {?}
     */
    FormControl.prototype.reset = function (formState, options) {
        if (formState === void 0) { formState = null; }
        if (options === void 0) { options = {}; }
        this._applyFormState(formState);
        this.markAsPristine(options);
        this.markAsUntouched(options);
        this.setValue(this._value, options);
    };
    /**
     * \@internal
     * @return {?}
     */
    FormControl.prototype._updateValue = function () { };
    /**
     * \@internal
     * @param {?} condition
     * @return {?}
     */
    FormControl.prototype._anyControls = function (condition) { return false; };
    /**
     * \@internal
     * @return {?}
     */
    FormControl.prototype._allControlsDisabled = function () { return this.disabled; };
    /**
     * Register a listener for change events.
     * @param {?} fn
     * @return {?}
     */
    FormControl.prototype.registerOnChange = function (fn) { this._onChange.push(fn); };
    /**
     * \@internal
     * @return {?}
     */
    FormControl.prototype._clearChangeFns = function () {
        this._onChange = [];
        this._onDisabledChange = [];
        this._onCollectionChange = function () { };
    };
    /**
     * Register a listener for disabled events.
     * @param {?} fn
     * @return {?}
     */
    FormControl.prototype.registerOnDisabledChange = function (fn) {
        this._onDisabledChange.push(fn);
    };
    /**
     * \@internal
     * @param {?} cb
     * @return {?}
     */
    FormControl.prototype._forEachChild = function (cb) { };
    /**
     * @param {?} formState
     * @return {?}
     */
    FormControl.prototype._applyFormState = function (formState) {
        if (this._isBoxedValue(formState)) {
            this._value = formState.value;
            formState.disabled ? this.disable({ onlySelf: true, emitEvent: false }) :
                this.enable({ onlySelf: true, emitEvent: false });
        }
        else {
            this._value = formState;
        }
    };
    return FormControl;
}(AbstractControl));
/**
 * \@whatItDoes Tracks the value and validity state of a group of {\@link FormControl}
 * instances.
 *
 * A `FormGroup` aggregates the values of each child {\@link FormControl} into one object,
 * with each control name as the key.  It calculates its status by reducing the statuses
 * of its children. For example, if one of the controls in a group is invalid, the entire
 * group becomes invalid.
 *
 * `FormGroup` is one of the three fundamental building blocks used to define forms in Angular,
 * along with {\@link FormControl} and {\@link FormArray}.
 *
 * \@howToUse
 *
 * When instantiating a {\@link FormGroup}, pass in a collection of child controls as the first
 * argument. The key for each child will be the name under which it is registered.
 *
 * ### Example
 *
 * ```
 * const form = new FormGroup({
 *   first: new FormControl('Nancy', Validators.minLength(2)),
 *   last: new FormControl('Drew'),
 * });
 *
 * console.log(form.value);   // {first: 'Nancy', last; 'Drew'}
 * console.log(form.status);  // 'VALID'
 * ```
 *
 * You can also include group-level validators as the second arg, or group-level async
 * validators as the third arg. These come in handy when you want to perform validation
 * that considers the value of more than one child control.
 *
 * ### Example
 *
 * ```
 * const form = new FormGroup({
 *   password: new FormControl('', Validators.minLength(2)),
 *   passwordConfirm: new FormControl('', Validators.minLength(2)),
 * }, passwordMatchValidator);
 *
 *
 * function passwordMatchValidator(g: FormGroup) {
 *    return g.get('password').value === g.get('passwordConfirm').value
 *       ? null : {'mismatch': true};
 * }
 * ```
 *
 * * **npm package**: `\@angular/forms`
 *
 * \@stable
 */
var FormGroup = (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](FormGroup, _super);
    /**
     * @param {?} controls
     * @param {?=} validator
     * @param {?=} asyncValidator
     */
    function FormGroup(controls, validator, asyncValidator) {
        var _this = _super.call(this, validator || null, asyncValidator || null) || this;
        _this.controls = controls;
        _this._initObservables();
        _this._setUpControls();
        _this.updateValueAndValidity({ onlySelf: true, emitEvent: false });
        return _this;
    }
    /**
     * Registers a control with the group's list of controls.
     *
     * This method does not update value or validity of the control, so for
     * most cases you'll want to use {\@link FormGroup#addControl} instead.
     * @param {?} name
     * @param {?} control
     * @return {?}
     */
    FormGroup.prototype.registerControl = function (name, control) {
        if (this.controls[name])
            return this.controls[name];
        this.controls[name] = control;
        control.setParent(this);
        control._registerOnCollectionChange(this._onCollectionChange);
        return control;
    };
    /**
     * Add a control to this group.
     * @param {?} name
     * @param {?} control
     * @return {?}
     */
    FormGroup.prototype.addControl = function (name, control) {
        this.registerControl(name, control);
        this.updateValueAndValidity();
        this._onCollectionChange();
    };
    /**
     * Remove a control from this group.
     * @param {?} name
     * @return {?}
     */
    FormGroup.prototype.removeControl = function (name) {
        if (this.controls[name])
            this.controls[name]._registerOnCollectionChange(function () { });
        delete (this.controls[name]);
        this.updateValueAndValidity();
        this._onCollectionChange();
    };
    /**
     * Replace an existing control.
     * @param {?} name
     * @param {?} control
     * @return {?}
     */
    FormGroup.prototype.setControl = function (name, control) {
        if (this.controls[name])
            this.controls[name]._registerOnCollectionChange(function () { });
        delete (this.controls[name]);
        if (control)
            this.registerControl(name, control);
        this.updateValueAndValidity();
        this._onCollectionChange();
    };
    /**
     * Check whether there is an enabled control with the given name in the group.
     *
     * It will return false for disabled controls. If you'd like to check for
     * existence in the group only, use {\@link AbstractControl#get} instead.
     * @param {?} controlName
     * @return {?}
     */
    FormGroup.prototype.contains = function (controlName) {
        return this.controls.hasOwnProperty(controlName) && this.controls[controlName].enabled;
    };
    /**
     *  Sets the value of the {\@link FormGroup}. It accepts an object that matches
     *  the structure of the group, with control names as keys.
     *
     * This method performs strict checks, so it will throw an error if you try
     * to set the value of a control that doesn't exist or if you exclude the
     * value of a control.
     *
     *  ### Example
     *
     *  ```
     *  const form = new FormGroup({
     *     first: new FormControl(),
     *     last: new FormControl()
     *  });
     *  console.log(form.value);   // {first: null, last: null}
     *
     *  form.setValue({first: 'Nancy', last: 'Drew'});
     *  console.log(form.value);   // {first: 'Nancy', last: 'Drew'}
     *
     *  ```
     * @param {?} value
     * @param {?=} options
     * @return {?}
     */
    FormGroup.prototype.setValue = function (value, options) {
        var _this = this;
        if (options === void 0) { options = {}; }
        this._checkAllValuesPresent(value);
        Object.keys(value).forEach(function (name) {
            _this._throwIfControlMissing(name);
            _this.controls[name].setValue(value[name], { onlySelf: true, emitEvent: options.emitEvent });
        });
        this.updateValueAndValidity(options);
    };
    /**
     *  Patches the value of the {\@link FormGroup}. It accepts an object with control
     *  names as keys, and will do its best to match the values to the correct controls
     *  in the group.
     *
     *  It accepts both super-sets and sub-sets of the group without throwing an error.
     *
     *  ### Example
     *
     *  ```
     *  const form = new FormGroup({
     *     first: new FormControl(),
     *     last: new FormControl()
     *  });
     *  console.log(form.value);   // {first: null, last: null}
     *
     *  form.patchValue({first: 'Nancy'});
     *  console.log(form.value);   // {first: 'Nancy', last: null}
     *
     *  ```
     * @param {?} value
     * @param {?=} options
     * @return {?}
     */
    FormGroup.prototype.patchValue = function (value, options) {
        var _this = this;
        if (options === void 0) { options = {}; }
        Object.keys(value).forEach(function (name) {
            if (_this.controls[name]) {
                _this.controls[name].patchValue(value[name], { onlySelf: true, emitEvent: options.emitEvent });
            }
        });
        this.updateValueAndValidity(options);
    };
    /**
     * Resets the {\@link FormGroup}. This means by default:
     *
     * * The group and all descendants are marked `pristine`
     * * The group and all descendants are marked `untouched`
     * * The value of all descendants will be null or null maps
     *
     * You can also reset to a specific form state by passing in a map of states
     * that matches the structure of your form, with control names as keys. The state
     * can be a standalone value or a form state object with both a value and a disabled
     * status.
     *
     * ### Example
     *
     * ```ts
     * this.form.reset({first: 'name', last: 'last name'});
     *
     * console.log(this.form.value);  // {first: 'name', last: 'last name'}
     * ```
     *
     * - OR -
     *
     * ```
     * this.form.reset({
     *   first: {value: 'name', disabled: true},
     *   last: 'last'
     * });
     *
     * console.log(this.form.value);  // {first: 'name', last: 'last name'}
     * console.log(this.form.get('first').status);  // 'DISABLED'
     * ```
     * @param {?=} value
     * @param {?=} options
     * @return {?}
     */
    FormGroup.prototype.reset = function (value, options) {
        if (value === void 0) { value = {}; }
        if (options === void 0) { options = {}; }
        this._forEachChild(function (control, name) {
            control.reset(value[name], { onlySelf: true, emitEvent: options.emitEvent });
        });
        this.updateValueAndValidity(options);
        this._updatePristine(options);
        this._updateTouched(options);
    };
    /**
     * The aggregate value of the {\@link FormGroup}, including any disabled controls.
     *
     * If you'd like to include all values regardless of disabled status, use this method.
     * Otherwise, the `value` property is the best way to get the value of the group.
     * @return {?}
     */
    FormGroup.prototype.getRawValue = function () {
        return this._reduceChildren({}, function (acc, control, name) {
            acc[name] = control instanceof FormControl ? control.value : ((control)).getRawValue();
            return acc;
        });
    };
    /**
     * \@internal
     * @param {?} name
     * @return {?}
     */
    FormGroup.prototype._throwIfControlMissing = function (name) {
        if (!Object.keys(this.controls).length) {
            throw new Error("\n        There are no form controls registered with this group yet.  If you're using ngModel,\n        you may want to check next tick (e.g. use setTimeout).\n      ");
        }
        if (!this.controls[name]) {
            throw new Error("Cannot find form control with name: " + name + ".");
        }
    };
    /**
     * \@internal
     * @param {?} cb
     * @return {?}
     */
    FormGroup.prototype._forEachChild = function (cb) {
        var _this = this;
        Object.keys(this.controls).forEach(function (k) { return cb(_this.controls[k], k); });
    };
    /**
     * \@internal
     * @return {?}
     */
    FormGroup.prototype._setUpControls = function () {
        var _this = this;
        this._forEachChild(function (control) {
            control.setParent(_this);
            control._registerOnCollectionChange(_this._onCollectionChange);
        });
    };
    /**
     * \@internal
     * @return {?}
     */
    FormGroup.prototype._updateValue = function () { this._value = this._reduceValue(); };
    /**
     * \@internal
     * @param {?} condition
     * @return {?}
     */
    FormGroup.prototype._anyControls = function (condition) {
        var _this = this;
        var /** @type {?} */ res = false;
        this._forEachChild(function (control, name) {
            res = res || (_this.contains(name) && condition(control));
        });
        return res;
    };
    /**
     * \@internal
     * @return {?}
     */
    FormGroup.prototype._reduceValue = function () {
        var _this = this;
        return this._reduceChildren({}, function (acc, control, name) {
            if (control.enabled || _this.disabled) {
                acc[name] = control.value;
            }
            return acc;
        });
    };
    /**
     * \@internal
     * @param {?} initValue
     * @param {?} fn
     * @return {?}
     */
    FormGroup.prototype._reduceChildren = function (initValue, fn) {
        var /** @type {?} */ res = initValue;
        this._forEachChild(function (control, name) { res = fn(res, control, name); });
        return res;
    };
    /**
     * \@internal
     * @return {?}
     */
    FormGroup.prototype._allControlsDisabled = function () {
        for (var _i = 0, _a = Object.keys(this.controls); _i < _a.length; _i++) {
            var controlName = _a[_i];
            if (this.controls[controlName].enabled) {
                return false;
            }
        }
        return Object.keys(this.controls).length > 0 || this.disabled;
    };
    /**
     * \@internal
     * @param {?} value
     * @return {?}
     */
    FormGroup.prototype._checkAllValuesPresent = function (value) {
        this._forEachChild(function (control, name) {
            if (value[name] === undefined) {
                throw new Error("Must supply a value for form control with name: '" + name + "'.");
            }
        });
    };
    return FormGroup;
}(AbstractControl));
/**
 * \@whatItDoes Tracks the value and validity state of an array of {\@link FormControl},
 * {\@link FormGroup} or {\@link FormArray} instances.
 *
 * A `FormArray` aggregates the values of each child {\@link FormControl} into an array.
 * It calculates its status by reducing the statuses of its children. For example, if one of
 * the controls in a `FormArray` is invalid, the entire array becomes invalid.
 *
 * `FormArray` is one of the three fundamental building blocks used to define forms in Angular,
 * along with {\@link FormControl} and {\@link FormGroup}.
 *
 * \@howToUse
 *
 * When instantiating a {\@link FormArray}, pass in an array of child controls as the first
 * argument.
 *
 * ### Example
 *
 * ```
 * const arr = new FormArray([
 *   new FormControl('Nancy', Validators.minLength(2)),
 *   new FormControl('Drew'),
 * ]);
 *
 * console.log(arr.value);   // ['Nancy', 'Drew']
 * console.log(arr.status);  // 'VALID'
 * ```
 *
 * You can also include array-level validators as the second arg, or array-level async
 * validators as the third arg. These come in handy when you want to perform validation
 * that considers the value of more than one child control.
 *
 * ### Adding or removing controls
 *
 * To change the controls in the array, use the `push`, `insert`, or `removeAt` methods
 * in `FormArray` itself. These methods ensure the controls are properly tracked in the
 * form's hierarchy. Do not modify the array of `AbstractControl`s used to instantiate
 * the `FormArray` directly, as that will result in strange and unexpected behavior such
 * as broken change detection.
 *
 * * **npm package**: `\@angular/forms`
 *
 * \@stable
 */
var FormArray = (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](FormArray, _super);
    /**
     * @param {?} controls
     * @param {?=} validator
     * @param {?=} asyncValidator
     */
    function FormArray(controls, validator, asyncValidator) {
        var _this = _super.call(this, validator || null, asyncValidator || null) || this;
        _this.controls = controls;
        _this._initObservables();
        _this._setUpControls();
        _this.updateValueAndValidity({ onlySelf: true, emitEvent: false });
        return _this;
    }
    /**
     * Get the {\@link AbstractControl} at the given `index` in the array.
     * @param {?} index
     * @return {?}
     */
    FormArray.prototype.at = function (index) { return this.controls[index]; };
    /**
     * Insert a new {\@link AbstractControl} at the end of the array.
     * @param {?} control
     * @return {?}
     */
    FormArray.prototype.push = function (control) {
        this.controls.push(control);
        this._registerControl(control);
        this.updateValueAndValidity();
        this._onCollectionChange();
    };
    /**
     * Insert a new {\@link AbstractControl} at the given `index` in the array.
     * @param {?} index
     * @param {?} control
     * @return {?}
     */
    FormArray.prototype.insert = function (index, control) {
        this.controls.splice(index, 0, control);
        this._registerControl(control);
        this.updateValueAndValidity();
        this._onCollectionChange();
    };
    /**
     * Remove the control at the given `index` in the array.
     * @param {?} index
     * @return {?}
     */
    FormArray.prototype.removeAt = function (index) {
        if (this.controls[index])
            this.controls[index]._registerOnCollectionChange(function () { });
        this.controls.splice(index, 1);
        this.updateValueAndValidity();
        this._onCollectionChange();
    };
    /**
     * Replace an existing control.
     * @param {?} index
     * @param {?} control
     * @return {?}
     */
    FormArray.prototype.setControl = function (index, control) {
        if (this.controls[index])
            this.controls[index]._registerOnCollectionChange(function () { });
        this.controls.splice(index, 1);
        if (control) {
            this.controls.splice(index, 0, control);
            this._registerControl(control);
        }
        this.updateValueAndValidity();
        this._onCollectionChange();
    };
    Object.defineProperty(FormArray.prototype, "length", {
        /**
         * Length of the control array.
         * @return {?}
         */
        get: function () { return this.controls.length; },
        enumerable: true,
        configurable: true
    });
    /**
     *  Sets the value of the {\@link FormArray}. It accepts an array that matches
     *  the structure of the control.
     *
     * This method performs strict checks, so it will throw an error if you try
     * to set the value of a control that doesn't exist or if you exclude the
     * value of a control.
     *
     *  ### Example
     *
     *  ```
     *  const arr = new FormArray([
     *     new FormControl(),
     *     new FormControl()
     *  ]);
     *  console.log(arr.value);   // [null, null]
     *
     *  arr.setValue(['Nancy', 'Drew']);
     *  console.log(arr.value);   // ['Nancy', 'Drew']
     *  ```
     * @param {?} value
     * @param {?=} options
     * @return {?}
     */
    FormArray.prototype.setValue = function (value, options) {
        var _this = this;
        if (options === void 0) { options = {}; }
        this._checkAllValuesPresent(value);
        value.forEach(function (newValue, index) {
            _this._throwIfControlMissing(index);
            _this.at(index).setValue(newValue, { onlySelf: true, emitEvent: options.emitEvent });
        });
        this.updateValueAndValidity(options);
    };
    /**
     *  Patches the value of the {\@link FormArray}. It accepts an array that matches the
     *  structure of the control, and will do its best to match the values to the correct
     *  controls in the group.
     *
     *  It accepts both super-sets and sub-sets of the array without throwing an error.
     *
     *  ### Example
     *
     *  ```
     *  const arr = new FormArray([
     *     new FormControl(),
     *     new FormControl()
     *  ]);
     *  console.log(arr.value);   // [null, null]
     *
     *  arr.patchValue(['Nancy']);
     *  console.log(arr.value);   // ['Nancy', null]
     *  ```
     * @param {?} value
     * @param {?=} options
     * @return {?}
     */
    FormArray.prototype.patchValue = function (value, options) {
        var _this = this;
        if (options === void 0) { options = {}; }
        value.forEach(function (newValue, index) {
            if (_this.at(index)) {
                _this.at(index).patchValue(newValue, { onlySelf: true, emitEvent: options.emitEvent });
            }
        });
        this.updateValueAndValidity(options);
    };
    /**
     * Resets the {\@link FormArray}. This means by default:
     *
     * * The array and all descendants are marked `pristine`
     * * The array and all descendants are marked `untouched`
     * * The value of all descendants will be null or null maps
     *
     * You can also reset to a specific form state by passing in an array of states
     * that matches the structure of the control. The state can be a standalone value
     * or a form state object with both a value and a disabled status.
     *
     * ### Example
     *
     * ```ts
     * this.arr.reset(['name', 'last name']);
     *
     * console.log(this.arr.value);  // ['name', 'last name']
     * ```
     *
     * - OR -
     *
     * ```
     * this.arr.reset([
     *   {value: 'name', disabled: true},
     *   'last'
     * ]);
     *
     * console.log(this.arr.value);  // ['name', 'last name']
     * console.log(this.arr.get(0).status);  // 'DISABLED'
     * ```
     * @param {?=} value
     * @param {?=} options
     * @return {?}
     */
    FormArray.prototype.reset = function (value, options) {
        if (value === void 0) { value = []; }
        if (options === void 0) { options = {}; }
        this._forEachChild(function (control, index) {
            control.reset(value[index], { onlySelf: true, emitEvent: options.emitEvent });
        });
        this.updateValueAndValidity(options);
        this._updatePristine(options);
        this._updateTouched(options);
    };
    /**
     * The aggregate value of the array, including any disabled controls.
     *
     * If you'd like to include all values regardless of disabled status, use this method.
     * Otherwise, the `value` property is the best way to get the value of the array.
     * @return {?}
     */
    FormArray.prototype.getRawValue = function () {
        return this.controls.map(function (control) {
            return control instanceof FormControl ? control.value : ((control)).getRawValue();
        });
    };
    /**
     * \@internal
     * @param {?} index
     * @return {?}
     */
    FormArray.prototype._throwIfControlMissing = function (index) {
        if (!this.controls.length) {
            throw new Error("\n        There are no form controls registered with this array yet.  If you're using ngModel,\n        you may want to check next tick (e.g. use setTimeout).\n      ");
        }
        if (!this.at(index)) {
            throw new Error("Cannot find form control at index " + index);
        }
    };
    /**
     * \@internal
     * @param {?} cb
     * @return {?}
     */
    FormArray.prototype._forEachChild = function (cb) {
        this.controls.forEach(function (control, index) { cb(control, index); });
    };
    /**
     * \@internal
     * @return {?}
     */
    FormArray.prototype._updateValue = function () {
        var _this = this;
        this._value = this.controls.filter(function (control) { return control.enabled || _this.disabled; })
            .map(function (control) { return control.value; });
    };
    /**
     * \@internal
     * @param {?} condition
     * @return {?}
     */
    FormArray.prototype._anyControls = function (condition) {
        return this.controls.some(function (control) { return control.enabled && condition(control); });
    };
    /**
     * \@internal
     * @return {?}
     */
    FormArray.prototype._setUpControls = function () {
        var _this = this;
        this._forEachChild(function (control) { return _this._registerControl(control); });
    };
    /**
     * \@internal
     * @param {?} value
     * @return {?}
     */
    FormArray.prototype._checkAllValuesPresent = function (value) {
        this._forEachChild(function (control, i) {
            if (value[i] === undefined) {
                throw new Error("Must supply a value for form control at index: " + i + ".");
            }
        });
    };
    /**
     * \@internal
     * @return {?}
     */
    FormArray.prototype._allControlsDisabled = function () {
        for (var _i = 0, _a = this.controls; _i < _a.length; _i++) {
            var control = _a[_i];
            if (control.enabled)
                return false;
        }
        return this.controls.length > 0 || this.disabled;
    };
    /**
     * @param {?} control
     * @return {?}
     */
    FormArray.prototype._registerControl = function (control) {
        control.setParent(this);
        control._registerOnCollectionChange(this._onCollectionChange);
    };
    return FormArray;
}(AbstractControl));
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var formDirectiveProvider = {
    provide: ControlContainer,
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["forwardRef"])(function () { return NgForm; })
};
var resolvedPromise = Promise.resolve(null);
/**
 * \@whatItDoes Creates a top-level {\@link FormGroup} instance and binds it to a form
 * to track aggregate form value and validation status.
 *
 * \@howToUse
 *
 * As soon as you import the `FormsModule`, this directive becomes active by default on
 * all `<form>` tags.  You don't need to add a special selector.
 *
 * You can export the directive into a local template variable using `ngForm` as the key
 * (ex: `#myForm="ngForm"`). This is optional, but useful.  Many properties from the underlying
 * {\@link FormGroup} instance are duplicated on the directive itself, so a reference to it
 * will give you access to the aggregate value and validity status of the form, as well as
 * user interaction properties like `dirty` and `touched`.
 *
 * To register child controls with the form, you'll want to use {\@link NgModel} with a
 * `name` attribute.  You can also use {\@link NgModelGroup} if you'd like to create
 * sub-groups within the form.
 *
 * You can listen to the directive's `ngSubmit` event to be notified when the user has
 * triggered a form submission. The `ngSubmit` event will be emitted with the original form
 * submission event.
 *
 * {\@example forms/ts/simpleForm/simple_form_example.ts region='Component'}
 *
 * * **npm package**: `\@angular/forms`
 *
 * * **NgModule**: `FormsModule`
 *
 *  \@stable
 */
var NgForm = (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](NgForm, _super);
    /**
     * @param {?} validators
     * @param {?} asyncValidators
     */
    function NgForm(validators, asyncValidators) {
        var _this = _super.call(this) || this;
        _this._submitted = false;
        _this.ngSubmit = new __WEBPACK_IMPORTED_MODULE_1__angular_core__["EventEmitter"]();
        _this.form =
            new FormGroup({}, composeValidators(validators), composeAsyncValidators(asyncValidators));
        return _this;
    }
    Object.defineProperty(NgForm.prototype, "submitted", {
        /**
         * @return {?}
         */
        get: function () { return this._submitted; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgForm.prototype, "formDirective", {
        /**
         * @return {?}
         */
        get: function () { return this; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgForm.prototype, "control", {
        /**
         * @return {?}
         */
        get: function () { return this.form; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgForm.prototype, "path", {
        /**
         * @return {?}
         */
        get: function () { return []; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgForm.prototype, "controls", {
        /**
         * @return {?}
         */
        get: function () { return this.form.controls; },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} dir
     * @return {?}
     */
    NgForm.prototype.addControl = function (dir) {
        var _this = this;
        resolvedPromise.then(function () {
            var /** @type {?} */ container = _this._findContainer(dir.path);
            dir._control = (container.registerControl(dir.name, dir.control));
            setUpControl(dir.control, dir);
            dir.control.updateValueAndValidity({ emitEvent: false });
        });
    };
    /**
     * @param {?} dir
     * @return {?}
     */
    NgForm.prototype.getControl = function (dir) { return (this.form.get(dir.path)); };
    /**
     * @param {?} dir
     * @return {?}
     */
    NgForm.prototype.removeControl = function (dir) {
        var _this = this;
        resolvedPromise.then(function () {
            var /** @type {?} */ container = _this._findContainer(dir.path);
            if (container) {
                container.removeControl(dir.name);
            }
        });
    };
    /**
     * @param {?} dir
     * @return {?}
     */
    NgForm.prototype.addFormGroup = function (dir) {
        var _this = this;
        resolvedPromise.then(function () {
            var /** @type {?} */ container = _this._findContainer(dir.path);
            var /** @type {?} */ group = new FormGroup({});
            setUpFormContainer(group, dir);
            container.registerControl(dir.name, group);
            group.updateValueAndValidity({ emitEvent: false });
        });
    };
    /**
     * @param {?} dir
     * @return {?}
     */
    NgForm.prototype.removeFormGroup = function (dir) {
        var _this = this;
        resolvedPromise.then(function () {
            var /** @type {?} */ container = _this._findContainer(dir.path);
            if (container) {
                container.removeControl(dir.name);
            }
        });
    };
    /**
     * @param {?} dir
     * @return {?}
     */
    NgForm.prototype.getFormGroup = function (dir) { return (this.form.get(dir.path)); };
    /**
     * @param {?} dir
     * @param {?} value
     * @return {?}
     */
    NgForm.prototype.updateModel = function (dir, value) {
        var _this = this;
        resolvedPromise.then(function () {
            var /** @type {?} */ ctrl = (_this.form.get(/** @type {?} */ ((dir.path))));
            ctrl.setValue(value);
        });
    };
    /**
     * @param {?} value
     * @return {?}
     */
    NgForm.prototype.setValue = function (value) { this.control.setValue(value); };
    /**
     * @param {?} $event
     * @return {?}
     */
    NgForm.prototype.onSubmit = function ($event) {
        this._submitted = true;
        this.ngSubmit.emit($event);
        return false;
    };
    /**
     * @return {?}
     */
    NgForm.prototype.onReset = function () { this.resetForm(); };
    /**
     * @param {?=} value
     * @return {?}
     */
    NgForm.prototype.resetForm = function (value) {
        if (value === void 0) { value = undefined; }
        this.form.reset(value);
        this._submitted = false;
    };
    /**
     * \@internal
     * @param {?} path
     * @return {?}
     */
    NgForm.prototype._findContainer = function (path) {
        path.pop();
        return path.length ? (this.form.get(path)) : this.form;
    };
    return NgForm;
}(ControlContainer));
NgForm.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"], args: [{
                selector: 'form:not([ngNoForm]):not([formGroup]),ngForm,[ngForm]',
                providers: [formDirectiveProvider],
                host: { '(submit)': 'onSubmit($event)', '(reset)': 'onReset()' },
                outputs: ['ngSubmit'],
                exportAs: 'ngForm'
            },] },
];
/**
 * @nocollapse
 */
NgForm.ctorParameters = function () { return [
    { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"], args: [NG_VALIDATORS,] },] },
    { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"], args: [NG_ASYNC_VALIDATORS,] },] },
]; };
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var FormErrorExamples = {
    formControlName: "\n    <div [formGroup]=\"myGroup\">\n      <input formControlName=\"firstName\">\n    </div>\n\n    In your class:\n\n    this.myGroup = new FormGroup({\n       firstName: new FormControl()\n    });",
    formGroupName: "\n    <div [formGroup]=\"myGroup\">\n       <div formGroupName=\"person\">\n          <input formControlName=\"firstName\">\n       </div>\n    </div>\n\n    In your class:\n\n    this.myGroup = new FormGroup({\n       person: new FormGroup({ firstName: new FormControl() })\n    });",
    formArrayName: "\n    <div [formGroup]=\"myGroup\">\n      <div formArrayName=\"cities\">\n        <div *ngFor=\"let city of cityArray.controls; index as i\">\n          <input [formControlName]=\"i\">\n        </div>\n      </div>\n    </div>\n\n    In your class:\n\n    this.cityArray = new FormArray([new FormControl('SF')]);\n    this.myGroup = new FormGroup({\n      cities: this.cityArray\n    });",
    ngModelGroup: "\n    <form>\n       <div ngModelGroup=\"person\">\n          <input [(ngModel)]=\"person.name\" name=\"firstName\">\n       </div>\n    </form>",
    ngModelWithFormGroup: "\n    <div [formGroup]=\"myGroup\">\n       <input formControlName=\"firstName\">\n       <input [(ngModel)]=\"showMoreControls\" [ngModelOptions]=\"{standalone: true}\">\n    </div>\n  "
};
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var TemplateDrivenErrors = (function () {
    function TemplateDrivenErrors() {
    }
    /**
     * @return {?}
     */
    TemplateDrivenErrors.modelParentException = function () {
        throw new Error("\n      ngModel cannot be used to register form controls with a parent formGroup directive.  Try using\n      formGroup's partner directive \"formControlName\" instead.  Example:\n\n      " + FormErrorExamples.formControlName + "\n\n      Or, if you'd like to avoid registering this form control, indicate that it's standalone in ngModelOptions:\n\n      Example:\n\n      " + FormErrorExamples.ngModelWithFormGroup);
    };
    /**
     * @return {?}
     */
    TemplateDrivenErrors.formGroupNameException = function () {
        throw new Error("\n      ngModel cannot be used to register form controls with a parent formGroupName or formArrayName directive.\n\n      Option 1: Use formControlName instead of ngModel (reactive strategy):\n\n      " + FormErrorExamples.formGroupName + "\n\n      Option 2:  Update ngModel's parent be ngModelGroup (template-driven strategy):\n\n      " + FormErrorExamples.ngModelGroup);
    };
    /**
     * @return {?}
     */
    TemplateDrivenErrors.missingNameException = function () {
        throw new Error("If ngModel is used within a form tag, either the name attribute must be set or the form\n      control must be defined as 'standalone' in ngModelOptions.\n\n      Example 1: <input [(ngModel)]=\"person.firstName\" name=\"first\">\n      Example 2: <input [(ngModel)]=\"person.firstName\" [ngModelOptions]=\"{standalone: true}\">");
    };
    /**
     * @return {?}
     */
    TemplateDrivenErrors.modelGroupParentException = function () {
        throw new Error("\n      ngModelGroup cannot be used with a parent formGroup directive.\n\n      Option 1: Use formGroupName instead of ngModelGroup (reactive strategy):\n\n      " + FormErrorExamples.formGroupName + "\n\n      Option 2:  Use a regular form tag instead of the formGroup directive (template-driven strategy):\n\n      " + FormErrorExamples.ngModelGroup);
    };
    return TemplateDrivenErrors;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var modelGroupProvider = {
    provide: ControlContainer,
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["forwardRef"])(function () { return NgModelGroup; })
};
/**
 * \@whatItDoes Creates and binds a {\@link FormGroup} instance to a DOM element.
 *
 * \@howToUse
 *
 * This directive can only be used as a child of {\@link NgForm} (or in other words,
 * within `<form>` tags).
 *
 * Use this directive if you'd like to create a sub-group within a form. This can
 * come in handy if you want to validate a sub-group of your form separately from
 * the rest of your form, or if some values in your domain model make more sense to
 * consume together in a nested object.
 *
 * Pass in the name you'd like this sub-group to have and it will become the key
 * for the sub-group in the form's full value. You can also export the directive into
 * a local template variable using `ngModelGroup` (ex: `#myGroup="ngModelGroup"`).
 *
 * {\@example forms/ts/ngModelGroup/ng_model_group_example.ts region='Component'}
 *
 * * **npm package**: `\@angular/forms`
 *
 * * **NgModule**: `FormsModule`
 *
 * \@stable
 */
var NgModelGroup = (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](NgModelGroup, _super);
    /**
     * @param {?} parent
     * @param {?} validators
     * @param {?} asyncValidators
     */
    function NgModelGroup(parent, validators, asyncValidators) {
        var _this = _super.call(this) || this;
        _this._parent = parent;
        _this._validators = validators;
        _this._asyncValidators = asyncValidators;
        return _this;
    }
    /**
     * \@internal
     * @return {?}
     */
    NgModelGroup.prototype._checkParentType = function () {
        if (!(this._parent instanceof NgModelGroup) && !(this._parent instanceof NgForm)) {
            TemplateDrivenErrors.modelGroupParentException();
        }
    };
    return NgModelGroup;
}(AbstractFormGroupDirective));
NgModelGroup.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"], args: [{ selector: '[ngModelGroup]', providers: [modelGroupProvider], exportAs: 'ngModelGroup' },] },
];
/**
 * @nocollapse
 */
NgModelGroup.ctorParameters = function () { return [
    { type: ControlContainer, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Host"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["SkipSelf"] },] },
    { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"], args: [NG_VALIDATORS,] },] },
    { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"], args: [NG_ASYNC_VALIDATORS,] },] },
]; };
NgModelGroup.propDecorators = {
    'name': [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"], args: ['ngModelGroup',] },],
};
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var formControlBinding = {
    provide: NgControl,
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["forwardRef"])(function () { return NgModel; })
};
/**
 * `ngModel` forces an additional change detection run when its inputs change:
 * E.g.:
 * ```
 * <div>{{myModel.valid}}</div>
 * <input [(ngModel)]="myValue" #myModel="ngModel">
 * ```
 * I.e. `ngModel` can export itself on the element and then be used in the template.
 * Normally, this would result in expressions before the `input` that use the exported directive
 * to have and old value as they have been
 * dirty checked before. As this is a very common case for `ngModel`, we added this second change
 * detection run.
 *
 * Notes:
 * - this is just one extra run no matter how many `ngModel` have been changed.
 * - this is a general problem when using `exportAs` for directives!
 */
var resolvedPromise$1 = Promise.resolve(null);
/**
 * \@whatItDoes Creates a {\@link FormControl} instance from a domain model and binds it
 * to a form control element.
 *
 * The {\@link FormControl} instance will track the value, user interaction, and
 * validation status of the control and keep the view synced with the model. If used
 * within a parent form, the directive will also register itself with the form as a child
 * control.
 *
 * \@howToUse
 *
 * This directive can be used by itself or as part of a larger form. All you need is the
 * `ngModel` selector to activate it.
 *
 * It accepts a domain model as an optional {\@link Input}. If you have a one-way binding
 * to `ngModel` with `[]` syntax, changing the value of the domain model in the component
 * class will set the value in the view. If you have a two-way binding with `[()]` syntax
 * (also known as 'banana-box syntax'), the value in the UI will always be synced back to
 * the domain model in your class as well.
 *
 * If you wish to inspect the properties of the associated {\@link FormControl} (like
 * validity state), you can also export the directive into a local template variable using
 * `ngModel` as the key (ex: `#myVar="ngModel"`). You can then access the control using the
 * directive's `control` property, but most properties you'll need (like `valid` and `dirty`)
 * will fall through to the control anyway, so you can access them directly. You can see a
 * full list of properties directly available in {\@link AbstractControlDirective}.
 *
 * The following is an example of a simple standalone control using `ngModel`:
 *
 * {\@example forms/ts/simpleNgModel/simple_ng_model_example.ts region='Component'}
 *
 * When using the `ngModel` within `<form>` tags, you'll also need to supply a `name` attribute
 * so that the control can be registered with the parent form under that name.
 *
 * It's worth noting that in the context of a parent form, you often can skip one-way or
 * two-way binding because the parent form will sync the value for you. You can access
 * its properties by exporting it into a local template variable using `ngForm` (ex:
 * `#f="ngForm"`). Then you can pass it where it needs to go on submit.
 *
 * If you do need to populate initial values into your form, using a one-way binding for
 * `ngModel` tends to be sufficient as long as you use the exported form's value rather
 * than the domain model's value on submit.
 *
 * Take a look at an example of using `ngModel` within a form:
 *
 * {\@example forms/ts/simpleForm/simple_form_example.ts region='Component'}
 *
 * To see `ngModel` examples with different form control types, see:
 *
 * * Radio buttons: {\@link RadioControlValueAccessor}
 * * Selects: {\@link SelectControlValueAccessor}
 *
 * **npm package**: `\@angular/forms`
 *
 * **NgModule**: `FormsModule`
 *
 *  \@stable
 */
var NgModel = (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](NgModel, _super);
    /**
     * @param {?} parent
     * @param {?} validators
     * @param {?} asyncValidators
     * @param {?} valueAccessors
     */
    function NgModel(parent, validators, asyncValidators, valueAccessors) {
        var _this = _super.call(this) || this;
        /**
         * \@internal
         */
        _this._control = new FormControl();
        /**
         * \@internal
         */
        _this._registered = false;
        _this.update = new __WEBPACK_IMPORTED_MODULE_1__angular_core__["EventEmitter"]();
        _this._parent = parent;
        _this._rawValidators = validators || [];
        _this._rawAsyncValidators = asyncValidators || [];
        _this.valueAccessor = selectValueAccessor(_this, valueAccessors);
        return _this;
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    NgModel.prototype.ngOnChanges = function (changes) {
        this._checkForErrors();
        if (!this._registered)
            this._setUpControl();
        if ('isDisabled' in changes) {
            this._updateDisabled(changes);
        }
        if (isPropertyUpdated(changes, this.viewModel)) {
            this._updateValue(this.model);
            this.viewModel = this.model;
        }
    };
    /**
     * @return {?}
     */
    NgModel.prototype.ngOnDestroy = function () { this.formDirective && this.formDirective.removeControl(this); };
    Object.defineProperty(NgModel.prototype, "control", {
        /**
         * @return {?}
         */
        get: function () { return this._control; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgModel.prototype, "path", {
        /**
         * @return {?}
         */
        get: function () {
            return this._parent ? controlPath(this.name, this._parent) : [this.name];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgModel.prototype, "formDirective", {
        /**
         * @return {?}
         */
        get: function () { return this._parent ? this._parent.formDirective : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgModel.prototype, "validator", {
        /**
         * @return {?}
         */
        get: function () { return composeValidators(this._rawValidators); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgModel.prototype, "asyncValidator", {
        /**
         * @return {?}
         */
        get: function () {
            return composeAsyncValidators(this._rawAsyncValidators);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} newValue
     * @return {?}
     */
    NgModel.prototype.viewToModelUpdate = function (newValue) {
        this.viewModel = newValue;
        this.update.emit(newValue);
    };
    /**
     * @return {?}
     */
    NgModel.prototype._setUpControl = function () {
        this._isStandalone() ? this._setUpStandalone() :
            this.formDirective.addControl(this);
        this._registered = true;
    };
    /**
     * @return {?}
     */
    NgModel.prototype._isStandalone = function () {
        return !this._parent || !!(this.options && this.options.standalone);
    };
    /**
     * @return {?}
     */
    NgModel.prototype._setUpStandalone = function () {
        setUpControl(this._control, this);
        this._control.updateValueAndValidity({ emitEvent: false });
    };
    /**
     * @return {?}
     */
    NgModel.prototype._checkForErrors = function () {
        if (!this._isStandalone()) {
            this._checkParentType();
        }
        this._checkName();
    };
    /**
     * @return {?}
     */
    NgModel.prototype._checkParentType = function () {
        if (!(this._parent instanceof NgModelGroup) &&
            this._parent instanceof AbstractFormGroupDirective) {
            TemplateDrivenErrors.formGroupNameException();
        }
        else if (!(this._parent instanceof NgModelGroup) && !(this._parent instanceof NgForm)) {
            TemplateDrivenErrors.modelParentException();
        }
    };
    /**
     * @return {?}
     */
    NgModel.prototype._checkName = function () {
        if (this.options && this.options.name)
            this.name = this.options.name;
        if (!this._isStandalone() && !this.name) {
            TemplateDrivenErrors.missingNameException();
        }
    };
    /**
     * @param {?} value
     * @return {?}
     */
    NgModel.prototype._updateValue = function (value) {
        var _this = this;
        resolvedPromise$1.then(function () { _this.control.setValue(value, { emitViewToModelChange: false }); });
    };
    /**
     * @param {?} changes
     * @return {?}
     */
    NgModel.prototype._updateDisabled = function (changes) {
        var _this = this;
        var /** @type {?} */ disabledValue = changes['isDisabled'].currentValue;
        var /** @type {?} */ isDisabled = disabledValue === '' || (disabledValue && disabledValue !== 'false');
        resolvedPromise$1.then(function () {
            if (isDisabled && !_this.control.disabled) {
                _this.control.disable();
            }
            else if (!isDisabled && _this.control.disabled) {
                _this.control.enable();
            }
        });
    };
    return NgModel;
}(NgControl));
NgModel.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"], args: [{
                selector: '[ngModel]:not([formControlName]):not([formControl])',
                providers: [formControlBinding],
                exportAs: 'ngModel'
            },] },
];
/**
 * @nocollapse
 */
NgModel.ctorParameters = function () { return [
    { type: ControlContainer, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Host"] },] },
    { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"], args: [NG_VALIDATORS,] },] },
    { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"], args: [NG_ASYNC_VALIDATORS,] },] },
    { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"], args: [NG_VALUE_ACCESSOR,] },] },
]; };
NgModel.propDecorators = {
    'name': [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"] },],
    'isDisabled': [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"], args: ['disabled',] },],
    'model': [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"], args: ['ngModel',] },],
    'options': [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"], args: ['ngModelOptions',] },],
    'update': [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Output"], args: ['ngModelChange',] },],
};
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var ReactiveErrors = (function () {
    function ReactiveErrors() {
    }
    /**
     * @return {?}
     */
    ReactiveErrors.controlParentException = function () {
        throw new Error("formControlName must be used with a parent formGroup directive.  You'll want to add a formGroup\n       directive and pass it an existing FormGroup instance (you can create one in your class).\n\n      Example:\n\n      " + FormErrorExamples.formControlName);
    };
    /**
     * @return {?}
     */
    ReactiveErrors.ngModelGroupException = function () {
        throw new Error("formControlName cannot be used with an ngModelGroup parent. It is only compatible with parents\n       that also have a \"form\" prefix: formGroupName, formArrayName, or formGroup.\n\n       Option 1:  Update the parent to be formGroupName (reactive form strategy)\n\n        " + FormErrorExamples.formGroupName + "\n\n        Option 2: Use ngModel instead of formControlName (template-driven strategy)\n\n        " + FormErrorExamples.ngModelGroup);
    };
    /**
     * @return {?}
     */
    ReactiveErrors.missingFormException = function () {
        throw new Error("formGroup expects a FormGroup instance. Please pass one in.\n\n       Example:\n\n       " + FormErrorExamples.formControlName);
    };
    /**
     * @return {?}
     */
    ReactiveErrors.groupParentException = function () {
        throw new Error("formGroupName must be used with a parent formGroup directive.  You'll want to add a formGroup\n      directive and pass it an existing FormGroup instance (you can create one in your class).\n\n      Example:\n\n      " + FormErrorExamples.formGroupName);
    };
    /**
     * @return {?}
     */
    ReactiveErrors.arrayParentException = function () {
        throw new Error("formArrayName must be used with a parent formGroup directive.  You'll want to add a formGroup\n       directive and pass it an existing FormGroup instance (you can create one in your class).\n\n        Example:\n\n        " + FormErrorExamples.formArrayName);
    };
    /**
     * @return {?}
     */
    ReactiveErrors.disabledAttrWarning = function () {
        console.warn("\n      It looks like you're using the disabled attribute with a reactive form directive. If you set disabled to true\n      when you set up this control in your component class, the disabled attribute will actually be set in the DOM for\n      you. We recommend using this approach to avoid 'changed after checked' errors.\n       \n      Example: \n      form = new FormGroup({\n        first: new FormControl({value: 'Nancy', disabled: true}, Validators.required),\n        last: new FormControl('Drew', Validators.required)\n      });\n    ");
    };
    return ReactiveErrors;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var formControlBinding$1 = {
    provide: NgControl,
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["forwardRef"])(function () { return FormControlDirective; })
};
/**
 * \@whatItDoes Syncs a standalone {\@link FormControl} instance to a form control element.
 *
 * In other words, this directive ensures that any values written to the {\@link FormControl}
 * instance programmatically will be written to the DOM element (model -> view). Conversely,
 * any values written to the DOM element through user input will be reflected in the
 * {\@link FormControl} instance (view -> model).
 *
 * \@howToUse
 *
 * Use this directive if you'd like to create and manage a {\@link FormControl} instance directly.
 * Simply create a {\@link FormControl}, save it to your component class, and pass it into the
 * {\@link FormControlDirective}.
 *
 * This directive is designed to be used as a standalone control.  Unlike {\@link FormControlName},
 * it does not require that your {\@link FormControl} instance be part of any parent
 * {\@link FormGroup}, and it won't be registered to any {\@link FormGroupDirective} that
 * exists above it.
 *
 * **Get the value**: the `value` property is always synced and available on the
 * {\@link FormControl} instance. See a full list of available properties in
 * {\@link AbstractControl}.
 *
 * **Set the value**: You can pass in an initial value when instantiating the {\@link FormControl},
 * or you can set it programmatically later using {\@link AbstractControl#setValue setValue} or
 * {\@link AbstractControl#patchValue patchValue}.
 *
 * **Listen to value**: If you want to listen to changes in the value of the control, you can
 * subscribe to the {\@link AbstractControl#valueChanges valueChanges} event.  You can also listen to
 * {\@link AbstractControl#statusChanges statusChanges} to be notified when the validation status is
 * re-calculated.
 *
 * ### Example
 *
 * {\@example forms/ts/simpleFormControl/simple_form_control_example.ts region='Component'}
 *
 * * **npm package**: `\@angular/forms`
 *
 * * **NgModule**: `ReactiveFormsModule`
 *
 *  \@stable
 */
var FormControlDirective = (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](FormControlDirective, _super);
    /**
     * @param {?} validators
     * @param {?} asyncValidators
     * @param {?} valueAccessors
     */
    function FormControlDirective(validators, asyncValidators, valueAccessors) {
        var _this = _super.call(this) || this;
        _this.update = new __WEBPACK_IMPORTED_MODULE_1__angular_core__["EventEmitter"]();
        _this._rawValidators = validators || [];
        _this._rawAsyncValidators = asyncValidators || [];
        _this.valueAccessor = selectValueAccessor(_this, valueAccessors);
        return _this;
    }
    Object.defineProperty(FormControlDirective.prototype, "isDisabled", {
        /**
         * @param {?} isDisabled
         * @return {?}
         */
        set: function (isDisabled) { ReactiveErrors.disabledAttrWarning(); },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} changes
     * @return {?}
     */
    FormControlDirective.prototype.ngOnChanges = function (changes) {
        if (this._isControlChanged(changes)) {
            setUpControl(this.form, this);
            if (this.control.disabled && ((this.valueAccessor)).setDisabledState) {
                ((((this.valueAccessor)).setDisabledState))(true);
            }
            this.form.updateValueAndValidity({ emitEvent: false });
        }
        if (isPropertyUpdated(changes, this.viewModel)) {
            this.form.setValue(this.model);
            this.viewModel = this.model;
        }
    };
    Object.defineProperty(FormControlDirective.prototype, "path", {
        /**
         * @return {?}
         */
        get: function () { return []; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormControlDirective.prototype, "validator", {
        /**
         * @return {?}
         */
        get: function () { return composeValidators(this._rawValidators); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormControlDirective.prototype, "asyncValidator", {
        /**
         * @return {?}
         */
        get: function () {
            return composeAsyncValidators(this._rawAsyncValidators);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormControlDirective.prototype, "control", {
        /**
         * @return {?}
         */
        get: function () { return this.form; },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} newValue
     * @return {?}
     */
    FormControlDirective.prototype.viewToModelUpdate = function (newValue) {
        this.viewModel = newValue;
        this.update.emit(newValue);
    };
    /**
     * @param {?} changes
     * @return {?}
     */
    FormControlDirective.prototype._isControlChanged = function (changes) {
        return changes.hasOwnProperty('form');
    };
    return FormControlDirective;
}(NgControl));
FormControlDirective.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"], args: [{ selector: '[formControl]', providers: [formControlBinding$1], exportAs: 'ngForm' },] },
];
/**
 * @nocollapse
 */
FormControlDirective.ctorParameters = function () { return [
    { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"], args: [NG_VALIDATORS,] },] },
    { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"], args: [NG_ASYNC_VALIDATORS,] },] },
    { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"], args: [NG_VALUE_ACCESSOR,] },] },
]; };
FormControlDirective.propDecorators = {
    'form': [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"], args: ['formControl',] },],
    'model': [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"], args: ['ngModel',] },],
    'update': [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Output"], args: ['ngModelChange',] },],
    'isDisabled': [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"], args: ['disabled',] },],
};
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var formDirectiveProvider$1 = {
    provide: ControlContainer,
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["forwardRef"])(function () { return FormGroupDirective; })
};
/**
 * \@whatItDoes Binds an existing {\@link FormGroup} to a DOM element.
 *
 * \@howToUse
 *
 * This directive accepts an existing {\@link FormGroup} instance. It will then use this
 * {\@link FormGroup} instance to match any child {\@link FormControl}, {\@link FormGroup},
 * and {\@link FormArray} instances to child {\@link FormControlName}, {\@link FormGroupName},
 * and {\@link FormArrayName} directives.
 *
 * **Set value**: You can set the form's initial value when instantiating the
 * {\@link FormGroup}, or you can set it programmatically later using the {\@link FormGroup}'s
 * {\@link AbstractControl#setValue setValue} or {\@link AbstractControl#patchValue patchValue}
 * methods.
 *
 * **Listen to value**: If you want to listen to changes in the value of the form, you can subscribe
 * to the {\@link FormGroup}'s {\@link AbstractControl#valueChanges valueChanges} event.  You can also
 * listen to its {\@link AbstractControl#statusChanges statusChanges} event to be notified when the
 * validation status is re-calculated.
 *
 * Furthermore, you can listen to the directive's `ngSubmit` event to be notified when the user has
 * triggered a form submission. The `ngSubmit` event will be emitted with the original form
 * submission event.
 *
 * ### Example
 *
 * In this example, we create form controls for first name and last name.
 *
 * {\@example forms/ts/simpleFormGroup/simple_form_group_example.ts region='Component'}
 *
 * **npm package**: `\@angular/forms`
 *
 * **NgModule**: {\@link ReactiveFormsModule}
 *
 *  \@stable
 */
var FormGroupDirective = (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](FormGroupDirective, _super);
    /**
     * @param {?} _validators
     * @param {?} _asyncValidators
     */
    function FormGroupDirective(_validators, _asyncValidators) {
        var _this = _super.call(this) || this;
        _this._validators = _validators;
        _this._asyncValidators = _asyncValidators;
        _this._submitted = false;
        _this.directives = [];
        _this.form = ((null));
        _this.ngSubmit = new __WEBPACK_IMPORTED_MODULE_1__angular_core__["EventEmitter"]();
        return _this;
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    FormGroupDirective.prototype.ngOnChanges = function (changes) {
        this._checkFormPresent();
        if (changes.hasOwnProperty('form')) {
            this._updateValidators();
            this._updateDomValue();
            this._updateRegistrations();
        }
    };
    Object.defineProperty(FormGroupDirective.prototype, "submitted", {
        /**
         * @return {?}
         */
        get: function () { return this._submitted; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormGroupDirective.prototype, "formDirective", {
        /**
         * @return {?}
         */
        get: function () { return this; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormGroupDirective.prototype, "control", {
        /**
         * @return {?}
         */
        get: function () { return this.form; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormGroupDirective.prototype, "path", {
        /**
         * @return {?}
         */
        get: function () { return []; },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} dir
     * @return {?}
     */
    FormGroupDirective.prototype.addControl = function (dir) {
        var /** @type {?} */ ctrl = this.form.get(dir.path);
        setUpControl(ctrl, dir);
        ctrl.updateValueAndValidity({ emitEvent: false });
        this.directives.push(dir);
        return ctrl;
    };
    /**
     * @param {?} dir
     * @return {?}
     */
    FormGroupDirective.prototype.getControl = function (dir) { return (this.form.get(dir.path)); };
    /**
     * @param {?} dir
     * @return {?}
     */
    FormGroupDirective.prototype.removeControl = function (dir) { remove(this.directives, dir); };
    /**
     * @param {?} dir
     * @return {?}
     */
    FormGroupDirective.prototype.addFormGroup = function (dir) {
        var /** @type {?} */ ctrl = this.form.get(dir.path);
        setUpFormContainer(ctrl, dir);
        ctrl.updateValueAndValidity({ emitEvent: false });
    };
    /**
     * @param {?} dir
     * @return {?}
     */
    FormGroupDirective.prototype.removeFormGroup = function (dir) { };
    /**
     * @param {?} dir
     * @return {?}
     */
    FormGroupDirective.prototype.getFormGroup = function (dir) { return (this.form.get(dir.path)); };
    /**
     * @param {?} dir
     * @return {?}
     */
    FormGroupDirective.prototype.addFormArray = function (dir) {
        var /** @type {?} */ ctrl = this.form.get(dir.path);
        setUpFormContainer(ctrl, dir);
        ctrl.updateValueAndValidity({ emitEvent: false });
    };
    /**
     * @param {?} dir
     * @return {?}
     */
    FormGroupDirective.prototype.removeFormArray = function (dir) { };
    /**
     * @param {?} dir
     * @return {?}
     */
    FormGroupDirective.prototype.getFormArray = function (dir) { return (this.form.get(dir.path)); };
    /**
     * @param {?} dir
     * @param {?} value
     * @return {?}
     */
    FormGroupDirective.prototype.updateModel = function (dir, value) {
        var /** @type {?} */ ctrl = (this.form.get(dir.path));
        ctrl.setValue(value);
    };
    /**
     * @param {?} $event
     * @return {?}
     */
    FormGroupDirective.prototype.onSubmit = function ($event) {
        this._submitted = true;
        this.ngSubmit.emit($event);
        return false;
    };
    /**
     * @return {?}
     */
    FormGroupDirective.prototype.onReset = function () { this.resetForm(); };
    /**
     * @param {?=} value
     * @return {?}
     */
    FormGroupDirective.prototype.resetForm = function (value) {
        if (value === void 0) { value = undefined; }
        this.form.reset(value);
        this._submitted = false;
    };
    /**
     * \@internal
     * @return {?}
     */
    FormGroupDirective.prototype._updateDomValue = function () {
        var _this = this;
        this.directives.forEach(function (dir) {
            var /** @type {?} */ newCtrl = _this.form.get(dir.path);
            if (dir._control !== newCtrl) {
                cleanUpControl(dir._control, dir);
                if (newCtrl)
                    setUpControl(newCtrl, dir);
                dir._control = newCtrl;
            }
        });
        this.form._updateTreeValidity({ emitEvent: false });
    };
    /**
     * @return {?}
     */
    FormGroupDirective.prototype._updateRegistrations = function () {
        var _this = this;
        this.form._registerOnCollectionChange(function () { return _this._updateDomValue(); });
        if (this._oldForm)
            this._oldForm._registerOnCollectionChange(function () { });
        this._oldForm = this.form;
    };
    /**
     * @return {?}
     */
    FormGroupDirective.prototype._updateValidators = function () {
        var /** @type {?} */ sync = composeValidators(this._validators);
        this.form.validator = Validators.compose([/** @type {?} */ ((this.form.validator)), /** @type {?} */ ((sync))]);
        var /** @type {?} */ async = composeAsyncValidators(this._asyncValidators);
        this.form.asyncValidator = Validators.composeAsync([/** @type {?} */ ((this.form.asyncValidator)), /** @type {?} */ ((async))]);
    };
    /**
     * @return {?}
     */
    FormGroupDirective.prototype._checkFormPresent = function () {
        if (!this.form) {
            ReactiveErrors.missingFormException();
        }
    };
    return FormGroupDirective;
}(ControlContainer));
FormGroupDirective.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"], args: [{
                selector: '[formGroup]',
                providers: [formDirectiveProvider$1],
                host: { '(submit)': 'onSubmit($event)', '(reset)': 'onReset()' },
                exportAs: 'ngForm'
            },] },
];
/**
 * @nocollapse
 */
FormGroupDirective.ctorParameters = function () { return [
    { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"], args: [NG_VALIDATORS,] },] },
    { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"], args: [NG_ASYNC_VALIDATORS,] },] },
]; };
FormGroupDirective.propDecorators = {
    'form': [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"], args: ['formGroup',] },],
    'ngSubmit': [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Output"] },],
};
/**
 * @template T
 * @param {?} list
 * @param {?} el
 * @return {?}
 */
function remove(list, el) {
    var /** @type {?} */ index = list.indexOf(el);
    if (index > -1) {
        list.splice(index, 1);
    }
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var formGroupNameProvider = {
    provide: ControlContainer,
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["forwardRef"])(function () { return FormGroupName; })
};
/**
 * \@whatItDoes Syncs a nested {\@link FormGroup} to a DOM element.
 *
 * \@howToUse
 *
 * This directive can only be used with a parent {\@link FormGroupDirective} (selector:
 * `[formGroup]`).
 *
 * It accepts the string name of the nested {\@link FormGroup} you want to link, and
 * will look for a {\@link FormGroup} registered with that name in the parent
 * {\@link FormGroup} instance you passed into {\@link FormGroupDirective}.
 *
 * Nested form groups can come in handy when you want to validate a sub-group of a
 * form separately from the rest or when you'd like to group the values of certain
 * controls into their own nested object.
 *
 * **Access the group**: You can access the associated {\@link FormGroup} using the
 * {\@link AbstractControl#get} method. Ex: `this.form.get('name')`.
 *
 * You can also access individual controls within the group using dot syntax.
 * Ex: `this.form.get('name.first')`
 *
 * **Get the value**: the `value` property is always synced and available on the
 * {\@link FormGroup}. See a full list of available properties in {\@link AbstractControl}.
 *
 * **Set the value**: You can set an initial value for each child control when instantiating
 * the {\@link FormGroup}, or you can set it programmatically later using
 * {\@link AbstractControl#setValue setValue} or {\@link AbstractControl#patchValue patchValue}.
 *
 * **Listen to value**: If you want to listen to changes in the value of the group, you can
 * subscribe to the {\@link AbstractControl#valueChanges valueChanges} event.  You can also listen to
 * {\@link AbstractControl#statusChanges statusChanges} to be notified when the validation status is
 * re-calculated.
 *
 * ### Example
 *
 * {\@example forms/ts/nestedFormGroup/nested_form_group_example.ts region='Component'}
 *
 * * **npm package**: `\@angular/forms`
 *
 * * **NgModule**: `ReactiveFormsModule`
 *
 * \@stable
 */
var FormGroupName = (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](FormGroupName, _super);
    /**
     * @param {?} parent
     * @param {?} validators
     * @param {?} asyncValidators
     */
    function FormGroupName(parent, validators, asyncValidators) {
        var _this = _super.call(this) || this;
        _this._parent = parent;
        _this._validators = validators;
        _this._asyncValidators = asyncValidators;
        return _this;
    }
    /**
     * \@internal
     * @return {?}
     */
    FormGroupName.prototype._checkParentType = function () {
        if (_hasInvalidParent(this._parent)) {
            ReactiveErrors.groupParentException();
        }
    };
    return FormGroupName;
}(AbstractFormGroupDirective));
FormGroupName.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"], args: [{ selector: '[formGroupName]', providers: [formGroupNameProvider] },] },
];
/**
 * @nocollapse
 */
FormGroupName.ctorParameters = function () { return [
    { type: ControlContainer, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Host"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["SkipSelf"] },] },
    { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"], args: [NG_VALIDATORS,] },] },
    { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"], args: [NG_ASYNC_VALIDATORS,] },] },
]; };
FormGroupName.propDecorators = {
    'name': [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"], args: ['formGroupName',] },],
};
var formArrayNameProvider = {
    provide: ControlContainer,
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["forwardRef"])(function () { return FormArrayName; })
};
/**
 * \@whatItDoes Syncs a nested {\@link FormArray} to a DOM element.
 *
 * \@howToUse
 *
 * This directive is designed to be used with a parent {\@link FormGroupDirective} (selector:
 * `[formGroup]`).
 *
 * It accepts the string name of the nested {\@link FormArray} you want to link, and
 * will look for a {\@link FormArray} registered with that name in the parent
 * {\@link FormGroup} instance you passed into {\@link FormGroupDirective}.
 *
 * Nested form arrays can come in handy when you have a group of form controls but
 * you're not sure how many there will be. Form arrays allow you to create new
 * form controls dynamically.
 *
 * **Access the array**: You can access the associated {\@link FormArray} using the
 * {\@link AbstractControl#get} method on the parent {\@link FormGroup}.
 * Ex: `this.form.get('cities')`.
 *
 * **Get the value**: the `value` property is always synced and available on the
 * {\@link FormArray}. See a full list of available properties in {\@link AbstractControl}.
 *
 * **Set the value**: You can set an initial value for each child control when instantiating
 * the {\@link FormArray}, or you can set the value programmatically later using the
 * {\@link FormArray}'s {\@link AbstractControl#setValue} or {\@link AbstractControl#patchValue}
 * methods.
 *
 * **Listen to value**: If you want to listen to changes in the value of the array, you can
 * subscribe to the {\@link FormArray}'s {\@link AbstractControl#valueChanges} event.  You can also
 * listen to its {\@link AbstractControl#statusChanges} event to be notified when the validation
 * status is re-calculated.
 *
 * **Add new controls**: You can add new controls to the {\@link FormArray} dynamically by
 * calling its {\@link FormArray#push} method.
 *  Ex: `this.form.get('cities').push(new FormControl());`
 *
 * ### Example
 *
 * {\@example forms/ts/nestedFormArray/nested_form_array_example.ts region='Component'}
 *
 * * **npm package**: `\@angular/forms`
 *
 * * **NgModule**: `ReactiveFormsModule`
 *
 * \@stable
 */
var FormArrayName = (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](FormArrayName, _super);
    /**
     * @param {?} parent
     * @param {?} validators
     * @param {?} asyncValidators
     */
    function FormArrayName(parent, validators, asyncValidators) {
        var _this = _super.call(this) || this;
        _this._parent = parent;
        _this._validators = validators;
        _this._asyncValidators = asyncValidators;
        return _this;
    }
    /**
     * @return {?}
     */
    FormArrayName.prototype.ngOnInit = function () {
        this._checkParentType(); /** @type {?} */
        ((this.formDirective)).addFormArray(this);
    };
    /**
     * @return {?}
     */
    FormArrayName.prototype.ngOnDestroy = function () {
        if (this.formDirective) {
            this.formDirective.removeFormArray(this);
        }
    };
    Object.defineProperty(FormArrayName.prototype, "control", {
        /**
         * @return {?}
         */
        get: function () { return ((this.formDirective)).getFormArray(this); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormArrayName.prototype, "formDirective", {
        /**
         * @return {?}
         */
        get: function () {
            return this._parent ? (this._parent.formDirective) : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormArrayName.prototype, "path", {
        /**
         * @return {?}
         */
        get: function () { return controlPath(this.name, this._parent); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormArrayName.prototype, "validator", {
        /**
         * @return {?}
         */
        get: function () { return composeValidators(this._validators); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormArrayName.prototype, "asyncValidator", {
        /**
         * @return {?}
         */
        get: function () {
            return composeAsyncValidators(this._asyncValidators);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    FormArrayName.prototype._checkParentType = function () {
        if (_hasInvalidParent(this._parent)) {
            ReactiveErrors.arrayParentException();
        }
    };
    return FormArrayName;
}(ControlContainer));
FormArrayName.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"], args: [{ selector: '[formArrayName]', providers: [formArrayNameProvider] },] },
];
/**
 * @nocollapse
 */
FormArrayName.ctorParameters = function () { return [
    { type: ControlContainer, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Host"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["SkipSelf"] },] },
    { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"], args: [NG_VALIDATORS,] },] },
    { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"], args: [NG_ASYNC_VALIDATORS,] },] },
]; };
FormArrayName.propDecorators = {
    'name': [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"], args: ['formArrayName',] },],
};
/**
 * @param {?} parent
 * @return {?}
 */
function _hasInvalidParent(parent) {
    return !(parent instanceof FormGroupName) && !(parent instanceof FormGroupDirective) &&
        !(parent instanceof FormArrayName);
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var controlNameBinding = {
    provide: NgControl,
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["forwardRef"])(function () { return FormControlName; })
};
/**
 * \@whatItDoes Syncs a {\@link FormControl} in an existing {\@link FormGroup} to a form control
 * element by name.
 *
 * In other words, this directive ensures that any values written to the {\@link FormControl}
 * instance programmatically will be written to the DOM element (model -> view). Conversely,
 * any values written to the DOM element through user input will be reflected in the
 * {\@link FormControl} instance (view -> model).
 *
 * \@howToUse
 *
 * This directive is designed to be used with a parent {\@link FormGroupDirective} (selector:
 * `[formGroup]`).
 *
 * It accepts the string name of the {\@link FormControl} instance you want to
 * link, and will look for a {\@link FormControl} registered with that name in the
 * closest {\@link FormGroup} or {\@link FormArray} above it.
 *
 * **Access the control**: You can access the {\@link FormControl} associated with
 * this directive by using the {\@link AbstractControl#get get} method.
 * Ex: `this.form.get('first');`
 *
 * **Get value**: the `value` property is always synced and available on the {\@link FormControl}.
 * See a full list of available properties in {\@link AbstractControl}.
 *
 *  **Set value**: You can set an initial value for the control when instantiating the
 *  {\@link FormControl}, or you can set it programmatically later using
 *  {\@link AbstractControl#setValue setValue} or {\@link AbstractControl#patchValue patchValue}.
 *
 * **Listen to value**: If you want to listen to changes in the value of the control, you can
 * subscribe to the {\@link AbstractControl#valueChanges valueChanges} event.  You can also listen to
 * {\@link AbstractControl#statusChanges statusChanges} to be notified when the validation status is
 * re-calculated.
 *
 * ### Example
 *
 * In this example, we create form controls for first name and last name.
 *
 * {\@example forms/ts/simpleFormGroup/simple_form_group_example.ts region='Component'}
 *
 * To see `formControlName` examples with different form control types, see:
 *
 * * Radio buttons: {\@link RadioControlValueAccessor}
 * * Selects: {\@link SelectControlValueAccessor}
 *
 * **npm package**: `\@angular/forms`
 *
 * **NgModule**: {\@link ReactiveFormsModule}
 *
 *  \@stable
 */
var FormControlName = (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](FormControlName, _super);
    /**
     * @param {?} parent
     * @param {?} validators
     * @param {?} asyncValidators
     * @param {?} valueAccessors
     */
    function FormControlName(parent, validators, asyncValidators, valueAccessors) {
        var _this = _super.call(this) || this;
        _this._added = false;
        _this.update = new __WEBPACK_IMPORTED_MODULE_1__angular_core__["EventEmitter"]();
        _this._parent = parent;
        _this._rawValidators = validators || [];
        _this._rawAsyncValidators = asyncValidators || [];
        _this.valueAccessor = selectValueAccessor(_this, valueAccessors);
        return _this;
    }
    Object.defineProperty(FormControlName.prototype, "isDisabled", {
        /**
         * @param {?} isDisabled
         * @return {?}
         */
        set: function (isDisabled) { ReactiveErrors.disabledAttrWarning(); },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} changes
     * @return {?}
     */
    FormControlName.prototype.ngOnChanges = function (changes) {
        if (!this._added)
            this._setUpControl();
        if (isPropertyUpdated(changes, this.viewModel)) {
            this.viewModel = this.model;
            this.formDirective.updateModel(this, this.model);
        }
    };
    /**
     * @return {?}
     */
    FormControlName.prototype.ngOnDestroy = function () {
        if (this.formDirective) {
            this.formDirective.removeControl(this);
        }
    };
    /**
     * @param {?} newValue
     * @return {?}
     */
    FormControlName.prototype.viewToModelUpdate = function (newValue) {
        this.viewModel = newValue;
        this.update.emit(newValue);
    };
    Object.defineProperty(FormControlName.prototype, "path", {
        /**
         * @return {?}
         */
        get: function () { return controlPath(this.name, /** @type {?} */ ((this._parent))); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormControlName.prototype, "formDirective", {
        /**
         * @return {?}
         */
        get: function () { return this._parent ? this._parent.formDirective : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormControlName.prototype, "validator", {
        /**
         * @return {?}
         */
        get: function () { return composeValidators(this._rawValidators); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormControlName.prototype, "asyncValidator", {
        /**
         * @return {?}
         */
        get: function () {
            return ((composeAsyncValidators(this._rawAsyncValidators)));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormControlName.prototype, "control", {
        /**
         * @return {?}
         */
        get: function () { return this._control; },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    FormControlName.prototype._checkParentType = function () {
        if (!(this._parent instanceof FormGroupName) &&
            this._parent instanceof AbstractFormGroupDirective) {
            ReactiveErrors.ngModelGroupException();
        }
        else if (!(this._parent instanceof FormGroupName) && !(this._parent instanceof FormGroupDirective) &&
            !(this._parent instanceof FormArrayName)) {
            ReactiveErrors.controlParentException();
        }
    };
    /**
     * @return {?}
     */
    FormControlName.prototype._setUpControl = function () {
        this._checkParentType();
        this._control = this.formDirective.addControl(this);
        if (this.control.disabled && ((this.valueAccessor)).setDisabledState) {
            ((((this.valueAccessor)).setDisabledState))(true);
        }
        this._added = true;
    };
    return FormControlName;
}(NgControl));
FormControlName.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"], args: [{ selector: '[formControlName]', providers: [controlNameBinding] },] },
];
/**
 * @nocollapse
 */
FormControlName.ctorParameters = function () { return [
    { type: ControlContainer, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Host"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["SkipSelf"] },] },
    { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"], args: [NG_VALIDATORS,] },] },
    { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"], args: [NG_ASYNC_VALIDATORS,] },] },
    { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"], args: [NG_VALUE_ACCESSOR,] },] },
]; };
FormControlName.propDecorators = {
    'name': [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"], args: ['formControlName',] },],
    'model': [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"], args: ['ngModel',] },],
    'update': [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Output"], args: ['ngModelChange',] },],
    'isDisabled': [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"], args: ['disabled',] },],
};
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var REQUIRED_VALIDATOR = {
    provide: NG_VALIDATORS,
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["forwardRef"])(function () { return RequiredValidator; }),
    multi: true
};
var CHECKBOX_REQUIRED_VALIDATOR = {
    provide: NG_VALIDATORS,
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["forwardRef"])(function () { return CheckboxRequiredValidator; }),
    multi: true
};
/**
 * A Directive that adds the `required` validator to any controls marked with the
 * `required` attribute, via the {\@link NG_VALIDATORS} binding.
 *
 * ### Example
 *
 * ```
 * <input name="fullName" ngModel required>
 * ```
 *
 * \@stable
 */
var RequiredValidator = (function () {
    function RequiredValidator() {
    }
    Object.defineProperty(RequiredValidator.prototype, "required", {
        /**
         * @return {?}
         */
        get: function () { return this._required; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._required = value != null && value !== false && "" + value !== 'false';
            if (this._onChange)
                this._onChange();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} c
     * @return {?}
     */
    RequiredValidator.prototype.validate = function (c) {
        return this.required ? Validators.required(c) : null;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    RequiredValidator.prototype.registerOnValidatorChange = function (fn) { this._onChange = fn; };
    return RequiredValidator;
}());
RequiredValidator.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"], args: [{
                selector: ':not([type=checkbox])[required][formControlName],:not([type=checkbox])[required][formControl],:not([type=checkbox])[required][ngModel]',
                providers: [REQUIRED_VALIDATOR],
                host: { '[attr.required]': 'required ? "" : null' }
            },] },
];
/**
 * @nocollapse
 */
RequiredValidator.ctorParameters = function () { return []; };
RequiredValidator.propDecorators = {
    'required': [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"] },],
};
/**
 * A Directive that adds the `required` validator to checkbox controls marked with the
 * `required` attribute, via the {\@link NG_VALIDATORS} binding.
 *
 * ### Example
 *
 * ```
 * <input type="checkbox" name="active" ngModel required>
 * ```
 *
 * \@experimental
 */
var CheckboxRequiredValidator = (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](CheckboxRequiredValidator, _super);
    function CheckboxRequiredValidator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @param {?} c
     * @return {?}
     */
    CheckboxRequiredValidator.prototype.validate = function (c) {
        return this.required ? Validators.requiredTrue(c) : null;
    };
    return CheckboxRequiredValidator;
}(RequiredValidator));
CheckboxRequiredValidator.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"], args: [{
                selector: 'input[type=checkbox][required][formControlName],input[type=checkbox][required][formControl],input[type=checkbox][required][ngModel]',
                providers: [CHECKBOX_REQUIRED_VALIDATOR],
                host: { '[attr.required]': 'required ? "" : null' }
            },] },
];
/**
 * @nocollapse
 */
CheckboxRequiredValidator.ctorParameters = function () { return []; };
/**
 * Provider which adds {\@link EmailValidator} to {\@link NG_VALIDATORS}.
 */
var EMAIL_VALIDATOR = {
    provide: NG_VALIDATORS,
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["forwardRef"])(function () { return EmailValidator; }),
    multi: true
};
/**
 * A Directive that adds the `email` validator to controls marked with the
 * `email` attribute, via the {\@link NG_VALIDATORS} binding.
 *
 * ### Example
 *
 * ```
 * <input type="email" name="email" ngModel email>
 * <input type="email" name="email" ngModel email="true">
 * <input type="email" name="email" ngModel [email]="true">
 * ```
 *
 * \@experimental
 */
var EmailValidator = (function () {
    function EmailValidator() {
    }
    Object.defineProperty(EmailValidator.prototype, "email", {
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._enabled = value === '' || value === true || value === 'true';
            if (this._onChange)
                this._onChange();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} c
     * @return {?}
     */
    EmailValidator.prototype.validate = function (c) {
        return this._enabled ? Validators.email(c) : null;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    EmailValidator.prototype.registerOnValidatorChange = function (fn) { this._onChange = fn; };
    return EmailValidator;
}());
EmailValidator.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"], args: [{
                selector: '[email][formControlName],[email][formControl],[email][ngModel]',
                providers: [EMAIL_VALIDATOR]
            },] },
];
/**
 * @nocollapse
 */
EmailValidator.ctorParameters = function () { return []; };
EmailValidator.propDecorators = {
    'email': [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"] },],
};
/**
 * Provider which adds {\@link MinLengthValidator} to {\@link NG_VALIDATORS}.
 *
 * ## Example:
 *
 * {\@example common/forms/ts/validators/validators.ts region='min'}
 */
var MIN_LENGTH_VALIDATOR = {
    provide: NG_VALIDATORS,
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["forwardRef"])(function () { return MinLengthValidator; }),
    multi: true
};
/**
 * A directive which installs the {\@link MinLengthValidator} for any `formControlName`,
 * `formControl`, or control with `ngModel` that also has a `minlength` attribute.
 *
 * \@stable
 */
var MinLengthValidator = (function () {
    function MinLengthValidator() {
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    MinLengthValidator.prototype.ngOnChanges = function (changes) {
        if ('minlength' in changes) {
            this._createValidator();
            if (this._onChange)
                this._onChange();
        }
    };
    /**
     * @param {?} c
     * @return {?}
     */
    MinLengthValidator.prototype.validate = function (c) {
        return this.minlength == null ? null : this._validator(c);
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    MinLengthValidator.prototype.registerOnValidatorChange = function (fn) { this._onChange = fn; };
    /**
     * @return {?}
     */
    MinLengthValidator.prototype._createValidator = function () {
        this._validator = Validators.minLength(parseInt(this.minlength, 10));
    };
    return MinLengthValidator;
}());
MinLengthValidator.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"], args: [{
                selector: '[minlength][formControlName],[minlength][formControl],[minlength][ngModel]',
                providers: [MIN_LENGTH_VALIDATOR],
                host: { '[attr.minlength]': 'minlength ? minlength : null' }
            },] },
];
/**
 * @nocollapse
 */
MinLengthValidator.ctorParameters = function () { return []; };
MinLengthValidator.propDecorators = {
    'minlength': [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"] },],
};
/**
 * Provider which adds {\@link MaxLengthValidator} to {\@link NG_VALIDATORS}.
 *
 * ## Example:
 *
 * {\@example common/forms/ts/validators/validators.ts region='max'}
 */
var MAX_LENGTH_VALIDATOR = {
    provide: NG_VALIDATORS,
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["forwardRef"])(function () { return MaxLengthValidator; }),
    multi: true
};
/**
 * A directive which installs the {\@link MaxLengthValidator} for any `formControlName,
 * `formControl`,
 * or control with `ngModel` that also has a `maxlength` attribute.
 *
 * \@stable
 */
var MaxLengthValidator = (function () {
    function MaxLengthValidator() {
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    MaxLengthValidator.prototype.ngOnChanges = function (changes) {
        if ('maxlength' in changes) {
            this._createValidator();
            if (this._onChange)
                this._onChange();
        }
    };
    /**
     * @param {?} c
     * @return {?}
     */
    MaxLengthValidator.prototype.validate = function (c) {
        return this.maxlength != null ? this._validator(c) : null;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    MaxLengthValidator.prototype.registerOnValidatorChange = function (fn) { this._onChange = fn; };
    /**
     * @return {?}
     */
    MaxLengthValidator.prototype._createValidator = function () {
        this._validator = Validators.maxLength(parseInt(this.maxlength, 10));
    };
    return MaxLengthValidator;
}());
MaxLengthValidator.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"], args: [{
                selector: '[maxlength][formControlName],[maxlength][formControl],[maxlength][ngModel]',
                providers: [MAX_LENGTH_VALIDATOR],
                host: { '[attr.maxlength]': 'maxlength ? maxlength : null' }
            },] },
];
/**
 * @nocollapse
 */
MaxLengthValidator.ctorParameters = function () { return []; };
MaxLengthValidator.propDecorators = {
    'maxlength': [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"] },],
};
var PATTERN_VALIDATOR = {
    provide: NG_VALIDATORS,
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["forwardRef"])(function () { return PatternValidator; }),
    multi: true
};
/**
 * A Directive that adds the `pattern` validator to any controls marked with the
 * `pattern` attribute, via the {\@link NG_VALIDATORS} binding. Uses attribute value
 * as the regex to validate Control value against.  Follows pattern attribute
 * semantics; i.e. regex must match entire Control value.
 *
 * ### Example
 *
 * ```
 * <input [name]="fullName" pattern="[a-zA-Z ]*" ngModel>
 * ```
 * \@stable
 */
var PatternValidator = (function () {
    function PatternValidator() {
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    PatternValidator.prototype.ngOnChanges = function (changes) {
        if ('pattern' in changes) {
            this._createValidator();
            if (this._onChange)
                this._onChange();
        }
    };
    /**
     * @param {?} c
     * @return {?}
     */
    PatternValidator.prototype.validate = function (c) { return this._validator(c); };
    /**
     * @param {?} fn
     * @return {?}
     */
    PatternValidator.prototype.registerOnValidatorChange = function (fn) { this._onChange = fn; };
    /**
     * @return {?}
     */
    PatternValidator.prototype._createValidator = function () { this._validator = Validators.pattern(this.pattern); };
    return PatternValidator;
}());
PatternValidator.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"], args: [{
                selector: '[pattern][formControlName],[pattern][formControl],[pattern][ngModel]',
                providers: [PATTERN_VALIDATOR],
                host: { '[attr.pattern]': 'pattern ? pattern : null' }
            },] },
];
/**
 * @nocollapse
 */
PatternValidator.ctorParameters = function () { return []; };
PatternValidator.propDecorators = {
    'pattern': [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"] },],
};
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * \@whatItDoes Creates an {\@link AbstractControl} from a user-specified configuration.
 *
 * It is essentially syntactic sugar that shortens the `new FormGroup()`,
 * `new FormControl()`, and `new FormArray()` boilerplate that can build up in larger
 * forms.
 *
 * \@howToUse
 *
 * To use, inject `FormBuilder` into your component class. You can then call its methods
 * directly.
 *
 * {\@example forms/ts/formBuilder/form_builder_example.ts region='Component'}
 *
 *  * **npm package**: `\@angular/forms`
 *
 *  * **NgModule**: {\@link ReactiveFormsModule}
 *
 * \@stable
 */
var FormBuilder = (function () {
    function FormBuilder() {
    }
    /**
     * Construct a new {\@link FormGroup} with the given map of configuration.
     * Valid keys for the `extra` parameter map are `validator` and `asyncValidator`.
     *
     * See the {\@link FormGroup} constructor for more details.
     * @param {?} controlsConfig
     * @param {?=} extra
     * @return {?}
     */
    FormBuilder.prototype.group = function (controlsConfig, extra) {
        if (extra === void 0) { extra = null; }
        var /** @type {?} */ controls = this._reduceControls(controlsConfig);
        var /** @type {?} */ validator = extra != null ? extra['validator'] : null;
        var /** @type {?} */ asyncValidator = extra != null ? extra['asyncValidator'] : null;
        return new FormGroup(controls, validator, asyncValidator);
    };
    /**
     * Construct a new {\@link FormControl} with the given `formState`,`validator`, and
     * `asyncValidator`.
     *
     * `formState` can either be a standalone value for the form control or an object
     * that contains both a value and a disabled status.
     *
     * @param {?} formState
     * @param {?=} validator
     * @param {?=} asyncValidator
     * @return {?}
     */
    FormBuilder.prototype.control = function (formState, validator, asyncValidator) {
        return new FormControl(formState, validator, asyncValidator);
    };
    /**
     * Construct a {\@link FormArray} from the given `controlsConfig` array of
     * configuration, with the given optional `validator` and `asyncValidator`.
     * @param {?} controlsConfig
     * @param {?=} validator
     * @param {?=} asyncValidator
     * @return {?}
     */
    FormBuilder.prototype.array = function (controlsConfig, validator, asyncValidator) {
        var _this = this;
        var /** @type {?} */ controls = controlsConfig.map(function (c) { return _this._createControl(c); });
        return new FormArray(controls, validator, asyncValidator);
    };
    /**
     * \@internal
     * @param {?} controlsConfig
     * @return {?}
     */
    FormBuilder.prototype._reduceControls = function (controlsConfig) {
        var _this = this;
        var /** @type {?} */ controls = {};
        Object.keys(controlsConfig).forEach(function (controlName) {
            controls[controlName] = _this._createControl(controlsConfig[controlName]);
        });
        return controls;
    };
    /**
     * \@internal
     * @param {?} controlConfig
     * @return {?}
     */
    FormBuilder.prototype._createControl = function (controlConfig) {
        if (controlConfig instanceof FormControl || controlConfig instanceof FormGroup ||
            controlConfig instanceof FormArray) {
            return controlConfig;
        }
        else if (Array.isArray(controlConfig)) {
            var /** @type {?} */ value = controlConfig[0];
            var /** @type {?} */ validator = controlConfig.length > 1 ? controlConfig[1] : null;
            var /** @type {?} */ asyncValidator = controlConfig.length > 2 ? controlConfig[2] : null;
            return this.control(value, validator, asyncValidator);
        }
        else {
            return this.control(controlConfig);
        }
    };
    return FormBuilder;
}());
FormBuilder.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Injectable"] },
];
/**
 * @nocollapse
 */
FormBuilder.ctorParameters = function () { return []; };
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @module
 * @description
 * Entry point for all public APIs of the common package.
 */
/**
 * \@stable
 */
var VERSION = new __WEBPACK_IMPORTED_MODULE_1__angular_core__["Version"]('4.4.4');
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * \@whatItDoes Adds `novalidate` attribute to all forms by default.
 *
 * `novalidate` is used to disable browser's native form validation.
 *
 * If you want to use native validation with Angular forms, just add `ngNativeValidate` attribute:
 *
 * ```
 * <form ngNativeValidate></form>
 * ```
 *
 * \@experimental
 */
var NgNoValidate = (function () {
    function NgNoValidate() {
    }
    return NgNoValidate;
}());
NgNoValidate.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"], args: [{
                selector: 'form:not([ngNoForm]):not([ngNativeValidate])',
                host: { 'novalidate': '' },
            },] },
];
/**
 * @nocollapse
 */
NgNoValidate.ctorParameters = function () { return []; };
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var SHARED_FORM_DIRECTIVES = [
    NgNoValidate,
    NgSelectOption,
    NgSelectMultipleOption,
    DefaultValueAccessor,
    NumberValueAccessor,
    RangeValueAccessor,
    CheckboxControlValueAccessor,
    SelectControlValueAccessor,
    SelectMultipleControlValueAccessor,
    RadioControlValueAccessor,
    NgControlStatus,
    NgControlStatusGroup,
    RequiredValidator,
    MinLengthValidator,
    MaxLengthValidator,
    PatternValidator,
    CheckboxRequiredValidator,
    EmailValidator,
];
var TEMPLATE_DRIVEN_DIRECTIVES = [NgModel, NgModelGroup, NgForm];
var REACTIVE_DRIVEN_DIRECTIVES = [FormControlDirective, FormGroupDirective, FormControlName, FormGroupName, FormArrayName];
/**
 * Internal module used for sharing directives between FormsModule and ReactiveFormsModule
 */
var InternalFormsSharedModule = (function () {
    function InternalFormsSharedModule() {
    }
    return InternalFormsSharedModule;
}());
InternalFormsSharedModule.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["NgModule"], args: [{
                declarations: SHARED_FORM_DIRECTIVES,
                exports: SHARED_FORM_DIRECTIVES,
            },] },
];
/**
 * @nocollapse
 */
InternalFormsSharedModule.ctorParameters = function () { return []; };
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * The ng module for forms.
 * \@stable
 */
var FormsModule = (function () {
    function FormsModule() {
    }
    return FormsModule;
}());
FormsModule.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["NgModule"], args: [{
                declarations: TEMPLATE_DRIVEN_DIRECTIVES,
                providers: [RadioControlRegistry],
                exports: [InternalFormsSharedModule, TEMPLATE_DRIVEN_DIRECTIVES]
            },] },
];
/**
 * @nocollapse
 */
FormsModule.ctorParameters = function () { return []; };
/**
 * The ng module for reactive forms.
 * \@stable
 */
var ReactiveFormsModule = (function () {
    function ReactiveFormsModule() {
    }
    return ReactiveFormsModule;
}());
ReactiveFormsModule.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["NgModule"], args: [{
                declarations: [REACTIVE_DRIVEN_DIRECTIVES],
                providers: [FormBuilder, RadioControlRegistry],
                exports: [InternalFormsSharedModule, REACTIVE_DRIVEN_DIRECTIVES]
            },] },
];
/**
 * @nocollapse
 */
ReactiveFormsModule.ctorParameters = function () { return []; };
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @module
 * @description
 * This module is used for handling user input, by defining and building a {@link FormGroup} that
 * consists of {@link FormControl} objects, and mapping them onto the DOM. {@link FormControl}
 * objects can then be used to read information from the form DOM elements.
 *
 * Forms providers are not included in default providers; you must import these providers
 * explicitly.
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @module
 * @description
 * Entry point for all public APIs of the forms package.
 */
// This file only reexports content of the `src` folder. Keep it that way.
/**
 * Generated bundle index. Do not edit.
 */

//# sourceMappingURL=forms.es5.js.map


/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AwsHttp; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_http__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__environment__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__signature__ = __webpack_require__(176);



var AwsHttp = /** @class */ (function () {
    function AwsHttp(http, signature, awsEnv) {
        this.http = http;
        this.signature = signature;
        this.awsEnv = awsEnv;
    }
    AwsHttp.prototype.get = function (url, options, signRequest) {
        if (signRequest === void 0) { signRequest = true; }
        if (signRequest) {
            options = this.signRequest('GET', url, null, options);
        }
        return this.http.get(url, options);
    };
    AwsHttp.prototype.post = function (url, body, options, signRequest) {
        if (signRequest === void 0) { signRequest = true; }
        if (signRequest) {
            options = this.signRequest('POST', url, body, options);
        }
        return this.http.post(url, body, options);
    };
    AwsHttp.prototype.put = function (url, body, options, signRequest) {
        if (signRequest === void 0) { signRequest = true; }
        if (signRequest) {
            options = this.signRequest('PUT', url, body, options);
        }
        return this.http.put(url, body, options);
    };
    AwsHttp.prototype.delete = function (url, options, signRequest) {
        if (signRequest === void 0) { signRequest = true; }
        if (signRequest) {
            options = this.signRequest('DELETE', url, null, options);
        }
        return this.http.delete(url, options);
    };
    AwsHttp.prototype.signRequest = function (method, url, body, options) {
        var request = {
            method: method,
            url: url,
            headers: {},
            data: (body ? body : '')
        };
        if (options && options.headers) {
            for (var _i = 0, _a = options.headers.keys(); _i < _a.length; _i++) {
                var header = _a[_i];
                request.headers[header] = options.headers.get(header);
            }
        }
        var result = this.signature.signRequest(request, this.awsEnv.getCredentials(), this.awsEnv.getApiRegion(), 'execute-api');
        if (!options) {
            options = {};
        }
        if (!options.headers) {
            options.headers = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["l" /* Headers */]();
        }
        options.headers.append('Authorization', result['Authorization']);
        options.headers.append('x-amz-date', result['x-amz-date']);
        options.headers.append('x-amz-content-sha256', result['x-amz-content-sha256']);
        options.headers.append('x-amz-security-token', result['x-amz-security-token']);
        return options;
    };
    AwsHttp.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_http__["i" /* Http */] }, { type: __WEBPACK_IMPORTED_MODULE_2__signature__["a" /* AwsSignature */] }, { type: __WEBPACK_IMPORTED_MODULE_1__environment__["a" /* AwsEnvironment */] }]; };
    return AwsHttp;
}());

//# sourceMappingURL=http.js.map

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LoginService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_http__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__aws_environment__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__restapi_error_handler__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_BehaviorSubject__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_BehaviorSubject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rxjs_BehaviorSubject__);




var LoginService = /** @class */ (function () {
    function LoginService(http, awsEnv, errorHandler) {
        this.http = http;
        this.awsEnv = awsEnv;
        this.errorHandler = errorHandler;
        this.userLoggedInSubject = new __WEBPACK_IMPORTED_MODULE_3_rxjs_BehaviorSubject__["BehaviorSubject"](false);
    }
    LoginService.prototype.login = function (userLogin) {
        var _this = this;
        var headers = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["l" /* Headers */]({
            'Content-Type': 'application/json'
        });
        var baseRegistrationUrl = this.awsEnv.getRegistrationUrl();
        var url = baseRegistrationUrl + "/login";
        return this.http
            .post(url, JSON.stringify(userLogin), { headers: headers })
            .map(function (response) { return response.json(); })
            .catch(function (response) { return _this.errorHandler.throwError(response); });
    };
    LoginService.prototype.userLoggedIn = function (value) {
        this.userLoggedInSubject.next(value);
    };
    LoginService.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_http__["i" /* Http */] }, { type: __WEBPACK_IMPORTED_MODULE_1__aws_environment__["a" /* AwsEnvironment */] }, { type: __WEBPACK_IMPORTED_MODULE_2__restapi_error_handler__["a" /* ErrorHandler */] }]; };
    return LoginService;
}());

//# sourceMappingURL=user-login.service.js.map

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BaseModal; });
var BaseModal = /** @class */ (function () {
    function BaseModal() {
    }
    BaseModal.prototype.initialize = function () {
        this.isOn = true;
    };
    BaseModal.prototype.closeDialog = function () {
        this.isOn = false;
        this.onClose();
    };
    BaseModal.prototype.showDialog = function (args) {
        this.onActivate(args);
        this.initialize();
    };
    BaseModal.prototype.ngOnInit = function () {
        this.isOn = false;
    };
    return BaseModal;
}());

//# sourceMappingURL=modal-base.js.map

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ModalService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Subject__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Subject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs_Subject__);

var ModalService = /** @class */ (function () {
    function ModalService() {
        this.modalChanged = new __WEBPACK_IMPORTED_MODULE_0_rxjs_Subject__["Subject"]();
        this.modalButtonClicked = new __WEBPACK_IMPORTED_MODULE_0_rxjs_Subject__["Subject"]();
    }
    ModalService.prototype.showLoadingModal = function (value, showStopTest, showOkButton) {
        if (showStopTest === void 0) { showStopTest = true; }
        if (showOkButton === void 0) { showOkButton = false; }
        this.modalChanged.next({
            'showLoading': true,
            'value': value,
            'showStopTest': showStopTest,
            'showOkButton': showOkButton
        });
    };
    ModalService.prototype.hideLoadingModal = function () {
        this.modalChanged.next({
            'showLoading': false
        });
    };
    ModalService.prototype.stopTest = function () {
        this.modalButtonClicked.next({
            'stopTest': true
        });
    };
    ModalService.prototype.okClicked = function () {
        this.modalButtonClicked.next({
            'closeDialog': true
        });
    };
    ModalService.ctorParameters = function () { return []; };
    return ModalService;
}());

//# sourceMappingURL=modal.service.js.map

/***/ }),
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = noop;
function noop() {}


/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Transition;
/* unused harmony export default */
/* harmony export (immutable) */ __webpack_exports__["b"] = newId;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_selection__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__attr__ = __webpack_require__(1064);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__attrTween__ = __webpack_require__(1065);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__delay__ = __webpack_require__(1066);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__duration__ = __webpack_require__(1067);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ease__ = __webpack_require__(1068);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__filter__ = __webpack_require__(1069);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__merge__ = __webpack_require__(1070);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__on__ = __webpack_require__(1071);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__remove__ = __webpack_require__(1072);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__select__ = __webpack_require__(1073);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__selectAll__ = __webpack_require__(1074);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__selection__ = __webpack_require__(1075);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__style__ = __webpack_require__(1076);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__styleTween__ = __webpack_require__(1077);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__text__ = __webpack_require__(1078);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__transition__ = __webpack_require__(1079);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__tween__ = __webpack_require__(164);



















var id = 0;

function Transition(groups, parents, name, id) {
  this._groups = groups;
  this._parents = parents;
  this._name = name;
  this._id = id;
}

function transition(name) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_selection__["f" /* selection */])().transition(name);
}

function newId() {
  return ++id;
}

var selection_prototype = __WEBPACK_IMPORTED_MODULE_0_d3_selection__["f" /* selection */].prototype;

Transition.prototype = transition.prototype = {
  constructor: Transition,
  select: __WEBPACK_IMPORTED_MODULE_10__select__["a" /* default */],
  selectAll: __WEBPACK_IMPORTED_MODULE_11__selectAll__["a" /* default */],
  filter: __WEBPACK_IMPORTED_MODULE_6__filter__["a" /* default */],
  merge: __WEBPACK_IMPORTED_MODULE_7__merge__["a" /* default */],
  selection: __WEBPACK_IMPORTED_MODULE_12__selection__["a" /* default */],
  transition: __WEBPACK_IMPORTED_MODULE_16__transition__["a" /* default */],
  call: selection_prototype.call,
  nodes: selection_prototype.nodes,
  node: selection_prototype.node,
  size: selection_prototype.size,
  empty: selection_prototype.empty,
  each: selection_prototype.each,
  on: __WEBPACK_IMPORTED_MODULE_8__on__["a" /* default */],
  attr: __WEBPACK_IMPORTED_MODULE_1__attr__["a" /* default */],
  attrTween: __WEBPACK_IMPORTED_MODULE_2__attrTween__["a" /* default */],
  style: __WEBPACK_IMPORTED_MODULE_13__style__["a" /* default */],
  styleTween: __WEBPACK_IMPORTED_MODULE_14__styleTween__["a" /* default */],
  text: __WEBPACK_IMPORTED_MODULE_15__text__["a" /* default */],
  remove: __WEBPACK_IMPORTED_MODULE_9__remove__["a" /* default */],
  tween: __WEBPACK_IMPORTED_MODULE_17__tween__["a" /* default */],
  delay: __WEBPACK_IMPORTED_MODULE_3__delay__["a" /* default */],
  duration: __WEBPACK_IMPORTED_MODULE_4__duration__["a" /* default */],
  ease: __WEBPACK_IMPORTED_MODULE_5__ease__["a" /* default */]
};


/***/ }),
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(344));
__export(__webpack_require__(343));
__export(__webpack_require__(204));
__export(__webpack_require__(138));
__export(__webpack_require__(624));
__export(__webpack_require__(625));
__export(__webpack_require__(345));
__export(__webpack_require__(627));
__export(__webpack_require__(630));
__export(__webpack_require__(629));
__export(__webpack_require__(628));
__export(__webpack_require__(626));
__export(__webpack_require__(622));
__export(__webpack_require__(623));
//# sourceMappingURL=index.js.map

/***/ }),
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_dispatch__ = __webpack_require__(838);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_dispatch__["a"]; });



/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function streamGeometry(geometry, stream) {
  if (geometry && streamGeometryType.hasOwnProperty(geometry.type)) {
    streamGeometryType[geometry.type](geometry, stream);
  }
}

var streamObjectType = {
  Feature: function(object, stream) {
    streamGeometry(object.geometry, stream);
  },
  FeatureCollection: function(object, stream) {
    var features = object.features, i = -1, n = features.length;
    while (++i < n) streamGeometry(features[i].geometry, stream);
  }
};

var streamGeometryType = {
  Sphere: function(object, stream) {
    stream.sphere();
  },
  Point: function(object, stream) {
    object = object.coordinates;
    stream.point(object[0], object[1], object[2]);
  },
  MultiPoint: function(object, stream) {
    var coordinates = object.coordinates, i = -1, n = coordinates.length;
    while (++i < n) object = coordinates[i], stream.point(object[0], object[1], object[2]);
  },
  LineString: function(object, stream) {
    streamLine(object.coordinates, stream, 0);
  },
  MultiLineString: function(object, stream) {
    var coordinates = object.coordinates, i = -1, n = coordinates.length;
    while (++i < n) streamLine(coordinates[i], stream, 0);
  },
  Polygon: function(object, stream) {
    streamPolygon(object.coordinates, stream);
  },
  MultiPolygon: function(object, stream) {
    var coordinates = object.coordinates, i = -1, n = coordinates.length;
    while (++i < n) streamPolygon(coordinates[i], stream);
  },
  GeometryCollection: function(object, stream) {
    var geometries = object.geometries, i = -1, n = geometries.length;
    while (++i < n) streamGeometry(geometries[i], stream);
  }
};

function streamLine(coordinates, stream, closed) {
  var i = -1, n = coordinates.length - closed, coordinate;
  stream.lineStart();
  while (++i < n) coordinate = coordinates[i], stream.point(coordinate[0], coordinate[1], coordinate[2]);
  stream.lineEnd();
}

function streamPolygon(coordinates, stream) {
  var i = -1, n = coordinates.length;
  stream.polygonStart();
  while (++i < n) streamLine(coordinates[i], stream, 1);
  stream.polygonEnd();
}

/* harmony default export */ __webpack_exports__["a"] = (function(object, stream) {
  if (object && streamObjectType.hasOwnProperty(object.type)) {
    streamObjectType[object.type](object, stream);
  } else {
    streamGeometry(object, stream);
  }
});


/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_path__ = __webpack_require__(931);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_path__["a"]; });



/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return map; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return slice; });
var array = Array.prototype;

var map = array.map;
var slice = array.slice;


/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function constant() {
    return x;
  };
});


/***/ }),
/* 92 */,
/* 93 */,
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HeaderService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_router__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__publisher_publisher_service__ = __webpack_require__(31);


var HeaderService = /** @class */ (function () {
    function HeaderService(pubService, router, route) {
        var _this = this;
        this.pubService = pubService;
        this.router = router;
        this.route = route;
        this.showPopup = false;
        this.showArrow = false;
        this.activeItem = '';
        this.defaultItemLabel = ' Project Management';
        this.mode = 'items';
        this.labelValue = '';
        this.pubService.subscribeToChannel('clicked-outside').subscribe(function (msg) {
            if (msg.Owner !== _this)
                _this.showPopup = false;
        });
    }
    HeaderService.prototype.updateHeaderComponent = function (headerComp) {
        this.headerComponent = headerComp;
    };
    HeaderService.prototype.setLabelMode = function (value) {
        this.mode = 'label';
        this.labelValue = value;
        this.showArrow = true;
    };
    HeaderService.prototype.setNoneMode = function () {
        this.labelValue = '';
        this.activeItem = '';
        this.showArrow = false;
        this.mode = 'none';
        this.headerComponent.refreshChanges();
    };
    HeaderService.prototype.itemClicked = function () {
    };
    HeaderService.prototype.popupClicked = function (itemName) {
        if (itemName === '') {
            this.navigateHome();
        }
        this.showPopup = false;
    };
    HeaderService.prototype.navigateHome = function () {
        this.router.navigate(['']);
        this.showArrow = false;
    };
    HeaderService.prototype.navigate = function (value) {
        this.router.navigate([value], { relativeTo: this.route });
    };
    HeaderService.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_1__publisher_publisher_service__["a" /* PublisherService */] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_router__["a" /* Router */] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_router__["b" /* ActivatedRoute */] }]; };
    return HeaderService;
}());

//# sourceMappingURL=header.service.js.map

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(2);
var platform_browser_1 = __webpack_require__(38);
/**
 * Gets the width of the scrollbar.  Nesc for windows
 * http://stackoverflow.com/a/13382873/888165
 *
 * @export
 * @class ScrollbarHelper
 */
var ScrollbarHelper = (function () {
    function ScrollbarHelper(document) {
        this.document = document;
        this.width = this.getWidth();
    }
    ScrollbarHelper.prototype.getWidth = function () {
        var outer = this.document.createElement('div');
        outer.style.visibility = 'hidden';
        outer.style.width = '100px';
        outer.style.msOverflowStyle = 'scrollbar';
        this.document.body.appendChild(outer);
        var widthNoScroll = outer.offsetWidth;
        outer.style.overflow = 'scroll';
        var inner = this.document.createElement('div');
        inner.style.width = '100%';
        outer.appendChild(inner);
        var widthWithScroll = inner.offsetWidth;
        outer.parentNode.removeChild(outer);
        return widthNoScroll - widthWithScroll;
    };
    return ScrollbarHelper;
}());
ScrollbarHelper.decorators = [
    { type: core_1.Injectable },
];
/** @nocollapse */
ScrollbarHelper.ctorParameters = function () { return [
    { type: undefined, decorators: [{ type: core_1.Inject, args: [platform_browser_1.DOCUMENT,] },] },
]; };
exports.ScrollbarHelper = ScrollbarHelper;
//# sourceMappingURL=scrollbar-helper.service.js.map

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(617));
__export(__webpack_require__(621));
__export(__webpack_require__(620));
__export(__webpack_require__(619));
__export(__webpack_require__(616));
__export(__webpack_require__(618));
//# sourceMappingURL=index.js.map

/***/ }),
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
});


/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Adds floating point numbers with twice the normal precision.
// Reference: J. R. Shewchuk, Adaptive Precision Floating-Point Arithmetic and
// Fast Robust Geometric Predicates, Discrete & Computational Geometry 18(3)
// 305–363 (1997).
// Code adapted from GeographicLib by Charles F. F. Karney,
// http://geographiclib.sourceforge.net/

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return new Adder;
});

function Adder() {
  this.reset();
}

Adder.prototype = {
  constructor: Adder,
  reset: function() {
    this.s = // rounded value
    this.t = 0; // exact error
  },
  add: function(y) {
    add(temp, y, this.t);
    add(this, temp.s, this.s);
    if (this.s) this.t += temp.t;
    else this.s = temp.t;
  },
  valueOf: function() {
    return this.s;
  }
};

var temp = new Adder;

function add(adder, a, b) {
  var x = adder.s = a + b,
      bv = x - a,
      av = x - bv;
  adder.t = (a - av) + (b - bv);
}


/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  return Math.random();
});


/***/ }),
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return x === null ? NaN : +x;
});


/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_nest__ = __webpack_require__(833);
/* unused harmony reexport nest */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_set__ = __webpack_require__(834);
/* unused harmony reexport set */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_map__ = __webpack_require__(230);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__src_map__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_keys__ = __webpack_require__(832);
/* unused harmony reexport keys */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_values__ = __webpack_require__(835);
/* unused harmony reexport values */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_entries__ = __webpack_require__(831);
/* unused harmony reexport entries */








/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["f"] = spherical;
/* harmony export (immutable) */ __webpack_exports__["a"] = cartesian;
/* harmony export (immutable) */ __webpack_exports__["c"] = cartesianDot;
/* harmony export (immutable) */ __webpack_exports__["b"] = cartesianCross;
/* harmony export (immutable) */ __webpack_exports__["e"] = cartesianAddInPlace;
/* harmony export (immutable) */ __webpack_exports__["d"] = cartesianScale;
/* harmony export (immutable) */ __webpack_exports__["g"] = cartesianNormalizeInPlace;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(5);


function spherical(cartesian) {
  return [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["e" /* atan2 */])(cartesian[1], cartesian[0]), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["f" /* asin */])(cartesian[2])];
}

function cartesian(spherical) {
  var lambda = spherical[0], phi = spherical[1], cosPhi = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* cos */])(phi);
  return [cosPhi * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* cos */])(lambda), cosPhi * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* sin */])(lambda), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* sin */])(phi)];
}

function cartesianDot(a, b) {
  return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
}

function cartesianCross(a, b) {
  return [a[1] * b[2] - a[2] * b[1], a[2] * b[0] - a[0] * b[2], a[0] * b[1] - a[1] * b[0]];
}

// TODO return a
function cartesianAddInPlace(a, b) {
  a[0] += b[0], a[1] += b[1], a[2] += b[2];
}

function cartesianScale(vector, k) {
  return [vector[0] * k, vector[1] * k, vector[2] * k];
}

// TODO return d
function cartesianNormalizeInPlace(d) {
  var l = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["n" /* sqrt */])(d[0] * d[0] + d[1] * d[1] + d[2] * d[2]);
  d[0] /= l, d[1] /= l, d[2] /= l;
}


/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = azimuthalRaw;
/* harmony export (immutable) */ __webpack_exports__["a"] = azimuthalInvert;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(5);


function azimuthalRaw(scale) {
  return function(x, y) {
    var cx = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* cos */])(x),
        cy = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* cos */])(y),
        k = scale(cx * cy);
    return [
      k * cy * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* sin */])(x),
      k * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* sin */])(y)
    ];
  }
}

function azimuthalInvert(angle) {
  return function(x, y) {
    var z = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["n" /* sqrt */])(x * x + y * y),
        c = angle(z),
        sc = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* sin */])(c),
        cc = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* cos */])(c);
    return [
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["e" /* atan2 */])(x * sc, z * cc),
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["f" /* asin */])(z && y * sc / z)
    ];
  }
}


/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(parent, x0, y0, x1, y1) {
  var nodes = parent.children,
      node,
      i = -1,
      n = nodes.length,
      k = parent.value && (x1 - x0) / parent.value;

  while (++i < n) {
    node = nodes[i], node.y0 = y0, node.y1 = y1;
    node.x0 = x0, node.x1 = x0 += node.value * k;
  }
});


/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = hue;
/* harmony export (immutable) */ __webpack_exports__["c"] = gamma;
/* harmony export (immutable) */ __webpack_exports__["a"] = nogamma;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(419);


function linear(a, d) {
  return function(t) {
    return a + t * d;
  };
}

function exponential(a, b, y) {
  return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
    return Math.pow(a + t * b, y);
  };
}

function hue(a, b) {
  var d = b - a;
  return d ? linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(isNaN(a) ? b : a);
}

function gamma(y) {
  return (y = +y) === 1 ? nogamma : function(a, b) {
    return b - a ? exponential(a, b, y) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(isNaN(a) ? b : a);
  };
}

function nogamma(a, b) {
  var d = b - a;
  return d ? linear(a, d) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(isNaN(a) ? b : a);
}


/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(s) {
  return s.match(/.{6}/g).map(function(x) {
    return "#" + x;
  });
});


/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = linearish;
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__continuous__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tickFormat__ = __webpack_require__(982);





function linearish(scale) {
  var domain = scale.domain;

  scale.ticks = function(count) {
    var d = domain();
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["a" /* ticks */])(d[0], d[d.length - 1], count == null ? 10 : count);
  };

  scale.tickFormat = function(count, specifier) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__tickFormat__["a" /* default */])(domain(), count, specifier);
  };

  scale.nice = function(count) {
    if (count == null) count = 10;

    var d = domain(),
        i0 = 0,
        i1 = d.length - 1,
        start = d[i0],
        stop = d[i1],
        step;

    if (stop < start) {
      step = start, start = stop, stop = step;
      step = i0, i0 = i1, i1 = step;
    }

    step = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["b" /* tickIncrement */])(start, stop, count);

    if (step > 0) {
      start = Math.floor(start / step) * step;
      stop = Math.ceil(stop / step) * step;
      step = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["b" /* tickIncrement */])(start, stop, count);
    } else if (step < 0) {
      start = Math.ceil(start * step) / step;
      stop = Math.floor(stop * step) / step;
      step = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["b" /* tickIncrement */])(start, stop, count);
    }

    if (step > 0) {
      d[i0] = Math.floor(start / step) * step;
      d[i1] = Math.ceil(stop / step) * step;
      domain(d);
    } else if (step < 0) {
      d[i0] = Math.ceil(start * step) / step;
      d[i1] = Math.floor(stop * step) / step;
      domain(d);
    }

    return scale;
  };

  return scale;
}

function linear() {
  var scale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__continuous__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2__continuous__["b" /* deinterpolateLinear */], __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["d" /* interpolateNumber */]);

  scale.copy = function() {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__continuous__["c" /* copy */])(scale, linear());
  };

  return linearish(scale);
}


/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return abs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return atan2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return cos; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return max; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return min; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return sin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return sqrt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return epsilon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return pi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return halfPi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return tau; });
/* harmony export (immutable) */ __webpack_exports__["l"] = acos;
/* harmony export (immutable) */ __webpack_exports__["k"] = asin;
var abs = Math.abs;
var atan2 = Math.atan2;
var cos = Math.cos;
var max = Math.max;
var min = Math.min;
var sin = Math.sin;
var sqrt = Math.sqrt;

var epsilon = 1e-12;
var pi = Math.PI;
var halfPi = pi / 2;
var tau = 2 * pi;

function acos(x) {
  return x > 1 ? 0 : x < -1 ? pi : Math.acos(x);
}

function asin(x) {
  return x >= 1 ? halfPi : x <= -1 ? -halfPi : Math.asin(x);
}


/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(series, order) {
  if (!((n = series.length) > 1)) return;
  for (var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i) {
    s0 = s1, s1 = series[order[i]];
    for (j = 0; j < m; ++j) {
      s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
    }
  }
});


/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(series) {
  var n = series.length, o = new Array(n);
  while (--n >= 0) o[n] = n;
  return o;
});


/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return epsilon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return epsilon2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return beaches; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return cells; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return circles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return edges; });
/* harmony export (immutable) */ __webpack_exports__["a"] = Diagram;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Beach__ = __webpack_require__(1081);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Cell__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Circle__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Edge__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RedBlackTree__ = __webpack_require__(269);






var epsilon = 1e-6;
var epsilon2 = 1e-12;
var beaches;
var cells;
var circles;
var edges;

function triangleArea(a, b, c) {
  return (a[0] - c[0]) * (b[1] - a[1]) - (a[0] - b[0]) * (c[1] - a[1]);
}

function lexicographic(a, b) {
  return b[1] - a[1]
      || b[0] - a[0];
}

function Diagram(sites, extent) {
  var site = sites.sort(lexicographic).pop(),
      x,
      y,
      circle;

  edges = [];
  cells = new Array(sites.length);
  beaches = new __WEBPACK_IMPORTED_MODULE_4__RedBlackTree__["a" /* default */];
  circles = new __WEBPACK_IMPORTED_MODULE_4__RedBlackTree__["a" /* default */];

  while (true) {
    circle = __WEBPACK_IMPORTED_MODULE_2__Circle__["a" /* firstCircle */];
    if (site && (!circle || site[1] < circle.y || (site[1] === circle.y && site[0] < circle.x))) {
      if (site[0] !== x || site[1] !== y) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__Beach__["a" /* addBeach */])(site);
        x = site[0], y = site[1];
      }
      site = sites.pop();
    } else if (circle) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__Beach__["b" /* removeBeach */])(circle.arc);
    } else {
      break;
    }
  }

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__Cell__["a" /* sortCellHalfedges */])();

  if (extent) {
    var x0 = +extent[0][0],
        y0 = +extent[0][1],
        x1 = +extent[1][0],
        y1 = +extent[1][1];
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__Edge__["a" /* clipEdges */])(x0, y0, x1, y1);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__Cell__["b" /* clipCells */])(x0, y0, x1, y1);
  }

  this.edges = edges;
  this.cells = cells;

  beaches =
  circles =
  edges =
  cells = null;
}

Diagram.prototype = {
  constructor: Diagram,

  polygons: function() {
    var edges = this.edges;

    return this.cells.map(function(cell) {
      var polygon = cell.halfedges.map(function(i) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__Cell__["c" /* cellHalfedgeStart */])(cell, edges[i]); });
      polygon.data = cell.site.data;
      return polygon;
    });
  },

  triangles: function() {
    var triangles = [],
        edges = this.edges;

    this.cells.forEach(function(cell, i) {
      if (!(m = (halfedges = cell.halfedges).length)) return;
      var site = cell.site,
          halfedges,
          j = -1,
          m,
          s0,
          e1 = edges[halfedges[m - 1]],
          s1 = e1.left === site ? e1.right : e1.left;

      while (++j < m) {
        s0 = s1;
        e1 = edges[halfedges[j]];
        s1 = e1.left === site ? e1.right : e1.left;
        if (s0 && s1 && i < s0.index && i < s1.index && triangleArea(site, s0, s1) < 0) {
          triangles.push([site.data, s0.data, s1.data]);
        }
      }
    });

    return triangles;
  },

  links: function() {
    return this.edges.filter(function(edge) {
      return edge.right;
    }).map(function(edge) {
      return {
        source: edge.left.data,
        target: edge.right.data
      };
    });
  },

  find: function(x, y, radius) {
    var that = this, i0, i1 = that._found || 0, n = that.cells.length, cell;

    // Use the previously-found cell, or start with an arbitrary one.
    while (!(cell = that.cells[i1])) if (++i1 >= n) return null;
    var dx = x - cell.site[0], dy = y - cell.site[1], d2 = dx * dx + dy * dy;

    // Traverse the half-edges to find a closer cell, if any.
    do {
      cell = that.cells[i0 = i1], i1 = null;
      cell.halfedges.forEach(function(e) {
        var edge = that.edges[e], v = edge.left;
        if ((v === cell.site || !v) && !(v = edge.right)) return;
        var vx = x - v[0], vy = y - v[1], v2 = vx * vx + vy * vy;
        if (v2 < d2) d2 = v2, i1 = v.index;
      });
    } while (i1 !== null);

    that._found = i0;

    return radius == null || d2 <= radius * radius ? cell.site : null;
  }
}


/***/ }),
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * An error thrown when an element was queried at a certain index of an
 * Observable, but no such index or position exists in that sequence.
 *
 * @see {@link elementAt}
 * @see {@link take}
 * @see {@link takeLast}
 *
 * @class ArgumentOutOfRangeError
 */
var ArgumentOutOfRangeError = (function (_super) {
    __extends(ArgumentOutOfRangeError, _super);
    function ArgumentOutOfRangeError() {
        var err = _super.call(this, 'argument out of range');
        this.name = err.name = 'ArgumentOutOfRangeError';
        this.stack = err.stack;
        this.message = err.message;
    }
    return ArgumentOutOfRangeError;
}(Error));
exports.ArgumentOutOfRangeError = ArgumentOutOfRangeError;
//# sourceMappingURL=ArgumentOutOfRangeError.js.map

/***/ }),
/* 132 */,
/* 133 */,
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ClipboardService; });
/* harmony export (immutable) */ __webpack_exports__["b"] = CLIPBOARD_SERVICE_PROVIDER_FACTORY;
/* unused harmony export CLIPBOARD_SERVICE_PROVIDER */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_platform_browser__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ngx_window_token__ = __webpack_require__(1096);



var ClipboardService = /** @class */ (function () {
    function ClipboardService(document, window) {
        this.document = document;
        this.window = window;
    }
    Object.defineProperty(ClipboardService.prototype, "isSupported", {
        get: function () {
            return !!this.document.queryCommandSupported && !!this.document.queryCommandSupported('copy');
        },
        enumerable: true,
        configurable: true
    });
    ClipboardService.prototype.isTargetValid = function (element) {
        if (element instanceof HTMLInputElement || element instanceof HTMLTextAreaElement) {
            if (element.hasAttribute('disabled')) {
                // tslint:disable-next-line:max-line-length
                throw new Error('Invalid "target" attribute. Please use "readonly" instead of "disabled" attribute');
            }
            return true;
        }
        throw new Error('Target should be input or textarea');
    };
    /**
     * copyFromInputElement
     */
    ClipboardService.prototype.copyFromInputElement = function (targetElm, renderer) {
        try {
            this.selectTarget(targetElm, renderer);
            var re = this.copyText();
            this.clearSelection(targetElm, this.window);
            return re;
        }
        catch (error) {
            return false;
        }
    };
    /**
     * Creates a fake textarea element, sets its value from `text` property,
     * and makes a selection on it.
     */
    ClipboardService.prototype.copyFromContent = function (content, renderer) {
        if (!this.tempTextArea) {
            this.tempTextArea = this.createTempTextArea(this.document, this.window);
            this.document.body.appendChild(this.tempTextArea);
        }
        this.tempTextArea.value = content;
        return this.copyFromInputElement(this.tempTextArea, renderer);
    };
    // remove temporary textarea if any
    ClipboardService.prototype.destroy = function () {
        if (this.tempTextArea) {
            this.document.body.removeChild(this.tempTextArea);
            this.tempTextArea = undefined;
        }
    };
    // select the target html input element
    ClipboardService.prototype.selectTarget = function (inputElement, renderer) {
        renderer.invokeElementMethod(inputElement, 'select');
        renderer.invokeElementMethod(inputElement, 'setSelectionRange', [0, inputElement.value.length]);
        return inputElement.value.length;
    };
    ClipboardService.prototype.copyText = function () {
        return this.document.execCommand('copy');
    };
    // Removes current selection and focus from `target` element.
    ClipboardService.prototype.clearSelection = function (inputElement, window) {
        // tslint:disable-next-line:no-unused-expression
        inputElement && inputElement.blur();
        window.getSelection().removeAllRanges();
    };
    // create a fake textarea for copy command
    ClipboardService.prototype.createTempTextArea = function (doc, window) {
        var isRTL = doc.documentElement.getAttribute('dir') === 'rtl';
        var ta;
        ta = doc.createElement('textarea');
        // Prevent zooming on iOS
        ta.style.fontSize = '12pt';
        // Reset box model
        ta.style.border = '0';
        ta.style.padding = '0';
        ta.style.margin = '0';
        // Move element out of screen horizontally
        ta.style.position = 'absolute';
        ta.style[isRTL ? 'right' : 'left'] = '-9999px';
        // Move element to the same position vertically
        var yPosition = window.pageYOffset || doc.documentElement.scrollTop;
        ta.style.top = yPosition + 'px';
        ta.setAttribute('readonly', '');
        return ta;
    };
    ClipboardService.ctorParameters = function () { return [{ type: undefined, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_1__angular_platform_browser__["DOCUMENT"]] }] }, { type: undefined, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_2_ngx_window_token__["a" /* WINDOW */]] }] }]; };
    return ClipboardService;
}());

// this pattern is mentioned in https://github.com/angular/angular/issues/13854 in #43
function CLIPBOARD_SERVICE_PROVIDER_FACTORY(doc, win, parentDispatcher) {
    return parentDispatcher || new ClipboardService(doc, win);
}
;
var CLIPBOARD_SERVICE_PROVIDER = {
    provide: ClipboardService,
    deps: [__WEBPACK_IMPORTED_MODULE_1__angular_platform_browser__["DOCUMENT"], __WEBPACK_IMPORTED_MODULE_2_ngx_window_token__["a" /* WINDOW */], [new __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"](), new __WEBPACK_IMPORTED_MODULE_0__angular_core__["SkipSelf"](), ClipboardService]],
    useFactory: CLIPBOARD_SERVICE_PROVIDER_FACTORY
};
//# sourceMappingURL=clipboard.service.js.map

/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Message; });
var Message = /** @class */ (function () {
    function Message(content, owner) {
        if (owner === void 0) { owner = null; }
        this.Content = content;
        this.Owner = owner;
    }
    return Message;
}());

//# sourceMappingURL=message.js.map

/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UserPreferencesService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_http__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__aws_http__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__restapi_error_handler__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__user_user__ = __webpack_require__(604);





var UserPreferencesService = /** @class */ (function () {
    function UserPreferencesService(http, errorHandler) {
        this.http = http;
        this.errorHandler = errorHandler;
    }
    UserPreferencesService.prototype.get = function (user) {
        var _this = this;
        var headers = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["l" /* Headers */]({
            'Content-Type': 'application/json'
        });
        var baseUrl = user.ApiServiceUrl;
        var url = baseUrl + "/" + user.Cognito.IdentityId + "/preferences";
        return this.http
            .get(url, { headers: headers })
            .map(function (response) {
            var preferences = response.json();
            _this.setDefault(preferences);
            user.Preferences = preferences;
            return preferences;
        })
            .catch(function (response) { return _this.errorHandler.throwError(response); });
    };
    UserPreferencesService.prototype.update = function (user) {
        return __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"].of(new __WEBPACK_IMPORTED_MODULE_4__user_user__["a" /* Preferences */]());
        // let headers = new Headers({
        //     'Content-Type': 'application/json'
        // });
        // let baseUrl = user.MgmtServUrl;
        // let url = `${baseUrl}/${user.Cognito.IdentityId}/preferences`;
        // return this.http
        //     .put(url, JSON.stringify({ Preferences: user.Preferences }), { headers: headers })
        //     .map((response: Response) => response.json())
        //     .catch((response: Response) => this.errorHandler.throwError(response));
    };
    UserPreferencesService.prototype.setDefault = function (preferences) {
        var defaultPreferences = new __WEBPACK_IMPORTED_MODULE_4__user_user__["a" /* Preferences */]();
        for (var prop in defaultPreferences) {
            if (!preferences.hasOwnProperty(prop)) {
                preferences[prop] = defaultPreferences[prop];
            }
        }
    };
    UserPreferencesService.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_2__aws_http__["a" /* AwsHttp */] }, { type: __WEBPACK_IMPORTED_MODULE_3__restapi_error_handler__["a" /* ErrorHandler */] }]; };
    return UserPreferencesService;
}());

//# sourceMappingURL=preferences.service.js.map

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(2);
var ScrollerComponent = (function () {
    function ScrollerComponent(element, renderer) {
        this.renderer = renderer;
        this.scrollbarV = false;
        this.scrollbarH = false;
        this.scroll = new core_1.EventEmitter();
        this.scrollYPos = 0;
        this.scrollXPos = 0;
        this.prevScrollYPos = 0;
        this.prevScrollXPos = 0;
        this.element = element.nativeElement;
    }
    ScrollerComponent.prototype.ngOnInit = function () {
        // manual bind so we don't always listen
        if (this.scrollbarV || this.scrollbarH) {
            this.parentElement = this.element.parentElement.parentElement;
            this.onScrollListener = this.renderer.listen(this.parentElement, 'scroll', this.onScrolled.bind(this));
        }
    };
    ScrollerComponent.prototype.ngOnDestroy = function () {
        if (this.scrollbarV || this.scrollbarH) {
            this.onScrollListener();
        }
    };
    ScrollerComponent.prototype.setOffset = function (offsetY) {
        if (this.parentElement) {
            this.parentElement.scrollTop = offsetY;
        }
    };
    ScrollerComponent.prototype.onScrolled = function (event) {
        var dom = event.currentTarget;
        this.scrollYPos = dom.scrollTop;
        this.scrollXPos = dom.scrollLeft;
        requestAnimationFrame(this.updateOffset.bind(this));
    };
    ScrollerComponent.prototype.updateOffset = function () {
        var direction;
        if (this.scrollYPos < this.prevScrollYPos) {
            direction = 'down';
        }
        else if (this.scrollYPos > this.prevScrollYPos) {
            direction = 'up';
        }
        this.scroll.emit({
            direction: direction,
            scrollYPos: this.scrollYPos,
            scrollXPos: this.scrollXPos
        });
        this.prevScrollYPos = this.scrollYPos;
        this.prevScrollXPos = this.scrollXPos;
    };
    return ScrollerComponent;
}());
ScrollerComponent.decorators = [
    { type: core_1.Component, args: [{
                selector: 'datatable-scroller',
                template: "\n    <ng-content></ng-content>\n  ",
                host: {
                    class: 'datatable-scroll'
                }
            },] },
];
/** @nocollapse */
ScrollerComponent.ctorParameters = function () { return [
    { type: core_1.ElementRef, },
    { type: core_1.Renderer, },
]; };
ScrollerComponent.propDecorators = {
    'scrollbarV': [{ type: core_1.Input },],
    'scrollbarH': [{ type: core_1.Input },],
    'scrollHeight': [{ type: core_1.HostBinding, args: ['style.height.px',] }, { type: core_1.Input },],
    'scrollWidth': [{ type: core_1.HostBinding, args: ['style.width.px',] }, { type: core_1.Input },],
    'scroll': [{ type: core_1.Output },],
};
exports.ScrollerComponent = ScrollerComponent;
//# sourceMappingURL=scroller.component.js.map

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Converts strings from something to camel case
 * http://stackoverflow.com/questions/10425287/convert-dash-separated-string-to-camelcase
 * @param  {string} str
 * @return {string} camel case string
 */
function camelCase(str) {
    // Replace special characters with a space
    str = str.replace(/[^a-zA-Z0-9 ]/g, ' ');
    // put a space before an uppercase letter
    str = str.replace(/([a-z](?=[A-Z]))/g, '$1 ');
    // Lower case first character and some other stuff
    str = str.replace(/([^a-zA-Z0-9 ])|^[0-9]+/g, '').trim().toLowerCase();
    // uppercase characters preceded by a space or number
    str = str.replace(/([ 0-9]+)([a-zA-Z])/g, function (a, b, c) {
        return b.trim() + c.toUpperCase();
    });
    return str;
}
exports.camelCase = camelCase;
/**
 * Converts strings from camel case to words
 * http://stackoverflow.com/questions/7225407/convert-camelcasetext-to-camel-case-text
 *
 * @export
 * @param {any} str
 * @returns string
 */
function deCamelCase(str) {
    return str
        .replace(/([A-Z])/g, function (match) { return " " + match; })
        .replace(/^./, function (match) { return match.toUpperCase(); });
}
exports.deCamelCase = deCamelCase;
//# sourceMappingURL=camel-case.js.map

/***/ }),
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formatDecimal__ = __webpack_require__(238);


/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return x = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__formatDecimal__["a" /* default */])(Math.abs(x)), x ? x[1] : NaN;
});


/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = clipRectangle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__buffer__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__line__ = __webpack_require__(875);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__rejoin__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_d3_array__ = __webpack_require__(29);






var clipMax = 1e9, clipMin = -clipMax;

// TODO Use d3-polygon’s polygonContains here for the ring check?
// TODO Eliminate duplicate buffering in clipBuffer and polygon.push?

function clipRectangle(x0, y0, x1, y1) {

  function visible(x, y) {
    return x0 <= x && x <= x1 && y0 <= y && y <= y1;
  }

  function interpolate(from, to, direction, stream) {
    var a = 0, a1 = 0;
    if (from == null
        || (a = corner(from, direction)) !== (a1 = corner(to, direction))
        || comparePoint(from, to) < 0 ^ direction > 0) {
      do stream.point(a === 0 || a === 3 ? x0 : x1, a > 1 ? y1 : y0);
      while ((a = (a + direction + 4) % 4) !== a1);
    } else {
      stream.point(to[0], to[1]);
    }
  }

  function corner(p, direction) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["o" /* abs */])(p[0] - x0) < __WEBPACK_IMPORTED_MODULE_0__math__["p" /* epsilon */] ? direction > 0 ? 0 : 3
        : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["o" /* abs */])(p[0] - x1) < __WEBPACK_IMPORTED_MODULE_0__math__["p" /* epsilon */] ? direction > 0 ? 2 : 1
        : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["o" /* abs */])(p[1] - y0) < __WEBPACK_IMPORTED_MODULE_0__math__["p" /* epsilon */] ? direction > 0 ? 1 : 0
        : direction > 0 ? 3 : 2; // abs(p[1] - y1) < epsilon
  }

  function compareIntersection(a, b) {
    return comparePoint(a.x, b.x);
  }

  function comparePoint(a, b) {
    var ca = corner(a, 1),
        cb = corner(b, 1);
    return ca !== cb ? ca - cb
        : ca === 0 ? b[1] - a[1]
        : ca === 1 ? a[0] - b[0]
        : ca === 2 ? a[1] - b[1]
        : b[0] - a[0];
  }

  return function(stream) {
    var activeStream = stream,
        bufferStream = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__buffer__["a" /* default */])(),
        segments,
        polygon,
        ring,
        x__, y__, v__, // first point
        x_, y_, v_, // previous point
        first,
        clean;

    var clipStream = {
      point: point,
      lineStart: lineStart,
      lineEnd: lineEnd,
      polygonStart: polygonStart,
      polygonEnd: polygonEnd
    };

    function point(x, y) {
      if (visible(x, y)) activeStream.point(x, y);
    }

    function polygonInside() {
      var winding = 0;

      for (var i = 0, n = polygon.length; i < n; ++i) {
        for (var ring = polygon[i], j = 1, m = ring.length, point = ring[0], a0, a1, b0 = point[0], b1 = point[1]; j < m; ++j) {
          a0 = b0, a1 = b1, point = ring[j], b0 = point[0], b1 = point[1];
          if (a1 <= y1) { if (b1 > y1 && (b0 - a0) * (y1 - a1) > (b1 - a1) * (x0 - a0)) ++winding; }
          else { if (b1 <= y1 && (b0 - a0) * (y1 - a1) < (b1 - a1) * (x0 - a0)) --winding; }
        }
      }

      return winding;
    }

    // Buffer geometry within a polygon and then clip it en masse.
    function polygonStart() {
      activeStream = bufferStream, segments = [], polygon = [], clean = true;
    }

    function polygonEnd() {
      var startInside = polygonInside(),
          cleanInside = clean && startInside,
          visible = (segments = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_d3_array__["i" /* merge */])(segments)).length;
      if (cleanInside || visible) {
        stream.polygonStart();
        if (cleanInside) {
          stream.lineStart();
          interpolate(null, null, 1, stream);
          stream.lineEnd();
        }
        if (visible) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__rejoin__["a" /* default */])(segments, compareIntersection, startInside, interpolate, stream);
        }
        stream.polygonEnd();
      }
      activeStream = stream, segments = polygon = ring = null;
    }

    function lineStart() {
      clipStream.point = linePoint;
      if (polygon) polygon.push(ring = []);
      first = true;
      v_ = false;
      x_ = y_ = NaN;
    }

    // TODO rather than special-case polygons, simply handle them separately.
    // Ideally, coincident intersection points should be jittered to avoid
    // clipping issues.
    function lineEnd() {
      if (segments) {
        linePoint(x__, y__);
        if (v__ && v_) bufferStream.rejoin();
        segments.push(bufferStream.result());
      }
      clipStream.point = point;
      if (v_) activeStream.lineEnd();
    }

    function linePoint(x, y) {
      var v = visible(x, y);
      if (polygon) ring.push([x, y]);
      if (first) {
        x__ = x, y__ = y, v__ = v;
        first = false;
        if (v) {
          activeStream.lineStart();
          activeStream.point(x, y);
        }
      } else {
        if (v && v_) activeStream.point(x, y);
        else {
          var a = [x_ = Math.max(clipMin, Math.min(clipMax, x_)), y_ = Math.max(clipMin, Math.min(clipMax, y_))],
              b = [x = Math.max(clipMin, Math.min(clipMax, x)), y = Math.max(clipMin, Math.min(clipMax, y))];
          if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__line__["a" /* default */])(a, b, x0, y0, x1, y1)) {
            if (!v_) {
              activeStream.lineStart();
              activeStream.point(a[0], a[1]);
            }
            activeStream.point(b[0], b[1]);
            if (!v) activeStream.lineEnd();
            clean = false;
          } else if (v) {
            activeStream.lineStart();
            activeStream.point(x, y);
            clean = false;
          }
        }
      }
      x_ = x, y_ = y, v_ = v;
    }

    return clipStream;
  };
}


/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = rotateRadians;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__compose__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(5);



function rotationIdentity(lambda, phi) {
  return [lambda > __WEBPACK_IMPORTED_MODULE_1__math__["a" /* pi */] ? lambda - __WEBPACK_IMPORTED_MODULE_1__math__["b" /* tau */] : lambda < -__WEBPACK_IMPORTED_MODULE_1__math__["a" /* pi */] ? lambda + __WEBPACK_IMPORTED_MODULE_1__math__["b" /* tau */] : lambda, phi];
}

rotationIdentity.invert = rotationIdentity;

function rotateRadians(deltaLambda, deltaPhi, deltaGamma) {
  return (deltaLambda %= __WEBPACK_IMPORTED_MODULE_1__math__["b" /* tau */]) ? (deltaPhi || deltaGamma ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__compose__["a" /* default */])(rotationLambda(deltaLambda), rotationPhiGamma(deltaPhi, deltaGamma))
    : rotationLambda(deltaLambda))
    : (deltaPhi || deltaGamma ? rotationPhiGamma(deltaPhi, deltaGamma)
    : rotationIdentity);
}

function forwardRotationLambda(deltaLambda) {
  return function(lambda, phi) {
    return lambda += deltaLambda, [lambda > __WEBPACK_IMPORTED_MODULE_1__math__["a" /* pi */] ? lambda - __WEBPACK_IMPORTED_MODULE_1__math__["b" /* tau */] : lambda < -__WEBPACK_IMPORTED_MODULE_1__math__["a" /* pi */] ? lambda + __WEBPACK_IMPORTED_MODULE_1__math__["b" /* tau */] : lambda, phi];
  };
}

function rotationLambda(deltaLambda) {
  var rotation = forwardRotationLambda(deltaLambda);
  rotation.invert = forwardRotationLambda(-deltaLambda);
  return rotation;
}

function rotationPhiGamma(deltaPhi, deltaGamma) {
  var cosDeltaPhi = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["c" /* cos */])(deltaPhi),
      sinDeltaPhi = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["d" /* sin */])(deltaPhi),
      cosDeltaGamma = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["c" /* cos */])(deltaGamma),
      sinDeltaGamma = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["d" /* sin */])(deltaGamma);

  function rotation(lambda, phi) {
    var cosPhi = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["c" /* cos */])(phi),
        x = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["c" /* cos */])(lambda) * cosPhi,
        y = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["d" /* sin */])(lambda) * cosPhi,
        z = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["d" /* sin */])(phi),
        k = z * cosDeltaPhi + x * sinDeltaPhi;
    return [
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["e" /* atan2 */])(y * cosDeltaGamma - k * sinDeltaGamma, x * cosDeltaPhi - z * sinDeltaPhi),
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["f" /* asin */])(k * cosDeltaGamma + y * sinDeltaGamma)
    ];
  }

  rotation.invert = function(lambda, phi) {
    var cosPhi = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["c" /* cos */])(phi),
        x = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["c" /* cos */])(lambda) * cosPhi,
        y = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["d" /* sin */])(lambda) * cosPhi,
        z = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["d" /* sin */])(phi),
        k = z * cosDeltaGamma - y * sinDeltaGamma;
    return [
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["e" /* atan2 */])(y * cosDeltaGamma + z * sinDeltaGamma, x * cosDeltaPhi + k * sinDeltaPhi),
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["f" /* asin */])(k * cosDeltaPhi - x * sinDeltaPhi)
    ];
  };

  return rotation;
}

/* harmony default export */ __webpack_exports__["a"] = (function(rotate) {
  rotate = rotateRadians(rotate[0] * __WEBPACK_IMPORTED_MODULE_1__math__["g" /* radians */], rotate[1] * __WEBPACK_IMPORTED_MODULE_1__math__["g" /* radians */], rotate.length > 2 ? rotate[2] * __WEBPACK_IMPORTED_MODULE_1__math__["g" /* radians */] : 0);

  function forward(coordinates) {
    coordinates = rotate(coordinates[0] * __WEBPACK_IMPORTED_MODULE_1__math__["g" /* radians */], coordinates[1] * __WEBPACK_IMPORTED_MODULE_1__math__["g" /* radians */]);
    return coordinates[0] *= __WEBPACK_IMPORTED_MODULE_1__math__["h" /* degrees */], coordinates[1] *= __WEBPACK_IMPORTED_MODULE_1__math__["h" /* degrees */], coordinates;
  }

  forward.invert = function(coordinates) {
    coordinates = rotate.invert(coordinates[0] * __WEBPACK_IMPORTED_MODULE_1__math__["g" /* radians */], coordinates[1] * __WEBPACK_IMPORTED_MODULE_1__math__["g" /* radians */]);
    return coordinates[0] *= __WEBPACK_IMPORTED_MODULE_1__math__["h" /* degrees */], coordinates[1] *= __WEBPACK_IMPORTED_MODULE_1__math__["h" /* degrees */], coordinates;
  };

  return forward;
});


/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = transformer;
/* unused harmony default export */ var _unused_webpack_default_export = (function(methods) {
  return {
    stream: transformer(methods)
  };
});

function transformer(methods) {
  return function(stream) {
    var s = new TransformStream;
    for (var key in methods) s[key] = methods[key];
    s.stream = stream;
    return s;
  };
}

function TransformStream() {}

TransformStream.prototype = {
  constructor: TransformStream,
  point: function(x, y) { this.stream.point(x, y); },
  sphere: function() { this.stream.sphere(); },
  lineStart: function() { this.stream.lineStart(); },
  lineEnd: function() { this.stream.lineEnd(); },
  polygonStart: function() { this.stream.polygonStart(); },
  polygonEnd: function() { this.stream.polygonEnd(); }
};


/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(parent, x0, y0, x1, y1) {
  var nodes = parent.children,
      node,
      i = -1,
      n = nodes.length,
      k = parent.value && (y1 - y0) / parent.value;

  while (++i < n) {
    node = nodes[i], node.x0 = x0, node.x1 = x1;
    node.y0 = y0, node.y1 = y0 += node.value * k;
  }
});


/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  return a = +a, b -= a, function(t) {
    return a + b * t;
  };
});


/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__request__ = __webpack_require__(251);


/* harmony default export */ __webpack_exports__["a"] = (function(defaultMimeType, response) {
  return function(url, callback) {
    var r = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__request__["a" /* default */])(url).mimeType(defaultMimeType).response(response);
    if (callback != null) {
      if (typeof callback !== "function") throw new Error("invalid callback: " + callback);
      return r.get(callback);
    }
    return r;
  };
});


/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = deinterpolateLinear;
/* harmony export (immutable) */ __webpack_exports__["c"] = copy;
/* harmony export (immutable) */ __webpack_exports__["a"] = continuous;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__array__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constant__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__number__ = __webpack_require__(428);






var unit = [0, 1];

function deinterpolateLinear(a, b) {
  return (b -= (a = +a))
      ? function(x) { return (x - a) / b; }
      : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__constant__["a" /* default */])(b);
}

function deinterpolateClamp(deinterpolate) {
  return function(a, b) {
    var d = deinterpolate(a = +a, b = +b);
    return function(x) { return x <= a ? 0 : x >= b ? 1 : d(x); };
  };
}

function reinterpolateClamp(reinterpolate) {
  return function(a, b) {
    var r = reinterpolate(a = +a, b = +b);
    return function(t) { return t <= 0 ? a : t >= 1 ? b : r(t); };
  };
}

function bimap(domain, range, deinterpolate, reinterpolate) {
  var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
  if (d1 < d0) d0 = deinterpolate(d1, d0), r0 = reinterpolate(r1, r0);
  else d0 = deinterpolate(d0, d1), r0 = reinterpolate(r0, r1);
  return function(x) { return r0(d0(x)); };
}

function polymap(domain, range, deinterpolate, reinterpolate) {
  var j = Math.min(domain.length, range.length) - 1,
      d = new Array(j),
      r = new Array(j),
      i = -1;

  // Reverse descending domains.
  if (domain[j] < domain[0]) {
    domain = domain.slice().reverse();
    range = range.slice().reverse();
  }

  while (++i < j) {
    d[i] = deinterpolate(domain[i], domain[i + 1]);
    r[i] = reinterpolate(range[i], range[i + 1]);
  }

  return function(x) {
    var i = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["c" /* bisect */])(domain, x, 1, j) - 1;
    return r[i](d[i](x));
  };
}

function copy(source, target) {
  return target
      .domain(source.domain())
      .range(source.range())
      .interpolate(source.interpolate())
      .clamp(source.clamp());
}

// deinterpolate(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// reinterpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding domain value x in [a,b].
function continuous(deinterpolate, reinterpolate) {
  var domain = unit,
      range = unit,
      interpolate = __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["a" /* interpolate */],
      clamp = false,
      piecewise,
      output,
      input;

  function rescale() {
    piecewise = Math.min(domain.length, range.length) > 2 ? polymap : bimap;
    output = input = null;
    return scale;
  }

  function scale(x) {
    return (output || (output = piecewise(domain, range, clamp ? deinterpolateClamp(deinterpolate) : deinterpolate, interpolate)))(+x);
  }

  scale.invert = function(y) {
    return (input || (input = piecewise(range, domain, deinterpolateLinear, clamp ? reinterpolateClamp(reinterpolate) : reinterpolate)))(+y);
  };

  scale.domain = function(_) {
    return arguments.length ? (domain = __WEBPACK_IMPORTED_MODULE_2__array__["a" /* map */].call(_, __WEBPACK_IMPORTED_MODULE_4__number__["a" /* default */]), rescale()) : domain.slice();
  };

  scale.range = function(_) {
    return arguments.length ? (range = __WEBPACK_IMPORTED_MODULE_2__array__["b" /* slice */].call(_), rescale()) : range.slice();
  };

  scale.rangeRound = function(_) {
    return range = __WEBPACK_IMPORTED_MODULE_2__array__["b" /* slice */].call(_), interpolate = __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["h" /* interpolateRound */], rescale();
  };

  scale.clamp = function(_) {
    return arguments.length ? (clamp = !!_, rescale()) : clamp;
  };

  scale.interpolate = function(_) {
    return arguments.length ? (interpolate = _, rescale()) : interpolate;
  };

  return rescale();
}


/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(node, event) {
  var svg = node.ownerSVGElement || node;

  if (svg.createSVGPoint) {
    var point = svg.createSVGPoint();
    point.x = event.clientX, point.y = event.clientY;
    point = point.matrixTransform(node.getScreenCTM().inverse());
    return [point.x, point.y];
  }

  var rect = node.getBoundingClientRect();
  return [event.clientX - rect.left - node.clientLeft, event.clientY - rect.top - node.clientTop];
});


/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = point;
/* harmony export (immutable) */ __webpack_exports__["a"] = Basis;
function point(that, x, y) {
  that._context.bezierCurveTo(
    (2 * that._x0 + that._x1) / 3,
    (2 * that._y0 + that._y1) / 3,
    (that._x0 + 2 * that._x1) / 3,
    (that._y0 + 2 * that._y1) / 3,
    (that._x0 + 4 * that._x1 + x) / 6,
    (that._y0 + 4 * that._y1 + y) / 6
  );
}

function Basis(context) {
  this._context = context;
}

Basis.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 =
    this._y0 = this._y1 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 3: point(this, this._x1, this._y1); // proceed
      case 2: this._context.lineTo(this._x1, this._y1); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6); // proceed
      default: point(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
  }
};

/* unused harmony default export */ var _unused_webpack_default_export = (function(context) {
  return new Basis(context);
});


/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = point;
/* harmony export (immutable) */ __webpack_exports__["a"] = Cardinal;
function point(that, x, y) {
  that._context.bezierCurveTo(
    that._x1 + that._k * (that._x2 - that._x0),
    that._y1 + that._k * (that._y2 - that._y0),
    that._x2 + that._k * (that._x1 - x),
    that._y2 + that._k * (that._y1 - y),
    that._x2,
    that._y2
  );
}

function Cardinal(context, tension) {
  this._context = context;
  this._k = (1 - tension) / 6;
}

Cardinal.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 =
    this._y0 = this._y1 = this._y2 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2: this._context.lineTo(this._x2, this._y2); break;
      case 3: point(this, this._x1, this._y1); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; this._x1 = x, this._y1 = y; break;
      case 2: this._point = 3; // proceed
      default: point(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* unused harmony default export */ var _unused_webpack_default_export = ((function custom(tension) {

  function cardinal(context) {
    return new Cardinal(context, tension);
  }

  cardinal.tension = function(tension) {
    return custom(+tension);
  };

  return cardinal;
})(0));


/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function Linear(context) {
  this._context = context;
}

Linear.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; // proceed
      default: this._context.lineTo(x, y); break;
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (function(context) {
  return new Linear(context);
});


/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {});


/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_interval__ = __webpack_require__(27);
/* unused harmony reexport timeInterval */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_millisecond__ = __webpack_require__(1046);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_1__src_millisecond__["a"]; });
/* unused harmony reexport timeMilliseconds */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_1__src_millisecond__["a"]; });
/* unused harmony reexport utcMilliseconds */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_second__ = __webpack_require__(1049);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_2__src_second__["a"]; });
/* unused harmony reexport timeSeconds */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_2__src_second__["a"]; });
/* unused harmony reexport utcSeconds */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_minute__ = __webpack_require__(1047);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_3__src_minute__["a"]; });
/* unused harmony reexport timeMinutes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_hour__ = __webpack_require__(1045);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_4__src_hour__["a"]; });
/* unused harmony reexport timeHours */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_day__ = __webpack_require__(1044);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_5__src_day__["a"]; });
/* unused harmony reexport timeDays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_week__ = __webpack_require__(1056);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_6__src_week__["a"]; });
/* unused harmony reexport timeWeeks */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_6__src_week__["a"]; });
/* unused harmony reexport timeSundays */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_6__src_week__["b"]; });
/* unused harmony reexport timeMondays */
/* unused harmony reexport timeTuesday */
/* unused harmony reexport timeTuesdays */
/* unused harmony reexport timeWednesday */
/* unused harmony reexport timeWednesdays */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_6__src_week__["c"]; });
/* unused harmony reexport timeThursdays */
/* unused harmony reexport timeFriday */
/* unused harmony reexport timeFridays */
/* unused harmony reexport timeSaturday */
/* unused harmony reexport timeSaturdays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_month__ = __webpack_require__(1048);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_7__src_month__["a"]; });
/* unused harmony reexport timeMonths */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_year__ = __webpack_require__(1057);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_8__src_year__["a"]; });
/* unused harmony reexport timeYears */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_utcMinute__ = __webpack_require__(1052);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_9__src_utcMinute__["a"]; });
/* unused harmony reexport utcMinutes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_utcHour__ = __webpack_require__(1051);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_10__src_utcHour__["a"]; });
/* unused harmony reexport utcHours */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_utcDay__ = __webpack_require__(1050);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_11__src_utcDay__["a"]; });
/* unused harmony reexport utcDays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_utcWeek__ = __webpack_require__(1054);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_12__src_utcWeek__["a"]; });
/* unused harmony reexport utcWeeks */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_12__src_utcWeek__["a"]; });
/* unused harmony reexport utcSundays */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_12__src_utcWeek__["b"]; });
/* unused harmony reexport utcMondays */
/* unused harmony reexport utcTuesday */
/* unused harmony reexport utcTuesdays */
/* unused harmony reexport utcWednesday */
/* unused harmony reexport utcWednesdays */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_12__src_utcWeek__["c"]; });
/* unused harmony reexport utcThursdays */
/* unused harmony reexport utcFriday */
/* unused harmony reexport utcFridays */
/* unused harmony reexport utcSaturday */
/* unused harmony reexport utcSaturdays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_utcMonth__ = __webpack_require__(1053);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_13__src_utcMonth__["a"]; });
/* unused harmony reexport utcMonths */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_utcYear__ = __webpack_require__(1055);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_14__src_utcYear__["a"]; });
/* unused harmony reexport utcYears */































/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_timer__ = __webpack_require__(266);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__src_timer__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_timer__["a"]; });
/* unused harmony reexport timerFlush */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_timeout__ = __webpack_require__(1059);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__src_timeout__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_interval__ = __webpack_require__(1058);
/* unused harmony reexport interval */







/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = tweenValue;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__schedule__ = __webpack_require__(44);


function tweenRemove(id, name) {
  var tween0, tween1;
  return function() {
    var schedule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__schedule__["e" /* set */])(this, id),
        tween = schedule.tween;

    // If this node shared tween with the previous node,
    // just assign the updated shared tween and we’re done!
    // Otherwise, copy-on-write.
    if (tween !== tween0) {
      tween1 = tween0 = tween;
      for (var i = 0, n = tween1.length; i < n; ++i) {
        if (tween1[i].name === name) {
          tween1 = tween1.slice();
          tween1.splice(i, 1);
          break;
        }
      }
    }

    schedule.tween = tween1;
  };
}

function tweenFunction(id, name, value) {
  var tween0, tween1;
  if (typeof value !== "function") throw new Error;
  return function() {
    var schedule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__schedule__["e" /* set */])(this, id),
        tween = schedule.tween;

    // If this node shared tween with the previous node,
    // just assign the updated shared tween and we’re done!
    // Otherwise, copy-on-write.
    if (tween !== tween0) {
      tween1 = (tween0 = tween).slice();
      for (var t = {name: name, value: value}, i = 0, n = tween1.length; i < n; ++i) {
        if (tween1[i].name === name) {
          tween1[i] = t;
          break;
        }
      }
      if (i === n) tween1.push(t);
    }

    schedule.tween = tween1;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(name, value) {
  var id = this._id;

  name += "";

  if (arguments.length < 2) {
    var tween = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__schedule__["f" /* get */])(this.node(), id).tween;
    for (var i = 0, n = tween.length, t; i < n; ++i) {
      if ((t = tween[i]).name === name) {
        return t.value;
      }
    }
    return null;
  }

  return this.each((value == null ? tweenRemove : tweenFunction)(id, name, value));
});

function tweenValue(transition, name, value) {
  var id = transition._id;

  transition.each(function() {
    var schedule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__schedule__["e" /* set */])(this, id);
    (schedule.value || (schedule.value = {}))[name] = value.apply(this, arguments);
  });

  return function(node) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__schedule__["f" /* get */])(node, id).value[name];
  };
}


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subject_1 = __webpack_require__(11);
var Subscription_1 = __webpack_require__(18);
/**
 * @class AsyncSubject<T>
 */
var AsyncSubject = (function (_super) {
    __extends(AsyncSubject, _super);
    function AsyncSubject() {
        _super.apply(this, arguments);
        this.value = null;
        this.hasNext = false;
        this.hasCompleted = false;
    }
    AsyncSubject.prototype._subscribe = function (subscriber) {
        if (this.hasError) {
            subscriber.error(this.thrownError);
            return Subscription_1.Subscription.EMPTY;
        }
        else if (this.hasCompleted && this.hasNext) {
            subscriber.next(this.value);
            subscriber.complete();
            return Subscription_1.Subscription.EMPTY;
        }
        return _super.prototype._subscribe.call(this, subscriber);
    };
    AsyncSubject.prototype.next = function (value) {
        if (!this.hasCompleted) {
            this.value = value;
            this.hasNext = true;
        }
    };
    AsyncSubject.prototype.error = function (error) {
        if (!this.hasCompleted) {
            _super.prototype.error.call(this, error);
        }
    };
    AsyncSubject.prototype.complete = function () {
        this.hasCompleted = true;
        if (this.hasNext) {
            _super.prototype.next.call(this, this.value);
        }
        _super.prototype.complete.call(this);
    };
    return AsyncSubject;
}(Subject_1.Subject));
exports.AsyncSubject = AsyncSubject;
//# sourceMappingURL=AsyncSubject.js.map

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subject_1 = __webpack_require__(11);
var queue_1 = __webpack_require__(493);
var Subscription_1 = __webpack_require__(18);
var observeOn_1 = __webpack_require__(277);
var ObjectUnsubscribedError_1 = __webpack_require__(171);
var SubjectSubscription_1 = __webpack_require__(465);
/**
 * @class ReplaySubject<T>
 */
var ReplaySubject = (function (_super) {
    __extends(ReplaySubject, _super);
    function ReplaySubject(bufferSize, windowTime, scheduler) {
        if (bufferSize === void 0) { bufferSize = Number.POSITIVE_INFINITY; }
        if (windowTime === void 0) { windowTime = Number.POSITIVE_INFINITY; }
        _super.call(this);
        this.scheduler = scheduler;
        this._events = [];
        this._bufferSize = bufferSize < 1 ? 1 : bufferSize;
        this._windowTime = windowTime < 1 ? 1 : windowTime;
    }
    ReplaySubject.prototype.next = function (value) {
        var now = this._getNow();
        this._events.push(new ReplayEvent(now, value));
        this._trimBufferThenGetEvents();
        _super.prototype.next.call(this, value);
    };
    ReplaySubject.prototype._subscribe = function (subscriber) {
        var _events = this._trimBufferThenGetEvents();
        var scheduler = this.scheduler;
        var subscription;
        if (this.closed) {
            throw new ObjectUnsubscribedError_1.ObjectUnsubscribedError();
        }
        else if (this.hasError) {
            subscription = Subscription_1.Subscription.EMPTY;
        }
        else if (this.isStopped) {
            subscription = Subscription_1.Subscription.EMPTY;
        }
        else {
            this.observers.push(subscriber);
            subscription = new SubjectSubscription_1.SubjectSubscription(this, subscriber);
        }
        if (scheduler) {
            subscriber.add(subscriber = new observeOn_1.ObserveOnSubscriber(subscriber, scheduler));
        }
        var len = _events.length;
        for (var i = 0; i < len && !subscriber.closed; i++) {
            subscriber.next(_events[i].value);
        }
        if (this.hasError) {
            subscriber.error(this.thrownError);
        }
        else if (this.isStopped) {
            subscriber.complete();
        }
        return subscription;
    };
    ReplaySubject.prototype._getNow = function () {
        return (this.scheduler || queue_1.queue).now();
    };
    ReplaySubject.prototype._trimBufferThenGetEvents = function () {
        var now = this._getNow();
        var _bufferSize = this._bufferSize;
        var _windowTime = this._windowTime;
        var _events = this._events;
        var eventsCount = _events.length;
        var spliceCount = 0;
        // Trim events that fall out of the time window.
        // Start at the front of the list. Break early once
        // we encounter an event that falls within the window.
        while (spliceCount < eventsCount) {
            if ((now - _events[spliceCount].time) < _windowTime) {
                break;
            }
            spliceCount++;
        }
        if (eventsCount > _bufferSize) {
            spliceCount = Math.max(spliceCount, eventsCount - _bufferSize);
        }
        if (spliceCount > 0) {
            _events.splice(0, spliceCount);
        }
        return _events;
    };
    return ReplaySubject;
}(Subject_1.Subject));
exports.ReplaySubject = ReplaySubject;
var ReplayEvent = (function () {
    function ReplayEvent(time, value) {
        this.time = time;
        this.value = value;
    }
    return ReplayEvent;
}());
//# sourceMappingURL=ReplaySubject.js.map

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var takeUntil_1 = __webpack_require__(1317);
Observable_1.Observable.prototype.takeUntil = takeUntil_1.takeUntil;
//# sourceMappingURL=takeUntil.js.map

/***/ }),
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AnimationBuilder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return AnimationFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return AUTO_STYLE; });
/* unused harmony export animate */
/* unused harmony export animateChild */
/* unused harmony export animation */
/* unused harmony export group */
/* unused harmony export keyframes */
/* unused harmony export query */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return sequence; });
/* unused harmony export stagger */
/* unused harmony export state */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return style; });
/* unused harmony export transition */
/* unused harmony export trigger */
/* unused harmony export useAnimation */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return NoopAnimationPlayer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return AnimationGroupPlayer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ɵPRE_STYLE; });
/**
 * @license Angular v4.4.4
 * (c) 2010-2017 Google, Inc. https://angular.io/
 * License: MIT
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * AnimationBuilder is an injectable service that is available when the {\@link
 * BrowserAnimationsModule BrowserAnimationsModule} or {\@link NoopAnimationsModule
 * NoopAnimationsModule} modules are used within an application.
 *
 * The purpose if this service is to produce an animation sequence programmatically within an
 * angular component or directive.
 *
 * Programmatic animations are first built and then a player is created when the build animation is
 * attached to an element.
 *
 * ```ts
 * // remember to include the BrowserAnimationsModule module for this to work...
 * import {AnimationBuilder} from '\@angular/animations';
 *
 * class MyCmp {
 *   constructor(private _builder: AnimationBuilder) {}
 *
 *   makeAnimation(element: any) {
 *     // first build the animation
 *     const myAnimation = this._builder.build([
 *       style({ width: 0 }),
 *       animate(1000, style({ width: '100px' }))
 *     ]);
 *
 *     // then create a player from it
 *     const player = myAnimation.create(element);
 *
 *     player.play();
 *   }
 * }
 * ```
 *
 * When an animation is built an instance of {\@link AnimationFactory AnimationFactory} will be
 * returned. Using that an {\@link AnimationPlayer AnimationPlayer} can be created which can then be
 * used to start the animation.
 *
 * \@experimental Animation support is experimental.
 * @abstract
 */
var AnimationBuilder = (function () {
    function AnimationBuilder() {
    }
    /**
     * @abstract
     * @param {?} animation
     * @return {?}
     */
    AnimationBuilder.prototype.build = function (animation) { };
    return AnimationBuilder;
}());
/**
 * An instance of `AnimationFactory` is returned from {\@link AnimationBuilder#build
 * AnimationBuilder.build}.
 *
 * \@experimental Animation support is experimental.
 * @abstract
 */
var AnimationFactory = (function () {
    function AnimationFactory() {
    }
    /**
     * @abstract
     * @param {?} element
     * @param {?=} options
     * @return {?}
     */
    AnimationFactory.prototype.create = function (element, options) { };
    return AnimationFactory;
}());
/**
 * \@experimental Animation support is experimental.
 */
var AUTO_STYLE = '*';
/**
 * `trigger` is an animation-specific function that is designed to be used inside of Angular's
 * animation DSL language. If this information is new, please navigate to the
 * {\@link Component#animations component animations metadata page} to gain a better
 * understanding of how animations in Angular are used.
 *
 * `trigger` Creates an animation trigger which will a list of {\@link state state} and
 * {\@link transition transition} entries that will be evaluated when the expression
 * bound to the trigger changes.
 *
 * Triggers are registered within the component annotation data under the
 * {\@link Component#animations animations section}. An animation trigger can be placed on an element
 * within a template by referencing the name of the trigger followed by the expression value that
 * the
 * trigger is bound to (in the form of `[\@triggerName]="expression"`.
 *
 * ### Usage
 *
 * `trigger` will create an animation trigger reference based on the provided `name` value. The
 * provided `animation` value is expected to be an array consisting of {\@link state state} and
 * {\@link transition transition} declarations.
 *
 * ```typescript
 * \@Component({
 *   selector: 'my-component',
 *   templateUrl: 'my-component-tpl.html',
 *   animations: [
 *     trigger("myAnimationTrigger", [
 *       state(...),
 *       state(...),
 *       transition(...),
 *       transition(...)
 *     ])
 *   ]
 * })
 * class MyComponent {
 *   myStatusExp = "something";
 * }
 * ```
 *
 * The template associated with this component will make use of the `myAnimationTrigger` animation
 * trigger by binding to an element within its template code.
 *
 * ```html
 * <!-- somewhere inside of my-component-tpl.html -->
 * <div [\@myAnimationTrigger]="myStatusExp">...</div>
 * ```
 *
 * ## Disable Animations
 * A special animation control binding called `\@.disabled` can be placed on an element which will
 * then disable animations for any inner animation triggers situated within the element as well as
 * any animations on the element itself.
 *
 * When true, the `\@.disabled` binding will prevent all animations from rendering. The example
 * below shows how to use this feature:
 *
 * ```ts
 * \@Component({
 *   selector: 'my-component',
 *   template: `
 *     <div [\@.disabled]="isDisabled">
 *       <div [\@childAnimation]="exp"></div>
 *     </div>
 *   `,
 *   animations: [
 *     trigger("childAnimation", [
 *       // ...
 *     ])
 *   ]
 * })
 * class MyComponent {
 *   isDisabled = true;
 *   exp = '...';
 * }
 * ```
 *
 * The `\@childAnimation` trigger will not animate because `\@.disabled` prevents it from happening
 * (when true).
 *
 * Note that `\@.disbled` will only disable all animations (this means any animations running on
 * the same element will also be disabled).
 *
 * ### Disabling Animations Application-wide
 * When an area of the template is set to have animations disabled, **all** inner components will
 * also have their animations disabled as well. This means that all animations for an angular
 * application can be disabled by placing a host binding set on `\@.disabled` on the topmost Angular
 * component.
 *
 * ```ts
 * import {Component, HostBinding} from '\@angular/core';
 *
 * \@Component({
 *   selector: 'app-component',
 *   templateUrl: 'app.component.html',
 * })
 * class AppComponent {
 *   \@HostBinding('\@.disabled')
 *   public animationsDisabled = true;
 * }
 * ```
 *
 * ### What about animations that us `query()` and `animateChild()`?
 * Despite inner animations being disabled, a parent animation can {\@link query query} for inner
 * elements located in disabled areas of the template and still animate them as it sees fit. This is
 * also the case for when a sub animation is queried by a parent and then later animated using {\@link
 * animateChild animateChild}.
 *
 * \@experimental Animation support is experimental.
 * @param {?} name
 * @param {?} definitions
 * @return {?}
 */
function trigger(name, definitions) {
    return { type: 7 /* Trigger */, name: name, definitions: definitions, options: {} };
}
/**
 * `animate` is an animation-specific function that is designed to be used inside of Angular's
 * animation DSL language. If this information is new, please navigate to the {\@link
 * Component#animations component animations metadata page} to gain a better understanding of
 * how animations in Angular are used.
 *
 * `animate` specifies an animation step that will apply the provided `styles` data for a given
 * amount of time based on the provided `timing` expression value. Calls to `animate` are expected
 * to be used within {\@link sequence an animation sequence}, {\@link group group}, or {\@link
 * transition transition}.
 *
 * ### Usage
 *
 * The `animate` function accepts two input parameters: `timing` and `styles`:
 *
 * - `timing` is a string based value that can be a combination of a duration with optional delay
 * and easing values. The format for the expression breaks down to `duration delay easing`
 * (therefore a value such as `1s 100ms ease-out` will be parse itself into `duration=1000,
 * delay=100, easing=ease-out`. If a numeric value is provided then that will be used as the
 * `duration` value in millisecond form.
 * - `styles` is the style input data which can either be a call to {\@link style style} or {\@link
 * keyframes keyframes}. If left empty then the styles from the destination state will be collected
 * and used (this is useful when describing an animation step that will complete an animation by
 * {\@link transition#the-final-animate-call animating to the final state}).
 *
 * ```typescript
 * // various functions for specifying timing data
 * animate(500, style(...))
 * animate("1s", style(...))
 * animate("100ms 0.5s", style(...))
 * animate("5s ease", style(...))
 * animate("5s 10ms cubic-bezier(.17,.67,.88,.1)", style(...))
 *
 * // either style() of keyframes() can be used
 * animate(500, style({ background: "red" }))
 * animate(500, keyframes([
 *   style({ background: "blue" })),
 *   style({ background: "red" }))
 * ])
 * ```
 *
 * {\@example core/animation/ts/dsl/animation_example.ts region='Component'}
 *
 * \@experimental Animation support is experimental.
 * @param {?} timings
 * @param {?=} styles
 * @return {?}
 */
function animate(timings, styles) {
    if (styles === void 0) { styles = null; }
    return { type: 4 /* Animate */, styles: styles, timings: timings };
}
/**
 * `group` is an animation-specific function that is designed to be used inside of Angular's
 * animation DSL language. If this information is new, please navigate to the {\@link
 * Component#animations component animations metadata page} to gain a better understanding of
 * how animations in Angular are used.
 *
 * `group` specifies a list of animation steps that are all run in parallel. Grouped animations are
 * useful when a series of styles must be animated/closed off at different starting/ending times.
 *
 * The `group` function can either be used within a {\@link sequence sequence} or a {\@link transition
 * transition} and it will only continue to the next instruction once all of the inner animation
 * steps have completed.
 *
 * ### Usage
 *
 * The `steps` data that is passed into the `group` animation function can either consist of {\@link
 * style style} or {\@link animate animate} function calls. Each call to `style()` or `animate()`
 * within a group will be executed instantly (use {\@link keyframes keyframes} or a {\@link
 * animate#usage animate() with a delay value} to offset styles to be applied at a later time).
 *
 * ```typescript
 * group([
 *   animate("1s", { background: "black" }))
 *   animate("2s", { color: "white" }))
 * ])
 * ```
 *
 * {\@example core/animation/ts/dsl/animation_example.ts region='Component'}
 *
 * \@experimental Animation support is experimental.
 * @param {?} steps
 * @param {?=} options
 * @return {?}
 */
function group(steps, options) {
    if (options === void 0) { options = null; }
    return { type: 3 /* Group */, steps: steps, options: options };
}
/**
 * `sequence` is an animation-specific function that is designed to be used inside of Angular's
 * animation DSL language. If this information is new, please navigate to the {\@link
 * Component#animations component animations metadata page} to gain a better understanding of
 * how animations in Angular are used.
 *
 * `sequence` Specifies a list of animation steps that are run one by one. (`sequence` is used by
 * default when an array is passed as animation data into {\@link transition transition}.)
 *
 * The `sequence` function can either be used within a {\@link group group} or a {\@link transition
 * transition} and it will only continue to the next instruction once each of the inner animation
 * steps have completed.
 *
 * To perform animation styling in parallel with other animation steps then have a look at the
 * {\@link group group} animation function.
 *
 * ### Usage
 *
 * The `steps` data that is passed into the `sequence` animation function can either consist of
 * {\@link style style} or {\@link animate animate} function calls. A call to `style()` will apply the
 * provided styling data immediately while a call to `animate()` will apply its styling data over a
 * given time depending on its timing data.
 *
 * ```typescript
 * sequence([
 *   style({ opacity: 0 })),
 *   animate("1s", { opacity: 1 }))
 * ])
 * ```
 *
 * {\@example core/animation/ts/dsl/animation_example.ts region='Component'}
 *
 * \@experimental Animation support is experimental.
 * @param {?} steps
 * @param {?=} options
 * @return {?}
 */
function sequence(steps, options) {
    if (options === void 0) { options = null; }
    return { type: 2 /* Sequence */, steps: steps, options: options };
}
/**
 * `style` is an animation-specific function that is designed to be used inside of Angular's
 * animation DSL language. If this information is new, please navigate to the {\@link
 * Component#animations component animations metadata page} to gain a better understanding of
 * how animations in Angular are used.
 *
 * `style` declares a key/value object containing CSS properties/styles that can then be used for
 * {\@link state animation states}, within an {\@link sequence animation sequence}, or as styling data
 * for both {\@link animate animate} and {\@link keyframes keyframes}.
 *
 * ### Usage
 *
 * `style` takes in a key/value string map as data and expects one or more CSS property/value pairs
 * to be defined.
 *
 * ```typescript
 * // string values are used for css properties
 * style({ background: "red", color: "blue" })
 *
 * // numerical (pixel) values are also supported
 * style({ width: 100, height: 0 })
 * ```
 *
 * #### Auto-styles (using `*`)
 *
 * When an asterix (`*`) character is used as a value then it will be detected from the element
 * being animated and applied as animation data when the animation starts.
 *
 * This feature proves useful for a state depending on layout and/or environment factors; in such
 * cases the styles are calculated just before the animation starts.
 *
 * ```typescript
 * // the steps below will animate from 0 to the
 * // actual height of the element
 * style({ height: 0 }),
 * animate("1s", style({ height: "*" }))
 * ```
 *
 * {\@example core/animation/ts/dsl/animation_example.ts region='Component'}
 *
 * \@experimental Animation support is experimental.
 * @param {?} tokens
 * @return {?}
 */
function style(tokens) {
    return { type: 6 /* Style */, styles: tokens, offset: null };
}
/**
 * `state` is an animation-specific function that is designed to be used inside of Angular's
 * animation DSL language. If this information is new, please navigate to the {\@link
 * Component#animations component animations metadata page} to gain a better understanding of
 * how animations in Angular are used.
 *
 * `state` declares an animation state within the given trigger. When a state is active within a
 * component then its associated styles will persist on the element that the trigger is attached to
 * (even when the animation ends).
 *
 * To animate between states, have a look at the animation {\@link transition transition} DSL
 * function. To register states to an animation trigger please have a look at the {\@link trigger
 * trigger} function.
 *
 * #### The `void` state
 *
 * The `void` state value is a reserved word that angular uses to determine when the element is not
 * apart of the application anymore (e.g. when an `ngIf` evaluates to false then the state of the
 * associated element is void).
 *
 * #### The `*` (default) state
 *
 * The `*` state (when styled) is a fallback state that will be used if the state that is being
 * animated is not declared within the trigger.
 *
 * ### Usage
 *
 * `state` will declare an animation state with its associated styles
 * within the given trigger.
 *
 * - `stateNameExpr` can be one or more state names separated by commas.
 * - `styles` refers to the {\@link style styling data} that will be persisted on the element once
 * the state has been reached.
 *
 * ```typescript
 * // "void" is a reserved name for a state and is used to represent
 * // the state in which an element is detached from from the application.
 * state("void", style({ height: 0 }))
 *
 * // user-defined states
 * state("closed", style({ height: 0 }))
 * state("open, visible", style({ height: "*" }))
 * ```
 *
 * {\@example core/animation/ts/dsl/animation_example.ts region='Component'}
 *
 * \@experimental Animation support is experimental.
 * @param {?} name
 * @param {?} styles
 * @param {?=} options
 * @return {?}
 */
function state(name, styles, options) {
    return { type: 0 /* State */, name: name, styles: styles, options: options };
}
/**
 * `keyframes` is an animation-specific function that is designed to be used inside of Angular's
 * animation DSL language. If this information is new, please navigate to the {\@link
 * Component#animations component animations metadata page} to gain a better understanding of
 * how animations in Angular are used.
 *
 * `keyframes` specifies a collection of {\@link style style} entries each optionally characterized
 * by an `offset` value.
 *
 * ### Usage
 *
 * The `keyframes` animation function is designed to be used alongside the {\@link animate animate}
 * animation function. Instead of applying animations from where they are currently to their
 * destination, keyframes can describe how each style entry is applied and at what point within the
 * animation arc (much like CSS Keyframe Animations do).
 *
 * For each `style()` entry an `offset` value can be set. Doing so allows to specifiy at what
 * percentage of the animate time the styles will be applied.
 *
 * ```typescript
 * // the provided offset values describe when each backgroundColor value is applied.
 * animate("5s", keyframes([
 *   style({ backgroundColor: "red", offset: 0 }),
 *   style({ backgroundColor: "blue", offset: 0.2 }),
 *   style({ backgroundColor: "orange", offset: 0.3 }),
 *   style({ backgroundColor: "black", offset: 1 })
 * ]))
 * ```
 *
 * Alternatively, if there are no `offset` values used within the style entries then the offsets
 * will be calculated automatically.
 *
 * ```typescript
 * animate("5s", keyframes([
 *   style({ backgroundColor: "red" }) // offset = 0
 *   style({ backgroundColor: "blue" }) // offset = 0.33
 *   style({ backgroundColor: "orange" }) // offset = 0.66
 *   style({ backgroundColor: "black" }) // offset = 1
 * ]))
 * ```
 *
 * {\@example core/animation/ts/dsl/animation_example.ts region='Component'}
 *
 * \@experimental Animation support is experimental.
 * @param {?} steps
 * @return {?}
 */
function keyframes(steps) {
    return { type: 5 /* Keyframes */, steps: steps };
}
/**
 * `transition` is an animation-specific function that is designed to be used inside of Angular's
 * animation DSL language. If this information is new, please navigate to the {\@link
 * Component#animations component animations metadata page} to gain a better understanding of
 * how animations in Angular are used.
 *
 * `transition` declares the {\@link sequence sequence of animation steps} that will be run when the
 * provided `stateChangeExpr` value is satisfied. The `stateChangeExpr` consists of a `state1 =>
 * state2` which consists of two known states (use an asterix (`*`) to refer to a dynamic starting
 * and/or ending state).
 *
 * A function can also be provided as the `stateChangeExpr` argument for a transition and this
 * function will be executed each time a state change occurs. If the value returned within the
 * function is true then the associated animation will be run.
 *
 * Animation transitions are placed within an {\@link trigger animation trigger}. For an transition
 * to animate to a state value and persist its styles then one or more {\@link state animation
 * states} is expected to be defined.
 *
 * ### Usage
 *
 * An animation transition is kicked off the `stateChangeExpr` predicate evaluates to true based on
 * what the previous state is and what the current state has become. In other words, if a transition
 * is defined that matches the old/current state criteria then the associated animation will be
 * triggered.
 *
 * ```typescript
 * // all transition/state changes are defined within an animation trigger
 * trigger("myAnimationTrigger", [
 *   // if a state is defined then its styles will be persisted when the
 *   // animation has fully completed itself
 *   state("on", style({ background: "green" })),
 *   state("off", style({ background: "grey" })),
 *
 *   // a transition animation that will be kicked off when the state value
 *   // bound to "myAnimationTrigger" changes from "on" to "off"
 *   transition("on => off", animate(500)),
 *
 *   // it is also possible to do run the same animation for both directions
 *   transition("on <=> off", animate(500)),
 *
 *   // or to define multiple states pairs separated by commas
 *   transition("on => off, off => void", animate(500)),
 *
 *   // this is a catch-all state change for when an element is inserted into
 *   // the page and the destination state is unknown
 *   transition("void => *", [
 *     style({ opacity: 0 }),
 *     animate(500)
 *   ]),
 *
 *   // this will capture a state change between any states
 *   transition("* => *", animate("1s 0s")),
 *
 *   // you can also go full out and include a function
 *   transition((fromState, toState) => {
 *     // when `true` then it will allow the animation below to be invoked
 *     return fromState == "off" && toState == "on";
 *   }, animate("1s 0s"))
 * ])
 * ```
 *
 * The template associated with this component will make use of the `myAnimationTrigger` animation
 * trigger by binding to an element within its template code.
 *
 * ```html
 * <!-- somewhere inside of my-component-tpl.html -->
 * <div [\@myAnimationTrigger]="myStatusExp">...</div>
 * ```
 *
 * #### The final `animate` call
 *
 * If the final step within the transition steps is a call to `animate()` that **only** uses a
 * timing value with **no style data** then it will be automatically used as the final animation arc
 * for the element to animate itself to the final state. This involves an automatic mix of
 * adding/removing CSS styles so that the element will be in the exact state it should be for the
 * applied state to be presented correctly.
 *
 * ```
 * // start off by hiding the element, but make sure that it animates properly to whatever state
 * // is currently active for "myAnimationTrigger"
 * transition("void => *", [
 *   style({ opacity: 0 }),
 *   animate(500)
 * ])
 * ```
 *
 * ### Transition Aliases (`:enter` and `:leave`)
 *
 * Given that enter (insertion) and leave (removal) animations are so common, the `transition`
 * function accepts both `:enter` and `:leave` values which are aliases for the `void => *` and `*
 * => void` state changes.
 *
 * ```
 * transition(":enter", [
 *   style({ opacity: 0 }),
 *   animate(500, style({ opacity: 1 }))
 * ])
 * transition(":leave", [
 *   animate(500, style({ opacity: 0 }))
 * ])
 * ```
 *
 * {\@example core/animation/ts/dsl/animation_example.ts region='Component'}
 *
 * \@experimental Animation support is experimental.
 * @param {?} stateChangeExpr
 * @param {?} steps
 * @param {?=} options
 * @return {?}
 */
function transition(stateChangeExpr, steps, options) {
    if (options === void 0) { options = null; }
    return { type: 1 /* Transition */, expr: stateChangeExpr, animation: steps, options: options };
}
/**
 * `animation` is an animation-specific function that is designed to be used inside of Angular's
 * animation DSL language.
 *
 * `var myAnimation = animation(...)` is designed to produce a reusable animation that can be later
 * invoked in another animation or sequence. Reusable animations are designed to make use of
 * animation parameters and the produced animation can be used via the `useAnimation` method.
 *
 * ```
 * var fadeAnimation = animation([
 *   style({ opacity: '{{ start }}' }),
 *   animate('{{ time }}',
 *     style({ opacity: '{{ end }}'))
 * ], { params: { time: '1000ms', start: 0, end: 1 }});
 * ```
 *
 * If parameters are attached to an animation then they act as **default parameter values**. When an
 * animation is invoked via `useAnimation` then parameter values are allowed to be passed in
 * directly. If any of the passed in parameter values are missing then the default values will be
 * used.
 *
 * ```
 * useAnimation(fadeAnimation, {
 *   params: {
 *     time: '2s',
 *     start: 1,
 *     end: 0
 *   }
 * })
 * ```
 *
 * If one or more parameter values are missing before animated then an error will be thrown.
 *
 * \@experimental Animation support is experimental.
 * @param {?} steps
 * @param {?=} options
 * @return {?}
 */
function animation(steps, options) {
    if (options === void 0) { options = null; }
    return { type: 8 /* Reference */, animation: steps, options: options };
}
/**
 * `animateChild` is an animation-specific function that is designed to be used inside of Angular's
 * animation DSL language. It works by allowing a queried element to execute its own
 * animation within the animation sequence.
 *
 * Each time an animation is triggered in angular, the parent animation
 * will always get priority and any child animations will be blocked. In order
 * for a child animation to run, the parent animation must query each of the elements
 * containing child animations and then allow the animations to run using `animateChild`.
 *
 * The example HTML code below shows both parent and child elements that have animation
 * triggers that will execute at the same time.
 *
 * ```html
 * <!-- parent-child.component.html -->
 * <button (click)="exp =! exp">Toggle</button>
 * <hr>
 *
 * <div [\@parentAnimation]="exp">
 *   <header>Hello</header>
 *   <div [\@childAnimation]="exp">
 *       one
 *   </div>
 *   <div [\@childAnimation]="exp">
 *       two
 *   </div>
 *   <div [\@childAnimation]="exp">
 *       three
 *   </div>
 * </div>
 * ```
 *
 * Now when the `exp` value changes to true, only the `parentAnimation` animation will animate
 * because it has priority. However, using `query` and `animateChild` each of the inner animations
 * can also fire:
 *
 * ```ts
 * // parent-child.component.ts
 * import {trigger, transition, animate, style, query, animateChild} from '\@angular/animations';
 * \@Component({
 *   selector: 'parent-child-component',
 *   animations: [
 *     trigger('parentAnimation', [
 *       transition('false => true', [
 *         query('header', [
 *           style({ opacity: 0 }),
 *           animate(500, style({ opacity: 1 }))
 *         ]),
 *         query('\@childAnimation', [
 *           animateChild()
 *         ])
 *       ])
 *     ]),
 *     trigger('childAnimation', [
 *       transition('false => true', [
 *         style({ opacity: 0 }),
 *         animate(500, style({ opacity: 1 }))
 *       ])
 *     ])
 *   ]
 * })
 * class ParentChildCmp {
 *   exp: boolean = false;
 * }
 * ```
 *
 * In the animation code above, when the `parentAnimation` transition kicks off it first queries to
 * find the header element and fades it in. It then finds each of the sub elements that contain the
 * `\@childAnimation` trigger and then allows for their animations to fire.
 *
 * This example can be further extended by using stagger:
 *
 * ```ts
 * query('\@childAnimation', stagger(100, [
 *   animateChild()
 * ]))
 * ```
 *
 * Now each of the sub animations start off with respect to the `100ms` staggering step.
 *
 * ## The first frame of child animations
 * When sub animations are executed using `animateChild` the animation engine will always apply the
 * first frame of every sub animation immediately at the start of the animation sequence. This way
 * the parent animation does not need to set any initial styling data on the sub elements before the
 * sub animations kick off.
 *
 * In the example above the first frame of the `childAnimation`'s `false => true` transition
 * consists of a style of `opacity: 0`. This is applied immediately when the `parentAnimation`
 * animation transition sequence starts. Only then when the `\@childAnimation` is queried and called
 * with `animateChild` will it then animate to its destination of `opacity: 1`.
 *
 * Note that this feature designed to be used alongside {\@link query query()} and it will only work
 * with animations that are assigned using the Angular animation DSL (this means that CSS keyframes
 * and transitions are not handled by this API).
 *
 * \@experimental Animation support is experimental.
 * @param {?=} options
 * @return {?}
 */
function animateChild(options) {
    if (options === void 0) { options = null; }
    return { type: 9 /* AnimateChild */, options: options };
}
/**
 * `useAnimation` is an animation-specific function that is designed to be used inside of Angular's
 * animation DSL language. It is used to kick off a reusable animation that is created using {\@link
 * animation animation()}.
 *
 * \@experimental Animation support is experimental.
 * @param {?} animation
 * @param {?=} options
 * @return {?}
 */
function useAnimation(animation, options) {
    if (options === void 0) { options = null; }
    return { type: 10 /* AnimateRef */, animation: animation, options: options };
}
/**
 * `query` is an animation-specific function that is designed to be used inside of Angular's
 * animation DSL language.
 *
 * query() is used to find one or more inner elements within the current element that is
 * being animated within the sequence. The provided animation steps are applied
 * to the queried element (by default, an array is provided, then this will be
 * treated as an animation sequence).
 *
 * ### Usage
 *
 * query() is designed to collect mutiple elements and works internally by using
 * `element.querySelectorAll`. An additional options object can be provided which
 * can be used to limit the total amount of items to be collected.
 *
 * ```js
 * query('div', [
 *   animate(...),
 *   animate(...)
 * ], { limit: 1 })
 * ```
 *
 * query(), by default, will throw an error when zero items are found. If a query
 * has the `optional` flag set to true then this error will be ignored.
 *
 * ```js
 * query('.some-element-that-may-not-be-there', [
 *   animate(...),
 *   animate(...)
 * ], { optional: true })
 * ```
 *
 * ### Special Selector Values
 *
 * The selector value within a query can collect elements that contain angular-specific
 * characteristics
 * using special pseudo-selectors tokens.
 *
 * These include:
 *
 *  - Querying for newly inserted/removed elements using `query(":enter")`/`query(":leave")`
 *  - Querying all currently animating elements using `query(":animating")`
 *  - Querying elements that contain an animation trigger using `query("\@triggerName")`
 *  - Querying all elements that contain an animation triggers using `query("\@*")`
 *  - Including the current element into the animation sequence using `query(":self")`
 *
 *
 *  Each of these pseudo-selector tokens can be merged together into a combined query selector
 * string:
 *
 *  ```
 *  query(':self, .record:enter, .record:leave, \@subTrigger', [...])
 *  ```
 *
 * ### Demo
 *
 * ```
 * \@Component({
 *   selector: 'inner',
 *   template: `
 *     <div [\@queryAnimation]="exp">
 *       <h1>Title</h1>
 *       <div class="content">
 *         Blah blah blah
 *       </div>
 *     </div>
 *   `,
 *   animations: [
 *    trigger('queryAnimation', [
 *      transition('* => goAnimate', [
 *        // hide the inner elements
 *        query('h1', style({ opacity: 0 })),
 *        query('.content', style({ opacity: 0 })),
 *
 *        // animate the inner elements in, one by one
 *        query('h1', animate(1000, style({ opacity: 1 })),
 *        query('.content', animate(1000, style({ opacity: 1 })),
 *      ])
 *    ])
 *  ]
 * })
 * class Cmp {
 *   exp = '';
 *
 *   goAnimate() {
 *     this.exp = 'goAnimate';
 *   }
 * }
 * ```
 *
 * \@experimental Animation support is experimental.
 * @param {?} selector
 * @param {?} animation
 * @param {?=} options
 * @return {?}
 */
function query(selector, animation, options) {
    if (options === void 0) { options = null; }
    return { type: 11 /* Query */, selector: selector, animation: animation, options: options };
}
/**
 * `stagger` is an animation-specific function that is designed to be used inside of Angular's
 * animation DSL language. It is designed to be used inside of an animation {\@link query query()}
 * and works by issuing a timing gap between after each queried item is animated.
 *
 * ### Usage
 *
 * In the example below there is a container element that wraps a list of items stamped out
 * by an ngFor. The container element contains an animation trigger that will later be set
 * to query for each of the inner items.
 *
 * ```html
 * <!-- list.component.html -->
 * <button (click)="toggle()">Show / Hide Items</button>
 * <hr />
 * <div [\@listAnimation]="items.length">
 *   <div *ngFor="let item of items">
 *     {{ item }}
 *   </div>
 * </div>
 * ```
 *
 * The component code for this looks as such:
 *
 * ```ts
 * import {trigger, transition, style, animate, query, stagger} from '\@angular/animations';
 * \@Component({
 *   templateUrl: 'list.component.html',
 *   animations: [
 *     trigger('listAnimation', [
 *        //...
 *     ])
 *   ]
 * })
 * class ListComponent {
 *   items = [];
 *
 *   showItems() {
 *     this.items = [0,1,2,3,4];
 *   }
 *
 *   hideItems() {
 *     this.items = [];
 *   }
 *
 *   toggle() {
 *     this.items.length ? this.hideItems() : this.showItems();
 *   }
 * }
 * ```
 *
 * And now for the animation trigger code:
 *
 * ```ts
 * trigger('listAnimation', [
 *   transition('* => *', [ // each time the binding value changes
 *     query(':leave', [
 *       stagger(100, [
 *         animate('0.5s', style({ opacity: 0 }))
 *       ])
 *     ]),
 *     query(':enter', [
 *       style({ opacity: 0 }),
 *       stagger(100, [
 *         animate('0.5s', style({ opacity: 1 }))
 *       ])
 *     ])
 *   ])
 * ])
 * ```
 *
 * Now each time the items are added/removed then either the opacity
 * fade-in animation will run or each removed item will be faded out.
 * When either of these animations occur then a stagger effect will be
 * applied after each item's animation is started.
 *
 * \@experimental Animation support is experimental.
 * @param {?} timings
 * @param {?} animation
 * @return {?}
 */
function stagger(timings, animation) {
    return { type: 12 /* Stagger */, timings: timings, animation: animation };
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 * @param {?} cb
 * @return {?}
 */
function scheduleMicroTask(cb) {
    Promise.resolve(null).then(cb);
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * \@experimental Animation support is experimental.
 */
var NoopAnimationPlayer = (function () {
    function NoopAnimationPlayer() {
        this._onDoneFns = [];
        this._onStartFns = [];
        this._onDestroyFns = [];
        this._started = false;
        this._destroyed = false;
        this._finished = false;
        this.parentPlayer = null;
        this.totalTime = 0;
    }
    /**
     * @return {?}
     */
    NoopAnimationPlayer.prototype._onFinish = function () {
        if (!this._finished) {
            this._finished = true;
            this._onDoneFns.forEach(function (fn) { return fn(); });
            this._onDoneFns = [];
        }
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    NoopAnimationPlayer.prototype.onStart = function (fn) { this._onStartFns.push(fn); };
    /**
     * @param {?} fn
     * @return {?}
     */
    NoopAnimationPlayer.prototype.onDone = function (fn) { this._onDoneFns.push(fn); };
    /**
     * @param {?} fn
     * @return {?}
     */
    NoopAnimationPlayer.prototype.onDestroy = function (fn) { this._onDestroyFns.push(fn); };
    /**
     * @return {?}
     */
    NoopAnimationPlayer.prototype.hasStarted = function () { return this._started; };
    /**
     * @return {?}
     */
    NoopAnimationPlayer.prototype.init = function () { };
    /**
     * @return {?}
     */
    NoopAnimationPlayer.prototype.play = function () {
        if (!this.hasStarted()) {
            this.triggerMicrotask();
            this._onStart();
        }
        this._started = true;
    };
    /**
     * @return {?}
     */
    NoopAnimationPlayer.prototype.triggerMicrotask = function () {
        var _this = this;
        scheduleMicroTask(function () { return _this._onFinish(); });
    };
    /**
     * @return {?}
     */
    NoopAnimationPlayer.prototype._onStart = function () {
        this._onStartFns.forEach(function (fn) { return fn(); });
        this._onStartFns = [];
    };
    /**
     * @return {?}
     */
    NoopAnimationPlayer.prototype.pause = function () { };
    /**
     * @return {?}
     */
    NoopAnimationPlayer.prototype.restart = function () { };
    /**
     * @return {?}
     */
    NoopAnimationPlayer.prototype.finish = function () { this._onFinish(); };
    /**
     * @return {?}
     */
    NoopAnimationPlayer.prototype.destroy = function () {
        if (!this._destroyed) {
            this._destroyed = true;
            if (!this.hasStarted()) {
                this._onStart();
            }
            this.finish();
            this._onDestroyFns.forEach(function (fn) { return fn(); });
            this._onDestroyFns = [];
        }
    };
    /**
     * @return {?}
     */
    NoopAnimationPlayer.prototype.reset = function () { };
    /**
     * @param {?} p
     * @return {?}
     */
    NoopAnimationPlayer.prototype.setPosition = function (p) { };
    /**
     * @return {?}
     */
    NoopAnimationPlayer.prototype.getPosition = function () { return 0; };
    return NoopAnimationPlayer;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var AnimationGroupPlayer = (function () {
    /**
     * @param {?} _players
     */
    function AnimationGroupPlayer(_players) {
        var _this = this;
        this._players = _players;
        this._onDoneFns = [];
        this._onStartFns = [];
        this._finished = false;
        this._started = false;
        this._destroyed = false;
        this._onDestroyFns = [];
        this.parentPlayer = null;
        this.totalTime = 0;
        var doneCount = 0;
        var destroyCount = 0;
        var startCount = 0;
        var total = this._players.length;
        if (total == 0) {
            scheduleMicroTask(function () { return _this._onFinish(); });
        }
        else {
            this._players.forEach(function (player) {
                player.parentPlayer = _this;
                player.onDone(function () {
                    if (++doneCount >= total) {
                        _this._onFinish();
                    }
                });
                player.onDestroy(function () {
                    if (++destroyCount >= total) {
                        _this._onDestroy();
                    }
                });
                player.onStart(function () {
                    if (++startCount >= total) {
                        _this._onStart();
                    }
                });
            });
        }
        this.totalTime = this._players.reduce(function (time, player) { return Math.max(time, player.totalTime); }, 0);
    }
    /**
     * @return {?}
     */
    AnimationGroupPlayer.prototype._onFinish = function () {
        if (!this._finished) {
            this._finished = true;
            this._onDoneFns.forEach(function (fn) { return fn(); });
            this._onDoneFns = [];
        }
    };
    /**
     * @return {?}
     */
    AnimationGroupPlayer.prototype.init = function () { this._players.forEach(function (player) { return player.init(); }); };
    /**
     * @param {?} fn
     * @return {?}
     */
    AnimationGroupPlayer.prototype.onStart = function (fn) { this._onStartFns.push(fn); };
    /**
     * @return {?}
     */
    AnimationGroupPlayer.prototype._onStart = function () {
        if (!this.hasStarted()) {
            this._onStartFns.forEach(function (fn) { return fn(); });
            this._onStartFns = [];
            this._started = true;
        }
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    AnimationGroupPlayer.prototype.onDone = function (fn) { this._onDoneFns.push(fn); };
    /**
     * @param {?} fn
     * @return {?}
     */
    AnimationGroupPlayer.prototype.onDestroy = function (fn) { this._onDestroyFns.push(fn); };
    /**
     * @return {?}
     */
    AnimationGroupPlayer.prototype.hasStarted = function () { return this._started; };
    /**
     * @return {?}
     */
    AnimationGroupPlayer.prototype.play = function () {
        if (!this.parentPlayer) {
            this.init();
        }
        this._onStart();
        this._players.forEach(function (player) { return player.play(); });
    };
    /**
     * @return {?}
     */
    AnimationGroupPlayer.prototype.pause = function () { this._players.forEach(function (player) { return player.pause(); }); };
    /**
     * @return {?}
     */
    AnimationGroupPlayer.prototype.restart = function () { this._players.forEach(function (player) { return player.restart(); }); };
    /**
     * @return {?}
     */
    AnimationGroupPlayer.prototype.finish = function () {
        this._onFinish();
        this._players.forEach(function (player) { return player.finish(); });
    };
    /**
     * @return {?}
     */
    AnimationGroupPlayer.prototype.destroy = function () { this._onDestroy(); };
    /**
     * @return {?}
     */
    AnimationGroupPlayer.prototype._onDestroy = function () {
        if (!this._destroyed) {
            this._destroyed = true;
            this._onFinish();
            this._players.forEach(function (player) { return player.destroy(); });
            this._onDestroyFns.forEach(function (fn) { return fn(); });
            this._onDestroyFns = [];
        }
    };
    /**
     * @return {?}
     */
    AnimationGroupPlayer.prototype.reset = function () {
        this._players.forEach(function (player) { return player.reset(); });
        this._destroyed = false;
        this._finished = false;
        this._started = false;
    };
    /**
     * @param {?} p
     * @return {?}
     */
    AnimationGroupPlayer.prototype.setPosition = function (p) {
        var /** @type {?} */ timeAtPosition = p * this.totalTime;
        this._players.forEach(function (player) {
            var /** @type {?} */ position = player.totalTime ? Math.min(1, timeAtPosition / player.totalTime) : 1;
            player.setPosition(position);
        });
    };
    /**
     * @return {?}
     */
    AnimationGroupPlayer.prototype.getPosition = function () {
        var /** @type {?} */ min = 0;
        this._players.forEach(function (player) {
            var /** @type {?} */ p = player.getPosition();
            min = Math.min(p, min);
        });
        return min;
    };
    Object.defineProperty(AnimationGroupPlayer.prototype, "players", {
        /**
         * @return {?}
         */
        get: function () { return this._players; },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    AnimationGroupPlayer.prototype.beforeDestroy = function () {
        this.players.forEach(function (player) {
            if (player.beforeDestroy) {
                player.beforeDestroy();
            }
        });
    };
    return AnimationGroupPlayer;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var ɵPRE_STYLE = '!';
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @module
 * @description
 * Entry point for all animation APIs of the animation package.
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @module
 * @description
 * Entry point for all public APIs of the animation package.
 */
/**
 * Generated bundle index. Do not edit.
 */

//# sourceMappingURL=animations.es5.js.map


/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AwsSignature; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_crypto_js__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_crypto_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_crypto_js__);

var AwsSignature = /** @class */ (function () {
    function AwsSignature() {
    }
    AwsSignature.prototype.signRequest = function (request, credentials, region, service, signDate) {
        var ws = this.initWorkingset(request, credentials, region, service, signDate);
        this.prepare(ws);
        this.buildCanonicalRequest(ws); // Step1: build the canonical request
        this.buildStringToSign(ws); // Step2: build the string to sign
        this.calculateSignature(ws); // Step3: calculate the signature hash
        this.buildSignatureHeader(ws); // Step4: build the authorization header
        return {
            'Authorization': ws.authorizationHeader,
            'x-amz-date': ws.request.headers['x-amz-date'],
            'x-amz-security-token': ws.config.credentials.sessionToken || undefined,
            'x-amz-content-sha256': this.hash(ws.request.data)
        };
    };
    ;
    AwsSignature.prototype.signRequestUsingQueryString = function (request, credentials, region, service, signDate) {
        var ws = this.initWorkingset(request, credentials, region, service, signDate);
        this.prepareForQueryString(ws);
        this.buildCanonicalRequest(ws); // Step1: build the canonical request
        this.buildStringToSign(ws); // Step2: build the string to sign
        this.calculateSignature(ws); // Step3: calculate the signature hash
        this.buildSignatureQueryString(ws); // Step4: build the authorization query string
        var requestUrl = null;
        if (request.url.indexOf('?') > -1) {
            requestUrl = request.url + '&' + ws.authorizationQueryString;
        }
        else {
            requestUrl = request.url + '?' + ws.authorizationQueryString;
        }
        if (ws.config.credentials.sessionToken) {
            requestUrl += '&X-Amz-Security-Token=' + encodeURIComponent(ws.config.credentials.sessionToken);
        }
        return requestUrl;
    };
    ;
    AwsSignature.prototype.initWorkingset = function (request, credentials, region, service, signDate) {
        var config = {
            region: region,
            service: service,
            credentials: credentials
        };
        var workingSet = new SignatureWorkingSet();
        workingSet.request = request;
        workingSet.config = config;
        workingSet.signDate = signDate || new Date(Date.now() + window['AWS'].config.systemClockOffset);
        workingSet.uri = this.parseUri(request.url);
        if (!workingSet.request.data) {
            workingSet.request.data = '';
        }
        workingSet.request.method = workingSet.request.method.toUpperCase();
        return workingSet;
    };
    AwsSignature.prototype.prepare = function (ws) {
        var headers = {
            'host': ws.uri.host,
            'x-amz-date': this.amzDate(ws.signDate)
        };
        if (ws.config.credentials.sessionToken) {
            headers['x-amz-security-token'] = ws.config.credentials.sessionToken;
        }
        headers['x-amz-content-sha256'] = this.hash(ws.request.data);
        // Headers
        ws.request.headers = AwsSignature.extend(headers, Object.keys(ws.request.headers || {}).reduce(function (normalized, key) {
            normalized[key.toLowerCase()] = ws.request.headers[key];
            return normalized;
        }, {}));
        ws.sortedHeaderKeys = Object.keys(ws.request.headers).sort();
    };
    AwsSignature.prototype.prepareForQueryString = function (ws) {
        var headers = {
            'host': ws.uri.host
        };
        ws.request.headers = headers;
        ws.sortedHeaderKeys = Object.keys(ws.request.headers).sort();
        ws.credentialScope = [this.amzDate(ws.signDate, true), ws.config.region, ws.config.service, 'aws4_request'].join('/');
        ws.uri.queryParams['X-Amz-Algorithm'] = 'AWS4-HMAC-SHA256';
        ws.uri.queryParams['X-Amz-Credential'] = ws.config.credentials.accessKeyId + '/' + ws.credentialScope;
        ws.uri.queryParams['X-Amz-Date'] = this.amzDate(ws.signDate);
        ws.uri.queryParams['X-Amz-SignedHeaders'] = 'host';
    };
    // Convert the request to a canonical format.
    AwsSignature.prototype.buildCanonicalRequest = function (ws) {
        ws.signedHeaders = ws.sortedHeaderKeys.map(function (key) {
            return key.toLowerCase();
        }).join(';');
        ws.canonicalRequest = String(ws.request.method).toUpperCase() + '\n' +
            // Canonical URI:
            this.uriEncode(ws.uri.path) + '\n' +
            // Canonical Query String:
            Object.keys(ws.uri.queryParams).sort().map(function (key) {
                return encodeURIComponent(key) + '=' +
                    encodeURIComponent(ws.uri.queryParams[key]);
            }).join('&') + '\n' +
            // Canonical Headers:
            ws.sortedHeaderKeys.map(function (key) {
                return key.toLocaleLowerCase() + ':' + ws.request.headers[key];
            }).join('\n') + '\n\n' +
            // Signed Headers:
            ws.signedHeaders + '\n' +
            // Hashed Payload
            this.hash(ws.request.data);
    };
    // Construct the string that will be signed.
    AwsSignature.prototype.buildStringToSign = function (ws) {
        if (!ws.credentialScope) {
            ws.credentialScope = [this.amzDate(ws.signDate, true), ws.config.region, ws.config.service, 'aws4_request'].join('/');
        }
        ws.stringToSign = 'AWS4-HMAC-SHA256' + '\n' +
            this.amzDate(ws.signDate) + '\n' +
            ws.credentialScope + '\n' +
            this.hash(ws.canonicalRequest);
    };
    // Calculate the signature
    AwsSignature.prototype.calculateSignature = function (ws) {
        var signKey = this.hmac(this.hmac(this.hmac(this.hmac('AWS4' + ws.config.credentials.secretAccessKey, this.amzDate(ws.signDate, true), { hexOutput: false }), ws.config.region, { hexOutput: false, textInput: false }), ws.config.service, { hexOutput: false, textInput: false }), 'aws4_request', { hexOutput: false, textInput: false });
        ws.signature = this.hmac(signKey, ws.stringToSign, { textInput: false });
    };
    // Build the signature HTTP header using the data in the working set.
    AwsSignature.prototype.buildSignatureHeader = function (ws) {
        ws.authorizationHeader = 'AWS4-HMAC-SHA256 ' +
            'Credential=' + ws.config.credentials.accessKeyId + '/' + ws.credentialScope + ',' +
            'SignedHeaders=' + ws.signedHeaders + ',' +
            'Signature=' + ws.signature;
    };
    // Build the signature query string using the data in the working set.
    AwsSignature.prototype.buildSignatureQueryString = function (ws) {
        ws.authorizationQueryString = 'X-Amz-Algorithm=AWS4-HMAC-SHA256';
        ws.authorizationQueryString += '&X-Amz-Credential=' + encodeURIComponent(ws.config.credentials.accessKeyId + '/' + ws.credentialScope);
        ws.authorizationQueryString += '&X-Amz-Date=' + this.amzDate(ws.signDate);
        ws.authorizationQueryString += '&X-Amz-SignedHeaders=host';
        ws.authorizationQueryString += '&X-Amz-Signature=' + ws.signature;
    };
    AwsSignature.prototype.parseUri = function (uri) {
        var parser;
        parser = document ? document.createElement('a') : {};
        parser.href = uri;
        var result = new Uri();
        result.protocol = parser.protocol;
        result.host = parser.host;
        var portIdx = result.host.indexOf(':');
        if (portIdx > 0) {
            result.host = result.host.substr(0, portIdx);
        }
        result.path = ((parser.pathname.charAt(0) !== '/') ? '/' : '') + parser.pathname;
        result.queryParams = this.extractQueryParams(parser.search);
        return result;
    };
    AwsSignature.prototype.extractQueryParams = function (search) {
        return /^\??(.*)$/.exec(search)[1].split('&')
            .reduce(function (result, arg) {
            arg = /^(.+)=(.*)$/.exec(arg);
            if (arg) {
                result[arg[1]] = arg[2];
            }
            return result;
        }, {});
    };
    AwsSignature.prototype.uriEncode = function (input) {
        var result = '';
        for (var i = 0; i < input.length; i++) {
            var ch = input.charAt(i);
            if ((ch >= 'A' && ch <= 'Z') || (ch >= 'a' && ch <= 'z') || (ch >= '0' && ch <= '9') || ch == '_' || ch == '-' || ch == '~' || ch == '.' || ch == '/') {
                result = result.concat(ch);
            }
            else {
                result = result.concat('%' + input.charCodeAt(i).toString(16).toUpperCase());
            }
        }
        return result;
    };
    AwsSignature.prototype.amzDate = function (date, short) {
        var result = date.toISOString().replace(/[:\-]|\.\d{3}/g, '').substr(0, 17);
        if (short) {
            return result.substr(0, 8);
        }
        return result;
    };
    /**
    * Hash the given input using SHA-256 algorithm.
    * The options can be used to control the in-/output of the hash operation.
    * @param {*} input Input data.
    * @param {object} options Options object:
    * `hexOutput` -- Output the hash with hex encoding (default: `true`).
    * `textInput` -- Interpret the input data as text (default: `true`).
    * @returns The generated hash
    */
    AwsSignature.prototype.hash = function (input, options) {
        options = AwsSignature.extend({ hexOutput: true, textInput: true }, options);
        var hash = __WEBPACK_IMPORTED_MODULE_0_crypto_js__["SHA256"](input);
        if (options.hexOutput) {
            return __WEBPACK_IMPORTED_MODULE_0_crypto_js__["enc"].Hex.stringify(hash);
        }
        return hash;
    };
    /**
     * Create the HMAC of the given input data with the given key using the SHA-256
     * hash algorithm.
     * The options can be used to control the in-/output of the hash operation.
     * @param {string} key Secret key.
     * @param {*} input Input data.
     * @param {object} options Options object:
     * `hexOutput` -- Output the hash with hex encoding (default: `true`).
     * `textInput` -- Interpret the input data as text (default: `true`).
     * @returns The generated HMAC.
     */
    AwsSignature.prototype.hmac = function (key, input, options) {
        options = AwsSignature.extend({ hexOutput: true, textInput: true }, options);
        var hmac = __WEBPACK_IMPORTED_MODULE_0_crypto_js__["HmacSHA256"](input, key, { asBytes: true });
        if (options.hexOutput) {
            return __WEBPACK_IMPORTED_MODULE_0_crypto_js__["enc"].Hex.stringify(hmac);
        }
        return hmac;
    };
    AwsSignature.extend = function (dest) {
        var objs = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            objs[_i - 1] = arguments[_i];
        }
        objs.forEach(function (obj) {
            if (!obj || typeof (obj) !== 'object') {
                return;
            }
            Object.keys(obj).forEach(function (key) {
                var src = obj[key];
                if (typeof (src) === 'undefined') {
                    return;
                }
                if (src !== null && typeof (src) === 'object') {
                    dest[key] = (Array.isArray(src) ? [] : {});
                    AwsSignature.extend(dest[key], src);
                }
                else {
                    dest[key] = src;
                }
            });
        });
        return dest;
    };
    return AwsSignature;
}());

var SignatureConfig = /** @class */ (function () {
    function SignatureConfig() {
    }
    return SignatureConfig;
}());
var SignatureWorkingSet = /** @class */ (function () {
    function SignatureWorkingSet() {
    }
    return SignatureWorkingSet;
}());
var Uri = /** @class */ (function () {
    function Uri() {
    }
    return Uri;
}());
//# sourceMappingURL=signature.js.map

/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BillingService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_http__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__aws_http__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__restapi_error_handler__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__user_user_service__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_observable_utils__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__billing__ = __webpack_require__(572);







var BillingQuery = /** @class */ (function () {
    function BillingQuery() {
    }
    return BillingQuery;
}());
var BillingService = /** @class */ (function () {
    function BillingService(http, errorHandler, observableUtils, userService) {
        this.http = http;
        this.errorHandler = errorHandler;
        this.observableUtils = observableUtils;
        this.userService = userService;
    }
    Object.defineProperty(BillingService.prototype, "baseUrl", {
        get: function () {
            return this.userService.getApiUrl() + "/billing";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BillingService.prototype, "query", {
        get: function () {
            var date = new Date();
            return {
                end_year: date.getFullYear().toString(),
                end_month: (date.getMonth() + 1).toString(),
                billingCycles: 12
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BillingService.prototype, "headers", {
        get: function () {
            return new __WEBPACK_IMPORTED_MODULE_0__angular_http__["l" /* Headers */]({
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            });
        },
        enumerable: true,
        configurable: true
    });
    BillingService.prototype.getStats = function (query) {
        var _this = this;
        return this.http
            .post(this.baseUrl + "/stats", JSON.stringify(query), { headers: this.headers })
            .map(function (response) { return new __WEBPACK_IMPORTED_MODULE_6__billing__["a" /* BillingInfo */](response.json()); })
            .catch(function (response) { return _this.errorHandler.throwError(response); });
    };
    BillingService.prototype.getCost = function (query) {
        var _this = this;
        return this.observableUtils.retry(function () { return _this.http
            .post(_this.baseUrl + "/cost", JSON.stringify(query), { headers: _this.headers })
            .map(function (response) { return response.json(); })
            .catch(function (response) { return _this.errorHandler.throwError(response); }); }, 3);
    };
    BillingService.prototype.padStart = function (s, length, padding) {
        while (s.length < length) {
            s = padding + s;
        }
        return s;
    };
    BillingService.prototype.getCycles = function () {
        var _this = this;
        var query = this.query;
        return __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"].forkJoin(this.getStats(query), this.getCost(query)).map(function (_a) {
            var cycles = _a[0], invoices = _a[1];
            invoices.forEach(function (invoice) {
                var _a = invoice.creationDate.split('-'), year = _a[0], month = _a[1], day = _a[2];
                var billingYear = Number(year);
                var billingMonth = Number(month);
                // if the bill month is january
                // then go back to december and decrement the year
                /*if (billingMonth === 0) {
                    billingYear -= 1;
                    billingMonth = 12;
                }*/
                invoice.invoiceForDate = _this.padStart(billingYear.toString(), 2, '0') + "-" + _this.padStart(billingMonth.toString(), 2, '0') + "-" + day;
            });
            cycles.updateCyclesWithCostInfo(invoices);
            cycles.orderDescending();
            cycles.removePast2MonthsSansInvoice();
            return cycles;
        });
    };
    BillingService.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_2__aws_http__["a" /* AwsHttp */] }, { type: __WEBPACK_IMPORTED_MODULE_3__restapi_error_handler__["a" /* ErrorHandler */] }, { type: __WEBPACK_IMPORTED_MODULE_5__util_observable_utils__["a" /* ObservableUtils */] }, { type: __WEBPACK_IMPORTED_MODULE_4__user_user_service__["a" /* UserService */] }]; };
    return BillingService;
}());

//# sourceMappingURL=billing.service.js.map

/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProgressbarComponent; });
var ProgressbarComponent = /** @class */ (function () {
    function ProgressbarComponent() {
        this.progressValue = '0';
        this.progressText = '';
        this.showOnRight = true;
    }
    // interval:any;
    ProgressbarComponent.prototype.resetProgress = function () {
        this.progressValue = '0';
        this.progressText = '';
        this.showOnRight = true;
    };
    ProgressbarComponent.prototype.updateProgress = function (value, text) {
        if (value > 50) {
            this.showOnRight = false;
        }
        else {
            this.showOnRight = true;
        }
        if (value <= 100) {
            this.progressValue = String(value);
        }
        else {
            this.progressValue = String(100);
        }
        this.progressText = text;
    };
    ProgressbarComponent.prototype.ngOnInit = function () {
        /*this.interval = setInterval(() => {
            var progNum = +this.progressValue;
            this.progressValue = String(progNum + 1);
            this.progressText = this.progressValue;
        }, 1000 );*/
    };
    return ProgressbarComponent;
}());

//# sourceMappingURL=progressbar.component.js.map

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TOSEntry; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__licensing_licensing_modal_component__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__licensing_modal_licensing_args__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__licensing_tos__ = __webpack_require__(183);




var TOSEntry = /** @class */ (function () {
    function TOSEntry(componentFactoryResolver) {
        this.componentFactoryResolver = componentFactoryResolver;
        this.childComponent = this.componentFactoryResolver.resolveComponentFactory(__WEBPACK_IMPORTED_MODULE_1__licensing_licensing_modal_component__["a" /* LicensingModal */]);
        this.label = 'Terms of Service';
    }
    TOSEntry.prototype.activate = function (viewContainerRef) {
        var _this = this;
        if (!this.childComponent) {
            this.childComponent = this.componentFactoryResolver.resolveComponentFactory(__WEBPACK_IMPORTED_MODULE_1__licensing_licensing_modal_component__["a" /* LicensingModal */]);
        }
        if (!this.compRef || viewContainerRef.indexOf(this.compRef.hostView) === -1) {
            this.compRef = viewContainerRef.createComponent(this.childComponent, 0);
        }
        setTimeout(function () {
            _this.compRef.instance.preview = true;
            _this.compRef.instance.okText = 'Ok';
            _this.compRef.instance.showDialog(new __WEBPACK_IMPORTED_MODULE_2__licensing_modal_licensing_args__["a" /* ModalLicensingArgs */](__WEBPACK_IMPORTED_MODULE_3__licensing_tos__["a" /* tos */], 'Terms Of Service', __WEBPACK_IMPORTED_MODULE_3__licensing_tos__["b" /* tosPath */], __WEBPACK_IMPORTED_MODULE_3__licensing_tos__["c" /* tosName */])).subscribe(function (value) {
            });
        }, 10);
    };
    TOSEntry.prototype.clean = function () {
        this.childComponent = null;
        this.compRef = null;
    };
    TOSEntry.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ComponentFactoryResolver"] }]; };
    return TOSEntry;
}());

//# sourceMappingURL=tos-entry.js.map

/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LicensingModal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Subject__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Subject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs_Subject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__licensing_tos__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modals_confirmation_modal__ = __webpack_require__(590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__user_user_service__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modal_licensing_args__ = __webpack_require__(182);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var LicensingModal = /** @class */ (function (_super) {
    __extends(LicensingModal, _super);
    function LicensingModal(UserService) {
        var _this = _super.call(this) || this;
        _this.UserService = UserService;
        _this.okText = 'Agree';
        _this.preview = false;
        _this.downloadPath = null;
        _this.args = new __WEBPACK_IMPORTED_MODULE_4__modal_licensing_args__["a" /* ModalLicensingArgs */](__WEBPACK_IMPORTED_MODULE_1__licensing_tos__["a" /* tos */], 'TOS', __WEBPACK_IMPORTED_MODULE_1__licensing_tos__["b" /* tosPath */], __WEBPACK_IMPORTED_MODULE_1__licensing_tos__["c" /* tosName */]);
        return _this;
    }
    LicensingModal.prototype.onActivate = function (args) {
        this.subject = new __WEBPACK_IMPORTED_MODULE_0_rxjs_Subject__["Subject"]();
        this.args = args;
        this.downloadPath = args.DocumentPath;
        return this.subject;
    };
    LicensingModal.prototype.onOkEvent = function (e) {
        this.subject.next(true);
        this.subject.complete();
    };
    LicensingModal.prototype.isDataValid = function () {
        return true;
    };
    LicensingModal.prototype.onClose = function () { };
    LicensingModal.prototype.showDialog = function (args) {
        var result = this.onActivate(args);
        this.initialize();
        return result;
    };
    LicensingModal.prototype.onCancelEvent = function (e) {
        /* don't bother to send on next again, we will log out the user
        just close the subject*/
        e.preventDefault();
        this.closeDialog();
        this.subject.next(false);
        this.subject.complete();
        this.UserService.logOut();
    };
    LicensingModal.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_3__user_user_service__["a" /* UserService */] }]; };
    return LicensingModal;
}(__WEBPACK_IMPORTED_MODULE_2__modals_confirmation_modal__["a" /* ConfirmationBaseModal */]));

//# sourceMappingURL=licensing-modal.component.js.map

/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LicensingComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_router__ = __webpack_require__(16);

var LicensingComponent = /** @class */ (function () {
    function LicensingComponent(router) {
        this.router = router;
    }
    LicensingComponent.prototype.ngOnInit = function () {
        switch (this.router.url) {
            case '/tos':
                window.location.href = '/licensing/tos.txt';
                break;
            case '/eula':
                window.location.href = '/licensing/eula.txt';
                break;
        }
    };
    LicensingComponent.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_router__["a" /* Router */] }]; };
    return LicensingComponent;
}());

//# sourceMappingURL=licensing.component.js.map

/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ModalLicensingArgs; });
var ModalLicensingArgs = /** @class */ (function () {
    function ModalLicensingArgs(message, title, documentPath, documentName) {
        this.Message = message;
        this.Title = title;
        this.DocumentPath = documentPath;
        this.DocumentName = documentName;
    }
    return ModalLicensingArgs;
}());

//# sourceMappingURL=modal-licensing-args.js.map

/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return tosPath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return tosName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return tos; });
var tosPath = __webpack_require__(1095);
var tosName = 'TOS';
var tos = "\nISG SAAS TERMS OF SERVICE\n1.\tACCEPTANCE OF TERMS \nThese ISG SaaS Terms of Service (\u201CTerms\u201D) are a legal agreement between Keysight Technologies, Inc., a Delaware corporation (\u201CKeysight\u201D) and you (\u201CLicensee\u201D). These Terms govern Licensee\u2019s use of https://store.ixiacom.com/(\u201CWebsite\u201D) and the purchase, access, and use of Ixia Solution Group (\u201CISG\u201D) branded software-as-a-service(s) (\u201CSaaS\u201D), including BreakingPoint Cloud, CloudLens, and Hawkeye Express, that Keysight makes available for Licensee\u2019s use through a network connection (\u201CService\u201D).  \nBY ACCESSING OR USING ANY PART OF THE WEBSITE OR SERVICE, INCLUDING, WITHOUT LIMITATION, LINKING TO THE WEBSITE, LICENSEE AGREES THAT LICENSEE HAS READ, UNDERSTANDS AND AGREES TO BE BOUND BY THESE TERMS. IF THERE ARE ADDITIONAL POSTED GUIDELINES OR POLICIES APPLICABLE TO THE WEBSITE OR SERVICE (INCLUDING, WITHOUT LIMITATION, THE PRIVACY POLICY AND APPLICABLE SERVICE SUPPORTING DOCUMENTATION), LICENSEE IS REQUIRED TO FOLLOW THOSE AS WELL. THOSE POLICIES AND GUIDELINES ARE INCORPORATED BY REFERENCE INTO THESE TERMS. ANY CHANGES, ADDITIONS, OR DELETIONS THAT LICENSEE MAKES TO THESE TERMS ARE NOT ACCEPTABLE, AND KEYSIGHT MAY REFUSE ACCESS TO THE WEBSITE OR SERVICE FOR NONCOMPLIANCE WITH ANY PART OF THESE TERMS. \n2.\tSERVICE\n(a)\tSoftware. In order to use the Service, Licensee may need to download and install the Service software (\u201CSoftware\u201D). If Licensee downloads Software, Licensee will need to accept the applicable end user license agreement (found at www.keysight.com/view/eula) (\u201CEULA\u201D) for the Software (the terms and conditions of such EULA are incorporated herein by reference). Licensee will need dedicated access to the Internet and Licensee will need to set up, at no cost to Licensee, a valid Keysight subscription user account (\u201CAccount\u201D). Licensee is responsible for providing and maintaining all necessary equipment and Internet service (at Licensee\u2019s sole cost) to use the Service and the Account. The quality and speed of Licensee\u2019s hardware and Internet connection will affect Licensee\u2019s use of the Service and Licensee\u2019s Account. \n(b)\tService Description. The Service replicates network traffic and provides Licensee with the ability to analyze or simulate such traffic for performance and security purposes in both physical and cloud environments. In furtherance thereof, the Service may collect data about the system on which it is running and the current system and network utilization (including, without limitation, CPU type, amount of RAM, operating system, Linux kernels, Amazon Web Services tags, CPU utilization, RAM utilization, and network utilization). By using the Service, Licensee consents to Keysight collecting, transmitting, and processing such data (whether or not such data may be construed as personally identifiable information or personal data). Licensee may opt-out of such collection, transmittal or processing by not using the Service.  \n3.\tUSE OF WEBSITE AND SERVICE\n(a)\tPrivacy. Licensee agrees to the terms of Keysight\u2019s Privacy Statement (www.keysight.com/go/privacy), which is incorporated by reference into these Terms.\n(b)\tRegistration Data. Licensee must provide accurate, current, and complete information required to create an Account (including, without limitation, a name, address and valid unique email address), as well as at other points as may be required in the course of accessing the Website or using the Service (\u201CRegistration Data\u201D). Further, Licensee shall maintain and update Licensee\u2019s Registration Data as required to keep it accurate, current, and complete. Keysight may terminate Licensee\u2019s rights to any part of or all of the Service if any information Licensee provides is false, inaccurate or incomplete. Licensee agrees that Keysight may store and use the Registration Data Licensee provides for use in maintaining Licensee\u2019s Account and in billing fees.\n(c)\tUser Account and Security. Licensee is solely responsible for maintaining the confidentiality and security of its Account. Licensee should not reveal its Account information to anyone else or use anyone else\u2019s Account. Licensee is entirely responsible for all activities that occur on or through its Account, and Licensee agrees to immediately notify Keysight of any unauthorized use of Licensee\u2019s Account or any other breach of security. Keysight shall not be responsible for any losses arising out of the unauthorized use of Licensee\u2019s Account. Licensee also agrees not to access the Service by any means other than through the Software or Website. Licensee shall not access or attempt to access an Account that Licensee is not authorized to access. Violations of system or network security may result in civil and/or criminal liability.\n(d)\tGeneral Compliance with Laws. Licensee agrees to comply with all local, state, federal, and national laws, statutes, ordinances, and regulations that may apply to Licensee\u2019s use of the Website and Service. Without limiting the generality of the foregoing, Licensee agrees that any user of the Website or Service through the Account will be aged 13 years or older.\n\t\n(e)\tEnforcement of these Terms. Keysight reserves the right to take any steps or course of action it believes are reasonably necessary or appropriate to enforce and/or verify compliance with any part of these Terms (including, but not limited to, Keysight\u2019s right to cooperate with any legal process relating to Licensee\u2019s use of the Website and/or Service, and/or a third party claim that Licensee\u2019s use of the Website and/or Service is unlawful and/or infringes such third party\u2019s rights). Licensee agrees that Keysight has the right, without liability to Licensee, to disclose any Registration Data and/or Account information to law enforcement authorities, government officials, and/or a third party, as Keysight believes is reasonably necessary or appropriate to enforce and/or verify compliance with any part of these Terms (including, but not limited to, Keysight\u2019s right to cooperate with any legal process relating to Licensee\u2019s use of the Website or Service, and/or a third party claim that Licensee\u2019s use of the Website or Service is unlawful and/or infringes such third party\u2019s rights).\n(f)\tRestrictions. Licensee may not cause harm to the Website, Service or other users thereof. Specifically, but not by way of limitation, Licensee may not: (a) interfere with the Website or Service by using viruses or any other programs or technology designed to disrupt or damage any software or hardware; (b) modify, create derivative works from, reverse engineer, decompile or disassemble any technology used to provide the Website, Service or Software; (c) rent, lease, loan, sell or distribute works based on the Website, Service or Software; (d) interfere with, or disrupt the access of any user, host or network, including, without limitation, sending a virus, overloading, flooding, spamming; (e) use a robot, spider or other device or process to monitor the activity on or copy pages from the Website, except in the operation or use of an internet \u201Csearch engine\u201D, hit counters or similar technology; (f) impersonate another person or entity; (g) engage in any activity that interferes with another user\u2019s ability to use or enjoy the Website or Service; (h) provide links to the Website other than links to the Website home page; or (i) assist or encourage any third-party in engaging in any activity prohibited by these Terms.\n4.\tFEES AND PAYMENT\n(a) Fees. Fees for the Service will be based on the pricing published on the Website as of the subscription or purchase date, unless otherwise set forth in a written quote. Fees set forth in a written quote are valid for period indicated on the quotation. \n(b) Payment. LICENSEE IS RESPONSIBLE FOR THE TIMELY PAYMENT OF ALL FEES FOR THE SERVICE. All fees will be billed to the address Licensee designates on Licensee\u2019s Account. If Licensee wants to designate a different address, Licensee must change the same by logging into Licensee\u2019s Account and updating Licensee\u2019s Account information. Fees are subject to change at time of any renewal. Depending on Licensee\u2019s Service subscription, Keysight may bill Licensee: (i) in advance; (ii) at the time of purchase; (iii) shortly after purchase; or (iv) on a recurring time- or usage-based basis. Any amount not paid when due will bear the lower of the interest rate of 1.5% per month or maximum rate permitted by applicable law.\n(c) Prepaid Credit.  Keysight may sell to Licensee one or more credits (each, a \u201CKeyCoin\u201D) that Licensee may use to pay for Licensee\u2019s subsequent use of one or more features or aspects of the Service that are identified by Keysight from time to time (each, an \u201CApproved Feature\u201D). Each KeyCoin will be valid for one calendar year from the date of purchase (the \u201CLifetime\u201D), and will expire and be forfeited with no refund or return of funds due to Licensee if such KeyCoin is not used to prepay for an Approved Feature prior to the end of the last day of that period. (As an example only, if a KeyCoin is purchased on October 1, 2017, that KeyCoin will expire and be forfeited if not used to prepay for an Approved Feature prior to the end of the day on October 1, 2018.) Keysight shall provide to Licensee a summary of any unexpired KeyCoin(s) following Licensee\u2019s written request for such summary. However, Keysight shall have no obligation to provide Licensee any notice or warning regarding any anticipated expiration of a KeyCoin, and failure to receive any such notice shall not operate to bar a KeyCoin from expiring. KeyCoins may only be used by the Licensee and are not transferable or sublicensable. KeyCoins may not be used for the benefit of any third party or to pay for an Approved Feature that will be used by a third party. Keysight may immediately cancel and refuse to honor any KeyCoin if Licensee transfers or attempts to transfer such KeyCoin, or if Licensee uses or attempts to use such KeyCoin in violation of these Terms of Service. In the event of any such cancellation, Keysight shall have no obligation to refund to Licensee any amounts paid for the corresponding KeyCoin(s). All KeyCoins are non-refundable once purchased, and shall have no cash value once purchased. No applicable tax is charged for the purchase of KeyCoins; however, Licensee will be responsible for applicable taxes on the purchase and use of the Approved Feature and/or Service. \n(d) Electronic Signatures and Contracts. Licensee\u2019s use of the Service includes the ability to enter into agreements and/or to complete transactions electronically. LICENSEE ACKNOWLEDGES THAT ITS ELECTRONIC SUBMISSIONS CONSTITUTE ITS AGREEMENT AND INTENT TO BE BOUND BY AND TO PAY FOR SUCH AGREEMENTS AND TRANSACTIONS. \n(e) Taxes. Prices are exclusive of any applicable sales, value added, or similar taxes imposed by any government authority (collectively, \u201CTaxes\u201D). Licensee shall be responsible for payment of all Taxes (including any interest or penalties), if any, levied on or deducted from any amounts payable to Keysight pursuant to these Terms. Licensee shall provide necessary documents to evidence that payments made under these Terms qualify for the benefit of a reduced rate of withholding tax under an applicable tax treaty.\n5.\tINTELLECTUAL PROPERTY \n(a)\tOwnership. The Website and Service contain proprietary information and material that is owned by Keysight and/or its affiliates, licensors and suppliers (as applicable), and is protected by applicable intellectual property and other laws, including, but not limited to, copyright laws, and therefore Licensee shall not use such proprietary information or materials in any way whatsoever except for use of the Service in compliance with the provisions of these Terms and use of the Software in compliance with the EULA. No portion or content of the Website or Service may be reproduced in any form or by any means, except as expressly permitted hereunder. Licensee shall not attempt to register any copyrights, register any trademarks or service marks, or apply for any patent or other intellectual property protection for the Website, Service, or any portion thereof.\n(b)\tRemoval of Content. Notwithstanding any other provision of these Terms, Keysight and its licensors reserve the right to change, suspend, remove, or disable access to any content or materials comprising a part of the Website or Service at any time without notice. In no event shall Keysight be liable for such change, suspension, removal or disabling. Keysight may also impose limits on the use of or access to certain features or portions of the Website or Service, in any case and without notice or liability.\n(c)\tTrademarks. Names, logos, designs, look and feel, titles, words and phrases used on the Website or Software are owned by Keysight or its licensors or other entities. Licensee is granted no right or license with respect to any of the aforesaid.\n(d)\tReservation of Rights. Except for the rights expressly granted to Licensee in these Terms and in the EULA, all intellectual property and other rights, title and interest in the Website, Service and Software are reserved and retained by Keysight and/or its affiliates, licensors and suppliers (as applicable). Licensee does not acquire any ownership interest or ownership rights whatsoever in the Website, Service or Software as a result of accessing, downloading, installing and/or using them.\n(e)\tFeedback. All feedback, comments, suggestions, ideas, and other submissions that Licensee discloses, submits or offers to Keysight in connection with Licensee\u2019s use of the Website or Service, including, without limitation, all data generated through the use of the Service (collectively, \u201CFeedback\u201D) will become Keysight\u2019s exclusive property. Such disclosure, submission or offer of any Feedback shall constitute an assignment to Keysight of all worldwide right, title and interest in all intellectual property and other rights whatsoever in and to the Feedback and a waiver of any claim based on moral rights, unfair competition, breach of implied contract, breach of confidentiality, and any other legal theory relating to Feedback. Keysight is not and will not be under any obligation: (i) to maintain any Feedback in confidence; (ii) to pay to Licensee or any third party any compensation for any Feedback; or (iii) to respond to any Feedback. Licensee is and shall remain solely responsible for the content of any Feedback Licensee makes.\n6.\tTERM AND TERMINATION  \n(a) Term. These Terms shall be effective from the date when Keysight accepts Licensee\u2019s order for the Service or upon Licensee\u2019s use of the Service and, unless terminated pursuant to this Section 6, shall continue for the period specified in Licensee\u2019s order or so long as Licensee timely pays fees due for Licensee\u2019s use of the Service. \n(b)\tTermination by Keysight. If Licensee fails, or Keysight suspects that Licensee has failed, to comply with any of the provisions of these Terms, including, but not limited to, failure to make payment of fees due, failure to provide Keysight with accurate and complete Registration Data, failure to safeguard Licensee\u2019s Account information, violation of the any usage rules included or referenced in these Terms, or infringement or other violation of a third party\u2019s rights, Keysight, at its sole discretion, without notice to Licensee may: (a) terminate these Terms and/or Licensee\u2019s Account, in which event Licensee will remain liable for all amounts due under its Account up to and including the date of termination; and/or (b) terminate the EULA; and/or (c) preclude access to the Service (or any part thereof).\n(c)\tEffect of Termination. If these Terms are terminated, Keysight may, in its sole discretion, delete any web sites, files, graphics or other content or materials relating to Licensee\u2019s use of the Services on Keysight\u2019s servers or otherwise in Keysight\u2019s possession and Keysight will have no liability to Licensee or any third party for doing so or for failing to do so. Following termination, Licensee will not be permitted to use the Service. If Licensee\u2019s Account or Licensee\u2019s access to the Service is terminated, Keysight reserves the right to exercise whatever means Keysight deems necessary to prevent unauthorized access to the Service, including, but not limited to, technological barriers, IP mapping and direct contact with Licensee\u2019s Internet Service Provider. If these Terms are terminated, Licensee must immediately pay Keysight any fees owed. Regardless of whether Licensee has the right to access or use the Website or the Service, the provisions of these Terms, except any license grants given to Licensee, will survive indefinitely.\n(d)\tThird Party Sites. The Website may contain links to third-party websites, advertisers, or services that are not owned or controlled by Keysight. Licensee acknowledges that Keysight has no control over, assumes no responsibility for, and does not recommend or endorse, the content, privacy policies, or practices of any third-party websites or services. If Licensee accesses a third-party website from the Website, Licensee does so at its own risk, and Licensee understands that these Terms do not apply to Licensee\u2019s use of such websites. Licensee expressly releases Keysight from any and all liability arising from Licensee\u2019s use of any third-party website or services or third-party owned content.\n7.\tDISCLAIMER; LIMITATION OF LIABILITY\n(a)\tKEYSIGHT DOES NOT GUARANTEE, REPRESENT, OR WARRANT THAT LICENSEE\u2019S USE OF THE WEBSITE OR SERVICE WILL BE UNINTERRUPTED OR ERROR-FREE, AND LICENSEE AGREES THAT FROM TIME TO TIME KEYSIGHT MAY SUSPEND, LIMIT, OR REMOVE THE WEBSITE OR SERVICE FOR INDEFINITE PERIODS OF TIME, OR CANCEL THE SERVICE AT ANY TIME, WITHOUT NOTICE TO LICENSEE. FURTHER, KEYSIGHT MAKES NO REPRESENTATION OR WARRANTY TO LICENSEE THAT: (A) THE WEBSITE OR SERVICE WILL MEET LICENSEE\u2019S NEEDS OR REQUIREMENTS; (B) THE WEBSITE OR SERVICE WILL BE SECURE; (C) THE QUALITY OF THE WEBSITE OR SERVICE WILL MEET LICENSEE\u2019S EXPECTATIONS; OR (D) THE WEBSITE, SERVICE OR SOFTWARE WILL BE COMPATIBLE WITH LICENSEE\u2019S COMPUTER SYSTEM.\n(b)\tTO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, AND EXCEPT AS EXPRESSLY SET FORTH HEREIN, (i) THE WEBSITE AND THE SERVICE ARE PROVIDED \u201CAS IS\u201D, (ii) LICENSEE\u2019S USE OF, OR INABILITY TO USE, THE WEBSITE AND/OR SERVICE IS AT LICENSEE\u2019S SOLE RISK, AND (iii) KEYSIGHT AND ITS SUPPLIERS, DISTRIBUTORS AND LICENSORS DO NOT MAKE AND SPECIFICALLY DISCLAIM, ALL EXPRESS AND IMPLIED WARRANTIES OF EVERY KIND RELATING TO THE WEBSITE AND SERVICE AND/OR THEIR USE (INCLUDING, WITHOUT LIMITATION,  ACTUAL AND IMPLIED WARRANTIES OF MERCHANTABILITY, TITLE, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT), AS WELL AS ANY WARRANTIES THAT THE WEBSITE OR SERVICE (OR ANY ELEMENTS THEREOF) WILL ACHIEVE A PARTICULAR RESULT, OR WILL BE UNINTERRUPTED OR ERROR-FREE.\n(c)\tTO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, IN NO EVENT SHALL KEYSIGHT, ITS SUPPLIERS, DISTRIBUTORS OR LICENSORS BE LIABLE UNDER ANY THEORY OF LIABILITY FOR ANY CONSEQUENTIAL, INDIRECT, INCIDENTAL, SPECIAL, PUNITIVE, OR EXEMPLARY DAMAGES OF ANY KIND (INCLUDING, WITHOUT LIMITATION, DAMAGES ARISING FROM LOSS OF PROFITS, REVENUE, DATA, OR USE, OR FROM INTERRUPTED COMMUNICATIONS OR DAMAGED DATA, OR FROM ANY DEFECT OR ERROR, OR IN CONNECTION WITH LICENSEE\u2019S ACQUISITION OF SUBSTITUTE GOODS OR SERVICES OR MALFUNCTION OF THE WEBSITE, SOFTWARE OR SERVICE, OR ANY SUCH DAMAGES ARISING FROM BREACH OF CONTRACT OR WARRANTY OR FROM NEGLIGENCE OR STRICT LIABILITY) IN CONNECTION WITH THESE TERMS, THE WEBSITE, SERVICE, SOFTWARE, AND/OR ANY USE OF ANY OF THE FOREGOING EVEN IF KEYSIGHT OR ANY OF ITS SUPPLIERS, DISTRIBUTORS OR LICENSORS OR ANY OTHER PERSON HAS BEEN ADVISED OR SHOULD KNOW OF THE POSSIBILITY OF SUCH DAMAGES, AND NOTWITHSTANDING THE FAILURE OF ANY REMEDY TO ACHIEVE ITS INTENDED PURPOSE. FURTHER, IN NO EVENT SHALL KEYSIGHT\u2019S MAXIMUM, AGGREGATE LIABILITY IN CONNECTION WITH THESE TERMS, THE WEBSITE, SERVICE, SOFTWARE, AND/OR ANY USE OF ANY OF THE FOREGOING EXCEED THE TOTAL AMOUNT ACTUALLY PAID BY LICENSEE FOR THE SERVICE IN THE IMMEDIATELY PRECEDING 12 MONTHS.\n(d)\tKEYSIGHT WILL USE REASONABLE AND APPROPRIATE EFFORTS TO PROTECT INFORMATION SUBMITTED BY LICENSEE IN CONNECTION WITH THE SERVICE, BUT LICENSEE ACKNOWLEDGES AND AGREES THAT ITS SUBMISSION OF SUCH INFORMATION IS AT ITS SOLE RISK, AND KEYSIGHT HEREBY DISCLAIMS ANY AND ALL LIABILITY TO LICENSEE FOR ANY LOSS OR LIABILITY RELATING TO SUCH INFORMATION IN ANY WAY.\n(e)\tKEYSIGHT DOES NOT REPRESENT OR GUARANTEE THAT THE WEBSITE OR SERVICE WILL BE FREE FROM LOSS, CORRUPTION, ATTACK, VIRUSES, INTERFERENCE, HACKING, OR OTHER SECURITY INTRUSION, AND KEYSIGHT DISCLAIMS ANY AND ALL LIABILITY RELATING THERETO. LICENSEE SHALL BE RESPONSIBLE FOR BACKING UP ITS OWN COMPUTER SYSTEM.\n8.\tINDEMNITY\nLicensee hereby agrees to indemnify, protect, defend, and hold Keysight and its suppliers, licensors and distributors and its and their directors, officers, employees, professional advisors, agents and representatives, harmless from and against any and all claims, losses, and damages, including, without limitation, reasonable attorneys\u2019 and experts\u2019 fees and disbursements (collectively \u201CClaims\u201D), arising out of, resulting from or relating to (a) Licensee\u2019s failure to perform any of the covenants, agreements, terms, provisions, or conditions contained in these Terms or (b) Licensee\u2019s use or misuse of the Website or Service. If Licensee is required to indemnify any party under this Section, Licensee will have the right to control the defense, settlement, and resolution of the Claim at Licensee\u2019s sole expense. However, Licensee may not settle or otherwise resolve any Claim without Keysight\u2019s express written permission.\n9.\tCLAIMS LIMITATION\nTo the maximum extent permitted by law, Licensee expressly, knowingly and voluntarily agrees that any and all lawsuits, causes of action and/or claims against Keysight and/or its affiliates shall be forever waived, barred and released unless properly brought and filed in a court of competent jurisdiction within one (1) year from the date upon which said lawsuit, cause of action or claim accrued.\n11. MISCELLANEOUS\n(a)\tModifications. Keysight reserves the right, at any time and from time to time, to update, revise, change, supplement, and otherwise modify these Terms and to impose new or additional rules, policies, terms, and/or conditions on Licensee\u2019s use of the Website or Service. Such updates, revisions, supplements, modifications, and additional rules, policies, terms, and conditions (collectively referred to in these Terms as \u201CAdditional Terms\u201D) will be effective immediately upon their publication on the Website and are incorporated into these Terms. Licensee\u2019s continued use of the Service or access of the Website after such publication shall be deemed to constitute Licensee\u2019s acceptance of any and all such Additional Terms. All Additional Terms are hereby incorporated into these Terms by this reference. Further, Keysight reserves the right, at any time and from time to time, to change, alter, update, replace, expand, limit, terminate or otherwise modify the Website or Service without notice or liability to Licensee.\n(b)\tNotices. Keysight may send Licensee notice with respect to the Service or Licensee\u2019s Account by sending an e-mail message to the e-mail address listed on Licensee\u2019s Account as part of Licensee\u2019s contact information, by sending a letter via postal mail to the contact address listed on Licensee\u2019s Account, or by a posting on the Website. All such notices shall become effective immediately.\n(c)\tHow to Contact Keysight. If Licensee needs to contact Keysight with respect to the Website, Service or these Terms, Licensee must refer to the technical support and contact information posted on the Website.  \n(d)\tGoverning Law and Jurisdiction. These Terms and Licensee\u2019s use of the Website and Service shall be governed by the laws of the State of California, without reference to conflicts of laws principles. Licensee\u2019s use of the Website and Service may also be subject to other local, state, national, or international laws. \n(e)\tIntegration. These Terms (including, without limitation, the documents referenced herein) constitute the entire and integrated agreement between Licensee and Keysight with respect to Licensee\u2019s use of the Website and Service and the subject matter hereof, and these Terms supersede and replace any and all prior and contemporaneous agreements between Licensee and Keysight with respect to the Website and Service and said subject matter. \n(f)\tSeverability. If any part of these Terms is held invalid or unenforceable by a court of competent jurisdiction, that portion shall be construed in a manner consistent with applicable law to reflect, as nearly as possible, the original intentions of the parties, and the remaining portions shall remain in full force and effect. \n(g)\tWaiver. Keysight\u2019s failure to enforce any right, remedy or provisions in these Terms shall not constitute a waiver of such provision, or any other provision of these Terms. Keysight shall not be responsible for failures to fulfill any obligations due to causes beyond its control.\n";
//# sourceMappingURL=tos.js.map

/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ConfigComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_service__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__user_user_service__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__trial_trial_service__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__systeminformation_systeminformation_service__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modals_modal_service__ = __webpack_require__(69);





var ConfigComponent = /** @class */ (function () {
    function ConfigComponent(cfgService, userService, trialService, systemInformationService, modalService) {
        this.cfgService = cfgService;
        this.userService = userService;
        this.trialService = trialService;
        this.systemInformationService = systemInformationService;
        this.modalService = modalService;
        this.showCostControlAlert = false;
        this.consume = 0;
        this.threshold = 0;
        this.trialMode = false;
        this.trialModeExpired = false;
        this.showDevDurations = true;
        this.percentComplete = 0;
        this.timeRemaining = '';
        this.status = '';
    }
    ConfigComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.systemInformationService.getSystemInformation().subscribe(function (information) {
            if (information['ShowDevDurations'] != null) {
                _this.showDevDurations = information['ShowDevDurations'];
            }
        });
        this.trialStatusSubscription = this.trialService.trialStatusChanged
            .subscribe(function (response) {
            if (response.trialMode) {
                _this.trialMode = response.trialMode;
                _this.trialModeExpired = response.trialModeExpired;
                _this.trialData = response.trialData;
            }
            else {
                _this.trialMode = response.trialMode;
                _this.consume = response.consume;
                _this.threshold = response.threshold;
            }
        });
        this.thresholdExceededSub = this.trialService.thresholdExceeded
            .subscribe(function (value) {
            _this.showCostControlAlert = value;
        });
        this.currentAttackSubscription = this.cfgService.currentAttackSubject
            .subscribe(function (attack) {
            if (attack) {
                var runningTime = attack && attack.StartDate && (((attack.StopDate ? Date.parse(attack.StopDate) : new Date().getTime()) - Date.parse(attack.StartDate)) / 1000);
                _this.percentComplete = Math.floor((runningTime / attack.AttackParams.Duration) * 100);
                if (runningTime) {
                    _this.timeRemaining = _this.cfgService.convertSecondsToHHMMSS(attack.AttackParams.Duration - runningTime);
                    _this.progressBar.updateProgress(_this.percentComplete, _this.timeRemaining + ' ' + _this.determineStatusString(attack.Status, attack.AttackParams.Duration - runningTime));
                }
                else {
                    _this.progressBar.updateProgress(0, '00:00:00');
                }
                if (attack.Status === 'Stopped') {
                    _this.progressBar.updateProgress(0, '');
                }
                /*if(!this.trialMode && attack.Status === 'Failed' && attack.FailReason.startsWith('Running the test would exceed')){
                        this.showCostControlAlert = true;
                }*/
            }
            else {
                _this.progressBar.updateProgress(0, '');
                _this.percentComplete = 0;
            }
        });
    };
    ConfigComponent.prototype.determineStatusString = function (status, timeRemaining) {
        var rtnValue = '';
        switch (status) {
            case 'Started':
                rtnValue = 'REMAINING';
                break;
            case 'Stopping':
                rtnValue = '(STOPPING)';
                break;
            case 'Stopped':
                if (+timeRemaining > 0) {
                    rtnValue = '(STOPPED)';
                }
                else {
                    rtnValue = '(COMPLETED)';
                }
                break;
            default:
                rtnValue = '';
                break;
        }
        return rtnValue;
    };
    ConfigComponent.prototype.btnOKCostControl = function () {
        var _this = this;
        this.modalService.showLoadingModal('Updating threshold...', false, false);
        this.trialService.updateAccount(this.userService.getCurrentUser().Email)
            .subscribe(function (result) {
            _this.modalService.showLoadingModal(result.message, false, false);
            //Get latest value
            _this.trialService.getAccountStatus(_this.userService.getCurrentUser().Email);
            //All this message to show for 2 seconds
            setTimeout(function () {
                _this.modalService.hideLoadingModal();
            }, 2000);
            _this.showCostControlAlert = false;
        }, function (error) {
            _this.modalService.hideLoadingModal();
        });
    };
    ConfigComponent.prototype.buyNowClick = function () {
        if (this.showDevDurations) {
            window.location.href = 'https://store-uat.ixiacom.com/product/BreakingPoint-Cloud';
        }
        else {
            window.location.href = 'https://www.ixiacom.com/products/breakingpoint-cloud';
        }
    };
    ConfigComponent.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_0__config_service__["a" /* ConfigService */] }, { type: __WEBPACK_IMPORTED_MODULE_1__user_user_service__["a" /* UserService */] }, { type: __WEBPACK_IMPORTED_MODULE_2__trial_trial_service__["a" /* TrialService */] }, { type: __WEBPACK_IMPORTED_MODULE_3__systeminformation_systeminformation_service__["a" /* SystemInformationService */] }, { type: __WEBPACK_IMPORTED_MODULE_4__modals_modal_service__["a" /* ModalService */] }]; };
    return ConfigComponent;
}());

//# sourceMappingURL=config.component.js.map

/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DashboardComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__publisher_publisher_service__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modals_modal_error_args__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modals_modal_service__ = __webpack_require__(69);



var DashboardComponent = /** @class */ (function () {
    function DashboardComponent(publisherService, modalService) {
        var _this = this;
        this.publisherService = publisherService;
        this.modalService = modalService;
        this.modalSubscription = this.modalService.modalChanged
            .subscribe(function (change) {
            if (change.showLoading === true) {
                _this.showLoadingProgress(change.value, change.showStopTest, change.showOkButton);
            }
            if (change.showLoading === false) {
                _this.hideLoadingProgress();
            }
        });
    }
    DashboardComponent.prototype.ngOnInit = function () {
    };
    DashboardComponent.prototype.showLoadingProgress = function (value, showButton, showOkButton) {
        if (!this.loadingModal.isOn) {
            this.loadingModal.showDialog(value);
            this.loadingModal.setShowStopTest(showButton);
            this.loadingModal.setShowOkButton(showOkButton);
        }
        else {
            this.loadingModal.updateDialog(value);
            this.loadingModal.setShowStopTest(showButton);
            this.loadingModal.setShowOkButton(showOkButton);
        }
    };
    DashboardComponent.prototype.hideLoadingProgress = function () {
        this.loadingModal.closeDialog();
    };
    DashboardComponent.prototype.showErrorModal = function () {
        this.errorModal.showDialog(new __WEBPACK_IMPORTED_MODULE_1__modals_modal_error_args__["a" /* ModalErrorArgs */]('error', 'Cannot Update Tool'));
    };
    DashboardComponent.prototype.hideErrorModal = function () {
        this.errorModal.closeDialog();
    };
    DashboardComponent.prototype.onButtonPush = function () {
    };
    DashboardComponent.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_0__publisher_publisher_service__["a" /* PublisherService */] }, { type: __WEBPACK_IMPORTED_MODULE_2__modals_modal_service__["a" /* ModalService */] }]; };
    return DashboardComponent;
}());

//# sourceMappingURL=dashboard.component.js.map

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HistoryComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__attack_attack_service__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_router__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_config_service__ = __webpack_require__(34);



var HistoryComponent = /** @class */ (function () {
    function HistoryComponent(attackService, router, cfgService) {
        this.attackService = attackService;
        this.router = router;
        this.cfgService = cfgService;
        this.gridMessage = 'Loading...';
        // temp: any = [];
        this.flag = false;
        this.columns = [];
        this.availableAttackProfiles = [];
        this.canStartAttack = false;
        this.needsAttackSelection = true;
        this.runButtonEnabled = false;
        //  this.temp = this.rows;
        this.rows = [];
    }
    /*updateFilter(event:any) {
        const val = event.target.value.toLowerCase();

        // filter our data
        const temp = this.temp.filter(function(d: any) {
            return d.name.toLowerCase().indexOf(val) !== -1 || !val;
        });

        // update the rows
        this.rows = temp;
        // Whenever the filter changes, always go back to the first page
        this.historyTable.offset = 0;
    }*/
    HistoryComponent.prototype.ngOnInit = function () {
        var _this = this;
        var me = this;
        this.selected = [];
        this.cfgService.availableAttackProfilesSubject
            .subscribe(function (profiles) {
            _this.availableAttackProfiles = profiles;
        });
        this.columns = [
            { prop: 'Name', name: 'DDoS Profile', resizeable: false, flexGrow: 3 },
            { prop: 'AttackParams.TargetIpAddress', name: 'Target IP:Port', minwidth: 150, cellTemplate: this.ipTmpl, resizeable: false, flexGrow: 3 },
            { prop: 'Status', name: 'Status', minwidth: 130, resizeable: false, cellTemplate: this.statusTmpl, flexGrow: 2 },
            { prop: 'StartDateToDisplay', name: 'Start Time', minwidth: 185, resizeable: false, flexGrow: 3 },
            { prop: 'runtime', name: 'Run Time', minwidth: 150, resizeable: false, cellTemplate: this.timeTmpl, flexGrow: 2 },
            { prop: 'Metrics.TxData', name: 'Outbound Data (MB)', minwidth: 190, resizeable: false, cellTemplate: this.MBTmpl, flexGrow: 3.7 },
            { prop: 'Metrics.TxFrameRate', name: 'Frames Per Second', minwidth: 180, resizeable: false, cellTemplate: this.numTmpl, flexGrow: 3.5 },
            { prop: 'Metrics.TxFrames', name: 'Frames Sent', minwidth: 175, resizeable: false, cellTemplate: this.numTmpl, flexGrow: 3 },
            { prop: 'ID', name: ' ', width: 30, resizeable: false, cellTemplate: this.supportTmpl, cellClass: 'icon-row', flexGrow: 0.7 }
        ];
        /*this.currentAttackSubscription = this.attackService.currentAttack.subscribe(attack => {
            this.currentAttack = attack;
            this.canStartAttack = !attack || ['Stopped', 'Failed', 'Unknown'].indexOf(attack.Status) >= 0;

            if(this.canStartAttack && this.selected.length > 0){
                this.enableRunButton(true);
            }else{
                this.enableRunButton(false);
            }

        });*/
        this.currentAttackSubscription = this.cfgService.currentAttackSubject.subscribe(function (attack) {
            _this.currentAttack = attack;
            _this.canStartAttack = !attack || ['Stopped', 'Failed', 'Unknown'].indexOf(attack.Status) >= 0;
            if (_this.canStartAttack && _this.selected.length > 0) {
                _this.enableRunButton(true);
            }
            else {
                _this.enableRunButton(false);
            }
        });
        this.cfgService.historySubject
            .subscribe(function (attacks) {
            //Even if it's empty, it will send an empty array with length 15 if it's coming from backend
            if (attacks.length > 0) {
                me.flag = true;
            }
            attacks = attacks.filter(function (attack) {
                return me.findWithAttr(me.availableAttackProfiles, 'Name', attack.AttackParams.AttackProfile) !== -1;
            });
            attacks.map(function (attack) {
                var profile = _this.availableAttackProfiles[_this.findWithAttr(_this.availableAttackProfiles, 'Name', attack.AttackParams.AttackProfile)];
                if (profile) {
                    attack['Name'] = profile.Label;
                }
                var timeDiff = attack && attack.StartDate && (((attack.StopDate ? Date.parse(attack.StopDate) : new Date().getTime()) - Date.parse(attack.StartDate)) / 1000);
                if (timeDiff) {
                    attack['runtime'] = timeDiff;
                }
                var formatDateTime = _this.cfgService.formatDateTime(attack.StartDate);
                if (formatDateTime) {
                    // attack['StartDate'] = formatDateTime;
                    attack['StartDateToDisplay'] = formatDateTime;
                }
            });
            me.rows = attacks.slice();
            // The first time it comes through it will always be an empty array
            if (!me.rows || me.rows.length === 0 && me.flag === true) {
                _this.gridMessage = 'No data to display';
            }
            else {
                me.flag = true;
            }
        });
    };
    HistoryComponent.prototype.findWithAttr = function (array, attr, value) {
        for (var i = 0; i < array.length; i += 1) {
            if (array[i][attr] === value) {
                return i;
            }
        }
        return -1;
    };
    HistoryComponent.prototype.enableRunButton = function (value) {
        var me = this;
        if (this.selected.length > 0) {
            this.needsAttackSelection = false;
        }
        else {
            this.needsAttackSelection = true;
        }
        this.runButtonEnabled = value;
    };
    HistoryComponent.prototype.onSelectHistory = function (s) {
        this.canStartAttack = !this.currentAttack || ['Stopped', 'Failed', 'Unknown'].indexOf(this.currentAttack.Status) >= 0;
        if (this.canStartAttack && this.selected.length > 0) {
            this.enableRunButton(true);
        }
        else {
            this.enableRunButton(false);
        }
    };
    HistoryComponent.prototype.runAgain = function () {
        //console.log(this.selected[0].AttackParams);
        if (this.canStartAttack) {
            this.cfgService.currentAttackSubject.next(this.selected[0]);
            this.router.navigate(['']);
        }
    };
    HistoryComponent.prototype.showSupportModal = function (value) {
        this.supportModal.showDialog(value);
    };
    HistoryComponent.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_0__attack_attack_service__["a" /* AttackService */] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_router__["a" /* Router */] }, { type: __WEBPACK_IMPORTED_MODULE_2__config_config_service__["a" /* ConfigService */] }]; };
    return HistoryComponent;
}());

//# sourceMappingURL=history.component.js.map

/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AdminConsentDialogArgs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AdminConsentDialog; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modals_modal_base__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_common__ = __webpack_require__(4);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var AdminConsentDialogArgs = /** @class */ (function () {
    function AdminConsentDialogArgs() {
    }
    return AdminConsentDialogArgs;
}());

var AdminConsentDialog = /** @class */ (function (_super) {
    __extends(AdminConsentDialog, _super);
    function AdminConsentDialog(location) {
        var _this = _super.call(this) || this;
        _this.location = location;
        _this.adminConsentUrl = '';
        _this.valueCopied = false;
        return _this;
    }
    AdminConsentDialog.prototype.onActivate = function (args) {
        this.args = args;
        this.adminConsentUrl = args.URL;
    };
    AdminConsentDialog.prototype.onCloseClicked = function (e) {
        e.preventDefault();
        this.closeDialog();
    };
    AdminConsentDialog.prototype.onClose = function () { };
    AdminConsentDialog.prototype.highlightAfterCopy = function (event) {
        var _this = this;
        this.valueCopied = !this.valueCopied;
        setTimeout(function () {
            _this.valueCopied = false;
        }, 100);
    };
    AdminConsentDialog.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_common__["Location"] }]; };
    return AdminConsentDialog;
}(__WEBPACK_IMPORTED_MODULE_0__modals_modal_base__["a" /* BaseModal */]));

//# sourceMappingURL=admin-consent-dialog.component.js.map

/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TargetValidationDialogArgs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TargetValidationDialog; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modals_modal_base__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__target_validation_service__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_common__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__admin_consent_dialog_component__ = __webpack_require__(187);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var TargetValidationDialogArgs = /** @class */ (function () {
    function TargetValidationDialogArgs() {
    }
    return TargetValidationDialogArgs;
}());

var TargetValidationDialog = /** @class */ (function (_super) {
    __extends(TargetValidationDialog, _super);
    function TargetValidationDialog(service, location) {
        var _this = _super.call(this) || this;
        _this.service = service;
        _this.location = location;
        _this.subscriptions = [];
        service.registerDialog(_this);
        return _this;
    }
    TargetValidationDialog.prototype.onActivate = function (args) {
        this.args = args;
        this.lastAuthzError = args.LastAuthzErrorCode;
        this.subscriptions = [];
        this.updateSubscriptions();
    };
    TargetValidationDialog.prototype.onCloseClicked = function (e) {
        e.preventDefault();
        this.closeDialog();
    };
    TargetValidationDialog.prototype.onClose = function () {
        this.location.go(this.service.getCleanUrl());
    };
    TargetValidationDialog.prototype.onAddSubscription = function () {
        var _this = this;
        this.addOperationInProgress = true;
        this.service.addSubscription(this.subscriptionId)
            .do(function (subscription) {
            subscription['btnDisable'] = true;
            subscription['pending'] = true;
            _this.subscriptions.push(subscription);
            setTimeout(function () {
                subscription['btnDisable'] = false;
            }, 4000);
        })
            .switchMap(function (subscription) { return _this.service.authorizeSubscription(subscription, window.location.href, false); })
            .subscribe({
            next: function (authorizationUrl) { return window.location.assign(authorizationUrl); },
            error: function (error) {
                console.error(error);
                _this.addOperationInProgress = false;
            }
        });
    };
    TargetValidationDialog.prototype.onRemoveSubscription = function (subscription) {
        var _this = this;
        this.service.removeSubscription(subscription).subscribe({
            next: function (subscription) {
                var index = _this.subscriptions.indexOf(subscription);
                if (index >= 0) {
                    _this.subscriptions.splice(index, 1);
                }
            },
            error: function (error) { return console.error(error); }
        });
    };
    TargetValidationDialog.prototype.onReauthorize = function (subscription) {
        this.service
            .authorizeSubscription(subscription, window.location.href, false)
            .subscribe({
            next: function (authorizationUrl) { return window.location.assign(authorizationUrl); },
            error: function (error) { return console.error(error); }
        });
    };
    TargetValidationDialog.prototype.onGetAdminConsentUrl = function (subscription) {
        var me = this;
        this.service
            .authorizeSubscription(subscription, window.location.href, true)
            .subscribe({
            next: function (authorizationUrl) {
                return me.showAdminConsentDialog(authorizationUrl);
            },
            error: function (error) { return console.error(error); }
        });
    };
    TargetValidationDialog.prototype.updateSubscriptions = function () {
        var _this = this;
        this.service.getSubscriptions()
            .subscribe(function (subscriptions) {
            _this.subscriptions = subscriptions;
        });
    };
    TargetValidationDialog.prototype.showAdminConsentDialog = function (adminConsentUrl) {
        var args = new __WEBPACK_IMPORTED_MODULE_3__admin_consent_dialog_component__["a" /* AdminConsentDialogArgs */]();
        args.URL = adminConsentUrl;
        this.adminConsentDialog.showDialog(args);
    };
    TargetValidationDialog.prototype.hideAdminConsentDialog = function () {
        this.adminConsentDialog.closeDialog();
    };
    TargetValidationDialog.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_1__target_validation_service__["a" /* TargetValidationService */] }, { type: __WEBPACK_IMPORTED_MODULE_2__angular_common__["Location"] }]; };
    return TargetValidationDialog;
}(__WEBPACK_IMPORTED_MODULE_0__modals_modal_base__["a" /* BaseModal */]));

//# sourceMappingURL=target-validation-dialog.component.js.map

/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LoadingModal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modals_modal_base__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modals_modal_service__ = __webpack_require__(69);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var LoadingModal = /** @class */ (function (_super) {
    __extends(LoadingModal, _super);
    function LoadingModal(modalService) {
        var _this = _super.call(this) || this;
        _this.modalService = modalService;
        _this.showStopTest = true;
        _this.showOkButton = false;
        _this.message = '';
        return _this;
    }
    LoadingModal.prototype.onActivate = function (message) {
        if (message !== 'Stopped') {
            this.progressBoxComponent.initProgress();
        }
        this.message = message;
    };
    LoadingModal.prototype.updateDialog = function (message) {
        this.message = message;
    };
    LoadingModal.prototype.onClose = function () {
        this.progressBoxComponent.stopProgress();
    };
    LoadingModal.prototype.onStopTest = function () {
        this.modalService.stopTest();
    };
    LoadingModal.prototype.onOkClick = function () {
        this.modalService.okClicked();
        this.closeDialog();
    };
    LoadingModal.prototype.setShowStopTest = function (value) {
        this.showStopTest = value;
    };
    LoadingModal.prototype.setShowOkButton = function (value) {
        this.showOkButton = value;
        if (value) {
            this.progressBoxComponent.stopProgress();
            this.progressBoxComponent.stopProgress();
        }
    };
    LoadingModal.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_1__modals_modal_service__["a" /* ModalService */] }]; };
    return LoadingModal;
}(__WEBPACK_IMPORTED_MODULE_0__modals_modal_base__["a" /* BaseModal */]));

//# sourceMappingURL=modal-loading.component.js.map

/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export LIGHT_BLUE */
/* unused harmony export BLUE */
/* unused harmony export BRIGHT_BLUE */
/* unused harmony export WHITE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProgressBoxComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__uimodels_color__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__marker__ = __webpack_require__(596);


var LIGHT_BLUE = new __WEBPACK_IMPORTED_MODULE_0__uimodels_color__["a" /* Color */](161, 211, 245);
var BLUE = new __WEBPACK_IMPORTED_MODULE_0__uimodels_color__["a" /* Color */](90, 178, 237);
var BRIGHT_BLUE = new __WEBPACK_IMPORTED_MODULE_0__uimodels_color__["a" /* Color */](20, 146, 230);
var WHITE = new __WEBPACK_IMPORTED_MODULE_0__uimodels_color__["a" /* Color */](255, 255, 255);
var ProgressBoxComponent = /** @class */ (function () {
    function ProgressBoxComponent() {
        this.markers = [];
    }
    ProgressBoxComponent.prototype.initProgress = function () {
        var _this = this;
        this.markers = [];
        var marker = new __WEBPACK_IMPORTED_MODULE_1__marker__["a" /* ProgressMarker */]();
        marker.color = LIGHT_BLUE;
        this.markers.push(marker);
        marker = new __WEBPACK_IMPORTED_MODULE_1__marker__["a" /* ProgressMarker */]();
        marker.color = BLUE;
        this.markers.push(marker);
        marker = new __WEBPACK_IMPORTED_MODULE_1__marker__["a" /* ProgressMarker */]();
        marker.color = BRIGHT_BLUE;
        this.markers.push(marker);
        marker = new __WEBPACK_IMPORTED_MODULE_1__marker__["a" /* ProgressMarker */]();
        marker.color = WHITE;
        this.markers.push(marker);
        marker = new __WEBPACK_IMPORTED_MODULE_1__marker__["a" /* ProgressMarker */]();
        marker.color = WHITE;
        this.markers.push(marker);
        this.changeColorsTimer = setInterval(function () {
            _this.rotateColors();
        }, 500);
    };
    ProgressBoxComponent.prototype.ngOnInit = function () {
        this.initProgress();
    };
    ProgressBoxComponent.prototype.stopProgress = function () {
        clearInterval(this.changeColorsTimer);
    };
    ProgressBoxComponent.prototype.getColor = function (marker) {
        return "rgb(" + marker.color.R + ", " + marker.color.G + ", " + marker.color.B + ")";
    };
    ProgressBoxComponent.prototype.rotateColors = function () {
        var firstWhiteAfterBlue = false;
        var blueSet = false;
        for (var _i = 0, _a = this.markers; _i < _a.length; _i++) {
            var marker = _a[_i];
            if (marker.color === LIGHT_BLUE) {
                marker.color = WHITE;
                continue;
            }
            if (marker.color === BLUE) {
                marker.color = LIGHT_BLUE;
                blueSet = true;
                continue;
            }
            if (marker.color === BRIGHT_BLUE) {
                marker.color = BLUE;
                firstWhiteAfterBlue = true;
                blueSet = true;
                continue;
            }
            if (marker.color === WHITE && firstWhiteAfterBlue) {
                marker.color = BRIGHT_BLUE;
                blueSet = true;
                firstWhiteAfterBlue = false;
                continue;
            }
        }
        if (!blueSet) {
            this.markers[0].color = BRIGHT_BLUE;
        }
    };
    return ProgressBoxComponent;
}());

//# sourceMappingURL=progress-box.component.js.map

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(2);
var utils_1 = __webpack_require__(78);
var types_1 = __webpack_require__(96);
var DataTableBodyCellComponent = (function () {
    function DataTableBodyCellComponent(element) {
        this.activate = new core_1.EventEmitter();
        this.isFocused = false;
        this.onCheckboxChangeFn = this.onCheckboxChange.bind(this);
        this.activateFn = this.activate.emit.bind(this.activate);
        this.element = element.nativeElement;
    }
    Object.defineProperty(DataTableBodyCellComponent.prototype, "sorts", {
        get: function () {
            return this._sorts;
        },
        set: function (val) {
            this._sorts = val;
            this.calcSortDir = this.calcSortDir(val);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTableBodyCellComponent.prototype, "columnCssClasses", {
        get: function () {
            var cls = 'datatable-body-cell';
            if (this.column.cellClass) {
                if (typeof this.column.cellClass === 'string') {
                    cls += ' ' + this.column.cellClass;
                }
                else if (typeof this.column.cellClass === 'function') {
                    var res = this.column.cellClass({
                        row: this.row,
                        column: this.column,
                        value: this.value
                    });
                    if (typeof res === 'string') {
                        cls += res;
                    }
                    else if (typeof res === 'object') {
                        var keys = Object.keys(res);
                        for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
                            var k = keys_1[_i];
                            if (res[k] === true)
                                cls += " " + k;
                        }
                    }
                }
            }
            if (!this.sortDir)
                cls += ' sort-active';
            if (this.isFocused)
                cls += ' active';
            if (this.sortDir === types_1.SortDirection.asc)
                cls += ' sort-asc';
            if (this.sortDir === types_1.SortDirection.desc)
                cls += ' sort-desc';
            return cls;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTableBodyCellComponent.prototype, "width", {
        get: function () {
            return this.column.width;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTableBodyCellComponent.prototype, "height", {
        get: function () {
            var height = this.rowHeight;
            if (isNaN(height))
                return height;
            return height + 'px';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTableBodyCellComponent.prototype, "value", {
        get: function () {
            if (!this.row || !this.column)
                return '';
            var val = this.column.$$valueGetter(this.row, this.column.prop);
            var userPipe = this.column.pipe;
            if (userPipe)
                return userPipe.transform(val);
            if (val !== undefined)
                return val;
            return '';
        },
        enumerable: true,
        configurable: true
    });
    DataTableBodyCellComponent.prototype.ngOnDestroy = function () {
        if (this.cellTemplate) {
            this.cellTemplate.clear();
        }
    };
    DataTableBodyCellComponent.prototype.onFocus = function () {
        this.isFocused = true;
    };
    DataTableBodyCellComponent.prototype.onBlur = function () {
        this.isFocused = false;
    };
    DataTableBodyCellComponent.prototype.onClick = function (event) {
        this.activate.emit({
            type: 'click',
            event: event,
            row: this.row,
            column: this.column,
            value: this.value,
            cellElement: this.element
        });
    };
    DataTableBodyCellComponent.prototype.onDblClick = function (event) {
        this.activate.emit({
            type: 'dblclick',
            event: event,
            row: this.row,
            column: this.column,
            value: this.value,
            cellElement: this.element
        });
    };
    DataTableBodyCellComponent.prototype.onKeyDown = function (event) {
        var keyCode = event.keyCode;
        var isTargetCell = event.target === this.element;
        var isAction = keyCode === utils_1.Keys.return ||
            keyCode === utils_1.Keys.down ||
            keyCode === utils_1.Keys.up ||
            keyCode === utils_1.Keys.left ||
            keyCode === utils_1.Keys.right;
        if (isAction && isTargetCell) {
            event.preventDefault();
            event.stopPropagation();
            this.activate.emit({
                type: 'keydown',
                event: event,
                row: this.row,
                column: this.column,
                value: this.value,
                cellElement: this.element
            });
        }
    };
    DataTableBodyCellComponent.prototype.onCheckboxChange = function (event) {
        this.activate.emit({
            type: 'checkbox',
            event: event,
            row: this.row,
            column: this.column,
            value: this.value,
            cellElement: this.element
        });
    };
    DataTableBodyCellComponent.prototype.calcSortDir = function (sorts) {
        var _this = this;
        if (!sorts)
            return;
        var sort = sorts.find(function (s) {
            return s.prop === _this.column.prop;
        });
        if (sort)
            return sort.dir;
    };
    return DataTableBodyCellComponent;
}());
DataTableBodyCellComponent.decorators = [
    { type: core_1.Component, args: [{
                selector: 'datatable-body-cell',
                template: "\n    <div class=\"datatable-body-cell-label\">\n      <label\n        *ngIf=\"column.checkboxable\" \n        class=\"datatable-checkbox\">\n        <input \n          type=\"checkbox\"\n          [checked]=\"isSelected\"\n          (click)=\"onCheckboxChange($event)\" \n        />\n      </label>\n      <span\n        *ngIf=\"!column.cellTemplate\"\n        [title]=\"value\"\n        [innerHTML]=\"value\">\n      </span>\n      <ng-template #cellTemplate\n        *ngIf=\"column.cellTemplate\"\n        [ngTemplateOutlet]=\"column.cellTemplate\"\n        [ngOutletContext]=\"{\n          value: value,\n          row: row,\n          column: column,\n          isSelected: isSelected,\n          onCheckboxChangeFn: onCheckboxChangeFn,\n          activateFn: activateFn\n        }\">\n      </ng-template>\n    </div>\n  ",
                host: {
                    class: 'datatable-body-cell'
                }
            },] },
];
/** @nocollapse */
DataTableBodyCellComponent.ctorParameters = function () { return [
    { type: core_1.ElementRef, },
]; };
DataTableBodyCellComponent.propDecorators = {
    'row': [{ type: core_1.Input },],
    'column': [{ type: core_1.Input },],
    'rowHeight': [{ type: core_1.Input },],
    'isSelected': [{ type: core_1.Input },],
    'sorts': [{ type: core_1.Input },],
    'activate': [{ type: core_1.Output },],
    'cellTemplate': [{ type: core_1.ViewChild, args: ['cellTemplate', { read: core_1.ViewContainerRef },] },],
    'columnCssClasses': [{ type: core_1.HostBinding, args: ['class',] },],
    'width': [{ type: core_1.HostBinding, args: ['style.width.px',] },],
    'height': [{ type: core_1.HostBinding, args: ['style.height',] },],
    'onFocus': [{ type: core_1.HostListener, args: ['focus',] },],
    'onBlur': [{ type: core_1.HostListener, args: ['blur',] },],
    'onClick': [{ type: core_1.HostListener, args: ['click', ['$event'],] },],
    'onDblClick': [{ type: core_1.HostListener, args: ['dblclick', ['$event'],] },],
    'onKeyDown': [{ type: core_1.HostListener, args: ['keydown', ['$event'],] },],
};
exports.DataTableBodyCellComponent = DataTableBodyCellComponent;
//# sourceMappingURL=body-cell.component.js.map

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(2);
var DataTableRowWrapperComponent = (function () {
    function DataTableRowWrapperComponent() {
        this.expanded = false;
        this.rowContextmenu = new core_1.EventEmitter(false);
    }
    DataTableRowWrapperComponent.prototype.onContextmenu = function ($event) {
        this.rowContextmenu.emit({ event: $event, row: this.row });
    };
    return DataTableRowWrapperComponent;
}());
DataTableRowWrapperComponent.decorators = [
    { type: core_1.Component, args: [{
                selector: 'datatable-row-wrapper',
                template: "\n    <ng-content></ng-content>\n    <div \n      *ngIf=\"expanded\"\n      [style.height.px]=\"detailRowHeight\" \n      class=\"datatable-row-detail\">\n      <ng-template\n        *ngIf=\"rowDetail && rowDetail.template\"\n        [ngTemplateOutlet]=\"rowDetail.template\"\n        [ngOutletContext]=\"{ row: row }\">\n      </ng-template>\n    </div>\n  ",
                host: {
                    class: 'datatable-row-wrapper'
                }
            },] },
];
/** @nocollapse */
DataTableRowWrapperComponent.ctorParameters = function () { return []; };
DataTableRowWrapperComponent.propDecorators = {
    'rowDetail': [{ type: core_1.Input },],
    'detailRowHeight': [{ type: core_1.Input },],
    'expanded': [{ type: core_1.Input },],
    'row': [{ type: core_1.Input },],
    'rowContextmenu': [{ type: core_1.Output },],
    'onContextmenu': [{ type: core_1.HostListener, args: ['contextmenu', ['$event'],] },],
};
exports.DataTableRowWrapperComponent = DataTableRowWrapperComponent;
//# sourceMappingURL=body-row-wrapper.component.js.map

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(2);
var utils_1 = __webpack_require__(78);
var services_1 = __webpack_require__(203);
var DataTableBodyRowComponent = (function () {
    function DataTableBodyRowComponent(scrollbarHelper, element) {
        this.scrollbarHelper = scrollbarHelper;
        this.activate = new core_1.EventEmitter();
        this.element = element.nativeElement;
    }
    Object.defineProperty(DataTableBodyRowComponent.prototype, "columns", {
        get: function () {
            return this._columns;
        },
        set: function (val) {
            this._columns = val;
            this.recalculateColumns(val);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTableBodyRowComponent.prototype, "innerWidth", {
        get: function () {
            return this._innerWidth;
        },
        set: function (val) {
            this._innerWidth = val;
            this.recalculateColumns();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTableBodyRowComponent.prototype, "cssClass", {
        get: function () {
            var cls = 'datatable-body-row';
            if (this.isSelected)
                cls += ' active';
            if (this.row.$$index % 2 !== 0)
                cls += ' datatable-row-odd';
            if (this.row.$$index % 2 === 0)
                cls += ' datatable-row-even';
            if (this.rowClass) {
                var res = this.rowClass(this.row);
                if (typeof res === 'string') {
                    cls += " " + res;
                }
                else if (typeof res === 'object') {
                    var keys = Object.keys(res);
                    for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
                        var k = keys_1[_i];
                        if (res[k] === true)
                            cls += " " + k;
                    }
                }
            }
            return cls;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTableBodyRowComponent.prototype, "columnsTotalWidths", {
        get: function () {
            return this.columnGroupWidths.total;
        },
        enumerable: true,
        configurable: true
    });
    DataTableBodyRowComponent.prototype.trackByGroups = function (index, colGroup) {
        return colGroup.type;
    };
    DataTableBodyRowComponent.prototype.columnTrackingFn = function (index, column) {
        return column.$$id;
    };
    DataTableBodyRowComponent.prototype.stylesByGroup = function (group) {
        var widths = this.columnGroupWidths;
        var offsetX = this.offsetX;
        var styles = {
            width: widths[group] + "px"
        };
        if (group === 'left') {
            utils_1.translateXY(styles, offsetX, 0);
        }
        else if (group === 'right') {
            var bodyWidth = parseInt(this.innerWidth + '', 0);
            var totalDiff = widths.total - bodyWidth;
            var offsetDiff = totalDiff - offsetX;
            var offset = (offsetDiff + this.scrollbarHelper.width) * -1;
            utils_1.translateXY(styles, offset, 0);
        }
        return styles;
    };
    DataTableBodyRowComponent.prototype.onActivate = function (event, index) {
        event.cellIndex = index;
        event.rowElement = this.element;
        this.activate.emit(event);
    };
    DataTableBodyRowComponent.prototype.onKeyDown = function (event) {
        var keyCode = event.keyCode;
        var isTargetRow = event.target === this.element;
        var isAction = keyCode === utils_1.Keys.return ||
            keyCode === utils_1.Keys.down ||
            keyCode === utils_1.Keys.up ||
            keyCode === utils_1.Keys.left ||
            keyCode === utils_1.Keys.right;
        if (isAction && isTargetRow) {
            event.preventDefault();
            event.stopPropagation();
            this.activate.emit({
                type: 'keydown',
                event: event,
                row: this.row,
                rowElement: this.element
            });
        }
    };
    DataTableBodyRowComponent.prototype.recalculateColumns = function (val) {
        if (val === void 0) { val = this.columns; }
        var colsByPin = utils_1.columnsByPin(val);
        this.columnsByPin = utils_1.columnsByPinArr(val);
        this.columnGroupWidths = utils_1.columnGroupWidths(colsByPin, val);
    };
    return DataTableBodyRowComponent;
}());
DataTableBodyRowComponent.decorators = [
    { type: core_1.Component, args: [{
                selector: 'datatable-body-row',
                template: "\n    <div\n      *ngFor=\"let colGroup of columnsByPin; let i = index; trackBy: trackByGroups\"\n      class=\"datatable-row-{{colGroup.type}} datatable-row-group\"\n      [ngStyle]=\"stylesByGroup(colGroup.type)\">\n      <datatable-body-cell\n        *ngFor=\"let column of colGroup.columns; let ii = index; trackBy: columnTrackingFn\"\n        tabindex=\"-1\"\n        [row]=\"row\"\n        [isSelected]=\"isSelected\"\n        [column]=\"column\"\n        [rowHeight]=\"rowHeight\"\n        (activate)=\"onActivate($event, ii)\">\n      </datatable-body-cell>\n    </div>\n  "
            },] },
];
/** @nocollapse */
DataTableBodyRowComponent.ctorParameters = function () { return [
    { type: services_1.ScrollbarHelper, },
    { type: core_1.ElementRef, },
]; };
DataTableBodyRowComponent.propDecorators = {
    'columns': [{ type: core_1.Input },],
    'innerWidth': [{ type: core_1.Input },],
    'rowClass': [{ type: core_1.Input },],
    'row': [{ type: core_1.Input },],
    'offsetX': [{ type: core_1.Input },],
    'isSelected': [{ type: core_1.Input },],
    'cssClass': [{ type: core_1.HostBinding, args: ['class',] },],
    'rowHeight': [{ type: core_1.HostBinding, args: ['style.height.px',] }, { type: core_1.Input },],
    'columnsTotalWidths': [{ type: core_1.HostBinding, args: ['style.width.px',] },],
    'activate': [{ type: core_1.Output },],
    'onKeyDown': [{ type: core_1.HostListener, args: ['keydown', ['$event'],] },],
};
exports.DataTableBodyRowComponent = DataTableBodyRowComponent;
//# sourceMappingURL=body-row.component.js.map

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(2);
var utils_1 = __webpack_require__(78);
var scroller_component_1 = __webpack_require__(137);
var DataTableBodyComponent = (function () {
    /**
     * Creates an instance of DataTableBodyComponent.
     *
     * @memberOf DataTableBodyComponent
     */
    function DataTableBodyComponent() {
        var _this = this;
        this.selected = [];
        this.scroll = new core_1.EventEmitter();
        this.page = new core_1.EventEmitter();
        this.activate = new core_1.EventEmitter();
        this.select = new core_1.EventEmitter();
        this.detailToggle = new core_1.EventEmitter();
        this.rowContextmenu = new core_1.EventEmitter(false);
        this.rowHeightsCache = new utils_1.RowHeightCache();
        this.temp = [];
        this.offsetY = 0;
        this.indexes = {};
        /**
         * Get the height of the detail row.
         *
         * @param {*} [row]
         * @param {*} [index]
         * @returns {number}
         *
         * @memberOf DataTableBodyComponent
         */
        this.getDetailRowHeight = function (row, index) {
            if (!_this.rowDetail)
                return 0;
            var rowHeight = _this.rowDetail.rowHeight;
            return typeof rowHeight === 'function' ? rowHeight(row, index) : rowHeight;
        };
        // declare fn here so we can get access to the `this` property
        this.rowTrackingFn = function (index, row) {
            if (this.trackByProp) {
                return row.$$index + "-" + this.trackByProp;
            }
            else {
                return row.$$index;
            }
        }.bind(this);
    }
    Object.defineProperty(DataTableBodyComponent.prototype, "pageSize", {
        get: function () {
            return this._pageSize;
        },
        set: function (val) {
            this._pageSize = val;
            this.recalcLayout();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTableBodyComponent.prototype, "rows", {
        get: function () {
            return this._rows;
        },
        set: function (val) {
            this._rows = val;
            this.recalcLayout();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTableBodyComponent.prototype, "columns", {
        get: function () {
            return this._columns;
        },
        set: function (val) {
            this._columns = val;
            var colsByPin = utils_1.columnsByPin(val);
            this.columnGroupWidths = utils_1.columnGroupWidths(colsByPin, val);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTableBodyComponent.prototype, "offset", {
        get: function () {
            return this._offset;
        },
        set: function (val) {
            this._offset = val;
            this.recalcLayout();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTableBodyComponent.prototype, "rowCount", {
        get: function () {
            return this._rowCount;
        },
        set: function (val) {
            this._rowCount = val;
            this.recalcLayout();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTableBodyComponent.prototype, "bodyWidth", {
        get: function () {
            if (this.scrollbarH) {
                return this.innerWidth + 'px';
            }
            else {
                return '100%';
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTableBodyComponent.prototype, "bodyHeight", {
        get: function () {
            return this._bodyHeight;
        },
        set: function (val) {
            if (this.scrollbarV) {
                this._bodyHeight = val + 'px';
            }
            else {
                this._bodyHeight = 'auto';
            }
            this.recalcLayout();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTableBodyComponent.prototype, "selectEnabled", {
        /**
         * Returns if selection is enabled.
         *
         * @readonly
         * @type {boolean}
         * @memberOf DataTableBodyComponent
         */
        get: function () {
            return !!this.selectionType;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTableBodyComponent.prototype, "scrollHeight", {
        /**
         * Property that would calculate the height of scroll bar
         * based on the row heights cache for virtual scroll. Other scenarios
         * calculate scroll height automatically (as height will be undefined).
         *
         * @readonly
         * @type {number}
         * @memberOf DataTableBodyComponent
         */
        get: function () {
            if (this.scrollbarV) {
                return this.rowHeightsCache.query(this.rowCount - 1);
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Called after the constructor, initializing input properties
     *
     * @memberOf DataTableBodyComponent
     */
    DataTableBodyComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (this.rowDetail) {
            this.listener = this.rowDetail.toggle
                .subscribe(function (_a) {
                var type = _a.type, value = _a.value;
                if (type === 'row')
                    _this.toggleRowExpansion(value);
                if (type === 'all')
                    _this.toggleAllRows(value);
            });
        }
    };
    /**
     * Called once, before the instance is destroyed.
     *
     * @memberOf DataTableBodyComponent
     */
    DataTableBodyComponent.prototype.ngOnDestroy = function () {
        if (this.rowDetail)
            this.listener.unsubscribe();
    };
    /**
     * Updates the Y offset given a new offset.
     *
     * @param {number} [offset]
     *
     * @memberOf DataTableBodyComponent
     */
    DataTableBodyComponent.prototype.updateOffsetY = function (offset) {
        // scroller is missing on empty table
        if (!this.scroller)
            return;
        if (this.scrollbarV && offset) {
            // First get the row Index that we need to move to.
            var rowIndex = this.pageSize * offset;
            offset = this.rowHeightsCache.query(rowIndex - 1);
        }
        this.scroller.setOffset(offset || 0);
    };
    /**
     * Body was scrolled, this is mainly useful for
     * when a user is server-side pagination via virtual scroll.
     *
     * @param {*} event
     *
     * @memberOf DataTableBodyComponent
     */
    DataTableBodyComponent.prototype.onBodyScroll = function (event) {
        var scrollYPos = event.scrollYPos;
        var scrollXPos = event.scrollXPos;
        // if scroll change, trigger update
        // this is mainly used for header cell positions
        if (this.offsetY !== scrollYPos || this.offsetX !== scrollXPos) {
            this.scroll.emit({
                offsetY: scrollYPos,
                offsetX: scrollXPos
            });
        }
        this.offsetY = scrollYPos;
        this.offsetX = scrollXPos;
        this.updateIndexes();
        this.updatePage(event.direction);
        this.updateRows();
    };
    /**
     * Updates the page given a direction.
     *
     * @param {string} direction
     *
     * @memberOf DataTableBodyComponent
     */
    DataTableBodyComponent.prototype.updatePage = function (direction) {
        var offset = this.indexes.first / this.pageSize;
        if (direction === 'up') {
            offset = Math.ceil(offset);
        }
        else if (direction === 'down') {
            offset = Math.ceil(offset);
        }
        if (direction !== undefined && !isNaN(offset)) {
            this.page.emit({ offset: offset });
        }
    };
    /**
     * Updates the rows in the view port
     *
     * @memberOf DataTableBodyComponent
     */
    DataTableBodyComponent.prototype.updateRows = function () {
        var _a = this.indexes, first = _a.first, last = _a.last;
        var rowIndex = first;
        var idx = 0;
        var temp = [];
        while (rowIndex < last && rowIndex < this.rowCount) {
            var row = this.rows[rowIndex];
            if (row) {
                row.$$index = rowIndex;
                temp[idx] = row;
            }
            idx++;
            rowIndex++;
        }
        this.temp = temp;
    };
    /**
     * Get the row height
     *
     * @param {*} row
     * @returns {number}
     *
     * @memberOf DataTableBodyComponent
     */
    DataTableBodyComponent.prototype.getRowHeight = function (row) {
        var rowHeight = this.rowHeight;
        // if its a function return it
        if (typeof this.rowHeight === 'function') {
            rowHeight = this.rowHeight(row);
        }
        return rowHeight;
    };
    /**
     * Calculate row height based on the expanded state of the row.
     *
     * @param {*} row the row for which the height need to be calculated.
     * @returns {number} height of the row.
     *
     * @memberOf DataTableBodyComponent
     */
    DataTableBodyComponent.prototype.getRowAndDetailHeight = function (row) {
        var rowHeight = this.getRowHeight(row);
        // Adding detail row height if its expanded.
        if (row.$$expanded === 1) {
            rowHeight += this.getDetailRowHeight(row);
        }
        return rowHeight;
    };
    /**
     * Calculates the styles for the row so that the rows can be moved in 2D space
     * during virtual scroll inside the DOM.   In the below case the Y position is
     * manipulated.   As an example, if the height of row 0 is 30 px and row 1 is
     * 100 px then following styles are generated:
     *
     * transform: translate3d(0px, 0px, 0px);    ->  row0
     * transform: translate3d(0px, 30px, 0px);   ->  row1
     * transform: translate3d(0px, 130px, 0px);  ->  row2
     *
     * Row heights have to be calculated based on the row heights cache as we wont
     * be able to determine which row is of what height before hand.  In the above
     * case the positionY of the translate3d for row2 would be the sum of all the
     * heights of the rows before it (i.e. row0 and row1).
     *
     * @param {*} row The row that needs to be placed in the 2D space.
     * @returns {*} Returns the CSS3 style to be applied
     *
     * @memberOf DataTableBodyComponent
     */
    DataTableBodyComponent.prototype.getRowsStyles = function (row) {
        var rowHeight = this.getRowAndDetailHeight(row);
        var styles = {
            height: rowHeight + 'px'
        };
        if (this.scrollbarV) {
            var idx = row ? row.$$index : 0;
            // const pos = idx * rowHeight;
            // The position of this row would be the sum of all row heights
            // until the previous row position.
            var pos = this.rowHeightsCache.query(idx - 1);
            utils_1.translateXY(styles, 0, pos);
        }
        return styles;
    };
    /**
     * Hides the loading indicator
     *
     *
     * @memberOf DataTableBodyComponent
     */
    DataTableBodyComponent.prototype.hideIndicator = function () {
        var _this = this;
        setTimeout(function () { return _this.loadingIndicator = false; }, 500);
    };
    /**
     * Updates the index of the rows in the viewport
     *
     * @memberOf DataTableBodyComponent
     */
    DataTableBodyComponent.prototype.updateIndexes = function () {
        var first = 0;
        var last = 0;
        if (this.scrollbarV) {
            // Calculation of the first and last indexes will be based on where the
            // scrollY position would be at.  The last index would be the one
            // that shows up inside the view port the last.
            var height = parseInt(this.bodyHeight, 0);
            first = this.rowHeightsCache.getRowIndex(this.offsetY);
            last = this.rowHeightsCache.getRowIndex(height + this.offsetY) + 1;
        }
        else {
            // The server is handling paging and will pass an array that begins with the
            // element at a specified offset.  first should always be 0 with external paging.
            if (!this.externalPaging) {
                first = Math.max(this.offset * this.pageSize, 0);
            }
            last = Math.min((first + this.pageSize), this.rowCount);
        }
        this.indexes = { first: first, last: last };
    };
    /**
     * Refreshes the full Row Height cache.  Should be used
     * when the entire row array state has changed.
     *
     * @returns {void}
     *
     * @memberOf DataTableBodyComponent
     */
    DataTableBodyComponent.prototype.refreshRowHeightCache = function () {
        if (!this.scrollbarV)
            return;
        // clear the previous row height cache if already present.
        // this is useful during sorts, filters where the state of the
        // rows array is changed.
        this.rowHeightsCache.clearCache();
        // Initialize the tree only if there are rows inside the tree.
        if (this.rows && this.rows.length) {
            this.rowHeightsCache.initCache({
                rows: this.rows,
                rowHeight: this.rowHeight,
                detailRowHeight: this.getDetailRowHeight,
                externalVirtual: this.scrollbarV && this.externalPaging,
                rowCount: this.rowCount
            });
        }
    };
    /**
     * Gets the index for the view port
     *
     * @returns {number}
     *
     * @memberOf DataTableBodyComponent
     */
    DataTableBodyComponent.prototype.getAdjustedViewPortIndex = function () {
        // Capture the row index of the first row that is visible on the viewport.
        // If the scroll bar is just below the row which is highlighted then make that as the
        // first index.
        var viewPortFirstRowIndex = this.indexes.first;
        if (this.scrollbarV) {
            var offsetScroll = this.rowHeightsCache.query(viewPortFirstRowIndex - 1);
            return offsetScroll <= this.offsetY ? viewPortFirstRowIndex - 1 : viewPortFirstRowIndex;
        }
        return viewPortFirstRowIndex;
    };
    /**
     * Toggle the Expansion of the row i.e. if the row is expanded then it will
     * collapse and vice versa.   Note that the expanded status is stored as
     * a part of the row object itself as we have to preserve the expanded row
     * status in case of sorting and filtering of the row set.
     *
     * @param {*} row The row for which the expansion needs to be toggled.
     *
     * @memberOf DataTableBodyComponent
     */
    DataTableBodyComponent.prototype.toggleRowExpansion = function (row) {
        // Capture the row index of the first row that is visible on the viewport.
        var viewPortFirstRowIndex = this.getAdjustedViewPortIndex();
        // If the detailRowHeight is auto --> only in case of non-virtualized scroll
        if (this.scrollbarV) {
            var detailRowHeight = this.getDetailRowHeight(row) * (row.$$expanded ? -1 : 1);
            this.rowHeightsCache.update(row.$$index, detailRowHeight);
        }
        // Update the toggled row and update the heights in the cache.
        row.$$expanded ^= 1;
        this.detailToggle.emit({
            rows: [row],
            currentIndex: viewPortFirstRowIndex
        });
    };
    /**
     * Expand/Collapse all the rows no matter what their state is.
     *
     * @param {boolean} expanded When true, all rows are expanded and when false, all rows will be collapsed.
     *
     * @memberOf DataTableBodyComponent
     */
    DataTableBodyComponent.prototype.toggleAllRows = function (expanded) {
        var rowExpanded = expanded ? 1 : 0;
        // Capture the row index of the first row that is visible on the viewport.
        var viewPortFirstRowIndex = this.getAdjustedViewPortIndex();
        for (var _i = 0, _a = this.rows; _i < _a.length; _i++) {
            var row = _a[_i];
            row.$$expanded = rowExpanded;
        }
        if (this.scrollbarV) {
            // Refresh the full row heights cache since every row was affected.
            this.recalcLayout();
        }
        // Emit all rows that have been expanded.
        this.detailToggle.emit({
            rows: this.rows,
            currentIndex: viewPortFirstRowIndex
        });
    };
    /**
     * Recalculates the table
     *
     * @memberOf DataTableBodyComponent
     */
    DataTableBodyComponent.prototype.recalcLayout = function () {
        this.refreshRowHeightCache();
        this.updateIndexes();
        this.updateRows();
    };
    return DataTableBodyComponent;
}());
DataTableBodyComponent.decorators = [
    { type: core_1.Component, args: [{
                selector: 'datatable-body',
                template: "\n    <datatable-selection\n      #selector\n      [selected]=\"selected\"\n      [rows]=\"temp\"\n      [selectCheck]=\"selectCheck\"\n      [selectEnabled]=\"selectEnabled\"\n      [selectionType]=\"selectionType\"\n      [rowIdentity]=\"rowIdentity\"\n      (select)=\"select.emit($event)\"\n      (activate)=\"activate.emit($event)\">\n      <datatable-progress\n        *ngIf=\"loadingIndicator\">\n      </datatable-progress>\n      <datatable-scroller\n        *ngIf=\"rows?.length\"\n        [scrollbarV]=\"scrollbarV\"\n        [scrollbarH]=\"scrollbarH\"\n        [scrollHeight]=\"scrollHeight\"\n        [scrollWidth]=\"columnGroupWidths.total\"\n        (scroll)=\"onBodyScroll($event)\">\n        <datatable-row-wrapper\n          *ngFor=\"let row of temp; let i = index; trackBy: rowTrackingFn;\"\n          [ngStyle]=\"getRowsStyles(row)\"\n          [rowDetail]=\"rowDetail\"\n          [detailRowHeight]=\"getDetailRowHeight(row,i)\"\n          [row]=\"row\"\n          [expanded]=\"row.$$expanded === 1\"\n          (rowContextmenu)=\"rowContextmenu.emit($event)\">\n          <datatable-body-row\n            tabindex=\"-1\"\n            [isSelected]=\"selector.getRowSelected(row)\"\n            [innerWidth]=\"innerWidth\"\n            [offsetX]=\"offsetX\"\n            [columns]=\"columns\"\n            [rowHeight]=\"getRowHeight(row)\"\n            [row]=\"row\"\n            [rowClass]=\"rowClass\"\n            (activate)=\"selector.onActivate($event, i)\">\n          </datatable-body-row>\n        </datatable-row-wrapper>\n      </datatable-scroller>\n      <div\n        class=\"empty-row\"\n        *ngIf=\"!rows?.length\"\n        [innerHTML]=\"emptyMessage\">\n      </div>\n    </datatable-selection>\n  ",
                host: {
                    class: 'datatable-body'
                }
            },] },
];
/** @nocollapse */
DataTableBodyComponent.ctorParameters = function () { return []; };
DataTableBodyComponent.propDecorators = {
    'scrollbarV': [{ type: core_1.Input },],
    'scrollbarH': [{ type: core_1.Input },],
    'loadingIndicator': [{ type: core_1.Input },],
    'externalPaging': [{ type: core_1.Input },],
    'rowHeight': [{ type: core_1.Input },],
    'offsetX': [{ type: core_1.Input },],
    'emptyMessage': [{ type: core_1.Input },],
    'selectionType': [{ type: core_1.Input },],
    'selected': [{ type: core_1.Input },],
    'rowIdentity': [{ type: core_1.Input },],
    'rowDetail': [{ type: core_1.Input },],
    'selectCheck': [{ type: core_1.Input },],
    'trackByProp': [{ type: core_1.Input },],
    'rowClass': [{ type: core_1.Input },],
    'pageSize': [{ type: core_1.Input },],
    'rows': [{ type: core_1.Input },],
    'columns': [{ type: core_1.Input },],
    'offset': [{ type: core_1.Input },],
    'rowCount': [{ type: core_1.Input },],
    'innerWidth': [{ type: core_1.Input },],
    'bodyWidth': [{ type: core_1.HostBinding, args: ['style.width',] },],
    'bodyHeight': [{ type: core_1.Input }, { type: core_1.HostBinding, args: ['style.height',] },],
    'scroll': [{ type: core_1.Output },],
    'page': [{ type: core_1.Output },],
    'activate': [{ type: core_1.Output },],
    'select': [{ type: core_1.Output },],
    'detailToggle': [{ type: core_1.Output },],
    'rowContextmenu': [{ type: core_1.Output },],
    'scroller': [{ type: core_1.ViewChild, args: [scroller_component_1.ScrollerComponent,] },],
};
exports.DataTableBodyComponent = DataTableBodyComponent;
//# sourceMappingURL=body.component.js.map

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(2);
var ProgressBarComponent = (function () {
    function ProgressBarComponent() {
    }
    return ProgressBarComponent;
}());
ProgressBarComponent.decorators = [
    { type: core_1.Component, args: [{
                selector: 'datatable-progress',
                template: "\n    <div class=\"progress-linear\" role=\"progressbar\">\n      <div class=\"container\">\n        <div class=\"bar\"></div>\n      </div>\n    </div>\n  ",
                changeDetection: core_1.ChangeDetectionStrategy.OnPush
            },] },
];
/** @nocollapse */
ProgressBarComponent.ctorParameters = function () { return []; };
exports.ProgressBarComponent = ProgressBarComponent;
//# sourceMappingURL=progress-bar.component.js.map

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(2);
var utils_1 = __webpack_require__(78);
var types_1 = __webpack_require__(96);
var DataTableSelectionComponent = (function () {
    function DataTableSelectionComponent() {
        this.activate = new core_1.EventEmitter();
        this.select = new core_1.EventEmitter();
    }
    DataTableSelectionComponent.prototype.selectRow = function (event, index, row) {
        if (!this.selectEnabled)
            return;
        var chkbox = this.selectionType === types_1.SelectionType.checkbox;
        var multi = this.selectionType === types_1.SelectionType.multi;
        var multiClick = this.selectionType === types_1.SelectionType.multiClick;
        var selected = [];
        if (multi || chkbox || multiClick) {
            if (event.shiftKey) {
                selected = utils_1.selectRowsBetween([], this.rows, index, this.prevIndex, this.getRowSelectedIdx.bind(this));
            }
            else if (event.ctrlKey || event.metaKey || multiClick || chkbox) {
                selected = utils_1.selectRows(this.selected.slice(), row, this.getRowSelectedIdx.bind(this));
            }
            else {
                selected = utils_1.selectRows([], row, this.getRowSelectedIdx.bind(this));
            }
        }
        else {
            selected = utils_1.selectRows([], row, this.getRowSelectedIdx.bind(this));
        }
        if (typeof this.selectCheck === 'function') {
            selected = selected.filter(this.selectCheck.bind(this));
        }
        this.selected.splice(0, this.selected.length);
        (_a = this.selected).push.apply(_a, selected);
        this.prevIndex = index;
        this.select.emit({
            selected: selected
        });
        var _a;
    };
    DataTableSelectionComponent.prototype.onActivate = function (model, index) {
        var type = model.type, event = model.event, row = model.row;
        var chkbox = this.selectionType === types_1.SelectionType.checkbox;
        var select = (!chkbox && (type === 'click' || type === 'dblclick')) ||
            (chkbox && type === 'checkbox');
        if (select) {
            this.selectRow(event, index, row);
        }
        else if (type === 'keydown') {
            if (event.keyCode === utils_1.Keys.return) {
                this.selectRow(event, index, row);
            }
            else {
                this.onKeyboardFocus(model);
            }
        }
        this.activate.emit(model);
    };
    DataTableSelectionComponent.prototype.onKeyboardFocus = function (model) {
        var keyCode = model.event.keyCode;
        var shouldFocus = keyCode === utils_1.Keys.up ||
            keyCode === utils_1.Keys.down ||
            keyCode === utils_1.Keys.right ||
            keyCode === utils_1.Keys.left;
        if (shouldFocus) {
            var isCellSelection = this.selectionType === types_1.SelectionType.cell;
            if (!model.cellElement || !isCellSelection) {
                this.focusRow(model.rowElement, keyCode);
            }
            else if (isCellSelection) {
                this.focusCell(model.cellElement, model.rowElement, keyCode, model.cellIndex);
            }
        }
    };
    DataTableSelectionComponent.prototype.focusRow = function (rowElement, keyCode) {
        var nextRowElement = this.getPrevNextRow(rowElement, keyCode);
        if (nextRowElement)
            nextRowElement.focus();
    };
    DataTableSelectionComponent.prototype.getPrevNextRow = function (rowElement, keyCode) {
        var parentElement = rowElement.parentElement;
        if (parentElement) {
            var focusElement = void 0;
            if (keyCode === utils_1.Keys.up) {
                focusElement = parentElement.previousElementSibling;
            }
            else if (keyCode === utils_1.Keys.down) {
                focusElement = parentElement.nextElementSibling;
            }
            if (focusElement && focusElement.children.length) {
                return focusElement.children[0];
            }
        }
    };
    DataTableSelectionComponent.prototype.focusCell = function (cellElement, rowElement, keyCode, cellIndex) {
        var nextCellElement;
        if (keyCode === utils_1.Keys.left) {
            nextCellElement = cellElement.previousElementSibling;
        }
        else if (keyCode === utils_1.Keys.right) {
            nextCellElement = cellElement.nextElementSibling;
        }
        else if (keyCode === utils_1.Keys.up || keyCode === utils_1.Keys.down) {
            var nextRowElement = this.getPrevNextRow(rowElement, keyCode);
            if (nextRowElement) {
                var children = nextRowElement.getElementsByClassName('datatable-body-cell');
                if (children.length)
                    nextCellElement = children[cellIndex];
            }
        }
        if (nextCellElement)
            nextCellElement.focus();
    };
    DataTableSelectionComponent.prototype.getRowSelected = function (row) {
        return this.getRowSelectedIdx(row, this.selected) > -1;
    };
    DataTableSelectionComponent.prototype.getRowSelectedIdx = function (row, selected) {
        var _this = this;
        if (!selected || !selected.length)
            return -1;
        var rowId = this.rowIdentity(row);
        return selected.findIndex(function (r) {
            var id = _this.rowIdentity(r);
            return id === rowId;
        });
    };
    return DataTableSelectionComponent;
}());
DataTableSelectionComponent.decorators = [
    { type: core_1.Component, args: [{
                selector: 'datatable-selection',
                template: "\n    <ng-content></ng-content>\n  "
            },] },
];
/** @nocollapse */
DataTableSelectionComponent.ctorParameters = function () { return []; };
DataTableSelectionComponent.propDecorators = {
    'rows': [{ type: core_1.Input },],
    'selected': [{ type: core_1.Input },],
    'selectEnabled': [{ type: core_1.Input },],
    'selectionType': [{ type: core_1.Input },],
    'rowIdentity': [{ type: core_1.Input },],
    'selectCheck': [{ type: core_1.Input },],
    'activate': [{ type: core_1.Output },],
    'select': [{ type: core_1.Output },],
};
exports.DataTableSelectionComponent = DataTableSelectionComponent;
//# sourceMappingURL=selection.component.js.map

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(2);
var utils_1 = __webpack_require__(78);
var services_1 = __webpack_require__(203);
var types_1 = __webpack_require__(96);
var body_1 = __webpack_require__(331);
var columns_1 = __webpack_require__(334);
var row_detail_1 = __webpack_require__(337);
var footer_1 = __webpack_require__(336);
var DatatableComponent = (function () {
    function DatatableComponent(scrollbarHelper, element, differs) {
        this.scrollbarHelper = scrollbarHelper;
        /**
         * List of row objects that should be
         * represented as selected in the grid.
         * Default value: `[]`
         *
         * @type {any[]}
         * @memberOf DatatableComponent
         */
        this.selected = [];
        /**
         * Enable vertical scrollbars
         *
         * @type {boolean}
         * @memberOf DatatableComponent
         */
        this.scrollbarV = false;
        /**
         * Enable horz scrollbars
         *
         * @type {boolean}
         * @memberOf DatatableComponent
         */
        this.scrollbarH = false;
        /**
         * The row height; which is necessary
         * to calculate the height for the lazy rendering.
         *
         * @type {number}
         * @memberOf DatatableComponent
         */
        this.rowHeight = 30;
        /**
         * Type of column width distribution formula.
         * Example: flex, force, standard
         *
         * @type {ColumnMode}
         * @memberOf DatatableComponent
         */
        this.columnMode = types_1.ColumnMode.standard;
        /**
         * The minimum header height in pixels.
         * Pass a falsey for no header
         *
         * @type {*}
         * @memberOf DatatableComponent
         */
        this.headerHeight = 30;
        /**
         * The minimum footer height in pixels.
         * Pass falsey for no footer
         *
         * @type {number}
         * @memberOf DatatableComponent
         */
        this.footerHeight = 0;
        /**
         * If the table should use external paging
         * otherwise its assumed that all data is preloaded.
         *
         * @type {boolean}
         * @memberOf DatatableComponent
         */
        this.externalPaging = false;
        /**
         * If the table should use external sorting or
         * the built-in basic sorting.
         *
         * @type {boolean}
         * @memberOf DatatableComponent
         */
        this.externalSorting = false;
        /**
         * The page size to be shown.
         * Default value: `undefined`
         *
         * @type {number}
         * @memberOf DatatableComponent
         */
        this.limit = undefined;
        /**
         * The current offset ( page - 1 ) shown.
         * Default value: `0`
         *
         * @type {number}
         * @memberOf DatatableComponent
         */
        this.offset = 0;
        /**
         * Show the linear loading bar.
         * Default value: `false`
         *
         * @type {boolean}
         * @memberOf DatatableComponent
         */
        this.loadingIndicator = false;
        /**
         * Enable/Disable ability to re-order columns
         * by dragging them.
         *
         * @type {boolean}
         * @memberOf DatatableComponent
         */
        this.reorderable = true;
        /**
         * The type of sorting
         *
         * @type {SortType}
         * @memberOf DatatableComponent
         */
        this.sortType = types_1.SortType.single;
        /**
         * Array of sorted columns by property and type.
         * Default value: `[]`
         *
         * @type {any[]}
         * @memberOf DatatableComponent
         */
        this.sorts = [];
        /**
         * Css class overrides
         *
         * @type {*}
         * @memberOf DatatableComponent
         */
        this.cssClasses = {
            sortAscending: 'datatable-icon-up',
            sortDescending: 'datatable-icon-down',
            pagerLeftArrow: 'datatable-icon-left',
            pagerRightArrow: 'datatable-icon-right',
            pagerPrevious: 'datatable-icon-prev',
            pagerNext: 'datatable-icon-skip'
        };
        /**
         * Message overrides for localization
         *
         * emptyMessage     [default] = 'No data to display'
         * totalMessage     [default] = 'total'
         * selectedMessage  [default] = 'selected'
         *
         * @type {*}
         * @memberOf DatatableComponent
         */
        this.messages = {
            // Message to show when array is presented
            // but contains no values
            emptyMessage: 'No data to display',
            // Footer total message
            totalMessage: 'total',
            // Footer selected message
            selectedMessage: 'selected'
        };
        /**
         * This will be used when displaying or selecting rows.
         * when tracking/comparing them, we'll use the value of this fn,
         *
         * (`fn(x) === fn(y)` instead of `x === y`)
         *
         * @memberOf DatatableComponent
         */
        this.rowIdentity = (function (x) { return x; });
        /**
         * Body was scrolled typically in a `scrollbarV:true` scenario.
         *
         * @type {EventEmitter<any>}
         * @memberOf DatatableComponent
         */
        this.scroll = new core_1.EventEmitter();
        /**
         * A cell or row was focused via keyboard or mouse click.
         *
         * @type {EventEmitter<any>}
         * @memberOf DatatableComponent
         */
        this.activate = new core_1.EventEmitter();
        /**
         * A cell or row was selected.
         *
         * @type {EventEmitter<any>}
         * @memberOf DatatableComponent
         */
        this.select = new core_1.EventEmitter();
        /**
         * Column sort was invoked.
         *
         * @type {EventEmitter<any>}
         * @memberOf DatatableComponent
         */
        this.sort = new core_1.EventEmitter();
        /**
         * The table was paged either triggered by the pager or the body scroll.
         *
         * @type {EventEmitter<any>}
         * @memberOf DatatableComponent
         */
        this.page = new core_1.EventEmitter();
        /**
         * Columns were re-ordered.
         *
         * @type {EventEmitter<any>}
         * @memberOf DatatableComponent
         */
        this.reorder = new core_1.EventEmitter();
        /**
         * Column was resized.
         *
         * @type {EventEmitter<any>}
         * @memberOf DatatableComponent
         */
        this.resize = new core_1.EventEmitter();
        /**
         * The context menu was invoked on the table.
         * type indicates whether the header or the body was clicked.
         * content contains either the column or the row that was clicked.
         *
         * @memberOf DatatableComponent
         */
        this.tableContextmenu = new core_1.EventEmitter(false);
        this.rowCount = 0;
        this.offsetX = 0;
        this._count = 0;
        // get ref to elm for measuring
        this.element = element.nativeElement;
        this.rowDiffer = differs.find({}).create(null);
    }
    Object.defineProperty(DatatableComponent.prototype, "rows", {
        /**
         * Gets the rows.
         *
         * @readonly
         * @type {*}
         * @memberOf DatatableComponent
         */
        get: function () {
            return this._rows;
        },
        /**
         * Rows that are displayed in the table.
         *
         * @memberOf DatatableComponent
         */
        set: function (val) {
            // auto sort on new updates
            if (!this.externalSorting) {
                val = utils_1.sortRows(val, this.columns, this.sorts);
            }
            this._rows = val;
            // recalculate sizes/etc
            this.recalculate();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DatatableComponent.prototype, "columns", {
        /**
         * Get the columns.
         *
         * @readonly
         * @type {any[]}
         * @memberOf DatatableComponent
         */
        get: function () {
            return this._columns;
        },
        /**
         * Columns to be displayed.
         *
         * @memberOf DatatableComponent
         */
        set: function (val) {
            if (val) {
                utils_1.setColumnDefaults(val);
                this.recalculateColumns(val);
            }
            this._columns = val;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DatatableComponent.prototype, "count", {
        /**
         * Gets the count.
         *
         * @readonly
         * @type {number}
         * @memberOf DatatableComponent
         */
        get: function () {
            return this._count;
        },
        /**
         * The total count of all rows.
         * Default value: `0`
         *
         * @type {number}
         * @memberOf DatatableComponent
         */
        set: function (val) {
            this._count = val;
            // recalculate sizes/etc
            this.recalculate();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DatatableComponent.prototype, "isFixedHeader", {
        /**
         * CSS class applied if the header height if fixed height.
         *
         * @readonly
         * @type {boolean}
         * @memberOf DatatableComponent
         */
        get: function () {
            var headerHeight = this.headerHeight;
            return (typeof headerHeight === 'string') ?
                headerHeight !== 'auto' : true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DatatableComponent.prototype, "isFixedRow", {
        /**
         * CSS class applied to the root element if
         * the row heights are fixed heights.
         *
         * @readonly
         * @type {boolean}
         * @memberOf DatatableComponent
         */
        get: function () {
            var rowHeight = this.rowHeight;
            return (typeof rowHeight === 'string') ?
                rowHeight !== 'auto' : true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DatatableComponent.prototype, "isVertScroll", {
        /**
         * CSS class applied to root element if
         * vertical scrolling is enabled.
         *
         * @readonly
         * @type {boolean}
         * @memberOf DatatableComponent
         */
        get: function () {
            return this.scrollbarV;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DatatableComponent.prototype, "isHorScroll", {
        /**
         * CSS class applied to the root element
         * if the horziontal scrolling is enabled.
         *
         * @readonly
         * @type {boolean}
         * @memberOf DatatableComponent
         */
        get: function () {
            return this.scrollbarH;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DatatableComponent.prototype, "isSelectable", {
        /**
         * CSS class applied to root element is selectable.
         *
         * @readonly
         * @type {boolean}
         * @memberOf DatatableComponent
         */
        get: function () {
            return this.selectionType !== undefined;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DatatableComponent.prototype, "isCheckboxSelection", {
        /**
         * CSS class applied to root is checkbox selection.
         *
         * @readonly
         * @type {boolean}
         * @memberOf DatatableComponent
         */
        get: function () {
            return this.selectionType === types_1.SelectionType.checkbox;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DatatableComponent.prototype, "isCellSelection", {
        /**
         * CSS class applied to root if cell selection.
         *
         * @readonly
         * @type {boolean}
         * @memberOf DatatableComponent
         */
        get: function () {
            return this.selectionType === types_1.SelectionType.cell;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DatatableComponent.prototype, "isSingleSelection", {
        /**
         * CSS class applied to root if single select.
         *
         * @readonly
         * @type {boolean}
         * @memberOf DatatableComponent
         */
        get: function () {
            return this.selectionType === types_1.SelectionType.single;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DatatableComponent.prototype, "isMultiSelection", {
        /**
         * CSS class added to root element if mulit select
         *
         * @readonly
         * @type {boolean}
         * @memberOf DatatableComponent
         */
        get: function () {
            return this.selectionType === types_1.SelectionType.multi;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DatatableComponent.prototype, "isMultiClickSelection", {
        /**
         * CSS class added to root element if mulit click select
         *
         * @readonly
         * @type {boolean}
         * @memberOf DatatableComponent
         */
        get: function () {
            return this.selectionType === types_1.SelectionType.multiClick;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DatatableComponent.prototype, "columnTemplates", {
        /**
         * Returns the column templates.
         *
         * @readonly
         * @type {QueryList<DataTableColumnDirective>}
         * @memberOf DatatableComponent
         */
        get: function () {
            return this._columnTemplates;
        },
        /**
         * Column templates gathered from `ContentChildren`
         * if described in your markup.
         *
         * @memberOf DatatableComponent
         */
        set: function (val) {
            this._columnTemplates = val;
            if (val) {
                // only set this if results were brought back
                var arr = val.toArray();
                if (arr.length) {
                    // translate them to normal objects
                    this.columns = utils_1.translateTemplates(arr);
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DatatableComponent.prototype, "allRowsSelected", {
        /**
         * Returns if all rows are selected.
         *
         * @readonly
         * @private
         * @type {boolean}
         * @memberOf DatatableComponent
         */
        get: function () {
            return this.selected &&
                this.rows &&
                this.rows.length !== 0 &&
                this.selected.length === this.rows.length;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Lifecycle hook that is called after data-bound
     * properties of a directive are initialized.
     *
     * @memberOf DatatableComponent
     */
    DatatableComponent.prototype.ngOnInit = function () {
        // need to call this immediatly to size
        // if the table is hidden the visibility
        // listener will invoke this itself upon show
        this.recalculate();
    };
    /**
     * Lifecycle hook that is called after a component's
     * view has been fully initialized.
     *
     * @memberOf DatatableComponent
     */
    DatatableComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        if (!this.externalSorting) {
            var val = utils_1.sortRows(this._rows, this.columns, this.sorts);
            this._rows = val;
        }
        // this has to be done to prevent the change detection
        // tree from freaking out because we are readjusting
        setTimeout(function () {
            _this.recalculate();
            // emit page for virtual server-side kickoff
            if (_this.externalPaging && _this.scrollbarV) {
                _this.page.emit({
                    count: _this.count,
                    pageSize: _this.pageSize,
                    limit: _this.limit,
                    offset: 0
                });
            }
        });
    };
    /**
     * Lifecycle hook that is called when Angular dirty checks a directive.
     *
     * @memberOf DatatableComponent
     */
    DatatableComponent.prototype.ngDoCheck = function () {
        if (this.rowDiffer.diff(this.rows)) {
            this.recalculatePages();
        }
    };
    /**
     * Recalc's the sizes of the grid.
     *
     * Updated automatically on changes to:
     *
     *  - Columns
     *  - Rows
     *  - Paging related
     *
     * Also can be manually invoked or upon window resize.
     *
     * @memberOf DatatableComponent
     */
    DatatableComponent.prototype.recalculate = function () {
        this.recalculateDims();
        this.recalculateColumns();
    };
    /**
     * Window resize handler to update sizes.
     *
     * @memberOf DatatableComponent
     */
    DatatableComponent.prototype.onWindowResize = function () {
        this.recalculate();
    };
    /**
     * Recalulcates the column widths based on column width
     * distribution mode and scrollbar offsets.
     *
     * @param {any[]} [columns=this.columns]
     * @param {number} [forceIdx=-1]
     * @param {boolean} [allowBleed=this.scrollH]
     * @returns {any[]}
     *
     * @memberOf DatatableComponent
     */
    DatatableComponent.prototype.recalculateColumns = function (columns, forceIdx, allowBleed) {
        if (columns === void 0) { columns = this.columns; }
        if (forceIdx === void 0) { forceIdx = -1; }
        if (allowBleed === void 0) { allowBleed = this.scrollbarH; }
        if (!columns)
            return;
        var width = this.innerWidth;
        if (this.scrollbarV) {
            width = width - this.scrollbarHelper.width;
        }
        if (this.columnMode === types_1.ColumnMode.force) {
            utils_1.forceFillColumnWidths(columns, width, forceIdx, allowBleed);
        }
        else if (this.columnMode === types_1.ColumnMode.flex) {
            utils_1.adjustColumnWidths(columns, width);
        }
        return columns;
    };
    /**
     * Recalculates the dimensions of the table size.
     * Internally calls the page size and row count calcs too.
     *
     * @memberOf DatatableComponent
     */
    DatatableComponent.prototype.recalculateDims = function () {
        var dims = this.element.getBoundingClientRect();
        this.innerWidth = Math.floor(dims.width);
        if (this.scrollbarV) {
            var height = dims.height;
            if (this.headerHeight)
                height = height - this.headerHeight;
            if (this.footerHeight)
                height = height - this.footerHeight;
            this.bodyHeight = height;
        }
        this.recalculatePages();
    };
    /**
     * Recalculates the pages after a update.
     *
     *
     * @memberOf DatatableComponent
     */
    DatatableComponent.prototype.recalculatePages = function () {
        this.pageSize = this.calcPageSize();
        this.rowCount = this.calcRowCount();
    };
    /**
     * Body triggered a page event.
     *
     * @param {*} { offset }
     *
     * @memberOf DatatableComponent
     */
    DatatableComponent.prototype.onBodyPage = function (_a) {
        var offset = _a.offset;
        this.offset = offset;
        this.page.emit({
            count: this.count,
            pageSize: this.pageSize,
            limit: this.limit,
            offset: this.offset
        });
    };
    /**
     * The body triggered a scroll event.
     *
     * @param {MouseEvent} event
     *
     * @memberOf DatatableComponent
     */
    DatatableComponent.prototype.onBodyScroll = function (event) {
        this.offsetX = event.offsetX;
        this.scroll.emit(event);
    };
    /**
     * The footer triggered a page event.
     *
     * @param {*} event
     *
     * @memberOf DatatableComponent
     */
    DatatableComponent.prototype.onFooterPage = function (event) {
        this.offset = event.page - 1;
        this.bodyComponent.updateOffsetY(this.offset);
        this.page.emit({
            count: this.count,
            pageSize: this.pageSize,
            limit: this.limit,
            offset: this.offset
        });
    };
    /**
     * Recalculates the sizes of the page
     *
     * @param {any[]} [val=this.rows]
     * @returns {number}
     *
     * @memberOf DatatableComponent
     */
    DatatableComponent.prototype.calcPageSize = function (val) {
        if (val === void 0) { val = this.rows; }
        // Keep the page size constant even if the row has been expanded.
        // This is because an expanded row is still considered to be a child of
        // the original row.  Hence calculation would use rowHeight only.
        if (this.scrollbarV) {
            var size = Math.ceil(this.bodyHeight / this.rowHeight);
            return Math.max(size, 0);
        }
        // if limit is passed, we are paging
        if (this.limit !== undefined)
            return this.limit;
        // otherwise use row length
        if (val)
            return val.length;
        // other empty :(
        return 0;
    };
    /**
     * Calculates the row count.
     *
     * @param {any[]} [val=this.rows]
     * @returns {number}
     *
     * @memberOf DatatableComponent
     */
    DatatableComponent.prototype.calcRowCount = function (val) {
        if (val === void 0) { val = this.rows; }
        if (!this.externalPaging) {
            if (!val)
                return 0;
            return val.length;
        }
        return this.count;
    };
    /**
     * The header triggered a contextmenu event.
     *
     * @param {*} { event, column }
     *
     * @memberOf DatatableComponent
     */
    DatatableComponent.prototype.onColumnContextmenu = function (_a) {
        var event = _a.event, column = _a.column;
        this.tableContextmenu.emit({ event: event, type: types_1.ContextmenuType.header, content: column });
    };
    /**
     * The body triggered a contextmenu event.
     *
     * @param {*} { event, row }
     *
     * @memberOf DatatableComponent
     */
    DatatableComponent.prototype.onRowContextmenu = function (_a) {
        var event = _a.event, row = _a.row;
        this.tableContextmenu.emit({ event: event, type: types_1.ContextmenuType.body, content: row });
    };
    /**
     * The header triggered a column resize event.
     *
     * @param {*} { column, newValue }
     *
     * @memberOf DatatableComponent
     */
    DatatableComponent.prototype.onColumnResize = function (_a) {
        var column = _a.column, newValue = _a.newValue;
        /* Safari/iOS 10.2 workaround */
        if (column === undefined) {
            return;
        }
        var idx;
        var cols = this.columns.map(function (c, i) {
            c = __assign({}, c);
            if (c.$$id === column.$$id) {
                idx = i;
                c.width = newValue;
                // set this so we can force the column
                // width distribution to be to this value
                c.$$oldWidth = newValue;
            }
            return c;
        });
        this.recalculateColumns(cols, idx);
        this._columns = cols;
        this.resize.emit({
            column: column,
            newValue: newValue
        });
    };
    /**
     * The header triggered a column re-order event.
     *
     * @param {*} { column, newValue, prevValue }
     *
     * @memberOf DatatableComponent
     */
    DatatableComponent.prototype.onColumnReorder = function (_a) {
        var column = _a.column, newValue = _a.newValue, prevValue = _a.prevValue;
        var cols = this.columns.map(function (c) {
            return __assign({}, c);
        });
        var prevCol = cols[newValue];
        cols[newValue] = column;
        cols[prevValue] = prevCol;
        this.columns = cols;
        this.reorder.emit({
            column: column,
            newValue: newValue,
            prevValue: prevValue
        });
    };
    /**
     * The header triggered a column sort event.
     *
     * @param {*} event
     *
     * @memberOf DatatableComponent
     */
    DatatableComponent.prototype.onColumnSort = function (event) {
        var sorts = event.sorts;
        // this could be optimized better since it will resort
        // the rows again on the 'push' detection...
        if (this.externalSorting === false) {
            // don't use normal setter so we don't resort
            this._rows = utils_1.sortRows(this.rows, this.columns, sorts);
        }
        this.sorts = sorts;
        // Always go to first page when sorting to see the newly sorted data
        this.offset = 0;
        this.bodyComponent.updateOffsetY(this.offset);
        this.sort.emit(event);
    };
    /**
     * Toggle all row selection
     *
     * @param {*} event
     *
     * @memberOf DatatableComponent
     */
    DatatableComponent.prototype.onHeaderSelect = function (event) {
        // before we splice, chk if we currently have all selected
        var allSelected = this.selected.length === this.rows.length;
        // remove all existing either way
        this.selected = [];
        // do the opposite here
        if (!allSelected) {
            (_a = this.selected).push.apply(_a, this.rows);
        }
        this.select.emit({
            selected: this.selected
        });
        var _a;
    };
    /**
     * A row was selected from body
     *
     * @param {*} event
     *
     * @memberOf DatatableComponent
     */
    DatatableComponent.prototype.onBodySelect = function (event) {
        this.select.emit(event);
    };
    return DatatableComponent;
}());
DatatableComponent.decorators = [
    { type: core_1.Component, args: [{
                selector: 'ngx-datatable',
                template: "\n    <div\n      visibilityObserver\n      (visible)=\"recalculate()\">\n      <datatable-header\n        *ngIf=\"headerHeight\"\n        [sorts]=\"sorts\"\n        [sortType]=\"sortType\"\n        [scrollbarH]=\"scrollbarH\"\n        [innerWidth]=\"innerWidth\"\n        [offsetX]=\"offsetX\"\n        [columns]=\"columns\"\n        [headerHeight]=\"headerHeight\"\n        [reorderable]=\"reorderable\"\n        [sortAscendingIcon]=\"cssClasses.sortAscending\"\n        [sortDescendingIcon]=\"cssClasses.sortDescending\"\n        [allRowsSelected]=\"allRowsSelected\"\n        [selectionType]=\"selectionType\"\n        (sort)=\"onColumnSort($event)\"\n        (resize)=\"onColumnResize($event)\"\n        (reorder)=\"onColumnReorder($event)\"\n        (select)=\"onHeaderSelect($event)\"\n        (columnContextmenu)=\"onColumnContextmenu($event)\">\n      </datatable-header>\n      <datatable-body\n        [rows]=\"rows\"\n        [scrollbarV]=\"scrollbarV\"\n        [scrollbarH]=\"scrollbarH\"\n        [loadingIndicator]=\"loadingIndicator\"\n        [externalPaging]=\"externalPaging\"\n        [rowHeight]=\"rowHeight\"\n        [rowCount]=\"rowCount\"\n        [offset]=\"offset\"\n        [trackByProp]=\"trackByProp\"\n        [columns]=\"columns\"\n        [pageSize]=\"pageSize\"\n        [offsetX]=\"offsetX\"\n        [rowDetail]=\"rowDetail\"\n        [selected]=\"selected\"\n        [innerWidth]=\"innerWidth\"\n        [bodyHeight]=\"bodyHeight\"\n        [selectionType]=\"selectionType\"\n        [emptyMessage]=\"messages.emptyMessage\"\n        [rowIdentity]=\"rowIdentity\"\n        [rowClass]=\"rowClass\"\n        [selectCheck]=\"selectCheck\"\n        (page)=\"onBodyPage($event)\"\n        (activate)=\"activate.emit($event)\"\n        (rowContextmenu)=\"onRowContextmenu($event)\"\n        (select)=\"onBodySelect($event)\"\n        (scroll)=\"onBodyScroll($event)\">\n      </datatable-body>\n      <datatable-footer\n        *ngIf=\"footerHeight\"\n        [rowCount]=\"rowCount\"\n        [pageSize]=\"pageSize\"\n        [offset]=\"offset\"\n        [footerHeight]=\"footerHeight\"\n        [footerTemplate]=\"footer\"\n        [totalMessage]=\"messages.totalMessage\"\n        [pagerLeftArrowIcon]=\"cssClasses.pagerLeftArrow\"\n        [pagerRightArrowIcon]=\"cssClasses.pagerRightArrow\"\n        [pagerPreviousIcon]=\"cssClasses.pagerPrevious\"\n        [selectedCount]=\"selected.length\"\n        [selectedMessage]=\"!!selectionType && messages.selectedMessage\"\n        [pagerNextIcon]=\"cssClasses.pagerNext\"\n        (page)=\"onFooterPage($event)\">\n      </datatable-footer>\n    </div>\n  ",
                encapsulation: core_1.ViewEncapsulation.None,
                styleUrls: ['./datatable.component.css'],
                host: {
                    class: 'ngx-datatable'
                }
            },] },
];
/** @nocollapse */
DatatableComponent.ctorParameters = function () { return [
    { type: services_1.ScrollbarHelper, },
    { type: core_1.ElementRef, },
    { type: core_1.KeyValueDiffers, },
]; };
DatatableComponent.propDecorators = {
    'rows': [{ type: core_1.Input },],
    'columns': [{ type: core_1.Input },],
    'selected': [{ type: core_1.Input },],
    'scrollbarV': [{ type: core_1.Input },],
    'scrollbarH': [{ type: core_1.Input },],
    'rowHeight': [{ type: core_1.Input },],
    'columnMode': [{ type: core_1.Input },],
    'headerHeight': [{ type: core_1.Input },],
    'footerHeight': [{ type: core_1.Input },],
    'externalPaging': [{ type: core_1.Input },],
    'externalSorting': [{ type: core_1.Input },],
    'limit': [{ type: core_1.Input },],
    'count': [{ type: core_1.Input },],
    'offset': [{ type: core_1.Input },],
    'loadingIndicator': [{ type: core_1.Input },],
    'selectionType': [{ type: core_1.Input },],
    'reorderable': [{ type: core_1.Input },],
    'sortType': [{ type: core_1.Input },],
    'sorts': [{ type: core_1.Input },],
    'cssClasses': [{ type: core_1.Input },],
    'messages': [{ type: core_1.Input },],
    'rowIdentity': [{ type: core_1.Input },],
    'rowClass': [{ type: core_1.Input },],
    'selectCheck': [{ type: core_1.Input },],
    'trackByProp': [{ type: core_1.Input },],
    'scroll': [{ type: core_1.Output },],
    'activate': [{ type: core_1.Output },],
    'select': [{ type: core_1.Output },],
    'sort': [{ type: core_1.Output },],
    'page': [{ type: core_1.Output },],
    'reorder': [{ type: core_1.Output },],
    'resize': [{ type: core_1.Output },],
    'tableContextmenu': [{ type: core_1.Output },],
    'isFixedHeader': [{ type: core_1.HostBinding, args: ['class.fixed-header',] },],
    'isFixedRow': [{ type: core_1.HostBinding, args: ['class.fixed-row',] },],
    'isVertScroll': [{ type: core_1.HostBinding, args: ['class.scroll-vertical',] },],
    'isHorScroll': [{ type: core_1.HostBinding, args: ['class.scroll-horz',] },],
    'isSelectable': [{ type: core_1.HostBinding, args: ['class.selectable',] },],
    'isCheckboxSelection': [{ type: core_1.HostBinding, args: ['class.checkbox-selection',] },],
    'isCellSelection': [{ type: core_1.HostBinding, args: ['class.cell-selection',] },],
    'isSingleSelection': [{ type: core_1.HostBinding, args: ['class.single-selection',] },],
    'isMultiSelection': [{ type: core_1.HostBinding, args: ['class.multi-selection',] },],
    'isMultiClickSelection': [{ type: core_1.HostBinding, args: ['class.multi-click-selection',] },],
    'columnTemplates': [{ type: core_1.ContentChildren, args: [columns_1.DataTableColumnDirective,] },],
    'rowDetail': [{ type: core_1.ContentChild, args: [row_detail_1.DatatableRowDetailDirective,] },],
    'footer': [{ type: core_1.ContentChild, args: [footer_1.DatatableFooterDirective,] },],
    'bodyComponent': [{ type: core_1.ViewChild, args: [body_1.DataTableBodyComponent,] },],
    'onWindowResize': [{ type: core_1.HostListener, args: ['window:resize',] },],
};
__decorate([
    utils_1.throttleable(5),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], DatatableComponent.prototype, "onWindowResize", null);
exports.DatatableComponent = DatatableComponent;
//# sourceMappingURL=datatable.component.js.map

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(2);
var DataTableFooterComponent = (function () {
    function DataTableFooterComponent() {
        this.selectedCount = 0;
        this.page = new core_1.EventEmitter();
    }
    Object.defineProperty(DataTableFooterComponent.prototype, "isVisible", {
        get: function () {
            return (this.rowCount / this.pageSize) > 1;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTableFooterComponent.prototype, "curPage", {
        get: function () {
            return this.offset + 1;
        },
        enumerable: true,
        configurable: true
    });
    return DataTableFooterComponent;
}());
DataTableFooterComponent.decorators = [
    { type: core_1.Component, args: [{
                selector: 'datatable-footer',
                template: "\n    <div\n      class=\"datatable-footer-inner\"\n      [ngClass]=\"{'selected-count': selectedMessage}\"\n      [style.height.px]=\"footerHeight\">\n      <ng-template\n        *ngIf=\"footerTemplate\"\n        [ngTemplateOutlet]=\"footerTemplate.template\"\n        [ngOutletContext]=\"{ \n          rowCount: rowCount, \n          pageSize: pageSize, \n          selectedCount: selectedCount,\n          curPage: curPage,\n          offset: offset\n        }\">\n      </ng-template>\n      <div class=\"page-count\" *ngIf=\"!footerTemplate\">\n        <span *ngIf=\"selectedMessage\">\n          {{selectedCount.toLocaleString()}} {{selectedMessage}} / \n        </span>\n        {{rowCount.toLocaleString()}} {{totalMessage}}\n      </div>\n      <datatable-pager *ngIf=\"!footerTemplate\"\n        [pagerLeftArrowIcon]=\"pagerLeftArrowIcon\"\n        [pagerRightArrowIcon]=\"pagerRightArrowIcon\"\n        [pagerPreviousIcon]=\"pagerPreviousIcon\"\n        [pagerNextIcon]=\"pagerNextIcon\"\n        [page]=\"curPage\"\n        [size]=\"pageSize\"\n        [count]=\"rowCount\"\n        [hidden]=\"!isVisible\"\n        (change)=\"page.emit($event)\">\n      </datatable-pager>\n    </div>\n  ",
                host: {
                    class: 'datatable-footer'
                },
                changeDetection: core_1.ChangeDetectionStrategy.OnPush
            },] },
];
/** @nocollapse */
DataTableFooterComponent.ctorParameters = function () { return []; };
DataTableFooterComponent.propDecorators = {
    'footerHeight': [{ type: core_1.Input },],
    'rowCount': [{ type: core_1.Input },],
    'pageSize': [{ type: core_1.Input },],
    'offset': [{ type: core_1.Input },],
    'pagerLeftArrowIcon': [{ type: core_1.Input },],
    'pagerRightArrowIcon': [{ type: core_1.Input },],
    'pagerPreviousIcon': [{ type: core_1.Input },],
    'pagerNextIcon': [{ type: core_1.Input },],
    'totalMessage': [{ type: core_1.Input },],
    'footerTemplate': [{ type: core_1.Input },],
    'selectedCount': [{ type: core_1.Input },],
    'selectedMessage': [{ type: core_1.Input },],
    'page': [{ type: core_1.Output },],
};
exports.DataTableFooterComponent = DataTableFooterComponent;
//# sourceMappingURL=footer.component.js.map

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(2);
var DataTablePagerComponent = (function () {
    function DataTablePagerComponent() {
        this.change = new core_1.EventEmitter();
        this._count = 0;
        this._page = 1;
        this._size = 0;
    }
    Object.defineProperty(DataTablePagerComponent.prototype, "size", {
        get: function () {
            return this._size;
        },
        set: function (val) {
            this._size = val;
            this.pages = this.calcPages();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTablePagerComponent.prototype, "count", {
        get: function () {
            return this._count;
        },
        set: function (val) {
            this._count = val;
            this.pages = this.calcPages();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTablePagerComponent.prototype, "page", {
        get: function () {
            return this._page;
        },
        set: function (val) {
            this._page = val;
            this.pages = this.calcPages();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTablePagerComponent.prototype, "totalPages", {
        get: function () {
            var count = this.size < 1 ? 1 : Math.ceil(this.count / this.size);
            return Math.max(count || 0, 1);
        },
        enumerable: true,
        configurable: true
    });
    DataTablePagerComponent.prototype.canPrevious = function () {
        return this.page > 1;
    };
    DataTablePagerComponent.prototype.canNext = function () {
        return this.page < this.totalPages;
    };
    DataTablePagerComponent.prototype.prevPage = function () {
        this.selectPage(this.page - 1);
    };
    DataTablePagerComponent.prototype.nextPage = function () {
        this.selectPage(this.page + 1);
    };
    DataTablePagerComponent.prototype.selectPage = function (page) {
        if (page > 0 && page <= this.totalPages && page !== this.page) {
            this.page = page;
            this.change.emit({
                page: page
            });
        }
    };
    DataTablePagerComponent.prototype.calcPages = function (page) {
        var pages = [];
        var startPage = 1;
        var endPage = this.totalPages;
        var maxSize = 5;
        var isMaxSized = maxSize < this.totalPages;
        page = page || this.page;
        if (isMaxSized) {
            startPage = ((Math.ceil(page / maxSize) - 1) * maxSize) + 1;
            endPage = Math.min(startPage + maxSize - 1, this.totalPages);
        }
        for (var num = startPage; num <= endPage; num++) {
            pages.push({
                number: num,
                text: num
            });
        }
        return pages;
    };
    return DataTablePagerComponent;
}());
DataTablePagerComponent.decorators = [
    { type: core_1.Component, args: [{
                selector: 'datatable-pager',
                template: "\n    <ul class=\"pager\">\n      <li [class.disabled]=\"!canPrevious()\">\n        <a\n          href=\"javascript:void(0)\"\n          (click)=\"selectPage(1)\">\n          <i class=\"{{pagerPreviousIcon}}\"></i>\n        </a>\n      </li>\n      <li [class.disabled]=\"!canPrevious()\">\n        <a\n          href=\"javascript:void(0)\"\n          (click)=\"prevPage()\">\n          <i class=\"{{pagerLeftArrowIcon}}\"></i>\n        </a>\n      </li>\n      <li\n        class=\"pages\"\n        *ngFor=\"let pg of pages\"\n        [class.active]=\"pg.number === page\">\n        <a\n          href=\"javascript:void(0)\"\n          (click)=\"selectPage(pg.number)\">\n          {{pg.text}}\n        </a>\n      </li>\n      <li [class.disabled]=\"!canNext()\">\n        <a\n          href=\"javascript:void(0)\"\n          (click)=\"nextPage()\">\n          <i class=\"{{pagerRightArrowIcon}}\"></i>\n        </a>\n      </li>\n      <li [class.disabled]=\"!canNext()\">\n        <a\n          href=\"javascript:void(0)\"\n          (click)=\"selectPage(totalPages)\">\n          <i class=\"{{pagerNextIcon}}\"></i>\n        </a>\n      </li>\n    </ul>\n  ",
                host: {
                    class: 'datatable-pager'
                },
                changeDetection: core_1.ChangeDetectionStrategy.OnPush
            },] },
];
/** @nocollapse */
DataTablePagerComponent.ctorParameters = function () { return []; };
DataTablePagerComponent.propDecorators = {
    'pagerLeftArrowIcon': [{ type: core_1.Input },],
    'pagerRightArrowIcon': [{ type: core_1.Input },],
    'pagerPreviousIcon': [{ type: core_1.Input },],
    'pagerNextIcon': [{ type: core_1.Input },],
    'size': [{ type: core_1.Input },],
    'count': [{ type: core_1.Input },],
    'page': [{ type: core_1.Input },],
    'change': [{ type: core_1.Output },],
};
exports.DataTablePagerComponent = DataTablePagerComponent;
//# sourceMappingURL=pager.component.js.map

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(2);
var types_1 = __webpack_require__(96);
var utils_1 = __webpack_require__(78);
var DataTableHeaderCellComponent = (function () {
    function DataTableHeaderCellComponent() {
        this.sort = new core_1.EventEmitter();
        this.select = new core_1.EventEmitter();
        this.columnContextmenu = new core_1.EventEmitter(false);
        this.sortFn = this.onSort.bind(this);
        this.selectFn = this.select.emit.bind(this.select);
    }
    Object.defineProperty(DataTableHeaderCellComponent.prototype, "sorts", {
        get: function () {
            return this._sorts;
        },
        set: function (val) {
            this._sorts = val;
            this.sortDir = this.calcSortDir(val);
            this.sortClass = this.calcSortClass(this.sortDir);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTableHeaderCellComponent.prototype, "columnCssClasses", {
        get: function () {
            var cls = 'datatable-header-cell';
            if (this.column.sortable)
                cls += ' sortable';
            if (this.column.resizeable)
                cls += ' resizeable';
            if (this.column.headerClass) {
                if (typeof this.column.headerClass === 'string') {
                    cls += ' ' + this.column.headerClass;
                }
                else if (typeof this.column.headerClass === 'function') {
                    var res = this.column.headerClass({
                        column: this.column
                    });
                    if (typeof res === 'string') {
                        cls += res;
                    }
                    else if (typeof res === 'object') {
                        var keys = Object.keys(res);
                        for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
                            var k = keys_1[_i];
                            if (res[k] === true)
                                cls += " " + k;
                        }
                    }
                }
            }
            var sortDir = this.sortDir;
            if (sortDir) {
                cls += " sort-active sort-" + sortDir;
            }
            return cls;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTableHeaderCellComponent.prototype, "name", {
        get: function () {
            // guaranteed to have a value by setColumnDefaults() in column-helper.ts
            return this.column.headerTemplate === undefined ? this.column.name : undefined;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTableHeaderCellComponent.prototype, "minWidth", {
        get: function () {
            return this.column.minWidth;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTableHeaderCellComponent.prototype, "maxWidth", {
        get: function () {
            return this.column.maxWidth;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTableHeaderCellComponent.prototype, "width", {
        get: function () {
            return this.column.width;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTableHeaderCellComponent.prototype, "isCheckboxable", {
        get: function () {
            return this.column.checkboxable &&
                this.column.headerCheckboxable &&
                this.selectionType === types_1.SelectionType.checkbox;
        },
        enumerable: true,
        configurable: true
    });
    DataTableHeaderCellComponent.prototype.onContextmenu = function ($event) {
        this.columnContextmenu.emit({ event: $event, column: this.column });
    };
    DataTableHeaderCellComponent.prototype.calcSortDir = function (sorts) {
        var _this = this;
        if (sorts && this.column) {
            var sort = sorts.find(function (s) {
                return s.prop === _this.column.prop;
            });
            if (sort)
                return sort.dir;
        }
    };
    DataTableHeaderCellComponent.prototype.onSort = function () {
        if (!this.column.sortable)
            return;
        var newValue = utils_1.nextSortDir(this.sortType, this.sortDir);
        this.sort.emit({
            column: this.column,
            prevValue: this.sortDir,
            newValue: newValue
        });
    };
    DataTableHeaderCellComponent.prototype.calcSortClass = function (sortDir) {
        if (sortDir === types_1.SortDirection.asc) {
            return "sort-btn sort-asc " + this.sortAscendingIcon;
        }
        else if (sortDir === types_1.SortDirection.desc) {
            return "sort-btn sort-desc " + this.sortDescendingIcon;
        }
        else {
            return "sort-btn";
        }
    };
    return DataTableHeaderCellComponent;
}());
DataTableHeaderCellComponent.decorators = [
    { type: core_1.Component, args: [{
                selector: 'datatable-header-cell',
                template: "\n    <div>\n      <label\n        *ngIf=\"isCheckboxable\" \n        class=\"datatable-checkbox\">\n        <input \n          type=\"checkbox\"\n          [checked]=\"allRowsSelected\"\n          (change)=\"select.emit(!allRowsSelected)\" \n        />\n      </label>\n      <span \n        *ngIf=\"!column.headerTemplate\"\n        class=\"datatable-header-cell-wrapper\">\n        <span\n          class=\"datatable-header-cell-label draggable\"\n          (click)=\"onSort()\"\n          [innerHTML]=\"name\">\n        </span>\n      </span>\n      <ng-template\n        *ngIf=\"column.headerTemplate\"\n        [ngTemplateOutlet]=\"column.headerTemplate\"\n        [ngOutletContext]=\"{ \n          column: column, \n          sortDir: sortDir,\n          sortFn: sortFn,\n          allRowsSelected: allRowsSelected,\n          selectFn: selectFn\n        }\">\n      </ng-template>\n      <span\n        (click)=\"onSort()\"\n        [class]=\"sortClass\">\n      </span>\n    </div>\n  ",
                host: {
                    class: 'datatable-header-cell'
                }
            },] },
];
/** @nocollapse */
DataTableHeaderCellComponent.ctorParameters = function () { return []; };
DataTableHeaderCellComponent.propDecorators = {
    'sortType': [{ type: core_1.Input },],
    'column': [{ type: core_1.Input },],
    'sortAscendingIcon': [{ type: core_1.Input },],
    'sortDescendingIcon': [{ type: core_1.Input },],
    'allRowsSelected': [{ type: core_1.Input },],
    'selectionType': [{ type: core_1.Input },],
    'headerHeight': [{ type: core_1.HostBinding, args: ['style.height.px',] }, { type: core_1.Input },],
    'sorts': [{ type: core_1.Input },],
    'sort': [{ type: core_1.Output },],
    'select': [{ type: core_1.Output },],
    'columnContextmenu': [{ type: core_1.Output },],
    'columnCssClasses': [{ type: core_1.HostBinding, args: ['class',] },],
    'name': [{ type: core_1.HostBinding, args: ['attr.title',] },],
    'minWidth': [{ type: core_1.HostBinding, args: ['style.minWidth.px',] },],
    'maxWidth': [{ type: core_1.HostBinding, args: ['style.maxWidth.px',] },],
    'width': [{ type: core_1.HostBinding, args: ['style.width.px',] },],
    'onContextmenu': [{ type: core_1.HostListener, args: ['contextmenu', ['$event'],] },],
};
exports.DataTableHeaderCellComponent = DataTableHeaderCellComponent;
//# sourceMappingURL=header-cell.component.js.map

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(2);
var types_1 = __webpack_require__(96);
var utils_1 = __webpack_require__(78);
var DataTableHeaderComponent = (function () {
    function DataTableHeaderComponent() {
        this.sort = new core_1.EventEmitter();
        this.reorder = new core_1.EventEmitter();
        this.resize = new core_1.EventEmitter();
        this.select = new core_1.EventEmitter();
        this.columnContextmenu = new core_1.EventEmitter(false);
    }
    Object.defineProperty(DataTableHeaderComponent.prototype, "headerHeight", {
        get: function () {
            return this._headerHeight;
        },
        set: function (val) {
            if (val !== 'auto') {
                this._headerHeight = val + "px";
            }
            else {
                this._headerHeight = val;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTableHeaderComponent.prototype, "columns", {
        get: function () {
            return this._columns;
        },
        set: function (val) {
            this._columns = val;
            var colsByPin = utils_1.columnsByPin(val);
            this.columnsByPin = utils_1.columnsByPinArr(val);
            this.columnGroupWidths = utils_1.columnGroupWidths(colsByPin, val);
        },
        enumerable: true,
        configurable: true
    });
    DataTableHeaderComponent.prototype.onLongPressStart = function (_a) {
        var event = _a.event, model = _a.model;
        model.dragging = true;
        this.dragEventTarget = event;
    };
    DataTableHeaderComponent.prototype.onLongPressEnd = function (_a) {
        var event = _a.event, model = _a.model;
        this.dragEventTarget = event;
        // delay resetting so sort can be 
        // prevented if we were dragging
        setTimeout(function () {
            model.dragging = false;
        }, 5);
    };
    Object.defineProperty(DataTableHeaderComponent.prototype, "headerWidth", {
        get: function () {
            if (this.scrollbarH) {
                return this.innerWidth + 'px';
            }
            return '100%';
        },
        enumerable: true,
        configurable: true
    });
    DataTableHeaderComponent.prototype.trackByGroups = function (index, colGroup) {
        return colGroup.type;
    };
    DataTableHeaderComponent.prototype.columnTrackingFn = function (index, column) {
        return column.$$id;
    };
    DataTableHeaderComponent.prototype.onColumnResized = function (width, column) {
        if (width <= column.minWidth) {
            width = column.minWidth;
        }
        else if (width >= column.maxWidth) {
            width = column.maxWidth;
        }
        this.resize.emit({
            column: column,
            prevValue: column.width,
            newValue: width
        });
    };
    DataTableHeaderComponent.prototype.onColumnReordered = function (_a) {
        var prevIndex = _a.prevIndex, newIndex = _a.newIndex, model = _a.model;
        this.reorder.emit({
            column: model,
            prevValue: prevIndex,
            newValue: newIndex
        });
    };
    DataTableHeaderComponent.prototype.onSort = function (_a) {
        var column = _a.column, prevValue = _a.prevValue, newValue = _a.newValue;
        // if we are dragging don't sort!
        if (column.dragging)
            return;
        var sorts = this.calcNewSorts(column, prevValue, newValue);
        this.sort.emit({
            sorts: sorts,
            column: column,
            prevValue: prevValue,
            newValue: newValue
        });
    };
    DataTableHeaderComponent.prototype.calcNewSorts = function (column, prevValue, newValue) {
        var idx = 0;
        if (!this.sorts) {
            this.sorts = [];
        }
        var sorts = this.sorts.map(function (s, i) {
            s = __assign({}, s);
            if (s.prop === column.prop)
                idx = i;
            return s;
        });
        if (newValue === undefined) {
            sorts.splice(idx, 1);
        }
        else if (prevValue) {
            sorts[idx].dir = newValue;
        }
        else {
            if (this.sortType === types_1.SortType.single) {
                sorts.splice(0, this.sorts.length);
            }
            sorts.push({ dir: newValue, prop: column.prop });
        }
        return sorts;
    };
    DataTableHeaderComponent.prototype.stylesByGroup = function (group) {
        var widths = this.columnGroupWidths;
        var offsetX = this.offsetX;
        var styles = {
            width: widths[group] + "px"
        };
        if (group === 'center') {
            utils_1.translateXY(styles, offsetX * -1, 0);
        }
        else if (group === 'right') {
            var totalDiff = widths.total - this.innerWidth;
            var offset = totalDiff * -1;
            utils_1.translateXY(styles, offset, 0);
        }
        return styles;
    };
    return DataTableHeaderComponent;
}());
DataTableHeaderComponent.decorators = [
    { type: core_1.Component, args: [{
                selector: 'datatable-header',
                template: "\n    <div\n      orderable\n      (reorder)=\"onColumnReordered($event)\"\n      [style.width.px]=\"columnGroupWidths.total\"\n      class=\"datatable-header-inner\">\n      <div\n        *ngFor=\"let colGroup of columnsByPin; trackBy: trackByGroups\"\n        [class]=\"'datatable-row-' + colGroup.type\"\n        [ngStyle]=\"stylesByGroup(colGroup.type)\">\n        <datatable-header-cell\n          *ngFor=\"let column of colGroup.columns; trackBy: columnTrackingFn\"\n          resizeable\n          [resizeEnabled]=\"column.resizeable\"\n          (resize)=\"onColumnResized($event, column)\"\n          long-press\n          [pressModel]=\"column\"\n          [pressEnabled]=\"reorderable && column.draggable\"\n          (longPressStart)=\"onLongPressStart($event)\"\n          (longPressEnd)=\"onLongPressEnd($event)\"\n          draggable\n          [dragX]=\"reorderable && column.draggable && column.dragging\"\n          [dragY]=\"false\"\n          [dragModel]=\"column\"\n          [dragEventTarget]=\"dragEventTarget\"\n          [headerHeight]=\"headerHeight\"\n          [column]=\"column\"\n          [sortType]=\"sortType\"\n          [sorts]=\"sorts\"\n          [selectionType]=\"selectionType\"\n          [sortAscendingIcon]=\"sortAscendingIcon\"\n          [sortDescendingIcon]=\"sortDescendingIcon\"\n          [allRowsSelected]=\"allRowsSelected\"\n          (sort)=\"onSort($event)\"\n          (select)=\"select.emit($event)\"\n          (columnContextmenu)=\"columnContextmenu.emit($event)\">\n        </datatable-header-cell>\n      </div>\n    </div>\n  ",
                host: {
                    class: 'datatable-header'
                }
            },] },
];
/** @nocollapse */
DataTableHeaderComponent.ctorParameters = function () { return []; };
DataTableHeaderComponent.propDecorators = {
    'sortAscendingIcon': [{ type: core_1.Input },],
    'sortDescendingIcon': [{ type: core_1.Input },],
    'scrollbarH': [{ type: core_1.Input },],
    'innerWidth': [{ type: core_1.Input },],
    'offsetX': [{ type: core_1.Input },],
    'sorts': [{ type: core_1.Input },],
    'sortType': [{ type: core_1.Input },],
    'allRowsSelected': [{ type: core_1.Input },],
    'selectionType': [{ type: core_1.Input },],
    'reorderable': [{ type: core_1.Input },],
    'headerHeight': [{ type: core_1.HostBinding, args: ['style.height',] }, { type: core_1.Input },],
    'columns': [{ type: core_1.Input },],
    'sort': [{ type: core_1.Output },],
    'reorder': [{ type: core_1.Output },],
    'resize': [{ type: core_1.Output },],
    'select': [{ type: core_1.Output },],
    'columnContextmenu': [{ type: core_1.Output },],
    'headerWidth': [{ type: core_1.HostBinding, args: ['style.width',] },],
};
exports.DataTableHeaderComponent = DataTableHeaderComponent;
//# sourceMappingURL=header.component.js.map

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(2);
var Observable_1 = __webpack_require__(0);
__webpack_require__(167);
/**
 * Draggable Directive for Angular2
 *
 * Inspiration:
 *   https://github.com/AngularClass/angular2-examples/blob/master/rx-draggable/directives/draggable.ts
 *   http://stackoverflow.com/questions/35662530/how-to-implement-drag-and-drop-in-angular2
 *
 */
var DraggableDirective = (function () {
    function DraggableDirective(element) {
        this.dragX = true;
        this.dragY = true;
        this.dragStart = new core_1.EventEmitter();
        this.dragging = new core_1.EventEmitter();
        this.dragEnd = new core_1.EventEmitter();
        this.isDragging = false;
        this.element = element.nativeElement;
    }
    DraggableDirective.prototype.ngOnChanges = function (changes) {
        if (changes['dragEventTarget'] && changes['dragEventTarget'].currentValue && this.dragModel.dragging) {
            this.onMousedown(changes['dragEventTarget'].currentValue);
        }
    };
    DraggableDirective.prototype.ngOnDestroy = function () {
        this._destroySubscription();
    };
    DraggableDirective.prototype.onMouseup = function (event) {
        if (!this.isDragging)
            return;
        this.isDragging = false;
        this.element.classList.remove('dragging');
        if (this.subscription) {
            this._destroySubscription();
            this.dragEnd.emit({
                event: event,
                element: this.element,
                model: this.dragModel
            });
        }
    };
    DraggableDirective.prototype.onMousedown = function (event) {
        var _this = this;
        // we only want to drag the inner header text
        var isDragElm = event.target.classList.contains('draggable');
        if (isDragElm && (this.dragX || this.dragY)) {
            event.preventDefault();
            this.isDragging = true;
            var mouseDownPos_1 = { x: event.clientX, y: event.clientY };
            var mouseup = Observable_1.Observable.fromEvent(document, 'mouseup');
            this.subscription = mouseup
                .subscribe(function (ev) { return _this.onMouseup(ev); });
            var mouseMoveSub = Observable_1.Observable.fromEvent(document, 'mousemove')
                .takeUntil(mouseup)
                .subscribe(function (ev) { return _this.move(ev, mouseDownPos_1); });
            this.subscription.add(mouseMoveSub);
            this.dragStart.emit({
                event: event,
                element: this.element,
                model: this.dragModel
            });
        }
    };
    DraggableDirective.prototype.move = function (event, mouseDownPos) {
        if (!this.isDragging)
            return;
        var x = event.clientX - mouseDownPos.x;
        var y = event.clientY - mouseDownPos.y;
        if (this.dragX)
            this.element.style.left = x + "px";
        if (this.dragY)
            this.element.style.top = y + "px";
        this.element.classList.add('dragging');
        this.dragging.emit({
            event: event,
            element: this.element,
            model: this.dragModel
        });
    };
    DraggableDirective.prototype._destroySubscription = function () {
        if (this.subscription) {
            this.subscription.unsubscribe();
            this.subscription = undefined;
        }
    };
    return DraggableDirective;
}());
DraggableDirective.decorators = [
    { type: core_1.Directive, args: [{ selector: '[draggable]' },] },
];
/** @nocollapse */
DraggableDirective.ctorParameters = function () { return [
    { type: core_1.ElementRef, },
]; };
DraggableDirective.propDecorators = {
    'dragEventTarget': [{ type: core_1.Input },],
    'dragModel': [{ type: core_1.Input },],
    'dragX': [{ type: core_1.Input },],
    'dragY': [{ type: core_1.Input },],
    'dragStart': [{ type: core_1.Output },],
    'dragging': [{ type: core_1.Output },],
    'dragEnd': [{ type: core_1.Output },],
};
exports.DraggableDirective = DraggableDirective;
//# sourceMappingURL=draggable.directive.js.map

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(95));
//# sourceMappingURL=index.js.map

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// maybe rename this file to prop-getters.ts
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Always returns the empty string ''
 * @returns {string}
 */
function emptyStringGetter() {
    return '';
}
exports.emptyStringGetter = emptyStringGetter;
/**
 * Returns the appropriate getter function for this kind of prop.
 * If prop == null, returns the emptyStringGetter.
 */
function getterForProp(prop) {
    if (prop == null)
        return emptyStringGetter;
    if (typeof prop === 'number') {
        return numericIndexGetter;
    }
    else {
        // deep or simple
        if (prop.indexOf('.') !== -1) {
            return deepValueGetter;
        }
        else {
            return shallowValueGetter;
        }
    }
}
exports.getterForProp = getterForProp;
/**
 * Returns the value at this numeric index.
 * @param row array of values
 * @param index numeric index
 * @returns {any} or '' if invalid index
 */
function numericIndexGetter(row, index) {
    // mimic behavior of deepValueGetter
    if (!row || index == null)
        return row;
    var value = row[index];
    if (value == null)
        return '';
    return value;
}
exports.numericIndexGetter = numericIndexGetter;
/**
 * Returns the value of a field.
 * (more efficient than deepValueGetter)
 * @param obj object containing the field
 * @param fieldName field name string
 * @returns {any}
 */
function shallowValueGetter(obj, fieldName) {
    if (!obj || !fieldName)
        return obj;
    var value = obj[fieldName];
    if (value == null)
        return '';
    return value;
}
exports.shallowValueGetter = shallowValueGetter;
/**
 * Returns a deep object given a string. zoo['animal.type']
 * @param {object} obj
 * @param {string} path
 */
function deepValueGetter(obj, path) {
    if (!obj || !path)
        return obj;
    // check if path matches a root-level field
    // { "a.b.c": 123 }
    var current = obj[path];
    if (current !== undefined)
        return current;
    current = obj;
    var split = path.split('.');
    if (split.length) {
        for (var i = 0; i < split.length; i++) {
            current = current[split[i]];
            // if found undefined, return empty string
            if (current === undefined || current === null)
                return '';
        }
    }
    return current;
}
exports.deepValueGetter = deepValueGetter;
//# sourceMappingURL=column-prop-getters.js.map

/***/ }),
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(113);


/* harmony default export */ __webpack_exports__["a"] = (function(values, p, valueof) {
  if (valueof == null) valueof = __WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */];
  if (!(n = values.length)) return;
  if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
  if (p >= 1) return +valueof(values[n - 1], n - 1, values);
  var n,
      i = (n - 1) * p,
      i0 = Math.floor(i),
      value0 = +valueof(values[i0], i0, values),
      value1 = +valueof(values[i0 + 1], i0 + 1, values);
  return value0 + (value1 - value0) * (i - i0);
});


/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return prefix; });
var prefix = "$";

function Map() {}

Map.prototype = map.prototype = {
  constructor: Map,
  has: function(key) {
    return (prefix + key) in this;
  },
  get: function(key) {
    return this[prefix + key];
  },
  set: function(key, value) {
    this[prefix + key] = value;
    return this;
  },
  remove: function(key) {
    var property = prefix + key;
    return property in this && delete this[property];
  },
  clear: function() {
    for (var property in this) if (property[0] === prefix) delete this[property];
  },
  keys: function() {
    var keys = [];
    for (var property in this) if (property[0] === prefix) keys.push(property.slice(1));
    return keys;
  },
  values: function() {
    var values = [];
    for (var property in this) if (property[0] === prefix) values.push(this[property]);
    return values;
  },
  entries: function() {
    var entries = [];
    for (var property in this) if (property[0] === prefix) entries.push({key: property.slice(1), value: this[property]});
    return entries;
  },
  size: function() {
    var size = 0;
    for (var property in this) if (property[0] === prefix) ++size;
    return size;
  },
  empty: function() {
    for (var property in this) if (property[0] === prefix) return false;
    return true;
  },
  each: function(f) {
    for (var property in this) if (property[0] === prefix) f(this[property], property.slice(1), this);
  }
};

function map(object, f) {
  var map = new Map;

  // Copy constructor.
  if (object instanceof Map) object.each(function(value, key) { map.set(key, value); });

  // Index array by numeric index or specified key function.
  else if (Array.isArray(object)) {
    var i = -1,
        n = object.length,
        o;

    if (f == null) while (++i < n) map.set(i, object[i]);
    else while (++i < n) map.set(f(o = object[i], i, object), o);
  }

  // Convert object to map.
  else if (object) for (var key in object) map.set(key, object[key]);

  return map;
}

/* harmony default export */ __webpack_exports__["a"] = (map);


/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = Color;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return darker; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return brighter; });
/* harmony export (immutable) */ __webpack_exports__["a"] = color;
/* harmony export (immutable) */ __webpack_exports__["c"] = rgbConvert;
/* harmony export (immutable) */ __webpack_exports__["h"] = rgb;
/* harmony export (immutable) */ __webpack_exports__["b"] = Rgb;
/* unused harmony export hslConvert */
/* harmony export (immutable) */ __webpack_exports__["g"] = hsl;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__define__ = __webpack_require__(232);


function Color() {}

var darker = 0.7;
var brighter = 1 / darker;

var reI = "\\s*([+-]?\\d+)\\s*",
    reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*",
    reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*",
    reHex3 = /^#([0-9a-f]{3})$/,
    reHex6 = /^#([0-9a-f]{6})$/,
    reRgbInteger = new RegExp("^rgb\\(" + [reI, reI, reI] + "\\)$"),
    reRgbPercent = new RegExp("^rgb\\(" + [reP, reP, reP] + "\\)$"),
    reRgbaInteger = new RegExp("^rgba\\(" + [reI, reI, reI, reN] + "\\)$"),
    reRgbaPercent = new RegExp("^rgba\\(" + [reP, reP, reP, reN] + "\\)$"),
    reHslPercent = new RegExp("^hsl\\(" + [reN, reP, reP] + "\\)$"),
    reHslaPercent = new RegExp("^hsla\\(" + [reN, reP, reP, reN] + "\\)$");

var named = {
  aliceblue: 0xf0f8ff,
  antiquewhite: 0xfaebd7,
  aqua: 0x00ffff,
  aquamarine: 0x7fffd4,
  azure: 0xf0ffff,
  beige: 0xf5f5dc,
  bisque: 0xffe4c4,
  black: 0x000000,
  blanchedalmond: 0xffebcd,
  blue: 0x0000ff,
  blueviolet: 0x8a2be2,
  brown: 0xa52a2a,
  burlywood: 0xdeb887,
  cadetblue: 0x5f9ea0,
  chartreuse: 0x7fff00,
  chocolate: 0xd2691e,
  coral: 0xff7f50,
  cornflowerblue: 0x6495ed,
  cornsilk: 0xfff8dc,
  crimson: 0xdc143c,
  cyan: 0x00ffff,
  darkblue: 0x00008b,
  darkcyan: 0x008b8b,
  darkgoldenrod: 0xb8860b,
  darkgray: 0xa9a9a9,
  darkgreen: 0x006400,
  darkgrey: 0xa9a9a9,
  darkkhaki: 0xbdb76b,
  darkmagenta: 0x8b008b,
  darkolivegreen: 0x556b2f,
  darkorange: 0xff8c00,
  darkorchid: 0x9932cc,
  darkred: 0x8b0000,
  darksalmon: 0xe9967a,
  darkseagreen: 0x8fbc8f,
  darkslateblue: 0x483d8b,
  darkslategray: 0x2f4f4f,
  darkslategrey: 0x2f4f4f,
  darkturquoise: 0x00ced1,
  darkviolet: 0x9400d3,
  deeppink: 0xff1493,
  deepskyblue: 0x00bfff,
  dimgray: 0x696969,
  dimgrey: 0x696969,
  dodgerblue: 0x1e90ff,
  firebrick: 0xb22222,
  floralwhite: 0xfffaf0,
  forestgreen: 0x228b22,
  fuchsia: 0xff00ff,
  gainsboro: 0xdcdcdc,
  ghostwhite: 0xf8f8ff,
  gold: 0xffd700,
  goldenrod: 0xdaa520,
  gray: 0x808080,
  green: 0x008000,
  greenyellow: 0xadff2f,
  grey: 0x808080,
  honeydew: 0xf0fff0,
  hotpink: 0xff69b4,
  indianred: 0xcd5c5c,
  indigo: 0x4b0082,
  ivory: 0xfffff0,
  khaki: 0xf0e68c,
  lavender: 0xe6e6fa,
  lavenderblush: 0xfff0f5,
  lawngreen: 0x7cfc00,
  lemonchiffon: 0xfffacd,
  lightblue: 0xadd8e6,
  lightcoral: 0xf08080,
  lightcyan: 0xe0ffff,
  lightgoldenrodyellow: 0xfafad2,
  lightgray: 0xd3d3d3,
  lightgreen: 0x90ee90,
  lightgrey: 0xd3d3d3,
  lightpink: 0xffb6c1,
  lightsalmon: 0xffa07a,
  lightseagreen: 0x20b2aa,
  lightskyblue: 0x87cefa,
  lightslategray: 0x778899,
  lightslategrey: 0x778899,
  lightsteelblue: 0xb0c4de,
  lightyellow: 0xffffe0,
  lime: 0x00ff00,
  limegreen: 0x32cd32,
  linen: 0xfaf0e6,
  magenta: 0xff00ff,
  maroon: 0x800000,
  mediumaquamarine: 0x66cdaa,
  mediumblue: 0x0000cd,
  mediumorchid: 0xba55d3,
  mediumpurple: 0x9370db,
  mediumseagreen: 0x3cb371,
  mediumslateblue: 0x7b68ee,
  mediumspringgreen: 0x00fa9a,
  mediumturquoise: 0x48d1cc,
  mediumvioletred: 0xc71585,
  midnightblue: 0x191970,
  mintcream: 0xf5fffa,
  mistyrose: 0xffe4e1,
  moccasin: 0xffe4b5,
  navajowhite: 0xffdead,
  navy: 0x000080,
  oldlace: 0xfdf5e6,
  olive: 0x808000,
  olivedrab: 0x6b8e23,
  orange: 0xffa500,
  orangered: 0xff4500,
  orchid: 0xda70d6,
  palegoldenrod: 0xeee8aa,
  palegreen: 0x98fb98,
  paleturquoise: 0xafeeee,
  palevioletred: 0xdb7093,
  papayawhip: 0xffefd5,
  peachpuff: 0xffdab9,
  peru: 0xcd853f,
  pink: 0xffc0cb,
  plum: 0xdda0dd,
  powderblue: 0xb0e0e6,
  purple: 0x800080,
  rebeccapurple: 0x663399,
  red: 0xff0000,
  rosybrown: 0xbc8f8f,
  royalblue: 0x4169e1,
  saddlebrown: 0x8b4513,
  salmon: 0xfa8072,
  sandybrown: 0xf4a460,
  seagreen: 0x2e8b57,
  seashell: 0xfff5ee,
  sienna: 0xa0522d,
  silver: 0xc0c0c0,
  skyblue: 0x87ceeb,
  slateblue: 0x6a5acd,
  slategray: 0x708090,
  slategrey: 0x708090,
  snow: 0xfffafa,
  springgreen: 0x00ff7f,
  steelblue: 0x4682b4,
  tan: 0xd2b48c,
  teal: 0x008080,
  thistle: 0xd8bfd8,
  tomato: 0xff6347,
  turquoise: 0x40e0d0,
  violet: 0xee82ee,
  wheat: 0xf5deb3,
  white: 0xffffff,
  whitesmoke: 0xf5f5f5,
  yellow: 0xffff00,
  yellowgreen: 0x9acd32
};

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Color, color, {
  displayable: function() {
    return this.rgb().displayable();
  },
  toString: function() {
    return this.rgb() + "";
  }
});

function color(format) {
  var m;
  format = (format + "").trim().toLowerCase();
  return (m = reHex3.exec(format)) ? (m = parseInt(m[1], 16), new Rgb((m >> 8 & 0xf) | (m >> 4 & 0x0f0), (m >> 4 & 0xf) | (m & 0xf0), ((m & 0xf) << 4) | (m & 0xf), 1)) // #f00
      : (m = reHex6.exec(format)) ? rgbn(parseInt(m[1], 16)) // #ff0000
      : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
      : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
      : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
      : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
      : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
      : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
      : named.hasOwnProperty(format) ? rgbn(named[format])
      : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0)
      : null;
}

function rgbn(n) {
  return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}

function rgba(r, g, b, a) {
  if (a <= 0) r = g = b = NaN;
  return new Rgb(r, g, b, a);
}

function rgbConvert(o) {
  if (!(o instanceof Color)) o = color(o);
  if (!o) return new Rgb;
  o = o.rgb();
  return new Rgb(o.r, o.g, o.b, o.opacity);
}

function rgb(r, g, b, opacity) {
  return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}

function Rgb(r, g, b, opacity) {
  this.r = +r;
  this.g = +g;
  this.b = +b;
  this.opacity = +opacity;
}

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Rgb, rgb, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define__["b" /* extend */])(Color, {
  brighter: function(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  rgb: function() {
    return this;
  },
  displayable: function() {
    return (0 <= this.r && this.r <= 255)
        && (0 <= this.g && this.g <= 255)
        && (0 <= this.b && this.b <= 255)
        && (0 <= this.opacity && this.opacity <= 1);
  },
  toString: function() {
    var a = this.opacity; a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
    return (a === 1 ? "rgb(" : "rgba(")
        + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", "
        + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", "
        + Math.max(0, Math.min(255, Math.round(this.b) || 0))
        + (a === 1 ? ")" : ", " + a + ")");
  }
}));

function hsla(h, s, l, a) {
  if (a <= 0) h = s = l = NaN;
  else if (l <= 0 || l >= 1) h = s = NaN;
  else if (s <= 0) h = NaN;
  return new Hsl(h, s, l, a);
}

function hslConvert(o) {
  if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof Color)) o = color(o);
  if (!o) return new Hsl;
  if (o instanceof Hsl) return o;
  o = o.rgb();
  var r = o.r / 255,
      g = o.g / 255,
      b = o.b / 255,
      min = Math.min(r, g, b),
      max = Math.max(r, g, b),
      h = NaN,
      s = max - min,
      l = (max + min) / 2;
  if (s) {
    if (r === max) h = (g - b) / s + (g < b) * 6;
    else if (g === max) h = (b - r) / s + 2;
    else h = (r - g) / s + 4;
    s /= l < 0.5 ? max + min : 2 - max - min;
    h *= 60;
  } else {
    s = l > 0 && l < 1 ? 0 : h;
  }
  return new Hsl(h, s, l, o.opacity);
}

function hsl(h, s, l, opacity) {
  return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}

function Hsl(h, s, l, opacity) {
  this.h = +h;
  this.s = +s;
  this.l = +l;
  this.opacity = +opacity;
}

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Hsl, hsl, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define__["b" /* extend */])(Color, {
  brighter: function(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Hsl(this.h, this.s, this.l * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Hsl(this.h, this.s, this.l * k, this.opacity);
  },
  rgb: function() {
    var h = this.h % 360 + (this.h < 0) * 360,
        s = isNaN(h) || isNaN(this.s) ? 0 : this.s,
        l = this.l,
        m2 = l + (l < 0.5 ? l : 1 - l) * s,
        m1 = 2 * l - m2;
    return new Rgb(
      hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2),
      hsl2rgb(h, m1, m2),
      hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2),
      this.opacity
    );
  },
  displayable: function() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s))
        && (0 <= this.l && this.l <= 1)
        && (0 <= this.opacity && this.opacity <= 1);
  }
}));

/* From FvD 13.37, CSS Color Module Level 3 */
function hsl2rgb(h, m1, m2) {
  return (h < 60 ? m1 + (m2 - m1) * h / 60
      : h < 180 ? m2
      : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60
      : m1) * 255;
}


/***/ }),
/* 232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = extend;
/* harmony default export */ __webpack_exports__["a"] = (function(constructor, factory, prototype) {
  constructor.prototype = factory.prototype = prototype;
  prototype.constructor = constructor;
});

function extend(parent, definition) {
  var prototype = Object.create(parent.prototype);
  for (var key in definition) prototype[key] = definition[key];
  return prototype;
}


/***/ }),
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_drag__ = __webpack_require__(840);
/* unused harmony reexport drag */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_nodrag__ = __webpack_require__(390);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__src_nodrag__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__src_nodrag__["b"]; });




/***/ }),
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_dsv__ = __webpack_require__(235);
/* unused harmony reexport dsvFormat */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_csv__ = __webpack_require__(842);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__src_csv__["a"]; });
/* unused harmony reexport csvParseRows */
/* unused harmony reexport csvFormat */
/* unused harmony reexport csvFormatRows */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_tsv__ = __webpack_require__(843);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__src_tsv__["a"]; });
/* unused harmony reexport tsvParseRows */
/* unused harmony reexport tsvFormat */
/* unused harmony reexport tsvFormatRows */





/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var EOL = {},
    EOF = {},
    QUOTE = 34,
    NEWLINE = 10,
    RETURN = 13;

function objectConverter(columns) {
  return new Function("d", "return {" + columns.map(function(name, i) {
    return JSON.stringify(name) + ": d[" + i + "]";
  }).join(",") + "}");
}

function customConverter(columns, f) {
  var object = objectConverter(columns);
  return function(row, i) {
    return f(object(row), i, columns);
  };
}

// Compute unique columns in order of discovery.
function inferColumns(rows) {
  var columnSet = Object.create(null),
      columns = [];

  rows.forEach(function(row) {
    for (var column in row) {
      if (!(column in columnSet)) {
        columns.push(columnSet[column] = column);
      }
    }
  });

  return columns;
}

/* harmony default export */ __webpack_exports__["a"] = (function(delimiter) {
  var reFormat = new RegExp("[\"" + delimiter + "\n\r]"),
      DELIMITER = delimiter.charCodeAt(0);

  function parse(text, f) {
    var convert, columns, rows = parseRows(text, function(row, i) {
      if (convert) return convert(row, i - 1);
      columns = row, convert = f ? customConverter(row, f) : objectConverter(row);
    });
    rows.columns = columns || [];
    return rows;
  }

  function parseRows(text, f) {
    var rows = [], // output rows
        N = text.length,
        I = 0, // current character index
        n = 0, // current line number
        t, // current token
        eof = N <= 0, // current token followed by EOF?
        eol = false; // current token followed by EOL?

    // Strip the trailing newline.
    if (text.charCodeAt(N - 1) === NEWLINE) --N;
    if (text.charCodeAt(N - 1) === RETURN) --N;

    function token() {
      if (eof) return EOF;
      if (eol) return eol = false, EOL;

      // Unescape quotes.
      var i, j = I, c;
      if (text.charCodeAt(j) === QUOTE) {
        while (I++ < N && text.charCodeAt(I) !== QUOTE || text.charCodeAt(++I) === QUOTE);
        if ((i = I) >= N) eof = true;
        else if ((c = text.charCodeAt(I++)) === NEWLINE) eol = true;
        else if (c === RETURN) { eol = true; if (text.charCodeAt(I) === NEWLINE) ++I; }
        return text.slice(j + 1, i - 1).replace(/""/g, "\"");
      }

      // Find next delimiter or newline.
      while (I < N) {
        if ((c = text.charCodeAt(i = I++)) === NEWLINE) eol = true;
        else if (c === RETURN) { eol = true; if (text.charCodeAt(I) === NEWLINE) ++I; }
        else if (c !== DELIMITER) continue;
        return text.slice(j, i);
      }

      // Return last token before EOF.
      return eof = true, text.slice(j, N);
    }

    while ((t = token()) !== EOF) {
      var row = [];
      while (t !== EOL && t !== EOF) row.push(t), t = token();
      if (f && (row = f(row, n++)) == null) continue;
      rows.push(row);
    }

    return rows;
  }

  function format(rows, columns) {
    if (columns == null) columns = inferColumns(rows);
    return [columns.map(formatValue).join(delimiter)].concat(rows.map(function(row) {
      return columns.map(function(column) {
        return formatValue(row[column]);
      }).join(delimiter);
    })).join("\n");
  }

  function formatRows(rows) {
    return rows.map(formatRow).join("\n");
  }

  function formatRow(row) {
    return row.map(formatValue).join(delimiter);
  }

  function formatValue(text) {
    return text == null ? ""
        : reFormat.test(text += "") ? "\"" + text.replace(/"/g, "\"\"") + "\""
        : text;
  }

  return {
    parse: parse,
    parseRows: parseRows,
    format: format,
    formatRows: formatRows
  };
});


/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  return (Math.random() - 0.5) * 1e-6;
});


/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__ = __webpack_require__(862);
/* unused harmony reexport formatDefaultLocale */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_locale__ = __webpack_require__(397);
/* unused harmony reexport formatLocale */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_formatSpecifier__ = __webpack_require__(395);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__src_formatSpecifier__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_precisionFixed__ = __webpack_require__(868);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_3__src_precisionFixed__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_precisionPrefix__ = __webpack_require__(869);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_4__src_precisionPrefix__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_precisionRound__ = __webpack_require__(870);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_5__src_precisionRound__["a"]; });








/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Computes the decimal coefficient and exponent of the specified number x with
// significant digits p, where x is positive and p is in [1, 21] or undefined.
// For example, formatDecimal(1.23) returns ["123", 0].
/* harmony default export */ __webpack_exports__["a"] = (function(x, p) {
  if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
  var i, coefficient = x.slice(0, i);

  // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
  // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
  return [
    coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
    +x.slice(i + 1)
  ];
});


/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return x;
});


/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = conicProjection;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(51);



function conicProjection(projectAt) {
  var phi0 = 0,
      phi1 = __WEBPACK_IMPORTED_MODULE_0__math__["a" /* pi */] / 3,
      m = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__index__["b" /* projectionMutator */])(projectAt),
      p = m(phi0, phi1);

  p.parallels = function(_) {
    return arguments.length ? m(phi0 = _[0] * __WEBPACK_IMPORTED_MODULE_0__math__["g" /* radians */], phi1 = _[1] * __WEBPACK_IMPORTED_MODULE_0__math__["g" /* radians */]) : [phi0 * __WEBPACK_IMPORTED_MODULE_0__math__["h" /* degrees */], phi1 * __WEBPACK_IMPORTED_MODULE_0__math__["h" /* degrees */]];
  };

  return p;
}


/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export conicEqualAreaRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__conic__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cylindricalEqualArea__ = __webpack_require__(891);




function conicEqualAreaRaw(y0, y1) {
  var sy0 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* sin */])(y0), n = (sy0 + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* sin */])(y1)) / 2;

  // Are the parallels symmetrical around the Equator?
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["o" /* abs */])(n) < __WEBPACK_IMPORTED_MODULE_0__math__["p" /* epsilon */]) return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cylindricalEqualArea__["a" /* cylindricalEqualAreaRaw */])(y0);

  var c = 1 + sy0 * (2 * n - sy0), r0 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["n" /* sqrt */])(c) / n;

  function project(x, y) {
    var r = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["n" /* sqrt */])(c - 2 * n * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* sin */])(y)) / n;
    return [r * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* sin */])(x *= n), r0 - r * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* cos */])(x)];
  }

  project.invert = function(x, y) {
    var r0y = r0 - y;
    return [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["e" /* atan2 */])(x, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["o" /* abs */])(r0y)) / n * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["s" /* sign */])(r0y), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["f" /* asin */])((c - (x * x + r0y * r0y) * n * n) / (2 * n))];
  };

  return project;
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__conic__["a" /* conicProjection */])(conicEqualAreaRaw)
      .scale(155.424)
      .center([0, 33.6442]);
});


/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = fitExtent;
/* harmony export (immutable) */ __webpack_exports__["b"] = fitSize;
/* harmony export (immutable) */ __webpack_exports__["c"] = fitWidth;
/* harmony export (immutable) */ __webpack_exports__["d"] = fitHeight;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stream__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__path_bounds__ = __webpack_require__(408);



function fit(projection, fitBounds, object) {
  var clip = projection.clipExtent && projection.clipExtent();
  projection.scale(150).translate([0, 0]);
  if (clip != null) projection.clipExtent(null);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__stream__["a" /* default */])(object, projection.stream(__WEBPACK_IMPORTED_MODULE_1__path_bounds__["a" /* default */]));
  fitBounds(__WEBPACK_IMPORTED_MODULE_1__path_bounds__["a" /* default */].result());
  if (clip != null) projection.clipExtent(clip);
  return projection;
}

function fitExtent(projection, extent, object) {
  return fit(projection, function(b) {
    var w = extent[1][0] - extent[0][0],
        h = extent[1][1] - extent[0][1],
        k = Math.min(w / (b[1][0] - b[0][0]), h / (b[1][1] - b[0][1])),
        x = +extent[0][0] + (w - k * (b[1][0] + b[0][0])) / 2,
        y = +extent[0][1] + (h - k * (b[1][1] + b[0][1])) / 2;
    projection.scale(150 * k).translate([x, y]);
  }, object);
}

function fitSize(projection, size, object) {
  return fitExtent(projection, [[0, 0], size], object);
}

function fitWidth(projection, width, object) {
  return fit(projection, function(b) {
    var w = +width,
        k = w / (b[1][0] - b[0][0]),
        x = (w - k * (b[1][0] + b[0][0])) / 2,
        y = -k * b[0][1];
    projection.scale(150 * k).translate([x, y]);
  }, object);
}

function fitHeight(projection, height, object) {
  return fit(projection, function(b) {
    var h = +height,
        k = h / (b[1][1] - b[0][1]),
        x = -k * b[0][0],
        y = (h - k * (b[1][1] + b[0][1])) / 2;
    projection.scale(150 * k).translate([x, y]);
  }, object);
}


/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = mercatorRaw;
/* harmony export (immutable) */ __webpack_exports__["a"] = mercatorProjection;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rotation__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index__ = __webpack_require__(51);




function mercatorRaw(lambda, phi) {
  return [lambda, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["i" /* log */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["j" /* tan */])((__WEBPACK_IMPORTED_MODULE_0__math__["k" /* halfPi */] + phi) / 2))];
}

mercatorRaw.invert = function(x, y) {
  return [x, 2 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["l" /* atan */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["m" /* exp */])(y)) - __WEBPACK_IMPORTED_MODULE_0__math__["k" /* halfPi */]];
};

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  return mercatorProjection(mercatorRaw)
      .scale(961 / __WEBPACK_IMPORTED_MODULE_0__math__["b" /* tau */]);
});

function mercatorProjection(project) {
  var m = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__index__["a" /* default */])(project),
      center = m.center,
      scale = m.scale,
      translate = m.translate,
      clipExtent = m.clipExtent,
      x0 = null, y0, x1, y1; // clip extent

  m.scale = function(_) {
    return arguments.length ? (scale(_), reclip()) : scale();
  };

  m.translate = function(_) {
    return arguments.length ? (translate(_), reclip()) : translate();
  };

  m.center = function(_) {
    return arguments.length ? (center(_), reclip()) : center();
  };

  m.clipExtent = function(_) {
    return arguments.length ? ((_ == null ? x0 = y0 = x1 = y1 = null : (x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1])), reclip()) : x0 == null ? null : [[x0, y0], [x1, y1]];
  };

  function reclip() {
    var k = __WEBPACK_IMPORTED_MODULE_0__math__["a" /* pi */] * scale(),
        t = m(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__rotation__["a" /* default */])(m.rotate()).invert([0, 0]));
    return clipExtent(x0 == null
        ? [[t[0] - k, t[1] - k], [t[0] + k, t[1] + k]] : project === mercatorRaw
        ? [[Math.max(t[0] - k, x0), y0], [Math.min(t[0] + k, x1), y1]]
        : [[x0, Math.max(t[1] - k, y0)], [x1, Math.min(t[1] + k, y1)]]);
  }

  return reclip();
}


/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = optional;
/* harmony export (immutable) */ __webpack_exports__["a"] = required;
function optional(f) {
  return f == null ? null : required(f);
}

function required(f) {
  if (typeof f !== "function") throw new Error;
  return f;
}


/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony export (immutable) */ __webpack_exports__["b"] = computeHeight;
/* harmony export (immutable) */ __webpack_exports__["a"] = Node;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__count__ = __webpack_require__(903);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__each__ = __webpack_require__(905);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__eachBefore__ = __webpack_require__(907);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__eachAfter__ = __webpack_require__(906);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__sum__ = __webpack_require__(912);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__sort__ = __webpack_require__(911);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__path__ = __webpack_require__(910);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ancestors__ = __webpack_require__(902);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__descendants__ = __webpack_require__(904);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__leaves__ = __webpack_require__(908);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__links__ = __webpack_require__(909);












function hierarchy(data, children) {
  var root = new Node(data),
      valued = +data.value && (root.value = data.value),
      node,
      nodes = [root],
      child,
      childs,
      i,
      n;

  if (children == null) children = defaultChildren;

  while (node = nodes.pop()) {
    if (valued) node.value = +node.data.value;
    if ((childs = children(node.data)) && (n = childs.length)) {
      node.children = new Array(n);
      for (i = n - 1; i >= 0; --i) {
        nodes.push(child = node.children[i] = new Node(childs[i]));
        child.parent = node;
        child.depth = node.depth + 1;
      }
    }
  }

  return root.eachBefore(computeHeight);
}

function node_copy() {
  return hierarchy(this).eachBefore(copyData);
}

function defaultChildren(d) {
  return d.children;
}

function copyData(node) {
  node.data = node.data.data;
}

function computeHeight(node) {
  var height = 0;
  do node.height = height;
  while ((node = node.parent) && (node.height < ++height));
}

function Node(data) {
  this.data = data;
  this.depth =
  this.height = 0;
  this.parent = null;
}

Node.prototype = hierarchy.prototype = {
  constructor: Node,
  count: __WEBPACK_IMPORTED_MODULE_0__count__["a" /* default */],
  each: __WEBPACK_IMPORTED_MODULE_1__each__["a" /* default */],
  eachAfter: __WEBPACK_IMPORTED_MODULE_3__eachAfter__["a" /* default */],
  eachBefore: __WEBPACK_IMPORTED_MODULE_2__eachBefore__["a" /* default */],
  sum: __WEBPACK_IMPORTED_MODULE_4__sum__["a" /* default */],
  sort: __WEBPACK_IMPORTED_MODULE_5__sort__["a" /* default */],
  path: __WEBPACK_IMPORTED_MODULE_6__path__["a" /* default */],
  ancestors: __WEBPACK_IMPORTED_MODULE_7__ancestors__["a" /* default */],
  descendants: __WEBPACK_IMPORTED_MODULE_8__descendants__["a" /* default */],
  leaves: __WEBPACK_IMPORTED_MODULE_9__leaves__["a" /* default */],
  links: __WEBPACK_IMPORTED_MODULE_10__links__["a" /* default */],
  copy: node_copy
};


/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return phi; });
/* harmony export (immutable) */ __webpack_exports__["a"] = squarifyRatio;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dice__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__slice__ = __webpack_require__(153);



var phi = (1 + Math.sqrt(5)) / 2;

function squarifyRatio(ratio, parent, x0, y0, x1, y1) {
  var rows = [],
      nodes = parent.children,
      row,
      nodeValue,
      i0 = 0,
      i1 = 0,
      n = nodes.length,
      dx, dy,
      value = parent.value,
      sumValue,
      minValue,
      maxValue,
      newRatio,
      minRatio,
      alpha,
      beta;

  while (i0 < n) {
    dx = x1 - x0, dy = y1 - y0;

    // Find the next non-empty node.
    do sumValue = nodes[i1++].value; while (!sumValue && i1 < n);
    minValue = maxValue = sumValue;
    alpha = Math.max(dy / dx, dx / dy) / (value * ratio);
    beta = sumValue * sumValue * alpha;
    minRatio = Math.max(maxValue / beta, beta / minValue);

    // Keep adding nodes while the aspect ratio maintains or improves.
    for (; i1 < n; ++i1) {
      sumValue += nodeValue = nodes[i1].value;
      if (nodeValue < minValue) minValue = nodeValue;
      if (nodeValue > maxValue) maxValue = nodeValue;
      beta = sumValue * sumValue * alpha;
      newRatio = Math.max(maxValue / beta, beta / minValue);
      if (newRatio > minRatio) { sumValue -= nodeValue; break; }
      minRatio = newRatio;
    }

    // Position and record the row orientation.
    rows.push(row = {value: sumValue, dice: dx < dy, children: nodes.slice(i0, i1)});
    if (row.dice) __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__dice__["a" /* default */])(row, x0, y0, x1, value ? y0 += dy * sumValue / value : y1);
    else __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__slice__["a" /* default */])(row, x0, y0, value ? x0 += dx * sumValue / value : x1, y1);
    value -= sumValue, i0 = i1;
  }

  return rows;
}

/* harmony default export */ __webpack_exports__["c"] = ((function custom(ratio) {

  function squarify(parent, x0, y0, x1, y1) {
    squarifyRatio(ratio, parent, x0, y0, x1, y1);
  }

  squarify.ratio = function(x) {
    return custom((x = +x) > 1 ? x : 1);
  };

  return squarify;
})(phi));


/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = basis;
function basis(t1, v0, v1, v2, v3) {
  var t2 = t1 * t1, t3 = t2 * t1;
  return ((1 - 3 * t1 + 3 * t2 - t3) * v0
      + (4 - 6 * t2 + 3 * t3) * v1
      + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2
      + t3 * v3) / 6;
}

/* harmony default export */ __webpack_exports__["a"] = (function(values) {
  var n = values.length - 1;
  return function(t) {
    var i = t <= 0 ? (t = 0) : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n),
        v1 = values[i],
        v2 = values[i + 1],
        v0 = i > 0 ? values[i - 1] : 2 * v1 - v2,
        v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
    return basis((t - i / n) * n, v0, v1, v2, v3);
  };
});


/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rgb__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__array__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__date__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__number__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__object__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__string__ = __webpack_require__(423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constant__ = __webpack_require__(419);









/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var t = typeof b, c;
  return b == null || t === "boolean" ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__constant__["a" /* default */])(b)
      : (t === "number" ? __WEBPACK_IMPORTED_MODULE_4__number__["a" /* default */]
      : t === "string" ? ((c = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["a" /* color */])(b)) ? (b = c, __WEBPACK_IMPORTED_MODULE_1__rgb__["a" /* default */]) : __WEBPACK_IMPORTED_MODULE_6__string__["a" /* default */])
      : b instanceof __WEBPACK_IMPORTED_MODULE_0_d3_color__["a" /* color */] ? __WEBPACK_IMPORTED_MODULE_1__rgb__["a" /* default */]
      : b instanceof Date ? __WEBPACK_IMPORTED_MODULE_3__date__["a" /* default */]
      : Array.isArray(b) ? __WEBPACK_IMPORTED_MODULE_2__array__["a" /* default */]
      : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? __WEBPACK_IMPORTED_MODULE_5__object__["a" /* default */]
      : __WEBPACK_IMPORTED_MODULE_4__number__["a" /* default */])(a, b);
});


/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_quadtree__ = __webpack_require__(944);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_quadtree__["a"]; });



/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(node, x0, y0, x1, y1) {
  this.node = node;
  this.x0 = x0;
  this.y0 = y0;
  this.x1 = x1;
  this.y1 = y1;
});


/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_collection__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_dispatch__ = __webpack_require__(87);



/* harmony default export */ __webpack_exports__["a"] = (function(url, callback) {
  var request,
      event = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_dispatch__["a" /* dispatch */])("beforesend", "progress", "load", "error"),
      mimeType,
      headers = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_collection__["a" /* map */])(),
      xhr = new XMLHttpRequest,
      user = null,
      password = null,
      response,
      responseType,
      timeout = 0;

  // If IE does not support CORS, use XDomainRequest.
  if (typeof XDomainRequest !== "undefined"
      && !("withCredentials" in xhr)
      && /^(http(s)?:)?\/\//.test(url)) xhr = new XDomainRequest;

  "onload" in xhr
      ? xhr.onload = xhr.onerror = xhr.ontimeout = respond
      : xhr.onreadystatechange = function(o) { xhr.readyState > 3 && respond(o); };

  function respond(o) {
    var status = xhr.status, result;
    if (!status && hasResponse(xhr)
        || status >= 200 && status < 300
        || status === 304) {
      if (response) {
        try {
          result = response.call(request, xhr);
        } catch (e) {
          event.call("error", request, e);
          return;
        }
      } else {
        result = xhr;
      }
      event.call("load", request, result);
    } else {
      event.call("error", request, o);
    }
  }

  xhr.onprogress = function(e) {
    event.call("progress", request, e);
  };

  request = {
    header: function(name, value) {
      name = (name + "").toLowerCase();
      if (arguments.length < 2) return headers.get(name);
      if (value == null) headers.remove(name);
      else headers.set(name, value + "");
      return request;
    },

    // If mimeType is non-null and no Accept header is set, a default is used.
    mimeType: function(value) {
      if (!arguments.length) return mimeType;
      mimeType = value == null ? null : value + "";
      return request;
    },

    // Specifies what type the response value should take;
    // for instance, arraybuffer, blob, document, or text.
    responseType: function(value) {
      if (!arguments.length) return responseType;
      responseType = value;
      return request;
    },

    timeout: function(value) {
      if (!arguments.length) return timeout;
      timeout = +value;
      return request;
    },

    user: function(value) {
      return arguments.length < 1 ? user : (user = value == null ? null : value + "", request);
    },

    password: function(value) {
      return arguments.length < 1 ? password : (password = value == null ? null : value + "", request);
    },

    // Specify how to convert the response content to a specific type;
    // changes the callback value on "load" events.
    response: function(value) {
      response = value;
      return request;
    },

    // Alias for send("GET", …).
    get: function(data, callback) {
      return request.send("GET", data, callback);
    },

    // Alias for send("POST", …).
    post: function(data, callback) {
      return request.send("POST", data, callback);
    },

    // If callback is non-null, it will be used for error and load events.
    send: function(method, data, callback) {
      xhr.open(method, url, true, user, password);
      if (mimeType != null && !headers.has("accept")) headers.set("accept", mimeType + ",*/*");
      if (xhr.setRequestHeader) headers.each(function(value, name) { xhr.setRequestHeader(name, value); });
      if (mimeType != null && xhr.overrideMimeType) xhr.overrideMimeType(mimeType);
      if (responseType != null) xhr.responseType = responseType;
      if (timeout > 0) xhr.timeout = timeout;
      if (callback == null && typeof data === "function") callback = data, data = null;
      if (callback != null && callback.length === 1) callback = fixCallback(callback);
      if (callback != null) request.on("error", callback).on("load", function(xhr) { callback(null, xhr); });
      event.call("beforesend", request, xhr);
      xhr.send(data == null ? null : data);
      return request;
    },

    abort: function() {
      xhr.abort();
      return request;
    },

    on: function() {
      var value = event.on.apply(event, arguments);
      return value === event ? request : value;
    }
  };

  if (callback != null) {
    if (typeof callback !== "function") throw new Error("invalid callback: " + callback);
    return request.get(callback);
  }

  return request;
});

function fixCallback(callback) {
  return function(error, xhr) {
    callback(error == null ? xhr : null);
  };
}

function hasResponse(xhr) {
  var type = xhr.responseType;
  return type && type !== "text"
      ? xhr.response // null on error
      : xhr.responseText; // "" on error
}


/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__namespace__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__namespaces__ = __webpack_require__(255);



function creatorInherit(name) {
  return function() {
    var document = this.ownerDocument,
        uri = this.namespaceURI;
    return uri === __WEBPACK_IMPORTED_MODULE_1__namespaces__["a" /* xhtml */] && document.documentElement.namespaceURI === __WEBPACK_IMPORTED_MODULE_1__namespaces__["a" /* xhtml */]
        ? document.createElement(name)
        : document.createElementNS(uri, name);
  };
}

function creatorFixed(fullname) {
  return function() {
    return this.ownerDocument.createElementNS(fullname.space, fullname.local);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(name) {
  var fullname = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__namespace__["a" /* default */])(name);
  return (fullname.local
      ? creatorFixed
      : creatorInherit)(fullname);
});


/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__namespaces__ = __webpack_require__(255);


/* harmony default export */ __webpack_exports__["a"] = (function(name) {
  var prefix = name += "", i = prefix.indexOf(":");
  if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
  return __WEBPACK_IMPORTED_MODULE_0__namespaces__["b" /* default */].hasOwnProperty(prefix) ? {space: __WEBPACK_IMPORTED_MODULE_0__namespaces__["b" /* default */][prefix], local: name} : name;
});


/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return xhtml; });
var xhtml = "http://www.w3.org/1999/xhtml";

/* harmony default export */ __webpack_exports__["b"] = ({
  svg: "http://www.w3.org/2000/svg",
  xhtml: xhtml,
  xlink: "http://www.w3.org/1999/xlink",
  xml: "http://www.w3.org/XML/1998/namespace",
  xmlns: "http://www.w3.org/2000/xmlns/"
});


/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return event; });
/* harmony export (immutable) */ __webpack_exports__["b"] = customEvent;
var filterEvents = {};

var event = null;

if (typeof document !== "undefined") {
  var element = document.documentElement;
  if (!("onmouseenter" in element)) {
    filterEvents = {mouseenter: "mouseover", mouseleave: "mouseout"};
  }
}

function filterContextListener(listener, index, group) {
  listener = contextListener(listener, index, group);
  return function(event) {
    var related = event.relatedTarget;
    if (!related || (related !== this && !(related.compareDocumentPosition(this) & 8))) {
      listener.call(this, event);
    }
  };
}

function contextListener(listener, index, group) {
  return function(event1) {
    var event0 = event; // Events can be reentrant (e.g., focus).
    event = event1;
    try {
      listener.call(this, this.__data__, index, group);
    } finally {
      event = event0;
    }
  };
}

function parseTypenames(typenames) {
  return typenames.trim().split(/^|\s+/).map(function(t) {
    var name = "", i = t.indexOf(".");
    if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
    return {type: t, name: name};
  });
}

function onRemove(typename) {
  return function() {
    var on = this.__on;
    if (!on) return;
    for (var j = 0, i = -1, m = on.length, o; j < m; ++j) {
      if (o = on[j], (!typename.type || o.type === typename.type) && o.name === typename.name) {
        this.removeEventListener(o.type, o.listener, o.capture);
      } else {
        on[++i] = o;
      }
    }
    if (++i) on.length = i;
    else delete this.__on;
  };
}

function onAdd(typename, value, capture) {
  var wrap = filterEvents.hasOwnProperty(typename.type) ? filterContextListener : contextListener;
  return function(d, i, group) {
    var on = this.__on, o, listener = wrap(value, i, group);
    if (on) for (var j = 0, m = on.length; j < m; ++j) {
      if ((o = on[j]).type === typename.type && o.name === typename.name) {
        this.removeEventListener(o.type, o.listener, o.capture);
        this.addEventListener(o.type, o.listener = listener, o.capture = capture);
        o.value = value;
        return;
      }
    }
    this.addEventListener(typename.type, listener, capture);
    o = {type: typename.type, name: typename.name, value: value, listener: listener, capture: capture};
    if (!on) this.__on = [o];
    else on.push(o);
  };
}

/* harmony default export */ __webpack_exports__["c"] = (function(typename, value, capture) {
  var typenames = parseTypenames(typename + ""), i, n = typenames.length, t;

  if (arguments.length < 2) {
    var on = this.node().__on;
    if (on) for (var j = 0, m = on.length, o; j < m; ++j) {
      for (i = 0, o = on[j]; i < n; ++i) {
        if ((t = typenames[i]).type === o.type && t.name === o.name) {
          return o.value;
        }
      }
    }
    return;
  }

  on = value ? onAdd : onRemove;
  if (capture == null) capture = false;
  for (i = 0; i < n; ++i) this.each(on(typenames[i], value, capture));
  return this;
});

function customEvent(event1, listener, that, args) {
  var event0 = event;
  event1.sourceEvent = event;
  event = event1;
  try {
    return listener.apply(that, args);
  } finally {
    event = event0;
  }
}


/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function none() {}

/* harmony default export */ __webpack_exports__["a"] = (function(selector) {
  return selector == null ? none : function() {
    return this.querySelector(selector);
  };
});


/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selection_on__ = __webpack_require__(256);


/* harmony default export */ __webpack_exports__["a"] = (function() {
  var current = __WEBPACK_IMPORTED_MODULE_0__selection_on__["a" /* event */], source;
  while (source = current.sourceEvent) current = source;
  return current;
});


/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(node) {
  return (node.ownerDocument && node.ownerDocument.defaultView) // node is a Node
      || (node.document && node) // node is a Window
      || node.defaultView; // node is a Document
});


/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = point;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cardinal__ = __webpack_require__(159);



function point(that, x, y) {
  var x1 = that._x1,
      y1 = that._y1,
      x2 = that._x2,
      y2 = that._y2;

  if (that._l01_a > __WEBPACK_IMPORTED_MODULE_0__math__["a" /* epsilon */]) {
    var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a,
        n = 3 * that._l01_a * (that._l01_a + that._l12_a);
    x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
    y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
  }

  if (that._l23_a > __WEBPACK_IMPORTED_MODULE_0__math__["a" /* epsilon */]) {
    var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a,
        m = 3 * that._l23_a * (that._l23_a + that._l12_a);
    x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
    y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
  }

  that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
}

function CatmullRom(context, alpha) {
  this._context = context;
  this._alpha = alpha;
}

CatmullRom.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 =
    this._y0 = this._y1 = this._y2 = NaN;
    this._l01_a = this._l12_a = this._l23_a =
    this._l01_2a = this._l12_2a = this._l23_2a =
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2: this._context.lineTo(this._x2, this._y2); break;
      case 3: this.point(this._x2, this._y2); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;

    if (this._point) {
      var x23 = this._x2 - x,
          y23 = this._y2 - y;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
    }

    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; // proceed
      default: point(this, x, y); break;
    }

    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* unused harmony default export */ var _unused_webpack_default_export = ((function custom(alpha) {

  function catmullRom(context) {
    return alpha ? new CatmullRom(context, alpha) : new __WEBPACK_IMPORTED_MODULE_1__cardinal__["a" /* Cardinal */](context, 0);
  }

  catmullRom.alpha = function(alpha) {
    return custom(+alpha);
  };

  return catmullRom;
})(0.5));


/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_path__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constant__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__curve_linear__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__point__ = __webpack_require__(263);





/* harmony default export */ __webpack_exports__["a"] = (function() {
  var x = __WEBPACK_IMPORTED_MODULE_3__point__["a" /* x */],
      y = __WEBPACK_IMPORTED_MODULE_3__point__["b" /* y */],
      defined = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(true),
      context = null,
      curve = __WEBPACK_IMPORTED_MODULE_2__curve_linear__["a" /* default */],
      output = null;

  function line(data) {
    var i,
        n = data.length,
        d,
        defined0 = false,
        buffer;

    if (context == null) output = curve(buffer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_path__["a" /* path */])());

    for (i = 0; i <= n; ++i) {
      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
        if (defined0 = !defined0) output.lineStart();
        else output.lineEnd();
      }
      if (defined0) output.point(+x(d, i, data), +y(d, i, data));
    }

    if (buffer) return output = null, buffer + "" || null;
  }

  line.x = function(_) {
    return arguments.length ? (x = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), line) : x;
  };

  line.y = function(_) {
    return arguments.length ? (y = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), line) : y;
  };

  line.defined = function(_) {
    return arguments.length ? (defined = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(!!_), line) : defined;
  };

  line.curve = function(_) {
    return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
  };

  line.context = function(_) {
    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
  };

  return line;
});


/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = sum;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__none__ = __webpack_require__(123);


/* harmony default export */ __webpack_exports__["b"] = (function(series) {
  var sums = series.map(sum);
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__none__["a" /* default */])(series).sort(function(a, b) { return sums[a] - sums[b]; });
});

function sum(series) {
  var s = 0, i = -1, n = series.length, v;
  while (++i < n) if (v = +series[i][1]) s += v;
  return s;
}


/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = x;
/* harmony export (immutable) */ __webpack_exports__["b"] = y;
function x(p) {
  return p[0];
}

function y(p) {
  return p[1];
}


/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__ = __webpack_require__(265);
/* unused harmony reexport timeFormatDefaultLocale */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__["c"]; });
/* unused harmony reexport timeParse */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__["b"]; });
/* unused harmony reexport utcParse */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_locale__ = __webpack_require__(451);
/* unused harmony reexport timeFormatLocale */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_isoFormat__ = __webpack_require__(450);
/* unused harmony reexport isoFormat */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_isoParse__ = __webpack_require__(1043);
/* unused harmony reexport isoParse */






/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return timeFormat; });
/* unused harmony export timeParse */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return utcFormat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return utcParse; });
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale__ = __webpack_require__(451);


var locale;
var timeFormat;
var timeParse;
var utcFormat;
var utcParse;

defaultLocale({
  dateTime: "%x, %X",
  date: "%-m/%-d/%Y",
  time: "%-I:%M:%S %p",
  periods: ["AM", "PM"],
  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
});

function defaultLocale(definition) {
  locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__locale__["a" /* default */])(definition);
  timeFormat = locale.format;
  timeParse = locale.parse;
  utcFormat = locale.utcFormat;
  utcParse = locale.utcParse;
  return locale;
}


/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = now;
/* harmony export (immutable) */ __webpack_exports__["b"] = Timer;
/* harmony export (immutable) */ __webpack_exports__["a"] = timer;
/* unused harmony export timerFlush */
var frame = 0, // is an animation frame pending?
    timeout = 0, // is a timeout pending?
    interval = 0, // are any timers active?
    pokeDelay = 1000, // how frequently we check for clock skew
    taskHead,
    taskTail,
    clockLast = 0,
    clockNow = 0,
    clockSkew = 0,
    clock = typeof performance === "object" && performance.now ? performance : Date,
    setFrame = typeof window === "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(f) { setTimeout(f, 17); };

function now() {
  return clockNow || (setFrame(clearNow), clockNow = clock.now() + clockSkew);
}

function clearNow() {
  clockNow = 0;
}

function Timer() {
  this._call =
  this._time =
  this._next = null;
}

Timer.prototype = timer.prototype = {
  constructor: Timer,
  restart: function(callback, delay, time) {
    if (typeof callback !== "function") throw new TypeError("callback is not a function");
    time = (time == null ? now() : +time) + (delay == null ? 0 : +delay);
    if (!this._next && taskTail !== this) {
      if (taskTail) taskTail._next = this;
      else taskHead = this;
      taskTail = this;
    }
    this._call = callback;
    this._time = time;
    sleep();
  },
  stop: function() {
    if (this._call) {
      this._call = null;
      this._time = Infinity;
      sleep();
    }
  }
};

function timer(callback, delay, time) {
  var t = new Timer;
  t.restart(callback, delay, time);
  return t;
}

function timerFlush() {
  now(); // Get the current time, if not already set.
  ++frame; // Pretend we’ve set an alarm, if we haven’t already.
  var t = taskHead, e;
  while (t) {
    if ((e = clockNow - t._time) >= 0) t._call.call(null, e);
    t = t._next;
  }
  --frame;
}

function wake() {
  clockNow = (clockLast = clock.now()) + clockSkew;
  frame = timeout = 0;
  try {
    timerFlush();
  } finally {
    frame = 0;
    nap();
    clockNow = 0;
  }
}

function poke() {
  var now = clock.now(), delay = now - clockLast;
  if (delay > pokeDelay) clockSkew -= delay, clockLast = now;
}

function nap() {
  var t0, t1 = taskHead, t2, time = Infinity;
  while (t1) {
    if (t1._call) {
      if (time > t1._time) time = t1._time;
      t0 = t1, t1 = t1._next;
    } else {
      t2 = t1._next, t1._next = null;
      t1 = t0 ? t0._next = t2 : taskHead = t2;
    }
  }
  taskTail = t0;
  sleep(time);
}

function sleep(time) {
  if (frame) return; // Soonest alarm already set, or will be.
  if (timeout) timeout = clearTimeout(timeout);
  var delay = time - clockNow; // Strictly less than if we recomputed clockNow.
  if (delay > 24) {
    if (time < Infinity) timeout = setTimeout(wake, time - clock.now() - clockSkew);
    if (interval) interval = clearInterval(interval);
  } else {
    if (!interval) clockLast = clock.now(), interval = setInterval(poke, pokeDelay);
    frame = 1, setFrame(wake);
  }
}


/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_selection_index__ = __webpack_require__(1061);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_transition_index__ = __webpack_require__(74);
/* unused harmony reexport transition */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_active__ = __webpack_require__(1060);
/* unused harmony reexport active */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_interrupt__ = __webpack_require__(452);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__src_interrupt__["a"]; });






/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = createEdge;
/* harmony export (immutable) */ __webpack_exports__["b"] = createBorderEdge;
/* harmony export (immutable) */ __webpack_exports__["c"] = setEdgeEnd;
/* harmony export (immutable) */ __webpack_exports__["a"] = clipEdges;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Diagram__ = __webpack_require__(124);


function createEdge(left, right, v0, v1) {
  var edge = [null, null],
      index = __WEBPACK_IMPORTED_MODULE_0__Diagram__["d" /* edges */].push(edge) - 1;
  edge.left = left;
  edge.right = right;
  if (v0) setEdgeEnd(edge, left, right, v0);
  if (v1) setEdgeEnd(edge, right, left, v1);
  __WEBPACK_IMPORTED_MODULE_0__Diagram__["c" /* cells */][left.index].halfedges.push(index);
  __WEBPACK_IMPORTED_MODULE_0__Diagram__["c" /* cells */][right.index].halfedges.push(index);
  return edge;
}

function createBorderEdge(left, v0, v1) {
  var edge = [v0, v1];
  edge.left = left;
  return edge;
}

function setEdgeEnd(edge, left, right, vertex) {
  if (!edge[0] && !edge[1]) {
    edge[0] = vertex;
    edge.left = left;
    edge.right = right;
  } else if (edge.left === right) {
    edge[1] = vertex;
  } else {
    edge[0] = vertex;
  }
}

// Liang–Barsky line clipping.
function clipEdge(edge, x0, y0, x1, y1) {
  var a = edge[0],
      b = edge[1],
      ax = a[0],
      ay = a[1],
      bx = b[0],
      by = b[1],
      t0 = 0,
      t1 = 1,
      dx = bx - ax,
      dy = by - ay,
      r;

  r = x0 - ax;
  if (!dx && r > 0) return;
  r /= dx;
  if (dx < 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  } else if (dx > 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  }

  r = x1 - ax;
  if (!dx && r < 0) return;
  r /= dx;
  if (dx < 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  } else if (dx > 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  }

  r = y0 - ay;
  if (!dy && r > 0) return;
  r /= dy;
  if (dy < 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  } else if (dy > 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  }

  r = y1 - ay;
  if (!dy && r < 0) return;
  r /= dy;
  if (dy < 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  } else if (dy > 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  }

  if (!(t0 > 0) && !(t1 < 1)) return true; // TODO Better check?

  if (t0 > 0) edge[0] = [ax + t0 * dx, ay + t0 * dy];
  if (t1 < 1) edge[1] = [ax + t1 * dx, ay + t1 * dy];
  return true;
}

function connectEdge(edge, x0, y0, x1, y1) {
  var v1 = edge[1];
  if (v1) return true;

  var v0 = edge[0],
      left = edge.left,
      right = edge.right,
      lx = left[0],
      ly = left[1],
      rx = right[0],
      ry = right[1],
      fx = (lx + rx) / 2,
      fy = (ly + ry) / 2,
      fm,
      fb;

  if (ry === ly) {
    if (fx < x0 || fx >= x1) return;
    if (lx > rx) {
      if (!v0) v0 = [fx, y0];
      else if (v0[1] >= y1) return;
      v1 = [fx, y1];
    } else {
      if (!v0) v0 = [fx, y1];
      else if (v0[1] < y0) return;
      v1 = [fx, y0];
    }
  } else {
    fm = (lx - rx) / (ry - ly);
    fb = fy - fm * fx;
    if (fm < -1 || fm > 1) {
      if (lx > rx) {
        if (!v0) v0 = [(y0 - fb) / fm, y0];
        else if (v0[1] >= y1) return;
        v1 = [(y1 - fb) / fm, y1];
      } else {
        if (!v0) v0 = [(y1 - fb) / fm, y1];
        else if (v0[1] < y0) return;
        v1 = [(y0 - fb) / fm, y0];
      }
    } else {
      if (ly < ry) {
        if (!v0) v0 = [x0, fm * x0 + fb];
        else if (v0[0] >= x1) return;
        v1 = [x1, fm * x1 + fb];
      } else {
        if (!v0) v0 = [x1, fm * x1 + fb];
        else if (v0[0] < x0) return;
        v1 = [x0, fm * x0 + fb];
      }
    }
  }

  edge[0] = v0;
  edge[1] = v1;
  return true;
}

function clipEdges(x0, y0, x1, y1) {
  var i = __WEBPACK_IMPORTED_MODULE_0__Diagram__["d" /* edges */].length,
      edge;

  while (i--) {
    if (!connectEdge(edge = __WEBPACK_IMPORTED_MODULE_0__Diagram__["d" /* edges */][i], x0, y0, x1, y1)
        || !clipEdge(edge, x0, y0, x1, y1)
        || !(Math.abs(edge[0][0] - edge[1][0]) > __WEBPACK_IMPORTED_MODULE_0__Diagram__["b" /* epsilon */]
            || Math.abs(edge[0][1] - edge[1][1]) > __WEBPACK_IMPORTED_MODULE_0__Diagram__["b" /* epsilon */])) {
      delete __WEBPACK_IMPORTED_MODULE_0__Diagram__["d" /* edges */][i];
    }
  }
}


/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = RedBlackNode;
function RedBlackTree() {
  this._ = null; // root node
}

function RedBlackNode(node) {
  node.U = // parent node
  node.C = // color - true for red, false for black
  node.L = // left node
  node.R = // right node
  node.P = // previous node
  node.N = null; // next node
}

RedBlackTree.prototype = {
  constructor: RedBlackTree,

  insert: function(after, node) {
    var parent, grandpa, uncle;

    if (after) {
      node.P = after;
      node.N = after.N;
      if (after.N) after.N.P = node;
      after.N = node;
      if (after.R) {
        after = after.R;
        while (after.L) after = after.L;
        after.L = node;
      } else {
        after.R = node;
      }
      parent = after;
    } else if (this._) {
      after = RedBlackFirst(this._);
      node.P = null;
      node.N = after;
      after.P = after.L = node;
      parent = after;
    } else {
      node.P = node.N = null;
      this._ = node;
      parent = null;
    }
    node.L = node.R = null;
    node.U = parent;
    node.C = true;

    after = node;
    while (parent && parent.C) {
      grandpa = parent.U;
      if (parent === grandpa.L) {
        uncle = grandpa.R;
        if (uncle && uncle.C) {
          parent.C = uncle.C = false;
          grandpa.C = true;
          after = grandpa;
        } else {
          if (after === parent.R) {
            RedBlackRotateLeft(this, parent);
            after = parent;
            parent = after.U;
          }
          parent.C = false;
          grandpa.C = true;
          RedBlackRotateRight(this, grandpa);
        }
      } else {
        uncle = grandpa.L;
        if (uncle && uncle.C) {
          parent.C = uncle.C = false;
          grandpa.C = true;
          after = grandpa;
        } else {
          if (after === parent.L) {
            RedBlackRotateRight(this, parent);
            after = parent;
            parent = after.U;
          }
          parent.C = false;
          grandpa.C = true;
          RedBlackRotateLeft(this, grandpa);
        }
      }
      parent = after.U;
    }
    this._.C = false;
  },

  remove: function(node) {
    if (node.N) node.N.P = node.P;
    if (node.P) node.P.N = node.N;
    node.N = node.P = null;

    var parent = node.U,
        sibling,
        left = node.L,
        right = node.R,
        next,
        red;

    if (!left) next = right;
    else if (!right) next = left;
    else next = RedBlackFirst(right);

    if (parent) {
      if (parent.L === node) parent.L = next;
      else parent.R = next;
    } else {
      this._ = next;
    }

    if (left && right) {
      red = next.C;
      next.C = node.C;
      next.L = left;
      left.U = next;
      if (next !== right) {
        parent = next.U;
        next.U = node.U;
        node = next.R;
        parent.L = node;
        next.R = right;
        right.U = next;
      } else {
        next.U = parent;
        parent = next;
        node = next.R;
      }
    } else {
      red = node.C;
      node = next;
    }

    if (node) node.U = parent;
    if (red) return;
    if (node && node.C) { node.C = false; return; }

    do {
      if (node === this._) break;
      if (node === parent.L) {
        sibling = parent.R;
        if (sibling.C) {
          sibling.C = false;
          parent.C = true;
          RedBlackRotateLeft(this, parent);
          sibling = parent.R;
        }
        if ((sibling.L && sibling.L.C)
            || (sibling.R && sibling.R.C)) {
          if (!sibling.R || !sibling.R.C) {
            sibling.L.C = false;
            sibling.C = true;
            RedBlackRotateRight(this, sibling);
            sibling = parent.R;
          }
          sibling.C = parent.C;
          parent.C = sibling.R.C = false;
          RedBlackRotateLeft(this, parent);
          node = this._;
          break;
        }
      } else {
        sibling = parent.L;
        if (sibling.C) {
          sibling.C = false;
          parent.C = true;
          RedBlackRotateRight(this, parent);
          sibling = parent.L;
        }
        if ((sibling.L && sibling.L.C)
          || (sibling.R && sibling.R.C)) {
          if (!sibling.L || !sibling.L.C) {
            sibling.R.C = false;
            sibling.C = true;
            RedBlackRotateLeft(this, sibling);
            sibling = parent.L;
          }
          sibling.C = parent.C;
          parent.C = sibling.L.C = false;
          RedBlackRotateRight(this, parent);
          node = this._;
          break;
        }
      }
      sibling.C = true;
      node = parent;
      parent = parent.U;
    } while (!node.C);

    if (node) node.C = false;
  }
};

function RedBlackRotateLeft(tree, node) {
  var p = node,
      q = node.R,
      parent = p.U;

  if (parent) {
    if (parent.L === p) parent.L = q;
    else parent.R = q;
  } else {
    tree._ = q;
  }

  q.U = parent;
  p.U = q;
  p.R = q.L;
  if (p.R) p.R.U = p;
  q.L = p;
}

function RedBlackRotateRight(tree, node) {
  var p = node,
      q = node.L,
      parent = p.U;

  if (parent) {
    if (parent.L === p) parent.L = q;
    else parent.R = q;
  } else {
    tree._ = q;
  }

  q.U = parent;
  p.U = q;
  p.L = q.R;
  if (p.L) p.L.U = p;
  q.R = p;
}

function RedBlackFirst(node) {
  while (node.L) node = node.L;
  return node;
}

/* harmony default export */ __webpack_exports__["a"] = (RedBlackTree);


/***/ }),
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var ArrayObservable_1 = __webpack_require__(61);
var isArray_1 = __webpack_require__(62);
var OuterSubscriber_1 = __webpack_require__(6);
var subscribeToResult_1 = __webpack_require__(7);
var none = {};
/* tslint:enable:max-line-length */
/**
 * Combines multiple Observables to create an Observable whose values are
 * calculated from the latest values of each of its input Observables.
 *
 * <span class="informal">Whenever any input Observable emits a value, it
 * computes a formula using the latest values from all the inputs, then emits
 * the output of that formula.</span>
 *
 * <img src="./img/combineLatest.png" width="100%">
 *
 * `combineLatest` combines the values from this Observable with values from
 * Observables passed as arguments. This is done by subscribing to each
 * Observable, in order, and collecting an array of each of the most recent
 * values any time any of the input Observables emits, then either taking that
 * array and passing it as arguments to an optional `project` function and
 * emitting the return value of that, or just emitting the array of recent
 * values directly if there is no `project` function.
 *
 * @example <caption>Dynamically calculate the Body-Mass Index from an Observable of weight and one for height</caption>
 * var weight = Rx.Observable.of(70, 72, 76, 79, 75);
 * var height = Rx.Observable.of(1.76, 1.77, 1.78);
 * var bmi = weight.combineLatest(height, (w, h) => w / (h * h));
 * bmi.subscribe(x => console.log('BMI is ' + x));
 *
 * // With output to console:
 * // BMI is 24.212293388429753
 * // BMI is 23.93948099205209
 * // BMI is 23.671253629592222
 *
 * @see {@link combineAll}
 * @see {@link merge}
 * @see {@link withLatestFrom}
 *
 * @param {ObservableInput} other An input Observable to combine with the source
 * Observable. More than one input Observables may be given as argument.
 * @param {function} [project] An optional function to project the values from
 * the combined latest values into a new value on the output Observable.
 * @return {Observable} An Observable of projected values from the most recent
 * values from each input Observable, or an array of the most recent values from
 * each input Observable.
 * @method combineLatest
 * @owner Observable
 */
function combineLatest() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i - 0] = arguments[_i];
    }
    var project = null;
    if (typeof observables[observables.length - 1] === 'function') {
        project = observables.pop();
    }
    // if the first and only other argument besides the resultSelector is an array
    // assume it's been called with `combineLatest([obs1, obs2, obs3], project)`
    if (observables.length === 1 && isArray_1.isArray(observables[0])) {
        observables = observables[0].slice();
    }
    observables.unshift(this);
    return this.lift.call(new ArrayObservable_1.ArrayObservable(observables), new CombineLatestOperator(project));
}
exports.combineLatest = combineLatest;
var CombineLatestOperator = (function () {
    function CombineLatestOperator(project) {
        this.project = project;
    }
    CombineLatestOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new CombineLatestSubscriber(subscriber, this.project));
    };
    return CombineLatestOperator;
}());
exports.CombineLatestOperator = CombineLatestOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var CombineLatestSubscriber = (function (_super) {
    __extends(CombineLatestSubscriber, _super);
    function CombineLatestSubscriber(destination, project) {
        _super.call(this, destination);
        this.project = project;
        this.active = 0;
        this.values = [];
        this.observables = [];
    }
    CombineLatestSubscriber.prototype._next = function (observable) {
        this.values.push(none);
        this.observables.push(observable);
    };
    CombineLatestSubscriber.prototype._complete = function () {
        var observables = this.observables;
        var len = observables.length;
        if (len === 0) {
            this.destination.complete();
        }
        else {
            this.active = len;
            this.toRespond = len;
            for (var i = 0; i < len; i++) {
                var observable = observables[i];
                this.add(subscribeToResult_1.subscribeToResult(this, observable, observable, i));
            }
        }
    };
    CombineLatestSubscriber.prototype.notifyComplete = function (unused) {
        if ((this.active -= 1) === 0) {
            this.destination.complete();
        }
    };
    CombineLatestSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        var values = this.values;
        var oldVal = values[outerIndex];
        var toRespond = !this.toRespond
            ? 0
            : oldVal === none ? --this.toRespond : this.toRespond;
        values[outerIndex] = innerValue;
        if (toRespond === 0) {
            if (this.project) {
                this._tryProject(values);
            }
            else {
                this.destination.next(values.slice());
            }
        }
    };
    CombineLatestSubscriber.prototype._tryProject = function (values) {
        var result;
        try {
            result = this.project.apply(this, values);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return CombineLatestSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
exports.CombineLatestSubscriber = CombineLatestSubscriber;
//# sourceMappingURL=combineLatest.js.map

/***/ }),
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AnimationDriver; });
/* unused harmony export ɵAnimation */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AnimationStyleNormalizer; });
/* unused harmony export ɵNoopAnimationStyleNormalizer */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return WebAnimationsStyleNormalizer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return NoopAnimationDriver; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return AnimationEngine; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return WebAnimationsDriver; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return supportsWebAnimations; });
/* unused harmony export ɵWebAnimationsPlayer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_animations__ = __webpack_require__(175);

/**
 * @license Angular v4.4.4
 * (c) 2010-2017 Google, Inc. https://angular.io/
 * License: MIT
 */

/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
function optimizeGroupPlayer(players) {
    switch (players.length) {
        case 0:
            return new __WEBPACK_IMPORTED_MODULE_1__angular_animations__["d" /* NoopAnimationPlayer */]();
        case 1:
            return players[0];
        default:
            return new __WEBPACK_IMPORTED_MODULE_1__angular_animations__["e" /* ɵAnimationGroupPlayer */](players);
    }
}
function normalizeKeyframes(driver, normalizer, element, keyframes, preStyles, postStyles) {
    if (preStyles === void 0) { preStyles = {}; }
    if (postStyles === void 0) { postStyles = {}; }
    var errors = [];
    var normalizedKeyframes = [];
    var previousOffset = -1;
    var previousKeyframe = null;
    keyframes.forEach(function (kf) {
        var offset = kf['offset'];
        var isSameOffset = offset == previousOffset;
        var normalizedKeyframe = (isSameOffset && previousKeyframe) || {};
        Object.keys(kf).forEach(function (prop) {
            var normalizedProp = prop;
            var normalizedValue = kf[prop];
            if (prop !== 'offset') {
                normalizedProp = normalizer.normalizePropertyName(normalizedProp, errors);
                switch (normalizedValue) {
                    case __WEBPACK_IMPORTED_MODULE_1__angular_animations__["f" /* ɵPRE_STYLE */]:
                        normalizedValue = preStyles[prop];
                        break;
                    case __WEBPACK_IMPORTED_MODULE_1__angular_animations__["g" /* AUTO_STYLE */]:
                        normalizedValue = postStyles[prop];
                        break;
                    default:
                        normalizedValue =
                            normalizer.normalizeStyleValue(prop, normalizedProp, normalizedValue, errors);
                        break;
                }
            }
            normalizedKeyframe[normalizedProp] = normalizedValue;
        });
        if (!isSameOffset) {
            normalizedKeyframes.push(normalizedKeyframe);
        }
        previousKeyframe = normalizedKeyframe;
        previousOffset = offset;
    });
    if (errors.length) {
        var LINE_START = '\n - ';
        throw new Error("Unable to animate due to the following errors:" + LINE_START + errors.join(LINE_START));
    }
    return normalizedKeyframes;
}
function listenOnPlayer(player, eventName, event, callback) {
    switch (eventName) {
        case 'start':
            player.onStart(function () { return callback(event && copyAnimationEvent(event, 'start', player.totalTime)); });
            break;
        case 'done':
            player.onDone(function () { return callback(event && copyAnimationEvent(event, 'done', player.totalTime)); });
            break;
        case 'destroy':
            player.onDestroy(function () { return callback(event && copyAnimationEvent(event, 'destroy', player.totalTime)); });
            break;
    }
}
function copyAnimationEvent(e, phaseName, totalTime) {
    var event = makeAnimationEvent(e.element, e.triggerName, e.fromState, e.toState, phaseName || e.phaseName, totalTime == undefined ? e.totalTime : totalTime);
    var data = e['_data'];
    if (data != null) {
        event['_data'] = data;
    }
    return event;
}
function makeAnimationEvent(element, triggerName, fromState, toState, phaseName, totalTime) {
    if (phaseName === void 0) { phaseName = ''; }
    if (totalTime === void 0) { totalTime = 0; }
    return { element: element, triggerName: triggerName, fromState: fromState, toState: toState, phaseName: phaseName, totalTime: totalTime };
}
function getOrSetAsInMap(map, key, defaultValue) {
    var value;
    if (map instanceof Map) {
        value = map.get(key);
        if (!value) {
            map.set(key, value = defaultValue);
        }
    }
    else {
        value = map[key];
        if (!value) {
            value = map[key] = defaultValue;
        }
    }
    return value;
}
function parseTimelineCommand(command) {
    var separatorPos = command.indexOf(':');
    var id = command.substring(1, separatorPos);
    var action = command.substr(separatorPos + 1);
    return [id, action];
}
var _contains = function (elm1, elm2) { return false; };
var _matches = function (element, selector) { return false; };
var _query = function (element, selector, multi) {
    return [];
};
if (typeof Element != 'undefined') {
    // this is well supported in all browsers
    _contains = function (elm1, elm2) { return elm1.contains(elm2); };
    if (Element.prototype.matches) {
        _matches = function (element, selector) { return element.matches(selector); };
    }
    else {
        var proto = Element.prototype;
        var fn_1 = proto.matchesSelector || proto.mozMatchesSelector || proto.msMatchesSelector ||
            proto.oMatchesSelector || proto.webkitMatchesSelector;
        if (fn_1) {
            _matches = function (element, selector) { return fn_1.apply(element, [selector]); };
        }
    }
    _query = function (element, selector, multi) {
        var results = [];
        if (multi) {
            results.push.apply(results, element.querySelectorAll(selector));
        }
        else {
            var elm = element.querySelector(selector);
            if (elm) {
                results.push(elm);
            }
        }
        return results;
    };
}
var matchesElement = _matches;
var containsElement = _contains;
var invokeQuery = _query;
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @experimental
 */
var NoopAnimationDriver = (function () {
    function NoopAnimationDriver() {
    }
    NoopAnimationDriver.prototype.matchesElement = function (element, selector) {
        return matchesElement(element, selector);
    };
    NoopAnimationDriver.prototype.containsElement = function (elm1, elm2) { return containsElement(elm1, elm2); };
    NoopAnimationDriver.prototype.query = function (element, selector, multi) {
        return invokeQuery(element, selector, multi);
    };
    NoopAnimationDriver.prototype.computeStyle = function (element, prop, defaultValue) {
        return defaultValue || '';
    };
    NoopAnimationDriver.prototype.animate = function (element, keyframes, duration, delay, easing, previousPlayers) {
        if (previousPlayers === void 0) { previousPlayers = []; }
        return new __WEBPACK_IMPORTED_MODULE_1__angular_animations__["d" /* NoopAnimationPlayer */]();
    };
    return NoopAnimationDriver;
}());
/**
 * @experimental
 */
var AnimationDriver = (function () {
    function AnimationDriver() {
    }
    return AnimationDriver;
}());
AnimationDriver.NOOP = new NoopAnimationDriver();
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var ONE_SECOND = 1000;
var SUBSTITUTION_EXPR_START = '{{';
var SUBSTITUTION_EXPR_END = '}}';
var ENTER_CLASSNAME = 'ng-enter';
var LEAVE_CLASSNAME = 'ng-leave';
var ENTER_SELECTOR = '.ng-enter';
var LEAVE_SELECTOR = '.ng-leave';
var NG_TRIGGER_CLASSNAME = 'ng-trigger';
var NG_TRIGGER_SELECTOR = '.ng-trigger';
var NG_ANIMATING_CLASSNAME = 'ng-animating';
var NG_ANIMATING_SELECTOR = '.ng-animating';
function resolveTimingValue(value) {
    if (typeof value == 'number')
        return value;
    var matches = value.match(/^(-?[\.\d]+)(m?s)/);
    if (!matches || matches.length < 2)
        return 0;
    return _convertTimeValueToMS(parseFloat(matches[1]), matches[2]);
}
function _convertTimeValueToMS(value, unit) {
    switch (unit) {
        case 's':
            return value * ONE_SECOND;
        default:
            return value;
    }
}
function resolveTiming(timings, errors, allowNegativeValues) {
    return timings.hasOwnProperty('duration') ?
        timings :
        parseTimeExpression(timings, errors, allowNegativeValues);
}
function parseTimeExpression(exp, errors, allowNegativeValues) {
    var regex = /^(-?[\.\d]+)(m?s)(?:\s+(-?[\.\d]+)(m?s))?(?:\s+([-a-z]+(?:\(.+?\))?))?$/i;
    var duration;
    var delay = 0;
    var easing = '';
    if (typeof exp === 'string') {
        var matches = exp.match(regex);
        if (matches === null) {
            errors.push("The provided timing value \"" + exp + "\" is invalid.");
            return { duration: 0, delay: 0, easing: '' };
        }
        duration = _convertTimeValueToMS(parseFloat(matches[1]), matches[2]);
        var delayMatch = matches[3];
        if (delayMatch != null) {
            delay = _convertTimeValueToMS(Math.floor(parseFloat(delayMatch)), matches[4]);
        }
        var easingVal = matches[5];
        if (easingVal) {
            easing = easingVal;
        }
    }
    else {
        duration = exp;
    }
    if (!allowNegativeValues) {
        var containsErrors = false;
        var startIndex = errors.length;
        if (duration < 0) {
            errors.push("Duration values below 0 are not allowed for this animation step.");
            containsErrors = true;
        }
        if (delay < 0) {
            errors.push("Delay values below 0 are not allowed for this animation step.");
            containsErrors = true;
        }
        if (containsErrors) {
            errors.splice(startIndex, 0, "The provided timing value \"" + exp + "\" is invalid.");
        }
    }
    return { duration: duration, delay: delay, easing: easing };
}
function copyObj(obj, destination) {
    if (destination === void 0) { destination = {}; }
    Object.keys(obj).forEach(function (prop) { destination[prop] = obj[prop]; });
    return destination;
}
function normalizeStyles(styles) {
    var normalizedStyles = {};
    if (Array.isArray(styles)) {
        styles.forEach(function (data) { return copyStyles(data, false, normalizedStyles); });
    }
    else {
        copyStyles(styles, false, normalizedStyles);
    }
    return normalizedStyles;
}
function copyStyles(styles, readPrototype, destination) {
    if (destination === void 0) { destination = {}; }
    if (readPrototype) {
        // we make use of a for-in loop so that the
        // prototypically inherited properties are
        // revealed from the backFill map
        for (var prop in styles) {
            destination[prop] = styles[prop];
        }
    }
    else {
        copyObj(styles, destination);
    }
    return destination;
}
function setStyles(element, styles) {
    if (element['style']) {
        Object.keys(styles).forEach(function (prop) {
            var camelProp = dashCaseToCamelCase(prop);
            element.style[camelProp] = styles[prop];
        });
    }
}
function eraseStyles(element, styles) {
    if (element['style']) {
        Object.keys(styles).forEach(function (prop) {
            var camelProp = dashCaseToCamelCase(prop);
            element.style[camelProp] = '';
        });
    }
}
function normalizeAnimationEntry(steps) {
    if (Array.isArray(steps)) {
        if (steps.length == 1)
            return steps[0];
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_animations__["b" /* sequence */])(steps);
    }
    return steps;
}
function validateStyleParams(value, options, errors) {
    var params = options.params || {};
    var matches = extractStyleParams(value);
    if (matches.length) {
        matches.forEach(function (varName) {
            if (!params.hasOwnProperty(varName)) {
                errors.push("Unable to resolve the local animation param " + varName + " in the given list of values");
            }
        });
    }
}
var PARAM_REGEX = new RegExp(SUBSTITUTION_EXPR_START + "\\s*(.+?)\\s*" + SUBSTITUTION_EXPR_END, 'g');
function extractStyleParams(value) {
    var params = [];
    if (typeof value === 'string') {
        var val = value.toString();
        var match = void 0;
        while (match = PARAM_REGEX.exec(val)) {
            params.push(match[1]);
        }
        PARAM_REGEX.lastIndex = 0;
    }
    return params;
}
function interpolateParams(value, params, errors) {
    var original = value.toString();
    var str = original.replace(PARAM_REGEX, function (_, varName) {
        var localVal = params[varName];
        // this means that the value was never overidden by the data passed in by the user
        if (!params.hasOwnProperty(varName)) {
            errors.push("Please provide a value for the animation param " + varName);
            localVal = '';
        }
        return localVal.toString();
    });
    // we do this to assert that numeric values stay as they are
    return str == original ? value : str;
}
function iteratorToArray(iterator) {
    var arr = [];
    var item = iterator.next();
    while (!item.done) {
        arr.push(item.value);
        item = iterator.next();
    }
    return arr;
}
var DASH_CASE_REGEXP = /-+([a-z0-9])/g;
function dashCaseToCamelCase(input) {
    return input.replace(DASH_CASE_REGEXP, function () {
        var m = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            m[_i] = arguments[_i];
        }
        return m[1].toUpperCase();
    });
}
function allowPreviousPlayerStylesMerge(duration, delay) {
    return duration === 0 || delay === 0;
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var EMPTY_ANIMATION_OPTIONS = {};
/**
 * @abstract
 */
var Ast = (function () {
    function Ast() {
        this.options = EMPTY_ANIMATION_OPTIONS;
    }
    /**
     * @abstract
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    Ast.prototype.visit = function (ast, context) { };
    Object.defineProperty(Ast.prototype, "params", {
        /**
         * @return {?}
         */
        get: function () { return this.options['params'] || null; },
        enumerable: true,
        configurable: true
    });
    return Ast;
}());
var TriggerAst = (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](TriggerAst, _super);
    /**
     * @param {?} name
     * @param {?} states
     * @param {?} transitions
     */
    function TriggerAst(name, states, transitions) {
        var _this = _super.call(this) || this;
        _this.name = name;
        _this.states = states;
        _this.transitions = transitions;
        _this.queryCount = 0;
        _this.depCount = 0;
        return _this;
    }
    /**
     * @param {?} visitor
     * @param {?} context
     * @return {?}
     */
    TriggerAst.prototype.visit = function (visitor, context) { return visitor.visitTrigger(this, context); };
    return TriggerAst;
}(Ast));
var StateAst = (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](StateAst, _super);
    /**
     * @param {?} name
     * @param {?} style
     */
    function StateAst(name, style$$1) {
        var _this = _super.call(this) || this;
        _this.name = name;
        _this.style = style$$1;
        return _this;
    }
    /**
     * @param {?} visitor
     * @param {?} context
     * @return {?}
     */
    StateAst.prototype.visit = function (visitor, context) { return visitor.visitState(this, context); };
    return StateAst;
}(Ast));
var TransitionAst = (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](TransitionAst, _super);
    /**
     * @param {?} matchers
     * @param {?} animation
     */
    function TransitionAst(matchers, animation) {
        var _this = _super.call(this) || this;
        _this.matchers = matchers;
        _this.animation = animation;
        _this.queryCount = 0;
        _this.depCount = 0;
        return _this;
    }
    /**
     * @param {?} visitor
     * @param {?} context
     * @return {?}
     */
    TransitionAst.prototype.visit = function (visitor, context) { return visitor.visitTransition(this, context); };
    return TransitionAst;
}(Ast));
var SequenceAst = (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](SequenceAst, _super);
    /**
     * @param {?} steps
     */
    function SequenceAst(steps) {
        var _this = _super.call(this) || this;
        _this.steps = steps;
        return _this;
    }
    /**
     * @param {?} visitor
     * @param {?} context
     * @return {?}
     */
    SequenceAst.prototype.visit = function (visitor, context) { return visitor.visitSequence(this, context); };
    return SequenceAst;
}(Ast));
var GroupAst = (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](GroupAst, _super);
    /**
     * @param {?} steps
     */
    function GroupAst(steps) {
        var _this = _super.call(this) || this;
        _this.steps = steps;
        return _this;
    }
    /**
     * @param {?} visitor
     * @param {?} context
     * @return {?}
     */
    GroupAst.prototype.visit = function (visitor, context) { return visitor.visitGroup(this, context); };
    return GroupAst;
}(Ast));
var AnimateAst = (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](AnimateAst, _super);
    /**
     * @param {?} timings
     * @param {?} style
     */
    function AnimateAst(timings, style$$1) {
        var _this = _super.call(this) || this;
        _this.timings = timings;
        _this.style = style$$1;
        return _this;
    }
    /**
     * @param {?} visitor
     * @param {?} context
     * @return {?}
     */
    AnimateAst.prototype.visit = function (visitor, context) { return visitor.visitAnimate(this, context); };
    return AnimateAst;
}(Ast));
var StyleAst = (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](StyleAst, _super);
    /**
     * @param {?} styles
     * @param {?} easing
     * @param {?} offset
     */
    function StyleAst(styles, easing, offset) {
        var _this = _super.call(this) || this;
        _this.styles = styles;
        _this.easing = easing;
        _this.offset = offset;
        _this.isEmptyStep = false;
        _this.containsDynamicStyles = false;
        return _this;
    }
    /**
     * @param {?} visitor
     * @param {?} context
     * @return {?}
     */
    StyleAst.prototype.visit = function (visitor, context) { return visitor.visitStyle(this, context); };
    return StyleAst;
}(Ast));
var KeyframesAst = (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](KeyframesAst, _super);
    /**
     * @param {?} styles
     */
    function KeyframesAst(styles) {
        var _this = _super.call(this) || this;
        _this.styles = styles;
        return _this;
    }
    /**
     * @param {?} visitor
     * @param {?} context
     * @return {?}
     */
    KeyframesAst.prototype.visit = function (visitor, context) { return visitor.visitKeyframes(this, context); };
    return KeyframesAst;
}(Ast));
var ReferenceAst = (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](ReferenceAst, _super);
    /**
     * @param {?} animation
     */
    function ReferenceAst(animation) {
        var _this = _super.call(this) || this;
        _this.animation = animation;
        return _this;
    }
    /**
     * @param {?} visitor
     * @param {?} context
     * @return {?}
     */
    ReferenceAst.prototype.visit = function (visitor, context) { return visitor.visitReference(this, context); };
    return ReferenceAst;
}(Ast));
var AnimateChildAst = (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](AnimateChildAst, _super);
    function AnimateChildAst() {
        return _super.call(this) || this;
    }
    /**
     * @param {?} visitor
     * @param {?} context
     * @return {?}
     */
    AnimateChildAst.prototype.visit = function (visitor, context) { return visitor.visitAnimateChild(this, context); };
    return AnimateChildAst;
}(Ast));
var AnimateRefAst = (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](AnimateRefAst, _super);
    /**
     * @param {?} animation
     */
    function AnimateRefAst(animation) {
        var _this = _super.call(this) || this;
        _this.animation = animation;
        return _this;
    }
    /**
     * @param {?} visitor
     * @param {?} context
     * @return {?}
     */
    AnimateRefAst.prototype.visit = function (visitor, context) { return visitor.visitAnimateRef(this, context); };
    return AnimateRefAst;
}(Ast));
var QueryAst = (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](QueryAst, _super);
    /**
     * @param {?} selector
     * @param {?} limit
     * @param {?} optional
     * @param {?} includeSelf
     * @param {?} animation
     */
    function QueryAst(selector, limit, optional, includeSelf, animation) {
        var _this = _super.call(this) || this;
        _this.selector = selector;
        _this.limit = limit;
        _this.optional = optional;
        _this.includeSelf = includeSelf;
        _this.animation = animation;
        return _this;
    }
    /**
     * @param {?} visitor
     * @param {?} context
     * @return {?}
     */
    QueryAst.prototype.visit = function (visitor, context) { return visitor.visitQuery(this, context); };
    return QueryAst;
}(Ast));
var StaggerAst = (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](StaggerAst, _super);
    /**
     * @param {?} timings
     * @param {?} animation
     */
    function StaggerAst(timings, animation) {
        var _this = _super.call(this) || this;
        _this.timings = timings;
        _this.animation = animation;
        return _this;
    }
    /**
     * @param {?} visitor
     * @param {?} context
     * @return {?}
     */
    StaggerAst.prototype.visit = function (visitor, context) { return visitor.visitStagger(this, context); };
    return StaggerAst;
}(Ast));
var TimingAst = (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](TimingAst, _super);
    /**
     * @param {?} duration
     * @param {?=} delay
     * @param {?=} easing
     */
    function TimingAst(duration, delay, easing) {
        if (delay === void 0) { delay = 0; }
        if (easing === void 0) { easing = null; }
        var _this = _super.call(this) || this;
        _this.duration = duration;
        _this.delay = delay;
        _this.easing = easing;
        return _this;
    }
    /**
     * @param {?} visitor
     * @param {?} context
     * @return {?}
     */
    TimingAst.prototype.visit = function (visitor, context) { return visitor.visitTiming(this, context); };
    return TimingAst;
}(Ast));
var DynamicTimingAst = (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](DynamicTimingAst, _super);
    /**
     * @param {?} value
     */
    function DynamicTimingAst(value) {
        var _this = _super.call(this, 0, 0, '') || this;
        _this.value = value;
        return _this;
    }
    /**
     * @param {?} visitor
     * @param {?} context
     * @return {?}
     */
    DynamicTimingAst.prototype.visit = function (visitor, context) { return visitor.visitTiming(this, context); };
    return DynamicTimingAst;
}(TimingAst));
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @param {?} visitor
 * @param {?} node
 * @param {?} context
 * @return {?}
 */
function visitAnimationNode(visitor, node, context) {
    switch (node.type) {
        case 7 /* Trigger */:
            return visitor.visitTrigger(/** @type {?} */ (node), context);
        case 0 /* State */:
            return visitor.visitState(/** @type {?} */ (node), context);
        case 1 /* Transition */:
            return visitor.visitTransition(/** @type {?} */ (node), context);
        case 2 /* Sequence */:
            return visitor.visitSequence(/** @type {?} */ (node), context);
        case 3 /* Group */:
            return visitor.visitGroup(/** @type {?} */ (node), context);
        case 4 /* Animate */:
            return visitor.visitAnimate(/** @type {?} */ (node), context);
        case 5 /* Keyframes */:
            return visitor.visitKeyframes(/** @type {?} */ (node), context);
        case 6 /* Style */:
            return visitor.visitStyle(/** @type {?} */ (node), context);
        case 8 /* Reference */:
            return visitor.visitReference(/** @type {?} */ (node), context);
        case 9 /* AnimateChild */:
            return visitor.visitAnimateChild(/** @type {?} */ (node), context);
        case 10 /* AnimateRef */:
            return visitor.visitAnimateRef(/** @type {?} */ (node), context);
        case 11 /* Query */:
            return visitor.visitQuery(/** @type {?} */ (node), context);
        case 12 /* Stagger */:
            return visitor.visitStagger(/** @type {?} */ (node), context);
        default:
            throw new Error("Unable to resolve animation metadata node #" + node.type);
    }
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var ANY_STATE = '*';
/**
 * @param {?} transitionValue
 * @param {?} errors
 * @return {?}
 */
function parseTransitionExpr(transitionValue, errors) {
    var /** @type {?} */ expressions = [];
    if (typeof transitionValue == 'string') {
        ((transitionValue))
            .split(/\s*,\s*/)
            .forEach(function (str) { return parseInnerTransitionStr(str, expressions, errors); });
    }
    else {
        expressions.push(/** @type {?} */ (transitionValue));
    }
    return expressions;
}
/**
 * @param {?} eventStr
 * @param {?} expressions
 * @param {?} errors
 * @return {?}
 */
function parseInnerTransitionStr(eventStr, expressions, errors) {
    if (eventStr[0] == ':') {
        eventStr = parseAnimationAlias(eventStr, errors);
    }
    var /** @type {?} */ match = eventStr.match(/^(\*|[-\w]+)\s*(<?[=-]>)\s*(\*|[-\w]+)$/);
    if (match == null || match.length < 4) {
        errors.push("The provided transition expression \"" + eventStr + "\" is not supported");
        return expressions;
    }
    var /** @type {?} */ fromState = match[1];
    var /** @type {?} */ separator = match[2];
    var /** @type {?} */ toState = match[3];
    expressions.push(makeLambdaFromStates(fromState, toState));
    var /** @type {?} */ isFullAnyStateExpr = fromState == ANY_STATE && toState == ANY_STATE;
    if (separator[0] == '<' && !isFullAnyStateExpr) {
        expressions.push(makeLambdaFromStates(toState, fromState));
    }
}
/**
 * @param {?} alias
 * @param {?} errors
 * @return {?}
 */
function parseAnimationAlias(alias, errors) {
    switch (alias) {
        case ':enter':
            return 'void => *';
        case ':leave':
            return '* => void';
        default:
            errors.push("The transition alias value \"" + alias + "\" is not supported");
            return '* => *';
    }
}
/**
 * @param {?} lhs
 * @param {?} rhs
 * @return {?}
 */
function makeLambdaFromStates(lhs, rhs) {
    return function (fromState, toState) {
        var /** @type {?} */ lhsMatch = lhs == ANY_STATE || lhs == fromState;
        var /** @type {?} */ rhsMatch = rhs == ANY_STATE || rhs == toState;
        if (!lhsMatch && typeof fromState === 'boolean') {
            lhsMatch = fromState ? lhs === 'true' : lhs === 'false';
        }
        if (!rhsMatch && typeof toState === 'boolean') {
            rhsMatch = toState ? rhs === 'true' : rhs === 'false';
        }
        return lhsMatch && rhsMatch;
    };
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var SELF_TOKEN = ':self';
var SELF_TOKEN_REGEX = new RegExp("s*" + SELF_TOKEN + "s*,?", 'g');
/**
 * @param {?} metadata
 * @param {?} errors
 * @return {?}
 */
function buildAnimationAst(metadata, errors) {
    return new AnimationAstBuilderVisitor().build(metadata, errors);
}
var LEAVE_TOKEN = ':leave';
var LEAVE_TOKEN_REGEX = new RegExp(LEAVE_TOKEN, 'g');
var ENTER_TOKEN = ':enter';
var ENTER_TOKEN_REGEX = new RegExp(ENTER_TOKEN, 'g');
var ROOT_SELECTOR = '';
var AnimationAstBuilderVisitor = (function () {
    function AnimationAstBuilderVisitor() {
    }
    /**
     * @param {?} metadata
     * @param {?} errors
     * @return {?}
     */
    AnimationAstBuilderVisitor.prototype.build = function (metadata, errors) {
        var /** @type {?} */ context = new AnimationAstBuilderContext(errors);
        this._resetContextStyleTimingState(context);
        return (visitAnimationNode(this, normalizeAnimationEntry(metadata), context));
    };
    /**
     * @param {?} context
     * @return {?}
     */
    AnimationAstBuilderVisitor.prototype._resetContextStyleTimingState = function (context) {
        context.currentQuerySelector = ROOT_SELECTOR;
        context.collectedStyles = {};
        context.collectedStyles[ROOT_SELECTOR] = {};
        context.currentTime = 0;
    };
    /**
     * @param {?} metadata
     * @param {?} context
     * @return {?}
     */
    AnimationAstBuilderVisitor.prototype.visitTrigger = function (metadata, context) {
        var _this = this;
        var /** @type {?} */ queryCount = context.queryCount = 0;
        var /** @type {?} */ depCount = context.depCount = 0;
        var /** @type {?} */ states = [];
        var /** @type {?} */ transitions = [];
        metadata.definitions.forEach(function (def) {
            _this._resetContextStyleTimingState(context);
            if (def.type == 0 /* State */) {
                var /** @type {?} */ stateDef_1 = (def);
                var /** @type {?} */ name = stateDef_1.name;
                name.split(/\s*,\s*/).forEach(function (n) {
                    stateDef_1.name = n;
                    states.push(_this.visitState(stateDef_1, context));
                });
                stateDef_1.name = name;
            }
            else if (def.type == 1 /* Transition */) {
                var /** @type {?} */ transition = _this.visitTransition(/** @type {?} */ (def), context);
                queryCount += transition.queryCount;
                depCount += transition.depCount;
                transitions.push(transition);
            }
            else {
                context.errors.push('only state() and transition() definitions can sit inside of a trigger()');
            }
        });
        var /** @type {?} */ ast = new TriggerAst(metadata.name, states, transitions);
        ast.options = normalizeAnimationOptions(metadata.options);
        ast.queryCount = queryCount;
        ast.depCount = depCount;
        return ast;
    };
    /**
     * @param {?} metadata
     * @param {?} context
     * @return {?}
     */
    AnimationAstBuilderVisitor.prototype.visitState = function (metadata, context) {
        var /** @type {?} */ styleAst = this.visitStyle(metadata.styles, context);
        var /** @type {?} */ astParams = (metadata.options && metadata.options.params) || null;
        if (styleAst.containsDynamicStyles) {
            var /** @type {?} */ missingSubs_1 = new Set();
            var /** @type {?} */ params_1 = astParams || {};
            styleAst.styles.forEach(function (value) {
                if (isObject(value)) {
                    var /** @type {?} */ stylesObj_1 = (value);
                    Object.keys(stylesObj_1).forEach(function (prop) {
                        extractStyleParams(stylesObj_1[prop]).forEach(function (sub) {
                            if (!params_1.hasOwnProperty(sub)) {
                                missingSubs_1.add(sub);
                            }
                        });
                    });
                }
            });
            if (missingSubs_1.size) {
                var /** @type {?} */ missingSubsArr = iteratorToArray(missingSubs_1.values());
                context.errors.push("state(\"" + metadata.name + "\", ...) must define default values for all the following style substitutions: " + missingSubsArr.join(', '));
            }
        }
        var /** @type {?} */ stateAst = new StateAst(metadata.name, styleAst);
        if (astParams) {
            stateAst.options = { params: astParams };
        }
        return stateAst;
    };
    /**
     * @param {?} metadata
     * @param {?} context
     * @return {?}
     */
    AnimationAstBuilderVisitor.prototype.visitTransition = function (metadata, context) {
        context.queryCount = 0;
        context.depCount = 0;
        var /** @type {?} */ entry = visitAnimationNode(this, normalizeAnimationEntry(metadata.animation), context);
        var /** @type {?} */ matchers = parseTransitionExpr(metadata.expr, context.errors);
        var /** @type {?} */ ast = new TransitionAst(matchers, entry);
        ast.options = normalizeAnimationOptions(metadata.options);
        ast.queryCount = context.queryCount;
        ast.depCount = context.depCount;
        return ast;
    };
    /**
     * @param {?} metadata
     * @param {?} context
     * @return {?}
     */
    AnimationAstBuilderVisitor.prototype.visitSequence = function (metadata, context) {
        var _this = this;
        var /** @type {?} */ ast = new SequenceAst(metadata.steps.map(function (s) { return visitAnimationNode(_this, s, context); }));
        ast.options = normalizeAnimationOptions(metadata.options);
        return ast;
    };
    /**
     * @param {?} metadata
     * @param {?} context
     * @return {?}
     */
    AnimationAstBuilderVisitor.prototype.visitGroup = function (metadata, context) {
        var _this = this;
        var /** @type {?} */ currentTime = context.currentTime;
        var /** @type {?} */ furthestTime = 0;
        var /** @type {?} */ steps = metadata.steps.map(function (step) {
            context.currentTime = currentTime;
            var /** @type {?} */ innerAst = visitAnimationNode(_this, step, context);
            furthestTime = Math.max(furthestTime, context.currentTime);
            return innerAst;
        });
        context.currentTime = furthestTime;
        var /** @type {?} */ ast = new GroupAst(steps);
        ast.options = normalizeAnimationOptions(metadata.options);
        return ast;
    };
    /**
     * @param {?} metadata
     * @param {?} context
     * @return {?}
     */
    AnimationAstBuilderVisitor.prototype.visitAnimate = function (metadata, context) {
        var /** @type {?} */ timingAst = constructTimingAst(metadata.timings, context.errors);
        context.currentAnimateTimings = timingAst;
        var /** @type {?} */ styles;
        var /** @type {?} */ styleMetadata = metadata.styles ? metadata.styles : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_animations__["h" /* style */])({});
        if (styleMetadata.type == 5 /* Keyframes */) {
            styles = this.visitKeyframes(/** @type {?} */ (styleMetadata), context);
        }
        else {
            var /** @type {?} */ styleMetadata_1 = (metadata.styles);
            var /** @type {?} */ isEmpty = false;
            if (!styleMetadata_1) {
                isEmpty = true;
                var /** @type {?} */ newStyleData = {};
                if (timingAst.easing) {
                    newStyleData['easing'] = timingAst.easing;
                }
                styleMetadata_1 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_animations__["h" /* style */])(newStyleData);
            }
            context.currentTime += timingAst.duration + timingAst.delay;
            var /** @type {?} */ styleAst = this.visitStyle(styleMetadata_1, context);
            styleAst.isEmptyStep = isEmpty;
            styles = styleAst;
        }
        context.currentAnimateTimings = null;
        return new AnimateAst(timingAst, styles);
    };
    /**
     * @param {?} metadata
     * @param {?} context
     * @return {?}
     */
    AnimationAstBuilderVisitor.prototype.visitStyle = function (metadata, context) {
        var /** @type {?} */ ast = this._makeStyleAst(metadata, context);
        this._validateStyleAst(ast, context);
        return ast;
    };
    /**
     * @param {?} metadata
     * @param {?} context
     * @return {?}
     */
    AnimationAstBuilderVisitor.prototype._makeStyleAst = function (metadata, context) {
        var /** @type {?} */ styles = [];
        if (Array.isArray(metadata.styles)) {
            ((metadata.styles)).forEach(function (styleTuple) {
                if (typeof styleTuple == 'string') {
                    if (styleTuple == __WEBPACK_IMPORTED_MODULE_1__angular_animations__["g" /* AUTO_STYLE */]) {
                        styles.push(/** @type {?} */ (styleTuple));
                    }
                    else {
                        context.errors.push("The provided style string value " + styleTuple + " is not allowed.");
                    }
                }
                else {
                    styles.push(/** @type {?} */ (styleTuple));
                }
            });
        }
        else {
            styles.push(metadata.styles);
        }
        var /** @type {?} */ containsDynamicStyles = false;
        var /** @type {?} */ collectedEasing = null;
        styles.forEach(function (styleData) {
            if (isObject(styleData)) {
                var /** @type {?} */ styleMap = (styleData);
                var /** @type {?} */ easing = styleMap['easing'];
                if (easing) {
                    collectedEasing = (easing);
                    delete styleMap['easing'];
                }
                if (!containsDynamicStyles) {
                    for (var /** @type {?} */ prop in styleMap) {
                        var /** @type {?} */ value = styleMap[prop];
                        if (value.toString().indexOf(SUBSTITUTION_EXPR_START) >= 0) {
                            containsDynamicStyles = true;
                            break;
                        }
                    }
                }
            }
        });
        var /** @type {?} */ ast = new StyleAst(styles, collectedEasing, metadata.offset);
        ast.containsDynamicStyles = containsDynamicStyles;
        return ast;
    };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    AnimationAstBuilderVisitor.prototype._validateStyleAst = function (ast, context) {
        var /** @type {?} */ timings = context.currentAnimateTimings;
        var /** @type {?} */ endTime = context.currentTime;
        var /** @type {?} */ startTime = context.currentTime;
        if (timings && startTime > 0) {
            startTime -= timings.duration + timings.delay;
        }
        ast.styles.forEach(function (tuple) {
            if (typeof tuple == 'string')
                return;
            Object.keys(tuple).forEach(function (prop) {
                var /** @type {?} */ collectedStyles = context.collectedStyles[((context.currentQuerySelector))];
                var /** @type {?} */ collectedEntry = collectedStyles[prop];
                var /** @type {?} */ updateCollectedStyle = true;
                if (collectedEntry) {
                    if (startTime != endTime && startTime >= collectedEntry.startTime &&
                        endTime <= collectedEntry.endTime) {
                        context.errors.push("The CSS property \"" + prop + "\" that exists between the times of \"" + collectedEntry.startTime + "ms\" and \"" + collectedEntry.endTime + "ms\" is also being animated in a parallel animation between the times of \"" + startTime + "ms\" and \"" + endTime + "ms\"");
                        updateCollectedStyle = false;
                    }
                    // we always choose the smaller start time value since we
                    // want to have a record of the entire animation window where
                    // the style property is being animated in between
                    startTime = collectedEntry.startTime;
                }
                if (updateCollectedStyle) {
                    collectedStyles[prop] = { startTime: startTime, endTime: endTime };
                }
                if (context.options) {
                    validateStyleParams(tuple[prop], context.options, context.errors);
                }
            });
        });
    };
    /**
     * @param {?} metadata
     * @param {?} context
     * @return {?}
     */
    AnimationAstBuilderVisitor.prototype.visitKeyframes = function (metadata, context) {
        var _this = this;
        if (!context.currentAnimateTimings) {
            context.errors.push("keyframes() must be placed inside of a call to animate()");
            return new KeyframesAst([]);
        }
        var /** @type {?} */ MAX_KEYFRAME_OFFSET = 1;
        var /** @type {?} */ totalKeyframesWithOffsets = 0;
        var /** @type {?} */ offsets = [];
        var /** @type {?} */ offsetsOutOfOrder = false;
        var /** @type {?} */ keyframesOutOfRange = false;
        var /** @type {?} */ previousOffset = 0;
        var /** @type {?} */ keyframes = metadata.steps.map(function (styles) {
            var /** @type {?} */ style$$1 = _this._makeStyleAst(styles, context);
            var /** @type {?} */ offsetVal = style$$1.offset != null ? style$$1.offset : consumeOffset(style$$1.styles);
            var /** @type {?} */ offset = 0;
            if (offsetVal != null) {
                totalKeyframesWithOffsets++;
                offset = style$$1.offset = offsetVal;
            }
            keyframesOutOfRange = keyframesOutOfRange || offset < 0 || offset > 1;
            offsetsOutOfOrder = offsetsOutOfOrder || offset < previousOffset;
            previousOffset = offset;
            offsets.push(offset);
            return style$$1;
        });
        if (keyframesOutOfRange) {
            context.errors.push("Please ensure that all keyframe offsets are between 0 and 1");
        }
        if (offsetsOutOfOrder) {
            context.errors.push("Please ensure that all keyframe offsets are in order");
        }
        var /** @type {?} */ length = metadata.steps.length;
        var /** @type {?} */ generatedOffset = 0;
        if (totalKeyframesWithOffsets > 0 && totalKeyframesWithOffsets < length) {
            context.errors.push("Not all style() steps within the declared keyframes() contain offsets");
        }
        else if (totalKeyframesWithOffsets == 0) {
            generatedOffset = MAX_KEYFRAME_OFFSET / (length - 1);
        }
        var /** @type {?} */ limit = length - 1;
        var /** @type {?} */ currentTime = context.currentTime;
        var /** @type {?} */ currentAnimateTimings = ((context.currentAnimateTimings));
        var /** @type {?} */ animateDuration = currentAnimateTimings.duration;
        keyframes.forEach(function (kf, i) {
            var /** @type {?} */ offset = generatedOffset > 0 ? (i == limit ? 1 : (generatedOffset * i)) : offsets[i];
            var /** @type {?} */ durationUpToThisFrame = offset * animateDuration;
            context.currentTime = currentTime + currentAnimateTimings.delay + durationUpToThisFrame;
            currentAnimateTimings.duration = durationUpToThisFrame;
            _this._validateStyleAst(kf, context);
            kf.offset = offset;
        });
        return new KeyframesAst(keyframes);
    };
    /**
     * @param {?} metadata
     * @param {?} context
     * @return {?}
     */
    AnimationAstBuilderVisitor.prototype.visitReference = function (metadata, context) {
        var /** @type {?} */ entry = visitAnimationNode(this, normalizeAnimationEntry(metadata.animation), context);
        var /** @type {?} */ ast = new ReferenceAst(entry);
        ast.options = normalizeAnimationOptions(metadata.options);
        return ast;
    };
    /**
     * @param {?} metadata
     * @param {?} context
     * @return {?}
     */
    AnimationAstBuilderVisitor.prototype.visitAnimateChild = function (metadata, context) {
        context.depCount++;
        var /** @type {?} */ ast = new AnimateChildAst();
        ast.options = normalizeAnimationOptions(metadata.options);
        return ast;
    };
    /**
     * @param {?} metadata
     * @param {?} context
     * @return {?}
     */
    AnimationAstBuilderVisitor.prototype.visitAnimateRef = function (metadata, context) {
        var /** @type {?} */ animation = this.visitReference(metadata.animation, context);
        var /** @type {?} */ ast = new AnimateRefAst(animation);
        ast.options = normalizeAnimationOptions(metadata.options);
        return ast;
    };
    /**
     * @param {?} metadata
     * @param {?} context
     * @return {?}
     */
    AnimationAstBuilderVisitor.prototype.visitQuery = function (metadata, context) {
        var /** @type {?} */ parentSelector = ((context.currentQuerySelector));
        var /** @type {?} */ options = ((metadata.options || {}));
        context.queryCount++;
        context.currentQuery = metadata;
        var _a = normalizeSelector(metadata.selector), selector = _a[0], includeSelf = _a[1];
        context.currentQuerySelector =
            parentSelector.length ? (parentSelector + ' ' + selector) : selector;
        getOrSetAsInMap(context.collectedStyles, context.currentQuerySelector, {});
        var /** @type {?} */ entry = visitAnimationNode(this, normalizeAnimationEntry(metadata.animation), context);
        context.currentQuery = null;
        context.currentQuerySelector = parentSelector;
        var /** @type {?} */ ast = new QueryAst(selector, options.limit || 0, !!options.optional, includeSelf, entry);
        ast.originalSelector = metadata.selector;
        ast.options = normalizeAnimationOptions(metadata.options);
        return ast;
    };
    /**
     * @param {?} metadata
     * @param {?} context
     * @return {?}
     */
    AnimationAstBuilderVisitor.prototype.visitStagger = function (metadata, context) {
        if (!context.currentQuery) {
            context.errors.push("stagger() can only be used inside of query()");
        }
        var /** @type {?} */ timings = metadata.timings === 'full' ?
            { duration: 0, delay: 0, easing: 'full' } :
            resolveTiming(metadata.timings, context.errors, true);
        var /** @type {?} */ animation = visitAnimationNode(this, normalizeAnimationEntry(metadata.animation), context);
        return new StaggerAst(timings, animation);
    };
    return AnimationAstBuilderVisitor;
}());
/**
 * @param {?} selector
 * @return {?}
 */
function normalizeSelector(selector) {
    var /** @type {?} */ hasAmpersand = selector.split(/\s*,\s*/).find(function (token) { return token == SELF_TOKEN; }) ? true : false;
    if (hasAmpersand) {
        selector = selector.replace(SELF_TOKEN_REGEX, '');
    }
    selector = selector.replace(ENTER_TOKEN_REGEX, ENTER_SELECTOR)
        .replace(LEAVE_TOKEN_REGEX, LEAVE_SELECTOR)
        .replace(/@\*/g, NG_TRIGGER_SELECTOR)
        .replace(/@\w+/g, function (match) { return NG_TRIGGER_SELECTOR + '-' + match.substr(1); })
        .replace(/:animating/g, NG_ANIMATING_SELECTOR);
    return [selector, hasAmpersand];
}
/**
 * @param {?} obj
 * @return {?}
 */
function normalizeParams(obj) {
    return obj ? copyObj(obj) : null;
}
var AnimationAstBuilderContext = (function () {
    /**
     * @param {?} errors
     */
    function AnimationAstBuilderContext(errors) {
        this.errors = errors;
        this.queryCount = 0;
        this.depCount = 0;
        this.currentTransition = null;
        this.currentQuery = null;
        this.currentQuerySelector = null;
        this.currentAnimateTimings = null;
        this.currentTime = 0;
        this.collectedStyles = {};
        this.options = null;
    }
    return AnimationAstBuilderContext;
}());
/**
 * @param {?} styles
 * @return {?}
 */
function consumeOffset(styles) {
    if (typeof styles == 'string')
        return null;
    var /** @type {?} */ offset = null;
    if (Array.isArray(styles)) {
        styles.forEach(function (styleTuple) {
            if (isObject(styleTuple) && styleTuple.hasOwnProperty('offset')) {
                var /** @type {?} */ obj = (styleTuple);
                offset = parseFloat(/** @type {?} */ (obj['offset']));
                delete obj['offset'];
            }
        });
    }
    else if (isObject(styles) && styles.hasOwnProperty('offset')) {
        var /** @type {?} */ obj = (styles);
        offset = parseFloat(/** @type {?} */ (obj['offset']));
        delete obj['offset'];
    }
    return offset;
}
/**
 * @param {?} value
 * @return {?}
 */
function isObject(value) {
    return !Array.isArray(value) && typeof value == 'object';
}
/**
 * @param {?} value
 * @param {?} errors
 * @return {?}
 */
function constructTimingAst(value, errors) {
    var /** @type {?} */ timings = null;
    if (value.hasOwnProperty('duration')) {
        timings = (value);
    }
    else if (typeof value == 'number') {
        var /** @type {?} */ duration = resolveTiming(/** @type {?} */ (value), errors).duration;
        return new TimingAst(/** @type {?} */ (value), 0, '');
    }
    var /** @type {?} */ strValue = (value);
    var /** @type {?} */ isDynamic = strValue.split(/\s+/).some(function (v) { return v.charAt(0) == '{' && v.charAt(1) == '{'; });
    if (isDynamic) {
        return new DynamicTimingAst(strValue);
    }
    timings = timings || resolveTiming(strValue, errors);
    return new TimingAst(timings.duration, timings.delay, timings.easing);
}
/**
 * @param {?} options
 * @return {?}
 */
function normalizeAnimationOptions(options) {
    if (options) {
        options = copyObj(options);
        if (options['params']) {
            options['params'] = ((normalizeParams(options['params'])));
        }
    }
    else {
        options = {};
    }
    return options;
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @param {?} element
 * @param {?} keyframes
 * @param {?} preStyleProps
 * @param {?} postStyleProps
 * @param {?} duration
 * @param {?} delay
 * @param {?=} easing
 * @param {?=} subTimeline
 * @return {?}
 */
function createTimelineInstruction(element, keyframes, preStyleProps, postStyleProps, duration, delay, easing, subTimeline) {
    if (easing === void 0) { easing = null; }
    if (subTimeline === void 0) { subTimeline = false; }
    return {
        type: 1 /* TimelineAnimation */,
        element: element,
        keyframes: keyframes,
        preStyleProps: preStyleProps,
        postStyleProps: postStyleProps,
        duration: duration,
        delay: delay,
        totalTime: duration + delay, easing: easing, subTimeline: subTimeline
    };
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var ElementInstructionMap = (function () {
    function ElementInstructionMap() {
        this._map = new Map();
    }
    /**
     * @param {?} element
     * @return {?}
     */
    ElementInstructionMap.prototype.consume = function (element) {
        var /** @type {?} */ instructions = this._map.get(element);
        if (instructions) {
            this._map.delete(element);
        }
        else {
            instructions = [];
        }
        return instructions;
    };
    /**
     * @param {?} element
     * @param {?} instructions
     * @return {?}
     */
    ElementInstructionMap.prototype.append = function (element, instructions) {
        var /** @type {?} */ existingInstructions = this._map.get(element);
        if (!existingInstructions) {
            this._map.set(element, existingInstructions = []);
        }
        existingInstructions.push.apply(existingInstructions, instructions);
    };
    /**
     * @param {?} element
     * @return {?}
     */
    ElementInstructionMap.prototype.has = function (element) { return this._map.has(element); };
    /**
     * @return {?}
     */
    ElementInstructionMap.prototype.clear = function () { this._map.clear(); };
    return ElementInstructionMap;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var ONE_FRAME_IN_MILLISECONDS = 1;
/**
 * @param {?} driver
 * @param {?} rootElement
 * @param {?} ast
 * @param {?=} startingStyles
 * @param {?=} finalStyles
 * @param {?=} options
 * @param {?=} subInstructions
 * @param {?=} errors
 * @return {?}
 */
function buildAnimationTimelines(driver, rootElement, ast, startingStyles, finalStyles, options, subInstructions, errors) {
    if (startingStyles === void 0) { startingStyles = {}; }
    if (finalStyles === void 0) { finalStyles = {}; }
    if (errors === void 0) { errors = []; }
    return new AnimationTimelineBuilderVisitor().buildKeyframes(driver, rootElement, ast, startingStyles, finalStyles, options, subInstructions, errors);
}
var AnimationTimelineBuilderVisitor = (function () {
    function AnimationTimelineBuilderVisitor() {
    }
    /**
     * @param {?} driver
     * @param {?} rootElement
     * @param {?} ast
     * @param {?} startingStyles
     * @param {?} finalStyles
     * @param {?} options
     * @param {?=} subInstructions
     * @param {?=} errors
     * @return {?}
     */
    AnimationTimelineBuilderVisitor.prototype.buildKeyframes = function (driver, rootElement, ast, startingStyles, finalStyles, options, subInstructions, errors) {
        if (errors === void 0) { errors = []; }
        subInstructions = subInstructions || new ElementInstructionMap();
        var /** @type {?} */ context = new AnimationTimelineContext(driver, rootElement, subInstructions, errors, []);
        context.options = options;
        context.currentTimeline.setStyles([startingStyles], null, context.errors, options);
        ast.visit(this, context);
        // this checks to see if an actual animation happened
        var /** @type {?} */ timelines = context.timelines.filter(function (timeline) { return timeline.containsAnimation(); });
        if (timelines.length && Object.keys(finalStyles).length) {
            var /** @type {?} */ tl = timelines[timelines.length - 1];
            if (!tl.allowOnlyTimelineStyles()) {
                tl.setStyles([finalStyles], null, context.errors, options);
            }
        }
        return timelines.length ? timelines.map(function (timeline) { return timeline.buildKeyframes(); }) :
            [createTimelineInstruction(rootElement, [], [], [], 0, 0, '', false)];
    };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    AnimationTimelineBuilderVisitor.prototype.visitTrigger = function (ast, context) {
        // these values are not visited in this AST
    };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    AnimationTimelineBuilderVisitor.prototype.visitState = function (ast, context) {
        // these values are not visited in this AST
    };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    AnimationTimelineBuilderVisitor.prototype.visitTransition = function (ast, context) {
        // these values are not visited in this AST
    };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    AnimationTimelineBuilderVisitor.prototype.visitAnimateChild = function (ast, context) {
        var /** @type {?} */ elementInstructions = context.subInstructions.consume(context.element);
        if (elementInstructions) {
            var /** @type {?} */ innerContext = context.createSubContext(ast.options);
            var /** @type {?} */ startTime = context.currentTimeline.currentTime;
            var /** @type {?} */ endTime = this._visitSubInstructions(elementInstructions, innerContext, /** @type {?} */ (innerContext.options));
            if (startTime != endTime) {
                // we do this on the upper context because we created a sub context for
                // the sub child animations
                context.transformIntoNewTimeline(endTime);
            }
        }
        context.previousNode = ast;
    };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    AnimationTimelineBuilderVisitor.prototype.visitAnimateRef = function (ast, context) {
        var /** @type {?} */ innerContext = context.createSubContext(ast.options);
        innerContext.transformIntoNewTimeline();
        this.visitReference(ast.animation, innerContext);
        context.transformIntoNewTimeline(innerContext.currentTimeline.currentTime);
        context.previousNode = ast;
    };
    /**
     * @param {?} instructions
     * @param {?} context
     * @param {?} options
     * @return {?}
     */
    AnimationTimelineBuilderVisitor.prototype._visitSubInstructions = function (instructions, context, options) {
        var /** @type {?} */ startTime = context.currentTimeline.currentTime;
        var /** @type {?} */ furthestTime = startTime;
        // this is a special-case for when a user wants to skip a sub
        // animation from being fired entirely.
        var /** @type {?} */ duration = options.duration != null ? resolveTimingValue(options.duration) : null;
        var /** @type {?} */ delay = options.delay != null ? resolveTimingValue(options.delay) : null;
        if (duration !== 0) {
            instructions.forEach(function (instruction) {
                var /** @type {?} */ instructionTimings = context.appendInstructionToTimeline(instruction, duration, delay);
                furthestTime =
                    Math.max(furthestTime, instructionTimings.duration + instructionTimings.delay);
            });
        }
        return furthestTime;
    };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    AnimationTimelineBuilderVisitor.prototype.visitReference = function (ast, context) {
        context.updateOptions(ast.options, true);
        ast.animation.visit(this, context);
        context.previousNode = ast;
    };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    AnimationTimelineBuilderVisitor.prototype.visitSequence = function (ast, context) {
        var _this = this;
        var /** @type {?} */ subContextCount = context.subContextCount;
        var /** @type {?} */ ctx = context;
        var /** @type {?} */ options = ast.options;
        if (options && (options.params || options.delay)) {
            ctx = context.createSubContext(options);
            ctx.transformIntoNewTimeline();
            if (options.delay != null) {
                if (ctx.previousNode instanceof StyleAst) {
                    ctx.currentTimeline.snapshotCurrentStyles();
                    ctx.previousNode = DEFAULT_NOOP_PREVIOUS_NODE;
                }
                var /** @type {?} */ delay = resolveTimingValue(options.delay);
                ctx.delayNextStep(delay);
            }
        }
        if (ast.steps.length) {
            ast.steps.forEach(function (s) { return s.visit(_this, ctx); });
            // this is here just incase the inner steps only contain or end with a style() call
            ctx.currentTimeline.applyStylesToKeyframe();
            // this means that some animation function within the sequence
            // ended up creating a sub timeline (which means the current
            // timeline cannot overlap with the contents of the sequence)
            if (ctx.subContextCount > subContextCount) {
                ctx.transformIntoNewTimeline();
            }
        }
        context.previousNode = ast;
    };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    AnimationTimelineBuilderVisitor.prototype.visitGroup = function (ast, context) {
        var _this = this;
        var /** @type {?} */ innerTimelines = [];
        var /** @type {?} */ furthestTime = context.currentTimeline.currentTime;
        var /** @type {?} */ delay = ast.options && ast.options.delay ? resolveTimingValue(ast.options.delay) : 0;
        ast.steps.forEach(function (s) {
            var /** @type {?} */ innerContext = context.createSubContext(ast.options);
            if (delay) {
                innerContext.delayNextStep(delay);
            }
            s.visit(_this, innerContext);
            furthestTime = Math.max(furthestTime, innerContext.currentTimeline.currentTime);
            innerTimelines.push(innerContext.currentTimeline);
        });
        // this operation is run after the AST loop because otherwise
        // if the parent timeline's collected styles were updated then
        // it would pass in invalid data into the new-to-be forked items
        innerTimelines.forEach(function (timeline) { return context.currentTimeline.mergeTimelineCollectedStyles(timeline); });
        context.transformIntoNewTimeline(furthestTime);
        context.previousNode = ast;
    };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    AnimationTimelineBuilderVisitor.prototype.visitTiming = function (ast, context) {
        if (ast instanceof DynamicTimingAst) {
            var /** @type {?} */ strValue = context.params ?
                interpolateParams(ast.value, context.params, context.errors) :
                ast.value.toString();
            return resolveTiming(strValue, context.errors);
        }
        else {
            return { duration: ast.duration, delay: ast.delay, easing: ast.easing };
        }
    };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    AnimationTimelineBuilderVisitor.prototype.visitAnimate = function (ast, context) {
        var /** @type {?} */ timings = context.currentAnimateTimings = this.visitTiming(ast.timings, context);
        var /** @type {?} */ timeline = context.currentTimeline;
        if (timings.delay) {
            context.incrementTime(timings.delay);
            timeline.snapshotCurrentStyles();
        }
        var /** @type {?} */ style$$1 = ast.style;
        if (style$$1 instanceof KeyframesAst) {
            this.visitKeyframes(style$$1, context);
        }
        else {
            context.incrementTime(timings.duration);
            this.visitStyle(/** @type {?} */ (style$$1), context);
            timeline.applyStylesToKeyframe();
        }
        context.currentAnimateTimings = null;
        context.previousNode = ast;
    };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    AnimationTimelineBuilderVisitor.prototype.visitStyle = function (ast, context) {
        var /** @type {?} */ timeline = context.currentTimeline;
        var /** @type {?} */ timings = ((context.currentAnimateTimings));
        // this is a special case for when a style() call
        // directly follows  an animate() call (but not inside of an animate() call)
        if (!timings && timeline.getCurrentStyleProperties().length) {
            timeline.forwardFrame();
        }
        var /** @type {?} */ easing = (timings && timings.easing) || ast.easing;
        if (ast.isEmptyStep) {
            timeline.applyEmptyStep(easing);
        }
        else {
            timeline.setStyles(ast.styles, easing, context.errors, context.options);
        }
        context.previousNode = ast;
    };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    AnimationTimelineBuilderVisitor.prototype.visitKeyframes = function (ast, context) {
        var /** @type {?} */ currentAnimateTimings = ((context.currentAnimateTimings));
        var /** @type {?} */ startTime = (((context.currentTimeline))).duration;
        var /** @type {?} */ duration = currentAnimateTimings.duration;
        var /** @type {?} */ innerContext = context.createSubContext();
        var /** @type {?} */ innerTimeline = innerContext.currentTimeline;
        innerTimeline.easing = currentAnimateTimings.easing;
        ast.styles.forEach(function (step) {
            var /** @type {?} */ offset = step.offset || 0;
            innerTimeline.forwardTime(offset * duration);
            innerTimeline.setStyles(step.styles, step.easing, context.errors, context.options);
            innerTimeline.applyStylesToKeyframe();
        });
        // this will ensure that the parent timeline gets all the styles from
        // the child even if the new timeline below is not used
        context.currentTimeline.mergeTimelineCollectedStyles(innerTimeline);
        // we do this because the window between this timeline and the sub timeline
        // should ensure that the styles within are exactly the same as they were before
        context.transformIntoNewTimeline(startTime + duration);
        context.previousNode = ast;
    };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    AnimationTimelineBuilderVisitor.prototype.visitQuery = function (ast, context) {
        var _this = this;
        // in the event that the first step before this is a style step we need
        // to ensure the styles are applied before the children are animated
        var /** @type {?} */ startTime = context.currentTimeline.currentTime;
        var /** @type {?} */ options = ((ast.options || {}));
        var /** @type {?} */ delay = options.delay ? resolveTimingValue(options.delay) : 0;
        if (delay && (context.previousNode instanceof StyleAst ||
            (startTime == 0 && context.currentTimeline.getCurrentStyleProperties().length))) {
            context.currentTimeline.snapshotCurrentStyles();
            context.previousNode = DEFAULT_NOOP_PREVIOUS_NODE;
        }
        var /** @type {?} */ furthestTime = startTime;
        var /** @type {?} */ elms = context.invokeQuery(ast.selector, ast.originalSelector, ast.limit, ast.includeSelf, options.optional ? true : false, context.errors);
        context.currentQueryTotal = elms.length;
        var /** @type {?} */ sameElementTimeline = null;
        elms.forEach(function (element, i) {
            context.currentQueryIndex = i;
            var /** @type {?} */ innerContext = context.createSubContext(ast.options, element);
            if (delay) {
                innerContext.delayNextStep(delay);
            }
            if (element === context.element) {
                sameElementTimeline = innerContext.currentTimeline;
            }
            ast.animation.visit(_this, innerContext);
            // this is here just incase the inner steps only contain or end
            // with a style() call (which is here to signal that this is a preparatory
            // call to style an element before it is animated again)
            innerContext.currentTimeline.applyStylesToKeyframe();
            var /** @type {?} */ endTime = innerContext.currentTimeline.currentTime;
            furthestTime = Math.max(furthestTime, endTime);
        });
        context.currentQueryIndex = 0;
        context.currentQueryTotal = 0;
        context.transformIntoNewTimeline(furthestTime);
        if (sameElementTimeline) {
            context.currentTimeline.mergeTimelineCollectedStyles(sameElementTimeline);
            context.currentTimeline.snapshotCurrentStyles();
        }
        context.previousNode = ast;
    };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    AnimationTimelineBuilderVisitor.prototype.visitStagger = function (ast, context) {
        var /** @type {?} */ parentContext = ((context.parentContext));
        var /** @type {?} */ tl = context.currentTimeline;
        var /** @type {?} */ timings = ast.timings;
        var /** @type {?} */ duration = Math.abs(timings.duration);
        var /** @type {?} */ maxTime = duration * (context.currentQueryTotal - 1);
        var /** @type {?} */ delay = duration * context.currentQueryIndex;
        var /** @type {?} */ staggerTransformer = timings.duration < 0 ? 'reverse' : timings.easing;
        switch (staggerTransformer) {
            case 'reverse':
                delay = maxTime - delay;
                break;
            case 'full':
                delay = parentContext.currentStaggerTime;
                break;
        }
        var /** @type {?} */ timeline = context.currentTimeline;
        if (delay) {
            timeline.delayNextStep(delay);
        }
        var /** @type {?} */ startingTime = timeline.currentTime;
        ast.animation.visit(this, context);
        context.previousNode = ast;
        // time = duration + delay
        // the reason why this computation is so complex is because
        // the inner timeline may either have a delay value or a stretched
        // keyframe depending on if a subtimeline is not used or is used.
        parentContext.currentStaggerTime =
            (tl.currentTime - startingTime) + (tl.startTime - parentContext.currentTimeline.startTime);
    };
    return AnimationTimelineBuilderVisitor;
}());
var DEFAULT_NOOP_PREVIOUS_NODE = ({});
var AnimationTimelineContext = (function () {
    /**
     * @param {?} _driver
     * @param {?} element
     * @param {?} subInstructions
     * @param {?} errors
     * @param {?} timelines
     * @param {?=} initialTimeline
     */
    function AnimationTimelineContext(_driver, element, subInstructions, errors, timelines, initialTimeline) {
        this._driver = _driver;
        this.element = element;
        this.subInstructions = subInstructions;
        this.errors = errors;
        this.timelines = timelines;
        this.parentContext = null;
        this.currentAnimateTimings = null;
        this.previousNode = DEFAULT_NOOP_PREVIOUS_NODE;
        this.subContextCount = 0;
        this.options = {};
        this.currentQueryIndex = 0;
        this.currentQueryTotal = 0;
        this.currentStaggerTime = 0;
        this.currentTimeline = initialTimeline || new TimelineBuilder(element, 0);
        timelines.push(this.currentTimeline);
    }
    Object.defineProperty(AnimationTimelineContext.prototype, "params", {
        /**
         * @return {?}
         */
        get: function () { return this.options.params; },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} options
     * @param {?=} skipIfExists
     * @return {?}
     */
    AnimationTimelineContext.prototype.updateOptions = function (options, skipIfExists) {
        var _this = this;
        if (!options)
            return;
        var /** @type {?} */ newOptions = (options);
        var /** @type {?} */ optionsToUpdate = this.options;
        // NOTE: this will get patched up when other animation methods support duration overrides
        if (newOptions.duration != null) {
            ((optionsToUpdate)).duration = resolveTimingValue(newOptions.duration);
        }
        if (newOptions.delay != null) {
            optionsToUpdate.delay = resolveTimingValue(newOptions.delay);
        }
        var /** @type {?} */ newParams = newOptions.params;
        if (newParams) {
            var /** @type {?} */ paramsToUpdate_1 = ((optionsToUpdate.params));
            if (!paramsToUpdate_1) {
                paramsToUpdate_1 = this.options.params = {};
            }
            Object.keys(newParams).forEach(function (name) {
                if (!skipIfExists || !paramsToUpdate_1.hasOwnProperty(name)) {
                    paramsToUpdate_1[name] = interpolateParams(newParams[name], paramsToUpdate_1, _this.errors);
                }
            });
        }
    };
    /**
     * @return {?}
     */
    AnimationTimelineContext.prototype._copyOptions = function () {
        var /** @type {?} */ options = {};
        if (this.options) {
            var /** @type {?} */ oldParams_1 = this.options.params;
            if (oldParams_1) {
                var /** @type {?} */ params_2 = options['params'] = {};
                Object.keys(this.options.params).forEach(function (name) { params_2[name] = oldParams_1[name]; });
            }
        }
        return options;
    };
    /**
     * @param {?=} options
     * @param {?=} element
     * @param {?=} newTime
     * @return {?}
     */
    AnimationTimelineContext.prototype.createSubContext = function (options, element, newTime) {
        if (options === void 0) { options = null; }
        var /** @type {?} */ target = element || this.element;
        var /** @type {?} */ context = new AnimationTimelineContext(this._driver, target, this.subInstructions, this.errors, this.timelines, this.currentTimeline.fork(target, newTime || 0));
        context.previousNode = this.previousNode;
        context.currentAnimateTimings = this.currentAnimateTimings;
        context.options = this._copyOptions();
        context.updateOptions(options);
        context.currentQueryIndex = this.currentQueryIndex;
        context.currentQueryTotal = this.currentQueryTotal;
        context.parentContext = this;
        this.subContextCount++;
        return context;
    };
    /**
     * @param {?=} newTime
     * @return {?}
     */
    AnimationTimelineContext.prototype.transformIntoNewTimeline = function (newTime) {
        this.previousNode = DEFAULT_NOOP_PREVIOUS_NODE;
        this.currentTimeline = this.currentTimeline.fork(this.element, newTime);
        this.timelines.push(this.currentTimeline);
        return this.currentTimeline;
    };
    /**
     * @param {?} instruction
     * @param {?} duration
     * @param {?} delay
     * @return {?}
     */
    AnimationTimelineContext.prototype.appendInstructionToTimeline = function (instruction, duration, delay) {
        var /** @type {?} */ updatedTimings = {
            duration: duration != null ? duration : instruction.duration,
            delay: this.currentTimeline.currentTime + (delay != null ? delay : 0) + instruction.delay,
            easing: ''
        };
        var /** @type {?} */ builder = new SubTimelineBuilder(instruction.element, instruction.keyframes, instruction.preStyleProps, instruction.postStyleProps, updatedTimings, instruction.stretchStartingKeyframe);
        this.timelines.push(builder);
        return updatedTimings;
    };
    /**
     * @param {?} time
     * @return {?}
     */
    AnimationTimelineContext.prototype.incrementTime = function (time) {
        this.currentTimeline.forwardTime(this.currentTimeline.duration + time);
    };
    /**
     * @param {?} delay
     * @return {?}
     */
    AnimationTimelineContext.prototype.delayNextStep = function (delay) {
        // negative delays are not yet supported
        if (delay > 0) {
            this.currentTimeline.delayNextStep(delay);
        }
    };
    /**
     * @param {?} selector
     * @param {?} originalSelector
     * @param {?} limit
     * @param {?} includeSelf
     * @param {?} optional
     * @param {?} errors
     * @return {?}
     */
    AnimationTimelineContext.prototype.invokeQuery = function (selector, originalSelector, limit, includeSelf, optional, errors) {
        var /** @type {?} */ results = [];
        if (includeSelf) {
            results.push(this.element);
        }
        if (selector.length > 0) {
            var /** @type {?} */ multi = limit != 1;
            var /** @type {?} */ elements = this._driver.query(this.element, selector, multi);
            if (limit !== 0) {
                elements = elements.slice(0, limit);
            }
            results.push.apply(results, elements);
        }
        if (!optional && results.length == 0) {
            errors.push("`query(\"" + originalSelector + "\")` returned zero elements. (Use `query(\"" + originalSelector + "\", { optional: true })` if you wish to allow this.)");
        }
        return results;
    };
    return AnimationTimelineContext;
}());
var TimelineBuilder = (function () {
    /**
     * @param {?} element
     * @param {?} startTime
     * @param {?=} _elementTimelineStylesLookup
     */
    function TimelineBuilder(element, startTime, _elementTimelineStylesLookup) {
        this.element = element;
        this.startTime = startTime;
        this._elementTimelineStylesLookup = _elementTimelineStylesLookup;
        this.duration = 0;
        this._previousKeyframe = {};
        this._currentKeyframe = {};
        this._keyframes = new Map();
        this._styleSummary = {};
        this._pendingStyles = {};
        this._backFill = {};
        this._currentEmptyStepKeyframe = null;
        if (!this._elementTimelineStylesLookup) {
            this._elementTimelineStylesLookup = new Map();
        }
        this._localTimelineStyles = Object.create(this._backFill, {});
        this._globalTimelineStyles = this._elementTimelineStylesLookup.get(element);
        if (!this._globalTimelineStyles) {
            this._globalTimelineStyles = this._localTimelineStyles;
            this._elementTimelineStylesLookup.set(element, this._localTimelineStyles);
        }
        this._loadKeyframe();
    }
    /**
     * @return {?}
     */
    TimelineBuilder.prototype.containsAnimation = function () {
        switch (this._keyframes.size) {
            case 0:
                return false;
            case 1:
                return this.getCurrentStyleProperties().length > 0;
            default:
                return true;
        }
    };
    /**
     * @return {?}
     */
    TimelineBuilder.prototype.getCurrentStyleProperties = function () { return Object.keys(this._currentKeyframe); };
    Object.defineProperty(TimelineBuilder.prototype, "currentTime", {
        /**
         * @return {?}
         */
        get: function () { return this.startTime + this.duration; },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} delay
     * @return {?}
     */
    TimelineBuilder.prototype.delayNextStep = function (delay) {
        // in the event that a style() step is placed right before a stagger()
        // and that style() step is the very first style() value in the animation
        // then we need to make a copy of the keyframe [0, copy, 1] so that the delay
        // properly applies the style() values to work with the stagger...
        var /** @type {?} */ hasPreStyleStep = this._keyframes.size == 1 && Object.keys(this._pendingStyles).length;
        if (this.duration || hasPreStyleStep) {
            this.forwardTime(this.currentTime + delay);
            if (hasPreStyleStep) {
                this.snapshotCurrentStyles();
            }
        }
        else {
            this.startTime += delay;
        }
    };
    /**
     * @param {?} element
     * @param {?=} currentTime
     * @return {?}
     */
    TimelineBuilder.prototype.fork = function (element, currentTime) {
        this.applyStylesToKeyframe();
        return new TimelineBuilder(element, currentTime || this.currentTime, this._elementTimelineStylesLookup);
    };
    /**
     * @return {?}
     */
    TimelineBuilder.prototype._loadKeyframe = function () {
        if (this._currentKeyframe) {
            this._previousKeyframe = this._currentKeyframe;
        }
        this._currentKeyframe = ((this._keyframes.get(this.duration)));
        if (!this._currentKeyframe) {
            this._currentKeyframe = Object.create(this._backFill, {});
            this._keyframes.set(this.duration, this._currentKeyframe);
        }
    };
    /**
     * @return {?}
     */
    TimelineBuilder.prototype.forwardFrame = function () {
        this.duration += ONE_FRAME_IN_MILLISECONDS;
        this._loadKeyframe();
    };
    /**
     * @param {?} time
     * @return {?}
     */
    TimelineBuilder.prototype.forwardTime = function (time) {
        this.applyStylesToKeyframe();
        this.duration = time;
        this._loadKeyframe();
    };
    /**
     * @param {?} prop
     * @param {?} value
     * @return {?}
     */
    TimelineBuilder.prototype._updateStyle = function (prop, value) {
        this._localTimelineStyles[prop] = value;
        this._globalTimelineStyles[prop] = value;
        this._styleSummary[prop] = { time: this.currentTime, value: value };
    };
    /**
     * @return {?}
     */
    TimelineBuilder.prototype.allowOnlyTimelineStyles = function () { return this._currentEmptyStepKeyframe !== this._currentKeyframe; };
    /**
     * @param {?} easing
     * @return {?}
     */
    TimelineBuilder.prototype.applyEmptyStep = function (easing) {
        var _this = this;
        if (easing) {
            this._previousKeyframe['easing'] = easing;
        }
        // special case for animate(duration):
        // all missing styles are filled with a `*` value then
        // if any destination styles are filled in later on the same
        // keyframe then they will override the overridden styles
        // We use `_globalTimelineStyles` here because there may be
        // styles in previous keyframes that are not present in this timeline
        Object.keys(this._globalTimelineStyles).forEach(function (prop) {
            _this._backFill[prop] = _this._globalTimelineStyles[prop] || __WEBPACK_IMPORTED_MODULE_1__angular_animations__["g" /* AUTO_STYLE */];
            _this._currentKeyframe[prop] = __WEBPACK_IMPORTED_MODULE_1__angular_animations__["g" /* AUTO_STYLE */];
        });
        this._currentEmptyStepKeyframe = this._currentKeyframe;
    };
    /**
     * @param {?} input
     * @param {?} easing
     * @param {?} errors
     * @param {?=} options
     * @return {?}
     */
    TimelineBuilder.prototype.setStyles = function (input, easing, errors, options) {
        var _this = this;
        if (easing) {
            this._previousKeyframe['easing'] = easing;
        }
        var /** @type {?} */ params = (options && options.params) || {};
        var /** @type {?} */ styles = flattenStyles(input, this._globalTimelineStyles);
        Object.keys(styles).forEach(function (prop) {
            var /** @type {?} */ val = interpolateParams(styles[prop], params, errors);
            _this._pendingStyles[prop] = val;
            if (!_this._localTimelineStyles.hasOwnProperty(prop)) {
                _this._backFill[prop] = _this._globalTimelineStyles.hasOwnProperty(prop) ?
                    _this._globalTimelineStyles[prop] :
                    __WEBPACK_IMPORTED_MODULE_1__angular_animations__["g" /* AUTO_STYLE */];
            }
            _this._updateStyle(prop, val);
        });
    };
    /**
     * @return {?}
     */
    TimelineBuilder.prototype.applyStylesToKeyframe = function () {
        var _this = this;
        var /** @type {?} */ styles = this._pendingStyles;
        var /** @type {?} */ props = Object.keys(styles);
        if (props.length == 0)
            return;
        this._pendingStyles = {};
        props.forEach(function (prop) {
            var /** @type {?} */ val = styles[prop];
            _this._currentKeyframe[prop] = val;
        });
        Object.keys(this._localTimelineStyles).forEach(function (prop) {
            if (!_this._currentKeyframe.hasOwnProperty(prop)) {
                _this._currentKeyframe[prop] = _this._localTimelineStyles[prop];
            }
        });
    };
    /**
     * @return {?}
     */
    TimelineBuilder.prototype.snapshotCurrentStyles = function () {
        var _this = this;
        Object.keys(this._localTimelineStyles).forEach(function (prop) {
            var /** @type {?} */ val = _this._localTimelineStyles[prop];
            _this._pendingStyles[prop] = val;
            _this._updateStyle(prop, val);
        });
    };
    /**
     * @return {?}
     */
    TimelineBuilder.prototype.getFinalKeyframe = function () { return this._keyframes.get(this.duration); };
    Object.defineProperty(TimelineBuilder.prototype, "properties", {
        /**
         * @return {?}
         */
        get: function () {
            var /** @type {?} */ properties = [];
            for (var /** @type {?} */ prop in this._currentKeyframe) {
                properties.push(prop);
            }
            return properties;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} timeline
     * @return {?}
     */
    TimelineBuilder.prototype.mergeTimelineCollectedStyles = function (timeline) {
        var _this = this;
        Object.keys(timeline._styleSummary).forEach(function (prop) {
            var /** @type {?} */ details0 = _this._styleSummary[prop];
            var /** @type {?} */ details1 = timeline._styleSummary[prop];
            if (!details0 || details1.time > details0.time) {
                _this._updateStyle(prop, details1.value);
            }
        });
    };
    /**
     * @return {?}
     */
    TimelineBuilder.prototype.buildKeyframes = function () {
        var _this = this;
        this.applyStylesToKeyframe();
        var /** @type {?} */ preStyleProps = new Set();
        var /** @type {?} */ postStyleProps = new Set();
        var /** @type {?} */ isEmpty = this._keyframes.size === 1 && this.duration === 0;
        var /** @type {?} */ finalKeyframes = [];
        this._keyframes.forEach(function (keyframe, time) {
            var /** @type {?} */ finalKeyframe = copyStyles(keyframe, true);
            Object.keys(finalKeyframe).forEach(function (prop) {
                var /** @type {?} */ value = finalKeyframe[prop];
                if (value == __WEBPACK_IMPORTED_MODULE_1__angular_animations__["f" /* ɵPRE_STYLE */]) {
                    preStyleProps.add(prop);
                }
                else if (value == __WEBPACK_IMPORTED_MODULE_1__angular_animations__["g" /* AUTO_STYLE */]) {
                    postStyleProps.add(prop);
                }
            });
            if (!isEmpty) {
                finalKeyframe['offset'] = time / _this.duration;
            }
            finalKeyframes.push(finalKeyframe);
        });
        var /** @type {?} */ preProps = preStyleProps.size ? iteratorToArray(preStyleProps.values()) : [];
        var /** @type {?} */ postProps = postStyleProps.size ? iteratorToArray(postStyleProps.values()) : [];
        // special case for a 0-second animation (which is designed just to place styles onscreen)
        if (isEmpty) {
            var /** @type {?} */ kf0 = finalKeyframes[0];
            var /** @type {?} */ kf1 = copyObj(kf0);
            kf0['offset'] = 0;
            kf1['offset'] = 1;
            finalKeyframes = [kf0, kf1];
        }
        return createTimelineInstruction(this.element, finalKeyframes, preProps, postProps, this.duration, this.startTime, this.easing, false);
    };
    return TimelineBuilder;
}());
var SubTimelineBuilder = (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](SubTimelineBuilder, _super);
    /**
     * @param {?} element
     * @param {?} keyframes
     * @param {?} preStyleProps
     * @param {?} postStyleProps
     * @param {?} timings
     * @param {?=} _stretchStartingKeyframe
     */
    function SubTimelineBuilder(element, keyframes, preStyleProps, postStyleProps, timings, _stretchStartingKeyframe) {
        if (_stretchStartingKeyframe === void 0) { _stretchStartingKeyframe = false; }
        var _this = _super.call(this, element, timings.delay) || this;
        _this.element = element;
        _this.keyframes = keyframes;
        _this.preStyleProps = preStyleProps;
        _this.postStyleProps = postStyleProps;
        _this._stretchStartingKeyframe = _stretchStartingKeyframe;
        _this.timings = { duration: timings.duration, delay: timings.delay, easing: timings.easing };
        return _this;
    }
    /**
     * @return {?}
     */
    SubTimelineBuilder.prototype.containsAnimation = function () { return this.keyframes.length > 1; };
    /**
     * @return {?}
     */
    SubTimelineBuilder.prototype.buildKeyframes = function () {
        var /** @type {?} */ keyframes = this.keyframes;
        var _a = this.timings, delay = _a.delay, duration = _a.duration, easing = _a.easing;
        if (this._stretchStartingKeyframe && delay) {
            var /** @type {?} */ newKeyframes = [];
            var /** @type {?} */ totalTime = duration + delay;
            var /** @type {?} */ startingGap = delay / totalTime;
            // the original starting keyframe now starts once the delay is done
            var /** @type {?} */ newFirstKeyframe = copyStyles(keyframes[0], false);
            newFirstKeyframe['offset'] = 0;
            newKeyframes.push(newFirstKeyframe);
            var /** @type {?} */ oldFirstKeyframe = copyStyles(keyframes[0], false);
            oldFirstKeyframe['offset'] = roundOffset(startingGap);
            newKeyframes.push(oldFirstKeyframe);
            /*
              When the keyframe is stretched then it means that the delay before the animation
              starts is gone. Instead the first keyframe is placed at the start of the animation
              and it is then copied to where it starts when the original delay is over. This basically
              means nothing animates during that delay, but the styles are still renderered. For this
              to work the original offset values that exist in the original keyframes must be "warped"
              so that they can take the new keyframe + delay into account.
      
              delay=1000, duration=1000, keyframes = 0 .5 1
      
              turns into
      
              delay=0, duration=2000, keyframes = 0 .33 .66 1
             */
            // offsets between 1 ... n -1 are all warped by the keyframe stretch
            var /** @type {?} */ limit = keyframes.length - 1;
            for (var /** @type {?} */ i = 1; i <= limit; i++) {
                var /** @type {?} */ kf = copyStyles(keyframes[i], false);
                var /** @type {?} */ oldOffset = (kf['offset']);
                var /** @type {?} */ timeAtKeyframe = delay + oldOffset * duration;
                kf['offset'] = roundOffset(timeAtKeyframe / totalTime);
                newKeyframes.push(kf);
            }
            // the new starting keyframe should be added at the start
            duration = totalTime;
            delay = 0;
            easing = '';
            keyframes = newKeyframes;
        }
        return createTimelineInstruction(this.element, keyframes, this.preStyleProps, this.postStyleProps, duration, delay, easing, true);
    };
    return SubTimelineBuilder;
}(TimelineBuilder));
/**
 * @param {?} offset
 * @param {?=} decimalPoints
 * @return {?}
 */
function roundOffset(offset, decimalPoints) {
    if (decimalPoints === void 0) { decimalPoints = 3; }
    var /** @type {?} */ mult = Math.pow(10, decimalPoints - 1);
    return Math.round(offset * mult) / mult;
}
/**
 * @param {?} input
 * @param {?} allStyles
 * @return {?}
 */
function flattenStyles(input, allStyles) {
    var /** @type {?} */ styles = {};
    var /** @type {?} */ allProperties;
    input.forEach(function (token) {
        if (token === '*') {
            allProperties = allProperties || Object.keys(allStyles);
            allProperties.forEach(function (prop) { styles[prop] = __WEBPACK_IMPORTED_MODULE_1__angular_animations__["g" /* AUTO_STYLE */]; });
        }
        else {
            copyStyles(/** @type {?} */ (token), false, styles);
        }
    });
    return styles;
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var Animation = (function () {
    /**
     * @param {?} _driver
     * @param {?} input
     */
    function Animation(_driver, input) {
        this._driver = _driver;
        var errors = [];
        var ast = buildAnimationAst(input, errors);
        if (errors.length) {
            var errorMessage = "animation validation failed:\n" + errors.join("\n");
            throw new Error(errorMessage);
        }
        this._animationAst = ast;
    }
    /**
     * @param {?} element
     * @param {?} startingStyles
     * @param {?} destinationStyles
     * @param {?} options
     * @param {?=} subInstructions
     * @return {?}
     */
    Animation.prototype.buildTimelines = function (element, startingStyles, destinationStyles, options, subInstructions) {
        var /** @type {?} */ start = Array.isArray(startingStyles) ? normalizeStyles(startingStyles) : (startingStyles);
        var /** @type {?} */ dest = Array.isArray(destinationStyles) ? normalizeStyles(destinationStyles) : (destinationStyles);
        var /** @type {?} */ errors = [];
        subInstructions = subInstructions || new ElementInstructionMap();
        var /** @type {?} */ result = buildAnimationTimelines(this._driver, element, this._animationAst, start, dest, options, subInstructions, errors);
        if (errors.length) {
            var /** @type {?} */ errorMessage = "animation building failed:\n" + errors.join("\n");
            throw new Error(errorMessage);
        }
        return result;
    };
    return Animation;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @experimental Animation support is experimental.
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */ var AnimationStyleNormalizer = (function () {
    function AnimationStyleNormalizer() {
    }
    return AnimationStyleNormalizer;
}());
/**
 * @experimental Animation support is experimental.
 */
var NoopAnimationStyleNormalizer = (function () {
    function NoopAnimationStyleNormalizer() {
    }
    NoopAnimationStyleNormalizer.prototype.normalizePropertyName = function (propertyName, errors) { return propertyName; };
    NoopAnimationStyleNormalizer.prototype.normalizeStyleValue = function (userProvidedProperty, normalizedProperty, value, errors) {
        return value;
    };
    return NoopAnimationStyleNormalizer;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var WebAnimationsStyleNormalizer = (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](WebAnimationsStyleNormalizer, _super);
    function WebAnimationsStyleNormalizer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @param {?} propertyName
     * @param {?} errors
     * @return {?}
     */
    WebAnimationsStyleNormalizer.prototype.normalizePropertyName = function (propertyName, errors) {
        return dashCaseToCamelCase(propertyName);
    };
    /**
     * @param {?} userProvidedProperty
     * @param {?} normalizedProperty
     * @param {?} value
     * @param {?} errors
     * @return {?}
     */
    WebAnimationsStyleNormalizer.prototype.normalizeStyleValue = function (userProvidedProperty, normalizedProperty, value, errors) {
        var /** @type {?} */ unit = '';
        var /** @type {?} */ strVal = value.toString().trim();
        if (DIMENSIONAL_PROP_MAP[normalizedProperty] && value !== 0 && value !== '0') {
            if (typeof value === 'number') {
                unit = 'px';
            }
            else {
                var /** @type {?} */ valAndSuffixMatch = value.match(/^[+-]?[\d\.]+([a-z]*)$/);
                if (valAndSuffixMatch && valAndSuffixMatch[1].length == 0) {
                    errors.push("Please provide a CSS unit value for " + userProvidedProperty + ":" + value);
                }
            }
        }
        return strVal + unit;
    };
    return WebAnimationsStyleNormalizer;
}(AnimationStyleNormalizer));
var DIMENSIONAL_PROP_MAP = makeBooleanMap('width,height,minWidth,minHeight,maxWidth,maxHeight,left,top,bottom,right,fontSize,outlineWidth,outlineOffset,paddingTop,paddingLeft,paddingBottom,paddingRight,marginTop,marginLeft,marginBottom,marginRight,borderRadius,borderWidth,borderTopWidth,borderLeftWidth,borderRightWidth,borderBottomWidth,textIndent,perspective'
    .split(','));
/**
 * @param {?} keys
 * @return {?}
 */
function makeBooleanMap(keys) {
    var /** @type {?} */ map = {};
    keys.forEach(function (key) { return map[key] = true; });
    return map;
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @param {?} element
 * @param {?} triggerName
 * @param {?} fromState
 * @param {?} toState
 * @param {?} isRemovalTransition
 * @param {?} fromStyles
 * @param {?} toStyles
 * @param {?} timelines
 * @param {?} queriedElements
 * @param {?} preStyleProps
 * @param {?} postStyleProps
 * @param {?=} errors
 * @return {?}
 */
function createTransitionInstruction(element, triggerName, fromState, toState, isRemovalTransition, fromStyles, toStyles, timelines, queriedElements, preStyleProps, postStyleProps, errors) {
    return {
        type: 0 /* TransitionAnimation */,
        element: element,
        triggerName: triggerName,
        isRemovalTransition: isRemovalTransition,
        fromState: fromState,
        fromStyles: fromStyles,
        toState: toState,
        toStyles: toStyles,
        timelines: timelines,
        queriedElements: queriedElements,
        preStyleProps: preStyleProps,
        postStyleProps: postStyleProps,
        errors: errors
    };
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var EMPTY_OBJECT = {};
var AnimationTransitionFactory = (function () {
    /**
     * @param {?} _triggerName
     * @param {?} ast
     * @param {?} _stateStyles
     */
    function AnimationTransitionFactory(_triggerName, ast, _stateStyles) {
        this._triggerName = _triggerName;
        this.ast = ast;
        this._stateStyles = _stateStyles;
    }
    /**
     * @param {?} currentState
     * @param {?} nextState
     * @return {?}
     */
    AnimationTransitionFactory.prototype.match = function (currentState, nextState) {
        return oneOrMoreTransitionsMatch(this.ast.matchers, currentState, nextState);
    };
    /**
     * @param {?} stateName
     * @param {?} params
     * @param {?} errors
     * @return {?}
     */
    AnimationTransitionFactory.prototype.buildStyles = function (stateName, params, errors) {
        var /** @type {?} */ backupStateStyler = this._stateStyles['*'];
        var /** @type {?} */ stateStyler = this._stateStyles[stateName];
        var /** @type {?} */ backupStyles = backupStateStyler ? backupStateStyler.buildStyles(params, errors) : {};
        return stateStyler ? stateStyler.buildStyles(params, errors) : backupStyles;
    };
    /**
     * @param {?} driver
     * @param {?} element
     * @param {?} currentState
     * @param {?} nextState
     * @param {?=} currentOptions
     * @param {?=} nextOptions
     * @param {?=} subInstructions
     * @return {?}
     */
    AnimationTransitionFactory.prototype.build = function (driver, element, currentState, nextState, currentOptions, nextOptions, subInstructions) {
        var /** @type {?} */ errors = [];
        var /** @type {?} */ transitionAnimationParams = this.ast.options && this.ast.options.params || EMPTY_OBJECT;
        var /** @type {?} */ currentAnimationParams = currentOptions && currentOptions.params || EMPTY_OBJECT;
        var /** @type {?} */ currentStateStyles = this.buildStyles(currentState, currentAnimationParams, errors);
        var /** @type {?} */ nextAnimationParams = nextOptions && nextOptions.params || EMPTY_OBJECT;
        var /** @type {?} */ nextStateStyles = this.buildStyles(nextState, nextAnimationParams, errors);
        var /** @type {?} */ queriedElements = new Set();
        var /** @type {?} */ preStyleMap = new Map();
        var /** @type {?} */ postStyleMap = new Map();
        var /** @type {?} */ isRemoval = nextState === 'void';
        var /** @type {?} */ animationOptions = { params: Object.assign({}, transitionAnimationParams, nextAnimationParams) };
        var /** @type {?} */ timelines = buildAnimationTimelines(driver, element, this.ast.animation, currentStateStyles, nextStateStyles, animationOptions, subInstructions, errors);
        if (errors.length) {
            return createTransitionInstruction(element, this._triggerName, currentState, nextState, isRemoval, currentStateStyles, nextStateStyles, [], [], preStyleMap, postStyleMap, errors);
        }
        timelines.forEach(function (tl) {
            var /** @type {?} */ elm = tl.element;
            var /** @type {?} */ preProps = getOrSetAsInMap(preStyleMap, elm, {});
            tl.preStyleProps.forEach(function (prop) { return preProps[prop] = true; });
            var /** @type {?} */ postProps = getOrSetAsInMap(postStyleMap, elm, {});
            tl.postStyleProps.forEach(function (prop) { return postProps[prop] = true; });
            if (elm !== element) {
                queriedElements.add(elm);
            }
        });
        var /** @type {?} */ queriedElementsList = iteratorToArray(queriedElements.values());
        return createTransitionInstruction(element, this._triggerName, currentState, nextState, isRemoval, currentStateStyles, nextStateStyles, timelines, queriedElementsList, preStyleMap, postStyleMap);
    };
    return AnimationTransitionFactory;
}());
/**
 * @param {?} matchFns
 * @param {?} currentState
 * @param {?} nextState
 * @return {?}
 */
function oneOrMoreTransitionsMatch(matchFns, currentState, nextState) {
    return matchFns.some(function (fn) { return fn(currentState, nextState); });
}
var AnimationStateStyles = (function () {
    /**
     * @param {?} styles
     * @param {?} defaultParams
     */
    function AnimationStateStyles(styles, defaultParams) {
        this.styles = styles;
        this.defaultParams = defaultParams;
    }
    /**
     * @param {?} params
     * @param {?} errors
     * @return {?}
     */
    AnimationStateStyles.prototype.buildStyles = function (params, errors) {
        var /** @type {?} */ finalStyles = {};
        var /** @type {?} */ combinedParams = copyObj(this.defaultParams);
        Object.keys(params).forEach(function (key) {
            var /** @type {?} */ value = params[key];
            if (value != null) {
                combinedParams[key] = value;
            }
        });
        this.styles.styles.forEach(function (value) {
            if (typeof value !== 'string') {
                var /** @type {?} */ styleObj_1 = (value);
                Object.keys(styleObj_1).forEach(function (prop) {
                    var /** @type {?} */ val = styleObj_1[prop];
                    if (val.length > 1) {
                        val = interpolateParams(val, combinedParams, errors);
                    }
                    finalStyles[prop] = val;
                });
            }
        });
        return finalStyles;
    };
    return AnimationStateStyles;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * \@experimental Animation support is experimental.
 * @param {?} name
 * @param {?} ast
 * @return {?}
 */
function buildTrigger(name, ast) {
    return new AnimationTrigger(name, ast);
}
/**
 * \@experimental Animation support is experimental.
 */
var AnimationTrigger = (function () {
    /**
     * @param {?} name
     * @param {?} ast
     */
    function AnimationTrigger(name, ast) {
        var _this = this;
        this.name = name;
        this.ast = ast;
        this.transitionFactories = [];
        this.states = {};
        ast.states.forEach(function (ast) {
            var defaultParams = (ast.options && ast.options.params) || {};
            _this.states[ast.name] = new AnimationStateStyles(ast.style, defaultParams);
        });
        balanceProperties(this.states, 'true', '1');
        balanceProperties(this.states, 'false', '0');
        ast.transitions.forEach(function (ast) {
            _this.transitionFactories.push(new AnimationTransitionFactory(name, ast, _this.states));
        });
        this.fallbackTransition = createFallbackTransition(name, this.states);
    }
    Object.defineProperty(AnimationTrigger.prototype, "containsQueries", {
        /**
         * @return {?}
         */
        get: function () { return this.ast.queryCount > 0; },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} currentState
     * @param {?} nextState
     * @return {?}
     */
    AnimationTrigger.prototype.matchTransition = function (currentState, nextState) {
        var /** @type {?} */ entry = this.transitionFactories.find(function (f) { return f.match(currentState, nextState); });
        return entry || null;
    };
    /**
     * @param {?} currentState
     * @param {?} params
     * @param {?} errors
     * @return {?}
     */
    AnimationTrigger.prototype.matchStyles = function (currentState, params, errors) {
        return this.fallbackTransition.buildStyles(currentState, params, errors);
    };
    return AnimationTrigger;
}());
/**
 * @param {?} triggerName
 * @param {?} states
 * @return {?}
 */
function createFallbackTransition(triggerName, states) {
    var /** @type {?} */ matchers = [function (fromState, toState) { return true; }];
    var /** @type {?} */ animation = new SequenceAst([]);
    var /** @type {?} */ transition = new TransitionAst(matchers, animation);
    return new AnimationTransitionFactory(triggerName, transition, states);
}
/**
 * @param {?} obj
 * @param {?} key1
 * @param {?} key2
 * @return {?}
 */
function balanceProperties(obj, key1, key2) {
    if (obj.hasOwnProperty(key1)) {
        if (!obj.hasOwnProperty(key2)) {
            obj[key2] = obj[key1];
        }
    }
    else if (obj.hasOwnProperty(key2)) {
        obj[key1] = obj[key2];
    }
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var EMPTY_INSTRUCTION_MAP = new ElementInstructionMap();
var TimelineAnimationEngine = (function () {
    /**
     * @param {?} _driver
     * @param {?} _normalizer
     */
    function TimelineAnimationEngine(_driver, _normalizer) {
        this._driver = _driver;
        this._normalizer = _normalizer;
        this._animations = {};
        this._playersById = {};
        this.players = [];
    }
    /**
     * @param {?} id
     * @param {?} metadata
     * @return {?}
     */
    TimelineAnimationEngine.prototype.register = function (id, metadata) {
        var /** @type {?} */ errors = [];
        var /** @type {?} */ ast = buildAnimationAst(metadata, errors);
        if (errors.length) {
            throw new Error("Unable to build the animation due to the following errors: " + errors.join("\n"));
        }
        else {
            this._animations[id] = ast;
        }
    };
    /**
     * @param {?} i
     * @param {?} preStyles
     * @param {?=} postStyles
     * @return {?}
     */
    TimelineAnimationEngine.prototype._buildPlayer = function (i, preStyles, postStyles) {
        var /** @type {?} */ element = i.element;
        var /** @type {?} */ keyframes = normalizeKeyframes(this._driver, this._normalizer, element, i.keyframes, preStyles, postStyles);
        return this._driver.animate(element, keyframes, i.duration, i.delay, i.easing, []);
    };
    /**
     * @param {?} id
     * @param {?} element
     * @param {?=} options
     * @return {?}
     */
    TimelineAnimationEngine.prototype.create = function (id, element, options) {
        var _this = this;
        if (options === void 0) { options = {}; }
        var /** @type {?} */ errors = [];
        var /** @type {?} */ ast = this._animations[id];
        var /** @type {?} */ instructions;
        var /** @type {?} */ autoStylesMap = new Map();
        if (ast) {
            instructions = buildAnimationTimelines(this._driver, element, ast, {}, {}, options, EMPTY_INSTRUCTION_MAP, errors);
            instructions.forEach(function (inst) {
                var /** @type {?} */ styles = getOrSetAsInMap(autoStylesMap, inst.element, {});
                inst.postStyleProps.forEach(function (prop) { return styles[prop] = null; });
            });
        }
        else {
            errors.push('The requested animation doesn\'t exist or has already been destroyed');
            instructions = [];
        }
        if (errors.length) {
            throw new Error("Unable to create the animation due to the following errors: " + errors.join("\n"));
        }
        autoStylesMap.forEach(function (styles, element) {
            Object.keys(styles).forEach(function (prop) { styles[prop] = _this._driver.computeStyle(element, prop, __WEBPACK_IMPORTED_MODULE_1__angular_animations__["g" /* AUTO_STYLE */]); });
        });
        var /** @type {?} */ players = instructions.map(function (i) {
            var /** @type {?} */ styles = autoStylesMap.get(i.element);
            return _this._buildPlayer(i, {}, styles);
        });
        var /** @type {?} */ player = optimizeGroupPlayer(players);
        this._playersById[id] = player;
        player.onDestroy(function () { return _this.destroy(id); });
        this.players.push(player);
        return player;
    };
    /**
     * @param {?} id
     * @return {?}
     */
    TimelineAnimationEngine.prototype.destroy = function (id) {
        var /** @type {?} */ player = this._getPlayer(id);
        player.destroy();
        delete this._playersById[id];
        var /** @type {?} */ index = this.players.indexOf(player);
        if (index >= 0) {
            this.players.splice(index, 1);
        }
    };
    /**
     * @param {?} id
     * @return {?}
     */
    TimelineAnimationEngine.prototype._getPlayer = function (id) {
        var /** @type {?} */ player = this._playersById[id];
        if (!player) {
            throw new Error("Unable to find the timeline player referenced by " + id);
        }
        return player;
    };
    /**
     * @param {?} id
     * @param {?} element
     * @param {?} eventName
     * @param {?} callback
     * @return {?}
     */
    TimelineAnimationEngine.prototype.listen = function (id, element, eventName, callback) {
        // triggerName, fromState, toState are all ignored for timeline animations
        var /** @type {?} */ baseEvent = makeAnimationEvent(element, '', '', '');
        listenOnPlayer(this._getPlayer(id), eventName, baseEvent, callback);
        return function () { };
    };
    /**
     * @param {?} id
     * @param {?} element
     * @param {?} command
     * @param {?} args
     * @return {?}
     */
    TimelineAnimationEngine.prototype.command = function (id, element, command, args) {
        if (command == 'register') {
            this.register(id, /** @type {?} */ (args[0]));
            return;
        }
        if (command == 'create') {
            var /** @type {?} */ options = ((args[0] || {}));
            this.create(id, element, options);
            return;
        }
        var /** @type {?} */ player = this._getPlayer(id);
        switch (command) {
            case 'play':
                player.play();
                break;
            case 'pause':
                player.pause();
                break;
            case 'reset':
                player.reset();
                break;
            case 'restart':
                player.restart();
                break;
            case 'finish':
                player.finish();
                break;
            case 'init':
                player.init();
                break;
            case 'setPosition':
                player.setPosition(parseFloat(/** @type {?} */ (args[0])));
                break;
            case 'destroy':
                this.destroy(id);
                break;
        }
    };
    return TimelineAnimationEngine;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var QUEUED_CLASSNAME = 'ng-animate-queued';
var QUEUED_SELECTOR = '.ng-animate-queued';
var DISABLED_CLASSNAME = 'ng-animate-disabled';
var DISABLED_SELECTOR = '.ng-animate-disabled';
var EMPTY_PLAYER_ARRAY = [];
var NULL_REMOVAL_STATE = {
    namespaceId: '',
    setForRemoval: null,
    hasAnimation: false,
    removedBeforeQueried: false
};
var NULL_REMOVED_QUERIED_STATE = {
    namespaceId: '',
    setForRemoval: null,
    hasAnimation: false,
    removedBeforeQueried: true
};
var REMOVAL_FLAG = '__ng_removed';
var StateValue = (function () {
    /**
     * @param {?} input
     */
    function StateValue(input) {
        var isObj = input && input.hasOwnProperty('value');
        var value = isObj ? input['value'] : input;
        this.value = normalizeTriggerValue(value);
        if (isObj) {
            var options = copyObj(input);
            delete options['value'];
            this.options = options;
        }
        else {
            this.options = {};
        }
        if (!this.options.params) {
            this.options.params = {};
        }
    }
    Object.defineProperty(StateValue.prototype, "params", {
        /**
         * @return {?}
         */
        get: function () { return (this.options.params); },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} options
     * @return {?}
     */
    StateValue.prototype.absorbOptions = function (options) {
        var /** @type {?} */ newParams = options.params;
        if (newParams) {
            var /** @type {?} */ oldParams_2 = ((this.options.params));
            Object.keys(newParams).forEach(function (prop) {
                if (oldParams_2[prop] == null) {
                    oldParams_2[prop] = newParams[prop];
                }
            });
        }
    };
    return StateValue;
}());
var VOID_VALUE = 'void';
var DEFAULT_STATE_VALUE = new StateValue(VOID_VALUE);
var DELETED_STATE_VALUE = new StateValue('DELETED');
var AnimationTransitionNamespace = (function () {
    /**
     * @param {?} id
     * @param {?} hostElement
     * @param {?} _engine
     */
    function AnimationTransitionNamespace(id, hostElement, _engine) {
        this.id = id;
        this.hostElement = hostElement;
        this._engine = _engine;
        this.players = [];
        this._triggers = {};
        this._queue = [];
        this._elementListeners = new Map();
        this._hostClassName = 'ng-tns-' + id;
        addClass(hostElement, this._hostClassName);
    }
    /**
     * @param {?} element
     * @param {?} name
     * @param {?} phase
     * @param {?} callback
     * @return {?}
     */
    AnimationTransitionNamespace.prototype.listen = function (element, name, phase, callback) {
        var _this = this;
        if (!this._triggers.hasOwnProperty(name)) {
            throw new Error("Unable to listen on the animation trigger event \"" + phase + "\" because the animation trigger \"" + name + "\" doesn't exist!");
        }
        if (phase == null || phase.length == 0) {
            throw new Error("Unable to listen on the animation trigger \"" + name + "\" because the provided event is undefined!");
        }
        if (!isTriggerEventValid(phase)) {
            throw new Error("The provided animation trigger event \"" + phase + "\" for the animation trigger \"" + name + "\" is not supported!");
        }
        var /** @type {?} */ listeners = getOrSetAsInMap(this._elementListeners, element, []);
        var /** @type {?} */ data = { name: name, phase: phase, callback: callback };
        listeners.push(data);
        var /** @type {?} */ triggersWithStates = getOrSetAsInMap(this._engine.statesByElement, element, {});
        if (!triggersWithStates.hasOwnProperty(name)) {
            addClass(element, NG_TRIGGER_CLASSNAME);
            addClass(element, NG_TRIGGER_CLASSNAME + '-' + name);
            triggersWithStates[name] = null;
        }
        return function () {
            // the event listener is removed AFTER the flush has occurred such
            // that leave animations callbacks can fire (otherwise if the node
            // is removed in between then the listeners would be deregistered)
            _this._engine.afterFlush(function () {
                var /** @type {?} */ index = listeners.indexOf(data);
                if (index >= 0) {
                    listeners.splice(index, 1);
                }
                if (!_this._triggers[name]) {
                    delete triggersWithStates[name];
                }
            });
        };
    };
    /**
     * @param {?} name
     * @param {?} ast
     * @return {?}
     */
    AnimationTransitionNamespace.prototype.register = function (name, ast) {
        if (this._triggers[name]) {
            // throw
            return false;
        }
        else {
            this._triggers[name] = ast;
            return true;
        }
    };
    /**
     * @param {?} name
     * @return {?}
     */
    AnimationTransitionNamespace.prototype._getTrigger = function (name) {
        var /** @type {?} */ trigger = this._triggers[name];
        if (!trigger) {
            throw new Error("The provided animation trigger \"" + name + "\" has not been registered!");
        }
        return trigger;
    };
    /**
     * @param {?} element
     * @param {?} triggerName
     * @param {?} value
     * @param {?=} defaultToFallback
     * @return {?}
     */
    AnimationTransitionNamespace.prototype.trigger = function (element, triggerName, value, defaultToFallback) {
        var _this = this;
        if (defaultToFallback === void 0) { defaultToFallback = true; }
        var /** @type {?} */ trigger = this._getTrigger(triggerName);
        var /** @type {?} */ player = new TransitionAnimationPlayer(this.id, triggerName, element);
        var /** @type {?} */ triggersWithStates = this._engine.statesByElement.get(element);
        if (!triggersWithStates) {
            addClass(element, NG_TRIGGER_CLASSNAME);
            addClass(element, NG_TRIGGER_CLASSNAME + '-' + triggerName);
            this._engine.statesByElement.set(element, triggersWithStates = {});
        }
        var /** @type {?} */ fromState = triggersWithStates[triggerName];
        var /** @type {?} */ toState = new StateValue(value);
        var /** @type {?} */ isObj = value && value.hasOwnProperty('value');
        if (!isObj && fromState) {
            toState.absorbOptions(fromState.options);
        }
        triggersWithStates[triggerName] = toState;
        if (!fromState) {
            fromState = DEFAULT_STATE_VALUE;
        }
        else if (fromState === DELETED_STATE_VALUE) {
            return player;
        }
        var /** @type {?} */ isRemoval = toState.value === VOID_VALUE;
        // normally this isn't reached by here, however, if an object expression
        // is passed in then it may be a new object each time. Comparing the value
        // is important since that will stay the same despite there being a new object.
        // The removal arc here is special cased because the same element is triggered
        // twice in the event that it contains animations on the outer/inner portions
        // of the host container
        if (!isRemoval && fromState.value === toState.value) {
            // this means that despite the value not changing, some inner params
            // have changed which means that the animation final styles need to be applied
            if (!objEquals(fromState.params, toState.params)) {
                var /** @type {?} */ errors = [];
                var /** @type {?} */ fromStyles_1 = trigger.matchStyles(fromState.value, fromState.params, errors);
                var /** @type {?} */ toStyles_1 = trigger.matchStyles(toState.value, toState.params, errors);
                if (errors.length) {
                    this._engine.reportError(errors);
                }
                else {
                    this._engine.afterFlush(function () {
                        eraseStyles(element, fromStyles_1);
                        setStyles(element, toStyles_1);
                    });
                }
            }
            return;
        }
        var /** @type {?} */ playersOnElement = getOrSetAsInMap(this._engine.playersByElement, element, []);
        playersOnElement.forEach(function (player) {
            // only remove the player if it is queued on the EXACT same trigger/namespace
            // we only also deal with queued players here because if the animation has
            // started then we want to keep the player alive until the flush happens
            // (which is where the previousPlayers are passed into the new palyer)
            if (player.namespaceId == _this.id && player.triggerName == triggerName && player.queued) {
                player.destroy();
            }
        });
        var /** @type {?} */ transition = trigger.matchTransition(fromState.value, toState.value);
        var /** @type {?} */ isFallbackTransition = false;
        if (!transition) {
            if (!defaultToFallback)
                return;
            transition = trigger.fallbackTransition;
            isFallbackTransition = true;
        }
        this._engine.totalQueuedPlayers++;
        this._queue.push({ element: element, triggerName: triggerName, transition: transition, fromState: fromState, toState: toState, player: player, isFallbackTransition: isFallbackTransition });
        if (!isFallbackTransition) {
            addClass(element, QUEUED_CLASSNAME);
            player.onStart(function () { removeClass(element, QUEUED_CLASSNAME); });
        }
        player.onDone(function () {
            var /** @type {?} */ index = _this.players.indexOf(player);
            if (index >= 0) {
                _this.players.splice(index, 1);
            }
            var /** @type {?} */ players = _this._engine.playersByElement.get(element);
            if (players) {
                var /** @type {?} */ index_1 = players.indexOf(player);
                if (index_1 >= 0) {
                    players.splice(index_1, 1);
                }
            }
        });
        this.players.push(player);
        playersOnElement.push(player);
        return player;
    };
    /**
     * @param {?} name
     * @return {?}
     */
    AnimationTransitionNamespace.prototype.deregister = function (name) {
        var _this = this;
        delete this._triggers[name];
        this._engine.statesByElement.forEach(function (stateMap, element) { delete stateMap[name]; });
        this._elementListeners.forEach(function (listeners, element) {
            _this._elementListeners.set(element, listeners.filter(function (entry) { return entry.name != name; }));
        });
    };
    /**
     * @param {?} element
     * @return {?}
     */
    AnimationTransitionNamespace.prototype.clearElementCache = function (element) {
        this._engine.statesByElement.delete(element);
        this._elementListeners.delete(element);
        var /** @type {?} */ elementPlayers = this._engine.playersByElement.get(element);
        if (elementPlayers) {
            elementPlayers.forEach(function (player) { return player.destroy(); });
            this._engine.playersByElement.delete(element);
        }
    };
    /**
     * @param {?} rootElement
     * @param {?} context
     * @param {?=} animate
     * @return {?}
     */
    AnimationTransitionNamespace.prototype._destroyInnerNodes = function (rootElement, context, animate) {
        var _this = this;
        if (animate === void 0) { animate = false; }
        this._engine.driver.query(rootElement, NG_TRIGGER_SELECTOR, true).forEach(function (elm) {
            if (animate && containsClass(elm, _this._hostClassName)) {
                var /** @type {?} */ innerNs = _this._engine.namespacesByHostElement.get(elm);
                // special case for a host element with animations on the same element
                if (innerNs) {
                    innerNs.removeNode(elm, context, true);
                }
                _this.removeNode(elm, context, true);
            }
            else {
                _this.clearElementCache(elm);
            }
        });
    };
    /**
     * @param {?} element
     * @param {?} context
     * @param {?=} doNotRecurse
     * @return {?}
     */
    AnimationTransitionNamespace.prototype.removeNode = function (element, context, doNotRecurse) {
        var _this = this;
        var /** @type {?} */ engine = this._engine;
        if (!doNotRecurse && element.childElementCount) {
            this._destroyInnerNodes(element, context, true);
        }
        var /** @type {?} */ triggerStates = engine.statesByElement.get(element);
        if (triggerStates) {
            var /** @type {?} */ players_1 = [];
            Object.keys(triggerStates).forEach(function (triggerName) {
                // this check is here in the event that an element is removed
                // twice (both on the host level and the component level)
                if (_this._triggers[triggerName]) {
                    var /** @type {?} */ player = _this.trigger(element, triggerName, VOID_VALUE, false);
                    if (player) {
                        players_1.push(player);
                    }
                }
            });
            if (players_1.length) {
                engine.markElementAsRemoved(this.id, element, true, context);
                optimizeGroupPlayer(players_1).onDone(function () { return engine.processLeaveNode(element); });
                return;
            }
        }
        // find the player that is animating and make sure that the
        // removal is delayed until that player has completed
        var /** @type {?} */ containsPotentialParentTransition = false;
        if (engine.totalAnimations) {
            var /** @type {?} */ currentPlayers = engine.players.length ? engine.playersByQueriedElement.get(element) : [];
            // when this `if statement` does not continue forward it means that
            // a previous animation query has selected the current element and
            // is animating it. In this situation want to continue fowards and
            // allow the element to be queued up for animation later.
            if (currentPlayers && currentPlayers.length) {
                containsPotentialParentTransition = true;
            }
            else {
                var /** @type {?} */ parent = element;
                while (parent = parent.parentNode) {
                    var /** @type {?} */ triggers = engine.statesByElement.get(parent);
                    if (triggers) {
                        containsPotentialParentTransition = true;
                        break;
                    }
                }
            }
        }
        // at this stage we know that the element will either get removed
        // during flush or will be picked up by a parent query. Either way
        // we need to fire the listeners for this element when it DOES get
        // removed (once the query parent animation is done or after flush)
        var /** @type {?} */ listeners = this._elementListeners.get(element);
        if (listeners) {
            var /** @type {?} */ visitedTriggers_1 = new Set();
            listeners.forEach(function (listener) {
                var /** @type {?} */ triggerName = listener.name;
                if (visitedTriggers_1.has(triggerName))
                    return;
                visitedTriggers_1.add(triggerName);
                var /** @type {?} */ trigger = _this._triggers[triggerName];
                var /** @type {?} */ transition = trigger.fallbackTransition;
                var /** @type {?} */ elementStates = ((engine.statesByElement.get(element)));
                var /** @type {?} */ fromState = elementStates[triggerName] || DEFAULT_STATE_VALUE;
                var /** @type {?} */ toState = new StateValue(VOID_VALUE);
                var /** @type {?} */ player = new TransitionAnimationPlayer(_this.id, triggerName, element);
                _this._engine.totalQueuedPlayers++;
                _this._queue.push({
                    element: element,
                    triggerName: triggerName,
                    transition: transition,
                    fromState: fromState,
                    toState: toState,
                    player: player,
                    isFallbackTransition: true
                });
            });
        }
        // whether or not a parent has an animation we need to delay the deferral of the leave
        // operation until we have more information (which we do after flush() has been called)
        if (containsPotentialParentTransition) {
            engine.markElementAsRemoved(this.id, element, false, context);
        }
        else {
            // we do this after the flush has occurred such
            // that the callbacks can be fired
            engine.afterFlush(function () { return _this.clearElementCache(element); });
            engine.destroyInnerAnimations(element);
            engine._onRemovalComplete(element, context);
        }
    };
    /**
     * @param {?} element
     * @param {?} parent
     * @return {?}
     */
    AnimationTransitionNamespace.prototype.insertNode = function (element, parent) { addClass(element, this._hostClassName); };
    /**
     * @param {?} microtaskId
     * @return {?}
     */
    AnimationTransitionNamespace.prototype.drainQueuedTransitions = function (microtaskId) {
        var _this = this;
        var /** @type {?} */ instructions = [];
        this._queue.forEach(function (entry) {
            var /** @type {?} */ player = entry.player;
            if (player.destroyed)
                return;
            var /** @type {?} */ element = entry.element;
            var /** @type {?} */ listeners = _this._elementListeners.get(element);
            if (listeners) {
                listeners.forEach(function (listener) {
                    if (listener.name == entry.triggerName) {
                        var /** @type {?} */ baseEvent = makeAnimationEvent(element, entry.triggerName, entry.fromState.value, entry.toState.value);
                        ((baseEvent))['_data'] = microtaskId;
                        listenOnPlayer(entry.player, listener.phase, baseEvent, listener.callback);
                    }
                });
            }
            if (player.markedForDestroy) {
                _this._engine.afterFlush(function () {
                    // now we can destroy the element properly since the event listeners have
                    // been bound to the player
                    player.destroy();
                });
            }
            else {
                instructions.push(entry);
            }
        });
        this._queue = [];
        return instructions.sort(function (a, b) {
            // if depCount == 0 them move to front
            // otherwise if a contains b then move back
            var /** @type {?} */ d0 = a.transition.ast.depCount;
            var /** @type {?} */ d1 = b.transition.ast.depCount;
            if (d0 == 0 || d1 == 0) {
                return d0 - d1;
            }
            return _this._engine.driver.containsElement(a.element, b.element) ? 1 : -1;
        });
    };
    /**
     * @param {?} context
     * @return {?}
     */
    AnimationTransitionNamespace.prototype.destroy = function (context) {
        this.players.forEach(function (p) { return p.destroy(); });
        this._destroyInnerNodes(this.hostElement, context);
    };
    /**
     * @param {?} element
     * @return {?}
     */
    AnimationTransitionNamespace.prototype.elementContainsData = function (element) {
        var /** @type {?} */ containsData = false;
        if (this._elementListeners.has(element))
            containsData = true;
        containsData =
            (this._queue.find(function (entry) { return entry.element === element; }) ? true : false) || containsData;
        return containsData;
    };
    return AnimationTransitionNamespace;
}());
var TransitionAnimationEngine = (function () {
    /**
     * @param {?} driver
     * @param {?} _normalizer
     */
    function TransitionAnimationEngine(driver, _normalizer) {
        this.driver = driver;
        this._normalizer = _normalizer;
        this.players = [];
        this.newHostElements = new Map();
        this.playersByElement = new Map();
        this.playersByQueriedElement = new Map();
        this.statesByElement = new Map();
        this.disabledNodes = new Set();
        this.totalAnimations = 0;
        this.totalQueuedPlayers = 0;
        this._namespaceLookup = {};
        this._namespaceList = [];
        this._flushFns = [];
        this._whenQuietFns = [];
        this.namespacesByHostElement = new Map();
        this.collectedEnterElements = [];
        this.collectedLeaveElements = [];
        this.onRemovalComplete = function (element, context) { };
    }
    /**
     * @param {?} element
     * @param {?} context
     * @return {?}
     */
    TransitionAnimationEngine.prototype._onRemovalComplete = function (element, context) { this.onRemovalComplete(element, context); };
    Object.defineProperty(TransitionAnimationEngine.prototype, "queuedPlayers", {
        /**
         * @return {?}
         */
        get: function () {
            var /** @type {?} */ players = [];
            this._namespaceList.forEach(function (ns) {
                ns.players.forEach(function (player) {
                    if (player.queued) {
                        players.push(player);
                    }
                });
            });
            return players;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} namespaceId
     * @param {?} hostElement
     * @return {?}
     */
    TransitionAnimationEngine.prototype.createNamespace = function (namespaceId, hostElement) {
        var /** @type {?} */ ns = new AnimationTransitionNamespace(namespaceId, hostElement, this);
        if (hostElement.parentNode) {
            this._balanceNamespaceList(ns, hostElement);
        }
        else {
            // defer this later until flush during when the host element has
            // been inserted so that we know exactly where to place it in
            // the namespace list
            this.newHostElements.set(hostElement, ns);
            // given that this host element is apart of the animation code, it
            // may or may not be inserted by a parent node that is an of an
            // animation renderer type. If this happens then we can still have
            // access to this item when we query for :enter nodes. If the parent
            // is a renderer then the set data-structure will normalize the entry
            this.collectEnterElement(hostElement);
        }
        return this._namespaceLookup[namespaceId] = ns;
    };
    /**
     * @param {?} ns
     * @param {?} hostElement
     * @return {?}
     */
    TransitionAnimationEngine.prototype._balanceNamespaceList = function (ns, hostElement) {
        var /** @type {?} */ limit = this._namespaceList.length - 1;
        if (limit >= 0) {
            var /** @type {?} */ found = false;
            for (var /** @type {?} */ i = limit; i >= 0; i--) {
                var /** @type {?} */ nextNamespace = this._namespaceList[i];
                if (this.driver.containsElement(nextNamespace.hostElement, hostElement)) {
                    this._namespaceList.splice(i + 1, 0, ns);
                    found = true;
                    break;
                }
            }
            if (!found) {
                this._namespaceList.splice(0, 0, ns);
            }
        }
        else {
            this._namespaceList.push(ns);
        }
        this.namespacesByHostElement.set(hostElement, ns);
        return ns;
    };
    /**
     * @param {?} namespaceId
     * @param {?} hostElement
     * @return {?}
     */
    TransitionAnimationEngine.prototype.register = function (namespaceId, hostElement) {
        var /** @type {?} */ ns = this._namespaceLookup[namespaceId];
        if (!ns) {
            ns = this.createNamespace(namespaceId, hostElement);
        }
        return ns;
    };
    /**
     * @param {?} namespaceId
     * @param {?} name
     * @param {?} trigger
     * @return {?}
     */
    TransitionAnimationEngine.prototype.registerTrigger = function (namespaceId, name, trigger) {
        var /** @type {?} */ ns = this._namespaceLookup[namespaceId];
        if (ns && ns.register(name, trigger)) {
            this.totalAnimations++;
        }
    };
    /**
     * @param {?} namespaceId
     * @param {?} context
     * @return {?}
     */
    TransitionAnimationEngine.prototype.destroy = function (namespaceId, context) {
        var _this = this;
        if (!namespaceId)
            return;
        var /** @type {?} */ ns = this._fetchNamespace(namespaceId);
        this.afterFlush(function () {
            _this.namespacesByHostElement.delete(ns.hostElement);
            delete _this._namespaceLookup[namespaceId];
            var /** @type {?} */ index = _this._namespaceList.indexOf(ns);
            if (index >= 0) {
                _this._namespaceList.splice(index, 1);
            }
        });
        this.afterFlushAnimationsDone(function () { return ns.destroy(context); });
    };
    /**
     * @param {?} id
     * @return {?}
     */
    TransitionAnimationEngine.prototype._fetchNamespace = function (id) { return this._namespaceLookup[id]; };
    /**
     * @param {?} namespaceId
     * @param {?} element
     * @param {?} name
     * @param {?} value
     * @return {?}
     */
    TransitionAnimationEngine.prototype.trigger = function (namespaceId, element, name, value) {
        if (isElementNode(element)) {
            this._fetchNamespace(namespaceId).trigger(element, name, value);
            return true;
        }
        return false;
    };
    /**
     * @param {?} namespaceId
     * @param {?} element
     * @param {?} parent
     * @param {?} insertBefore
     * @return {?}
     */
    TransitionAnimationEngine.prototype.insertNode = function (namespaceId, element, parent, insertBefore) {
        if (!isElementNode(element))
            return;
        // special case for when an element is removed and reinserted (move operation)
        // when this occurs we do not want to use the element for deletion later
        var /** @type {?} */ details = (element[REMOVAL_FLAG]);
        if (details && details.setForRemoval) {
            details.setForRemoval = false;
        }
        // in the event that the namespaceId is blank then the caller
        // code does not contain any animation code in it, but it is
        // just being called so that the node is marked as being inserted
        if (namespaceId) {
            this._fetchNamespace(namespaceId).insertNode(element, parent);
        }
        // only *directives and host elements are inserted before
        if (insertBefore) {
            this.collectEnterElement(element);
        }
    };
    /**
     * @param {?} element
     * @return {?}
     */
    TransitionAnimationEngine.prototype.collectEnterElement = function (element) { this.collectedEnterElements.push(element); };
    /**
     * @param {?} element
     * @param {?} value
     * @return {?}
     */
    TransitionAnimationEngine.prototype.markElementAsDisabled = function (element, value) {
        if (value) {
            if (!this.disabledNodes.has(element)) {
                this.disabledNodes.add(element);
                addClass(element, DISABLED_CLASSNAME);
            }
        }
        else if (this.disabledNodes.has(element)) {
            this.disabledNodes.delete(element);
            removeClass(element, DISABLED_CLASSNAME);
        }
    };
    /**
     * @param {?} namespaceId
     * @param {?} element
     * @param {?} context
     * @param {?=} doNotRecurse
     * @return {?}
     */
    TransitionAnimationEngine.prototype.removeNode = function (namespaceId, element, context, doNotRecurse) {
        if (!isElementNode(element)) {
            this._onRemovalComplete(element, context);
            return;
        }
        var /** @type {?} */ ns = namespaceId ? this._fetchNamespace(namespaceId) : null;
        if (ns) {
            ns.removeNode(element, context, doNotRecurse);
        }
        else {
            this.markElementAsRemoved(namespaceId, element, false, context);
        }
    };
    /**
     * @param {?} namespaceId
     * @param {?} element
     * @param {?=} hasAnimation
     * @param {?=} context
     * @return {?}
     */
    TransitionAnimationEngine.prototype.markElementAsRemoved = function (namespaceId, element, hasAnimation, context) {
        this.collectedLeaveElements.push(element);
        element[REMOVAL_FLAG] = {
            namespaceId: namespaceId,
            setForRemoval: context, hasAnimation: hasAnimation,
            removedBeforeQueried: false
        };
    };
    /**
     * @param {?} namespaceId
     * @param {?} element
     * @param {?} name
     * @param {?} phase
     * @param {?} callback
     * @return {?}
     */
    TransitionAnimationEngine.prototype.listen = function (namespaceId, element, name, phase, callback) {
        if (isElementNode(element)) {
            return this._fetchNamespace(namespaceId).listen(element, name, phase, callback);
        }
        return function () { };
    };
    /**
     * @param {?} entry
     * @param {?} subTimelines
     * @return {?}
     */
    TransitionAnimationEngine.prototype._buildInstruction = function (entry, subTimelines) {
        return entry.transition.build(this.driver, entry.element, entry.fromState.value, entry.toState.value, entry.fromState.options, entry.toState.options, subTimelines);
    };
    /**
     * @param {?} containerElement
     * @return {?}
     */
    TransitionAnimationEngine.prototype.destroyInnerAnimations = function (containerElement) {
        var _this = this;
        var /** @type {?} */ elements = this.driver.query(containerElement, NG_TRIGGER_SELECTOR, true);
        elements.forEach(function (element) {
            var /** @type {?} */ players = _this.playersByElement.get(element);
            if (players) {
                players.forEach(function (player) {
                    // special case for when an element is set for destruction, but hasn't started.
                    // in this situation we want to delay the destruction until the flush occurs
                    // so that any event listeners attached to the player are triggered.
                    if (player.queued) {
                        player.markedForDestroy = true;
                    }
                    else {
                        player.destroy();
                    }
                });
            }
            var /** @type {?} */ stateMap = _this.statesByElement.get(element);
            if (stateMap) {
                Object.keys(stateMap).forEach(function (triggerName) { return stateMap[triggerName] = DELETED_STATE_VALUE; });
            }
        });
        if (this.playersByQueriedElement.size == 0)
            return;
        elements = this.driver.query(containerElement, NG_ANIMATING_SELECTOR, true);
        if (elements.length) {
            elements.forEach(function (element) {
                var /** @type {?} */ players = _this.playersByQueriedElement.get(element);
                if (players) {
                    players.forEach(function (player) { return player.finish(); });
                }
            });
        }
    };
    /**
     * @return {?}
     */
    TransitionAnimationEngine.prototype.whenRenderingDone = function () {
        var _this = this;
        return new Promise(function (resolve) {
            if (_this.players.length) {
                return optimizeGroupPlayer(_this.players).onDone(function () { return resolve(); });
            }
            else {
                resolve();
            }
        });
    };
    /**
     * @param {?} element
     * @return {?}
     */
    TransitionAnimationEngine.prototype.processLeaveNode = function (element) {
        var _this = this;
        var /** @type {?} */ details = (element[REMOVAL_FLAG]);
        if (details && details.setForRemoval) {
            // this will prevent it from removing it twice
            element[REMOVAL_FLAG] = NULL_REMOVAL_STATE;
            if (details.namespaceId) {
                this.destroyInnerAnimations(element);
                var /** @type {?} */ ns = this._fetchNamespace(details.namespaceId);
                if (ns) {
                    ns.clearElementCache(element);
                }
            }
            this._onRemovalComplete(element, details.setForRemoval);
        }
        if (this.driver.matchesElement(element, DISABLED_SELECTOR)) {
            this.markElementAsDisabled(element, false);
        }
        this.driver.query(element, DISABLED_SELECTOR, true).forEach(function (node) {
            _this.markElementAsDisabled(element, false);
        });
    };
    /**
     * @param {?=} microtaskId
     * @return {?}
     */
    TransitionAnimationEngine.prototype.flush = function (microtaskId) {
        var _this = this;
        if (microtaskId === void 0) { microtaskId = -1; }
        var /** @type {?} */ players = [];
        if (this.newHostElements.size) {
            this.newHostElements.forEach(function (ns, element) { return _this._balanceNamespaceList(ns, element); });
            this.newHostElements.clear();
        }
        if (this._namespaceList.length &&
            (this.totalQueuedPlayers || this.collectedLeaveElements.length)) {
            var /** @type {?} */ cleanupFns = [];
            try {
                players = this._flushAnimations(cleanupFns, microtaskId);
            }
            finally {
                for (var /** @type {?} */ i = 0; i < cleanupFns.length; i++) {
                    cleanupFns[i]();
                }
            }
        }
        else {
            for (var /** @type {?} */ i = 0; i < this.collectedLeaveElements.length; i++) {
                var /** @type {?} */ element = this.collectedLeaveElements[i];
                this.processLeaveNode(element);
            }
        }
        this.totalQueuedPlayers = 0;
        this.collectedEnterElements.length = 0;
        this.collectedLeaveElements.length = 0;
        this._flushFns.forEach(function (fn) { return fn(); });
        this._flushFns = [];
        if (this._whenQuietFns.length) {
            // we move these over to a variable so that
            // if any new callbacks are registered in another
            // flush they do not populate the existing set
            var /** @type {?} */ quietFns_1 = this._whenQuietFns;
            this._whenQuietFns = [];
            if (players.length) {
                optimizeGroupPlayer(players).onDone(function () { quietFns_1.forEach(function (fn) { return fn(); }); });
            }
            else {
                quietFns_1.forEach(function (fn) { return fn(); });
            }
        }
    };
    /**
     * @param {?} errors
     * @return {?}
     */
    TransitionAnimationEngine.prototype.reportError = function (errors) {
        throw new Error("Unable to process animations due to the following failed trigger transitions\n " + errors.join("\n"));
    };
    /**
     * @param {?} cleanupFns
     * @param {?} microtaskId
     * @return {?}
     */
    TransitionAnimationEngine.prototype._flushAnimations = function (cleanupFns, microtaskId) {
        var _this = this;
        var /** @type {?} */ subTimelines = new ElementInstructionMap();
        var /** @type {?} */ skippedPlayers = [];
        var /** @type {?} */ skippedPlayersMap = new Map();
        var /** @type {?} */ queuedInstructions = [];
        var /** @type {?} */ queriedElements = new Map();
        var /** @type {?} */ allPreStyleElements = new Map();
        var /** @type {?} */ allPostStyleElements = new Map();
        var /** @type {?} */ disabledElementsSet = new Set();
        this.disabledNodes.forEach(function (node) {
            disabledElementsSet.add(node);
            var /** @type {?} */ nodesThatAreDisabled = _this.driver.query(node, QUEUED_SELECTOR, true);
            for (var /** @type {?} */ i = 0; i < nodesThatAreDisabled.length; i++) {
                disabledElementsSet.add(nodesThatAreDisabled[i]);
            }
        });
        var /** @type {?} */ bodyNode = getBodyNode();
        var /** @type {?} */ allEnterNodes = this.collectedEnterElements.length ?
            this.collectedEnterElements.filter(createIsRootFilterFn(this.collectedEnterElements)) :
            [];
        // this must occur before the instructions are built below such that
        // the :enter queries match the elements (since the timeline queries
        // are fired during instruction building).
        for (var /** @type {?} */ i = 0; i < allEnterNodes.length; i++) {
            addClass(allEnterNodes[i], ENTER_CLASSNAME);
        }
        var /** @type {?} */ allLeaveNodes = [];
        var /** @type {?} */ leaveNodesWithoutAnimations = new Set();
        for (var /** @type {?} */ i = 0; i < this.collectedLeaveElements.length; i++) {
            var /** @type {?} */ element = this.collectedLeaveElements[i];
            var /** @type {?} */ details = (element[REMOVAL_FLAG]);
            if (details && details.setForRemoval) {
                addClass(element, LEAVE_CLASSNAME);
                allLeaveNodes.push(element);
                if (!details.hasAnimation) {
                    leaveNodesWithoutAnimations.add(element);
                }
            }
        }
        cleanupFns.push(function () {
            allEnterNodes.forEach(function (element) { return removeClass(element, ENTER_CLASSNAME); });
            allLeaveNodes.forEach(function (element) {
                removeClass(element, LEAVE_CLASSNAME);
                _this.processLeaveNode(element);
            });
        });
        var /** @type {?} */ allPlayers = [];
        var /** @type {?} */ erroneousTransitions = [];
        for (var /** @type {?} */ i = this._namespaceList.length - 1; i >= 0; i--) {
            var /** @type {?} */ ns = this._namespaceList[i];
            ns.drainQueuedTransitions(microtaskId).forEach(function (entry) {
                var /** @type {?} */ player = entry.player;
                allPlayers.push(player);
                var /** @type {?} */ element = entry.element;
                if (!bodyNode || !_this.driver.containsElement(bodyNode, element)) {
                    player.destroy();
                    return;
                }
                var /** @type {?} */ instruction = ((_this._buildInstruction(entry, subTimelines)));
                if (instruction.errors && instruction.errors.length) {
                    erroneousTransitions.push(instruction);
                    return;
                }
                // if a unmatched transition is queued to go then it SHOULD NOT render
                // an animation and cancel the previously running animations.
                if (entry.isFallbackTransition) {
                    player.onStart(function () { return eraseStyles(element, instruction.fromStyles); });
                    player.onDestroy(function () { return setStyles(element, instruction.toStyles); });
                    skippedPlayers.push(player);
                    return;
                }
                // this means that if a parent animation uses this animation as a sub trigger
                // then it will instruct the timeline builder to not add a player delay, but
                // instead stretch the first keyframe gap up until the animation starts. The
                // reason this is important is to prevent extra initialization styles from being
                // required by the user in the animation.
                instruction.timelines.forEach(function (tl) { return tl.stretchStartingKeyframe = true; });
                subTimelines.append(element, instruction.timelines);
                var /** @type {?} */ tuple = { instruction: instruction, player: player, element: element };
                queuedInstructions.push(tuple);
                instruction.queriedElements.forEach(function (element) { return getOrSetAsInMap(queriedElements, element, []).push(player); });
                instruction.preStyleProps.forEach(function (stringMap, element) {
                    var /** @type {?} */ props = Object.keys(stringMap);
                    if (props.length) {
                        var /** @type {?} */ setVal_1 = ((allPreStyleElements.get(element)));
                        if (!setVal_1) {
                            allPreStyleElements.set(element, setVal_1 = new Set());
                        }
                        props.forEach(function (prop) { return setVal_1.add(prop); });
                    }
                });
                instruction.postStyleProps.forEach(function (stringMap, element) {
                    var /** @type {?} */ props = Object.keys(stringMap);
                    var /** @type {?} */ setVal = ((allPostStyleElements.get(element)));
                    if (!setVal) {
                        allPostStyleElements.set(element, setVal = new Set());
                    }
                    props.forEach(function (prop) { return setVal.add(prop); });
                });
            });
        }
        if (erroneousTransitions.length) {
            var /** @type {?} */ errors_1 = [];
            erroneousTransitions.forEach(function (instruction) {
                errors_1.push("@" + instruction.triggerName + " has failed due to:\n"); /** @type {?} */
                ((instruction.errors)).forEach(function (error) { return errors_1.push("- " + error + "\n"); });
            });
            allPlayers.forEach(function (player) { return player.destroy(); });
            this.reportError(errors_1);
        }
        // these can only be detected here since we have a map of all the elements
        // that have animations attached to them... We use a set here in the event
        // multiple enter captures on the same element were caught in different
        // renderer namespaces (e.g. when a @trigger was on a host binding that had *ngIf)
        var /** @type {?} */ enterNodesWithoutAnimations = new Set();
        for (var /** @type {?} */ i = 0; i < allEnterNodes.length; i++) {
            var /** @type {?} */ element = allEnterNodes[i];
            if (!subTimelines.has(element)) {
                enterNodesWithoutAnimations.add(element);
            }
        }
        var /** @type {?} */ allPreviousPlayersMap = new Map();
        var /** @type {?} */ sortedParentElements = [];
        queuedInstructions.forEach(function (entry) {
            var /** @type {?} */ element = entry.element;
            if (subTimelines.has(element)) {
                sortedParentElements.unshift(element);
                _this._beforeAnimationBuild(entry.player.namespaceId, entry.instruction, allPreviousPlayersMap);
            }
        });
        skippedPlayers.forEach(function (player) {
            var /** @type {?} */ element = player.element;
            var /** @type {?} */ previousPlayers = _this._getPreviousPlayers(element, false, player.namespaceId, player.triggerName, null);
            previousPlayers.forEach(function (prevPlayer) {
                getOrSetAsInMap(allPreviousPlayersMap, element, []).push(prevPlayer);
                prevPlayer.destroy();
            });
        });
        // this is a special case for nodes that will be removed (either by)
        // having their own leave animations or by being queried in a container
        // that will be removed once a parent animation is complete. The idea
        // here is that * styles must be identical to ! styles because of
        // backwards compatibility (* is also filled in by default in many places).
        // Otherwise * styles will return an empty value or auto since the element
        // that is being getComputedStyle'd will not be visible (since * = destination)
        var /** @type {?} */ replaceNodes = allLeaveNodes.filter(function (node) {
            return replacePostStylesAsPre(node, allPreStyleElements, allPostStyleElements);
        });
        // POST STAGE: fill the * styles
        var _a = cloakAndComputeStyles(this.driver, leaveNodesWithoutAnimations, allPostStyleElements, __WEBPACK_IMPORTED_MODULE_1__angular_animations__["g" /* AUTO_STYLE */]), postStylesMap = _a[0], allLeaveQueriedNodes = _a[1];
        allLeaveQueriedNodes.forEach(function (node) {
            if (replacePostStylesAsPre(node, allPreStyleElements, allPostStyleElements)) {
                replaceNodes.push(node);
            }
        });
        // PRE STAGE: fill the ! styles
        var preStylesMap = (allPreStyleElements.size ?
            cloakAndComputeStyles(this.driver, enterNodesWithoutAnimations, allPreStyleElements, __WEBPACK_IMPORTED_MODULE_1__angular_animations__["f" /* ɵPRE_STYLE */]) :
            [new Map()])[0];
        replaceNodes.forEach(function (node) {
            var /** @type {?} */ post = postStylesMap.get(node);
            var /** @type {?} */ pre = preStylesMap.get(node);
            postStylesMap.set(node, /** @type {?} */ (Object.assign({}, post, pre)));
        });
        var /** @type {?} */ rootPlayers = [];
        var /** @type {?} */ subPlayers = [];
        queuedInstructions.forEach(function (entry) {
            var element = entry.element, player = entry.player, instruction = entry.instruction;
            // this means that it was never consumed by a parent animation which
            // means that it is independent and therefore should be set for animation
            if (subTimelines.has(element)) {
                if (disabledElementsSet.has(element)) {
                    skippedPlayers.push(player);
                    return;
                }
                var /** @type {?} */ innerPlayer = _this._buildAnimation(player.namespaceId, instruction, allPreviousPlayersMap, skippedPlayersMap, preStylesMap, postStylesMap);
                player.setRealPlayer(innerPlayer);
                var /** @type {?} */ parentHasPriority = null;
                for (var /** @type {?} */ i = 0; i < sortedParentElements.length; i++) {
                    var /** @type {?} */ parent = sortedParentElements[i];
                    if (parent === element)
                        break;
                    if (_this.driver.containsElement(parent, element)) {
                        parentHasPriority = parent;
                        break;
                    }
                }
                if (parentHasPriority) {
                    var /** @type {?} */ parentPlayers = _this.playersByElement.get(parentHasPriority);
                    if (parentPlayers && parentPlayers.length) {
                        player.parentPlayer = optimizeGroupPlayer(parentPlayers);
                    }
                    skippedPlayers.push(player);
                }
                else {
                    rootPlayers.push(player);
                }
            }
            else {
                eraseStyles(element, instruction.fromStyles);
                player.onDestroy(function () { return setStyles(element, instruction.toStyles); });
                // there still might be a ancestor player animating this
                // element therefore we will still add it as a sub player
                // even if its animation may be disabled
                subPlayers.push(player);
                if (disabledElementsSet.has(element)) {
                    skippedPlayers.push(player);
                }
            }
        });
        // find all of the sub players' corresponding inner animation player
        subPlayers.forEach(function (player) {
            // even if any players are not found for a sub animation then it
            // will still complete itself after the next tick since it's Noop
            var /** @type {?} */ playersForElement = skippedPlayersMap.get(player.element);
            if (playersForElement && playersForElement.length) {
                var /** @type {?} */ innerPlayer = optimizeGroupPlayer(playersForElement);
                player.setRealPlayer(innerPlayer);
            }
        });
        // the reason why we don't actually play the animation is
        // because all that a skipped player is designed to do is to
        // fire the start/done transition callback events
        skippedPlayers.forEach(function (player) {
            if (player.parentPlayer) {
                player.parentPlayer.onDestroy(function () { return player.destroy(); });
            }
            else {
                player.destroy();
            }
        });
        // run through all of the queued removals and see if they
        // were picked up by a query. If not then perform the removal
        // operation right away unless a parent animation is ongoing.
        for (var /** @type {?} */ i = 0; i < allLeaveNodes.length; i++) {
            var /** @type {?} */ element = allLeaveNodes[i];
            var /** @type {?} */ details = (element[REMOVAL_FLAG]);
            removeClass(element, LEAVE_CLASSNAME);
            // this means the element has a removal animation that is being
            // taken care of and therefore the inner elements will hang around
            // until that animation is over (or the parent queried animation)
            if (details && details.hasAnimation)
                continue;
            var /** @type {?} */ players = [];
            // if this element is queried or if it contains queried children
            // then we want for the element not to be removed from the page
            // until the queried animations have finished
            if (queriedElements.size) {
                var /** @type {?} */ queriedPlayerResults = queriedElements.get(element);
                if (queriedPlayerResults && queriedPlayerResults.length) {
                    players.push.apply(players, queriedPlayerResults);
                }
                var /** @type {?} */ queriedInnerElements = this.driver.query(element, NG_ANIMATING_SELECTOR, true);
                for (var /** @type {?} */ j = 0; j < queriedInnerElements.length; j++) {
                    var /** @type {?} */ queriedPlayers = queriedElements.get(queriedInnerElements[j]);
                    if (queriedPlayers && queriedPlayers.length) {
                        players.push.apply(players, queriedPlayers);
                    }
                }
            }
            var /** @type {?} */ activePlayers = players.filter(function (p) { return !p.destroyed; });
            if (activePlayers.length) {
                removeNodesAfterAnimationDone(this, element, activePlayers);
            }
            else {
                this.processLeaveNode(element);
            }
        }
        // this is required so the cleanup method doesn't remove them
        allLeaveNodes.length = 0;
        rootPlayers.forEach(function (player) {
            _this.players.push(player);
            player.onDone(function () {
                player.destroy();
                var /** @type {?} */ index = _this.players.indexOf(player);
                _this.players.splice(index, 1);
            });
            player.play();
        });
        return rootPlayers;
    };
    /**
     * @param {?} namespaceId
     * @param {?} element
     * @return {?}
     */
    TransitionAnimationEngine.prototype.elementContainsData = function (namespaceId, element) {
        var /** @type {?} */ containsData = false;
        var /** @type {?} */ details = (element[REMOVAL_FLAG]);
        if (details && details.setForRemoval)
            containsData = true;
        if (this.playersByElement.has(element))
            containsData = true;
        if (this.playersByQueriedElement.has(element))
            containsData = true;
        if (this.statesByElement.has(element))
            containsData = true;
        return this._fetchNamespace(namespaceId).elementContainsData(element) || containsData;
    };
    /**
     * @param {?} callback
     * @return {?}
     */
    TransitionAnimationEngine.prototype.afterFlush = function (callback) { this._flushFns.push(callback); };
    /**
     * @param {?} callback
     * @return {?}
     */
    TransitionAnimationEngine.prototype.afterFlushAnimationsDone = function (callback) { this._whenQuietFns.push(callback); };
    /**
     * @param {?} element
     * @param {?} isQueriedElement
     * @param {?=} namespaceId
     * @param {?=} triggerName
     * @param {?=} toStateValue
     * @return {?}
     */
    TransitionAnimationEngine.prototype._getPreviousPlayers = function (element, isQueriedElement, namespaceId, triggerName, toStateValue) {
        var /** @type {?} */ players = [];
        if (isQueriedElement) {
            var /** @type {?} */ queriedElementPlayers = this.playersByQueriedElement.get(element);
            if (queriedElementPlayers) {
                players = queriedElementPlayers;
            }
        }
        else {
            var /** @type {?} */ elementPlayers = this.playersByElement.get(element);
            if (elementPlayers) {
                var /** @type {?} */ isRemovalAnimation_1 = !toStateValue || toStateValue == VOID_VALUE;
                elementPlayers.forEach(function (player) {
                    if (player.queued)
                        return;
                    if (!isRemovalAnimation_1 && player.triggerName != triggerName)
                        return;
                    players.push(player);
                });
            }
        }
        if (namespaceId || triggerName) {
            players = players.filter(function (player) {
                if (namespaceId && namespaceId != player.namespaceId)
                    return false;
                if (triggerName && triggerName != player.triggerName)
                    return false;
                return true;
            });
        }
        return players;
    };
    /**
     * @param {?} namespaceId
     * @param {?} instruction
     * @param {?} allPreviousPlayersMap
     * @return {?}
     */
    TransitionAnimationEngine.prototype._beforeAnimationBuild = function (namespaceId, instruction, allPreviousPlayersMap) {
        var _this = this;
        var /** @type {?} */ triggerName = instruction.triggerName;
        var /** @type {?} */ rootElement = instruction.element;
        // when a removal animation occurs, ALL previous players are collected
        // and destroyed (even if they are outside of the current namespace)
        var /** @type {?} */ targetNameSpaceId = instruction.isRemovalTransition ? undefined : namespaceId;
        var /** @type {?} */ targetTriggerName = instruction.isRemovalTransition ? undefined : triggerName;
        instruction.timelines.map(function (timelineInstruction) {
            var /** @type {?} */ element = timelineInstruction.element;
            var /** @type {?} */ isQueriedElement = element !== rootElement;
            var /** @type {?} */ players = getOrSetAsInMap(allPreviousPlayersMap, element, []);
            var /** @type {?} */ previousPlayers = _this._getPreviousPlayers(element, isQueriedElement, targetNameSpaceId, targetTriggerName, instruction.toState);
            previousPlayers.forEach(function (player) {
                var /** @type {?} */ realPlayer = (player.getRealPlayer());
                if (realPlayer.beforeDestroy) {
                    realPlayer.beforeDestroy();
                }
                player.destroy();
                players.push(player);
            });
        });
        // this needs to be done so that the PRE/POST styles can be
        // computed properly without interfering with the previous animation
        eraseStyles(rootElement, instruction.fromStyles);
    };
    /**
     * @param {?} namespaceId
     * @param {?} instruction
     * @param {?} allPreviousPlayersMap
     * @param {?} skippedPlayersMap
     * @param {?} preStylesMap
     * @param {?} postStylesMap
     * @return {?}
     */
    TransitionAnimationEngine.prototype._buildAnimation = function (namespaceId, instruction, allPreviousPlayersMap, skippedPlayersMap, preStylesMap, postStylesMap) {
        var _this = this;
        var /** @type {?} */ triggerName = instruction.triggerName;
        var /** @type {?} */ rootElement = instruction.element;
        // we first run this so that the previous animation player
        // data can be passed into the successive animation players
        var /** @type {?} */ allQueriedPlayers = [];
        var /** @type {?} */ allConsumedElements = new Set();
        var /** @type {?} */ allSubElements = new Set();
        var /** @type {?} */ allNewPlayers = instruction.timelines.map(function (timelineInstruction) {
            var /** @type {?} */ element = timelineInstruction.element;
            allConsumedElements.add(element);
            // FIXME (matsko): make sure to-be-removed animations are removed properly
            var /** @type {?} */ details = element[REMOVAL_FLAG];
            if (details && details.removedBeforeQueried)
                return new __WEBPACK_IMPORTED_MODULE_1__angular_animations__["d" /* NoopAnimationPlayer */]();
            var /** @type {?} */ isQueriedElement = element !== rootElement;
            var /** @type {?} */ previousPlayers = flattenGroupPlayers((allPreviousPlayersMap.get(element) || EMPTY_PLAYER_ARRAY)
                .map(function (p) { return p.getRealPlayer(); }))
                .filter(function (p) {
                // the `element` is not apart of the AnimationPlayer definition, but
                // Mock/WebAnimations
                // use the element within their implementation. This will be added in Angular5 to
                // AnimationPlayer
                var /** @type {?} */ pp = (p);
                return pp.element ? pp.element === element : false;
            });
            var /** @type {?} */ preStyles = preStylesMap.get(element);
            var /** @type {?} */ postStyles = postStylesMap.get(element);
            var /** @type {?} */ keyframes = normalizeKeyframes(_this.driver, _this._normalizer, element, timelineInstruction.keyframes, preStyles, postStyles);
            var /** @type {?} */ player = _this._buildPlayer(timelineInstruction, keyframes, previousPlayers);
            // this means that this particular player belongs to a sub trigger. It is
            // important that we match this player up with the corresponding (@trigger.listener)
            if (timelineInstruction.subTimeline && skippedPlayersMap) {
                allSubElements.add(element);
            }
            if (isQueriedElement) {
                var /** @type {?} */ wrappedPlayer = new TransitionAnimationPlayer(namespaceId, triggerName, element);
                wrappedPlayer.setRealPlayer(player);
                allQueriedPlayers.push(wrappedPlayer);
            }
            return player;
        });
        allQueriedPlayers.forEach(function (player) {
            getOrSetAsInMap(_this.playersByQueriedElement, player.element, []).push(player);
            player.onDone(function () { return deleteOrUnsetInMap(_this.playersByQueriedElement, player.element, player); });
        });
        allConsumedElements.forEach(function (element) { return addClass(element, NG_ANIMATING_CLASSNAME); });
        var /** @type {?} */ player = optimizeGroupPlayer(allNewPlayers);
        player.onDestroy(function () {
            allConsumedElements.forEach(function (element) { return removeClass(element, NG_ANIMATING_CLASSNAME); });
            setStyles(rootElement, instruction.toStyles);
        });
        // this basically makes all of the callbacks for sub element animations
        // be dependent on the upper players for when they finish
        allSubElements.forEach(function (element) { getOrSetAsInMap(skippedPlayersMap, element, []).push(player); });
        return player;
    };
    /**
     * @param {?} instruction
     * @param {?} keyframes
     * @param {?} previousPlayers
     * @return {?}
     */
    TransitionAnimationEngine.prototype._buildPlayer = function (instruction, keyframes, previousPlayers) {
        if (keyframes.length > 0) {
            return this.driver.animate(instruction.element, keyframes, instruction.duration, instruction.delay, instruction.easing, previousPlayers);
        }
        // special case for when an empty transition|definition is provided
        // ... there is no point in rendering an empty animation
        return new __WEBPACK_IMPORTED_MODULE_1__angular_animations__["d" /* NoopAnimationPlayer */]();
    };
    return TransitionAnimationEngine;
}());
var TransitionAnimationPlayer = (function () {
    /**
     * @param {?} namespaceId
     * @param {?} triggerName
     * @param {?} element
     */
    function TransitionAnimationPlayer(namespaceId, triggerName, element) {
        this.namespaceId = namespaceId;
        this.triggerName = triggerName;
        this.element = element;
        this._player = new __WEBPACK_IMPORTED_MODULE_1__angular_animations__["d" /* NoopAnimationPlayer */]();
        this._containsRealPlayer = false;
        this._queuedCallbacks = {};
        this._destroyed = false;
        this.markedForDestroy = false;
    }
    Object.defineProperty(TransitionAnimationPlayer.prototype, "queued", {
        /**
         * @return {?}
         */
        get: function () { return this._containsRealPlayer == false; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TransitionAnimationPlayer.prototype, "destroyed", {
        /**
         * @return {?}
         */
        get: function () { return this._destroyed; },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} player
     * @return {?}
     */
    TransitionAnimationPlayer.prototype.setRealPlayer = function (player) {
        var _this = this;
        if (this._containsRealPlayer)
            return;
        this._player = player;
        Object.keys(this._queuedCallbacks).forEach(function (phase) {
            _this._queuedCallbacks[phase].forEach(function (callback) { return listenOnPlayer(player, phase, undefined, callback); });
        });
        this._queuedCallbacks = {};
        this._containsRealPlayer = true;
    };
    /**
     * @return {?}
     */
    TransitionAnimationPlayer.prototype.getRealPlayer = function () { return this._player; };
    /**
     * @param {?} name
     * @param {?} callback
     * @return {?}
     */
    TransitionAnimationPlayer.prototype._queueEvent = function (name, callback) {
        getOrSetAsInMap(this._queuedCallbacks, name, []).push(callback);
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    TransitionAnimationPlayer.prototype.onDone = function (fn) {
        if (this.queued) {
            this._queueEvent('done', fn);
        }
        this._player.onDone(fn);
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    TransitionAnimationPlayer.prototype.onStart = function (fn) {
        if (this.queued) {
            this._queueEvent('start', fn);
        }
        this._player.onStart(fn);
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    TransitionAnimationPlayer.prototype.onDestroy = function (fn) {
        if (this.queued) {
            this._queueEvent('destroy', fn);
        }
        this._player.onDestroy(fn);
    };
    /**
     * @return {?}
     */
    TransitionAnimationPlayer.prototype.init = function () { this._player.init(); };
    /**
     * @return {?}
     */
    TransitionAnimationPlayer.prototype.hasStarted = function () { return this.queued ? false : this._player.hasStarted(); };
    /**
     * @return {?}
     */
    TransitionAnimationPlayer.prototype.play = function () { !this.queued && this._player.play(); };
    /**
     * @return {?}
     */
    TransitionAnimationPlayer.prototype.pause = function () { !this.queued && this._player.pause(); };
    /**
     * @return {?}
     */
    TransitionAnimationPlayer.prototype.restart = function () { !this.queued && this._player.restart(); };
    /**
     * @return {?}
     */
    TransitionAnimationPlayer.prototype.finish = function () { this._player.finish(); };
    /**
     * @return {?}
     */
    TransitionAnimationPlayer.prototype.destroy = function () {
        this._destroyed = true;
        this._player.destroy();
    };
    /**
     * @return {?}
     */
    TransitionAnimationPlayer.prototype.reset = function () { !this.queued && this._player.reset(); };
    /**
     * @param {?} p
     * @return {?}
     */
    TransitionAnimationPlayer.prototype.setPosition = function (p) {
        if (!this.queued) {
            this._player.setPosition(p);
        }
    };
    /**
     * @return {?}
     */
    TransitionAnimationPlayer.prototype.getPosition = function () { return this.queued ? 0 : this._player.getPosition(); };
    Object.defineProperty(TransitionAnimationPlayer.prototype, "totalTime", {
        /**
         * @return {?}
         */
        get: function () { return this._player.totalTime; },
        enumerable: true,
        configurable: true
    });
    return TransitionAnimationPlayer;
}());
/**
 * @param {?} map
 * @param {?} key
 * @param {?} value
 * @return {?}
 */
function deleteOrUnsetInMap(map, key, value) {
    var /** @type {?} */ currentValues;
    if (map instanceof Map) {
        currentValues = map.get(key);
        if (currentValues) {
            if (currentValues.length) {
                var /** @type {?} */ index = currentValues.indexOf(value);
                currentValues.splice(index, 1);
            }
            if (currentValues.length == 0) {
                map.delete(key);
            }
        }
    }
    else {
        currentValues = map[key];
        if (currentValues) {
            if (currentValues.length) {
                var /** @type {?} */ index = currentValues.indexOf(value);
                currentValues.splice(index, 1);
            }
            if (currentValues.length == 0) {
                delete map[key];
            }
        }
    }
    return currentValues;
}
/**
 * @param {?} value
 * @return {?}
 */
function normalizeTriggerValue(value) {
    switch (typeof value) {
        case 'boolean':
            return value ? '1' : '0';
        default:
            return value != null ? value.toString() : null;
    }
}
/**
 * @param {?} node
 * @return {?}
 */
function isElementNode(node) {
    return node && node['nodeType'] === 1;
}
/**
 * @param {?} eventName
 * @return {?}
 */
function isTriggerEventValid(eventName) {
    return eventName == 'start' || eventName == 'done';
}
/**
 * @param {?} element
 * @param {?=} value
 * @return {?}
 */
function cloakElement(element, value) {
    var /** @type {?} */ oldValue = element.style.display;
    element.style.display = value != null ? value : 'none';
    return oldValue;
}
/**
 * @param {?} driver
 * @param {?} elements
 * @param {?} elementPropsMap
 * @param {?} defaultStyle
 * @return {?}
 */
function cloakAndComputeStyles(driver, elements, elementPropsMap, defaultStyle) {
    var /** @type {?} */ cloakVals = [];
    elements.forEach(function (element) { return cloakVals.push(cloakElement(element)); });
    var /** @type {?} */ valuesMap = new Map();
    var /** @type {?} */ failedElements = [];
    elementPropsMap.forEach(function (props, element) {
        var /** @type {?} */ styles = {};
        props.forEach(function (prop) {
            var /** @type {?} */ value = styles[prop] = driver.computeStyle(element, prop, defaultStyle);
            // there is no easy way to detect this because a sub element could be removed
            // by a parent animation element being detached.
            if (!value || value.length == 0) {
                element[REMOVAL_FLAG] = NULL_REMOVED_QUERIED_STATE;
                failedElements.push(element);
            }
        });
        valuesMap.set(element, styles);
    });
    // we use a index variable here since Set.forEach(a, i) does not return
    // an index value for the closure (but instead just the value)
    var /** @type {?} */ i = 0;
    elements.forEach(function (element) { return cloakElement(element, cloakVals[i++]); });
    return [valuesMap, failedElements];
}
/**
 * @param {?} nodes
 * @return {?}
 */
function createIsRootFilterFn(nodes) {
    var /** @type {?} */ nodeSet = new Set(nodes);
    var /** @type {?} */ knownRootContainer = new Set();
    var /** @type {?} */ isRoot;
    isRoot = function (node) {
        if (!node)
            return true;
        if (nodeSet.has(node.parentNode))
            return false;
        if (knownRootContainer.has(node.parentNode))
            return true;
        if (isRoot(node.parentNode)) {
            knownRootContainer.add(node);
            return true;
        }
        return false;
    };
    return isRoot;
}
var CLASSES_CACHE_KEY = '$$classes';
/**
 * @param {?} element
 * @param {?} className
 * @return {?}
 */
function containsClass(element, className) {
    if (element.classList) {
        return element.classList.contains(className);
    }
    else {
        var /** @type {?} */ classes = element[CLASSES_CACHE_KEY];
        return classes && classes[className];
    }
}
/**
 * @param {?} element
 * @param {?} className
 * @return {?}
 */
function addClass(element, className) {
    if (element.classList) {
        element.classList.add(className);
    }
    else {
        var /** @type {?} */ classes = element[CLASSES_CACHE_KEY];
        if (!classes) {
            classes = element[CLASSES_CACHE_KEY] = {};
        }
        classes[className] = true;
    }
}
/**
 * @param {?} element
 * @param {?} className
 * @return {?}
 */
function removeClass(element, className) {
    if (element.classList) {
        element.classList.remove(className);
    }
    else {
        var /** @type {?} */ classes = element[CLASSES_CACHE_KEY];
        if (classes) {
            delete classes[className];
        }
    }
}
/**
 * @return {?}
 */
function getBodyNode() {
    if (typeof document != 'undefined') {
        return document.body;
    }
    return null;
}
/**
 * @param {?} engine
 * @param {?} element
 * @param {?} players
 * @return {?}
 */
function removeNodesAfterAnimationDone(engine, element, players) {
    optimizeGroupPlayer(players).onDone(function () { return engine.processLeaveNode(element); });
}
/**
 * @param {?} players
 * @return {?}
 */
function flattenGroupPlayers(players) {
    var /** @type {?} */ finalPlayers = [];
    _flattenGroupPlayersRecur(players, finalPlayers);
    return finalPlayers;
}
/**
 * @param {?} players
 * @param {?} finalPlayers
 * @return {?}
 */
function _flattenGroupPlayersRecur(players, finalPlayers) {
    for (var /** @type {?} */ i = 0; i < players.length; i++) {
        var /** @type {?} */ player = players[i];
        if (player instanceof __WEBPACK_IMPORTED_MODULE_1__angular_animations__["e" /* ɵAnimationGroupPlayer */]) {
            _flattenGroupPlayersRecur(player.players, finalPlayers);
        }
        else {
            finalPlayers.push(/** @type {?} */ (player));
        }
    }
}
/**
 * @param {?} a
 * @param {?} b
 * @return {?}
 */
function objEquals(a, b) {
    var /** @type {?} */ k1 = Object.keys(a);
    var /** @type {?} */ k2 = Object.keys(b);
    if (k1.length != k2.length)
        return false;
    for (var /** @type {?} */ i = 0; i < k1.length; i++) {
        var /** @type {?} */ prop = k1[i];
        if (!b.hasOwnProperty(prop) || a[prop] !== b[prop])
            return false;
    }
    return true;
}
/**
 * @param {?} element
 * @param {?} allPreStyleElements
 * @param {?} allPostStyleElements
 * @return {?}
 */
function replacePostStylesAsPre(element, allPreStyleElements, allPostStyleElements) {
    var /** @type {?} */ postEntry = allPostStyleElements.get(element);
    if (!postEntry)
        return false;
    var /** @type {?} */ preEntry = allPreStyleElements.get(element);
    if (preEntry) {
        postEntry.forEach(function (data) { return ((preEntry)).add(data); });
    }
    else {
        allPreStyleElements.set(element, postEntry);
    }
    allPostStyleElements.delete(element);
    return true;
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var AnimationEngine = (function () {
    /**
     * @param {?} driver
     * @param {?} normalizer
     */
    function AnimationEngine(driver, normalizer) {
        var _this = this;
        this._triggerCache = {};
        this.onRemovalComplete = function (element, context) { };
        this._transitionEngine = new TransitionAnimationEngine(driver, normalizer);
        this._timelineEngine = new TimelineAnimationEngine(driver, normalizer);
        this._transitionEngine.onRemovalComplete = function (element, context) { return _this.onRemovalComplete(element, context); };
    }
    /**
     * @param {?} componentId
     * @param {?} namespaceId
     * @param {?} hostElement
     * @param {?} name
     * @param {?} metadata
     * @return {?}
     */
    AnimationEngine.prototype.registerTrigger = function (componentId, namespaceId, hostElement, name, metadata) {
        var /** @type {?} */ cacheKey = componentId + '-' + name;
        var /** @type {?} */ trigger = this._triggerCache[cacheKey];
        if (!trigger) {
            var /** @type {?} */ errors = [];
            var /** @type {?} */ ast = (buildAnimationAst(/** @type {?} */ (metadata), errors));
            if (errors.length) {
                throw new Error("The animation trigger \"" + name + "\" has failed to build due to the following errors:\n - " + errors.join("\n - "));
            }
            trigger = buildTrigger(name, ast);
            this._triggerCache[cacheKey] = trigger;
        }
        this._transitionEngine.registerTrigger(namespaceId, name, trigger);
    };
    /**
     * @param {?} namespaceId
     * @param {?} hostElement
     * @return {?}
     */
    AnimationEngine.prototype.register = function (namespaceId, hostElement) {
        this._transitionEngine.register(namespaceId, hostElement);
    };
    /**
     * @param {?} namespaceId
     * @param {?} context
     * @return {?}
     */
    AnimationEngine.prototype.destroy = function (namespaceId, context) {
        this._transitionEngine.destroy(namespaceId, context);
    };
    /**
     * @param {?} namespaceId
     * @param {?} element
     * @param {?} parent
     * @param {?} insertBefore
     * @return {?}
     */
    AnimationEngine.prototype.onInsert = function (namespaceId, element, parent, insertBefore) {
        this._transitionEngine.insertNode(namespaceId, element, parent, insertBefore);
    };
    /**
     * @param {?} namespaceId
     * @param {?} element
     * @param {?} context
     * @return {?}
     */
    AnimationEngine.prototype.onRemove = function (namespaceId, element, context) {
        this._transitionEngine.removeNode(namespaceId, element, context);
    };
    /**
     * @param {?} element
     * @param {?} disable
     * @return {?}
     */
    AnimationEngine.prototype.disableAnimations = function (element, disable) {
        this._transitionEngine.markElementAsDisabled(element, disable);
    };
    /**
     * @param {?} namespaceId
     * @param {?} element
     * @param {?} property
     * @param {?} value
     * @return {?}
     */
    AnimationEngine.prototype.process = function (namespaceId, element, property, value) {
        if (property.charAt(0) == '@') {
            var _a = parseTimelineCommand(property), id = _a[0], action = _a[1];
            var /** @type {?} */ args = (value);
            this._timelineEngine.command(id, element, action, args);
        }
        else {
            this._transitionEngine.trigger(namespaceId, element, property, value);
        }
    };
    /**
     * @param {?} namespaceId
     * @param {?} element
     * @param {?} eventName
     * @param {?} eventPhase
     * @param {?} callback
     * @return {?}
     */
    AnimationEngine.prototype.listen = function (namespaceId, element, eventName, eventPhase, callback) {
        // @@listen
        if (eventName.charAt(0) == '@') {
            var _a = parseTimelineCommand(eventName), id = _a[0], action = _a[1];
            return this._timelineEngine.listen(id, element, action, callback);
        }
        return this._transitionEngine.listen(namespaceId, element, eventName, eventPhase, callback);
    };
    /**
     * @param {?=} microtaskId
     * @return {?}
     */
    AnimationEngine.prototype.flush = function (microtaskId) {
        if (microtaskId === void 0) { microtaskId = -1; }
        this._transitionEngine.flush(microtaskId);
    };
    Object.defineProperty(AnimationEngine.prototype, "players", {
        /**
         * @return {?}
         */
        get: function () {
            return ((this._transitionEngine.players))
                .concat(/** @type {?} */ (this._timelineEngine.players));
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    AnimationEngine.prototype.whenRenderingDone = function () { return this._transitionEngine.whenRenderingDone(); };
    return AnimationEngine;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var WebAnimationsPlayer = (function () {
    /**
     * @param {?} element
     * @param {?} keyframes
     * @param {?} options
     * @param {?=} previousPlayers
     */
    function WebAnimationsPlayer(element, keyframes, options, previousPlayers) {
        if (previousPlayers === void 0) { previousPlayers = []; }
        var _this = this;
        this.element = element;
        this.keyframes = keyframes;
        this.options = options;
        this.previousPlayers = previousPlayers;
        this._onDoneFns = [];
        this._onStartFns = [];
        this._onDestroyFns = [];
        this._initialized = false;
        this._finished = false;
        this._started = false;
        this._destroyed = false;
        this.time = 0;
        this.parentPlayer = null;
        this.previousStyles = {};
        this.currentSnapshot = {};
        this._duration = options['duration'];
        this._delay = options['delay'] || 0;
        this.time = this._duration + this._delay;
        if (allowPreviousPlayerStylesMerge(this._duration, this._delay)) {
            previousPlayers.forEach(function (player) {
                var styles = player.currentSnapshot;
                Object.keys(styles).forEach(function (prop) { return _this.previousStyles[prop] = styles[prop]; });
            });
        }
    }
    /**
     * @return {?}
     */
    WebAnimationsPlayer.prototype._onFinish = function () {
        if (!this._finished) {
            this._finished = true;
            this._onDoneFns.forEach(function (fn) { return fn(); });
            this._onDoneFns = [];
        }
    };
    /**
     * @return {?}
     */
    WebAnimationsPlayer.prototype.init = function () {
        this._buildPlayer();
        this._preparePlayerBeforeStart();
    };
    /**
     * @return {?}
     */
    WebAnimationsPlayer.prototype._buildPlayer = function () {
        var _this = this;
        if (this._initialized)
            return;
        this._initialized = true;
        var /** @type {?} */ keyframes = this.keyframes.map(function (styles) { return copyStyles(styles, false); });
        var /** @type {?} */ previousStyleProps = Object.keys(this.previousStyles);
        if (previousStyleProps.length) {
            var /** @type {?} */ startingKeyframe_1 = keyframes[0];
            var /** @type {?} */ missingStyleProps_1 = [];
            previousStyleProps.forEach(function (prop) {
                if (!startingKeyframe_1.hasOwnProperty(prop)) {
                    missingStyleProps_1.push(prop);
                }
                startingKeyframe_1[prop] = _this.previousStyles[prop];
            });
            if (missingStyleProps_1.length) {
                var /** @type {?} */ self_1 = this;
                var _loop_1 = function () {
                    var /** @type {?} */ kf = keyframes[i];
                    missingStyleProps_1.forEach(function (prop) {
                        kf[prop] = _computeStyle(self_1.element, prop);
                    });
                };
                // tslint:disable-next-line
                for (var /** @type {?} */ i = 1; i < keyframes.length; i++) {
                    _loop_1();
                }
            }
        }
        this._player = this._triggerWebAnimation(this.element, keyframes, this.options);
        this._finalKeyframe = keyframes.length ? keyframes[keyframes.length - 1] : {};
        this._player.addEventListener('finish', function () { return _this._onFinish(); });
    };
    /**
     * @return {?}
     */
    WebAnimationsPlayer.prototype._preparePlayerBeforeStart = function () {
        // this is required so that the player doesn't start to animate right away
        if (this._delay) {
            this._resetDomPlayerState();
        }
        else {
            this._player.pause();
        }
    };
    /**
     * \@internal
     * @param {?} element
     * @param {?} keyframes
     * @param {?} options
     * @return {?}
     */
    WebAnimationsPlayer.prototype._triggerWebAnimation = function (element, keyframes, options) {
        // jscompiler doesn't seem to know animate is a native property because it's not fully
        // supported yet across common browsers (we polyfill it for Edge/Safari) [CL #143630929]
        return (element['animate'](keyframes, options));
    };
    Object.defineProperty(WebAnimationsPlayer.prototype, "domPlayer", {
        /**
         * @return {?}
         */
        get: function () { return this._player; },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} fn
     * @return {?}
     */
    WebAnimationsPlayer.prototype.onStart = function (fn) { this._onStartFns.push(fn); };
    /**
     * @param {?} fn
     * @return {?}
     */
    WebAnimationsPlayer.prototype.onDone = function (fn) { this._onDoneFns.push(fn); };
    /**
     * @param {?} fn
     * @return {?}
     */
    WebAnimationsPlayer.prototype.onDestroy = function (fn) { this._onDestroyFns.push(fn); };
    /**
     * @return {?}
     */
    WebAnimationsPlayer.prototype.play = function () {
        this._buildPlayer();
        if (!this.hasStarted()) {
            this._onStartFns.forEach(function (fn) { return fn(); });
            this._onStartFns = [];
            this._started = true;
        }
        this._player.play();
    };
    /**
     * @return {?}
     */
    WebAnimationsPlayer.prototype.pause = function () {
        this.init();
        this._player.pause();
    };
    /**
     * @return {?}
     */
    WebAnimationsPlayer.prototype.finish = function () {
        this.init();
        this._onFinish();
        this._player.finish();
    };
    /**
     * @return {?}
     */
    WebAnimationsPlayer.prototype.reset = function () {
        this._resetDomPlayerState();
        this._destroyed = false;
        this._finished = false;
        this._started = false;
    };
    /**
     * @return {?}
     */
    WebAnimationsPlayer.prototype._resetDomPlayerState = function () {
        if (this._player) {
            this._player.cancel();
        }
    };
    /**
     * @return {?}
     */
    WebAnimationsPlayer.prototype.restart = function () {
        this.reset();
        this.play();
    };
    /**
     * @return {?}
     */
    WebAnimationsPlayer.prototype.hasStarted = function () { return this._started; };
    /**
     * @return {?}
     */
    WebAnimationsPlayer.prototype.destroy = function () {
        if (!this._destroyed) {
            this._destroyed = true;
            this._resetDomPlayerState();
            this._onFinish();
            this._onDestroyFns.forEach(function (fn) { return fn(); });
            this._onDestroyFns = [];
        }
    };
    /**
     * @param {?} p
     * @return {?}
     */
    WebAnimationsPlayer.prototype.setPosition = function (p) { this._player.currentTime = p * this.time; };
    /**
     * @return {?}
     */
    WebAnimationsPlayer.prototype.getPosition = function () { return this._player.currentTime / this.time; };
    Object.defineProperty(WebAnimationsPlayer.prototype, "totalTime", {
        /**
         * @return {?}
         */
        get: function () { return this._delay + this._duration; },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    WebAnimationsPlayer.prototype.beforeDestroy = function () {
        var _this = this;
        var /** @type {?} */ styles = {};
        if (this.hasStarted()) {
            Object.keys(this._finalKeyframe).forEach(function (prop) {
                if (prop != 'offset') {
                    styles[prop] =
                        _this._finished ? _this._finalKeyframe[prop] : _computeStyle(_this.element, prop);
                }
            });
        }
        this.currentSnapshot = styles;
    };
    return WebAnimationsPlayer;
}());
/**
 * @param {?} element
 * @param {?} prop
 * @return {?}
 */
function _computeStyle(element, prop) {
    return ((window.getComputedStyle(element)))[prop];
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var WebAnimationsDriver = (function () {
    function WebAnimationsDriver() {
    }
    /**
     * @param {?} element
     * @param {?} selector
     * @return {?}
     */
    WebAnimationsDriver.prototype.matchesElement = function (element, selector) {
        return matchesElement(element, selector);
    };
    /**
     * @param {?} elm1
     * @param {?} elm2
     * @return {?}
     */
    WebAnimationsDriver.prototype.containsElement = function (elm1, elm2) { return containsElement(elm1, elm2); };
    /**
     * @param {?} element
     * @param {?} selector
     * @param {?} multi
     * @return {?}
     */
    WebAnimationsDriver.prototype.query = function (element, selector, multi) {
        return invokeQuery(element, selector, multi);
    };
    /**
     * @param {?} element
     * @param {?} prop
     * @param {?=} defaultValue
     * @return {?}
     */
    WebAnimationsDriver.prototype.computeStyle = function (element, prop, defaultValue) {
        return (((window.getComputedStyle(element)))[prop]);
    };
    /**
     * @param {?} element
     * @param {?} keyframes
     * @param {?} duration
     * @param {?} delay
     * @param {?} easing
     * @param {?=} previousPlayers
     * @return {?}
     */
    WebAnimationsDriver.prototype.animate = function (element, keyframes, duration, delay, easing, previousPlayers) {
        if (previousPlayers === void 0) { previousPlayers = []; }
        var /** @type {?} */ fill = delay == 0 ? 'both' : 'forwards';
        var /** @type {?} */ playerOptions = { duration: duration, delay: delay, fill: fill };
        // we check for this to avoid having a null|undefined value be present
        // for the easing (which results in an error for certain browsers #9752)
        if (easing) {
            playerOptions['easing'] = easing;
        }
        var /** @type {?} */ previousWebAnimationPlayers = (previousPlayers.filter(function (player) { return player instanceof WebAnimationsPlayer; }));
        return new WebAnimationsPlayer(element, keyframes, playerOptions, previousWebAnimationPlayers);
    };
    return WebAnimationsDriver;
}());
/**
 * @return {?}
 */
function supportsWebAnimations() {
    return typeof Element !== 'undefined' && typeof ((Element)).prototype['animate'] === 'function';
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @module
 * @description
 * Entry point for all animation APIs of the animation browser package.
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @module
 * @description
 * Entry point for all public APIs of the animation package.
 */
/**
 * Generated bundle index. Do not edit.
 */

//# sourceMappingURL=browser.es5.js.map


/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RenderType_ProgressbarComponent; });
/* harmony export (immutable) */ __webpack_exports__["a"] = View_ProgressbarComponent_0;
/* unused harmony export View_ProgressbarComponent_Host_0 */
/* unused harmony export ProgressbarComponentNgFactory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__progressbar_component_css_shim_ngstyle__ = __webpack_require__(533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_bootstrap_dist_css_bootstrap_css_shim_ngstyle__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_core__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__angular_common__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_app_components_progressbar_progressbar_component__ = __webpack_require__(178);
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */





var styles_ProgressbarComponent = [__WEBPACK_IMPORTED_MODULE_0__progressbar_component_css_shim_ngstyle__["a" /* styles */], __WEBPACK_IMPORTED_MODULE_1__node_modules_bootstrap_dist_css_bootstrap_css_shim_ngstyle__["a" /* styles */]];
var RenderType_ProgressbarComponent = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵcrt"]({ encapsulation: 0,
    styles: styles_ProgressbarComponent, data: {} });
function View_ProgressbarComponent_1(_l) {
    return __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'div', [['style',
                'margin-top:0px;font-size:14px;text-align:right;']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['',
            '    ']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.progressText;
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_ProgressbarComponent_2(_l) {
    return __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'div', [['style',
                'margin-top:15px;font-size:14px;font-weight:bold;']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['    ',
            '']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.progressText;
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_ProgressbarComponent_0(_l) {
    return __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n'])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 10, 'div', [['class', 'progress bg-striped']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n    '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 4, 'div', [['aria-valuemax', '100'],
            ['aria-valuemin', '0'], ['class', 'progress-bar progress-bar-cloud'], ['role',
                'progressbar']], [[1, 'aria-valuenow', 0], [4, 'width', null]], null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n         '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵand"](16777216, null, null, 1, null, View_ProgressbarComponent_1)), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_common__["NgIf"], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["ViewContainerRef"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n    '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵand"](16777216, null, null, 1, null, View_ProgressbarComponent_2)),
        __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_common__["NgIf"], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["ViewContainerRef"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n'])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_2 = !_co.showOnRight;
        _ck(_v, 6, 0, currVal_2);
        var currVal_3 = _co.showOnRight;
        _ck(_v, 10, 0, currVal_3);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵinlineInterpolate"](1, '', _co.progressValue, '');
        var currVal_1 = (_co.progressValue + '%');
        _ck(_v, 3, 0, currVal_0, currVal_1);
    });
}
function View_ProgressbarComponent_Host_0(_l) {
    return __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'ixprogressbar', [], null, null, null, View_ProgressbarComponent_0, RenderType_ProgressbarComponent)), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](114688, null, 0, __WEBPACK_IMPORTED_MODULE_4__src_app_components_progressbar_progressbar_component__["a" /* ProgressbarComponent */], [], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var ProgressbarComponentNgFactory = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵccf"]('ixprogressbar', __WEBPACK_IMPORTED_MODULE_4__src_app_components_progressbar_progressbar_component__["a" /* ProgressbarComponent */], View_ProgressbarComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3NyYy91aS9zcmMvYXBwL2NvbXBvbmVudHMvcHJvZ3Jlc3NiYXIvcHJvZ3Jlc3NiYXIuY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL3NyYy91aS9zcmMvYXBwL2NvbXBvbmVudHMvcHJvZ3Jlc3NiYXIvcHJvZ3Jlc3NiYXIuY29tcG9uZW50LnRzIiwibmc6Ly8vc3JjL3VpL3NyYy9hcHAvY29tcG9uZW50cy9wcm9ncmVzc2Jhci9wcm9ncmVzc2Jhci5jb21wb25lbnQuaHRtbCIsIm5nOi8vL3NyYy91aS9zcmMvYXBwL2NvbXBvbmVudHMvcHJvZ3Jlc3NiYXIvcHJvZ3Jlc3NiYXIuY29tcG9uZW50LnRzLlByb2dyZXNzYmFyQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiXG48ZGl2IGNsYXNzPVwicHJvZ3Jlc3MgYmctc3RyaXBlZFwiPlxuICAgIDxkaXYgY2xhc3M9XCJwcm9ncmVzcy1iYXIgcHJvZ3Jlc3MtYmFyLWNsb3VkXCIgIHJvbGU9XCJwcm9ncmVzc2JhclwiIGF0dHIuYXJpYS12YWx1ZW5vdz1cInt7cHJvZ3Jlc3NWYWx1ZX19XCJcbiAgICAgICAgIGFyaWEtdmFsdWVtaW49XCIwXCIgYXJpYS12YWx1ZW1heD1cIjEwMFwiIFtzdHlsZS53aWR0aF09XCJwcm9ncmVzc1ZhbHVlKyclJ1wiPlxuICAgICAgICAgPGRpdiAqbmdJZj1cIiFzaG93T25SaWdodFwiIHN0eWxlPVwibWFyZ2luLXRvcDowcHg7Zm9udC1zaXplOjE0cHg7dGV4dC1hbGlnbjpyaWdodDtcIj57eyBwcm9ncmVzc1RleHQgfX0mbmJzcDsmbmJzcDsmbmJzcDsmbmJzcDs8L2Rpdj5cbiAgICA8L2Rpdj5cbiAgICA8ZGl2ICpuZ0lmPVwic2hvd09uUmlnaHRcIiBzdHlsZT1cIm1hcmdpbi10b3A6MTVweDtmb250LXNpemU6MTRweDtmb250LXdlaWdodDpib2xkO1wiPiZuYnNwOyZuYnNwOyZuYnNwOyZuYnNwO3t7IHByb2dyZXNzVGV4dCB9fTwvZGl2PlxuPC9kaXY+XG4iLCI8aXhwcm9ncmVzc2Jhcj48L2l4cHJvZ3Jlc3NiYXI+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7b0JDSVM7TUFBQTtNQUFBLDRDQUFrRjtNQUFBOztJQUFBO0lBQUE7Ozs7b0JBRXZGO01BQUE7TUFBQSw0Q0FBa0Y7TUFBQTs7SUFBQTtJQUFBOzs7O29CQU50Rix1Q0FDQTtNQUFBO01BQUEsNENBQWlDO01BQzdCO1VBQUE7Y0FBQTtVQUFBLDRDQUM2RTtVQUFBLGtCQUN4RTtVQUFBLG1EQUFBO1VBQUE7TUFBa0ksMkNBQ2pJO01BQ047YUFBQTtVQUFBLHdCQUFrSSx1Q0FDaEk7VUFBQTs7SUFIUTtJQUFMLFdBQUssU0FBTDtJQUVBO0lBQUwsWUFBSyxTQUFMOzs7SUFKaUU7SUFDdEI7SUFEM0MsV0FBaUUsVUFDdEIsU0FEM0M7Ozs7b0JDRko7TUFBQTtxQ0FBQSxVQUFBO01BQUE7SUFBQTs7OzsifQ==
//# sourceMappingURL=progressbar.component.ngfactory.js.map

/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return RenderType_LicensingModal; });
/* harmony export (immutable) */ __webpack_exports__["b"] = View_LicensingModal_0;
/* unused harmony export View_LicensingModal_Host_0 */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LicensingModalNgFactory; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__licensing_component_scss_shim_ngstyle__ = __webpack_require__(538);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_common__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_app_licensing_licensing_modal_component__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_app_user_user_service__ = __webpack_require__(12);
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */





var styles_LicensingModal = [__WEBPACK_IMPORTED_MODULE_0__licensing_component_scss_shim_ngstyle__["a" /* styles */]];
var RenderType_LicensingModal = __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵcrt"]({ encapsulation: 0,
    styles: styles_LicensingModal, data: {} });
function View_LicensingModal_0(_l) {
    return __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵvid"](0, [__WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵpid"](0, __WEBPACK_IMPORTED_MODULE_2__angular_common__["UpperCasePipe"], []), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵeld"](0, null, null, 54, 'div', [], null, null, null, null, null)), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵdid"](278528, null, 0, __WEBPACK_IMPORTED_MODULE_2__angular_common__["NgClass"], [__WEBPACK_IMPORTED_MODULE_1__angular_core__["IterableDiffers"],
            __WEBPACK_IMPORTED_MODULE_1__angular_core__["KeyValueDiffers"], __WEBPACK_IMPORTED_MODULE_1__angular_core__["ElementRef"], __WEBPACK_IMPORTED_MODULE_1__angular_core__["Renderer"]], { ngClass: [0, 'ngClass'] }, null),
        __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵpod"]({ 'modal-component': 0, 'modal-component-off': 1 }), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵeld"](0, null, null, 49, 'div', [['class',
                'modal-container'], ['id', 'eulaConfirmationBox']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵeld"](0, null, null, 4, 'div', [['class',
                'header header_border']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n            '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵeld"](0, null, null, 1, 'legend', [['class', 'dialog-title']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['', ''])), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n        '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵeld"](0, null, null, 19, 'div', [['class', 'mainbody']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵeld"](0, null, null, 16, 'div', [['class', 'message']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n                '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵeld"](0, null, null, 1, 'textarea', [['class', 'message-text'],
                ['readonly', '']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['', ''])), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n                '])), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵeld"](0, null, null, 10, 'div', [['class', 'download-button-container']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n                    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵeld"](0, null, null, 7, 'a', [['style', 'text-decoration: none']], [[8, 'href', 4], [8, 'download', 0]], null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n                        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵeld"](0, null, null, 4, 'button', [['class', 'download-button']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n                        '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵeld"](0, null, null, 1, 'span', [['class', 'download-label']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['Download'])), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n                    '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n                    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n                '])), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n            '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵeld"](0, null, null, 19, 'div', [['class', 'footer footer_border']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n            '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵeld"](0, null, null, 16, 'div', [['class', 'ok-cancel-buttons']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n                '])), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵeld"](0, null, null, 5, 'button', [['class', 'okButton'], ['id', 'eula-okButton']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.onOk($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n                '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵeld"](0, null, null, 2, 'span', [], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['', ''])), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵppd"](1), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n            '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n                '])), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵeld"](0, null, null, 6, 'button', [['id', 'eula-cancelButton']], null, [[null,
                'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.onCancel($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵdid"](278528, null, 0, __WEBPACK_IMPORTED_MODULE_2__angular_common__["NgClass"], [__WEBPACK_IMPORTED_MODULE_1__angular_core__["IterableDiffers"], __WEBPACK_IMPORTED_MODULE_1__angular_core__["KeyValueDiffers"], __WEBPACK_IMPORTED_MODULE_1__angular_core__["ElementRef"], __WEBPACK_IMPORTED_MODULE_1__angular_core__["Renderer"]], { ngClass: [0,
                'ngClass'] }, null), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵpod"]({ 'cancelButton': 0, 'cancelButtonOff': 1 }),
        (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n                '])), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵeld"](0, null, null, 1, 'span', [], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, [' ', ''])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, [' \n            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n        '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _ck(_v, 3, 0, _co.isOn, !_co.isOn);
        _ck(_v, 2, 0, currVal_0);
        var currVal_6 = _ck(_v, 47, 0, (_co.preview === false), (_co.preview === true));
        _ck(_v, 46, 0, currVal_6);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_1 = _co.args.Title;
        _ck(_v, 10, 0, currVal_1);
        var currVal_2 = _co.args.Message;
        _ck(_v, 18, 0, currVal_2);
        var currVal_3 = __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵinlineInterpolate"](1, '', _co.downloadPath, '');
        var currVal_4 = __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵinlineInterpolate"](1, '', _co.args.DocumentName, '.pdf');
        _ck(_v, 22, 0, currVal_3, currVal_4);
        var currVal_5 = __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵunv"](_v, 41, 0, _ck(_v, 42, 0, __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵnov"](_v, 0), _co.okText));
        _ck(_v, 41, 0, currVal_5);
        var currVal_7 = _co.cancelText;
        _ck(_v, 50, 0, currVal_7);
    });
}
function View_LicensingModal_Host_0(_l) {
    return __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵeld"](0, null, null, 1, 'licensing', [], null, null, null, View_LicensingModal_0, RenderType_LicensingModal)),
        __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵdid"](114688, null, 0, __WEBPACK_IMPORTED_MODULE_3__src_app_licensing_licensing_modal_component__["a" /* LicensingModal */], [__WEBPACK_IMPORTED_MODULE_4__src_app_user_user_service__["a" /* UserService */]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var LicensingModalNgFactory = __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵccf"]('licensing', __WEBPACK_IMPORTED_MODULE_3__src_app_licensing_licensing_modal_component__["a" /* LicensingModal */], View_LicensingModal_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3NyYy91aS9zcmMvYXBwL2xpY2Vuc2luZy9saWNlbnNpbmctbW9kYWwuY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL3NyYy91aS9zcmMvYXBwL2xpY2Vuc2luZy9saWNlbnNpbmctbW9kYWwuY29tcG9uZW50LnRzIiwibmc6Ly8vc3JjL3VpL3NyYy9hcHAvbGljZW5zaW5nL2xpY2Vuc2luZy5jb21wb25lbnQuaHRtbCIsIm5nOi8vL3NyYy91aS9zcmMvYXBwL2xpY2Vuc2luZy9saWNlbnNpbmctbW9kYWwuY29tcG9uZW50LnRzLkxpY2Vuc2luZ01vZGFsX0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPGRpdiBbbmdDbGFzc109XCJ7J21vZGFsLWNvbXBvbmVudCc6aXNPbiwgJ21vZGFsLWNvbXBvbmVudC1vZmYnOiFpc09ufVwiPlxuICAgIDxkaXYgaWQ9XCJldWxhQ29uZmlybWF0aW9uQm94XCIgY2xhc3M9XCJtb2RhbC1jb250YWluZXJcIj5cbiAgICAgICAgPGRpdiBjbGFzcz1cImhlYWRlciBoZWFkZXJfYm9yZGVyXCI+XG4gICAgICAgICAgICA8bGVnZW5kIGNsYXNzPVwiZGlhbG9nLXRpdGxlXCI+e3sgYXJncy5UaXRsZSB9fTwvbGVnZW5kPlxuICAgICAgICA8L2Rpdj5cbiAgICAgICAgPGRpdiBjbGFzcz1cIm1haW5ib2R5XCI+XG4gICAgICAgICAgICA8ZGl2IGNsYXNzPVwibWVzc2FnZVwiPlxuICAgICAgICAgICAgICAgIDx0ZXh0YXJlYSBjbGFzcz1cIm1lc3NhZ2UtdGV4dFwiIHJlYWRvbmx5Pnt7IGFyZ3MuTWVzc2FnZSB9fTwvdGV4dGFyZWE+XG4gICAgICAgICAgICAgICAgPGRpdiBjbGFzcz1cImRvd25sb2FkLWJ1dHRvbi1jb250YWluZXJcIj5cbiAgICAgICAgICAgICAgICAgICAgPGEgaHJlZj1cInt7IGRvd25sb2FkUGF0aCB9fVwiIHN0eWxlPVwidGV4dC1kZWNvcmF0aW9uOiBub25lXCIgZG93bmxvYWQ9XCJ7eyBhcmdzLkRvY3VtZW50TmFtZSB9fS5wZGZcIj5cbiAgICAgICAgICAgICAgICAgICAgICAgIDxidXR0b24gY2xhc3M9XCJkb3dubG9hZC1idXR0b25cIj5cbiAgICAgICAgICAgICAgICAgICAgICAgIDxzcGFuIGNsYXNzPVwiZG93bmxvYWQtbGFiZWxcIj5Eb3dubG9hZDwvc3Bhbj5cbiAgICAgICAgICAgICAgICAgICAgPC9idXR0b24+XG4gICAgICAgICAgICAgICAgICAgIDwvYT5cbiAgICAgICAgICAgICAgICA8L2Rpdj5cbiAgICAgICAgICAgIDwvZGl2PlxuICAgICAgICA8L2Rpdj5cbiAgICAgICAgPGRpdiBjbGFzcz1cImZvb3RlciBmb290ZXJfYm9yZGVyXCI+XG4gICAgICAgICAgICA8ZGl2IGNsYXNzPVwib2stY2FuY2VsLWJ1dHRvbnNcIj5cbiAgICAgICAgICAgICAgICA8YnV0dG9uIGlkPVwiZXVsYS1va0J1dHRvblwiIGNsYXNzPVwib2tCdXR0b25cIiAoY2xpY2spPVwib25PaygkZXZlbnQpXCI+XG4gICAgICAgICAgICAgICAgPHNwYW4+e3tva1RleHQgfCB1cHBlcmNhc2V9fTwvc3Bhbj5cbiAgICAgICAgICAgIDwvYnV0dG9uPlxuICAgICAgICAgICAgICAgIDxidXR0b24gW25nQ2xhc3NdPVwieydjYW5jZWxCdXR0b24nOnByZXZpZXcgPT09IGZhbHNlLCAnY2FuY2VsQnV0dG9uT2ZmJzpwcmV2aWV3ID09PSB0cnVlfVwiIGlkPVwiZXVsYS1jYW5jZWxCdXR0b25cIiAoY2xpY2spPVwib25DYW5jZWwoJGV2ZW50KVwiPlxuICAgICAgICAgICAgICAgIDxzcGFuPiB7e2NhbmNlbFRleHR9fTwvc3Bhbj4gXG4gICAgICAgICAgICA8L2J1dHRvbj5cbiAgICAgICAgICAgIDwvZGl2PlxuICAgICAgICA8L2Rpdj5cbiAgICA8L2Rpdj5cbjwvZGl2PiIsIjxsaWNlbnNpbmc+PC9saWNlbnNpbmc+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7OERDQUE7TUFBQTtNQUFBLHFDQUFBO2tEQUFBO2FBQUssZ0RBQWtFO1VBQUEsYUFDbkU7VUFBQTtVQUFBLDRDQUFzRDtVQUFBLGlCQUNsRDtVQUFBO1VBQUEsZ0JBQWtDLG1EQUM5QjtpQkFBQTtjQUFBO01BQTZCLHdDQUF5QjtNQUNwRCwrQ0FDTjtVQUFBO1VBQUEsNENBQXNCO1VBQUEscUJBQ2xCO1VBQUE7VUFBQSxnQkFBcUIsdURBQ2pCO2lCQUFBO2NBQUE7Y0FBQSxnQkFBd0Msd0NBQTZCO1VBQUEseUJBQ3JFO1VBQUE7VUFBQSw0Q0FBdUM7VUFBQSw2QkFDbkM7VUFBQTtVQUFBLDBEQUFrRztVQUFBLGlDQUM5RjtVQUFBO1VBQUEsOEJBQWdDO01BQ2hDO1VBQUE7TUFBNkIsNkNBQWU7TUFDdkMsMkRBQ0w7VUFBQSx5QkFDRjtNQUNKLCtDQUNKO1VBQUEsaUJBQ047VUFBQTtVQUFBLDhCQUFrQztNQUM5QjtVQUFBO01BQStCLHVEQUMzQjtVQUFBO1VBQUE7WUFBQTtZQUFBO1lBQTRDO2NBQUE7Y0FBQTtZQUFBO1lBQTVDO1VBQUEsZ0NBQW1FO01BQ25FO1VBQUEsMERBQU07VUFBQSxxQkFBNkI7TUFDOUIsdURBQ0w7VUFBQTtjQUFBO1lBQUE7WUFBQTtZQUFrSDtjQUFBO2NBQUE7WUFBQTtZQUFsSDtVQUFBLHVDQUFBO1VBQUE7Y0FBQSxrQ0FBUTtNQUFxSSx1REFDN0k7VUFBQTtVQUFBLDhCQUFNLHlDQUFzQjtpQkFBQSxxQ0FDdkI7VUFBQSxxQkFDSCwrQ0FDSjtpQkFBQSw0QkFDSjs7O1FBM0JMO1FBQUwsV0FBSyxTQUFMO1FBc0J3QjtRQUFSLFlBQVEsU0FBUjs7O1FBbkJ5QjtRQUFBO1FBSWU7UUFBQTtRQUVqQztRQUF3RDtRQUEzRCxZQUFHLFVBQXdELFNBQTNEO1FBV0U7UUFBQTtRQUdBO1FBQUE7Ozs7b0JDdkJ0QjtNQUFBO2FBQUE7VUFBQTtJQUFBOzs7OyJ9
//# sourceMappingURL=licensing-modal.component.ngfactory.js.map

/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return RenderType_LicensingComponent; });
/* harmony export (immutable) */ __webpack_exports__["b"] = View_LicensingComponent_0;
/* unused harmony export View_LicensingComponent_Host_0 */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LicensingComponentNgFactory; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_app_licensing_licensing_component__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_router__ = __webpack_require__(16);
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */



var styles_LicensingComponent = [];
var RenderType_LicensingComponent = __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵcrt"]({ encapsulation: 2,
    styles: styles_LicensingComponent, data: {} });
function View_LicensingComponent_0(_l) {
    return __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵeld"](0, null, null, 0, 'div', [], null, null, null, null, null))], null, null);
}
function View_LicensingComponent_Host_0(_l) {
    return __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵeld"](0, null, null, 1, 'licensing-component', [], null, null, null, View_LicensingComponent_0, RenderType_LicensingComponent)), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵdid"](114688, null, 0, __WEBPACK_IMPORTED_MODULE_1__src_app_licensing_licensing_component__["a" /* LicensingComponent */], [__WEBPACK_IMPORTED_MODULE_2__angular_router__["a" /* Router */]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var LicensingComponentNgFactory = __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵccf"]('licensing-component', __WEBPACK_IMPORTED_MODULE_1__src_app_licensing_licensing_component__["a" /* LicensingComponent */], View_LicensingComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3NyYy91aS9zcmMvYXBwL2xpY2Vuc2luZy9saWNlbnNpbmcuY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL3NyYy91aS9zcmMvYXBwL2xpY2Vuc2luZy9saWNlbnNpbmcuY29tcG9uZW50LnRzIiwibmc6Ly8vc3JjL3VpL3NyYy9hcHAvbGljZW5zaW5nL2xpY2Vuc2luZy5jb21wb25lbnQudHMuTGljZW5zaW5nQ29tcG9uZW50Lmh0bWwiLCJuZzovLy9zcmMvdWkvc3JjL2FwcC9saWNlbnNpbmcvbGljZW5zaW5nLmNvbXBvbmVudC50cy5MaWNlbnNpbmdDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8ZGl2PjwvZGl2PiIsIjxsaWNlbnNpbmctY29tcG9uZW50PjwvbGljZW5zaW5nLWNvbXBvbmVudD4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7b0JDQUE7TUFBQTs7OztvQkNBQTtNQUFBO21DQUFBLFVBQUE7TUFBQTtJQUFBOzs7OyJ9
//# sourceMappingURL=licensing.component.ngfactory.js.map

/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return styles; });
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */
var styles = ['.modal-container[_ngcontent-%COMP%] {\n  width: 620px; }\n\n.header[_ngcontent-%COMP%]   legend[_ngcontent-%COMP%] {\n  margin-bottom: 0; }\n\n.mainbody[_ngcontent-%COMP%] {\n  max-height: 640px;\n  overflow-y: auto; }\n\n.main-container[_ngcontent-%COMP%] {\n  margin: 40px; }\n\n.dialog-title[_ngcontent-%COMP%] {\n  padding-left: 20px;\n  padding-top: 10px;\n  font-weight: 800;\n  color: #5A5A64;\n  font-family: open_sans;\n  font-weight: bold;\n  font-size: 13px; }\n\n.close-button[_ngcontent-%COMP%] {\n  height: 20px;\n  width: 55px;\n  color: #5a5a64;\n  background-color: #FAFAFA;\n  background: -webkit-gradient(linear, 0% 0%, 0% 100%, from(#ffffff), to(#F1F1F1));\n  background: -webkit-linear-gradient(0% 0%, 0% 100%, from(#ffffff), to(#F1F1F1));\n  background: -moz-linear-gradient(center top, #ffffff, #F1F1F1);\n  border: 1px solid #bababa;\n  font-family: open_sans;\n  font-weight: bold;\n  font-size: 10px;\n  text-align: center;\n  cursor: pointer;\n  margin-right: 20px; }\n\n.title[_ngcontent-%COMP%] {\n  font-weight: bold;\n  font-size: 15px;\n  color: #4DACD9;\n  text-transform: uppercase;\n  margin-bottom: 20px; }\n\n.description[_ngcontent-%COMP%] {\n  text-align: justify;\n  font-size: 14px; }\n\n.add-subscription-container[_ngcontent-%COMP%] {\n  margin-top: 20px; }\n  .add-subscription-container[_ngcontent-%COMP%]   .input-container[_ngcontent-%COMP%] {\n    width: 100%;\n    display: flex;\n    flex-direction: row;\n    align-items: stretch; }\n    .add-subscription-container[_ngcontent-%COMP%]   .input-container[_ngcontent-%COMP%]   input[_ngcontent-%COMP%] {\n      flex: 1;\n      margin-right: 10px; }\n\n.subscription[_ngcontent-%COMP%] {\n  margin-top: 30px;\n  border: 1px solid #CFCFCF;\n  background-color: #FFFFFF;\n  font-size: 13px;\n  box-shadow: 1px 1px 5px 0px rgba(0, 0, 0, 0.25); }\n  .subscription[_ngcontent-%COMP%]   .subscription-info-container[_ngcontent-%COMP%] {\n    padding: 30px;\n    border-bottom: 1px solid #E4E4E4; }\n    .subscription[_ngcontent-%COMP%]   .subscription-info-container[_ngcontent-%COMP%]   .subscription-info-item[_ngcontent-%COMP%] {\n      margin-top: 10px; }\n      .subscription[_ngcontent-%COMP%]   .subscription-info-container[_ngcontent-%COMP%]   .subscription-info-item[_ngcontent-%COMP%]:first-child {\n        margin-top: 0px; }\n      .subscription[_ngcontent-%COMP%]   .subscription-info-container[_ngcontent-%COMP%]   .subscription-info-item[_ngcontent-%COMP%]   .subscription-info-label[_ngcontent-%COMP%] {\n        color: #A8A8A8; }\n      .subscription[_ngcontent-%COMP%]   .subscription-info-container[_ngcontent-%COMP%]   .subscription-info-item[_ngcontent-%COMP%]   .subscription-info-value[_ngcontent-%COMP%] {\n        color: #4D4D4D; }\n  .subscription[_ngcontent-%COMP%]   .subscription-footer[_ngcontent-%COMP%] {\n    background-color: #F9F9F9;\n    height: 50px;\n    display: flex;\n    flex-direction: row;\n    align-items: stretch; }\n    .subscription[_ngcontent-%COMP%]   .subscription-footer[_ngcontent-%COMP%]   .footer-item[_ngcontent-%COMP%] {\n      padding: 0 20px;\n      flex-shrink: 0;\n      display: flex;\n      align-items: center;\n      border-left: 1px solid #E4E4E4; }\n      .subscription[_ngcontent-%COMP%]   .subscription-footer[_ngcontent-%COMP%]   .footer-item[_ngcontent-%COMP%]:first-child {\n        border-left: 0px; }\n    .subscription[_ngcontent-%COMP%]   .subscription-footer[_ngcontent-%COMP%]   .subscription-status[_ngcontent-%COMP%] {\n      flex: 1; }\n      .subscription[_ngcontent-%COMP%]   .subscription-footer[_ngcontent-%COMP%]   .subscription-status[_ngcontent-%COMP%]   .status-label[_ngcontent-%COMP%] {\n        margin-left: 10px;\n        text-transform: uppercase;\n        color: #A8A8A8; }\n    .subscription[_ngcontent-%COMP%]   .subscription-footer[_ngcontent-%COMP%]   button[_ngcontent-%COMP%] {\n      color: #9ABC7D;\n      padding: 0;\n      border: 0; }\n\n.last-authz-error[_ngcontent-%COMP%] {\n  width: 100%;\n  margin-top: 10px;\n  margin-left: 20px;\n  text-align: left;\n  font-size: 12px;\n  color: #af2816; }'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3NyYy91aS9zcmMvYXBwL21haW4vdGFyZ2V0LXZhbGlkYXRpb24vdGFyZ2V0LXZhbGlkYXRpb24tZGlhbG9nLmNvbXBvbmVudC5zY3NzLnNoaW0ubmdzdHlsZS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL3NyYy91aS9zcmMvYXBwL21haW4vdGFyZ2V0LXZhbGlkYXRpb24vdGFyZ2V0LXZhbGlkYXRpb24tZGlhbG9nLmNvbXBvbmVudC5zY3NzIl0sInNvdXJjZXNDb250ZW50IjpbIiAiXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7OzsifQ==
//# sourceMappingURL=target-validation-dialog.component.scss.shim.ngstyle.js.map

/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RenderType_LoadingModal; });
/* harmony export (immutable) */ __webpack_exports__["a"] = View_LoadingModal_0;
/* unused harmony export View_LoadingModal_Host_0 */
/* unused harmony export LoadingModalNgFactory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modal_loading_component_scss_shim_ngstyle__ = __webpack_require__(560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_common__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__progress_progress_box_component_ngfactory__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_app_progress_progress_box_component__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_app_modals_modal_loading_component__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_app_modals_modal_service__ = __webpack_require__(69);
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */







var styles_LoadingModal = [__WEBPACK_IMPORTED_MODULE_0__modal_loading_component_scss_shim_ngstyle__["a" /* styles */]];
var RenderType_LoadingModal = __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵcrt"]({ encapsulation: 0, styles: styles_LoadingModal,
    data: {} });
function View_LoadingModal_0(_l) {
    return __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵvid"](0, [__WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵqud"](402653184, 1, { progressBoxComponent: 0 }), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵeld"](0, null, null, 25, 'div', [['id', 'progressModal']], null, null, null, null, null)), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵdid"](278528, null, 0, __WEBPACK_IMPORTED_MODULE_2__angular_common__["NgClass"], [__WEBPACK_IMPORTED_MODULE_1__angular_core__["IterableDiffers"], __WEBPACK_IMPORTED_MODULE_1__angular_core__["KeyValueDiffers"], __WEBPACK_IMPORTED_MODULE_1__angular_core__["ElementRef"], __WEBPACK_IMPORTED_MODULE_1__angular_core__["Renderer"]], { ngClass: [0, 'ngClass'] }, null), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵpod"]({ 'modal-component': 0, 'modal-component-off': 1 }),
        (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n    '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵeld"](0, null, null, 19, 'div', [['class', 'modal-container'],
            ['style', '']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵeld"](0, null, null, 4, 'div', [['class', 'header  header_border']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵeld"](0, null, null, 1, 'legend', [['class', 'dialog-title'], ['style', 'width:95%; text-align:center; ']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['', ''])), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵeld"](0, null, null, 5, 'div', [['class',
                'mainbody']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵeld"](0, null, null, 1, 'progress-box', [['class', 'progress-box'], ['style', 'min-width: 375px;']], null, null, null, __WEBPACK_IMPORTED_MODULE_3__progress_progress_box_component_ngfactory__["a" /* View_ProgressBoxComponent_0 */], __WEBPACK_IMPORTED_MODULE_3__progress_progress_box_component_ngfactory__["b" /* RenderType_ProgressBoxComponent */])), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵdid"](114688, [[1, 4], ['progress', 4]], 0, __WEBPACK_IMPORTED_MODULE_4__src_app_progress_progress_box_component__["a" /* ProgressBoxComponent */], [], null, null), (_l()(),
            __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n        '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵeld"](0, null, null, 2, 'div', [['class', 'footer footer_border']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n          '])), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n       '])), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n'])), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _ck(_v, 3, 0, _co.isOn, !_co.isOn);
        _ck(_v, 2, 0, currVal_0);
        _ck(_v, 17, 0);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_1 = _co.message;
        _ck(_v, 11, 0, currVal_1);
    });
}
function View_LoadingModal_Host_0(_l) {
    return __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵeld"](0, null, null, 1, 'modal-loading', [], null, null, null, View_LoadingModal_0, RenderType_LoadingModal)), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵdid"](114688, null, 0, __WEBPACK_IMPORTED_MODULE_5__src_app_modals_modal_loading_component__["a" /* LoadingModal */], [__WEBPACK_IMPORTED_MODULE_6__src_app_modals_modal_service__["a" /* ModalService */]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var LoadingModalNgFactory = __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵccf"]('modal-loading', __WEBPACK_IMPORTED_MODULE_5__src_app_modals_modal_loading_component__["a" /* LoadingModal */], View_LoadingModal_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=modal-loading.component.ngfactory.js.map

/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RenderType_ProgressBoxComponent; });
/* harmony export (immutable) */ __webpack_exports__["a"] = View_ProgressBoxComponent_0;
/* unused harmony export View_ProgressBoxComponent_Host_0 */
/* unused harmony export ProgressBoxComponentNgFactory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__progress_box_component_scss_shim_ngstyle__ = __webpack_require__(563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_common__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_app_progress_progress_box_component__ = __webpack_require__(190);
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */




var styles_ProgressBoxComponent = [__WEBPACK_IMPORTED_MODULE_0__progress_box_component_scss_shim_ngstyle__["a" /* styles */]];
var RenderType_ProgressBoxComponent = __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵcrt"]({ encapsulation: 0,
    styles: styles_ProgressBoxComponent, data: {} });
function View_ProgressBoxComponent_1(_l) {
    return __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵeld"](0, null, null, 4, 'div', [['class',
                'progressMarker'], ['id', 'progressMarker']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n        '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵeld"](0, null, null, 1, 'div', [['class', 'coloredProgressMarker'],
            ['id', 'coloredProgressMarker']], [[4, 'background', null]], null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n    ']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.getColor(_v.context.$implicit);
        _ck(_v, 2, 0, currVal_0);
    });
}
function View_ProgressBoxComponent_0(_l) {
    return __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵeld"](0, null, null, 4, 'div', [['class',
                'markersContainer'], ['id', 'markersContainer']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n    '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵand"](16777216, null, null, 1, null, View_ProgressBoxComponent_1)),
        __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵdid"](802816, null, 0, __WEBPACK_IMPORTED_MODULE_2__angular_common__["NgForOf"], [__WEBPACK_IMPORTED_MODULE_1__angular_core__["ViewContainerRef"], __WEBPACK_IMPORTED_MODULE_1__angular_core__["TemplateRef"],
            __WEBPACK_IMPORTED_MODULE_1__angular_core__["IterableDiffers"]], { ngForOf: [0, 'ngForOf'] }, null), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.markers;
        _ck(_v, 3, 0, currVal_0);
    }, null);
}
function View_ProgressBoxComponent_Host_0(_l) {
    return __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵeld"](0, null, null, 1, 'progress-box', [], null, null, null, View_ProgressBoxComponent_0, RenderType_ProgressBoxComponent)), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵdid"](114688, null, 0, __WEBPACK_IMPORTED_MODULE_3__src_app_progress_progress_box_component__["a" /* ProgressBoxComponent */], [], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var ProgressBoxComponentNgFactory = __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵccf"]('progress-box', __WEBPACK_IMPORTED_MODULE_3__src_app_progress_progress_box_component__["a" /* ProgressBoxComponent */], View_ProgressBoxComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3NyYy91aS9zcmMvYXBwL3Byb2dyZXNzL3Byb2dyZXNzLWJveC5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vc3JjL3VpL3NyYy9hcHAvcHJvZ3Jlc3MvcHJvZ3Jlc3MtYm94LmNvbXBvbmVudC50cyIsIm5nOi8vL3NyYy91aS9zcmMvYXBwL3Byb2dyZXNzL3Byb2dyZXNzLWJveC5jb21wb25lbnQuaHRtbCIsIm5nOi8vL3NyYy91aS9zcmMvYXBwL3Byb2dyZXNzL3Byb2dyZXNzLWJveC5jb21wb25lbnQudHMuUHJvZ3Jlc3NCb3hDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8ZGl2IGlkPVwibWFya2Vyc0NvbnRhaW5lclwiIGNsYXNzPVwibWFya2Vyc0NvbnRhaW5lclwiPlxuICAgIDxkaXYgaWQ9XCJwcm9ncmVzc01hcmtlclwiIGNsYXNzPVwicHJvZ3Jlc3NNYXJrZXJcIiAqbmdGb3I9XCJsZXQgbWFya2VyIG9mIG1hcmtlcnNcIj5cbiAgICAgICAgPGRpdiBpZD1cImNvbG9yZWRQcm9ncmVzc01hcmtlclwiIGNsYXNzPVwiY29sb3JlZFByb2dyZXNzTWFya2VyXCIgW3N0eWxlLmJhY2tncm91bmRdPVwiZ2V0Q29sb3IobWFya2VyKVwiPlxuICAgICAgICA8L2Rpdj5cbiAgICA8L2Rpdj5cbjwvZGl2PiIsIjxwcm9ncmVzcy1ib3g+PC9wcm9ncmVzcy1ib3g+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7OztvQkNDSTtNQUFBO01BQUEsOEJBQStFO01BQzNFO1VBQUE7VUFBQSw0Q0FBb0c7VUFBQSxpQkFDOUY7OztRQUR3RDtRQUE5RCxXQUE4RCxTQUE5RDs7OztvQkFGUjtNQUFBO01BQUEsOEJBQW9ELDJDQUNoRDthQUFBO2FBQUE7NEJBQUEseUNBR007VUFBQTs7SUFIMEM7SUFBaEQsV0FBZ0QsU0FBaEQ7Ozs7b0JDREo7TUFBQTtxQ0FBQSxVQUFBO01BQUE7SUFBQTs7OzsifQ==
//# sourceMappingURL=progress-box.component.ngfactory.js.map

/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ClipboardDirective; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__clipboard_service__ = __webpack_require__(134);


var ClipboardDirective = /** @class */ (function () {
    function ClipboardDirective(clipboardSrv, renderer) {
        this.clipboardSrv = clipboardSrv;
        this.renderer = renderer;
        this.cbOnSuccess = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.cbOnError = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
    }
    ClipboardDirective.prototype.ngOnInit = function () { };
    ClipboardDirective.prototype.ngOnDestroy = function () {
        this.clipboardSrv.destroy();
    };
    ClipboardDirective.prototype.onClick = function () {
        if (!this.clipboardSrv.isSupported) {
            this.handleResult(false, undefined);
        }
        else if (this.targetElm && this.clipboardSrv.isTargetValid(this.targetElm)) {
            this.handleResult(this.clipboardSrv.copyFromInputElement(this.targetElm, this.renderer), this.targetElm.value);
        }
        else if (this.cbContent) {
            this.handleResult(this.clipboardSrv.copyFromContent(this.cbContent, this.renderer), this.cbContent);
        }
    };
    /**
     * Fires an event based on the copy operation result.
     * @param {Boolean} succeeded
     */
    ClipboardDirective.prototype.handleResult = function (succeeded, copiedContent) {
        if (succeeded) {
            this.cbOnSuccess.emit({ isSuccess: true, content: copiedContent });
        }
        else {
            this.cbOnError.emit({ isSuccess: false });
        }
    };
    ClipboardDirective.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_1__clipboard_service__["a" /* ClipboardService */] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"] }]; };
    return ClipboardDirective;
}());

//# sourceMappingURL=clipboard.directive.js.map

/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AppComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__user_user_service__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__publisher_publisher_service__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__publisher_message__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__angular_router__ = __webpack_require__(16);




var AppComponent = /** @class */ (function () {
    function AppComponent(userService, pubService, router, route) {
        var _this = this;
        this.userService = userService;
        this.pubService = pubService;
        this.router = router;
        this.route = route;
        this.currentRoute = '/';
        this.router.events.subscribe(function (event) {
            if (event instanceof __WEBPACK_IMPORTED_MODULE_3__angular_router__["y" /* NavigationEnd */]) {
                _this.currentRoute = event.url;
            }
        });
    }
    AppComponent.prototype.ngOnInit = function () {
        this.clickedOutsideChannel = this.pubService.createChannel('clicked-outside');
        this.userService.updateFromStorage();
    };
    AppComponent.prototype.isLoggedIn = function () {
        return this.userService.isLoggedIn();
    };
    AppComponent.prototype.onClicked = function () {
        this.clickedOutsideChannel.next(new __WEBPACK_IMPORTED_MODULE_2__publisher_message__["a" /* Message */]('clicked-outside'));
    };
    AppComponent.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_0__user_user_service__["a" /* UserService */] }, { type: __WEBPACK_IMPORTED_MODULE_1__publisher_publisher_service__["a" /* PublisherService */] }, { type: __WEBPACK_IMPORTED_MODULE_3__angular_router__["a" /* Router */] }, { type: __WEBPACK_IMPORTED_MODULE_3__angular_router__["b" /* ActivatedRoute */] }]; };
    return AppComponent;
}());

//# sourceMappingURL=app.component.js.map

/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AwsSdk; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_aws_sdk_dist_aws_sdk__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_aws_sdk_dist_aws_sdk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_aws_sdk_dist_aws_sdk__);

var AwsSdk = /** @class */ (function () {
    function AwsSdk() {
        window['AWS'].config.maxRetries = 10;
        window['AWS'].config.correctClockSkew = true;
        window['AWS'].config.update({ retryDelayOptions: { base: 1000 } });
    }
    AwsSdk.prototype.getTempCredentials = function (email, roleArn, cognitoToken) {
        var sts = new window['AWS'].STS();
        var sessionName = email + "_role_session";
        var params = {
            RoleArn: roleArn,
            RoleSessionName: sessionName,
            WebIdentityToken: cognitoToken
        };
        var request = sts.assumeRoleWithWebIdentity(params);
        request.on('retry', function (response) {
            // this resource is not yet available, wait 10 seconds to get it again
            if (response.httpResponse.statusCode === 403 && response.error) {
                response.error.retryable = true; // retry this error
            }
        });
        return request.promise();
    };
    AwsSdk.prototype.renewCredentials = function (email, roleArn, credentials) {
        var sts = new window['AWS'].STS({
            accessKeyId: credentials.accessKeyId,
            secretAccessKey: credentials.secretAccessKey,
            sessionToken: credentials.sessionToken
        });
        var sessionName = email + "_role_session";
        var params = {
            RoleArn: roleArn,
            RoleSessionName: sessionName,
        };
        var retries = 2;
        var request = sts.assumeRole(params);
        request.on('retry', function (response) {
            // this resource is not yet available, wait 10 seconds to get it again
            if (response.httpResponse.statusCode === 403 && response.error) {
                if (retries > 0) {
                    response.error.retryable = true; // retry this error
                    retries--;
                }
                else {
                    response.error.retryable = false;
                }
            }
        });
        return request.promise();
    };
    AwsSdk.ctorParameters = function () { return []; };
    return AwsSdk;
}());

//# sourceMappingURL=sdk.js.map

/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GaugeComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3__ = __webpack_require__(1091);

var GaugeComponent = /** @class */ (function () {
    function GaugeComponent() {
        this.margin = { top: 20, bottom: 20, left: 20, right: 20 };
    }
    GaugeComponent.prototype.ngOnInit = function () {
        this.createChart();
    };
    GaugeComponent.prototype.createChart = function () {
        //  const me = this;
        var element = this.chartContainer.nativeElement;
        this.width = element.offsetWidth - this.margin.left - this.margin.right;
        this.height = element.offsetHeight - this.margin.top - this.margin.bottom;
        var tickFontSize = '16px';
        var ltGrayColor = '#c9c9c9';
        var drGrayColor = '#626262';
        var gaugeFontFamily = 'open_sans_condensed';
        var w = 385;
        var h = 350;
        var svg = __WEBPACK_IMPORTED_MODULE_0_d3__["a" /* select */](element)
            .append('svg')
            .attr('width', w)
            .attr('height', h);
        var arc = __WEBPACK_IMPORTED_MODULE_0_d3__["b" /* arc */]()
            .innerRadius(115)
            .outerRadius(155)
            .startAngle(-2.5)
            .endAngle(2.5);
        var path = svg
            .append('path')
            .attr('id', 'bgPath')
            .attr('d', arc)
            .attr('stroke', ltGrayColor)
            .attr('stroke-width', 3)
            .attr('transform', 'translate(' + w / 2 + ',' + h / 2 + ')')
            .attr('fill', ltGrayColor);
        var percentText = svg
            .append('text')
            .attr('id', 'percentTxt')
            .attr('x', w / 2)
            .attr('y', h / 2 + 16)
            .attr('text-anchor', 'middle')
            .attr('font-size', '60px')
            .attr('font-family', gaugeFontFamily)
            .attr('fill', drGrayColor)
            .text('0');
        var throughputText = svg
            .append('text')
            .attr('x', w / 2)
            .attr('y', h / 1.23)
            .attr('text-anchor', 'middle')
            .attr('font-family', gaugeFontFamily)
            .attr('font-size', '16px')
            .attr('fill', drGrayColor)
            .text('THROUGHPUT');
        var mbpsText = svg
            .append('text')
            .attr('x', w / 2)
            .attr('y', h / 1.15)
            .attr('text-anchor', 'middle')
            .attr('fill', ltGrayColor)
            .attr('font-style', 'italic')
            .attr('font-family', 'open_sans')
            .attr('font-size', '12px')
            .text('Mbps');
        var tick0 = svg
            .append('text')
            .attr('x', w / 2.7) //bigger number goes left; smaller number goes right
            .attr('y', h / 1.4) //bigger number goes up; smaller goes down
            .style('text-anchor', 'middle')
            .attr('fill', ltGrayColor)
            .attr('font-family', gaugeFontFamily)
            .attr('font-size', tickFontSize)
            .text('0%');
        var tick1 = svg
            .append('text')
            .attr('x', w / 3.6) //bigger number goes left; smaller number goes right
            .attr('y', h / 2) //bigger number goes up; smaller goes down
            .style('text-anchor', 'middle')
            .attr('fill', ltGrayColor)
            .attr('font-family', gaugeFontFamily)
            .attr('font-size', tickFontSize)
            .text('20%');
        var tick2 = svg
            .append('text')
            .attr('x', w / 2.6) //bigger number goes left; smaller number goes right
            .attr('y', h / 3.5) //bigger number goes up; smaller goes down
            .style('text-anchor', 'middle')
            .attr('fill', ltGrayColor)
            .attr('font-family', gaugeFontFamily)
            .attr('font-size', tickFontSize)
            .text('40%');
        var tick3 = svg
            .append('text')
            .attr('x', w / 1.6) //bigger number goes left; smaller number goes right
            .attr('y', h / 3.5) //bigger number goes up; smaller goes down
            .style('text-anchor', 'middle')
            .attr('fill', ltGrayColor)
            .attr('font-family', gaugeFontFamily)
            .attr('font-size', tickFontSize)
            .text('60%');
        var tick4 = svg
            .append('text')
            .attr('x', w / 1.37) //bigger number goes left; smaller number goes right
            .attr('y', h / 2) //bigger number goes up; smaller goes down
            .style('text-anchor', 'middle')
            .attr('fill', ltGrayColor)
            .attr('font-family', gaugeFontFamily)
            .attr('font-size', tickFontSize)
            .text('80%');
        var tick5 = svg
            .append('text')
            .attr('x', w / 1.6) //bigger number goes left; smaller number goes right
            .attr('y', h / 1.4) //bigger number goes up; smaller goes down
            .style('text-anchor', 'middle')
            .attr('font-family', gaugeFontFamily)
            .attr('fill', ltGrayColor)
            .attr('font-size', tickFontSize)
            .text('100%');
        // ***************************************************************************************************
        this.arc2 = __WEBPACK_IMPORTED_MODULE_0_d3__["b" /* arc */]()
            .innerRadius(115)
            .outerRadius(155)
            .startAngle(-2.5);
        var path2 = svg
            .append('path')
            .datum({ endAngle: -2.5 })
            .attr('class', 'foreArc')
            .attr('stroke', '#31b4ce')
            .attr('stroke-width', 3)
            .attr('transform', 'translate(' + w / 2 + ',' + h / 2 + ')')
            .attr('fill', '#31b4ce')
            .attr('d', this.arc2);
        /*this.interval = setInterval(function() {
            me.animateGauge(me.getRandomInt(0, 100));
        }, 1500);*/
    };
    GaugeComponent.prototype.updateGauge = function (value) {
        var element = this.chartContainer.nativeElement;
        var percent = __WEBPACK_IMPORTED_MODULE_0_d3__["a" /* select */](element).select('#percentTxt');
        percent
            .text(value);
    };
    GaugeComponent.prototype.getRandomInt = function (min, max) {
        min = Math.ceil(min);
        max = Math.floor(max);
        return Math.floor(Math.random() * (max - min)) + min; //The maximum is exclusive and the minimum is inclusive
    };
    GaugeComponent.prototype.animateGauge = function (percent) {
        var initVal = -2.5;
        var element = this.chartContainer.nativeElement;
        initVal = initVal + (.05 * percent);
        if (initVal > 2.5) {
            initVal = 2.5;
        }
        var svg = __WEBPACK_IMPORTED_MODULE_0_d3__["a" /* select */](element).select('.foreArc')
            .transition()
            .duration(750)
            .attrTween('d', this.arcTween(initVal));
    };
    GaugeComponent.prototype.arcTween = function (newAngle) {
        var me = this;
        return function (d) {
            var interpolate = __WEBPACK_IMPORTED_MODULE_0_d3__["c" /* interpolate */](d.endAngle, newAngle);
            return function (t) {
                d.endAngle = interpolate(t);
                return me.arc2(d);
            };
        };
    };
    return GaugeComponent;
}());

//# sourceMappingURL=gauge.component.js.map

/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HeaderMenuComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__publisher_message__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__publisher_publisher_service__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__user_user_service__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__header_service__ = __webpack_require__(94);






var HeaderMenuComponent = /** @class */ (function () {
    function HeaderMenuComponent(pubService, viewContainerRef, componentFactoryResolver, headerService, userService, cdr, settingEntries) {
        this.pubService = pubService;
        this.viewContainerRef = viewContainerRef;
        this.componentFactoryResolver = componentFactoryResolver;
        this.cdr = cdr;
        this.showSettingsPopup = false;
        this.headerService = headerService;
        this.userService = userService;
        this.settingEntries = settingEntries;
        this.headerService.mode = 'items';
    }
    HeaderMenuComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.headerService.updateHeaderComponent(this);
        this.pubService.subscribeToChannel('clicked-outside').subscribe(function (msg) {
            if (msg.Owner !== _this) {
                _this.showSettingsPopup = false;
            }
        });
    };
    HeaderMenuComponent.prototype.refreshChanges = function () {
        this.cdr.detectChanges();
    };
    HeaderMenuComponent.prototype.popupClicked = function (evt, itemName) {
        this.headerService.popupClicked(itemName);
        evt.stopPropagation();
    };
    HeaderMenuComponent.prototype.itemClicked = function (evt) {
        this.headerService.itemClicked();
        evt.stopPropagation();
    };
    HeaderMenuComponent.prototype.onSettingsClicked = function (evt) {
        this.showSettingsPopup = !this.showSettingsPopup;
        this.pubService.sendToChannel('clicked-outside', new __WEBPACK_IMPORTED_MODULE_1__publisher_message__["a" /* Message */]('', this));
        evt.stopPropagation();
    };
    HeaderMenuComponent.prototype.onEntryClicked = function (evt, entry) {
        this.showSettingsPopup = false;
        entry.activate(this.viewContainerRef);
        evt.stopPropagation();
    };
    HeaderMenuComponent.prototype.ngOnDestroy = function () {
        for (var _i = 0, _a = this.settingEntries; _i < _a.length; _i++) {
            var entry = _a[_i];
            entry.clean();
        }
    };
    HeaderMenuComponent.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_2__publisher_publisher_service__["a" /* PublisherService */] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewContainerRef"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ComponentFactoryResolver"] }, { type: __WEBPACK_IMPORTED_MODULE_4__header_service__["a" /* HeaderService */] }, { type: __WEBPACK_IMPORTED_MODULE_3__user_user_service__["a" /* UserService */] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectorRef"] }, { type: null, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: ['SettingsEntry'] }] }]; };
    return HeaderMenuComponent;
}());

//# sourceMappingURL=header-menu.component.js.map

/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HeaderComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__user_user_service__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__header_service__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_router__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__trial_trial_service__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__main_config_config_service__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__systeminformation_systeminformation_service__ = __webpack_require__(46);






var HeaderComponent = /** @class */ (function () {
    function HeaderComponent(router, route, userService, headerService, trialService, cfgService, systemInformationService) {
        var _this = this;
        this.router = router;
        this.route = route;
        this.userService = userService;
        this.headerService = headerService;
        this.trialService = trialService;
        this.cfgService = cfgService;
        this.systemInformationService = systemInformationService;
        this.trialMode = false;
        this.trialModeExpired = false;
        this.consume = 0;
        this.threshold = 0;
        this.showDevDurations = true;
        this.currentRoute = '/';
        this.router.events.subscribe(function (event) {
            if (event instanceof __WEBPACK_IMPORTED_MODULE_2__angular_router__["y" /* NavigationEnd */]) {
                _this.currentRoute = event.url;
            }
        });
    }
    HeaderComponent.prototype.ngOnInit = function () {
        var _this = this;
        var me = this;
        this.systemInformationService.getSystemInformation().subscribe(function (information) {
            if (information['ShowDevDurations'] != null) {
                _this.showDevDurations = information['ShowDevDurations'];
            }
        });
        //Only do these things if user is in trialMode
        //  if (this.userService.getCurrentUser()['TrialMode']) {
        this.trialStatusSubscription = this.trialService.trialStatusChanged
            .subscribe(function (response) {
            if (response.trialMode) {
                _this.trialMode = response.trialMode;
                _this.trialModeExpired = response.trialModeExpired;
                _this.trialData = response.trialData;
                _this.trialMax = response.max;
                if (_this.trialMode && _this.trialMax === 0) {
                    _this.navigate('trial');
                }
            }
            else {
                _this.trialMode = response.trialMode;
                _this.consume = response.consume;
                _this.threshold = response.threshold;
            }
        });
        this.trialService.getAccountStatus(this.userService.getCurrentUser().Email);
        //   }
        this.currentAttackSubscription = this.cfgService.currentAttackSubject
            .subscribe(function (attack) {
            if (attack && attack.Status && (attack.Status === 'Stopped' || attack.Status === 'Failed')) {
                _this.trialService.getAccountStatus(_this.userService.getCurrentUser().Email);
            }
        });
    };
    HeaderComponent.prototype.logOut = function () {
        this.userService.logOut();
    };
    HeaderComponent.prototype.isLoggedIn = function () {
        return this.userService.isLoggedIn();
    };
    HeaderComponent.prototype.navigateHome = function () {
        this.headerService.navigateHome();
    };
    HeaderComponent.prototype.navigate = function (value) {
        this.headerService.navigate(value);
    };
    HeaderComponent.prototype.buyNowClick = function () {
        if (this.showDevDurations) {
            window.location.href = 'https://store-uat.ixiacom.com/product/BreakingPoint-Cloud';
        }
        else {
            window.location.href = 'https://www.ixiacom.com/products/breakingpoint-cloud';
        }
    };
    HeaderComponent.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_2__angular_router__["a" /* Router */] }, { type: __WEBPACK_IMPORTED_MODULE_2__angular_router__["b" /* ActivatedRoute */] }, { type: __WEBPACK_IMPORTED_MODULE_0__user_user_service__["a" /* UserService */] }, { type: __WEBPACK_IMPORTED_MODULE_1__header_service__["a" /* HeaderService */] }, { type: __WEBPACK_IMPORTED_MODULE_3__trial_trial_service__["a" /* TrialService */] }, { type: __WEBPACK_IMPORTED_MODULE_4__main_config_config_service__["a" /* ConfigService */] }, { type: __WEBPACK_IMPORTED_MODULE_5__systeminformation_systeminformation_service__["a" /* SystemInformationService */] }]; };
    return HeaderComponent;
}());

//# sourceMappingURL=header.component.js.map

/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export IXIA_OFFICES */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UserLoginComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_router__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__licensing_modal_licensing_args__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__licensing_tos__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__user_preferences_service__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__user_user_service__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__user_login__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__user_login_service__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__aws_environment__ = __webpack_require__(26);








/*
const AUSTIN_IMG = require('../../assets/login/austin.jpg');
const BUCHAREST_IMG = require('../../assets/login/bucharest.jpg');
const KOLKATA_IMG = require('../../assets/login/kolkata.jpg');
const LOSANGELES_IMG = require('../../assets/login/losangeles.jpg');
const PORTLAND_IMG = require('../../assets/login/portland.jpg');
const SANTACLARA_IMG = require('../../assets/login/santaclara.jpg');
const VANCOUVER_IMG = require('../../assets/login/vancouver.jpg');

const BACKGROUND_IMGS = [AUSTIN_IMG, BUCHAREST_IMG, KOLKATA_IMG, LOSANGELES_IMG, PORTLAND_IMG, SANTACLARA_IMG, VANCOUVER_IMG]
*/
var GREEN_IMG = __webpack_require__(1093);
var BLUE_IMG = __webpack_require__(1092);
var PURPLE_IMG = __webpack_require__(1094);
var BACKGROUND_IMGS = [GREEN_IMG, BLUE_IMG, PURPLE_IMG];
var ROTATE_INTERVAL = 120000;
var FADE_ANIMATION = 'fade-background 1s ease-in backwards';
var IXIA_OFFICES = [{
        image: GREEN_IMG,
        city: '',
        address: ''
    }, {
        image: BLUE_IMG,
        city: '',
        address: ''
    }, {
        image: PURPLE_IMG,
        city: '',
        address: ''
    }];
var UserLoginComponent = /** @class */ (function () {
    function UserLoginComponent(userService, loginService, preferencesService, router, awsEnv, route) {
        this.userService = userService;
        this.loginService = loginService;
        this.preferencesService = preferencesService;
        this.router = router;
        this.awsEnv = awsEnv;
        this.route = route;
        this.mousePointer = 'pointer';
        this.inputDisabled = false;
        this.playAnimation = false;
        this.animation = 'none';
        this.city = '';
        this.address = '';
        this.forgotPasswordUrl = '';
    }
    UserLoginComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.forgotPasswordUrl = this.awsEnv.getForgotPasswordUrl();
        // this.signupUrl = this.awsEnv.getSignupUrl();
        this.backgroundImg = BACKGROUND_IMGS[Math.floor(Math.random() * BACKGROUND_IMGS.length)];
        this.nextBackgroundImg = this.backgroundImg;
        this.setFooterDetails();
        this.backgroundImgRotatorTimer = setTimeout(function () { _this.rotateBackgroundImage(); }, ROTATE_INTERVAL);
    };
    UserLoginComponent.prototype.login = function () {
        var _this = this;
        this.error = null;
        this.mousePointer = 'wait';
        this.inputDisabled = true;
        this.loginService.login(new __WEBPACK_IMPORTED_MODULE_5__user_login__["a" /* UserLogin */](this.email, this.password))
            .subscribe(function (user) {
            _this.loginService.userLoggedIn(true);
            if (_this.backgroundImgRotatorTimer) {
                clearTimeout(_this.backgroundImgRotatorTimer);
                _this.backgroundImgRotatorTimer = null;
            }
            _this.preferencesService.setDefault(user.Preferences);
            if (!user.Preferences.AgreedToEula) {
                _this.eulaModel.showDialog(new __WEBPACK_IMPORTED_MODULE_1__licensing_modal_licensing_args__["a" /* ModalLicensingArgs */](__WEBPACK_IMPORTED_MODULE_2__licensing_tos__["a" /* tos */], 'Terms Of Service', __WEBPACK_IMPORTED_MODULE_2__licensing_tos__["b" /* tosPath */], __WEBPACK_IMPORTED_MODULE_2__licensing_tos__["c" /* tosName */])).subscribe(function (value) {
                    if (value === true) {
                        user.Preferences.AgreedToEula = true;
                        _this.userLoggedIn(user);
                    }
                    else {
                        _this.mousePointer = 'pointer';
                        _this.inputDisabled = false;
                    }
                });
            }
            else {
                _this.userLoggedIn(user);
            }
        }, function (error) {
            _this.error = error;
            _this.mousePointer = 'pointer';
            _this.inputDisabled = false;
        }, function () {
        });
    };
    UserLoginComponent.prototype.forgotPassword = function () {
        window.open(this.awsEnv.getForgotPasswordUrl(), '_blank');
    };
    UserLoginComponent.prototype.userLoggedIn = function (user) {
        var _this = this;
        this.userService.setCurrentUser(user)
            .then(function () {
            _this.router.navigate(['/dashboard']);
        })
            .catch(function (error) {
            _this.error = error;
        });
    };
    UserLoginComponent.prototype.rotateBackgroundImage = function () {
        var _this = this;
        var crtIdx = BACKGROUND_IMGS.indexOf(this.backgroundImg) + 1;
        if (crtIdx >= BACKGROUND_IMGS.length) {
            crtIdx = BACKGROUND_IMGS.length - crtIdx;
        }
        var img = BACKGROUND_IMGS[crtIdx];
        var xhr = new XMLHttpRequest();
        xhr.onload = function (ev) {
            if (xhr.readyState == 4) {
                if (xhr.status == 200) {
                    _this.nextBackgroundImg = img;
                    _this.animation = FADE_ANIMATION;
                    _this.playAnimation = true;
                }
            }
        };
        xhr.onerror = function (ev) {
            console.error(xhr.statusText);
        };
        xhr.open('GET', img, true);
        xhr.send();
    };
    UserLoginComponent.prototype.onAnimationEnd = function (event) {
        var _this = this;
        if (event.animationName === 'fade-background') {
            this.backgroundImg = this.nextBackgroundImg;
            this.playAnimation = false;
            this.animation = 'none';
            this.setFooterDetails();
            this.backgroundImgRotatorTimer = setTimeout(function () { _this.rotateBackgroundImage(); }, ROTATE_INTERVAL);
        }
    };
    UserLoginComponent.prototype.setFooterDetails = function () {
        for (var _i = 0, IXIA_OFFICES_1 = IXIA_OFFICES; _i < IXIA_OFFICES_1.length; _i++) {
            var office = IXIA_OFFICES_1[_i];
            if (office.image == this.backgroundImg) {
                this.city = office.city;
                this.address = office.address;
                break;
            }
        }
    };
    UserLoginComponent.prototype.signUp = function () {
        if (this.awsEnv.getShowFreeTrial()) {
            this.router.navigate(['trial']);
        }
        else {
            this.router.navigate(['no-trial']);
        }
    };
    UserLoginComponent.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_4__user_user_service__["a" /* UserService */] }, { type: __WEBPACK_IMPORTED_MODULE_6__user_login_service__["a" /* LoginService */] }, { type: __WEBPACK_IMPORTED_MODULE_3__user_preferences_service__["a" /* UserPreferencesService */] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_router__["a" /* Router */] }, { type: __WEBPACK_IMPORTED_MODULE_7__aws_environment__["a" /* AwsEnvironment */] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_router__["b" /* ActivatedRoute */] }]; };
    return UserLoginComponent;
}());

//# sourceMappingURL=user-login.component.js.map

/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UserLogin; });
var UserLogin = /** @class */ (function () {
    function UserLogin(Email, Password) {
        this.Email = Email;
        this.Password = Password;
    }
    return UserLogin;
}());

//# sourceMappingURL=user-login.js.map

/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DdosAttackConfigComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__attack_attack_service__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__aws_environment__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_config_service__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main_target_validation_target_validation_service__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__systeminformation_systeminformation_service__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__trial_trial_service__ = __webpack_require__(39);






var AttackConfig = /** @class */ (function () {
    function AttackConfig() {
    }
    return AttackConfig;
}());
var Target = /** @class */ (function () {
    function Target() {
    }
    return Target;
}());
var Host = /** @class */ (function () {
    function Host() {
    }
    return Host;
}());
var Port = /** @class */ (function () {
    function Port() {
    }
    return Port;
}());
var DdosAttackConfigComponent = /** @class */ (function () {
    function DdosAttackConfigComponent(attackService, awsEnv, cfgService, targetValidationService, systemInformationService, trialService) {
        this.attackService = attackService;
        this.awsEnv = awsEnv;
        this.cfgService = cfgService;
        this.targetValidationService = targetValidationService;
        this.systemInformationService = systemInformationService;
        this.trialService = trialService;
        this.availableAttackProfiles = [];
        this.canStartAttack = true;
        this.canStopAttack = false;
        this.disableInputs = false;
        this.showDevDurations = true;
        this.showEstimatedTime = false;
        this.estimatedTime = '15';
        this.showEstimatedOutboundData = true;
    }
    DdosAttackConfigComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.systemInformationService.getSystemInformation().subscribe(function (information) {
            if (information['ShowDevDurations'] != null) {
                _this.showDevDurations = information['ShowDevDurations'];
            }
        });
        this.updateAttackConfig();
        this.cfgService.availableAttackProfilesSubject
            .subscribe(function (profiles) {
            profiles.sort(function (as, bs) {
                var a, b, a1, b1, i = 0, n, L, rx = /(\.\d+)|(\d+(\.\d+)?)|([^\d.]+)|(\.\D+)|(\.$)/g;
                if (as.Label === bs.Label)
                    return 0;
                a = as.Label.toLowerCase().match(rx);
                b = bs.Label.toLowerCase().match(rx);
                L = a.length;
                while (i < L) {
                    if (!b[i])
                        return 1;
                    a1 = a[i],
                        b1 = b[i++];
                    if (a1 !== b1) {
                        n = a1 - b1;
                        if (!isNaN(n))
                            return n;
                        return a1 > b1 ? 1 : -1;
                    }
                }
                return b[i] ? -1 : 0;
            });
            _this.availableAttackProfiles = profiles;
            _this.updateAttackConfig();
        });
        this.currentAttackSubscription = this.cfgService.currentAttackSubject
            .subscribe(function (attack) {
            if (attack) {
                _this.currentAttack = attack;
                //console.log(attack);
                _this.canStartAttack = !attack || ['Stopped', 'Failed', 'Unknown'].indexOf(attack.Status) >= 0;
                _this.canStopAttack = attack && ['Queued', 'Preparing', 'Started'].indexOf(attack.Status) >= 0;
                if (attack.Status === 'Queued' || attack.Status === 'Preparing' || attack.Status === 'Starting' || attack.Status === 'Stopping' || attack.Status === 'Started') {
                    _this.disableInputs = true;
                }
                else if (attack.Status === 'Stopped' || attack.Status === 'Failed') {
                    _this.disableInputs = false;
                }
                else {
                    _this.disableInputs = false;
                }
                _this.updateAttackConfig();
            }
        });
    };
    DdosAttackConfigComponent.prototype.ngOnDestroy = function () {
        this.currentAttackSubscription.unsubscribe();
    };
    DdosAttackConfigComponent.prototype.updateAttackConfig = function () {
        if (this.currentAttack) {
            this.attackConfig = {
                target: {
                    host: {
                        ip: this.currentAttack.AttackParams.TargetIpAddress
                    },
                    port: {
                        number: this.currentAttack.AttackParams.TargetPortNumber
                    }
                },
                ddosProfile: this.currentAttack.AttackParams.AttackProfile,
                throughput: 1000,
                duration: this.currentAttack.AttackParams.Duration,
                volume: this.currentAttack.AttackParams.AttackSize,
                region: this.currentAttack.AttackParams.SourceRegionName
            };
            if (this.attackConfig.region === '') {
                this.attackConfig.region = this.awsEnv.getDefaultSourceRegion();
            }
        }
        else {
            var defaultProfile = this.getDefaultAttackProfile();
            this.attackConfig = {
                target: {
                    host: {
                        ip: ''
                    },
                    port: {
                        number: 80
                    }
                },
                ddosProfile: defaultProfile ? defaultProfile.Name : null,
                throughput: 1000,
                duration: 600,
                volume: 'small',
                region: this.awsEnv.getDefaultSourceRegion()
            };
        }
        var profileIndex = this.findWithAttr(this.availableAttackProfiles, 'Name', this.attackConfig.ddosProfile);
        if (this.attackConfig.ddosProfile && this.availableAttackProfiles.length && (profileIndex !== -1)) {
            this.selectedAttackSizes = this.availableAttackProfiles[profileIndex].Sizes;
        }
        this.calculateEstimatedThroughput();
    };
    DdosAttackConfigComponent.prototype.findWithAttr = function (array, attr, value) {
        for (var i = 0; i < array.length; i += 1) {
            if (array[i][attr] === value) {
                return i;
            }
        }
        return -1;
    };
    DdosAttackConfigComponent.prototype.getDefaultAttackProfile = function () {
        if (!this.availableAttackProfiles) {
            return null;
        }
        for (var _i = 0, _a = this.availableAttackProfiles; _i < _a.length; _i++) {
            var profile = _a[_i];
            if (profile.Default) {
                return profile;
            }
        }
        return this.availableAttackProfiles[0] || null;
    };
    DdosAttackConfigComponent.prototype.getAttackParams = function () {
        return {
            TargetIpAddress: this.attackConfig.target.host.ip,
            TargetPortNumber: this.attackConfig.target.port.number,
            AttackProfile: this.attackConfig.ddosProfile,
            AttackSize: this.attackConfig.volume,
            Duration: this.attackConfig.duration,
            SourceRegionName: this.attackConfig.region
        };
    };
    DdosAttackConfigComponent.prototype.onStartStopAttack = function () {
        var _this = this;
        this.startStopOperationInProgress = true;
        this.error = null;
        if (this.canStartAttack) {
            if (this.awsEnv.isIpValidationEnabled()) {
                this.targetValidationService.getSubscriptions().subscribe(function (subcriptions) {
                    var validSubscription = false;
                    subcriptions.forEach(function (subscription) {
                        if (subscription.valid) {
                            validSubscription = true;
                        }
                    });
                    if (!validSubscription) {
                        _this.targetValidationService.showDialog();
                        _this.startStopOperationInProgress = false;
                    }
                    else {
                        _this.startAttack();
                    }
                }, function (error) {
                    _this.error = error;
                    _this.startStopOperationInProgress = false;
                    console.log('Error during start test: ' + error);
                });
            }
            else {
                // no ip validation
                this.startAttack();
            }
        }
        else if (this.canStopAttack) {
            this.stopAttack();
        }
    };
    DdosAttackConfigComponent.prototype.onAttackSelect = function (event) {
        //console.log(event);
        this.selectedAttackSizes = this.availableAttackProfiles[event.target.selectedIndex].Sizes;
        var valueFound = this.findWithAttr(this.selectedAttackSizes, 'Name', this.attackConfig.volume);
        if (valueFound === -1) {
            this.attackConfig.volume = this.selectedAttackSizes[0].Name; //If value doesn't exist revert to 0th
        }
        this.calculateEstimatedThroughput();
    };
    DdosAttackConfigComponent.prototype.startAttack = function () {
        var _this = this;
        // fix the source region
        this.attackConfig.region = this.awsEnv.getDefaultSourceRegion();
        this.attackService.start(this.getAttackParams()).subscribe(function (attack) {
            _this.startStopOperationInProgress = false;
            //console.log(attack);
        }, function (error) {
            _this.error = error;
            _this.startStopOperationInProgress = false;
            console.log('Error during start test: ' + error);
        }, function () {
        });
    };
    DdosAttackConfigComponent.prototype.stopAttack = function () {
        var _this = this;
        this.attackService.stop(this.currentAttack.ID).subscribe(function (attack) {
            _this.startStopOperationInProgress = false;
            //console.log(attack);
        }, function (error) {
            _this.error = error;
            _this.startStopOperationInProgress = false;
            console.log('Error during stop test: ' + error);
        }, function () {
        });
    };
    DdosAttackConfigComponent.prototype.onDurationChange = function () {
        this.calculateEstimatedThroughput();
    };
    DdosAttackConfigComponent.prototype.onAttackSizeSelect = function (event) {
        this.calculateEstimatedThroughput();
    };
    DdosAttackConfigComponent.prototype.bytesToSize = function (size) {
        var i = Math.floor(Math.log(size) / Math.log(1000));
        if (size === 0) {
            return '0 MB';
        }
        return +(size / Math.pow(1000, i)).toFixed(2) * 1 + ' ' + ['B', 'kB', 'MB', 'GB', 'TB'][i];
    };
    ;
    DdosAttackConfigComponent.prototype.calculateEstimatedThroughput = function () {
        if (this.selectedAttackSizes && this.attackConfig.volume && this.attackConfig.duration) {
            var idx = this.findWithAttr(this.selectedAttackSizes, 'Name', this.attackConfig.volume);
            if (idx > -1) {
                var bytes = this.selectedAttackSizes[idx].max * 1000 * 1000 / 8; //max is in bits
                this.estimatedOutboundData = this.bytesToSize(bytes * this.attackConfig.duration);
                this.trialService.setEstimatedOutboundData(parseFloat((((bytes * this.attackConfig.duration) / 1000000) / 1000).toFixed(2)));
                this.showEstimatedOutboundData = true;
            }
            else {
                //Something went wrong. don't show estimated outbound data
                this.showEstimatedOutboundData = false;
            }
        }
    };
    DdosAttackConfigComponent.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_0__attack_attack_service__["a" /* AttackService */] }, { type: __WEBPACK_IMPORTED_MODULE_1__aws_environment__["a" /* AwsEnvironment */] }, { type: __WEBPACK_IMPORTED_MODULE_2__config_config_service__["a" /* ConfigService */] }, { type: __WEBPACK_IMPORTED_MODULE_3__main_target_validation_target_validation_service__["a" /* TargetValidationService */] }, { type: __WEBPACK_IMPORTED_MODULE_4__systeminformation_systeminformation_service__["a" /* SystemInformationService */] }, { type: __WEBPACK_IMPORTED_MODULE_5__trial_trial_service__["a" /* TrialService */] }]; };
    return DdosAttackConfigComponent;
}());

//# sourceMappingURL=ddos-attack-config.component.js.map

/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export aResultsState */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DdosAttackResultsComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__attack_attack_service__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_config_service__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main_target_validation_target_validation_service__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__login_user_login_service__ = __webpack_require__(67);




var aResultsState;
(function (aResultsState) {
    aResultsState["RUNNING"] = "running";
    aResultsState["LOADING"] = "loading";
    aResultsState["COMPLETE"] = "complete";
    aResultsState["INFO"] = "info";
    aResultsState["WELCOME"] = "welcome";
    aResultsState["FAIL"] = "fail";
})(aResultsState || (aResultsState = {}));
var DdosAttackResultsComponent = /** @class */ (function () {
    function DdosAttackResultsComponent(attackService, cfgService, targetValidationService, loginService) {
        var _this = this;
        this.attackService = attackService;
        this.cfgService = cfgService;
        this.targetValidationService = targetValidationService;
        this.loginService = loginService;
        this.state = aResultsState.LOADING;
        this.loadingMessasge = 'LOADING';
        this.failReason = '';
        this.formattedDateTime = '';
        this.framesPerSecond = '0';
        this.framesSent = '0';
        this.throughput = 0;
        this.availableAttackProfiles = [];
        this.outboundData = '0';
        this.view = [400, 400];
        //Let the app know if the user has loggedIn since the last test has run.
        //Should return to false once a test has run
        this.userLoggedIn = false;
        this.showCheckBoxes = false;
        this.readyToRun = false;
        this.loginService.userLoggedInSubject
            .subscribe(function (value) {
            _this.userLoggedIn = value;
        });
    }
    DdosAttackResultsComponent.prototype.onGaugeCreated = function (value) {
        //      this.processCurrentAttack(this.currentAttack);
    };
    DdosAttackResultsComponent.prototype.ngOnInit = function () {
        //Reveal to get loading progress example
        /*var me = this;
        setTimeout(() => {
            if(me.loadProgressBar) {
                me.loadProgressBar.updateProgress(50, '02 of 05 Source IPs reserved');
            }
        }, 5000);*/
        var _this = this;
        this.currentAttackSubscription = this.cfgService.currentAttackSubject.subscribe(function (attack) { return _this.processCurrentAttack(attack); });
        this.cfgService.availableAttackProfilesSubject
            .subscribe(function (profiles) {
            _this.availableAttackProfiles = profiles;
        });
    };
    DdosAttackResultsComponent.prototype.processCurrentAttack = function (attack) {
        var _this = this;
        var me = this;
        if (attack) {
            this.currentAttack = attack;
            if (attack.Status === 'Queued' || attack.Status === 'Preparing' || attack.Status === 'Starting' || attack.Status === 'Created') {
                this.resetAttackResults();
                this.userLoggedIn = false;
            }
            if (attack.Status === 'Queued' || attack.Status === 'Preparing' || attack.Status === 'Starting') {
                this.loadingMessasge = attack.Status;
                this.state = aResultsState.LOADING;
            }
            else if (attack.Status === 'Created') {
                this.loadingMessasge = 'Validating';
                this.state = aResultsState.LOADING;
            }
            else if ((attack.Status === 'Started') || attack.Status === 'Stopping') {
                this.state = aResultsState.RUNNING;
            }
            else if (attack.Status === 'Stopped') {
                this.state = aResultsState.COMPLETE;
            }
            else if (attack.Status === 'Failed') {
                this.state = aResultsState.FAIL;
                this.failReason = attack.FailReason;
            }
            else {
                this.state = aResultsState.LOADING;
                setTimeout(function () {
                    if (attack.Status === null) {
                        _this.state = aResultsState.WELCOME;
                    }
                }, 10000);
            }
            if (this.gauge && attack['Metrics']) {
                //Give the UI a .5 millisecond timeout to prevent DE9049
                if (attack.Status === 'Stopped') {
                    setTimeout(function () {
                        _this.updateAttack(attack);
                    }, 500);
                }
                else {
                    this.updateAttack(attack);
                }
            }
        }
        else {
            this.state = aResultsState.LOADING;
            setTimeout(function () {
                if (!me.currentAttack || me.currentAttack.Status === 'Unknown') {
                    _this.state = aResultsState.WELCOME;
                }
            }, 3000);
            //this.state = aResultsState.LOADING;
        }
        //this.state = aResultsState.WELCOME;
    };
    DdosAttackResultsComponent.prototype.updateAttack = function (attack) {
        this.runningTime = attack && attack.StartDate && (((attack.StopDate ? Date.parse(attack.StopDate) : new Date().getTime()) - Date.parse(attack.StartDate)) / 1000);
        this.formattedDateTime = this.cfgService.formatDateTime(attack.StartDate);
        this.gauge.animateGauge(this.getGaugePercentage(attack));
        this.throughput = this.bytesPerSecondToMegabitsPerSecond(attack['Metrics'].TxDataRate);
        this.gauge.updateGauge(String(this.throughput));
        this.framesPerSecond = String(attack['Metrics'].TxFrameRate);
        this.framesSent = String(attack['Metrics'].TxFrames);
        this.outboundData = String(attack['Metrics'].TxData);
    };
    DdosAttackResultsComponent.prototype.resetAttackResults = function () {
        if (this.gauge) {
            this.gauge.animateGauge(0);
            this.gauge.updateGauge('0');
        }
        this.framesPerSecond = '0';
        this.framesSent = '0';
        this.runningTime = 0;
    };
    DdosAttackResultsComponent.prototype.ngOnDestroy = function () {
        this.currentAttackSubscription.unsubscribe();
    };
    DdosAttackResultsComponent.prototype.getGaugePercentage = function (attack) {
        var max = this.getMaxofSize(attack);
        if (!max) {
            return 0;
        }
        var rate = this.bytesPerSecondToMegabitsPerSecond(attack['Metrics'].TxDataRate);
        return (rate * 100) / max;
    };
    DdosAttackResultsComponent.prototype.getMaxofSize = function (attack) {
        this.availableAttackProfiles;
        for (var _i = 0, _a = this.availableAttackProfiles; _i < _a.length; _i++) {
            var i = _a[_i];
            if (i.Name === attack.AttackParams.AttackProfile) {
                for (var _b = 0, _c = i.Sizes; _b < _c.length; _b++) {
                    var size = _c[_b];
                    if (size.Name === attack.AttackParams.AttackSize) {
                        return size.max;
                    }
                }
            }
        }
    };
    DdosAttackResultsComponent.prototype.bytesPerSecondToMegabitsPerSecond = function (bytes) {
        var val = bytes / 1000;
        val = val / 1000;
        val = val * 8;
        return Math.round(val);
    };
    DdosAttackResultsComponent.prototype.openWelcomeScreenLink = function (theLink, isExternal) {
        if (isExternal) {
            window.open(theLink, '_blank');
        }
        else {
            var url = window.location.protocol + '//' + window.location.hostname + ':' +
                window.location.port + theLink;
            window.open(url, '_blank');
        }
    };
    DdosAttackResultsComponent.prototype.openTargetValidationService = function () {
        this.targetValidationService.showDialog();
    };
    DdosAttackResultsComponent.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_0__attack_attack_service__["a" /* AttackService */] }, { type: __WEBPACK_IMPORTED_MODULE_1__config_config_service__["a" /* ConfigService */] }, { type: __WEBPACK_IMPORTED_MODULE_2__main_target_validation_target_validation_service__["a" /* TargetValidationService */] }, { type: __WEBPACK_IMPORTED_MODULE_3__login_user_login_service__["a" /* LoginService */] }]; };
    return DdosAttackResultsComponent;
}());

//# sourceMappingURL=ddos-attack-results.component.js.map

/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AboutDialogComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__aws_environment__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modals_modal_base__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__systeminformation_systeminformation_service__ = __webpack_require__(46);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var AboutDialogComponent = /** @class */ (function (_super) {
    __extends(AboutDialogComponent, _super);
    function AboutDialogComponent(awsEnv, systemInformationService) {
        var _this = _super.call(this) || this;
        _this.awsEnv = awsEnv;
        _this.systemInformationService = systemInformationService;
        _this.deploymentVersion = '...';
        _this.azureDeploymentVersion = '...';
        _this.awsDeploymentRegion = '...';
        _this.azureDeploymentRegion = '...';
        _this.botContainerVersion = '...';
        _this.uiDeploymentVersion = '...';
        return _this;
    }
    AboutDialogComponent.prototype.ngOnInit = function () {
        this.azureDeploymentRegion = this.awsEnv.getDefaultSourceRegion();
        this.awsDeploymentRegion = this.awsEnv.getApiRegion();
    };
    AboutDialogComponent.prototype.onActivate = function (args) {
        var _this = this;
        this.systemInformationService.getSystemInformation().subscribe(function (information) {
            _this.deploymentVersion = information.Version;
            _this.botContainerVersion = information.BotVersion;
            var cluster = information.Clusters.filter(function (c) { return c.Region === _this.azureDeploymentRegion; })[0];
            if (cluster) {
                _this.azureDeploymentVersion = cluster.Version;
            }
        });
    };
    AboutDialogComponent.prototype.onClose = function () {
    };
    AboutDialogComponent.prototype.onCloseClicked = function (e) {
        e.preventDefault();
        this.closeDialog();
    };
    AboutDialogComponent.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_0__aws_environment__["a" /* AwsEnvironment */] }, { type: __WEBPACK_IMPORTED_MODULE_2__systeminformation_systeminformation_service__["a" /* SystemInformationService */] }]; };
    return AboutDialogComponent;
}(__WEBPACK_IMPORTED_MODULE_1__modals_modal_base__["a" /* BaseModal */]));

//# sourceMappingURL=about-dialog.component.js.map

/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BillingDialogArgs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BillingDialog; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__billing_billing_service__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modals_modal_base__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__user_user_service__ = __webpack_require__(12);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var BillingDialogArgs = /** @class */ (function () {
    function BillingDialogArgs() {
    }
    return BillingDialogArgs;
}());

var BillingDialog = /** @class */ (function (_super) {
    __extends(BillingDialog, _super);
    function BillingDialog(service, userService) {
        var _this = _super.call(this) || this;
        _this.service = service;
        _this.userService = userService;
        _this.cycles = [];
        _this.userEmail = _this.userService.getCurrentUser().Email;
        return _this;
    }
    BillingDialog.prototype.onActivate = function (args) {
        this.updateCycles();
    };
    BillingDialog.prototype.onCloseClicked = function (e) {
        e.preventDefault();
        this.closeDialog();
    };
    BillingDialog.prototype.onClose = function () {
    };
    BillingDialog.prototype.updateCycles = function () {
        var _this = this;
        this.dialogError = undefined;
        this.loading = true;
        this.service.getCycles().catch(function (e) {
            _this.dialogError = JSON.stringify(e);
            throw e;
        }).subscribe(function (cycles) {
            _this.cycles = cycles.cycles;
            _this.currentCycle = _this.cycles && _this.cycles[0];
            _this.loading = false;
        });
    };
    BillingDialog.prototype.downloadInvoice = function (event) {
        if (this.currentCycle.invoiceUrl) {
            window.open(this.currentCycle.invoiceUrl);
        }
    };
    BillingDialog.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_0__billing_billing_service__["a" /* BillingService */] }, { type: __WEBPACK_IMPORTED_MODULE_2__user_user_service__["a" /* UserService */] }]; };
    return BillingDialog;
}(__WEBPACK_IMPORTED_MODULE_1__modals_modal_base__["a" /* BaseModal */]));

//# sourceMappingURL=billing-dialog.component.js.map

/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ModalErrorArgs; });
var ModalErrorArgs = /** @class */ (function () {
    function ModalErrorArgs(message, title) {
        this.Message = message;
        this.Title = title;
    }
    return ModalErrorArgs;
}());

//# sourceMappingURL=modal-error-args.js.map

/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ShowErrorModal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modals_modal_error_args__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modal_base__ = __webpack_require__(68);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var ShowErrorModal = /** @class */ (function (_super) {
    __extends(ShowErrorModal, _super);
    function ShowErrorModal() {
        var _this = _super.call(this) || this;
        _this.args = new __WEBPACK_IMPORTED_MODULE_0__modals_modal_error_args__["a" /* ModalErrorArgs */]('', '');
        return _this;
    }
    ShowErrorModal.prototype.onActivate = function (args) {
        this.args = args;
    };
    ShowErrorModal.prototype.onCloseClicked = function (e) {
        e.preventDefault();
        this.closeDialog();
    };
    ShowErrorModal.prototype.onClose = function () { };
    ShowErrorModal.ctorParameters = function () { return []; };
    return ShowErrorModal;
}(__WEBPACK_IMPORTED_MODULE_1__modal_base__["a" /* BaseModal */]));

//# sourceMappingURL=modal-error.component.js.map

/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SupportDialogComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modal_base__ = __webpack_require__(68);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var SupportDialogComponent = /** @class */ (function (_super) {
    __extends(SupportDialogComponent, _super);
    function SupportDialogComponent() {
        return _super.call(this) || this;
        //  this.args = new ModalErrorArgs('', '');
    }
    SupportDialogComponent.prototype.onActivate = function (args) {
        this.supportId = args;
        this.mailToString = 'mailto:support@ixiacom.com?subject=BreakingPoint%20Cloud%20Support%20For%20Test%20ID%20' + this.supportId + '&body=%0A%0A------------DO%20NOT%20REMOVE--------------%0A%0ABreakingPoint%20Cloud%20Test%20ID:%20' + this.supportId + '%0A%0A--------------DO%20NOT%20REMOVE------------%0A%0AYour%20message%20here';
    };
    SupportDialogComponent.prototype.onCloseClicked = function (e) {
        e.preventDefault();
        this.closeDialog();
    };
    SupportDialogComponent.prototype.onClose = function () { };
    SupportDialogComponent.ctorParameters = function () { return []; };
    return SupportDialogComponent;
}(__WEBPACK_IMPORTED_MODULE_0__modal_base__["a" /* BaseModal */]));

//# sourceMappingURL=support-dialog.component.js.map

/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MQTTService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mqttws31__ = __webpack_require__(1352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mqttws31___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__mqttws31__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_BehaviorSubject__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_BehaviorSubject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs_BehaviorSubject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__aws_environment__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__aws_signature__ = __webpack_require__(176);




var MQTTService = /** @class */ (function () {
    function MQTTService(signature, awsEnv) {
        var _this = this;
        this.signature = signature;
        this.awsEnv = awsEnv;
        this.connected = false;
        this.connecting = false;
        this.topicsMap = new Map();
        this.topicSubscribers = new Map();
        this.onMessageArrived = function (message) {
            //console.log("onMessageArrived:" + message.payloadString);
            if (_this.topicsMap.has(message.destinationName)) {
                var topicSubject = _this.topicsMap.get(message.destinationName);
                console.info('Received on MQTT channel: ' + message.destinationName + '-' + message.payloadString);
                topicSubject.next(message.payloadString);
            }
        };
        this.onConnectionLost = function (response) {
            if (response.errorCode !== 0) {
                console.log('MQTT connection lost:' + response.errorMessage);
            }
            _this.connected = false;
            _this.connecting = false;
            _this.topicsMap.clear();
            _this.topicSubscribers.clear();
            _this.client = null;
            _this.connSubject.error(response.errorMessage);
        };
        this.onConnectionSuccess = function () {
            console.log('MQTT connect succeded. ClientId=' + _this.clientId);
            _this.connected = true;
            _this.connecting = false;
            _this.connSubject.next(true);
        };
        this.onConnectionFailed = function (response) {
            console.log('MQTT connect failed: code=' + response.errorCode + ' message=' + response.errorMessage);
            _this.connected = false;
            _this.connecting = false;
            _this.topicsMap.clear();
            _this.topicSubscribers.clear();
            _this.client = null;
            _this.connSubject.error(response.errorMessage);
        };
    }
    MQTTService.prototype.connect = function (user) {
        if (!this.connected && !this.connecting) {
            this.connSubject = new __WEBPACK_IMPORTED_MODULE_1_rxjs_BehaviorSubject__["BehaviorSubject"](false);
            this.connecting = true;
            this.topicsMap.clear();
            this.topicSubscribers.clear();
            var url = "wss://" + user.IoTEndpoint + "/mqtt";
            var request = {
                method: 'GET',
                url: url,
                headers: {},
                data: ''
            };
            var signedUrl = this.signature.signRequestUsingQueryString(request, this.awsEnv.getCredentials(), this.awsEnv.getIotRegion(), 'iotdevicegateway');
            this.clientId = this.createClientId(user);
            this.client = this.createClient(signedUrl, this.clientId);
            this.client.onConnectionLost = this.onConnectionLost;
            this.client.onMessageArrived = this.onMessageArrived;
            var connectOptions = {
                onSuccess: this.onConnectionSuccess,
                useSSL: true,
                timeout: 3,
                mqttVersion: 4,
                onFailure: this.onConnectionFailed
            };
            this.client.connect(connectOptions);
        }
        return this.connSubject.asObservable();
    };
    MQTTService.prototype.register = function (topic) {
        this.checkConnection();
        var topicSubject;
        if (this.topicsMap.has(topic)) {
            topicSubject = this.topicsMap.get(topic);
            this.topicSubscribers[topic]++;
        }
        else {
            topicSubject = new __WEBPACK_IMPORTED_MODULE_1_rxjs_BehaviorSubject__["BehaviorSubject"]('');
            this.topicsMap.set(topic, topicSubject);
            this.topicSubscribers[topic] = 1;
            try {
                this.client.subscribe(topic);
            }
            catch (e) {
                this.topicsMap.delete(topic);
                throw e;
            }
        }
        return topicSubject.asObservable();
    };
    MQTTService.prototype.unregister = function (topic) {
        this.checkConnection();
        if (this.topicsMap.has(topic)) {
            this.topicSubscribers[topic]--;
            if (this.topicSubscribers[topic] <= 0) {
                try {
                    var topicSubject = this.topicsMap.get(topic);
                    topicSubject.complete();
                    this.client.unsubscribe(topic);
                }
                finally {
                    this.topicsMap.delete(topic);
                }
            }
        }
    };
    MQTTService.prototype.publish = function (topic, data) {
        this.checkConnection();
        var message = new Paho.MQTT.Message(JSON.stringify(data));
        message.destinationName = topic;
        this.client.send(message);
    };
    MQTTService.prototype.getClientId = function () {
        this.checkConnection();
        return this.clientId;
    };
    /**
    * Will ne mocked during unit tests
    */
    MQTTService.prototype.createClient = function (signedUrl, clientId) {
        return new Paho.MQTT.Client(signedUrl, clientId);
    };
    MQTTService.prototype.createClientId = function (user) {
        return user.Email + "_" + Math.random().toString(16).substr(2, 8);
    };
    MQTTService.prototype.checkConnection = function () {
        if (!this.connected) {
            throw 'Client is not connected';
        }
    };
    MQTTService.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_3__aws_signature__["a" /* AwsSignature */] }, { type: __WEBPACK_IMPORTED_MODULE_2__aws_environment__["a" /* AwsEnvironment */] }]; };
    return MQTTService;
}());

//# sourceMappingURL=mqtt.service.js.map

/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BytesToMegabytesPipe; });
var BytesToMegabytesPipe = /** @class */ (function () {
    function BytesToMegabytesPipe() {
    }
    BytesToMegabytesPipe.prototype.transform = function (bytes) {
        var val = bytes / 1000;
        val = val / 1000;
        return Math.round(val).toLocaleString();
    };
    return BytesToMegabytesPipe;
}());

//# sourceMappingURL=bytes-to-megabytes.pipe.js.map

/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SecondsToDurationPipe; });
var SecondsToDurationPipe = /** @class */ (function () {
    function SecondsToDurationPipe() {
    }
    SecondsToDurationPipe.prototype.transform = function (seconds) {
        if (seconds < 0) {
            seconds = 0;
        }
        var hours = ("0" + Math.floor(seconds / 3600)).slice(-2);
        var mins = ("0" + Math.floor((seconds - (+hours * 3600)) / 60)).slice(-2);
        var secs = ("0" + Math.floor(seconds % 60)).slice(-2);
        return hours + ':' + mins + ':' + secs;
    };
    return SecondsToDurationPipe;
}());

//# sourceMappingURL=seconds-to-duration.pipe.js.map

/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ReleaseNotesComponent; });
var ReleaseNotesComponent = /** @class */ (function () {
    function ReleaseNotesComponent() {
    }
    return ReleaseNotesComponent;
}());

//# sourceMappingURL=release-notes.component.js.map

/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AuthGuard; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_router__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__user_user_service__ = __webpack_require__(12);


var AuthGuard = /** @class */ (function () {
    function AuthGuard(userService, router) {
        this.userService = userService;
        this.router = router;
    }
    AuthGuard.prototype.canActivate = function (route, state) {
        if (this.userService.isLoggedIn()) {
            return true;
        }
        // Navigate to the login page
        this.router.navigate(['/login']);
        return false;
    };
    AuthGuard.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_1__user_user_service__["a" /* UserService */] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_router__["a" /* Router */] }]; };
    return AuthGuard;
}());

//# sourceMappingURL=auth-guard.service.js.map

/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ValidatePwordRetry */
/* unused harmony export ValidateWhitespace */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ValidateOnBlur; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TrialComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_forms__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__trial_service__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__login_user_login_service__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__login_user_login__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__user_user_service__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__angular_router__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__headerfooter_setting_entries_tos_entry__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__aws_environment__ = __webpack_require__(26);









function ValidatePwordRetry(c) {
    // self value
    var v = c.value;
    var validateEqual = "pword";
    // control vlaue
    var e = c.root.get(validateEqual);
    // value not equal
    if (e && v !== e.value) {
        return {
            validateEqual: false
        };
    }
    return null;
}
function ValidateWhitespace(c) {
    var isWhitespace = (c.value || '').trim().length === 0;
    var isValid = !isWhitespace;
    return isValid ? null : { 'whitespace': 'value is only whitespace' };
}
var ValidateOnBlur = /** @class */ (function () {
    function ValidateOnBlur() {
    }
    ValidateOnBlur.addFirstNameValidator = function (model, triggerValidation, required) {
        if (triggerValidation === void 0) { triggerValidation = false; }
        if (required === void 0) { required = true; }
        model.control.clearValidators();
        model.control.clearAsyncValidators();
        var validators = [
            __WEBPACK_IMPORTED_MODULE_1__angular_forms__["d" /* Validators */].pattern(/^[a-zA-Z\-\s]*$/),
            __WEBPACK_IMPORTED_MODULE_1__angular_forms__["d" /* Validators */].maxLength(32),
            ValidateWhitespace
        ];
        if (required)
            validators.push(__WEBPACK_IMPORTED_MODULE_1__angular_forms__["d" /* Validators */].required);
        model.control.setValidators(validators);
        if (triggerValidation) {
            model.control.updateValueAndValidity();
        }
    };
    ValidateOnBlur.addLastNameValidator = function (model, triggerValidation, required) {
        if (triggerValidation === void 0) { triggerValidation = false; }
        if (required === void 0) { required = true; }
        model.control.clearValidators();
        model.control.clearAsyncValidators();
        var validators = [
            __WEBPACK_IMPORTED_MODULE_1__angular_forms__["d" /* Validators */].pattern(/^[a-zA-Z\-\s]*$/),
            __WEBPACK_IMPORTED_MODULE_1__angular_forms__["d" /* Validators */].maxLength(32),
            ValidateWhitespace
        ];
        if (required)
            validators.push(__WEBPACK_IMPORTED_MODULE_1__angular_forms__["d" /* Validators */].required);
        model.control.setValidators(validators);
        if (triggerValidation) {
            model.control.updateValueAndValidity();
        }
    };
    ValidateOnBlur.addEmailValidator = function (model, triggerValidation) {
        if (triggerValidation === void 0) { triggerValidation = false; }
        model.control.setValidators([
            __WEBPACK_IMPORTED_MODULE_1__angular_forms__["d" /* Validators */].maxLength(64),
            ValidateWhitespace,
            __WEBPACK_IMPORTED_MODULE_1__angular_forms__["d" /* Validators */].pattern(/^[-a-z0-9~!$%^&*_=+}{\'?]+(\.[-a-z0-9~!$%^&*_=+}{\'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*\.([a-z]{2,63})|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i),
            __WEBPACK_IMPORTED_MODULE_1__angular_forms__["d" /* Validators */].required
        ]);
        if (triggerValidation) {
            model.control.updateValueAndValidity();
        }
    };
    ValidateOnBlur.addPasswordValidator = function (model, triggerValidation, matchPass) {
        if (triggerValidation === void 0) { triggerValidation = false; }
        if (matchPass === void 0) { matchPass = true; }
        model.control.setValidators([
            __WEBPACK_IMPORTED_MODULE_1__angular_forms__["d" /* Validators */].required,
            ValidateWhitespace,
            __WEBPACK_IMPORTED_MODULE_1__angular_forms__["d" /* Validators */].pattern("^(?=.*\\d)(?=.*[A-Z])[\\S][^\\>\\<]{7,}$"),
            __WEBPACK_IMPORTED_MODULE_1__angular_forms__["d" /* Validators */].minLength(8),
            __WEBPACK_IMPORTED_MODULE_1__angular_forms__["d" /* Validators */].maxLength(32)
        ]);
        if (matchPass) {
            var pwdRetry = model.control.root.get("pwordRetry");
            pwdRetry.setValidators([
                __WEBPACK_IMPORTED_MODULE_1__angular_forms__["d" /* Validators */].required
            ]);
            pwdRetry.updateValueAndValidity();
        }
        if (triggerValidation) {
            model.control.updateValueAndValidity();
        }
    };
    ValidateOnBlur.addPasswordRetryValidator = function (model, triggerValidation, matchPass) {
        if (triggerValidation === void 0) { triggerValidation = false; }
        if (matchPass === void 0) { matchPass = true; }
        if (matchPass) {
            model.control.setValidators([
                __WEBPACK_IMPORTED_MODULE_1__angular_forms__["d" /* Validators */].required,
                ValidateWhitespace,
                ValidatePwordRetry
            ]);
        }
        else
            model.control.setValidators([]);
        if (triggerValidation) {
            model.control.updateValueAndValidity();
        }
    };
    ValidateOnBlur.removePasswordRetryValidator = function (model) {
        model.control.setValidators([]);
    };
    ValidateOnBlur.prototype.onFocus = function (target) {
        this.model.control.markAsUntouched();
        this.model.control.markAsPristine();
        this.model.control.clearValidators();
        this.model.control.clearAsyncValidators();
    };
    ValidateOnBlur.prototype.onFocusout = function (target) {
        switch (this.model.name) {
            case "email": {
                ValidateOnBlur.addEmailValidator(this.model);
                break;
            }
            case "fname": {
                ValidateOnBlur.addFirstNameValidator(this.model);
                break;
            }
            case "lname": {
                ValidateOnBlur.addLastNameValidator(this.model);
                break;
            }
            case "pword": {
                ValidateOnBlur.addPasswordValidator(this.model);
                break;
            }
            case "pwordRetry": {
                ValidateOnBlur.addPasswordRetryValidator(this.model);
                break;
            }
        }
        if (this.model.control.value) {
            this.model.control.hadValue = true;
            this.model.control.markAsTouched();
            this.model.control.markAsDirty();
        }
        if (this.model.control.hadValue) {
            this.model.control.markAsDirty();
        }
        this.model.control.updateValueAndValidity();
    };
    ValidateOnBlur.ctorParameters = function () { return []; };
    return ValidateOnBlur;
}());

var TrialComponent = /** @class */ (function () {
    function TrialComponent(trialService, loginService, userService, router, route, tosEntry, viewContainerRef, awsEnv) {
        this.trialService = trialService;
        this.loginService = loginService;
        this.userService = userService;
        this.router = router;
        this.route = route;
        this.tosEntry = tosEntry;
        this.viewContainerRef = viewContainerRef;
        this.awsEnv = awsEnv;
        this.captchaResponse = false;
        this.registered = false;
        this.error = '';
        this.forgotPasswordUrl = '';
        this.passPlaceholder = "Choose a password";
        this.showRegCode = false;
        this.showPromoCode = false;
        this.showAlreadyUserLogin = false;
        window['verifyCallback'] = this.verifyCallback.bind(this);
        window['onloadCallback'] = this.onloadCallback.bind(this);
        this.trialParams = {
            Email: '',
            FirstName: '',
            LastName: '',
            Captcha: '',
            Password: '',
            Trial: true,
            UserExists: false,
            RegCode: '',
            PromoCode: ''
        };
        this.loadRecaptchaScript();
    }
    TrialComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.showRegCode = this.awsEnv.getShowRegCode();
        this.showPromoCode = this.awsEnv.getShowPromoCode();
        this.trialStatusSubscription = this.trialService.trialStatusChanged
            .subscribe(function (response) {
            if (response.trialMode && response.max === 0) {
                _this.registered = true;
            }
        });
        this.forgotPasswordUrl = this.awsEnv.getForgotPasswordUrl();
        this.createAccountCredSubscription = this.trialService.createAccountCredentials
            .subscribe(function (credentials) {
            if (credentials === 'CREATED') {
                //console.log('credentials->' + credentials);
                setTimeout(function () {
                    _this.loginUser();
                }, 10000);
            }
            else {
                _this.error = 'An error has occurred. Please try again.';
                _this.hideLoadingProgress();
                _this.trialForm.reset();
                grecaptcha.reset();
            }
        }, function (error) {
            _this.error = error;
            _this.hideLoadingProgress();
            grecaptcha.reset();
        });
    };
    TrialComponent.prototype.loadRecaptchaScript = function () {
        if (!this.node) {
            this.node = document.createElement('script');
            this.node.src = "https://www.google.com/recaptcha/api.js?onload=onloadCallback&render=explicit";
            this.node.type = 'text/javascript';
            this.node.async = true;
            this.node.defer = true;
            this.node.charset = 'utf-8';
            document.getElementsByTagName('head')[0].appendChild(this.node);
        }
    };
    TrialComponent.prototype.submitTrial = function () {
        var _this = this;
        this.trialParams.UserExists = this.showAlreadyUserLogin;
        //console.log(this.trialParams);
        this.showLoadingProgress('creating user');
        this.trialService.postTrialRegistration(this.trialParams).subscribe(function (registration) {
            //console.log(registration);
            _this.trialService.pollTrialRegistration(registration.RequestId);
        }, function (error) {
            _this.error = error;
            _this.hideLoadingProgress();
            grecaptcha.reset();
        });
    };
    TrialComponent.prototype.loginUser = function () {
        var _this = this;
        this.loginService.login(new __WEBPACK_IMPORTED_MODULE_4__login_user_login__["a" /* UserLogin */](this.trialParams.Email, this.trialParams.Password))
            .subscribe(function (user) {
            _this.loginService.userLoggedIn(true);
            _this.userService.setCurrentUser(user, true)
                .then(function () {
                _this.registered = true;
                _this.hideLoadingProgress();
                //this.startTrial();
            })
                .catch(function (error) {
                _this.error = error;
                _this.hideLoadingProgress();
                grecaptcha.reset();
            });
        }, function (error) {
            _this.error = error;
            _this.hideLoadingProgress();
            grecaptcha.reset();
        });
    };
    TrialComponent.prototype.startTrial = function () {
        var _this = this;
        var email = this.trialParams.Email;
        var promoCode = this.trialParams.PromoCode;
        if (!email) {
            email = this.userService.getCurrentUser().Email;
        }
        this.showLoadingProgress('activating your trial account');
        this.trialService.accountActivation(email, promoCode)
            .subscribe(function (result) {
            _this.trialService.accountStatus(email).subscribe(function (result) {
                _this.hideLoadingProgress();
                _this.trialService.trialStatusChanged.next({ trialMode: result.trial,
                    trialModeExpired: result.expired,
                    trialData: _this.trialService.bytesToSize(result.remaining) });
                _this.routeToDashboard();
            }, function (error) {
                _this.error = error;
                _this.hideLoadingProgress();
            });
        }, function (error) {
            _this.error = error;
            _this.hideLoadingProgress();
            grecaptcha.reset();
        });
    };
    TrialComponent.prototype.routeToDashboard = function () {
        this.router.navigate(['dashboard'], { relativeTo: this.route });
    };
    TrialComponent.prototype.verifyCallback = function (response) {
        this.trialParams.Captcha = response;
        this.captchaResponse = true;
    };
    TrialComponent.prototype.onloadCallback = function () {
        grecaptcha.render('create-account-captcha', {
            'sitekey': '6LeRCkgUAAAAAOs6KfbxeoCu1F4Q09D4HIvtHnPG',
            'callback': 'verifyCallback'
        });
    };
    TrialComponent.prototype.showLoadingProgress = function (value) {
        if (!this.loading.isOn) {
            this.loading.showDialog(value);
            this.loading.setShowStopTest(true);
            this.loading.setShowOkButton(false);
        }
        else {
            this.loading.updateDialog(value);
            this.loading.setShowStopTest(true);
            this.loading.setShowOkButton(false);
        }
    };
    TrialComponent.prototype.hideLoadingProgress = function () {
        this.loading.closeDialog();
    };
    TrialComponent.prototype.onAlreadyUserChange = function (event) {
        if (event.target.checked) {
            this.showAlreadyUserLogin = true;
        }
        else {
            this.showAlreadyUserLogin = false;
        }
    };
    TrialComponent.prototype.showTOS = function () {
        this.tosEntry.activate(this.viewContainerRef);
    };
    TrialComponent.prototype.getShowAlreadyUser = function () {
        if (this.showAlreadyUserLogin) {
            return 'none';
        }
        else {
            return 'flex';
        }
    };
    TrialComponent.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_2__trial_service__["a" /* TrialService */] }, { type: __WEBPACK_IMPORTED_MODULE_3__login_user_login_service__["a" /* LoginService */] }, { type: __WEBPACK_IMPORTED_MODULE_5__user_user_service__["a" /* UserService */] }, { type: __WEBPACK_IMPORTED_MODULE_6__angular_router__["a" /* Router */] }, { type: __WEBPACK_IMPORTED_MODULE_6__angular_router__["b" /* ActivatedRoute */] }, { type: __WEBPACK_IMPORTED_MODULE_7__headerfooter_setting_entries_tos_entry__["a" /* TOSEntry */] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewContainerRef"] }, { type: __WEBPACK_IMPORTED_MODULE_8__aws_environment__["a" /* AwsEnvironment */] }]; };
    return TrialComponent;
}());

//# sourceMappingURL=trial.component.js.map

/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Color; });
var Color = /** @class */ (function () {
    function Color(R, G, B) {
        this.R = R;
        this.G = G;
        this.B = B;
    }
    return Color;
}());

//# sourceMappingURL=color.js.map

/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RetryInterval */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ObservableUtils; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__);

var RetryInterval = /** @class */ (function () {
    function RetryInterval(interval, exponentialFactor, polynomialFactor) {
        if (interval === void 0) { interval = 0; }
        if (exponentialFactor === void 0) { exponentialFactor = 1; }
        if (polynomialFactor === void 0) { polynomialFactor = 0; }
        this.interval = interval;
        this.exponentialFactor = exponentialFactor;
        this.polynomialFactor = polynomialFactor;
    }
    RetryInterval.prototype.get = function (retryNumber) {
        var exponentialFactor = Math.pow(this.exponentialFactor, retryNumber);
        var polynomialFactor = Math.pow(retryNumber, this.polynomialFactor);
        var interval = this.interval * exponentialFactor * polynomialFactor;
        console.log("Retrying Observable after " + interval + "ms");
        return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].timer(interval).map(function () { return retryNumber; });
    };
    return RetryInterval;
}());

var ObservableUtils = /** @class */ (function () {
    function ObservableUtils() {
    }
    ObservableUtils.prototype.retry = function (retryable, maxRetries, interval, errorPredicate) {
        if (maxRetries === void 0) { maxRetries = Number.MAX_SAFE_INTEGER - 1; }
        if (interval === void 0) { interval = new RetryInterval(); }
        if (errorPredicate === void 0) { errorPredicate = function () { return true; }; }
        return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].defer(retryable)
            .retryWhen(function (attempts) { return attempts.zip(__WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].range(0, maxRetries + 1)).switchMap(function (_a) {
            var error = _a[0], retryNumber = _a[1];
            if (retryNumber >= maxRetries) {
                console.warn("Observable exceeded " + maxRetries + " retries");
                return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].throw(error);
            }
            if (!errorPredicate(error)) {
                return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].throw(error);
            }
            console.log('Retrying observable due to error', error);
            return interval.get(retryNumber);
        }); });
    };
    return ObservableUtils;
}());

//# sourceMappingURL=observable-utils.js.map

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(194));
__export(__webpack_require__(191));
__export(__webpack_require__(193));
__export(__webpack_require__(195));
__export(__webpack_require__(137));
__export(__webpack_require__(192));
__export(__webpack_require__(196));
//# sourceMappingURL=index.js.map

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(2);
var DataTableColumnCellDirective = (function () {
    function DataTableColumnCellDirective(template) {
        this.template = template;
    }
    return DataTableColumnCellDirective;
}());
DataTableColumnCellDirective.decorators = [
    { type: core_1.Directive, args: [{ selector: '[ngx-datatable-cell-template]' },] },
];
/** @nocollapse */
DataTableColumnCellDirective.ctorParameters = function () { return [
    { type: core_1.TemplateRef, },
]; };
exports.DataTableColumnCellDirective = DataTableColumnCellDirective;
//# sourceMappingURL=column-cell.directive.js.map

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(2);
var DataTableColumnHeaderDirective = (function () {
    function DataTableColumnHeaderDirective(template) {
        this.template = template;
    }
    return DataTableColumnHeaderDirective;
}());
DataTableColumnHeaderDirective.decorators = [
    { type: core_1.Directive, args: [{ selector: '[ngx-datatable-header-template]' },] },
];
/** @nocollapse */
DataTableColumnHeaderDirective.ctorParameters = function () { return [
    { type: core_1.TemplateRef, },
]; };
exports.DataTableColumnHeaderDirective = DataTableColumnHeaderDirective;
//# sourceMappingURL=column-header.directive.js.map

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(609));
__export(__webpack_require__(333));
__export(__webpack_require__(332));
//# sourceMappingURL=index.js.map

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(2);
var DataTableFooterTemplateDirective = (function () {
    function DataTableFooterTemplateDirective(template) {
        this.template = template;
    }
    return DataTableFooterTemplateDirective;
}());
DataTableFooterTemplateDirective.decorators = [
    { type: core_1.Directive, args: [{ selector: '[ngx-datatable-footer-template]' },] },
];
/** @nocollapse */
DataTableFooterTemplateDirective.ctorParameters = function () { return [
    { type: core_1.TemplateRef, },
]; };
exports.DataTableFooterTemplateDirective = DataTableFooterTemplateDirective;
//# sourceMappingURL=footer-template.directive.js.map

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(198));
__export(__webpack_require__(199));
__export(__webpack_require__(610));
__export(__webpack_require__(335));
//# sourceMappingURL=index.js.map

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(613));
__export(__webpack_require__(338));
//# sourceMappingURL=index.js.map

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(2);
var DatatableRowDetailTemplateDirective = (function () {
    function DatatableRowDetailTemplateDirective(template) {
        this.template = template;
    }
    return DatatableRowDetailTemplateDirective;
}());
DatatableRowDetailTemplateDirective.decorators = [
    { type: core_1.Directive, args: [{
                selector: '[ngx-datatable-row-detail-template]'
            },] },
];
/** @nocollapse */
DatatableRowDetailTemplateDirective.ctorParameters = function () { return [
    { type: core_1.TemplateRef, },
]; };
exports.DatatableRowDetailTemplateDirective = DatatableRowDetailTemplateDirective;
//# sourceMappingURL=row-detail-template.directive.js.map

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(2);
var Observable_1 = __webpack_require__(0);
__webpack_require__(167);
var LongPressDirective = (function () {
    function LongPressDirective() {
        this.pressEnabled = true;
        this.duration = 500;
        this.longPressStart = new core_1.EventEmitter();
        this.longPressing = new core_1.EventEmitter();
        this.longPressEnd = new core_1.EventEmitter();
        this.mouseX = 0;
        this.mouseY = 0;
    }
    Object.defineProperty(LongPressDirective.prototype, "press", {
        get: function () { return this.pressing; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LongPressDirective.prototype, "isLongPress", {
        get: function () {
            return this.isLongPressing;
        },
        enumerable: true,
        configurable: true
    });
    LongPressDirective.prototype.onMouseDown = function (event) {
        var _this = this;
        // don't do right/middle clicks
        if (event.which !== 1 || !this.pressEnabled)
            return;
        // don't start drag if its on resize handle
        var target = event.target;
        if (target.classList.contains('resize-handle'))
            return;
        this.mouseX = event.clientX;
        this.mouseY = event.clientY;
        this.pressing = true;
        this.isLongPressing = false;
        var mouseup = Observable_1.Observable.fromEvent(document, 'mouseup');
        this.subscription = mouseup.subscribe(function (ev) { return _this.onMouseup(); });
        this.timeout = setTimeout(function () {
            _this.isLongPressing = true;
            _this.longPressStart.emit({
                event: event,
                model: _this.pressModel
            });
            _this.subscription.add(Observable_1.Observable.fromEvent(document, 'mousemove')
                .takeUntil(mouseup)
                .subscribe(function (mouseEvent) { return _this.onMouseMove(mouseEvent); }));
            _this.loop(event);
        }, this.duration);
        this.loop(event);
    };
    LongPressDirective.prototype.onMouseMove = function (event) {
        if (this.pressing && !this.isLongPressing) {
            var xThres = Math.abs(event.clientX - this.mouseX) > 10;
            var yThres = Math.abs(event.clientY - this.mouseY) > 10;
            if (xThres || yThres) {
                this.endPress();
            }
        }
    };
    LongPressDirective.prototype.loop = function (event) {
        var _this = this;
        if (this.isLongPressing) {
            this.timeout = setTimeout(function () {
                _this.longPressing.emit({
                    event: event,
                    model: _this.pressModel
                });
                _this.loop(event);
            }, 50);
        }
    };
    LongPressDirective.prototype.endPress = function () {
        clearTimeout(this.timeout);
        this.isLongPressing = false;
        this.pressing = false;
        this._destroySubscription();
        this.longPressEnd.emit({
            model: this.pressModel
        });
    };
    LongPressDirective.prototype.onMouseup = function () {
        this.endPress();
    };
    LongPressDirective.prototype.ngOnDestroy = function () {
        this._destroySubscription();
    };
    LongPressDirective.prototype._destroySubscription = function () {
        if (this.subscription) {
            this.subscription.unsubscribe();
            this.subscription = undefined;
        }
    };
    return LongPressDirective;
}());
LongPressDirective.decorators = [
    { type: core_1.Directive, args: [{ selector: '[long-press]' },] },
];
/** @nocollapse */
LongPressDirective.ctorParameters = function () { return []; };
LongPressDirective.propDecorators = {
    'pressEnabled': [{ type: core_1.Input },],
    'pressModel': [{ type: core_1.Input },],
    'duration': [{ type: core_1.Input },],
    'longPressStart': [{ type: core_1.Output },],
    'longPressing': [{ type: core_1.Output },],
    'longPressEnd': [{ type: core_1.Output },],
    'press': [{ type: core_1.HostBinding, args: ['class.press',] },],
    'isLongPress': [{ type: core_1.HostBinding, args: ['class.longpress',] },],
    'onMouseDown': [{ type: core_1.HostListener, args: ['mousedown', ['$event'],] },],
};
exports.LongPressDirective = LongPressDirective;
//# sourceMappingURL=long-press.directive.js.map

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(2);
var draggable_directive_1 = __webpack_require__(202);
var platform_browser_1 = __webpack_require__(38);
var OrderableDirective = (function () {
    function OrderableDirective(differs, document) {
        this.document = document;
        this.reorder = new core_1.EventEmitter();
        this.differ = differs.find({}).create(null);
    }
    OrderableDirective.prototype.ngAfterContentInit = function () {
        // HACK: Investigate Better Way
        this.updateSubscriptions();
        this.draggables.changes.subscribe(this.updateSubscriptions.bind(this));
    };
    OrderableDirective.prototype.ngOnDestroy = function () {
        this.draggables.forEach(function (d) {
            d.dragStart.unsubscribe();
            d.dragEnd.unsubscribe();
        });
    };
    OrderableDirective.prototype.updateSubscriptions = function () {
        var _this = this;
        var diffs = this.differ.diff(this.createMapDiffs());
        if (diffs) {
            var subscribe = function (_a) {
                var currentValue = _a.currentValue, previousValue = _a.previousValue;
                unsubscribe_1({ previousValue: previousValue });
                if (currentValue) {
                    currentValue.dragStart.subscribe(_this.onDragStart.bind(_this));
                    currentValue.dragEnd.subscribe(_this.onDragEnd.bind(_this));
                }
            };
            var unsubscribe_1 = function (_a) {
                var previousValue = _a.previousValue;
                if (previousValue) {
                    previousValue.dragStart.unsubscribe();
                    previousValue.dragEnd.unsubscribe();
                }
            };
            diffs.forEachAddedItem(subscribe.bind(this));
            // diffs.forEachChangedItem(subscribe.bind(this));
            diffs.forEachRemovedItem(unsubscribe_1.bind(this));
        }
    };
    OrderableDirective.prototype.onDragStart = function () {
        this.positions = {};
        var i = 0;
        for (var _i = 0, _a = this.draggables.toArray(); _i < _a.length; _i++) {
            var dragger = _a[_i];
            var elm = dragger.element;
            var left = parseInt(elm.offsetLeft.toString(), 0);
            this.positions[dragger.dragModel.prop] = {
                left: left,
                right: left + parseInt(elm.offsetWidth.toString(), 0),
                index: i++,
                element: elm
            };
        }
    };
    OrderableDirective.prototype.onDragEnd = function (_a) {
        var element = _a.element, model = _a.model, event = _a.event;
        var prevPos = this.positions[model.prop];
        var target = this.isTarget(model, event);
        if (target) {
            this.reorder.emit({
                prevIndex: prevPos.index,
                newIndex: target.i,
                model: model
            });
        }
        element.style.left = 'auto';
    };
    OrderableDirective.prototype.isTarget = function (model, event) {
        var i = 0;
        var x = event.x || event.clientX;
        var y = event.y || event.clientY;
        var targets = this.document.elementsFromPoint(x, y);
        var _loop_1 = function (prop) {
            // current column position which throws event.
            var pos = this_1.positions[prop];
            // since we drag the inner span, we need to find it in the elements at the cursor
            if (model.prop !== prop && targets.find(function (el) { return el === pos.element; })) {
                return { value: {
                        pos: pos,
                        i: i
                    } };
            }
            i++;
        };
        var this_1 = this;
        for (var prop in this.positions) {
            var state_1 = _loop_1(prop);
            if (typeof state_1 === "object")
                return state_1.value;
        }
    };
    OrderableDirective.prototype.createMapDiffs = function () {
        return this.draggables.toArray()
            .reduce(function (acc, curr) {
            acc[curr.dragModel.$$id] = curr;
            return acc;
        }, {});
    };
    return OrderableDirective;
}());
OrderableDirective.decorators = [
    { type: core_1.Directive, args: [{ selector: '[orderable]' },] },
];
/** @nocollapse */
OrderableDirective.ctorParameters = function () { return [
    { type: core_1.KeyValueDiffers, },
    { type: undefined, decorators: [{ type: core_1.Inject, args: [platform_browser_1.DOCUMENT,] },] },
]; };
OrderableDirective.propDecorators = {
    'reorder': [{ type: core_1.Output },],
    'draggables': [{ type: core_1.ContentChildren, args: [draggable_directive_1.DraggableDirective, { descendants: true },] },],
};
exports.OrderableDirective = OrderableDirective;
//# sourceMappingURL=orderable.directive.js.map

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(2);
var Observable_1 = __webpack_require__(0);
__webpack_require__(167);
var ResizeableDirective = (function () {
    function ResizeableDirective(element) {
        this.resizeEnabled = true;
        this.resize = new core_1.EventEmitter();
        this.resizing = false;
        this.element = element.nativeElement;
    }
    ResizeableDirective.prototype.ngAfterViewInit = function () {
        if (this.resizeEnabled) {
            var node = document.createElement('span');
            node.classList.add('resize-handle');
            this.element.appendChild(node);
        }
    };
    ResizeableDirective.prototype.ngOnDestroy = function () {
        this._destroySubscription();
    };
    ResizeableDirective.prototype.onMouseup = function () {
        this.resizing = false;
        if (this.subscription && !this.subscription.closed) {
            this._destroySubscription();
            this.resize.emit(this.element.clientWidth);
        }
    };
    ResizeableDirective.prototype.onMousedown = function (event) {
        var _this = this;
        var isHandle = (event.target).classList.contains('resize-handle');
        var initialWidth = this.element.clientWidth;
        var mouseDownScreenX = event.screenX;
        if (isHandle) {
            event.stopPropagation();
            this.resizing = true;
            var mouseup = Observable_1.Observable.fromEvent(document, 'mouseup');
            this.subscription = mouseup
                .subscribe(function (ev) { return _this.onMouseup(); });
            var mouseMoveSub = Observable_1.Observable.fromEvent(document, 'mousemove')
                .takeUntil(mouseup)
                .subscribe(function (e) { return _this.move(e, initialWidth, mouseDownScreenX); });
            this.subscription.add(mouseMoveSub);
        }
    };
    ResizeableDirective.prototype.move = function (event, initialWidth, mouseDownScreenX) {
        var movementX = event.screenX - mouseDownScreenX;
        var newWidth = initialWidth + movementX;
        var overMinWidth = !this.minWidth || newWidth >= this.minWidth;
        var underMaxWidth = !this.maxWidth || newWidth <= this.maxWidth;
        if (overMinWidth && underMaxWidth) {
            this.element.style.width = newWidth + "px";
        }
    };
    ResizeableDirective.prototype._destroySubscription = function () {
        if (this.subscription) {
            this.subscription.unsubscribe();
            this.subscription = undefined;
        }
    };
    return ResizeableDirective;
}());
ResizeableDirective.decorators = [
    { type: core_1.Directive, args: [{
                selector: '[resizeable]',
                host: {
                    '[class.resizeable]': 'resizeEnabled'
                }
            },] },
];
/** @nocollapse */
ResizeableDirective.ctorParameters = function () { return [
    { type: core_1.ElementRef, },
]; };
ResizeableDirective.propDecorators = {
    'resizeEnabled': [{ type: core_1.Input },],
    'minWidth': [{ type: core_1.Input },],
    'maxWidth': [{ type: core_1.Input },],
    'resize': [{ type: core_1.Output },],
    'onMousedown': [{ type: core_1.HostListener, args: ['mousedown', ['$event'],] },],
};
exports.ResizeableDirective = ResizeableDirective;
//# sourceMappingURL=resizeable.directive.js.map

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(2);
/**
 * Visibility Observer Directive
 *
 * Usage:
 *
 * 		<div
 * 			visibilityObserver
 * 			(visible)="onVisible($event)">
 * 		</div>
 *
 */
var VisibilityDirective = (function () {
    function VisibilityDirective(element, zone) {
        this.element = element;
        this.zone = zone;
        this.isVisible = false;
        this.visible = new core_1.EventEmitter();
    }
    VisibilityDirective.prototype.ngOnInit = function () {
        this.runCheck();
    };
    VisibilityDirective.prototype.ngOnDestroy = function () {
        clearTimeout(this.timeout);
    };
    VisibilityDirective.prototype.onVisibilityChange = function () {
        var _this = this;
        // trigger zone recalc for columns
        this.zone.run(function () {
            _this.isVisible = true;
            _this.visible.emit(true);
        });
    };
    VisibilityDirective.prototype.runCheck = function () {
        var _this = this;
        var check = function () {
            // https://davidwalsh.name/offsetheight-visibility
            var _a = _this.element.nativeElement, offsetHeight = _a.offsetHeight, offsetWidth = _a.offsetWidth;
            if (offsetHeight && offsetWidth) {
                clearTimeout(_this.timeout);
                _this.onVisibilityChange();
            }
            else {
                clearTimeout(_this.timeout);
                _this.zone.runOutsideAngular(function () {
                    _this.timeout = setTimeout(function () { return check(); }, 50);
                });
            }
        };
        setTimeout(function () { return check(); });
    };
    return VisibilityDirective;
}());
VisibilityDirective.decorators = [
    { type: core_1.Directive, args: [{ selector: '[visibilityObserver]' },] },
];
/** @nocollapse */
VisibilityDirective.ctorParameters = function () { return [
    { type: core_1.ElementRef, },
    { type: core_1.NgZone, },
]; };
VisibilityDirective.propDecorators = {
    'isVisible': [{ type: core_1.HostBinding, args: ['class.visible',] },],
    'visible': [{ type: core_1.Output },],
};
exports.VisibilityDirective = VisibilityDirective;
//# sourceMappingURL=visibility.directive.js.map

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Returns the columns by pin.
 * @param {array} cols
 */
function columnsByPin(cols) {
    var ret = {
        left: [],
        center: [],
        right: []
    };
    if (cols) {
        for (var _i = 0, cols_1 = cols; _i < cols_1.length; _i++) {
            var col = cols_1[_i];
            if (col.frozenLeft) {
                ret.left.push(col);
            }
            else if (col.frozenRight) {
                ret.right.push(col);
            }
            else {
                ret.center.push(col);
            }
        }
    }
    return ret;
}
exports.columnsByPin = columnsByPin;
/**
 * Returns the widths of all group sets of a column
 * @param {object} groups
 * @param {array} all
 */
function columnGroupWidths(groups, all) {
    return {
        left: columnTotalWidth(groups.left),
        center: columnTotalWidth(groups.center),
        right: columnTotalWidth(groups.right),
        total: columnTotalWidth(all)
    };
}
exports.columnGroupWidths = columnGroupWidths;
/**
 * Calculates the total width of all columns and their groups
 * @param {array} columns
 * @param {string} prop width to get
 */
function columnTotalWidth(columns, prop) {
    var totalWidth = 0;
    if (columns) {
        for (var _i = 0, columns_1 = columns; _i < columns_1.length; _i++) {
            var c = columns_1[_i];
            var has = prop && c[prop];
            var width = has ? c[prop] : c.width;
            totalWidth = totalWidth + parseFloat(width);
        }
    }
    return totalWidth;
}
exports.columnTotalWidth = columnTotalWidth;
/**
 * Calculates the total width of all columns and their groups
 * @param {array} columns
 * @param {string} property width to get
 */
function columnsTotalWidth(columns, prop) {
    var totalWidth = 0;
    for (var _i = 0, columns_2 = columns; _i < columns_2.length; _i++) {
        var column = columns_2[_i];
        var has = prop && column[prop];
        totalWidth = totalWidth + (has ? column[prop] : column.width);
    }
    return totalWidth;
}
exports.columnsTotalWidth = columnsTotalWidth;
function columnsByPinArr(val) {
    var colsByPinArr = [];
    var colsByPin = columnsByPin(val);
    colsByPinArr.push({ type: 'left', columns: colsByPin['left'] });
    colsByPinArr.push({ type: 'center', columns: colsByPin['center'] });
    colsByPinArr.push({ type: 'right', columns: colsByPin['right'] });
    return colsByPinArr;
}
exports.columnsByPinArr = columnsByPinArr;
//# sourceMappingURL=column.js.map

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Creates a unique object id.
 * http://stackoverflow.com/questions/6248666/how-to-generate-short-uid-like-ax4j9z-in-js
 */
function id() {
    return ('0000' + (Math.random() * Math.pow(36, 4) << 0).toString(36)).slice(-4);
}
exports.id = id;
//# sourceMappingURL=id.js.map

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var camel_case_1 = __webpack_require__(138);
var cache = {};
var testStyle = document !== undefined ? document.createElement('div').style : undefined;
// Get Prefix
// http://davidwalsh.name/vendor-prefix
var prefix = (function () {
    var styles = window !== undefined ? window.getComputedStyle(document.documentElement, '') : undefined;
    var pre = styles !== undefined ? (Array.prototype.slice.call(styles).join('').match(/-(moz|webkit|ms)-/))[1] : undefined;
    var dom = pre !== undefined ? ('WebKit|Moz|MS|O').match(new RegExp('(' + pre + ')', 'i'))[1] : undefined;
    return dom ? {
        dom: dom,
        lowercase: pre,
        css: "-" + pre + "-",
        js: pre[0].toUpperCase() + pre.substr(1)
    } : undefined;
})();
function getVendorPrefixedName(property) {
    var name = camel_case_1.camelCase(property);
    if (!cache[name]) {
        if (prefix !== undefined && testStyle[prefix.css + property] !== undefined) {
            cache[name] = prefix.css + property;
        }
        else if (testStyle[property] !== undefined) {
            cache[name] = property;
        }
    }
    return cache[name];
}
exports.getVendorPrefixedName = getVendorPrefixedName;
//# sourceMappingURL=prefixes.js.map

/***/ }),
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return slice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return map; });
var array = Array.prototype;

var slice = array.slice;
var map = array.map;


/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export bisectRight */
/* unused harmony export bisectLeft */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ascending__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bisector__ = __webpack_require__(378);



var ascendingBisect = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__bisector__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__ascending__["a" /* default */]);
var bisectRight = ascendingBisect.right;
var bisectLeft = ascendingBisect.left;
/* harmony default export */ __webpack_exports__["a"] = (bisectRight);


/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ascending__ = __webpack_require__(105);


/* harmony default export */ __webpack_exports__["a"] = (function(compare) {
  if (compare.length === 1) compare = ascendingComparator(compare);
  return {
    left: function(a, x, lo, hi) {
      if (lo == null) lo = 0;
      if (hi == null) hi = a.length;
      while (lo < hi) {
        var mid = lo + hi >>> 1;
        if (compare(a[mid], x) < 0) lo = mid + 1;
        else hi = mid;
      }
      return lo;
    },
    right: function(a, x, lo, hi) {
      if (lo == null) lo = 0;
      if (hi == null) hi = a.length;
      while (lo < hi) {
        var mid = lo + hi >>> 1;
        if (compare(a[mid], x) > 0) hi = mid;
        else lo = mid + 1;
      }
      return lo;
    }
  };
});

function ascendingComparator(f) {
  return function(d, x) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__ascending__["a" /* default */])(f(d), x);
  };
}


/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__variance__ = __webpack_require__(387);


/* harmony default export */ __webpack_exports__["a"] = (function(array, f) {
  var v = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__variance__["a" /* default */])(array, f);
  return v ? Math.sqrt(v) : v;
});


/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      min,
      max;

  if (valueof == null) {
    while (++i < n) { // Find the first comparable value.
      if ((value = values[i]) != null && value >= value) {
        min = max = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = values[i]) != null) {
            if (min > value) min = value;
            if (max < value) max = value;
          }
        }
      }
    }
  }

  else {
    while (++i < n) { // Find the first comparable value.
      if ((value = valueof(values[i], i, values)) != null && value >= value) {
        min = max = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = valueof(values[i], i, values)) != null) {
            if (min > value) min = value;
            if (max < value) max = value;
          }
        }
      }
    }
  }

  return [min, max];
});


/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      min;

  if (valueof == null) {
    while (++i < n) { // Find the first comparable value.
      if ((value = values[i]) != null && value >= value) {
        min = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = values[i]) != null && min > value) {
            min = value;
          }
        }
      }
    }
  }

  else {
    while (++i < n) { // Find the first comparable value.
      if ((value = valueof(values[i], i, values)) != null && value >= value) {
        min = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = valueof(values[i], i, values)) != null && min > value) {
            min = value;
          }
        }
      }
    }
  }

  return min;
});


/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = pair;
/* unused harmony default export */ var _unused_webpack_default_export = (function(array, f) {
  if (f == null) f = pair;
  var i = 0, n = array.length - 1, p = array[0], pairs = new Array(n < 0 ? 0 : n);
  while (i < n) pairs[i] = f(p, p = array[++i]);
  return pairs;
});

function pair(a, b) {
  return [a, b];
}


/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(start, stop, step) {
  start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;

  var i = -1,
      n = Math.max(0, Math.ceil((stop - start) / step)) | 0,
      range = new Array(n);

  while (++i < n) {
    range[i] = start + i * step;
  }

  return range;
});


/***/ }),
/* 384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(values) {
  return Math.ceil(Math.log(values.length) / Math.LN2) + 1;
});


/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = tickIncrement;
/* harmony export (immutable) */ __webpack_exports__["c"] = tickStep;
var e10 = Math.sqrt(50),
    e5 = Math.sqrt(10),
    e2 = Math.sqrt(2);

/* harmony default export */ __webpack_exports__["a"] = (function(start, stop, count) {
  var reverse,
      i = -1,
      n,
      ticks,
      step;

  stop = +stop, start = +start, count = +count;
  if (start === stop && count > 0) return [start];
  if (reverse = stop < start) n = start, start = stop, stop = n;
  if ((step = tickIncrement(start, stop, count)) === 0 || !isFinite(step)) return [];

  if (step > 0) {
    start = Math.ceil(start / step);
    stop = Math.floor(stop / step);
    ticks = new Array(n = Math.ceil(stop - start + 1));
    while (++i < n) ticks[i] = (start + i) * step;
  } else {
    start = Math.floor(start * step);
    stop = Math.ceil(stop * step);
    ticks = new Array(n = Math.ceil(start - stop + 1));
    while (++i < n) ticks[i] = (start - i) / step;
  }

  if (reverse) ticks.reverse();

  return ticks;
});

function tickIncrement(start, stop, count) {
  var step = (stop - start) / Math.max(0, count),
      power = Math.floor(Math.log(step) / Math.LN10),
      error = step / Math.pow(10, power);
  return power >= 0
      ? (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1) * Math.pow(10, power)
      : -Math.pow(10, -power) / (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1);
}

function tickStep(start, stop, count) {
  var step0 = Math.abs(stop - start) / Math.max(0, count),
      step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)),
      error = step0 / step1;
  if (error >= e10) step1 *= 10;
  else if (error >= e5) step1 *= 5;
  else if (error >= e2) step1 *= 2;
  return stop < start ? -step1 : step1;
}


/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__min__ = __webpack_require__(381);


/* harmony default export */ __webpack_exports__["a"] = (function(matrix) {
  if (!(n = matrix.length)) return [];
  for (var i = -1, m = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__min__["a" /* default */])(matrix, length), transpose = new Array(m); ++i < m;) {
    for (var j = -1, n, row = transpose[i] = new Array(n); ++j < n;) {
      row[j] = matrix[j][i];
    }
  }
  return transpose;
});

function length(d) {
  return d.length;
}


/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(113);


/* harmony default export */ __webpack_exports__["a"] = (function(values, valueof) {
  var n = values.length,
      m = 0,
      i = -1,
      mean = 0,
      value,
      delta,
      sum = 0;

  if (valueof == null) {
    while (++i < n) {
      if (!isNaN(value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(values[i]))) {
        delta = value - mean;
        mean += delta / ++m;
        sum += delta * (value - mean);
      }
    }
  }

  else {
    while (++i < n) {
      if (!isNaN(value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(valueof(values[i], i, values)))) {
        delta = value - mean;
        mean += delta / ++m;
        sum += delta * (value - mean);
      }
    }
  }

  if (m > 1) return sum / (m - 1);
});


/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return cos; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return sin; });
/* unused harmony export pi */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return halfPi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return tau; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return max; });
var cos = Math.cos;
var sin = Math.sin;
var pi = Math.PI;
var halfPi = pi / 2;
var tau = pi * 2;
var max = Math.max;


/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return deg2rad; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return rad2deg; });
var deg2rad = Math.PI / 180;
var rad2deg = 180 / Math.PI;


/***/ }),
/* 390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = yesdrag;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_selection__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__noevent__ = __webpack_require__(391);



/* harmony default export */ __webpack_exports__["a"] = (function(view) {
  var root = view.document.documentElement,
      selection = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_selection__["a" /* select */])(view).on("dragstart.drag", __WEBPACK_IMPORTED_MODULE_1__noevent__["a" /* default */], true);
  if ("onselectstart" in root) {
    selection.on("selectstart.drag", __WEBPACK_IMPORTED_MODULE_1__noevent__["a" /* default */], true);
  } else {
    root.__noselect = root.style.MozUserSelect;
    root.style.MozUserSelect = "none";
  }
});

function yesdrag(view, noclick) {
  var root = view.document.documentElement,
      selection = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_selection__["a" /* select */])(view).on("dragstart.drag", null);
  if (noclick) {
    selection.on("click.drag", __WEBPACK_IMPORTED_MODULE_1__noevent__["a" /* default */], true);
    setTimeout(function() { selection.on("click.drag", null); }, 0);
  }
  if ("onselectstart" in root) {
    selection.on("selectstart.drag", null);
  } else {
    root.style.MozUserSelect = root.__noselect;
    delete root.__noselect;
  }
}


/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = nopropagation;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_selection__ = __webpack_require__(21);


function nopropagation() {
  __WEBPACK_IMPORTED_MODULE_0_d3_selection__["b" /* event */].stopImmediatePropagation();
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  __WEBPACK_IMPORTED_MODULE_0_d3_selection__["b" /* event */].preventDefault();
  __WEBPACK_IMPORTED_MODULE_0_d3_selection__["b" /* event */].stopImmediatePropagation();
});


/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_linear__ = __webpack_require__(850);
/* unused harmony reexport easeLinear */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_quad__ = __webpack_require__(852);
/* unused harmony reexport easeQuad */
/* unused harmony reexport easeQuadIn */
/* unused harmony reexport easeQuadOut */
/* unused harmony reexport easeQuadInOut */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_cubic__ = __webpack_require__(847);
/* unused harmony reexport easeCubic */
/* unused harmony reexport easeCubicIn */
/* unused harmony reexport easeCubicOut */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__src_cubic__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_poly__ = __webpack_require__(851);
/* unused harmony reexport easePoly */
/* unused harmony reexport easePolyIn */
/* unused harmony reexport easePolyOut */
/* unused harmony reexport easePolyInOut */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_sin__ = __webpack_require__(853);
/* unused harmony reexport easeSin */
/* unused harmony reexport easeSinIn */
/* unused harmony reexport easeSinOut */
/* unused harmony reexport easeSinInOut */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_exp__ = __webpack_require__(849);
/* unused harmony reexport easeExp */
/* unused harmony reexport easeExpIn */
/* unused harmony reexport easeExpOut */
/* unused harmony reexport easeExpInOut */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_circle__ = __webpack_require__(846);
/* unused harmony reexport easeCircle */
/* unused harmony reexport easeCircleIn */
/* unused harmony reexport easeCircleOut */
/* unused harmony reexport easeCircleInOut */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_bounce__ = __webpack_require__(845);
/* unused harmony reexport easeBounce */
/* unused harmony reexport easeBounceIn */
/* unused harmony reexport easeBounceOut */
/* unused harmony reexport easeBounceInOut */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_back__ = __webpack_require__(844);
/* unused harmony reexport easeBack */
/* unused harmony reexport easeBackIn */
/* unused harmony reexport easeBackOut */
/* unused harmony reexport easeBackInOut */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_elastic__ = __webpack_require__(848);
/* unused harmony reexport easeElastic */
/* unused harmony reexport easeElasticIn */
/* unused harmony reexport easeElasticOut */
/* unused harmony reexport easeElasticInOut */





















/***/ }),
/* 393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = x;
/* harmony export (immutable) */ __webpack_exports__["b"] = y;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_dispatch__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_collection__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_timer__ = __webpack_require__(163);




function x(d) {
  return d.x;
}

function y(d) {
  return d.y;
}

var initialRadius = 10,
    initialAngle = Math.PI * (3 - Math.sqrt(5));

/* unused harmony default export */ var _unused_webpack_default_export = (function(nodes) {
  var simulation,
      alpha = 1,
      alphaMin = 0.001,
      alphaDecay = 1 - Math.pow(alphaMin, 1 / 300),
      alphaTarget = 0,
      velocityDecay = 0.6,
      forces = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_collection__["a" /* map */])(),
      stepper = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_d3_timer__["a" /* timer */])(step),
      event = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_dispatch__["a" /* dispatch */])("tick", "end");

  if (nodes == null) nodes = [];

  function step() {
    tick();
    event.call("tick", simulation);
    if (alpha < alphaMin) {
      stepper.stop();
      event.call("end", simulation);
    }
  }

  function tick() {
    var i, n = nodes.length, node;

    alpha += (alphaTarget - alpha) * alphaDecay;

    forces.each(function(force) {
      force(alpha);
    });

    for (i = 0; i < n; ++i) {
      node = nodes[i];
      if (node.fx == null) node.x += node.vx *= velocityDecay;
      else node.x = node.fx, node.vx = 0;
      if (node.fy == null) node.y += node.vy *= velocityDecay;
      else node.y = node.fy, node.vy = 0;
    }
  }

  function initializeNodes() {
    for (var i = 0, n = nodes.length, node; i < n; ++i) {
      node = nodes[i], node.index = i;
      if (isNaN(node.x) || isNaN(node.y)) {
        var radius = initialRadius * Math.sqrt(i), angle = i * initialAngle;
        node.x = radius * Math.cos(angle);
        node.y = radius * Math.sin(angle);
      }
      if (isNaN(node.vx) || isNaN(node.vy)) {
        node.vx = node.vy = 0;
      }
    }
  }

  function initializeForce(force) {
    if (force.initialize) force.initialize(nodes);
    return force;
  }

  initializeNodes();

  return simulation = {
    tick: tick,

    restart: function() {
      return stepper.restart(step), simulation;
    },

    stop: function() {
      return stepper.stop(), simulation;
    },

    nodes: function(_) {
      return arguments.length ? (nodes = _, initializeNodes(), forces.each(initializeForce), simulation) : nodes;
    },

    alpha: function(_) {
      return arguments.length ? (alpha = +_, simulation) : alpha;
    },

    alphaMin: function(_) {
      return arguments.length ? (alphaMin = +_, simulation) : alphaMin;
    },

    alphaDecay: function(_) {
      return arguments.length ? (alphaDecay = +_, simulation) : +alphaDecay;
    },

    alphaTarget: function(_) {
      return arguments.length ? (alphaTarget = +_, simulation) : alphaTarget;
    },

    velocityDecay: function(_) {
      return arguments.length ? (velocityDecay = 1 - _, simulation) : 1 - velocityDecay;
    },

    force: function(name, _) {
      return arguments.length > 1 ? ((_ == null ? forces.remove(name) : forces.set(name, initializeForce(_))), simulation) : forces.get(name);
    },

    find: function(x, y, radius) {
      var i = 0,
          n = nodes.length,
          dx,
          dy,
          d2,
          node,
          closest;

      if (radius == null) radius = Infinity;
      else radius *= radius;

      for (i = 0; i < n; ++i) {
        node = nodes[i];
        dx = x - node.x;
        dy = y - node.y;
        d2 = dx * dx + dy * dy;
        if (d2 < radius) closest = node, radius = d2;
      }

      return closest;
    },

    on: function(name, _) {
      return arguments.length > 1 ? (event.on(name, _), simulation) : event.on(name);
    }
  };
});


/***/ }),
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return prefixExponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formatDecimal__ = __webpack_require__(238);


var prefixExponent;

/* harmony default export */ __webpack_exports__["a"] = (function(x, p) {
  var d = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__formatDecimal__["a" /* default */])(x, p);
  if (!d) return x + "";
  var coefficient = d[0],
      exponent = d[1],
      i = exponent - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1,
      n = coefficient.length;
  return i === n ? coefficient
      : i > n ? coefficient + new Array(i - n + 1).join("0")
      : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i)
      : "0." + new Array(1 - i).join("0") + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__formatDecimal__["a" /* default */])(x, Math.max(0, p + i - 1))[0]; // less than 1y!
});


/***/ }),
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = formatSpecifier;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formatTypes__ = __webpack_require__(396);


// [[fill]align][sign][symbol][0][width][,][.precision][type]
var re = /^(?:(.)?([<>=^]))?([+\-\( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?([a-z%])?$/i;

function formatSpecifier(specifier) {
  return new FormatSpecifier(specifier);
}

formatSpecifier.prototype = FormatSpecifier.prototype; // instanceof

function FormatSpecifier(specifier) {
  if (!(match = re.exec(specifier))) throw new Error("invalid format: " + specifier);

  var match,
      fill = match[1] || " ",
      align = match[2] || ">",
      sign = match[3] || "-",
      symbol = match[4] || "",
      zero = !!match[5],
      width = match[6] && +match[6],
      comma = !!match[7],
      precision = match[8] && +match[8].slice(1),
      type = match[9] || "";

  // The "n" type is an alias for ",g".
  if (type === "n") comma = true, type = "g";

  // Map invalid types to the default format.
  else if (!__WEBPACK_IMPORTED_MODULE_0__formatTypes__["a" /* default */][type]) type = "";

  // If zero fill is specified, padding goes after sign and before digits.
  if (zero || (fill === "0" && align === "=")) zero = true, fill = "0", align = "=";

  this.fill = fill;
  this.align = align;
  this.sign = sign;
  this.symbol = symbol;
  this.zero = zero;
  this.width = width;
  this.comma = comma;
  this.precision = precision;
  this.type = type;
}

FormatSpecifier.prototype.toString = function() {
  return this.fill
      + this.align
      + this.sign
      + this.symbol
      + (this.zero ? "0" : "")
      + (this.width == null ? "" : Math.max(1, this.width | 0))
      + (this.comma ? "," : "")
      + (this.precision == null ? "" : "." + Math.max(0, this.precision | 0))
      + this.type;
};


/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formatDefault__ = __webpack_require__(863);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__formatPrefixAuto__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__formatRounded__ = __webpack_require__(866);




/* harmony default export */ __webpack_exports__["a"] = ({
  "": __WEBPACK_IMPORTED_MODULE_0__formatDefault__["a" /* default */],
  "%": function(x, p) { return (x * 100).toFixed(p); },
  "b": function(x) { return Math.round(x).toString(2); },
  "c": function(x) { return x + ""; },
  "d": function(x) { return Math.round(x).toString(10); },
  "e": function(x, p) { return x.toExponential(p); },
  "f": function(x, p) { return x.toFixed(p); },
  "g": function(x, p) { return x.toPrecision(p); },
  "o": function(x) { return Math.round(x).toString(8); },
  "p": function(x, p) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__formatRounded__["a" /* default */])(x * 100, p); },
  "r": __WEBPACK_IMPORTED_MODULE_2__formatRounded__["a" /* default */],
  "s": __WEBPACK_IMPORTED_MODULE_1__formatPrefixAuto__["a" /* default */],
  "X": function(x) { return Math.round(x).toString(16).toUpperCase(); },
  "x": function(x) { return Math.round(x).toString(16); }
});


/***/ }),
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exponent__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__formatGroup__ = __webpack_require__(864);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__formatNumerals__ = __webpack_require__(865);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__formatSpecifier__ = __webpack_require__(395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__formatTypes__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__formatPrefixAuto__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__identity__ = __webpack_require__(867);








var prefixes = ["y","z","a","f","p","n","µ","m","","k","M","G","T","P","E","Z","Y"];

/* harmony default export */ __webpack_exports__["a"] = (function(locale) {
  var group = locale.grouping && locale.thousands ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__formatGroup__["a" /* default */])(locale.grouping, locale.thousands) : __WEBPACK_IMPORTED_MODULE_6__identity__["a" /* default */],
      currency = locale.currency,
      decimal = locale.decimal,
      numerals = locale.numerals ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__formatNumerals__["a" /* default */])(locale.numerals) : __WEBPACK_IMPORTED_MODULE_6__identity__["a" /* default */],
      percent = locale.percent || "%";

  function newFormat(specifier) {
    specifier = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__formatSpecifier__["a" /* default */])(specifier);

    var fill = specifier.fill,
        align = specifier.align,
        sign = specifier.sign,
        symbol = specifier.symbol,
        zero = specifier.zero,
        width = specifier.width,
        comma = specifier.comma,
        precision = specifier.precision,
        type = specifier.type;

    // Compute the prefix and suffix.
    // For SI-prefix, the suffix is lazily computed.
    var prefix = symbol === "$" ? currency[0] : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "",
        suffix = symbol === "$" ? currency[1] : /[%p]/.test(type) ? percent : "";

    // What format function should we use?
    // Is this an integer type?
    // Can this type generate exponential notation?
    var formatType = __WEBPACK_IMPORTED_MODULE_4__formatTypes__["a" /* default */][type],
        maybeSuffix = !type || /[defgprs%]/.test(type);

    // Set the default precision if not specified,
    // or clamp the specified precision to the supported range.
    // For significant precision, it must be in [1, 21].
    // For fixed precision, it must be in [0, 20].
    precision = precision == null ? (type ? 6 : 12)
        : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision))
        : Math.max(0, Math.min(20, precision));

    function format(value) {
      var valuePrefix = prefix,
          valueSuffix = suffix,
          i, n, c;

      if (type === "c") {
        valueSuffix = formatType(value) + valueSuffix;
        value = "";
      } else {
        value = +value;

        // Perform the initial formatting.
        var valueNegative = value < 0;
        value = formatType(Math.abs(value), precision);

        // If a negative value rounds to zero during formatting, treat as positive.
        if (valueNegative && +value === 0) valueNegative = false;

        // Compute the prefix and suffix.
        valuePrefix = (valueNegative ? (sign === "(" ? sign : "-") : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
        valueSuffix = valueSuffix + (type === "s" ? prefixes[8 + __WEBPACK_IMPORTED_MODULE_5__formatPrefixAuto__["b" /* prefixExponent */] / 3] : "") + (valueNegative && sign === "(" ? ")" : "");

        // Break the formatted value into the integer “value” part that can be
        // grouped, and fractional or exponential “suffix” part that is not.
        if (maybeSuffix) {
          i = -1, n = value.length;
          while (++i < n) {
            if (c = value.charCodeAt(i), 48 > c || c > 57) {
              valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
              value = value.slice(0, i);
              break;
            }
          }
        }
      }

      // If the fill character is not "0", grouping is applied before padding.
      if (comma && !zero) value = group(value, Infinity);

      // Compute the padding.
      var length = valuePrefix.length + value.length + valueSuffix.length,
          padding = length < width ? new Array(width - length + 1).join(fill) : "";

      // If the fill character is "0", grouping is applied after padding.
      if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";

      // Reconstruct the final output based on the desired alignment.
      switch (align) {
        case "<": value = valuePrefix + value + valueSuffix + padding; break;
        case "=": value = valuePrefix + padding + value + valueSuffix; break;
        case "^": value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length); break;
        default: value = padding + valuePrefix + value + valueSuffix; break;
      }

      return numerals(value);
    }

    format.toString = function() {
      return specifier + "";
    };

    return format;
  }

  function formatPrefix(specifier, value) {
    var f = newFormat((specifier = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__formatSpecifier__["a" /* default */])(specifier), specifier.type = "f", specifier)),
        e = Math.max(-8, Math.min(8, Math.floor(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__exponent__["a" /* default */])(value) / 3))) * 3,
        k = Math.pow(10, -e),
        prefix = prefixes[8 + e / 3];
    return function(value) {
      return f(k * value) + prefix;
    };
  }

  return {
    format: newFormat,
    formatPrefix: formatPrefix
  };
});


/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return areaRingSum; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return areaStream; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__adder__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__noop__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__stream__ = __webpack_require__(88);





var areaRingSum = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__adder__["a" /* default */])();

var areaSum = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__adder__["a" /* default */])(),
    lambda00,
    phi00,
    lambda0,
    cosPhi0,
    sinPhi0;

var areaStream = {
  point: __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */],
  lineStart: __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */],
  lineEnd: __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */],
  polygonStart: function() {
    areaRingSum.reset();
    areaStream.lineStart = areaRingStart;
    areaStream.lineEnd = areaRingEnd;
  },
  polygonEnd: function() {
    var areaRing = +areaRingSum;
    areaSum.add(areaRing < 0 ? __WEBPACK_IMPORTED_MODULE_1__math__["b" /* tau */] + areaRing : areaRing);
    this.lineStart = this.lineEnd = this.point = __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */];
  },
  sphere: function() {
    areaSum.add(__WEBPACK_IMPORTED_MODULE_1__math__["b" /* tau */]);
  }
};

function areaRingStart() {
  areaStream.point = areaPointFirst;
}

function areaRingEnd() {
  areaPoint(lambda00, phi00);
}

function areaPointFirst(lambda, phi) {
  areaStream.point = areaPoint;
  lambda00 = lambda, phi00 = phi;
  lambda *= __WEBPACK_IMPORTED_MODULE_1__math__["g" /* radians */], phi *= __WEBPACK_IMPORTED_MODULE_1__math__["g" /* radians */];
  lambda0 = lambda, cosPhi0 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["c" /* cos */])(phi = phi / 2 + __WEBPACK_IMPORTED_MODULE_1__math__["q" /* quarterPi */]), sinPhi0 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["d" /* sin */])(phi);
}

function areaPoint(lambda, phi) {
  lambda *= __WEBPACK_IMPORTED_MODULE_1__math__["g" /* radians */], phi *= __WEBPACK_IMPORTED_MODULE_1__math__["g" /* radians */];
  phi = phi / 2 + __WEBPACK_IMPORTED_MODULE_1__math__["q" /* quarterPi */]; // half the angular distance from south pole

  // Spherical excess E for a spherical triangle with vertices: south pole,
  // previous point, current point.  Uses a formula derived from Cagnoli’s
  // theorem.  See Todhunter, Spherical Trig. (1871), Sec. 103, Eq. (2).
  var dLambda = lambda - lambda0,
      sdLambda = dLambda >= 0 ? 1 : -1,
      adLambda = sdLambda * dLambda,
      cosPhi = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["c" /* cos */])(phi),
      sinPhi = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["d" /* sin */])(phi),
      k = sinPhi0 * sinPhi,
      u = cosPhi0 * cosPhi + k * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["c" /* cos */])(adLambda),
      v = k * sdLambda * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["d" /* sin */])(adLambda);
  areaRingSum.add(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["e" /* atan2 */])(v, u));

  // Advance the previous points.
  lambda0 = lambda, cosPhi0 = cosPhi, sinPhi0 = sinPhi;
}

/* unused harmony default export */ var _unused_webpack_default_export = (function(object) {
  areaSum.reset();
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__stream__["a" /* default */])(object, areaStream);
  return areaSum * 2;
});


/***/ }),
/* 399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = circleStream;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cartesian__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constant__ = __webpack_require__(876);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__rotation__ = __webpack_require__(151);





// Generates a circle centered at [0°, 0°], with a given radius and precision.
function circleStream(stream, radius, delta, direction, t0, t1) {
  if (!delta) return;
  var cosRadius = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["c" /* cos */])(radius),
      sinRadius = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* sin */])(radius),
      step = direction * delta;
  if (t0 == null) {
    t0 = radius + direction * __WEBPACK_IMPORTED_MODULE_2__math__["b" /* tau */];
    t1 = radius - step / 2;
  } else {
    t0 = circleRadius(cosRadius, t0);
    t1 = circleRadius(cosRadius, t1);
    if (direction > 0 ? t0 < t1 : t0 > t1) t0 += direction * __WEBPACK_IMPORTED_MODULE_2__math__["b" /* tau */];
  }
  for (var point, t = t0; direction > 0 ? t > t1 : t < t1; t -= step) {
    point = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cartesian__["f" /* spherical */])([cosRadius, -sinRadius * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["c" /* cos */])(t), -sinRadius * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* sin */])(t)]);
    stream.point(point[0], point[1]);
  }
}

// Returns the signed angle of a cartesian point relative to [cosRadius, 0, 0].
function circleRadius(cosRadius, point) {
  point = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cartesian__["a" /* cartesian */])(point), point[0] -= cosRadius;
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cartesian__["g" /* cartesianNormalizeInPlace */])(point);
  var radius = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["r" /* acos */])(-point[1]);
  return ((-point[2] < 0 ? -radius : radius) + __WEBPACK_IMPORTED_MODULE_2__math__["b" /* tau */] - __WEBPACK_IMPORTED_MODULE_2__math__["p" /* epsilon */]) % __WEBPACK_IMPORTED_MODULE_2__math__["b" /* tau */];
}

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var center = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])([0, 0]),
      radius = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(90),
      precision = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(6),
      ring,
      rotate,
      stream = {point: point};

  function point(x, y) {
    ring.push(x = rotate(x, y));
    x[0] *= __WEBPACK_IMPORTED_MODULE_2__math__["h" /* degrees */], x[1] *= __WEBPACK_IMPORTED_MODULE_2__math__["h" /* degrees */];
  }

  function circle() {
    var c = center.apply(this, arguments),
        r = radius.apply(this, arguments) * __WEBPACK_IMPORTED_MODULE_2__math__["g" /* radians */],
        p = precision.apply(this, arguments) * __WEBPACK_IMPORTED_MODULE_2__math__["g" /* radians */];
    ring = [];
    rotate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__rotation__["b" /* rotateRadians */])(-c[0] * __WEBPACK_IMPORTED_MODULE_2__math__["g" /* radians */], -c[1] * __WEBPACK_IMPORTED_MODULE_2__math__["g" /* radians */], 0).invert;
    circleStream(stream, r, p, 1);
    c = {type: "Polygon", coordinates: [ring]};
    ring = rotate = null;
    return c;
  }

  circle.center = function(_) {
    return arguments.length ? (center = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])([+_[0], +_[1]]), circle) : center;
  };

  circle.radius = function(_) {
    return arguments.length ? (radius = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), circle) : radius;
  };

  circle.precision = function(_) {
    return arguments.length ? (precision = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), circle) : precision;
  };

  return circle;
});


/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(5);



/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__index__["a" /* default */])(
  function() { return true; },
  clipAntimeridianLine,
  clipAntimeridianInterpolate,
  [-__WEBPACK_IMPORTED_MODULE_1__math__["a" /* pi */], -__WEBPACK_IMPORTED_MODULE_1__math__["k" /* halfPi */]]
));

// Takes a line and cuts into visible segments. Return values: 0 - there were
// intersections or the line was empty; 1 - no intersections; 2 - there were
// intersections, and the first and last segments should be rejoined.
function clipAntimeridianLine(stream) {
  var lambda0 = NaN,
      phi0 = NaN,
      sign0 = NaN,
      clean; // no intersections

  return {
    lineStart: function() {
      stream.lineStart();
      clean = 1;
    },
    point: function(lambda1, phi1) {
      var sign1 = lambda1 > 0 ? __WEBPACK_IMPORTED_MODULE_1__math__["a" /* pi */] : -__WEBPACK_IMPORTED_MODULE_1__math__["a" /* pi */],
          delta = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["o" /* abs */])(lambda1 - lambda0);
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["o" /* abs */])(delta - __WEBPACK_IMPORTED_MODULE_1__math__["a" /* pi */]) < __WEBPACK_IMPORTED_MODULE_1__math__["p" /* epsilon */]) { // line crosses a pole
        stream.point(lambda0, phi0 = (phi0 + phi1) / 2 > 0 ? __WEBPACK_IMPORTED_MODULE_1__math__["k" /* halfPi */] : -__WEBPACK_IMPORTED_MODULE_1__math__["k" /* halfPi */]);
        stream.point(sign0, phi0);
        stream.lineEnd();
        stream.lineStart();
        stream.point(sign1, phi0);
        stream.point(lambda1, phi0);
        clean = 0;
      } else if (sign0 !== sign1 && delta >= __WEBPACK_IMPORTED_MODULE_1__math__["a" /* pi */]) { // line crosses antimeridian
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["o" /* abs */])(lambda0 - sign0) < __WEBPACK_IMPORTED_MODULE_1__math__["p" /* epsilon */]) lambda0 -= sign0 * __WEBPACK_IMPORTED_MODULE_1__math__["p" /* epsilon */]; // handle degeneracies
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["o" /* abs */])(lambda1 - sign1) < __WEBPACK_IMPORTED_MODULE_1__math__["p" /* epsilon */]) lambda1 -= sign1 * __WEBPACK_IMPORTED_MODULE_1__math__["p" /* epsilon */];
        phi0 = clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1);
        stream.point(sign0, phi0);
        stream.lineEnd();
        stream.lineStart();
        stream.point(sign1, phi0);
        clean = 0;
      }
      stream.point(lambda0 = lambda1, phi0 = phi1);
      sign0 = sign1;
    },
    lineEnd: function() {
      stream.lineEnd();
      lambda0 = phi0 = NaN;
    },
    clean: function() {
      return 2 - clean; // if intersections, rejoin first and last segments
    }
  };
}

function clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1) {
  var cosPhi0,
      cosPhi1,
      sinLambda0Lambda1 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["d" /* sin */])(lambda0 - lambda1);
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["o" /* abs */])(sinLambda0Lambda1) > __WEBPACK_IMPORTED_MODULE_1__math__["p" /* epsilon */]
      ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["l" /* atan */])((__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["d" /* sin */])(phi0) * (cosPhi1 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["c" /* cos */])(phi1)) * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["d" /* sin */])(lambda1)
          - __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["d" /* sin */])(phi1) * (cosPhi0 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["c" /* cos */])(phi0)) * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["d" /* sin */])(lambda0))
          / (cosPhi0 * cosPhi1 * sinLambda0Lambda1))
      : (phi0 + phi1) / 2;
}

function clipAntimeridianInterpolate(from, to, direction, stream) {
  var phi;
  if (from == null) {
    phi = direction * __WEBPACK_IMPORTED_MODULE_1__math__["k" /* halfPi */];
    stream.point(-__WEBPACK_IMPORTED_MODULE_1__math__["a" /* pi */], phi);
    stream.point(0, phi);
    stream.point(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* pi */], phi);
    stream.point(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* pi */], 0);
    stream.point(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* pi */], -phi);
    stream.point(0, -phi);
    stream.point(-__WEBPACK_IMPORTED_MODULE_1__math__["a" /* pi */], -phi);
    stream.point(-__WEBPACK_IMPORTED_MODULE_1__math__["a" /* pi */], 0);
    stream.point(-__WEBPACK_IMPORTED_MODULE_1__math__["a" /* pi */], phi);
  } else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["o" /* abs */])(from[0] - to[0]) > __WEBPACK_IMPORTED_MODULE_1__math__["p" /* epsilon */]) {
    var lambda = from[0] < to[0] ? __WEBPACK_IMPORTED_MODULE_1__math__["a" /* pi */] : -__WEBPACK_IMPORTED_MODULE_1__math__["a" /* pi */];
    phi = direction * lambda / 2;
    stream.point(-lambda, phi);
    stream.point(0, phi);
    stream.point(lambda, phi);
  } else {
    stream.point(to[0], to[1]);
  }
}


/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__noop__ = __webpack_require__(73);


/* harmony default export */ __webpack_exports__["a"] = (function() {
  var lines = [],
      line;
  return {
    point: function(x, y) {
      line.push([x, y]);
    },
    lineStart: function() {
      lines.push(line = []);
    },
    lineEnd: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
    rejoin: function() {
      if (lines.length > 1) lines.push(lines.pop().concat(lines.shift()));
    },
    result: function() {
      var result = lines;
      lines = [];
      line = null;
      return result;
    }
  };
});


/***/ }),
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cartesian__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__circle__ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pointEqual__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__index__ = __webpack_require__(403);






/* harmony default export */ __webpack_exports__["a"] = (function(radius) {
  var cr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["c" /* cos */])(radius),
      delta = 6 * __WEBPACK_IMPORTED_MODULE_2__math__["g" /* radians */],
      smallRadius = cr > 0,
      notHemisphere = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["o" /* abs */])(cr) > __WEBPACK_IMPORTED_MODULE_2__math__["p" /* epsilon */]; // TODO optimise for this common case

  function interpolate(from, to, direction, stream) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__circle__["a" /* circleStream */])(stream, radius, delta, direction, from, to);
  }

  function visible(lambda, phi) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["c" /* cos */])(lambda) * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["c" /* cos */])(phi) > cr;
  }

  // Takes a line and cuts into visible segments. Return values used for polygon
  // clipping: 0 - there were intersections or the line was empty; 1 - no
  // intersections 2 - there were intersections, and the first and last segments
  // should be rejoined.
  function clipLine(stream) {
    var point0, // previous point
        c0, // code for previous point
        v0, // visibility of previous point
        v00, // visibility of first point
        clean; // no intersections
    return {
      lineStart: function() {
        v00 = v0 = false;
        clean = 1;
      },
      point: function(lambda, phi) {
        var point1 = [lambda, phi],
            point2,
            v = visible(lambda, phi),
            c = smallRadius
              ? v ? 0 : code(lambda, phi)
              : v ? code(lambda + (lambda < 0 ? __WEBPACK_IMPORTED_MODULE_2__math__["a" /* pi */] : -__WEBPACK_IMPORTED_MODULE_2__math__["a" /* pi */]), phi) : 0;
        if (!point0 && (v00 = v0 = v)) stream.lineStart();
        // Handle degeneracies.
        // TODO ignore if not clipping polygons.
        if (v !== v0) {
          point2 = intersect(point0, point1);
          if (!point2 || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__pointEqual__["a" /* default */])(point0, point2) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__pointEqual__["a" /* default */])(point1, point2)) {
            point1[0] += __WEBPACK_IMPORTED_MODULE_2__math__["p" /* epsilon */];
            point1[1] += __WEBPACK_IMPORTED_MODULE_2__math__["p" /* epsilon */];
            v = visible(point1[0], point1[1]);
          }
        }
        if (v !== v0) {
          clean = 0;
          if (v) {
            // outside going in
            stream.lineStart();
            point2 = intersect(point1, point0);
            stream.point(point2[0], point2[1]);
          } else {
            // inside going out
            point2 = intersect(point0, point1);
            stream.point(point2[0], point2[1]);
            stream.lineEnd();
          }
          point0 = point2;
        } else if (notHemisphere && point0 && smallRadius ^ v) {
          var t;
          // If the codes for two points are different, or are both zero,
          // and there this segment intersects with the small circle.
          if (!(c & c0) && (t = intersect(point1, point0, true))) {
            clean = 0;
            if (smallRadius) {
              stream.lineStart();
              stream.point(t[0][0], t[0][1]);
              stream.point(t[1][0], t[1][1]);
              stream.lineEnd();
            } else {
              stream.point(t[1][0], t[1][1]);
              stream.lineEnd();
              stream.lineStart();
              stream.point(t[0][0], t[0][1]);
            }
          }
        }
        if (v && (!point0 || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__pointEqual__["a" /* default */])(point0, point1))) {
          stream.point(point1[0], point1[1]);
        }
        point0 = point1, v0 = v, c0 = c;
      },
      lineEnd: function() {
        if (v0) stream.lineEnd();
        point0 = null;
      },
      // Rejoin first and last segments if there were intersections and the first
      // and last points were visible.
      clean: function() {
        return clean | ((v00 && v0) << 1);
      }
    };
  }

  // Intersects the great circle between a and b with the clip circle.
  function intersect(a, b, two) {
    var pa = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cartesian__["a" /* cartesian */])(a),
        pb = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cartesian__["a" /* cartesian */])(b);

    // We have two planes, n1.p = d1 and n2.p = d2.
    // Find intersection line p(t) = c1 n1 + c2 n2 + t (n1 ⨯ n2).
    var n1 = [1, 0, 0], // normal
        n2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cartesian__["b" /* cartesianCross */])(pa, pb),
        n2n2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cartesian__["c" /* cartesianDot */])(n2, n2),
        n1n2 = n2[0], // cartesianDot(n1, n2),
        determinant = n2n2 - n1n2 * n1n2;

    // Two polar points.
    if (!determinant) return !two && a;

    var c1 =  cr * n2n2 / determinant,
        c2 = -cr * n1n2 / determinant,
        n1xn2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cartesian__["b" /* cartesianCross */])(n1, n2),
        A = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cartesian__["d" /* cartesianScale */])(n1, c1),
        B = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cartesian__["d" /* cartesianScale */])(n2, c2);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cartesian__["e" /* cartesianAddInPlace */])(A, B);

    // Solve |p(t)|^2 = 1.
    var u = n1xn2,
        w = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cartesian__["c" /* cartesianDot */])(A, u),
        uu = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cartesian__["c" /* cartesianDot */])(u, u),
        t2 = w * w - uu * (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cartesian__["c" /* cartesianDot */])(A, A) - 1);

    if (t2 < 0) return;

    var t = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["n" /* sqrt */])(t2),
        q = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cartesian__["d" /* cartesianScale */])(u, (-w - t) / uu);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cartesian__["e" /* cartesianAddInPlace */])(q, A);
    q = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cartesian__["f" /* spherical */])(q);

    if (!two) return q;

    // Two intersection points.
    var lambda0 = a[0],
        lambda1 = b[0],
        phi0 = a[1],
        phi1 = b[1],
        z;

    if (lambda1 < lambda0) z = lambda0, lambda0 = lambda1, lambda1 = z;

    var delta = lambda1 - lambda0,
        polar = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["o" /* abs */])(delta - __WEBPACK_IMPORTED_MODULE_2__math__["a" /* pi */]) < __WEBPACK_IMPORTED_MODULE_2__math__["p" /* epsilon */],
        meridian = polar || delta < __WEBPACK_IMPORTED_MODULE_2__math__["p" /* epsilon */];

    if (!polar && phi1 < phi0) z = phi0, phi0 = phi1, phi1 = z;

    // Check that the first point is between a and b.
    if (meridian
        ? polar
          ? phi0 + phi1 > 0 ^ q[1] < (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["o" /* abs */])(q[0] - lambda0) < __WEBPACK_IMPORTED_MODULE_2__math__["p" /* epsilon */] ? phi0 : phi1)
          : phi0 <= q[1] && q[1] <= phi1
        : delta > __WEBPACK_IMPORTED_MODULE_2__math__["a" /* pi */] ^ (lambda0 <= q[0] && q[0] <= lambda1)) {
      var q1 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cartesian__["d" /* cartesianScale */])(u, (-w + t) / uu);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cartesian__["e" /* cartesianAddInPlace */])(q1, A);
      return [q, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cartesian__["f" /* spherical */])(q1)];
    }
  }

  // Generates a 4-bit vector representing the location of a point relative to
  // the small circle's bounding box.
  function code(lambda, phi) {
    var r = smallRadius ? radius : __WEBPACK_IMPORTED_MODULE_2__math__["a" /* pi */] - radius,
        code = 0;
    if (lambda < -r) code |= 1; // left
    else if (lambda > r) code |= 2; // right
    if (phi < -r) code |= 4; // below
    else if (phi > r) code |= 8; // above
    return code;
  }

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__index__["a" /* default */])(visible, clipLine, interpolate, smallRadius ? [0, -radius] : [-__WEBPACK_IMPORTED_MODULE_2__math__["a" /* pi */], radius - __WEBPACK_IMPORTED_MODULE_2__math__["a" /* pi */]]);
});


/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__buffer__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rejoin__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__polygonContains__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_d3_array__ = __webpack_require__(29);






/* harmony default export */ __webpack_exports__["a"] = (function(pointVisible, clipLine, interpolate, start) {
  return function(sink) {
    var line = clipLine(sink),
        ringBuffer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__buffer__["a" /* default */])(),
        ringSink = clipLine(ringBuffer),
        polygonStarted = false,
        polygon,
        segments,
        ring;

    var clip = {
      point: point,
      lineStart: lineStart,
      lineEnd: lineEnd,
      polygonStart: function() {
        clip.point = pointRing;
        clip.lineStart = ringStart;
        clip.lineEnd = ringEnd;
        segments = [];
        polygon = [];
      },
      polygonEnd: function() {
        clip.point = point;
        clip.lineStart = lineStart;
        clip.lineEnd = lineEnd;
        segments = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_d3_array__["i" /* merge */])(segments);
        var startInside = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__polygonContains__["a" /* default */])(polygon, start);
        if (segments.length) {
          if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__rejoin__["a" /* default */])(segments, compareIntersection, startInside, interpolate, sink);
        } else if (startInside) {
          if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
          sink.lineStart();
          interpolate(null, null, 1, sink);
          sink.lineEnd();
        }
        if (polygonStarted) sink.polygonEnd(), polygonStarted = false;
        segments = polygon = null;
      },
      sphere: function() {
        sink.polygonStart();
        sink.lineStart();
        interpolate(null, null, 1, sink);
        sink.lineEnd();
        sink.polygonEnd();
      }
    };

    function point(lambda, phi) {
      if (pointVisible(lambda, phi)) sink.point(lambda, phi);
    }

    function pointLine(lambda, phi) {
      line.point(lambda, phi);
    }

    function lineStart() {
      clip.point = pointLine;
      line.lineStart();
    }

    function lineEnd() {
      clip.point = point;
      line.lineEnd();
    }

    function pointRing(lambda, phi) {
      ring.push([lambda, phi]);
      ringSink.point(lambda, phi);
    }

    function ringStart() {
      ringSink.lineStart();
      ring = [];
    }

    function ringEnd() {
      pointRing(ring[0][0], ring[0][1]);
      ringSink.lineEnd();

      var clean = ringSink.clean(),
          ringSegments = ringBuffer.result(),
          i, n = ringSegments.length, m,
          segment,
          point;

      ring.pop();
      polygon.push(ring);
      ring = null;

      if (!n) return;

      // No intersections.
      if (clean & 1) {
        segment = ringSegments[0];
        if ((m = segment.length - 1) > 0) {
          if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
          sink.lineStart();
          for (i = 0; i < m; ++i) sink.point((point = segment[i])[0], point[1]);
          sink.lineEnd();
        }
        return;
      }

      // Rejoin connected segments.
      // TODO reuse ringBuffer.rejoin()?
      if (n > 1 && clean & 2) ringSegments.push(ringSegments.pop().concat(ringSegments.shift()));

      segments.push(ringSegments.filter(validSegment));
    }

    return clip;
  };
});

function validSegment(segment) {
  return segment.length > 1;
}

// Intersections are sorted along the clip edge. For both antimeridian cutting
// and circle clipping, the same comparison is used.
function compareIntersection(a, b) {
  return ((a = a.x)[0] < 0 ? a[1] - __WEBPACK_IMPORTED_MODULE_2__math__["k" /* halfPi */] - __WEBPACK_IMPORTED_MODULE_2__math__["p" /* epsilon */] : __WEBPACK_IMPORTED_MODULE_2__math__["k" /* halfPi */] - a[1])
       - ((b = b.x)[0] < 0 ? b[1] - __WEBPACK_IMPORTED_MODULE_2__math__["k" /* halfPi */] - __WEBPACK_IMPORTED_MODULE_2__math__["p" /* epsilon */] : __WEBPACK_IMPORTED_MODULE_2__math__["k" /* halfPi */] - b[1]);
}


/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pointEqual__ = __webpack_require__(409);


function Intersection(point, points, other, entry) {
  this.x = point;
  this.z = points;
  this.o = other; // another intersection
  this.e = entry; // is an entry?
  this.v = false; // visited
  this.n = this.p = null; // next & previous
}

// A generalized polygon clipping algorithm: given a polygon that has been cut
// into its visible line segments, and rejoins the segments by interpolating
// along the clip edge.
/* harmony default export */ __webpack_exports__["a"] = (function(segments, compareIntersection, startInside, interpolate, stream) {
  var subject = [],
      clip = [],
      i,
      n;

  segments.forEach(function(segment) {
    if ((n = segment.length - 1) <= 0) return;
    var n, p0 = segment[0], p1 = segment[n], x;

    // If the first and last points of a segment are coincident, then treat as a
    // closed ring. TODO if all rings are closed, then the winding order of the
    // exterior ring should be checked.
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__pointEqual__["a" /* default */])(p0, p1)) {
      stream.lineStart();
      for (i = 0; i < n; ++i) stream.point((p0 = segment[i])[0], p0[1]);
      stream.lineEnd();
      return;
    }

    subject.push(x = new Intersection(p0, segment, null, true));
    clip.push(x.o = new Intersection(p0, null, x, false));
    subject.push(x = new Intersection(p1, segment, null, false));
    clip.push(x.o = new Intersection(p1, null, x, true));
  });

  if (!subject.length) return;

  clip.sort(compareIntersection);
  link(subject);
  link(clip);

  for (i = 0, n = clip.length; i < n; ++i) {
    clip[i].e = startInside = !startInside;
  }

  var start = subject[0],
      points,
      point;

  while (1) {
    // Find first unvisited intersection.
    var current = start,
        isSubject = true;
    while (current.v) if ((current = current.n) === start) return;
    points = current.z;
    stream.lineStart();
    do {
      current.v = current.o.v = true;
      if (current.e) {
        if (isSubject) {
          for (i = 0, n = points.length; i < n; ++i) stream.point((point = points[i])[0], point[1]);
        } else {
          interpolate(current.x, current.n.x, 1, stream);
        }
        current = current.n;
      } else {
        if (isSubject) {
          points = current.p.z;
          for (i = points.length - 1; i >= 0; --i) stream.point((point = points[i])[0], point[1]);
        } else {
          interpolate(current.x, current.p.x, -1, stream);
        }
        current = current.p;
      }
      current = current.o;
      points = current.z;
      isSubject = !isSubject;
    } while (!current.v);
    stream.lineEnd();
  }
});

function link(array) {
  if (!(n = array.length)) return;
  var n,
      i = 0,
      a = array[0],
      b;
  while (++i < n) {
    a.n = b = array[i];
    b.p = a;
    a = b;
  }
  a.n = b = array[0];
  b.p = a;
}


/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {

  function compose(x, y) {
    return x = a(x, y), b(x[0], x[1]);
  }

  if (a.invert && b.invert) compose.invert = function(x, y) {
    return x = b.invert(x, y), x && a.invert(x[0], x[1]);
  };

  return compose;
});


/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__length__ = __webpack_require__(407);


var coordinates = [null, null],
    object = {type: "LineString", coordinates: coordinates};

/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  coordinates[0] = a;
  coordinates[1] = b;
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__length__["a" /* default */])(object);
});


/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__adder__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__noop__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__stream__ = __webpack_require__(88);





var lengthSum = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__adder__["a" /* default */])(),
    lambda0,
    sinPhi0,
    cosPhi0;

var lengthStream = {
  sphere: __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */],
  point: __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */],
  lineStart: lengthLineStart,
  lineEnd: __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */],
  polygonStart: __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */],
  polygonEnd: __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */]
};

function lengthLineStart() {
  lengthStream.point = lengthPointFirst;
  lengthStream.lineEnd = lengthLineEnd;
}

function lengthLineEnd() {
  lengthStream.point = lengthStream.lineEnd = __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */];
}

function lengthPointFirst(lambda, phi) {
  lambda *= __WEBPACK_IMPORTED_MODULE_1__math__["g" /* radians */], phi *= __WEBPACK_IMPORTED_MODULE_1__math__["g" /* radians */];
  lambda0 = lambda, sinPhi0 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["d" /* sin */])(phi), cosPhi0 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["c" /* cos */])(phi);
  lengthStream.point = lengthPoint;
}

function lengthPoint(lambda, phi) {
  lambda *= __WEBPACK_IMPORTED_MODULE_1__math__["g" /* radians */], phi *= __WEBPACK_IMPORTED_MODULE_1__math__["g" /* radians */];
  var sinPhi = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["d" /* sin */])(phi),
      cosPhi = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["c" /* cos */])(phi),
      delta = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["o" /* abs */])(lambda - lambda0),
      cosDelta = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["c" /* cos */])(delta),
      sinDelta = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["d" /* sin */])(delta),
      x = cosPhi * sinDelta,
      y = cosPhi0 * sinPhi - sinPhi0 * cosPhi * cosDelta,
      z = sinPhi0 * sinPhi + cosPhi0 * cosPhi * cosDelta;
  lengthSum.add(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["e" /* atan2 */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["n" /* sqrt */])(x * x + y * y), z));
  lambda0 = lambda, sinPhi0 = sinPhi, cosPhi0 = cosPhi;
}

/* harmony default export */ __webpack_exports__["a"] = (function(object) {
  lengthSum.reset();
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__stream__["a" /* default */])(object, lengthStream);
  return +lengthSum;
});


/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__noop__ = __webpack_require__(73);


var x0 = Infinity,
    y0 = x0,
    x1 = -x0,
    y1 = x1;

var boundsStream = {
  point: boundsPoint,
  lineStart: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  lineEnd: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  polygonStart: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  polygonEnd: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  result: function() {
    var bounds = [[x0, y0], [x1, y1]];
    x1 = y1 = -(y0 = x0 = Infinity);
    return bounds;
  }
};

function boundsPoint(x, y) {
  if (x < x0) x0 = x;
  if (x > x1) x1 = x;
  if (y < y0) y0 = y;
  if (y > y1) y1 = y;
}

/* harmony default export */ __webpack_exports__["a"] = (boundsStream);


/***/ }),
/* 409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(5);


/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["o" /* abs */])(a[0] - b[0]) < __WEBPACK_IMPORTED_MODULE_0__math__["p" /* epsilon */] && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["o" /* abs */])(a[1] - b[1]) < __WEBPACK_IMPORTED_MODULE_0__math__["p" /* epsilon */];
});


/***/ }),
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__adder__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cartesian__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(5);




var sum = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__adder__["a" /* default */])();

/* harmony default export */ __webpack_exports__["a"] = (function(polygon, point) {
  var lambda = point[0],
      phi = point[1],
      normal = [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* sin */])(lambda), -__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["c" /* cos */])(lambda), 0],
      angle = 0,
      winding = 0;

  sum.reset();

  for (var i = 0, n = polygon.length; i < n; ++i) {
    if (!(m = (ring = polygon[i]).length)) continue;
    var ring,
        m,
        point0 = ring[m - 1],
        lambda0 = point0[0],
        phi0 = point0[1] / 2 + __WEBPACK_IMPORTED_MODULE_2__math__["q" /* quarterPi */],
        sinPhi0 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* sin */])(phi0),
        cosPhi0 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["c" /* cos */])(phi0);

    for (var j = 0; j < m; ++j, lambda0 = lambda1, sinPhi0 = sinPhi1, cosPhi0 = cosPhi1, point0 = point1) {
      var point1 = ring[j],
          lambda1 = point1[0],
          phi1 = point1[1] / 2 + __WEBPACK_IMPORTED_MODULE_2__math__["q" /* quarterPi */],
          sinPhi1 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* sin */])(phi1),
          cosPhi1 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["c" /* cos */])(phi1),
          delta = lambda1 - lambda0,
          sign = delta >= 0 ? 1 : -1,
          absDelta = sign * delta,
          antimeridian = absDelta > __WEBPACK_IMPORTED_MODULE_2__math__["a" /* pi */],
          k = sinPhi0 * sinPhi1;

      sum.add(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["e" /* atan2 */])(k * sign * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* sin */])(absDelta), cosPhi0 * cosPhi1 + k * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["c" /* cos */])(absDelta)));
      angle += antimeridian ? delta + sign * __WEBPACK_IMPORTED_MODULE_2__math__["b" /* tau */] : delta;

      // Are the longitudes either side of the point’s meridian (lambda),
      // and are the latitudes smaller than the parallel (phi)?
      if (antimeridian ^ lambda0 >= lambda ^ lambda1 >= lambda) {
        var arc = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__cartesian__["b" /* cartesianCross */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__cartesian__["a" /* cartesian */])(point0), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__cartesian__["a" /* cartesian */])(point1));
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__cartesian__["g" /* cartesianNormalizeInPlace */])(arc);
        var intersection = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__cartesian__["b" /* cartesianCross */])(normal, arc);
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__cartesian__["g" /* cartesianNormalizeInPlace */])(intersection);
        var phiArc = (antimeridian ^ delta >= 0 ? -1 : 1) * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["f" /* asin */])(intersection[2]);
        if (phi > phiArc || phi === phiArc && (arc[0] || arc[1])) {
          winding += antimeridian ^ delta >= 0 ? 1 : -1;
        }
      }
    }
  }

  // First, determine whether the South pole is inside or outside:
  //
  // It is inside if:
  // * the polygon winds around it in a clockwise direction.
  // * the polygon does not (cumulatively) wind around it, but has a negative
  //   (counter-clockwise) area.
  //
  // Second, count the (signed) number of times a segment crosses a lambda
  // from the point to the South pole.  If it is zero, then the point is the
  // same side as the South pole.

  return (angle < -__WEBPACK_IMPORTED_MODULE_2__math__["p" /* epsilon */] || angle < __WEBPACK_IMPORTED_MODULE_2__math__["p" /* epsilon */] && sum < -__WEBPACK_IMPORTED_MODULE_2__math__["p" /* epsilon */]) ^ (winding & 1);
});


/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__conicEqualArea__ = __webpack_require__(241);


/* harmony default export */ __webpack_exports__["a"] = (function() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__conicEqualArea__["a" /* default */])()
      .parallels([29.5, 45.5])
      .scale(1070)
      .translate([480, 250])
      .rotate([96, 0])
      .center([-0.6, 38.7]);
});


/***/ }),
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = equirectangularRaw;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(51);


function equirectangularRaw(lambda, phi) {
  return [lambda, phi];
}

equirectangularRaw.invert = equirectangularRaw;

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__index__["a" /* default */])(equirectangularRaw)
      .scale(152.63);
});


/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = constantZero;
function constantZero() {
  return 0;
}

/* harmony default export */ __webpack_exports__["b"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(900);


/* harmony default export */ __webpack_exports__["a"] = (function(circles) {
  var i = 0, n = (circles = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__array__["a" /* shuffle */])(__WEBPACK_IMPORTED_MODULE_0__array__["b" /* slice */].call(circles))).length, B = [], p, e;

  while (i < n) {
    p = circles[i];
    if (e && enclosesWeak(e, p)) ++i;
    else e = encloseBasis(B = extendBasis(B, p)), i = 0;
  }

  return e;
});

function extendBasis(B, p) {
  var i, j;

  if (enclosesWeakAll(p, B)) return [p];

  // If we get here then B must have at least one element.
  for (i = 0; i < B.length; ++i) {
    if (enclosesNot(p, B[i])
        && enclosesWeakAll(encloseBasis2(B[i], p), B)) {
      return [B[i], p];
    }
  }

  // If we get here then B must have at least two elements.
  for (i = 0; i < B.length - 1; ++i) {
    for (j = i + 1; j < B.length; ++j) {
      if (enclosesNot(encloseBasis2(B[i], B[j]), p)
          && enclosesNot(encloseBasis2(B[i], p), B[j])
          && enclosesNot(encloseBasis2(B[j], p), B[i])
          && enclosesWeakAll(encloseBasis3(B[i], B[j], p), B)) {
        return [B[i], B[j], p];
      }
    }
  }

  // If we get here then something is very wrong.
  throw new Error;
}

function enclosesNot(a, b) {
  var dr = a.r - b.r, dx = b.x - a.x, dy = b.y - a.y;
  return dr < 0 || dr * dr < dx * dx + dy * dy;
}

function enclosesWeak(a, b) {
  var dr = a.r - b.r + 1e-6, dx = b.x - a.x, dy = b.y - a.y;
  return dr > 0 && dr * dr > dx * dx + dy * dy;
}

function enclosesWeakAll(a, B) {
  for (var i = 0; i < B.length; ++i) {
    if (!enclosesWeak(a, B[i])) {
      return false;
    }
  }
  return true;
}

function encloseBasis(B) {
  switch (B.length) {
    case 1: return encloseBasis1(B[0]);
    case 2: return encloseBasis2(B[0], B[1]);
    case 3: return encloseBasis3(B[0], B[1], B[2]);
  }
}

function encloseBasis1(a) {
  return {
    x: a.x,
    y: a.y,
    r: a.r
  };
}

function encloseBasis2(a, b) {
  var x1 = a.x, y1 = a.y, r1 = a.r,
      x2 = b.x, y2 = b.y, r2 = b.r,
      x21 = x2 - x1, y21 = y2 - y1, r21 = r2 - r1,
      l = Math.sqrt(x21 * x21 + y21 * y21);
  return {
    x: (x1 + x2 + x21 / l * r21) / 2,
    y: (y1 + y2 + y21 / l * r21) / 2,
    r: (l + r1 + r2) / 2
  };
}

function encloseBasis3(a, b, c) {
  var x1 = a.x, y1 = a.y, r1 = a.r,
      x2 = b.x, y2 = b.y, r2 = b.r,
      x3 = c.x, y3 = c.y, r3 = c.r,
      a2 = x1 - x2,
      a3 = x1 - x3,
      b2 = y1 - y2,
      b3 = y1 - y3,
      c2 = r2 - r1,
      c3 = r3 - r1,
      d1 = x1 * x1 + y1 * y1 - r1 * r1,
      d2 = d1 - x2 * x2 - y2 * y2 + r2 * r2,
      d3 = d1 - x3 * x3 - y3 * y3 + r3 * r3,
      ab = a3 * b2 - a2 * b3,
      xa = (b2 * d3 - b3 * d2) / (ab * 2) - x1,
      xb = (b3 * c2 - b2 * c3) / ab,
      ya = (a3 * d2 - a2 * d3) / (ab * 2) - y1,
      yb = (a2 * c3 - a3 * c2) / ab,
      A = xb * xb + yb * yb - 1,
      B = 2 * (r1 + xa * xb + ya * yb),
      C = xa * xa + ya * ya - r1 * r1,
      r = -(A ? (B + Math.sqrt(B * B - 4 * A * C)) / (2 * A) : C / B);
  return {
    x: x1 + xa + xb * r,
    y: y1 + ya + yb * r,
    r: r
  };
}


/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = packEnclose;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__enclose__ = __webpack_require__(414);


function place(a, b, c) {
  var ax = a.x,
      ay = a.y,
      da = b.r + c.r,
      db = a.r + c.r,
      dx = b.x - ax,
      dy = b.y - ay,
      dc = dx * dx + dy * dy;
  if (dc) {
    var x = 0.5 + ((db *= db) - (da *= da)) / (2 * dc),
        y = Math.sqrt(Math.max(0, 2 * da * (db + dc) - (db -= dc) * db - da * da)) / (2 * dc);
    c.x = ax + x * dx + y * dy;
    c.y = ay + x * dy - y * dx;
  } else {
    c.x = ax + db;
    c.y = ay;
  }
}

function intersects(a, b) {
  var dx = b.x - a.x,
      dy = b.y - a.y,
      dr = a.r + b.r;
  return dr * dr - 1e-6 > dx * dx + dy * dy;
}

function score(node) {
  var a = node._,
      b = node.next._,
      ab = a.r + b.r,
      dx = (a.x * b.r + b.x * a.r) / ab,
      dy = (a.y * b.r + b.y * a.r) / ab;
  return dx * dx + dy * dy;
}

function Node(circle) {
  this._ = circle;
  this.next = null;
  this.previous = null;
}

function packEnclose(circles) {
  if (!(n = circles.length)) return 0;

  var a, b, c, n, aa, ca, i, j, k, sj, sk;

  // Place the first circle.
  a = circles[0], a.x = 0, a.y = 0;
  if (!(n > 1)) return a.r;

  // Place the second circle.
  b = circles[1], a.x = -b.r, b.x = a.r, b.y = 0;
  if (!(n > 2)) return a.r + b.r;

  // Place the third circle.
  place(b, a, c = circles[2]);

  // Initialize the front-chain using the first three circles a, b and c.
  a = new Node(a), b = new Node(b), c = new Node(c);
  a.next = c.previous = b;
  b.next = a.previous = c;
  c.next = b.previous = a;

  // Attempt to place each remaining circle…
  pack: for (i = 3; i < n; ++i) {
    place(a._, b._, c = circles[i]), c = new Node(c);

    // Find the closest intersecting circle on the front-chain, if any.
    // “Closeness” is determined by linear distance along the front-chain.
    // “Ahead” or “behind” is likewise determined by linear distance.
    j = b.next, k = a.previous, sj = b._.r, sk = a._.r;
    do {
      if (sj <= sk) {
        if (intersects(j._, c._)) {
          b = j, a.next = b, b.previous = a, --i;
          continue pack;
        }
        sj += j._.r, j = j.next;
      } else {
        if (intersects(k._, c._)) {
          a = k, a.next = b, b.previous = a, --i;
          continue pack;
        }
        sk += k._.r, k = k.previous;
      }
    } while (j !== k.next);

    // Success! Insert the new circle c between a and b.
    c.previous = a, c.next = b, a.next = b.previous = b = c;

    // Compute the new closest circle pair to the centroid.
    aa = score(a);
    while ((c = c.next) !== b) {
      if ((ca = score(c)) < aa) {
        a = c, aa = ca;
      }
    }
    b = a.next;
  }

  // Compute the enclosing circle of the front chain.
  a = [b._], c = b; while ((c = c.next) !== b) a.push(c._); c = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__enclose__["a" /* default */])(a);

  // Translate the circles to put the enclosing circle around the origin.
  for (i = 0; i < n; ++i) a = circles[i], a.x -= c.x, a.y -= c.y;

  return c.r;
}

/* unused harmony default export */ var _unused_webpack_default_export = (function(circles) {
  packEnclose(circles);
  return circles;
});


/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(node) {
  node.x0 = Math.round(node.x0);
  node.y0 = Math.round(node.y0);
  node.x1 = Math.round(node.x1);
  node.y1 = Math.round(node.y1);
});


/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__value__ = __webpack_require__(248);


/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var nb = b ? b.length : 0,
      na = a ? Math.min(nb, a.length) : 0,
      x = new Array(na),
      c = new Array(nb),
      i;

  for (i = 0; i < na; ++i) x[i] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__value__["a" /* default */])(a[i], b[i]);
  for (; i < nb; ++i) c[i] = b[i];

  return function(t) {
    for (i = 0; i < na; ++i) c[i] = x[i](t);
    return c;
  };
});


/***/ }),
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__basis__ = __webpack_require__(247);


/* harmony default export */ __webpack_exports__["a"] = (function(values) {
  var n = values.length;
  return function(t) {
    var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n),
        v0 = values[(i + n - 1) % n],
        v1 = values[i % n],
        v2 = values[(i + 1) % n],
        v3 = values[(i + 2) % n];
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__basis__["b" /* basis */])((t - i / n) * n, v0, v1, v2, v3);
  };
});


/***/ }),
/* 419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var d = new Date;
  return a = +a, b -= a, function(t) {
    return d.setTime(a + b * t), d;
  };
});


/***/ }),
/* 421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__value__ = __webpack_require__(248);


/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var i = {},
      c = {},
      k;

  if (a === null || typeof a !== "object") a = {};
  if (b === null || typeof b !== "object") b = {};

  for (k in b) {
    if (k in a) {
      i[k] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__value__["a" /* default */])(a[k], b[k]);
    } else {
      c[k] = b[k];
    }
  }

  return function(t) {
    for (k in i) c[k] = i[k](t);
    return c;
  };
});


/***/ }),
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export rgbBasis */
/* unused harmony export rgbBasisClosed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__basis__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__basisClosed__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__color__ = __webpack_require__(118);





/* harmony default export */ __webpack_exports__["a"] = ((function rgbGamma(y) {
  var color = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__color__["c" /* gamma */])(y);

  function rgb(start, end) {
    var r = color((start = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["f" /* rgb */])(start)).r, (end = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["f" /* rgb */])(end)).r),
        g = color(start.g, end.g),
        b = color(start.b, end.b),
        opacity = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__color__["a" /* default */])(start.opacity, end.opacity);
    return function(t) {
      start.r = r(t);
      start.g = g(t);
      start.b = b(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }

  rgb.gamma = rgbGamma;

  return rgb;
})(1));

function rgbSpline(spline) {
  return function(colors) {
    var n = colors.length,
        r = new Array(n),
        g = new Array(n),
        b = new Array(n),
        i, color;
    for (i = 0; i < n; ++i) {
      color = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["f" /* rgb */])(colors[i]);
      r[i] = color.r || 0;
      g[i] = color.g || 0;
      b[i] = color.b || 0;
    }
    r = spline(r);
    g = spline(g);
    b = spline(b);
    color.opacity = 1;
    return function(t) {
      color.r = r(t);
      color.g = g(t);
      color.b = b(t);
      return color + "";
    };
  };
}

var rgbBasis = rgbSpline(__WEBPACK_IMPORTED_MODULE_1__basis__["a" /* default */]);
var rgbBasisClosed = rgbSpline(__WEBPACK_IMPORTED_MODULE_2__basisClosed__["a" /* default */]);


/***/ }),
/* 423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(154);


var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,
    reB = new RegExp(reA.source, "g");

function zero(b) {
  return function() {
    return b;
  };
}

function one(b) {
  return function(t) {
    return b(t) + "";
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var bi = reA.lastIndex = reB.lastIndex = 0, // scan index for next number in b
      am, // current match in a
      bm, // current match in b
      bs, // string preceding current number in b, if any
      i = -1, // index in s
      s = [], // string constants and placeholders
      q = []; // number interpolators

  // Coerce inputs to strings.
  a = a + "", b = b + "";

  // Interpolate pairs of numbers in a & b.
  while ((am = reA.exec(a))
      && (bm = reB.exec(b))) {
    if ((bs = bm.index) > bi) { // a string precedes the next number in b
      bs = b.slice(bi, bs);
      if (s[i]) s[i] += bs; // coalesce with previous string
      else s[++i] = bs;
    }
    if ((am = am[0]) === (bm = bm[0])) { // numbers in a & b match
      if (s[i]) s[i] += bm; // coalesce with previous string
      else s[++i] = bm;
    } else { // interpolate non-matching numbers
      s[++i] = null;
      q.push({i: i, x: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(am, bm)});
    }
    bi = reB.lastIndex;
  }

  // Add remains of b.
  if (bi < b.length) {
    bs = b.slice(bi);
    if (s[i]) s[i] += bs; // coalesce with previous string
    else s[++i] = bs;
  }

  // Special optimization for only a single match.
  // Otherwise, interpolate each of the numbers and rejoin the string.
  return s.length < 2 ? (q[0]
      ? one(q[0].x)
      : zero(b))
      : (b = q.length, function(t) {
          for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
          return s.join("");
        });
});


/***/ }),
/* 424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defaultSource__ = __webpack_require__(108);


/* harmony default export */ __webpack_exports__["a"] = ((function sourceRandomIrwinHall(source) {
  function randomIrwinHall(n) {
    return function() {
      for (var sum = 0, i = 0; i < n; ++i) sum += source();
      return sum;
    };
  }

  randomIrwinHall.source = sourceRandomIrwinHall;

  return randomIrwinHall;
})(__WEBPACK_IMPORTED_MODULE_0__defaultSource__["a" /* default */]));


/***/ }),
/* 425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defaultSource__ = __webpack_require__(108);


/* harmony default export */ __webpack_exports__["a"] = ((function sourceRandomNormal(source) {
  function randomNormal(mu, sigma) {
    var x, r;
    mu = mu == null ? 0 : +mu;
    sigma = sigma == null ? 1 : +sigma;
    return function() {
      var y;

      // If available, use the second previously-generated uniform random.
      if (x != null) y = x, x = null;

      // Otherwise, generate a new x and y.
      else do {
        x = source() * 2 - 1;
        y = source() * 2 - 1;
        r = x * x + y * y;
      } while (!r || r > 1);

      return mu + sigma * y * Math.sqrt(-2 * Math.log(r) / r);
    };
  }

  randomNormal.source = sourceRandomNormal;

  return randomNormal;
})(__WEBPACK_IMPORTED_MODULE_0__defaultSource__["a" /* default */]));


/***/ }),
/* 426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__request__ = __webpack_require__(251);


/* harmony default export */ __webpack_exports__["a"] = (function(defaultMimeType, parse) {
  return function(url, row, callback) {
    if (arguments.length < 3) callback = row, row = null;
    var r = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__request__["a" /* default */])(url).mimeType(defaultMimeType);
    r.row = function(_) { return arguments.length ? r.response(responseOf(parse, row = _)) : row; };
    r.row(row);
    return callback ? r.get(callback) : r;
  };
});

function responseOf(parse, row) {
  return function(request) {
    return parse(request.responseText, row);
  };
}


/***/ }),
/* 427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(domain, interval) {
  domain = domain.slice();

  var i0 = 0,
      i1 = domain.length - 1,
      x0 = domain[i0],
      x1 = domain[i1],
      t;

  if (x1 < x0) {
    t = i0, i0 = i1, i1 = t;
    t = x0, x0 = x1, x1 = t;
  }

  domain[i0] = interval.floor(x0);
  domain[i1] = interval.ceil(x1);
  return domain;
});


/***/ }),
/* 428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return +x;
});


/***/ }),
/* 429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export implicit */
/* harmony export (immutable) */ __webpack_exports__["a"] = ordinal;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_collection__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(90);



var implicit = {name: "implicit"};

function ordinal(range) {
  var index = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_collection__["a" /* map */])(),
      domain = [],
      unknown = implicit;

  range = range == null ? [] : __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(range);

  function scale(d) {
    var key = d + "", i = index.get(key);
    if (!i) {
      if (unknown !== implicit) return unknown;
      index.set(key, i = domain.push(d));
    }
    return range[(i - 1) % range.length];
  }

  scale.domain = function(_) {
    if (!arguments.length) return domain.slice();
    domain = [], index = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_collection__["a" /* map */])();
    var i = -1, n = _.length, d, key;
    while (++i < n) if (!index.has(key = (d = _[i]) + "")) index.set(key, domain.push(d));
    return scale;
  };

  scale.range = function(_) {
    return arguments.length ? (range = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_), scale) : range.slice();
  };

  scale.unknown = function(_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };

  scale.copy = function() {
    return ordinal()
        .domain(domain)
        .range(range)
        .unknown(unknown);
  };

  return scale;
}


/***/ }),
/* 430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = calendar;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_time__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_d3_time_format__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__array__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__continuous__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__nice__ = __webpack_require__(427);








var durationSecond = 1000,
    durationMinute = durationSecond * 60,
    durationHour = durationMinute * 60,
    durationDay = durationHour * 24,
    durationWeek = durationDay * 7,
    durationMonth = durationDay * 30,
    durationYear = durationDay * 365;

function date(t) {
  return new Date(t);
}

function number(t) {
  return t instanceof Date ? +t : +new Date(+t);
}

function calendar(year, month, week, day, hour, minute, second, millisecond, format) {
  var scale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__continuous__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_5__continuous__["b" /* deinterpolateLinear */], __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["d" /* interpolateNumber */]),
      invert = scale.invert,
      domain = scale.domain;

  var formatMillisecond = format(".%L"),
      formatSecond = format(":%S"),
      formatMinute = format("%I:%M"),
      formatHour = format("%I %p"),
      formatDay = format("%a %d"),
      formatWeek = format("%b %d"),
      formatMonth = format("%B"),
      formatYear = format("%Y");

  var tickIntervals = [
    [second,  1,      durationSecond],
    [second,  5,  5 * durationSecond],
    [second, 15, 15 * durationSecond],
    [second, 30, 30 * durationSecond],
    [minute,  1,      durationMinute],
    [minute,  5,  5 * durationMinute],
    [minute, 15, 15 * durationMinute],
    [minute, 30, 30 * durationMinute],
    [  hour,  1,      durationHour  ],
    [  hour,  3,  3 * durationHour  ],
    [  hour,  6,  6 * durationHour  ],
    [  hour, 12, 12 * durationHour  ],
    [   day,  1,      durationDay   ],
    [   day,  2,  2 * durationDay   ],
    [  week,  1,      durationWeek  ],
    [ month,  1,      durationMonth ],
    [ month,  3,  3 * durationMonth ],
    [  year,  1,      durationYear  ]
  ];

  function tickFormat(date) {
    return (second(date) < date ? formatMillisecond
        : minute(date) < date ? formatSecond
        : hour(date) < date ? formatMinute
        : day(date) < date ? formatHour
        : month(date) < date ? (week(date) < date ? formatDay : formatWeek)
        : year(date) < date ? formatMonth
        : formatYear)(date);
  }

  function tickInterval(interval, start, stop, step) {
    if (interval == null) interval = 10;

    // If a desired tick count is specified, pick a reasonable tick interval
    // based on the extent of the domain and a rough estimate of tick size.
    // Otherwise, assume interval is already a time interval and use it.
    if (typeof interval === "number") {
      var target = Math.abs(stop - start) / interval,
          i = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["e" /* bisector */])(function(i) { return i[2]; }).right(tickIntervals, target);
      if (i === tickIntervals.length) {
        step = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["d" /* tickStep */])(start / durationYear, stop / durationYear, interval);
        interval = year;
      } else if (i) {
        i = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
        step = i[1];
        interval = i[0];
      } else {
        step = Math.max(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["d" /* tickStep */])(start, stop, interval), 1);
        interval = millisecond;
      }
    }

    return step == null ? interval : interval.every(step);
  }

  scale.invert = function(y) {
    return new Date(invert(y));
  };

  scale.domain = function(_) {
    return arguments.length ? domain(__WEBPACK_IMPORTED_MODULE_4__array__["a" /* map */].call(_, number)) : domain().map(date);
  };

  scale.ticks = function(interval, step) {
    var d = domain(),
        t0 = d[0],
        t1 = d[d.length - 1],
        r = t1 < t0,
        t;
    if (r) t = t0, t0 = t1, t1 = t;
    t = tickInterval(interval, t0, t1, step);
    t = t ? t.range(t0, t1 + 1) : []; // inclusive stop
    return r ? t.reverse() : t;
  };

  scale.tickFormat = function(count, specifier) {
    return specifier == null ? tickFormat : format(specifier);
  };

  scale.nice = function(interval, step) {
    var d = domain();
    return (interval = tickInterval(interval, d[0], d[d.length - 1], step))
        ? domain(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__nice__["a" /* default */])(d, interval))
        : scale;
  };

  scale.copy = function() {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__continuous__["c" /* copy */])(scale, calendar(year, month, week, day, hour, minute, second, millisecond, format));
  };

  return scale;
}

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  return calendar(__WEBPACK_IMPORTED_MODULE_2_d3_time__["e" /* timeYear */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["q" /* timeMonth */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["r" /* timeWeek */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["d" /* timeDay */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["s" /* timeHour */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["t" /* timeMinute */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["u" /* timeSecond */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["v" /* timeMillisecond */], __WEBPACK_IMPORTED_MODULE_3_d3_time_format__["b" /* timeFormat */]).domain([new Date(2000, 0, 1), new Date(2000, 0, 2)]);
});


/***/ }),
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var matcher = function(selector) {
  return function() {
    return this.matches(selector);
  };
};

if (typeof document !== "undefined") {
  var element = document.documentElement;
  if (!element.matches) {
    var vendorMatches = element.webkitMatchesSelector
        || element.msMatchesSelector
        || element.mozMatchesSelector
        || element.oMatchesSelector;
    matcher = function(selector) {
      return function() {
        return vendorMatches.call(this, selector);
      };
    };
  }
}

/* harmony default export */ __webpack_exports__["a"] = (matcher);


/***/ }),
/* 432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = EnterNode;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sparse__ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(43);



/* harmony default export */ __webpack_exports__["a"] = (function() {
  return new __WEBPACK_IMPORTED_MODULE_1__index__["a" /* Selection */](this._enter || this._groups.map(__WEBPACK_IMPORTED_MODULE_0__sparse__["a" /* default */]), this._parents);
});

function EnterNode(parent, datum) {
  this.ownerDocument = parent.ownerDocument;
  this.namespaceURI = parent.namespaceURI;
  this._next = null;
  this._parent = parent;
  this.__data__ = datum;
}

EnterNode.prototype = {
  constructor: EnterNode,
  appendChild: function(child) { return this._parent.insertBefore(child, this._next); },
  insertBefore: function(child, next) { return this._parent.insertBefore(child, next); },
  querySelector: function(selector) { return this._parent.querySelector(selector); },
  querySelectorAll: function(selector) { return this._parent.querySelectorAll(selector); }
};


/***/ }),
/* 433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(update) {
  return new Array(update.length);
});


/***/ }),
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = styleValue;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__window__ = __webpack_require__(259);


function styleRemove(name) {
  return function() {
    this.style.removeProperty(name);
  };
}

function styleConstant(name, value, priority) {
  return function() {
    this.style.setProperty(name, value, priority);
  };
}

function styleFunction(name, value, priority) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null) this.style.removeProperty(name);
    else this.style.setProperty(name, v, priority);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(name, value, priority) {
  return arguments.length > 1
      ? this.each((value == null
            ? styleRemove : typeof value === "function"
            ? styleFunction
            : styleConstant)(name, value, priority == null ? "" : priority))
      : styleValue(this.node(), name);
});

function styleValue(node, name) {
  return node.style.getPropertyValue(name)
      || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__window__["a" /* default */])(node).getComputedStyle(node, null).getPropertyValue(name);
}


/***/ }),
/* 435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function empty() {
  return [];
}

/* harmony default export */ __webpack_exports__["a"] = (function(selector) {
  return selector == null ? empty : function() {
    return this.querySelectorAll(selector);
  };
});


/***/ }),
/* 436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_path__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constant__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__curve_linear__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__line__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__point__ = __webpack_require__(263);






/* harmony default export */ __webpack_exports__["a"] = (function() {
  var x0 = __WEBPACK_IMPORTED_MODULE_4__point__["a" /* x */],
      x1 = null,
      y0 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(0),
      y1 = __WEBPACK_IMPORTED_MODULE_4__point__["b" /* y */],
      defined = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(true),
      context = null,
      curve = __WEBPACK_IMPORTED_MODULE_2__curve_linear__["a" /* default */],
      output = null;

  function area(data) {
    var i,
        j,
        k,
        n = data.length,
        d,
        defined0 = false,
        buffer,
        x0z = new Array(n),
        y0z = new Array(n);

    if (context == null) output = curve(buffer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_path__["a" /* path */])());

    for (i = 0; i <= n; ++i) {
      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
        if (defined0 = !defined0) {
          j = i;
          output.areaStart();
          output.lineStart();
        } else {
          output.lineEnd();
          output.lineStart();
          for (k = i - 1; k >= j; --k) {
            output.point(x0z[k], y0z[k]);
          }
          output.lineEnd();
          output.areaEnd();
        }
      }
      if (defined0) {
        x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
        output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
      }
    }

    if (buffer) return output = null, buffer + "" || null;
  }

  function arealine() {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__line__["a" /* default */])().defined(defined).curve(curve).context(context);
  }

  area.x = function(_) {
    return arguments.length ? (x0 = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), x1 = null, area) : x0;
  };

  area.x0 = function(_) {
    return arguments.length ? (x0 = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), area) : x0;
  };

  area.x1 = function(_) {
    return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), area) : x1;
  };

  area.y = function(_) {
    return arguments.length ? (y0 = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), y1 = null, area) : y0;
  };

  area.y0 = function(_) {
    return arguments.length ? (y0 = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), area) : y0;
  };

  area.y1 = function(_) {
    return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), area) : y1;
  };

  area.lineX0 =
  area.lineY0 = function() {
    return arealine().x(x0).y(y0);
  };

  area.lineY1 = function() {
    return arealine().x(x0).y(y1);
  };

  area.lineX1 = function() {
    return arealine().x(x1).y(y0);
  };

  area.defined = function(_) {
    return arguments.length ? (defined = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(!!_), area) : defined;
  };

  area.curve = function(_) {
    return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
  };

  area.context = function(_) {
    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
  };

  return area;
});


/***/ }),
/* 437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return slice; });
var slice = Array.prototype.slice;


/***/ }),
/* 438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = CardinalClosed;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__noop__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cardinal__ = __webpack_require__(159);



function CardinalClosed(context, tension) {
  this._context = context;
  this._k = (1 - tension) / 6;
}

CardinalClosed.prototype = {
  areaStart: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  areaEnd: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 =
    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 2: {
        this._context.lineTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x3, this._y3);
        this.point(this._x4, this._y4);
        this.point(this._x5, this._y5);
        break;
      }
    }
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._x3 = x, this._y3 = y; break;
      case 1: this._point = 2; this._context.moveTo(this._x4 = x, this._y4 = y); break;
      case 2: this._point = 3; this._x5 = x, this._y5 = y; break;
      default: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__cardinal__["b" /* point */])(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* unused harmony default export */ var _unused_webpack_default_export = ((function custom(tension) {

  function cardinal(context) {
    return new CardinalClosed(context, tension);
  }

  cardinal.tension = function(tension) {
    return custom(+tension);
  };

  return cardinal;
})(0));


/***/ }),
/* 439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = CardinalOpen;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cardinal__ = __webpack_require__(159);


function CardinalOpen(context, tension) {
  this._context = context;
  this._k = (1 - tension) / 6;
}

CardinalOpen.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 =
    this._y0 = this._y1 = this._y2 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2); break;
      case 3: this._point = 4; // proceed
      default: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cardinal__["b" /* point */])(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* unused harmony default export */ var _unused_webpack_default_export = ((function custom(tension) {

  function cardinal(context) {
    return new CardinalOpen(context, tension);
  }

  cardinal.tension = function(tension) {
    return custom(+tension);
  };

  return cardinal;
})(0));


/***/ }),
/* 440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return curveRadialLinear; });
/* harmony export (immutable) */ __webpack_exports__["a"] = curveRadial;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__linear__ = __webpack_require__(160);


var curveRadialLinear = curveRadial(__WEBPACK_IMPORTED_MODULE_0__linear__["a" /* default */]);

function Radial(curve) {
  this._curve = curve;
}

Radial.prototype = {
  areaStart: function() {
    this._curve.areaStart();
  },
  areaEnd: function() {
    this._curve.areaEnd();
  },
  lineStart: function() {
    this._curve.lineStart();
  },
  lineEnd: function() {
    this._curve.lineEnd();
  },
  point: function(a, r) {
    this._curve.point(r * Math.sin(a), r * -Math.cos(a));
  }
};

function curveRadial(curve) {

  function radial(context) {
    return new Radial(curve(context));
  }

  radial._curve = curve;

  return radial;
}


/***/ }),
/* 441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = lineRadial;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__curve_radial__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__line__ = __webpack_require__(261);



function lineRadial(l) {
  var c = l.curve;

  l.angle = l.x, delete l.x;
  l.radius = l.y, delete l.y;

  l.curve = function(_) {
    return arguments.length ? c(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__curve_radial__["a" /* default */])(_)) : c()._curve;
  };

  return l;
}

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  return lineRadial(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__line__["a" /* default */])().curve(__WEBPACK_IMPORTED_MODULE_0__curve_radial__["b" /* curveRadialLinear */]));
});


/***/ }),
/* 442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x, y) {
  return [(y = +y) * Math.cos(x -= Math.PI / 2), y * Math.sin(x)];
});


/***/ }),
/* 443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(121);


/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var r = Math.sqrt(size / __WEBPACK_IMPORTED_MODULE_0__math__["b" /* pi */]);
    context.moveTo(r, 0);
    context.arc(0, 0, r, 0, __WEBPACK_IMPORTED_MODULE_0__math__["c" /* tau */]);
  }
});


/***/ }),
/* 444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var r = Math.sqrt(size / 5) / 2;
    context.moveTo(-3 * r, -r);
    context.lineTo(-r, -r);
    context.lineTo(-r, -3 * r);
    context.lineTo(r, -3 * r);
    context.lineTo(r, -r);
    context.lineTo(3 * r, -r);
    context.lineTo(3 * r, r);
    context.lineTo(r, r);
    context.lineTo(r, 3 * r);
    context.lineTo(-r, 3 * r);
    context.lineTo(-r, r);
    context.lineTo(-3 * r, r);
    context.closePath();
  }
});


/***/ }),
/* 445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var tan30 = Math.sqrt(1 / 3),
    tan30_2 = tan30 * 2;

/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var y = Math.sqrt(size / tan30_2),
        x = y * tan30;
    context.moveTo(0, -y);
    context.lineTo(x, 0);
    context.lineTo(0, y);
    context.lineTo(-x, 0);
    context.closePath();
  }
});


/***/ }),
/* 446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var w = Math.sqrt(size),
        x = -w / 2;
    context.rect(x, x, w, w);
  }
});


/***/ }),
/* 447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(121);


var ka = 0.89081309152928522810,
    kr = Math.sin(__WEBPACK_IMPORTED_MODULE_0__math__["b" /* pi */] / 10) / Math.sin(7 * __WEBPACK_IMPORTED_MODULE_0__math__["b" /* pi */] / 10),
    kx = Math.sin(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* tau */] / 10) * kr,
    ky = -Math.cos(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* tau */] / 10) * kr;

/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var r = Math.sqrt(size * ka),
        x = kx * r,
        y = ky * r;
    context.moveTo(0, -r);
    context.lineTo(x, y);
    for (var i = 1; i < 5; ++i) {
      var a = __WEBPACK_IMPORTED_MODULE_0__math__["c" /* tau */] * i / 5,
          c = Math.cos(a),
          s = Math.sin(a);
      context.lineTo(s * r, -c * r);
      context.lineTo(c * x - s * y, s * x + c * y);
    }
    context.closePath();
  }
});


/***/ }),
/* 448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var sqrt3 = Math.sqrt(3);

/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var y = -Math.sqrt(size / (sqrt3 * 3));
    context.moveTo(0, y * 2);
    context.lineTo(-sqrt3 * y, -y);
    context.lineTo(sqrt3 * y, -y);
    context.closePath();
  }
});


/***/ }),
/* 449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var c = -0.5,
    s = Math.sqrt(3) / 2,
    k = 1 / Math.sqrt(12),
    a = (k / 2 + 1) * 3;

/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var r = Math.sqrt(size / a),
        x0 = r / 2,
        y0 = r * k,
        x1 = x0,
        y1 = r * k + r,
        x2 = -x1,
        y2 = y1;
    context.moveTo(x0, y0);
    context.lineTo(x1, y1);
    context.lineTo(x2, y2);
    context.lineTo(c * x0 - s * y0, s * x0 + c * y0);
    context.lineTo(c * x1 - s * y1, s * x1 + c * y1);
    context.lineTo(c * x2 - s * y2, s * x2 + c * y2);
    context.lineTo(c * x0 + s * y0, c * y0 - s * x0);
    context.lineTo(c * x1 + s * y1, c * y1 - s * x1);
    context.lineTo(c * x2 + s * y2, c * y2 - s * x2);
    context.closePath();
  }
});


/***/ }),
/* 450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isoSpecifier; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defaultLocale__ = __webpack_require__(265);


var isoSpecifier = "%Y-%m-%dT%H:%M:%S.%LZ";

function formatIsoNative(date) {
  return date.toISOString();
}

var formatIso = Date.prototype.toISOString
    ? formatIsoNative
    : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__defaultLocale__["b" /* utcFormat */])(isoSpecifier);

/* unused harmony default export */ var _unused_webpack_default_export = (formatIso);


/***/ }),
/* 451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = formatLocale;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_time__ = __webpack_require__(162);


function localDate(d) {
  if (0 <= d.y && d.y < 100) {
    var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
    date.setFullYear(d.y);
    return date;
  }
  return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}

function utcDate(d) {
  if (0 <= d.y && d.y < 100) {
    var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
    date.setUTCFullYear(d.y);
    return date;
  }
  return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}

function newYear(y) {
  return {y: y, m: 0, d: 1, H: 0, M: 0, S: 0, L: 0};
}

function formatLocale(locale) {
  var locale_dateTime = locale.dateTime,
      locale_date = locale.date,
      locale_time = locale.time,
      locale_periods = locale.periods,
      locale_weekdays = locale.days,
      locale_shortWeekdays = locale.shortDays,
      locale_months = locale.months,
      locale_shortMonths = locale.shortMonths;

  var periodRe = formatRe(locale_periods),
      periodLookup = formatLookup(locale_periods),
      weekdayRe = formatRe(locale_weekdays),
      weekdayLookup = formatLookup(locale_weekdays),
      shortWeekdayRe = formatRe(locale_shortWeekdays),
      shortWeekdayLookup = formatLookup(locale_shortWeekdays),
      monthRe = formatRe(locale_months),
      monthLookup = formatLookup(locale_months),
      shortMonthRe = formatRe(locale_shortMonths),
      shortMonthLookup = formatLookup(locale_shortMonths);

  var formats = {
    "a": formatShortWeekday,
    "A": formatWeekday,
    "b": formatShortMonth,
    "B": formatMonth,
    "c": null,
    "d": formatDayOfMonth,
    "e": formatDayOfMonth,
    "f": formatMicroseconds,
    "H": formatHour24,
    "I": formatHour12,
    "j": formatDayOfYear,
    "L": formatMilliseconds,
    "m": formatMonthNumber,
    "M": formatMinutes,
    "p": formatPeriod,
    "Q": formatUnixTimestamp,
    "s": formatUnixTimestampSeconds,
    "S": formatSeconds,
    "u": formatWeekdayNumberMonday,
    "U": formatWeekNumberSunday,
    "V": formatWeekNumberISO,
    "w": formatWeekdayNumberSunday,
    "W": formatWeekNumberMonday,
    "x": null,
    "X": null,
    "y": formatYear,
    "Y": formatFullYear,
    "Z": formatZone,
    "%": formatLiteralPercent
  };

  var utcFormats = {
    "a": formatUTCShortWeekday,
    "A": formatUTCWeekday,
    "b": formatUTCShortMonth,
    "B": formatUTCMonth,
    "c": null,
    "d": formatUTCDayOfMonth,
    "e": formatUTCDayOfMonth,
    "f": formatUTCMicroseconds,
    "H": formatUTCHour24,
    "I": formatUTCHour12,
    "j": formatUTCDayOfYear,
    "L": formatUTCMilliseconds,
    "m": formatUTCMonthNumber,
    "M": formatUTCMinutes,
    "p": formatUTCPeriod,
    "Q": formatUnixTimestamp,
    "s": formatUnixTimestampSeconds,
    "S": formatUTCSeconds,
    "u": formatUTCWeekdayNumberMonday,
    "U": formatUTCWeekNumberSunday,
    "V": formatUTCWeekNumberISO,
    "w": formatUTCWeekdayNumberSunday,
    "W": formatUTCWeekNumberMonday,
    "x": null,
    "X": null,
    "y": formatUTCYear,
    "Y": formatUTCFullYear,
    "Z": formatUTCZone,
    "%": formatLiteralPercent
  };

  var parses = {
    "a": parseShortWeekday,
    "A": parseWeekday,
    "b": parseShortMonth,
    "B": parseMonth,
    "c": parseLocaleDateTime,
    "d": parseDayOfMonth,
    "e": parseDayOfMonth,
    "f": parseMicroseconds,
    "H": parseHour24,
    "I": parseHour24,
    "j": parseDayOfYear,
    "L": parseMilliseconds,
    "m": parseMonthNumber,
    "M": parseMinutes,
    "p": parsePeriod,
    "Q": parseUnixTimestamp,
    "s": parseUnixTimestampSeconds,
    "S": parseSeconds,
    "u": parseWeekdayNumberMonday,
    "U": parseWeekNumberSunday,
    "V": parseWeekNumberISO,
    "w": parseWeekdayNumberSunday,
    "W": parseWeekNumberMonday,
    "x": parseLocaleDate,
    "X": parseLocaleTime,
    "y": parseYear,
    "Y": parseFullYear,
    "Z": parseZone,
    "%": parseLiteralPercent
  };

  // These recursive directive definitions must be deferred.
  formats.x = newFormat(locale_date, formats);
  formats.X = newFormat(locale_time, formats);
  formats.c = newFormat(locale_dateTime, formats);
  utcFormats.x = newFormat(locale_date, utcFormats);
  utcFormats.X = newFormat(locale_time, utcFormats);
  utcFormats.c = newFormat(locale_dateTime, utcFormats);

  function newFormat(specifier, formats) {
    return function(date) {
      var string = [],
          i = -1,
          j = 0,
          n = specifier.length,
          c,
          pad,
          format;

      if (!(date instanceof Date)) date = new Date(+date);

      while (++i < n) {
        if (specifier.charCodeAt(i) === 37) {
          string.push(specifier.slice(j, i));
          if ((pad = pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
          else pad = c === "e" ? " " : "0";
          if (format = formats[c]) c = format(date, pad);
          string.push(c);
          j = i + 1;
        }
      }

      string.push(specifier.slice(j, i));
      return string.join("");
    };
  }

  function newParse(specifier, newDate) {
    return function(string) {
      var d = newYear(1900),
          i = parseSpecifier(d, specifier, string += "", 0),
          week, day;
      if (i != string.length) return null;

      // If a UNIX timestamp is specified, return it.
      if ("Q" in d) return new Date(d.Q);

      // The am-pm flag is 0 for AM, and 1 for PM.
      if ("p" in d) d.H = d.H % 12 + d.p * 12;

      // Convert day-of-week and week-of-year to day-of-year.
      if ("V" in d) {
        if (d.V < 1 || d.V > 53) return null;
        if (!("w" in d)) d.w = 1;
        if ("Z" in d) {
          week = utcDate(newYear(d.y)), day = week.getUTCDay();
          week = day > 4 || day === 0 ? __WEBPACK_IMPORTED_MODULE_0_d3_time__["a" /* utcMonday */].ceil(week) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_time__["a" /* utcMonday */])(week);
          week = __WEBPACK_IMPORTED_MODULE_0_d3_time__["b" /* utcDay */].offset(week, (d.V - 1) * 7);
          d.y = week.getUTCFullYear();
          d.m = week.getUTCMonth();
          d.d = week.getUTCDate() + (d.w + 6) % 7;
        } else {
          week = newDate(newYear(d.y)), day = week.getDay();
          week = day > 4 || day === 0 ? __WEBPACK_IMPORTED_MODULE_0_d3_time__["c" /* timeMonday */].ceil(week) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_time__["c" /* timeMonday */])(week);
          week = __WEBPACK_IMPORTED_MODULE_0_d3_time__["d" /* timeDay */].offset(week, (d.V - 1) * 7);
          d.y = week.getFullYear();
          d.m = week.getMonth();
          d.d = week.getDate() + (d.w + 6) % 7;
        }
      } else if ("W" in d || "U" in d) {
        if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
        day = "Z" in d ? utcDate(newYear(d.y)).getUTCDay() : newDate(newYear(d.y)).getDay();
        d.m = 0;
        d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
      }

      // If a time zone is specified, all fields are interpreted as UTC and then
      // offset according to the specified time zone.
      if ("Z" in d) {
        d.H += d.Z / 100 | 0;
        d.M += d.Z % 100;
        return utcDate(d);
      }

      // Otherwise, all fields are in local time.
      return newDate(d);
    };
  }

  function parseSpecifier(d, specifier, string, j) {
    var i = 0,
        n = specifier.length,
        m = string.length,
        c,
        parse;

    while (i < n) {
      if (j >= m) return -1;
      c = specifier.charCodeAt(i++);
      if (c === 37) {
        c = specifier.charAt(i++);
        parse = parses[c in pads ? specifier.charAt(i++) : c];
        if (!parse || ((j = parse(d, string, j)) < 0)) return -1;
      } else if (c != string.charCodeAt(j++)) {
        return -1;
      }
    }

    return j;
  }

  function parsePeriod(d, string, i) {
    var n = periodRe.exec(string.slice(i));
    return n ? (d.p = periodLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseShortWeekday(d, string, i) {
    var n = shortWeekdayRe.exec(string.slice(i));
    return n ? (d.w = shortWeekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseWeekday(d, string, i) {
    var n = weekdayRe.exec(string.slice(i));
    return n ? (d.w = weekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseShortMonth(d, string, i) {
    var n = shortMonthRe.exec(string.slice(i));
    return n ? (d.m = shortMonthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseMonth(d, string, i) {
    var n = monthRe.exec(string.slice(i));
    return n ? (d.m = monthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseLocaleDateTime(d, string, i) {
    return parseSpecifier(d, locale_dateTime, string, i);
  }

  function parseLocaleDate(d, string, i) {
    return parseSpecifier(d, locale_date, string, i);
  }

  function parseLocaleTime(d, string, i) {
    return parseSpecifier(d, locale_time, string, i);
  }

  function formatShortWeekday(d) {
    return locale_shortWeekdays[d.getDay()];
  }

  function formatWeekday(d) {
    return locale_weekdays[d.getDay()];
  }

  function formatShortMonth(d) {
    return locale_shortMonths[d.getMonth()];
  }

  function formatMonth(d) {
    return locale_months[d.getMonth()];
  }

  function formatPeriod(d) {
    return locale_periods[+(d.getHours() >= 12)];
  }

  function formatUTCShortWeekday(d) {
    return locale_shortWeekdays[d.getUTCDay()];
  }

  function formatUTCWeekday(d) {
    return locale_weekdays[d.getUTCDay()];
  }

  function formatUTCShortMonth(d) {
    return locale_shortMonths[d.getUTCMonth()];
  }

  function formatUTCMonth(d) {
    return locale_months[d.getUTCMonth()];
  }

  function formatUTCPeriod(d) {
    return locale_periods[+(d.getUTCHours() >= 12)];
  }

  return {
    format: function(specifier) {
      var f = newFormat(specifier += "", formats);
      f.toString = function() { return specifier; };
      return f;
    },
    parse: function(specifier) {
      var p = newParse(specifier += "", localDate);
      p.toString = function() { return specifier; };
      return p;
    },
    utcFormat: function(specifier) {
      var f = newFormat(specifier += "", utcFormats);
      f.toString = function() { return specifier; };
      return f;
    },
    utcParse: function(specifier) {
      var p = newParse(specifier, utcDate);
      p.toString = function() { return specifier; };
      return p;
    }
  };
}

var pads = {"-": "", "_": " ", "0": "0"},
    numberRe = /^\s*\d+/, // note: ignores next directive
    percentRe = /^%/,
    requoteRe = /[\\^$*+?|[\]().{}]/g;

function pad(value, fill, width) {
  var sign = value < 0 ? "-" : "",
      string = (sign ? -value : value) + "",
      length = string.length;
  return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}

function requote(s) {
  return s.replace(requoteRe, "\\$&");
}

function formatRe(names) {
  return new RegExp("^(?:" + names.map(requote).join("|") + ")", "i");
}

function formatLookup(names) {
  var map = {}, i = -1, n = names.length;
  while (++i < n) map[names[i].toLowerCase()] = i;
  return map;
}

function parseWeekdayNumberSunday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 1));
  return n ? (d.w = +n[0], i + n[0].length) : -1;
}

function parseWeekdayNumberMonday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 1));
  return n ? (d.u = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberSunday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.U = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberISO(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.V = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberMonday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.W = +n[0], i + n[0].length) : -1;
}

function parseFullYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 4));
  return n ? (d.y = +n[0], i + n[0].length) : -1;
}

function parseYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}

function parseZone(d, string, i) {
  var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
  return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}

function parseMonthNumber(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}

function parseDayOfMonth(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.d = +n[0], i + n[0].length) : -1;
}

function parseDayOfYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 3));
  return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}

function parseHour24(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.H = +n[0], i + n[0].length) : -1;
}

function parseMinutes(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.M = +n[0], i + n[0].length) : -1;
}

function parseSeconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.S = +n[0], i + n[0].length) : -1;
}

function parseMilliseconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 3));
  return n ? (d.L = +n[0], i + n[0].length) : -1;
}

function parseMicroseconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 6));
  return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
}

function parseLiteralPercent(d, string, i) {
  var n = percentRe.exec(string.slice(i, i + 1));
  return n ? i + n[0].length : -1;
}

function parseUnixTimestamp(d, string, i) {
  var n = numberRe.exec(string.slice(i));
  return n ? (d.Q = +n[0], i + n[0].length) : -1;
}

function parseUnixTimestampSeconds(d, string, i) {
  var n = numberRe.exec(string.slice(i));
  return n ? (d.Q = (+n[0]) * 1000, i + n[0].length) : -1;
}

function formatDayOfMonth(d, p) {
  return pad(d.getDate(), p, 2);
}

function formatHour24(d, p) {
  return pad(d.getHours(), p, 2);
}

function formatHour12(d, p) {
  return pad(d.getHours() % 12 || 12, p, 2);
}

function formatDayOfYear(d, p) {
  return pad(1 + __WEBPACK_IMPORTED_MODULE_0_d3_time__["d" /* timeDay */].count(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_time__["e" /* timeYear */])(d), d), p, 3);
}

function formatMilliseconds(d, p) {
  return pad(d.getMilliseconds(), p, 3);
}

function formatMicroseconds(d, p) {
  return formatMilliseconds(d, p) + "000";
}

function formatMonthNumber(d, p) {
  return pad(d.getMonth() + 1, p, 2);
}

function formatMinutes(d, p) {
  return pad(d.getMinutes(), p, 2);
}

function formatSeconds(d, p) {
  return pad(d.getSeconds(), p, 2);
}

function formatWeekdayNumberMonday(d) {
  var day = d.getDay();
  return day === 0 ? 7 : day;
}

function formatWeekNumberSunday(d, p) {
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["f" /* timeSunday */].count(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_time__["e" /* timeYear */])(d), d), p, 2);
}

function formatWeekNumberISO(d, p) {
  var day = d.getDay();
  d = (day >= 4 || day === 0) ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_time__["g" /* timeThursday */])(d) : __WEBPACK_IMPORTED_MODULE_0_d3_time__["g" /* timeThursday */].ceil(d);
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["g" /* timeThursday */].count(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_time__["e" /* timeYear */])(d), d) + (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_time__["e" /* timeYear */])(d).getDay() === 4), p, 2);
}

function formatWeekdayNumberSunday(d) {
  return d.getDay();
}

function formatWeekNumberMonday(d, p) {
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["c" /* timeMonday */].count(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_time__["e" /* timeYear */])(d), d), p, 2);
}

function formatYear(d, p) {
  return pad(d.getFullYear() % 100, p, 2);
}

function formatFullYear(d, p) {
  return pad(d.getFullYear() % 10000, p, 4);
}

function formatZone(d) {
  var z = d.getTimezoneOffset();
  return (z > 0 ? "-" : (z *= -1, "+"))
      + pad(z / 60 | 0, "0", 2)
      + pad(z % 60, "0", 2);
}

function formatUTCDayOfMonth(d, p) {
  return pad(d.getUTCDate(), p, 2);
}

function formatUTCHour24(d, p) {
  return pad(d.getUTCHours(), p, 2);
}

function formatUTCHour12(d, p) {
  return pad(d.getUTCHours() % 12 || 12, p, 2);
}

function formatUTCDayOfYear(d, p) {
  return pad(1 + __WEBPACK_IMPORTED_MODULE_0_d3_time__["b" /* utcDay */].count(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_time__["h" /* utcYear */])(d), d), p, 3);
}

function formatUTCMilliseconds(d, p) {
  return pad(d.getUTCMilliseconds(), p, 3);
}

function formatUTCMicroseconds(d, p) {
  return formatUTCMilliseconds(d, p) + "000";
}

function formatUTCMonthNumber(d, p) {
  return pad(d.getUTCMonth() + 1, p, 2);
}

function formatUTCMinutes(d, p) {
  return pad(d.getUTCMinutes(), p, 2);
}

function formatUTCSeconds(d, p) {
  return pad(d.getUTCSeconds(), p, 2);
}

function formatUTCWeekdayNumberMonday(d) {
  var dow = d.getUTCDay();
  return dow === 0 ? 7 : dow;
}

function formatUTCWeekNumberSunday(d, p) {
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["i" /* utcSunday */].count(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_time__["h" /* utcYear */])(d), d), p, 2);
}

function formatUTCWeekNumberISO(d, p) {
  var day = d.getUTCDay();
  d = (day >= 4 || day === 0) ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_time__["j" /* utcThursday */])(d) : __WEBPACK_IMPORTED_MODULE_0_d3_time__["j" /* utcThursday */].ceil(d);
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["j" /* utcThursday */].count(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_time__["h" /* utcYear */])(d), d) + (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_time__["h" /* utcYear */])(d).getUTCDay() === 4), p, 2);
}

function formatUTCWeekdayNumberSunday(d) {
  return d.getUTCDay();
}

function formatUTCWeekNumberMonday(d, p) {
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["a" /* utcMonday */].count(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_time__["h" /* utcYear */])(d), d), p, 2);
}

function formatUTCYear(d, p) {
  return pad(d.getUTCFullYear() % 100, p, 2);
}

function formatUTCFullYear(d, p) {
  return pad(d.getUTCFullYear() % 10000, p, 4);
}

function formatUTCZone() {
  return "+0000";
}

function formatLiteralPercent() {
  return "%";
}

function formatUnixTimestamp(d) {
  return +d;
}

function formatUnixTimestampSeconds(d) {
  return Math.floor(+d / 1000);
}


/***/ }),
/* 452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__transition_schedule__ = __webpack_require__(44);


/* harmony default export */ __webpack_exports__["a"] = (function(node, name) {
  var schedules = node.__transition,
      schedule,
      active,
      empty = true,
      i;

  if (!schedules) return;

  name = name == null ? null : name + "";

  for (i in schedules) {
    if ((schedule = schedules[i]).name !== name) { empty = false; continue; }
    active = schedule.state > __WEBPACK_IMPORTED_MODULE_0__transition_schedule__["a" /* STARTING */] && schedule.state < __WEBPACK_IMPORTED_MODULE_0__transition_schedule__["b" /* ENDING */];
    schedule.state = __WEBPACK_IMPORTED_MODULE_0__transition_schedule__["c" /* ENDED */];
    schedule.timer.stop();
    if (active) schedule.on.call("interrupt", node, node.__data__, schedule.index, schedule.group);
    delete schedules[i];
  }

  if (empty) delete node.__transition;
});


/***/ }),
/* 453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__(42);



/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var c;
  return (typeof b === "number" ? __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["d" /* interpolateNumber */]
      : b instanceof __WEBPACK_IMPORTED_MODULE_0_d3_color__["a" /* color */] ? __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["e" /* interpolateRgb */]
      : (c = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["a" /* color */])(b)) ? (b = c, __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["e" /* interpolateRgb */])
      : __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["f" /* interpolateString */])(a, b);
});


/***/ }),
/* 454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = createCell;
/* harmony export (immutable) */ __webpack_exports__["c"] = cellHalfedgeStart;
/* unused harmony export cellHalfedgeEnd */
/* harmony export (immutable) */ __webpack_exports__["a"] = sortCellHalfedges;
/* harmony export (immutable) */ __webpack_exports__["b"] = clipCells;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Edge__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Diagram__ = __webpack_require__(124);



function createCell(site) {
  return __WEBPACK_IMPORTED_MODULE_1__Diagram__["c" /* cells */][site.index] = {
    site: site,
    halfedges: []
  };
}

function cellHalfedgeAngle(cell, edge) {
  var site = cell.site,
      va = edge.left,
      vb = edge.right;
  if (site === vb) vb = va, va = site;
  if (vb) return Math.atan2(vb[1] - va[1], vb[0] - va[0]);
  if (site === va) va = edge[1], vb = edge[0];
  else va = edge[0], vb = edge[1];
  return Math.atan2(va[0] - vb[0], vb[1] - va[1]);
}

function cellHalfedgeStart(cell, edge) {
  return edge[+(edge.left !== cell.site)];
}

function cellHalfedgeEnd(cell, edge) {
  return edge[+(edge.left === cell.site)];
}

function sortCellHalfedges() {
  for (var i = 0, n = __WEBPACK_IMPORTED_MODULE_1__Diagram__["c" /* cells */].length, cell, halfedges, j, m; i < n; ++i) {
    if ((cell = __WEBPACK_IMPORTED_MODULE_1__Diagram__["c" /* cells */][i]) && (m = (halfedges = cell.halfedges).length)) {
      var index = new Array(m),
          array = new Array(m);
      for (j = 0; j < m; ++j) index[j] = j, array[j] = cellHalfedgeAngle(cell, __WEBPACK_IMPORTED_MODULE_1__Diagram__["d" /* edges */][halfedges[j]]);
      index.sort(function(i, j) { return array[j] - array[i]; });
      for (j = 0; j < m; ++j) array[j] = halfedges[index[j]];
      for (j = 0; j < m; ++j) halfedges[j] = array[j];
    }
  }
}

function clipCells(x0, y0, x1, y1) {
  var nCells = __WEBPACK_IMPORTED_MODULE_1__Diagram__["c" /* cells */].length,
      iCell,
      cell,
      site,
      iHalfedge,
      halfedges,
      nHalfedges,
      start,
      startX,
      startY,
      end,
      endX,
      endY,
      cover = true;

  for (iCell = 0; iCell < nCells; ++iCell) {
    if (cell = __WEBPACK_IMPORTED_MODULE_1__Diagram__["c" /* cells */][iCell]) {
      site = cell.site;
      halfedges = cell.halfedges;
      iHalfedge = halfedges.length;

      // Remove any dangling clipped edges.
      while (iHalfedge--) {
        if (!__WEBPACK_IMPORTED_MODULE_1__Diagram__["d" /* edges */][halfedges[iHalfedge]]) {
          halfedges.splice(iHalfedge, 1);
        }
      }

      // Insert any border edges as necessary.
      iHalfedge = 0, nHalfedges = halfedges.length;
      while (iHalfedge < nHalfedges) {
        end = cellHalfedgeEnd(cell, __WEBPACK_IMPORTED_MODULE_1__Diagram__["d" /* edges */][halfedges[iHalfedge]]), endX = end[0], endY = end[1];
        start = cellHalfedgeStart(cell, __WEBPACK_IMPORTED_MODULE_1__Diagram__["d" /* edges */][halfedges[++iHalfedge % nHalfedges]]), startX = start[0], startY = start[1];
        if (Math.abs(endX - startX) > __WEBPACK_IMPORTED_MODULE_1__Diagram__["b" /* epsilon */] || Math.abs(endY - startY) > __WEBPACK_IMPORTED_MODULE_1__Diagram__["b" /* epsilon */]) {
          halfedges.splice(iHalfedge, 0, __WEBPACK_IMPORTED_MODULE_1__Diagram__["d" /* edges */].push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__Edge__["b" /* createBorderEdge */])(site, end,
              Math.abs(endX - x0) < __WEBPACK_IMPORTED_MODULE_1__Diagram__["b" /* epsilon */] && y1 - endY > __WEBPACK_IMPORTED_MODULE_1__Diagram__["b" /* epsilon */] ? [x0, Math.abs(startX - x0) < __WEBPACK_IMPORTED_MODULE_1__Diagram__["b" /* epsilon */] ? startY : y1]
              : Math.abs(endY - y1) < __WEBPACK_IMPORTED_MODULE_1__Diagram__["b" /* epsilon */] && x1 - endX > __WEBPACK_IMPORTED_MODULE_1__Diagram__["b" /* epsilon */] ? [Math.abs(startY - y1) < __WEBPACK_IMPORTED_MODULE_1__Diagram__["b" /* epsilon */] ? startX : x1, y1]
              : Math.abs(endX - x1) < __WEBPACK_IMPORTED_MODULE_1__Diagram__["b" /* epsilon */] && endY - y0 > __WEBPACK_IMPORTED_MODULE_1__Diagram__["b" /* epsilon */] ? [x1, Math.abs(startX - x1) < __WEBPACK_IMPORTED_MODULE_1__Diagram__["b" /* epsilon */] ? startY : y0]
              : Math.abs(endY - y0) < __WEBPACK_IMPORTED_MODULE_1__Diagram__["b" /* epsilon */] && endX - x0 > __WEBPACK_IMPORTED_MODULE_1__Diagram__["b" /* epsilon */] ? [Math.abs(startY - y0) < __WEBPACK_IMPORTED_MODULE_1__Diagram__["b" /* epsilon */] ? startX : x0, y0]
              : null)) - 1);
          ++nHalfedges;
        }
      }

      if (nHalfedges) cover = false;
    }
  }

  // If there weren’t any edges, have the closest site cover the extent.
  // It doesn’t matter which corner of the extent we measure!
  if (cover) {
    var dx, dy, d2, dc = Infinity;

    for (iCell = 0, cover = null; iCell < nCells; ++iCell) {
      if (cell = __WEBPACK_IMPORTED_MODULE_1__Diagram__["c" /* cells */][iCell]) {
        site = cell.site;
        dx = site[0] - x0;
        dy = site[1] - y0;
        d2 = dx * dx + dy * dy;
        if (d2 < dc) dc = d2, cover = cell;
      }
    }

    if (cover) {
      var v00 = [x0, y0], v01 = [x0, y1], v11 = [x1, y1], v10 = [x1, y0];
      cover.halfedges.push(
        __WEBPACK_IMPORTED_MODULE_1__Diagram__["d" /* edges */].push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__Edge__["b" /* createBorderEdge */])(site = cover.site, v00, v01)) - 1,
        __WEBPACK_IMPORTED_MODULE_1__Diagram__["d" /* edges */].push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__Edge__["b" /* createBorderEdge */])(site, v01, v11)) - 1,
        __WEBPACK_IMPORTED_MODULE_1__Diagram__["d" /* edges */].push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__Edge__["b" /* createBorderEdge */])(site, v11, v10)) - 1,
        __WEBPACK_IMPORTED_MODULE_1__Diagram__["d" /* edges */].push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__Edge__["b" /* createBorderEdge */])(site, v10, v00)) - 1
      );
    }
  }

  // Lastly delete any cells with no edges; these were entirely clipped.
  for (iCell = 0; iCell < nCells; ++iCell) {
    if (cell = __WEBPACK_IMPORTED_MODULE_1__Diagram__["c" /* cells */][iCell]) {
      if (!cell.halfedges.length) {
        delete __WEBPACK_IMPORTED_MODULE_1__Diagram__["c" /* cells */][iCell];
      }
    }
  }
}


/***/ }),
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return firstCircle; });
/* harmony export (immutable) */ __webpack_exports__["c"] = attachCircle;
/* harmony export (immutable) */ __webpack_exports__["b"] = detachCircle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RedBlackTree__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Diagram__ = __webpack_require__(124);



var circlePool = [];

var firstCircle;

function Circle() {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__RedBlackTree__["b" /* RedBlackNode */])(this);
  this.x =
  this.y =
  this.arc =
  this.site =
  this.cy = null;
}

function attachCircle(arc) {
  var lArc = arc.P,
      rArc = arc.N;

  if (!lArc || !rArc) return;

  var lSite = lArc.site,
      cSite = arc.site,
      rSite = rArc.site;

  if (lSite === rSite) return;

  var bx = cSite[0],
      by = cSite[1],
      ax = lSite[0] - bx,
      ay = lSite[1] - by,
      cx = rSite[0] - bx,
      cy = rSite[1] - by;

  var d = 2 * (ax * cy - ay * cx);
  if (d >= -__WEBPACK_IMPORTED_MODULE_1__Diagram__["f" /* epsilon2 */]) return;

  var ha = ax * ax + ay * ay,
      hc = cx * cx + cy * cy,
      x = (cy * ha - ay * hc) / d,
      y = (ax * hc - cx * ha) / d;

  var circle = circlePool.pop() || new Circle;
  circle.arc = arc;
  circle.site = cSite;
  circle.x = x + bx;
  circle.y = (circle.cy = y + by) + Math.sqrt(x * x + y * y); // y bottom

  arc.circle = circle;

  var before = null,
      node = __WEBPACK_IMPORTED_MODULE_1__Diagram__["g" /* circles */]._;

  while (node) {
    if (circle.y < node.y || (circle.y === node.y && circle.x <= node.x)) {
      if (node.L) node = node.L;
      else { before = node.P; break; }
    } else {
      if (node.R) node = node.R;
      else { before = node; break; }
    }
  }

  __WEBPACK_IMPORTED_MODULE_1__Diagram__["g" /* circles */].insert(before, circle);
  if (!before) firstCircle = circle;
}

function detachCircle(arc) {
  var circle = arc.circle;
  if (circle) {
    if (!circle.P) firstCircle = circle.N;
    __WEBPACK_IMPORTED_MODULE_1__Diagram__["g" /* circles */].remove(circle);
    circlePool.push(circle);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__RedBlackTree__["b" /* RedBlackNode */])(circle);
    arc.circle = null;
  }
}


/***/ }),
/* 456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = Transform;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return identity; });
/* unused harmony export default */
function Transform(k, x, y) {
  this.k = k;
  this.x = x;
  this.y = y;
}

Transform.prototype = {
  constructor: Transform,
  scale: function(k) {
    return k === 1 ? this : new Transform(this.k * k, this.x, this.y);
  },
  translate: function(x, y) {
    return x === 0 & y === 0 ? this : new Transform(this.k, this.x + this.k * x, this.y + this.k * y);
  },
  apply: function(point) {
    return [point[0] * this.k + this.x, point[1] * this.k + this.y];
  },
  applyX: function(x) {
    return x * this.k + this.x;
  },
  applyY: function(y) {
    return y * this.k + this.y;
  },
  invert: function(location) {
    return [(location[0] - this.x) / this.k, (location[1] - this.y) / this.k];
  },
  invertX: function(x) {
    return (x - this.x) / this.k;
  },
  invertY: function(y) {
    return (y - this.y) / this.k;
  },
  rescaleX: function(x) {
    return x.copy().domain(x.range().map(this.invertX, this).map(x.invert, x));
  },
  rescaleY: function(y) {
    return y.copy().domain(y.range().map(this.invertY, this).map(y.invert, y));
  },
  toString: function() {
    return "translate(" + this.x + "," + this.y + ") scale(" + this.k + ")";
  }
};

var identity = new Transform(1, 0, 0);

transform.prototype = Transform.prototype;

function transform(node) {
  return node.__zoom || identity;
}


/***/ }),
/* 457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return WINDOW; });
/* harmony export (immutable) */ __webpack_exports__["b"] = _window;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return WindowTokenModule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(2);


var /** @type {?} */ WINDOW = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["InjectionToken"]('WindowToken');
/**
 * @return {?}
 */
function _window() {
    return window;
}
var WindowTokenModule = (function () {
    function WindowTokenModule() {
    }
    return WindowTokenModule;
}());

WindowTokenModule.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"], args: [{
                providers: [{
                        provide: WINDOW,
                        useFactory: _window
                    }]
            },] },
];
/**
 * @nocollapse
 */
WindowTokenModule.ctorParameters = function () { return []; };
function WindowTokenModule_tsickle_Closure_declarations() {
    /** @type {?} */
    WindowTokenModule.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    WindowTokenModule.ctorParameters;
}
//# sourceMappingURL=ngx-window-token.js.map

/***/ }),
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var fromEvent_1 = __webpack_require__(1241);
Observable_1.Observable.fromEvent = fromEvent_1.fromEvent;
//# sourceMappingURL=fromEvent.js.map

/***/ }),
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var root_1 = __webpack_require__(24);
var tryCatch_1 = __webpack_require__(25);
var errorObject_1 = __webpack_require__(22);
var Observable_1 = __webpack_require__(0);
var Subscriber_1 = __webpack_require__(3);
var map_1 = __webpack_require__(126);
function getCORSRequest() {
    if (root_1.root.XMLHttpRequest) {
        return new root_1.root.XMLHttpRequest();
    }
    else if (!!root_1.root.XDomainRequest) {
        return new root_1.root.XDomainRequest();
    }
    else {
        throw new Error('CORS is not supported by your browser');
    }
}
function getXMLHttpRequest() {
    if (root_1.root.XMLHttpRequest) {
        return new root_1.root.XMLHttpRequest();
    }
    else {
        var progId = void 0;
        try {
            var progIds = ['Msxml2.XMLHTTP', 'Microsoft.XMLHTTP', 'Msxml2.XMLHTTP.4.0'];
            for (var i = 0; i < 3; i++) {
                try {
                    progId = progIds[i];
                    if (new root_1.root.ActiveXObject(progId)) {
                        break;
                    }
                }
                catch (e) {
                }
            }
            return new root_1.root.ActiveXObject(progId);
        }
        catch (e) {
            throw new Error('XMLHttpRequest is not supported by your browser');
        }
    }
}
function ajaxGet(url, headers) {
    if (headers === void 0) { headers = null; }
    return new AjaxObservable({ method: 'GET', url: url, headers: headers });
}
exports.ajaxGet = ajaxGet;
;
function ajaxPost(url, body, headers) {
    return new AjaxObservable({ method: 'POST', url: url, body: body, headers: headers });
}
exports.ajaxPost = ajaxPost;
;
function ajaxDelete(url, headers) {
    return new AjaxObservable({ method: 'DELETE', url: url, headers: headers });
}
exports.ajaxDelete = ajaxDelete;
;
function ajaxPut(url, body, headers) {
    return new AjaxObservable({ method: 'PUT', url: url, body: body, headers: headers });
}
exports.ajaxPut = ajaxPut;
;
function ajaxPatch(url, body, headers) {
    return new AjaxObservable({ method: 'PATCH', url: url, body: body, headers: headers });
}
exports.ajaxPatch = ajaxPatch;
;
function ajaxGetJSON(url, headers) {
    return new AjaxObservable({ method: 'GET', url: url, responseType: 'json', headers: headers })
        .lift(new map_1.MapOperator(function (x, index) { return x.response; }, null));
}
exports.ajaxGetJSON = ajaxGetJSON;
;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var AjaxObservable = (function (_super) {
    __extends(AjaxObservable, _super);
    function AjaxObservable(urlOrRequest) {
        _super.call(this);
        var request = {
            async: true,
            createXHR: function () {
                return this.crossDomain ? getCORSRequest.call(this) : getXMLHttpRequest();
            },
            crossDomain: false,
            withCredentials: false,
            headers: {},
            method: 'GET',
            responseType: 'json',
            timeout: 0
        };
        if (typeof urlOrRequest === 'string') {
            request.url = urlOrRequest;
        }
        else {
            for (var prop in urlOrRequest) {
                if (urlOrRequest.hasOwnProperty(prop)) {
                    request[prop] = urlOrRequest[prop];
                }
            }
        }
        this.request = request;
    }
    AjaxObservable.prototype._subscribe = function (subscriber) {
        return new AjaxSubscriber(subscriber, this.request);
    };
    /**
     * Creates an observable for an Ajax request with either a request object with
     * url, headers, etc or a string for a URL.
     *
     * @example
     * source = Rx.Observable.ajax('/products');
     * source = Rx.Observable.ajax({ url: 'products', method: 'GET' });
     *
     * @param {string|Object} request Can be one of the following:
     *   A string of the URL to make the Ajax call.
     *   An object with the following properties
     *   - url: URL of the request
     *   - body: The body of the request
     *   - method: Method of the request, such as GET, POST, PUT, PATCH, DELETE
     *   - async: Whether the request is async
     *   - headers: Optional headers
     *   - crossDomain: true if a cross domain request, else false
     *   - createXHR: a function to override if you need to use an alternate
     *   XMLHttpRequest implementation.
     *   - resultSelector: a function to use to alter the output value type of
     *   the Observable. Gets {@link AjaxResponse} as an argument.
     * @return {Observable} An observable sequence containing the XMLHttpRequest.
     * @static true
     * @name ajax
     * @owner Observable
    */
    AjaxObservable.create = (function () {
        var create = function (urlOrRequest) {
            return new AjaxObservable(urlOrRequest);
        };
        create.get = ajaxGet;
        create.post = ajaxPost;
        create.delete = ajaxDelete;
        create.put = ajaxPut;
        create.patch = ajaxPatch;
        create.getJSON = ajaxGetJSON;
        return create;
    })();
    return AjaxObservable;
}(Observable_1.Observable));
exports.AjaxObservable = AjaxObservable;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var AjaxSubscriber = (function (_super) {
    __extends(AjaxSubscriber, _super);
    function AjaxSubscriber(destination, request) {
        _super.call(this, destination);
        this.request = request;
        this.done = false;
        var headers = request.headers = request.headers || {};
        // force CORS if requested
        if (!request.crossDomain && !headers['X-Requested-With']) {
            headers['X-Requested-With'] = 'XMLHttpRequest';
        }
        // ensure content type is set
        if (!('Content-Type' in headers) && !(root_1.root.FormData && request.body instanceof root_1.root.FormData) && typeof request.body !== 'undefined') {
            headers['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8';
        }
        // properly serialize body
        request.body = this.serializeBody(request.body, request.headers['Content-Type']);
        this.send();
    }
    AjaxSubscriber.prototype.next = function (e) {
        this.done = true;
        var _a = this, xhr = _a.xhr, request = _a.request, destination = _a.destination;
        var response = new AjaxResponse(e, xhr, request);
        destination.next(response);
    };
    AjaxSubscriber.prototype.send = function () {
        var _a = this, request = _a.request, _b = _a.request, user = _b.user, method = _b.method, url = _b.url, async = _b.async, password = _b.password, headers = _b.headers, body = _b.body;
        var createXHR = request.createXHR;
        var xhr = tryCatch_1.tryCatch(createXHR).call(request);
        if (xhr === errorObject_1.errorObject) {
            this.error(errorObject_1.errorObject.e);
        }
        else {
            this.xhr = xhr;
            // set up the events before open XHR
            // https://developer.mozilla.org/en/docs/Web/API/XMLHttpRequest/Using_XMLHttpRequest
            // You need to add the event listeners before calling open() on the request.
            // Otherwise the progress events will not fire.
            this.setupEvents(xhr, request);
            // open XHR
            var result = void 0;
            if (user) {
                result = tryCatch_1.tryCatch(xhr.open).call(xhr, method, url, async, user, password);
            }
            else {
                result = tryCatch_1.tryCatch(xhr.open).call(xhr, method, url, async);
            }
            if (result === errorObject_1.errorObject) {
                this.error(errorObject_1.errorObject.e);
                return null;
            }
            // timeout, responseType and withCredentials can be set once the XHR is open
            if (async) {
                xhr.timeout = request.timeout;
                xhr.responseType = request.responseType;
            }
            if ('withCredentials' in xhr) {
                xhr.withCredentials = !!request.withCredentials;
            }
            // set headers
            this.setHeaders(xhr, headers);
            // finally send the request
            result = body ? tryCatch_1.tryCatch(xhr.send).call(xhr, body) : tryCatch_1.tryCatch(xhr.send).call(xhr);
            if (result === errorObject_1.errorObject) {
                this.error(errorObject_1.errorObject.e);
                return null;
            }
        }
        return xhr;
    };
    AjaxSubscriber.prototype.serializeBody = function (body, contentType) {
        if (!body || typeof body === 'string') {
            return body;
        }
        else if (root_1.root.FormData && body instanceof root_1.root.FormData) {
            return body;
        }
        if (contentType) {
            var splitIndex = contentType.indexOf(';');
            if (splitIndex !== -1) {
                contentType = contentType.substring(0, splitIndex);
            }
        }
        switch (contentType) {
            case 'application/x-www-form-urlencoded':
                return Object.keys(body).map(function (key) { return (encodeURI(key) + "=" + encodeURI(body[key])); }).join('&');
            case 'application/json':
                return JSON.stringify(body);
            default:
                return body;
        }
    };
    AjaxSubscriber.prototype.setHeaders = function (xhr, headers) {
        for (var key in headers) {
            if (headers.hasOwnProperty(key)) {
                xhr.setRequestHeader(key, headers[key]);
            }
        }
    };
    AjaxSubscriber.prototype.setupEvents = function (xhr, request) {
        var progressSubscriber = request.progressSubscriber;
        function xhrTimeout(e) {
            var _a = xhrTimeout, subscriber = _a.subscriber, progressSubscriber = _a.progressSubscriber, request = _a.request;
            if (progressSubscriber) {
                progressSubscriber.error(e);
            }
            subscriber.error(new AjaxTimeoutError(this, request)); //TODO: Make betterer.
        }
        ;
        xhr.ontimeout = xhrTimeout;
        xhrTimeout.request = request;
        xhrTimeout.subscriber = this;
        xhrTimeout.progressSubscriber = progressSubscriber;
        if (xhr.upload && 'withCredentials' in xhr) {
            if (progressSubscriber) {
                var xhrProgress_1;
                xhrProgress_1 = function (e) {
                    var progressSubscriber = xhrProgress_1.progressSubscriber;
                    progressSubscriber.next(e);
                };
                if (root_1.root.XDomainRequest) {
                    xhr.onprogress = xhrProgress_1;
                }
                else {
                    xhr.upload.onprogress = xhrProgress_1;
                }
                xhrProgress_1.progressSubscriber = progressSubscriber;
            }
            var xhrError_1;
            xhrError_1 = function (e) {
                var _a = xhrError_1, progressSubscriber = _a.progressSubscriber, subscriber = _a.subscriber, request = _a.request;
                if (progressSubscriber) {
                    progressSubscriber.error(e);
                }
                subscriber.error(new AjaxError('ajax error', this, request));
            };
            xhr.onerror = xhrError_1;
            xhrError_1.request = request;
            xhrError_1.subscriber = this;
            xhrError_1.progressSubscriber = progressSubscriber;
        }
        function xhrReadyStateChange(e) {
            var _a = xhrReadyStateChange, subscriber = _a.subscriber, progressSubscriber = _a.progressSubscriber, request = _a.request;
            if (this.readyState === 4) {
                // normalize IE9 bug (http://bugs.jquery.com/ticket/1450)
                var status_1 = this.status === 1223 ? 204 : this.status;
                var response = (this.responseType === 'text' ? (this.response || this.responseText) : this.response);
                // fix status code when it is 0 (0 status is undocumented).
                // Occurs when accessing file resources or on Android 4.1 stock browser
                // while retrieving files from application cache.
                if (status_1 === 0) {
                    status_1 = response ? 200 : 0;
                }
                if (200 <= status_1 && status_1 < 300) {
                    if (progressSubscriber) {
                        progressSubscriber.complete();
                    }
                    subscriber.next(e);
                    subscriber.complete();
                }
                else {
                    if (progressSubscriber) {
                        progressSubscriber.error(e);
                    }
                    subscriber.error(new AjaxError('ajax error ' + status_1, this, request));
                }
            }
        }
        ;
        xhr.onreadystatechange = xhrReadyStateChange;
        xhrReadyStateChange.subscriber = this;
        xhrReadyStateChange.progressSubscriber = progressSubscriber;
        xhrReadyStateChange.request = request;
    };
    AjaxSubscriber.prototype.unsubscribe = function () {
        var _a = this, done = _a.done, xhr = _a.xhr;
        if (!done && xhr && xhr.readyState !== 4 && typeof xhr.abort === 'function') {
            xhr.abort();
        }
        _super.prototype.unsubscribe.call(this);
    };
    return AjaxSubscriber;
}(Subscriber_1.Subscriber));
exports.AjaxSubscriber = AjaxSubscriber;
/**
 * A normalized AJAX response.
 *
 * @see {@link ajax}
 *
 * @class AjaxResponse
 */
var AjaxResponse = (function () {
    function AjaxResponse(originalEvent, xhr, request) {
        this.originalEvent = originalEvent;
        this.xhr = xhr;
        this.request = request;
        this.status = xhr.status;
        this.responseType = xhr.responseType || request.responseType;
        switch (this.responseType) {
            case 'json':
                if ('response' in xhr) {
                    //IE does not support json as responseType, parse it internally
                    this.response = xhr.responseType ? xhr.response : JSON.parse(xhr.response || xhr.responseText || 'null');
                }
                else {
                    this.response = JSON.parse(xhr.responseText || 'null');
                }
                break;
            case 'xml':
                this.response = xhr.responseXML;
                break;
            case 'text':
            default:
                this.response = ('response' in xhr) ? xhr.response : xhr.responseText;
                break;
        }
    }
    return AjaxResponse;
}());
exports.AjaxResponse = AjaxResponse;
/**
 * A normalized AJAX error.
 *
 * @see {@link ajax}
 *
 * @class AjaxError
 */
var AjaxError = (function (_super) {
    __extends(AjaxError, _super);
    function AjaxError(message, xhr, request) {
        _super.call(this, message);
        this.message = message;
        this.xhr = xhr;
        this.request = request;
        this.status = xhr.status;
    }
    return AjaxError;
}(Error));
exports.AjaxError = AjaxError;
/**
 * @see {@link ajax}
 *
 * @class AjaxTimeoutError
 */
var AjaxTimeoutError = (function (_super) {
    __extends(AjaxTimeoutError, _super);
    function AjaxTimeoutError(xhr, request) {
        _super.call(this, 'ajax timeout', xhr, request);
    }
    return AjaxTimeoutError;
}(AjaxError));
exports.AjaxTimeoutError = AjaxTimeoutError;
//# sourceMappingURL=AjaxObservable.js.map

/***/ }),
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(3);
var tryCatch_1 = __webpack_require__(25);
var errorObject_1 = __webpack_require__(22);
/* tslint:enable:max-line-length */
/**
 * Returns an Observable that emits all items emitted by the source Observable that are distinct by comparison from the previous item.
 *
 * If a comparator function is provided, then it will be called for each item to test for whether or not that value should be emitted.
 *
 * If a comparator function is not provided, an equality check is used by default.
 *
 * @example <caption>A simple example with numbers</caption>
 * Observable.of(1, 1, 2, 2, 2, 1, 1, 2, 3, 3, 4)
 *   .distinctUntilChanged()
 *   .subscribe(x => console.log(x)); // 1, 2, 1, 2, 3, 4
 *
 * @example <caption>An example using a compare function</caption>
 * interface Person {
 *    age: number,
 *    name: string
 * }
 *
 * Observable.of<Person>(
 *     { age: 4, name: 'Foo'},
 *     { age: 7, name: 'Bar'},
 *     { age: 5, name: 'Foo'})
 *     { age: 6, name: 'Foo'})
 *     .distinctUntilChanged((p: Person, q: Person) => p.name === q.name)
 *     .subscribe(x => console.log(x));
 *
 * // displays:
 * // { age: 4, name: 'Foo' }
 * // { age: 7, name: 'Bar' }
 * // { age: 5, name: 'Foo' }
 *
 * @see {@link distinct}
 * @see {@link distinctUntilKeyChanged}
 *
 * @param {function} [compare] Optional comparison function called to test if an item is distinct from the previous item in the source.
 * @return {Observable} An Observable that emits items from the source Observable with distinct values.
 * @method distinctUntilChanged
 * @owner Observable
 */
function distinctUntilChanged(compare, keySelector) {
    return this.lift(new DistinctUntilChangedOperator(compare, keySelector));
}
exports.distinctUntilChanged = distinctUntilChanged;
var DistinctUntilChangedOperator = (function () {
    function DistinctUntilChangedOperator(compare, keySelector) {
        this.compare = compare;
        this.keySelector = keySelector;
    }
    DistinctUntilChangedOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new DistinctUntilChangedSubscriber(subscriber, this.compare, this.keySelector));
    };
    return DistinctUntilChangedOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var DistinctUntilChangedSubscriber = (function (_super) {
    __extends(DistinctUntilChangedSubscriber, _super);
    function DistinctUntilChangedSubscriber(destination, compare, keySelector) {
        _super.call(this, destination);
        this.keySelector = keySelector;
        this.hasKey = false;
        if (typeof compare === 'function') {
            this.compare = compare;
        }
    }
    DistinctUntilChangedSubscriber.prototype.compare = function (x, y) {
        return x === y;
    };
    DistinctUntilChangedSubscriber.prototype._next = function (value) {
        var keySelector = this.keySelector;
        var key = value;
        if (keySelector) {
            key = tryCatch_1.tryCatch(this.keySelector)(value);
            if (key === errorObject_1.errorObject) {
                return this.destination.error(errorObject_1.errorObject.e);
            }
        }
        var result = false;
        if (this.hasKey) {
            result = tryCatch_1.tryCatch(this.compare)(this.key, key);
            if (result === errorObject_1.errorObject) {
                return this.destination.error(errorObject_1.errorObject.e);
            }
        }
        else {
            this.hasKey = true;
        }
        if (Boolean(result) === false) {
            this.key = key;
            this.destination.next(value);
        }
    };
    return DistinctUntilChangedSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=distinctUntilChanged.js.map

/***/ }),
/* 479 */,
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(3);
/* tslint:enable:max-line-length */
/**
 * Emits only the first value emitted by the source Observable that meets some
 * condition.
 *
 * <span class="informal">Finds the first value that passes some test and emits
 * that.</span>
 *
 * <img src="./img/find.png" width="100%">
 *
 * `find` searches for the first item in the source Observable that matches the
 * specified condition embodied by the `predicate`, and returns the first
 * occurrence in the source. Unlike {@link first}, the `predicate` is required
 * in `find`, and does not emit an error if a valid value is not found.
 *
 * @example <caption>Find and emit the first click that happens on a DIV element</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.find(ev => ev.target.tagName === 'DIV');
 * result.subscribe(x => console.log(x));
 *
 * @see {@link filter}
 * @see {@link first}
 * @see {@link findIndex}
 * @see {@link take}
 *
 * @param {function(value: T, index: number, source: Observable<T>): boolean} predicate
 * A function called with each item to test for condition matching.
 * @param {any} [thisArg] An optional argument to determine the value of `this`
 * in the `predicate` function.
 * @return {Observable<T>} An Observable of the first item that matches the
 * condition.
 * @method find
 * @owner Observable
 */
function find(predicate, thisArg) {
    if (typeof predicate !== 'function') {
        throw new TypeError('predicate is not a function');
    }
    return this.lift(new FindValueOperator(predicate, this, false, thisArg));
}
exports.find = find;
var FindValueOperator = (function () {
    function FindValueOperator(predicate, source, yieldIndex, thisArg) {
        this.predicate = predicate;
        this.source = source;
        this.yieldIndex = yieldIndex;
        this.thisArg = thisArg;
    }
    FindValueOperator.prototype.call = function (observer, source) {
        return source.subscribe(new FindValueSubscriber(observer, this.predicate, this.source, this.yieldIndex, this.thisArg));
    };
    return FindValueOperator;
}());
exports.FindValueOperator = FindValueOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var FindValueSubscriber = (function (_super) {
    __extends(FindValueSubscriber, _super);
    function FindValueSubscriber(destination, predicate, source, yieldIndex, thisArg) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.source = source;
        this.yieldIndex = yieldIndex;
        this.thisArg = thisArg;
        this.index = 0;
    }
    FindValueSubscriber.prototype.notifyComplete = function (value) {
        var destination = this.destination;
        destination.next(value);
        destination.complete();
    };
    FindValueSubscriber.prototype._next = function (value) {
        var _a = this, predicate = _a.predicate, thisArg = _a.thisArg;
        var index = this.index++;
        try {
            var result = predicate.call(thisArg || this, value, index, this.source);
            if (result) {
                this.notifyComplete(this.yieldIndex ? index : value);
            }
        }
        catch (err) {
            this.destination.error(err);
        }
    };
    FindValueSubscriber.prototype._complete = function () {
        this.notifyComplete(this.yieldIndex ? -1 : undefined);
    };
    return FindValueSubscriber;
}(Subscriber_1.Subscriber));
exports.FindValueSubscriber = FindValueSubscriber;
//# sourceMappingURL=find.js.map

/***/ }),
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var OuterSubscriber_1 = __webpack_require__(6);
var subscribeToResult_1 = __webpack_require__(7);
/* tslint:enable:max-line-length */
/**
 * Projects each source value to the same Observable which is merged multiple
 * times in the output Observable.
 *
 * <span class="informal">It's like {@link mergeMap}, but maps each value always
 * to the same inner Observable.</span>
 *
 * <img src="./img/mergeMapTo.png" width="100%">
 *
 * Maps each source value to the given Observable `innerObservable` regardless
 * of the source value, and then merges those resulting Observables into one
 * single Observable, which is the output Observable.
 *
 * @example <caption>For each click event, start an interval Observable ticking every 1 second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.mergeMapTo(Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link concatMapTo}
 * @see {@link merge}
 * @see {@link mergeAll}
 * @see {@link mergeMap}
 * @see {@link mergeScan}
 * @see {@link switchMapTo}
 *
 * @param {ObservableInput} innerObservable An Observable to replace each value from
 * the source Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
 * Observables being subscribed to concurrently.
 * @return {Observable} An Observable that emits items from the given
 * `innerObservable` (and optionally transformed through `resultSelector`) every
 * time a value is emitted on the source Observable.
 * @method mergeMapTo
 * @owner Observable
 */
function mergeMapTo(innerObservable, resultSelector, concurrent) {
    if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
    if (typeof resultSelector === 'number') {
        concurrent = resultSelector;
        resultSelector = null;
    }
    return this.lift(new MergeMapToOperator(innerObservable, resultSelector, concurrent));
}
exports.mergeMapTo = mergeMapTo;
// TODO: Figure out correct signature here: an Operator<Observable<T>, R>
//       needs to implement call(observer: Subscriber<R>): Subscriber<Observable<T>>
var MergeMapToOperator = (function () {
    function MergeMapToOperator(ish, resultSelector, concurrent) {
        if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
        this.ish = ish;
        this.resultSelector = resultSelector;
        this.concurrent = concurrent;
    }
    MergeMapToOperator.prototype.call = function (observer, source) {
        return source.subscribe(new MergeMapToSubscriber(observer, this.ish, this.resultSelector, this.concurrent));
    };
    return MergeMapToOperator;
}());
exports.MergeMapToOperator = MergeMapToOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var MergeMapToSubscriber = (function (_super) {
    __extends(MergeMapToSubscriber, _super);
    function MergeMapToSubscriber(destination, ish, resultSelector, concurrent) {
        if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
        _super.call(this, destination);
        this.ish = ish;
        this.resultSelector = resultSelector;
        this.concurrent = concurrent;
        this.hasCompleted = false;
        this.buffer = [];
        this.active = 0;
        this.index = 0;
    }
    MergeMapToSubscriber.prototype._next = function (value) {
        if (this.active < this.concurrent) {
            var resultSelector = this.resultSelector;
            var index = this.index++;
            var ish = this.ish;
            var destination = this.destination;
            this.active++;
            this._innerSub(ish, destination, resultSelector, value, index);
        }
        else {
            this.buffer.push(value);
        }
    };
    MergeMapToSubscriber.prototype._innerSub = function (ish, destination, resultSelector, value, index) {
        this.add(subscribeToResult_1.subscribeToResult(this, ish, value, index));
    };
    MergeMapToSubscriber.prototype._complete = function () {
        this.hasCompleted = true;
        if (this.active === 0 && this.buffer.length === 0) {
            this.destination.complete();
        }
    };
    MergeMapToSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        var _a = this, resultSelector = _a.resultSelector, destination = _a.destination;
        if (resultSelector) {
            this.trySelectResult(outerValue, innerValue, outerIndex, innerIndex);
        }
        else {
            destination.next(innerValue);
        }
    };
    MergeMapToSubscriber.prototype.trySelectResult = function (outerValue, innerValue, outerIndex, innerIndex) {
        var _a = this, resultSelector = _a.resultSelector, destination = _a.destination;
        var result;
        try {
            result = resultSelector(outerValue, innerValue, outerIndex, innerIndex);
        }
        catch (err) {
            destination.error(err);
            return;
        }
        destination.next(result);
    };
    MergeMapToSubscriber.prototype.notifyError = function (err) {
        this.destination.error(err);
    };
    MergeMapToSubscriber.prototype.notifyComplete = function (innerSub) {
        var buffer = this.buffer;
        this.remove(innerSub);
        this.active--;
        if (buffer.length > 0) {
            this._next(buffer.shift());
        }
        else if (this.active === 0 && this.hasCompleted) {
            this.destination.complete();
        }
    };
    return MergeMapToSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
exports.MergeMapToSubscriber = MergeMapToSubscriber;
//# sourceMappingURL=mergeMapTo.js.map

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var FromObservable_1 = __webpack_require__(468);
var isArray_1 = __webpack_require__(62);
var OuterSubscriber_1 = __webpack_require__(6);
var subscribeToResult_1 = __webpack_require__(7);
/* tslint:enable:max-line-length */
/**
 * When any of the provided Observable emits an complete or error notification, it immediately subscribes to the next one
 * that was passed.
 *
 * <span class="informal">Execute series of Observables no matter what, even if it means swallowing errors.</span>
 *
 * <img src="./img/onErrorResumeNext.png" width="100%">
 *
 * `onErrorResumeNext` is an operator that accepts a series of Observables, provided either directly as
 * arguments or as an array. If no single Observable is provided, returned Observable will simply behave the same
 * as the source.
 *
 * `onErrorResumeNext` returns an Observable that starts by subscribing and re-emitting values from the source Observable.
 * When its stream of values ends - no matter if Observable completed or emitted an error - `onErrorResumeNext`
 * will subscribe to the first Observable that was passed as an argument to the method. It will start re-emitting
 * its values as well and - again - when that stream ends, `onErrorResumeNext` will proceed to subscribing yet another
 * Observable in provided series, no matter if previous Observable completed or ended with an error. This will
 * be happening until there is no more Observables left in the series, at which point returned Observable will
 * complete - even if the last subscribed stream ended with an error.
 *
 * `onErrorResumeNext` can be therefore thought of as version of {@link concat} operator, which is more permissive
 * when it comes to the errors emitted by its input Observables. While `concat` subscribes to the next Observable
 * in series only if previous one successfully completed, `onErrorResumeNext` subscribes even if it ended with
 * an error.
 *
 * Note that you do not get any access to errors emitted by the Observables. In particular do not
 * expect these errors to appear in error callback passed to {@link subscribe}. If you want to take
 * specific actions based on what error was emitted by an Observable, you should try out {@link catch} instead.
 *
 *
 * @example <caption>Subscribe to the next Observable after map fails</caption>
 * Rx.Observable.of(1, 2, 3, 0)
 *   .map(x => {
 *       if (x === 0) { throw Error(); }
         return 10 / x;
 *   })
 *   .onErrorResumeNext(Rx.Observable.of(1, 2, 3))
 *   .subscribe(
 *     val => console.log(val),
 *     err => console.log(err),          // Will never be called.
 *     () => console.log('that\'s it!')
 *   );
 *
 * // Logs:
 * // 10
 * // 5
 * // 3.3333333333333335
 * // 1
 * // 2
 * // 3
 * // "that's it!"
 *
 * @see {@link concat}
 * @see {@link catch}
 *
 * @param {...ObservableInput} observables Observables passed either directly or as an array.
 * @return {Observable} An Observable that emits values from source Observable, but - if it errors - subscribes
 * to the next passed Observable and so on, until it completes or runs out of Observables.
 * @method onErrorResumeNext
 * @owner Observable
 */
function onErrorResumeNext() {
    var nextSources = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        nextSources[_i - 0] = arguments[_i];
    }
    if (nextSources.length === 1 && isArray_1.isArray(nextSources[0])) {
        nextSources = nextSources[0];
    }
    return this.lift(new OnErrorResumeNextOperator(nextSources));
}
exports.onErrorResumeNext = onErrorResumeNext;
/* tslint:enable:max-line-length */
function onErrorResumeNextStatic() {
    var nextSources = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        nextSources[_i - 0] = arguments[_i];
    }
    var source = null;
    if (nextSources.length === 1 && isArray_1.isArray(nextSources[0])) {
        nextSources = nextSources[0];
    }
    source = nextSources.shift();
    return new FromObservable_1.FromObservable(source, null).lift(new OnErrorResumeNextOperator(nextSources));
}
exports.onErrorResumeNextStatic = onErrorResumeNextStatic;
var OnErrorResumeNextOperator = (function () {
    function OnErrorResumeNextOperator(nextSources) {
        this.nextSources = nextSources;
    }
    OnErrorResumeNextOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new OnErrorResumeNextSubscriber(subscriber, this.nextSources));
    };
    return OnErrorResumeNextOperator;
}());
var OnErrorResumeNextSubscriber = (function (_super) {
    __extends(OnErrorResumeNextSubscriber, _super);
    function OnErrorResumeNextSubscriber(destination, nextSources) {
        _super.call(this, destination);
        this.destination = destination;
        this.nextSources = nextSources;
    }
    OnErrorResumeNextSubscriber.prototype.notifyError = function (error, innerSub) {
        this.subscribeToNextSource();
    };
    OnErrorResumeNextSubscriber.prototype.notifyComplete = function (innerSub) {
        this.subscribeToNextSource();
    };
    OnErrorResumeNextSubscriber.prototype._error = function (err) {
        this.subscribeToNextSource();
    };
    OnErrorResumeNextSubscriber.prototype._complete = function () {
        this.subscribeToNextSource();
    };
    OnErrorResumeNextSubscriber.prototype.subscribeToNextSource = function () {
        var next = this.nextSources.shift();
        if (next) {
            this.add(subscribeToResult_1.subscribeToResult(this, next));
        }
        else {
            this.destination.complete();
        }
    };
    return OnErrorResumeNextSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
//# sourceMappingURL=onErrorResumeNext.js.map

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var isArray_1 = __webpack_require__(62);
var ArrayObservable_1 = __webpack_require__(61);
var OuterSubscriber_1 = __webpack_require__(6);
var subscribeToResult_1 = __webpack_require__(7);
/* tslint:enable:max-line-length */
/**
 * Returns an Observable that mirrors the first source Observable to emit an item
 * from the combination of this Observable and supplied Observables.
 * @param {...Observables} ...observables Sources used to race for which Observable emits first.
 * @return {Observable} An Observable that mirrors the output of the first Observable to emit an item.
 * @method race
 * @owner Observable
 */
function race() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i - 0] = arguments[_i];
    }
    // if the only argument is an array, it was most likely called with
    // `pair([obs1, obs2, ...])`
    if (observables.length === 1 && isArray_1.isArray(observables[0])) {
        observables = observables[0];
    }
    return this.lift.call(raceStatic.apply(void 0, [this].concat(observables)));
}
exports.race = race;
function raceStatic() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i - 0] = arguments[_i];
    }
    // if the only argument is an array, it was most likely called with
    // `race([obs1, obs2, ...])`
    if (observables.length === 1) {
        if (isArray_1.isArray(observables[0])) {
            observables = observables[0];
        }
        else {
            return observables[0];
        }
    }
    return new ArrayObservable_1.ArrayObservable(observables).lift(new RaceOperator());
}
exports.raceStatic = raceStatic;
var RaceOperator = (function () {
    function RaceOperator() {
    }
    RaceOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new RaceSubscriber(subscriber));
    };
    return RaceOperator;
}());
exports.RaceOperator = RaceOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var RaceSubscriber = (function (_super) {
    __extends(RaceSubscriber, _super);
    function RaceSubscriber(destination) {
        _super.call(this, destination);
        this.hasFirst = false;
        this.observables = [];
        this.subscriptions = [];
    }
    RaceSubscriber.prototype._next = function (observable) {
        this.observables.push(observable);
    };
    RaceSubscriber.prototype._complete = function () {
        var observables = this.observables;
        var len = observables.length;
        if (len === 0) {
            this.destination.complete();
        }
        else {
            for (var i = 0; i < len && !this.hasFirst; i++) {
                var observable = observables[i];
                var subscription = subscribeToResult_1.subscribeToResult(this, observable, observable, i);
                if (this.subscriptions) {
                    this.subscriptions.push(subscription);
                }
                this.add(subscription);
            }
            this.observables = null;
        }
    };
    RaceSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        if (!this.hasFirst) {
            this.hasFirst = true;
            for (var i = 0; i < this.subscriptions.length; i++) {
                if (i !== outerIndex) {
                    var subscription = this.subscriptions[i];
                    subscription.unsubscribe();
                    this.remove(subscription);
                }
            }
            this.subscriptions = null;
        }
        this.destination.next(innerValue);
    };
    return RaceSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
exports.RaceSubscriber = RaceSubscriber;
//# sourceMappingURL=race.js.map

/***/ }),
/* 487 */,
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var OuterSubscriber_1 = __webpack_require__(6);
var subscribeToResult_1 = __webpack_require__(7);
exports.defaultThrottleConfig = {
    leading: true,
    trailing: false
};
/**
 * Emits a value from the source Observable, then ignores subsequent source
 * values for a duration determined by another Observable, then repeats this
 * process.
 *
 * <span class="informal">It's like {@link throttleTime}, but the silencing
 * duration is determined by a second Observable.</span>
 *
 * <img src="./img/throttle.png" width="100%">
 *
 * `throttle` emits the source Observable values on the output Observable
 * when its internal timer is disabled, and ignores source values when the timer
 * is enabled. Initially, the timer is disabled. As soon as the first source
 * value arrives, it is forwarded to the output Observable, and then the timer
 * is enabled by calling the `durationSelector` function with the source value,
 * which returns the "duration" Observable. When the duration Observable emits a
 * value or completes, the timer is disabled, and this process repeats for the
 * next source value.
 *
 * @example <caption>Emit clicks at a rate of at most one click per second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.throttle(ev => Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link audit}
 * @see {@link debounce}
 * @see {@link delayWhen}
 * @see {@link sample}
 * @see {@link throttleTime}
 *
 * @param {function(value: T): SubscribableOrPromise} durationSelector A function
 * that receives a value from the source Observable, for computing the silencing
 * duration for each source value, returned as an Observable or a Promise.
 * @param {Object} config a configuration object to define `leading` and `trailing` behavior. Defaults
 * to `{ leading: true, trailing: false }`.
 * @return {Observable<T>} An Observable that performs the throttle operation to
 * limit the rate of emissions from the source.
 * @method throttle
 * @owner Observable
 */
function throttle(durationSelector, config) {
    if (config === void 0) { config = exports.defaultThrottleConfig; }
    return this.lift(new ThrottleOperator(durationSelector, config.leading, config.trailing));
}
exports.throttle = throttle;
var ThrottleOperator = (function () {
    function ThrottleOperator(durationSelector, leading, trailing) {
        this.durationSelector = durationSelector;
        this.leading = leading;
        this.trailing = trailing;
    }
    ThrottleOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new ThrottleSubscriber(subscriber, this.durationSelector, this.leading, this.trailing));
    };
    return ThrottleOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc
 * @ignore
 * @extends {Ignored}
 */
var ThrottleSubscriber = (function (_super) {
    __extends(ThrottleSubscriber, _super);
    function ThrottleSubscriber(destination, durationSelector, _leading, _trailing) {
        _super.call(this, destination);
        this.destination = destination;
        this.durationSelector = durationSelector;
        this._leading = _leading;
        this._trailing = _trailing;
        this._hasTrailingValue = false;
    }
    ThrottleSubscriber.prototype._next = function (value) {
        if (this.throttled) {
            if (this._trailing) {
                this._hasTrailingValue = true;
                this._trailingValue = value;
            }
        }
        else {
            var duration = this.tryDurationSelector(value);
            if (duration) {
                this.add(this.throttled = subscribeToResult_1.subscribeToResult(this, duration));
            }
            if (this._leading) {
                this.destination.next(value);
                if (this._trailing) {
                    this._hasTrailingValue = true;
                    this._trailingValue = value;
                }
            }
        }
    };
    ThrottleSubscriber.prototype.tryDurationSelector = function (value) {
        try {
            return this.durationSelector(value);
        }
        catch (err) {
            this.destination.error(err);
            return null;
        }
    };
    ThrottleSubscriber.prototype._unsubscribe = function () {
        var _a = this, throttled = _a.throttled, _trailingValue = _a._trailingValue, _hasTrailingValue = _a._hasTrailingValue, _trailing = _a._trailing;
        this._trailingValue = null;
        this._hasTrailingValue = false;
        if (throttled) {
            this.remove(throttled);
            this.throttled = null;
            throttled.unsubscribe();
        }
    };
    ThrottleSubscriber.prototype._sendTrailing = function () {
        var _a = this, destination = _a.destination, throttled = _a.throttled, _trailing = _a._trailing, _trailingValue = _a._trailingValue, _hasTrailingValue = _a._hasTrailingValue;
        if (throttled && _trailing && _hasTrailingValue) {
            destination.next(_trailingValue);
            this._trailingValue = null;
            this._hasTrailingValue = false;
        }
    };
    ThrottleSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this._sendTrailing();
        this._unsubscribe();
    };
    ThrottleSubscriber.prototype.notifyComplete = function () {
        this._sendTrailing();
        this._unsubscribe();
    };
    return ThrottleSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
//# sourceMappingURL=throttle.js.map

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(3);
var async_1 = __webpack_require__(30);
/**
 * @param scheduler
 * @return {Observable<TimeInterval<any>>|WebSocketSubject<T>|Observable<T>}
 * @method timeInterval
 * @owner Observable
 */
function timeInterval(scheduler) {
    if (scheduler === void 0) { scheduler = async_1.async; }
    return this.lift(new TimeIntervalOperator(scheduler));
}
exports.timeInterval = timeInterval;
var TimeInterval = (function () {
    function TimeInterval(value, interval) {
        this.value = value;
        this.interval = interval;
    }
    return TimeInterval;
}());
exports.TimeInterval = TimeInterval;
;
var TimeIntervalOperator = (function () {
    function TimeIntervalOperator(scheduler) {
        this.scheduler = scheduler;
    }
    TimeIntervalOperator.prototype.call = function (observer, source) {
        return source.subscribe(new TimeIntervalSubscriber(observer, this.scheduler));
    };
    return TimeIntervalOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var TimeIntervalSubscriber = (function (_super) {
    __extends(TimeIntervalSubscriber, _super);
    function TimeIntervalSubscriber(destination, scheduler) {
        _super.call(this, destination);
        this.scheduler = scheduler;
        this.lastTime = 0;
        this.lastTime = scheduler.now();
    }
    TimeIntervalSubscriber.prototype._next = function (value) {
        var now = this.scheduler.now();
        var span = now - this.lastTime;
        this.lastTime = now;
        this.destination.next(new TimeInterval(value, span));
    };
    return TimeIntervalSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=timeInterval.js.map

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(3);
var async_1 = __webpack_require__(30);
/**
 * @param scheduler
 * @return {Observable<Timestamp<any>>|WebSocketSubject<T>|Observable<T>}
 * @method timestamp
 * @owner Observable
 */
function timestamp(scheduler) {
    if (scheduler === void 0) { scheduler = async_1.async; }
    return this.lift(new TimestampOperator(scheduler));
}
exports.timestamp = timestamp;
var Timestamp = (function () {
    function Timestamp(value, timestamp) {
        this.value = value;
        this.timestamp = timestamp;
    }
    return Timestamp;
}());
exports.Timestamp = Timestamp;
;
var TimestampOperator = (function () {
    function TimestampOperator(scheduler) {
        this.scheduler = scheduler;
    }
    TimestampOperator.prototype.call = function (observer, source) {
        return source.subscribe(new TimestampSubscriber(observer, this.scheduler));
    };
    return TimestampOperator;
}());
var TimestampSubscriber = (function (_super) {
    __extends(TimestampSubscriber, _super);
    function TimestampSubscriber(destination, scheduler) {
        _super.call(this, destination);
        this.scheduler = scheduler;
    }
    TimestampSubscriber.prototype._next = function (value) {
        var now = this.scheduler.now();
        this.destination.next(new Timestamp(value, now));
    };
    return TimestampSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=timestamp.js.map

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var AsyncAction_1 = __webpack_require__(128);
var AsyncScheduler_1 = __webpack_require__(129);
var VirtualTimeScheduler = (function (_super) {
    __extends(VirtualTimeScheduler, _super);
    function VirtualTimeScheduler(SchedulerAction, maxFrames) {
        var _this = this;
        if (SchedulerAction === void 0) { SchedulerAction = VirtualAction; }
        if (maxFrames === void 0) { maxFrames = Number.POSITIVE_INFINITY; }
        _super.call(this, SchedulerAction, function () { return _this.frame; });
        this.maxFrames = maxFrames;
        this.frame = 0;
        this.index = -1;
    }
    /**
     * Prompt the Scheduler to execute all of its queued actions, therefore
     * clearing its queue.
     * @return {void}
     */
    VirtualTimeScheduler.prototype.flush = function () {
        var _a = this, actions = _a.actions, maxFrames = _a.maxFrames;
        var error, action;
        while ((action = actions.shift()) && (this.frame = action.delay) <= maxFrames) {
            if (error = action.execute(action.state, action.delay)) {
                break;
            }
        }
        if (error) {
            while (action = actions.shift()) {
                action.unsubscribe();
            }
            throw error;
        }
    };
    VirtualTimeScheduler.frameTimeFactor = 10;
    return VirtualTimeScheduler;
}(AsyncScheduler_1.AsyncScheduler));
exports.VirtualTimeScheduler = VirtualTimeScheduler;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var VirtualAction = (function (_super) {
    __extends(VirtualAction, _super);
    function VirtualAction(scheduler, work, index) {
        if (index === void 0) { index = scheduler.index += 1; }
        _super.call(this, scheduler, work);
        this.scheduler = scheduler;
        this.work = work;
        this.index = index;
        this.active = true;
        this.index = scheduler.index = index;
    }
    VirtualAction.prototype.schedule = function (state, delay) {
        if (delay === void 0) { delay = 0; }
        if (!this.id) {
            return _super.prototype.schedule.call(this, state, delay);
        }
        this.active = false;
        // If an action is rescheduled, we save allocations by mutating its state,
        // pushing it to the end of the scheduler queue, and recycling the action.
        // But since the VirtualTimeScheduler is used for testing, VirtualActions
        // must be immutable so they can be inspected later.
        var action = new VirtualAction(this.scheduler, this.work);
        this.add(action);
        return action.schedule(state, delay);
    };
    VirtualAction.prototype.requestAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) { delay = 0; }
        this.delay = scheduler.frame + delay;
        var actions = scheduler.actions;
        actions.push(this);
        actions.sort(VirtualAction.sortActions);
        return true;
    };
    VirtualAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) { delay = 0; }
        return undefined;
    };
    VirtualAction.prototype._execute = function (state, delay) {
        if (this.active === true) {
            return _super.prototype._execute.call(this, state, delay);
        }
    };
    VirtualAction.sortActions = function (a, b) {
        if (a.delay === b.delay) {
            if (a.index === b.index) {
                return 0;
            }
            else if (a.index > b.index) {
                return 1;
            }
            else {
                return -1;
            }
        }
        else if (a.delay > b.delay) {
            return 1;
        }
        else {
            return -1;
        }
    };
    return VirtualAction;
}(AsyncAction_1.AsyncAction));
exports.VirtualAction = VirtualAction;
//# sourceMappingURL=VirtualTimeScheduler.js.map

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var AsapAction_1 = __webpack_require__(1334);
var AsapScheduler_1 = __webpack_require__(1335);
/**
 *
 * Asap Scheduler
 *
 * <span class="informal">Perform task as fast as it can be performed asynchronously</span>
 *
 * `asap` scheduler behaves the same as {@link async} scheduler when you use it to delay task
 * in time. If however you set delay to `0`, `asap` will wait for current synchronously executing
 * code to end and then it will try to execute given task as fast as possible.
 *
 * `asap` scheduler will do its best to minimize time between end of currently executing code
 * and start of scheduled task. This makes it best candidate for performing so called "deferring".
 * Traditionally this was achieved by calling `setTimeout(deferredTask, 0)`, but that technique involves
 * some (although minimal) unwanted delay.
 *
 * Note that using `asap` scheduler does not necessarily mean that your task will be first to process
 * after currently executing code. In particular, if some task was also scheduled with `asap` before,
 * that task will execute first. That being said, if you need to schedule task asynchronously, but
 * as soon as possible, `asap` scheduler is your best bet.
 *
 * @example <caption>Compare async and asap scheduler</caption>
 *
 * Rx.Scheduler.async.schedule(() => console.log('async')); // scheduling 'async' first...
 * Rx.Scheduler.asap.schedule(() => console.log('asap'));
 *
 * // Logs:
 * // "asap"
 * // "async"
 * // ... but 'asap' goes first!
 *
 * @static true
 * @name asap
 * @owner Scheduler
 */
exports.asap = new AsapScheduler_1.AsapScheduler(AsapAction_1.AsapAction);
//# sourceMappingURL=asap.js.map

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var QueueAction_1 = __webpack_require__(1336);
var QueueScheduler_1 = __webpack_require__(1337);
/**
 *
 * Queue Scheduler
 *
 * <span class="informal">Put every next task on a queue, instead of executing it immediately</span>
 *
 * `queue` scheduler, when used with delay, behaves the same as {@link async} scheduler.
 *
 * When used without delay, it schedules given task synchronously - executes it right when
 * it is scheduled. However when called recursively, that is when inside the scheduled task,
 * another task is scheduled with queue scheduler, instead of executing immediately as well,
 * that task will be put on a queue and wait for current one to finish.
 *
 * This means that when you execute task with `queue` scheduler, you are sure it will end
 * before any other task scheduled with that scheduler will start.
 *
 * @examples <caption>Schedule recursively first, then do something</caption>
 *
 * Rx.Scheduler.queue.schedule(() => {
 *   Rx.Scheduler.queue.schedule(() => console.log('second')); // will not happen now, but will be put on a queue
 *
 *   console.log('first');
 * });
 *
 * // Logs:
 * // "first"
 * // "second"
 *
 *
 * @example <caption>Reschedule itself recursively</caption>
 *
 * Rx.Scheduler.queue.schedule(function(state) {
 *   if (state !== 0) {
 *     console.log('before', state);
 *     this.schedule(state - 1); // `this` references currently executing Action,
 *                               // which we reschedule with new state
 *     console.log('after', state);
 *   }
 * }, 0, 3);
 *
 * // In scheduler that runs recursively, you would expect:
 * // "before", 3
 * // "before", 2
 * // "before", 1
 * // "after", 1
 * // "after", 2
 * // "after", 3
 *
 * // But with queue it logs:
 * // "before", 3
 * // "after", 3
 * // "before", 2
 * // "after", 2
 * // "before", 1
 * // "after", 1
 *
 *
 * @static true
 * @name queue
 * @owner Scheduler
 */
exports.queue = new QueueScheduler_1.QueueScheduler(QueueAction_1.QueueAction);
//# sourceMappingURL=queue.js.map

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var SubscriptionLog = (function () {
    function SubscriptionLog(subscribedFrame, unsubscribedFrame) {
        if (unsubscribedFrame === void 0) { unsubscribedFrame = Number.POSITIVE_INFINITY; }
        this.subscribedFrame = subscribedFrame;
        this.unsubscribedFrame = unsubscribedFrame;
    }
    return SubscriptionLog;
}());
exports.SubscriptionLog = SubscriptionLog;
//# sourceMappingURL=SubscriptionLog.js.map

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var SubscriptionLog_1 = __webpack_require__(494);
var SubscriptionLoggable = (function () {
    function SubscriptionLoggable() {
        this.subscriptions = [];
    }
    SubscriptionLoggable.prototype.logSubscribedFrame = function () {
        this.subscriptions.push(new SubscriptionLog_1.SubscriptionLog(this.scheduler.now()));
        return this.subscriptions.length - 1;
    };
    SubscriptionLoggable.prototype.logUnsubscribedFrame = function (index) {
        var subscriptionLogs = this.subscriptions;
        var oldSubscriptionLog = subscriptionLogs[index];
        subscriptionLogs[index] = new SubscriptionLog_1.SubscriptionLog(oldSubscriptionLog.subscribedFrame, this.scheduler.now());
    };
    return SubscriptionLoggable;
}());
exports.SubscriptionLoggable = SubscriptionLoggable;
//# sourceMappingURL=SubscriptionLoggable.js.map

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * An error thrown when duetime elapses.
 *
 * @see {@link timeout}
 *
 * @class TimeoutError
 */
var TimeoutError = (function (_super) {
    __extends(TimeoutError, _super);
    function TimeoutError() {
        var err = _super.call(this, 'Timeout has occurred');
        this.name = err.name = 'TimeoutError';
        this.stack = err.stack;
        this.message = err.message;
    }
    return TimeoutError;
}(Error));
exports.TimeoutError = TimeoutError;
//# sourceMappingURL=TimeoutError.js.map

/***/ }),
/* 497 */,
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function applyMixins(derivedCtor, baseCtors) {
    for (var i = 0, len = baseCtors.length; i < len; i++) {
        var baseCtor = baseCtors[i];
        var propertyKeys = Object.getOwnPropertyNames(baseCtor.prototype);
        for (var j = 0, len2 = propertyKeys.length; j < len2; j++) {
            var name_1 = propertyKeys[j];
            derivedCtor.prototype[name_1] = baseCtor.prototype[name_1];
        }
    }
}
exports.applyMixins = applyMixins;
//# sourceMappingURL=applyMixins.js.map

/***/ }),
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* tslint:disable:no-empty */
function noop() { }
exports.noop = noop;
//# sourceMappingURL=noop.js.map

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(1351);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(93)))

/***/ }),
/* 504 */,
/* 505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AppModuleNgFactory; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_app_app_module__ = __webpack_require__(568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_app_app_component__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modals_about_about_dialog_component_ngfactory__ = __webpack_require__(554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modals_billing_billing_dialog_component_ngfactory__ = __webpack_require__(556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__licensing_licensing_modal_component_ngfactory__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__main_dashboard_component_ngfactory__ = __webpack_require__(543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__main_config_config_component_ngfactory__ = __webpack_require__(541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__main_history_history_component_ngfactory__ = __webpack_require__(549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__trial_trial_component_ngfactory__ = __webpack_require__(565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__login_user_login_component_ngfactory__ = __webpack_require__(539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__licensing_licensing_component_ngfactory__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__release_notes_release_notes_component_ngfactory__ = __webpack_require__(564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__app_component_ngfactory__ = __webpack_require__(529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__angular_common__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__angular_platform_browser__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__angular_animations_browser__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__angular_platform_browser_animations__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__angular_http__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__src_app_aws_sdk__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__src_app_aws_signature__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__src_app_aws_environment__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__src_app_aws_http__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__angular_forms__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__src_app_mqtt_mqtt_service__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__src_app_publisher_publisher_service__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__src_app_restapi_error_handler__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__src_app_user_preferences_service__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__src_app_user_user_service__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__angular_router__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__src_app_systeminformation_systeminformation_service__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__src_app_util_observable_utils__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__src_app_billing_billing_service__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__src_app_main_target_validation_target_validation_service__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__src_app_headerfooter_setting_entries_target_validation_entry__ = __webpack_require__(585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__src_app_headerfooter_setting_entries_tos_entry__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__src_app_headerfooter_setting_entries_billing_entry__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__src_app_headerfooter_setting_entries_help_entry__ = __webpack_require__(580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__src_app_headerfooter_setting_entries_help_pdf_entry__ = __webpack_require__(581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__src_app_headerfooter_setting_entries_api_help_entry__ = __webpack_require__(577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__src_app_headerfooter_setting_entries_api_help_pdf_entry__ = __webpack_require__(578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__src_app_headerfooter_setting_entries_python_api_entry__ = __webpack_require__(583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__src_app_headerfooter_setting_entries_support_entry__ = __webpack_require__(584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__src_app_headerfooter_setting_entries_about_entry__ = __webpack_require__(576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__src_app_headerfooter_setting_entries_logout_entry__ = __webpack_require__(582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__src_app_headerfooter_header_service__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__src_app_login_user_login_service__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__swimlane_ngx_datatable_release_services_scrollbar_helper_service__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__swimlane_ngx_datatable_release_services_scrollbar_helper_service___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_47__swimlane_ngx_datatable_release_services_scrollbar_helper_service__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__angular_animations__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49_ngx_window_token_dist_src_ngx_window_token__ = __webpack_require__(457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50_ngx_clipboard_src_clipboard_service__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__src_app_attack_attack_service__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__src_app_main_config_config_service__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__src_app_notifier_notifier_service__ = __webpack_require__(594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__src_app_modals_modal_service__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__src_app_router_auth_guard_service__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__src_app_trial_trial_service__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__src_app_router_trial_auth_guard_service__ = __webpack_require__(600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__src_app_main_dashboard_component__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__src_app_main_config_config_component__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__src_app_main_history_history_component__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__src_app_trial_trial_component__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__src_app_login_user_login_component__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__src_app_licensing_licensing_component__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__src_app_release_notes_release_notes_component__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__src_app_aws_aws_module__ = __webpack_require__(569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__src_app_mqtt_mqtt_module__ = __webpack_require__(592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__src_app_publisher_publisher_module__ = __webpack_require__(598);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__src_app_user_user_module__ = __webpack_require__(603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__src_app_progress_progress_module__ = __webpack_require__(597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__src_app_systeminformation_systeminformation_module__ = __webpack_require__(601);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__src_app_util_util_module__ = __webpack_require__(605);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__src_app_billing_billing_module__ = __webpack_require__(571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__src_app_modals_modals_module__ = __webpack_require__(591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__src_app_headerfooter_headerfooter_module__ = __webpack_require__(575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__src_app_licensing_licensing_module__ = __webpack_require__(586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__src_app_restapi_restapi_module__ = __webpack_require__(599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__src_app_login_login_module__ = __webpack_require__(587);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__src_app_main_main_routing_module__ = __webpack_require__(588);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__swimlane_ngx_datatable_release_datatable_module__ = __webpack_require__(614);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__swimlane_ngx_datatable_release_datatable_module___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_79__swimlane_ngx_datatable_release_datatable_module__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__src_app_pipes_pipes_module__ = __webpack_require__(595);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81_ngx_clipboard_src_index__ = __webpack_require__(567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__src_app_main_main_module__ = __webpack_require__(589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__src_app_tree_tree_module__ = __webpack_require__(602);
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */




















































































var AppModuleNgFactory = __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵcmf"](__WEBPACK_IMPORTED_MODULE_1__src_app_app_module__["a" /* AppModule */], [__WEBPACK_IMPORTED_MODULE_2__src_app_app_component__["a" /* AppComponent */]], function (_l) {
    return __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵmod"]([__WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵmpd"](512, __WEBPACK_IMPORTED_MODULE_0__angular_core__["ComponentFactoryResolver"], __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵCodegenComponentFactoryResolver"], [[8, [__WEBPACK_IMPORTED_MODULE_3__modals_about_about_dialog_component_ngfactory__["a" /* AboutDialogComponentNgFactory */], __WEBPACK_IMPORTED_MODULE_4__modals_billing_billing_dialog_component_ngfactory__["a" /* BillingDialogNgFactory */], __WEBPACK_IMPORTED_MODULE_5__licensing_licensing_modal_component_ngfactory__["a" /* LicensingModalNgFactory */],
                    __WEBPACK_IMPORTED_MODULE_6__main_dashboard_component_ngfactory__["a" /* DashboardComponentNgFactory */], __WEBPACK_IMPORTED_MODULE_7__main_config_config_component_ngfactory__["a" /* ConfigComponentNgFactory */], __WEBPACK_IMPORTED_MODULE_8__main_history_history_component_ngfactory__["a" /* HistoryComponentNgFactory */],
                    __WEBPACK_IMPORTED_MODULE_9__trial_trial_component_ngfactory__["a" /* TrialComponentNgFactory */], __WEBPACK_IMPORTED_MODULE_10__login_user_login_component_ngfactory__["a" /* UserLoginComponentNgFactory */], __WEBPACK_IMPORTED_MODULE_11__licensing_licensing_component_ngfactory__["a" /* LicensingComponentNgFactory */],
                    __WEBPACK_IMPORTED_MODULE_12__release_notes_release_notes_component_ngfactory__["a" /* ReleaseNotesComponentNgFactory */], __WEBPACK_IMPORTED_MODULE_13__app_component_ngfactory__["a" /* AppComponentNgFactory */]]], [3, __WEBPACK_IMPORTED_MODULE_0__angular_core__["ComponentFactoryResolver"]],
            __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModuleRef"]]), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵmpd"](5120, __WEBPACK_IMPORTED_MODULE_0__angular_core__["LOCALE_ID"], __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵm"], [[3, __WEBPACK_IMPORTED_MODULE_0__angular_core__["LOCALE_ID"]]]),
        __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵmpd"](4608, __WEBPACK_IMPORTED_MODULE_14__angular_common__["NgLocalization"], __WEBPACK_IMPORTED_MODULE_14__angular_common__["NgLocaleLocalization"], [__WEBPACK_IMPORTED_MODULE_0__angular_core__["LOCALE_ID"]]),
        __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵmpd"](5120, __WEBPACK_IMPORTED_MODULE_0__angular_core__["APP_ID"], __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵf"], []), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵmpd"](5120, __WEBPACK_IMPORTED_MODULE_0__angular_core__["IterableDiffers"], __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵk"], []), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵmpd"](5120, __WEBPACK_IMPORTED_MODULE_0__angular_core__["KeyValueDiffers"], __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵl"], []),
        __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵmpd"](4608, __WEBPACK_IMPORTED_MODULE_15__angular_platform_browser__["DomSanitizer"], __WEBPACK_IMPORTED_MODULE_15__angular_platform_browser__["ɵe"], [__WEBPACK_IMPORTED_MODULE_14__angular_common__["DOCUMENT"]]), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵmpd"](6144, __WEBPACK_IMPORTED_MODULE_0__angular_core__["Sanitizer"], null, [__WEBPACK_IMPORTED_MODULE_15__angular_platform_browser__["DomSanitizer"]]), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵmpd"](4608, __WEBPACK_IMPORTED_MODULE_15__angular_platform_browser__["HAMMER_GESTURE_CONFIG"], __WEBPACK_IMPORTED_MODULE_15__angular_platform_browser__["HammerGestureConfig"], []), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵmpd"](5120, __WEBPACK_IMPORTED_MODULE_15__angular_platform_browser__["EVENT_MANAGER_PLUGINS"], function (p0_0, p1_0, p2_0, p2_1) {
            return [new __WEBPACK_IMPORTED_MODULE_15__angular_platform_browser__["ɵDomEventsPlugin"](p0_0), new __WEBPACK_IMPORTED_MODULE_15__angular_platform_browser__["ɵKeyEventsPlugin"](p1_0),
                new __WEBPACK_IMPORTED_MODULE_15__angular_platform_browser__["ɵHammerGesturesPlugin"](p2_0, p2_1)];
        }, [__WEBPACK_IMPORTED_MODULE_14__angular_common__["DOCUMENT"], __WEBPACK_IMPORTED_MODULE_14__angular_common__["DOCUMENT"], __WEBPACK_IMPORTED_MODULE_14__angular_common__["DOCUMENT"], __WEBPACK_IMPORTED_MODULE_15__angular_platform_browser__["HAMMER_GESTURE_CONFIG"]]),
        __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵmpd"](4608, __WEBPACK_IMPORTED_MODULE_15__angular_platform_browser__["EventManager"], __WEBPACK_IMPORTED_MODULE_15__angular_platform_browser__["EventManager"], [__WEBPACK_IMPORTED_MODULE_15__angular_platform_browser__["EVENT_MANAGER_PLUGINS"],
            __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgZone"]]), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵmpd"](135680, __WEBPACK_IMPORTED_MODULE_15__angular_platform_browser__["ɵDomSharedStylesHost"], __WEBPACK_IMPORTED_MODULE_15__angular_platform_browser__["ɵDomSharedStylesHost"], [__WEBPACK_IMPORTED_MODULE_14__angular_common__["DOCUMENT"]]), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵmpd"](4608, __WEBPACK_IMPORTED_MODULE_15__angular_platform_browser__["ɵDomRendererFactory2"], __WEBPACK_IMPORTED_MODULE_15__angular_platform_browser__["ɵDomRendererFactory2"], [__WEBPACK_IMPORTED_MODULE_15__angular_platform_browser__["EventManager"], __WEBPACK_IMPORTED_MODULE_15__angular_platform_browser__["ɵDomSharedStylesHost"]]), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵmpd"](5120, __WEBPACK_IMPORTED_MODULE_16__angular_animations_browser__["a" /* AnimationDriver */], __WEBPACK_IMPORTED_MODULE_17__angular_platform_browser_animations__["a" /* ɵc */], []), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵmpd"](5120, __WEBPACK_IMPORTED_MODULE_16__angular_animations_browser__["b" /* ɵAnimationStyleNormalizer */], __WEBPACK_IMPORTED_MODULE_17__angular_platform_browser_animations__["b" /* ɵd */], []), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵmpd"](4608, __WEBPACK_IMPORTED_MODULE_16__angular_animations_browser__["c" /* ɵAnimationEngine */], __WEBPACK_IMPORTED_MODULE_17__angular_platform_browser_animations__["c" /* ɵb */], [__WEBPACK_IMPORTED_MODULE_16__angular_animations_browser__["a" /* AnimationDriver */],
            __WEBPACK_IMPORTED_MODULE_16__angular_animations_browser__["b" /* ɵAnimationStyleNormalizer */]]), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵmpd"](5120, __WEBPACK_IMPORTED_MODULE_0__angular_core__["RendererFactory2"], __WEBPACK_IMPORTED_MODULE_17__angular_platform_browser_animations__["d" /* ɵe */], [__WEBPACK_IMPORTED_MODULE_15__angular_platform_browser__["ɵDomRendererFactory2"], __WEBPACK_IMPORTED_MODULE_16__angular_animations_browser__["c" /* ɵAnimationEngine */], __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgZone"]]), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵmpd"](6144, __WEBPACK_IMPORTED_MODULE_15__angular_platform_browser__["ɵSharedStylesHost"], null, [__WEBPACK_IMPORTED_MODULE_15__angular_platform_browser__["ɵDomSharedStylesHost"]]), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵmpd"](4608, __WEBPACK_IMPORTED_MODULE_0__angular_core__["Testability"], __WEBPACK_IMPORTED_MODULE_0__angular_core__["Testability"], [__WEBPACK_IMPORTED_MODULE_0__angular_core__["NgZone"]]), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵmpd"](4608, __WEBPACK_IMPORTED_MODULE_15__angular_platform_browser__["Meta"], __WEBPACK_IMPORTED_MODULE_15__angular_platform_browser__["Meta"], [__WEBPACK_IMPORTED_MODULE_14__angular_common__["DOCUMENT"]]), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵmpd"](4608, __WEBPACK_IMPORTED_MODULE_15__angular_platform_browser__["Title"], __WEBPACK_IMPORTED_MODULE_15__angular_platform_browser__["Title"], [__WEBPACK_IMPORTED_MODULE_14__angular_common__["DOCUMENT"]]), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵmpd"](4608, __WEBPACK_IMPORTED_MODULE_18__angular_http__["a" /* BrowserXhr */], __WEBPACK_IMPORTED_MODULE_18__angular_http__["a" /* BrowserXhr */], []), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵmpd"](4608, __WEBPACK_IMPORTED_MODULE_18__angular_http__["b" /* ResponseOptions */], __WEBPACK_IMPORTED_MODULE_18__angular_http__["c" /* BaseResponseOptions */], []), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵmpd"](5120, __WEBPACK_IMPORTED_MODULE_18__angular_http__["d" /* XSRFStrategy */], __WEBPACK_IMPORTED_MODULE_18__angular_http__["e" /* ɵb */], []), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵmpd"](4608, __WEBPACK_IMPORTED_MODULE_18__angular_http__["f" /* XHRBackend */], __WEBPACK_IMPORTED_MODULE_18__angular_http__["f" /* XHRBackend */], [__WEBPACK_IMPORTED_MODULE_18__angular_http__["a" /* BrowserXhr */],
            __WEBPACK_IMPORTED_MODULE_18__angular_http__["b" /* ResponseOptions */], __WEBPACK_IMPORTED_MODULE_18__angular_http__["d" /* XSRFStrategy */]]), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵmpd"](4608, __WEBPACK_IMPORTED_MODULE_18__angular_http__["g" /* RequestOptions */], __WEBPACK_IMPORTED_MODULE_18__angular_http__["h" /* BaseRequestOptions */], []), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵmpd"](5120, __WEBPACK_IMPORTED_MODULE_18__angular_http__["i" /* Http */], __WEBPACK_IMPORTED_MODULE_18__angular_http__["j" /* ɵc */], [__WEBPACK_IMPORTED_MODULE_18__angular_http__["f" /* XHRBackend */],
            __WEBPACK_IMPORTED_MODULE_18__angular_http__["g" /* RequestOptions */]]), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵmpd"](4608, __WEBPACK_IMPORTED_MODULE_19__src_app_aws_sdk__["a" /* AwsSdk */], __WEBPACK_IMPORTED_MODULE_19__src_app_aws_sdk__["a" /* AwsSdk */], []),
        __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵmpd"](4608, __WEBPACK_IMPORTED_MODULE_20__src_app_aws_signature__["a" /* AwsSignature */], __WEBPACK_IMPORTED_MODULE_20__src_app_aws_signature__["a" /* AwsSignature */], []), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵmpd"](5120, __WEBPACK_IMPORTED_MODULE_21__src_app_aws_environment__["a" /* AwsEnvironment */], __WEBPACK_IMPORTED_MODULE_21__src_app_aws_environment__["b" /* createAwsEnv */], []), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵmpd"](4608, __WEBPACK_IMPORTED_MODULE_22__src_app_aws_http__["a" /* AwsHttp */], __WEBPACK_IMPORTED_MODULE_22__src_app_aws_http__["a" /* AwsHttp */], [__WEBPACK_IMPORTED_MODULE_18__angular_http__["i" /* Http */], __WEBPACK_IMPORTED_MODULE_20__src_app_aws_signature__["a" /* AwsSignature */], __WEBPACK_IMPORTED_MODULE_21__src_app_aws_environment__["a" /* AwsEnvironment */]]), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵmpd"](4608, __WEBPACK_IMPORTED_MODULE_23__angular_forms__["a" /* ɵi */], __WEBPACK_IMPORTED_MODULE_23__angular_forms__["a" /* ɵi */], []), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵmpd"](4608, __WEBPACK_IMPORTED_MODULE_24__src_app_mqtt_mqtt_service__["a" /* MQTTService */], __WEBPACK_IMPORTED_MODULE_24__src_app_mqtt_mqtt_service__["a" /* MQTTService */], [__WEBPACK_IMPORTED_MODULE_20__src_app_aws_signature__["a" /* AwsSignature */], __WEBPACK_IMPORTED_MODULE_21__src_app_aws_environment__["a" /* AwsEnvironment */]]), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵmpd"](4608, __WEBPACK_IMPORTED_MODULE_25__src_app_publisher_publisher_service__["a" /* PublisherService */], __WEBPACK_IMPORTED_MODULE_25__src_app_publisher_publisher_service__["a" /* PublisherService */], []), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵmpd"](4608, __WEBPACK_IMPORTED_MODULE_26__src_app_restapi_error_handler__["a" /* ErrorHandler */], __WEBPACK_IMPORTED_MODULE_26__src_app_restapi_error_handler__["a" /* ErrorHandler */], []), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵmpd"](4608, __WEBPACK_IMPORTED_MODULE_27__src_app_user_preferences_service__["a" /* UserPreferencesService */], __WEBPACK_IMPORTED_MODULE_27__src_app_user_preferences_service__["a" /* UserPreferencesService */], [__WEBPACK_IMPORTED_MODULE_22__src_app_aws_http__["a" /* AwsHttp */], __WEBPACK_IMPORTED_MODULE_26__src_app_restapi_error_handler__["a" /* ErrorHandler */]]), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵmpd"](4608, __WEBPACK_IMPORTED_MODULE_28__src_app_user_user_service__["a" /* UserService */], __WEBPACK_IMPORTED_MODULE_28__src_app_user_user_service__["a" /* UserService */], [__WEBPACK_IMPORTED_MODULE_21__src_app_aws_environment__["a" /* AwsEnvironment */], __WEBPACK_IMPORTED_MODULE_19__src_app_aws_sdk__["a" /* AwsSdk */], __WEBPACK_IMPORTED_MODULE_27__src_app_user_preferences_service__["a" /* UserPreferencesService */], __WEBPACK_IMPORTED_MODULE_24__src_app_mqtt_mqtt_service__["a" /* MQTTService */],
            __WEBPACK_IMPORTED_MODULE_29__angular_router__["a" /* Router */], __WEBPACK_IMPORTED_MODULE_25__src_app_publisher_publisher_service__["a" /* PublisherService */]]), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵmpd"](4608, __WEBPACK_IMPORTED_MODULE_30__src_app_systeminformation_systeminformation_service__["a" /* SystemInformationService */], __WEBPACK_IMPORTED_MODULE_30__src_app_systeminformation_systeminformation_service__["a" /* SystemInformationService */], [__WEBPACK_IMPORTED_MODULE_22__src_app_aws_http__["a" /* AwsHttp */], __WEBPACK_IMPORTED_MODULE_26__src_app_restapi_error_handler__["a" /* ErrorHandler */], __WEBPACK_IMPORTED_MODULE_28__src_app_user_user_service__["a" /* UserService */]]),
        __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵmpd"](4608, __WEBPACK_IMPORTED_MODULE_31__src_app_util_observable_utils__["a" /* ObservableUtils */], __WEBPACK_IMPORTED_MODULE_31__src_app_util_observable_utils__["a" /* ObservableUtils */], []), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵmpd"](4608, __WEBPACK_IMPORTED_MODULE_32__src_app_billing_billing_service__["a" /* BillingService */], __WEBPACK_IMPORTED_MODULE_32__src_app_billing_billing_service__["a" /* BillingService */], [__WEBPACK_IMPORTED_MODULE_22__src_app_aws_http__["a" /* AwsHttp */], __WEBPACK_IMPORTED_MODULE_26__src_app_restapi_error_handler__["a" /* ErrorHandler */],
            __WEBPACK_IMPORTED_MODULE_31__src_app_util_observable_utils__["a" /* ObservableUtils */], __WEBPACK_IMPORTED_MODULE_28__src_app_user_user_service__["a" /* UserService */]]), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵmpd"](4608, __WEBPACK_IMPORTED_MODULE_33__src_app_main_target_validation_target_validation_service__["a" /* TargetValidationService */], __WEBPACK_IMPORTED_MODULE_33__src_app_main_target_validation_target_validation_service__["a" /* TargetValidationService */], [__WEBPACK_IMPORTED_MODULE_29__angular_router__["a" /* Router */], __WEBPACK_IMPORTED_MODULE_22__src_app_aws_http__["a" /* AwsHttp */], __WEBPACK_IMPORTED_MODULE_26__src_app_restapi_error_handler__["a" /* ErrorHandler */],
            __WEBPACK_IMPORTED_MODULE_28__src_app_user_user_service__["a" /* UserService */], __WEBPACK_IMPORTED_MODULE_25__src_app_publisher_publisher_service__["a" /* PublisherService */]]), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵmpd"](5120, 'SettingsEntry', function (p0_0, p1_0, p2_0, p7_0, p7_1, p7_2, p7_3, p9_0, p10_0) {
            return [new __WEBPACK_IMPORTED_MODULE_34__src_app_headerfooter_setting_entries_target_validation_entry__["a" /* TargetValidationEntry */](p0_0), new __WEBPACK_IMPORTED_MODULE_35__src_app_headerfooter_setting_entries_tos_entry__["a" /* TOSEntry */](p1_0),
                new __WEBPACK_IMPORTED_MODULE_36__src_app_headerfooter_setting_entries_billing_entry__["a" /* BillingEntry */](p2_0), new __WEBPACK_IMPORTED_MODULE_37__src_app_headerfooter_setting_entries_help_entry__["a" /* HelpEntry */](), new __WEBPACK_IMPORTED_MODULE_38__src_app_headerfooter_setting_entries_help_pdf_entry__["a" /* HelpPdfEntry */](),
                new __WEBPACK_IMPORTED_MODULE_39__src_app_headerfooter_setting_entries_api_help_entry__["a" /* ApiHelpEntry */](), new __WEBPACK_IMPORTED_MODULE_40__src_app_headerfooter_setting_entries_api_help_pdf_entry__["a" /* ApiHelpPdfEntry */](), new __WEBPACK_IMPORTED_MODULE_41__src_app_headerfooter_setting_entries_python_api_entry__["a" /* PythonApiEntry */](p7_0, p7_1, p7_2, p7_3), new __WEBPACK_IMPORTED_MODULE_42__src_app_headerfooter_setting_entries_support_entry__["a" /* SupportEntry */](), new __WEBPACK_IMPORTED_MODULE_43__src_app_headerfooter_setting_entries_about_entry__["a" /* AboutEntry */](p9_0),
                new __WEBPACK_IMPORTED_MODULE_44__src_app_headerfooter_setting_entries_logout_entry__["a" /* LogOutEntry */](p10_0)];
        }, [__WEBPACK_IMPORTED_MODULE_33__src_app_main_target_validation_target_validation_service__["a" /* TargetValidationService */], __WEBPACK_IMPORTED_MODULE_0__angular_core__["ComponentFactoryResolver"], __WEBPACK_IMPORTED_MODULE_0__angular_core__["ComponentFactoryResolver"],
            __WEBPACK_IMPORTED_MODULE_18__angular_http__["i" /* Http */], __WEBPACK_IMPORTED_MODULE_26__src_app_restapi_error_handler__["a" /* ErrorHandler */], __WEBPACK_IMPORTED_MODULE_28__src_app_user_user_service__["a" /* UserService */], __WEBPACK_IMPORTED_MODULE_22__src_app_aws_http__["a" /* AwsHttp */], __WEBPACK_IMPORTED_MODULE_0__angular_core__["ComponentFactoryResolver"],
            __WEBPACK_IMPORTED_MODULE_28__src_app_user_user_service__["a" /* UserService */]]), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵmpd"](5120, __WEBPACK_IMPORTED_MODULE_29__angular_router__["b" /* ActivatedRoute */], __WEBPACK_IMPORTED_MODULE_29__angular_router__["c" /* ɵf */], [__WEBPACK_IMPORTED_MODULE_29__angular_router__["a" /* Router */]]),
        __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵmpd"](4608, __WEBPACK_IMPORTED_MODULE_45__src_app_headerfooter_header_service__["a" /* HeaderService */], __WEBPACK_IMPORTED_MODULE_45__src_app_headerfooter_header_service__["a" /* HeaderService */], [__WEBPACK_IMPORTED_MODULE_25__src_app_publisher_publisher_service__["a" /* PublisherService */], __WEBPACK_IMPORTED_MODULE_29__angular_router__["a" /* Router */],
            __WEBPACK_IMPORTED_MODULE_29__angular_router__["b" /* ActivatedRoute */]]), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵmpd"](4608, __WEBPACK_IMPORTED_MODULE_46__src_app_login_user_login_service__["a" /* LoginService */], __WEBPACK_IMPORTED_MODULE_46__src_app_login_user_login_service__["a" /* LoginService */], [__WEBPACK_IMPORTED_MODULE_18__angular_http__["i" /* Http */], __WEBPACK_IMPORTED_MODULE_21__src_app_aws_environment__["a" /* AwsEnvironment */], __WEBPACK_IMPORTED_MODULE_26__src_app_restapi_error_handler__["a" /* ErrorHandler */]]), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵmpd"](4608, __WEBPACK_IMPORTED_MODULE_47__swimlane_ngx_datatable_release_services_scrollbar_helper_service__["ScrollbarHelper"], __WEBPACK_IMPORTED_MODULE_47__swimlane_ngx_datatable_release_services_scrollbar_helper_service__["ScrollbarHelper"], [__WEBPACK_IMPORTED_MODULE_15__angular_platform_browser__["DOCUMENT"]]), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵmpd"](4608, __WEBPACK_IMPORTED_MODULE_48__angular_animations__["a" /* AnimationBuilder */], __WEBPACK_IMPORTED_MODULE_17__angular_platform_browser_animations__["e" /* ɵBrowserAnimationBuilder */], [__WEBPACK_IMPORTED_MODULE_0__angular_core__["RendererFactory2"], __WEBPACK_IMPORTED_MODULE_15__angular_platform_browser__["DOCUMENT"]]), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵmpd"](5120, __WEBPACK_IMPORTED_MODULE_49_ngx_window_token_dist_src_ngx_window_token__["a" /* WINDOW */], __WEBPACK_IMPORTED_MODULE_49_ngx_window_token_dist_src_ngx_window_token__["b" /* _window */], []), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵmpd"](5120, __WEBPACK_IMPORTED_MODULE_50_ngx_clipboard_src_clipboard_service__["a" /* ClipboardService */], __WEBPACK_IMPORTED_MODULE_50_ngx_clipboard_src_clipboard_service__["b" /* CLIPBOARD_SERVICE_PROVIDER_FACTORY */], [__WEBPACK_IMPORTED_MODULE_15__angular_platform_browser__["DOCUMENT"], __WEBPACK_IMPORTED_MODULE_49_ngx_window_token_dist_src_ngx_window_token__["a" /* WINDOW */], [3, __WEBPACK_IMPORTED_MODULE_50_ngx_clipboard_src_clipboard_service__["a" /* ClipboardService */]]]),
        __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵmpd"](4608, __WEBPACK_IMPORTED_MODULE_51__src_app_attack_attack_service__["a" /* AttackService */], __WEBPACK_IMPORTED_MODULE_51__src_app_attack_attack_service__["a" /* AttackService */], [__WEBPACK_IMPORTED_MODULE_22__src_app_aws_http__["a" /* AwsHttp */], __WEBPACK_IMPORTED_MODULE_26__src_app_restapi_error_handler__["a" /* ErrorHandler */],
            __WEBPACK_IMPORTED_MODULE_28__src_app_user_user_service__["a" /* UserService */], __WEBPACK_IMPORTED_MODULE_25__src_app_publisher_publisher_service__["a" /* PublisherService */]]), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵmpd"](4608, __WEBPACK_IMPORTED_MODULE_52__src_app_main_config_config_service__["a" /* ConfigService */], __WEBPACK_IMPORTED_MODULE_52__src_app_main_config_config_service__["a" /* ConfigService */], [__WEBPACK_IMPORTED_MODULE_51__src_app_attack_attack_service__["a" /* AttackService */], __WEBPACK_IMPORTED_MODULE_25__src_app_publisher_publisher_service__["a" /* PublisherService */]]), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵmpd"](4608, __WEBPACK_IMPORTED_MODULE_53__src_app_notifier_notifier_service__["a" /* NotifierService */], __WEBPACK_IMPORTED_MODULE_53__src_app_notifier_notifier_service__["a" /* NotifierService */], []), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵmpd"](4608, __WEBPACK_IMPORTED_MODULE_54__src_app_modals_modal_service__["a" /* ModalService */], __WEBPACK_IMPORTED_MODULE_54__src_app_modals_modal_service__["a" /* ModalService */], []), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵmpd"](4608, __WEBPACK_IMPORTED_MODULE_29__angular_router__["d" /* NoPreloading */], __WEBPACK_IMPORTED_MODULE_29__angular_router__["d" /* NoPreloading */], []), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵmpd"](6144, __WEBPACK_IMPORTED_MODULE_29__angular_router__["e" /* PreloadingStrategy */], null, [__WEBPACK_IMPORTED_MODULE_29__angular_router__["d" /* NoPreloading */]]), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵmpd"](135680, __WEBPACK_IMPORTED_MODULE_29__angular_router__["f" /* RouterPreloader */], __WEBPACK_IMPORTED_MODULE_29__angular_router__["f" /* RouterPreloader */], [__WEBPACK_IMPORTED_MODULE_29__angular_router__["a" /* Router */], __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModuleFactoryLoader"], __WEBPACK_IMPORTED_MODULE_0__angular_core__["Compiler"],
            __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injector"], __WEBPACK_IMPORTED_MODULE_29__angular_router__["e" /* PreloadingStrategy */]]), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵmpd"](4608, __WEBPACK_IMPORTED_MODULE_29__angular_router__["g" /* PreloadAllModules */], __WEBPACK_IMPORTED_MODULE_29__angular_router__["g" /* PreloadAllModules */], []), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵmpd"](5120, __WEBPACK_IMPORTED_MODULE_29__angular_router__["h" /* ROUTER_INITIALIZER */], __WEBPACK_IMPORTED_MODULE_29__angular_router__["i" /* ɵi */], [__WEBPACK_IMPORTED_MODULE_29__angular_router__["j" /* ɵg */]]), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵmpd"](5120, __WEBPACK_IMPORTED_MODULE_0__angular_core__["APP_BOOTSTRAP_LISTENER"], function (p0_0) {
            return [p0_0];
        }, [__WEBPACK_IMPORTED_MODULE_29__angular_router__["h" /* ROUTER_INITIALIZER */]]), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵmpd"](4608, __WEBPACK_IMPORTED_MODULE_55__src_app_router_auth_guard_service__["a" /* AuthGuard */], __WEBPACK_IMPORTED_MODULE_55__src_app_router_auth_guard_service__["a" /* AuthGuard */], [__WEBPACK_IMPORTED_MODULE_28__src_app_user_user_service__["a" /* UserService */],
            __WEBPACK_IMPORTED_MODULE_29__angular_router__["a" /* Router */]]), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵmpd"](4608, __WEBPACK_IMPORTED_MODULE_56__src_app_trial_trial_service__["a" /* TrialService */], __WEBPACK_IMPORTED_MODULE_56__src_app_trial_trial_service__["a" /* TrialService */], [__WEBPACK_IMPORTED_MODULE_26__src_app_restapi_error_handler__["a" /* ErrorHandler */],
            __WEBPACK_IMPORTED_MODULE_21__src_app_aws_environment__["a" /* AwsEnvironment */], __WEBPACK_IMPORTED_MODULE_18__angular_http__["i" /* Http */], __WEBPACK_IMPORTED_MODULE_22__src_app_aws_http__["a" /* AwsHttp */], __WEBPACK_IMPORTED_MODULE_28__src_app_user_user_service__["a" /* UserService */]]), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵmpd"](4608, __WEBPACK_IMPORTED_MODULE_57__src_app_router_trial_auth_guard_service__["a" /* TrialAuthGuardService */], __WEBPACK_IMPORTED_MODULE_57__src_app_router_trial_auth_guard_service__["a" /* TrialAuthGuardService */], [__WEBPACK_IMPORTED_MODULE_28__src_app_user_user_service__["a" /* UserService */],
            __WEBPACK_IMPORTED_MODULE_29__angular_router__["a" /* Router */], __WEBPACK_IMPORTED_MODULE_56__src_app_trial_trial_service__["a" /* TrialService */]]), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵmpd"](4608, __WEBPACK_IMPORTED_MODULE_35__src_app_headerfooter_setting_entries_tos_entry__["a" /* TOSEntry */], __WEBPACK_IMPORTED_MODULE_35__src_app_headerfooter_setting_entries_tos_entry__["a" /* TOSEntry */], [__WEBPACK_IMPORTED_MODULE_0__angular_core__["ComponentFactoryResolver"]]), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵmpd"](512, __WEBPACK_IMPORTED_MODULE_14__angular_common__["CommonModule"], __WEBPACK_IMPORTED_MODULE_14__angular_common__["CommonModule"], []), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵmpd"](1024, __WEBPACK_IMPORTED_MODULE_0__angular_core__["ErrorHandler"], __WEBPACK_IMPORTED_MODULE_15__angular_platform_browser__["ɵa"], []), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵmpd"](1024, __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgProbeToken"], function () {
            return [__WEBPACK_IMPORTED_MODULE_29__angular_router__["k" /* ɵb */]()];
        }, []), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵmpd"](512, __WEBPACK_IMPORTED_MODULE_29__angular_router__["j" /* ɵg */], __WEBPACK_IMPORTED_MODULE_29__angular_router__["j" /* ɵg */], [__WEBPACK_IMPORTED_MODULE_0__angular_core__["Injector"]]), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵmpd"](1024, __WEBPACK_IMPORTED_MODULE_0__angular_core__["APP_INITIALIZER"], function (p0_0, p0_1, p1_0) {
            return [__WEBPACK_IMPORTED_MODULE_15__angular_platform_browser__["ɵc"](p0_0, p0_1), __WEBPACK_IMPORTED_MODULE_29__angular_router__["l" /* ɵh */](p1_0)];
        }, [[2, __WEBPACK_IMPORTED_MODULE_15__angular_platform_browser__["NgProbeToken"]], [2, __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgProbeToken"]], __WEBPACK_IMPORTED_MODULE_29__angular_router__["j" /* ɵg */]]), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵmpd"](512, __WEBPACK_IMPORTED_MODULE_0__angular_core__["ApplicationInitStatus"], __WEBPACK_IMPORTED_MODULE_0__angular_core__["ApplicationInitStatus"], [[2, __WEBPACK_IMPORTED_MODULE_0__angular_core__["APP_INITIALIZER"]]]), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵmpd"](131584, __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵe"], __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵe"], [__WEBPACK_IMPORTED_MODULE_0__angular_core__["NgZone"], __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵConsole"], __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injector"], __WEBPACK_IMPORTED_MODULE_0__angular_core__["ErrorHandler"], __WEBPACK_IMPORTED_MODULE_0__angular_core__["ComponentFactoryResolver"],
            __WEBPACK_IMPORTED_MODULE_0__angular_core__["ApplicationInitStatus"]]), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵmpd"](2048, __WEBPACK_IMPORTED_MODULE_0__angular_core__["ApplicationRef"], null, [__WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵe"]]), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵmpd"](512, __WEBPACK_IMPORTED_MODULE_0__angular_core__["ApplicationModule"], __WEBPACK_IMPORTED_MODULE_0__angular_core__["ApplicationModule"], [__WEBPACK_IMPORTED_MODULE_0__angular_core__["ApplicationRef"]]),
        __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵmpd"](512, __WEBPACK_IMPORTED_MODULE_15__angular_platform_browser__["BrowserModule"], __WEBPACK_IMPORTED_MODULE_15__angular_platform_browser__["BrowserModule"], [[3, __WEBPACK_IMPORTED_MODULE_15__angular_platform_browser__["BrowserModule"]]]),
        __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵmpd"](1024, __WEBPACK_IMPORTED_MODULE_29__angular_router__["m" /* ɵa */], __WEBPACK_IMPORTED_MODULE_29__angular_router__["n" /* ɵd */], [[3, __WEBPACK_IMPORTED_MODULE_29__angular_router__["a" /* Router */]]]), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵmpd"](512, __WEBPACK_IMPORTED_MODULE_29__angular_router__["o" /* UrlSerializer */], __WEBPACK_IMPORTED_MODULE_29__angular_router__["p" /* DefaultUrlSerializer */], []), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵmpd"](512, __WEBPACK_IMPORTED_MODULE_29__angular_router__["q" /* ChildrenOutletContexts */], __WEBPACK_IMPORTED_MODULE_29__angular_router__["q" /* ChildrenOutletContexts */], []), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵmpd"](256, __WEBPACK_IMPORTED_MODULE_29__angular_router__["r" /* ROUTER_CONFIGURATION */], {}, []), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵmpd"](1024, __WEBPACK_IMPORTED_MODULE_14__angular_common__["LocationStrategy"], __WEBPACK_IMPORTED_MODULE_29__angular_router__["s" /* ɵc */], [__WEBPACK_IMPORTED_MODULE_14__angular_common__["PlatformLocation"],
            [2, __WEBPACK_IMPORTED_MODULE_14__angular_common__["APP_BASE_HREF"]], __WEBPACK_IMPORTED_MODULE_29__angular_router__["r" /* ROUTER_CONFIGURATION */]]), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵmpd"](512, __WEBPACK_IMPORTED_MODULE_14__angular_common__["Location"], __WEBPACK_IMPORTED_MODULE_14__angular_common__["Location"], [__WEBPACK_IMPORTED_MODULE_14__angular_common__["LocationStrategy"]]), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵmpd"](512, __WEBPACK_IMPORTED_MODULE_0__angular_core__["Compiler"], __WEBPACK_IMPORTED_MODULE_0__angular_core__["Compiler"], []), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵmpd"](512, __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModuleFactoryLoader"], __WEBPACK_IMPORTED_MODULE_0__angular_core__["SystemJsNgModuleLoader"], [__WEBPACK_IMPORTED_MODULE_0__angular_core__["Compiler"], [2, __WEBPACK_IMPORTED_MODULE_0__angular_core__["SystemJsNgModuleLoaderConfig"]]]), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵmpd"](1024, __WEBPACK_IMPORTED_MODULE_29__angular_router__["t" /* ROUTES */], function () {
            return [[{ path: '', component: __WEBPACK_IMPORTED_MODULE_58__src_app_main_dashboard_component__["a" /* DashboardComponent */], canActivate: [__WEBPACK_IMPORTED_MODULE_55__src_app_router_auth_guard_service__["a" /* AuthGuard */]],
                        children: [{ path: '', component: __WEBPACK_IMPORTED_MODULE_59__src_app_main_config_config_component__["a" /* ConfigComponent */] }, { path: 'history',
                                component: __WEBPACK_IMPORTED_MODULE_60__src_app_main_history_history_component__["a" /* HistoryComponent */] }] }], [{ path: '', redirectTo: '/dashboard',
                        pathMatch: 'full' }, { path: 'trial', component: __WEBPACK_IMPORTED_MODULE_61__src_app_trial_trial_component__["a" /* TrialComponent */], canActivate: [__WEBPACK_IMPORTED_MODULE_57__src_app_router_trial_auth_guard_service__["a" /* TrialAuthGuardService */]] },
                    { path: 'login', component: __WEBPACK_IMPORTED_MODULE_62__src_app_login_user_login_component__["a" /* UserLoginComponent */] }, { path: 'dashboard',
                        component: __WEBPACK_IMPORTED_MODULE_58__src_app_main_dashboard_component__["a" /* DashboardComponent */], redirectTo: '', canActivate: [__WEBPACK_IMPORTED_MODULE_55__src_app_router_auth_guard_service__["a" /* AuthGuard */]] },
                    { path: 'tos', component: __WEBPACK_IMPORTED_MODULE_63__src_app_licensing_licensing_component__["a" /* LicensingComponent */] }, { path: 'eula', component: __WEBPACK_IMPORTED_MODULE_63__src_app_licensing_licensing_component__["a" /* LicensingComponent */] },
                    { path: 'release-notes', component: __WEBPACK_IMPORTED_MODULE_64__src_app_release_notes_release_notes_component__["a" /* ReleaseNotesComponent */] }, { path: '**',
                        redirectTo: '' }]];
        }, []), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵmpd"](1024, __WEBPACK_IMPORTED_MODULE_29__angular_router__["a" /* Router */], __WEBPACK_IMPORTED_MODULE_29__angular_router__["u" /* ɵe */], [__WEBPACK_IMPORTED_MODULE_0__angular_core__["ApplicationRef"], __WEBPACK_IMPORTED_MODULE_29__angular_router__["o" /* UrlSerializer */],
            __WEBPACK_IMPORTED_MODULE_29__angular_router__["q" /* ChildrenOutletContexts */], __WEBPACK_IMPORTED_MODULE_14__angular_common__["Location"], __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injector"], __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModuleFactoryLoader"],
            __WEBPACK_IMPORTED_MODULE_0__angular_core__["Compiler"], __WEBPACK_IMPORTED_MODULE_29__angular_router__["t" /* ROUTES */], __WEBPACK_IMPORTED_MODULE_29__angular_router__["r" /* ROUTER_CONFIGURATION */], [2, __WEBPACK_IMPORTED_MODULE_29__angular_router__["v" /* UrlHandlingStrategy */]],
            [2, __WEBPACK_IMPORTED_MODULE_29__angular_router__["w" /* RouteReuseStrategy */]]]), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵmpd"](512, __WEBPACK_IMPORTED_MODULE_29__angular_router__["x" /* RouterModule */], __WEBPACK_IMPORTED_MODULE_29__angular_router__["x" /* RouterModule */], [[2, __WEBPACK_IMPORTED_MODULE_29__angular_router__["m" /* ɵa */]], [2, __WEBPACK_IMPORTED_MODULE_29__angular_router__["a" /* Router */]]]), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵmpd"](512, __WEBPACK_IMPORTED_MODULE_18__angular_http__["k" /* HttpModule */], __WEBPACK_IMPORTED_MODULE_18__angular_http__["k" /* HttpModule */], []), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵmpd"](512, __WEBPACK_IMPORTED_MODULE_65__src_app_aws_aws_module__["a" /* AwsModule */], __WEBPACK_IMPORTED_MODULE_65__src_app_aws_aws_module__["a" /* AwsModule */], []),
        __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵmpd"](512, __WEBPACK_IMPORTED_MODULE_23__angular_forms__["b" /* ɵba */], __WEBPACK_IMPORTED_MODULE_23__angular_forms__["b" /* ɵba */], []), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵmpd"](512, __WEBPACK_IMPORTED_MODULE_23__angular_forms__["c" /* FormsModule */], __WEBPACK_IMPORTED_MODULE_23__angular_forms__["c" /* FormsModule */], []), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵmpd"](512, __WEBPACK_IMPORTED_MODULE_66__src_app_mqtt_mqtt_module__["a" /* MQTTModule */], __WEBPACK_IMPORTED_MODULE_66__src_app_mqtt_mqtt_module__["a" /* MQTTModule */], []),
        __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵmpd"](512, __WEBPACK_IMPORTED_MODULE_67__src_app_publisher_publisher_module__["a" /* PublisherModule */], __WEBPACK_IMPORTED_MODULE_67__src_app_publisher_publisher_module__["a" /* PublisherModule */], []), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵmpd"](512, __WEBPACK_IMPORTED_MODULE_68__src_app_user_user_module__["a" /* UserModule */], __WEBPACK_IMPORTED_MODULE_68__src_app_user_user_module__["a" /* UserModule */], []), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵmpd"](512, __WEBPACK_IMPORTED_MODULE_69__src_app_progress_progress_module__["a" /* ProgressModule */], __WEBPACK_IMPORTED_MODULE_69__src_app_progress_progress_module__["a" /* ProgressModule */], []), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵmpd"](512, __WEBPACK_IMPORTED_MODULE_70__src_app_systeminformation_systeminformation_module__["a" /* SystemInformationModule */], __WEBPACK_IMPORTED_MODULE_70__src_app_systeminformation_systeminformation_module__["a" /* SystemInformationModule */], []), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵmpd"](512, __WEBPACK_IMPORTED_MODULE_71__src_app_util_util_module__["a" /* UtilModule */], __WEBPACK_IMPORTED_MODULE_71__src_app_util_util_module__["a" /* UtilModule */], []), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵmpd"](512, __WEBPACK_IMPORTED_MODULE_72__src_app_billing_billing_module__["a" /* BillingModule */], __WEBPACK_IMPORTED_MODULE_72__src_app_billing_billing_module__["a" /* BillingModule */], []), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵmpd"](512, __WEBPACK_IMPORTED_MODULE_73__src_app_modals_modals_module__["a" /* ModalsModule */], __WEBPACK_IMPORTED_MODULE_73__src_app_modals_modals_module__["a" /* ModalsModule */], []),
        __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵmpd"](512, __WEBPACK_IMPORTED_MODULE_74__src_app_headerfooter_headerfooter_module__["a" /* HeaderFooterModule */], __WEBPACK_IMPORTED_MODULE_74__src_app_headerfooter_headerfooter_module__["a" /* HeaderFooterModule */], []),
        __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵmpd"](512, __WEBPACK_IMPORTED_MODULE_75__src_app_licensing_licensing_module__["a" /* LicensingModule */], __WEBPACK_IMPORTED_MODULE_75__src_app_licensing_licensing_module__["a" /* LicensingModule */], []), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵmpd"](512, __WEBPACK_IMPORTED_MODULE_76__src_app_restapi_restapi_module__["a" /* RestApiModule */], __WEBPACK_IMPORTED_MODULE_76__src_app_restapi_restapi_module__["a" /* RestApiModule */], []), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵmpd"](512, __WEBPACK_IMPORTED_MODULE_77__src_app_login_login_module__["a" /* LoginModule */], __WEBPACK_IMPORTED_MODULE_77__src_app_login_login_module__["a" /* LoginModule */], []), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵmpd"](512, __WEBPACK_IMPORTED_MODULE_78__src_app_main_main_routing_module__["a" /* MainRoutingModule */], __WEBPACK_IMPORTED_MODULE_78__src_app_main_main_routing_module__["a" /* MainRoutingModule */], []), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵmpd"](512, __WEBPACK_IMPORTED_MODULE_79__swimlane_ngx_datatable_release_datatable_module__["NgxDatatableModule"], __WEBPACK_IMPORTED_MODULE_79__swimlane_ngx_datatable_release_datatable_module__["NgxDatatableModule"], []), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵmpd"](512, __WEBPACK_IMPORTED_MODULE_80__src_app_pipes_pipes_module__["a" /* PipesModule */], __WEBPACK_IMPORTED_MODULE_80__src_app_pipes_pipes_module__["a" /* PipesModule */], []),
        __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵmpd"](512, __WEBPACK_IMPORTED_MODULE_17__angular_platform_browser_animations__["f" /* BrowserAnimationsModule */], __WEBPACK_IMPORTED_MODULE_17__angular_platform_browser_animations__["f" /* BrowserAnimationsModule */], []),
        __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵmpd"](512, __WEBPACK_IMPORTED_MODULE_49_ngx_window_token_dist_src_ngx_window_token__["c" /* WindowTokenModule */], __WEBPACK_IMPORTED_MODULE_49_ngx_window_token_dist_src_ngx_window_token__["c" /* WindowTokenModule */], []), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵmpd"](512, __WEBPACK_IMPORTED_MODULE_81_ngx_clipboard_src_index__["a" /* ClipboardModule */], __WEBPACK_IMPORTED_MODULE_81_ngx_clipboard_src_index__["a" /* ClipboardModule */], []), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵmpd"](512, __WEBPACK_IMPORTED_MODULE_82__src_app_main_main_module__["a" /* MainModule */], __WEBPACK_IMPORTED_MODULE_82__src_app_main_main_module__["a" /* MainModule */], []), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵmpd"](512, __WEBPACK_IMPORTED_MODULE_83__src_app_tree_tree_module__["a" /* TreeModule */], __WEBPACK_IMPORTED_MODULE_83__src_app_tree_tree_module__["a" /* TreeModule */], []), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵmpd"](512, __WEBPACK_IMPORTED_MODULE_1__src_app_app_module__["a" /* AppModule */], __WEBPACK_IMPORTED_MODULE_1__src_app_app_module__["a" /* AppModule */], [])]);
});
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3NyYy91aS9zcmMvYXBwL2FwcC5tb2R1bGUubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vc3JjL3VpL3NyYy9hcHAvYXBwLm1vZHVsZS50cyJdLCJzb3VyY2VzQ29udGVudCI6WyIgIl0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7In0=
//# sourceMappingURL=app.module.ngfactory.js.map

/***/ }),
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return BrowserAnimationsModule; });
/* unused harmony export NoopAnimationsModule */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return BrowserAnimationBuilder; });
/* unused harmony export ɵBrowserAnimationFactory */
/* unused harmony export ɵAnimationRenderer */
/* unused harmony export ɵAnimationRendererFactory */
/* unused harmony export ɵa */
/* unused harmony export ɵf */
/* unused harmony export ɵg */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return InjectableAnimationEngine; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return instantiateDefaultStyleNormalizer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return instantiateRendererFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return instantiateSupportedAnimationDriver; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_platform_browser__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__angular_animations__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__angular_animations_browser__ = __webpack_require__(301);

/**
 * @license Angular v4.4.4
 * (c) 2010-2017 Google, Inc. https://angular.io/
 * License: MIT
 */




/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var BrowserAnimationBuilder = (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](BrowserAnimationBuilder, _super);
    /**
     * @param {?} rootRenderer
     * @param {?} doc
     */
    function BrowserAnimationBuilder(rootRenderer, doc) {
        var _this = _super.call(this) || this;
        _this._nextAnimationId = 0;
        var typeData = {
            id: '0',
            encapsulation: __WEBPACK_IMPORTED_MODULE_1__angular_core__["ViewEncapsulation"].None,
            styles: [],
            data: { animation: [] }
        };
        _this._renderer = rootRenderer.createRenderer(doc.body, typeData);
        return _this;
    }
    /**
     * @param {?} animation
     * @return {?}
     */
    BrowserAnimationBuilder.prototype.build = function (animation) {
        var /** @type {?} */ id = this._nextAnimationId.toString();
        this._nextAnimationId++;
        var /** @type {?} */ entry = Array.isArray(animation) ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__angular_animations__["b" /* sequence */])(animation) : animation;
        issueAnimationCommand(this._renderer, null, id, 'register', [entry]);
        return new BrowserAnimationFactory(id, this._renderer);
    };
    return BrowserAnimationBuilder;
}(__WEBPACK_IMPORTED_MODULE_3__angular_animations__["a" /* AnimationBuilder */]));
BrowserAnimationBuilder.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Injectable"] },
];
/**
 * @nocollapse
 */
BrowserAnimationBuilder.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["RendererFactory2"], },
    { type: undefined, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_2__angular_platform_browser__["DOCUMENT"],] },] },
]; };
var BrowserAnimationFactory = (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](BrowserAnimationFactory, _super);
    /**
     * @param {?} _id
     * @param {?} _renderer
     */
    function BrowserAnimationFactory(_id, _renderer) {
        var _this = _super.call(this) || this;
        _this._id = _id;
        _this._renderer = _renderer;
        return _this;
    }
    /**
     * @param {?} element
     * @param {?=} options
     * @return {?}
     */
    BrowserAnimationFactory.prototype.create = function (element, options) {
        return new RendererAnimationPlayer(this._id, element, options || {}, this._renderer);
    };
    return BrowserAnimationFactory;
}(__WEBPACK_IMPORTED_MODULE_3__angular_animations__["c" /* AnimationFactory */]));
var RendererAnimationPlayer = (function () {
    /**
     * @param {?} id
     * @param {?} element
     * @param {?} options
     * @param {?} _renderer
     */
    function RendererAnimationPlayer(id, element, options, _renderer) {
        this.id = id;
        this.element = element;
        this._renderer = _renderer;
        this.parentPlayer = null;
        this._started = false;
        this.totalTime = 0;
        this._command('create', options);
    }
    /**
     * @param {?} eventName
     * @param {?} callback
     * @return {?}
     */
    RendererAnimationPlayer.prototype._listen = function (eventName, callback) {
        return this._renderer.listen(this.element, "@@" + this.id + ":" + eventName, callback);
    };
    /**
     * @param {?} command
     * @param {...?} args
     * @return {?}
     */
    RendererAnimationPlayer.prototype._command = function (command) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        return issueAnimationCommand(this._renderer, this.element, this.id, command, args);
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    RendererAnimationPlayer.prototype.onDone = function (fn) { this._listen('done', fn); };
    /**
     * @param {?} fn
     * @return {?}
     */
    RendererAnimationPlayer.prototype.onStart = function (fn) { this._listen('start', fn); };
    /**
     * @param {?} fn
     * @return {?}
     */
    RendererAnimationPlayer.prototype.onDestroy = function (fn) { this._listen('destroy', fn); };
    /**
     * @return {?}
     */
    RendererAnimationPlayer.prototype.init = function () { this._command('init'); };
    /**
     * @return {?}
     */
    RendererAnimationPlayer.prototype.hasStarted = function () { return this._started; };
    /**
     * @return {?}
     */
    RendererAnimationPlayer.prototype.play = function () {
        this._command('play');
        this._started = true;
    };
    /**
     * @return {?}
     */
    RendererAnimationPlayer.prototype.pause = function () { this._command('pause'); };
    /**
     * @return {?}
     */
    RendererAnimationPlayer.prototype.restart = function () { this._command('restart'); };
    /**
     * @return {?}
     */
    RendererAnimationPlayer.prototype.finish = function () { this._command('finish'); };
    /**
     * @return {?}
     */
    RendererAnimationPlayer.prototype.destroy = function () { this._command('destroy'); };
    /**
     * @return {?}
     */
    RendererAnimationPlayer.prototype.reset = function () { this._command('reset'); };
    /**
     * @param {?} p
     * @return {?}
     */
    RendererAnimationPlayer.prototype.setPosition = function (p) { this._command('setPosition', p); };
    /**
     * @return {?}
     */
    RendererAnimationPlayer.prototype.getPosition = function () { return 0; };
    return RendererAnimationPlayer;
}());
/**
 * @param {?} renderer
 * @param {?} element
 * @param {?} id
 * @param {?} command
 * @param {?} args
 * @return {?}
 */
function issueAnimationCommand(renderer, element, id, command, args) {
    return renderer.setProperty(element, "@@" + id + ":" + command, args);
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var ANIMATION_PREFIX = '@';
var DISABLE_ANIMATIONS_FLAG = '@.disabled';
var AnimationRendererFactory = (function () {
    /**
     * @param {?} delegate
     * @param {?} engine
     * @param {?} _zone
     */
    function AnimationRendererFactory(delegate, engine, _zone) {
        this.delegate = delegate;
        this.engine = engine;
        this._zone = _zone;
        this._currentId = 0;
        this._microtaskId = 1;
        this._animationCallbacksBuffer = [];
        this._rendererCache = new Map();
        this._cdRecurDepth = 0;
        engine.onRemovalComplete = function (element, delegate) {
            // Note: if an component element has a leave animation, and the component
            // a host leave animation, the view engine will call `removeChild` for the parent
            // component renderer as well as for the child component renderer.
            // Therefore, we need to check if we already removed the element.
            if (delegate && delegate.parentNode(element)) {
                delegate.removeChild(element.parentNode, element);
            }
        };
    }
    /**
     * @param {?} hostElement
     * @param {?} type
     * @return {?}
     */
    AnimationRendererFactory.prototype.createRenderer = function (hostElement, type) {
        var _this = this;
        var /** @type {?} */ EMPTY_NAMESPACE_ID = '';
        // cache the delegates to find out which cached delegate can
        // be used by which cached renderer
        var /** @type {?} */ delegate = this.delegate.createRenderer(hostElement, type);
        if (!hostElement || !type || !type.data || !type.data['animation']) {
            var /** @type {?} */ renderer = this._rendererCache.get(delegate);
            if (!renderer) {
                renderer = new BaseAnimationRenderer(EMPTY_NAMESPACE_ID, delegate, this.engine);
                // only cache this result when the base renderer is used
                this._rendererCache.set(delegate, renderer);
            }
            return renderer;
        }
        var /** @type {?} */ componentId = type.id;
        var /** @type {?} */ namespaceId = type.id + '-' + this._currentId;
        this._currentId++;
        this.engine.register(namespaceId, hostElement);
        var /** @type {?} */ animationTriggers = (type.data['animation']);
        animationTriggers.forEach(function (trigger) { return _this.engine.registerTrigger(componentId, namespaceId, hostElement, trigger.name, trigger); });
        return new AnimationRenderer(this, namespaceId, delegate, this.engine);
    };
    /**
     * @return {?}
     */
    AnimationRendererFactory.prototype.begin = function () {
        this._cdRecurDepth++;
        if (this.delegate.begin) {
            this.delegate.begin();
        }
    };
    /**
     * @return {?}
     */
    AnimationRendererFactory.prototype._scheduleCountTask = function () {
        var _this = this;
        Zone.current.scheduleMicroTask('incremenet the animation microtask', function () { return _this._microtaskId++; });
    };
    /**
     * @param {?} count
     * @param {?} fn
     * @param {?} data
     * @return {?}
     */
    AnimationRendererFactory.prototype.scheduleListenerCallback = function (count, fn, data) {
        var _this = this;
        if (count >= 0 && count < this._microtaskId) {
            this._zone.run(function () { return fn(data); });
            return;
        }
        if (this._animationCallbacksBuffer.length == 0) {
            Promise.resolve(null).then(function () {
                _this._zone.run(function () {
                    _this._animationCallbacksBuffer.forEach(function (tuple) {
                        var fn = tuple[0], data = tuple[1];
                        fn(data);
                    });
                    _this._animationCallbacksBuffer = [];
                });
            });
        }
        this._animationCallbacksBuffer.push([fn, data]);
    };
    /**
     * @return {?}
     */
    AnimationRendererFactory.prototype.end = function () {
        var _this = this;
        this._cdRecurDepth--;
        // this is to prevent animations from running twice when an inner
        // component does CD when a parent component insted has inserted it
        if (this._cdRecurDepth == 0) {
            this._zone.runOutsideAngular(function () {
                _this._scheduleCountTask();
                _this.engine.flush(_this._microtaskId);
            });
        }
        if (this.delegate.end) {
            this.delegate.end();
        }
    };
    /**
     * @return {?}
     */
    AnimationRendererFactory.prototype.whenRenderingDone = function () { return this.engine.whenRenderingDone(); };
    return AnimationRendererFactory;
}());
AnimationRendererFactory.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Injectable"] },
];
/**
 * @nocollapse
 */
AnimationRendererFactory.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["RendererFactory2"], },
    { type: __WEBPACK_IMPORTED_MODULE_4__angular_animations_browser__["c" /* ɵAnimationEngine */], },
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["NgZone"], },
]; };
var BaseAnimationRenderer = (function () {
    /**
     * @param {?} namespaceId
     * @param {?} delegate
     * @param {?} engine
     */
    function BaseAnimationRenderer(namespaceId, delegate, engine) {
        this.namespaceId = namespaceId;
        this.delegate = delegate;
        this.engine = engine;
        this.destroyNode = this.delegate.destroyNode ? function (n) { return delegate.destroyNode(n); } : null;
    }
    Object.defineProperty(BaseAnimationRenderer.prototype, "data", {
        /**
         * @return {?}
         */
        get: function () { return this.delegate.data; },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    BaseAnimationRenderer.prototype.destroy = function () {
        this.engine.destroy(this.namespaceId, this.delegate);
        this.delegate.destroy();
    };
    /**
     * @param {?} name
     * @param {?=} namespace
     * @return {?}
     */
    BaseAnimationRenderer.prototype.createElement = function (name, namespace) {
        return this.delegate.createElement(name, namespace);
    };
    /**
     * @param {?} value
     * @return {?}
     */
    BaseAnimationRenderer.prototype.createComment = function (value) { return this.delegate.createComment(value); };
    /**
     * @param {?} value
     * @return {?}
     */
    BaseAnimationRenderer.prototype.createText = function (value) { return this.delegate.createText(value); };
    /**
     * @param {?} parent
     * @param {?} newChild
     * @return {?}
     */
    BaseAnimationRenderer.prototype.appendChild = function (parent, newChild) {
        this.delegate.appendChild(parent, newChild);
        this.engine.onInsert(this.namespaceId, newChild, parent, false);
    };
    /**
     * @param {?} parent
     * @param {?} newChild
     * @param {?} refChild
     * @return {?}
     */
    BaseAnimationRenderer.prototype.insertBefore = function (parent, newChild, refChild) {
        this.delegate.insertBefore(parent, newChild, refChild);
        this.engine.onInsert(this.namespaceId, newChild, parent, true);
    };
    /**
     * @param {?} parent
     * @param {?} oldChild
     * @return {?}
     */
    BaseAnimationRenderer.prototype.removeChild = function (parent, oldChild) {
        this.engine.onRemove(this.namespaceId, oldChild, this.delegate);
    };
    /**
     * @param {?} selectorOrNode
     * @return {?}
     */
    BaseAnimationRenderer.prototype.selectRootElement = function (selectorOrNode) { return this.delegate.selectRootElement(selectorOrNode); };
    /**
     * @param {?} node
     * @return {?}
     */
    BaseAnimationRenderer.prototype.parentNode = function (node) { return this.delegate.parentNode(node); };
    /**
     * @param {?} node
     * @return {?}
     */
    BaseAnimationRenderer.prototype.nextSibling = function (node) { return this.delegate.nextSibling(node); };
    /**
     * @param {?} el
     * @param {?} name
     * @param {?} value
     * @param {?=} namespace
     * @return {?}
     */
    BaseAnimationRenderer.prototype.setAttribute = function (el, name, value, namespace) {
        this.delegate.setAttribute(el, name, value, namespace);
    };
    /**
     * @param {?} el
     * @param {?} name
     * @param {?=} namespace
     * @return {?}
     */
    BaseAnimationRenderer.prototype.removeAttribute = function (el, name, namespace) {
        this.delegate.removeAttribute(el, name, namespace);
    };
    /**
     * @param {?} el
     * @param {?} name
     * @return {?}
     */
    BaseAnimationRenderer.prototype.addClass = function (el, name) { this.delegate.addClass(el, name); };
    /**
     * @param {?} el
     * @param {?} name
     * @return {?}
     */
    BaseAnimationRenderer.prototype.removeClass = function (el, name) { this.delegate.removeClass(el, name); };
    /**
     * @param {?} el
     * @param {?} style
     * @param {?} value
     * @param {?=} flags
     * @return {?}
     */
    BaseAnimationRenderer.prototype.setStyle = function (el, style, value, flags) {
        this.delegate.setStyle(el, style, value, flags);
    };
    /**
     * @param {?} el
     * @param {?} style
     * @param {?=} flags
     * @return {?}
     */
    BaseAnimationRenderer.prototype.removeStyle = function (el, style, flags) {
        this.delegate.removeStyle(el, style, flags);
    };
    /**
     * @param {?} el
     * @param {?} name
     * @param {?} value
     * @return {?}
     */
    BaseAnimationRenderer.prototype.setProperty = function (el, name, value) {
        if (name.charAt(0) == ANIMATION_PREFIX && name == DISABLE_ANIMATIONS_FLAG) {
            this.disableAnimations(el, !!value);
        }
        else {
            this.delegate.setProperty(el, name, value);
        }
    };
    /**
     * @param {?} node
     * @param {?} value
     * @return {?}
     */
    BaseAnimationRenderer.prototype.setValue = function (node, value) { this.delegate.setValue(node, value); };
    /**
     * @param {?} target
     * @param {?} eventName
     * @param {?} callback
     * @return {?}
     */
    BaseAnimationRenderer.prototype.listen = function (target, eventName, callback) {
        return this.delegate.listen(target, eventName, callback);
    };
    /**
     * @param {?} element
     * @param {?} value
     * @return {?}
     */
    BaseAnimationRenderer.prototype.disableAnimations = function (element, value) {
        this.engine.disableAnimations(element, value);
    };
    return BaseAnimationRenderer;
}());
var AnimationRenderer = (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](AnimationRenderer, _super);
    /**
     * @param {?} factory
     * @param {?} namespaceId
     * @param {?} delegate
     * @param {?} engine
     */
    function AnimationRenderer(factory, namespaceId, delegate, engine) {
        var _this = _super.call(this, namespaceId, delegate, engine) || this;
        _this.factory = factory;
        _this.namespaceId = namespaceId;
        return _this;
    }
    /**
     * @param {?} el
     * @param {?} name
     * @param {?} value
     * @return {?}
     */
    AnimationRenderer.prototype.setProperty = function (el, name, value) {
        if (name.charAt(0) == ANIMATION_PREFIX) {
            if (name.charAt(1) == '.' && name == DISABLE_ANIMATIONS_FLAG) {
                value = value === undefined ? true : !!value;
                this.disableAnimations(el, /** @type {?} */ (value));
            }
            else {
                this.engine.process(this.namespaceId, el, name.substr(1), value);
            }
        }
        else {
            this.delegate.setProperty(el, name, value);
        }
    };
    /**
     * @param {?} target
     * @param {?} eventName
     * @param {?} callback
     * @return {?}
     */
    AnimationRenderer.prototype.listen = function (target, eventName, callback) {
        var _this = this;
        if (eventName.charAt(0) == ANIMATION_PREFIX) {
            var /** @type {?} */ element = resolveElementFromTarget(target);
            var /** @type {?} */ name = eventName.substr(1);
            var /** @type {?} */ phase = '';
            // @listener.phase is for trigger animation callbacks
            // @@listener is for animation builder callbacks
            if (name.charAt(0) != ANIMATION_PREFIX) {
                _a = parseTriggerCallbackName(name), name = _a[0], phase = _a[1];
            }
            return this.engine.listen(this.namespaceId, element, name, phase, function (event) {
                var /** @type {?} */ countId = ((event))['_data'] || -1;
                _this.factory.scheduleListenerCallback(countId, callback, event);
            });
        }
        return this.delegate.listen(target, eventName, callback);
        var _a;
    };
    return AnimationRenderer;
}(BaseAnimationRenderer));
/**
 * @param {?} target
 * @return {?}
 */
function resolveElementFromTarget(target) {
    switch (target) {
        case 'body':
            return document.body;
        case 'document':
            return document;
        case 'window':
            return window;
        default:
            return target;
    }
}
/**
 * @param {?} triggerName
 * @return {?}
 */
function parseTriggerCallbackName(triggerName) {
    var /** @type {?} */ dotIndex = triggerName.indexOf('.');
    var /** @type {?} */ trigger = triggerName.substring(0, dotIndex);
    var /** @type {?} */ phase = triggerName.substr(dotIndex + 1);
    return [trigger, phase];
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var InjectableAnimationEngine = (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](InjectableAnimationEngine, _super);
    /**
     * @param {?} driver
     * @param {?} normalizer
     */
    function InjectableAnimationEngine(driver, normalizer) {
        return _super.call(this, driver, normalizer) || this;
    }
    return InjectableAnimationEngine;
}(__WEBPACK_IMPORTED_MODULE_4__angular_animations_browser__["c" /* ɵAnimationEngine */]));
InjectableAnimationEngine.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Injectable"] },
];
/**
 * @nocollapse
 */
InjectableAnimationEngine.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_4__angular_animations_browser__["a" /* AnimationDriver */], },
    { type: __WEBPACK_IMPORTED_MODULE_4__angular_animations_browser__["b" /* ɵAnimationStyleNormalizer */], },
]; };
/**
 * @return {?}
 */
function instantiateSupportedAnimationDriver() {
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__angular_animations_browser__["d" /* ɵsupportsWebAnimations */])()) {
        return new __WEBPACK_IMPORTED_MODULE_4__angular_animations_browser__["e" /* ɵWebAnimationsDriver */]();
    }
    return new __WEBPACK_IMPORTED_MODULE_4__angular_animations_browser__["f" /* ɵNoopAnimationDriver */]();
}
/**
 * @return {?}
 */
function instantiateDefaultStyleNormalizer() {
    return new __WEBPACK_IMPORTED_MODULE_4__angular_animations_browser__["g" /* ɵWebAnimationsStyleNormalizer */]();
}
/**
 * @param {?} renderer
 * @param {?} engine
 * @param {?} zone
 * @return {?}
 */
function instantiateRendererFactory(renderer, engine, zone) {
    return new AnimationRendererFactory(renderer, engine, zone);
}
var SHARED_ANIMATION_PROVIDERS = [
    { provide: __WEBPACK_IMPORTED_MODULE_3__angular_animations__["a" /* AnimationBuilder */], useClass: BrowserAnimationBuilder },
    { provide: __WEBPACK_IMPORTED_MODULE_4__angular_animations_browser__["b" /* ɵAnimationStyleNormalizer */], useFactory: instantiateDefaultStyleNormalizer },
    { provide: __WEBPACK_IMPORTED_MODULE_4__angular_animations_browser__["c" /* ɵAnimationEngine */], useClass: InjectableAnimationEngine }, {
        provide: __WEBPACK_IMPORTED_MODULE_1__angular_core__["RendererFactory2"],
        useFactory: instantiateRendererFactory,
        deps: [__WEBPACK_IMPORTED_MODULE_2__angular_platform_browser__["ɵDomRendererFactory2"], __WEBPACK_IMPORTED_MODULE_4__angular_animations_browser__["c" /* ɵAnimationEngine */], __WEBPACK_IMPORTED_MODULE_1__angular_core__["NgZone"]]
    }
];
/**
 * Separate providers from the actual module so that we can do a local modification in Google3 to
 * include them in the BrowserModule.
 */
var BROWSER_ANIMATIONS_PROVIDERS = [
    { provide: __WEBPACK_IMPORTED_MODULE_4__angular_animations_browser__["a" /* AnimationDriver */], useFactory: instantiateSupportedAnimationDriver }
].concat(SHARED_ANIMATION_PROVIDERS);
/**
 * Separate providers from the actual module so that we can do a local modification in Google3 to
 * include them in the BrowserTestingModule.
 */
var BROWSER_NOOP_ANIMATIONS_PROVIDERS = [{ provide: __WEBPACK_IMPORTED_MODULE_4__angular_animations_browser__["a" /* AnimationDriver */], useClass: __WEBPACK_IMPORTED_MODULE_4__angular_animations_browser__["f" /* ɵNoopAnimationDriver */] }].concat(SHARED_ANIMATION_PROVIDERS);
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * \@experimental Animation support is experimental.
 */
var BrowserAnimationsModule = (function () {
    function BrowserAnimationsModule() {
    }
    return BrowserAnimationsModule;
}());
BrowserAnimationsModule.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["NgModule"], args: [{
                exports: [__WEBPACK_IMPORTED_MODULE_2__angular_platform_browser__["BrowserModule"]],
                providers: BROWSER_ANIMATIONS_PROVIDERS,
            },] },
];
/**
 * @nocollapse
 */
BrowserAnimationsModule.ctorParameters = function () { return []; };
/**
 * \@experimental Animation support is experimental.
 */
var NoopAnimationsModule = (function () {
    function NoopAnimationsModule() {
    }
    return NoopAnimationsModule;
}());
NoopAnimationsModule.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["NgModule"], args: [{
                exports: [__WEBPACK_IMPORTED_MODULE_2__angular_platform_browser__["BrowserModule"]],
                providers: BROWSER_NOOP_ANIMATIONS_PROVIDERS,
            },] },
];
/**
 * @nocollapse
 */
NoopAnimationsModule.ctorParameters = function () { return []; };
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @module
 * @description
 * Entry point for all animation APIs of the animation browser package.
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @module
 * @description
 * Entry point for all public APIs of the animation package.
 */
/**
 * Generated bundle index. Do not edit.
 */

//# sourceMappingURL=animations.es5.js.map


/***/ }),
/* 515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RenderType_DataTableBodyCellComponent; });
/* harmony export (immutable) */ __webpack_exports__["a"] = View_DataTableBodyCellComponent_0;
/* unused harmony export View_DataTableBodyCellComponent_Host_0 */
/* unused harmony export DataTableBodyCellComponentNgFactory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_common__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__swimlane_ngx_datatable_release_components_body_body_cell_component__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__swimlane_ngx_datatable_release_components_body_body_cell_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__swimlane_ngx_datatable_release_components_body_body_cell_component__);
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */



var styles_DataTableBodyCellComponent = [];
var RenderType_DataTableBodyCellComponent = __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵcrt"]({ encapsulation: 2,
    styles: styles_DataTableBodyCellComponent, data: {} });
function View_DataTableBodyCellComponent_1(_l) {
    return __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵeld"](0, null, null, 3, 'label', [['class',
                'datatable-checkbox']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵted"](null, ['\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵeld"](0, null, null, 0, 'input', [['type', 'checkbox']], [[8, 'checked', 0]], [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.onCheckboxChange($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵted"](null, ['\n      ']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.isSelected;
        _ck(_v, 2, 0, currVal_0);
    });
}
function View_DataTableBodyCellComponent_2(_l) {
    return __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵeld"](0, null, null, 1, 'span', [], [[8, 'title', 0], [8, 'innerHTML', 1]], null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵted"](null, ['\n      ']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.value;
        var currVal_1 = _co.value;
        _ck(_v, 0, 0, currVal_0, currVal_1);
    });
}
function View_DataTableBodyCellComponent_4(_l) {
    return __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵted"](null, ['\n      ']))], null, null);
}
function View_DataTableBodyCellComponent_3(_l) {
    return __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵand"](16777216, [[1, 3], ['cellTemplate', 2]], null, 2, null, View_DataTableBodyCellComponent_4)), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵdid"](540672, null, 0, __WEBPACK_IMPORTED_MODULE_1__angular_common__["NgTemplateOutlet"], [__WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewContainerRef"]], { ngTemplateOutlet: [0, 'ngTemplateOutlet'],
            ngOutletContext: [1, 'ngOutletContext'] }, null), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵpod"]({ value: 0, row: 1,
            column: 2, isSelected: 3, onCheckboxChangeFn: 4, activateFn: 5 }), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵand"](0, null, null, 0))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.column.cellTemplate;
        var currVal_1 = _ck(_v, 2, 0, _co.value, _co.row, _co.column, _co.isSelected, _co.onCheckboxChangeFn, _co.activateFn);
        _ck(_v, 1, 0, currVal_0, currVal_1);
    }, null);
}
function View_DataTableBodyCellComponent_0(_l) {
    return __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵvid"](0, [__WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵqud"](671088640, 1, { cellTemplate: 0 }), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵted"](null, ['\n    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵeld"](0, null, null, 10, 'div', [['class',
                'datatable-body-cell-label']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵted"](null, ['\n      '])), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵand"](16777216, null, null, 1, null, View_DataTableBodyCellComponent_1)),
        __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_1__angular_common__["NgIf"], [__WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewContainerRef"], __WEBPACK_IMPORTED_MODULE_0__angular_core__["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵted"](null, ['\n      '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵand"](16777216, null, null, 1, null, View_DataTableBodyCellComponent_2)),
        __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_1__angular_common__["NgIf"], [__WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewContainerRef"], __WEBPACK_IMPORTED_MODULE_0__angular_core__["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵted"](null, ['\n      '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵand"](16777216, null, null, 1, null, View_DataTableBodyCellComponent_3)),
        __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_1__angular_common__["NgIf"], [__WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewContainerRef"], __WEBPACK_IMPORTED_MODULE_0__angular_core__["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵted"](null, ['\n    '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵted"](null, ['\n  ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.column.checkboxable;
        _ck(_v, 5, 0, currVal_0);
        var currVal_1 = !_co.column.cellTemplate;
        _ck(_v, 8, 0, currVal_1);
        var currVal_2 = _co.column.cellTemplate;
        _ck(_v, 11, 0, currVal_2);
    }, null);
}
function View_DataTableBodyCellComponent_Host_0(_l) {
    return __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵeld"](0, null, null, 1, 'datatable-body-cell', [['class', 'datatable-body-cell']], [[8, 'className', 0], [4, 'width', 'px'], [4, 'height',
                null]], [[null, 'focus'], [null, 'blur'], [null,
                'click'], [null, 'dblclick'], [null, 'keydown']], function (_v, en, $event) {
            var ad = true;
            if (('focus' === en)) {
                var pd_0 = (__WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵnov"](_v, 1).onFocus() !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (__WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵnov"](_v, 1).onBlur() !== false);
                ad = (pd_1 && ad);
            }
            if (('click' === en)) {
                var pd_2 = (__WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵnov"](_v, 1).onClick($event) !== false);
                ad = (pd_2 && ad);
            }
            if (('dblclick' === en)) {
                var pd_3 = (__WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵnov"](_v, 1).onDblClick($event) !== false);
                ad = (pd_3 && ad);
            }
            if (('keydown' === en)) {
                var pd_4 = (__WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵnov"](_v, 1).onKeyDown($event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, View_DataTableBodyCellComponent_0, RenderType_DataTableBodyCellComponent)),
        __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵdid"](180224, null, 0, __WEBPACK_IMPORTED_MODULE_2__swimlane_ngx_datatable_release_components_body_body_cell_component__["DataTableBodyCellComponent"], [__WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"]], null, null)], null, function (_ck, _v) {
        var currVal_0 = __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵnov"](_v, 1).columnCssClasses;
        var currVal_1 = __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵnov"](_v, 1).width;
        var currVal_2 = __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵnov"](_v, 1).height;
        _ck(_v, 0, 0, currVal_0, currVal_1, currVal_2);
    });
}
var DataTableBodyCellComponentNgFactory = __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵccf"]('datatable-body-cell', __WEBPACK_IMPORTED_MODULE_2__swimlane_ngx_datatable_release_components_body_body_cell_component__["DataTableBodyCellComponent"], View_DataTableBodyCellComponent_Host_0, { row: 'row',
    column: 'column', rowHeight: 'rowHeight', isSelected: 'isSelected', sorts: 'sorts' }, { activate: 'activate' }, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=body-cell.component.ngfactory.js.map

/***/ }),
/* 516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RenderType_DataTableRowWrapperComponent; });
/* harmony export (immutable) */ __webpack_exports__["a"] = View_DataTableRowWrapperComponent_0;
/* unused harmony export View_DataTableRowWrapperComponent_Host_0 */
/* unused harmony export DataTableRowWrapperComponentNgFactory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_common__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__swimlane_ngx_datatable_release_components_body_body_row_wrapper_component__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__swimlane_ngx_datatable_release_components_body_body_row_wrapper_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__swimlane_ngx_datatable_release_components_body_body_row_wrapper_component__);
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */



var styles_DataTableRowWrapperComponent = [];
var RenderType_DataTableRowWrapperComponent = __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵcrt"]({ encapsulation: 2,
    styles: styles_DataTableRowWrapperComponent, data: {} });
function View_DataTableRowWrapperComponent_3(_l) {
    return __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵted"](null, ['\n      ']))], null, null);
}
function View_DataTableRowWrapperComponent_2(_l) {
    return __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵand"](16777216, null, null, 2, null, View_DataTableRowWrapperComponent_3)), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵdid"](540672, null, 0, __WEBPACK_IMPORTED_MODULE_1__angular_common__["NgTemplateOutlet"], [__WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewContainerRef"]], { ngTemplateOutlet: [0, 'ngTemplateOutlet'], ngOutletContext: [1,
                'ngOutletContext'] }, null), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵpod"]({ row: 0 }), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵand"](0, null, null, 0))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.rowDetail.template;
        var currVal_1 = _ck(_v, 2, 0, _co.row);
        _ck(_v, 1, 0, currVal_0, currVal_1);
    }, null);
}
function View_DataTableRowWrapperComponent_1(_l) {
    return __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵeld"](0, null, null, 4, 'div', [['class',
                'datatable-row-detail']], [[4, 'height', 'px']], null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵted"](null, ['\n      '])), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵand"](16777216, null, null, 1, null, View_DataTableRowWrapperComponent_2)),
        __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_1__angular_common__["NgIf"], [__WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewContainerRef"], __WEBPACK_IMPORTED_MODULE_0__angular_core__["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵted"](null, ['\n    ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_1 = (_co.rowDetail && _co.rowDetail.template);
        _ck(_v, 3, 0, currVal_1);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.detailRowHeight;
        _ck(_v, 0, 0, currVal_0);
    });
}
function View_DataTableRowWrapperComponent_0(_l) {
    return __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵted"](null, ['\n    '])), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵncd"](null, 0), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵted"](null, ['\n    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵand"](16777216, null, null, 1, null, View_DataTableRowWrapperComponent_1)), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_1__angular_common__["NgIf"], [__WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewContainerRef"], __WEBPACK_IMPORTED_MODULE_0__angular_core__["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵted"](null, ['\n  ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.expanded;
        _ck(_v, 4, 0, currVal_0);
    }, null);
}
function View_DataTableRowWrapperComponent_Host_0(_l) {
    return __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵeld"](0, null, null, 1, 'datatable-row-wrapper', [['class', 'datatable-row-wrapper']], null, [[null, 'contextmenu']], function (_v, en, $event) {
            var ad = true;
            if (('contextmenu' === en)) {
                var pd_0 = (__WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵnov"](_v, 1).onContextmenu($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_DataTableRowWrapperComponent_0, RenderType_DataTableRowWrapperComponent)),
        __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵdid"](49152, null, 0, __WEBPACK_IMPORTED_MODULE_2__swimlane_ngx_datatable_release_components_body_body_row_wrapper_component__["DataTableRowWrapperComponent"], [], null, null)], null, null);
}
var DataTableRowWrapperComponentNgFactory = __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵccf"]('datatable-row-wrapper', __WEBPACK_IMPORTED_MODULE_2__swimlane_ngx_datatable_release_components_body_body_row_wrapper_component__["DataTableRowWrapperComponent"], View_DataTableRowWrapperComponent_Host_0, { rowDetail: 'rowDetail',
    detailRowHeight: 'detailRowHeight', expanded: 'expanded', row: 'row' }, { rowContextmenu: 'rowContextmenu' }, ['*']);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3NyYy91aS9ub2RlX21vZHVsZXMvQHN3aW1sYW5lL25neC1kYXRhdGFibGUvcmVsZWFzZS9jb21wb25lbnRzL2JvZHkvYm9keS1yb3ctd3JhcHBlci5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vc3JjL3VpL25vZGVfbW9kdWxlcy9Ac3dpbWxhbmUvbmd4LWRhdGF0YWJsZS9yZWxlYXNlL2NvbXBvbmVudHMvYm9keS9ib2R5LXJvdy13cmFwcGVyLmNvbXBvbmVudC5kLnRzIiwibmc6Ly8vc3JjL3VpL25vZGVfbW9kdWxlcy9Ac3dpbWxhbmUvbmd4LWRhdGF0YWJsZS9yZWxlYXNlL2NvbXBvbmVudHMvYm9keS9ib2R5LXJvdy13cmFwcGVyLmNvbXBvbmVudC5kLnRzLkRhdGFUYWJsZVJvd1dyYXBwZXJDb21wb25lbnQuaHRtbCIsIm5nOi8vL3NyYy91aS9ub2RlX21vZHVsZXMvQHN3aW1sYW5lL25neC1kYXRhdGFibGUvcmVsZWFzZS9jb21wb25lbnRzL2JvZHkvYm9keS1yb3ctd3JhcHBlci5jb21wb25lbnQuZC50cy5EYXRhVGFibGVSb3dXcmFwcGVyQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiXG4gICAgPG5nLWNvbnRlbnQ+PC9uZy1jb250ZW50PlxuICAgIDxkaXYgXG4gICAgICAqbmdJZj1cImV4cGFuZGVkXCJcbiAgICAgIFtzdHlsZS5oZWlnaHQucHhdPVwiZGV0YWlsUm93SGVpZ2h0XCIgXG4gICAgICBjbGFzcz1cImRhdGF0YWJsZS1yb3ctZGV0YWlsXCI+XG4gICAgICA8bmctdGVtcGxhdGVcbiAgICAgICAgKm5nSWY9XCJyb3dEZXRhaWwgJiYgcm93RGV0YWlsLnRlbXBsYXRlXCJcbiAgICAgICAgW25nVGVtcGxhdGVPdXRsZXRdPVwicm93RGV0YWlsLnRlbXBsYXRlXCJcbiAgICAgICAgW25nT3V0bGV0Q29udGV4dF09XCJ7IHJvdzogcm93IH1cIj5cbiAgICAgIDwvbmctdGVtcGxhdGU+XG4gICAgPC9kaXY+XG4gICIsIjxkYXRhdGFibGUtcm93LXdyYXBwZXI+PC9kYXRhdGFibGUtcm93LXdyYXBwZXI+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7O29CQ1N5Qzs7O29CQUhuQztNQUFBLDZDQUFBO01BQUE7VUFBQSwwQ0FHRTs7O0lBREE7SUFDQTtJQUhGLFdBRUUsVUFDQSxTQUhGOzs7O29CQUpGO01BQUE7TUFBQSxnQkFHK0IsNkNBQzdCO01BQUE7YUFBQTtVQUFBLHdCQUljOzs7SUFIWjtJQURGLFdBQ0UsU0FERjs7O0lBRkE7SUFGRixXQUVFLFNBRkY7Ozs7b0JBRkosa0RBQ0k7TUFBQSxHQUF5QiwyQ0FDekI7TUFBQSwyRUFBQTtNQUFBO01BQUEsZUFTTTs7SUFSSjtJQURGLFdBQ0UsU0FERjs7OztvQkNGSjtNQUFBO01BQUE7UUFBQTtRQUFBO1VBQUE7VUFBQTtRQUFBO1FBQUE7TUFBQTthQUFBO1VBQUE7Ozs7OyJ9
//# sourceMappingURL=body-row-wrapper.component.ngfactory.js.map

/***/ }),
/* 517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RenderType_DataTableBodyRowComponent; });
/* harmony export (immutable) */ __webpack_exports__["a"] = View_DataTableBodyRowComponent_0;
/* unused harmony export View_DataTableBodyRowComponent_Host_0 */
/* unused harmony export DataTableBodyRowComponentNgFactory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__body_cell_component_ngfactory__ = __webpack_require__(515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__swimlane_ngx_datatable_release_components_body_body_cell_component__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__swimlane_ngx_datatable_release_components_body_body_cell_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__swimlane_ngx_datatable_release_components_body_body_cell_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__angular_common__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__swimlane_ngx_datatable_release_components_body_body_row_component__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__swimlane_ngx_datatable_release_components_body_body_row_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__swimlane_ngx_datatable_release_components_body_body_row_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__swimlane_ngx_datatable_release_services_scrollbar_helper_service__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__swimlane_ngx_datatable_release_services_scrollbar_helper_service___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__swimlane_ngx_datatable_release_services_scrollbar_helper_service__);
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */






var styles_DataTableBodyRowComponent = [];
var RenderType_DataTableBodyRowComponent = __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵcrt"]({ encapsulation: 2,
    styles: styles_DataTableBodyRowComponent, data: {} });
function View_DataTableBodyRowComponent_2(_l) {
    return __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵeld"](0, null, null, 2, 'datatable-body-cell', [['class', 'datatable-body-cell'], ['tabindex', '-1']], [[8, 'className', 0], [4, 'width',
                'px'], [4, 'height', null]], [[null, 'activate'], [null,
                'focus'], [null, 'blur'], [null, 'click'], [null, 'dblclick'],
            [null, 'keydown']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('focus' === en)) {
                var pd_0 = (__WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵnov"](_v, 1).onFocus() !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (__WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵnov"](_v, 1).onBlur() !== false);
                ad = (pd_1 && ad);
            }
            if (('click' === en)) {
                var pd_2 = (__WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵnov"](_v, 1).onClick($event) !== false);
                ad = (pd_2 && ad);
            }
            if (('dblclick' === en)) {
                var pd_3 = (__WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵnov"](_v, 1).onDblClick($event) !== false);
                ad = (pd_3 && ad);
            }
            if (('keydown' === en)) {
                var pd_4 = (__WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵnov"](_v, 1).onKeyDown($event) !== false);
                ad = (pd_4 && ad);
            }
            if (('activate' === en)) {
                var pd_5 = (_co.onActivate($event, _v.context.index) !== false);
                ad = (pd_5 && ad);
            }
            return ad;
        }, __WEBPACK_IMPORTED_MODULE_1__body_cell_component_ngfactory__["a" /* View_DataTableBodyCellComponent_0 */], __WEBPACK_IMPORTED_MODULE_1__body_cell_component_ngfactory__["b" /* RenderType_DataTableBodyCellComponent */])),
        __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵdid"](180224, null, 0, __WEBPACK_IMPORTED_MODULE_2__swimlane_ngx_datatable_release_components_body_body_cell_component__["DataTableBodyCellComponent"], [__WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"]], { row: [0, 'row'], column: [1, 'column'], rowHeight: [2, 'rowHeight'], isSelected: [3,
                'isSelected'] }, { activate: 'activate' }), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵted"](null, ['\n      ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_3 = _co.row;
        var currVal_4 = _v.context.$implicit;
        var currVal_5 = _co.rowHeight;
        var currVal_6 = _co.isSelected;
        _ck(_v, 1, 0, currVal_3, currVal_4, currVal_5, currVal_6);
    }, function (_ck, _v) {
        var currVal_0 = __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵnov"](_v, 1).columnCssClasses;
        var currVal_1 = __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵnov"](_v, 1).width;
        var currVal_2 = __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵnov"](_v, 1).height;
        _ck(_v, 0, 0, currVal_0, currVal_1, currVal_2);
    });
}
function View_DataTableBodyRowComponent_1(_l) {
    return __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵeld"](0, null, null, 5, 'div', [], [[8, 'className', 0]], null, null, null, null)),
        __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵdid"](278528, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_common__["NgStyle"], [__WEBPACK_IMPORTED_MODULE_0__angular_core__["KeyValueDiffers"], __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"],
            __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"]], { ngStyle: [0, 'ngStyle'] }, null), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵted"](null, ['\n      '])), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵand"](16777216, null, null, 1, null, View_DataTableBodyRowComponent_2)), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵdid"](802816, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_common__["NgForOf"], [__WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewContainerRef"], __WEBPACK_IMPORTED_MODULE_0__angular_core__["TemplateRef"], __WEBPACK_IMPORTED_MODULE_0__angular_core__["IterableDiffers"]], { ngForOf: [0, 'ngForOf'],
            ngForTrackBy: [1, 'ngForTrackBy'] }, null), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵted"](null, ['\n    ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_1 = _co.stylesByGroup(_v.context.$implicit.type);
        _ck(_v, 1, 0, currVal_1);
        var currVal_2 = _v.context.$implicit.columns;
        var currVal_3 = _co.columnTrackingFn;
        _ck(_v, 4, 0, currVal_2, currVal_3);
    }, function (_ck, _v) {
        var currVal_0 = __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵinlineInterpolate"](1, 'datatable-row-', _v.context.$implicit.type, ' datatable-row-group');
        _ck(_v, 0, 0, currVal_0);
    });
}
function View_DataTableBodyRowComponent_0(_l) {
    return __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵted"](null, ['\n    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵand"](16777216, null, null, 1, null, View_DataTableBodyRowComponent_1)),
        __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵdid"](802816, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_common__["NgForOf"], [__WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewContainerRef"], __WEBPACK_IMPORTED_MODULE_0__angular_core__["TemplateRef"],
            __WEBPACK_IMPORTED_MODULE_0__angular_core__["IterableDiffers"]], { ngForOf: [0, 'ngForOf'], ngForTrackBy: [1, 'ngForTrackBy'] }, null), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵted"](null, ['\n  ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.columnsByPin;
        var currVal_1 = _co.trackByGroups;
        _ck(_v, 2, 0, currVal_0, currVal_1);
    }, null);
}
function View_DataTableBodyRowComponent_Host_0(_l) {
    return __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵeld"](0, null, null, 1, 'datatable-body-row', [], [[8, 'className', 0], [4, 'height', 'px'], [4, 'width', 'px']], [[null,
                'keydown']], function (_v, en, $event) {
            var ad = true;
            if (('keydown' === en)) {
                var pd_0 = (__WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵnov"](_v, 1).onKeyDown($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_DataTableBodyRowComponent_0, RenderType_DataTableBodyRowComponent)), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵdid"](49152, null, 0, __WEBPACK_IMPORTED_MODULE_4__swimlane_ngx_datatable_release_components_body_body_row_component__["DataTableBodyRowComponent"], [__WEBPACK_IMPORTED_MODULE_5__swimlane_ngx_datatable_release_services_scrollbar_helper_service__["ScrollbarHelper"], __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"]], null, null)], null, function (_ck, _v) {
        var currVal_0 = __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵnov"](_v, 1).cssClass;
        var currVal_1 = __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵnov"](_v, 1).rowHeight;
        var currVal_2 = __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵnov"](_v, 1).columnsTotalWidths;
        _ck(_v, 0, 0, currVal_0, currVal_1, currVal_2);
    });
}
var DataTableBodyRowComponentNgFactory = __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵccf"]('datatable-body-row', __WEBPACK_IMPORTED_MODULE_4__swimlane_ngx_datatable_release_components_body_body_row_component__["DataTableBodyRowComponent"], View_DataTableBodyRowComponent_Host_0, { columns: 'columns',
    innerWidth: 'innerWidth', rowClass: 'rowClass', row: 'row', offsetX: 'offsetX', isSelected: 'isSelected',
    rowHeight: 'rowHeight' }, { activate: 'activate' }, []);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3NyYy91aS9ub2RlX21vZHVsZXMvQHN3aW1sYW5lL25neC1kYXRhdGFibGUvcmVsZWFzZS9jb21wb25lbnRzL2JvZHkvYm9keS1yb3cuY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL3NyYy91aS9ub2RlX21vZHVsZXMvQHN3aW1sYW5lL25neC1kYXRhdGFibGUvcmVsZWFzZS9jb21wb25lbnRzL2JvZHkvYm9keS1yb3cuY29tcG9uZW50LmQudHMiLCJuZzovLy9zcmMvdWkvbm9kZV9tb2R1bGVzL0Bzd2ltbGFuZS9uZ3gtZGF0YXRhYmxlL3JlbGVhc2UvY29tcG9uZW50cy9ib2R5L2JvZHktcm93LmNvbXBvbmVudC5kLnRzLkRhdGFUYWJsZUJvZHlSb3dDb21wb25lbnQuaHRtbCIsIm5nOi8vL3NyYy91aS9ub2RlX21vZHVsZXMvQHN3aW1sYW5lL25neC1kYXRhdGFibGUvcmVsZWFzZS9jb21wb25lbnRzL2JvZHkvYm9keS1yb3cuY29tcG9uZW50LmQudHMuRGF0YVRhYmxlQm9keVJvd0NvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIlxuICAgIDxkaXZcbiAgICAgICpuZ0Zvcj1cImxldCBjb2xHcm91cCBvZiBjb2x1bW5zQnlQaW47IGxldCBpID0gaW5kZXg7IHRyYWNrQnk6IHRyYWNrQnlHcm91cHNcIlxuICAgICAgY2xhc3M9XCJkYXRhdGFibGUtcm93LXt7Y29sR3JvdXAudHlwZX19IGRhdGF0YWJsZS1yb3ctZ3JvdXBcIlxuICAgICAgW25nU3R5bGVdPVwic3R5bGVzQnlHcm91cChjb2xHcm91cC50eXBlKVwiPlxuICAgICAgPGRhdGF0YWJsZS1ib2R5LWNlbGxcbiAgICAgICAgKm5nRm9yPVwibGV0IGNvbHVtbiBvZiBjb2xHcm91cC5jb2x1bW5zOyBsZXQgaWkgPSBpbmRleDsgdHJhY2tCeTogY29sdW1uVHJhY2tpbmdGblwiXG4gICAgICAgIHRhYmluZGV4PVwiLTFcIlxuICAgICAgICBbcm93XT1cInJvd1wiXG4gICAgICAgIFtpc1NlbGVjdGVkXT1cImlzU2VsZWN0ZWRcIlxuICAgICAgICBbY29sdW1uXT1cImNvbHVtblwiXG4gICAgICAgIFtyb3dIZWlnaHRdPVwicm93SGVpZ2h0XCJcbiAgICAgICAgKGFjdGl2YXRlKT1cIm9uQWN0aXZhdGUoJGV2ZW50LCBpaSlcIj5cbiAgICAgIDwvZGF0YXRhYmxlLWJvZHktY2VsbD5cbiAgICA8L2Rpdj5cbiAgIiwiPGRhdGF0YWJsZS1ib2R5LXJvdz48L2RhdGF0YWJsZS1ib2R5LXJvdz4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7b0JDS007TUFBQTtVQUFBO1VBQUE7VUFBQTtRQUFBO1FBQUE7UUFBQTtVQUFBO1VBQUE7UUFBQTtRQUFBO1VBQUE7VUFBQTtRQUFBO1FBQUE7VUFBQTtVQUFBO1FBQUE7UUFBQTtVQUFBO1VBQUE7UUFBQTtRQUFBO1VBQUE7VUFBQTtRQUFBO1FBT0U7VUFBQTtVQUFBO1FBQUE7UUFQRjtNQUFBO2FBQUE7VUFBQTtjQUFBLHNDQU9zQztVQUFBOztJQUpwQztJQUVBO0lBQ0E7SUFGQTtJQUpGLFdBR0UsVUFFQSxVQUNBLFVBRkEsU0FKRjs7SUFBQTtJQUFBO0lBQUE7SUFBQSxXQUFBLDZCQUFBOzs7O29CQUpGO01BQUE7YUFBQTtxQkFBQSx5Q0FHMkM7VUFBQSxlQUN6QztVQUFBLDBDQUFBO1VBQUE7Y0FBQSxnREFRc0I7VUFBQTs7SUFUdEI7SUFIRixXQUdFLFNBSEY7SUFLSTtJQUFBO0lBREYsV0FDRSxtQkFERjs7SUFGQTtRQUFBO0lBRkYsV0FFRSxTQUZGOzs7O29CQURKLDJDQUNJO01BQUE7YUFBQTs0QkFBQTtVQUFBLGVBYU07O0lBWko7SUFBQTtJQURGLFdBQ0UsbUJBREY7Ozs7b0JDREo7TUFBQTtVQUFBO1FBQUE7UUFBQTtVQUFBO1VBQUE7UUFBQTtRQUFBO01BQUEsaUZBQUE7TUFBQTtNQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUEsV0FBQSw2QkFBQTs7Ozs7OyJ9
//# sourceMappingURL=body-row.component.ngfactory.js.map

/***/ }),
/* 518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RenderType_DataTableBodyComponent; });
/* harmony export (immutable) */ __webpack_exports__["a"] = View_DataTableBodyComponent_0;
/* unused harmony export View_DataTableBodyComponent_Host_0 */
/* unused harmony export DataTableBodyComponentNgFactory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__progress_bar_component_ngfactory__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__swimlane_ngx_datatable_release_components_body_progress_bar_component__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__swimlane_ngx_datatable_release_components_body_progress_bar_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__swimlane_ngx_datatable_release_components_body_progress_bar_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__body_row_wrapper_component_ngfactory__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__angular_common__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__swimlane_ngx_datatable_release_components_body_body_row_wrapper_component__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__swimlane_ngx_datatable_release_components_body_body_row_wrapper_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__swimlane_ngx_datatable_release_components_body_body_row_wrapper_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__body_row_component_ngfactory__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__swimlane_ngx_datatable_release_components_body_body_row_component__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__swimlane_ngx_datatable_release_components_body_body_row_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__swimlane_ngx_datatable_release_components_body_body_row_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__swimlane_ngx_datatable_release_services_scrollbar_helper_service__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__swimlane_ngx_datatable_release_services_scrollbar_helper_service___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__swimlane_ngx_datatable_release_services_scrollbar_helper_service__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__scroller_component_ngfactory__ = __webpack_require__(520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__swimlane_ngx_datatable_release_components_body_scroller_component__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__swimlane_ngx_datatable_release_components_body_scroller_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__swimlane_ngx_datatable_release_components_body_scroller_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__swimlane_ngx_datatable_release_components_body_body_component__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__swimlane_ngx_datatable_release_components_body_body_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__swimlane_ngx_datatable_release_components_body_body_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__selection_component_ngfactory__ = __webpack_require__(521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__swimlane_ngx_datatable_release_components_body_selection_component__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__swimlane_ngx_datatable_release_components_body_selection_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__swimlane_ngx_datatable_release_components_body_selection_component__);
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */














var styles_DataTableBodyComponent = [];
var RenderType_DataTableBodyComponent = __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵcrt"]({ encapsulation: 2,
    styles: styles_DataTableBodyComponent, data: {} });
function View_DataTableBodyComponent_1(_l) {
    return __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵeld"](0, null, null, 2, 'datatable-progress', [], null, null, null, __WEBPACK_IMPORTED_MODULE_1__progress_bar_component_ngfactory__["a" /* View_ProgressBarComponent_0 */], __WEBPACK_IMPORTED_MODULE_1__progress_bar_component_ngfactory__["b" /* RenderType_ProgressBarComponent */])), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵdid"](49152, null, 0, __WEBPACK_IMPORTED_MODULE_2__swimlane_ngx_datatable_release_components_body_progress_bar_component__["ProgressBarComponent"], [], null, null), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵted"](null, ['\n      ']))], null, null);
}
function View_DataTableBodyComponent_3(_l) {
    return __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵeld"](0, null, null, 7, 'datatable-row-wrapper', [['class', 'datatable-row-wrapper']], null, [[null, 'rowContextmenu'],
            [null, 'contextmenu']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('contextmenu' === en)) {
                var pd_0 = (__WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵnov"](_v, 2).onContextmenu($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('rowContextmenu' === en)) {
                var pd_1 = (_co.rowContextmenu.emit($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, __WEBPACK_IMPORTED_MODULE_3__body_row_wrapper_component_ngfactory__["a" /* View_DataTableRowWrapperComponent_0 */], __WEBPACK_IMPORTED_MODULE_3__body_row_wrapper_component_ngfactory__["b" /* RenderType_DataTableRowWrapperComponent */])),
        __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵdid"](278528, null, 0, __WEBPACK_IMPORTED_MODULE_4__angular_common__["NgStyle"], [__WEBPACK_IMPORTED_MODULE_0__angular_core__["KeyValueDiffers"], __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"],
            __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"]], { ngStyle: [0, 'ngStyle'] }, null), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵdid"](49152, null, 0, __WEBPACK_IMPORTED_MODULE_5__swimlane_ngx_datatable_release_components_body_body_row_wrapper_component__["DataTableRowWrapperComponent"], [], { rowDetail: [0, 'rowDetail'],
            detailRowHeight: [1, 'detailRowHeight'], expanded: [2, 'expanded'], row: [3,
                'row'] }, { rowContextmenu: 'rowContextmenu' }), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵted"](0, ['\n          '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵeld"](0, null, 0, 2, 'datatable-body-row', [['tabindex', '-1']], [[8, 'className', 0], [4, 'height', 'px'], [4, 'width', 'px']], [[null, 'activate'],
            [null, 'keydown']], function (_v, en, $event) {
            var ad = true;
            if (('keydown' === en)) {
                var pd_0 = (__WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵnov"](_v, 5).onKeyDown($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('activate' === en)) {
                var pd_1 = (__WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵnov"](_v.parent.parent, 3).onActivate($event, _v.context.index) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, __WEBPACK_IMPORTED_MODULE_6__body_row_component_ngfactory__["a" /* View_DataTableBodyRowComponent_0 */], __WEBPACK_IMPORTED_MODULE_6__body_row_component_ngfactory__["b" /* RenderType_DataTableBodyRowComponent */])),
        __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵdid"](49152, null, 0, __WEBPACK_IMPORTED_MODULE_7__swimlane_ngx_datatable_release_components_body_body_row_component__["DataTableBodyRowComponent"], [__WEBPACK_IMPORTED_MODULE_8__swimlane_ngx_datatable_release_services_scrollbar_helper_service__["ScrollbarHelper"],
            __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"]], { columns: [0, 'columns'], innerWidth: [1, 'innerWidth'], rowClass: [2,
                'rowClass'], row: [3, 'row'], offsetX: [4, 'offsetX'], isSelected: [5, 'isSelected'],
            rowHeight: [6, 'rowHeight'] }, { activate: 'activate' }), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵted"](null, ['\n          '])), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵted"](0, ['\n        ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.getRowsStyles(_v.context.$implicit);
        _ck(_v, 1, 0, currVal_0);
        var currVal_1 = _co.rowDetail;
        var currVal_2 = _co.getDetailRowHeight(_v.context.$implicit, _v.context.index);
        var currVal_3 = (_v.context.$implicit.$$expanded === 1);
        var currVal_4 = _v.context.$implicit;
        _ck(_v, 2, 0, currVal_1, currVal_2, currVal_3, currVal_4);
        var currVal_8 = _co.columns;
        var currVal_9 = _co.innerWidth;
        var currVal_10 = _co.rowClass;
        var currVal_11 = _v.context.$implicit;
        var currVal_12 = _co.offsetX;
        var currVal_13 = __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵnov"](_v.parent.parent, 3).getRowSelected(_v.context.$implicit);
        var currVal_14 = _co.getRowHeight(_v.context.$implicit);
        _ck(_v, 5, 0, currVal_8, currVal_9, currVal_10, currVal_11, currVal_12, currVal_13, currVal_14);
    }, function (_ck, _v) {
        var currVal_5 = __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵnov"](_v, 5).cssClass;
        var currVal_6 = __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵnov"](_v, 5).rowHeight;
        var currVal_7 = __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵnov"](_v, 5).columnsTotalWidths;
        _ck(_v, 4, 0, currVal_5, currVal_6, currVal_7);
    });
}
function View_DataTableBodyComponent_2(_l) {
    return __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵeld"](0, null, null, 5, 'datatable-scroller', [['class', 'datatable-scroll']], [[4, 'height', 'px'], [4, 'width', 'px']], [[null,
                'scroll']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('scroll' === en)) {
                var pd_0 = (_co.onBodyScroll($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, __WEBPACK_IMPORTED_MODULE_9__scroller_component_ngfactory__["a" /* View_ScrollerComponent_0 */], __WEBPACK_IMPORTED_MODULE_9__scroller_component_ngfactory__["b" /* RenderType_ScrollerComponent */])), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵdid"](245760, [[1, 4]], 0, __WEBPACK_IMPORTED_MODULE_10__swimlane_ngx_datatable_release_components_body_scroller_component__["ScrollerComponent"], [__WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"]], { scrollbarV: [0, 'scrollbarV'],
            scrollbarH: [1, 'scrollbarH'], scrollHeight: [2, 'scrollHeight'], scrollWidth: [3,
                'scrollWidth'] }, { scroll: 'scroll' }), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵted"](0, ['\n        '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵand"](16777216, null, 0, 1, null, View_DataTableBodyComponent_3)),
        __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵdid"](802816, null, 0, __WEBPACK_IMPORTED_MODULE_4__angular_common__["NgForOf"], [__WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewContainerRef"], __WEBPACK_IMPORTED_MODULE_0__angular_core__["TemplateRef"],
            __WEBPACK_IMPORTED_MODULE_0__angular_core__["IterableDiffers"]], { ngForOf: [0, 'ngForOf'], ngForTrackBy: [1, 'ngForTrackBy'] }, null), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵted"](0, ['\n      ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_2 = _co.scrollbarV;
        var currVal_3 = _co.scrollbarH;
        var currVal_4 = _co.scrollHeight;
        var currVal_5 = _co.columnGroupWidths.total;
        _ck(_v, 1, 0, currVal_2, currVal_3, currVal_4, currVal_5);
        var currVal_6 = _co.temp;
        var currVal_7 = _co.rowTrackingFn;
        _ck(_v, 4, 0, currVal_6, currVal_7);
    }, function (_ck, _v) {
        var currVal_0 = __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵnov"](_v, 1).scrollHeight;
        var currVal_1 = __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵnov"](_v, 1).scrollWidth;
        _ck(_v, 0, 0, currVal_0, currVal_1);
    });
}
function View_DataTableBodyComponent_4(_l) {
    return __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵeld"](0, null, null, 1, 'div', [['class',
                'empty-row']], [[8, 'innerHTML', 1]], null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵted"](null, ['\n      ']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.emptyMessage;
        _ck(_v, 0, 0, currVal_0);
    });
}
function View_DataTableBodyComponent_0(_l) {
    return __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵvid"](0, [__WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵqud"](671088640, 1, { scroller: 0 }), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵted"](null, ['\n    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵeld"](0, null, null, 11, 'datatable-selection', [], null, [[null, 'select'], [null, 'activate']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('select' === en)) {
                var pd_0 = (_co.select.emit($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('activate' === en)) {
                var pd_1 = (_co.activate.emit($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, __WEBPACK_IMPORTED_MODULE_12__selection_component_ngfactory__["a" /* View_DataTableSelectionComponent_0 */], __WEBPACK_IMPORTED_MODULE_12__selection_component_ngfactory__["b" /* RenderType_DataTableSelectionComponent */])),
        __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵdid"](49152, [['selector', 4]], 0, __WEBPACK_IMPORTED_MODULE_13__swimlane_ngx_datatable_release_components_body_selection_component__["DataTableSelectionComponent"], [], { rows: [0, 'rows'], selected: [1, 'selected'], selectEnabled: [2, 'selectEnabled'],
            selectionType: [3, 'selectionType'], rowIdentity: [4, 'rowIdentity'], selectCheck: [5,
                'selectCheck'] }, { activate: 'activate', select: 'select' }), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵted"](0, ['\n      '])), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵand"](16777216, null, 0, 1, null, View_DataTableBodyComponent_1)), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_4__angular_common__["NgIf"], [__WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewContainerRef"],
            __WEBPACK_IMPORTED_MODULE_0__angular_core__["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵted"](0, ['\n      '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵand"](16777216, null, 0, 1, null, View_DataTableBodyComponent_2)),
        __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_4__angular_common__["NgIf"], [__WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewContainerRef"], __WEBPACK_IMPORTED_MODULE_0__angular_core__["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵted"](0, ['\n      '])), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵand"](16777216, null, 0, 1, null, View_DataTableBodyComponent_4)), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_4__angular_common__["NgIf"], [__WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewContainerRef"], __WEBPACK_IMPORTED_MODULE_0__angular_core__["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵted"](0, ['\n    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵted"](null, ['\n  ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.temp;
        var currVal_1 = _co.selected;
        var currVal_2 = _co.selectEnabled;
        var currVal_3 = _co.selectionType;
        var currVal_4 = _co.rowIdentity;
        var currVal_5 = _co.selectCheck;
        _ck(_v, 3, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5);
        var currVal_6 = _co.loadingIndicator;
        _ck(_v, 6, 0, currVal_6);
        var currVal_7 = ((_co.rows == null) ? null : _co.rows.length);
        _ck(_v, 9, 0, currVal_7);
        var currVal_8 = !((_co.rows == null) ? null : _co.rows.length);
        _ck(_v, 12, 0, currVal_8);
    }, null);
}
function View_DataTableBodyComponent_Host_0(_l) {
    return __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵeld"](0, null, null, 1, 'datatable-body', [['class', 'datatable-body']], [[4, 'width', null], [4, 'height', null]], null, null, View_DataTableBodyComponent_0, RenderType_DataTableBodyComponent)),
        __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵdid"](245760, null, 0, __WEBPACK_IMPORTED_MODULE_11__swimlane_ngx_datatable_release_components_body_body_component__["DataTableBodyComponent"], [], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, function (_ck, _v) {
        var currVal_0 = __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵnov"](_v, 1).bodyWidth;
        var currVal_1 = __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵnov"](_v, 1).bodyHeight;
        _ck(_v, 0, 0, currVal_0, currVal_1);
    });
}
var DataTableBodyComponentNgFactory = __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵccf"]('datatable-body', __WEBPACK_IMPORTED_MODULE_11__swimlane_ngx_datatable_release_components_body_body_component__["DataTableBodyComponent"], View_DataTableBodyComponent_Host_0, { scrollbarV: 'scrollbarV',
    scrollbarH: 'scrollbarH', loadingIndicator: 'loadingIndicator', externalPaging: 'externalPaging',
    rowHeight: 'rowHeight', offsetX: 'offsetX', emptyMessage: 'emptyMessage', selectionType: 'selectionType',
    selected: 'selected', rowIdentity: 'rowIdentity', rowDetail: 'rowDetail', selectCheck: 'selectCheck',
    trackByProp: 'trackByProp', rowClass: 'rowClass', pageSize: 'pageSize', rows: 'rows',
    columns: 'columns', offset: 'offset', rowCount: 'rowCount', innerWidth: 'innerWidth',
    bodyHeight: 'bodyHeight' }, { scroll: 'scroll', page: 'page', activate: 'activate',
    select: 'select', detailToggle: 'detailToggle', rowContextmenu: 'rowContextmenu' }, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=body.component.ngfactory.js.map

/***/ }),
/* 519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RenderType_ProgressBarComponent; });
/* harmony export (immutable) */ __webpack_exports__["a"] = View_ProgressBarComponent_0;
/* unused harmony export View_ProgressBarComponent_Host_0 */
/* unused harmony export ProgressBarComponentNgFactory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__swimlane_ngx_datatable_release_components_body_progress_bar_component__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__swimlane_ngx_datatable_release_components_body_progress_bar_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__swimlane_ngx_datatable_release_components_body_progress_bar_component__);
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */


var styles_ProgressBarComponent = [];
var RenderType_ProgressBarComponent = __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵcrt"]({ encapsulation: 2,
    styles: styles_ProgressBarComponent, data: {} });
function View_ProgressBarComponent_0(_l) {
    return __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵvid"](2, [(_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵted"](null, ['\n    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵeld"](0, null, null, 6, 'div', [['class', 'progress-linear'], ['role', 'progressbar']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵted"](null, ['\n      '])), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵeld"](0, null, null, 3, 'div', [['class',
                'container']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵted"](null, ['\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵeld"](0, null, null, 0, 'div', [['class', 'bar']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵted"](null, ['\n      '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵted"](null, ['\n    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵted"](null, ['\n  ']))], null, null);
}
function View_ProgressBarComponent_Host_0(_l) {
    return __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵeld"](0, null, null, 1, 'datatable-progress', [], null, null, null, View_ProgressBarComponent_0, RenderType_ProgressBarComponent)), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵdid"](49152, null, 0, __WEBPACK_IMPORTED_MODULE_1__swimlane_ngx_datatable_release_components_body_progress_bar_component__["ProgressBarComponent"], [], null, null)], null, null);
}
var ProgressBarComponentNgFactory = __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵccf"]('datatable-progress', __WEBPACK_IMPORTED_MODULE_1__swimlane_ngx_datatable_release_components_body_progress_bar_component__["ProgressBarComponent"], View_ProgressBarComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3NyYy91aS9ub2RlX21vZHVsZXMvQHN3aW1sYW5lL25neC1kYXRhdGFibGUvcmVsZWFzZS9jb21wb25lbnRzL2JvZHkvcHJvZ3Jlc3MtYmFyLmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9zcmMvdWkvbm9kZV9tb2R1bGVzL0Bzd2ltbGFuZS9uZ3gtZGF0YXRhYmxlL3JlbGVhc2UvY29tcG9uZW50cy9ib2R5L3Byb2dyZXNzLWJhci5jb21wb25lbnQuZC50cyIsIm5nOi8vL3NyYy91aS9ub2RlX21vZHVsZXMvQHN3aW1sYW5lL25neC1kYXRhdGFibGUvcmVsZWFzZS9jb21wb25lbnRzL2JvZHkvcHJvZ3Jlc3MtYmFyLmNvbXBvbmVudC5kLnRzLlByb2dyZXNzQmFyQ29tcG9uZW50Lmh0bWwiLCJuZzovLy9zcmMvdWkvbm9kZV9tb2R1bGVzL0Bzd2ltbGFuZS9uZ3gtZGF0YXRhYmxlL3JlbGVhc2UvY29tcG9uZW50cy9ib2R5L3Byb2dyZXNzLWJhci5jb21wb25lbnQuZC50cy5Qcm9ncmVzc0JhckNvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIlxuICAgIDxkaXYgY2xhc3M9XCJwcm9ncmVzcy1saW5lYXJcIiByb2xlPVwicHJvZ3Jlc3NiYXJcIj5cbiAgICAgIDxkaXYgY2xhc3M9XCJjb250YWluZXJcIj5cbiAgICAgICAgPGRpdiBjbGFzcz1cImJhclwiPjwvZGl2PlxuICAgICAgPC9kaXY+XG4gICAgPC9kaXY+XG4gICIsIjxkYXRhdGFibGUtcHJvZ3Jlc3M+PC9kYXRhdGFibGUtcHJvZ3Jlc3M+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7b0JDQUEsMkNBQ0k7TUFBQTtNQUFBLDBEQUFnRDtNQUFBLGVBQzlDO01BQUE7TUFBdUIsK0NBQ3JCO1VBQUE7VUFBQSw4QkFBdUI7TUFDbkIsMkNBQ0Y7Ozs7b0JDTFY7TUFBQTtxQ0FBQSxVQUFBO01BQUE7OzsifQ==
//# sourceMappingURL=progress-bar.component.ngfactory.js.map

/***/ }),
/* 520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RenderType_ScrollerComponent; });
/* harmony export (immutable) */ __webpack_exports__["a"] = View_ScrollerComponent_0;
/* unused harmony export View_ScrollerComponent_Host_0 */
/* unused harmony export ScrollerComponentNgFactory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__swimlane_ngx_datatable_release_components_body_scroller_component__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__swimlane_ngx_datatable_release_components_body_scroller_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__swimlane_ngx_datatable_release_components_body_scroller_component__);
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */


var styles_ScrollerComponent = [];
var RenderType_ScrollerComponent = __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵcrt"]({ encapsulation: 2,
    styles: styles_ScrollerComponent, data: {} });
function View_ScrollerComponent_0(_l) {
    return __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵted"](null, ['\n    '])), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵncd"](null, 0), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵted"](null, ['\n  ']))], null, null);
}
function View_ScrollerComponent_Host_0(_l) {
    return __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵeld"](0, null, null, 1, 'datatable-scroller', [['class', 'datatable-scroll']], [[4, 'height', 'px'], [4, 'width', 'px']], null, null, View_ScrollerComponent_0, RenderType_ScrollerComponent)), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵdid"](245760, null, 0, __WEBPACK_IMPORTED_MODULE_1__swimlane_ngx_datatable_release_components_body_scroller_component__["ScrollerComponent"], [__WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, function (_ck, _v) {
        var currVal_0 = __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵnov"](_v, 1).scrollHeight;
        var currVal_1 = __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵnov"](_v, 1).scrollWidth;
        _ck(_v, 0, 0, currVal_0, currVal_1);
    });
}
var ScrollerComponentNgFactory = __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵccf"]('datatable-scroller', __WEBPACK_IMPORTED_MODULE_1__swimlane_ngx_datatable_release_components_body_scroller_component__["ScrollerComponent"], View_ScrollerComponent_Host_0, { scrollbarV: 'scrollbarV', scrollbarH: 'scrollbarH',
    scrollHeight: 'scrollHeight', scrollWidth: 'scrollWidth' }, { scroll: 'scroll' }, ['*']);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3NyYy91aS9ub2RlX21vZHVsZXMvQHN3aW1sYW5lL25neC1kYXRhdGFibGUvcmVsZWFzZS9jb21wb25lbnRzL2JvZHkvc2Nyb2xsZXIuY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL3NyYy91aS9ub2RlX21vZHVsZXMvQHN3aW1sYW5lL25neC1kYXRhdGFibGUvcmVsZWFzZS9jb21wb25lbnRzL2JvZHkvc2Nyb2xsZXIuY29tcG9uZW50LmQudHMiLCJuZzovLy9zcmMvdWkvbm9kZV9tb2R1bGVzL0Bzd2ltbGFuZS9uZ3gtZGF0YXRhYmxlL3JlbGVhc2UvY29tcG9uZW50cy9ib2R5L3Njcm9sbGVyLmNvbXBvbmVudC5kLnRzLlNjcm9sbGVyQ29tcG9uZW50Lmh0bWwiLCJuZzovLy9zcmMvdWkvbm9kZV9tb2R1bGVzL0Bzd2ltbGFuZS9uZ3gtZGF0YXRhYmxlL3JlbGVhc2UvY29tcG9uZW50cy9ib2R5L3Njcm9sbGVyLmNvbXBvbmVudC5kLnRzLlNjcm9sbGVyQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiXG4gICAgPG5nLWNvbnRlbnQ+PC9uZy1jb250ZW50PlxuICAiLCI8ZGF0YXRhYmxlLXNjcm9sbGVyPjwvZGF0YXRhYmxlLXNjcm9sbGVyPiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7O29CQ0FBLGtEQUNJO01BQUEsR0FBeUI7OztvQkNEN0I7TUFBQTtNQUFBLDZFQUFBO01BQUE7TUFBQTtJQUFBOztJQUFBO0lBQUE7SUFBQSxXQUFBLG1CQUFBOzs7OzsifQ==
//# sourceMappingURL=scroller.component.ngfactory.js.map

/***/ }),
/* 521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RenderType_DataTableSelectionComponent; });
/* harmony export (immutable) */ __webpack_exports__["a"] = View_DataTableSelectionComponent_0;
/* unused harmony export View_DataTableSelectionComponent_Host_0 */
/* unused harmony export DataTableSelectionComponentNgFactory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__swimlane_ngx_datatable_release_components_body_selection_component__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__swimlane_ngx_datatable_release_components_body_selection_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__swimlane_ngx_datatable_release_components_body_selection_component__);
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */


var styles_DataTableSelectionComponent = [];
var RenderType_DataTableSelectionComponent = __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵcrt"]({ encapsulation: 2,
    styles: styles_DataTableSelectionComponent, data: {} });
function View_DataTableSelectionComponent_0(_l) {
    return __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵted"](null, ['\n    '])), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵncd"](null, 0), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵted"](null, ['\n  ']))], null, null);
}
function View_DataTableSelectionComponent_Host_0(_l) {
    return __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵeld"](0, null, null, 1, 'datatable-selection', [], null, null, null, View_DataTableSelectionComponent_0, RenderType_DataTableSelectionComponent)), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵdid"](49152, null, 0, __WEBPACK_IMPORTED_MODULE_1__swimlane_ngx_datatable_release_components_body_selection_component__["DataTableSelectionComponent"], [], null, null)], null, null);
}
var DataTableSelectionComponentNgFactory = __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵccf"]('datatable-selection', __WEBPACK_IMPORTED_MODULE_1__swimlane_ngx_datatable_release_components_body_selection_component__["DataTableSelectionComponent"], View_DataTableSelectionComponent_Host_0, { rows: 'rows',
    selected: 'selected', selectEnabled: 'selectEnabled', selectionType: 'selectionType',
    rowIdentity: 'rowIdentity', selectCheck: 'selectCheck' }, { activate: 'activate',
    select: 'select' }, ['*']);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3NyYy91aS9ub2RlX21vZHVsZXMvQHN3aW1sYW5lL25neC1kYXRhdGFibGUvcmVsZWFzZS9jb21wb25lbnRzL2JvZHkvc2VsZWN0aW9uLmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9zcmMvdWkvbm9kZV9tb2R1bGVzL0Bzd2ltbGFuZS9uZ3gtZGF0YXRhYmxlL3JlbGVhc2UvY29tcG9uZW50cy9ib2R5L3NlbGVjdGlvbi5jb21wb25lbnQuZC50cyIsIm5nOi8vL3NyYy91aS9ub2RlX21vZHVsZXMvQHN3aW1sYW5lL25neC1kYXRhdGFibGUvcmVsZWFzZS9jb21wb25lbnRzL2JvZHkvc2VsZWN0aW9uLmNvbXBvbmVudC5kLnRzLkRhdGFUYWJsZVNlbGVjdGlvbkNvbXBvbmVudC5odG1sIiwibmc6Ly8vc3JjL3VpL25vZGVfbW9kdWxlcy9Ac3dpbWxhbmUvbmd4LWRhdGF0YWJsZS9yZWxlYXNlL2NvbXBvbmVudHMvYm9keS9zZWxlY3Rpb24uY29tcG9uZW50LmQudHMuRGF0YVRhYmxlU2VsZWN0aW9uQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiXG4gICAgPG5nLWNvbnRlbnQ+PC9uZy1jb250ZW50PlxuICAiLCI8ZGF0YXRhYmxlLXNlbGVjdGlvbj48L2RhdGF0YWJsZS1zZWxlY3Rpb24+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7b0JDQUEsa0RBQ0k7TUFBQSxHQUF5Qjs7O29CQ0Q3QjtNQUFBOzRDQUFBLFVBQUE7TUFBQTs7Ozs7OyJ9
//# sourceMappingURL=selection.component.ngfactory.js.map

/***/ }),
/* 522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return styles; });
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */
var styles = ['.ngx-datatable {\n  display: block;\n  overflow: hidden;\n  justify-content: center;\n  position: relative;\n  -webkit-transform: translate3d(0, 0, 0);\n  \n  \n  \n  \n  \n  \n  \n   }\n  .ngx-datatable [hidden] {\n    display: none !important; }\n  .ngx-datatable *, .ngx-datatable *:before, .ngx-datatable *:after {\n    -moz-box-sizing: border-box;\n    -webkit-box-sizing: border-box;\n    box-sizing: border-box; }\n  .ngx-datatable.scroll-vertical .datatable-body {\n    overflow-y: auto; }\n    .ngx-datatable.scroll-vertical .datatable-body .datatable-row-wrapper {\n      position: absolute; }\n  .ngx-datatable.scroll-horz .datatable-body {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch; }\n  .ngx-datatable.fixed-header .datatable-header .datatable-header-inner {\n    white-space: nowrap; }\n    .ngx-datatable.fixed-header .datatable-header .datatable-header-inner .datatable-header-cell {\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis; }\n  .ngx-datatable.fixed-row .datatable-scroll {\n    white-space: nowrap; }\n    .ngx-datatable.fixed-row .datatable-scroll .datatable-body-row {\n      white-space: nowrap; }\n      .ngx-datatable.fixed-row .datatable-scroll .datatable-body-row .datatable-body-cell {\n        overflow: hidden;\n        white-space: nowrap;\n        text-overflow: ellipsis; }\n  .ngx-datatable .datatable-body-row,\n  .ngx-datatable .datatable-header-inner {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    flex-direction: row;\n    -webkit-flex-flow: row;\n    -moz-flex-flow: row;\n    -ms-flex-flow: row;\n    -o-flex-flow: row;\n    flex-flow: row; }\n  .ngx-datatable .datatable-body-cell,\n  .ngx-datatable .datatable-header-cell {\n    vertical-align: top;\n    display: inline-block;\n    line-height: 1.625;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    -o-user-select: none;\n    user-select: none; }\n    .ngx-datatable .datatable-body-cell:focus,\n    .ngx-datatable .datatable-header-cell:focus {\n      outline: none; }\n  .ngx-datatable .datatable-row-left,\n  .ngx-datatable .datatable-row-right {\n    z-index: 9; }\n  .ngx-datatable .datatable-row-left,\n  .ngx-datatable .datatable-row-center,\n  .ngx-datatable .datatable-row-right {\n    position: relative; }\n  .ngx-datatable .datatable-header {\n    display: block;\n    overflow: hidden; }\n    .ngx-datatable .datatable-header .datatable-header-inner {\n      align-items: stretch;\n      -webkit-align-items: stretch; }\n    .ngx-datatable .datatable-header .datatable-header-cell {\n      position: relative;\n      display: inline-block; }\n      .ngx-datatable .datatable-header .datatable-header-cell .datatable-header-cell-wrapper {\n        cursor: pointer; }\n      .ngx-datatable .datatable-header .datatable-header-cell.longpress .datatable-header-cell-wrapper {\n        cursor: move; }\n      .ngx-datatable .datatable-header .datatable-header-cell .sort-btn {\n        line-height: 100%;\n        vertical-align: middle;\n        display: inline-block;\n        cursor: pointer; }\n      .ngx-datatable .datatable-header .datatable-header-cell .resize-handle {\n        display: inline-block;\n        position: absolute;\n        right: 0;\n        top: 0;\n        bottom: 0;\n        width: 5px;\n        padding: 0 4px;\n        visibility: hidden;\n        cursor: ew-resize; }\n      .ngx-datatable .datatable-header .datatable-header-cell.resizeable:hover .resize-handle {\n        visibility: visible; }\n  .ngx-datatable .datatable-body {\n    position: relative;\n    z-index: 10;\n    display: block; }\n    .ngx-datatable .datatable-body .datatable-scroll {\n      display: inline-block; }\n    .ngx-datatable .datatable-body .datatable-row-detail {\n      overflow-y: hidden; }\n    .ngx-datatable .datatable-body .datatable-row-wrapper {\n      display: -webkit-box;\n      display: -moz-box;\n      display: -ms-flexbox;\n      display: -webkit-flex;\n      display: flex;\n      -webkit-box-orient: vertical;\n      -webkit-box-direction: normal;\n      -webkit-flex-direction: column;\n      -moz-box-orient: vertical;\n      -moz-box-direction: normal;\n      -ms-flex-direction: column;\n      flex-direction: column; }\n    .ngx-datatable .datatable-body .datatable-body-row {\n      outline: none; }\n      .ngx-datatable .datatable-body .datatable-body-row > div {\n        display: -webkit-box;\n        display: -moz-box;\n        display: -ms-flexbox;\n        display: -webkit-flex;\n        display: flex; }\n  .ngx-datatable .datatable-footer {\n    display: block;\n    width: 100%; }\n    .ngx-datatable .datatable-footer .datatable-footer-inner {\n      display: flex;\n      align-items: center;\n      width: 100%; }\n    .ngx-datatable .datatable-footer .selected-count .page-count {\n      flex: 1 1 40%; }\n    .ngx-datatable .datatable-footer .selected-count .datatable-pager {\n      flex: 1 1 60%; }\n    .ngx-datatable .datatable-footer .page-count {\n      flex: 1 1 20%; }\n    .ngx-datatable .datatable-footer .datatable-pager {\n      flex: 1 1 80%;\n      text-align: right; }\n      .ngx-datatable .datatable-footer .datatable-pager .pager,\n      .ngx-datatable .datatable-footer .datatable-pager .pager li {\n        padding: 0;\n        margin: 0;\n        display: inline-block;\n        list-style: none; }\n      .ngx-datatable .datatable-footer .datatable-pager .pager li, .ngx-datatable .datatable-footer .datatable-pager .pager li a {\n        outline: none; }\n      .ngx-datatable .datatable-footer .datatable-pager .pager li a {\n        cursor: pointer;\n        display: inline-block; }\n      .ngx-datatable .datatable-footer .datatable-pager .pager li.disabled a {\n        cursor: not-allowed; }\n'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3NyYy91aS9ub2RlX21vZHVsZXMvQHN3aW1sYW5lL25neC1kYXRhdGFibGUvcmVsZWFzZS9jb21wb25lbnRzL2RhdGF0YWJsZS5jb21wb25lbnQuY3NzLm5nc3R5bGUudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9zcmMvdWkvbm9kZV9tb2R1bGVzL0Bzd2ltbGFuZS9uZ3gtZGF0YXRhYmxlL3JlbGVhc2UvY29tcG9uZW50cy9kYXRhdGFibGUuY29tcG9uZW50LmNzcyJdLCJzb3VyY2VzQ29udGVudCI6WyIgIl0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7In0=
//# sourceMappingURL=datatable.component.css.ngstyle.js.map

/***/ }),
/* 523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RenderType_DatatableComponent; });
/* harmony export (immutable) */ __webpack_exports__["a"] = View_DatatableComponent_0;
/* unused harmony export View_DatatableComponent_Host_0 */
/* unused harmony export DatatableComponentNgFactory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__datatable_component_css_ngstyle__ = __webpack_require__(522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__header_header_component_ngfactory__ = __webpack_require__(527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__swimlane_ngx_datatable_release_components_header_header_component__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__swimlane_ngx_datatable_release_components_header_header_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__swimlane_ngx_datatable_release_components_header_header_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__footer_footer_component_ngfactory__ = __webpack_require__(524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__swimlane_ngx_datatable_release_components_footer_footer_component__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__swimlane_ngx_datatable_release_components_footer_footer_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__swimlane_ngx_datatable_release_components_footer_footer_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__swimlane_ngx_datatable_release_components_datatable_component__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__swimlane_ngx_datatable_release_components_datatable_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__swimlane_ngx_datatable_release_components_datatable_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__swimlane_ngx_datatable_release_directives_visibility_directive__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__swimlane_ngx_datatable_release_directives_visibility_directive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__swimlane_ngx_datatable_release_directives_visibility_directive__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__angular_common__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__body_body_component_ngfactory__ = __webpack_require__(518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__swimlane_ngx_datatable_release_components_body_body_component__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__swimlane_ngx_datatable_release_components_body_body_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__swimlane_ngx_datatable_release_components_body_body_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__swimlane_ngx_datatable_release_services_scrollbar_helper_service__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__swimlane_ngx_datatable_release_services_scrollbar_helper_service___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__swimlane_ngx_datatable_release_services_scrollbar_helper_service__);
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */












var styles_DatatableComponent = [__WEBPACK_IMPORTED_MODULE_0__datatable_component_css_ngstyle__["a" /* styles */]];
var RenderType_DatatableComponent = __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵcrt"]({ encapsulation: 2,
    styles: styles_DatatableComponent, data: {} });
function View_DatatableComponent_1(_l) {
    return __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵeld"](0, null, null, 2, 'datatable-header', [['class', 'datatable-header']], [[4, 'height', null], [4, 'width', null]], [[null, 'sort'], [null, 'resize'], [null, 'reorder'], [null,
                'select'], [null, 'columnContextmenu']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('sort' === en)) {
                var pd_0 = (_co.onColumnSort($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('resize' === en)) {
                var pd_1 = (_co.onColumnResize($event) !== false);
                ad = (pd_1 && ad);
            }
            if (('reorder' === en)) {
                var pd_2 = (_co.onColumnReorder($event) !== false);
                ad = (pd_2 && ad);
            }
            if (('select' === en)) {
                var pd_3 = (_co.onHeaderSelect($event) !== false);
                ad = (pd_3 && ad);
            }
            if (('columnContextmenu' === en)) {
                var pd_4 = (_co.onColumnContextmenu($event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, __WEBPACK_IMPORTED_MODULE_2__header_header_component_ngfactory__["a" /* View_DataTableHeaderComponent_0 */], __WEBPACK_IMPORTED_MODULE_2__header_header_component_ngfactory__["b" /* RenderType_DataTableHeaderComponent */])),
        __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵdid"](49152, null, 0, __WEBPACK_IMPORTED_MODULE_3__swimlane_ngx_datatable_release_components_header_header_component__["DataTableHeaderComponent"], [], { sortAscendingIcon: [0,
                'sortAscendingIcon'], sortDescendingIcon: [1, 'sortDescendingIcon'], scrollbarH: [2,
                'scrollbarH'], innerWidth: [3, 'innerWidth'], offsetX: [4, 'offsetX'], sorts: [5,
                'sorts'], sortType: [6, 'sortType'], allRowsSelected: [7, 'allRowsSelected'], selectionType: [8,
                'selectionType'], reorderable: [9, 'reorderable'], headerHeight: [10, 'headerHeight'],
            columns: [11, 'columns'] }, { sort: 'sort', reorder: 'reorder', resize: 'resize', select: 'select',
            columnContextmenu: 'columnContextmenu' }), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n      ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_2 = _co.cssClasses.sortAscending;
        var currVal_3 = _co.cssClasses.sortDescending;
        var currVal_4 = _co.scrollbarH;
        var currVal_5 = _co.innerWidth;
        var currVal_6 = _co.offsetX;
        var currVal_7 = _co.sorts;
        var currVal_8 = _co.sortType;
        var currVal_9 = _co.allRowsSelected;
        var currVal_10 = _co.selectionType;
        var currVal_11 = _co.reorderable;
        var currVal_12 = _co.headerHeight;
        var currVal_13 = _co.columns;
        _ck(_v, 1, 1, [currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8,
            currVal_9, currVal_10, currVal_11, currVal_12, currVal_13]);
    }, function (_ck, _v) {
        var currVal_0 = __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵnov"](_v, 1).headerHeight;
        var currVal_1 = __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵnov"](_v, 1).headerWidth;
        _ck(_v, 0, 0, currVal_0, currVal_1);
    });
}
function View_DatatableComponent_2(_l) {
    return __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵeld"](0, null, null, 2, 'datatable-footer', [['class', 'datatable-footer']], null, [[null, 'page']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('page' === en)) {
                var pd_0 = (_co.onFooterPage($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, __WEBPACK_IMPORTED_MODULE_4__footer_footer_component_ngfactory__["a" /* View_DataTableFooterComponent_0 */], __WEBPACK_IMPORTED_MODULE_4__footer_footer_component_ngfactory__["b" /* RenderType_DataTableFooterComponent */])),
        __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵdid"](49152, null, 0, __WEBPACK_IMPORTED_MODULE_5__swimlane_ngx_datatable_release_components_footer_footer_component__["DataTableFooterComponent"], [], { footerHeight: [0,
                'footerHeight'], rowCount: [1, 'rowCount'], pageSize: [2, 'pageSize'], offset: [3,
                'offset'], pagerLeftArrowIcon: [4, 'pagerLeftArrowIcon'], pagerRightArrowIcon: [5,
                'pagerRightArrowIcon'], pagerPreviousIcon: [6, 'pagerPreviousIcon'], pagerNextIcon: [7,
                'pagerNextIcon'], totalMessage: [8, 'totalMessage'], footerTemplate: [9, 'footerTemplate'],
            selectedCount: [10, 'selectedCount'], selectedMessage: [11, 'selectedMessage'] }, { page: 'page' }), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n      ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.footerHeight;
        var currVal_1 = _co.rowCount;
        var currVal_2 = _co.pageSize;
        var currVal_3 = _co.offset;
        var currVal_4 = _co.cssClasses.pagerLeftArrow;
        var currVal_5 = _co.cssClasses.pagerRightArrow;
        var currVal_6 = _co.cssClasses.pagerPrevious;
        var currVal_7 = _co.cssClasses.pagerNext;
        var currVal_8 = _co.messages.totalMessage;
        var currVal_9 = _co.footer;
        var currVal_10 = _co.selected.length;
        var currVal_11 = (!!_co.selectionType && _co.messages.selectedMessage);
        _ck(_v, 1, 1, [currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6,
            currVal_7, currVal_8, currVal_9, currVal_10, currVal_11]);
    }, null);
}
function View_DatatableComponent_0(_l) {
    return __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵvid"](0, [__WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵqud"](402653184, 1, { bodyComponent: 0 }), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵeld"](0, null, null, 12, 'div', [['visibilityObserver',
                '']], [[2, 'visible', null]], [[null, 'visible']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('visible' === en)) {
                var pd_0 = (_co.recalculate() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵdid"](212992, null, 0, __WEBPACK_IMPORTED_MODULE_7__swimlane_ngx_datatable_release_directives_visibility_directive__["VisibilityDirective"], [__WEBPACK_IMPORTED_MODULE_1__angular_core__["ElementRef"], __WEBPACK_IMPORTED_MODULE_1__angular_core__["NgZone"]], null, { visible: 'visible' }), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n      '])), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵand"](16777216, null, null, 1, null, View_DatatableComponent_1)), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_8__angular_common__["NgIf"], [__WEBPACK_IMPORTED_MODULE_1__angular_core__["ViewContainerRef"],
            __WEBPACK_IMPORTED_MODULE_1__angular_core__["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n      '])), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵeld"](0, null, null, 2, 'datatable-body', [['class', 'datatable-body']], [[4, 'width', null], [4, 'height', null]], [[null, 'page'], [null, 'activate'], [null, 'rowContextmenu'],
            [null, 'select'], [null, 'scroll']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('page' === en)) {
                var pd_0 = (_co.onBodyPage($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('activate' === en)) {
                var pd_1 = (_co.activate.emit($event) !== false);
                ad = (pd_1 && ad);
            }
            if (('rowContextmenu' === en)) {
                var pd_2 = (_co.onRowContextmenu($event) !== false);
                ad = (pd_2 && ad);
            }
            if (('select' === en)) {
                var pd_3 = (_co.onBodySelect($event) !== false);
                ad = (pd_3 && ad);
            }
            if (('scroll' === en)) {
                var pd_4 = (_co.onBodyScroll($event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, __WEBPACK_IMPORTED_MODULE_9__body_body_component_ngfactory__["a" /* View_DataTableBodyComponent_0 */], __WEBPACK_IMPORTED_MODULE_9__body_body_component_ngfactory__["b" /* RenderType_DataTableBodyComponent */])), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵdid"](245760, [[1, 4]], 0, __WEBPACK_IMPORTED_MODULE_10__swimlane_ngx_datatable_release_components_body_body_component__["DataTableBodyComponent"], [], { scrollbarV: [0, 'scrollbarV'],
            scrollbarH: [1, 'scrollbarH'], loadingIndicator: [2, 'loadingIndicator'], externalPaging: [3,
                'externalPaging'], rowHeight: [4, 'rowHeight'], offsetX: [5, 'offsetX'], emptyMessage: [6,
                'emptyMessage'], selectionType: [7, 'selectionType'], selected: [8, 'selected'],
            rowIdentity: [9, 'rowIdentity'], rowDetail: [10, 'rowDetail'], selectCheck: [11,
                'selectCheck'], trackByProp: [12, 'trackByProp'], rowClass: [13, 'rowClass'],
            pageSize: [14, 'pageSize'], rows: [15, 'rows'], columns: [16, 'columns'], offset: [17,
                'offset'], rowCount: [18, 'rowCount'], innerWidth: [19, 'innerWidth'], bodyHeight: [20,
                'bodyHeight'] }, { scroll: 'scroll', page: 'page', activate: 'activate', select: 'select',
            rowContextmenu: 'rowContextmenu' }), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n      '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n      '])), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵand"](16777216, null, null, 1, null, View_DatatableComponent_2)), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_8__angular_common__["NgIf"], [__WEBPACK_IMPORTED_MODULE_1__angular_core__["ViewContainerRef"], __WEBPACK_IMPORTED_MODULE_1__angular_core__["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n  ']))], function (_ck, _v) {
        var _co = _v.component;
        _ck(_v, 3, 0);
        var currVal_1 = _co.headerHeight;
        _ck(_v, 6, 0, currVal_1);
        var currVal_4 = _co.scrollbarV;
        var currVal_5 = _co.scrollbarH;
        var currVal_6 = _co.loadingIndicator;
        var currVal_7 = _co.externalPaging;
        var currVal_8 = _co.rowHeight;
        var currVal_9 = _co.offsetX;
        var currVal_10 = _co.messages.emptyMessage;
        var currVal_11 = _co.selectionType;
        var currVal_12 = _co.selected;
        var currVal_13 = _co.rowIdentity;
        var currVal_14 = _co.rowDetail;
        var currVal_15 = _co.selectCheck;
        var currVal_16 = _co.trackByProp;
        var currVal_17 = _co.rowClass;
        var currVal_18 = _co.pageSize;
        var currVal_19 = _co.rows;
        var currVal_20 = _co.columns;
        var currVal_21 = _co.offset;
        var currVal_22 = _co.rowCount;
        var currVal_23 = _co.innerWidth;
        var currVal_24 = _co.bodyHeight;
        _ck(_v, 9, 1, [currVal_4, currVal_5, currVal_6, currVal_7, currVal_8, currVal_9, currVal_10,
            currVal_11, currVal_12, currVal_13, currVal_14, currVal_15, currVal_16, currVal_17,
            currVal_18, currVal_19, currVal_20, currVal_21, currVal_22, currVal_23, currVal_24]);
        var currVal_25 = _co.footerHeight;
        _ck(_v, 13, 0, currVal_25);
    }, function (_ck, _v) {
        var currVal_0 = __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵnov"](_v, 3).isVisible;
        _ck(_v, 2, 0, currVal_0);
        var currVal_2 = __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵnov"](_v, 9).bodyWidth;
        var currVal_3 = __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵnov"](_v, 9).bodyHeight;
        _ck(_v, 8, 0, currVal_2, currVal_3);
    });
}
function View_DatatableComponent_Host_0(_l) {
    return __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵeld"](0, null, null, 4, 'ngx-datatable', [['class', 'ngx-datatable']], [[2, 'fixed-header', null], [2, 'fixed-row',
                null], [2, 'scroll-vertical', null], [2, 'scroll-horz', null],
            [2, 'selectable', null], [2, 'checkbox-selection', null], [2,
                'cell-selection', null], [2, 'single-selection', null],
            [2, 'multi-selection', null], [2, 'multi-click-selection', null]], [['window', 'resize']], function (_v, en, $event) {
            var ad = true;
            if (('window:resize' === en)) {
                var pd_0 = (__WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵnov"](_v, 1).onWindowResize() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_DatatableComponent_0, RenderType_DatatableComponent)), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵdid"](4571136, null, 3, __WEBPACK_IMPORTED_MODULE_6__swimlane_ngx_datatable_release_components_datatable_component__["DatatableComponent"], [__WEBPACK_IMPORTED_MODULE_11__swimlane_ngx_datatable_release_services_scrollbar_helper_service__["ScrollbarHelper"], __WEBPACK_IMPORTED_MODULE_1__angular_core__["ElementRef"], __WEBPACK_IMPORTED_MODULE_1__angular_core__["KeyValueDiffers"]], null, null), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵqud"](603979776, 1, { columnTemplates: 1 }), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵqud"](335544320, 2, { rowDetail: 0 }), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵqud"](335544320, 3, { footer: 0 })], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, function (_ck, _v) {
        var currVal_0 = __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵnov"](_v, 1).isFixedHeader;
        var currVal_1 = __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵnov"](_v, 1).isFixedRow;
        var currVal_2 = __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵnov"](_v, 1).isVertScroll;
        var currVal_3 = __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵnov"](_v, 1).isHorScroll;
        var currVal_4 = __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵnov"](_v, 1).isSelectable;
        var currVal_5 = __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵnov"](_v, 1).isCheckboxSelection;
        var currVal_6 = __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵnov"](_v, 1).isCellSelection;
        var currVal_7 = __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵnov"](_v, 1).isSingleSelection;
        var currVal_8 = __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵnov"](_v, 1).isMultiSelection;
        var currVal_9 = __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵnov"](_v, 1).isMultiClickSelection;
        _ck(_v, 0, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8, currVal_9);
    });
}
var DatatableComponentNgFactory = __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵccf"]('ngx-datatable', __WEBPACK_IMPORTED_MODULE_6__swimlane_ngx_datatable_release_components_datatable_component__["DatatableComponent"], View_DatatableComponent_Host_0, { rows: 'rows', columns: 'columns',
    selected: 'selected', scrollbarV: 'scrollbarV', scrollbarH: 'scrollbarH', rowHeight: 'rowHeight',
    columnMode: 'columnMode', headerHeight: 'headerHeight', footerHeight: 'footerHeight',
    externalPaging: 'externalPaging', externalSorting: 'externalSorting', limit: 'limit',
    count: 'count', offset: 'offset', loadingIndicator: 'loadingIndicator', selectionType: 'selectionType',
    reorderable: 'reorderable', sortType: 'sortType', sorts: 'sorts', cssClasses: 'cssClasses',
    messages: 'messages', rowIdentity: 'rowIdentity', rowClass: 'rowClass', selectCheck: 'selectCheck',
    trackByProp: 'trackByProp' }, { scroll: 'scroll', activate: 'activate', select: 'select',
    sort: 'sort', page: 'page', reorder: 'reorder', resize: 'resize', tableContextmenu: 'tableContextmenu' }, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=datatable.component.ngfactory.js.map

/***/ }),
/* 524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RenderType_DataTableFooterComponent; });
/* harmony export (immutable) */ __webpack_exports__["a"] = View_DataTableFooterComponent_0;
/* unused harmony export View_DataTableFooterComponent_Host_0 */
/* unused harmony export DataTableFooterComponentNgFactory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_common__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pager_component_ngfactory__ = __webpack_require__(525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__swimlane_ngx_datatable_release_components_footer_pager_component__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__swimlane_ngx_datatable_release_components_footer_pager_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__swimlane_ngx_datatable_release_components_footer_pager_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__swimlane_ngx_datatable_release_components_footer_footer_component__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__swimlane_ngx_datatable_release_components_footer_footer_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__swimlane_ngx_datatable_release_components_footer_footer_component__);
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */





var styles_DataTableFooterComponent = [];
var RenderType_DataTableFooterComponent = __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵcrt"]({ encapsulation: 2,
    styles: styles_DataTableFooterComponent, data: {} });
function View_DataTableFooterComponent_2(_l) {
    return __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵted"](null, ['\n      ']))], null, null);
}
function View_DataTableFooterComponent_1(_l) {
    return __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵand"](16777216, null, null, 2, null, View_DataTableFooterComponent_2)), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵdid"](540672, null, 0, __WEBPACK_IMPORTED_MODULE_1__angular_common__["NgTemplateOutlet"], [__WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewContainerRef"]], { ngTemplateOutlet: [0, 'ngTemplateOutlet'], ngOutletContext: [1,
                'ngOutletContext'] }, null), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵpod"]({ rowCount: 0, pageSize: 1, selectedCount: 2,
            curPage: 3, offset: 4 }), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵand"](0, null, null, 0))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.footerTemplate.template;
        var currVal_1 = _ck(_v, 2, 0, _co.rowCount, _co.pageSize, _co.selectedCount, _co.curPage, _co.offset);
        _ck(_v, 1, 0, currVal_0, currVal_1);
    }, null);
}
function View_DataTableFooterComponent_4(_l) {
    return __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵeld"](0, null, null, 1, 'span', [], null, null, null, null, null)), (_l()(),
            __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵted"](null, ['\n          ', ' ', ' / \n        ']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.selectedCount.toLocaleString();
        var currVal_1 = _co.selectedMessage;
        _ck(_v, 1, 0, currVal_0, currVal_1);
    });
}
function View_DataTableFooterComponent_3(_l) {
    return __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵeld"](0, null, null, 4, 'div', [['class',
                'page-count']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵted"](null, ['\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵand"](16777216, null, null, 1, null, View_DataTableFooterComponent_4)), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_1__angular_common__["NgIf"], [__WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewContainerRef"], __WEBPACK_IMPORTED_MODULE_0__angular_core__["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵted"](null, ['\n        ', ' ', '\n      ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.selectedMessage;
        _ck(_v, 3, 0, currVal_0);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_1 = _co.rowCount.toLocaleString();
        var currVal_2 = _co.totalMessage;
        _ck(_v, 4, 0, currVal_1, currVal_2);
    });
}
function View_DataTableFooterComponent_5(_l) {
    return __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵeld"](0, null, null, 2, 'datatable-pager', [['class', 'datatable-pager']], [[8, 'hidden', 0]], [[null, 'change']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('change' === en)) {
                var pd_0 = (_co.page.emit($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, __WEBPACK_IMPORTED_MODULE_2__pager_component_ngfactory__["a" /* View_DataTablePagerComponent_0 */], __WEBPACK_IMPORTED_MODULE_2__pager_component_ngfactory__["b" /* RenderType_DataTablePagerComponent */])),
        __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵdid"](49152, null, 0, __WEBPACK_IMPORTED_MODULE_3__swimlane_ngx_datatable_release_components_footer_pager_component__["DataTablePagerComponent"], [], { pagerLeftArrowIcon: [0,
                'pagerLeftArrowIcon'], pagerRightArrowIcon: [1, 'pagerRightArrowIcon'], pagerPreviousIcon: [2,
                'pagerPreviousIcon'], pagerNextIcon: [3, 'pagerNextIcon'], size: [4, 'size'], count: [5,
                'count'], page: [6, 'page'] }, { change: 'change' }), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵted"](null, ['\n      ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_1 = _co.pagerLeftArrowIcon;
        var currVal_2 = _co.pagerRightArrowIcon;
        var currVal_3 = _co.pagerPreviousIcon;
        var currVal_4 = _co.pagerNextIcon;
        var currVal_5 = _co.pageSize;
        var currVal_6 = _co.rowCount;
        var currVal_7 = _co.curPage;
        _ck(_v, 1, 0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = !_co.isVisible;
        _ck(_v, 0, 0, currVal_0);
    });
}
function View_DataTableFooterComponent_0(_l) {
    return __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵvid"](2, [(_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵted"](null, ['\n    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵeld"](0, null, null, 12, 'div', [['class', 'datatable-footer-inner']], [[4, 'height', 'px']], null, null, null, null)), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵdid"](278528, null, 0, __WEBPACK_IMPORTED_MODULE_1__angular_common__["NgClass"], [__WEBPACK_IMPORTED_MODULE_0__angular_core__["IterableDiffers"], __WEBPACK_IMPORTED_MODULE_0__angular_core__["KeyValueDiffers"], __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"]], { klass: [0, 'klass'], ngClass: [1, 'ngClass'] }, null), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵpod"]({ 'selected-count': 0 }),
        (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵted"](null, ['\n      '])), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵand"](16777216, null, null, 1, null, View_DataTableFooterComponent_1)), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_1__angular_common__["NgIf"], [__WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewContainerRef"], __WEBPACK_IMPORTED_MODULE_0__angular_core__["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵted"](null, ['\n      '])), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵand"](16777216, null, null, 1, null, View_DataTableFooterComponent_3)),
        __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_1__angular_common__["NgIf"], [__WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewContainerRef"], __WEBPACK_IMPORTED_MODULE_0__angular_core__["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵted"](null, ['\n      '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵand"](16777216, null, null, 1, null, View_DataTableFooterComponent_5)),
        __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_1__angular_common__["NgIf"], [__WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewContainerRef"], __WEBPACK_IMPORTED_MODULE_0__angular_core__["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵted"](null, ['\n    '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵted"](null, ['\n  ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_1 = 'datatable-footer-inner';
        var currVal_2 = _ck(_v, 3, 0, _co.selectedMessage);
        _ck(_v, 2, 0, currVal_1, currVal_2);
        var currVal_3 = _co.footerTemplate;
        _ck(_v, 6, 0, currVal_3);
        var currVal_4 = !_co.footerTemplate;
        _ck(_v, 9, 0, currVal_4);
        var currVal_5 = !_co.footerTemplate;
        _ck(_v, 12, 0, currVal_5);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.footerHeight;
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_DataTableFooterComponent_Host_0(_l) {
    return __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵeld"](0, null, null, 1, 'datatable-footer', [['class', 'datatable-footer']], null, null, null, View_DataTableFooterComponent_0, RenderType_DataTableFooterComponent)), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵdid"](49152, null, 0, __WEBPACK_IMPORTED_MODULE_4__swimlane_ngx_datatable_release_components_footer_footer_component__["DataTableFooterComponent"], [], null, null)], null, null);
}
var DataTableFooterComponentNgFactory = __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵccf"]('datatable-footer', __WEBPACK_IMPORTED_MODULE_4__swimlane_ngx_datatable_release_components_footer_footer_component__["DataTableFooterComponent"], View_DataTableFooterComponent_Host_0, { footerHeight: 'footerHeight',
    rowCount: 'rowCount', pageSize: 'pageSize', offset: 'offset', pagerLeftArrowIcon: 'pagerLeftArrowIcon',
    pagerRightArrowIcon: 'pagerRightArrowIcon', pagerPreviousIcon: 'pagerPreviousIcon',
    pagerNextIcon: 'pagerNextIcon', totalMessage: 'totalMessage', footerTemplate: 'footerTemplate',
    selectedCount: 'selectedCount', selectedMessage: 'selectedMessage' }, { page: 'page' }, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=footer.component.ngfactory.js.map

/***/ }),
/* 525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RenderType_DataTablePagerComponent; });
/* harmony export (immutable) */ __webpack_exports__["a"] = View_DataTablePagerComponent_0;
/* unused harmony export View_DataTablePagerComponent_Host_0 */
/* unused harmony export DataTablePagerComponentNgFactory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__swimlane_ngx_datatable_release_components_footer_pager_component__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__swimlane_ngx_datatable_release_components_footer_pager_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__swimlane_ngx_datatable_release_components_footer_pager_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_common__ = __webpack_require__(4);
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */



var styles_DataTablePagerComponent = [];
var RenderType_DataTablePagerComponent = __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵcrt"]({ encapsulation: 2,
    styles: styles_DataTablePagerComponent, data: {} });
function View_DataTablePagerComponent_1(_l) {
    return __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵeld"](0, null, null, 4, 'li', [['class',
                'pages']], [[2, 'active', null]], null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵted"](null, ['\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵeld"](0, null, null, 1, 'a', [['href', 'javascript:void(0)']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.selectPage(_v.context.$implicit.number) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵted"](null, ['\n          ',
            '\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵted"](null, ['\n      ']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = (_v.context.$implicit.number === _co.page);
        _ck(_v, 0, 0, currVal_0);
        var currVal_1 = _v.context.$implicit.text;
        _ck(_v, 3, 0, currVal_1);
    });
}
function View_DataTablePagerComponent_0(_l) {
    return __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵvid"](2, [(_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵted"](null, ['\n    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵeld"](0, null, null, 36, 'ul', [['class', 'pager']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵted"](null, ['\n      '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵeld"](0, null, null, 6, 'li', [], [[2, 'disabled', null]], null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵted"](null, ['\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵeld"](0, null, null, 3, 'a', [['href',
                'javascript:void(0)']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.selectPage(1) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵted"](null, ['\n          '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵeld"](0, null, null, 0, 'i', [], [[8, 'className',
                0]], null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵted"](null, ['\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵted"](null, ['\n      '])), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵted"](null, ['\n      '])), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵeld"](0, null, null, 6, 'li', [], [[2, 'disabled', null]], null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵted"](null, ['\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵeld"](0, null, null, 3, 'a', [['href', 'javascript:void(0)']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.prevPage() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵted"](null, ['\n          '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵeld"](0, null, null, 0, 'i', [], [[8, 'className',
                0]], null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵted"](null, ['\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵted"](null, ['\n      '])), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵted"](null, ['\n      '])), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵand"](16777216, null, null, 1, null, View_DataTablePagerComponent_1)), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵdid"](802816, null, 0, __WEBPACK_IMPORTED_MODULE_2__angular_common__["NgForOf"], [__WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewContainerRef"], __WEBPACK_IMPORTED_MODULE_0__angular_core__["TemplateRef"], __WEBPACK_IMPORTED_MODULE_0__angular_core__["IterableDiffers"]], { ngForOf: [0, 'ngForOf'] }, null), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵted"](null, ['\n      '])), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵeld"](0, null, null, 6, 'li', [], [[2, 'disabled', null]], null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵted"](null, ['\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵeld"](0, null, null, 3, 'a', [['href',
                'javascript:void(0)']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.nextPage() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵted"](null, ['\n          '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵeld"](0, null, null, 0, 'i', [], [[8, 'className',
                0]], null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵted"](null, ['\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵted"](null, ['\n      '])), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵted"](null, ['\n      '])), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵeld"](0, null, null, 6, 'li', [], [[2, 'disabled', null]], null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵted"](null, ['\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵeld"](0, null, null, 3, 'a', [['href', 'javascript:void(0)']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.selectPage(_co.totalPages) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵted"](null, ['\n          '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵeld"](0, null, null, 0, 'i', [], [[8, 'className',
                0]], null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵted"](null, ['\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵted"](null, ['\n      '])), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵted"](null, ['\n    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵted"](null, ['\n  ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_4 = _co.pages;
        _ck(_v, 20, 0, currVal_4);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = !_co.canPrevious();
        _ck(_v, 3, 0, currVal_0);
        var currVal_1 = __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵinlineInterpolate"](1, '', _co.pagerPreviousIcon, '');
        _ck(_v, 7, 0, currVal_1);
        var currVal_2 = !_co.canPrevious();
        _ck(_v, 11, 0, currVal_2);
        var currVal_3 = __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵinlineInterpolate"](1, '', _co.pagerLeftArrowIcon, '');
        _ck(_v, 15, 0, currVal_3);
        var currVal_5 = !_co.canNext();
        _ck(_v, 22, 0, currVal_5);
        var currVal_6 = __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵinlineInterpolate"](1, '', _co.pagerRightArrowIcon, '');
        _ck(_v, 26, 0, currVal_6);
        var currVal_7 = !_co.canNext();
        _ck(_v, 30, 0, currVal_7);
        var currVal_8 = __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵinlineInterpolate"](1, '', _co.pagerNextIcon, '');
        _ck(_v, 34, 0, currVal_8);
    });
}
function View_DataTablePagerComponent_Host_0(_l) {
    return __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵeld"](0, null, null, 1, 'datatable-pager', [['class', 'datatable-pager']], null, null, null, View_DataTablePagerComponent_0, RenderType_DataTablePagerComponent)), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵdid"](49152, null, 0, __WEBPACK_IMPORTED_MODULE_1__swimlane_ngx_datatable_release_components_footer_pager_component__["DataTablePagerComponent"], [], null, null)], null, null);
}
var DataTablePagerComponentNgFactory = __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵccf"]('datatable-pager', __WEBPACK_IMPORTED_MODULE_1__swimlane_ngx_datatable_release_components_footer_pager_component__["DataTablePagerComponent"], View_DataTablePagerComponent_Host_0, { pagerLeftArrowIcon: 'pagerLeftArrowIcon',
    pagerRightArrowIcon: 'pagerRightArrowIcon', pagerPreviousIcon: 'pagerPreviousIcon',
    pagerNextIcon: 'pagerNextIcon', size: 'size', count: 'count', page: 'page' }, { change: 'change' }, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=pager.component.ngfactory.js.map

/***/ }),
/* 526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RenderType_DataTableHeaderCellComponent; });
/* harmony export (immutable) */ __webpack_exports__["a"] = View_DataTableHeaderCellComponent_0;
/* unused harmony export View_DataTableHeaderCellComponent_Host_0 */
/* unused harmony export DataTableHeaderCellComponentNgFactory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_common__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__swimlane_ngx_datatable_release_components_header_header_cell_component__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__swimlane_ngx_datatable_release_components_header_header_cell_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__swimlane_ngx_datatable_release_components_header_header_cell_component__);
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */



var styles_DataTableHeaderCellComponent = [];
var RenderType_DataTableHeaderCellComponent = __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵcrt"]({ encapsulation: 2,
    styles: styles_DataTableHeaderCellComponent, data: {} });
function View_DataTableHeaderCellComponent_1(_l) {
    return __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵeld"](0, null, null, 3, 'label', [['class',
                'datatable-checkbox']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵted"](null, ['\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵeld"](0, null, null, 0, 'input', [['type', 'checkbox']], [[8, 'checked', 0]], [[null, 'change']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('change' === en)) {
                var pd_0 = (_co.select.emit(!_co.allRowsSelected) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵted"](null, ['\n      ']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.allRowsSelected;
        _ck(_v, 2, 0, currVal_0);
    });
}
function View_DataTableHeaderCellComponent_2(_l) {
    return __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵeld"](0, null, null, 4, 'span', [['class',
                'datatable-header-cell-wrapper']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵted"](null, ['\n        '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵeld"](0, null, null, 1, 'span', [['class', 'datatable-header-cell-label draggable']], [[8, 'innerHTML', 1]], [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.onSort() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵted"](null, ['\n        '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵted"](null, ['\n      ']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.name;
        _ck(_v, 2, 0, currVal_0);
    });
}
function View_DataTableHeaderCellComponent_4(_l) {
    return __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵted"](null, ['\n      ']))], null, null);
}
function View_DataTableHeaderCellComponent_3(_l) {
    return __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵand"](16777216, null, null, 2, null, View_DataTableHeaderCellComponent_4)), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵdid"](540672, null, 0, __WEBPACK_IMPORTED_MODULE_1__angular_common__["NgTemplateOutlet"], [__WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewContainerRef"]], { ngTemplateOutlet: [0, 'ngTemplateOutlet'], ngOutletContext: [1,
                'ngOutletContext'] }, null), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵpod"]({ column: 0, sortDir: 1, sortFn: 2,
            allRowsSelected: 3, selectFn: 4 }), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵand"](0, null, null, 0))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.column.headerTemplate;
        var currVal_1 = _ck(_v, 2, 0, _co.column, _co.sortDir, _co.sortFn, _co.allRowsSelected, _co.selectFn);
        _ck(_v, 1, 0, currVal_0, currVal_1);
    }, null);
}
function View_DataTableHeaderCellComponent_0(_l) {
    return __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵted"](null, ['\n    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵeld"](0, null, null, 13, 'div', [], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵted"](null, ['\n      '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵand"](16777216, null, null, 1, null, View_DataTableHeaderCellComponent_1)),
        __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_1__angular_common__["NgIf"], [__WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewContainerRef"], __WEBPACK_IMPORTED_MODULE_0__angular_core__["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵted"](null, ['\n      '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵand"](16777216, null, null, 1, null, View_DataTableHeaderCellComponent_2)),
        __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_1__angular_common__["NgIf"], [__WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewContainerRef"], __WEBPACK_IMPORTED_MODULE_0__angular_core__["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵted"](null, ['\n      '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵand"](16777216, null, null, 1, null, View_DataTableHeaderCellComponent_3)),
        __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_1__angular_common__["NgIf"], [__WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewContainerRef"], __WEBPACK_IMPORTED_MODULE_0__angular_core__["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵted"](null, ['\n      '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵeld"](0, null, null, 1, 'span', [], [[8, 'className',
                    0]], [[null, 'click']], function (_v, en, $event) {
                var ad = true;
                var _co = _v.component;
                if (('click' === en)) {
                    var pd_0 = (_co.onSort() !== false);
                    ad = (pd_0 && ad);
                }
                return ad;
            }, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵted"](null, ['\n      '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵted"](null, ['\n    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵted"](null, ['\n  ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.isCheckboxable;
        _ck(_v, 4, 0, currVal_0);
        var currVal_1 = !_co.column.headerTemplate;
        _ck(_v, 7, 0, currVal_1);
        var currVal_2 = _co.column.headerTemplate;
        _ck(_v, 10, 0, currVal_2);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_3 = _co.sortClass;
        _ck(_v, 12, 0, currVal_3);
    });
}
function View_DataTableHeaderCellComponent_Host_0(_l) {
    return __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵeld"](0, null, null, 1, 'datatable-header-cell', [['class', 'datatable-header-cell']], [[4, 'height', 'px'], [8, 'className', 0], [1,
                'title', 0], [4, 'minWidth', 'px'], [4, 'maxWidth', 'px'], [4, 'width', 'px']], [[null,
                'contextmenu']], function (_v, en, $event) {
            var ad = true;
            if (('contextmenu' === en)) {
                var pd_0 = (__WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵnov"](_v, 1).onContextmenu($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_DataTableHeaderCellComponent_0, RenderType_DataTableHeaderCellComponent)),
        __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵdid"](49152, null, 0, __WEBPACK_IMPORTED_MODULE_2__swimlane_ngx_datatable_release_components_header_header_cell_component__["DataTableHeaderCellComponent"], [], null, null)], null, function (_ck, _v) {
        var currVal_0 = __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵnov"](_v, 1).headerHeight;
        var currVal_1 = __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵnov"](_v, 1).columnCssClasses;
        var currVal_2 = __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵnov"](_v, 1).name;
        var currVal_3 = __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵnov"](_v, 1).minWidth;
        var currVal_4 = __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵnov"](_v, 1).maxWidth;
        var currVal_5 = __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵnov"](_v, 1).width;
        _ck(_v, 0, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5);
    });
}
var DataTableHeaderCellComponentNgFactory = __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵccf"]('datatable-header-cell', __WEBPACK_IMPORTED_MODULE_2__swimlane_ngx_datatable_release_components_header_header_cell_component__["DataTableHeaderCellComponent"], View_DataTableHeaderCellComponent_Host_0, { sortType: 'sortType',
    column: 'column', sortAscendingIcon: 'sortAscendingIcon', sortDescendingIcon: 'sortDescendingIcon',
    allRowsSelected: 'allRowsSelected', selectionType: 'selectionType', headerHeight: 'headerHeight',
    sorts: 'sorts' }, { sort: 'sort', select: 'select', columnContextmenu: 'columnContextmenu' }, []);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3NyYy91aS9ub2RlX21vZHVsZXMvQHN3aW1sYW5lL25neC1kYXRhdGFibGUvcmVsZWFzZS9jb21wb25lbnRzL2hlYWRlci9oZWFkZXItY2VsbC5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vc3JjL3VpL25vZGVfbW9kdWxlcy9Ac3dpbWxhbmUvbmd4LWRhdGF0YWJsZS9yZWxlYXNlL2NvbXBvbmVudHMvaGVhZGVyL2hlYWRlci1jZWxsLmNvbXBvbmVudC5kLnRzIiwibmc6Ly8vc3JjL3VpL25vZGVfbW9kdWxlcy9Ac3dpbWxhbmUvbmd4LWRhdGF0YWJsZS9yZWxlYXNlL2NvbXBvbmVudHMvaGVhZGVyL2hlYWRlci1jZWxsLmNvbXBvbmVudC5kLnRzLkRhdGFUYWJsZUhlYWRlckNlbGxDb21wb25lbnQuaHRtbCIsIm5nOi8vL3NyYy91aS9ub2RlX21vZHVsZXMvQHN3aW1sYW5lL25neC1kYXRhdGFibGUvcmVsZWFzZS9jb21wb25lbnRzL2hlYWRlci9oZWFkZXItY2VsbC5jb21wb25lbnQuZC50cy5EYXRhVGFibGVIZWFkZXJDZWxsQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiXG4gICAgPGRpdj5cbiAgICAgIDxsYWJlbFxuICAgICAgICAqbmdJZj1cImlzQ2hlY2tib3hhYmxlXCIgXG4gICAgICAgIGNsYXNzPVwiZGF0YXRhYmxlLWNoZWNrYm94XCI+XG4gICAgICAgIDxpbnB1dCBcbiAgICAgICAgICB0eXBlPVwiY2hlY2tib3hcIlxuICAgICAgICAgIFtjaGVja2VkXT1cImFsbFJvd3NTZWxlY3RlZFwiXG4gICAgICAgICAgKGNoYW5nZSk9XCJzZWxlY3QuZW1pdCghYWxsUm93c1NlbGVjdGVkKVwiIFxuICAgICAgICAvPlxuICAgICAgPC9sYWJlbD5cbiAgICAgIDxzcGFuIFxuICAgICAgICAqbmdJZj1cIiFjb2x1bW4uaGVhZGVyVGVtcGxhdGVcIlxuICAgICAgICBjbGFzcz1cImRhdGF0YWJsZS1oZWFkZXItY2VsbC13cmFwcGVyXCI+XG4gICAgICAgIDxzcGFuXG4gICAgICAgICAgY2xhc3M9XCJkYXRhdGFibGUtaGVhZGVyLWNlbGwtbGFiZWwgZHJhZ2dhYmxlXCJcbiAgICAgICAgICAoY2xpY2spPVwib25Tb3J0KClcIlxuICAgICAgICAgIFtpbm5lckhUTUxdPVwibmFtZVwiPlxuICAgICAgICA8L3NwYW4+XG4gICAgICA8L3NwYW4+XG4gICAgICA8bmctdGVtcGxhdGVcbiAgICAgICAgKm5nSWY9XCJjb2x1bW4uaGVhZGVyVGVtcGxhdGVcIlxuICAgICAgICBbbmdUZW1wbGF0ZU91dGxldF09XCJjb2x1bW4uaGVhZGVyVGVtcGxhdGVcIlxuICAgICAgICBbbmdPdXRsZXRDb250ZXh0XT1cInsgXG4gICAgICAgICAgY29sdW1uOiBjb2x1bW4sIFxuICAgICAgICAgIHNvcnREaXI6IHNvcnREaXIsXG4gICAgICAgICAgc29ydEZuOiBzb3J0Rm4sXG4gICAgICAgICAgYWxsUm93c1NlbGVjdGVkOiBhbGxSb3dzU2VsZWN0ZWQsXG4gICAgICAgICAgc2VsZWN0Rm46IHNlbGVjdEZuXG4gICAgICAgIH1cIj5cbiAgICAgIDwvbmctdGVtcGxhdGU+XG4gICAgICA8c3BhblxuICAgICAgICAoY2xpY2spPVwib25Tb3J0KClcIlxuICAgICAgICBbY2xhc3NdPVwic29ydENsYXNzXCI+XG4gICAgICA8L3NwYW4+XG4gICAgPC9kaXY+XG4gICIsIjxkYXRhdGFibGUtaGVhZGVyLWNlbGw+PC9kYXRhdGFibGUtaGVhZGVyLWNlbGw+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7O29CQ0VNO01BQUE7TUFBQSxnQkFFNkIsK0NBQzNCO01BQUE7TUFBQTtRQUFBO1FBQUE7UUFHRTtVQUFBO1VBQUE7UUFBQTtRQUhGO01BQUEsZ0NBSUU7OztRQUZBO1FBRkYsV0FFRSxTQUZGOzs7O29CQU1GO01BQUE7TUFBQSw4QkFFd0M7TUFDdEM7VUFBQTtZQUFBO1lBQUE7WUFFRTtjQUFBO2NBQUE7WUFBQTtZQUZGO1VBQUEsZ0NBR3FCO01BQ2Q7O0lBREw7SUFIRixXQUdFLFNBSEY7Ozs7b0JBZUc7OztvQkFUTDtNQUFBLDZDQUFBO01BQUE7VUFBQSwwQ0FHRTtNQUFBOzs7SUFEQTtJQUNBO1FBQUE7SUFIRixXQUVFLFVBQ0EsU0FIRjs7OztvQkFwQk4sMkNBQ0k7TUFBQTtNQUFBLDhCQUFLLDZDQUNIO2FBQUE7YUFBQTtVQUFBLHdCQVFRLDZDQUNSO2lCQUFBO2FBQUE7VUFBQSx3QkFRTyw2Q0FDUDtpQkFBQTthQUFBO1VBQUEsd0JBVWMsNkNBQ2Q7aUJBQUE7Y0FBQTtZQUFBO1lBQUE7WUFDRTtjQUFBO2NBQUE7WUFBQTtZQURGO1VBQUEsZ0NBRXNCO01BQ2YsMkNBQ0g7OztRQWhDRjtRQURGLFdBQ0UsU0FERjtRQVVFO1FBREYsV0FDRSxTQURGO1FBVUU7UUFERixZQUNFLFNBREY7OztRQWFFO1FBRkYsWUFFRSxTQUZGOzs7O29CQy9CTjtNQUFBO1VBQUE7VUFBQTtRQUFBO1FBQUE7VUFBQTtVQUFBO1FBQUE7UUFBQTtNQUFBO2FBQUE7VUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBLFdBQUEsMkRBQUE7Ozs7Ozs7OyJ9
//# sourceMappingURL=header-cell.component.ngfactory.js.map

/***/ }),
/* 527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RenderType_DataTableHeaderComponent; });
/* harmony export (immutable) */ __webpack_exports__["a"] = View_DataTableHeaderComponent_0;
/* unused harmony export View_DataTableHeaderComponent_Host_0 */
/* unused harmony export DataTableHeaderComponentNgFactory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__header_cell_component_ngfactory__ = __webpack_require__(526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__swimlane_ngx_datatable_release_directives_draggable_directive__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__swimlane_ngx_datatable_release_directives_draggable_directive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__swimlane_ngx_datatable_release_directives_draggable_directive__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__swimlane_ngx_datatable_release_directives_resizeable_directive__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__swimlane_ngx_datatable_release_directives_resizeable_directive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__swimlane_ngx_datatable_release_directives_resizeable_directive__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__swimlane_ngx_datatable_release_directives_long_press_directive__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__swimlane_ngx_datatable_release_directives_long_press_directive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__swimlane_ngx_datatable_release_directives_long_press_directive__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__swimlane_ngx_datatable_release_components_header_header_cell_component__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__swimlane_ngx_datatable_release_components_header_header_cell_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__swimlane_ngx_datatable_release_components_header_header_cell_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__angular_common__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__swimlane_ngx_datatable_release_components_header_header_component__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__swimlane_ngx_datatable_release_components_header_header_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__swimlane_ngx_datatable_release_components_header_header_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__swimlane_ngx_datatable_release_directives_orderable_directive__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__swimlane_ngx_datatable_release_directives_orderable_directive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__swimlane_ngx_datatable_release_directives_orderable_directive__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__angular_platform_browser__ = __webpack_require__(38);
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */










var styles_DataTableHeaderComponent = [];
var RenderType_DataTableHeaderComponent = __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵcrt"]({ encapsulation: 2,
    styles: styles_DataTableHeaderComponent, data: {} });
function View_DataTableHeaderComponent_2(_l) {
    return __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵeld"](0, null, null, 5, 'datatable-header-cell', [['class', 'datatable-header-cell'], ['draggable', ''], ['long-press', ''], ['resizeable',
                '']], [[2, 'resizeable', null], [2, 'press', null], [2, 'longpress',
                null], [4, 'height', 'px'], [8, 'className', 0], [1, 'title', 0], [4, 'minWidth',
                'px'], [4, 'maxWidth', 'px'], [4, 'width', 'px']], [[null, 'resize'], [null,
                'longPressStart'], [null, 'longPressEnd'], [null, 'sort'],
            [null, 'select'], [null, 'columnContextmenu'], [null,
                'mousedown'], [null, 'contextmenu']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('mousedown' === en)) {
                var pd_0 = (__WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵnov"](_v, 2).onMousedown($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('mousedown' === en)) {
                var pd_1 = (__WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵnov"](_v, 3).onMouseDown($event) !== false);
                ad = (pd_1 && ad);
            }
            if (('contextmenu' === en)) {
                var pd_2 = (__WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵnov"](_v, 4).onContextmenu($event) !== false);
                ad = (pd_2 && ad);
            }
            if (('resize' === en)) {
                var pd_3 = (_co.onColumnResized($event, _v.context.$implicit) !== false);
                ad = (pd_3 && ad);
            }
            if (('longPressStart' === en)) {
                var pd_4 = (_co.onLongPressStart($event) !== false);
                ad = (pd_4 && ad);
            }
            if (('longPressEnd' === en)) {
                var pd_5 = (_co.onLongPressEnd($event) !== false);
                ad = (pd_5 && ad);
            }
            if (('sort' === en)) {
                var pd_6 = (_co.onSort($event) !== false);
                ad = (pd_6 && ad);
            }
            if (('select' === en)) {
                var pd_7 = (_co.select.emit($event) !== false);
                ad = (pd_7 && ad);
            }
            if (('columnContextmenu' === en)) {
                var pd_8 = (_co.columnContextmenu.emit($event) !== false);
                ad = (pd_8 && ad);
            }
            return ad;
        }, __WEBPACK_IMPORTED_MODULE_1__header_cell_component_ngfactory__["a" /* View_DataTableHeaderCellComponent_0 */], __WEBPACK_IMPORTED_MODULE_1__header_cell_component_ngfactory__["b" /* RenderType_DataTableHeaderCellComponent */])),
        __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵdid"](671744, [[1, 4]], 0, __WEBPACK_IMPORTED_MODULE_2__swimlane_ngx_datatable_release_directives_draggable_directive__["DraggableDirective"], [__WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"]], { dragEventTarget: [0,
                'dragEventTarget'], dragModel: [1, 'dragModel'], dragX: [2, 'dragX'], dragY: [3,
                'dragY'] }, null), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵdid"](4341760, null, 0, __WEBPACK_IMPORTED_MODULE_3__swimlane_ngx_datatable_release_directives_resizeable_directive__["ResizeableDirective"], [__WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"]], { resizeEnabled: [0, 'resizeEnabled'] }, { resize: 'resize' }), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵdid"](147456, null, 0, __WEBPACK_IMPORTED_MODULE_4__swimlane_ngx_datatable_release_directives_long_press_directive__["LongPressDirective"], [], { pressEnabled: [0, 'pressEnabled'],
            pressModel: [1, 'pressModel'] }, { longPressStart: 'longPressStart', longPressEnd: 'longPressEnd' }),
        __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵdid"](49152, null, 0, __WEBPACK_IMPORTED_MODULE_5__swimlane_ngx_datatable_release_components_header_header_cell_component__["DataTableHeaderCellComponent"], [], { sortType: [0, 'sortType'], column: [1, 'column'], sortAscendingIcon: [2, 'sortAscendingIcon'],
            sortDescendingIcon: [3, 'sortDescendingIcon'], allRowsSelected: [4, 'allRowsSelected'],
            selectionType: [5, 'selectionType'], headerHeight: [6, 'headerHeight'], sorts: [7,
                'sorts'] }, { sort: 'sort', select: 'select', columnContextmenu: 'columnContextmenu' }),
        (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵted"](null, ['\n        ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_9 = _co.dragEventTarget;
        var currVal_10 = _v.context.$implicit;
        var currVal_11 = ((_co.reorderable && _v.context.$implicit.draggable) && _v.context.$implicit.dragging);
        var currVal_12 = false;
        _ck(_v, 1, 0, currVal_9, currVal_10, currVal_11, currVal_12);
        var currVal_13 = _v.context.$implicit.resizeable;
        _ck(_v, 2, 0, currVal_13);
        var currVal_14 = (_co.reorderable && _v.context.$implicit.draggable);
        var currVal_15 = _v.context.$implicit;
        _ck(_v, 3, 0, currVal_14, currVal_15);
        var currVal_16 = _co.sortType;
        var currVal_17 = _v.context.$implicit;
        var currVal_18 = _co.sortAscendingIcon;
        var currVal_19 = _co.sortDescendingIcon;
        var currVal_20 = _co.allRowsSelected;
        var currVal_21 = _co.selectionType;
        var currVal_22 = _co.headerHeight;
        var currVal_23 = _co.sorts;
        _ck(_v, 4, 0, currVal_16, currVal_17, currVal_18, currVal_19, currVal_20, currVal_21, currVal_22, currVal_23);
    }, function (_ck, _v) {
        var currVal_0 = __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵnov"](_v, 2).resizeEnabled;
        var currVal_1 = __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵnov"](_v, 3).press;
        var currVal_2 = __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵnov"](_v, 3).isLongPress;
        var currVal_3 = __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵnov"](_v, 4).headerHeight;
        var currVal_4 = __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵnov"](_v, 4).columnCssClasses;
        var currVal_5 = __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵnov"](_v, 4).name;
        var currVal_6 = __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵnov"](_v, 4).minWidth;
        var currVal_7 = __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵnov"](_v, 4).maxWidth;
        var currVal_8 = __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵnov"](_v, 4).width;
        _ck(_v, 0, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8);
    });
}
function View_DataTableHeaderComponent_1(_l) {
    return __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵeld"](0, null, null, 5, 'div', [], [[8, 'className', 0]], null, null, null, null)),
        __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵdid"](278528, null, 0, __WEBPACK_IMPORTED_MODULE_6__angular_common__["NgStyle"], [__WEBPACK_IMPORTED_MODULE_0__angular_core__["KeyValueDiffers"], __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"],
            __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"]], { ngStyle: [0, 'ngStyle'] }, null), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵted"](null, ['\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵand"](16777216, null, null, 1, null, View_DataTableHeaderComponent_2)), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵdid"](802816, null, 0, __WEBPACK_IMPORTED_MODULE_6__angular_common__["NgForOf"], [__WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewContainerRef"], __WEBPACK_IMPORTED_MODULE_0__angular_core__["TemplateRef"], __WEBPACK_IMPORTED_MODULE_0__angular_core__["IterableDiffers"]], { ngForOf: [0,
                'ngForOf'], ngForTrackBy: [1, 'ngForTrackBy'] }, null), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵted"](null, ['\n      ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_1 = _co.stylesByGroup(_v.context.$implicit.type);
        _ck(_v, 1, 0, currVal_1);
        var currVal_2 = _v.context.$implicit.columns;
        var currVal_3 = _co.columnTrackingFn;
        _ck(_v, 4, 0, currVal_2, currVal_3);
    }, function (_ck, _v) {
        var currVal_0 = ('datatable-row-' + _v.context.$implicit.type);
        _ck(_v, 0, 0, currVal_0);
    });
}
function View_DataTableHeaderComponent_0(_l) {
    return __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵted"](null, ['\n    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵeld"](0, null, null, 6, 'div', [['class', 'datatable-header-inner'], ['orderable', '']], [[4, 'width', 'px']], [[null, 'reorder']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('reorder' === en)) {
                var pd_0 = (_co.onColumnReordered($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵdid"](1196032, null, 1, __WEBPACK_IMPORTED_MODULE_8__swimlane_ngx_datatable_release_directives_orderable_directive__["OrderableDirective"], [__WEBPACK_IMPORTED_MODULE_0__angular_core__["KeyValueDiffers"], __WEBPACK_IMPORTED_MODULE_9__angular_platform_browser__["DOCUMENT"]], null, { reorder: 'reorder' }), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵqud"](603979776, 1, { draggables: 1 }), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵted"](null, ['\n      '])), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵand"](16777216, null, null, 1, null, View_DataTableHeaderComponent_1)),
        __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵdid"](802816, null, 0, __WEBPACK_IMPORTED_MODULE_6__angular_common__["NgForOf"], [__WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewContainerRef"], __WEBPACK_IMPORTED_MODULE_0__angular_core__["TemplateRef"],
            __WEBPACK_IMPORTED_MODULE_0__angular_core__["IterableDiffers"]], { ngForOf: [0, 'ngForOf'], ngForTrackBy: [1, 'ngForTrackBy'] }, null), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵted"](null, ['\n    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵted"](null, ['\n  ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_1 = _co.columnsByPin;
        var currVal_2 = _co.trackByGroups;
        _ck(_v, 6, 0, currVal_1, currVal_2);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.columnGroupWidths.total;
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_DataTableHeaderComponent_Host_0(_l) {
    return __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵeld"](0, null, null, 1, 'datatable-header', [['class', 'datatable-header']], [[4, 'height', null], [4, 'width', null]], null, null, View_DataTableHeaderComponent_0, RenderType_DataTableHeaderComponent)),
        __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵdid"](49152, null, 0, __WEBPACK_IMPORTED_MODULE_7__swimlane_ngx_datatable_release_components_header_header_component__["DataTableHeaderComponent"], [], null, null)], null, function (_ck, _v) {
        var currVal_0 = __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵnov"](_v, 1).headerHeight;
        var currVal_1 = __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵnov"](_v, 1).headerWidth;
        _ck(_v, 0, 0, currVal_0, currVal_1);
    });
}
var DataTableHeaderComponentNgFactory = __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵccf"]('datatable-header', __WEBPACK_IMPORTED_MODULE_7__swimlane_ngx_datatable_release_components_header_header_component__["DataTableHeaderComponent"], View_DataTableHeaderComponent_Host_0, { sortAscendingIcon: 'sortAscendingIcon',
    sortDescendingIcon: 'sortDescendingIcon', scrollbarH: 'scrollbarH', innerWidth: 'innerWidth',
    offsetX: 'offsetX', sorts: 'sorts', sortType: 'sortType', allRowsSelected: 'allRowsSelected',
    selectionType: 'selectionType', reorderable: 'reorderable', headerHeight: 'headerHeight',
    columns: 'columns' }, { sort: 'sort', reorder: 'reorder', resize: 'resize', select: 'select',
    columnContextmenu: 'columnContextmenu' }, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=header.component.ngfactory.js.map

/***/ }),
/* 528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return styles; });
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */
var styles = ['\n\nhtml {\n  font-family: sans-serif;\n  -webkit-text-size-adjust: 100%;\n      -ms-text-size-adjust: 100%;\n}\nbody {\n  margin: 0;\n}\narticle,\naside,\ndetails,\nfigcaption,\nfigure,\nfooter,\nheader,\nhgroup,\nmain,\nmenu,\nnav,\nsection,\nsummary {\n  display: block;\n}\naudio,\ncanvas,\nprogress,\nvideo {\n  display: inline-block;\n  vertical-align: baseline;\n}\naudio:not([controls]) {\n  display: none;\n  height: 0;\n}\n[hidden],\ntemplate {\n  display: none;\n}\na {\n  background-color: transparent;\n}\na:active,\na:hover {\n  outline: 0;\n}\nabbr[title] {\n  border-bottom: 1px dotted;\n}\nb,\nstrong {\n  font-weight: bold;\n}\ndfn {\n  font-style: italic;\n}\nh1 {\n  margin: .67em 0;\n  font-size: 2em;\n}\nmark {\n  color: #000;\n  background: #ff0;\n}\nsmall {\n  font-size: 80%;\n}\nsub,\nsup {\n  position: relative;\n  font-size: 75%;\n  line-height: 0;\n  vertical-align: baseline;\n}\nsup {\n  top: -.5em;\n}\nsub {\n  bottom: -.25em;\n}\nimg {\n  border: 0;\n}\nsvg:not(:root) {\n  overflow: hidden;\n}\nfigure {\n  margin: 1em 40px;\n}\nhr {\n  height: 0;\n  -webkit-box-sizing: content-box;\n     -moz-box-sizing: content-box;\n          box-sizing: content-box;\n}\npre {\n  overflow: auto;\n}\ncode,\nkbd,\npre,\nsamp {\n  font-family: monospace, monospace;\n  font-size: 1em;\n}\nbutton,\ninput,\noptgroup,\nselect,\ntextarea {\n  margin: 0;\n  font: inherit;\n  color: inherit;\n}\nbutton {\n  overflow: visible;\n}\nbutton,\nselect {\n  text-transform: none;\n}\nbutton,\nhtml input[type="button"],\ninput[type="reset"],\ninput[type="submit"] {\n  -webkit-appearance: button;\n  cursor: pointer;\n}\nbutton[disabled],\nhtml input[disabled] {\n  cursor: default;\n}\nbutton::-moz-focus-inner,\ninput::-moz-focus-inner {\n  padding: 0;\n  border: 0;\n}\ninput {\n  line-height: normal;\n}\ninput[type="checkbox"],\ninput[type="radio"] {\n  -webkit-box-sizing: border-box;\n     -moz-box-sizing: border-box;\n          box-sizing: border-box;\n  padding: 0;\n}\ninput[type="number"]::-webkit-inner-spin-button,\ninput[type="number"]::-webkit-outer-spin-button {\n  height: auto;\n}\ninput[type="search"] {\n  -webkit-box-sizing: content-box;\n     -moz-box-sizing: content-box;\n          box-sizing: content-box;\n  -webkit-appearance: textfield;\n}\ninput[type="search"]::-webkit-search-cancel-button,\ninput[type="search"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\nfieldset {\n  padding: .35em .625em .75em;\n  margin: 0 2px;\n  border: 1px solid #c0c0c0;\n}\nlegend {\n  padding: 0;\n  border: 0;\n}\ntextarea {\n  overflow: auto;\n}\noptgroup {\n  font-weight: bold;\n}\ntable {\n  border-spacing: 0;\n  border-collapse: collapse;\n}\ntd,\nth {\n  padding: 0;\n}\n\n@media print {\n  *,\n  *:before,\n  *:after {\n    color: #000 !important;\n    text-shadow: none !important;\n    background: transparent !important;\n    -webkit-box-shadow: none !important;\n            box-shadow: none !important;\n  }\n  a,\n  a:visited {\n    text-decoration: underline;\n  }\n  a[href]:after {\n    content: " (" attr(href) ")";\n  }\n  abbr[title]:after {\n    content: " (" attr(title) ")";\n  }\n  a[href^="#"]:after,\n  a[href^="javascript:"]:after {\n    content: "";\n  }\n  pre,\n  blockquote {\n    border: 1px solid #999;\n\n    page-break-inside: avoid;\n  }\n  thead {\n    display: table-header-group;\n  }\n  tr,\n  img {\n    page-break-inside: avoid;\n  }\n  img {\n    max-width: 100% !important;\n  }\n  p,\n  h2,\n  h3 {\n    orphans: 3;\n    widows: 3;\n  }\n  h2,\n  h3 {\n    page-break-after: avoid;\n  }\n  .navbar {\n    display: none;\n  }\n  .btn > .caret,\n  .dropup > .btn > .caret {\n    border-top-color: #000 !important;\n  }\n  .label {\n    border: 1px solid #000;\n  }\n  .table {\n    border-collapse: collapse !important;\n  }\n  .table td,\n  .table th {\n    background-color: #fff !important;\n  }\n  .table-bordered th,\n  .table-bordered td {\n    border: 1px solid #ddd !important;\n  }\n}\n@font-face {\n  font-family: \'Glyphicons Halflings\';\n\n  src: url(\'../fonts/glyphicons-halflings-regular.eot\');\n  src: url(\'../fonts/glyphicons-halflings-regular.eot?#iefix\') format(\'embedded-opentype\'), url(\'../fonts/glyphicons-halflings-regular.woff2\') format(\'woff2\'), url(\'../fonts/glyphicons-halflings-regular.woff\') format(\'woff\'), url(\'../fonts/glyphicons-halflings-regular.ttf\') format(\'truetype\'), url(\'../fonts/glyphicons-halflings-regular.svg#glyphicons_halflingsregular\') format(\'svg\');\n}\n.glyphicon {\n  position: relative;\n  top: 1px;\n  display: inline-block;\n  font-family: \'Glyphicons Halflings\';\n  font-style: normal;\n  font-weight: normal;\n  line-height: 1;\n\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n.glyphicon-asterisk:before {\n  content: "\\002a";\n}\n.glyphicon-plus:before {\n  content: "\\002b";\n}\n.glyphicon-euro:before,\n.glyphicon-eur:before {\n  content: "\\20ac";\n}\n.glyphicon-minus:before {\n  content: "\\2212";\n}\n.glyphicon-cloud:before {\n  content: "\\2601";\n}\n.glyphicon-envelope:before {\n  content: "\\2709";\n}\n.glyphicon-pencil:before {\n  content: "\\270f";\n}\n.glyphicon-glass:before {\n  content: "\\e001";\n}\n.glyphicon-music:before {\n  content: "\\e002";\n}\n.glyphicon-search:before {\n  content: "\\e003";\n}\n.glyphicon-heart:before {\n  content: "\\e005";\n}\n.glyphicon-star:before {\n  content: "\\e006";\n}\n.glyphicon-star-empty:before {\n  content: "\\e007";\n}\n.glyphicon-user:before {\n  content: "\\e008";\n}\n.glyphicon-film:before {\n  content: "\\e009";\n}\n.glyphicon-th-large:before {\n  content: "\\e010";\n}\n.glyphicon-th:before {\n  content: "\\e011";\n}\n.glyphicon-th-list:before {\n  content: "\\e012";\n}\n.glyphicon-ok:before {\n  content: "\\e013";\n}\n.glyphicon-remove:before {\n  content: "\\e014";\n}\n.glyphicon-zoom-in:before {\n  content: "\\e015";\n}\n.glyphicon-zoom-out:before {\n  content: "\\e016";\n}\n.glyphicon-off:before {\n  content: "\\e017";\n}\n.glyphicon-signal:before {\n  content: "\\e018";\n}\n.glyphicon-cog:before {\n  content: "\\e019";\n}\n.glyphicon-trash:before {\n  content: "\\e020";\n}\n.glyphicon-home:before {\n  content: "\\e021";\n}\n.glyphicon-file:before {\n  content: "\\e022";\n}\n.glyphicon-time:before {\n  content: "\\e023";\n}\n.glyphicon-road:before {\n  content: "\\e024";\n}\n.glyphicon-download-alt:before {\n  content: "\\e025";\n}\n.glyphicon-download:before {\n  content: "\\e026";\n}\n.glyphicon-upload:before {\n  content: "\\e027";\n}\n.glyphicon-inbox:before {\n  content: "\\e028";\n}\n.glyphicon-play-circle:before {\n  content: "\\e029";\n}\n.glyphicon-repeat:before {\n  content: "\\e030";\n}\n.glyphicon-refresh:before {\n  content: "\\e031";\n}\n.glyphicon-list-alt:before {\n  content: "\\e032";\n}\n.glyphicon-lock:before {\n  content: "\\e033";\n}\n.glyphicon-flag:before {\n  content: "\\e034";\n}\n.glyphicon-headphones:before {\n  content: "\\e035";\n}\n.glyphicon-volume-off:before {\n  content: "\\e036";\n}\n.glyphicon-volume-down:before {\n  content: "\\e037";\n}\n.glyphicon-volume-up:before {\n  content: "\\e038";\n}\n.glyphicon-qrcode:before {\n  content: "\\e039";\n}\n.glyphicon-barcode:before {\n  content: "\\e040";\n}\n.glyphicon-tag:before {\n  content: "\\e041";\n}\n.glyphicon-tags:before {\n  content: "\\e042";\n}\n.glyphicon-book:before {\n  content: "\\e043";\n}\n.glyphicon-bookmark:before {\n  content: "\\e044";\n}\n.glyphicon-print:before {\n  content: "\\e045";\n}\n.glyphicon-camera:before {\n  content: "\\e046";\n}\n.glyphicon-font:before {\n  content: "\\e047";\n}\n.glyphicon-bold:before {\n  content: "\\e048";\n}\n.glyphicon-italic:before {\n  content: "\\e049";\n}\n.glyphicon-text-height:before {\n  content: "\\e050";\n}\n.glyphicon-text-width:before {\n  content: "\\e051";\n}\n.glyphicon-align-left:before {\n  content: "\\e052";\n}\n.glyphicon-align-center:before {\n  content: "\\e053";\n}\n.glyphicon-align-right:before {\n  content: "\\e054";\n}\n.glyphicon-align-justify:before {\n  content: "\\e055";\n}\n.glyphicon-list:before {\n  content: "\\e056";\n}\n.glyphicon-indent-left:before {\n  content: "\\e057";\n}\n.glyphicon-indent-right:before {\n  content: "\\e058";\n}\n.glyphicon-facetime-video:before {\n  content: "\\e059";\n}\n.glyphicon-picture:before {\n  content: "\\e060";\n}\n.glyphicon-map-marker:before {\n  content: "\\e062";\n}\n.glyphicon-adjust:before {\n  content: "\\e063";\n}\n.glyphicon-tint:before {\n  content: "\\e064";\n}\n.glyphicon-edit:before {\n  content: "\\e065";\n}\n.glyphicon-share:before {\n  content: "\\e066";\n}\n.glyphicon-check:before {\n  content: "\\e067";\n}\n.glyphicon-move:before {\n  content: "\\e068";\n}\n.glyphicon-step-backward:before {\n  content: "\\e069";\n}\n.glyphicon-fast-backward:before {\n  content: "\\e070";\n}\n.glyphicon-backward:before {\n  content: "\\e071";\n}\n.glyphicon-play:before {\n  content: "\\e072";\n}\n.glyphicon-pause:before {\n  content: "\\e073";\n}\n.glyphicon-stop:before {\n  content: "\\e074";\n}\n.glyphicon-forward:before {\n  content: "\\e075";\n}\n.glyphicon-fast-forward:before {\n  content: "\\e076";\n}\n.glyphicon-step-forward:before {\n  content: "\\e077";\n}\n.glyphicon-eject:before {\n  content: "\\e078";\n}\n.glyphicon-chevron-left:before {\n  content: "\\e079";\n}\n.glyphicon-chevron-right:before {\n  content: "\\e080";\n}\n.glyphicon-plus-sign:before {\n  content: "\\e081";\n}\n.glyphicon-minus-sign:before {\n  content: "\\e082";\n}\n.glyphicon-remove-sign:before {\n  content: "\\e083";\n}\n.glyphicon-ok-sign:before {\n  content: "\\e084";\n}\n.glyphicon-question-sign:before {\n  content: "\\e085";\n}\n.glyphicon-info-sign:before {\n  content: "\\e086";\n}\n.glyphicon-screenshot:before {\n  content: "\\e087";\n}\n.glyphicon-remove-circle:before {\n  content: "\\e088";\n}\n.glyphicon-ok-circle:before {\n  content: "\\e089";\n}\n.glyphicon-ban-circle:before {\n  content: "\\e090";\n}\n.glyphicon-arrow-left:before {\n  content: "\\e091";\n}\n.glyphicon-arrow-right:before {\n  content: "\\e092";\n}\n.glyphicon-arrow-up:before {\n  content: "\\e093";\n}\n.glyphicon-arrow-down:before {\n  content: "\\e094";\n}\n.glyphicon-share-alt:before {\n  content: "\\e095";\n}\n.glyphicon-resize-full:before {\n  content: "\\e096";\n}\n.glyphicon-resize-small:before {\n  content: "\\e097";\n}\n.glyphicon-exclamation-sign:before {\n  content: "\\e101";\n}\n.glyphicon-gift:before {\n  content: "\\e102";\n}\n.glyphicon-leaf:before {\n  content: "\\e103";\n}\n.glyphicon-fire:before {\n  content: "\\e104";\n}\n.glyphicon-eye-open:before {\n  content: "\\e105";\n}\n.glyphicon-eye-close:before {\n  content: "\\e106";\n}\n.glyphicon-warning-sign:before {\n  content: "\\e107";\n}\n.glyphicon-plane:before {\n  content: "\\e108";\n}\n.glyphicon-calendar:before {\n  content: "\\e109";\n}\n.glyphicon-random:before {\n  content: "\\e110";\n}\n.glyphicon-comment:before {\n  content: "\\e111";\n}\n.glyphicon-magnet:before {\n  content: "\\e112";\n}\n.glyphicon-chevron-up:before {\n  content: "\\e113";\n}\n.glyphicon-chevron-down:before {\n  content: "\\e114";\n}\n.glyphicon-retweet:before {\n  content: "\\e115";\n}\n.glyphicon-shopping-cart:before {\n  content: "\\e116";\n}\n.glyphicon-folder-close:before {\n  content: "\\e117";\n}\n.glyphicon-folder-open:before {\n  content: "\\e118";\n}\n.glyphicon-resize-vertical:before {\n  content: "\\e119";\n}\n.glyphicon-resize-horizontal:before {\n  content: "\\e120";\n}\n.glyphicon-hdd:before {\n  content: "\\e121";\n}\n.glyphicon-bullhorn:before {\n  content: "\\e122";\n}\n.glyphicon-bell:before {\n  content: "\\e123";\n}\n.glyphicon-certificate:before {\n  content: "\\e124";\n}\n.glyphicon-thumbs-up:before {\n  content: "\\e125";\n}\n.glyphicon-thumbs-down:before {\n  content: "\\e126";\n}\n.glyphicon-hand-right:before {\n  content: "\\e127";\n}\n.glyphicon-hand-left:before {\n  content: "\\e128";\n}\n.glyphicon-hand-up:before {\n  content: "\\e129";\n}\n.glyphicon-hand-down:before {\n  content: "\\e130";\n}\n.glyphicon-circle-arrow-right:before {\n  content: "\\e131";\n}\n.glyphicon-circle-arrow-left:before {\n  content: "\\e132";\n}\n.glyphicon-circle-arrow-up:before {\n  content: "\\e133";\n}\n.glyphicon-circle-arrow-down:before {\n  content: "\\e134";\n}\n.glyphicon-globe:before {\n  content: "\\e135";\n}\n.glyphicon-wrench:before {\n  content: "\\e136";\n}\n.glyphicon-tasks:before {\n  content: "\\e137";\n}\n.glyphicon-filter:before {\n  content: "\\e138";\n}\n.glyphicon-briefcase:before {\n  content: "\\e139";\n}\n.glyphicon-fullscreen:before {\n  content: "\\e140";\n}\n.glyphicon-dashboard:before {\n  content: "\\e141";\n}\n.glyphicon-paperclip:before {\n  content: "\\e142";\n}\n.glyphicon-heart-empty:before {\n  content: "\\e143";\n}\n.glyphicon-link:before {\n  content: "\\e144";\n}\n.glyphicon-phone:before {\n  content: "\\e145";\n}\n.glyphicon-pushpin:before {\n  content: "\\e146";\n}\n.glyphicon-usd:before {\n  content: "\\e148";\n}\n.glyphicon-gbp:before {\n  content: "\\e149";\n}\n.glyphicon-sort:before {\n  content: "\\e150";\n}\n.glyphicon-sort-by-alphabet:before {\n  content: "\\e151";\n}\n.glyphicon-sort-by-alphabet-alt:before {\n  content: "\\e152";\n}\n.glyphicon-sort-by-order:before {\n  content: "\\e153";\n}\n.glyphicon-sort-by-order-alt:before {\n  content: "\\e154";\n}\n.glyphicon-sort-by-attributes:before {\n  content: "\\e155";\n}\n.glyphicon-sort-by-attributes-alt:before {\n  content: "\\e156";\n}\n.glyphicon-unchecked:before {\n  content: "\\e157";\n}\n.glyphicon-expand:before {\n  content: "\\e158";\n}\n.glyphicon-collapse-down:before {\n  content: "\\e159";\n}\n.glyphicon-collapse-up:before {\n  content: "\\e160";\n}\n.glyphicon-log-in:before {\n  content: "\\e161";\n}\n.glyphicon-flash:before {\n  content: "\\e162";\n}\n.glyphicon-log-out:before {\n  content: "\\e163";\n}\n.glyphicon-new-window:before {\n  content: "\\e164";\n}\n.glyphicon-record:before {\n  content: "\\e165";\n}\n.glyphicon-save:before {\n  content: "\\e166";\n}\n.glyphicon-open:before {\n  content: "\\e167";\n}\n.glyphicon-saved:before {\n  content: "\\e168";\n}\n.glyphicon-import:before {\n  content: "\\e169";\n}\n.glyphicon-export:before {\n  content: "\\e170";\n}\n.glyphicon-send:before {\n  content: "\\e171";\n}\n.glyphicon-floppy-disk:before {\n  content: "\\e172";\n}\n.glyphicon-floppy-saved:before {\n  content: "\\e173";\n}\n.glyphicon-floppy-remove:before {\n  content: "\\e174";\n}\n.glyphicon-floppy-save:before {\n  content: "\\e175";\n}\n.glyphicon-floppy-open:before {\n  content: "\\e176";\n}\n.glyphicon-credit-card:before {\n  content: "\\e177";\n}\n.glyphicon-transfer:before {\n  content: "\\e178";\n}\n.glyphicon-cutlery:before {\n  content: "\\e179";\n}\n.glyphicon-header:before {\n  content: "\\e180";\n}\n.glyphicon-compressed:before {\n  content: "\\e181";\n}\n.glyphicon-earphone:before {\n  content: "\\e182";\n}\n.glyphicon-phone-alt:before {\n  content: "\\e183";\n}\n.glyphicon-tower:before {\n  content: "\\e184";\n}\n.glyphicon-stats:before {\n  content: "\\e185";\n}\n.glyphicon-sd-video:before {\n  content: "\\e186";\n}\n.glyphicon-hd-video:before {\n  content: "\\e187";\n}\n.glyphicon-subtitles:before {\n  content: "\\e188";\n}\n.glyphicon-sound-stereo:before {\n  content: "\\e189";\n}\n.glyphicon-sound-dolby:before {\n  content: "\\e190";\n}\n.glyphicon-sound-5-1:before {\n  content: "\\e191";\n}\n.glyphicon-sound-6-1:before {\n  content: "\\e192";\n}\n.glyphicon-sound-7-1:before {\n  content: "\\e193";\n}\n.glyphicon-copyright-mark:before {\n  content: "\\e194";\n}\n.glyphicon-registration-mark:before {\n  content: "\\e195";\n}\n.glyphicon-cloud-download:before {\n  content: "\\e197";\n}\n.glyphicon-cloud-upload:before {\n  content: "\\e198";\n}\n.glyphicon-tree-conifer:before {\n  content: "\\e199";\n}\n.glyphicon-tree-deciduous:before {\n  content: "\\e200";\n}\n.glyphicon-cd:before {\n  content: "\\e201";\n}\n.glyphicon-save-file:before {\n  content: "\\e202";\n}\n.glyphicon-open-file:before {\n  content: "\\e203";\n}\n.glyphicon-level-up:before {\n  content: "\\e204";\n}\n.glyphicon-copy:before {\n  content: "\\e205";\n}\n.glyphicon-paste:before {\n  content: "\\e206";\n}\n.glyphicon-alert:before {\n  content: "\\e209";\n}\n.glyphicon-equalizer:before {\n  content: "\\e210";\n}\n.glyphicon-king:before {\n  content: "\\e211";\n}\n.glyphicon-queen:before {\n  content: "\\e212";\n}\n.glyphicon-pawn:before {\n  content: "\\e213";\n}\n.glyphicon-bishop:before {\n  content: "\\e214";\n}\n.glyphicon-knight:before {\n  content: "\\e215";\n}\n.glyphicon-baby-formula:before {\n  content: "\\e216";\n}\n.glyphicon-tent:before {\n  content: "\\26fa";\n}\n.glyphicon-blackboard:before {\n  content: "\\e218";\n}\n.glyphicon-bed:before {\n  content: "\\e219";\n}\n.glyphicon-apple:before {\n  content: "\\f8ff";\n}\n.glyphicon-erase:before {\n  content: "\\e221";\n}\n.glyphicon-hourglass:before {\n  content: "\\231b";\n}\n.glyphicon-lamp:before {\n  content: "\\e223";\n}\n.glyphicon-duplicate:before {\n  content: "\\e224";\n}\n.glyphicon-piggy-bank:before {\n  content: "\\e225";\n}\n.glyphicon-scissors:before {\n  content: "\\e226";\n}\n.glyphicon-bitcoin:before {\n  content: "\\e227";\n}\n.glyphicon-btc:before {\n  content: "\\e227";\n}\n.glyphicon-xbt:before {\n  content: "\\e227";\n}\n.glyphicon-yen:before {\n  content: "\\00a5";\n}\n.glyphicon-jpy:before {\n  content: "\\00a5";\n}\n.glyphicon-ruble:before {\n  content: "\\20bd";\n}\n.glyphicon-rub:before {\n  content: "\\20bd";\n}\n.glyphicon-scale:before {\n  content: "\\e230";\n}\n.glyphicon-ice-lolly:before {\n  content: "\\e231";\n}\n.glyphicon-ice-lolly-tasted:before {\n  content: "\\e232";\n}\n.glyphicon-education:before {\n  content: "\\e233";\n}\n.glyphicon-option-horizontal:before {\n  content: "\\e234";\n}\n.glyphicon-option-vertical:before {\n  content: "\\e235";\n}\n.glyphicon-menu-hamburger:before {\n  content: "\\e236";\n}\n.glyphicon-modal-window:before {\n  content: "\\e237";\n}\n.glyphicon-oil:before {\n  content: "\\e238";\n}\n.glyphicon-grain:before {\n  content: "\\e239";\n}\n.glyphicon-sunglasses:before {\n  content: "\\e240";\n}\n.glyphicon-text-size:before {\n  content: "\\e241";\n}\n.glyphicon-text-color:before {\n  content: "\\e242";\n}\n.glyphicon-text-background:before {\n  content: "\\e243";\n}\n.glyphicon-object-align-top:before {\n  content: "\\e244";\n}\n.glyphicon-object-align-bottom:before {\n  content: "\\e245";\n}\n.glyphicon-object-align-horizontal:before {\n  content: "\\e246";\n}\n.glyphicon-object-align-left:before {\n  content: "\\e247";\n}\n.glyphicon-object-align-vertical:before {\n  content: "\\e248";\n}\n.glyphicon-object-align-right:before {\n  content: "\\e249";\n}\n.glyphicon-triangle-right:before {\n  content: "\\e250";\n}\n.glyphicon-triangle-left:before {\n  content: "\\e251";\n}\n.glyphicon-triangle-bottom:before {\n  content: "\\e252";\n}\n.glyphicon-triangle-top:before {\n  content: "\\e253";\n}\n.glyphicon-console:before {\n  content: "\\e254";\n}\n.glyphicon-superscript:before {\n  content: "\\e255";\n}\n.glyphicon-subscript:before {\n  content: "\\e256";\n}\n.glyphicon-menu-left:before {\n  content: "\\e257";\n}\n.glyphicon-menu-right:before {\n  content: "\\e258";\n}\n.glyphicon-menu-down:before {\n  content: "\\e259";\n}\n.glyphicon-menu-up:before {\n  content: "\\e260";\n}\n* {\n  -webkit-box-sizing: border-box;\n     -moz-box-sizing: border-box;\n          box-sizing: border-box;\n}\n*:before,\n*:after {\n  -webkit-box-sizing: border-box;\n     -moz-box-sizing: border-box;\n          box-sizing: border-box;\n}\nhtml {\n  font-size: 10px;\n\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\nbody {\n  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;\n  font-size: 14px;\n  line-height: 1.42857143;\n  color: #333;\n  background-color: #fff;\n}\ninput,\nbutton,\nselect,\ntextarea {\n  font-family: inherit;\n  font-size: inherit;\n  line-height: inherit;\n}\na {\n  color: #337ab7;\n  text-decoration: none;\n}\na:hover,\na:focus {\n  color: #23527c;\n  text-decoration: underline;\n}\na:focus {\n  outline: 5px auto -webkit-focus-ring-color;\n  outline-offset: -2px;\n}\nfigure {\n  margin: 0;\n}\nimg {\n  vertical-align: middle;\n}\n.img-responsive,\n.thumbnail > img,\n.thumbnail a > img,\n.carousel-inner > .item > img,\n.carousel-inner > .item > a > img {\n  display: block;\n  max-width: 100%;\n  height: auto;\n}\n.img-rounded {\n  border-radius: 6px;\n}\n.img-thumbnail {\n  display: inline-block;\n  max-width: 100%;\n  height: auto;\n  padding: 4px;\n  line-height: 1.42857143;\n  background-color: #fff;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  -webkit-transition: all .2s ease-in-out;\n       -o-transition: all .2s ease-in-out;\n          transition: all .2s ease-in-out;\n}\n.img-circle {\n  border-radius: 50%;\n}\nhr {\n  margin-top: 20px;\n  margin-bottom: 20px;\n  border: 0;\n  border-top: 1px solid #eee;\n}\n.sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  border: 0;\n}\n.sr-only-focusable:active,\n.sr-only-focusable:focus {\n  position: static;\n  width: auto;\n  height: auto;\n  margin: 0;\n  overflow: visible;\n  clip: auto;\n}\n[role="button"] {\n  cursor: pointer;\n}\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\n.h1,\n.h2,\n.h3,\n.h4,\n.h5,\n.h6 {\n  font-family: inherit;\n  font-weight: 500;\n  line-height: 1.1;\n  color: inherit;\n}\nh1 small,\nh2 small,\nh3 small,\nh4 small,\nh5 small,\nh6 small,\n.h1 small,\n.h2 small,\n.h3 small,\n.h4 small,\n.h5 small,\n.h6 small,\nh1 .small,\nh2 .small,\nh3 .small,\nh4 .small,\nh5 .small,\nh6 .small,\n.h1 .small,\n.h2 .small,\n.h3 .small,\n.h4 .small,\n.h5 .small,\n.h6 .small {\n  font-weight: normal;\n  line-height: 1;\n  color: #777;\n}\nh1,\n.h1,\nh2,\n.h2,\nh3,\n.h3 {\n  margin-top: 20px;\n  margin-bottom: 10px;\n}\nh1 small,\n.h1 small,\nh2 small,\n.h2 small,\nh3 small,\n.h3 small,\nh1 .small,\n.h1 .small,\nh2 .small,\n.h2 .small,\nh3 .small,\n.h3 .small {\n  font-size: 65%;\n}\nh4,\n.h4,\nh5,\n.h5,\nh6,\n.h6 {\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\nh4 small,\n.h4 small,\nh5 small,\n.h5 small,\nh6 small,\n.h6 small,\nh4 .small,\n.h4 .small,\nh5 .small,\n.h5 .small,\nh6 .small,\n.h6 .small {\n  font-size: 75%;\n}\nh1,\n.h1 {\n  font-size: 36px;\n}\nh2,\n.h2 {\n  font-size: 30px;\n}\nh3,\n.h3 {\n  font-size: 24px;\n}\nh4,\n.h4 {\n  font-size: 18px;\n}\nh5,\n.h5 {\n  font-size: 14px;\n}\nh6,\n.h6 {\n  font-size: 12px;\n}\np {\n  margin: 0 0 10px;\n}\n.lead {\n  margin-bottom: 20px;\n  font-size: 16px;\n  font-weight: 300;\n  line-height: 1.4;\n}\n@media (min-width: 768px) {\n  .lead {\n    font-size: 21px;\n  }\n}\nsmall,\n.small {\n  font-size: 85%;\n}\nmark,\n.mark {\n  padding: .2em;\n  background-color: #fcf8e3;\n}\n.text-left {\n  text-align: left;\n}\n.text-right {\n  text-align: right;\n}\n.text-center {\n  text-align: center;\n}\n.text-justify {\n  text-align: justify;\n}\n.text-nowrap {\n  white-space: nowrap;\n}\n.text-lowercase {\n  text-transform: lowercase;\n}\n.text-uppercase {\n  text-transform: uppercase;\n}\n.text-capitalize {\n  text-transform: capitalize;\n}\n.text-muted {\n  color: #777;\n}\n.text-primary {\n  color: #337ab7;\n}\na.text-primary:hover,\na.text-primary:focus {\n  color: #286090;\n}\n.text-success {\n  color: #3c763d;\n}\na.text-success:hover,\na.text-success:focus {\n  color: #2b542c;\n}\n.text-info {\n  color: #31708f;\n}\na.text-info:hover,\na.text-info:focus {\n  color: #245269;\n}\n.text-warning {\n  color: #8a6d3b;\n}\na.text-warning:hover,\na.text-warning:focus {\n  color: #66512c;\n}\n.text-danger {\n  color: #a94442;\n}\na.text-danger:hover,\na.text-danger:focus {\n  color: #843534;\n}\n.bg-primary {\n  color: #fff;\n  background-color: #337ab7;\n}\na.bg-primary:hover,\na.bg-primary:focus {\n  background-color: #286090;\n}\n.bg-success {\n  background-color: #dff0d8;\n}\na.bg-success:hover,\na.bg-success:focus {\n  background-color: #c1e2b3;\n}\n.bg-info {\n  background-color: #d9edf7;\n}\na.bg-info:hover,\na.bg-info:focus {\n  background-color: #afd9ee;\n}\n.bg-warning {\n  background-color: #fcf8e3;\n}\na.bg-warning:hover,\na.bg-warning:focus {\n  background-color: #f7ecb5;\n}\n.bg-danger {\n  background-color: #f2dede;\n}\na.bg-danger:hover,\na.bg-danger:focus {\n  background-color: #e4b9b9;\n}\n.page-header {\n  padding-bottom: 9px;\n  margin: 40px 0 20px;\n  border-bottom: 1px solid #eee;\n}\nul,\nol {\n  margin-top: 0;\n  margin-bottom: 10px;\n}\nul ul,\nol ul,\nul ol,\nol ol {\n  margin-bottom: 0;\n}\n.list-unstyled {\n  padding-left: 0;\n  list-style: none;\n}\n.list-inline {\n  padding-left: 0;\n  margin-left: -5px;\n  list-style: none;\n}\n.list-inline > li {\n  display: inline-block;\n  padding-right: 5px;\n  padding-left: 5px;\n}\ndl {\n  margin-top: 0;\n  margin-bottom: 20px;\n}\ndt,\ndd {\n  line-height: 1.42857143;\n}\ndt {\n  font-weight: bold;\n}\ndd {\n  margin-left: 0;\n}\n@media (min-width: 768px) {\n  .dl-horizontal dt {\n    float: left;\n    width: 160px;\n    overflow: hidden;\n    clear: left;\n    text-align: right;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n  .dl-horizontal dd {\n    margin-left: 180px;\n  }\n}\nabbr[title],\nabbr[data-original-title] {\n  cursor: help;\n  border-bottom: 1px dotted #777;\n}\n.initialism {\n  font-size: 90%;\n  text-transform: uppercase;\n}\nblockquote {\n  padding: 10px 20px;\n  margin: 0 0 20px;\n  font-size: 17.5px;\n  border-left: 5px solid #eee;\n}\nblockquote p:last-child,\nblockquote ul:last-child,\nblockquote ol:last-child {\n  margin-bottom: 0;\n}\nblockquote footer,\nblockquote small,\nblockquote .small {\n  display: block;\n  font-size: 80%;\n  line-height: 1.42857143;\n  color: #777;\n}\nblockquote footer:before,\nblockquote small:before,\nblockquote .small:before {\n  content: \'\\2014 \\00A0\';\n}\n.blockquote-reverse,\nblockquote.pull-right {\n  padding-right: 15px;\n  padding-left: 0;\n  text-align: right;\n  border-right: 5px solid #eee;\n  border-left: 0;\n}\n.blockquote-reverse footer:before,\nblockquote.pull-right footer:before,\n.blockquote-reverse small:before,\nblockquote.pull-right small:before,\n.blockquote-reverse .small:before,\nblockquote.pull-right .small:before {\n  content: \'\';\n}\n.blockquote-reverse footer:after,\nblockquote.pull-right footer:after,\n.blockquote-reverse small:after,\nblockquote.pull-right small:after,\n.blockquote-reverse .small:after,\nblockquote.pull-right .small:after {\n  content: \'\\00A0 \\2014\';\n}\naddress {\n  margin-bottom: 20px;\n  font-style: normal;\n  line-height: 1.42857143;\n}\ncode,\nkbd,\npre,\nsamp {\n  font-family: Menlo, Monaco, Consolas, "Courier New", monospace;\n}\ncode {\n  padding: 2px 4px;\n  font-size: 90%;\n  color: #c7254e;\n  background-color: #f9f2f4;\n  border-radius: 4px;\n}\nkbd {\n  padding: 2px 4px;\n  font-size: 90%;\n  color: #fff;\n  background-color: #333;\n  border-radius: 3px;\n  -webkit-box-shadow: inset 0 -1px 0 rgba(0, 0, 0, .25);\n          box-shadow: inset 0 -1px 0 rgba(0, 0, 0, .25);\n}\nkbd kbd {\n  padding: 0;\n  font-size: 100%;\n  font-weight: bold;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\npre {\n  display: block;\n  padding: 9.5px;\n  margin: 0 0 10px;\n  font-size: 13px;\n  line-height: 1.42857143;\n  color: #333;\n  word-break: break-all;\n  word-wrap: break-word;\n  background-color: #f5f5f5;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\npre code {\n  padding: 0;\n  font-size: inherit;\n  color: inherit;\n  white-space: pre-wrap;\n  background-color: transparent;\n  border-radius: 0;\n}\n.pre-scrollable {\n  max-height: 340px;\n  overflow-y: scroll;\n}\n.container {\n  padding-right: 15px;\n  padding-left: 15px;\n  margin-right: auto;\n  margin-left: auto;\n}\n@media (min-width: 768px) {\n  .container {\n    width: 750px;\n  }\n}\n@media (min-width: 992px) {\n  .container {\n    width: 970px;\n  }\n}\n@media (min-width: 1200px) {\n  .container {\n    width: 1170px;\n  }\n}\n.container-fluid {\n  padding-right: 15px;\n  padding-left: 15px;\n  margin-right: auto;\n  margin-left: auto;\n}\n.row {\n  margin-right: -15px;\n  margin-left: -15px;\n}\n.col-xs-1, .col-sm-1, .col-md-1, .col-lg-1, .col-xs-2, .col-sm-2, .col-md-2, .col-lg-2, .col-xs-3, .col-sm-3, .col-md-3, .col-lg-3, .col-xs-4, .col-sm-4, .col-md-4, .col-lg-4, .col-xs-5, .col-sm-5, .col-md-5, .col-lg-5, .col-xs-6, .col-sm-6, .col-md-6, .col-lg-6, .col-xs-7, .col-sm-7, .col-md-7, .col-lg-7, .col-xs-8, .col-sm-8, .col-md-8, .col-lg-8, .col-xs-9, .col-sm-9, .col-md-9, .col-lg-9, .col-xs-10, .col-sm-10, .col-md-10, .col-lg-10, .col-xs-11, .col-sm-11, .col-md-11, .col-lg-11, .col-xs-12, .col-sm-12, .col-md-12, .col-lg-12 {\n  position: relative;\n  min-height: 1px;\n  padding-right: 15px;\n  padding-left: 15px;\n}\n.col-xs-1, .col-xs-2, .col-xs-3, .col-xs-4, .col-xs-5, .col-xs-6, .col-xs-7, .col-xs-8, .col-xs-9, .col-xs-10, .col-xs-11, .col-xs-12 {\n  float: left;\n}\n.col-xs-12 {\n  width: 100%;\n}\n.col-xs-11 {\n  width: 91.66666667%;\n}\n.col-xs-10 {\n  width: 83.33333333%;\n}\n.col-xs-9 {\n  width: 75%;\n}\n.col-xs-8 {\n  width: 66.66666667%;\n}\n.col-xs-7 {\n  width: 58.33333333%;\n}\n.col-xs-6 {\n  width: 50%;\n}\n.col-xs-5 {\n  width: 41.66666667%;\n}\n.col-xs-4 {\n  width: 33.33333333%;\n}\n.col-xs-3 {\n  width: 25%;\n}\n.col-xs-2 {\n  width: 16.66666667%;\n}\n.col-xs-1 {\n  width: 8.33333333%;\n}\n.col-xs-pull-12 {\n  right: 100%;\n}\n.col-xs-pull-11 {\n  right: 91.66666667%;\n}\n.col-xs-pull-10 {\n  right: 83.33333333%;\n}\n.col-xs-pull-9 {\n  right: 75%;\n}\n.col-xs-pull-8 {\n  right: 66.66666667%;\n}\n.col-xs-pull-7 {\n  right: 58.33333333%;\n}\n.col-xs-pull-6 {\n  right: 50%;\n}\n.col-xs-pull-5 {\n  right: 41.66666667%;\n}\n.col-xs-pull-4 {\n  right: 33.33333333%;\n}\n.col-xs-pull-3 {\n  right: 25%;\n}\n.col-xs-pull-2 {\n  right: 16.66666667%;\n}\n.col-xs-pull-1 {\n  right: 8.33333333%;\n}\n.col-xs-pull-0 {\n  right: auto;\n}\n.col-xs-push-12 {\n  left: 100%;\n}\n.col-xs-push-11 {\n  left: 91.66666667%;\n}\n.col-xs-push-10 {\n  left: 83.33333333%;\n}\n.col-xs-push-9 {\n  left: 75%;\n}\n.col-xs-push-8 {\n  left: 66.66666667%;\n}\n.col-xs-push-7 {\n  left: 58.33333333%;\n}\n.col-xs-push-6 {\n  left: 50%;\n}\n.col-xs-push-5 {\n  left: 41.66666667%;\n}\n.col-xs-push-4 {\n  left: 33.33333333%;\n}\n.col-xs-push-3 {\n  left: 25%;\n}\n.col-xs-push-2 {\n  left: 16.66666667%;\n}\n.col-xs-push-1 {\n  left: 8.33333333%;\n}\n.col-xs-push-0 {\n  left: auto;\n}\n.col-xs-offset-12 {\n  margin-left: 100%;\n}\n.col-xs-offset-11 {\n  margin-left: 91.66666667%;\n}\n.col-xs-offset-10 {\n  margin-left: 83.33333333%;\n}\n.col-xs-offset-9 {\n  margin-left: 75%;\n}\n.col-xs-offset-8 {\n  margin-left: 66.66666667%;\n}\n.col-xs-offset-7 {\n  margin-left: 58.33333333%;\n}\n.col-xs-offset-6 {\n  margin-left: 50%;\n}\n.col-xs-offset-5 {\n  margin-left: 41.66666667%;\n}\n.col-xs-offset-4 {\n  margin-left: 33.33333333%;\n}\n.col-xs-offset-3 {\n  margin-left: 25%;\n}\n.col-xs-offset-2 {\n  margin-left: 16.66666667%;\n}\n.col-xs-offset-1 {\n  margin-left: 8.33333333%;\n}\n.col-xs-offset-0 {\n  margin-left: 0;\n}\n@media (min-width: 768px) {\n  .col-sm-1, .col-sm-2, .col-sm-3, .col-sm-4, .col-sm-5, .col-sm-6, .col-sm-7, .col-sm-8, .col-sm-9, .col-sm-10, .col-sm-11, .col-sm-12 {\n    float: left;\n  }\n  .col-sm-12 {\n    width: 100%;\n  }\n  .col-sm-11 {\n    width: 91.66666667%;\n  }\n  .col-sm-10 {\n    width: 83.33333333%;\n  }\n  .col-sm-9 {\n    width: 75%;\n  }\n  .col-sm-8 {\n    width: 66.66666667%;\n  }\n  .col-sm-7 {\n    width: 58.33333333%;\n  }\n  .col-sm-6 {\n    width: 50%;\n  }\n  .col-sm-5 {\n    width: 41.66666667%;\n  }\n  .col-sm-4 {\n    width: 33.33333333%;\n  }\n  .col-sm-3 {\n    width: 25%;\n  }\n  .col-sm-2 {\n    width: 16.66666667%;\n  }\n  .col-sm-1 {\n    width: 8.33333333%;\n  }\n  .col-sm-pull-12 {\n    right: 100%;\n  }\n  .col-sm-pull-11 {\n    right: 91.66666667%;\n  }\n  .col-sm-pull-10 {\n    right: 83.33333333%;\n  }\n  .col-sm-pull-9 {\n    right: 75%;\n  }\n  .col-sm-pull-8 {\n    right: 66.66666667%;\n  }\n  .col-sm-pull-7 {\n    right: 58.33333333%;\n  }\n  .col-sm-pull-6 {\n    right: 50%;\n  }\n  .col-sm-pull-5 {\n    right: 41.66666667%;\n  }\n  .col-sm-pull-4 {\n    right: 33.33333333%;\n  }\n  .col-sm-pull-3 {\n    right: 25%;\n  }\n  .col-sm-pull-2 {\n    right: 16.66666667%;\n  }\n  .col-sm-pull-1 {\n    right: 8.33333333%;\n  }\n  .col-sm-pull-0 {\n    right: auto;\n  }\n  .col-sm-push-12 {\n    left: 100%;\n  }\n  .col-sm-push-11 {\n    left: 91.66666667%;\n  }\n  .col-sm-push-10 {\n    left: 83.33333333%;\n  }\n  .col-sm-push-9 {\n    left: 75%;\n  }\n  .col-sm-push-8 {\n    left: 66.66666667%;\n  }\n  .col-sm-push-7 {\n    left: 58.33333333%;\n  }\n  .col-sm-push-6 {\n    left: 50%;\n  }\n  .col-sm-push-5 {\n    left: 41.66666667%;\n  }\n  .col-sm-push-4 {\n    left: 33.33333333%;\n  }\n  .col-sm-push-3 {\n    left: 25%;\n  }\n  .col-sm-push-2 {\n    left: 16.66666667%;\n  }\n  .col-sm-push-1 {\n    left: 8.33333333%;\n  }\n  .col-sm-push-0 {\n    left: auto;\n  }\n  .col-sm-offset-12 {\n    margin-left: 100%;\n  }\n  .col-sm-offset-11 {\n    margin-left: 91.66666667%;\n  }\n  .col-sm-offset-10 {\n    margin-left: 83.33333333%;\n  }\n  .col-sm-offset-9 {\n    margin-left: 75%;\n  }\n  .col-sm-offset-8 {\n    margin-left: 66.66666667%;\n  }\n  .col-sm-offset-7 {\n    margin-left: 58.33333333%;\n  }\n  .col-sm-offset-6 {\n    margin-left: 50%;\n  }\n  .col-sm-offset-5 {\n    margin-left: 41.66666667%;\n  }\n  .col-sm-offset-4 {\n    margin-left: 33.33333333%;\n  }\n  .col-sm-offset-3 {\n    margin-left: 25%;\n  }\n  .col-sm-offset-2 {\n    margin-left: 16.66666667%;\n  }\n  .col-sm-offset-1 {\n    margin-left: 8.33333333%;\n  }\n  .col-sm-offset-0 {\n    margin-left: 0;\n  }\n}\n@media (min-width: 992px) {\n  .col-md-1, .col-md-2, .col-md-3, .col-md-4, .col-md-5, .col-md-6, .col-md-7, .col-md-8, .col-md-9, .col-md-10, .col-md-11, .col-md-12 {\n    float: left;\n  }\n  .col-md-12 {\n    width: 100%;\n  }\n  .col-md-11 {\n    width: 91.66666667%;\n  }\n  .col-md-10 {\n    width: 83.33333333%;\n  }\n  .col-md-9 {\n    width: 75%;\n  }\n  .col-md-8 {\n    width: 66.66666667%;\n  }\n  .col-md-7 {\n    width: 58.33333333%;\n  }\n  .col-md-6 {\n    width: 50%;\n  }\n  .col-md-5 {\n    width: 41.66666667%;\n  }\n  .col-md-4 {\n    width: 33.33333333%;\n  }\n  .col-md-3 {\n    width: 25%;\n  }\n  .col-md-2 {\n    width: 16.66666667%;\n  }\n  .col-md-1 {\n    width: 8.33333333%;\n  }\n  .col-md-pull-12 {\n    right: 100%;\n  }\n  .col-md-pull-11 {\n    right: 91.66666667%;\n  }\n  .col-md-pull-10 {\n    right: 83.33333333%;\n  }\n  .col-md-pull-9 {\n    right: 75%;\n  }\n  .col-md-pull-8 {\n    right: 66.66666667%;\n  }\n  .col-md-pull-7 {\n    right: 58.33333333%;\n  }\n  .col-md-pull-6 {\n    right: 50%;\n  }\n  .col-md-pull-5 {\n    right: 41.66666667%;\n  }\n  .col-md-pull-4 {\n    right: 33.33333333%;\n  }\n  .col-md-pull-3 {\n    right: 25%;\n  }\n  .col-md-pull-2 {\n    right: 16.66666667%;\n  }\n  .col-md-pull-1 {\n    right: 8.33333333%;\n  }\n  .col-md-pull-0 {\n    right: auto;\n  }\n  .col-md-push-12 {\n    left: 100%;\n  }\n  .col-md-push-11 {\n    left: 91.66666667%;\n  }\n  .col-md-push-10 {\n    left: 83.33333333%;\n  }\n  .col-md-push-9 {\n    left: 75%;\n  }\n  .col-md-push-8 {\n    left: 66.66666667%;\n  }\n  .col-md-push-7 {\n    left: 58.33333333%;\n  }\n  .col-md-push-6 {\n    left: 50%;\n  }\n  .col-md-push-5 {\n    left: 41.66666667%;\n  }\n  .col-md-push-4 {\n    left: 33.33333333%;\n  }\n  .col-md-push-3 {\n    left: 25%;\n  }\n  .col-md-push-2 {\n    left: 16.66666667%;\n  }\n  .col-md-push-1 {\n    left: 8.33333333%;\n  }\n  .col-md-push-0 {\n    left: auto;\n  }\n  .col-md-offset-12 {\n    margin-left: 100%;\n  }\n  .col-md-offset-11 {\n    margin-left: 91.66666667%;\n  }\n  .col-md-offset-10 {\n    margin-left: 83.33333333%;\n  }\n  .col-md-offset-9 {\n    margin-left: 75%;\n  }\n  .col-md-offset-8 {\n    margin-left: 66.66666667%;\n  }\n  .col-md-offset-7 {\n    margin-left: 58.33333333%;\n  }\n  .col-md-offset-6 {\n    margin-left: 50%;\n  }\n  .col-md-offset-5 {\n    margin-left: 41.66666667%;\n  }\n  .col-md-offset-4 {\n    margin-left: 33.33333333%;\n  }\n  .col-md-offset-3 {\n    margin-left: 25%;\n  }\n  .col-md-offset-2 {\n    margin-left: 16.66666667%;\n  }\n  .col-md-offset-1 {\n    margin-left: 8.33333333%;\n  }\n  .col-md-offset-0 {\n    margin-left: 0;\n  }\n}\n@media (min-width: 1200px) {\n  .col-lg-1, .col-lg-2, .col-lg-3, .col-lg-4, .col-lg-5, .col-lg-6, .col-lg-7, .col-lg-8, .col-lg-9, .col-lg-10, .col-lg-11, .col-lg-12 {\n    float: left;\n  }\n  .col-lg-12 {\n    width: 100%;\n  }\n  .col-lg-11 {\n    width: 91.66666667%;\n  }\n  .col-lg-10 {\n    width: 83.33333333%;\n  }\n  .col-lg-9 {\n    width: 75%;\n  }\n  .col-lg-8 {\n    width: 66.66666667%;\n  }\n  .col-lg-7 {\n    width: 58.33333333%;\n  }\n  .col-lg-6 {\n    width: 50%;\n  }\n  .col-lg-5 {\n    width: 41.66666667%;\n  }\n  .col-lg-4 {\n    width: 33.33333333%;\n  }\n  .col-lg-3 {\n    width: 25%;\n  }\n  .col-lg-2 {\n    width: 16.66666667%;\n  }\n  .col-lg-1 {\n    width: 8.33333333%;\n  }\n  .col-lg-pull-12 {\n    right: 100%;\n  }\n  .col-lg-pull-11 {\n    right: 91.66666667%;\n  }\n  .col-lg-pull-10 {\n    right: 83.33333333%;\n  }\n  .col-lg-pull-9 {\n    right: 75%;\n  }\n  .col-lg-pull-8 {\n    right: 66.66666667%;\n  }\n  .col-lg-pull-7 {\n    right: 58.33333333%;\n  }\n  .col-lg-pull-6 {\n    right: 50%;\n  }\n  .col-lg-pull-5 {\n    right: 41.66666667%;\n  }\n  .col-lg-pull-4 {\n    right: 33.33333333%;\n  }\n  .col-lg-pull-3 {\n    right: 25%;\n  }\n  .col-lg-pull-2 {\n    right: 16.66666667%;\n  }\n  .col-lg-pull-1 {\n    right: 8.33333333%;\n  }\n  .col-lg-pull-0 {\n    right: auto;\n  }\n  .col-lg-push-12 {\n    left: 100%;\n  }\n  .col-lg-push-11 {\n    left: 91.66666667%;\n  }\n  .col-lg-push-10 {\n    left: 83.33333333%;\n  }\n  .col-lg-push-9 {\n    left: 75%;\n  }\n  .col-lg-push-8 {\n    left: 66.66666667%;\n  }\n  .col-lg-push-7 {\n    left: 58.33333333%;\n  }\n  .col-lg-push-6 {\n    left: 50%;\n  }\n  .col-lg-push-5 {\n    left: 41.66666667%;\n  }\n  .col-lg-push-4 {\n    left: 33.33333333%;\n  }\n  .col-lg-push-3 {\n    left: 25%;\n  }\n  .col-lg-push-2 {\n    left: 16.66666667%;\n  }\n  .col-lg-push-1 {\n    left: 8.33333333%;\n  }\n  .col-lg-push-0 {\n    left: auto;\n  }\n  .col-lg-offset-12 {\n    margin-left: 100%;\n  }\n  .col-lg-offset-11 {\n    margin-left: 91.66666667%;\n  }\n  .col-lg-offset-10 {\n    margin-left: 83.33333333%;\n  }\n  .col-lg-offset-9 {\n    margin-left: 75%;\n  }\n  .col-lg-offset-8 {\n    margin-left: 66.66666667%;\n  }\n  .col-lg-offset-7 {\n    margin-left: 58.33333333%;\n  }\n  .col-lg-offset-6 {\n    margin-left: 50%;\n  }\n  .col-lg-offset-5 {\n    margin-left: 41.66666667%;\n  }\n  .col-lg-offset-4 {\n    margin-left: 33.33333333%;\n  }\n  .col-lg-offset-3 {\n    margin-left: 25%;\n  }\n  .col-lg-offset-2 {\n    margin-left: 16.66666667%;\n  }\n  .col-lg-offset-1 {\n    margin-left: 8.33333333%;\n  }\n  .col-lg-offset-0 {\n    margin-left: 0;\n  }\n}\ntable {\n  background-color: transparent;\n}\ncaption {\n  padding-top: 8px;\n  padding-bottom: 8px;\n  color: #777;\n  text-align: left;\n}\nth {\n  text-align: left;\n}\n.table {\n  width: 100%;\n  max-width: 100%;\n  margin-bottom: 20px;\n}\n.table > thead > tr > th,\n.table > tbody > tr > th,\n.table > tfoot > tr > th,\n.table > thead > tr > td,\n.table > tbody > tr > td,\n.table > tfoot > tr > td {\n  padding: 8px;\n  line-height: 1.42857143;\n  vertical-align: top;\n  border-top: 1px solid #ddd;\n}\n.table > thead > tr > th {\n  vertical-align: bottom;\n  border-bottom: 2px solid #ddd;\n}\n.table > caption + thead > tr:first-child > th,\n.table > colgroup + thead > tr:first-child > th,\n.table > thead:first-child > tr:first-child > th,\n.table > caption + thead > tr:first-child > td,\n.table > colgroup + thead > tr:first-child > td,\n.table > thead:first-child > tr:first-child > td {\n  border-top: 0;\n}\n.table > tbody + tbody {\n  border-top: 2px solid #ddd;\n}\n.table .table {\n  background-color: #fff;\n}\n.table-condensed > thead > tr > th,\n.table-condensed > tbody > tr > th,\n.table-condensed > tfoot > tr > th,\n.table-condensed > thead > tr > td,\n.table-condensed > tbody > tr > td,\n.table-condensed > tfoot > tr > td {\n  padding: 5px;\n}\n.table-bordered {\n  border: 1px solid #ddd;\n}\n.table-bordered > thead > tr > th,\n.table-bordered > tbody > tr > th,\n.table-bordered > tfoot > tr > th,\n.table-bordered > thead > tr > td,\n.table-bordered > tbody > tr > td,\n.table-bordered > tfoot > tr > td {\n  border: 1px solid #ddd;\n}\n.table-bordered > thead > tr > th,\n.table-bordered > thead > tr > td {\n  border-bottom-width: 2px;\n}\n.table-striped > tbody > tr:nth-of-type(odd) {\n  background-color: #f9f9f9;\n}\n.table-hover > tbody > tr:hover {\n  background-color: #f5f5f5;\n}\ntable col[class*="col-"] {\n  position: static;\n  display: table-column;\n  float: none;\n}\ntable td[class*="col-"],\ntable th[class*="col-"] {\n  position: static;\n  display: table-cell;\n  float: none;\n}\n.table > thead > tr > td.active,\n.table > tbody > tr > td.active,\n.table > tfoot > tr > td.active,\n.table > thead > tr > th.active,\n.table > tbody > tr > th.active,\n.table > tfoot > tr > th.active,\n.table > thead > tr.active > td,\n.table > tbody > tr.active > td,\n.table > tfoot > tr.active > td,\n.table > thead > tr.active > th,\n.table > tbody > tr.active > th,\n.table > tfoot > tr.active > th {\n  background-color: #f5f5f5;\n}\n.table-hover > tbody > tr > td.active:hover,\n.table-hover > tbody > tr > th.active:hover,\n.table-hover > tbody > tr.active:hover > td,\n.table-hover > tbody > tr:hover > .active,\n.table-hover > tbody > tr.active:hover > th {\n  background-color: #e8e8e8;\n}\n.table > thead > tr > td.success,\n.table > tbody > tr > td.success,\n.table > tfoot > tr > td.success,\n.table > thead > tr > th.success,\n.table > tbody > tr > th.success,\n.table > tfoot > tr > th.success,\n.table > thead > tr.success > td,\n.table > tbody > tr.success > td,\n.table > tfoot > tr.success > td,\n.table > thead > tr.success > th,\n.table > tbody > tr.success > th,\n.table > tfoot > tr.success > th {\n  background-color: #dff0d8;\n}\n.table-hover > tbody > tr > td.success:hover,\n.table-hover > tbody > tr > th.success:hover,\n.table-hover > tbody > tr.success:hover > td,\n.table-hover > tbody > tr:hover > .success,\n.table-hover > tbody > tr.success:hover > th {\n  background-color: #d0e9c6;\n}\n.table > thead > tr > td.info,\n.table > tbody > tr > td.info,\n.table > tfoot > tr > td.info,\n.table > thead > tr > th.info,\n.table > tbody > tr > th.info,\n.table > tfoot > tr > th.info,\n.table > thead > tr.info > td,\n.table > tbody > tr.info > td,\n.table > tfoot > tr.info > td,\n.table > thead > tr.info > th,\n.table > tbody > tr.info > th,\n.table > tfoot > tr.info > th {\n  background-color: #d9edf7;\n}\n.table-hover > tbody > tr > td.info:hover,\n.table-hover > tbody > tr > th.info:hover,\n.table-hover > tbody > tr.info:hover > td,\n.table-hover > tbody > tr:hover > .info,\n.table-hover > tbody > tr.info:hover > th {\n  background-color: #c4e3f3;\n}\n.table > thead > tr > td.warning,\n.table > tbody > tr > td.warning,\n.table > tfoot > tr > td.warning,\n.table > thead > tr > th.warning,\n.table > tbody > tr > th.warning,\n.table > tfoot > tr > th.warning,\n.table > thead > tr.warning > td,\n.table > tbody > tr.warning > td,\n.table > tfoot > tr.warning > td,\n.table > thead > tr.warning > th,\n.table > tbody > tr.warning > th,\n.table > tfoot > tr.warning > th {\n  background-color: #fcf8e3;\n}\n.table-hover > tbody > tr > td.warning:hover,\n.table-hover > tbody > tr > th.warning:hover,\n.table-hover > tbody > tr.warning:hover > td,\n.table-hover > tbody > tr:hover > .warning,\n.table-hover > tbody > tr.warning:hover > th {\n  background-color: #faf2cc;\n}\n.table > thead > tr > td.danger,\n.table > tbody > tr > td.danger,\n.table > tfoot > tr > td.danger,\n.table > thead > tr > th.danger,\n.table > tbody > tr > th.danger,\n.table > tfoot > tr > th.danger,\n.table > thead > tr.danger > td,\n.table > tbody > tr.danger > td,\n.table > tfoot > tr.danger > td,\n.table > thead > tr.danger > th,\n.table > tbody > tr.danger > th,\n.table > tfoot > tr.danger > th {\n  background-color: #f2dede;\n}\n.table-hover > tbody > tr > td.danger:hover,\n.table-hover > tbody > tr > th.danger:hover,\n.table-hover > tbody > tr.danger:hover > td,\n.table-hover > tbody > tr:hover > .danger,\n.table-hover > tbody > tr.danger:hover > th {\n  background-color: #ebcccc;\n}\n.table-responsive {\n  min-height: .01%;\n  overflow-x: auto;\n}\n@media screen and (max-width: 767px) {\n  .table-responsive {\n    width: 100%;\n    margin-bottom: 15px;\n    overflow-y: hidden;\n    -ms-overflow-style: -ms-autohiding-scrollbar;\n    border: 1px solid #ddd;\n  }\n  .table-responsive > .table {\n    margin-bottom: 0;\n  }\n  .table-responsive > .table > thead > tr > th,\n  .table-responsive > .table > tbody > tr > th,\n  .table-responsive > .table > tfoot > tr > th,\n  .table-responsive > .table > thead > tr > td,\n  .table-responsive > .table > tbody > tr > td,\n  .table-responsive > .table > tfoot > tr > td {\n    white-space: nowrap;\n  }\n  .table-responsive > .table-bordered {\n    border: 0;\n  }\n  .table-responsive > .table-bordered > thead > tr > th:first-child,\n  .table-responsive > .table-bordered > tbody > tr > th:first-child,\n  .table-responsive > .table-bordered > tfoot > tr > th:first-child,\n  .table-responsive > .table-bordered > thead > tr > td:first-child,\n  .table-responsive > .table-bordered > tbody > tr > td:first-child,\n  .table-responsive > .table-bordered > tfoot > tr > td:first-child {\n    border-left: 0;\n  }\n  .table-responsive > .table-bordered > thead > tr > th:last-child,\n  .table-responsive > .table-bordered > tbody > tr > th:last-child,\n  .table-responsive > .table-bordered > tfoot > tr > th:last-child,\n  .table-responsive > .table-bordered > thead > tr > td:last-child,\n  .table-responsive > .table-bordered > tbody > tr > td:last-child,\n  .table-responsive > .table-bordered > tfoot > tr > td:last-child {\n    border-right: 0;\n  }\n  .table-responsive > .table-bordered > tbody > tr:last-child > th,\n  .table-responsive > .table-bordered > tfoot > tr:last-child > th,\n  .table-responsive > .table-bordered > tbody > tr:last-child > td,\n  .table-responsive > .table-bordered > tfoot > tr:last-child > td {\n    border-bottom: 0;\n  }\n}\nfieldset {\n  min-width: 0;\n  padding: 0;\n  margin: 0;\n  border: 0;\n}\nlegend {\n  display: block;\n  width: 100%;\n  padding: 0;\n  margin-bottom: 20px;\n  font-size: 21px;\n  line-height: inherit;\n  color: #333;\n  border: 0;\n  border-bottom: 1px solid #e5e5e5;\n}\nlabel {\n  display: inline-block;\n  max-width: 100%;\n  margin-bottom: 5px;\n  font-weight: bold;\n}\ninput[type="search"] {\n  -webkit-box-sizing: border-box;\n     -moz-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[type="radio"],\ninput[type="checkbox"] {\n  margin: 4px 0 0;\n  margin-top: 1px \\9;\n  line-height: normal;\n}\ninput[type="file"] {\n  display: block;\n}\ninput[type="range"] {\n  display: block;\n  width: 100%;\n}\nselect[multiple],\nselect[size] {\n  height: auto;\n}\ninput[type="file"]:focus,\ninput[type="radio"]:focus,\ninput[type="checkbox"]:focus {\n  outline: 5px auto -webkit-focus-ring-color;\n  outline-offset: -2px;\n}\noutput {\n  display: block;\n  padding-top: 7px;\n  font-size: 14px;\n  line-height: 1.42857143;\n  color: #555;\n}\n.form-control {\n  display: block;\n  width: 100%;\n  height: 34px;\n  padding: 6px 12px;\n  font-size: 14px;\n  line-height: 1.42857143;\n  color: #555;\n  background-color: #fff;\n  background-image: none;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075);\n          box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075);\n  -webkit-transition: border-color ease-in-out .15s, -webkit-box-shadow ease-in-out .15s;\n       -o-transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;\n          transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;\n}\n.form-control:focus {\n  border-color: #66afe9;\n  outline: 0;\n  -webkit-box-shadow: inset 0 1px 1px rgba(0,0,0,.075), 0 0 8px rgba(102, 175, 233, .6);\n          box-shadow: inset 0 1px 1px rgba(0,0,0,.075), 0 0 8px rgba(102, 175, 233, .6);\n}\n.form-control::-moz-placeholder {\n  color: #999;\n  opacity: 1;\n}\n.form-control:-ms-input-placeholder {\n  color: #999;\n}\n.form-control::-webkit-input-placeholder {\n  color: #999;\n}\n.form-control::-ms-expand {\n  background-color: transparent;\n  border: 0;\n}\n.form-control[disabled],\n.form-control[readonly],\nfieldset[disabled] .form-control {\n  background-color: #eee;\n  opacity: 1;\n}\n.form-control[disabled],\nfieldset[disabled] .form-control {\n  cursor: not-allowed;\n}\ntextarea.form-control {\n  height: auto;\n}\ninput[type="search"] {\n  -webkit-appearance: none;\n}\n@media screen and (-webkit-min-device-pixel-ratio: 0) {\n  input[type="date"].form-control,\n  input[type="time"].form-control,\n  input[type="datetime-local"].form-control,\n  input[type="month"].form-control {\n    line-height: 34px;\n  }\n  input[type="date"].input-sm,\n  input[type="time"].input-sm,\n  input[type="datetime-local"].input-sm,\n  input[type="month"].input-sm,\n  .input-group-sm input[type="date"],\n  .input-group-sm input[type="time"],\n  .input-group-sm input[type="datetime-local"],\n  .input-group-sm input[type="month"] {\n    line-height: 30px;\n  }\n  input[type="date"].input-lg,\n  input[type="time"].input-lg,\n  input[type="datetime-local"].input-lg,\n  input[type="month"].input-lg,\n  .input-group-lg input[type="date"],\n  .input-group-lg input[type="time"],\n  .input-group-lg input[type="datetime-local"],\n  .input-group-lg input[type="month"] {\n    line-height: 46px;\n  }\n}\n.form-group {\n  margin-bottom: 15px;\n}\n.radio,\n.checkbox {\n  position: relative;\n  display: block;\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n.radio label,\n.checkbox label {\n  min-height: 20px;\n  padding-left: 20px;\n  margin-bottom: 0;\n  font-weight: normal;\n  cursor: pointer;\n}\n.radio input[type="radio"],\n.radio-inline input[type="radio"],\n.checkbox input[type="checkbox"],\n.checkbox-inline input[type="checkbox"] {\n  position: absolute;\n  margin-top: 4px \\9;\n  margin-left: -20px;\n}\n.radio + .radio,\n.checkbox + .checkbox {\n  margin-top: -5px;\n}\n.radio-inline,\n.checkbox-inline {\n  position: relative;\n  display: inline-block;\n  padding-left: 20px;\n  margin-bottom: 0;\n  font-weight: normal;\n  vertical-align: middle;\n  cursor: pointer;\n}\n.radio-inline + .radio-inline,\n.checkbox-inline + .checkbox-inline {\n  margin-top: 0;\n  margin-left: 10px;\n}\ninput[type="radio"][disabled],\ninput[type="checkbox"][disabled],\ninput[type="radio"].disabled,\ninput[type="checkbox"].disabled,\nfieldset[disabled] input[type="radio"],\nfieldset[disabled] input[type="checkbox"] {\n  cursor: not-allowed;\n}\n.radio-inline.disabled,\n.checkbox-inline.disabled,\nfieldset[disabled] .radio-inline,\nfieldset[disabled] .checkbox-inline {\n  cursor: not-allowed;\n}\n.radio.disabled label,\n.checkbox.disabled label,\nfieldset[disabled] .radio label,\nfieldset[disabled] .checkbox label {\n  cursor: not-allowed;\n}\n.form-control-static {\n  min-height: 34px;\n  padding-top: 7px;\n  padding-bottom: 7px;\n  margin-bottom: 0;\n}\n.form-control-static.input-lg,\n.form-control-static.input-sm {\n  padding-right: 0;\n  padding-left: 0;\n}\n.input-sm {\n  height: 30px;\n  padding: 5px 10px;\n  font-size: 12px;\n  line-height: 1.5;\n  border-radius: 3px;\n}\nselect.input-sm {\n  height: 30px;\n  line-height: 30px;\n}\ntextarea.input-sm,\nselect[multiple].input-sm {\n  height: auto;\n}\n.form-group-sm .form-control {\n  height: 30px;\n  padding: 5px 10px;\n  font-size: 12px;\n  line-height: 1.5;\n  border-radius: 3px;\n}\n.form-group-sm select.form-control {\n  height: 30px;\n  line-height: 30px;\n}\n.form-group-sm textarea.form-control,\n.form-group-sm select[multiple].form-control {\n  height: auto;\n}\n.form-group-sm .form-control-static {\n  height: 30px;\n  min-height: 32px;\n  padding: 6px 10px;\n  font-size: 12px;\n  line-height: 1.5;\n}\n.input-lg {\n  height: 46px;\n  padding: 10px 16px;\n  font-size: 18px;\n  line-height: 1.3333333;\n  border-radius: 6px;\n}\nselect.input-lg {\n  height: 46px;\n  line-height: 46px;\n}\ntextarea.input-lg,\nselect[multiple].input-lg {\n  height: auto;\n}\n.form-group-lg .form-control {\n  height: 46px;\n  padding: 10px 16px;\n  font-size: 18px;\n  line-height: 1.3333333;\n  border-radius: 6px;\n}\n.form-group-lg select.form-control {\n  height: 46px;\n  line-height: 46px;\n}\n.form-group-lg textarea.form-control,\n.form-group-lg select[multiple].form-control {\n  height: auto;\n}\n.form-group-lg .form-control-static {\n  height: 46px;\n  min-height: 38px;\n  padding: 11px 16px;\n  font-size: 18px;\n  line-height: 1.3333333;\n}\n.has-feedback {\n  position: relative;\n}\n.has-feedback .form-control {\n  padding-right: 42.5px;\n}\n.form-control-feedback {\n  position: absolute;\n  top: 0;\n  right: 0;\n  z-index: 2;\n  display: block;\n  width: 34px;\n  height: 34px;\n  line-height: 34px;\n  text-align: center;\n  pointer-events: none;\n}\n.input-lg + .form-control-feedback,\n.input-group-lg + .form-control-feedback,\n.form-group-lg .form-control + .form-control-feedback {\n  width: 46px;\n  height: 46px;\n  line-height: 46px;\n}\n.input-sm + .form-control-feedback,\n.input-group-sm + .form-control-feedback,\n.form-group-sm .form-control + .form-control-feedback {\n  width: 30px;\n  height: 30px;\n  line-height: 30px;\n}\n.has-success .help-block,\n.has-success .control-label,\n.has-success .radio,\n.has-success .checkbox,\n.has-success .radio-inline,\n.has-success .checkbox-inline,\n.has-success.radio label,\n.has-success.checkbox label,\n.has-success.radio-inline label,\n.has-success.checkbox-inline label {\n  color: #3c763d;\n}\n.has-success .form-control {\n  border-color: #3c763d;\n  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075);\n          box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075);\n}\n.has-success .form-control:focus {\n  border-color: #2b542c;\n  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 6px #67b168;\n          box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 6px #67b168;\n}\n.has-success .input-group-addon {\n  color: #3c763d;\n  background-color: #dff0d8;\n  border-color: #3c763d;\n}\n.has-success .form-control-feedback {\n  color: #3c763d;\n}\n.has-warning .help-block,\n.has-warning .control-label,\n.has-warning .radio,\n.has-warning .checkbox,\n.has-warning .radio-inline,\n.has-warning .checkbox-inline,\n.has-warning.radio label,\n.has-warning.checkbox label,\n.has-warning.radio-inline label,\n.has-warning.checkbox-inline label {\n  color: #8a6d3b;\n}\n.has-warning .form-control {\n  border-color: #8a6d3b;\n  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075);\n          box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075);\n}\n.has-warning .form-control:focus {\n  border-color: #66512c;\n  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 6px #c0a16b;\n          box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 6px #c0a16b;\n}\n.has-warning .input-group-addon {\n  color: #8a6d3b;\n  background-color: #fcf8e3;\n  border-color: #8a6d3b;\n}\n.has-warning .form-control-feedback {\n  color: #8a6d3b;\n}\n.has-error .help-block,\n.has-error .control-label,\n.has-error .radio,\n.has-error .checkbox,\n.has-error .radio-inline,\n.has-error .checkbox-inline,\n.has-error.radio label,\n.has-error.checkbox label,\n.has-error.radio-inline label,\n.has-error.checkbox-inline label {\n  color: #a94442;\n}\n.has-error .form-control {\n  border-color: #a94442;\n  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075);\n          box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075);\n}\n.has-error .form-control:focus {\n  border-color: #843534;\n  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 6px #ce8483;\n          box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 6px #ce8483;\n}\n.has-error .input-group-addon {\n  color: #a94442;\n  background-color: #f2dede;\n  border-color: #a94442;\n}\n.has-error .form-control-feedback {\n  color: #a94442;\n}\n.has-feedback label ~ .form-control-feedback {\n  top: 25px;\n}\n.has-feedback label.sr-only ~ .form-control-feedback {\n  top: 0;\n}\n.help-block {\n  display: block;\n  margin-top: 5px;\n  margin-bottom: 10px;\n  color: #737373;\n}\n@media (min-width: 768px) {\n  .form-inline .form-group {\n    display: inline-block;\n    margin-bottom: 0;\n    vertical-align: middle;\n  }\n  .form-inline .form-control {\n    display: inline-block;\n    width: auto;\n    vertical-align: middle;\n  }\n  .form-inline .form-control-static {\n    display: inline-block;\n  }\n  .form-inline .input-group {\n    display: inline-table;\n    vertical-align: middle;\n  }\n  .form-inline .input-group .input-group-addon,\n  .form-inline .input-group .input-group-btn,\n  .form-inline .input-group .form-control {\n    width: auto;\n  }\n  .form-inline .input-group > .form-control {\n    width: 100%;\n  }\n  .form-inline .control-label {\n    margin-bottom: 0;\n    vertical-align: middle;\n  }\n  .form-inline .radio,\n  .form-inline .checkbox {\n    display: inline-block;\n    margin-top: 0;\n    margin-bottom: 0;\n    vertical-align: middle;\n  }\n  .form-inline .radio label,\n  .form-inline .checkbox label {\n    padding-left: 0;\n  }\n  .form-inline .radio input[type="radio"],\n  .form-inline .checkbox input[type="checkbox"] {\n    position: relative;\n    margin-left: 0;\n  }\n  .form-inline .has-feedback .form-control-feedback {\n    top: 0;\n  }\n}\n.form-horizontal .radio,\n.form-horizontal .checkbox,\n.form-horizontal .radio-inline,\n.form-horizontal .checkbox-inline {\n  padding-top: 7px;\n  margin-top: 0;\n  margin-bottom: 0;\n}\n.form-horizontal .radio,\n.form-horizontal .checkbox {\n  min-height: 27px;\n}\n.form-horizontal .form-group {\n  margin-right: -15px;\n  margin-left: -15px;\n}\n@media (min-width: 768px) {\n  .form-horizontal .control-label {\n    padding-top: 7px;\n    margin-bottom: 0;\n    text-align: right;\n  }\n}\n.form-horizontal .has-feedback .form-control-feedback {\n  right: 15px;\n}\n@media (min-width: 768px) {\n  .form-horizontal .form-group-lg .control-label {\n    padding-top: 11px;\n    font-size: 18px;\n  }\n}\n@media (min-width: 768px) {\n  .form-horizontal .form-group-sm .control-label {\n    padding-top: 6px;\n    font-size: 12px;\n  }\n}\n.btn {\n  display: inline-block;\n  padding: 6px 12px;\n  margin-bottom: 0;\n  font-size: 14px;\n  font-weight: normal;\n  line-height: 1.42857143;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: middle;\n  -ms-touch-action: manipulation;\n      touch-action: manipulation;\n  cursor: pointer;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  background-image: none;\n  border: 1px solid transparent;\n  border-radius: 4px;\n}\n.btn:focus,\n.btn:active:focus,\n.btn.active:focus,\n.btn.focus,\n.btn:active.focus,\n.btn.active.focus {\n  outline: 5px auto -webkit-focus-ring-color;\n  outline-offset: -2px;\n}\n.btn:hover,\n.btn:focus,\n.btn.focus {\n  color: #333;\n  text-decoration: none;\n}\n.btn:active,\n.btn.active {\n  background-image: none;\n  outline: 0;\n  -webkit-box-shadow: inset 0 3px 5px rgba(0, 0, 0, .125);\n          box-shadow: inset 0 3px 5px rgba(0, 0, 0, .125);\n}\n.btn.disabled,\n.btn[disabled],\nfieldset[disabled] .btn {\n  cursor: not-allowed;\n  filter: alpha(opacity=65);\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  opacity: .65;\n}\na.btn.disabled,\nfieldset[disabled] a.btn {\n  pointer-events: none;\n}\n.btn-default {\n  color: #333;\n  background-color: #fff;\n  border-color: #ccc;\n}\n.btn-default:focus,\n.btn-default.focus {\n  color: #333;\n  background-color: #e6e6e6;\n  border-color: #8c8c8c;\n}\n.btn-default:hover {\n  color: #333;\n  background-color: #e6e6e6;\n  border-color: #adadad;\n}\n.btn-default:active,\n.btn-default.active,\n.open > .dropdown-toggle.btn-default {\n  color: #333;\n  background-color: #e6e6e6;\n  border-color: #adadad;\n}\n.btn-default:active:hover,\n.btn-default.active:hover,\n.open > .dropdown-toggle.btn-default:hover,\n.btn-default:active:focus,\n.btn-default.active:focus,\n.open > .dropdown-toggle.btn-default:focus,\n.btn-default:active.focus,\n.btn-default.active.focus,\n.open > .dropdown-toggle.btn-default.focus {\n  color: #333;\n  background-color: #d4d4d4;\n  border-color: #8c8c8c;\n}\n.btn-default:active,\n.btn-default.active,\n.open > .dropdown-toggle.btn-default {\n  background-image: none;\n}\n.btn-default.disabled:hover,\n.btn-default[disabled]:hover,\nfieldset[disabled] .btn-default:hover,\n.btn-default.disabled:focus,\n.btn-default[disabled]:focus,\nfieldset[disabled] .btn-default:focus,\n.btn-default.disabled.focus,\n.btn-default[disabled].focus,\nfieldset[disabled] .btn-default.focus {\n  background-color: #fff;\n  border-color: #ccc;\n}\n.btn-default .badge {\n  color: #fff;\n  background-color: #333;\n}\n.btn-primary {\n  color: #fff;\n  background-color: #337ab7;\n  border-color: #2e6da4;\n}\n.btn-primary:focus,\n.btn-primary.focus {\n  color: #fff;\n  background-color: #286090;\n  border-color: #122b40;\n}\n.btn-primary:hover {\n  color: #fff;\n  background-color: #286090;\n  border-color: #204d74;\n}\n.btn-primary:active,\n.btn-primary.active,\n.open > .dropdown-toggle.btn-primary {\n  color: #fff;\n  background-color: #286090;\n  border-color: #204d74;\n}\n.btn-primary:active:hover,\n.btn-primary.active:hover,\n.open > .dropdown-toggle.btn-primary:hover,\n.btn-primary:active:focus,\n.btn-primary.active:focus,\n.open > .dropdown-toggle.btn-primary:focus,\n.btn-primary:active.focus,\n.btn-primary.active.focus,\n.open > .dropdown-toggle.btn-primary.focus {\n  color: #fff;\n  background-color: #204d74;\n  border-color: #122b40;\n}\n.btn-primary:active,\n.btn-primary.active,\n.open > .dropdown-toggle.btn-primary {\n  background-image: none;\n}\n.btn-primary.disabled:hover,\n.btn-primary[disabled]:hover,\nfieldset[disabled] .btn-primary:hover,\n.btn-primary.disabled:focus,\n.btn-primary[disabled]:focus,\nfieldset[disabled] .btn-primary:focus,\n.btn-primary.disabled.focus,\n.btn-primary[disabled].focus,\nfieldset[disabled] .btn-primary.focus {\n  background-color: #337ab7;\n  border-color: #2e6da4;\n}\n.btn-primary .badge {\n  color: #337ab7;\n  background-color: #fff;\n}\n.btn-success {\n  color: #fff;\n  background-color: #5cb85c;\n  border-color: #4cae4c;\n}\n.btn-success:focus,\n.btn-success.focus {\n  color: #fff;\n  background-color: #449d44;\n  border-color: #255625;\n}\n.btn-success:hover {\n  color: #fff;\n  background-color: #449d44;\n  border-color: #398439;\n}\n.btn-success:active,\n.btn-success.active,\n.open > .dropdown-toggle.btn-success {\n  color: #fff;\n  background-color: #449d44;\n  border-color: #398439;\n}\n.btn-success:active:hover,\n.btn-success.active:hover,\n.open > .dropdown-toggle.btn-success:hover,\n.btn-success:active:focus,\n.btn-success.active:focus,\n.open > .dropdown-toggle.btn-success:focus,\n.btn-success:active.focus,\n.btn-success.active.focus,\n.open > .dropdown-toggle.btn-success.focus {\n  color: #fff;\n  background-color: #398439;\n  border-color: #255625;\n}\n.btn-success:active,\n.btn-success.active,\n.open > .dropdown-toggle.btn-success {\n  background-image: none;\n}\n.btn-success.disabled:hover,\n.btn-success[disabled]:hover,\nfieldset[disabled] .btn-success:hover,\n.btn-success.disabled:focus,\n.btn-success[disabled]:focus,\nfieldset[disabled] .btn-success:focus,\n.btn-success.disabled.focus,\n.btn-success[disabled].focus,\nfieldset[disabled] .btn-success.focus {\n  background-color: #5cb85c;\n  border-color: #4cae4c;\n}\n.btn-success .badge {\n  color: #5cb85c;\n  background-color: #fff;\n}\n.btn-info {\n  color: #fff;\n  background-color: #5bc0de;\n  border-color: #46b8da;\n}\n.btn-info:focus,\n.btn-info.focus {\n  color: #fff;\n  background-color: #31b0d5;\n  border-color: #1b6d85;\n}\n.btn-info:hover {\n  color: #fff;\n  background-color: #31b0d5;\n  border-color: #269abc;\n}\n.btn-info:active,\n.btn-info.active,\n.open > .dropdown-toggle.btn-info {\n  color: #fff;\n  background-color: #31b0d5;\n  border-color: #269abc;\n}\n.btn-info:active:hover,\n.btn-info.active:hover,\n.open > .dropdown-toggle.btn-info:hover,\n.btn-info:active:focus,\n.btn-info.active:focus,\n.open > .dropdown-toggle.btn-info:focus,\n.btn-info:active.focus,\n.btn-info.active.focus,\n.open > .dropdown-toggle.btn-info.focus {\n  color: #fff;\n  background-color: #269abc;\n  border-color: #1b6d85;\n}\n.btn-info:active,\n.btn-info.active,\n.open > .dropdown-toggle.btn-info {\n  background-image: none;\n}\n.btn-info.disabled:hover,\n.btn-info[disabled]:hover,\nfieldset[disabled] .btn-info:hover,\n.btn-info.disabled:focus,\n.btn-info[disabled]:focus,\nfieldset[disabled] .btn-info:focus,\n.btn-info.disabled.focus,\n.btn-info[disabled].focus,\nfieldset[disabled] .btn-info.focus {\n  background-color: #5bc0de;\n  border-color: #46b8da;\n}\n.btn-info .badge {\n  color: #5bc0de;\n  background-color: #fff;\n}\n.btn-warning {\n  color: #fff;\n  background-color: #f0ad4e;\n  border-color: #eea236;\n}\n.btn-warning:focus,\n.btn-warning.focus {\n  color: #fff;\n  background-color: #ec971f;\n  border-color: #985f0d;\n}\n.btn-warning:hover {\n  color: #fff;\n  background-color: #ec971f;\n  border-color: #d58512;\n}\n.btn-warning:active,\n.btn-warning.active,\n.open > .dropdown-toggle.btn-warning {\n  color: #fff;\n  background-color: #ec971f;\n  border-color: #d58512;\n}\n.btn-warning:active:hover,\n.btn-warning.active:hover,\n.open > .dropdown-toggle.btn-warning:hover,\n.btn-warning:active:focus,\n.btn-warning.active:focus,\n.open > .dropdown-toggle.btn-warning:focus,\n.btn-warning:active.focus,\n.btn-warning.active.focus,\n.open > .dropdown-toggle.btn-warning.focus {\n  color: #fff;\n  background-color: #d58512;\n  border-color: #985f0d;\n}\n.btn-warning:active,\n.btn-warning.active,\n.open > .dropdown-toggle.btn-warning {\n  background-image: none;\n}\n.btn-warning.disabled:hover,\n.btn-warning[disabled]:hover,\nfieldset[disabled] .btn-warning:hover,\n.btn-warning.disabled:focus,\n.btn-warning[disabled]:focus,\nfieldset[disabled] .btn-warning:focus,\n.btn-warning.disabled.focus,\n.btn-warning[disabled].focus,\nfieldset[disabled] .btn-warning.focus {\n  background-color: #f0ad4e;\n  border-color: #eea236;\n}\n.btn-warning .badge {\n  color: #f0ad4e;\n  background-color: #fff;\n}\n.btn-danger {\n  color: #fff;\n  background-color: #d9534f;\n  border-color: #d43f3a;\n}\n.btn-danger:focus,\n.btn-danger.focus {\n  color: #fff;\n  background-color: #c9302c;\n  border-color: #761c19;\n}\n.btn-danger:hover {\n  color: #fff;\n  background-color: #c9302c;\n  border-color: #ac2925;\n}\n.btn-danger:active,\n.btn-danger.active,\n.open > .dropdown-toggle.btn-danger {\n  color: #fff;\n  background-color: #c9302c;\n  border-color: #ac2925;\n}\n.btn-danger:active:hover,\n.btn-danger.active:hover,\n.open > .dropdown-toggle.btn-danger:hover,\n.btn-danger:active:focus,\n.btn-danger.active:focus,\n.open > .dropdown-toggle.btn-danger:focus,\n.btn-danger:active.focus,\n.btn-danger.active.focus,\n.open > .dropdown-toggle.btn-danger.focus {\n  color: #fff;\n  background-color: #ac2925;\n  border-color: #761c19;\n}\n.btn-danger:active,\n.btn-danger.active,\n.open > .dropdown-toggle.btn-danger {\n  background-image: none;\n}\n.btn-danger.disabled:hover,\n.btn-danger[disabled]:hover,\nfieldset[disabled] .btn-danger:hover,\n.btn-danger.disabled:focus,\n.btn-danger[disabled]:focus,\nfieldset[disabled] .btn-danger:focus,\n.btn-danger.disabled.focus,\n.btn-danger[disabled].focus,\nfieldset[disabled] .btn-danger.focus {\n  background-color: #d9534f;\n  border-color: #d43f3a;\n}\n.btn-danger .badge {\n  color: #d9534f;\n  background-color: #fff;\n}\n.btn-link {\n  font-weight: normal;\n  color: #337ab7;\n  border-radius: 0;\n}\n.btn-link,\n.btn-link:active,\n.btn-link.active,\n.btn-link[disabled],\nfieldset[disabled] .btn-link {\n  background-color: transparent;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n.btn-link,\n.btn-link:hover,\n.btn-link:focus,\n.btn-link:active {\n  border-color: transparent;\n}\n.btn-link:hover,\n.btn-link:focus {\n  color: #23527c;\n  text-decoration: underline;\n  background-color: transparent;\n}\n.btn-link[disabled]:hover,\nfieldset[disabled] .btn-link:hover,\n.btn-link[disabled]:focus,\nfieldset[disabled] .btn-link:focus {\n  color: #777;\n  text-decoration: none;\n}\n.btn-lg,\n.btn-group-lg > .btn {\n  padding: 10px 16px;\n  font-size: 18px;\n  line-height: 1.3333333;\n  border-radius: 6px;\n}\n.btn-sm,\n.btn-group-sm > .btn {\n  padding: 5px 10px;\n  font-size: 12px;\n  line-height: 1.5;\n  border-radius: 3px;\n}\n.btn-xs,\n.btn-group-xs > .btn {\n  padding: 1px 5px;\n  font-size: 12px;\n  line-height: 1.5;\n  border-radius: 3px;\n}\n.btn-block {\n  display: block;\n  width: 100%;\n}\n.btn-block + .btn-block {\n  margin-top: 5px;\n}\ninput[type="submit"].btn-block,\ninput[type="reset"].btn-block,\ninput[type="button"].btn-block {\n  width: 100%;\n}\n.fade {\n  opacity: 0;\n  -webkit-transition: opacity .15s linear;\n       -o-transition: opacity .15s linear;\n          transition: opacity .15s linear;\n}\n.fade.in {\n  opacity: 1;\n}\n.collapse {\n  display: none;\n}\n.collapse.in {\n  display: block;\n}\ntr.collapse.in {\n  display: table-row;\n}\ntbody.collapse.in {\n  display: table-row-group;\n}\n.collapsing {\n  position: relative;\n  height: 0;\n  overflow: hidden;\n  -webkit-transition-timing-function: ease;\n       -o-transition-timing-function: ease;\n          transition-timing-function: ease;\n  -webkit-transition-duration: .35s;\n       -o-transition-duration: .35s;\n          transition-duration: .35s;\n  -webkit-transition-property: height, visibility;\n       -o-transition-property: height, visibility;\n          transition-property: height, visibility;\n}\n.caret {\n  display: inline-block;\n  width: 0;\n  height: 0;\n  margin-left: 2px;\n  vertical-align: middle;\n  border-top: 4px dashed;\n  border-top: 4px solid \\9;\n  border-right: 4px solid transparent;\n  border-left: 4px solid transparent;\n}\n.dropup,\n.dropdown {\n  position: relative;\n}\n.dropdown-toggle:focus {\n  outline: 0;\n}\n.dropdown-menu {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  z-index: 1000;\n  display: none;\n  float: left;\n  min-width: 160px;\n  padding: 5px 0;\n  margin: 2px 0 0;\n  font-size: 14px;\n  text-align: left;\n  list-style: none;\n  background-color: #fff;\n  -webkit-background-clip: padding-box;\n          background-clip: padding-box;\n  border: 1px solid #ccc;\n  border: 1px solid rgba(0, 0, 0, .15);\n  border-radius: 4px;\n  -webkit-box-shadow: 0 6px 12px rgba(0, 0, 0, .175);\n          box-shadow: 0 6px 12px rgba(0, 0, 0, .175);\n}\n.dropdown-menu.pull-right {\n  right: 0;\n  left: auto;\n}\n.dropdown-menu .divider {\n  height: 1px;\n  margin: 9px 0;\n  overflow: hidden;\n  background-color: #e5e5e5;\n}\n.dropdown-menu > li > a {\n  display: block;\n  padding: 3px 20px;\n  clear: both;\n  font-weight: normal;\n  line-height: 1.42857143;\n  color: #333;\n  white-space: nowrap;\n}\n.dropdown-menu > li > a:hover,\n.dropdown-menu > li > a:focus {\n  color: #262626;\n  text-decoration: none;\n  background-color: #f5f5f5;\n}\n.dropdown-menu > .active > a,\n.dropdown-menu > .active > a:hover,\n.dropdown-menu > .active > a:focus {\n  color: #fff;\n  text-decoration: none;\n  background-color: #337ab7;\n  outline: 0;\n}\n.dropdown-menu > .disabled > a,\n.dropdown-menu > .disabled > a:hover,\n.dropdown-menu > .disabled > a:focus {\n  color: #777;\n}\n.dropdown-menu > .disabled > a:hover,\n.dropdown-menu > .disabled > a:focus {\n  text-decoration: none;\n  cursor: not-allowed;\n  background-color: transparent;\n  background-image: none;\n  filter: progid:DXImageTransform.Microsoft.gradient(enabled = false);\n}\n.open > .dropdown-menu {\n  display: block;\n}\n.open > a {\n  outline: 0;\n}\n.dropdown-menu-right {\n  right: 0;\n  left: auto;\n}\n.dropdown-menu-left {\n  right: auto;\n  left: 0;\n}\n.dropdown-header {\n  display: block;\n  padding: 3px 20px;\n  font-size: 12px;\n  line-height: 1.42857143;\n  color: #777;\n  white-space: nowrap;\n}\n.dropdown-backdrop {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 990;\n}\n.pull-right > .dropdown-menu {\n  right: 0;\n  left: auto;\n}\n.dropup .caret,\n.navbar-fixed-bottom .dropdown .caret {\n  content: "";\n  border-top: 0;\n  border-bottom: 4px dashed;\n  border-bottom: 4px solid \\9;\n}\n.dropup .dropdown-menu,\n.navbar-fixed-bottom .dropdown .dropdown-menu {\n  top: auto;\n  bottom: 100%;\n  margin-bottom: 2px;\n}\n@media (min-width: 768px) {\n  .navbar-right .dropdown-menu {\n    right: 0;\n    left: auto;\n  }\n  .navbar-right .dropdown-menu-left {\n    right: auto;\n    left: 0;\n  }\n}\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-block;\n  vertical-align: middle;\n}\n.btn-group > .btn,\n.btn-group-vertical > .btn {\n  position: relative;\n  float: left;\n}\n.btn-group > .btn:hover,\n.btn-group-vertical > .btn:hover,\n.btn-group > .btn:focus,\n.btn-group-vertical > .btn:focus,\n.btn-group > .btn:active,\n.btn-group-vertical > .btn:active,\n.btn-group > .btn.active,\n.btn-group-vertical > .btn.active {\n  z-index: 2;\n}\n.btn-group .btn + .btn,\n.btn-group .btn + .btn-group,\n.btn-group .btn-group + .btn,\n.btn-group .btn-group + .btn-group {\n  margin-left: -1px;\n}\n.btn-toolbar {\n  margin-left: -5px;\n}\n.btn-toolbar .btn,\n.btn-toolbar .btn-group,\n.btn-toolbar .input-group {\n  float: left;\n}\n.btn-toolbar > .btn,\n.btn-toolbar > .btn-group,\n.btn-toolbar > .input-group {\n  margin-left: 5px;\n}\n.btn-group > .btn:not(:first-child):not(:last-child):not(.dropdown-toggle) {\n  border-radius: 0;\n}\n.btn-group > .btn:first-child {\n  margin-left: 0;\n}\n.btn-group > .btn:first-child:not(:last-child):not(.dropdown-toggle) {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.btn-group > .btn:last-child:not(:first-child),\n.btn-group > .dropdown-toggle:not(:first-child) {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.btn-group > .btn-group {\n  float: left;\n}\n.btn-group > .btn-group:not(:first-child):not(:last-child) > .btn {\n  border-radius: 0;\n}\n.btn-group > .btn-group:first-child:not(:last-child) > .btn:last-child,\n.btn-group > .btn-group:first-child:not(:last-child) > .dropdown-toggle {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.btn-group > .btn-group:last-child:not(:first-child) > .btn:first-child {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.btn-group .dropdown-toggle:active,\n.btn-group.open .dropdown-toggle {\n  outline: 0;\n}\n.btn-group > .btn + .dropdown-toggle {\n  padding-right: 8px;\n  padding-left: 8px;\n}\n.btn-group > .btn-lg + .dropdown-toggle {\n  padding-right: 12px;\n  padding-left: 12px;\n}\n.btn-group.open .dropdown-toggle {\n  -webkit-box-shadow: inset 0 3px 5px rgba(0, 0, 0, .125);\n          box-shadow: inset 0 3px 5px rgba(0, 0, 0, .125);\n}\n.btn-group.open .dropdown-toggle.btn-link {\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n.btn .caret {\n  margin-left: 0;\n}\n.btn-lg .caret {\n  border-width: 5px 5px 0;\n  border-bottom-width: 0;\n}\n.dropup .btn-lg .caret {\n  border-width: 0 5px 5px;\n}\n.btn-group-vertical > .btn,\n.btn-group-vertical > .btn-group,\n.btn-group-vertical > .btn-group > .btn {\n  display: block;\n  float: none;\n  width: 100%;\n  max-width: 100%;\n}\n.btn-group-vertical > .btn-group > .btn {\n  float: none;\n}\n.btn-group-vertical > .btn + .btn,\n.btn-group-vertical > .btn + .btn-group,\n.btn-group-vertical > .btn-group + .btn,\n.btn-group-vertical > .btn-group + .btn-group {\n  margin-top: -1px;\n  margin-left: 0;\n}\n.btn-group-vertical > .btn:not(:first-child):not(:last-child) {\n  border-radius: 0;\n}\n.btn-group-vertical > .btn:first-child:not(:last-child) {\n  border-top-left-radius: 4px;\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.btn-group-vertical > .btn:last-child:not(:first-child) {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 4px;\n  border-bottom-left-radius: 4px;\n}\n.btn-group-vertical > .btn-group:not(:first-child):not(:last-child) > .btn {\n  border-radius: 0;\n}\n.btn-group-vertical > .btn-group:first-child:not(:last-child) > .btn:last-child,\n.btn-group-vertical > .btn-group:first-child:not(:last-child) > .dropdown-toggle {\n  border-bottom-right-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.btn-group-vertical > .btn-group:last-child:not(:first-child) > .btn:first-child {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n.btn-group-justified {\n  display: table;\n  width: 100%;\n  table-layout: fixed;\n  border-collapse: separate;\n}\n.btn-group-justified > .btn,\n.btn-group-justified > .btn-group {\n  display: table-cell;\n  float: none;\n  width: 1%;\n}\n.btn-group-justified > .btn-group .btn {\n  width: 100%;\n}\n.btn-group-justified > .btn-group .dropdown-menu {\n  left: auto;\n}\n[data-toggle="buttons"] > .btn input[type="radio"],\n[data-toggle="buttons"] > .btn-group > .btn input[type="radio"],\n[data-toggle="buttons"] > .btn input[type="checkbox"],\n[data-toggle="buttons"] > .btn-group > .btn input[type="checkbox"] {\n  position: absolute;\n  clip: rect(0, 0, 0, 0);\n  pointer-events: none;\n}\n.input-group {\n  position: relative;\n  display: table;\n  border-collapse: separate;\n}\n.input-group[class*="col-"] {\n  float: none;\n  padding-right: 0;\n  padding-left: 0;\n}\n.input-group .form-control {\n  position: relative;\n  z-index: 2;\n  float: left;\n  width: 100%;\n  margin-bottom: 0;\n}\n.input-group .form-control:focus {\n  z-index: 3;\n}\n.input-group-lg > .form-control,\n.input-group-lg > .input-group-addon,\n.input-group-lg > .input-group-btn > .btn {\n  height: 46px;\n  padding: 10px 16px;\n  font-size: 18px;\n  line-height: 1.3333333;\n  border-radius: 6px;\n}\nselect.input-group-lg > .form-control,\nselect.input-group-lg > .input-group-addon,\nselect.input-group-lg > .input-group-btn > .btn {\n  height: 46px;\n  line-height: 46px;\n}\ntextarea.input-group-lg > .form-control,\ntextarea.input-group-lg > .input-group-addon,\ntextarea.input-group-lg > .input-group-btn > .btn,\nselect[multiple].input-group-lg > .form-control,\nselect[multiple].input-group-lg > .input-group-addon,\nselect[multiple].input-group-lg > .input-group-btn > .btn {\n  height: auto;\n}\n.input-group-sm > .form-control,\n.input-group-sm > .input-group-addon,\n.input-group-sm > .input-group-btn > .btn {\n  height: 30px;\n  padding: 5px 10px;\n  font-size: 12px;\n  line-height: 1.5;\n  border-radius: 3px;\n}\nselect.input-group-sm > .form-control,\nselect.input-group-sm > .input-group-addon,\nselect.input-group-sm > .input-group-btn > .btn {\n  height: 30px;\n  line-height: 30px;\n}\ntextarea.input-group-sm > .form-control,\ntextarea.input-group-sm > .input-group-addon,\ntextarea.input-group-sm > .input-group-btn > .btn,\nselect[multiple].input-group-sm > .form-control,\nselect[multiple].input-group-sm > .input-group-addon,\nselect[multiple].input-group-sm > .input-group-btn > .btn {\n  height: auto;\n}\n.input-group-addon,\n.input-group-btn,\n.input-group .form-control {\n  display: table-cell;\n}\n.input-group-addon:not(:first-child):not(:last-child),\n.input-group-btn:not(:first-child):not(:last-child),\n.input-group .form-control:not(:first-child):not(:last-child) {\n  border-radius: 0;\n}\n.input-group-addon,\n.input-group-btn {\n  width: 1%;\n  white-space: nowrap;\n  vertical-align: middle;\n}\n.input-group-addon {\n  padding: 6px 12px;\n  font-size: 14px;\n  font-weight: normal;\n  line-height: 1;\n  color: #555;\n  text-align: center;\n  background-color: #eee;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\n.input-group-addon.input-sm {\n  padding: 5px 10px;\n  font-size: 12px;\n  border-radius: 3px;\n}\n.input-group-addon.input-lg {\n  padding: 10px 16px;\n  font-size: 18px;\n  border-radius: 6px;\n}\n.input-group-addon input[type="radio"],\n.input-group-addon input[type="checkbox"] {\n  margin-top: 0;\n}\n.input-group .form-control:first-child,\n.input-group-addon:first-child,\n.input-group-btn:first-child > .btn,\n.input-group-btn:first-child > .btn-group > .btn,\n.input-group-btn:first-child > .dropdown-toggle,\n.input-group-btn:last-child > .btn:not(:last-child):not(.dropdown-toggle),\n.input-group-btn:last-child > .btn-group:not(:last-child) > .btn {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.input-group-addon:first-child {\n  border-right: 0;\n}\n.input-group .form-control:last-child,\n.input-group-addon:last-child,\n.input-group-btn:last-child > .btn,\n.input-group-btn:last-child > .btn-group > .btn,\n.input-group-btn:last-child > .dropdown-toggle,\n.input-group-btn:first-child > .btn:not(:first-child),\n.input-group-btn:first-child > .btn-group:not(:first-child) > .btn {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.input-group-addon:last-child {\n  border-left: 0;\n}\n.input-group-btn {\n  position: relative;\n  font-size: 0;\n  white-space: nowrap;\n}\n.input-group-btn > .btn {\n  position: relative;\n}\n.input-group-btn > .btn + .btn {\n  margin-left: -1px;\n}\n.input-group-btn > .btn:hover,\n.input-group-btn > .btn:focus,\n.input-group-btn > .btn:active {\n  z-index: 2;\n}\n.input-group-btn:first-child > .btn,\n.input-group-btn:first-child > .btn-group {\n  margin-right: -1px;\n}\n.input-group-btn:last-child > .btn,\n.input-group-btn:last-child > .btn-group {\n  z-index: 2;\n  margin-left: -1px;\n}\n.nav {\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n.nav > li {\n  position: relative;\n  display: block;\n}\n.nav > li > a {\n  position: relative;\n  display: block;\n  padding: 10px 15px;\n}\n.nav > li > a:hover,\n.nav > li > a:focus {\n  text-decoration: none;\n  background-color: #eee;\n}\n.nav > li.disabled > a {\n  color: #777;\n}\n.nav > li.disabled > a:hover,\n.nav > li.disabled > a:focus {\n  color: #777;\n  text-decoration: none;\n  cursor: not-allowed;\n  background-color: transparent;\n}\n.nav .open > a,\n.nav .open > a:hover,\n.nav .open > a:focus {\n  background-color: #eee;\n  border-color: #337ab7;\n}\n.nav .nav-divider {\n  height: 1px;\n  margin: 9px 0;\n  overflow: hidden;\n  background-color: #e5e5e5;\n}\n.nav > li > a > img {\n  max-width: none;\n}\n.nav-tabs {\n  border-bottom: 1px solid #ddd;\n}\n.nav-tabs > li {\n  float: left;\n  margin-bottom: -1px;\n}\n.nav-tabs > li > a {\n  margin-right: 2px;\n  line-height: 1.42857143;\n  border: 1px solid transparent;\n  border-radius: 4px 4px 0 0;\n}\n.nav-tabs > li > a:hover {\n  border-color: #eee #eee #ddd;\n}\n.nav-tabs > li.active > a,\n.nav-tabs > li.active > a:hover,\n.nav-tabs > li.active > a:focus {\n  color: #555;\n  cursor: default;\n  background-color: #fff;\n  border: 1px solid #ddd;\n  border-bottom-color: transparent;\n}\n.nav-tabs.nav-justified {\n  width: 100%;\n  border-bottom: 0;\n}\n.nav-tabs.nav-justified > li {\n  float: none;\n}\n.nav-tabs.nav-justified > li > a {\n  margin-bottom: 5px;\n  text-align: center;\n}\n.nav-tabs.nav-justified > .dropdown .dropdown-menu {\n  top: auto;\n  left: auto;\n}\n@media (min-width: 768px) {\n  .nav-tabs.nav-justified > li {\n    display: table-cell;\n    width: 1%;\n  }\n  .nav-tabs.nav-justified > li > a {\n    margin-bottom: 0;\n  }\n}\n.nav-tabs.nav-justified > li > a {\n  margin-right: 0;\n  border-radius: 4px;\n}\n.nav-tabs.nav-justified > .active > a,\n.nav-tabs.nav-justified > .active > a:hover,\n.nav-tabs.nav-justified > .active > a:focus {\n  border: 1px solid #ddd;\n}\n@media (min-width: 768px) {\n  .nav-tabs.nav-justified > li > a {\n    border-bottom: 1px solid #ddd;\n    border-radius: 4px 4px 0 0;\n  }\n  .nav-tabs.nav-justified > .active > a,\n  .nav-tabs.nav-justified > .active > a:hover,\n  .nav-tabs.nav-justified > .active > a:focus {\n    border-bottom-color: #fff;\n  }\n}\n.nav-pills > li {\n  float: left;\n}\n.nav-pills > li > a {\n  border-radius: 4px;\n}\n.nav-pills > li + li {\n  margin-left: 2px;\n}\n.nav-pills > li.active > a,\n.nav-pills > li.active > a:hover,\n.nav-pills > li.active > a:focus {\n  color: #fff;\n  background-color: #337ab7;\n}\n.nav-stacked > li {\n  float: none;\n}\n.nav-stacked > li + li {\n  margin-top: 2px;\n  margin-left: 0;\n}\n.nav-justified {\n  width: 100%;\n}\n.nav-justified > li {\n  float: none;\n}\n.nav-justified > li > a {\n  margin-bottom: 5px;\n  text-align: center;\n}\n.nav-justified > .dropdown .dropdown-menu {\n  top: auto;\n  left: auto;\n}\n@media (min-width: 768px) {\n  .nav-justified > li {\n    display: table-cell;\n    width: 1%;\n  }\n  .nav-justified > li > a {\n    margin-bottom: 0;\n  }\n}\n.nav-tabs-justified {\n  border-bottom: 0;\n}\n.nav-tabs-justified > li > a {\n  margin-right: 0;\n  border-radius: 4px;\n}\n.nav-tabs-justified > .active > a,\n.nav-tabs-justified > .active > a:hover,\n.nav-tabs-justified > .active > a:focus {\n  border: 1px solid #ddd;\n}\n@media (min-width: 768px) {\n  .nav-tabs-justified > li > a {\n    border-bottom: 1px solid #ddd;\n    border-radius: 4px 4px 0 0;\n  }\n  .nav-tabs-justified > .active > a,\n  .nav-tabs-justified > .active > a:hover,\n  .nav-tabs-justified > .active > a:focus {\n    border-bottom-color: #fff;\n  }\n}\n.tab-content > .tab-pane {\n  display: none;\n}\n.tab-content > .active {\n  display: block;\n}\n.nav-tabs .dropdown-menu {\n  margin-top: -1px;\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n.navbar {\n  position: relative;\n  min-height: 50px;\n  margin-bottom: 20px;\n  border: 1px solid transparent;\n}\n@media (min-width: 768px) {\n  .navbar {\n    border-radius: 4px;\n  }\n}\n@media (min-width: 768px) {\n  .navbar-header {\n    float: left;\n  }\n}\n.navbar-collapse {\n  padding-right: 15px;\n  padding-left: 15px;\n  overflow-x: visible;\n  -webkit-overflow-scrolling: touch;\n  border-top: 1px solid transparent;\n  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, .1);\n          box-shadow: inset 0 1px 0 rgba(255, 255, 255, .1);\n}\n.navbar-collapse.in {\n  overflow-y: auto;\n}\n@media (min-width: 768px) {\n  .navbar-collapse {\n    width: auto;\n    border-top: 0;\n    -webkit-box-shadow: none;\n            box-shadow: none;\n  }\n  .navbar-collapse.collapse {\n    display: block !important;\n    height: auto !important;\n    padding-bottom: 0;\n    overflow: visible !important;\n  }\n  .navbar-collapse.in {\n    overflow-y: visible;\n  }\n  .navbar-fixed-top .navbar-collapse,\n  .navbar-static-top .navbar-collapse,\n  .navbar-fixed-bottom .navbar-collapse {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n.navbar-fixed-top .navbar-collapse,\n.navbar-fixed-bottom .navbar-collapse {\n  max-height: 340px;\n}\n@media (max-device-width: 480px) and (orientation: landscape) {\n  .navbar-fixed-top .navbar-collapse,\n  .navbar-fixed-bottom .navbar-collapse {\n    max-height: 200px;\n  }\n}\n.container > .navbar-header,\n.container-fluid > .navbar-header,\n.container > .navbar-collapse,\n.container-fluid > .navbar-collapse {\n  margin-right: -15px;\n  margin-left: -15px;\n}\n@media (min-width: 768px) {\n  .container > .navbar-header,\n  .container-fluid > .navbar-header,\n  .container > .navbar-collapse,\n  .container-fluid > .navbar-collapse {\n    margin-right: 0;\n    margin-left: 0;\n  }\n}\n.navbar-static-top {\n  z-index: 1000;\n  border-width: 0 0 1px;\n}\n@media (min-width: 768px) {\n  .navbar-static-top {\n    border-radius: 0;\n  }\n}\n.navbar-fixed-top,\n.navbar-fixed-bottom {\n  position: fixed;\n  right: 0;\n  left: 0;\n  z-index: 1030;\n}\n@media (min-width: 768px) {\n  .navbar-fixed-top,\n  .navbar-fixed-bottom {\n    border-radius: 0;\n  }\n}\n.navbar-fixed-top {\n  top: 0;\n  border-width: 0 0 1px;\n}\n.navbar-fixed-bottom {\n  bottom: 0;\n  margin-bottom: 0;\n  border-width: 1px 0 0;\n}\n.navbar-brand {\n  float: left;\n  height: 50px;\n  padding: 15px 15px;\n  font-size: 18px;\n  line-height: 20px;\n}\n.navbar-brand:hover,\n.navbar-brand:focus {\n  text-decoration: none;\n}\n.navbar-brand > img {\n  display: block;\n}\n@media (min-width: 768px) {\n  .navbar > .container .navbar-brand,\n  .navbar > .container-fluid .navbar-brand {\n    margin-left: -15px;\n  }\n}\n.navbar-toggle {\n  position: relative;\n  float: right;\n  padding: 9px 10px;\n  margin-top: 8px;\n  margin-right: 15px;\n  margin-bottom: 8px;\n  background-color: transparent;\n  background-image: none;\n  border: 1px solid transparent;\n  border-radius: 4px;\n}\n.navbar-toggle:focus {\n  outline: 0;\n}\n.navbar-toggle .icon-bar {\n  display: block;\n  width: 22px;\n  height: 2px;\n  border-radius: 1px;\n}\n.navbar-toggle .icon-bar + .icon-bar {\n  margin-top: 4px;\n}\n@media (min-width: 768px) {\n  .navbar-toggle {\n    display: none;\n  }\n}\n.navbar-nav {\n  margin: 7.5px -15px;\n}\n.navbar-nav > li > a {\n  padding-top: 10px;\n  padding-bottom: 10px;\n  line-height: 20px;\n}\n@media (max-width: 767px) {\n  .navbar-nav .open .dropdown-menu {\n    position: static;\n    float: none;\n    width: auto;\n    margin-top: 0;\n    background-color: transparent;\n    border: 0;\n    -webkit-box-shadow: none;\n            box-shadow: none;\n  }\n  .navbar-nav .open .dropdown-menu > li > a,\n  .navbar-nav .open .dropdown-menu .dropdown-header {\n    padding: 5px 15px 5px 25px;\n  }\n  .navbar-nav .open .dropdown-menu > li > a {\n    line-height: 20px;\n  }\n  .navbar-nav .open .dropdown-menu > li > a:hover,\n  .navbar-nav .open .dropdown-menu > li > a:focus {\n    background-image: none;\n  }\n}\n@media (min-width: 768px) {\n  .navbar-nav {\n    float: left;\n    margin: 0;\n  }\n  .navbar-nav > li {\n    float: left;\n  }\n  .navbar-nav > li > a {\n    padding-top: 15px;\n    padding-bottom: 15px;\n  }\n}\n.navbar-form {\n  padding: 10px 15px;\n  margin-top: 8px;\n  margin-right: -15px;\n  margin-bottom: 8px;\n  margin-left: -15px;\n  border-top: 1px solid transparent;\n  border-bottom: 1px solid transparent;\n  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, .1), 0 1px 0 rgba(255, 255, 255, .1);\n          box-shadow: inset 0 1px 0 rgba(255, 255, 255, .1), 0 1px 0 rgba(255, 255, 255, .1);\n}\n@media (min-width: 768px) {\n  .navbar-form .form-group {\n    display: inline-block;\n    margin-bottom: 0;\n    vertical-align: middle;\n  }\n  .navbar-form .form-control {\n    display: inline-block;\n    width: auto;\n    vertical-align: middle;\n  }\n  .navbar-form .form-control-static {\n    display: inline-block;\n  }\n  .navbar-form .input-group {\n    display: inline-table;\n    vertical-align: middle;\n  }\n  .navbar-form .input-group .input-group-addon,\n  .navbar-form .input-group .input-group-btn,\n  .navbar-form .input-group .form-control {\n    width: auto;\n  }\n  .navbar-form .input-group > .form-control {\n    width: 100%;\n  }\n  .navbar-form .control-label {\n    margin-bottom: 0;\n    vertical-align: middle;\n  }\n  .navbar-form .radio,\n  .navbar-form .checkbox {\n    display: inline-block;\n    margin-top: 0;\n    margin-bottom: 0;\n    vertical-align: middle;\n  }\n  .navbar-form .radio label,\n  .navbar-form .checkbox label {\n    padding-left: 0;\n  }\n  .navbar-form .radio input[type="radio"],\n  .navbar-form .checkbox input[type="checkbox"] {\n    position: relative;\n    margin-left: 0;\n  }\n  .navbar-form .has-feedback .form-control-feedback {\n    top: 0;\n  }\n}\n@media (max-width: 767px) {\n  .navbar-form .form-group {\n    margin-bottom: 5px;\n  }\n  .navbar-form .form-group:last-child {\n    margin-bottom: 0;\n  }\n}\n@media (min-width: 768px) {\n  .navbar-form {\n    width: auto;\n    padding-top: 0;\n    padding-bottom: 0;\n    margin-right: 0;\n    margin-left: 0;\n    border: 0;\n    -webkit-box-shadow: none;\n            box-shadow: none;\n  }\n}\n.navbar-nav > li > .dropdown-menu {\n  margin-top: 0;\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n.navbar-fixed-bottom .navbar-nav > li > .dropdown-menu {\n  margin-bottom: 0;\n  border-top-left-radius: 4px;\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.navbar-btn {\n  margin-top: 8px;\n  margin-bottom: 8px;\n}\n.navbar-btn.btn-sm {\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n.navbar-btn.btn-xs {\n  margin-top: 14px;\n  margin-bottom: 14px;\n}\n.navbar-text {\n  margin-top: 15px;\n  margin-bottom: 15px;\n}\n@media (min-width: 768px) {\n  .navbar-text {\n    float: left;\n    margin-right: 15px;\n    margin-left: 15px;\n  }\n}\n@media (min-width: 768px) {\n  .navbar-left {\n    float: left !important;\n  }\n  .navbar-right {\n    float: right !important;\n    margin-right: -15px;\n  }\n  .navbar-right ~ .navbar-right {\n    margin-right: 0;\n  }\n}\n.navbar-default {\n  background-color: #f8f8f8;\n  border-color: #e7e7e7;\n}\n.navbar-default .navbar-brand {\n  color: #777;\n}\n.navbar-default .navbar-brand:hover,\n.navbar-default .navbar-brand:focus {\n  color: #5e5e5e;\n  background-color: transparent;\n}\n.navbar-default .navbar-text {\n  color: #777;\n}\n.navbar-default .navbar-nav > li > a {\n  color: #777;\n}\n.navbar-default .navbar-nav > li > a:hover,\n.navbar-default .navbar-nav > li > a:focus {\n  color: #333;\n  background-color: transparent;\n}\n.navbar-default .navbar-nav > .active > a,\n.navbar-default .navbar-nav > .active > a:hover,\n.navbar-default .navbar-nav > .active > a:focus {\n  color: #555;\n  background-color: #e7e7e7;\n}\n.navbar-default .navbar-nav > .disabled > a,\n.navbar-default .navbar-nav > .disabled > a:hover,\n.navbar-default .navbar-nav > .disabled > a:focus {\n  color: #ccc;\n  background-color: transparent;\n}\n.navbar-default .navbar-toggle {\n  border-color: #ddd;\n}\n.navbar-default .navbar-toggle:hover,\n.navbar-default .navbar-toggle:focus {\n  background-color: #ddd;\n}\n.navbar-default .navbar-toggle .icon-bar {\n  background-color: #888;\n}\n.navbar-default .navbar-collapse,\n.navbar-default .navbar-form {\n  border-color: #e7e7e7;\n}\n.navbar-default .navbar-nav > .open > a,\n.navbar-default .navbar-nav > .open > a:hover,\n.navbar-default .navbar-nav > .open > a:focus {\n  color: #555;\n  background-color: #e7e7e7;\n}\n@media (max-width: 767px) {\n  .navbar-default .navbar-nav .open .dropdown-menu > li > a {\n    color: #777;\n  }\n  .navbar-default .navbar-nav .open .dropdown-menu > li > a:hover,\n  .navbar-default .navbar-nav .open .dropdown-menu > li > a:focus {\n    color: #333;\n    background-color: transparent;\n  }\n  .navbar-default .navbar-nav .open .dropdown-menu > .active > a,\n  .navbar-default .navbar-nav .open .dropdown-menu > .active > a:hover,\n  .navbar-default .navbar-nav .open .dropdown-menu > .active > a:focus {\n    color: #555;\n    background-color: #e7e7e7;\n  }\n  .navbar-default .navbar-nav .open .dropdown-menu > .disabled > a,\n  .navbar-default .navbar-nav .open .dropdown-menu > .disabled > a:hover,\n  .navbar-default .navbar-nav .open .dropdown-menu > .disabled > a:focus {\n    color: #ccc;\n    background-color: transparent;\n  }\n}\n.navbar-default .navbar-link {\n  color: #777;\n}\n.navbar-default .navbar-link:hover {\n  color: #333;\n}\n.navbar-default .btn-link {\n  color: #777;\n}\n.navbar-default .btn-link:hover,\n.navbar-default .btn-link:focus {\n  color: #333;\n}\n.navbar-default .btn-link[disabled]:hover,\nfieldset[disabled] .navbar-default .btn-link:hover,\n.navbar-default .btn-link[disabled]:focus,\nfieldset[disabled] .navbar-default .btn-link:focus {\n  color: #ccc;\n}\n.navbar-inverse {\n  background-color: #222;\n  border-color: #080808;\n}\n.navbar-inverse .navbar-brand {\n  color: #9d9d9d;\n}\n.navbar-inverse .navbar-brand:hover,\n.navbar-inverse .navbar-brand:focus {\n  color: #fff;\n  background-color: transparent;\n}\n.navbar-inverse .navbar-text {\n  color: #9d9d9d;\n}\n.navbar-inverse .navbar-nav > li > a {\n  color: #9d9d9d;\n}\n.navbar-inverse .navbar-nav > li > a:hover,\n.navbar-inverse .navbar-nav > li > a:focus {\n  color: #fff;\n  background-color: transparent;\n}\n.navbar-inverse .navbar-nav > .active > a,\n.navbar-inverse .navbar-nav > .active > a:hover,\n.navbar-inverse .navbar-nav > .active > a:focus {\n  color: #fff;\n  background-color: #080808;\n}\n.navbar-inverse .navbar-nav > .disabled > a,\n.navbar-inverse .navbar-nav > .disabled > a:hover,\n.navbar-inverse .navbar-nav > .disabled > a:focus {\n  color: #444;\n  background-color: transparent;\n}\n.navbar-inverse .navbar-toggle {\n  border-color: #333;\n}\n.navbar-inverse .navbar-toggle:hover,\n.navbar-inverse .navbar-toggle:focus {\n  background-color: #333;\n}\n.navbar-inverse .navbar-toggle .icon-bar {\n  background-color: #fff;\n}\n.navbar-inverse .navbar-collapse,\n.navbar-inverse .navbar-form {\n  border-color: #101010;\n}\n.navbar-inverse .navbar-nav > .open > a,\n.navbar-inverse .navbar-nav > .open > a:hover,\n.navbar-inverse .navbar-nav > .open > a:focus {\n  color: #fff;\n  background-color: #080808;\n}\n@media (max-width: 767px) {\n  .navbar-inverse .navbar-nav .open .dropdown-menu > .dropdown-header {\n    border-color: #080808;\n  }\n  .navbar-inverse .navbar-nav .open .dropdown-menu .divider {\n    background-color: #080808;\n  }\n  .navbar-inverse .navbar-nav .open .dropdown-menu > li > a {\n    color: #9d9d9d;\n  }\n  .navbar-inverse .navbar-nav .open .dropdown-menu > li > a:hover,\n  .navbar-inverse .navbar-nav .open .dropdown-menu > li > a:focus {\n    color: #fff;\n    background-color: transparent;\n  }\n  .navbar-inverse .navbar-nav .open .dropdown-menu > .active > a,\n  .navbar-inverse .navbar-nav .open .dropdown-menu > .active > a:hover,\n  .navbar-inverse .navbar-nav .open .dropdown-menu > .active > a:focus {\n    color: #fff;\n    background-color: #080808;\n  }\n  .navbar-inverse .navbar-nav .open .dropdown-menu > .disabled > a,\n  .navbar-inverse .navbar-nav .open .dropdown-menu > .disabled > a:hover,\n  .navbar-inverse .navbar-nav .open .dropdown-menu > .disabled > a:focus {\n    color: #444;\n    background-color: transparent;\n  }\n}\n.navbar-inverse .navbar-link {\n  color: #9d9d9d;\n}\n.navbar-inverse .navbar-link:hover {\n  color: #fff;\n}\n.navbar-inverse .btn-link {\n  color: #9d9d9d;\n}\n.navbar-inverse .btn-link:hover,\n.navbar-inverse .btn-link:focus {\n  color: #fff;\n}\n.navbar-inverse .btn-link[disabled]:hover,\nfieldset[disabled] .navbar-inverse .btn-link:hover,\n.navbar-inverse .btn-link[disabled]:focus,\nfieldset[disabled] .navbar-inverse .btn-link:focus {\n  color: #444;\n}\n.breadcrumb {\n  padding: 8px 15px;\n  margin-bottom: 20px;\n  list-style: none;\n  background-color: #f5f5f5;\n  border-radius: 4px;\n}\n.breadcrumb > li {\n  display: inline-block;\n}\n.breadcrumb > li + li:before {\n  padding: 0 5px;\n  color: #ccc;\n  content: "/\\00a0";\n}\n.breadcrumb > .active {\n  color: #777;\n}\n.pagination {\n  display: inline-block;\n  padding-left: 0;\n  margin: 20px 0;\n  border-radius: 4px;\n}\n.pagination > li {\n  display: inline;\n}\n.pagination > li > a,\n.pagination > li > span {\n  position: relative;\n  float: left;\n  padding: 6px 12px;\n  margin-left: -1px;\n  line-height: 1.42857143;\n  color: #337ab7;\n  text-decoration: none;\n  background-color: #fff;\n  border: 1px solid #ddd;\n}\n.pagination > li:first-child > a,\n.pagination > li:first-child > span {\n  margin-left: 0;\n  border-top-left-radius: 4px;\n  border-bottom-left-radius: 4px;\n}\n.pagination > li:last-child > a,\n.pagination > li:last-child > span {\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 4px;\n}\n.pagination > li > a:hover,\n.pagination > li > span:hover,\n.pagination > li > a:focus,\n.pagination > li > span:focus {\n  z-index: 2;\n  color: #23527c;\n  background-color: #eee;\n  border-color: #ddd;\n}\n.pagination > .active > a,\n.pagination > .active > span,\n.pagination > .active > a:hover,\n.pagination > .active > span:hover,\n.pagination > .active > a:focus,\n.pagination > .active > span:focus {\n  z-index: 3;\n  color: #fff;\n  cursor: default;\n  background-color: #337ab7;\n  border-color: #337ab7;\n}\n.pagination > .disabled > span,\n.pagination > .disabled > span:hover,\n.pagination > .disabled > span:focus,\n.pagination > .disabled > a,\n.pagination > .disabled > a:hover,\n.pagination > .disabled > a:focus {\n  color: #777;\n  cursor: not-allowed;\n  background-color: #fff;\n  border-color: #ddd;\n}\n.pagination-lg > li > a,\n.pagination-lg > li > span {\n  padding: 10px 16px;\n  font-size: 18px;\n  line-height: 1.3333333;\n}\n.pagination-lg > li:first-child > a,\n.pagination-lg > li:first-child > span {\n  border-top-left-radius: 6px;\n  border-bottom-left-radius: 6px;\n}\n.pagination-lg > li:last-child > a,\n.pagination-lg > li:last-child > span {\n  border-top-right-radius: 6px;\n  border-bottom-right-radius: 6px;\n}\n.pagination-sm > li > a,\n.pagination-sm > li > span {\n  padding: 5px 10px;\n  font-size: 12px;\n  line-height: 1.5;\n}\n.pagination-sm > li:first-child > a,\n.pagination-sm > li:first-child > span {\n  border-top-left-radius: 3px;\n  border-bottom-left-radius: 3px;\n}\n.pagination-sm > li:last-child > a,\n.pagination-sm > li:last-child > span {\n  border-top-right-radius: 3px;\n  border-bottom-right-radius: 3px;\n}\n.pager {\n  padding-left: 0;\n  margin: 20px 0;\n  text-align: center;\n  list-style: none;\n}\n.pager li {\n  display: inline;\n}\n.pager li > a,\n.pager li > span {\n  display: inline-block;\n  padding: 5px 14px;\n  background-color: #fff;\n  border: 1px solid #ddd;\n  border-radius: 15px;\n}\n.pager li > a:hover,\n.pager li > a:focus {\n  text-decoration: none;\n  background-color: #eee;\n}\n.pager .next > a,\n.pager .next > span {\n  float: right;\n}\n.pager .previous > a,\n.pager .previous > span {\n  float: left;\n}\n.pager .disabled > a,\n.pager .disabled > a:hover,\n.pager .disabled > a:focus,\n.pager .disabled > span {\n  color: #777;\n  cursor: not-allowed;\n  background-color: #fff;\n}\n.label {\n  display: inline;\n  padding: .2em .6em .3em;\n  font-size: 75%;\n  font-weight: bold;\n  line-height: 1;\n  color: #fff;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  border-radius: .25em;\n}\na.label:hover,\na.label:focus {\n  color: #fff;\n  text-decoration: none;\n  cursor: pointer;\n}\n.label:empty {\n  display: none;\n}\n.btn .label {\n  position: relative;\n  top: -1px;\n}\n.label-default {\n  background-color: #777;\n}\n.label-default[href]:hover,\n.label-default[href]:focus {\n  background-color: #5e5e5e;\n}\n.label-primary {\n  background-color: #337ab7;\n}\n.label-primary[href]:hover,\n.label-primary[href]:focus {\n  background-color: #286090;\n}\n.label-success {\n  background-color: #5cb85c;\n}\n.label-success[href]:hover,\n.label-success[href]:focus {\n  background-color: #449d44;\n}\n.label-info {\n  background-color: #5bc0de;\n}\n.label-info[href]:hover,\n.label-info[href]:focus {\n  background-color: #31b0d5;\n}\n.label-warning {\n  background-color: #f0ad4e;\n}\n.label-warning[href]:hover,\n.label-warning[href]:focus {\n  background-color: #ec971f;\n}\n.label-danger {\n  background-color: #d9534f;\n}\n.label-danger[href]:hover,\n.label-danger[href]:focus {\n  background-color: #c9302c;\n}\n.badge {\n  display: inline-block;\n  min-width: 10px;\n  padding: 3px 7px;\n  font-size: 12px;\n  font-weight: bold;\n  line-height: 1;\n  color: #fff;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: middle;\n  background-color: #777;\n  border-radius: 10px;\n}\n.badge:empty {\n  display: none;\n}\n.btn .badge {\n  position: relative;\n  top: -1px;\n}\n.btn-xs .badge,\n.btn-group-xs > .btn .badge {\n  top: 0;\n  padding: 1px 5px;\n}\na.badge:hover,\na.badge:focus {\n  color: #fff;\n  text-decoration: none;\n  cursor: pointer;\n}\n.list-group-item.active > .badge,\n.nav-pills > .active > a > .badge {\n  color: #337ab7;\n  background-color: #fff;\n}\n.list-group-item > .badge {\n  float: right;\n}\n.list-group-item > .badge + .badge {\n  margin-right: 5px;\n}\n.nav-pills > li > a > .badge {\n  margin-left: 3px;\n}\n.jumbotron {\n  padding-top: 30px;\n  padding-bottom: 30px;\n  margin-bottom: 30px;\n  color: inherit;\n  background-color: #eee;\n}\n.jumbotron h1,\n.jumbotron .h1 {\n  color: inherit;\n}\n.jumbotron p {\n  margin-bottom: 15px;\n  font-size: 21px;\n  font-weight: 200;\n}\n.jumbotron > hr {\n  border-top-color: #d5d5d5;\n}\n.container .jumbotron,\n.container-fluid .jumbotron {\n  padding-right: 15px;\n  padding-left: 15px;\n  border-radius: 6px;\n}\n.jumbotron .container {\n  max-width: 100%;\n}\n@media screen and (min-width: 768px) {\n  .jumbotron {\n    padding-top: 48px;\n    padding-bottom: 48px;\n  }\n  .container .jumbotron,\n  .container-fluid .jumbotron {\n    padding-right: 60px;\n    padding-left: 60px;\n  }\n  .jumbotron h1,\n  .jumbotron .h1 {\n    font-size: 63px;\n  }\n}\n.thumbnail {\n  display: block;\n  padding: 4px;\n  margin-bottom: 20px;\n  line-height: 1.42857143;\n  background-color: #fff;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  -webkit-transition: border .2s ease-in-out;\n       -o-transition: border .2s ease-in-out;\n          transition: border .2s ease-in-out;\n}\n.thumbnail > img,\n.thumbnail a > img {\n  margin-right: auto;\n  margin-left: auto;\n}\na.thumbnail:hover,\na.thumbnail:focus,\na.thumbnail.active {\n  border-color: #337ab7;\n}\n.thumbnail .caption {\n  padding: 9px;\n  color: #333;\n}\n.alert {\n  padding: 15px;\n  margin-bottom: 20px;\n  border: 1px solid transparent;\n  border-radius: 4px;\n}\n.alert h4 {\n  margin-top: 0;\n  color: inherit;\n}\n.alert .alert-link {\n  font-weight: bold;\n}\n.alert > p,\n.alert > ul {\n  margin-bottom: 0;\n}\n.alert > p + p {\n  margin-top: 5px;\n}\n.alert-dismissable,\n.alert-dismissible {\n  padding-right: 35px;\n}\n.alert-dismissable .close,\n.alert-dismissible .close {\n  position: relative;\n  top: -2px;\n  right: -21px;\n  color: inherit;\n}\n.alert-success {\n  color: #3c763d;\n  background-color: #dff0d8;\n  border-color: #d6e9c6;\n}\n.alert-success hr {\n  border-top-color: #c9e2b3;\n}\n.alert-success .alert-link {\n  color: #2b542c;\n}\n.alert-info {\n  color: #31708f;\n  background-color: #d9edf7;\n  border-color: #bce8f1;\n}\n.alert-info hr {\n  border-top-color: #a6e1ec;\n}\n.alert-info .alert-link {\n  color: #245269;\n}\n.alert-warning {\n  color: #8a6d3b;\n  background-color: #fcf8e3;\n  border-color: #faebcc;\n}\n.alert-warning hr {\n  border-top-color: #f7e1b5;\n}\n.alert-warning .alert-link {\n  color: #66512c;\n}\n.alert-danger {\n  color: #a94442;\n  background-color: #f2dede;\n  border-color: #ebccd1;\n}\n.alert-danger hr {\n  border-top-color: #e4b9c0;\n}\n.alert-danger .alert-link {\n  color: #843534;\n}\n@-webkit-keyframes progress-bar-stripes {\n  from {\n    background-position: 40px 0;\n  }\n  to {\n    background-position: 0 0;\n  }\n}\n@-o-keyframes progress-bar-stripes {\n  from {\n    background-position: 40px 0;\n  }\n  to {\n    background-position: 0 0;\n  }\n}\n@keyframes progress-bar-stripes {\n  from {\n    background-position: 40px 0;\n  }\n  to {\n    background-position: 0 0;\n  }\n}\n.progress {\n  height: 20px;\n  margin-bottom: 20px;\n  overflow: hidden;\n  background-color: #f5f5f5;\n  border-radius: 4px;\n  -webkit-box-shadow: inset 0 1px 2px rgba(0, 0, 0, .1);\n          box-shadow: inset 0 1px 2px rgba(0, 0, 0, .1);\n}\n.progress-bar {\n  float: left;\n  width: 0;\n  height: 100%;\n  font-size: 12px;\n  line-height: 20px;\n  color: #fff;\n  text-align: center;\n  background-color: #337ab7;\n  -webkit-box-shadow: inset 0 -1px 0 rgba(0, 0, 0, .15);\n          box-shadow: inset 0 -1px 0 rgba(0, 0, 0, .15);\n  -webkit-transition: width .6s ease;\n       -o-transition: width .6s ease;\n          transition: width .6s ease;\n}\n.progress-striped .progress-bar,\n.progress-bar-striped {\n  background-image: -webkit-linear-gradient(45deg, rgba(255, 255, 255, .15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .15) 50%, rgba(255, 255, 255, .15) 75%, transparent 75%, transparent);\n  background-image:      -o-linear-gradient(45deg, rgba(255, 255, 255, .15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .15) 50%, rgba(255, 255, 255, .15) 75%, transparent 75%, transparent);\n  background-image:         linear-gradient(45deg, rgba(255, 255, 255, .15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .15) 50%, rgba(255, 255, 255, .15) 75%, transparent 75%, transparent);\n  -webkit-background-size: 40px 40px;\n          background-size: 40px 40px;\n}\n.progress.active .progress-bar,\n.progress-bar.active {\n  -webkit-animation: progress-bar-stripes 2s linear infinite;\n       -o-animation: progress-bar-stripes 2s linear infinite;\n          animation: progress-bar-stripes 2s linear infinite;\n}\n.progress-bar-success {\n  background-color: #5cb85c;\n}\n.progress-striped .progress-bar-success {\n  background-image: -webkit-linear-gradient(45deg, rgba(255, 255, 255, .15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .15) 50%, rgba(255, 255, 255, .15) 75%, transparent 75%, transparent);\n  background-image:      -o-linear-gradient(45deg, rgba(255, 255, 255, .15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .15) 50%, rgba(255, 255, 255, .15) 75%, transparent 75%, transparent);\n  background-image:         linear-gradient(45deg, rgba(255, 255, 255, .15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .15) 50%, rgba(255, 255, 255, .15) 75%, transparent 75%, transparent);\n}\n.progress-bar-info {\n  background-color: #5bc0de;\n}\n.progress-striped .progress-bar-info {\n  background-image: -webkit-linear-gradient(45deg, rgba(255, 255, 255, .15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .15) 50%, rgba(255, 255, 255, .15) 75%, transparent 75%, transparent);\n  background-image:      -o-linear-gradient(45deg, rgba(255, 255, 255, .15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .15) 50%, rgba(255, 255, 255, .15) 75%, transparent 75%, transparent);\n  background-image:         linear-gradient(45deg, rgba(255, 255, 255, .15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .15) 50%, rgba(255, 255, 255, .15) 75%, transparent 75%, transparent);\n}\n.progress-bar-warning {\n  background-color: #f0ad4e;\n}\n.progress-striped .progress-bar-warning {\n  background-image: -webkit-linear-gradient(45deg, rgba(255, 255, 255, .15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .15) 50%, rgba(255, 255, 255, .15) 75%, transparent 75%, transparent);\n  background-image:      -o-linear-gradient(45deg, rgba(255, 255, 255, .15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .15) 50%, rgba(255, 255, 255, .15) 75%, transparent 75%, transparent);\n  background-image:         linear-gradient(45deg, rgba(255, 255, 255, .15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .15) 50%, rgba(255, 255, 255, .15) 75%, transparent 75%, transparent);\n}\n.progress-bar-danger {\n  background-color: #d9534f;\n}\n.progress-striped .progress-bar-danger {\n  background-image: -webkit-linear-gradient(45deg, rgba(255, 255, 255, .15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .15) 50%, rgba(255, 255, 255, .15) 75%, transparent 75%, transparent);\n  background-image:      -o-linear-gradient(45deg, rgba(255, 255, 255, .15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .15) 50%, rgba(255, 255, 255, .15) 75%, transparent 75%, transparent);\n  background-image:         linear-gradient(45deg, rgba(255, 255, 255, .15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .15) 50%, rgba(255, 255, 255, .15) 75%, transparent 75%, transparent);\n}\n.media {\n  margin-top: 15px;\n}\n.media:first-child {\n  margin-top: 0;\n}\n.media,\n.media-body {\n  overflow: hidden;\n  zoom: 1;\n}\n.media-body {\n  width: 10000px;\n}\n.media-object {\n  display: block;\n}\n.media-object.img-thumbnail {\n  max-width: none;\n}\n.media-right,\n.media > .pull-right {\n  padding-left: 10px;\n}\n.media-left,\n.media > .pull-left {\n  padding-right: 10px;\n}\n.media-left,\n.media-right,\n.media-body {\n  display: table-cell;\n  vertical-align: top;\n}\n.media-middle {\n  vertical-align: middle;\n}\n.media-bottom {\n  vertical-align: bottom;\n}\n.media-heading {\n  margin-top: 0;\n  margin-bottom: 5px;\n}\n.media-list {\n  padding-left: 0;\n  list-style: none;\n}\n.list-group {\n  padding-left: 0;\n  margin-bottom: 20px;\n}\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: 10px 15px;\n  margin-bottom: -1px;\n  background-color: #fff;\n  border: 1px solid #ddd;\n}\n.list-group-item:first-child {\n  border-top-left-radius: 4px;\n  border-top-right-radius: 4px;\n}\n.list-group-item:last-child {\n  margin-bottom: 0;\n  border-bottom-right-radius: 4px;\n  border-bottom-left-radius: 4px;\n}\na.list-group-item,\nbutton.list-group-item {\n  color: #555;\n}\na.list-group-item .list-group-item-heading,\nbutton.list-group-item .list-group-item-heading {\n  color: #333;\n}\na.list-group-item:hover,\nbutton.list-group-item:hover,\na.list-group-item:focus,\nbutton.list-group-item:focus {\n  color: #555;\n  text-decoration: none;\n  background-color: #f5f5f5;\n}\nbutton.list-group-item {\n  width: 100%;\n  text-align: left;\n}\n.list-group-item.disabled,\n.list-group-item.disabled:hover,\n.list-group-item.disabled:focus {\n  color: #777;\n  cursor: not-allowed;\n  background-color: #eee;\n}\n.list-group-item.disabled .list-group-item-heading,\n.list-group-item.disabled:hover .list-group-item-heading,\n.list-group-item.disabled:focus .list-group-item-heading {\n  color: inherit;\n}\n.list-group-item.disabled .list-group-item-text,\n.list-group-item.disabled:hover .list-group-item-text,\n.list-group-item.disabled:focus .list-group-item-text {\n  color: #777;\n}\n.list-group-item.active,\n.list-group-item.active:hover,\n.list-group-item.active:focus {\n  z-index: 2;\n  color: #fff;\n  background-color: #337ab7;\n  border-color: #337ab7;\n}\n.list-group-item.active .list-group-item-heading,\n.list-group-item.active:hover .list-group-item-heading,\n.list-group-item.active:focus .list-group-item-heading,\n.list-group-item.active .list-group-item-heading > small,\n.list-group-item.active:hover .list-group-item-heading > small,\n.list-group-item.active:focus .list-group-item-heading > small,\n.list-group-item.active .list-group-item-heading > .small,\n.list-group-item.active:hover .list-group-item-heading > .small,\n.list-group-item.active:focus .list-group-item-heading > .small {\n  color: inherit;\n}\n.list-group-item.active .list-group-item-text,\n.list-group-item.active:hover .list-group-item-text,\n.list-group-item.active:focus .list-group-item-text {\n  color: #c7ddef;\n}\n.list-group-item-success {\n  color: #3c763d;\n  background-color: #dff0d8;\n}\na.list-group-item-success,\nbutton.list-group-item-success {\n  color: #3c763d;\n}\na.list-group-item-success .list-group-item-heading,\nbutton.list-group-item-success .list-group-item-heading {\n  color: inherit;\n}\na.list-group-item-success:hover,\nbutton.list-group-item-success:hover,\na.list-group-item-success:focus,\nbutton.list-group-item-success:focus {\n  color: #3c763d;\n  background-color: #d0e9c6;\n}\na.list-group-item-success.active,\nbutton.list-group-item-success.active,\na.list-group-item-success.active:hover,\nbutton.list-group-item-success.active:hover,\na.list-group-item-success.active:focus,\nbutton.list-group-item-success.active:focus {\n  color: #fff;\n  background-color: #3c763d;\n  border-color: #3c763d;\n}\n.list-group-item-info {\n  color: #31708f;\n  background-color: #d9edf7;\n}\na.list-group-item-info,\nbutton.list-group-item-info {\n  color: #31708f;\n}\na.list-group-item-info .list-group-item-heading,\nbutton.list-group-item-info .list-group-item-heading {\n  color: inherit;\n}\na.list-group-item-info:hover,\nbutton.list-group-item-info:hover,\na.list-group-item-info:focus,\nbutton.list-group-item-info:focus {\n  color: #31708f;\n  background-color: #c4e3f3;\n}\na.list-group-item-info.active,\nbutton.list-group-item-info.active,\na.list-group-item-info.active:hover,\nbutton.list-group-item-info.active:hover,\na.list-group-item-info.active:focus,\nbutton.list-group-item-info.active:focus {\n  color: #fff;\n  background-color: #31708f;\n  border-color: #31708f;\n}\n.list-group-item-warning {\n  color: #8a6d3b;\n  background-color: #fcf8e3;\n}\na.list-group-item-warning,\nbutton.list-group-item-warning {\n  color: #8a6d3b;\n}\na.list-group-item-warning .list-group-item-heading,\nbutton.list-group-item-warning .list-group-item-heading {\n  color: inherit;\n}\na.list-group-item-warning:hover,\nbutton.list-group-item-warning:hover,\na.list-group-item-warning:focus,\nbutton.list-group-item-warning:focus {\n  color: #8a6d3b;\n  background-color: #faf2cc;\n}\na.list-group-item-warning.active,\nbutton.list-group-item-warning.active,\na.list-group-item-warning.active:hover,\nbutton.list-group-item-warning.active:hover,\na.list-group-item-warning.active:focus,\nbutton.list-group-item-warning.active:focus {\n  color: #fff;\n  background-color: #8a6d3b;\n  border-color: #8a6d3b;\n}\n.list-group-item-danger {\n  color: #a94442;\n  background-color: #f2dede;\n}\na.list-group-item-danger,\nbutton.list-group-item-danger {\n  color: #a94442;\n}\na.list-group-item-danger .list-group-item-heading,\nbutton.list-group-item-danger .list-group-item-heading {\n  color: inherit;\n}\na.list-group-item-danger:hover,\nbutton.list-group-item-danger:hover,\na.list-group-item-danger:focus,\nbutton.list-group-item-danger:focus {\n  color: #a94442;\n  background-color: #ebcccc;\n}\na.list-group-item-danger.active,\nbutton.list-group-item-danger.active,\na.list-group-item-danger.active:hover,\nbutton.list-group-item-danger.active:hover,\na.list-group-item-danger.active:focus,\nbutton.list-group-item-danger.active:focus {\n  color: #fff;\n  background-color: #a94442;\n  border-color: #a94442;\n}\n.list-group-item-heading {\n  margin-top: 0;\n  margin-bottom: 5px;\n}\n.list-group-item-text {\n  margin-bottom: 0;\n  line-height: 1.3;\n}\n.panel {\n  margin-bottom: 20px;\n  background-color: #fff;\n  border: 1px solid transparent;\n  border-radius: 4px;\n  -webkit-box-shadow: 0 1px 1px rgba(0, 0, 0, .05);\n          box-shadow: 0 1px 1px rgba(0, 0, 0, .05);\n}\n.panel-body {\n  padding: 15px;\n}\n.panel-heading {\n  padding: 10px 15px;\n  border-bottom: 1px solid transparent;\n  border-top-left-radius: 3px;\n  border-top-right-radius: 3px;\n}\n.panel-heading > .dropdown .dropdown-toggle {\n  color: inherit;\n}\n.panel-title {\n  margin-top: 0;\n  margin-bottom: 0;\n  font-size: 16px;\n  color: inherit;\n}\n.panel-title > a,\n.panel-title > small,\n.panel-title > .small,\n.panel-title > small > a,\n.panel-title > .small > a {\n  color: inherit;\n}\n.panel-footer {\n  padding: 10px 15px;\n  background-color: #f5f5f5;\n  border-top: 1px solid #ddd;\n  border-bottom-right-radius: 3px;\n  border-bottom-left-radius: 3px;\n}\n.panel > .list-group,\n.panel > .panel-collapse > .list-group {\n  margin-bottom: 0;\n}\n.panel > .list-group .list-group-item,\n.panel > .panel-collapse > .list-group .list-group-item {\n  border-width: 1px 0;\n  border-radius: 0;\n}\n.panel > .list-group:first-child .list-group-item:first-child,\n.panel > .panel-collapse > .list-group:first-child .list-group-item:first-child {\n  border-top: 0;\n  border-top-left-radius: 3px;\n  border-top-right-radius: 3px;\n}\n.panel > .list-group:last-child .list-group-item:last-child,\n.panel > .panel-collapse > .list-group:last-child .list-group-item:last-child {\n  border-bottom: 0;\n  border-bottom-right-radius: 3px;\n  border-bottom-left-radius: 3px;\n}\n.panel > .panel-heading + .panel-collapse > .list-group .list-group-item:first-child {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n.panel-heading + .list-group .list-group-item:first-child {\n  border-top-width: 0;\n}\n.list-group + .panel-footer {\n  border-top-width: 0;\n}\n.panel > .table,\n.panel > .table-responsive > .table,\n.panel > .panel-collapse > .table {\n  margin-bottom: 0;\n}\n.panel > .table caption,\n.panel > .table-responsive > .table caption,\n.panel > .panel-collapse > .table caption {\n  padding-right: 15px;\n  padding-left: 15px;\n}\n.panel > .table:first-child,\n.panel > .table-responsive:first-child > .table:first-child {\n  border-top-left-radius: 3px;\n  border-top-right-radius: 3px;\n}\n.panel > .table:first-child > thead:first-child > tr:first-child,\n.panel > .table-responsive:first-child > .table:first-child > thead:first-child > tr:first-child,\n.panel > .table:first-child > tbody:first-child > tr:first-child,\n.panel > .table-responsive:first-child > .table:first-child > tbody:first-child > tr:first-child {\n  border-top-left-radius: 3px;\n  border-top-right-radius: 3px;\n}\n.panel > .table:first-child > thead:first-child > tr:first-child td:first-child,\n.panel > .table-responsive:first-child > .table:first-child > thead:first-child > tr:first-child td:first-child,\n.panel > .table:first-child > tbody:first-child > tr:first-child td:first-child,\n.panel > .table-responsive:first-child > .table:first-child > tbody:first-child > tr:first-child td:first-child,\n.panel > .table:first-child > thead:first-child > tr:first-child th:first-child,\n.panel > .table-responsive:first-child > .table:first-child > thead:first-child > tr:first-child th:first-child,\n.panel > .table:first-child > tbody:first-child > tr:first-child th:first-child,\n.panel > .table-responsive:first-child > .table:first-child > tbody:first-child > tr:first-child th:first-child {\n  border-top-left-radius: 3px;\n}\n.panel > .table:first-child > thead:first-child > tr:first-child td:last-child,\n.panel > .table-responsive:first-child > .table:first-child > thead:first-child > tr:first-child td:last-child,\n.panel > .table:first-child > tbody:first-child > tr:first-child td:last-child,\n.panel > .table-responsive:first-child > .table:first-child > tbody:first-child > tr:first-child td:last-child,\n.panel > .table:first-child > thead:first-child > tr:first-child th:last-child,\n.panel > .table-responsive:first-child > .table:first-child > thead:first-child > tr:first-child th:last-child,\n.panel > .table:first-child > tbody:first-child > tr:first-child th:last-child,\n.panel > .table-responsive:first-child > .table:first-child > tbody:first-child > tr:first-child th:last-child {\n  border-top-right-radius: 3px;\n}\n.panel > .table:last-child,\n.panel > .table-responsive:last-child > .table:last-child {\n  border-bottom-right-radius: 3px;\n  border-bottom-left-radius: 3px;\n}\n.panel > .table:last-child > tbody:last-child > tr:last-child,\n.panel > .table-responsive:last-child > .table:last-child > tbody:last-child > tr:last-child,\n.panel > .table:last-child > tfoot:last-child > tr:last-child,\n.panel > .table-responsive:last-child > .table:last-child > tfoot:last-child > tr:last-child {\n  border-bottom-right-radius: 3px;\n  border-bottom-left-radius: 3px;\n}\n.panel > .table:last-child > tbody:last-child > tr:last-child td:first-child,\n.panel > .table-responsive:last-child > .table:last-child > tbody:last-child > tr:last-child td:first-child,\n.panel > .table:last-child > tfoot:last-child > tr:last-child td:first-child,\n.panel > .table-responsive:last-child > .table:last-child > tfoot:last-child > tr:last-child td:first-child,\n.panel > .table:last-child > tbody:last-child > tr:last-child th:first-child,\n.panel > .table-responsive:last-child > .table:last-child > tbody:last-child > tr:last-child th:first-child,\n.panel > .table:last-child > tfoot:last-child > tr:last-child th:first-child,\n.panel > .table-responsive:last-child > .table:last-child > tfoot:last-child > tr:last-child th:first-child {\n  border-bottom-left-radius: 3px;\n}\n.panel > .table:last-child > tbody:last-child > tr:last-child td:last-child,\n.panel > .table-responsive:last-child > .table:last-child > tbody:last-child > tr:last-child td:last-child,\n.panel > .table:last-child > tfoot:last-child > tr:last-child td:last-child,\n.panel > .table-responsive:last-child > .table:last-child > tfoot:last-child > tr:last-child td:last-child,\n.panel > .table:last-child > tbody:last-child > tr:last-child th:last-child,\n.panel > .table-responsive:last-child > .table:last-child > tbody:last-child > tr:last-child th:last-child,\n.panel > .table:last-child > tfoot:last-child > tr:last-child th:last-child,\n.panel > .table-responsive:last-child > .table:last-child > tfoot:last-child > tr:last-child th:last-child {\n  border-bottom-right-radius: 3px;\n}\n.panel > .panel-body + .table,\n.panel > .panel-body + .table-responsive,\n.panel > .table + .panel-body,\n.panel > .table-responsive + .panel-body {\n  border-top: 1px solid #ddd;\n}\n.panel > .table > tbody:first-child > tr:first-child th,\n.panel > .table > tbody:first-child > tr:first-child td {\n  border-top: 0;\n}\n.panel > .table-bordered,\n.panel > .table-responsive > .table-bordered {\n  border: 0;\n}\n.panel > .table-bordered > thead > tr > th:first-child,\n.panel > .table-responsive > .table-bordered > thead > tr > th:first-child,\n.panel > .table-bordered > tbody > tr > th:first-child,\n.panel > .table-responsive > .table-bordered > tbody > tr > th:first-child,\n.panel > .table-bordered > tfoot > tr > th:first-child,\n.panel > .table-responsive > .table-bordered > tfoot > tr > th:first-child,\n.panel > .table-bordered > thead > tr > td:first-child,\n.panel > .table-responsive > .table-bordered > thead > tr > td:first-child,\n.panel > .table-bordered > tbody > tr > td:first-child,\n.panel > .table-responsive > .table-bordered > tbody > tr > td:first-child,\n.panel > .table-bordered > tfoot > tr > td:first-child,\n.panel > .table-responsive > .table-bordered > tfoot > tr > td:first-child {\n  border-left: 0;\n}\n.panel > .table-bordered > thead > tr > th:last-child,\n.panel > .table-responsive > .table-bordered > thead > tr > th:last-child,\n.panel > .table-bordered > tbody > tr > th:last-child,\n.panel > .table-responsive > .table-bordered > tbody > tr > th:last-child,\n.panel > .table-bordered > tfoot > tr > th:last-child,\n.panel > .table-responsive > .table-bordered > tfoot > tr > th:last-child,\n.panel > .table-bordered > thead > tr > td:last-child,\n.panel > .table-responsive > .table-bordered > thead > tr > td:last-child,\n.panel > .table-bordered > tbody > tr > td:last-child,\n.panel > .table-responsive > .table-bordered > tbody > tr > td:last-child,\n.panel > .table-bordered > tfoot > tr > td:last-child,\n.panel > .table-responsive > .table-bordered > tfoot > tr > td:last-child {\n  border-right: 0;\n}\n.panel > .table-bordered > thead > tr:first-child > td,\n.panel > .table-responsive > .table-bordered > thead > tr:first-child > td,\n.panel > .table-bordered > tbody > tr:first-child > td,\n.panel > .table-responsive > .table-bordered > tbody > tr:first-child > td,\n.panel > .table-bordered > thead > tr:first-child > th,\n.panel > .table-responsive > .table-bordered > thead > tr:first-child > th,\n.panel > .table-bordered > tbody > tr:first-child > th,\n.panel > .table-responsive > .table-bordered > tbody > tr:first-child > th {\n  border-bottom: 0;\n}\n.panel > .table-bordered > tbody > tr:last-child > td,\n.panel > .table-responsive > .table-bordered > tbody > tr:last-child > td,\n.panel > .table-bordered > tfoot > tr:last-child > td,\n.panel > .table-responsive > .table-bordered > tfoot > tr:last-child > td,\n.panel > .table-bordered > tbody > tr:last-child > th,\n.panel > .table-responsive > .table-bordered > tbody > tr:last-child > th,\n.panel > .table-bordered > tfoot > tr:last-child > th,\n.panel > .table-responsive > .table-bordered > tfoot > tr:last-child > th {\n  border-bottom: 0;\n}\n.panel > .table-responsive {\n  margin-bottom: 0;\n  border: 0;\n}\n.panel-group {\n  margin-bottom: 20px;\n}\n.panel-group .panel {\n  margin-bottom: 0;\n  border-radius: 4px;\n}\n.panel-group .panel + .panel {\n  margin-top: 5px;\n}\n.panel-group .panel-heading {\n  border-bottom: 0;\n}\n.panel-group .panel-heading + .panel-collapse > .panel-body,\n.panel-group .panel-heading + .panel-collapse > .list-group {\n  border-top: 1px solid #ddd;\n}\n.panel-group .panel-footer {\n  border-top: 0;\n}\n.panel-group .panel-footer + .panel-collapse .panel-body {\n  border-bottom: 1px solid #ddd;\n}\n.panel-default {\n  border-color: #ddd;\n}\n.panel-default > .panel-heading {\n  color: #333;\n  background-color: #f5f5f5;\n  border-color: #ddd;\n}\n.panel-default > .panel-heading + .panel-collapse > .panel-body {\n  border-top-color: #ddd;\n}\n.panel-default > .panel-heading .badge {\n  color: #f5f5f5;\n  background-color: #333;\n}\n.panel-default > .panel-footer + .panel-collapse > .panel-body {\n  border-bottom-color: #ddd;\n}\n.panel-primary {\n  border-color: #337ab7;\n}\n.panel-primary > .panel-heading {\n  color: #fff;\n  background-color: #337ab7;\n  border-color: #337ab7;\n}\n.panel-primary > .panel-heading + .panel-collapse > .panel-body {\n  border-top-color: #337ab7;\n}\n.panel-primary > .panel-heading .badge {\n  color: #337ab7;\n  background-color: #fff;\n}\n.panel-primary > .panel-footer + .panel-collapse > .panel-body {\n  border-bottom-color: #337ab7;\n}\n.panel-success {\n  border-color: #d6e9c6;\n}\n.panel-success > .panel-heading {\n  color: #3c763d;\n  background-color: #dff0d8;\n  border-color: #d6e9c6;\n}\n.panel-success > .panel-heading + .panel-collapse > .panel-body {\n  border-top-color: #d6e9c6;\n}\n.panel-success > .panel-heading .badge {\n  color: #dff0d8;\n  background-color: #3c763d;\n}\n.panel-success > .panel-footer + .panel-collapse > .panel-body {\n  border-bottom-color: #d6e9c6;\n}\n.panel-info {\n  border-color: #bce8f1;\n}\n.panel-info > .panel-heading {\n  color: #31708f;\n  background-color: #d9edf7;\n  border-color: #bce8f1;\n}\n.panel-info > .panel-heading + .panel-collapse > .panel-body {\n  border-top-color: #bce8f1;\n}\n.panel-info > .panel-heading .badge {\n  color: #d9edf7;\n  background-color: #31708f;\n}\n.panel-info > .panel-footer + .panel-collapse > .panel-body {\n  border-bottom-color: #bce8f1;\n}\n.panel-warning {\n  border-color: #faebcc;\n}\n.panel-warning > .panel-heading {\n  color: #8a6d3b;\n  background-color: #fcf8e3;\n  border-color: #faebcc;\n}\n.panel-warning > .panel-heading + .panel-collapse > .panel-body {\n  border-top-color: #faebcc;\n}\n.panel-warning > .panel-heading .badge {\n  color: #fcf8e3;\n  background-color: #8a6d3b;\n}\n.panel-warning > .panel-footer + .panel-collapse > .panel-body {\n  border-bottom-color: #faebcc;\n}\n.panel-danger {\n  border-color: #ebccd1;\n}\n.panel-danger > .panel-heading {\n  color: #a94442;\n  background-color: #f2dede;\n  border-color: #ebccd1;\n}\n.panel-danger > .panel-heading + .panel-collapse > .panel-body {\n  border-top-color: #ebccd1;\n}\n.panel-danger > .panel-heading .badge {\n  color: #f2dede;\n  background-color: #a94442;\n}\n.panel-danger > .panel-footer + .panel-collapse > .panel-body {\n  border-bottom-color: #ebccd1;\n}\n.embed-responsive {\n  position: relative;\n  display: block;\n  height: 0;\n  padding: 0;\n  overflow: hidden;\n}\n.embed-responsive .embed-responsive-item,\n.embed-responsive iframe,\n.embed-responsive embed,\n.embed-responsive object,\n.embed-responsive video {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  border: 0;\n}\n.embed-responsive-16by9 {\n  padding-bottom: 56.25%;\n}\n.embed-responsive-4by3 {\n  padding-bottom: 75%;\n}\n.well {\n  min-height: 20px;\n  padding: 19px;\n  margin-bottom: 20px;\n  background-color: #f5f5f5;\n  border: 1px solid #e3e3e3;\n  border-radius: 4px;\n  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, .05);\n          box-shadow: inset 0 1px 1px rgba(0, 0, 0, .05);\n}\n.well blockquote {\n  border-color: #ddd;\n  border-color: rgba(0, 0, 0, .15);\n}\n.well-lg {\n  padding: 24px;\n  border-radius: 6px;\n}\n.well-sm {\n  padding: 9px;\n  border-radius: 3px;\n}\n.close {\n  float: right;\n  font-size: 21px;\n  font-weight: bold;\n  line-height: 1;\n  color: #000;\n  text-shadow: 0 1px 0 #fff;\n  filter: alpha(opacity=20);\n  opacity: .2;\n}\n.close:hover,\n.close:focus {\n  color: #000;\n  text-decoration: none;\n  cursor: pointer;\n  filter: alpha(opacity=50);\n  opacity: .5;\n}\nbutton.close {\n  -webkit-appearance: none;\n  padding: 0;\n  cursor: pointer;\n  background: transparent;\n  border: 0;\n}\n.modal-open {\n  overflow: hidden;\n}\n.modal {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1050;\n  display: none;\n  overflow: hidden;\n  -webkit-overflow-scrolling: touch;\n  outline: 0;\n}\n.modal.fade .modal-dialog {\n  -webkit-transition: -webkit-transform .3s ease-out;\n       -o-transition:      -o-transform .3s ease-out;\n          transition:         transform .3s ease-out;\n  -webkit-transform: translate(0, -25%);\n      -ms-transform: translate(0, -25%);\n       -o-transform: translate(0, -25%);\n          transform: translate(0, -25%);\n}\n.modal.in .modal-dialog {\n  -webkit-transform: translate(0, 0);\n      -ms-transform: translate(0, 0);\n       -o-transform: translate(0, 0);\n          transform: translate(0, 0);\n}\n.modal-open .modal {\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: 10px;\n}\n.modal-content {\n  position: relative;\n  background-color: #fff;\n  -webkit-background-clip: padding-box;\n          background-clip: padding-box;\n  border: 1px solid #999;\n  border: 1px solid rgba(0, 0, 0, .2);\n  border-radius: 6px;\n  outline: 0;\n  -webkit-box-shadow: 0 3px 9px rgba(0, 0, 0, .5);\n          box-shadow: 0 3px 9px rgba(0, 0, 0, .5);\n}\n.modal-backdrop {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1040;\n  background-color: #000;\n}\n.modal-backdrop.fade {\n  filter: alpha(opacity=0);\n  opacity: 0;\n}\n.modal-backdrop.in {\n  filter: alpha(opacity=50);\n  opacity: .5;\n}\n.modal-header {\n  padding: 15px;\n  border-bottom: 1px solid #e5e5e5;\n}\n.modal-header .close {\n  margin-top: -2px;\n}\n.modal-title {\n  margin: 0;\n  line-height: 1.42857143;\n}\n.modal-body {\n  position: relative;\n  padding: 15px;\n}\n.modal-footer {\n  padding: 15px;\n  text-align: right;\n  border-top: 1px solid #e5e5e5;\n}\n.modal-footer .btn + .btn {\n  margin-bottom: 0;\n  margin-left: 5px;\n}\n.modal-footer .btn-group .btn + .btn {\n  margin-left: -1px;\n}\n.modal-footer .btn-block + .btn-block {\n  margin-left: 0;\n}\n.modal-scrollbar-measure {\n  position: absolute;\n  top: -9999px;\n  width: 50px;\n  height: 50px;\n  overflow: scroll;\n}\n@media (min-width: 768px) {\n  .modal-dialog {\n    width: 600px;\n    margin: 30px auto;\n  }\n  .modal-content {\n    -webkit-box-shadow: 0 5px 15px rgba(0, 0, 0, .5);\n            box-shadow: 0 5px 15px rgba(0, 0, 0, .5);\n  }\n  .modal-sm {\n    width: 300px;\n  }\n}\n@media (min-width: 992px) {\n  .modal-lg {\n    width: 900px;\n  }\n}\n.tooltip {\n  position: absolute;\n  z-index: 1070;\n  display: block;\n  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: normal;\n  line-height: 1.42857143;\n  text-align: left;\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  word-spacing: normal;\n  word-wrap: normal;\n  white-space: normal;\n  filter: alpha(opacity=0);\n  opacity: 0;\n\n  line-break: auto;\n}\n.tooltip.in {\n  filter: alpha(opacity=90);\n  opacity: .9;\n}\n.tooltip.top {\n  padding: 5px 0;\n  margin-top: -3px;\n}\n.tooltip.right {\n  padding: 0 5px;\n  margin-left: 3px;\n}\n.tooltip.bottom {\n  padding: 5px 0;\n  margin-top: 3px;\n}\n.tooltip.left {\n  padding: 0 5px;\n  margin-left: -3px;\n}\n.tooltip-inner {\n  max-width: 200px;\n  padding: 3px 8px;\n  color: #fff;\n  text-align: center;\n  background-color: #000;\n  border-radius: 4px;\n}\n.tooltip-arrow {\n  position: absolute;\n  width: 0;\n  height: 0;\n  border-color: transparent;\n  border-style: solid;\n}\n.tooltip.top .tooltip-arrow {\n  bottom: 0;\n  left: 50%;\n  margin-left: -5px;\n  border-width: 5px 5px 0;\n  border-top-color: #000;\n}\n.tooltip.top-left .tooltip-arrow {\n  right: 5px;\n  bottom: 0;\n  margin-bottom: -5px;\n  border-width: 5px 5px 0;\n  border-top-color: #000;\n}\n.tooltip.top-right .tooltip-arrow {\n  bottom: 0;\n  left: 5px;\n  margin-bottom: -5px;\n  border-width: 5px 5px 0;\n  border-top-color: #000;\n}\n.tooltip.right .tooltip-arrow {\n  top: 50%;\n  left: 0;\n  margin-top: -5px;\n  border-width: 5px 5px 5px 0;\n  border-right-color: #000;\n}\n.tooltip.left .tooltip-arrow {\n  top: 50%;\n  right: 0;\n  margin-top: -5px;\n  border-width: 5px 0 5px 5px;\n  border-left-color: #000;\n}\n.tooltip.bottom .tooltip-arrow {\n  top: 0;\n  left: 50%;\n  margin-left: -5px;\n  border-width: 0 5px 5px;\n  border-bottom-color: #000;\n}\n.tooltip.bottom-left .tooltip-arrow {\n  top: 0;\n  right: 5px;\n  margin-top: -5px;\n  border-width: 0 5px 5px;\n  border-bottom-color: #000;\n}\n.tooltip.bottom-right .tooltip-arrow {\n  top: 0;\n  left: 5px;\n  margin-top: -5px;\n  border-width: 0 5px 5px;\n  border-bottom-color: #000;\n}\n.popover {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 1060;\n  display: none;\n  max-width: 276px;\n  padding: 1px;\n  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: normal;\n  line-height: 1.42857143;\n  text-align: left;\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  word-spacing: normal;\n  word-wrap: normal;\n  white-space: normal;\n  background-color: #fff;\n  -webkit-background-clip: padding-box;\n          background-clip: padding-box;\n  border: 1px solid #ccc;\n  border: 1px solid rgba(0, 0, 0, .2);\n  border-radius: 6px;\n  -webkit-box-shadow: 0 5px 10px rgba(0, 0, 0, .2);\n          box-shadow: 0 5px 10px rgba(0, 0, 0, .2);\n\n  line-break: auto;\n}\n.popover.top {\n  margin-top: -10px;\n}\n.popover.right {\n  margin-left: 10px;\n}\n.popover.bottom {\n  margin-top: 10px;\n}\n.popover.left {\n  margin-left: -10px;\n}\n.popover-title {\n  padding: 8px 14px;\n  margin: 0;\n  font-size: 14px;\n  background-color: #f7f7f7;\n  border-bottom: 1px solid #ebebeb;\n  border-radius: 5px 5px 0 0;\n}\n.popover-content {\n  padding: 9px 14px;\n}\n.popover > .arrow,\n.popover > .arrow:after {\n  position: absolute;\n  display: block;\n  width: 0;\n  height: 0;\n  border-color: transparent;\n  border-style: solid;\n}\n.popover > .arrow {\n  border-width: 11px;\n}\n.popover > .arrow:after {\n  content: "";\n  border-width: 10px;\n}\n.popover.top > .arrow {\n  bottom: -11px;\n  left: 50%;\n  margin-left: -11px;\n  border-top-color: #999;\n  border-top-color: rgba(0, 0, 0, .25);\n  border-bottom-width: 0;\n}\n.popover.top > .arrow:after {\n  bottom: 1px;\n  margin-left: -10px;\n  content: " ";\n  border-top-color: #fff;\n  border-bottom-width: 0;\n}\n.popover.right > .arrow {\n  top: 50%;\n  left: -11px;\n  margin-top: -11px;\n  border-right-color: #999;\n  border-right-color: rgba(0, 0, 0, .25);\n  border-left-width: 0;\n}\n.popover.right > .arrow:after {\n  bottom: -10px;\n  left: 1px;\n  content: " ";\n  border-right-color: #fff;\n  border-left-width: 0;\n}\n.popover.bottom > .arrow {\n  top: -11px;\n  left: 50%;\n  margin-left: -11px;\n  border-top-width: 0;\n  border-bottom-color: #999;\n  border-bottom-color: rgba(0, 0, 0, .25);\n}\n.popover.bottom > .arrow:after {\n  top: 1px;\n  margin-left: -10px;\n  content: " ";\n  border-top-width: 0;\n  border-bottom-color: #fff;\n}\n.popover.left > .arrow {\n  top: 50%;\n  right: -11px;\n  margin-top: -11px;\n  border-right-width: 0;\n  border-left-color: #999;\n  border-left-color: rgba(0, 0, 0, .25);\n}\n.popover.left > .arrow:after {\n  right: 1px;\n  bottom: -10px;\n  content: " ";\n  border-right-width: 0;\n  border-left-color: #fff;\n}\n.carousel {\n  position: relative;\n}\n.carousel-inner {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n}\n.carousel-inner > .item {\n  position: relative;\n  display: none;\n  -webkit-transition: .6s ease-in-out left;\n       -o-transition: .6s ease-in-out left;\n          transition: .6s ease-in-out left;\n}\n.carousel-inner > .item > img,\n.carousel-inner > .item > a > img {\n  line-height: 1;\n}\n@media all and (transform-3d), (-webkit-transform-3d) {\n  .carousel-inner > .item {\n    -webkit-transition: -webkit-transform .6s ease-in-out;\n         -o-transition:      -o-transform .6s ease-in-out;\n            transition:         transform .6s ease-in-out;\n\n    -webkit-backface-visibility: hidden;\n            backface-visibility: hidden;\n    -webkit-perspective: 1000px;\n            perspective: 1000px;\n  }\n  .carousel-inner > .item.next,\n  .carousel-inner > .item.active.right {\n    left: 0;\n    -webkit-transform: translate3d(100%, 0, 0);\n            transform: translate3d(100%, 0, 0);\n  }\n  .carousel-inner > .item.prev,\n  .carousel-inner > .item.active.left {\n    left: 0;\n    -webkit-transform: translate3d(-100%, 0, 0);\n            transform: translate3d(-100%, 0, 0);\n  }\n  .carousel-inner > .item.next.left,\n  .carousel-inner > .item.prev.right,\n  .carousel-inner > .item.active {\n    left: 0;\n    -webkit-transform: translate3d(0, 0, 0);\n            transform: translate3d(0, 0, 0);\n  }\n}\n.carousel-inner > .active,\n.carousel-inner > .next,\n.carousel-inner > .prev {\n  display: block;\n}\n.carousel-inner > .active {\n  left: 0;\n}\n.carousel-inner > .next,\n.carousel-inner > .prev {\n  position: absolute;\n  top: 0;\n  width: 100%;\n}\n.carousel-inner > .next {\n  left: 100%;\n}\n.carousel-inner > .prev {\n  left: -100%;\n}\n.carousel-inner > .next.left,\n.carousel-inner > .prev.right {\n  left: 0;\n}\n.carousel-inner > .active.left {\n  left: -100%;\n}\n.carousel-inner > .active.right {\n  left: 100%;\n}\n.carousel-control {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  width: 15%;\n  font-size: 20px;\n  color: #fff;\n  text-align: center;\n  text-shadow: 0 1px 2px rgba(0, 0, 0, .6);\n  background-color: rgba(0, 0, 0, 0);\n  filter: alpha(opacity=50);\n  opacity: .5;\n}\n.carousel-control.left {\n  background-image: -webkit-linear-gradient(left, rgba(0, 0, 0, .5) 0%, rgba(0, 0, 0, .0001) 100%);\n  background-image:      -o-linear-gradient(left, rgba(0, 0, 0, .5) 0%, rgba(0, 0, 0, .0001) 100%);\n  background-image: -webkit-gradient(linear, left top, right top, from(rgba(0, 0, 0, .5)), to(rgba(0, 0, 0, .0001)));\n  background-image:         linear-gradient(to right, rgba(0, 0, 0, .5) 0%, rgba(0, 0, 0, .0001) 100%);\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr=\'#80000000\', endColorstr=\'#00000000\', GradientType=1);\n  background-repeat: repeat-x;\n}\n.carousel-control.right {\n  right: 0;\n  left: auto;\n  background-image: -webkit-linear-gradient(left, rgba(0, 0, 0, .0001) 0%, rgba(0, 0, 0, .5) 100%);\n  background-image:      -o-linear-gradient(left, rgba(0, 0, 0, .0001) 0%, rgba(0, 0, 0, .5) 100%);\n  background-image: -webkit-gradient(linear, left top, right top, from(rgba(0, 0, 0, .0001)), to(rgba(0, 0, 0, .5)));\n  background-image:         linear-gradient(to right, rgba(0, 0, 0, .0001) 0%, rgba(0, 0, 0, .5) 100%);\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr=\'#00000000\', endColorstr=\'#80000000\', GradientType=1);\n  background-repeat: repeat-x;\n}\n.carousel-control:hover,\n.carousel-control:focus {\n  color: #fff;\n  text-decoration: none;\n  filter: alpha(opacity=90);\n  outline: 0;\n  opacity: .9;\n}\n.carousel-control .icon-prev,\n.carousel-control .icon-next,\n.carousel-control .glyphicon-chevron-left,\n.carousel-control .glyphicon-chevron-right {\n  position: absolute;\n  top: 50%;\n  z-index: 5;\n  display: inline-block;\n  margin-top: -10px;\n}\n.carousel-control .icon-prev,\n.carousel-control .glyphicon-chevron-left {\n  left: 50%;\n  margin-left: -10px;\n}\n.carousel-control .icon-next,\n.carousel-control .glyphicon-chevron-right {\n  right: 50%;\n  margin-right: -10px;\n}\n.carousel-control .icon-prev,\n.carousel-control .icon-next {\n  width: 20px;\n  height: 20px;\n  font-family: serif;\n  line-height: 1;\n}\n.carousel-control .icon-prev:before {\n  content: \'\\2039\';\n}\n.carousel-control .icon-next:before {\n  content: \'\\203a\';\n}\n.carousel-indicators {\n  position: absolute;\n  bottom: 10px;\n  left: 50%;\n  z-index: 15;\n  width: 60%;\n  padding-left: 0;\n  margin-left: -30%;\n  text-align: center;\n  list-style: none;\n}\n.carousel-indicators li {\n  display: inline-block;\n  width: 10px;\n  height: 10px;\n  margin: 1px;\n  text-indent: -999px;\n  cursor: pointer;\n  background-color: #000 \\9;\n  background-color: rgba(0, 0, 0, 0);\n  border: 1px solid #fff;\n  border-radius: 10px;\n}\n.carousel-indicators .active {\n  width: 12px;\n  height: 12px;\n  margin: 0;\n  background-color: #fff;\n}\n.carousel-caption {\n  position: absolute;\n  right: 15%;\n  bottom: 20px;\n  left: 15%;\n  z-index: 10;\n  padding-top: 20px;\n  padding-bottom: 20px;\n  color: #fff;\n  text-align: center;\n  text-shadow: 0 1px 2px rgba(0, 0, 0, .6);\n}\n.carousel-caption .btn {\n  text-shadow: none;\n}\n@media screen and (min-width: 768px) {\n  .carousel-control .glyphicon-chevron-left,\n  .carousel-control .glyphicon-chevron-right,\n  .carousel-control .icon-prev,\n  .carousel-control .icon-next {\n    width: 30px;\n    height: 30px;\n    margin-top: -10px;\n    font-size: 30px;\n  }\n  .carousel-control .glyphicon-chevron-left,\n  .carousel-control .icon-prev {\n    margin-left: -10px;\n  }\n  .carousel-control .glyphicon-chevron-right,\n  .carousel-control .icon-next {\n    margin-right: -10px;\n  }\n  .carousel-caption {\n    right: 20%;\n    left: 20%;\n    padding-bottom: 30px;\n  }\n  .carousel-indicators {\n    bottom: 20px;\n  }\n}\n.clearfix:before,\n.clearfix:after,\n.dl-horizontal dd:before,\n.dl-horizontal dd:after,\n.container:before,\n.container:after,\n.container-fluid:before,\n.container-fluid:after,\n.row:before,\n.row:after,\n.form-horizontal .form-group:before,\n.form-horizontal .form-group:after,\n.btn-toolbar:before,\n.btn-toolbar:after,\n.btn-group-vertical > .btn-group:before,\n.btn-group-vertical > .btn-group:after,\n.nav:before,\n.nav:after,\n.navbar:before,\n.navbar:after,\n.navbar-header:before,\n.navbar-header:after,\n.navbar-collapse:before,\n.navbar-collapse:after,\n.pager:before,\n.pager:after,\n.panel-body:before,\n.panel-body:after,\n.modal-header:before,\n.modal-header:after,\n.modal-footer:before,\n.modal-footer:after {\n  display: table;\n  content: " ";\n}\n.clearfix:after,\n.dl-horizontal dd:after,\n.container:after,\n.container-fluid:after,\n.row:after,\n.form-horizontal .form-group:after,\n.btn-toolbar:after,\n.btn-group-vertical > .btn-group:after,\n.nav:after,\n.navbar:after,\n.navbar-header:after,\n.navbar-collapse:after,\n.pager:after,\n.panel-body:after,\n.modal-header:after,\n.modal-footer:after {\n  clear: both;\n}\n.center-block {\n  display: block;\n  margin-right: auto;\n  margin-left: auto;\n}\n.pull-right {\n  float: right !important;\n}\n.pull-left {\n  float: left !important;\n}\n.hide {\n  display: none !important;\n}\n.show {\n  display: block !important;\n}\n.invisible {\n  visibility: hidden;\n}\n.text-hide {\n  font: 0/0 a;\n  color: transparent;\n  text-shadow: none;\n  background-color: transparent;\n  border: 0;\n}\n.hidden {\n  display: none !important;\n}\n.affix {\n  position: fixed;\n}\n@-ms-viewport {\n  width: device-width;\n}\n.visible-xs,\n.visible-sm,\n.visible-md,\n.visible-lg {\n  display: none !important;\n}\n.visible-xs-block,\n.visible-xs-inline,\n.visible-xs-inline-block,\n.visible-sm-block,\n.visible-sm-inline,\n.visible-sm-inline-block,\n.visible-md-block,\n.visible-md-inline,\n.visible-md-inline-block,\n.visible-lg-block,\n.visible-lg-inline,\n.visible-lg-inline-block {\n  display: none !important;\n}\n@media (max-width: 767px) {\n  .visible-xs {\n    display: block !important;\n  }\n  table.visible-xs {\n    display: table !important;\n  }\n  tr.visible-xs {\n    display: table-row !important;\n  }\n  th.visible-xs,\n  td.visible-xs {\n    display: table-cell !important;\n  }\n}\n@media (max-width: 767px) {\n  .visible-xs-block {\n    display: block !important;\n  }\n}\n@media (max-width: 767px) {\n  .visible-xs-inline {\n    display: inline !important;\n  }\n}\n@media (max-width: 767px) {\n  .visible-xs-inline-block {\n    display: inline-block !important;\n  }\n}\n@media (min-width: 768px) and (max-width: 991px) {\n  .visible-sm {\n    display: block !important;\n  }\n  table.visible-sm {\n    display: table !important;\n  }\n  tr.visible-sm {\n    display: table-row !important;\n  }\n  th.visible-sm,\n  td.visible-sm {\n    display: table-cell !important;\n  }\n}\n@media (min-width: 768px) and (max-width: 991px) {\n  .visible-sm-block {\n    display: block !important;\n  }\n}\n@media (min-width: 768px) and (max-width: 991px) {\n  .visible-sm-inline {\n    display: inline !important;\n  }\n}\n@media (min-width: 768px) and (max-width: 991px) {\n  .visible-sm-inline-block {\n    display: inline-block !important;\n  }\n}\n@media (min-width: 992px) and (max-width: 1199px) {\n  .visible-md {\n    display: block !important;\n  }\n  table.visible-md {\n    display: table !important;\n  }\n  tr.visible-md {\n    display: table-row !important;\n  }\n  th.visible-md,\n  td.visible-md {\n    display: table-cell !important;\n  }\n}\n@media (min-width: 992px) and (max-width: 1199px) {\n  .visible-md-block {\n    display: block !important;\n  }\n}\n@media (min-width: 992px) and (max-width: 1199px) {\n  .visible-md-inline {\n    display: inline !important;\n  }\n}\n@media (min-width: 992px) and (max-width: 1199px) {\n  .visible-md-inline-block {\n    display: inline-block !important;\n  }\n}\n@media (min-width: 1200px) {\n  .visible-lg {\n    display: block !important;\n  }\n  table.visible-lg {\n    display: table !important;\n  }\n  tr.visible-lg {\n    display: table-row !important;\n  }\n  th.visible-lg,\n  td.visible-lg {\n    display: table-cell !important;\n  }\n}\n@media (min-width: 1200px) {\n  .visible-lg-block {\n    display: block !important;\n  }\n}\n@media (min-width: 1200px) {\n  .visible-lg-inline {\n    display: inline !important;\n  }\n}\n@media (min-width: 1200px) {\n  .visible-lg-inline-block {\n    display: inline-block !important;\n  }\n}\n@media (max-width: 767px) {\n  .hidden-xs {\n    display: none !important;\n  }\n}\n@media (min-width: 768px) and (max-width: 991px) {\n  .hidden-sm {\n    display: none !important;\n  }\n}\n@media (min-width: 992px) and (max-width: 1199px) {\n  .hidden-md {\n    display: none !important;\n  }\n}\n@media (min-width: 1200px) {\n  .hidden-lg {\n    display: none !important;\n  }\n}\n.visible-print {\n  display: none !important;\n}\n@media print {\n  .visible-print {\n    display: block !important;\n  }\n  table.visible-print {\n    display: table !important;\n  }\n  tr.visible-print {\n    display: table-row !important;\n  }\n  th.visible-print,\n  td.visible-print {\n    display: table-cell !important;\n  }\n}\n.visible-print-block {\n  display: none !important;\n}\n@media print {\n  .visible-print-block {\n    display: block !important;\n  }\n}\n.visible-print-inline {\n  display: none !important;\n}\n@media print {\n  .visible-print-inline {\n    display: inline !important;\n  }\n}\n.visible-print-inline-block {\n  display: none !important;\n}\n@media print {\n  .visible-print-inline-block {\n    display: inline-block !important;\n  }\n}\n@media print {\n  .hidden-print {\n    display: none !important;\n  }\n}\n\n'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3NyYy91aS9ub2RlX21vZHVsZXMvYm9vdHN0cmFwL2Rpc3QvY3NzL2Jvb3RzdHJhcC5jc3MubmdzdHlsZS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL3NyYy91aS9ub2RlX21vZHVsZXMvYm9vdHN0cmFwL2Rpc3QvY3NzL2Jvb3RzdHJhcC5jc3MiXSwic291cmNlc0NvbnRlbnQiOlsiICJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7OyJ9
//# sourceMappingURL=bootstrap.css.ngstyle.js.map

/***/ }),
/* 529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RenderType_AppComponent */
/* unused harmony export View_AppComponent_0 */
/* unused harmony export View_AppComponent_Host_0 */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AppComponentNgFactory; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__app_component_scss_shim_ngstyle__ = __webpack_require__(530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_common__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__headerfooter_header_component_ngfactory__ = __webpack_require__(536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_app_headerfooter_header_component__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__angular_router__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_app_user_user_service__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_app_headerfooter_header_service__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_app_trial_trial_service__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_app_main_config_config_service__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_app_systeminformation_systeminformation_service__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_app_app_component__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_app_publisher_publisher_service__ = __webpack_require__(31);
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */













var styles_AppComponent = [__WEBPACK_IMPORTED_MODULE_0__app_component_scss_shim_ngstyle__["a" /* styles */]];
var RenderType_AppComponent = __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵcrt"]({ encapsulation: 0, styles: styles_AppComponent,
    data: {} });
function View_AppComponent_1(_l) {
    return __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵeld"](0, null, null, 6, 'div', [['class',
                'header-area']], null, null, null, null, null)),
        __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵdid"](278528, null, 0, __WEBPACK_IMPORTED_MODULE_2__angular_common__["NgStyle"], [__WEBPACK_IMPORTED_MODULE_1__angular_core__["KeyValueDiffers"], __WEBPACK_IMPORTED_MODULE_1__angular_core__["ElementRef"],
            __WEBPACK_IMPORTED_MODULE_1__angular_core__["Renderer"]], { ngStyle: [0, 'ngStyle'] }, null), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵpod"]({ display: 0 }),
        (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵeld"](0, null, null, 1, 'header', [], null, null, null, __WEBPACK_IMPORTED_MODULE_3__headerfooter_header_component_ngfactory__["a" /* View_HeaderComponent_0 */], __WEBPACK_IMPORTED_MODULE_3__headerfooter_header_component_ngfactory__["b" /* RenderType_HeaderComponent */])), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵdid"](114688, null, 0, __WEBPACK_IMPORTED_MODULE_4__src_app_headerfooter_header_component__["a" /* HeaderComponent */], [__WEBPACK_IMPORTED_MODULE_5__angular_router__["a" /* Router */], __WEBPACK_IMPORTED_MODULE_5__angular_router__["b" /* ActivatedRoute */], __WEBPACK_IMPORTED_MODULE_6__src_app_user_user_service__["a" /* UserService */],
            __WEBPACK_IMPORTED_MODULE_7__src_app_headerfooter_header_service__["a" /* HeaderService */], __WEBPACK_IMPORTED_MODULE_8__src_app_trial_trial_service__["a" /* TrialService */], __WEBPACK_IMPORTED_MODULE_9__src_app_main_config_config_service__["a" /* ConfigService */], __WEBPACK_IMPORTED_MODULE_10__src_app_systeminformation_systeminformation_service__["a" /* SystemInformationService */]], null, null), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n    ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _ck(_v, 2, 0, (((_co.currentRoute === '/trial') || (_co.currentRoute === '/release-notes')) ? 'none' : 'block'));
        _ck(_v, 1, 0, currVal_0);
        _ck(_v, 5, 0);
    }, null);
}
function View_AppComponent_0(_l) {
    return __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵeld"](0, null, null, 10, 'div', [['class',
                'app']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.onClicked() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n    '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵand"](16777216, null, null, 1, null, View_AppComponent_1)),
        __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_2__angular_common__["NgIf"], [__WEBPACK_IMPORTED_MODULE_1__angular_core__["ViewContainerRef"], __WEBPACK_IMPORTED_MODULE_1__angular_core__["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n    '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵeld"](0, null, null, 4, 'div', [['class', 'mainarea']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵeld"](16777216, null, null, 1, 'router-outlet', [], null, null, null, null, null)), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵdid"](212992, null, 0, __WEBPACK_IMPORTED_MODULE_5__angular_router__["z" /* RouterOutlet */], [__WEBPACK_IMPORTED_MODULE_5__angular_router__["q" /* ChildrenOutletContexts */], __WEBPACK_IMPORTED_MODULE_1__angular_core__["ViewContainerRef"], __WEBPACK_IMPORTED_MODULE_1__angular_core__["ComponentFactoryResolver"],
            [8, null], __WEBPACK_IMPORTED_MODULE_1__angular_core__["ChangeDetectorRef"]], null, null),
        (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.isLoggedIn();
        _ck(_v, 3, 0, currVal_0);
        _ck(_v, 8, 0);
    }, null);
}
function View_AppComponent_Host_0(_l) {
    return __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵeld"](0, null, null, 1, 'app', [], null, null, null, View_AppComponent_0, RenderType_AppComponent)),
        __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵdid"](114688, null, 0, __WEBPACK_IMPORTED_MODULE_11__src_app_app_component__["a" /* AppComponent */], [__WEBPACK_IMPORTED_MODULE_6__src_app_user_user_service__["a" /* UserService */], __WEBPACK_IMPORTED_MODULE_12__src_app_publisher_publisher_service__["a" /* PublisherService */],
            __WEBPACK_IMPORTED_MODULE_5__angular_router__["a" /* Router */], __WEBPACK_IMPORTED_MODULE_5__angular_router__["b" /* ActivatedRoute */]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var AppComponentNgFactory = __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵccf"]('app', __WEBPACK_IMPORTED_MODULE_11__src_app_app_component__["a" /* AppComponent */], View_AppComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3NyYy91aS9zcmMvYXBwL2FwcC5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vc3JjL3VpL3NyYy9hcHAvYXBwLmNvbXBvbmVudC50cyIsIm5nOi8vL3NyYy91aS9zcmMvYXBwL2FwcC5jb21wb25lbnQuaHRtbCIsIm5nOi8vL3NyYy91aS9zcmMvYXBwL2FwcC5jb21wb25lbnQudHMuQXBwQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPGRpdiBjbGFzcz1cImFwcFwiIChjbGljayk9XCJvbkNsaWNrZWQoKVwiPlxuICAgIDxkaXYgY2xhc3M9XCJoZWFkZXItYXJlYVwiICpuZ0lmPVwiaXNMb2dnZWRJbigpXCIgW25nU3R5bGVdPVwie2Rpc3BsYXk6IChjdXJyZW50Um91dGUgPT09ICcvdHJpYWwnIHx8IGN1cnJlbnRSb3V0ZSA9PT0gJy9yZWxlYXNlLW5vdGVzJykgPyAnbm9uZScgOiAnYmxvY2snfVwiPlxuICAgICAgICA8aGVhZGVyPjwvaGVhZGVyPlxuICAgIDwvZGl2PlxuICAgIDxkaXYgY2xhc3M9XCJtYWluYXJlYVwiPlxuICAgICAgICA8cm91dGVyLW91dGxldD48L3JvdXRlci1vdXRsZXQ+XG4gICAgPC9kaXY+XG48L2Rpdj4iLCI8YXBwPjwvYXBwPiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7b0JDQ0k7TUFBQTthQUFBO3FCQUFBLGdEQUE4QztNQUEyRywrQ0FDcko7VUFBQTtpRUFBQSxVQUFBO1VBQUE7NEZBQUE7VUFBQSw2QkFBaUI7OztRQUR5QjtRQUE5QyxXQUE4QyxTQUE5QztRQUNJOzs7O29CQUZSO01BQUE7SUFBQTtJQUFBO0lBQWlCO01BQUE7TUFBQTtJQUFBO0lBQWpCO0VBQUEsZ0NBQXVDLDJDQUNuQzthQUFBO2FBQUE7VUFBQSx3QkFFTSwyQ0FDTjtpQkFBQTtjQUFBLDBEQUFzQjtVQUFBLGlCQUNsQjtVQUFBO1VBQUEscUNBQUE7VUFBQTtjQUFBO01BQStCLDJDQUM3Qjs7O1FBTG1CO1FBQXpCLFdBQXlCLFNBQXpCO1FBSUk7Ozs7b0JDTFI7TUFBQTthQUFBO3FDQUFBO0lBQUE7Ozs7In0=
//# sourceMappingURL=app.component.ngfactory.js.map

/***/ }),
/* 530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return styles; });
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */
var styles = ['.mainarea[_ngcontent-%COMP%] {\n  flex: 1;\n  margin-top: -18px; }\n\n.header-area[_ngcontent-%COMP%] {\n  width: 100%;\n  height: 40px;\n  min-height: 40px;\n  flex: 0;\n  background-color: #1D1D1D;\n  z-index: 20; }\n\n.app[_ngcontent-%COMP%] {\n  display: flex;\n  flex-direction: column;\n  height: 100%; }'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3NyYy91aS9zcmMvYXBwL2FwcC5jb21wb25lbnQuc2Nzcy5zaGltLm5nc3R5bGUudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9zcmMvdWkvc3JjL2FwcC9hcHAuY29tcG9uZW50LnNjc3MiXSwic291cmNlc0NvbnRlbnQiOlsiICJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7OyJ9
//# sourceMappingURL=app.component.scss.shim.ngstyle.js.map

/***/ }),
/* 531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RenderType_GaugeComponent; });
/* harmony export (immutable) */ __webpack_exports__["a"] = View_GaugeComponent_0;
/* unused harmony export View_GaugeComponent_Host_0 */
/* unused harmony export GaugeComponentNgFactory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__gauge_component_scss_shim_ngstyle__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_bootstrap_dist_css_bootstrap_css_shim_ngstyle__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_core__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_app_components_gauge_gauge_component__ = __webpack_require__(311);
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */




var styles_GaugeComponent = [__WEBPACK_IMPORTED_MODULE_0__gauge_component_scss_shim_ngstyle__["a" /* styles */], __WEBPACK_IMPORTED_MODULE_1__node_modules_bootstrap_dist_css_bootstrap_css_shim_ngstyle__["a" /* styles */]];
var RenderType_GaugeComponent = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵcrt"]({ encapsulation: 0,
    styles: styles_GaugeComponent, data: {} });
function View_GaugeComponent_0(_l) {
    return __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵvid"](0, [__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵqud"](402653184, 1, { chartContainer: 0 }), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, [[1,
                0], ['gauge', 1]], null, 0, 'div', [['class', 'd3-chart']], null, null, null, null, null))], null, null);
}
function View_GaugeComponent_Host_0(_l) {
    return __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'ixgauge', [], null, null, null, View_GaugeComponent_0, RenderType_GaugeComponent)),
        __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](114688, null, 0, __WEBPACK_IMPORTED_MODULE_3__src_app_components_gauge_gauge_component__["a" /* GaugeComponent */], [], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var GaugeComponentNgFactory = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵccf"]('ixgauge', __WEBPACK_IMPORTED_MODULE_3__src_app_components_gauge_gauge_component__["a" /* GaugeComponent */], View_GaugeComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3NyYy91aS9zcmMvYXBwL2NvbXBvbmVudHMvZ2F1Z2UvZ2F1Z2UuY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL3NyYy91aS9zcmMvYXBwL2NvbXBvbmVudHMvZ2F1Z2UvZ2F1Z2UuY29tcG9uZW50LnRzIiwibmc6Ly8vc3JjL3VpL3NyYy9hcHAvY29tcG9uZW50cy9nYXVnZS9nYXVnZS5jb21wb25lbnQuaHRtbCIsIm5nOi8vL3NyYy91aS9zcmMvYXBwL2NvbXBvbmVudHMvZ2F1Z2UvZ2F1Z2UuY29tcG9uZW50LnRzLkdhdWdlQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPGRpdiBjbGFzcz1cImQzLWNoYXJ0XCIgI2dhdWdlPjwvZGl2PiIsIjxpeGdhdWdlPjwvaXhnYXVnZT4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7OzREQ0FBO01BQUE7TUFBQTs7O29CQ0FBO01BQUE7YUFBQTtVQUFBO0lBQUE7Ozs7In0=
//# sourceMappingURL=gauge.component.ngfactory.js.map

/***/ }),
/* 532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return styles; });
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */
var styles = [''];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3NyYy91aS9zcmMvYXBwL2NvbXBvbmVudHMvZ2F1Z2UvZ2F1Z2UuY29tcG9uZW50LnNjc3Muc2hpbS5uZ3N0eWxlLnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vc3JjL3VpL3NyYy9hcHAvY29tcG9uZW50cy9nYXVnZS9nYXVnZS5jb21wb25lbnQuc2NzcyJdLCJzb3VyY2VzQ29udGVudCI6WyIgIl0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7In0=
//# sourceMappingURL=gauge.component.scss.shim.ngstyle.js.map

/***/ }),
/* 533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return styles; });
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */
var styles = ['.bg-striped[_ngcontent-%COMP%]{\n    margin: 0;\n    height: 45px !important;\n    background-color: gray;\n    border-radius: 0 !important;\n    background-image: repeating-linear-gradient(-45deg, transparent, transparent 25px, rgba(255,255,255,.5) 25px, rgba(255,255,255,.5) 45px);\n}\n\n.progress-bar-cloud[_ngcontent-%COMP%]{\n    height: 45px !important;\n    background-color: #000000 !important;\n    opacity: 0.7;\n    border-radius: 0 !important;\n    line-height: 45px !important;\n}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3NyYy91aS9zcmMvYXBwL2NvbXBvbmVudHMvcHJvZ3Jlc3NiYXIvcHJvZ3Jlc3NiYXIuY29tcG9uZW50LmNzcy5zaGltLm5nc3R5bGUudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9zcmMvdWkvc3JjL2FwcC9jb21wb25lbnRzL3Byb2dyZXNzYmFyL3Byb2dyZXNzYmFyLmNvbXBvbmVudC5jc3MiXSwic291cmNlc0NvbnRlbnQiOlsiICJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7OyJ9
//# sourceMappingURL=progressbar.component.css.shim.ngstyle.js.map

/***/ }),
/* 534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RenderType_HeaderMenuComponent; });
/* harmony export (immutable) */ __webpack_exports__["a"] = View_HeaderMenuComponent_0;
/* unused harmony export View_HeaderMenuComponent_Host_0 */
/* unused harmony export HeaderMenuComponentNgFactory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__header_menu_component_scss_shim_ngstyle__ = __webpack_require__(535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_common__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_app_headerfooter_header_menu_component__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_app_publisher_publisher_service__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_app_headerfooter_header_service__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_app_user_user_service__ = __webpack_require__(12);
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */







var styles_HeaderMenuComponent = [__WEBPACK_IMPORTED_MODULE_0__header_menu_component_scss_shim_ngstyle__["a" /* styles */]];
var RenderType_HeaderMenuComponent = __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵcrt"]({ encapsulation: 0,
    styles: styles_HeaderMenuComponent, data: {} });
function View_HeaderMenuComponent_1(_l) {
    return __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵeld"](0, null, null, 3, 'div', [['class',
                'arrow']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n			'])), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵeld"](0, null, null, 0, 'div', [['class', 'arrow-pic']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n		']))], null, null);
}
function View_HeaderMenuComponent_3(_l) {
    return __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵeld"](0, null, null, 10, 'div', [], null, null, null, null, null)), (_l()(),
            __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n					'])), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵeld"](0, null, null, 7, 'div', [['class', 'popup-box'], ['id', 'header-menu-popup-box']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n						'])), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵeld"](0, null, null, 4, 'div', [['class',
                'popup-entry item-management']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.popupClicked($event, '') !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n							'])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵeld"](0, null, null, 1, 'span', [['class', 'popup-span']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['', ''])), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n						'])), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n					'])), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n				']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.headerService.defaultItemLabel;
        _ck(_v, 7, 0, currVal_0);
    });
}
function View_HeaderMenuComponent_2(_l) {
    return __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵeld"](0, null, null, 7, 'div', [['class',
                'item-name']], [[2, 'item-name-hover', null]], [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.itemClicked($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n				'])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵeld"](0, null, null, 1, 'span', [], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, [' ', ''])), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n				'])), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵand"](16777216, null, null, 1, null, View_HeaderMenuComponent_3)), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_2__angular_common__["NgIf"], [__WEBPACK_IMPORTED_MODULE_1__angular_core__["ViewContainerRef"], __WEBPACK_IMPORTED_MODULE_1__angular_core__["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n			']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_2 = (_co.headerService.showPopup === true);
        _ck(_v, 6, 0, currVal_2);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.headerService.showPopup;
        _ck(_v, 0, 0, currVal_0);
        var currVal_1 = _co.headerService.activeItem;
        _ck(_v, 3, 0, currVal_1);
    });
}
function View_HeaderMenuComponent_4(_l) {
    return __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵeld"](0, null, null, 4, 'div', [], null, null, null, null, null)), (_l()(),
            __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n				'])), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵeld"](0, null, null, 1, 'span', [['class', 'item-name-no-hover']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, [' ', ''])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n			']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.headerService.labelValue;
        _ck(_v, 3, 0, currVal_0);
    });
}
function View_HeaderMenuComponent_6(_l) {
    return __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵeld"](0, null, null, 9, 'div', [], null, null, null, null, null)), (_l()(),
            __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n							'])), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵeld"](0, null, null, 4, 'div', [['class', 'popup-entry']], [[8, 'id', 0]], [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.onEntryClicked($event, _v.context.$implicit) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n								'])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵeld"](0, null, null, 1, 'span', [['class', 'popup-span']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, [' ', ' '])), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n							'])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n							'])), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵeld"](0, null, null, 0, 'hr', [['class', 'hr-separator']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n						']))], null, function (_ck, _v) {
        var currVal_0 = __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵinlineInterpolate"](1, 'navMenuBtn', _v.context.$implicit.label, '');
        _ck(_v, 2, 0, currVal_0);
        var currVal_1 = _v.context.$implicit.label;
        _ck(_v, 5, 0, currVal_1);
    });
}
function View_HeaderMenuComponent_5(_l) {
    return __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵeld"](0, null, null, 7, 'div', [], null, null, null, null, null)), (_l()(),
            __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n					'])), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵeld"](0, null, null, 4, 'div', [['class', 'settings-popup-box'], ['id', 'header-menu-settings-popup-box']], null, null, null, null, null)), (_l()(),
            __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n						'])), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵand"](16777216, null, null, 1, null, View_HeaderMenuComponent_6)), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵdid"](802816, null, 0, __WEBPACK_IMPORTED_MODULE_2__angular_common__["NgForOf"], [__WEBPACK_IMPORTED_MODULE_1__angular_core__["ViewContainerRef"], __WEBPACK_IMPORTED_MODULE_1__angular_core__["TemplateRef"], __WEBPACK_IMPORTED_MODULE_1__angular_core__["IterableDiffers"]], { ngForOf: [0,
                'ngForOf'] }, null), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n					'])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n				']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.settingEntries;
        _ck(_v, 5, 0, currVal_0);
    }, null);
}
function View_HeaderMenuComponent_0(_l) {
    return __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵeld"](0, null, null, 34, 'div', [['class',
                'container']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n	'])), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵeld"](0, null, null, 14, 'div', [['class', 'menu-container'], ['id', 'menu-container']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n		'])), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵand"](16777216, null, null, 1, null, View_HeaderMenuComponent_1)), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_2__angular_common__["NgIf"], [__WEBPACK_IMPORTED_MODULE_1__angular_core__["ViewContainerRef"],
            __WEBPACK_IMPORTED_MODULE_1__angular_core__["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n		'])), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵeld"](0, null, null, 8, 'div', [], null, null, null, null, null)),
        __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_2__angular_common__["NgSwitch"], [], { ngSwitch: [0, 'ngSwitch'] }, null), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n			'])), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵand"](16777216, null, null, 1, null, View_HeaderMenuComponent_2)),
        __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵdid"](278528, null, 0, __WEBPACK_IMPORTED_MODULE_2__angular_common__["NgSwitchCase"], [__WEBPACK_IMPORTED_MODULE_1__angular_core__["ViewContainerRef"], __WEBPACK_IMPORTED_MODULE_1__angular_core__["TemplateRef"],
            __WEBPACK_IMPORTED_MODULE_2__angular_common__["NgSwitch"]], { ngSwitchCase: [0, 'ngSwitchCase'] }, null), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n			'])), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵand"](16777216, null, null, 1, null, View_HeaderMenuComponent_4)), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵdid"](278528, null, 0, __WEBPACK_IMPORTED_MODULE_2__angular_common__["NgSwitchCase"], [__WEBPACK_IMPORTED_MODULE_1__angular_core__["ViewContainerRef"], __WEBPACK_IMPORTED_MODULE_1__angular_core__["TemplateRef"], __WEBPACK_IMPORTED_MODULE_2__angular_common__["NgSwitch"]], { ngSwitchCase: [0, 'ngSwitchCase'] }, null), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n		'])), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n	'])), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n	'])), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n	'])), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵeld"](0, null, null, 14, 'div', [['class',
                'settings-wrapper']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.onSettingsClicked($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵdid"](278528, null, 0, __WEBPACK_IMPORTED_MODULE_2__angular_common__["NgClass"], [__WEBPACK_IMPORTED_MODULE_1__angular_core__["IterableDiffers"],
            __WEBPACK_IMPORTED_MODULE_1__angular_core__["KeyValueDiffers"], __WEBPACK_IMPORTED_MODULE_1__angular_core__["ElementRef"], __WEBPACK_IMPORTED_MODULE_1__angular_core__["Renderer"]], { klass: [0, 'klass'], ngClass: [1,
                'ngClass'] }, null), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵpod"]({ 'settings-wrapper': 0, 'settings-wrapper-hover': 1 }),
        (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n		'])), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵeld"](0, null, null, 9, 'div', [['class', 'settings']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n			'])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵeld"](0, null, null, 6, 'div', [], null, null, null, null, null)), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵdid"](278528, null, 0, __WEBPACK_IMPORTED_MODULE_2__angular_common__["NgClass"], [__WEBPACK_IMPORTED_MODULE_1__angular_core__["IterableDiffers"], __WEBPACK_IMPORTED_MODULE_1__angular_core__["KeyValueDiffers"], __WEBPACK_IMPORTED_MODULE_1__angular_core__["ElementRef"],
            __WEBPACK_IMPORTED_MODULE_1__angular_core__["Renderer"]], { ngClass: [0, 'ngClass'] }, null), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵpod"]({ 'settings-pic': 0,
            'settings-pic-hover': 1 }), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n				'])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵand"](16777216, null, null, 1, null, View_HeaderMenuComponent_5)),
        __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_2__angular_common__["NgIf"], [__WEBPACK_IMPORTED_MODULE_1__angular_core__["ViewContainerRef"], __WEBPACK_IMPORTED_MODULE_1__angular_core__["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n			'])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n		'])), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n	'])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.headerService.showArrow;
        _ck(_v, 5, 0, currVal_0);
        var currVal_1 = _co.headerService.mode;
        _ck(_v, 8, 0, currVal_1);
        var currVal_2 = 'items';
        _ck(_v, 11, 0, currVal_2);
        var currVal_3 = 'label';
        _ck(_v, 14, 0, currVal_3);
        var currVal_4 = 'settings-wrapper';
        var currVal_5 = _ck(_v, 21, 0, !_co.showSettingsPopup, _co.showSettingsPopup);
        _ck(_v, 20, 0, currVal_4, currVal_5);
        var currVal_6 = _ck(_v, 27, 0, !_co.showSettingsPopup, _co.showSettingsPopup);
        _ck(_v, 26, 0, currVal_6);
        var currVal_7 = (_co.showSettingsPopup === true);
        _ck(_v, 30, 0, currVal_7);
    }, null);
}
function View_HeaderMenuComponent_Host_0(_l) {
    return __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵeld"](16777216, null, null, 1, 'header-menu', [], null, null, null, View_HeaderMenuComponent_0, RenderType_HeaderMenuComponent)), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵdid"](245760, null, 0, __WEBPACK_IMPORTED_MODULE_3__src_app_headerfooter_header_menu_component__["a" /* HeaderMenuComponent */], [__WEBPACK_IMPORTED_MODULE_4__src_app_publisher_publisher_service__["a" /* PublisherService */], __WEBPACK_IMPORTED_MODULE_1__angular_core__["ViewContainerRef"], __WEBPACK_IMPORTED_MODULE_1__angular_core__["ComponentFactoryResolver"], __WEBPACK_IMPORTED_MODULE_5__src_app_headerfooter_header_service__["a" /* HeaderService */],
            __WEBPACK_IMPORTED_MODULE_6__src_app_user_user_service__["a" /* UserService */], __WEBPACK_IMPORTED_MODULE_1__angular_core__["ChangeDetectorRef"], 'SettingsEntry'], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var HeaderMenuComponentNgFactory = __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵccf"]('header-menu', __WEBPACK_IMPORTED_MODULE_3__src_app_headerfooter_header_menu_component__["a" /* HeaderMenuComponent */], View_HeaderMenuComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=header-menu.component.ngfactory.js.map

/***/ }),
/* 535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return styles; });
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */
var styles = ['.menu-container[_ngcontent-%COMP%] {\n  display: flex;\n  flex-direction: row;\n  color: white;\n  text-align: center;\n  align-items: center;\n  height: 100%;\n  flex: 2; }\n\n.item-name-no-hover[_ngcontent-%COMP%] {\n  margin-left: 10px;\n  margin-right: 10px;\n  font-size: 14px;\n  color: #ffffff;\n  display: flex;\n  flex-direction: row-reverse;\n  height: 100%;\n  align-items: center;\n  cursor: pointer;\n  cursor: default; }\n\n.item-name[_ngcontent-%COMP%] {\n  margin-left: 10px;\n  margin-right: 10px;\n  font-size: 14px;\n  color: #ffffff;\n  display: flex;\n  flex-direction: row-reverse;\n  height: 100%;\n  align-items: center;\n  cursor: pointer; }\n\n.item-name[_ngcontent-%COMP%]:hover {\n  background-color: #343434; }\n\n.item-name-hover[_ngcontent-%COMP%] {\n  background-color: #343434; }\n\n.popup-box[_ngcontent-%COMP%] {\n  z-index: 1000;\n  top: 44px;\n  position: absolute;\n  background-color: #1d1d1d;\n  border: 1px solid #5a5a64;\n  display: flex;\n  white-space: nowrap;\n  flex-direction: column;\n  justify-content: center; }\n\n.settings-popup-box[_ngcontent-%COMP%] {\n  z-index: 1000;\n  top: 44px;\n  position: absolute;\n  background-color: #1d1d1d;\n  border: 1px solid #5a5a64;\n  display: flex;\n  white-space: nowrap;\n  flex-direction: column;\n  justify-content: center;\n  word-break: keep-all;\n  transform: translateX(-175px); }\n\n.popup-entry[_ngcontent-%COMP%] {\n  padding-left: 20px;\n  padding-right: 20px;\n  height: 50px;\n  font-size: 14px;\n  color: #ffffff;\n  text-align: center;\n  display: flex;\n  cursor: pointer; }\n\n.popup-entry[_ngcontent-%COMP%]:hover {\n  background-color: #343434; }\n\n.popup-span[_ngcontent-%COMP%] {\n  text-align: center;\n  margin: auto;\n  margin-left: 0px;\n  cursor: pointer;\n  opacity: 1;\n  font-size: 13px; }\n\n.item-management[_ngcontent-%COMP%] {\n  color: #1492e6;\n  cursor: pointer;\n  font-size: 14px; }\n\n.hr-separator[_ngcontent-%COMP%] {\n  border-top: 1px;\n  border-color: #3f3f3f;\n  margin: 0px; }\n\n.download-label[_ngcontent-%COMP%] {\n  text-decoration: none; }\n\n.arrow-pic[_ngcontent-%COMP%] {\n  background-image: url(/assets/breadcrumbs-arrow.5ed8bca543651ba5e121185ed979e93b.svg);\n  height: 16px;\n  width: 10px; }\n\n.arrow[_ngcontent-%COMP%] {\n  padding-left: 10px; }\n\n.settings-wrapper[_ngcontent-%COMP%] {\n  cursor: pointer; }\n\n.settings-wrapper-hover[_ngcontent-%COMP%] {\n  background-color: #343434; }\n\n.settings-wrapper[_ngcontent-%COMP%]:hover {\n  background-color: #343434; }\n\n.settings-pic[_ngcontent-%COMP%] {\n  background-image: url(/assets/gear.1399860380cbf7405dfe8dace0c20225.svg);\n  height: 40px;\n  width: 40px; }\n\n.settings-pic-hover[_ngcontent-%COMP%] {\n  background-image: url(/assets/gear.1399860380cbf7405dfe8dace0c20225.svg);\n  height: 40px;\n  width: 40px;\n  background-image: url(/assets/gear_clicked.d9ee945583d552a1d4fb77f5244e6267.svg); }\n\n.settings-pic[_ngcontent-%COMP%]:hover {\n  background-image: url(/assets/gear_clicked.d9ee945583d552a1d4fb77f5244e6267.svg); }\n\n.container[_ngcontent-%COMP%] {\n  display: flex;\n  justify-content: flex-end;\n  width: 100%; }\n\n.user-name[_ngcontent-%COMP%] {\n  color: #ffffff;\n  align-self: center;\n  padding-right: 10px;\n  cursor: default;\n  font-size: 13px; }'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3NyYy91aS9zcmMvYXBwL2hlYWRlcmZvb3Rlci9oZWFkZXItbWVudS5jb21wb25lbnQuc2Nzcy5zaGltLm5nc3R5bGUudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9zcmMvdWkvc3JjL2FwcC9oZWFkZXJmb290ZXIvaGVhZGVyLW1lbnUuY29tcG9uZW50LnNjc3MiXSwic291cmNlc0NvbnRlbnQiOlsiICJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7OyJ9
//# sourceMappingURL=header-menu.component.scss.shim.ngstyle.js.map

/***/ }),
/* 536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RenderType_HeaderComponent; });
/* harmony export (immutable) */ __webpack_exports__["a"] = View_HeaderComponent_0;
/* unused harmony export View_HeaderComponent_Host_0 */
/* unused harmony export HeaderComponentNgFactory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__header_component_scss_shim_ngstyle__ = __webpack_require__(537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_bootstrap_dist_css_bootstrap_css_shim_ngstyle__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_core__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__angular_common__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_app_headerfooter_header_component__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__header_menu_component_ngfactory__ = __webpack_require__(534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_app_headerfooter_header_menu_component__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_app_publisher_publisher_service__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_app_headerfooter_header_service__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_app_user_user_service__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__angular_router__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_app_trial_trial_service__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_app_main_config_config_service__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_app_systeminformation_systeminformation_service__ = __webpack_require__(46);
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */














var styles_HeaderComponent = [__WEBPACK_IMPORTED_MODULE_0__header_component_scss_shim_ngstyle__["a" /* styles */], __WEBPACK_IMPORTED_MODULE_1__node_modules_bootstrap_dist_css_bootstrap_css_shim_ngstyle__["a" /* styles */]];
var RenderType_HeaderComponent = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵcrt"]({ encapsulation: 0,
    styles: styles_HeaderComponent, data: {} });
function View_HeaderComponent_1(_l) {
    return __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 8, 'div', [['class',
                'clearfix  visible-sm-block visible-md-block visible-lg-block trial_mode'], ['id',
                'trialModeMessageLarge']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['Running in trial mode.\n        '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 3, 'font', [], null, null, null, null, null)), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](278528, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_common__["NgClass"], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["IterableDiffers"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["KeyValueDiffers"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["ElementRef"],
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["Renderer"]], { ngClass: [0, 'ngClass'] }, null), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵpod"]({ 'trail_countdown': 0,
            'trail_countdown_done': 1 }), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['', ''])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, [' of free traffic remaining. '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'a', [['class', 'buy_trial_font'], ['role', 'button']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.buyNowClick() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['Buy Now!']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _ck(_v, 4, 0, _co.hasTrialDataLeft, !_co.hasTrialDataLeft);
        _ck(_v, 3, 0, currVal_0);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_1 = _co.trialData;
        _ck(_v, 5, 0, currVal_1);
    });
}
function View_HeaderComponent_2(_l) {
    return __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 12, 'div', [['class',
                'clearfix  visible-xs-block trial_mode_sm'], ['id', 'trialModeMessageSmall']], null, null, null, null, null)), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n      Running in trial mode.\n      '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 5, 'div', [], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 3, 'font', [], null, null, null, null, null)), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](278528, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_common__["NgClass"], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["IterableDiffers"],
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["KeyValueDiffers"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["ElementRef"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["Renderer"]], { ngClass: [0, 'ngClass'] }, null),
        __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵpod"]({ 'trail_countdown': 0, 'trail_countdown_done': 1 }), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['', ''])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, [' of free traffic remaining.'])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n      '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 2, 'div', [], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'a', [['class', 'buy_trial_font'], ['href', '#']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['Buy Now!'])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n    ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _ck(_v, 5, 0, _co.hasTrailDataLeft, !_co.hasTrailDataLeft);
        _ck(_v, 4, 0, currVal_0);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_1 = _co.trialData;
        _ck(_v, 6, 0, currVal_1);
    });
}
function View_HeaderComponent_3(_l) {
    return __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'div', [['class', 'clearfix  visible-sm-block visible-md-block visible-lg-block data_usage'],
            ['id', 'current-usage']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            Data Usage: ',
            ' GB / ', ' GB\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n\n        '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 10, 'div', [['class', 'clearfix  visible-xs-block data_usage_sm'],
            ['id', 'current-usage']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'div', [], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['Data Usage:'])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'div', [], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['', ' GB /'])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'div', [], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['', ' GB'])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n    ']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.consume;
        var currVal_1 = _co.threshold;
        _ck(_v, 2, 0, currVal_0, currVal_1);
        var currVal_2 = _co.consume;
        _ck(_v, 10, 0, currVal_2);
        var currVal_3 = _co.threshold;
        _ck(_v, 13, 0, currVal_3);
    });
}
function View_HeaderComponent_0(_l) {
    return __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 62, 'div', [['id',
                'header-component']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 3, 'div', [['class', 'logo'], ['id', 'navBarHome']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.navigateHome() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n        '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 0, 'img', [['class', 'breakingpoint-cloud-logo'],
            ['src', '/assets/logo.ce16449cf57d7db95102b696b4a4355a.svg']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵand"](16777216, null, null, 1, null, View_HeaderComponent_1)), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_common__["NgIf"], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["ViewContainerRef"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["TemplateRef"]], { ngIf: [0, 'ngIf'],
            ngIfElse: [1, 'ngIfElse'] }, null), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n\n    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵand"](16777216, null, null, 1, null, View_HeaderComponent_2)), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_common__["NgIf"], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["ViewContainerRef"],
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n\n    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵand"](0, [['currentUsage', 2]], null, 0, null, View_HeaderComponent_3)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n\n    '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 46, 'div', [['class', 'menurow']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 38, 'div', [['class', 'navbtngroup'], ['style', 'margin-right:10px; ']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n\n            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 35, 'nav', [['class', 'navbar navbar-inverse no-border '], ['style', ' min-height:30px!important; height:35px!important;']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 15, 'ul', [['class', 'nav navbar-nav navbar-right clearfix  visible-sm-block visible-md-block visible-lg-block'],
            ['style', 'min-width:200px !important; margin-top:0px;margin-left:5px;']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 5, 'li', [['id', 'navBarValidation1']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 3, 'a', [['class', 'header-navbtn']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.navigate('') !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](278528, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_common__["NgClass"], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["IterableDiffers"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["KeyValueDiffers"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["ElementRef"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["Renderer"]], { klass: [0,
                'klass'], ngClass: [1, 'ngClass'] }, null), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵpod"]({ 'header-navbtn-active': 0 }),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['VALIDATION'])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, [' '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                    '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 5, 'li', [['id', 'navBarHistory1']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 3, 'a', [['class', 'header-navbtn']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.navigate('history') !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](278528, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_common__["NgClass"], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["IterableDiffers"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["KeyValueDiffers"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["ElementRef"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["Renderer"]], { klass: [0,
                'klass'], ngClass: [1, 'ngClass'] }, null), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵpod"]({ 'header-navbtn-active': 0 }),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['HISTORY'])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, [' '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n\n                '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 15, 'ul', [['class', 'nav navbar-nav navbar-right clearfix  visible-xs-block'],
            ['style', 'min-width:50px !important; margin-top:0px;margin-left:5px;']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 5, 'li', [['id', 'navBarValidation2']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 3, 'a', [['class', 'header-navbtn-sm']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.navigate('') !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](278528, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_common__["NgClass"], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["IterableDiffers"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["KeyValueDiffers"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["ElementRef"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["Renderer"]], { klass: [0,
                'klass'], ngClass: [1, 'ngClass'] }, null), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵpod"]({ 'header-navbtn-active-sm': 0 }),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['VALIDATION'])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, [' '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                    '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 5, 'li', [['id', 'navBarHistory2']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 3, 'a', [['class', 'header-navbtn-sm']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.navigate('history') !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](278528, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_common__["NgClass"], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["IterableDiffers"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["KeyValueDiffers"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["ElementRef"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["Renderer"]], { klass: [0,
                'klass'], ngClass: [1, 'ngClass'] }, null), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵpod"]({ 'header-navbtn-active-sm': 0 }),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['HISTORY'])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, [' '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n        '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n\n\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](16777216, null, null, 1, 'header-menu', [['class', 'menu']], null, null, null, __WEBPACK_IMPORTED_MODULE_5__header_menu_component_ngfactory__["a" /* View_HeaderMenuComponent_0 */], __WEBPACK_IMPORTED_MODULE_5__header_menu_component_ngfactory__["b" /* RenderType_HeaderMenuComponent */])),
        __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](245760, null, 0, __WEBPACK_IMPORTED_MODULE_6__src_app_headerfooter_header_menu_component__["a" /* HeaderMenuComponent */], [__WEBPACK_IMPORTED_MODULE_7__src_app_publisher_publisher_service__["a" /* PublisherService */], __WEBPACK_IMPORTED_MODULE_2__angular_core__["ViewContainerRef"],
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ComponentFactoryResolver"], __WEBPACK_IMPORTED_MODULE_8__src_app_headerfooter_header_service__["a" /* HeaderService */], __WEBPACK_IMPORTED_MODULE_9__src_app_user_user_service__["a" /* UserService */], __WEBPACK_IMPORTED_MODULE_2__angular_core__["ChangeDetectorRef"],
            'SettingsEntry'], null, null), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 0, 'div', [['style',
                'width:20px; ']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n\n    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n'])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n\n'])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.trialMode;
        var currVal_1 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 13);
        _ck(_v, 8, 0, currVal_0, currVal_1);
        var currVal_2 = _co.trialMode;
        _ck(_v, 11, 0, currVal_2);
        var currVal_3 = 'header-navbtn';
        var currVal_4 = _ck(_v, 26, 0, (_co.currentRoute === '/'));
        _ck(_v, 25, 0, currVal_3, currVal_4);
        var currVal_5 = 'header-navbtn';
        var currVal_6 = _ck(_v, 33, 0, (_co.currentRoute === '/history'));
        _ck(_v, 32, 0, currVal_5, currVal_6);
        var currVal_7 = 'header-navbtn-sm';
        var currVal_8 = _ck(_v, 43, 0, (_co.currentRoute === '/'));
        _ck(_v, 42, 0, currVal_7, currVal_8);
        var currVal_9 = 'header-navbtn-sm';
        var currVal_10 = _ck(_v, 50, 0, (_co.currentRoute === '/history'));
        _ck(_v, 49, 0, currVal_9, currVal_10);
        _ck(_v, 58, 0);
    }, null);
}
function View_HeaderComponent_Host_0(_l) {
    return __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'header', [], null, null, null, View_HeaderComponent_0, RenderType_HeaderComponent)),
        __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](114688, null, 0, __WEBPACK_IMPORTED_MODULE_4__src_app_headerfooter_header_component__["a" /* HeaderComponent */], [__WEBPACK_IMPORTED_MODULE_10__angular_router__["a" /* Router */], __WEBPACK_IMPORTED_MODULE_10__angular_router__["b" /* ActivatedRoute */],
            __WEBPACK_IMPORTED_MODULE_9__src_app_user_user_service__["a" /* UserService */], __WEBPACK_IMPORTED_MODULE_8__src_app_headerfooter_header_service__["a" /* HeaderService */], __WEBPACK_IMPORTED_MODULE_11__src_app_trial_trial_service__["a" /* TrialService */], __WEBPACK_IMPORTED_MODULE_12__src_app_main_config_config_service__["a" /* ConfigService */], __WEBPACK_IMPORTED_MODULE_13__src_app_systeminformation_systeminformation_service__["a" /* SystemInformationService */]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var HeaderComponentNgFactory = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵccf"]('header', __WEBPACK_IMPORTED_MODULE_4__src_app_headerfooter_header_component__["a" /* HeaderComponent */], View_HeaderComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3NyYy91aS9zcmMvYXBwL2hlYWRlcmZvb3Rlci9oZWFkZXIuY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL3NyYy91aS9zcmMvYXBwL2hlYWRlcmZvb3Rlci9oZWFkZXIuY29tcG9uZW50LnRzIiwibmc6Ly8vc3JjL3VpL3NyYy9hcHAvaGVhZGVyZm9vdGVyL2hlYWRlci5jb21wb25lbnQuaHRtbCIsIm5nOi8vL3NyYy91aS9zcmMvYXBwL2hlYWRlcmZvb3Rlci9oZWFkZXIuY29tcG9uZW50LnRzLkhlYWRlckNvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIjxkaXYgaWQ9XCJoZWFkZXItY29tcG9uZW50XCI+XG4gICAgPGRpdiBjbGFzcz1cImxvZ29cIiAoY2xpY2spPVwibmF2aWdhdGVIb21lKClcIiBpZD1cIm5hdkJhckhvbWVcIj5cbiAgICAgICAgPGltZyBjbGFzcz1cImJyZWFraW5ncG9pbnQtY2xvdWQtbG9nb1wiIHNyYz1cIi9hc3NldHMvbG9nby5jZTE2NDQ5Y2Y1N2Q3ZGI5NTEwMmI2OTZiNGE0MzU1YS5zdmdcIj5cbiAgICA8L2Rpdj5cbiAgICA8ZGl2IGlkPVwidHJpYWxNb2RlTWVzc2FnZUxhcmdlXCIgY2xhc3M9XCJjbGVhcmZpeCAgdmlzaWJsZS1zbS1ibG9jayB2aXNpYmxlLW1kLWJsb2NrIHZpc2libGUtbGctYmxvY2sgdHJpYWxfbW9kZVwiXG4gICAgICAgICAqbmdJZj1cInRyaWFsTW9kZTsgZWxzZSBjdXJyZW50VXNhZ2VcIj5SdW5uaW5nIGluIHRyaWFsIG1vZGUuXG4gICAgICAgIDxmb250IFtuZ0NsYXNzXT1cInsndHJhaWxfY291bnRkb3duJzogaGFzVHJpYWxEYXRhTGVmdCwgJ3RyYWlsX2NvdW50ZG93bl9kb25lJzogIWhhc1RyaWFsRGF0YUxlZnR9XCI+e3t0cmlhbERhdGF9fTwvZm9udD4gb2YgZnJlZSB0cmFmZmljIHJlbWFpbmluZy4gPGEgcm9sZT1cImJ1dHRvblwiIChjbGljayk9XCJidXlOb3dDbGljaygpXCIgY2xhc3M9XCJidXlfdHJpYWxfZm9udFwiPkJ1eSBOb3chPC9hPjwvZGl2PlxuXG4gICAgPGRpdiBpZD1cInRyaWFsTW9kZU1lc3NhZ2VTbWFsbFwiIGNsYXNzPVwiY2xlYXJmaXggIHZpc2libGUteHMtYmxvY2sgdHJpYWxfbW9kZV9zbVwiICpuZ0lmPVwidHJpYWxNb2RlXCIgPlxuICAgICAgUnVubmluZyBpbiB0cmlhbCBtb2RlLlxuICAgICAgPGRpdj48Zm9udCBbbmdDbGFzc109XCJ7J3RyYWlsX2NvdW50ZG93bic6IGhhc1RyYWlsRGF0YUxlZnQsICd0cmFpbF9jb3VudGRvd25fZG9uZSc6ICFoYXNUcmFpbERhdGFMZWZ0fVwiPnt7dHJpYWxEYXRhfX08L2ZvbnQ+IG9mIGZyZWUgdHJhZmZpYyByZW1haW5pbmcuPC9kaXY+XG4gICAgICA8ZGl2PjxhIGhyZWY9XCIjXCIgY2xhc3M9XCJidXlfdHJpYWxfZm9udFwiPkJ1eSBOb3chPC9hPjwvZGl2PlxuICAgIDwvZGl2PlxuXG4gICAgPG5nLXRlbXBsYXRlICNjdXJyZW50VXNhZ2U+XG4gICAgICAgIDxkaXYgaWQ9XCJjdXJyZW50LXVzYWdlXCIgY2xhc3M9XCJjbGVhcmZpeCAgdmlzaWJsZS1zbS1ibG9jayB2aXNpYmxlLW1kLWJsb2NrIHZpc2libGUtbGctYmxvY2sgZGF0YV91c2FnZVwiID5cbiAgICAgICAgICAgIERhdGEgVXNhZ2U6IHt7Y29uc3VtZX19IEdCIC8ge3t0aHJlc2hvbGR9fSBHQlxuICAgICAgICA8L2Rpdj5cblxuICAgICAgICA8ZGl2IGlkPVwiY3VycmVudC11c2FnZVwiIGNsYXNzPVwiY2xlYXJmaXggIHZpc2libGUteHMtYmxvY2sgZGF0YV91c2FnZV9zbVwiID5cbiAgICAgICAgICAgIDxkaXY+RGF0YSBVc2FnZTo8L2Rpdj5cbiAgICAgICAgICAgIDxkaXY+e3tjb25zdW1lfX0gR0IgLzwvZGl2PlxuICAgICAgICAgICAgPGRpdj57e3RocmVzaG9sZH19IEdCPC9kaXY+XG4gICAgICAgIDwvZGl2PlxuICAgIDwvbmctdGVtcGxhdGU+XG5cbiAgICA8ZGl2IGNsYXNzPVwibWVudXJvd1wiID5cblxuICAgICAgICA8ZGl2IGNsYXNzPVwibmF2YnRuZ3JvdXBcIiBzdHlsZT1cIm1hcmdpbi1yaWdodDoxMHB4OyBcIj5cblxuICAgICAgICAgICAgPG5hdiBjbGFzcz1cIm5hdmJhciBuYXZiYXItaW52ZXJzZSBuby1ib3JkZXIgXCIgc3R5bGU9XCIgbWluLWhlaWdodDozMHB4IWltcG9ydGFudDsgaGVpZ2h0OjM1cHghaW1wb3J0YW50O1wiPlxuICAgICAgICAgICAgICAgIDx1bCBjbGFzcz1cIm5hdiBuYXZiYXItbmF2IG5hdmJhci1yaWdodCBjbGVhcmZpeCAgdmlzaWJsZS1zbS1ibG9jayB2aXNpYmxlLW1kLWJsb2NrIHZpc2libGUtbGctYmxvY2tcIiBzdHlsZT1cIm1pbi13aWR0aDoyMDBweCAhaW1wb3J0YW50OyBtYXJnaW4tdG9wOjBweDttYXJnaW4tbGVmdDo1cHg7XCI+XG4gICAgICAgICAgICAgICAgICAgIDxsaSBpZD1cIm5hdkJhclZhbGlkYXRpb24xXCIgPjxhIFtuZ0NsYXNzXT1cInsnaGVhZGVyLW5hdmJ0bi1hY3RpdmUnIDogY3VycmVudFJvdXRlID09PSAnLyd9XCIgY2xhc3M9XCJoZWFkZXItbmF2YnRuXCIgKGNsaWNrKT1cIm5hdmlnYXRlKCcnKVwiPlZBTElEQVRJT048L2E+IDwvbGk+XG4gICAgICAgICAgICAgICAgICAgIDxsaSBpZD1cIm5hdkJhckhpc3RvcnkxXCIgPjxhIFtuZ0NsYXNzXT1cInsnaGVhZGVyLW5hdmJ0bi1hY3RpdmUnIDogY3VycmVudFJvdXRlID09PSAnL2hpc3RvcnknfVwiIGNsYXNzPVwiaGVhZGVyLW5hdmJ0blwiIChjbGljayk9XCJuYXZpZ2F0ZSgnaGlzdG9yeScpXCI+SElTVE9SWTwvYT4gPC9saT5cbiAgICAgICAgICAgICAgICA8L3VsPlxuXG4gICAgICAgICAgICAgICAgPHVsIGNsYXNzPVwibmF2IG5hdmJhci1uYXYgbmF2YmFyLXJpZ2h0IGNsZWFyZml4ICB2aXNpYmxlLXhzLWJsb2NrXCIgc3R5bGU9XCJtaW4td2lkdGg6NTBweCAhaW1wb3J0YW50OyBtYXJnaW4tdG9wOjBweDttYXJnaW4tbGVmdDo1cHg7XCI+XG4gICAgICAgICAgICAgICAgICAgIDxsaSBpZD1cIm5hdkJhclZhbGlkYXRpb24yXCIgPjxhIFtuZ0NsYXNzXT1cInsnaGVhZGVyLW5hdmJ0bi1hY3RpdmUtc20nIDogY3VycmVudFJvdXRlID09PSAnLyd9XCIgY2xhc3M9XCJoZWFkZXItbmF2YnRuLXNtXCIgKGNsaWNrKT1cIm5hdmlnYXRlKCcnKVwiPlZBTElEQVRJT048L2E+IDwvbGk+XG4gICAgICAgICAgICAgICAgICAgIDxsaSBpZD1cIm5hdkJhckhpc3RvcnkyXCIgPjxhIFtuZ0NsYXNzXT1cInsnaGVhZGVyLW5hdmJ0bi1hY3RpdmUtc20nIDogY3VycmVudFJvdXRlID09PSAnL2hpc3RvcnknfVwiIGNsYXNzPVwiaGVhZGVyLW5hdmJ0bi1zbVwiIChjbGljayk9XCJuYXZpZ2F0ZSgnaGlzdG9yeScpXCI+SElTVE9SWTwvYT4gPC9saT5cbiAgICAgICAgICAgICAgICA8L3VsPlxuICAgICAgICAgICAgPC9uYXY+XG4gICAgICAgIDwvZGl2PlxuXG5cbiAgICAgICAgPGhlYWRlci1tZW51IGNsYXNzPVwibWVudVwiPjwvaGVhZGVyLW1lbnU+XG4gICAgICAgIDxkaXYgIHN0eWxlPVwid2lkdGg6MjBweDsgXCI+PC9kaXY+XG5cbiAgICA8L2Rpdj5cbjwvZGl2PlxuXG48IS0tXG48bmF2IGNsYXNzPVwibmF2YmFyIG5hdmJhci1kZWZhdWx0XCI+XG4gICAgPGRpdiBjbGFzcz1cImNvbnRhaW5lci1mbHVpZFwiPlxuICAgICAgICA8ZGl2IGNsYXNzPVwibmF2YmFyLWhlYWRlclwiPlxuICAgICAgICAgICAgPGRpdiBjbGFzcz1cImxvZ29cIiAoY2xpY2spPVwibmF2aWdhdGVIb21lKClcIj5cbiAgICAgICAgICAgICAgICA8aW1nIGNsYXNzPVwiYnJlYWtpbmdwb2ludC1jbG91ZC1sb2dvXCIgc3JjPVwiL2Fzc2V0cy9sb2dvLmNlMTY0NDljZjU3ZDdkYjk1MTAyYjY5NmI0YTQzNTVhLnN2Z1wiPlxuICAgICAgICAgICAgPC9kaXY+XG4gICAgICAgIDwvZGl2PlxuICAgICAgICAmbHQ7ISZuZGFzaDs8ZGl2IGNsYXNzPVwiY29sbGFwc2UgbmF2YmFyLWNvbGxhcHNlXCI+Jm5kYXNoOyZndDtcbiAgICAgICAgICAgIDx1bCBjbGFzcz1cIm5hdiBuYXZiYXItbmF2XCI+XG4gICAgICAgICAgICAgICAgPGxpIHJvdXRlckxpbmtBY3RpdmU9XCJhY3RpdmVcIj48YSByb3V0ZXJMaW5rPVwiL3JlY2lwZXNcIj5SZWNpcGVzPC9hPiA8L2xpPlxuICAgICAgICAgICAgICAgIDxsaSByb3V0ZXJMaW5rQWN0aXZlPVwiYWN0aXZlXCI+PGEgcm91dGVyTGluaz1cIi9zaG9wcGluZy1saXN0XCI+U2hvcHBpbmcgTGlzdDwvYT4gPC9saT5cbiAgICAgICAgICAgIDwvdWw+XG4gICAgICAgICAgICA8dWwgY2xhc3M9XCJuYXYgbmF2YmFyLW5hdiBuYXZiYXItcmlnaHRcIj5cblxuICAgICAgICAgICAgICAgIDxsaT48YSByb3V0ZXJMaW5rPVwiL3NpZ251cFwiPlJlZ2lzdGVyPC9hPjwvbGk+XG4gICAgICAgICAgICAgICAgPGxpPjxhIHJvdXRlckxpbms9XCIvc2lnbmluXCI+TG9naW48L2E+PC9saT5cbiAgICAgICAgICAgICAgICA8bGkgY2xhc3M9XCJkcm9wZG93blwiPlxuICAgICAgICAgICAgICAgICAgICA8YSBjbGFzcz1cImRyb3Bkb3duLXRvZ2dsZVwiIGRhdGEtdG9nZ2xlPVwiZHJvcGRvd25cIiBocmVmPVwiI1wiPlBhZ2UgMVxuICAgICAgICAgICAgICAgICAgICAgICAgPHNwYW4gY2xhc3M9XCJjYXJldFwiPjwvc3Bhbj48L2E+XG4gICAgICAgICAgICAgICAgICAgIDx1bCBjbGFzcz1cImRyb3Bkb3duLW1lbnVcIj5cbiAgICAgICAgICAgICAgICAgICAgICAgIDxsaT48YSBocmVmPVwiI1wiPlBhZ2UgMS0xPC9hPjwvbGk+XG4gICAgICAgICAgICAgICAgICAgICAgICA8bGk+PGEgaHJlZj1cIiNcIj5QYWdlIDEtMjwvYT48L2xpPlxuICAgICAgICAgICAgICAgICAgICAgICAgPGxpPjxhIGhyZWY9XCIjXCI+UGFnZSAxLTM8L2E+PC9saT5cbiAgICAgICAgICAgICAgICAgICAgPC91bD5cbiAgICAgICAgICAgICAgICA8L2xpPlxuICAgICAgICAgICAgPC91bD5cbiAgICAgICAgJmx0OyEmbmRhc2g7PC9kaXY+Jm5kYXNoOyZndDtcbiAgICA8L2Rpdj5cbjwvbmF2Pi0tPlxuIiwiPGhlYWRlcj48L2hlYWRlcj4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztvQkNJSTtNQUFBO01BQUE7TUFBQSxnQkFDMEM7TUFDdEM7VUFBQSxpRUFBQTtVQUFBO3lCQUFBLGdEQUFNO1VBQUEsMkJBQTZGLHdDQUFvQjtpQkFBQSxrREFBNEI7VUFBQTtVQUFBO1lBQUE7WUFBQTtZQUFpQjtjQUFBO2NBQUE7WUFBQTtZQUFqQjtVQUFBLGdDQUFnRTs7O1FBQTdNO1FBQU4sV0FBTSxTQUFOOzs7UUFBbUc7UUFBQTs7OztvQkFFdkc7TUFBQTtNQUFBLHdFQUFvRzthQUFBLDREQUVsRztNQUFBO01BQUEsNENBQUs7TUFBQTtNQUFBLHFDQUFBO2tEQUFBO2FBQU0saURBQTZGO1VBQUEsVUFBb0I7TUFBaUMsNkNBQzdKO1VBQUE7VUFBQSw4QkFBSztVQUFBO1VBQUEsNENBQW1DO1VBQUEsZUFBa0I7O0lBRC9DO0lBQU4sV0FBTSxTQUFOOzs7SUFBbUc7SUFBQTs7OztvQkFJL0UsK0NBQ3ZCO01BQUE7VUFBQTtNQUFBLGdCQUF5RztNQUFBLDRCQUVuRztNQUVOO1VBQUE7VUFBQSxnQkFBMEUsbURBQ3RFO2lCQUFBO2NBQUEsMERBQUs7VUFBQSxrQkFBaUIsbURBQ3RCO2lCQUFBO2NBQUEsMERBQUs7VUFBQSxlQUFzQixtREFDM0I7aUJBQUE7Y0FBQSwwREFBSztVQUFBLGFBQXNCLCtDQUN6QjtVQUFBOztJQVJtRztJQUFBO0lBQUE7SUFNaEc7SUFBQTtJQUNBO0lBQUE7Ozs7b0JBdEJqQjtNQUFBO01BQUEsZ0JBQTJCLDJDQUN2QjtNQUFBO01BQUE7UUFBQTtRQUFBO1FBQWtCO1VBQUE7VUFBQTtRQUFBO1FBQWxCO01BQUEsZ0NBQTJEO01BQ3ZEO1VBQUE7VUFBQSwwREFBOEY7VUFBQSxhQUM1RiwyQ0FDTjtVQUFBLDRFQUFBO1VBQUE7Y0FBQSx3Q0FFeU87VUFBQSxlQUV6TztVQUFBLGdDQUFBO3dCQUFBLG1DQUlNO1VBQUEsZUFFTjtVQUFBLHlCQVVjLDZDQUVkO2lCQUFBO2NBQUEsMERBQXNCO1VBQUEsbUJBRWxCO1VBQUE7VUFBQSwwREFBcUQ7VUFBQSx1QkFFakQ7VUFBQTtVQUFBO01BQXlHLHVEQUNyRztVQUFBO2NBQUE7VUFBQTtNQUF5SywyREFDcks7VUFBQTtVQUFBLDBEQUE0QjtVQUFBO1VBQUE7WUFBQTtZQUFBO1lBQXFGO2NBQUE7Y0FBQTtZQUFBO1lBQXJGO1VBQUEsdUNBQUE7VUFBQTtjQUFBLHNEQUFHO01BQXlHLCtDQUFjO1VBQUEsUUFBTSwyREFDNUo7aUJBQUE7Y0FBQSwwREFBeUI7VUFBQTtVQUFBO1lBQUE7WUFBQTtZQUE0RjtjQUFBO2NBQUE7WUFBQTtZQUE1RjtVQUFBLHVDQUFBO1VBQUE7Y0FBQSxzREFBRztNQUF1SCw0Q0FBVztNQUFNLHVEQUNuSztVQUFBLDJCQUVMO1VBQUE7Y0FBQTtVQUFBO01BQXNJLDJEQUNsSTtVQUFBO1VBQUEsMERBQTRCO1VBQUE7VUFBQTtZQUFBO1lBQUE7WUFBMkY7Y0FBQTtjQUFBO1lBQUE7WUFBM0Y7VUFBQSx1Q0FBQTtVQUFBO2NBQUEsc0RBQUc7TUFBK0csK0NBQWM7VUFBQSxRQUFNLDJEQUNsSztpQkFBQTtjQUFBLDBEQUF5QjtVQUFBO1VBQUE7WUFBQTtZQUFBO1lBQWtHO2NBQUE7Y0FBQTtZQUFBO1lBQWxHO1VBQUEsdUNBQUE7VUFBQTtjQUFBLHNEQUFHO01BQTZILDRDQUFXO01BQU0sdURBQ3pLO1VBQUEscUJBQ0gsK0NBQ0o7aUJBQUEsb0NBR047VUFBQTtVQUFBO2FBQUE7O1VBQUEsOENBQXdDO1VBQUEsaUJBQ3hDO1VBQUE7VUFBQSxnQkFBaUMsNkNBRS9CO1VBQUEsU0FDSix5Q0ErQkc7VUFBQTs7SUExRUE7SUFBQTtJQURMLFdBQ0ssbUJBREw7SUFJaUY7SUFBakYsWUFBaUYsU0FBakY7SUF3QjJHO0lBQTVEO0lBQUgsWUFBK0QsVUFBNUQsU0FBSDtJQUNtRTtJQUFuRTtJQUFILFlBQXNFLFVBQW5FLFNBQUg7SUFJcUU7SUFBL0Q7SUFBSCxZQUFrRSxVQUEvRCxTQUFIO0lBQ3NFO0lBQXRFO0lBQUgsWUFBeUUsVUFBdEUsVUFBSDtJQU1yQzs7OztvQkM1Q1I7TUFBQTthQUFBO3lHQUFBO1VBQUE7SUFBQTs7OzsifQ==
//# sourceMappingURL=header.component.ngfactory.js.map

/***/ }),
/* 537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return styles; });
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */
var styles = ['#header-div[_ngcontent-%COMP%] {\n  bottom: 0;\n  height: 35px;\n  left: 0;\n  background: #1d1d1d none repeat scroll 0% 0%/auto padding-box border-box;\n  right: 0px;\n  top: 0px;\n  perspective-origin: 472.5px 15px;\n  transform-origin: 472.5px 15px;\n  background: #1d1d1d none repeat scroll 0% 0%/auto padding-box border-box;\n  font-size: 12px;\n  overflow: hidden; }\n\n.breakingpoint-cloud-logo[_ngcontent-%COMP%] {\n  width: 200px;\n  height: 40px; }\n\n.logo[_ngcontent-%COMP%] {\n  padding: 0 15px;\n  cursor: pointer; }\n\n.logo[_ngcontent-%COMP%]:hover {\n  background-color: #343434; }\n\n.navbtngroup[_ngcontent-%COMP%] {\n  width: 100%; }\n\n.menu[_ngcontent-%COMP%] {\n  justify-content: center;\n  display: flex;\n  width: 60px; }\n\n.menurow[_ngcontent-%COMP%] {\n  justify-content: center;\n  display: flex;\n  width: 100%; }\n\n.cloud-heightadustment[_ngcontent-%COMP%] {\n  min-height: 35px !important;\n  height: 39px; }\n\n.header-navbtn-active[_ngcontent-%COMP%] {\n  background-color: #4dadd8 !important;\n  padding-top: 9px !important;\n  padding-bottom: 9px !important;\n  color: white !important;\n  max-width: 100px;\n  font-size: 12px;\n  cursor: default;\n  height: 42px;\n  top: 1px; }\n\n.header-navbtn[_ngcontent-%COMP%] {\n  padding-top: 9px !important;\n  padding-bottom: 9px !important;\n  max-width: 100px;\n  font-size: 12px;\n  cursor: pointer; }\n\n.header-navbtn-active-sm[_ngcontent-%COMP%] {\n  padding-top: 0px !important;\n  padding-bottom: 0px !important;\n  color: #4dadd8 !important;\n  font-size: 11px;\n  cursor: default; }\n\n.header-navbtn-sm[_ngcontent-%COMP%] {\n  padding-top: 0px !important;\n  padding-bottom: 0px !important;\n  font-size: 11px;\n  cursor: pointer; }\n\n#header-component[_ngcontent-%COMP%] {\n  box-sizing: border-box;\n  height: 45px;\n  display: flex;\n  align-content: center;\n  flex-direction: row;\n  width: 100%;\n  left: 0px;\n  right: 0px;\n  top: 0px;\n  z-index: 1;\n  perspective-origin: 472.5px 20px;\n  transform-origin: 472.5px 20px;\n  background: #1d1d1d none repeat scroll 0% 0%/auto padding-box border-box;\n  border-bottom: 1px solid #a3a3a3;\n  font-size: 12px; }\n\n.no-border[_ngcontent-%COMP%] {\n  border: 0px solid transparent !important;\n  margin-bottom: 0px !important; }\n\n.trial_mode[_ngcontent-%COMP%] {\n  white-space: nowrap;\n  margin-top: 13px;\n  color: #adadad; }\n\n.trial_mode_sm[_ngcontent-%COMP%] {\n  margin-top: 2px;\n  min-width: 200px;\n  color: #adadad; }\n\n.data_usage[_ngcontent-%COMP%] {\n  white-space: nowrap;\n  margin-top: 13px;\n  color: #adadad; }\n\n.data_usage_sm[_ngcontent-%COMP%] {\n  margin-top: 3px;\n  min-width: 100px;\n  color: #adadad; }\n\n.buy_trial_font[_ngcontent-%COMP%] {\n  color: #9abc7d; }\n\n.trail_countdown[_ngcontent-%COMP%] {\n  color: #4dadd8; }\n\n.trail_countdown_done[_ngcontent-%COMP%] {\n  color: #d20f0f; }'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3NyYy91aS9zcmMvYXBwL2hlYWRlcmZvb3Rlci9oZWFkZXIuY29tcG9uZW50LnNjc3Muc2hpbS5uZ3N0eWxlLnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vc3JjL3VpL3NyYy9hcHAvaGVhZGVyZm9vdGVyL2hlYWRlci5jb21wb25lbnQuc2NzcyJdLCJzb3VyY2VzQ29udGVudCI6WyIgIl0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7In0=
//# sourceMappingURL=header.component.scss.shim.ngstyle.js.map

/***/ }),
/* 538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return styles; });
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */
var styles = ['.modal-container[_ngcontent-%COMP%] {\n  height: 630px;\n  width: 710px; }\n\n.dialog-title[_ngcontent-%COMP%] {\n  padding-left: 20px;\n  padding-top: 10px;\n  font-weight: 800;\n  color: #5A5A64;\n  font-family: open_sans;\n  font-weight: bold;\n  font-size: 13px;\n  margin-bottom: 0px !important; }\n\n.message-text[_ngcontent-%COMP%] {\n  width: 95%;\n  padding-left: 30px;\n  height: 95%;\n  border: 2px solid #cbcbcb;\n  resize: none; }\n\n.download-button-container[_ngcontent-%COMP%] {\n  padding-top: 5px; }\n\n.download-button[_ngcontent-%COMP%] {\n  color: #5a5a64;\n  background-color: #FAFAFA;\n  background: -webkit-gradient(linear, 0% 0%, 0% 100%, from(#ffffff), to(#F1F1F1));\n  background: -webkit-linear-gradient(0% 0%, 0% 100%, from(#ffffff), to(#F1F1F1));\n  background: -moz-linear-gradient(center top, #ffffff, #F1F1F1);\n  border: 1px solid #bababa;\n  font-family: open_sans;\n  font-weight: bold;\n  font-size: 10px;\n  text-align: center;\n  padding: 5px;\n  align-items: center; }\n\n.message[_ngcontent-%COMP%] {\n  color: #5a5a64;\n  font-family: open_sans;\n  font-weight: 600;\n  font-size: 13px;\n  padding: 20px;\n  width: 100%; }\n\n.mainbody[_ngcontent-%COMP%] {\n  display: flex;\n  flex-direction: row; }\n\n.cancelButtonOff[_ngcontent-%COMP%] {\n  display: none; }'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3NyYy91aS9zcmMvYXBwL2xpY2Vuc2luZy9saWNlbnNpbmcuY29tcG9uZW50LnNjc3Muc2hpbS5uZ3N0eWxlLnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vc3JjL3VpL3NyYy9hcHAvbGljZW5zaW5nL2xpY2Vuc2luZy5jb21wb25lbnQuc2NzcyJdLCJzb3VyY2VzQ29udGVudCI6WyIgIl0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7In0=
//# sourceMappingURL=licensing.component.scss.shim.ngstyle.js.map

/***/ }),
/* 539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RenderType_UserLoginComponent */
/* unused harmony export View_UserLoginComponent_0 */
/* unused harmony export View_UserLoginComponent_Host_0 */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UserLoginComponentNgFactory; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__user_login_component_scss_shim_ngstyle__ = __webpack_require__(540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_bootstrap_dist_css_bootstrap_css_shim_ngstyle__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_core__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__angular_common__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_app_login_user_login_component__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__angular_forms__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__licensing_licensing_modal_component_ngfactory__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_app_licensing_licensing_modal_component__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_app_user_user_service__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_app_login_user_login_service__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_app_user_preferences_service__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__angular_router__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_app_aws_environment__ = __webpack_require__(26);
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */













var styles_UserLoginComponent = [__WEBPACK_IMPORTED_MODULE_0__user_login_component_scss_shim_ngstyle__["a" /* styles */], __WEBPACK_IMPORTED_MODULE_1__node_modules_bootstrap_dist_css_bootstrap_css_shim_ngstyle__["a" /* styles */]];
var RenderType_UserLoginComponent = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵcrt"]({ encapsulation: 0,
    styles: styles_UserLoginComponent, data: {} });
function View_UserLoginComponent_1(_l) {
    return __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 9, 'div', [['class',
                'row login-error-div'], ['id', 'login-error-div']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                    '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 0, 'div', [['class', 'col-sm-1 login-error-icon'],
            ['id', 'login-error-icon']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                    '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 4, 'div', [['class', 'col-sm-11 login-error-label'],
            ['id', 'login-error-label']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                        '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'span', [], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['', ''])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                    '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                ']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.error;
        _ck(_v, 7, 0, currVal_0);
    });
}
function View_UserLoginComponent_0(_l) {
    return __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵvid"](0, [__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵqud"](402653184, 1, { eulaModel: 0 }), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['﻿'])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 3, 'div', [['class', 'under-background'],
            ['id', 'under-background']], null, null, null, null, null)), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](278528, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_common__["NgStyle"], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["KeyValueDiffers"],
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ElementRef"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["Renderer"]], { ngStyle: [0, 'ngStyle'] }, null), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵpod"]({ 'background-image': 0 }),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n'])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n'])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 3, 'div', [['class', 'background'],
            ['id', 'background']], null, [[null, 'animationend']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('animationend' === en)) {
                var pd_0 = (_co.onAnimationEnd($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](278528, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_common__["NgStyle"], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["KeyValueDiffers"],
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ElementRef"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["Renderer"]], { ngStyle: [0, 'ngStyle'] }, null), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵpod"]({ 'animation-play-state': 0,
            'animation': 1, 'background-image': 2 }), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n'])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n\n'])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 159, 'div', [['class', 'container'], ['id', 'container'], ['style', 'z-index: 2;position: relative;']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n  '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 156, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 66, 'div', [['class', 'col-sm-4']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n          '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 63, 'div', [['class', 'panel cloud-panel-margins-padding login-panel'], ['style', 'min-height: 232px; width:275px; margin-top:300px; margin-left:100px;']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 3, 'div', [['class', 'panel-heading login-logo'], ['style', 'height: 40px;']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 0, 'img', [['class', 'breakingpoint-cloud-logo'], ['src', '/assets/logo.8215d977e243b00c9a02c7227909cb9d.png']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 55, 'div', [['class', 'panel-body']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n              '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 31, 'form', [['id', 'login-form'], ['novalidate',
                    '']], [[2, 'ng-untouched', null], [2, 'ng-touched', null],
                [2, 'ng-pristine', null], [2, 'ng-dirty', null], [2, 'ng-valid',
                    null], [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null, 'submit'], [null, 'reset']], function (_v, en, $event) {
                var ad = true;
                if (('submit' === en)) {
                    var pd_0 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 29).onSubmit($event) !== false);
                    ad = (pd_0 && ad);
                }
                if (('reset' === en)) {
                    var pd_1 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 29).onReset() !== false);
                    ad = (pd_1 && ad);
                }
                return ad;
            }, null, null)), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_5__angular_forms__["e" /* ɵbf */], [], null, null), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_5__angular_forms__["f" /* NgForm */], [[8, null], [8, null]], null, null),
        __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵprd"](2048, null, __WEBPACK_IMPORTED_MODULE_5__angular_forms__["g" /* ControlContainer */], null, [__WEBPACK_IMPORTED_MODULE_5__angular_forms__["f" /* NgForm */]]), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_5__angular_forms__["h" /* NgControlStatusGroup */], [__WEBPACK_IMPORTED_MODULE_5__angular_forms__["g" /* ControlContainer */]], null, null), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵand"](16777216, null, null, 1, null, View_UserLoginComponent_1)),
        __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_common__["NgIf"], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["ViewContainerRef"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 15, 'div', [], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                  '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 5, 'input', [['class', 'form-control cloud-label-style'], ['id', 'email'], ['name',
                'email'], ['placeholder', 'Email'], ['style', 'margin-top:13px; margin-bottom: 10px;'],
            ['type', 'text']], [[2, 'ng-untouched', null], [2, 'ng-touched', null],
            [2, 'ng-pristine', null], [2, 'ng-dirty', null], [2, 'ng-valid',
                null], [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null, 'ngModelChange'], [null, 'input'], [null,
                'blur'], [null, 'compositionstart'], [null, 'compositionend']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('input' === en)) {
                var pd_0 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 39)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 39).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 39)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 39)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_4 = ((_co.email = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_5__angular_forms__["i" /* DefaultValueAccessor */], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["Renderer2"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["ElementRef"], [2, __WEBPACK_IMPORTED_MODULE_5__angular_forms__["j" /* COMPOSITION_BUFFER_MODE */]]], null, null), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵprd"](1024, null, __WEBPACK_IMPORTED_MODULE_5__angular_forms__["k" /* NG_VALUE_ACCESSOR */], function (p0_0) {
            return [p0_0];
        }, [__WEBPACK_IMPORTED_MODULE_5__angular_forms__["i" /* DefaultValueAccessor */]]), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](671744, null, 0, __WEBPACK_IMPORTED_MODULE_5__angular_forms__["l" /* NgModel */], [[2, __WEBPACK_IMPORTED_MODULE_5__angular_forms__["g" /* ControlContainer */]],
            [8, null], [8, null], [2, __WEBPACK_IMPORTED_MODULE_5__angular_forms__["k" /* NG_VALUE_ACCESSOR */]]], { name: [0, 'name'],
            isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵprd"](2048, null, __WEBPACK_IMPORTED_MODULE_5__angular_forms__["m" /* NgControl */], null, [__WEBPACK_IMPORTED_MODULE_5__angular_forms__["l" /* NgModel */]]), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_5__angular_forms__["n" /* NgControlStatus */], [__WEBPACK_IMPORTED_MODULE_5__angular_forms__["m" /* NgControl */]], null, null),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                  '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 5, 'input', [['class', 'form-control cloud-label-style'], ['id',
                'password'], ['name', 'password'], ['placeholder', 'Password'], ['style',
                'margin-bottom: 10px;'], ['type', 'password']], [[2, 'ng-untouched', null],
            [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'ngModelChange'], [null,
                'input'], [null, 'blur'], [null, 'compositionstart'], [null,
                'compositionend']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('input' === en)) {
                var pd_0 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 46)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 46).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 46)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 46)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_4 = ((_co.password = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_5__angular_forms__["i" /* DefaultValueAccessor */], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["Renderer2"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["ElementRef"], [2, __WEBPACK_IMPORTED_MODULE_5__angular_forms__["j" /* COMPOSITION_BUFFER_MODE */]]], null, null), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵprd"](1024, null, __WEBPACK_IMPORTED_MODULE_5__angular_forms__["k" /* NG_VALUE_ACCESSOR */], function (p0_0) {
            return [p0_0];
        }, [__WEBPACK_IMPORTED_MODULE_5__angular_forms__["i" /* DefaultValueAccessor */]]), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](671744, null, 0, __WEBPACK_IMPORTED_MODULE_5__angular_forms__["l" /* NgModel */], [[2, __WEBPACK_IMPORTED_MODULE_5__angular_forms__["g" /* ControlContainer */]],
            [8, null], [8, null], [2, __WEBPACK_IMPORTED_MODULE_5__angular_forms__["k" /* NG_VALUE_ACCESSOR */]]], { name: [0, 'name'],
            isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵprd"](2048, null, __WEBPACK_IMPORTED_MODULE_5__angular_forms__["m" /* NgControl */], null, [__WEBPACK_IMPORTED_MODULE_5__angular_forms__["l" /* NgModel */]]), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_5__angular_forms__["n" /* NgControlStatus */], [__WEBPACK_IMPORTED_MODULE_5__angular_forms__["m" /* NgControl */]], null, null),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 4, 'div', [['id', 'login-button-div'], ['style', 'margin-bottom: 10px;']], null, [[null, 'click'], [null, 'keyup.enter']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.login() !== false);
                ad = (pd_0 && ad);
            }
            if (('keyup.enter' === en)) {
                var pd_1 = (_co.login() !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                  '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'button', [['class', 'btn btn-success btn-block cloud-btn-style'],
            ['id', 'login-button']], [[4, 'cursor', null]], null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['Login'])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n              '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n              '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 4, 'div', [['class', 'clearfix  visible-sm-block visible-md-block visible-lg-block col-sm-2'],
            ['style', 'padding-left:0;']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                  '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'a', [['class', 'login-link-style-sm'],
            ['target', '_blank']], [[8, 'href', 4]], null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['Forgot?'])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n              '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n              '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 4, 'div', [['class', 'clearfix  visible-sm-block visible-md-block visible-lg-block col-sm-6 login-verticalLine-sm'],
            ['style', 'margin-left: 10px;']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                  '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'a', [['class', 'login-link-style-sm'],
            ['target', '_blank']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.signUp() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['Sign Up'])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n              '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n\n              '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 7, 'div', [['class', 'clearfix  visible-xs-block col-sm-12 '], ['style', 'padding-left:0;']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                  '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'a', [['class', 'login-link-style-sm'], ['target', '_blank']], [[8, 'href', 4]], null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['Forgot?'])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                    \n                  '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'a', [['class', 'login-link-style-sm'],
            ['target', '_blank']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.signUp() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['Sign Up'])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n              '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n          '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n\n\n\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 26, 'div', [['class', 'clearfix visible-sm-block col-sm-8'], ['style', 'margin-top:260px; left:200px;']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 23, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n              '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n              '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 19, 'div', [['class', 'col-sm-12']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'div', [['class', 'cloud-login-style-lg']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                  BreakingPoint Cloud\n                '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'div', [['class', 'cloud-login-style-lg-bold '], ['style', 'color:#ffffff;']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                  Gain actionable insight into your Microsoft Azure DDoS protection\n                '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'div', [['class', 'login-link-style'], ['style', 'color:#ffffff;']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                  •	Validate Microsoft Azure DDoS protection service defenses for your Azure resources.\n                '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'div', [['class', 'login-link-style'], ['style', 'color:#ffffff;']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                  •	Optimize your DDoS response process to reduce the time to detect and react to attacks\n                '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'div', [['class', 'login-link-style'], ['style', 'color:#ffffff;']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                  •	Accelerate time to meet your DDoS compliance requirements\n                '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'div', [['class', 'login-link-style'], ['style', 'color:#ffffff;']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                  •	Train your network security teams\n                '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n              '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n        '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n\n\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 25, 'div', [['class', 'clearfix visible-md-block col-sm-8'], ['style',
                'margin-top:260px;left:130px;']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 22, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n              '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 19, 'div', [['class', 'col-sm-12']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'div', [['class', 'cloud-login-style-lg']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                  BreakingPoint Cloud\n                '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'div', [['class', 'cloud-login-style-lg-bold '], ['style', 'color:#ffffff;']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                  Gain actionable insight into your Microsoft Azure DDoS protection\n                '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'div', [['class', 'login-link-style'], ['style', 'color:#ffffff;']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                  •	Validate Microsoft Azure DDoS protection service defenses for your Azure resources.\n                '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'div', [['class', 'login-link-style'], ['style', 'color:#ffffff;']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                  •	Optimize your DDoS response process to reduce the time to detect and react to attacks\n                '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'div', [['class', 'login-link-style'], ['style', 'color:#ffffff;']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                  •	Accelerate time to meet your DDoS compliance requirements\n                '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'div', [['class', 'login-link-style'], ['style', 'color:#ffffff;']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                  •	Train your network security teams\n                '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n              '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n        '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n\n\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 30, 'div', [['class', 'clearfix   visible-lg-block col-sm-8 '],
            ['style', 'margin-top:260px;']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 27, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n              '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 3, 'div', [['class', 'col-sm-1']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 0, 'div', [['class', 'clearfix visible-md-block visible-lg-block login-verticalLine']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n              '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n              '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 19, 'div', [['class', 'col-sm-11']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'div', [['class', 'cloud-login-style-lg']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                  BreakingPoint Cloud\n                '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'div', [['class', 'cloud-login-style-lg-bold '], ['style', 'color:#ffffff;']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                  Gain actionable insight into your Microsoft Azure DDoS protection\n                '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'div', [['class', 'login-link-style'], ['style', 'color:#ffffff;']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                  •	Validate Microsoft Azure DDoS protection service defenses for your Azure resources.\n                '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'div', [['class', 'login-link-style'], ['style', 'color:#ffffff;']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                  •	Optimize your DDoS response process to reduce the time to detect and react to attacks\n                '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'div', [['class', 'login-link-style'], ['style', 'color:#ffffff;']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                  •	Accelerate time to meet your DDoS compliance requirements\n                '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'div', [['class', 'login-link-style'], ['style', 'color:#ffffff;']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                  •	Train your network security teams\n                '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n              '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n        '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n\n  '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n'])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n\n\n\n'])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'licensing', [], null, null, null, __WEBPACK_IMPORTED_MODULE_6__licensing_licensing_modal_component_ngfactory__["b" /* View_LicensingModal_0 */], __WEBPACK_IMPORTED_MODULE_6__licensing_licensing_modal_component_ngfactory__["c" /* RenderType_LicensingModal */])), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](114688, [[1,
                4]], 0, __WEBPACK_IMPORTED_MODULE_7__src_app_licensing_licensing_modal_component__["a" /* LicensingModal */], [__WEBPACK_IMPORTED_MODULE_8__src_app_user_user_service__["a" /* UserService */]], null, null), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n    '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _ck(_v, 4, 0, (('url(' + _co.nextBackgroundImg) + ')'));
        _ck(_v, 3, 0, currVal_0);
        var currVal_1 = _ck(_v, 9, 0, (_co.playAnimation ? 'running' : 'paused'), _co.animation, (('url(' + _co.backgroundImg) + ')'));
        _ck(_v, 8, 0, currVal_1);
        var currVal_9 = _co.error;
        _ck(_v, 34, 0, currVal_9);
        var currVal_17 = 'email';
        var currVal_18 = _co.inputDisabled;
        var currVal_19 = _co.email;
        _ck(_v, 41, 0, currVal_17, currVal_18, currVal_19);
        var currVal_27 = 'password';
        var currVal_28 = _co.inputDisabled;
        var currVal_29 = _co.password;
        _ck(_v, 48, 0, currVal_27, currVal_28, currVal_29);
        _ck(_v, 174, 0);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_2 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 31).ngClassUntouched;
        var currVal_3 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 31).ngClassTouched;
        var currVal_4 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 31).ngClassPristine;
        var currVal_5 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 31).ngClassDirty;
        var currVal_6 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 31).ngClassValid;
        var currVal_7 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 31).ngClassInvalid;
        var currVal_8 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 31).ngClassPending;
        _ck(_v, 27, 0, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8);
        var currVal_10 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 43).ngClassUntouched;
        var currVal_11 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 43).ngClassTouched;
        var currVal_12 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 43).ngClassPristine;
        var currVal_13 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 43).ngClassDirty;
        var currVal_14 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 43).ngClassValid;
        var currVal_15 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 43).ngClassInvalid;
        var currVal_16 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 43).ngClassPending;
        _ck(_v, 38, 0, currVal_10, currVal_11, currVal_12, currVal_13, currVal_14, currVal_15, currVal_16);
        var currVal_20 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 50).ngClassUntouched;
        var currVal_21 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 50).ngClassTouched;
        var currVal_22 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 50).ngClassPristine;
        var currVal_23 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 50).ngClassDirty;
        var currVal_24 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 50).ngClassValid;
        var currVal_25 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 50).ngClassInvalid;
        var currVal_26 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 50).ngClassPending;
        _ck(_v, 45, 0, currVal_20, currVal_21, currVal_22, currVal_23, currVal_24, currVal_25, currVal_26);
        var currVal_30 = _co.mousePointer;
        _ck(_v, 55, 0, currVal_30);
        var currVal_31 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵinlineInterpolate"](1, '', _co.forgotPasswordUrl, '');
        _ck(_v, 62, 0, currVal_31);
        var currVal_32 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵinlineInterpolate"](1, '', _co.forgotPasswordUrl, '');
        _ck(_v, 74, 0, currVal_32);
    });
}
function View_UserLoginComponent_Host_0(_l) {
    return __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'user-login', [], null, null, null, View_UserLoginComponent_0, RenderType_UserLoginComponent)),
        __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](114688, null, 0, __WEBPACK_IMPORTED_MODULE_4__src_app_login_user_login_component__["a" /* UserLoginComponent */], [__WEBPACK_IMPORTED_MODULE_8__src_app_user_user_service__["a" /* UserService */], __WEBPACK_IMPORTED_MODULE_9__src_app_login_user_login_service__["a" /* LoginService */],
            __WEBPACK_IMPORTED_MODULE_10__src_app_user_preferences_service__["a" /* UserPreferencesService */], __WEBPACK_IMPORTED_MODULE_11__angular_router__["a" /* Router */], __WEBPACK_IMPORTED_MODULE_12__src_app_aws_environment__["a" /* AwsEnvironment */], __WEBPACK_IMPORTED_MODULE_11__angular_router__["b" /* ActivatedRoute */]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var UserLoginComponentNgFactory = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵccf"]('user-login', __WEBPACK_IMPORTED_MODULE_4__src_app_login_user_login_component__["a" /* UserLoginComponent */], View_UserLoginComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=user-login.component.ngfactory.js.map

/***/ }),
/* 540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return styles; });
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */
var styles = ['.background[_ngcontent-%COMP%] {\n  background-size: cover;\n  background-position: center;\n  background-attachment: fixed;\n  background-repeat: no-repeat;\n  opacity: 1;\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  z-index: 1; }\n\n.under-background[_ngcontent-%COMP%] {\n  background-size: cover;\n  background-position: center;\n  background-attachment: fixed;\n  background-repeat: no-repeat;\n  opacity: 1;\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  z-index: 0; }\n\n@keyframes fade-background {\n  to {\n    opacity: 0; } }\n\n\n.login-container[_ngcontent-%COMP%] {\n  flex-grow: 1;\n  height: 100%; }\n\n.login-footer[_ngcontent-%COMP%] {\n  min-height: 30px;\n  height: 30px;\n  flex-grow: 0;\n  background-color: black;\n  display: flex; }\n\n.image-details[_ngcontent-%COMP%] {\n  margin-left: 30px;\n  min-width: 600px; }\n\n.city[_ngcontent-%COMP%] {\n  font-size: 12px;\n  line-height: 30px;\n  text-transform: uppercase;\n  color: #f1f1f1; }\n\n.address[_ngcontent-%COMP%] {\n  font-size: 12px;\n  line-height: 30px;\n  color: #999; }\n\n.empty-space[_ngcontent-%COMP%] {\n  flex-grow: 1;\n  width: 100%; }\n\n.copyright[_ngcontent-%COMP%] {\n  margin-right: 30px;\n  flex-shrink: 0; }\n\n.copyright-text[_ngcontent-%COMP%] {\n  font-size: 12px;\n  line-height: 30px;\n  color: #f1f1f1; }\n\n.login-outline[_ngcontent-%COMP%] {\n  position: relative;\n  transform: translate(-50%, -50%);\n  top: 50%;\n  left: 50%;\n  width: 358px;\n  box-shadow: rgba(0, 0, 0, 0.619608) 0px 5px 20px 0px;\n  box-sizing: border-box;\n  background: rgba(255, 255, 255, 0.498039);\n  border-radius: 8px 8px 8px 8px;\n  display: block;\n  padding: 4px; }\n\n.login-header[_ngcontent-%COMP%] {\n  height: 54px;\n  background: #212121;\n  border-radius: 5px 5px 0 0;\n  display: flex;\n  flex-direction: row;\n  align-items: center; }\n\n.header-logo[_ngcontent-%COMP%] {\n  width: 120px;\n  height: 100%;\n  position: relative;\n  margin-left: 35px;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-image: url(/assets/logo.ce16449cf57d7db95102b696b4a4355a.svg); }\n\n.header-separator[_ngcontent-%COMP%] {\n  width: 20px;\n  height: 100%;\n  position: relative;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-image: url(/assets/breadCrumb.6d8b507f05f610a5a8a0a7b7f6b4e6f0.svg); }\n\n.header-lock[_ngcontent-%COMP%] {\n  width: 10px;\n  height: 100%;\n  position: relative;\n  margin-left: 15px;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-image: url(/assets/padlock.e013144837af08ac693d86f68fae3edb.svg); }\n\n.header-text[_ngcontent-%COMP%] {\n  font-size: 12px;\n  line-height: 54px;\n  color: #fdfdfd;\n  margin-left: 10px; }\n\n.separator[_ngcontent-%COMP%] {\n  height: 4px;\n  background-image: url(/assets/brandingStripe.4f486bc7661101e5296b3624d6eb736f.svg); }\n\n.login-form[_ngcontent-%COMP%] {\n  background: rgba(255, 255, 255, 0.9);\n  border: 0px none #bfbfbf;\n  border-radius: 0px 0px 4px 4px;\n  margin: 0px; }\n\n.login-div[_ngcontent-%COMP%] {\n  position: relative;\n  padding-left: 35px;\n  padding-bottom: 15px;\n  padding-top: 10px; }\n\n.username-div[_ngcontent-%COMP%] {\n  height: 40px;\n  width: 275px;\n  border: 0px none #bfbfbf;\n  padding-top: 20px; }\n\n.password-div[_ngcontent-%COMP%] {\n  height: 40px;\n  width: 275px;\n  border: 0px none #bfbfbf;\n  padding-top: 20px; }\n\ninput[_ngcontent-%COMP%]:-webkit-autofill, input[_ngcontent-%COMP%]:-webkit-autofill:hover, input[_ngcontent-%COMP%]:-webkit-autofill:focus, input[_ngcontent-%COMP%]:-webkit-autofill:active {\n  -webkit-transition-delay: 999999s;\n  transition-delay: 999999s;\n  -webkit-transition: color 999999s ease-out, background-color 999999s ease-out;\n  transition: color 999999s ease-out, background-color 999999s ease-out; }\n\n.forgot[_ngcontent-%COMP%] {\n  box-sizing: border-box;\n  box-shadow: rgba(0, 0, 0, 0.247059) 2px 2px 0px 0px inset;\n  color: black;\n  height: 100%;\n  width: 100%;\n  border: 1px solid white;\n  border-radius: 4px 4px 4px 4px;\n  font-style: italic;\n  font-size: 11px;\n  padding-left: 10px;\n  outline-width: 0;\n  width: 70px;\n  text-decoration: underline;\n  border-left-style: none;\n  border-left-width: 0px;\n  border-radius: 0px 4px 4px 0px;\n  box-shadow: rgba(0, 0, 0, 0.247059) 0px 2px 0px 0px inset;\n  text-transform: uppercase;\n  font-style: normal;\n  font-weight: 600;\n  font-size: 10px;\n  color: #41a4c7;\n  cursor: pointer; }\n  .forgot[_ngcontent-%COMP%]:disabled {\n    transition-delay: 999999s;\n    transition: color 999999s ease-out, background-color 999999s ease-out;\n    box-shadow: rgba(0, 0, 0, 0.147059) 0px 2px 0px 500px inset; }\n\na[_ngcontent-%COMP%] {\n  color: inherit;\n  text-decoration: inherit; }\n\n.login-button-div[_ngcontent-%COMP%] {\n  height: 35px;\n  width: 275px;\n  padding-top: 40px; }\n\n.login-button[_ngcontent-%COMP%] {\n  box-shadow: #dbdbdb 0px 0px 0px 0px;\n  background-color: #383838;\n  color: white;\n  height: 35px;\n  width: 100%;\n  font-size: 12px;\n  font-weight: bold;\n  text-transform: uppercase;\n  border: #dbdbdb;\n  border-radius: 4px 4px 4px 4px; }\n\n.login-button[_ngcontent-%COMP%]:hover {\n  background-color: #4c4c4c; }\n\n.signup-separator1[_ngcontent-%COMP%] {\n  margin-top: 30px;\n  height: 1px;\n  width: 275px;\n  background-color: #cccccc; }\n\n.signup-separator2[_ngcontent-%COMP%] {\n  height: 1px;\n  width: 275px;\n  background-color: #ffffff; }\n\n.signup-div[_ngcontent-%COMP%] {\n  height: 20px;\n  width: 275px;\n  padding-top: 10px;\n  text-decoration: underline;\n  font-size: 13px;\n  font-weight: 600;\n  color: #41a4c7;\n  line-height: 20px;\n  text-align: center; }\n\n.login-error-div[_ngcontent-%COMP%] {\n  width: 275px;\n  padding-top: 10px;\n  display: flex;\n  flex-direction: row; }\n\n.login-error-icon[_ngcontent-%COMP%] {\n  height: 20px;\n  width: 20px;\n  min-width: 20px;\n  margin-left: 5px;\n  background-position: center;\n  background-repeat: no-repeat;\n  background-image: url(/assets/error.bdaf0008c084b16da681ad026a92d8d3.svg); }\n\n.login-error-label[_ngcontent-%COMP%] {\n  padding-left: 5px !important;\n  font-size: 12px;\n  margin-bottom: 10px;\n  line-height: 20px; }\n\n.login-panel[_ngcontent-%COMP%] {\n  background-color: #e7f4f7 !important;\n  border: 0px !important;\n  border-radius: 0 !important; }\n\n.login-verticalLine[_ngcontent-%COMP%] {\n  border-left: thin solid #e7e7e7;\n  height: 375px;\n  margin-left: 40px; }\n\n.login-verticalLine-sm[_ngcontent-%COMP%] {\n  border-left: thin solid #626262;\n  height: 12px; }\n\n.login-link-style-sm[_ngcontent-%COMP%] {\n  font-size: 10px;\n  font-weight: normal;\n  color: #626262;\n  cursor: pointer;\n  vertical-align: top; }\n\n.cloud-login-style-lg[_ngcontent-%COMP%] {\n  font-size: 34px;\n  font-weight: normal;\n  color: #ffffff;\n  margin-bottom: 40px;\n  margin-top: 20px;\n  white-space: nowrap; }\n\n.cloud-login-style-lg-bold[_ngcontent-%COMP%] {\n  font-size: 26px;\n  font-weight: bold;\n  color: #ffffff;\n  margin-bottom: 40px; }\n\n.login-link-style[_ngcontent-%COMP%] {\n  font-size: 16px;\n  font-weight: normal;\n  color: #ffffff;\n  margin-bottom: 15px; }\n\n.login-logo[_ngcontent-%COMP%] {\n  background-color: #000000; }'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3NyYy91aS9zcmMvYXBwL2xvZ2luL3VzZXItbG9naW4uY29tcG9uZW50LnNjc3Muc2hpbS5uZ3N0eWxlLnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vc3JjL3VpL3NyYy9hcHAvbG9naW4vdXNlci1sb2dpbi5jb21wb25lbnQuc2NzcyJdLCJzb3VyY2VzQ29udGVudCI6WyIgIl0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7In0=
//# sourceMappingURL=user-login.component.scss.shim.ngstyle.js.map

/***/ }),
/* 541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RenderType_ConfigComponent */
/* unused harmony export View_ConfigComponent_0 */
/* unused harmony export View_ConfigComponent_Host_0 */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ConfigComponentNgFactory; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_component_scss_shim_ngstyle__ = __webpack_require__(542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_bootstrap_dist_css_bootstrap_css_shim_ngstyle__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_core__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_progressbar_progressbar_component_ngfactory__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_app_components_progressbar_progressbar_component__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__angular_common__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ddos_attack_config_ddos_attack_config_component_ngfactory__ = __webpack_require__(545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_app_main_ddos_attack_config_ddos_attack_config_component__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_app_attack_attack_service__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_app_aws_environment__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_app_main_config_config_service__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_app_main_target_validation_target_validation_service__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_app_systeminformation_systeminformation_service__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_app_trial_trial_service__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__ddos_attack_results_ddos_attack_results_component_ngfactory__ = __webpack_require__(547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__src_app_main_ddos_attack_results_ddos_attack_results_component__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__src_app_login_user_login_service__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__src_app_main_config_config_component__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__src_app_user_user_service__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__src_app_modals_modal_service__ = __webpack_require__(69);
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */




















var styles_ConfigComponent = [__WEBPACK_IMPORTED_MODULE_0__config_component_scss_shim_ngstyle__["a" /* styles */], __WEBPACK_IMPORTED_MODULE_1__node_modules_bootstrap_dist_css_bootstrap_css_shim_ngstyle__["a" /* styles */]];
var RenderType_ConfigComponent = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵcrt"]({ encapsulation: 0,
    styles: styles_ConfigComponent, data: {} });
function View_ConfigComponent_1(_l) {
    return __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 40, 'div', [['class',
                'row'], ['style', 'margin:0px; padding:0px;']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n      '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 37, 'div', [['class', 'col-sm-12 col-sm-offset-1 '],
                ['style', 'padding:0px;']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 7, 'div', [['class', ' clearfix visible-lg-block unreserve-box col-sm-10 '],
            ['style', 'min-width:972px !important;']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n          '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'div', [['class', 'col-sm-9 unreserve-box__textlg']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['You have consumed ', ' GB. To avoid accidental overspend, we require acknowledgement every 250 GB to proceed.'])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n          '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'button', [['class', 'col-sm-3 unreserve-box__btn btn '], ['id',
                'btn-unreserve-ips']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.btnOKCostControl() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['Yes, I understand'])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 7, 'div', [['class', ' clearfix visible-md-block unreserve-box col-sm-10 '], ['style',
                'min-width:805px !important;']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n          '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'div', [['class', 'col-sm-9 unreserve-box__text']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['You have consumed ', ' GB. To avoid accidental overspend, we require acknowledgement every 250 GB to proceed.'])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n          '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'button', [['class', 'col-sm-3 unreserve-box__btn btn '], ['id',
                'btn-unreserve-ips2']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.btnOKCostControl() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['Yes, I understand'])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 7, 'div', [['class', ' clearfix visible-sm-block unreserve-box col-sm-7 '], ['style',
                'max-width:385px !important; margin-bottom:20px !important;']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n          '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'div', [['class', 'col-sm-12 unreserve-box__text']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['You have consumed ', ' GB. To avoid accidental overspend, we require acknowledgement every 250 GB to proceed.'])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n          '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'button', [['class', 'col-sm-12 unreserve-box__btn btn '],
            ['id', 'btn-unreserve-ips3']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.btnOKCostControl() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['Yes, I understand'])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 7, 'div', [['class', ' clearfix visible-xs-block unreserve-box col-sm-10 '], ['style',
                'min-width:385px !important; margin-right:20px; margin-bottom:20px !important;']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n          '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'div', [['class', 'col-sm-9 unreserve-box__text']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['You have consumed ', ' GB. To avoid accidental overspend, we require acknowledgement every 250 GB to proceed.'])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n          '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'button', [['class', 'col-sm-3 unreserve-box__btn btn btn-block'],
            ['id', 'btn-unreserve-ips4'], ['style', 'height:50px !important;']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.btnOKCostControl() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['Yes, I understand'])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n      '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n  ']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.consume;
        _ck(_v, 7, 0, currVal_0);
        var currVal_1 = _co.consume;
        _ck(_v, 16, 0, currVal_1);
        var currVal_2 = _co.consume;
        _ck(_v, 25, 0, currVal_2);
        var currVal_3 = _co.consume;
        _ck(_v, 34, 0, currVal_3);
    });
}
function View_ConfigComponent_2(_l) {
    return __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 0, 'div', [['class',
                'empty-space row'], ['style', 'height:33px;']], null, null, null, null, null))], null, null);
}
function View_ConfigComponent_3(_l) {
    return __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 7, 'div', [['class',
                'row']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 4, 'div', [['class', 'col-sm-12 trail-over-block'], ['style', 'cursor: pointer']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.buyNowClick() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n        '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'div', [['class', 'trail-over-font']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['Your trial run has ended. To continue running the product, please click this banner to access the store and view buying options'])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n']))], null, null);
}
function View_ConfigComponent_0(_l) {
    return __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵvid"](0, [__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵqud"](402653184, 1, { progressBar: 0 }), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵqud"](402653184, 2, { attackResults: 0 }),
        __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵqud"](402653184, 3, { attackConfig: 0 }), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 7, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 4, 'div', [['class', 'col-sm-12']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'ixprogressbar', [], null, null, null, __WEBPACK_IMPORTED_MODULE_3__components_progressbar_progressbar_component_ngfactory__["a" /* View_ProgressbarComponent_0 */], __WEBPACK_IMPORTED_MODULE_3__components_progressbar_progressbar_component_ngfactory__["b" /* RenderType_ProgressbarComponent */])), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](114688, [[1, 4], ['progressBar',
                4]], 0, __WEBPACK_IMPORTED_MODULE_4__src_app_components_progressbar_progressbar_component__["a" /* ProgressbarComponent */], [], null, null),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n'])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n\n'])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 4, 'div', [['class', 'container']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n  '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵand"](16777216, null, null, 1, null, View_ConfigComponent_1)),
        __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_5__angular_common__["NgIf"], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["ViewContainerRef"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n'])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n\n'])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵand"](16777216, null, null, 1, null, View_ConfigComponent_2)), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_5__angular_common__["NgIf"], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["ViewContainerRef"],
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n'])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵand"](16777216, null, null, 1, null, View_ConfigComponent_3)), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_5__angular_common__["NgIf"], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["ViewContainerRef"],
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n\n'])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 13, 'div', [['class',
                'container']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n  '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 10, 'div', [['class', 'row ']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n      '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 7, 'div', [['class', 'col-sm-12 col-sm-offset-1']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n          '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'ddos-attack-config', [], null, null, null, __WEBPACK_IMPORTED_MODULE_6__ddos_attack_config_ddos_attack_config_component_ngfactory__["a" /* View_DdosAttackConfigComponent_0 */], __WEBPACK_IMPORTED_MODULE_6__ddos_attack_config_ddos_attack_config_component_ngfactory__["b" /* RenderType_DdosAttackConfigComponent */])),
        __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](245760, [[3, 4], ['attackConfig', 4]], 0, __WEBPACK_IMPORTED_MODULE_7__src_app_main_ddos_attack_config_ddos_attack_config_component__["a" /* DdosAttackConfigComponent */], [__WEBPACK_IMPORTED_MODULE_8__src_app_attack_attack_service__["a" /* AttackService */],
            __WEBPACK_IMPORTED_MODULE_9__src_app_aws_environment__["a" /* AwsEnvironment */], __WEBPACK_IMPORTED_MODULE_10__src_app_main_config_config_service__["a" /* ConfigService */], __WEBPACK_IMPORTED_MODULE_11__src_app_main_target_validation_target_validation_service__["a" /* TargetValidationService */], __WEBPACK_IMPORTED_MODULE_12__src_app_systeminformation_systeminformation_service__["a" /* SystemInformationService */],
            __WEBPACK_IMPORTED_MODULE_13__src_app_trial_trial_service__["a" /* TrialService */]], null, null), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n          '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'ddos-attack-results', [], null, null, null, __WEBPACK_IMPORTED_MODULE_14__ddos_attack_results_ddos_attack_results_component_ngfactory__["a" /* View_DdosAttackResultsComponent_0 */], __WEBPACK_IMPORTED_MODULE_14__ddos_attack_results_ddos_attack_results_component_ngfactory__["b" /* RenderType_DdosAttackResultsComponent */])), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](245760, [[2, 4], ['attackResults',
                4]], 0, __WEBPACK_IMPORTED_MODULE_15__src_app_main_ddos_attack_results_ddos_attack_results_component__["a" /* DdosAttackResultsComponent */], [__WEBPACK_IMPORTED_MODULE_8__src_app_attack_attack_service__["a" /* AttackService */], __WEBPACK_IMPORTED_MODULE_10__src_app_main_config_config_service__["a" /* ConfigService */],
            __WEBPACK_IMPORTED_MODULE_11__src_app_main_target_validation_target_validation_service__["a" /* TargetValidationService */], __WEBPACK_IMPORTED_MODULE_16__src_app_login_user_login_service__["a" /* LoginService */]], null, null),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n      '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n  '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n\n'])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n']))], function (_ck, _v) {
        var _co = _v.component;
        _ck(_v, 8, 0);
        var currVal_0 = _co.showCostControlAlert;
        _ck(_v, 15, 0, currVal_0);
        var currVal_1 = (_co.trialMode && _co.trialModeExpired);
        _ck(_v, 19, 0, currVal_1);
        var currVal_2 = (_co.trialMode && _co.trialModeExpired);
        _ck(_v, 22, 0, currVal_2);
        _ck(_v, 31, 0);
        _ck(_v, 34, 0);
    }, null);
}
function View_ConfigComponent_Host_0(_l) {
    return __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'config', [], null, null, null, View_ConfigComponent_0, RenderType_ConfigComponent)),
        __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](114688, null, 0, __WEBPACK_IMPORTED_MODULE_17__src_app_main_config_config_component__["a" /* ConfigComponent */], [__WEBPACK_IMPORTED_MODULE_10__src_app_main_config_config_service__["a" /* ConfigService */], __WEBPACK_IMPORTED_MODULE_18__src_app_user_user_service__["a" /* UserService */],
            __WEBPACK_IMPORTED_MODULE_13__src_app_trial_trial_service__["a" /* TrialService */], __WEBPACK_IMPORTED_MODULE_12__src_app_systeminformation_systeminformation_service__["a" /* SystemInformationService */], __WEBPACK_IMPORTED_MODULE_19__src_app_modals_modal_service__["a" /* ModalService */]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var ConfigComponentNgFactory = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵccf"]('config', __WEBPACK_IMPORTED_MODULE_17__src_app_main_config_config_component__["a" /* ConfigComponent */], View_ConfigComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3NyYy91aS9zcmMvYXBwL21haW4vY29uZmlnL2NvbmZpZy5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vc3JjL3VpL3NyYy9hcHAvbWFpbi9jb25maWcvY29uZmlnLmNvbXBvbmVudC50cyIsIm5nOi8vL3NyYy91aS9zcmMvYXBwL21haW4vY29uZmlnL2NvbmZpZy5jb21wb25lbnQuaHRtbCIsIm5nOi8vL3NyYy91aS9zcmMvYXBwL21haW4vY29uZmlnL2NvbmZpZy5jb21wb25lbnQudHMuQ29uZmlnQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPGRpdiBjbGFzcz1cInJvd1wiPlxuICAgIDxkaXYgY2xhc3M9XCJjb2wtc20tMTJcIj5cbiAgICAgICAgPGl4cHJvZ3Jlc3NiYXIgI3Byb2dyZXNzQmFyPjwvaXhwcm9ncmVzc2Jhcj5cbiAgICA8L2Rpdj5cbjwvZGl2PlxuXG48ZGl2IGNsYXNzPVwiY29udGFpbmVyXCI+XG4gIDxkaXYgKm5nSWY9XCJzaG93Q29zdENvbnRyb2xBbGVydFwiIGNsYXNzPVwicm93XCIgc3R5bGU9XCJtYXJnaW46MHB4OyBwYWRkaW5nOjBweDtcIj5cbiAgICAgIDxkaXYgIGNsYXNzPVwiY29sLXNtLTEyIGNvbC1zbS1vZmZzZXQtMSBcIiAgc3R5bGU9XCJwYWRkaW5nOjBweDtcIiA+XG4gICAgICAgIDxkaXYgIGNsYXNzPVwiIGNsZWFyZml4IHZpc2libGUtbGctYmxvY2sgdW5yZXNlcnZlLWJveCBjb2wtc20tMTAgXCIgc3R5bGU9XCJtaW4td2lkdGg6OTcycHggIWltcG9ydGFudDtcIj5cbiAgICAgICAgICA8ZGl2IGNsYXNzPVwiY29sLXNtLTkgdW5yZXNlcnZlLWJveF9fdGV4dGxnXCIgPllvdSBoYXZlIGNvbnN1bWVkIHt7Y29uc3VtZX19IEdCLiBUbyBhdm9pZCBhY2NpZGVudGFsIG92ZXJzcGVuZCwgd2UgcmVxdWlyZSBhY2tub3dsZWRnZW1lbnQgZXZlcnkgMjUwIEdCIHRvIHByb2NlZWQuPC9kaXY+XG4gICAgICAgICAgPGJ1dHRvbiBjbGFzcz1cImNvbC1zbS0zIHVucmVzZXJ2ZS1ib3hfX2J0biBidG4gXCIgaWQ9XCJidG4tdW5yZXNlcnZlLWlwc1wiIChjbGljayk9XCJidG5PS0Nvc3RDb250cm9sKClcIj5ZZXMsIEkgdW5kZXJzdGFuZDwvYnV0dG9uPlxuICAgICAgICA8L2Rpdj5cblxuICAgICAgICA8ZGl2ICBjbGFzcz1cIiBjbGVhcmZpeCB2aXNpYmxlLW1kLWJsb2NrIHVucmVzZXJ2ZS1ib3ggY29sLXNtLTEwIFwiIHN0eWxlPVwibWluLXdpZHRoOjgwNXB4ICFpbXBvcnRhbnQ7XCI+XG4gICAgICAgICAgPGRpdiBjbGFzcz1cImNvbC1zbS05IHVucmVzZXJ2ZS1ib3hfX3RleHRcIiA+WW91IGhhdmUgY29uc3VtZWQge3tjb25zdW1lfX0gR0IuIFRvIGF2b2lkIGFjY2lkZW50YWwgb3ZlcnNwZW5kLCB3ZSByZXF1aXJlIGFja25vd2xlZGdlbWVudCBldmVyeSAyNTAgR0IgdG8gcHJvY2VlZC48L2Rpdj5cbiAgICAgICAgICA8YnV0dG9uIGNsYXNzPVwiY29sLXNtLTMgdW5yZXNlcnZlLWJveF9fYnRuIGJ0biBcIiBpZD1cImJ0bi11bnJlc2VydmUtaXBzMlwiIChjbGljayk9XCJidG5PS0Nvc3RDb250cm9sKClcIj5ZZXMsIEkgdW5kZXJzdGFuZDwvYnV0dG9uPlxuICAgICAgICA8L2Rpdj5cblxuICAgICAgICA8ZGl2ICBjbGFzcz1cIiBjbGVhcmZpeCB2aXNpYmxlLXNtLWJsb2NrIHVucmVzZXJ2ZS1ib3ggY29sLXNtLTcgXCIgc3R5bGU9XCJtYXgtd2lkdGg6Mzg1cHggIWltcG9ydGFudDsgbWFyZ2luLWJvdHRvbToyMHB4ICFpbXBvcnRhbnQ7XCI+XG4gICAgICAgICAgPGRpdiBjbGFzcz1cImNvbC1zbS0xMiB1bnJlc2VydmUtYm94X190ZXh0XCIgPllvdSBoYXZlIGNvbnN1bWVkIHt7Y29uc3VtZX19IEdCLiBUbyBhdm9pZCBhY2NpZGVudGFsIG92ZXJzcGVuZCwgd2UgcmVxdWlyZSBhY2tub3dsZWRnZW1lbnQgZXZlcnkgMjUwIEdCIHRvIHByb2NlZWQuPC9kaXY+XG4gICAgICAgICAgPGJ1dHRvbiBjbGFzcz1cImNvbC1zbS0xMiB1bnJlc2VydmUtYm94X19idG4gYnRuIFwiIGlkPVwiYnRuLXVucmVzZXJ2ZS1pcHMzXCIgKGNsaWNrKT1cImJ0bk9LQ29zdENvbnRyb2woKVwiPlllcywgSSB1bmRlcnN0YW5kPC9idXR0b24+XG4gICAgICAgIDwvZGl2PlxuXG4gICAgICAgIDxkaXYgIGNsYXNzPVwiIGNsZWFyZml4IHZpc2libGUteHMtYmxvY2sgdW5yZXNlcnZlLWJveCBjb2wtc20tMTAgXCIgc3R5bGU9XCJtaW4td2lkdGg6Mzg1cHggIWltcG9ydGFudDsgbWFyZ2luLXJpZ2h0OjIwcHg7IG1hcmdpbi1ib3R0b206MjBweCAhaW1wb3J0YW50O1wiPlxuICAgICAgICAgIDxkaXYgY2xhc3M9XCJjb2wtc20tOSB1bnJlc2VydmUtYm94X190ZXh0XCIgPllvdSBoYXZlIGNvbnN1bWVkIHt7Y29uc3VtZX19IEdCLiBUbyBhdm9pZCBhY2NpZGVudGFsIG92ZXJzcGVuZCwgd2UgcmVxdWlyZSBhY2tub3dsZWRnZW1lbnQgZXZlcnkgMjUwIEdCIHRvIHByb2NlZWQuPC9kaXY+XG4gICAgICAgICAgPGJ1dHRvbiBjbGFzcz1cImNvbC1zbS0zIHVucmVzZXJ2ZS1ib3hfX2J0biBidG4gYnRuLWJsb2NrXCIgaWQ9XCJidG4tdW5yZXNlcnZlLWlwczRcIiAoY2xpY2spPVwiYnRuT0tDb3N0Q29udHJvbCgpXCIgc3R5bGU9XCJoZWlnaHQ6NTBweCAhaW1wb3J0YW50O1wiPlllcywgSSB1bmRlcnN0YW5kPC9idXR0b24+XG4gICAgICAgIDwvZGl2PlxuICAgICAgPC9kaXY+XG4gIDwvZGl2PlxuPC9kaXY+XG5cbjxkaXYgY2xhc3M9XCJlbXB0eS1zcGFjZSByb3dcIiAqbmdJZj1cInRyaWFsTW9kZSAmJiB0cmlhbE1vZGVFeHBpcmVkXCIgc3R5bGU9XCJoZWlnaHQ6MzNweDtcIj48L2Rpdj5cbjxkaXYgY2xhc3M9XCJyb3dcIiAqbmdJZj1cInRyaWFsTW9kZSAmJiB0cmlhbE1vZGVFeHBpcmVkXCI+XG4gICAgPGRpdiBjbGFzcz1cImNvbC1zbS0xMiB0cmFpbC1vdmVyLWJsb2NrXCIgIHN0eWxlPVwiY3Vyc29yOiBwb2ludGVyXCIgKGNsaWNrKT1cImJ1eU5vd0NsaWNrKClcIj5cbiAgICAgICAgPGRpdiBjbGFzcz1cInRyYWlsLW92ZXItZm9udFwiID5Zb3VyIHRyaWFsIHJ1biBoYXMgZW5kZWQuIFRvIGNvbnRpbnVlIHJ1bm5pbmcgdGhlIHByb2R1Y3QsIHBsZWFzZSBjbGljayB0aGlzIGJhbm5lciB0byBhY2Nlc3MgdGhlIHN0b3JlIGFuZCB2aWV3IGJ1eWluZyBvcHRpb25zPC9kaXY+XG4gICAgPC9kaXY+XG48L2Rpdj5cblxuPGRpdiBjbGFzcz1cImNvbnRhaW5lclwiPlxuICA8ZGl2IGNsYXNzPVwicm93IFwiPlxuICAgICAgPGRpdiBjbGFzcz1cImNvbC1zbS0xMiBjb2wtc20tb2Zmc2V0LTFcIiA+XG4gICAgICAgICAgPGRkb3MtYXR0YWNrLWNvbmZpZyAjYXR0YWNrQ29uZmlnID48L2Rkb3MtYXR0YWNrLWNvbmZpZz5cbiAgICAgICAgICA8ZGRvcy1hdHRhY2stcmVzdWx0cyAjYXR0YWNrUmVzdWx0cz48L2Rkb3MtYXR0YWNrLXJlc3VsdHM+XG4gICAgICA8L2Rpdj5cbiAgPC9kaXY+XG5cbjwvZGl2PlxuIiwiPGNvbmZpZz48L2NvbmZpZz4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztvQkNPRTtNQUFBO01BQUEsOEJBQStFLDZDQUMzRTthQUFBO1VBQUE7VUFBQSxnQkFBZ0UsK0NBQzlEO01BQUE7VUFBQTtNQUFBLDhCQUFzRztNQUNwRztVQUFBO01BQTZDO01BQTBILGlEQUN2SztVQUFBO2NBQUE7b0JBQUE7WUFBQTtZQUFBO1lBQXdFO2NBQUE7Y0FBQTtZQUFBO1lBQXhFO1VBQUEsZ0NBQXFHO01BQTBCLCtDQUMzSDtVQUFBLG1CQUVOO1VBQUE7Y0FBQTtVQUFBLDhCQUFzRztNQUNwRztVQUFBO01BQTJDO01BQTBILGlEQUNySztVQUFBO2NBQUE7b0JBQUE7WUFBQTtZQUFBO1lBQXlFO2NBQUE7Y0FBQTtZQUFBO1lBQXpFO1VBQUEsZ0NBQXNHO01BQTBCLCtDQUM1SDtVQUFBLG1CQUVOO1VBQUE7Y0FBQTtVQUFBLDBEQUFvSTtVQUFBLG1CQUNsSTtVQUFBO1VBQUEsNENBQTRDO1VBQUE7TUFBMEgsaURBQ3RLO1VBQUE7Y0FBQTtVQUFBO1lBQUE7WUFBQTtZQUEwRTtjQUFBO2NBQUE7WUFBQTtZQUExRTtVQUFBLGdDQUF1RztNQUEwQiwrQ0FDN0g7VUFBQSxtQkFFTjtVQUFBO2NBQUE7VUFBQTtNQUF3SixpREFDdEo7VUFBQTtVQUFBLDBEQUEyQztVQUFBO01BQTBILGlEQUNySztVQUFBO2NBQUE7VUFBQTtZQUFBO1lBQUE7WUFBa0Y7Y0FBQTtjQUFBO1lBQUE7WUFBbEY7VUFBQSxnQ0FBK0k7TUFBMEIsK0NBQ3JLO1VBQUEsZUFDRjs7O0lBbEIyQztJQUFBO0lBS0Y7SUFBQTtJQUtDO0lBQUE7SUFLRDtJQUFBOzs7O29CQU9yRDtNQUFBO01BQUE7OztvQkFDQTtNQUFBO01BQXVELDJDQUNuRDtVQUFBO1VBQUE7WUFBQTtZQUFBO1lBQWlFO2NBQUE7Y0FBQTtZQUFBO1lBQWpFO1VBQUEsZ0NBQXlGO01BQ3JGO1VBQUE7TUFBOEI7TUFBcUksMkNBQ2pLOzs7Ozs0Q0FwQ1Y7VUFBQTtVQUFBLGdCQUFpQiwyQ0FDYjtVQUFBO1VBQUEsMERBQXVCO1VBQUEsaUJBQ25CO1VBQUE7NENBQUEsVUFBQTtVQUFBO01BQTRDLDJDQUMxQztNQUNKLHlDQUVOO1VBQUE7VUFBQSw4QkFBdUIseUNBQ3JCO2lCQUFBO2FBQUE7VUFBQSx3QkFzQk0sdUNBQ0Y7VUFBQSxXQUVOO1VBQUEsZ0NBQUE7d0JBQUEsbUNBQThGO1VBQUEsU0FDOUY7VUFBQSxnQ0FBQTt3QkFBQSxtQ0FJTTtVQUFBLFdBRU47VUFBQTtNQUF1Qix5Q0FDckI7VUFBQTtVQUFBLGdCQUFrQiw2Q0FDZDtVQUFBO1VBQUE7TUFBd0MsaURBQ3BDO1VBQUE7VUFBQTthQUFBOzswQkFBQSwrQkFBd0Q7VUFBQSxtQkFDeEQ7VUFBQTttREFBQSxVQUFBO1VBQUE7c0RBQUE7TUFBMEQsNkNBQ3hEO01BQ0oseUNBRUY7OztRQTdDRTtRQUtEO1FBQUwsWUFBSyxTQUFMO1FBeUIyQjtRQUE3QixZQUE2QixTQUE3QjtRQUNpQjtRQUFqQixZQUFpQixTQUFqQjtRQVNVO1FBQ0E7Ozs7b0JDM0NWO01BQUE7YUFBQTt3RUFBQTtVQUFBO0lBQUE7Ozs7In0=
//# sourceMappingURL=config.component.ngfactory.js.map

/***/ }),
/* 542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return styles; });
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */
var styles = ['.unreserve-box[_ngcontent-%COMP%] {\n  background-color: #fff;\n  margin: 0px;\n  margin-bottom: 20px;\n  padding: 0px !important;\n  border: 1px solid #d20f0f; }\n  .unreserve-box__text[_ngcontent-%COMP%] {\n    justify: left;\n    font-size: 11px;\n    padding-top: 1em;\n    height: 50px !important; }\n    .unreserve-box__text-bold[_ngcontent-%COMP%] {\n      text-align: left;\n      font-size: 11px;\n      font-weight: bold;\n      padding: 20px;\n      margin-right: auto; }\n  .unreserve-box__textlg[_ngcontent-%COMP%] {\n    justify: left;\n    font-size: 11px;\n    padding-top: 1.7em;\n    height: 50px !important; }\n    .unreserve-box__textlg-bold[_ngcontent-%COMP%] {\n      text-align: left;\n      font-size: 11px;\n      font-weight: bold;\n      padding: 20px;\n      margin-right: auto; }\n  .unreserve-box__btn[_ngcontent-%COMP%] {\n    text-transform: uppercase;\n    height: 50px !important;\n    border-radius: 0 !important;\n    background-color: #d20f0f;\n    border-color: #d20f0f;\n    color: #ffffff; }\n\n.trail-over-block[_ngcontent-%COMP%] {\n  background-color: #9abc7d;\n  min-height: 3em !important;\n  max-height: 4em !important;\n  margin-bottom: 30px;\n  text-align: center;\n  min-width: 525px;\n  padding: 0px 30px 30px 0px; }\n\n.trail-over-font[_ngcontent-%COMP%] {\n  color: #ffffff;\n  padding-top: 13px; }'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3NyYy91aS9zcmMvYXBwL21haW4vY29uZmlnL2NvbmZpZy5jb21wb25lbnQuc2Nzcy5zaGltLm5nc3R5bGUudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9zcmMvdWkvc3JjL2FwcC9tYWluL2NvbmZpZy9jb25maWcuY29tcG9uZW50LnNjc3MiXSwic291cmNlc0NvbnRlbnQiOlsiICJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7OyJ9
//# sourceMappingURL=config.component.scss.shim.ngstyle.js.map

/***/ }),
/* 543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RenderType_DashboardComponent */
/* unused harmony export View_DashboardComponent_0 */
/* unused harmony export View_DashboardComponent_Host_0 */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DashboardComponentNgFactory; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dashboard_component_scss_shim_ngstyle__ = __webpack_require__(544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_bootstrap_dist_css_bootstrap_css_shim_ngstyle__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_core__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__angular_router__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__target_validation_target_validation_dialog_component_ngfactory__ = __webpack_require__(553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_app_main_target_validation_target_validation_dialog_component__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_app_main_target_validation_target_validation_service__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__angular_common__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modals_modal_loading_component_ngfactory__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_app_modals_modal_loading_component__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_app_modals_modal_service__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__modals_modal_error_component_ngfactory__ = __webpack_require__(558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_app_modals_modal_error_component__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_app_main_dashboard_component__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_app_publisher_publisher_service__ = __webpack_require__(31);
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */















var styles_DashboardComponent = [__WEBPACK_IMPORTED_MODULE_0__dashboard_component_scss_shim_ngstyle__["a" /* styles */], __WEBPACK_IMPORTED_MODULE_1__node_modules_bootstrap_dist_css_bootstrap_css_shim_ngstyle__["a" /* styles */]];
var RenderType_DashboardComponent = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵcrt"]({ encapsulation: 0,
    styles: styles_DashboardComponent, data: {} });
function View_DashboardComponent_0(_l) {
    return __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵvid"](0, [__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵqud"](402653184, 1, { targetValidationModal: 0 }), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵqud"](402653184, 2, { errorModal: 0 }), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵqud"](402653184, 3, { loadingModal: 0 }), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['﻿'])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 4, 'div', [['class', 'dashboard'],
            ['id', 'dashboard']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](16777216, null, null, 1, 'router-outlet', [], null, null, null, null, null)), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](212992, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_router__["z" /* RouterOutlet */], [__WEBPACK_IMPORTED_MODULE_3__angular_router__["q" /* ChildrenOutletContexts */], __WEBPACK_IMPORTED_MODULE_2__angular_core__["ViewContainerRef"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["ComponentFactoryResolver"], [8,
                null], __WEBPACK_IMPORTED_MODULE_2__angular_core__["ChangeDetectorRef"]], null, null), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n'])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n'])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'dialog-target-validation', [], null, null, null, __WEBPACK_IMPORTED_MODULE_4__target_validation_target_validation_dialog_component_ngfactory__["a" /* View_TargetValidationDialog_0 */], __WEBPACK_IMPORTED_MODULE_4__target_validation_target_validation_dialog_component_ngfactory__["b" /* RenderType_TargetValidationDialog */])), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](114688, [[1, 4], ['targetValidationDialog',
                4]], 0, __WEBPACK_IMPORTED_MODULE_5__src_app_main_target_validation_target_validation_dialog_component__["b" /* TargetValidationDialog */], [__WEBPACK_IMPORTED_MODULE_6__src_app_main_target_validation_target_validation_service__["a" /* TargetValidationService */], __WEBPACK_IMPORTED_MODULE_7__angular_common__["Location"]], null, null), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n'])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'modal-loading', [], null, null, null, __WEBPACK_IMPORTED_MODULE_8__modals_modal_loading_component_ngfactory__["a" /* View_LoadingModal_0 */], __WEBPACK_IMPORTED_MODULE_8__modals_modal_loading_component_ngfactory__["b" /* RenderType_LoadingModal */])), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](114688, [[3, 4], ['loadingModal',
                4]], 0, __WEBPACK_IMPORTED_MODULE_9__src_app_modals_modal_loading_component__["a" /* LoadingModal */], [__WEBPACK_IMPORTED_MODULE_10__src_app_modals_modal_service__["a" /* ModalService */]], null, null), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n'])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'modal-error', [], null, null, null, __WEBPACK_IMPORTED_MODULE_11__modals_modal_error_component_ngfactory__["a" /* View_ShowErrorModal_0 */], __WEBPACK_IMPORTED_MODULE_11__modals_modal_error_component_ngfactory__["b" /* RenderType_ShowErrorModal */])), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](114688, [[2, 4], ['errorModal', 4]], 0, __WEBPACK_IMPORTED_MODULE_12__src_app_modals_modal_error_component__["a" /* ShowErrorModal */], [], null, null)], function (_ck, _v) {
        _ck(_v, 7, 0);
        _ck(_v, 11, 0);
        _ck(_v, 14, 0);
        _ck(_v, 17, 0);
    }, null);
}
function View_DashboardComponent_Host_0(_l) {
    return __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'dashboard', [], null, null, null, View_DashboardComponent_0, RenderType_DashboardComponent)),
        __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](114688, null, 0, __WEBPACK_IMPORTED_MODULE_13__src_app_main_dashboard_component__["a" /* DashboardComponent */], [__WEBPACK_IMPORTED_MODULE_14__src_app_publisher_publisher_service__["a" /* PublisherService */],
            __WEBPACK_IMPORTED_MODULE_10__src_app_modals_modal_service__["a" /* ModalService */]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var DashboardComponentNgFactory = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵccf"]('dashboard', __WEBPACK_IMPORTED_MODULE_13__src_app_main_dashboard_component__["a" /* DashboardComponent */], View_DashboardComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3NyYy91aS9zcmMvYXBwL21haW4vZGFzaGJvYXJkLmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9zcmMvdWkvc3JjL2FwcC9tYWluL2Rhc2hib2FyZC5jb21wb25lbnQudHMiLCJuZzovLy9zcmMvdWkvc3JjL2FwcC9tYWluL2Rhc2hib2FyZC5jb21wb25lbnQuaHRtbCIsIm5nOi8vL3NyYy91aS9zcmMvYXBwL21haW4vZGFzaGJvYXJkLmNvbXBvbmVudC50cy5EYXNoYm9hcmRDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCLvu788ZGl2IGlkPVwiZGFzaGJvYXJkXCIgY2xhc3M9XCJkYXNoYm9hcmRcIj5cbiAgICA8cm91dGVyLW91dGxldD48L3JvdXRlci1vdXRsZXQ+XG48L2Rpdj5cbjxkaWFsb2ctdGFyZ2V0LXZhbGlkYXRpb24gI3RhcmdldFZhbGlkYXRpb25EaWFsb2c+PC9kaWFsb2ctdGFyZ2V0LXZhbGlkYXRpb24+XG48bW9kYWwtbG9hZGluZyAjbG9hZGluZ01vZGFsPjwvbW9kYWwtbG9hZGluZz5cbjxtb2RhbC1lcnJvciAjZXJyb3JNb2RhbD48L21vZGFsLWVycm9yPiIsIjxkYXNoYm9hcmQ+PC9kYXNoYm9hcmQ+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs4RENBQTtNQUFBLFFBQUM7TUFBQTtNQUFBLGdCQUFzQywyQ0FDbkM7TUFBQTtNQUFBLG1EQUFBO01BQUE7VUFBQSxrRUFBK0I7YUFBQSx3QkFDN0IsdUNBQ047YUFBQTtVQUFBOzhDQUFBLFVBQUE7TUFBQTtNQUFBLGVBQTZFLHVDQUM3RTtNQUFBO3VEQUFBLFVBQUE7TUFBQSxzRUFBNkM7YUFBQSx3QkFDN0M7TUFBQTttQ0FBQSxVQUFBO01BQUE7SUFKSTtJQUVKO0lBQ0E7SUFDQTs7OztvQkNMQTtNQUFBO2FBQUE7MEJBQUE7SUFBQTs7OzsifQ==
//# sourceMappingURL=dashboard.component.ngfactory.js.map

/***/ }),
/* 544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return styles; });
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */
var styles = ['.dashboard[_ngcontent-%COMP%] {\n  height: 100%;\n  width: 100%;\n  overflow: auto;\n  box-sizing: border-box;\n  background-color: #F1F1F1;\n  margin-top: 0;\n  padding-top: 0; }\n\n.progressPlaceholderBG[_ngcontent-%COMP%] {\n  background-color: white;\n  margin: 0; }'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3NyYy91aS9zcmMvYXBwL21haW4vZGFzaGJvYXJkLmNvbXBvbmVudC5zY3NzLnNoaW0ubmdzdHlsZS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL3NyYy91aS9zcmMvYXBwL21haW4vZGFzaGJvYXJkLmNvbXBvbmVudC5zY3NzIl0sInNvdXJjZXNDb250ZW50IjpbIiAiXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7OzsifQ==
//# sourceMappingURL=dashboard.component.scss.shim.ngstyle.js.map

/***/ }),
/* 545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RenderType_DdosAttackConfigComponent; });
/* harmony export (immutable) */ __webpack_exports__["a"] = View_DdosAttackConfigComponent_0;
/* unused harmony export View_DdosAttackConfigComponent_Host_0 */
/* unused harmony export DdosAttackConfigComponentNgFactory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ddos_attack_config_component_scss_shim_ngstyle__ = __webpack_require__(546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_bootstrap_dist_css_bootstrap_css_shim_ngstyle__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_core__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__angular_forms__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_app_main_ddos_attack_config_ddos_attack_config_component__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_app_components_input_trim_directive__ = __webpack_require__(574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__angular_common__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_app_attack_attack_service__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_app_aws_environment__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_app_main_config_config_service__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_app_main_target_validation_target_validation_service__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_app_systeminformation_systeminformation_service__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_app_trial_trial_service__ = __webpack_require__(39);
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */













var styles_DdosAttackConfigComponent = [__WEBPACK_IMPORTED_MODULE_0__ddos_attack_config_component_scss_shim_ngstyle__["a" /* styles */], __WEBPACK_IMPORTED_MODULE_1__node_modules_bootstrap_dist_css_bootstrap_css_shim_ngstyle__["a" /* styles */]];
var RenderType_DdosAttackConfigComponent = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵcrt"]({ encapsulation: 0,
    styles: styles_DdosAttackConfigComponent, data: {} });
function View_DdosAttackConfigComponent_1(_l) {
    return __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 3, 'option', [], null, null, null, null, null)), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](147456, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["t" /* NgSelectOption */], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["ElementRef"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["Renderer2"], [2, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["u" /* SelectControlValueAccessor */]]], { value: [0, 'value'] }, null), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](147456, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["v" /* ɵq */], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["ElementRef"],
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["Renderer2"], [8, null]], { value: [0, 'value'] }, null), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['', '']))], function (_ck, _v) {
        var currVal_0 = _v.context.$implicit.Name;
        _ck(_v, 1, 0, currVal_0);
        var currVal_1 = _v.context.$implicit.Name;
        _ck(_v, 2, 0, currVal_1);
    }, function (_ck, _v) {
        var currVal_2 = _v.context.$implicit.Label;
        _ck(_v, 3, 0, currVal_2);
    });
}
function View_DdosAttackConfigComponent_2(_l) {
    return __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 3, 'option', [], null, null, null, null, null)), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](147456, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["t" /* NgSelectOption */], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["ElementRef"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["Renderer2"], [2, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["u" /* SelectControlValueAccessor */]]], { ngValue: [0, 'ngValue'] }, null), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](147456, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["v" /* ɵq */], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["ElementRef"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["Renderer2"], [8, null]], { ngValue: [0, 'ngValue'] }, null),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['', '']))], function (_ck, _v) {
        var currVal_0 = _v.context.$implicit.Name;
        _ck(_v, 1, 0, currVal_0);
        var currVal_1 = _v.context.$implicit.Name;
        _ck(_v, 2, 0, currVal_1);
    }, function (_ck, _v) {
        var currVal_2 = _v.context.$implicit.Label;
        _ck(_v, 3, 0, currVal_2);
    });
}
function View_DdosAttackConfigComponent_3(_l) {
    return __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 3, 'option', [['value',
                '30']], null, null, null, null, null)),
        __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](147456, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["t" /* NgSelectOption */], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["ElementRef"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["Renderer2"],
            [2, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["u" /* SelectControlValueAccessor */]]], { value: [0, 'value'] }, null), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](147456, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["v" /* ɵq */], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["ElementRef"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["Renderer2"], [8, null]], { value: [0,
                'value'] }, null), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['30 Seconds']))], function (_ck, _v) {
        var currVal_0 = '30';
        _ck(_v, 1, 0, currVal_0);
        var currVal_1 = '30';
        _ck(_v, 2, 0, currVal_1);
    }, null);
}
function View_DdosAttackConfigComponent_4(_l) {
    return __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 3, 'option', [['value',
                '120']], null, null, null, null, null)),
        __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](147456, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["t" /* NgSelectOption */], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["ElementRef"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["Renderer2"],
            [2, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["u" /* SelectControlValueAccessor */]]], { value: [0, 'value'] }, null), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](147456, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["v" /* ɵq */], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["ElementRef"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["Renderer2"], [8, null]], { value: [0,
                'value'] }, null), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['2 Minutes']))], function (_ck, _v) {
        var currVal_0 = '120';
        _ck(_v, 1, 0, currVal_0);
        var currVal_1 = '120';
        _ck(_v, 2, 0, currVal_1);
    }, null);
}
function View_DdosAttackConfigComponent_5(_l) {
    return __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 0, 'div', [['class',
                'empty-space col-sm-1'], ['style', 'height: 47px;']], null, null, null, null, null))], null, null);
}
function View_DdosAttackConfigComponent_6(_l) {
    return __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 0, 'div', [['class',
                'empty-space col-sm-1'], ['style', 'height: 29px;']], null, null, null, null, null))], null, null);
}
function View_DdosAttackConfigComponent_7(_l) {
    return __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 4, 'div', [['class',
                'col-sm-12 text-center estimatedCycleTime'], ['style', 'margin-top: 5px;']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['Estimated\n                Outbound Data: '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'b', [], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['', ''])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            ']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.estimatedOutboundData;
        _ck(_v, 3, 0, currVal_0);
    });
}
function View_DdosAttackConfigComponent_8(_l) {
    return __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 3, 'div', [['class',
                'col-sm-12 text-center estimatedCycleTime'], ['style', 'margin-top: 5px;']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['Estimated cycle time: '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'b', [], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['', ' minutes']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.estimatedTime;
        _ck(_v, 3, 0, currVal_0);
    });
}
function View_DdosAttackConfigComponent_9(_l) {
    return __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 0, 'div', [['class',
                'empty-space col-sm-1'], ['style', 'height: 0px;']], null, null, null, null, null))], null, null);
}
function View_DdosAttackConfigComponent_10(_l) {
    return __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 9, 'div', [['class',
                'attack-error-div'], ['id', 'attack-error-div']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n        '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 0, 'div', [['class', 'attack-error-icon'],
            ['id', 'attack-error-icon']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 4, 'div', [['class', 'attack-error-label'], ['id',
                'attack-error-label']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'span', [], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['', ''])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n    ']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.error;
        _ck(_v, 7, 0, currVal_0);
    });
}
function View_DdosAttackConfigComponent_0(_l) {
    return __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵvid"](0, [__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵqud"](402653184, 1, { attackForm: 0 }), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 264, 'div', [['class', 'panel cloud-panel-style cloud-panel-margins-padding col-sm-5 form-panel-height']], null, null, null, null, null)), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'div', [['class', 'panel-heading cloud-panel-header-style']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n        DDoS TEST CONFIGURATION\n    '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 247, 'div', [['class', 'panel-body']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n        '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 244, 'form', [['novalidate', '']], [[2, 'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'submit'], [null, 'reset']], function (_v, en, $event) {
            var ad = true;
            if (('submit' === en)) {
                var pd_0 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 10).onSubmit($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('reset' === en)) {
                var pd_1 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 10).onReset() !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["e" /* ɵbf */], [], null, null), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, [[1, 4], ['attackForm', 4]], 0, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["f" /* NgForm */], [[8, null], [8, null]], null, null), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵprd"](2048, null, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["g" /* ControlContainer */], null, [__WEBPACK_IMPORTED_MODULE_3__angular_forms__["f" /* NgForm */]]), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["h" /* NgControlStatusGroup */], [__WEBPACK_IMPORTED_MODULE_3__angular_forms__["g" /* ControlContainer */]], null, null), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 4, 'div', [['class', 'clearfix  visible-xs-block ']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'label', [['class', 'control-label form-top-padding cloud-label-style'], ['for',
                'targetIP']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['Target IP Address'])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 48, 'div', [['class', 'row clearfix  visible-sm-block visible-md-block visible-lg-block'],
            ['style', 'height: 60px; margin-bottom: 33px;']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 45, 'div', [], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                    '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 18, 'div', [['class', 'col-sm-7 mytooltip']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                      '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 4, 'div', [['class', 'clearfix  visible-sm-block visible-md-block visible-lg-block']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                          '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'label', [['class', 'control-label form-top-padding cloud-label-style'],
            ['for', 'targetIP']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['Target IP Address'])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                      '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 9, 'input', [['class', 'form-control cloud-label-style'], ['id', 'targetIP'],
            ['name', 'targetIp'], ['pattern', '^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$'],
            ['placeholder', 'Target IP'], ['required', ''], ['trim', ''], ['type', 'text']], [[8, 'title', 0], [1, 'required', 0], [1, 'pattern', 0], [2, 'ng-untouched', null],
            [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'ngModelChange'], [null,
                'input'], [null, 'blur'], [null, 'compositionstart'], [null,
                'compositionend']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('input' === en)) {
                var pd_0 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 34)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 34).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 34)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 34)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('blur' === en)) {
                var pd_4 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 38).onBlur($event.type, $event.target.value) !== false);
                ad = (pd_4 && ad);
            }
            if (('input' === en)) {
                var pd_5 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 38).onInput($event.type, $event.target.value) !== false);
                ad = (pd_5 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_6 = ((_co.attackConfig.target.host.ip = $event) !== false);
                ad = (pd_6 && ad);
            }
            return ad;
        }, null, null)), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["i" /* DefaultValueAccessor */], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["Renderer2"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["ElementRef"], [2, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["j" /* COMPOSITION_BUFFER_MODE */]]], null, null), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["o" /* RequiredValidator */], [], { required: [0, 'required'] }, null), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](540672, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["w" /* PatternValidator */], [], { pattern: [0, 'pattern'] }, null),
        __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵprd"](1024, null, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["p" /* NG_VALIDATORS */], function (p0_0, p1_0) {
            return [p0_0, p1_0];
        }, [__WEBPACK_IMPORTED_MODULE_3__angular_forms__["o" /* RequiredValidator */], __WEBPACK_IMPORTED_MODULE_3__angular_forms__["w" /* PatternValidator */]]), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_5__src_app_components_input_trim_directive__["a" /* InputTrimDirective */], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["Renderer2"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["ElementRef"], [2, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["j" /* COMPOSITION_BUFFER_MODE */]]], { trim: [0, 'trim'], type: [1, 'type'] }, null), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵprd"](1024, null, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["k" /* NG_VALUE_ACCESSOR */], function (p0_0, p1_0) {
            return [p0_0, p1_0];
        }, [__WEBPACK_IMPORTED_MODULE_3__angular_forms__["i" /* DefaultValueAccessor */], __WEBPACK_IMPORTED_MODULE_5__src_app_components_input_trim_directive__["a" /* InputTrimDirective */]]), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](671744, [['targetIp',
                4]], 0, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["l" /* NgModel */], [[2, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["g" /* ControlContainer */]], [2, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["p" /* NG_VALIDATORS */]], [8, null],
            [2, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["k" /* NG_VALUE_ACCESSOR */]]], { name: [0, 'name'], isDisabled: [1, 'isDisabled'], model: [2,
                'model'] }, { update: 'ngModelChange' }), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵprd"](2048, null, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["m" /* NgControl */], null, [__WEBPACK_IMPORTED_MODULE_3__angular_forms__["l" /* NgModel */]]), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["n" /* NgControlStatus */], [__WEBPACK_IMPORTED_MODULE_3__angular_forms__["m" /* NgControl */]], null, null), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n\n                    '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 15, 'div', [['class', 'col-sm-4 mytooltip']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                      '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'label', [['class', 'control-label form-top-padding cloud-label-style'],
            ['for', 'portNumber']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['Port Number'])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 9, 'input', [['class', 'form-control cloud-label-style'],
            ['id', 'portNumber'], ['name', 'targetPortNumber'], ['pattern', '^([1-9][0-9]{0,3}|[1-5][0-9]{4}|6[0-4][0-9]{3}|65[0-4][0-9]{2}|655[0-2][0-9]|6553[0-5])$'],
            ['placeholder', 'Port'], ['required', ''], ['trim', ''], ['type', 'text']], [[8, 'title', 0], [1, 'required', 0], [1, 'pattern', 0], [2, 'ng-untouched', null],
            [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'ngModelChange'], [null,
                'input'], [null, 'blur'], [null, 'compositionstart'], [null,
                'compositionend']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('input' === en)) {
                var pd_0 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 51)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 51).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 51)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 51)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('blur' === en)) {
                var pd_4 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 55).onBlur($event.type, $event.target.value) !== false);
                ad = (pd_4 && ad);
            }
            if (('input' === en)) {
                var pd_5 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 55).onInput($event.type, $event.target.value) !== false);
                ad = (pd_5 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_6 = ((_co.attackConfig.target.port.number = $event) !== false);
                ad = (pd_6 && ad);
            }
            return ad;
        }, null, null)), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["i" /* DefaultValueAccessor */], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["Renderer2"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["ElementRef"], [2, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["j" /* COMPOSITION_BUFFER_MODE */]]], null, null), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["o" /* RequiredValidator */], [], { required: [0, 'required'] }, null), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](540672, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["w" /* PatternValidator */], [], { pattern: [0, 'pattern'] }, null),
        __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵprd"](1024, null, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["p" /* NG_VALIDATORS */], function (p0_0, p1_0) {
            return [p0_0, p1_0];
        }, [__WEBPACK_IMPORTED_MODULE_3__angular_forms__["o" /* RequiredValidator */], __WEBPACK_IMPORTED_MODULE_3__angular_forms__["w" /* PatternValidator */]]), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_5__src_app_components_input_trim_directive__["a" /* InputTrimDirective */], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["Renderer2"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["ElementRef"], [2, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["j" /* COMPOSITION_BUFFER_MODE */]]], { trim: [0, 'trim'], type: [1, 'type'] }, null), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵprd"](1024, null, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["k" /* NG_VALUE_ACCESSOR */], function (p0_0, p1_0) {
            return [p0_0, p1_0];
        }, [__WEBPACK_IMPORTED_MODULE_3__angular_forms__["i" /* DefaultValueAccessor */], __WEBPACK_IMPORTED_MODULE_5__src_app_components_input_trim_directive__["a" /* InputTrimDirective */]]), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](671744, [['portNumber',
                4]], 0, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["l" /* NgModel */], [[2, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["g" /* ControlContainer */]], [2, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["p" /* NG_VALIDATORS */]], [8, null],
            [2, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["k" /* NG_VALUE_ACCESSOR */]]], { name: [0, 'name'], isDisabled: [1, 'isDisabled'], model: [2,
                'model'] }, { update: 'ngModelChange' }), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵprd"](2048, null, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["m" /* NgControl */], null, [__WEBPACK_IMPORTED_MODULE_3__angular_forms__["l" /* NgModel */]]), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["n" /* NgControlStatus */], [__WEBPACK_IMPORTED_MODULE_3__angular_forms__["m" /* NgControl */]], null, null), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                      '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                    '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 5, 'div', [['class', 'col-sm-1 clearfix  visible-sm-block visible-md-block visible-lg-block '],
            ['style', 'padding: 0px; margin-top: 33px;']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                          '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 2, 'span', [['class', 'glyphicon span-glyph-padding'], ['style', 'text-align: left;']], null, null, null, null, null)),
        __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](278528, null, 0, __WEBPACK_IMPORTED_MODULE_6__angular_common__["NgClass"], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["IterableDiffers"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["KeyValueDiffers"],
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ElementRef"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["Renderer"]], { klass: [0, 'klass'], ngClass: [1, 'ngClass'] }, null),
        __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵpod"]({ 'glyphicon-ok cloud-ok-color': 0, 'glyphicon-alert cloud-alert-color': 1 }),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n\n            '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 20, 'div', [['class', 'row clearfix  visible-xs-block'], ['style',
                'height: 60px;']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 17, 'div', [], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                  '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 14, 'div', [['class', 'clearfix  visible-xs-block']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                      '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 11, 'div', [['class', 'col-sm-12 mytooltip']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                          '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 8, 'input', [['class', 'form-control cloud-label-style'],
            ['id', 'targetIP'], ['name', 'targetIp'], ['placeholder', 'Target IP'], ['required',
                ''], ['title', 'Enter the IPv4 address of the node that you are validating. This address must be owned by the Azure account that is executing the attack.'],
            ['trim', ''], ['type', 'text']], [[1, 'required', 0], [2, 'ng-untouched', null],
            [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'ngModelChange'], [null,
                'input'], [null, 'blur'], [null, 'compositionstart'], [null,
                'compositionend']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('input' === en)) {
                var pd_0 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 80)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 80).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 80)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 80)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('blur' === en)) {
                var pd_4 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 83).onBlur($event.type, $event.target.value) !== false);
                ad = (pd_4 && ad);
            }
            if (('input' === en)) {
                var pd_5 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 83).onInput($event.type, $event.target.value) !== false);
                ad = (pd_5 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_6 = ((_co.attackConfig.target.host.ip = $event) !== false);
                ad = (pd_6 && ad);
            }
            return ad;
        }, null, null)), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["i" /* DefaultValueAccessor */], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["Renderer2"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["ElementRef"], [2, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["j" /* COMPOSITION_BUFFER_MODE */]]], null, null), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["o" /* RequiredValidator */], [], { required: [0, 'required'] }, null), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵprd"](1024, null, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["p" /* NG_VALIDATORS */], function (p0_0) {
            return [p0_0];
        }, [__WEBPACK_IMPORTED_MODULE_3__angular_forms__["o" /* RequiredValidator */]]), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_5__src_app_components_input_trim_directive__["a" /* InputTrimDirective */], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["Renderer2"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["ElementRef"], [2, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["j" /* COMPOSITION_BUFFER_MODE */]]], { trim: [0, 'trim'],
            type: [1, 'type'] }, null), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵprd"](1024, null, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["k" /* NG_VALUE_ACCESSOR */], function (p0_0, p1_0) {
            return [p0_0, p1_0];
        }, [__WEBPACK_IMPORTED_MODULE_3__angular_forms__["i" /* DefaultValueAccessor */], __WEBPACK_IMPORTED_MODULE_5__src_app_components_input_trim_directive__["a" /* InputTrimDirective */]]), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](671744, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["l" /* NgModel */], [[2, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["g" /* ControlContainer */]], [2, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["p" /* NG_VALIDATORS */]], [8, null],
            [2, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["k" /* NG_VALUE_ACCESSOR */]]], { name: [0, 'name'], isDisabled: [1, 'isDisabled'],
            model: [2, 'model'] }, { update: 'ngModelChange' }), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵprd"](2048, null, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["m" /* NgControl */], null, [__WEBPACK_IMPORTED_MODULE_3__angular_forms__["l" /* NgModel */]]), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["n" /* NgControlStatus */], [__WEBPACK_IMPORTED_MODULE_3__angular_forms__["m" /* NgControl */]], null, null), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                      '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                  '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 27, 'div', [['class', 'clearfix  visible-xs-block']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'label', [['class', 'control-label form-top-padding cloud-label-style'],
            ['for', 'targetIP']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['Port Number'])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 21, 'div', [['class', 'row'], ['style', 'height: 60px;']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 18, 'div', [['class', 'col-sm-12 mytooltip']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                        '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 8, 'input', [['class', 'form-control cloud-label-style'],
            ['id', 'portNumber'], ['name', 'targetPortNumber'], ['placeholder', 'Port'], ['required',
                ''], ['title', '>Enter the TCP/UDP port number of the the specific process that you are validating. Examples: port 80 (HTTP), port 123 (NTP), 4333 (mSQL).'],
            ['trim', ''], ['type', 'text']], [[1, 'required', 0], [2, 'ng-untouched', null],
            [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'ngModelChange'], [null,
                'input'], [null, 'blur'], [null, 'compositionstart'], [null,
                'compositionend']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('input' === en)) {
                var pd_0 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 103)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 103).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 103)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 103)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('blur' === en)) {
                var pd_4 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 106).onBlur($event.type, $event.target.value) !== false);
                ad = (pd_4 && ad);
            }
            if (('input' === en)) {
                var pd_5 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 106).onInput($event.type, $event.target.value) !== false);
                ad = (pd_5 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_6 = ((_co.attackConfig.target.port.number = $event) !== false);
                ad = (pd_6 && ad);
            }
            return ad;
        }, null, null)), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["i" /* DefaultValueAccessor */], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["Renderer2"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["ElementRef"], [2, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["j" /* COMPOSITION_BUFFER_MODE */]]], null, null), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["o" /* RequiredValidator */], [], { required: [0, 'required'] }, null), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵprd"](1024, null, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["p" /* NG_VALIDATORS */], function (p0_0) {
            return [p0_0];
        }, [__WEBPACK_IMPORTED_MODULE_3__angular_forms__["o" /* RequiredValidator */]]), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_5__src_app_components_input_trim_directive__["a" /* InputTrimDirective */], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["Renderer2"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["ElementRef"], [2, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["j" /* COMPOSITION_BUFFER_MODE */]]], { trim: [0, 'trim'],
            type: [1, 'type'] }, null), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵprd"](1024, null, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["k" /* NG_VALUE_ACCESSOR */], function (p0_0, p1_0) {
            return [p0_0, p1_0];
        }, [__WEBPACK_IMPORTED_MODULE_3__angular_forms__["i" /* DefaultValueAccessor */], __WEBPACK_IMPORTED_MODULE_5__src_app_components_input_trim_directive__["a" /* InputTrimDirective */]]), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](671744, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["l" /* NgModel */], [[2, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["g" /* ControlContainer */]], [2, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["p" /* NG_VALIDATORS */]], [8, null],
            [2, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["k" /* NG_VALUE_ACCESSOR */]]], { name: [0, 'name'], isDisabled: [1, 'isDisabled'],
            model: [2, 'model'] }, { update: 'ngModelChange' }), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵprd"](2048, null, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["m" /* NgControl */], null, [__WEBPACK_IMPORTED_MODULE_3__angular_forms__["l" /* NgModel */]]), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["n" /* NgControlStatus */], [__WEBPACK_IMPORTED_MODULE_3__angular_forms__["m" /* NgControl */]], null, null), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 5, 'div', [['class', 'clearfix  visible-sm-block visible-md-block visible-lg-block']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 2, 'span', [['class', 'glyphicon'], ['style', 'text-align: left;']], null, null, null, null, null)),
        __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](278528, null, 0, __WEBPACK_IMPORTED_MODULE_6__angular_common__["NgClass"], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["IterableDiffers"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["KeyValueDiffers"],
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ElementRef"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["Renderer"]], { klass: [0, 'klass'], ngClass: [1, 'ngClass'] }, null),
        __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵpod"]({ 'glyphicon-ok cloud-ok-color': 0, 'glyphicon-alert cloud-alert-color': 1 }),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 26, 'div', [], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n              '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'label', [['class', 'control-label form-top-padding cloud-label-style'],
            ['for', 'attackProfile']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['DDoS Profile'])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n              '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 20, 'div', [['class', 'row'], ['style', 'height: 60px;']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                  '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 12, 'div', [['class', 'col-sm-11 mytooltip']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                      '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 9, 'select', [['class', 'form-control cloud-label-style'],
            ['id', 'attackProfile'], ['name', 'ddosProfile'], ['title', 'Select a DDoS profile to use in the validation. Each profile specifies the type of DDoS attack that will be generated.']], [[2, 'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'change'], [null, 'ngModelChange'], [null, 'blur']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('change' === en)) {
                var pd_0 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 132).onChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 132).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('change' === en)) {
                var pd_2 = (_co.onAttackSelect($event) !== false);
                ad = (pd_2 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_3 = ((_co.attackConfig.ddosProfile = $event) !== false);
                ad = (pd_3 && ad);
            }
            return ad;
        }, null, null)), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["u" /* SelectControlValueAccessor */], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["Renderer2"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["ElementRef"]], null, null), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵprd"](1024, null, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["k" /* NG_VALUE_ACCESSOR */], function (p0_0) {
            return [p0_0];
        }, [__WEBPACK_IMPORTED_MODULE_3__angular_forms__["u" /* SelectControlValueAccessor */]]), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](671744, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["l" /* NgModel */], [[2, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["g" /* ControlContainer */]], [8, null], [8, null], [2, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["k" /* NG_VALUE_ACCESSOR */]]], { name: [0, 'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵprd"](2048, null, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["m" /* NgControl */], null, [__WEBPACK_IMPORTED_MODULE_3__angular_forms__["l" /* NgModel */]]), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["n" /* NgControlStatus */], [__WEBPACK_IMPORTED_MODULE_3__angular_forms__["m" /* NgControl */]], null, null),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                          '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵand"](16777216, null, null, 1, null, View_DdosAttackConfigComponent_1)),
        __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](802816, null, 0, __WEBPACK_IMPORTED_MODULE_6__angular_common__["NgForOf"], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["ViewContainerRef"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["TemplateRef"],
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["IterableDiffers"]], { ngForOf: [0, 'ngForOf'] }, null), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                      '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                  '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                  '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 3, 'div', [['class', 'col-sm-1 clearfix  visible-sm-block visible-md-block visible-lg-block'],
            ['style', 'padding: 0px;']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                      '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 0, 'span', [['class', 'glyphicon glyphicon-ok cloud-ok-color span-glyph-padding']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                  '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n              '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n          '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n\n            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 26, 'div', [], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n              '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'label', [['class', 'control-label form-top-padding cloud-label-style'],
            ['for', 'attackSize']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['Test Size'])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n              '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 20, 'div', [['class', 'row'], ['style', 'height: 60px;']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                  '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 12, 'div', [['class', 'col-sm-11 mytooltip']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                      '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 9, 'select', [['class', 'form-control cloud-label-style'],
            ['id', 'attackSize'], ['name', 'volume'], ['title', 'Select one of the Test Size profiles. Each profile specifies the data rate (bits or packets per second) and the number of IPs (simulated bots) from which the test traffic will be generated. Note that the available profiles are specific to the DDoS profile that you have selected.']], [[2, 'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'change'], [null, 'ngModelChange'], [null, 'blur']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('change' === en)) {
                var pd_0 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 161).onChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 161).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('change' === en)) {
                var pd_2 = (_co.onAttackSizeSelect($event) !== false);
                ad = (pd_2 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_3 = ((_co.attackConfig.volume = $event) !== false);
                ad = (pd_3 && ad);
            }
            return ad;
        }, null, null)), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["u" /* SelectControlValueAccessor */], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["Renderer2"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["ElementRef"]], null, null), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵprd"](1024, null, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["k" /* NG_VALUE_ACCESSOR */], function (p0_0) {
            return [p0_0];
        }, [__WEBPACK_IMPORTED_MODULE_3__angular_forms__["u" /* SelectControlValueAccessor */]]), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](671744, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["l" /* NgModel */], [[2, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["g" /* ControlContainer */]], [8, null], [8, null], [2, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["k" /* NG_VALUE_ACCESSOR */]]], { name: [0, 'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵprd"](2048, null, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["m" /* NgControl */], null, [__WEBPACK_IMPORTED_MODULE_3__angular_forms__["l" /* NgModel */]]), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["n" /* NgControlStatus */], [__WEBPACK_IMPORTED_MODULE_3__angular_forms__["m" /* NgControl */]], null, null),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                          '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵand"](16777216, null, null, 1, null, View_DdosAttackConfigComponent_2)),
        __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](802816, null, 0, __WEBPACK_IMPORTED_MODULE_6__angular_common__["NgForOf"], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["ViewContainerRef"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["TemplateRef"],
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["IterableDiffers"]], { ngForOf: [0, 'ngForOf'] }, null), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                      '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                    '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                  '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 3, 'div', [['class', 'col-sm-1 clearfix  visible-sm-block visible-md-block visible-lg-block'],
            ['style', 'padding: 0px;']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                      '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 0, 'span', [['class', 'glyphicon glyphicon-ok cloud-ok-color span-glyph-padding']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                  '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n              '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n\n            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 54, 'div', [], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'label', [['class', 'control-label form-top-padding cloud-label-style'],
            ['for', 'attackDuration']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['Test Duration'])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n              '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 48, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                  '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 40, 'div', [['class', 'col-sm-11 mytooltip']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                      '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 37, 'select', [['class', 'form-control cloud-label-style'],
            ['id', 'attackDuration'], ['name', 'duration'], ['title', 'Select the desired duration of the test. The durations range from 10 minutes to 30 minutes.']], [[2, 'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'ngModelChange'], [null, 'change'], [null, 'blur']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('change' === en)) {
                var pd_0 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 189).onChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 189).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_2 = ((_co.attackConfig.duration = $event) !== false);
                ad = (pd_2 && ad);
            }
            if (('change' === en)) {
                var pd_3 = (_co.onDurationChange() !== false);
                ad = (pd_3 && ad);
            }
            return ad;
        }, null, null)), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["u" /* SelectControlValueAccessor */], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["Renderer2"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["ElementRef"]], null, null), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵprd"](1024, null, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["k" /* NG_VALUE_ACCESSOR */], function (p0_0) {
            return [p0_0];
        }, [__WEBPACK_IMPORTED_MODULE_3__angular_forms__["u" /* SelectControlValueAccessor */]]), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](671744, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["l" /* NgModel */], [[2, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["g" /* ControlContainer */]], [8, null], [8, null], [2, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["k" /* NG_VALUE_ACCESSOR */]]], { name: [0, 'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵprd"](2048, null, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["m" /* NgControl */], null, [__WEBPACK_IMPORTED_MODULE_3__angular_forms__["l" /* NgModel */]]), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["n" /* NgControlStatus */], [__WEBPACK_IMPORTED_MODULE_3__angular_forms__["m" /* NgControl */]], null, null),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                          '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵand"](16777216, null, null, 1, null, View_DdosAttackConfigComponent_3)),
        __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_6__angular_common__["NgIf"], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["ViewContainerRef"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                          '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵand"](16777216, null, null, 1, null, View_DdosAttackConfigComponent_4)),
        __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_6__angular_common__["NgIf"], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["ViewContainerRef"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                          '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 3, 'option', [['value', '600']], null, null, null, null, null)), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](147456, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["t" /* NgSelectOption */], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["ElementRef"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["Renderer2"], [2, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["u" /* SelectControlValueAccessor */]]], { value: [0, 'value'] }, null), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](147456, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["v" /* ɵq */], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["ElementRef"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["Renderer2"], [8, null]], { value: [0, 'value'] }, null),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['10 Minutes'])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                          '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 3, 'option', [['value', '900']], null, null, null, null, null)), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](147456, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["t" /* NgSelectOption */], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["ElementRef"],
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["Renderer2"], [2, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["u" /* SelectControlValueAccessor */]]], { value: [0, 'value'] }, null),
        __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](147456, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["v" /* ɵq */], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["ElementRef"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["Renderer2"], [8, null]], { value: [0, 'value'] }, null), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['15 Minutes'])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                          '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 3, 'option', [['value', '1200']], null, null, null, null, null)), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](147456, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["t" /* NgSelectOption */], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["ElementRef"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["Renderer2"], [2, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["u" /* SelectControlValueAccessor */]]], { value: [0, 'value'] }, null), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](147456, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["v" /* ɵq */], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["ElementRef"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["Renderer2"], [8, null]], { value: [0, 'value'] }, null),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['20 Minutes'])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                          '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 3, 'option', [['value', '1500']], null, null, null, null, null)), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](147456, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["t" /* NgSelectOption */], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["ElementRef"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["Renderer2"], [2, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["u" /* SelectControlValueAccessor */]]], { value: [0,
                'value'] }, null), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](147456, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["v" /* ɵq */], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["ElementRef"],
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["Renderer2"], [8, null]], { value: [0, 'value'] }, null), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['25 Minutes'])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                          '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 3, 'option', [['value', '1800']], null, null, null, null, null)),
        __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](147456, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["t" /* NgSelectOption */], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["ElementRef"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["Renderer2"],
            [2, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["u" /* SelectControlValueAccessor */]]], { value: [0, 'value'] }, null), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](147456, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["v" /* ɵq */], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["ElementRef"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["Renderer2"], [8, null]], { value: [0,
                'value'] }, null), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['30 Minutes'])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                      '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                  '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                  '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 3, 'div', [['class', 'col-sm-1 clearfix  visible-sm-block visible-md-block visible-lg-block'],
            ['style', 'padding: 0px;']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                      '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 0, 'span', [['class', 'glyphicon glyphicon-ok cloud-ok-color span-glyph-padding']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                  '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n              '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 0, 'div', [['class', 'empty-space col-sm-1'], ['style', 'height: 10px;']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵand"](16777216, null, null, 1, null, View_DdosAttackConfigComponent_5)), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_6__angular_common__["NgIf"], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["ViewContainerRef"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵand"](16777216, null, null, 1, null, View_DdosAttackConfigComponent_6)),
        __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_6__angular_common__["NgIf"], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["ViewContainerRef"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵand"](16777216, null, null, 1, null, View_DdosAttackConfigComponent_7)),
        __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_6__angular_common__["NgIf"], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["ViewContainerRef"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵand"](16777216, null, null, 1, null, View_DdosAttackConfigComponent_8)),
        __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_6__angular_common__["NgIf"], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["ViewContainerRef"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵand"](16777216, null, null, 1, null, View_DdosAttackConfigComponent_9)),
        __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_6__angular_common__["NgIf"], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["ViewContainerRef"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n        '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n    '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 6, 'div', [], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 3, 'button', [['class', 'btn btn-success btn-block cloud-btn-style']], [[8, 'disabled', 0]], [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.onStartStopAttack() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](278528, null, 0, __WEBPACK_IMPORTED_MODULE_6__angular_common__["NgClass"], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["IterableDiffers"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["KeyValueDiffers"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["ElementRef"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["Renderer"]], { klass: [0,
                'klass'], ngClass: [1, 'ngClass'] }, null), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵpod"]({ 'cloud-btn-style': 0,
            'cloud-btn-style-alert': 1 }), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['', ' TEST'])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n    '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵand"](16777216, null, null, 1, null, View_DdosAttackConfigComponent_10)),
        __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_6__angular_common__["NgIf"], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["ViewContainerRef"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n'])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_17 = '';
        _ck(_v, 35, 0, currVal_17);
        var currVal_18 = '^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$';
        _ck(_v, 36, 0, currVal_18);
        var currVal_19 = '';
        var currVal_20 = 'text';
        _ck(_v, 38, 0, currVal_19, currVal_20);
        var currVal_21 = 'targetIp';
        var currVal_22 = _co.disableInputs;
        var currVal_23 = _co.attackConfig.target.host.ip;
        _ck(_v, 40, 0, currVal_21, currVal_22, currVal_23);
        var currVal_34 = '';
        _ck(_v, 52, 0, currVal_34);
        var currVal_35 = '^([1-9][0-9]{0,3}|[1-5][0-9]{4}|6[0-4][0-9]{3}|65[0-4][0-9]{2}|655[0-2][0-9]|6553[0-5])$';
        _ck(_v, 53, 0, currVal_35);
        var currVal_36 = '';
        var currVal_37 = 'text';
        _ck(_v, 55, 0, currVal_36, currVal_37);
        var currVal_38 = 'targetPortNumber';
        var currVal_39 = _co.disableInputs;
        var currVal_40 = _co.attackConfig.target.port.number;
        _ck(_v, 57, 0, currVal_38, currVal_39, currVal_40);
        var currVal_41 = 'glyphicon span-glyph-padding';
        var currVal_42 = _ck(_v, 66, 0, ((__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 40).valid && __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 57).valid) || __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 40).disabled), ((!__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 40).valid || !__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 57).valid) && !__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 40).disabled));
        _ck(_v, 65, 0, currVal_41, currVal_42);
        var currVal_51 = '';
        _ck(_v, 81, 0, currVal_51);
        var currVal_52 = '';
        var currVal_53 = 'text';
        _ck(_v, 83, 0, currVal_52, currVal_53);
        var currVal_54 = 'targetIp';
        var currVal_55 = _co.disableInputs;
        var currVal_56 = _co.attackConfig.target.host.ip;
        _ck(_v, 85, 0, currVal_54, currVal_55, currVal_56);
        var currVal_65 = '';
        _ck(_v, 104, 0, currVal_65);
        var currVal_66 = '';
        var currVal_67 = 'text';
        _ck(_v, 106, 0, currVal_66, currVal_67);
        var currVal_68 = 'targetPortNumber';
        var currVal_69 = _co.disableInputs;
        var currVal_70 = _co.attackConfig.target.port.number;
        _ck(_v, 108, 0, currVal_68, currVal_69, currVal_70);
        var currVal_71 = 'glyphicon';
        var currVal_72 = _ck(_v, 116, 0, __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 40).valid, !__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 40).valid);
        _ck(_v, 115, 0, currVal_71, currVal_72);
        var currVal_80 = 'ddosProfile';
        var currVal_81 = _co.disableInputs;
        var currVal_82 = _co.attackConfig.ddosProfile;
        _ck(_v, 134, 0, currVal_80, currVal_81, currVal_82);
        var currVal_83 = _co.availableAttackProfiles;
        _ck(_v, 139, 0, currVal_83);
        var currVal_91 = 'volume';
        var currVal_92 = _co.disableInputs;
        var currVal_93 = _co.attackConfig.volume;
        _ck(_v, 163, 0, currVal_91, currVal_92, currVal_93);
        var currVal_94 = _co.selectedAttackSizes;
        _ck(_v, 168, 0, currVal_94);
        var currVal_102 = 'duration';
        var currVal_103 = _co.disableInputs;
        var currVal_104 = _co.attackConfig.duration;
        _ck(_v, 191, 0, currVal_102, currVal_103, currVal_104);
        var currVal_105 = _co.showDevDurations;
        _ck(_v, 196, 0, currVal_105);
        var currVal_106 = _co.showDevDurations;
        _ck(_v, 199, 0, currVal_106);
        var currVal_107 = '600';
        _ck(_v, 202, 0, currVal_107);
        var currVal_108 = '600';
        _ck(_v, 203, 0, currVal_108);
        var currVal_109 = '900';
        _ck(_v, 207, 0, currVal_109);
        var currVal_110 = '900';
        _ck(_v, 208, 0, currVal_110);
        var currVal_111 = '1200';
        _ck(_v, 212, 0, currVal_111);
        var currVal_112 = '1200';
        _ck(_v, 213, 0, currVal_112);
        var currVal_113 = '1500';
        _ck(_v, 217, 0, currVal_113);
        var currVal_114 = '1500';
        _ck(_v, 218, 0, currVal_114);
        var currVal_115 = '1800';
        _ck(_v, 222, 0, currVal_115);
        var currVal_116 = '1800';
        _ck(_v, 223, 0, currVal_116);
        var currVal_117 = !_co.showEstimatedOutboundData;
        _ck(_v, 239, 0, currVal_117);
        var currVal_118 = !_co.showEstimatedTime;
        _ck(_v, 242, 0, currVal_118);
        var currVal_119 = _co.showEstimatedOutboundData;
        _ck(_v, 245, 0, currVal_119);
        var currVal_120 = _co.showEstimatedTime;
        _ck(_v, 248, 0, currVal_120);
        var currVal_121 = _co.showEstimatedTime;
        _ck(_v, 251, 0, currVal_121);
        var currVal_123 = 'btn btn-success btn-block cloud-btn-style';
        var currVal_124 = _ck(_v, 259, 0, _co.canStartAttack, !_co.canStartAttack);
        _ck(_v, 258, 0, currVal_123, currVal_124);
        var currVal_126 = _co.error;
        _ck(_v, 264, 0, currVal_126);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 12).ngClassUntouched;
        var currVal_1 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 12).ngClassTouched;
        var currVal_2 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 12).ngClassPristine;
        var currVal_3 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 12).ngClassDirty;
        var currVal_4 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 12).ngClassValid;
        var currVal_5 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 12).ngClassInvalid;
        var currVal_6 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 12).ngClassPending;
        _ck(_v, 8, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6);
        var currVal_7 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵinlineInterpolate"](1, '', ((__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 40).errors && __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 40).errors.pattern) ? 'Must be valid IP address' : 'Enter the IPv4 address of the node that you are validating. This address must be owned by the Azure account that is executing the attack.'), '');
        var currVal_8 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 35).required ? '' : null);
        var currVal_9 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 36).pattern ? __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 36).pattern : null);
        var currVal_10 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 42).ngClassUntouched;
        var currVal_11 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 42).ngClassTouched;
        var currVal_12 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 42).ngClassPristine;
        var currVal_13 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 42).ngClassDirty;
        var currVal_14 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 42).ngClassValid;
        var currVal_15 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 42).ngClassInvalid;
        var currVal_16 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 42).ngClassPending;
        _ck(_v, 33, 0, currVal_7, currVal_8, currVal_9, currVal_10, currVal_11, currVal_12, currVal_13, currVal_14, currVal_15, currVal_16);
        var currVal_24 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵinlineInterpolate"](1, '', ((__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 57).errors && __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 57).errors.pattern) ? 'Must be valid port number' : 'Enter the TCP/UDP port number of the the specific process that you are validating. Examples: port 80 (HTTP), port 123 (NTP), 4333 (mSQL).'), '');
        var currVal_25 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 52).required ? '' : null);
        var currVal_26 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 53).pattern ? __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 53).pattern : null);
        var currVal_27 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 59).ngClassUntouched;
        var currVal_28 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 59).ngClassTouched;
        var currVal_29 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 59).ngClassPristine;
        var currVal_30 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 59).ngClassDirty;
        var currVal_31 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 59).ngClassValid;
        var currVal_32 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 59).ngClassInvalid;
        var currVal_33 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 59).ngClassPending;
        _ck(_v, 50, 0, currVal_24, currVal_25, currVal_26, currVal_27, currVal_28, currVal_29, currVal_30, currVal_31, currVal_32, currVal_33);
        var currVal_43 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 81).required ? '' : null);
        var currVal_44 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 87).ngClassUntouched;
        var currVal_45 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 87).ngClassTouched;
        var currVal_46 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 87).ngClassPristine;
        var currVal_47 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 87).ngClassDirty;
        var currVal_48 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 87).ngClassValid;
        var currVal_49 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 87).ngClassInvalid;
        var currVal_50 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 87).ngClassPending;
        _ck(_v, 79, 0, currVal_43, currVal_44, currVal_45, currVal_46, currVal_47, currVal_48, currVal_49, currVal_50);
        var currVal_57 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 104).required ? '' : null);
        var currVal_58 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 110).ngClassUntouched;
        var currVal_59 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 110).ngClassTouched;
        var currVal_60 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 110).ngClassPristine;
        var currVal_61 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 110).ngClassDirty;
        var currVal_62 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 110).ngClassValid;
        var currVal_63 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 110).ngClassInvalid;
        var currVal_64 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 110).ngClassPending;
        _ck(_v, 102, 0, currVal_57, currVal_58, currVal_59, currVal_60, currVal_61, currVal_62, currVal_63, currVal_64);
        var currVal_73 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 136).ngClassUntouched;
        var currVal_74 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 136).ngClassTouched;
        var currVal_75 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 136).ngClassPristine;
        var currVal_76 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 136).ngClassDirty;
        var currVal_77 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 136).ngClassValid;
        var currVal_78 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 136).ngClassInvalid;
        var currVal_79 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 136).ngClassPending;
        _ck(_v, 131, 0, currVal_73, currVal_74, currVal_75, currVal_76, currVal_77, currVal_78, currVal_79);
        var currVal_84 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 165).ngClassUntouched;
        var currVal_85 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 165).ngClassTouched;
        var currVal_86 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 165).ngClassPristine;
        var currVal_87 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 165).ngClassDirty;
        var currVal_88 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 165).ngClassValid;
        var currVal_89 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 165).ngClassInvalid;
        var currVal_90 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 165).ngClassPending;
        _ck(_v, 160, 0, currVal_84, currVal_85, currVal_86, currVal_87, currVal_88, currVal_89, currVal_90);
        var currVal_95 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 193).ngClassUntouched;
        var currVal_96 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 193).ngClassTouched;
        var currVal_97 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 193).ngClassPristine;
        var currVal_98 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 193).ngClassDirty;
        var currVal_99 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 193).ngClassValid;
        var currVal_100 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 193).ngClassInvalid;
        var currVal_101 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 193).ngClassPending;
        _ck(_v, 188, 0, currVal_95, currVal_96, currVal_97, currVal_98, currVal_99, currVal_100, currVal_101);
        var currVal_122 = ((_co.startStopOperationInProgress || (_co.canStartAttack && !__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 10).valid)) || (!_co.canStartAttack && !_co.canStopAttack));
        _ck(_v, 257, 0, currVal_122);
        var currVal_125 = (_co.canStartAttack ? 'START' : 'STOP');
        _ck(_v, 260, 0, currVal_125);
    });
}
function View_DdosAttackConfigComponent_Host_0(_l) {
    return __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'ddos-attack-config', [], null, null, null, View_DdosAttackConfigComponent_0, RenderType_DdosAttackConfigComponent)), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](245760, null, 0, __WEBPACK_IMPORTED_MODULE_4__src_app_main_ddos_attack_config_ddos_attack_config_component__["a" /* DdosAttackConfigComponent */], [__WEBPACK_IMPORTED_MODULE_7__src_app_attack_attack_service__["a" /* AttackService */], __WEBPACK_IMPORTED_MODULE_8__src_app_aws_environment__["a" /* AwsEnvironment */], __WEBPACK_IMPORTED_MODULE_9__src_app_main_config_config_service__["a" /* ConfigService */], __WEBPACK_IMPORTED_MODULE_10__src_app_main_target_validation_target_validation_service__["a" /* TargetValidationService */],
            __WEBPACK_IMPORTED_MODULE_11__src_app_systeminformation_systeminformation_service__["a" /* SystemInformationService */], __WEBPACK_IMPORTED_MODULE_12__src_app_trial_trial_service__["a" /* TrialService */]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var DdosAttackConfigComponentNgFactory = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵccf"]('ddos-attack-config', __WEBPACK_IMPORTED_MODULE_4__src_app_main_ddos_attack_config_ddos_attack_config_component__["a" /* DdosAttackConfigComponent */], View_DdosAttackConfigComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=ddos-attack-config.component.ngfactory.js.map

/***/ }),
/* 546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return styles; });
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */
var styles = ['input.ng-invalid.ng-touched[_ngcontent-%COMP%] {\n  border: 1px solid #d20f0f; }\n\n.form-top-padding[_ngcontent-%COMP%] {\n  padding-top: 15px; }\n\n.form-glyph-padding[_ngcontent-%COMP%] {\n  padding-top: 35px;\n  padding-left: 0px !important; }\n\n.span-glyph-padding[_ngcontent-%COMP%] {\n  margin-left: 13%;\n  margin-top: 7px; }\n\n.attack-error-div[_ngcontent-%COMP%] {\n  width: 480px;\n  padding-top: 20px;\n  display: flex;\n  flex-direction: row; }\n\n.attack-error-icon[_ngcontent-%COMP%] {\n  height: 20px;\n  width: 20px;\n  min-width: 20px;\n  background-image: url(/assets/error.bdaf0008c084b16da681ad026a92d8d3.svg); }\n\n.attack-error-label[_ngcontent-%COMP%] {\n  word-wrap: break-word;\n  color: #666;\n  font-size: 13px;\n  margin-left: 10px;\n  line-height: 20px; }\n\n.estimatedCycleTime[_ngcontent-%COMP%] {\n  font-size: 12px;\n  font-style: italic; }\n\n\n.mytooltip[_ngcontent-%COMP%] {\n  position: relative;\n  display: block; }\n  .mytooltip__tooltiptext[_ngcontent-%COMP%] {\n    visibility: hidden;\n    font-size: 10px;\n    width: 400px;\n    background-color: #f3f3f3;\n    color: #000;\n    text-align: left;\n    margin: 3px;\n    padding: 5px 3px;\n    border-radius: 2px;\n    border: black solid 1px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.25);\n    \n    position: absolute;\n    z-index: 1; }\n  .mytooltip[_ngcontent-%COMP%]:hover   .mytooltip__tooltiptext[_ngcontent-%COMP%] {\n    visibility: visible; }'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3NyYy91aS9zcmMvYXBwL21haW4vZGRvcy1hdHRhY2stY29uZmlnL2Rkb3MtYXR0YWNrLWNvbmZpZy5jb21wb25lbnQuc2Nzcy5zaGltLm5nc3R5bGUudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9zcmMvdWkvc3JjL2FwcC9tYWluL2Rkb3MtYXR0YWNrLWNvbmZpZy9kZG9zLWF0dGFjay1jb25maWcuY29tcG9uZW50LnNjc3MiXSwic291cmNlc0NvbnRlbnQiOlsiICJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7OyJ9
//# sourceMappingURL=ddos-attack-config.component.scss.shim.ngstyle.js.map

/***/ }),
/* 547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RenderType_DdosAttackResultsComponent; });
/* harmony export (immutable) */ __webpack_exports__["a"] = View_DdosAttackResultsComponent_0;
/* unused harmony export View_DdosAttackResultsComponent_Host_0 */
/* unused harmony export DdosAttackResultsComponentNgFactory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_bootstrap_dist_css_bootstrap_css_shim_ngstyle__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ddos_attack_results_component_scss_shim_ngstyle__ = __webpack_require__(548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_core__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__angular_common__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_progressbar_progressbar_component_ngfactory__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_app_components_progressbar_progressbar_component__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_app_pipes_seconds_to_duration_pipe__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_app_pipes_bytes_to_megabytes_pipe__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_app_main_ddos_attack_results_ddos_attack_results_component__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_gauge_gauge_component_ngfactory__ = __webpack_require__(531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_app_components_gauge_gauge_component__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_app_attack_attack_service__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_app_main_config_config_service__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_app_main_target_validation_target_validation_service__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_app_login_user_login_service__ = __webpack_require__(67);
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */















var styles_DdosAttackResultsComponent = [__WEBPACK_IMPORTED_MODULE_0__node_modules_bootstrap_dist_css_bootstrap_css_shim_ngstyle__["a" /* styles */], __WEBPACK_IMPORTED_MODULE_1__ddos_attack_results_component_scss_shim_ngstyle__["a" /* styles */]];
var RenderType_DdosAttackResultsComponent = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵcrt"]({ encapsulation: 0,
    styles: styles_DdosAttackResultsComponent, data: {} });
function View_DdosAttackResultsComponent_2(_l) {
    return __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'span', [], null, null, null, null, null)), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['LAST TEST RESULTS']))], null, null);
}
function View_DdosAttackResultsComponent_3(_l) {
    return __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'span', [], null, null, null, null, null)), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['TEST COMPLETED!']))], null, null);
}
function View_DdosAttackResultsComponent_1(_l) {
    return __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 146, 'div', [['class',
                'panel cloud-chart-style cloud-panel-margins-padding col-sm-5 chart-panel-height ']], null, null, null, null, null)), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 143, 'div', [['class', 'panel-body']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n        '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 7, 'div', [['class', 'col-sm-12 test-complete-label']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵand"](16777216, null, null, 1, null, View_DdosAttackResultsComponent_2)),
        __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_common__["NgIf"], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["ViewContainerRef"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵand"](16777216, null, null, 1, null, View_DdosAttackResultsComponent_3)),
        __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_common__["NgIf"], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["ViewContainerRef"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n        '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'div', [['class', 'col-sm-8 col-sm-offset-2 test-complete-info']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n             CHECK CONFIGURATION AND RUN ANOTHER TEST\n        '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 34, 'div', [['class', 'row clearfix  visible-sm-block visible-md-block visible-lg-block'],
            ['style', 'margin-right:0px !important;margin-left:0px !important;']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n          '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 4, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n              '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'div', [['class', 'col-sm-8 col-sm-offset-2 last-run-label horizontalLine']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                LAST RUN RESULTS\n              '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n          '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n          '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 13, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n              '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 2, 'div', [['class', 'col-sm-4 cloud-blue-font-large verticalLine'],
                ['id', 'ddos-results-ffs-lg']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                  ',
            '\n              '])), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵppd"](1), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n              '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 2, 'div', [['class', 'col-sm-4 cloud-blue-font-large verticalLine'],
            ['id', 'ddos-results-frames-lg']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                  ',
            '\n              '])), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵppd"](1), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n              '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 2, 'div', [['class', 'col-sm-4 cloud-blue-font-large'],
            ['id', 'ddos-results-throughput-lg']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                  ',
            '\n              '])), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵppd"](1), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n          '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n          '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 10, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n              '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'div', [['class', 'col-sm-4 cloud-grey-font-med verticalLine']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                  FRAMES PER SECOND\n              '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n              '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'div', [['class', 'col-sm-4 cloud-grey-font-med verticalLine']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                  FRAMES SENT\n              '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n              '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'div', [['class', 'col-sm-4 cloud-grey-font-med']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                  THROUGHPUT(Mbps)\n              '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n          '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n      '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n\n\n\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 30, 'div', [['class', 'clearfix  visible-sm-block visible-md-block visible-lg-block'],
            ['style', 'margin-top:40px;']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 14, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n              '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'div', [['class', 'col-sm-4 cloud-drk-grey-font'], ['id', 'text-start-time-complete']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                  ', '\n              '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 2, 'div', [['class', 'col-sm-4 cloud-drk-grey-font'],
            ['id', 'text-run-time-complete']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                    ',
            '\n                '])), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵppd"](1), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n\n                '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 2, 'div', [['class', 'col-sm-4 cloud-drk-grey-font'],
            ['id', 'text-outbound-data-complete']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                    ',
            '\n                '])), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵppd"](1), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n\n            '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 11, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'div', [['class', 'col-sm-4 cloud-grey-font-med']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                    START TIME\n                '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'div', [['class', 'col-sm-4 cloud-grey-font-med']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                    RUN TIME\n                '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'div', [['class', 'col-sm-4 cloud-grey-font-med']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                    OUTBOUND DATA (MB)\n                '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n\n        '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 31, 'div', [['class', 'row clearfix  visible-xs-block']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 8, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 2, 'div', [['class', 'col-sm-6 cloud-blue-font-large'],
                ['id', 'ddos-results-ffs-sm']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                    ',
            '\n                '])), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵppd"](1), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'div', [['class', 'col-sm-6 cloud-grey-font-med']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                    FRAMES PER SECOND\n                '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 8, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 2, 'div', [['class', 'col-sm-6 cloud-blue-font-large'],
                ['id', 'ddos-results-frames-sm']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                    ',
            '\n                '])), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵppd"](1), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'div', [['class', 'col-sm-6 cloud-grey-font-med']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                    FRAMES SENT\n                '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 8, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 2, 'div', [['class', 'col-sm-6 cloud-blue-font-large'],
                ['id', 'ddos-results-throughput-sm']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                    ',
            '\n                '])), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵppd"](1), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'div', [['class', 'col-sm-6 cloud-grey-font-med']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                    THROUGHPUT(Mbps)\n                '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n\n        '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 26, 'div', [['class', 'clearfix  visible-xs-block'],
                ['style', 'margin-top:25px;']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 23, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n              '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'div', [['class', 'col-sm-4 cloud-drk-grey-font'], ['id', 'text-start-time-complete-sm']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                  ', '\n              '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'div', [['class', 'col-sm-4 cloud-grey-font-med']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                    START TIME\n                '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 2, 'div', [['class', 'col-sm-4 cloud-drk-grey-font'],
            ['id', 'text-run-time-complete-sm']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                    ',
            '\n                '])), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵppd"](2), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'div', [['class', 'col-sm-4 cloud-grey-font-med']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                    RUN TIME\n                '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 2, 'div', [['class', 'col-sm-4 cloud-drk-grey-font'], ['id', 'text-outbound-data-complete-sm']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                    ', '\n                '])),
        __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵppd"](1), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'div', [['class', 'col-sm-4 cloud-grey-font-med']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                    OUTBOUND DATA (MB)\n                '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.userLoggedIn;
        _ck(_v, 7, 0, currVal_0);
        var currVal_1 = !_co.userLoggedIn;
        _ck(_v, 10, 0, currVal_1);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_2 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵunv"](_v, 27, 0, _ck(_v, 28, 0, __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v.parent, 0), _co.framesPerSecond));
        _ck(_v, 27, 0, currVal_2);
        var currVal_3 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵunv"](_v, 31, 0, _ck(_v, 32, 0, __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v.parent, 0), _co.framesSent));
        _ck(_v, 31, 0, currVal_3);
        var currVal_4 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵunv"](_v, 35, 0, _ck(_v, 36, 0, __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v.parent, 0), _co.throughput));
        _ck(_v, 35, 0, currVal_4);
        var currVal_5 = (_co.formattedDateTime ? _co.formattedDateTime : 'N/A');
        _ck(_v, 57, 0, currVal_5);
        var currVal_6 = (_co.runningTime ? __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵunv"](_v, 62, 0, _ck(_v, 63, 0, __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v.parent, 1), _co.runningTime)) : 'N/A');
        _ck(_v, 62, 0, currVal_6);
        var currVal_7 = (_co.outboundData ? __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵunv"](_v, 66, 0, _ck(_v, 67, 0, __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v.parent, 2), _co.outboundData)) : 'N/A');
        _ck(_v, 66, 0, currVal_7);
        var currVal_8 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵunv"](_v, 90, 0, _ck(_v, 91, 0, __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v.parent, 0), _co.framesPerSecond));
        _ck(_v, 90, 0, currVal_8);
        var currVal_9 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵunv"](_v, 100, 0, _ck(_v, 101, 0, __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v.parent, 0), _co.framesSent));
        _ck(_v, 100, 0, currVal_9);
        var currVal_10 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵunv"](_v, 110, 0, _ck(_v, 111, 0, __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v.parent, 0), _co.throughput));
        _ck(_v, 110, 0, currVal_10);
        var currVal_11 = (_co.formattedDateTime ? _co.formattedDateTime : 'N/A');
        _ck(_v, 123, 0, currVal_11);
        var currVal_12 = (_co.runningTime ? __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵunv"](_v, 131, 0, _ck(_v, 132, 0, __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v.parent, 3), _co.runningTime, 'HH:mm:ss')) : 'N/A');
        _ck(_v, 131, 0, currVal_12);
        var currVal_13 = (_co.outboundData ? __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵunv"](_v, 138, 0, _ck(_v, 139, 0, __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v.parent, 2), _co.outboundData)) : 'N/A');
        _ck(_v, 138, 0, currVal_13);
    });
}
function View_DdosAttackResultsComponent_5(_l) {
    return __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'div', [], null, null, null, null, null)), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 0, 'span', [['class', 'glyphicon glyphicon-ok cloud-ok-color show-ready-big-ok-glyph']], null, null, null, null, null))], null, null);
}
function View_DdosAttackResultsComponent_6(_l) {
    return __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 0, 'div', [['class',
                'loader']], null, null, null, null, null))], null, null);
}
function View_DdosAttackResultsComponent_7(_l) {
    return __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 29, 'div', [['class',
                'col-sm-12'], ['style', 'padding:0px;']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n\n      '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 12, 'div', [['class', 'col-sm-5 checkbox-defaults']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 0, 'input', [['class', 'loading-checkbox-input'], ['id', 'ddos-check-run-immediately'],
            ['name', 'chkRunImmediately'], ['type', 'checkbox']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 7, 'label', [['class', 'loading-checkbox-label'], ['for', 'ddos-check-run-immediately']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['Pause After Reservation\n          '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 4, ':svg:svg', [['class', 'loading-checkbox-svg'],
                ['viewBox', '0 0 100 100']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, ':svg:path', [['d', 'M 39.363,79 16,55.49 27.347,44.071 39.694,56.49 72.983,23 84,34.085 Z'],
            ['fill', 'none'], ['id', 'Path-1'], ['stroke', '#9abc7d'], ['stroke-dasharray',
                '270'], ['stroke-dashoffset', '-270'], ['stroke-width', '4']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n          '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n          '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n      '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n\n      '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 12, 'div', [['class', 'col-sm-5 col-sm-offset-2 checkbox-defaults']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 0, 'input', [['class', 'loading-checkbox-input'], ['id', 'ddos-check-unreserve'],
            ['name', 'chkUnreserve'], ['type', 'checkbox']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 7, 'label', [['class', 'loading-checkbox-label'], ['for', 'ddos-check-unreserve']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['Unreserve At Completion\n          '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 4, ':svg:svg', [['class', 'loading-checkbox-svg'], ['viewBox',
                '0 0 100 100']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, ':svg:path', [['d', 'M 39.363,79 16,55.49 27.347,44.071 39.694,56.49 72.983,23 84,34.085 Z'],
                ['fill', 'none'], ['id', 'Path-1'], ['stroke', '#9abc7d'], ['stroke-dasharray',
                    '270'], ['stroke-dashoffset', '-270'], ['stroke-width', '4']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n          '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n      '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n    ']))], null, null);
}
function View_DdosAttackResultsComponent_8(_l) {
    return __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 4, 'div', [['class',
                'col-sm-12'], ['style', 'margin-top:20px; padding:0px;']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n        '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'ixprogressbar', [], null, null, null, __WEBPACK_IMPORTED_MODULE_4__components_progressbar_progressbar_component_ngfactory__["a" /* View_ProgressbarComponent_0 */], __WEBPACK_IMPORTED_MODULE_4__components_progressbar_progressbar_component_ngfactory__["b" /* RenderType_ProgressbarComponent */])), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](114688, [[2, 4], ['loadProgressBar',
                4]], 0, __WEBPACK_IMPORTED_MODULE_5__src_app_components_progressbar_progressbar_component__["a" /* ProgressbarComponent */], [], null, null),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n    ']))], function (_ck, _v) {
        _ck(_v, 3, 0);
    }, null);
}
function View_DdosAttackResultsComponent_4(_l) {
    return __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 27, 'div', [['class',
                'panel cloud-chart-style cloud-panel-margins-padding col-sm-5 chart-panel-height ']], null, null, null, null, null)), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 18, 'div', [['class', 'panel-body']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n      '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 0, 'div', [['class', 'clearfix  visible-md-block visible-sm-block col-sm-12'],
                ['style', 'height: 52px;']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n      '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 0, 'div', [['class', 'clearfix  visible-lg-block col-sm-12'],
            ['style', 'height: 68px;']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n      '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 11, 'div', [['class', 'col-sm-12'], ['style', 'text-align:center; ']], null, null, null, null, null)), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵand"](16777216, null, null, 1, null, View_DdosAttackResultsComponent_5)), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_common__["NgIf"], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["ViewContainerRef"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵand"](16777216, null, null, 1, null, View_DdosAttackResultsComponent_6)),
        __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_common__["NgIf"], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["ViewContainerRef"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n        '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 2, 'div', [['style', 'margin-top:50px;margin-bottom:73px;']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n          ', '\n        '])), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵppd"](1), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n      '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n    '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵand"](16777216, null, null, 1, null, View_DdosAttackResultsComponent_7)), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_common__["NgIf"], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["ViewContainerRef"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵand"](16777216, null, null, 1, null, View_DdosAttackResultsComponent_8)),
        __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_common__["NgIf"], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["ViewContainerRef"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n\n']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.readyToRun;
        _ck(_v, 11, 0, currVal_0);
        var currVal_1 = !_co.readyToRun;
        _ck(_v, 14, 0, currVal_1);
        var currVal_3 = _co.showCheckBoxes;
        _ck(_v, 23, 0, currVal_3);
        var currVal_4 = _co.showCheckBoxes;
        _ck(_v, 26, 0, currVal_4);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_2 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵunv"](_v, 17, 0, _ck(_v, 18, 0, __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v.parent, 4), _co.loadingMessasge));
        _ck(_v, 17, 0, currVal_2);
    });
}
function View_DdosAttackResultsComponent_9(_l) {
    return __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 22, 'div', [['class',
                'panel cloud-error-style cloud-panel-margins-padding col-sm-5 chart-panel-height ']], null, null, null, null, null)), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 19, 'div', [['class', 'panel-body']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n\n      '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'div', [['class', 'col-sm-12 test-error-label']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n          TEST ENCOUNTERED ERRORS\n      '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n      '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'div', [['class', 'col-sm-8 col-sm-offset-2 test-complete-info']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n           CHECK CONFIGURATION AND RUN ANOTHER TEST\n      '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n\n      '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 4, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n          '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'div', [['class', 'col-sm-10 col-sm-offset-1 issue-error-label horizontalLine']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            DETAILS\n          '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n      '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n\n      '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 4, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n          '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'div', [['class', 'col-sm-10 col-sm-offset-1 issue-detail-label']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            ', '\n          '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n      '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n\n    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.failReason;
        _ck(_v, 19, 0, currVal_0);
    });
}
function View_DdosAttackResultsComponent_10(_l) {
    return __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 51, 'div', [['class',
                'panel cloud-chart-style cloud-panel-margins-padding col-sm-5 chart-panel-height ']], null, null, null, null, null)), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 48, 'div', [['class', 'panel-body']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n      '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'div', [['class', 'col-sm-12 test-Welcome-label']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            STEPS TO GET STARTED\n      '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n      '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'div', [['class', 'col-sm-12 test-welcome-info']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n          1. Authorize access to your Azure Subscription for validating DDoS target IP ownership.\n      '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n      '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 14, 'div', [['class', 'row col-sm-12']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n          '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 11, 'ul', [], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 2, 'li', [['class', 'test-welcome-link']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'div', [['id', 'welcome-new-integration']], null, [[null,
                'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.openTargetValidationService() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['Add Azure Subscription'])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'li', [['class', 'test-welcome-link'], ['id', 'welcome-view-integration']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.openTargetValidationService() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['View Azure Subscriptions'])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'li', [['class', 'test-welcome-link'], ['id', 'welcome-integration-more']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.openWelcomeScreenLink('/help/BPCloudDDoSUG.htm#Topics/DDoS_topics/DDoS_AzureSubsMng.htm', false) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['Learn More'])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n          '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n      '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n\n      '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'div', [['class', 'col-sm-12 test-welcome-info']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n          2. Identify the public IP address of your Azure resource protected from DDoS threats.\n      '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n      '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n\n      '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'div', [['class', 'col-sm-12 test-welcome-info']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n          3. Configure and run DDoS validation test.\n      '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n      '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 4, 'div', [['class', 'row col-sm-12']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n          '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'ul', [], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n          '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n      '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n\n      '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'div', [['class', 'col-sm-12 test-welcome-info']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n          4. Use Microsoft Azure Portal to view DDoS Protection service analytics and insights.\n      '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n      '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 7, 'div', [['class', 'row col-sm-12']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n          '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 4, 'ul', [], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'li', [['class', 'test-welcome-link'], ['id', 'welcome-cloud-use-azure-more']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.openWelcomeScreenLink('https://azure.microsoft.com/en-us/blog/azure-ddos-protection-service-preview', true) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['Learn More'])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n          '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n      '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n\n    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n']))], null, null);
}
function View_DdosAttackResultsComponent_0(_l) {
    return __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵvid"](0, [__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵpid"](0, __WEBPACK_IMPORTED_MODULE_3__angular_common__["DecimalPipe"], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["LOCALE_ID"]]), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵpid"](0, __WEBPACK_IMPORTED_MODULE_6__src_app_pipes_seconds_to_duration_pipe__["a" /* SecondsToDurationPipe */], []), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵpid"](0, __WEBPACK_IMPORTED_MODULE_7__src_app_pipes_bytes_to_megabytes_pipe__["a" /* BytesToMegabytesPipe */], []), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵpid"](0, __WEBPACK_IMPORTED_MODULE_3__angular_common__["DatePipe"], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["LOCALE_ID"]]), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵpid"](0, __WEBPACK_IMPORTED_MODULE_3__angular_common__["UpperCasePipe"], []), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵqud"](402653184, 1, { gauge: 0 }), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵqud"](671088640, 2, { loadProgressBar: 0 }), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 124, 'div', [['class', 'panel cloud-chart-style cloud-panel-margins-padding col-sm-5 chart-panel-height ']], [[8, 'hidden', 0]], null, null, null, null)), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n'])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n    '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 120, 'div', [['class', 'panel-body']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 21, 'div', [['class', 'row clearfix  visible-sm-block visible-md-block visible-lg-block']], null, null, null, null, null)), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 9, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 2, 'div', [['class', 'col-sm-6 cloud-blue-font-large verticalLine'],
                ['id', 'ddos-running-fps']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                    ',
            '\n                '])), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵppd"](1), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 2, 'div', [['class', 'col-sm-6 cloud-blue-font-large'],
            ['id', 'ddos-running-frames-sent']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                    ',
            '\n                '])), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵppd"](1), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n\n            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 7, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'div', [['class', 'col-sm-6 cloud-grey-font-med verticalLine']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                    FRAMES PER SECOND\n                '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'div', [['class', 'col-sm-6 cloud-grey-font-med']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                    FRAMES SENT\n                '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n        '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n        '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 21, 'div', [['class', 'row clearfix  visible-xs-block']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 8, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 2, 'div', [['class', 'col-sm-6 cloud-blue-font-large']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                    ', '\n                '])),
        __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵppd"](1), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'div', [['class', 'col-sm-6 cloud-grey-font-med']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                    FRAMES PER SECOND\n                '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 8, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 2, 'div', [['class', 'col-sm-6 cloud-blue-font-large']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                    ', '\n                '])),
        __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵppd"](1), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'div', [['class', 'col-sm-6 cloud-grey-font-med']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                    FRAMES SENT\n                '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n        '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 7, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 4, 'div', [['style', 'height: 360px; text-align: center;']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'ixgauge', [], null, [[null, 'onCreated']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('onCreated' === en)) {
                var pd_0 = (_co.onGaugeCreated($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, __WEBPACK_IMPORTED_MODULE_9__components_gauge_gauge_component_ngfactory__["a" /* View_GaugeComponent_0 */], __WEBPACK_IMPORTED_MODULE_9__components_gauge_gauge_component_ngfactory__["b" /* RenderType_GaugeComponent */])), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](114688, [[1, 4], ['gauge', 4]], 0, __WEBPACK_IMPORTED_MODULE_10__src_app_components_gauge_gauge_component__["a" /* GaugeComponent */], [], null, null),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n\n\n\n        '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 31, 'div', [['class', 'clearfix  visible-sm-block visible-md-block visible-lg-block']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 15, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'div', [['class', 'col-sm-4 cloud-drk-grey-font'], ['id', 'textStartTime']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                    ', '\n                '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n\n                '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 3, 'div', [['class', 'col-sm-4 cloud-drk-grey-font'], ['id', 'textRunTime']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                    ',
            '\n                '])), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵppd"](1), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 2, 'div', [['class', 'col-sm-4 cloud-drk-grey-font'],
            ['id', 'textOutboundData']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                    ',
            '\n                '])), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵppd"](1), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 11, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'div', [['class', 'col-sm-4 cloud-grey-font-med']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                    START TIME\n                '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'div', [['class', 'col-sm-4 cloud-grey-font-med']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                    RUN TIME\n                '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'div', [['class', 'col-sm-4 cloud-grey-font-med']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                    OUTBOUND DATA (MB)\n                '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n\n\n\n\n        '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 26, 'div', [['class', 'clearfix  visible-xs-block']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 23, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'div', [['class', 'col-sm-4 cloud-drk-grey-font'], ['id', 'textStartTime-sm']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                    ', '\n                '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'div', [['class', 'col-sm-4 cloud-grey-font-med']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                    START TIME\n                '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 2, 'div', [['class', 'col-sm-4 cloud-drk-grey-font'],
            ['id', 'textRunTime-sm']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                    ',
            '\n                '])), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵppd"](2), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'div', [['class', 'col-sm-4 cloud-grey-font-med']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                    RUN TIME\n                '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n\n                '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 2, 'div', [['class', 'col-sm-4 cloud-drk-grey-font'], ['id', 'textOutboundData-sm']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                    ', '\n                '])),
        __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵppd"](1), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n\n                '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'div', [['class', 'col-sm-4 cloud-grey-font-med']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                    OUTBOUND DATA (MB)\n                '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n\n    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n'])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n\n'])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n'])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵand"](16777216, null, null, 1, null, View_DdosAttackResultsComponent_1)), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_common__["NgIf"], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["ViewContainerRef"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n\n\n'])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n'])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵand"](16777216, null, null, 1, null, View_DdosAttackResultsComponent_4)),
        __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_common__["NgIf"], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["ViewContainerRef"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n\n'])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n'])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵand"](16777216, null, null, 1, null, View_DdosAttackResultsComponent_9)), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_common__["NgIf"], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["ViewContainerRef"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n\n'])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n'])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵand"](16777216, null, null, 1, null, View_DdosAttackResultsComponent_10)),
        __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_common__["NgIf"], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["ViewContainerRef"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n']))], function (_ck, _v) {
        var _co = _v.component;
        _ck(_v, 66, 0);
        var currVal_11 = (_co.state === 'complete');
        _ck(_v, 135, 0, currVal_11);
        var currVal_12 = (_co.state === 'loading');
        _ck(_v, 139, 0, currVal_12);
        var currVal_13 = (_co.state === 'fail');
        _ck(_v, 143, 0, currVal_13);
        var currVal_14 = (_co.state === 'welcome');
        _ck(_v, 147, 0, currVal_14);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = (_co.state !== 'running');
        _ck(_v, 7, 0, currVal_0);
        var currVal_1 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵunv"](_v, 18, 0, _ck(_v, 19, 0, __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 0), _co.framesPerSecond));
        _ck(_v, 18, 0, currVal_1);
        var currVal_2 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵunv"](_v, 22, 0, _ck(_v, 23, 0, __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 0), _co.framesSent));
        _ck(_v, 22, 0, currVal_2);
        var currVal_3 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵunv"](_v, 42, 0, _ck(_v, 43, 0, __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 0), _co.framesPerSecond));
        _ck(_v, 42, 0, currVal_3);
        var currVal_4 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵunv"](_v, 52, 0, _ck(_v, 53, 0, __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 0), _co.framesSent));
        _ck(_v, 52, 0, currVal_4);
        var currVal_5 = (_co.formattedDateTime ? _co.formattedDateTime : 'N/A');
        _ck(_v, 76, 0, currVal_5);
        var currVal_6 = (_co.runningTime ? __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵunv"](_v, 81, 0, _ck(_v, 82, 0, __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 1), _co.runningTime)) : 'N/A');
        _ck(_v, 81, 0, currVal_6);
        var currVal_7 = (_co.outboundData ? __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵunv"](_v, 85, 0, _ck(_v, 86, 0, __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 2), _co.outboundData)) : 'N/A');
        _ck(_v, 85, 0, currVal_7);
        var currVal_8 = (_co.formattedDateTime ? _co.formattedDateTime : 'N/A');
        _ck(_v, 109, 0, currVal_8);
        var currVal_9 = (_co.runningTime ? __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵunv"](_v, 116, 0, _ck(_v, 117, 0, __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 3), _co.runningTime, 'HH:mm:ss')) : 'N/A');
        _ck(_v, 116, 0, currVal_9);
        var currVal_10 = (_co.outboundData ? __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵunv"](_v, 123, 0, _ck(_v, 124, 0, __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 2), _co.outboundData)) : 'N/A');
        _ck(_v, 123, 0, currVal_10);
    });
}
function View_DdosAttackResultsComponent_Host_0(_l) {
    return __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'ddos-attack-results', [], null, null, null, View_DdosAttackResultsComponent_0, RenderType_DdosAttackResultsComponent)), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](245760, null, 0, __WEBPACK_IMPORTED_MODULE_8__src_app_main_ddos_attack_results_ddos_attack_results_component__["a" /* DdosAttackResultsComponent */], [__WEBPACK_IMPORTED_MODULE_11__src_app_attack_attack_service__["a" /* AttackService */], __WEBPACK_IMPORTED_MODULE_12__src_app_main_config_config_service__["a" /* ConfigService */], __WEBPACK_IMPORTED_MODULE_13__src_app_main_target_validation_target_validation_service__["a" /* TargetValidationService */], __WEBPACK_IMPORTED_MODULE_14__src_app_login_user_login_service__["a" /* LoginService */]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var DdosAttackResultsComponentNgFactory = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵccf"]('ddos-attack-results', __WEBPACK_IMPORTED_MODULE_8__src_app_main_ddos_attack_results_ddos_attack_results_component__["a" /* DdosAttackResultsComponent */], View_DdosAttackResultsComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=ddos-attack-results.component.ngfactory.js.map

/***/ }),
/* 548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return styles; });
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */
var styles = ['.verticalLine[_ngcontent-%COMP%] {\n  border-right: thin solid #e7e7e7; }\n\n.horizontalLine[_ngcontent-%COMP%] {\n  border-top: thin solid #e7e7e7;\n  padding-top: 10px; }\n\n.test-complete-label[_ngcontent-%COMP%] {\n  color: #9abc7d;\n  font-size: 24px;\n  text-align: center;\n  margin-top: 100px;\n  max-height: 28px; }\n\n.test-error-label[_ngcontent-%COMP%] {\n  color: #b64b4e;\n  font-size: 24px;\n  text-align: center;\n  margin-top: 100px;\n  max-height: 28px; }\n\n.show-ready-big-ok-glyph[_ngcontent-%COMP%] {\n  font-size: 110px;\n  margin-top: 58px; }\n\n.checkbox-defaults[_ngcontent-%COMP%] {\n  margin-left: 20px; }\n\n.loading-checkbox-svg[_ngcontent-%COMP%] {\n  width: 2.5em;\n  height: 2.5em;\n  position: absolute;\n  left: -1.3em;\n  top: .1em;\n  border: 1px solid #848484; }\n\n.loading-checkbox-label[_ngcontent-%COMP%] {\n  display: inline-block;\n  padding-left: 1.7em;\n  white-space: nowrap;\n  padding-top: .6em;\n  position: relative;\n  font-size: 10px;\n  cursor: pointer; }\n\n.loading-checkbox-input[type="checkbox"][_ngcontent-%COMP%] {\n  opacity: 0;\n  width: 1px;\n  height: 1px; }\n\n.loading-checkbox-input[type="checkbox"][_ngcontent-%COMP%]:checked    ~ .loading-checkbox-label[_ngcontent-%COMP%]   .loading-checkbox-svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%] {\n  stroke-dashoffset: 0;\n  fill: #9abc7d; }\n\n.test-complete-info[_ngcontent-%COMP%] {\n  color: #c9c9c9;\n  font-size: 18px;\n  text-align: center;\n  margin-top: 25px;\n  margin-bottom: 100px;\n  max-height: 40px;\n  font-weight: normal; }\n\n.test-Welcome-label[_ngcontent-%COMP%] {\n  color: #9abc7d;\n  font-size: 24px;\n  text-align: left;\n  margin-top: 20px;\n  max-height: 27px; }\n\n.test-welcome-info[_ngcontent-%COMP%] {\n  font-size: 16px;\n  text-align: left;\n  margin-top: 20px;\n  max-height: 55px;\n  font-weight: bold;\n  color: #8b8b8b; }\n\n.test-welcome-link[_ngcontent-%COMP%] {\n  font-size: 11px;\n  font-weight: normal;\n  text-align: left;\n  text-decoration: none;\n  cursor: pointer;\n  color: #4dadd8;\n  margin-top: 10px;\n  max-height: 13px; }\n\n.last-run-label[_ngcontent-%COMP%] {\n  color: #626262;\n  font-size: 12px;\n  text-align: center;\n  max-height: 24px; }\n\n.issue-error-label[_ngcontent-%COMP%] {\n  color: #626262;\n  font-size: 12px;\n  text-align: left;\n  max-height: 24px;\n  padding-top: 30px;\n  margin-bottom: 30px; }\n\n.issue-detail-label[_ngcontent-%COMP%] {\n  color: #b64b4e;\n  font-size: 12px;\n  text-align: left;\n  max-height: 24px; }\n\n.loader[_ngcontent-%COMP%] {\n  font-size: 20px;\n  margin: 100px auto;\n  width: 1em;\n  height: 1em;\n  border-radius: 50%;\n  position: relative;\n  text-indent: -9999em;\n  -webkit-animation: load4 1.3s infinite linear;\n  animation: load4 1.3s infinite linear;\n  -webkit-transform: translateZ(0);\n  -ms-transform: translateZ(0);\n  transform: translateZ(0);\n  opacity: 0.5; }\n\n@-webkit-keyframes load4 {\n  0%,\n  100% {\n    box-shadow: 0 -3em 0 0.2em, 2em -2em 0 0em, 3em 0 0 -1em, 2em 2em 0 -1em, 0 3em 0 -1em, -2em 2em 0 -1em, -3em 0 0 -1em, -2em -2em 0 0; }\n  12.5% {\n    box-shadow: 0 -3em 0 0, 2em -2em 0 0.2em, 3em 0 0 0, 2em 2em 0 -1em, 0 3em 0 -1em, -2em 2em 0 -1em, -3em 0 0 -1em, -2em -2em 0 -1em; }\n  25% {\n    box-shadow: 0 -3em 0 -0.5em, 2em -2em 0 0, 3em 0 0 0.2em, 2em 2em 0 0, 0 3em 0 -1em, -2em 2em 0 -1em, -3em 0 0 -1em, -2em -2em 0 -1em; }\n  37.5% {\n    box-shadow: 0 -3em 0 -1em, 2em -2em 0 -1em, 3em 0em 0 0, 2em 2em 0 0.2em, 0 3em 0 0em, -2em 2em 0 -1em, -3em 0em 0 -1em, -2em -2em 0 -1em; }\n  50% {\n    box-shadow: 0 -3em 0 -1em, 2em -2em 0 -1em, 3em 0 0 -1em, 2em 2em 0 0em, 0 3em 0 0.2em, -2em 2em 0 0, -3em 0em 0 -1em, -2em -2em 0 -1em; }\n  62.5% {\n    box-shadow: 0 -3em 0 -1em, 2em -2em 0 -1em, 3em 0 0 -1em, 2em 2em 0 -1em, 0 3em 0 0, -2em 2em 0 0.2em, -3em 0 0 0, -2em -2em 0 -1em; }\n  75% {\n    box-shadow: 0em -3em 0 -1em, 2em -2em 0 -1em, 3em 0em 0 -1em, 2em 2em 0 -1em, 0 3em 0 -1em, -2em 2em 0 0, -3em 0em 0 0.2em, -2em -2em 0 0; }\n  87.5% {\n    box-shadow: 0em -3em 0 0, 2em -2em 0 -1em, 3em 0 0 -1em, 2em 2em 0 -1em, 0 3em 0 -1em, -2em 2em 0 0, -3em 0em 0 0, -2em -2em 0 0.2em; } }\n\n@keyframes load4 {\n  0%,\n  100% {\n    box-shadow: 0 -3em 0 0.2em, 2em -2em 0 0em, 3em 0 0 -1em, 2em 2em 0 -1em, 0 3em 0 -1em, -2em 2em 0 -1em, -3em 0 0 -1em, -2em -2em 0 0; }\n  12.5% {\n    box-shadow: 0 -3em 0 0, 2em -2em 0 0.2em, 3em 0 0 0, 2em 2em 0 -1em, 0 3em 0 -1em, -2em 2em 0 -1em, -3em 0 0 -1em, -2em -2em 0 -1em; }\n  25% {\n    box-shadow: 0 -3em 0 -0.5em, 2em -2em 0 0, 3em 0 0 0.2em, 2em 2em 0 0, 0 3em 0 -1em, -2em 2em 0 -1em, -3em 0 0 -1em, -2em -2em 0 -1em; }\n  37.5% {\n    box-shadow: 0 -3em 0 -1em, 2em -2em 0 -1em, 3em 0em 0 0, 2em 2em 0 0.2em, 0 3em 0 0em, -2em 2em 0 -1em, -3em 0em 0 -1em, -2em -2em 0 -1em; }\n  50% {\n    box-shadow: 0 -3em 0 -1em, 2em -2em 0 -1em, 3em 0 0 -1em, 2em 2em 0 0em, 0 3em 0 0.2em, -2em 2em 0 0, -3em 0em 0 -1em, -2em -2em 0 -1em; }\n  62.5% {\n    box-shadow: 0 -3em 0 -1em, 2em -2em 0 -1em, 3em 0 0 -1em, 2em 2em 0 -1em, 0 3em 0 0, -2em 2em 0 0.2em, -3em 0 0 0, -2em -2em 0 -1em; }\n  75% {\n    box-shadow: 0em -3em 0 -1em, 2em -2em 0 -1em, 3em 0em 0 -1em, 2em 2em 0 -1em, 0 3em 0 -1em, -2em 2em 0 0, -3em 0em 0 0.2em, -2em -2em 0 0; }\n  87.5% {\n    box-shadow: 0em -3em 0 0, 2em -2em 0 -1em, 3em 0 0 -1em, 2em 2em 0 -1em, 0 3em 0 -1em, -2em 2em 0 0, -3em 0em 0 0, -2em -2em 0 0.2em; } }'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3NyYy91aS9zcmMvYXBwL21haW4vZGRvcy1hdHRhY2stcmVzdWx0cy9kZG9zLWF0dGFjay1yZXN1bHRzLmNvbXBvbmVudC5zY3NzLnNoaW0ubmdzdHlsZS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL3NyYy91aS9zcmMvYXBwL21haW4vZGRvcy1hdHRhY2stcmVzdWx0cy9kZG9zLWF0dGFjay1yZXN1bHRzLmNvbXBvbmVudC5zY3NzIl0sInNvdXJjZXNDb250ZW50IjpbIiAiXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7OzsifQ==
//# sourceMappingURL=ddos-attack-results.component.scss.shim.ngstyle.js.map

/***/ }),
/* 549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RenderType_HistoryComponent */
/* unused harmony export View_HistoryComponent_0 */
/* unused harmony export View_HistoryComponent_Host_0 */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HistoryComponentNgFactory; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__history_component_scss_ngstyle__ = __webpack_require__(550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_bootstrap_dist_css_bootstrap_css_ngstyle__ = __webpack_require__(528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_core__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__angular_common__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_app_pipes_seconds_to_duration_pipe__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_app_pipes_bytes_to_megabytes_pipe__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_app_main_history_history_component__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__node_modules_swimlane_ngx_datatable_release_components_datatable_component_ngfactory__ = __webpack_require__(523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__swimlane_ngx_datatable_release_components_datatable_component__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__swimlane_ngx_datatable_release_components_datatable_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__swimlane_ngx_datatable_release_components_datatable_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__swimlane_ngx_datatable_release_services_scrollbar_helper_service__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__swimlane_ngx_datatable_release_services_scrollbar_helper_service___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__swimlane_ngx_datatable_release_services_scrollbar_helper_service__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modals_support_support_dialog_component_ngfactory__ = __webpack_require__(561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_app_modals_support_support_dialog_component__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_app_attack_attack_service__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__angular_router__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_app_main_config_config_service__ = __webpack_require__(34);
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */















var styles_HistoryComponent = [__WEBPACK_IMPORTED_MODULE_0__history_component_scss_ngstyle__["a" /* styles */], __WEBPACK_IMPORTED_MODULE_1__node_modules_bootstrap_dist_css_bootstrap_css_ngstyle__["a" /* styles */]];
var RenderType_HistoryComponent = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵcrt"]({ encapsulation: 2,
    styles: styles_HistoryComponent, data: {} });
function View_HistoryComponent_1(_l) {
    return __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'span', [], [[8, 'title', 0]], null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['', ''])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            ']))], null, function (_ck, _v) {
        var currVal_0 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵinlineInterpolate"](1, '', ((_v.context.value === 'Stopped') ? _v.context.row.StopReason : ((_v.context.value === 'Failed') ? _v.context.row.FailReason : _v.context.value)), '');
        _ck(_v, 1, 0, currVal_0);
        var currVal_1 = ((_v.context.value === 'Failed') ? 'Error' : ((_v.context.value === 'Created') ? 'Validating' : _v.context.value));
        _ck(_v, 2, 0, currVal_1);
    });
}
function View_HistoryComponent_2(_l) {
    return __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'span', [], [[8, 'title', 0]], null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['', ':', ''])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            ']))], null, function (_ck, _v) {
        var currVal_0 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵinlineInterpolate"](2, '', _v.context.value, ':', _v.context.row.AttackParams.TargetPortNumber, '');
        _ck(_v, 1, 0, currVal_0);
        var currVal_1 = _v.context.value;
        var currVal_2 = _v.context.row.AttackParams.TargetPortNumber;
        _ck(_v, 2, 0, currVal_1, currVal_2);
    });
}
function View_HistoryComponent_3(_l) {
    return __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 3, 'span', [], [[8, 'title', 0]], null, null, null, null)), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵppd"](2), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['', ''])), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵppd"](2), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            ']))], null, function (_ck, _v) {
        var currVal_0 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵinlineInterpolate"](1, '', (_v.context.value ? __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵunv"](_v, 1, 0, _ck(_v, 2, 0, __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v.parent, 0), _v.context.value, 'MM.dd.y HH:mm:ss')) : 'N/A'), '');
        _ck(_v, 1, 0, currVal_0);
        var currVal_1 = (_v.context.value ? __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵunv"](_v, 3, 0, _ck(_v, 4, 0, __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v.parent, 0), _v.context.value, 'MM.dd.y HH:mm:ss')) : 'N/A');
        _ck(_v, 3, 0, currVal_1);
    });
}
function View_HistoryComponent_4(_l) {
    return __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 3, 'span', [], [[8, 'title', 0]], null, null, null, null)), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵppd"](1), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['', ''])), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵppd"](1), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            ']))], null, function (_ck, _v) {
        var currVal_0 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵinlineInterpolate"](1, '', (_v.context.value ? __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵunv"](_v, 1, 0, _ck(_v, 2, 0, __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v.parent, 1), _v.context.value)) : 'N/A'), '');
        _ck(_v, 1, 0, currVal_0);
        var currVal_1 = (_v.context.value ? __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵunv"](_v, 3, 0, _ck(_v, 4, 0, __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v.parent, 1), _v.context.value)) : 'N/A');
        _ck(_v, 3, 0, currVal_1);
    });
}
function View_HistoryComponent_5(_l) {
    return __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 3, 'span', [], [[8, 'title', 0]], null, null, null, null)), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵppd"](1), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['', ''])), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵppd"](1), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            ']))], null, function (_ck, _v) {
        var currVal_0 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵinlineInterpolate"](1, '', (_v.context.value ? __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵunv"](_v, 1, 0, _ck(_v, 2, 0, __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v.parent, 2), _v.context.value)) : '0'), '');
        _ck(_v, 1, 0, currVal_0);
        var currVal_1 = (_v.context.value ? __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵunv"](_v, 3, 0, _ck(_v, 4, 0, __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v.parent, 2), _v.context.value)) : '0');
        _ck(_v, 3, 0, currVal_1);
    });
}
function View_HistoryComponent_6(_l) {
    return __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 3, 'span', [], [[8, 'title', 0]], null, null, null, null)), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵppd"](1), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['', ''])), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵppd"](1), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            ']))], null, function (_ck, _v) {
        var currVal_0 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵinlineInterpolate"](1, '', (_v.context.value ? __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵunv"](_v, 1, 0, _ck(_v, 2, 0, __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v.parent, 3), _v.context.value)) : '0'), '');
        _ck(_v, 1, 0, currVal_0);
        var currVal_1 = (_v.context.value ? __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵunv"](_v, 3, 0, _ck(_v, 4, 0, __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v.parent, 3), _v.context.value)) : '0');
        _ck(_v, 3, 0, currVal_1);
    });
}
function View_HistoryComponent_7(_l) {
    return __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 0, 'img', [['class', 'headset-icon'], ['src',
                    '/assets/Headset.b5b10178cf8486294142eec7ba2f357a.svg'], ['title', 'BreakingPoint Cloud support for this test run.']], null, [[null, 'click']], function (_v, en, $event) {
                var ad = true;
                var _co = _v.component;
                if (('click' === en)) {
                    var pd_0 = (_co.showSupportModal(_v.context.value) !== false);
                    ad = (pd_0 && ad);
                }
                return ad;
            }, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n\n            ']))], null, null);
}
function View_HistoryComponent_0(_l) {
    return __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵvid"](0, [__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵpid"](0, __WEBPACK_IMPORTED_MODULE_3__angular_common__["DatePipe"], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["LOCALE_ID"]]), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵpid"](0, __WEBPACK_IMPORTED_MODULE_4__src_app_pipes_seconds_to_duration_pipe__["a" /* SecondsToDurationPipe */], []), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵpid"](0, __WEBPACK_IMPORTED_MODULE_3__angular_common__["DecimalPipe"], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["LOCALE_ID"]]), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵpid"](0, __WEBPACK_IMPORTED_MODULE_5__src_app_pipes_bytes_to_megabytes_pipe__["a" /* BytesToMegabytesPipe */], []), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵqud"](402653184, 1, { historyTable: 0 }), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵqud"](402653184, 2, { editTmpl: 0 }),
        __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵqud"](402653184, 3, { ipTmpl: 0 }), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵqud"](402653184, 4, { timeTmpl: 0 }), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵqud"](402653184, 5, { numTmpl: 0 }), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵqud"](402653184, 6, { MBTmpl: 0 }), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵqud"](402653184, 7, { statusTmpl: 0 }),
        __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵqud"](402653184, 8, { supportTmpl: 0 }), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵqud"](402653184, 9, { supportModal: 0 }), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 44, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 41, 'div', [['class',
                'col-sm-10 col-sm-offset-1 cloud-title-style'], ['style', 'padding-top: 30px;']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n        RECENT TEST HISTORY\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 23, 'div', [['class', 'cloud-grid-style']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 6, 'ngx-datatable', [['class', 'material striped ngx-datatable'], ['id', 'ddos-history-table']], [[2, 'fixed-header', null], [2, 'fixed-row', null], [2, 'scroll-vertical',
                null], [2, 'scroll-horz', null], [2, 'selectable', null],
            [2, 'checkbox-selection', null], [2, 'cell-selection', null],
            [2, 'single-selection', null], [2, 'multi-selection', null],
            [2, 'multi-click-selection', null]], [[null, 'select'],
            ['window', 'resize']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('window:resize' === en)) {
                var pd_0 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 21).onWindowResize() !== false);
                ad = (pd_0 && ad);
            }
            if (('select' === en)) {
                var pd_1 = (_co.onSelectHistory($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, __WEBPACK_IMPORTED_MODULE_7__node_modules_swimlane_ngx_datatable_release_components_datatable_component_ngfactory__["a" /* View_DatatableComponent_0 */], __WEBPACK_IMPORTED_MODULE_7__node_modules_swimlane_ngx_datatable_release_components_datatable_component_ngfactory__["b" /* RenderType_DatatableComponent */])), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](4571136, [[1, 4], ['historyTable', 4]], 3, __WEBPACK_IMPORTED_MODULE_8__swimlane_ngx_datatable_release_components_datatable_component__["DatatableComponent"], [__WEBPACK_IMPORTED_MODULE_9__swimlane_ngx_datatable_release_services_scrollbar_helper_service__["ScrollbarHelper"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["ElementRef"],
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["KeyValueDiffers"]], { rows: [0, 'rows'], columns: [1, 'columns'], selected: [2,
                'selected'], rowHeight: [3, 'rowHeight'], columnMode: [4, 'columnMode'], headerHeight: [5,
                'headerHeight'], limit: [6, 'limit'], selectionType: [7, 'selectionType'],
            messages: [8, 'messages'] }, { select: 'select' }), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵqud"](603979776, 10, { columnTemplates: 1 }),
        __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵqud"](335544320, 11, { rowDetail: 0 }), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵqud"](335544320, 12, { footer: 0 }), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵpod"]({ emptyMessage: 0 }),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n\n            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵand"](0, [[7, 2], ['statusTmpl', 2]], null, 0, null, View_HistoryComponent_1)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n\n            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵand"](0, [[3, 2], ['ipTmpl', 2]], null, 0, null, View_HistoryComponent_2)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n\n            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵand"](0, [[2, 2], ['editTmpl', 2]], null, 0, null, View_HistoryComponent_3)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n\n            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵand"](0, [[4, 2], ['timeTmpl', 2]], null, 0, null, View_HistoryComponent_4)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n\n            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵand"](0, [[5, 2], ['numTmpl', 2]], null, 0, null, View_HistoryComponent_5)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n\n            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵand"](0, [[6, 2], ['MBTmpl', 2]], null, 0, null, View_HistoryComponent_6)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n\n            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵand"](0, [[8, 2], ['supportTmpl', 2]], null, 0, null, View_HistoryComponent_7)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n\n\n\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n        '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 12, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'div', [['class', 'col-sm-10']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                 \n            '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 4, 'div', [['class', 'col-sm-2 cloud-btn-group-right']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'button', [['class', 'btn btn-success btn-block cloud-btn-style'], ['id', 'btn-run-again-ddos'],
            ['style', 'pointer-events: auto;']], [[8, 'disabled', 0], [8, 'title', 0]], [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.runAgain() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['Load Test'])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n\n'])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n\n'])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'support-dialog', [], null, null, null, __WEBPACK_IMPORTED_MODULE_10__modals_support_support_dialog_component_ngfactory__["a" /* View_SupportDialogComponent_0 */], __WEBPACK_IMPORTED_MODULE_10__modals_support_support_dialog_component_ngfactory__["b" /* RenderType_SupportDialogComponent */])),
        __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](114688, [[9, 4], ['supportModal', 4]], 0, __WEBPACK_IMPORTED_MODULE_11__src_app_modals_support_support_dialog_component__["a" /* SupportDialogComponent */], [], null, null), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_10 = _co.rows;
        var currVal_11 = _co.columns;
        var currVal_12 = _co.selected;
        var currVal_13 = 'auto';
        var currVal_14 = 'flex';
        var currVal_15 = 40;
        var currVal_16 = 15;
        var currVal_17 = 'single';
        var currVal_18 = _ck(_v, 25, 0, _co.gridMessage);
        _ck(_v, 21, 0, currVal_10, currVal_11, currVal_12, currVal_13, currVal_14, currVal_15, currVal_16, currVal_17, currVal_18);
        _ck(_v, 60, 0);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 21).isFixedHeader;
        var currVal_1 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 21).isFixedRow;
        var currVal_2 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 21).isVertScroll;
        var currVal_3 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 21).isHorScroll;
        var currVal_4 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 21).isSelectable;
        var currVal_5 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 21).isCheckboxSelection;
        var currVal_6 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 21).isCellSelection;
        var currVal_7 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 21).isSingleSelection;
        var currVal_8 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 21).isMultiSelection;
        var currVal_9 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 21).isMultiClickSelection;
        _ck(_v, 20, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8, currVal_9);
        var currVal_19 = !_co.runButtonEnabled;
        var currVal_20 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵinlineInterpolate"](1, '', (!_co.needsAttackSelection ? (!_co.canStartAttack ? 'A test is currently running' : 'Load this test configuration') : (!_co.canStartAttack ? 'A test is currently running' : 'Select a test')), '');
        _ck(_v, 52, 0, currVal_19, currVal_20);
    });
}
function View_HistoryComponent_Host_0(_l) {
    return __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'history', [], null, null, null, View_HistoryComponent_0, RenderType_HistoryComponent)),
        __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](114688, null, 0, __WEBPACK_IMPORTED_MODULE_6__src_app_main_history_history_component__["a" /* HistoryComponent */], [__WEBPACK_IMPORTED_MODULE_12__src_app_attack_attack_service__["a" /* AttackService */], __WEBPACK_IMPORTED_MODULE_13__angular_router__["a" /* Router */],
            __WEBPACK_IMPORTED_MODULE_14__src_app_main_config_config_service__["a" /* ConfigService */]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var HistoryComponentNgFactory = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵccf"]('history', __WEBPACK_IMPORTED_MODULE_6__src_app_main_history_history_component__["a" /* HistoryComponent */], View_HistoryComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=history.component.ngfactory.js.map

/***/ }),
/* 550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return styles; });
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */
var styles = ['.ngx-datatable {\n  min-width: 950px; }\n\n.datatable-body-row.active .datatable-row-group {\n  background: #dbf4c8 !important; }\n\n.datatable-header-cell-label {\n  color: white;\n  font-size: 12px;\n  font-family: open_sans;\n  font-weight: bold; }\n\n.datatable-header-cell {\n  cursor: none;\n  background: #4dadd8;\n  padding-left: 0px !important;\n  text-align: center; }\n\n.datatable-header {\n  max-height: 30px; }\n\n.ngx-datatable.material.striped .datatable-row-odd {\n  background: #f8f8f8; }\n\n.ngx-datatable .datatable-body .datatable-body-row {\n  border-bottom: 0px solid #e6e6e6;\n  min-height: 35px; }\n\n.ngx-datatable .datatable-body .datatable-body-row .datatable-body-cell {\n  border-right: 0px solid #e6e6e6;\n  color: #656565;\n  font-size: 12px;\n  font-family: open_sans;\n  padding-left: 5px !important;\n  padding-top: 7px !important;\n  padding-bottom: 7px !important;\n  text-align: left; }\n\n.ngx-datatable.material:not(.cell-selection) .datatable-body-row:hover,\n.ngx-datatable.material:not(.cell-selection) .datatable-body-row:hover .datatable-row-group {\n  background: #eaeaea; }\n\n.ngx-datatable .datatable-header .datatable-header-cell {\n  border-right: 1px solid #4dadd8;\n  text-align: left;\n  padding-left: 5px !important; }\n\n.icon-row {\n  padding-left: 0px !important; }\n\n.headset-icon {\n  width: 15px;\n  height: 15px;\n  opacity: 0.5; }\n'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3NyYy91aS9zcmMvYXBwL21haW4vaGlzdG9yeS9oaXN0b3J5LmNvbXBvbmVudC5zY3NzLm5nc3R5bGUudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9zcmMvdWkvc3JjL2FwcC9tYWluL2hpc3RvcnkvaGlzdG9yeS5jb21wb25lbnQuc2NzcyJdLCJzb3VyY2VzQ29udGVudCI6WyIgIl0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7In0=
//# sourceMappingURL=history.component.scss.ngstyle.js.map

/***/ }),
/* 551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RenderType_AdminConsentDialog; });
/* harmony export (immutable) */ __webpack_exports__["a"] = View_AdminConsentDialog_0;
/* unused harmony export View_AdminConsentDialog_Host_0 */
/* unused harmony export AdminConsentDialogNgFactory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_bootstrap_dist_css_bootstrap_css_shim_ngstyle__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__target_validation_dialog_component_scss_shim_ngstyle__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__admin_consent_dialog_component_scss_shim_ngstyle__ = __webpack_require__(552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__angular_core__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__angular_common__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_app_main_target_validation_admin_consent_dialog_component__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_ngx_clipboard_src_clipboard_directive__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_ngx_clipboard_src_clipboard_service__ = __webpack_require__(134);
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */








var styles_AdminConsentDialog = [__WEBPACK_IMPORTED_MODULE_0__node_modules_bootstrap_dist_css_bootstrap_css_shim_ngstyle__["a" /* styles */], __WEBPACK_IMPORTED_MODULE_1__target_validation_dialog_component_scss_shim_ngstyle__["a" /* styles */], __WEBPACK_IMPORTED_MODULE_2__admin_consent_dialog_component_scss_shim_ngstyle__["a" /* styles */]];
var RenderType_AdminConsentDialog = __WEBPACK_IMPORTED_MODULE_3__angular_core__["ɵcrt"]({ encapsulation: 0,
    styles: styles_AdminConsentDialog, data: {} });
function View_AdminConsentDialog_0(_l) {
    return __WEBPACK_IMPORTED_MODULE_3__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_3__angular_core__["ɵeld"](0, null, null, 50, 'div', [['id',
                'targetValidationModal']], null, null, null, null, null)), __WEBPACK_IMPORTED_MODULE_3__angular_core__["ɵdid"](278528, null, 0, __WEBPACK_IMPORTED_MODULE_4__angular_common__["NgClass"], [__WEBPACK_IMPORTED_MODULE_3__angular_core__["IterableDiffers"],
            __WEBPACK_IMPORTED_MODULE_3__angular_core__["KeyValueDiffers"], __WEBPACK_IMPORTED_MODULE_3__angular_core__["ElementRef"], __WEBPACK_IMPORTED_MODULE_3__angular_core__["Renderer"]], { ngClass: [0, 'ngClass'] }, null),
        __WEBPACK_IMPORTED_MODULE_3__angular_core__["ɵpod"]({ 'modal-component': 0, 'modal-component-off': 1 }), (_l()(), __WEBPACK_IMPORTED_MODULE_3__angular_core__["ɵted"](null, ['\n    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_3__angular_core__["ɵeld"](0, null, null, 45, 'div', [['class',
                'modal-container'], ['id', 'targetSubscriptionBox']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_3__angular_core__["ɵted"](null, ['\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_3__angular_core__["ɵeld"](0, null, null, 4, 'div', [['class',
                'header header_border']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_3__angular_core__["ɵted"](null, ['\n            '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_3__angular_core__["ɵeld"](0, null, null, 1, 'legend', [['class', 'dialog-title']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_3__angular_core__["ɵted"](null, ['Admin Consent'])), (_l()(), __WEBPACK_IMPORTED_MODULE_3__angular_core__["ɵted"](null, ['\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_3__angular_core__["ɵted"](null, ['\n        '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_3__angular_core__["ɵeld"](0, null, null, 24, 'div', [['class', 'mainbody'], ['style',
                    'min-height: 275px;']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_3__angular_core__["ɵted"](null, ['\n            '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_3__angular_core__["ɵeld"](0, null, null, 21, 'div', [['class', 'main-container']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_3__angular_core__["ɵted"](null, ['\n                '])), (_l()(), __WEBPACK_IMPORTED_MODULE_3__angular_core__["ɵeld"](0, null, null, 18, 'div', [['class', 'description']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_3__angular_core__["ɵted"](null, ['\n                    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_3__angular_core__["ɵeld"](0, null, null, 1, 'p', [], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_3__angular_core__["ɵted"](null, ['\n                        If "Add Subscription" authorization returns the message "Need admin approval",\n                        an Azure AD Global Administrator from your organization must approve the use of\n                        BreakingPoint Cloud application by accessing the following link:\n                    '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_3__angular_core__["ɵted"](null, ['\n                    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_3__angular_core__["ɵeld"](0, null, null, 9, 'div', [['class', 'urlContainer displayFlex']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_3__angular_core__["ɵted"](null, ['\n                        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_3__angular_core__["ɵeld"](0, null, null, 3, 'div', [['class', 'urlInput']], null, null, null, null, null)), __WEBPACK_IMPORTED_MODULE_3__angular_core__["ɵdid"](278528, null, 0, __WEBPACK_IMPORTED_MODULE_4__angular_common__["NgClass"], [__WEBPACK_IMPORTED_MODULE_3__angular_core__["IterableDiffers"], __WEBPACK_IMPORTED_MODULE_3__angular_core__["KeyValueDiffers"], __WEBPACK_IMPORTED_MODULE_3__angular_core__["ElementRef"],
            __WEBPACK_IMPORTED_MODULE_3__angular_core__["Renderer"]], { klass: [0, 'klass'], ngClass: [1, 'ngClass'] }, null),
        __WEBPACK_IMPORTED_MODULE_3__angular_core__["ɵpod"]({ 'highlighted': 0, 'not-highlighted': 1 }), (_l()(), __WEBPACK_IMPORTED_MODULE_3__angular_core__["ɵted"](null, ['\n                            ', '\n                        '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_3__angular_core__["ɵted"](null, ['\n                        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_3__angular_core__["ɵeld"](0, null, null, 1, 'div', [['class', 'copyButton glyphicon glyphicon-copy'],
            ['ngxClipboard', ''], ['style', 'cursor:pointer'], ['title', 'Copy to clipboard']], null, [[null, 'cbOnSuccess'], [null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (__WEBPACK_IMPORTED_MODULE_3__angular_core__["ɵnov"](_v, 29).onClick($event.target) !== false);
                ad = (pd_0 && ad);
            }
            if (('cbOnSuccess' === en)) {
                var pd_1 = (_co.highlightAfterCopy($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), __WEBPACK_IMPORTED_MODULE_3__angular_core__["ɵdid"](212992, null, 0, __WEBPACK_IMPORTED_MODULE_6_ngx_clipboard_src_clipboard_directive__["a" /* ClipboardDirective */], [__WEBPACK_IMPORTED_MODULE_7_ngx_clipboard_src_clipboard_service__["a" /* ClipboardService */], __WEBPACK_IMPORTED_MODULE_3__angular_core__["Renderer"]], { targetElm: [0, 'targetElm'], cbContent: [1,
                'cbContent'] }, { cbOnSuccess: 'cbOnSuccess' }), (_l()(), __WEBPACK_IMPORTED_MODULE_3__angular_core__["ɵted"](null, ['\n                    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_3__angular_core__["ɵted"](null, ['\n                    '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_3__angular_core__["ɵeld"](0, null, null, 1, 'p', [], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_3__angular_core__["ɵted"](null, ['\n                        After permissions are granted, return to BreakingPoint Cloud Azure Subscriptions dialog and\n                        "Re-authorize" your Azure Subscription (or remove it and add it again).\n                    '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_3__angular_core__["ɵted"](null, ['\n                '])), (_l()(), __WEBPACK_IMPORTED_MODULE_3__angular_core__["ɵted"](null, ['\n            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_3__angular_core__["ɵted"](null, ['\n        '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_3__angular_core__["ɵted"](null, ['\n\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_3__angular_core__["ɵeld"](0, null, null, 10, 'div', [['class', 'footer footer_border']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_3__angular_core__["ɵted"](null, ['\n            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_3__angular_core__["ɵeld"](0, null, null, 7, 'div', [['class', 'ok-cancel-buttons']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_3__angular_core__["ɵted"](null, ['\n                '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_3__angular_core__["ɵeld"](0, null, null, 4, 'button', [['class', 'close-button'],
            ['id', 'closeButton']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.onCloseClicked($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_3__angular_core__["ɵted"](null, ['\n                    '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_3__angular_core__["ɵeld"](0, null, null, 1, 'span', [], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_3__angular_core__["ɵted"](null, ['Close'])), (_l()(), __WEBPACK_IMPORTED_MODULE_3__angular_core__["ɵted"](null, ['\n                '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_3__angular_core__["ɵted"](null, ['\n            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_3__angular_core__["ɵted"](null, ['\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_3__angular_core__["ɵted"](null, ['\n    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_3__angular_core__["ɵted"](null, ['\n']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _ck(_v, 2, 0, _co.isOn, !_co.isOn);
        _ck(_v, 1, 0, currVal_0);
        var currVal_1 = 'urlInput';
        var currVal_2 = _ck(_v, 25, 0, _co.valueCopied, !_co.valueCopied);
        _ck(_v, 24, 0, currVal_1, currVal_2);
        var currVal_4 = '';
        var currVal_5 = _co.adminConsentUrl;
        _ck(_v, 29, 0, currVal_4, currVal_5);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_3 = _co.adminConsentUrl;
        _ck(_v, 26, 0, currVal_3);
    });
}
function View_AdminConsentDialog_Host_0(_l) {
    return __WEBPACK_IMPORTED_MODULE_3__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_3__angular_core__["ɵeld"](0, null, null, 1, 'dialog-admin-consent', [], null, null, null, View_AdminConsentDialog_0, RenderType_AdminConsentDialog)), __WEBPACK_IMPORTED_MODULE_3__angular_core__["ɵdid"](114688, null, 0, __WEBPACK_IMPORTED_MODULE_5__src_app_main_target_validation_admin_consent_dialog_component__["b" /* AdminConsentDialog */], [__WEBPACK_IMPORTED_MODULE_4__angular_common__["Location"]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var AdminConsentDialogNgFactory = __WEBPACK_IMPORTED_MODULE_3__angular_core__["ɵccf"]('dialog-admin-consent', __WEBPACK_IMPORTED_MODULE_5__src_app_main_target_validation_admin_consent_dialog_component__["b" /* AdminConsentDialog */], View_AdminConsentDialog_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=admin-consent-dialog.component.ngfactory.js.map

/***/ }),
/* 552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return styles; });
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */
var styles = ['.urlInput[_ngcontent-%COMP%] {\n  flex: 1;\n  margin: 10px;\n  word-break: break-all;\n  font-size: 13px; }\n\n.urlContainer[_ngcontent-%COMP%] {\n  width: 100%;\n  min-height: 60px;\n  margin: 10px 0;\n  border: 2px solid #CCCCCC;\n  background-color: #FFFFFF; }\n\n.displayFlex[_ngcontent-%COMP%] {\n  display: flex;\n  align-items: center; }\n\n.highlighted[_ngcontent-%COMP%] {\n  background-color: #58a2d3; }\n\n.not-highlighted[_ngcontent-%COMP%] {\n  background-color: #FFFFFF;\n  transition: background-color 2000ms ease; }\n\n.copyButton[_ngcontent-%COMP%] {\n  margin: 12px;\n  font-size: 25px; }'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3NyYy91aS9zcmMvYXBwL21haW4vdGFyZ2V0LXZhbGlkYXRpb24vYWRtaW4tY29uc2VudC1kaWFsb2cuY29tcG9uZW50LnNjc3Muc2hpbS5uZ3N0eWxlLnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vc3JjL3VpL3NyYy9hcHAvbWFpbi90YXJnZXQtdmFsaWRhdGlvbi9hZG1pbi1jb25zZW50LWRpYWxvZy5jb21wb25lbnQuc2NzcyJdLCJzb3VyY2VzQ29udGVudCI6WyIgIl0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7In0=
//# sourceMappingURL=admin-consent-dialog.component.scss.shim.ngstyle.js.map

/***/ }),
/* 553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RenderType_TargetValidationDialog; });
/* harmony export (immutable) */ __webpack_exports__["a"] = View_TargetValidationDialog_0;
/* unused harmony export View_TargetValidationDialog_Host_0 */
/* unused harmony export TargetValidationDialogNgFactory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_bootstrap_dist_css_bootstrap_css_shim_ngstyle__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__target_validation_dialog_component_scss_shim_ngstyle__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_core__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__angular_common__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_app_main_target_validation_target_validation_dialog_component__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__angular_forms__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__admin_consent_dialog_component_ngfactory__ = __webpack_require__(551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_app_main_target_validation_admin_consent_dialog_component__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_app_main_target_validation_target_validation_service__ = __webpack_require__(45);
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */









var styles_TargetValidationDialog = [__WEBPACK_IMPORTED_MODULE_0__node_modules_bootstrap_dist_css_bootstrap_css_shim_ngstyle__["a" /* styles */], __WEBPACK_IMPORTED_MODULE_1__target_validation_dialog_component_scss_shim_ngstyle__["a" /* styles */]];
var RenderType_TargetValidationDialog = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵcrt"]({ encapsulation: 0,
    styles: styles_TargetValidationDialog, data: {} });
function View_TargetValidationDialog_2(_l) {
    return __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 4, 'div', [['class',
                'subscription-info-item']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                                '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'button', [['class', 'btn-link'],
            ['style', 'float:right'], ['title', 'An Azure AD administrator from your organization might need to sign in through a specific link to grant permissions for BreakingPoint Cloud application.'],
            ['type', 'button']], [[8, 'disabled', 0], [8, 'id', 0]], [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.onGetAdminConsentUrl(_v.parent.context.$implicit) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                                    Need Admin Consent?'])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                              ']))], null, function (_ck, _v) {
        var currVal_0 = _v.parent.context.$implicit.btnDisable;
        var currVal_1 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵinlineInterpolate"](1, 'btn-adminconsent-', _v.parent.context.index, '');
        _ck(_v, 2, 0, currVal_0, currVal_1);
    });
}
function View_TargetValidationDialog_3(_l) {
    return __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 0, 'span', [['class',
                'glyphicon glyphicon-ok cloud-ok-color']], null, null, null, null, null))], null, null);
}
function View_TargetValidationDialog_4(_l) {
    return __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 0, 'span', [['class',
                'glyphicon glyphicon-alert cloud-alert-color']], null, null, null, null, null))], null, null);
}
function View_TargetValidationDialog_5(_l) {
    return __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'span', [['class',
                'status-label']], [[8, 'id', 0]], null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['', '']))], null, function (_ck, _v) {
        var currVal_0 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵinlineInterpolate"](1, 'subscription-valid-', _v.parent.context.index, '');
        _ck(_v, 0, 0, currVal_0);
        var currVal_1 = (_v.parent.context.$implicit.valid ? 'Authorized' : 'Not Authorized');
        _ck(_v, 1, 0, currVal_1);
    });
}
function View_TargetValidationDialog_6(_l) {
    return __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'span', [['class',
                'status-label']], [[8, 'id', 0]], null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['Authorization Pending']))], null, function (_ck, _v) {
        var currVal_0 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵinlineInterpolate"](1, 'subscription-pending-', _v.parent.context.index, '');
        _ck(_v, 0, 0, currVal_0);
    });
}
function View_TargetValidationDialog_1(_l) {
    return __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 64, 'div', [['class',
                'subscription']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 31, 'div', [['class', 'subscription-info-container']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 7, 'div', [['class', 'subscription-info-item']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                                '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'span', [['class', 'subscription-info-label']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['Azure subscription ID: '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                                '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'span', [['class', 'subscription-info-value']], [[8, 'id', 0]], null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['', ''])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                            '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 7, 'div', [['class', 'subscription-info-item']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                                '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'span', [['class', 'subscription-info-label']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['Subscription name: '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                                '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'span', [['class', 'subscription-info-value']], [[8, 'id', 0]], null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['', ''])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                            '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 7, 'div', [['class', 'subscription-info-item']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                                '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'span', [['class', 'subscription-info-label']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['User ID: '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                                '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'span', [['class', 'subscription-info-value']], [[8, 'id', 0]], null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['', ''])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                            '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵand"](16777216, null, null, 1, null, View_TargetValidationDialog_2)),
        __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_common__["NgIf"], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["ViewContainerRef"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                        '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 28, 'div', [['class', 'subscription-footer']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 13, 'div', [['class', 'footer-item subscription-status']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                                '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵand"](16777216, null, null, 1, null, View_TargetValidationDialog_3)), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_common__["NgIf"], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["ViewContainerRef"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                                '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵand"](16777216, null, null, 1, null, View_TargetValidationDialog_4)),
        __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_common__["NgIf"], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["ViewContainerRef"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                                '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵand"](16777216, null, null, 1, null, View_TargetValidationDialog_5)),
        __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_common__["NgIf"], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["ViewContainerRef"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                                '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵand"](16777216, null, null, 1, null, View_TargetValidationDialog_6)),
        __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_common__["NgIf"], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["ViewContainerRef"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                            '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 4, 'div', [['class', 'footer-item']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                                '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'button', [['class', 'btn btn-link'], ['type', 'button']], [[8,
                'disabled', 0], [8, 'id', 0]], [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.onReauthorize(_v.context.$implicit) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['Re-authorize '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 4, 'div', [['class', 'footer-item']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                                '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'button', [['class', 'btn btn-link'],
            ['type', 'button']], [[8, 'disabled', 0], [8, 'id', 0]], [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.onRemoveSubscription(_v.context.$implicit) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['Remove subscription'])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                    ']))], function (_ck, _v) {
        var currVal_6 = !_v.context.$implicit.valid;
        _ck(_v, 32, 0, currVal_6);
        var currVal_7 = _v.context.$implicit.valid;
        _ck(_v, 40, 0, currVal_7);
        var currVal_8 = !_v.context.$implicit.valid;
        _ck(_v, 43, 0, currVal_8);
        var currVal_9 = !_v.context.$implicit.pending;
        _ck(_v, 46, 0, currVal_9);
        var currVal_10 = _v.context.$implicit.pending;
        _ck(_v, 49, 0, currVal_10);
    }, function (_ck, _v) {
        var currVal_0 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵinlineInterpolate"](1, 'subscription-id-', _v.context.index, '');
        _ck(_v, 9, 0, currVal_0);
        var currVal_1 = _v.context.$implicit.id;
        _ck(_v, 10, 0, currVal_1);
        var currVal_2 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵinlineInterpolate"](1, 'subscription-name-', _v.context.index, '');
        _ck(_v, 18, 0, currVal_2);
        var currVal_3 = _v.context.$implicit.name;
        _ck(_v, 19, 0, currVal_3);
        var currVal_4 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵinlineInterpolate"](1, 'subscription-userid-', _v.context.index, '');
        _ck(_v, 27, 0, currVal_4);
        var currVal_5 = _v.context.$implicit.user;
        _ck(_v, 28, 0, currVal_5);
        var currVal_11 = _v.context.$implicit.btnDisable;
        var currVal_12 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵinlineInterpolate"](1, 'btn-reauthorize-', _v.context.index, '');
        _ck(_v, 54, 0, currVal_11, currVal_12);
        var currVal_13 = _v.context.$implicit.btnDisable;
        var currVal_14 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵinlineInterpolate"](1, 'btn-remove-', _v.context.index, '');
        _ck(_v, 60, 0, currVal_13, currVal_14);
    });
}
function View_TargetValidationDialog_7(_l) {
    return __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'div', [['class',
                'last-authz-error']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['Last Authorization Error: ',
            '']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.lastAuthzError;
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_TargetValidationDialog_0(_l) {
    return __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵvid"](0, [__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵqud"](402653184, 1, { adminConsentDialog: 0 }), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 73, 'div', [['id', 'targetValidationModal']], null, null, null, null, null)), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](278528, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_common__["NgClass"], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["IterableDiffers"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["KeyValueDiffers"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["ElementRef"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["Renderer"]], { ngClass: [0, 'ngClass'] }, null), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵpod"]({ 'modal-component': 0, 'modal-component-off': 1 }),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 68, 'div', [['class', 'modal-container'], ['id', 'targetSubscriptionBox']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 4, 'div', [['class',
                'header header_border']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'legend', [['class', 'dialog-title']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['Azure Subscriptions'])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n        '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 44, 'div', [['class', 'mainbody'], ['style',
                    'min-height: 575px;']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 41, 'div', [['class', 'main-container']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'div', [['class', 'title']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['Azure Subscriptions'])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 10, 'div', [['class', 'description']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'p', [], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                        To ensure that this service is not used for malicious attacks, we require the ability to validate that the IP address you\n                        are targeting is owned by an Azure Subscription that you have access to.\n                    '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'p', [], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                        To do so, please provide the ID of the Azure subscription where this IP address is allocated. You will then be taken to the\n                        Microsoft Azure login page for authentication and for authorizing our app to sign you in, read your\n                        profile and read the list of all Public IPs allocated to that subscription.\n                    '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'p', [], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                        If at any point you decide not to allow this anymore, you may remove your Azure subscription from this page. You’ll be asked\n                        again to re-enter your Azure credentials when they expire or otherwise become invalid.\n                    '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 17, 'div', [['class', 'add-subscription-container']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'label', [['class', 'control-label form-top-padding cloud-label-style'],
            ['for', 'subscriptionInput']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['Your Azure Subscriptions:'])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 11, 'div', [['class', 'input-container']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 5, 'input', [['class', 'form-control cloud-label-style'], ['id', 'subscriptionInput'],
            ['name', 'subscriptionInput'], ['placeholder', 'Enter your Azure subscription ID'],
            ['type', 'text']], [[2, 'ng-untouched', null], [2, 'ng-touched', null],
            [2, 'ng-pristine', null], [2, 'ng-dirty', null], [2, 'ng-valid',
                null], [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null, 'ngModelChange'], [null, 'input'], [null,
                'blur'], [null, 'compositionstart'], [null, 'compositionend']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('input' === en)) {
                var pd_0 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 40)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 40).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 40)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 40)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_4 = ((_co.subscriptionId = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_5__angular_forms__["i" /* DefaultValueAccessor */], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["Renderer2"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["ElementRef"], [2, __WEBPACK_IMPORTED_MODULE_5__angular_forms__["j" /* COMPOSITION_BUFFER_MODE */]]], null, null), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵprd"](1024, null, __WEBPACK_IMPORTED_MODULE_5__angular_forms__["k" /* NG_VALUE_ACCESSOR */], function (p0_0) {
            return [p0_0];
        }, [__WEBPACK_IMPORTED_MODULE_5__angular_forms__["i" /* DefaultValueAccessor */]]), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](671744, null, 0, __WEBPACK_IMPORTED_MODULE_5__angular_forms__["l" /* NgModel */], [[8, null],
            [8, null], [8, null], [2, __WEBPACK_IMPORTED_MODULE_5__angular_forms__["k" /* NG_VALUE_ACCESSOR */]]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵprd"](2048, null, __WEBPACK_IMPORTED_MODULE_5__angular_forms__["m" /* NgControl */], null, [__WEBPACK_IMPORTED_MODULE_5__angular_forms__["l" /* NgModel */]]), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_5__angular_forms__["n" /* NgControlStatus */], [__WEBPACK_IMPORTED_MODULE_5__angular_forms__["m" /* NgControl */]], null, null), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'button', [['class', 'btn btn-success cloud-btn-style-no-block'], ['id', 'btn-add-subscription']], [[8, 'disabled', 0]], [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.onAddSubscription() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['ADD SUBSCRIPTION'])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 4, 'div', [], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵand"](16777216, null, null, 1, null, View_TargetValidationDialog_1)), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](802816, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_common__["NgForOf"], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["ViewContainerRef"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["TemplateRef"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["IterableDiffers"]], { ngForOf: [0,
                'ngForOf'] }, null), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n        '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 13, 'div', [['class', 'footer footer_border']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵand"](16777216, null, null, 1, null, View_TargetValidationDialog_7)),
        __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_common__["NgIf"], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["ViewContainerRef"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 7, 'div', [['class', 'ok-cancel-buttons']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 4, 'button', [['class', 'close-button'], ['id', 'closeButton']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.onCloseClicked($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                    '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'span', [], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['Close'])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n'])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n'])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'dialog-admin-consent', [], null, null, null, __WEBPACK_IMPORTED_MODULE_6__admin_consent_dialog_component_ngfactory__["a" /* View_AdminConsentDialog_0 */], __WEBPACK_IMPORTED_MODULE_6__admin_consent_dialog_component_ngfactory__["b" /* RenderType_AdminConsentDialog */])),
        __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](114688, [[1, 4], ['adminConsent', 4]], 0, __WEBPACK_IMPORTED_MODULE_7__src_app_main_target_validation_admin_consent_dialog_component__["b" /* AdminConsentDialog */], [__WEBPACK_IMPORTED_MODULE_3__angular_common__["Location"]], null, null)], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _ck(_v, 3, 0, _co.isOn, !_co.isOn);
        _ck(_v, 2, 0, currVal_0);
        var currVal_8 = 'subscriptionInput';
        var currVal_9 = _co.subscriptionId;
        _ck(_v, 42, 0, currVal_8, currVal_9);
        var currVal_11 = _co.subscriptions;
        _ck(_v, 54, 0, currVal_11);
        var currVal_12 = _co.lastAuthzError;
        _ck(_v, 62, 0, currVal_12);
        _ck(_v, 77, 0);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_1 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 44).ngClassUntouched;
        var currVal_2 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 44).ngClassTouched;
        var currVal_3 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 44).ngClassPristine;
        var currVal_4 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 44).ngClassDirty;
        var currVal_5 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 44).ngClassValid;
        var currVal_6 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 44).ngClassInvalid;
        var currVal_7 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 44).ngClassPending;
        _ck(_v, 39, 0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7);
        var currVal_10 = ((_co.addOperationInProgress || !_co.subscriptionId) || !_co.subscriptionId.length);
        _ck(_v, 46, 0, currVal_10);
    });
}
function View_TargetValidationDialog_Host_0(_l) {
    return __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'dialog-target-validation', [], null, null, null, View_TargetValidationDialog_0, RenderType_TargetValidationDialog)), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](114688, null, 0, __WEBPACK_IMPORTED_MODULE_4__src_app_main_target_validation_target_validation_dialog_component__["b" /* TargetValidationDialog */], [__WEBPACK_IMPORTED_MODULE_8__src_app_main_target_validation_target_validation_service__["a" /* TargetValidationService */], __WEBPACK_IMPORTED_MODULE_3__angular_common__["Location"]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var TargetValidationDialogNgFactory = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵccf"]('dialog-target-validation', __WEBPACK_IMPORTED_MODULE_4__src_app_main_target_validation_target_validation_dialog_component__["b" /* TargetValidationDialog */], View_TargetValidationDialog_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3NyYy91aS9zcmMvYXBwL21haW4vdGFyZ2V0LXZhbGlkYXRpb24vdGFyZ2V0LXZhbGlkYXRpb24tZGlhbG9nLmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9zcmMvdWkvc3JjL2FwcC9tYWluL3RhcmdldC12YWxpZGF0aW9uL3RhcmdldC12YWxpZGF0aW9uLWRpYWxvZy5jb21wb25lbnQudHMiLCJuZzovLy9zcmMvdWkvc3JjL2FwcC9tYWluL3RhcmdldC12YWxpZGF0aW9uL3RhcmdldC12YWxpZGF0aW9uLWRpYWxvZy5jb21wb25lbnQuaHRtbCIsIm5nOi8vL3NyYy91aS9zcmMvYXBwL21haW4vdGFyZ2V0LXZhbGlkYXRpb24vdGFyZ2V0LXZhbGlkYXRpb24tZGlhbG9nLmNvbXBvbmVudC50cy5UYXJnZXRWYWxpZGF0aW9uRGlhbG9nX0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPGRpdiBpZD1cInRhcmdldFZhbGlkYXRpb25Nb2RhbFwiIFtuZ0NsYXNzXT1cInsnbW9kYWwtY29tcG9uZW50Jzppc09uLCAnbW9kYWwtY29tcG9uZW50LW9mZic6IWlzT259XCI+XG4gICAgPGRpdiBpZD1cInRhcmdldFN1YnNjcmlwdGlvbkJveFwiIGNsYXNzPVwibW9kYWwtY29udGFpbmVyXCI+XG4gICAgICAgIDxkaXYgY2xhc3M9XCJoZWFkZXIgaGVhZGVyX2JvcmRlclwiPlxuICAgICAgICAgICAgPGxlZ2VuZCBjbGFzcz1cImRpYWxvZy10aXRsZVwiPkF6dXJlIFN1YnNjcmlwdGlvbnM8L2xlZ2VuZD5cbiAgICAgICAgPC9kaXY+XG4gICAgICAgIDxkaXYgY2xhc3M9XCJtYWluYm9keVwiIHN0eWxlPVwibWluLWhlaWdodDogNTc1cHg7XCI+XG4gICAgICAgICAgICA8ZGl2IGNsYXNzPVwibWFpbi1jb250YWluZXJcIj5cbiAgICAgICAgICAgICAgICA8ZGl2IGNsYXNzPXRpdGxlPkF6dXJlIFN1YnNjcmlwdGlvbnM8L2Rpdj5cbiAgICAgICAgICAgICAgICA8ZGl2IGNsYXNzPVwiZGVzY3JpcHRpb25cIj5cbiAgICAgICAgICAgICAgICAgICAgPHA+XG4gICAgICAgICAgICAgICAgICAgICAgICBUbyBlbnN1cmUgdGhhdCB0aGlzIHNlcnZpY2UgaXMgbm90IHVzZWQgZm9yIG1hbGljaW91cyBhdHRhY2tzLCB3ZSByZXF1aXJlIHRoZSBhYmlsaXR5IHRvIHZhbGlkYXRlIHRoYXQgdGhlIElQIGFkZHJlc3MgeW91XG4gICAgICAgICAgICAgICAgICAgICAgICBhcmUgdGFyZ2V0aW5nIGlzIG93bmVkIGJ5IGFuIEF6dXJlIFN1YnNjcmlwdGlvbiB0aGF0IHlvdSBoYXZlIGFjY2VzcyB0by5cbiAgICAgICAgICAgICAgICAgICAgPC9wPlxuICAgICAgICAgICAgICAgICAgICA8cD5cbiAgICAgICAgICAgICAgICAgICAgICAgIFRvIGRvIHNvLCBwbGVhc2UgcHJvdmlkZSB0aGUgSUQgb2YgdGhlIEF6dXJlIHN1YnNjcmlwdGlvbiB3aGVyZSB0aGlzIElQIGFkZHJlc3MgaXMgYWxsb2NhdGVkLiBZb3Ugd2lsbCB0aGVuIGJlIHRha2VuIHRvIHRoZVxuICAgICAgICAgICAgICAgICAgICAgICAgTWljcm9zb2Z0IEF6dXJlIGxvZ2luIHBhZ2UgZm9yIGF1dGhlbnRpY2F0aW9uIGFuZCBmb3IgYXV0aG9yaXppbmcgb3VyIGFwcCB0byBzaWduIHlvdSBpbiwgcmVhZCB5b3VyXG4gICAgICAgICAgICAgICAgICAgICAgICBwcm9maWxlIGFuZCByZWFkIHRoZSBsaXN0IG9mIGFsbCBQdWJsaWMgSVBzIGFsbG9jYXRlZCB0byB0aGF0IHN1YnNjcmlwdGlvbi5cbiAgICAgICAgICAgICAgICAgICAgPC9wPlxuICAgICAgICAgICAgICAgICAgICA8cD5cbiAgICAgICAgICAgICAgICAgICAgICAgIElmIGF0IGFueSBwb2ludCB5b3UgZGVjaWRlIG5vdCB0byBhbGxvdyB0aGlzIGFueW1vcmUsIHlvdSBtYXkgcmVtb3ZlIHlvdXIgQXp1cmUgc3Vic2NyaXB0aW9uIGZyb20gdGhpcyBwYWdlLiBZb3XigJlsbCBiZSBhc2tlZFxuICAgICAgICAgICAgICAgICAgICAgICAgYWdhaW4gdG8gcmUtZW50ZXIgeW91ciBBenVyZSBjcmVkZW50aWFscyB3aGVuIHRoZXkgZXhwaXJlIG9yIG90aGVyd2lzZSBiZWNvbWUgaW52YWxpZC5cbiAgICAgICAgICAgICAgICAgICAgPC9wPlxuICAgICAgICAgICAgICAgIDwvZGl2PlxuICAgICAgICAgICAgICAgIDxkaXYgY2xhc3M9XCJhZGQtc3Vic2NyaXB0aW9uLWNvbnRhaW5lclwiPlxuICAgICAgICAgICAgICAgICAgICA8bGFiZWwgZm9yPVwic3Vic2NyaXB0aW9uSW5wdXRcIiBjbGFzcz1cImNvbnRyb2wtbGFiZWwgZm9ybS10b3AtcGFkZGluZyBjbG91ZC1sYWJlbC1zdHlsZVwiPllvdXIgQXp1cmUgU3Vic2NyaXB0aW9uczo8L2xhYmVsPlxuICAgICAgICAgICAgICAgICAgICA8ZGl2IGNsYXNzPVwiaW5wdXQtY29udGFpbmVyXCI+XG4gICAgICAgICAgICAgICAgICAgICAgICA8aW5wdXQgbmFtZT1cInN1YnNjcmlwdGlvbklucHV0XCIgWyhuZ01vZGVsKV09XCJzdWJzY3JpcHRpb25JZFwiIHR5cGU9XCJ0ZXh0XCIgY2xhc3M9XCJmb3JtLWNvbnRyb2wgY2xvdWQtbGFiZWwtc3R5bGVcIiBpZD1cInN1YnNjcmlwdGlvbklucHV0XCJcbiAgICAgICAgICAgICAgICAgICAgICAgICAgICBwbGFjZWhvbGRlcj1cIkVudGVyIHlvdXIgQXp1cmUgc3Vic2NyaXB0aW9uIElEXCIgLz5cbiAgICAgICAgICAgICAgICAgICAgICAgIDxidXR0b24gY2xhc3M9XCJidG4gYnRuLXN1Y2Nlc3MgY2xvdWQtYnRuLXN0eWxlLW5vLWJsb2NrXCIgaWQ9XCJidG4tYWRkLXN1YnNjcmlwdGlvblwiIChjbGljayk9XCJvbkFkZFN1YnNjcmlwdGlvbigpXCIgW2Rpc2FibGVkXT1cImFkZE9wZXJhdGlvbkluUHJvZ3Jlc3MgfHwgIXN1YnNjcmlwdGlvbklkIHx8ICFzdWJzY3JpcHRpb25JZC5sZW5ndGhcIj5BREQgU1VCU0NSSVBUSU9OPC9idXR0b24+XG4gICAgICAgICAgICAgICAgICAgIDwvZGl2PlxuICAgICAgICAgICAgICAgIDwvZGl2PlxuICAgICAgICAgICAgICAgIDxkaXY+XG4gICAgICAgICAgICAgICAgICAgIDxkaXYgKm5nRm9yPVwibGV0IHN1YnNjcmlwdGlvbiBvZiBzdWJzY3JpcHRpb25zOyBsZXQgaSA9IGluZGV4XCIgY2xhc3M9XCJzdWJzY3JpcHRpb25cIj5cbiAgICAgICAgICAgICAgICAgICAgICAgIDxkaXYgY2xhc3M9XCJzdWJzY3JpcHRpb24taW5mby1jb250YWluZXJcIj5cbiAgICAgICAgICAgICAgICAgICAgICAgICAgICA8ZGl2IGNsYXNzPVwic3Vic2NyaXB0aW9uLWluZm8taXRlbVwiPlxuICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICA8c3BhbiBjbGFzcz1cInN1YnNjcmlwdGlvbi1pbmZvLWxhYmVsXCI+QXp1cmUgc3Vic2NyaXB0aW9uIElEOiA8L3NwYW4+XG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIDxzcGFuIGlkPVwic3Vic2NyaXB0aW9uLWlkLXt7aX19XCIgY2xhc3M9XCJzdWJzY3JpcHRpb24taW5mby12YWx1ZVwiPnt7c3Vic2NyaXB0aW9uLmlkfX08L3NwYW4+XG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgPC9kaXY+XG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgPGRpdiBjbGFzcz1cInN1YnNjcmlwdGlvbi1pbmZvLWl0ZW1cIj5cbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgPHNwYW4gY2xhc3M9XCJzdWJzY3JpcHRpb24taW5mby1sYWJlbFwiPlN1YnNjcmlwdGlvbiBuYW1lOiA8L3NwYW4+XG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIDxzcGFuIGlkPVwic3Vic2NyaXB0aW9uLW5hbWUte3tpfX1cIiBjbGFzcz1cInN1YnNjcmlwdGlvbi1pbmZvLXZhbHVlXCI+e3tzdWJzY3JpcHRpb24ubmFtZX19PC9zcGFuPlxuICAgICAgICAgICAgICAgICAgICAgICAgICAgIDwvZGl2PlxuICAgICAgICAgICAgICAgICAgICAgICAgICAgIDxkaXYgY2xhc3M9XCJzdWJzY3JpcHRpb24taW5mby1pdGVtXCI+XG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIDxzcGFuIGNsYXNzPVwic3Vic2NyaXB0aW9uLWluZm8tbGFiZWxcIj5Vc2VyIElEOiA8L3NwYW4+XG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIDxzcGFuIGlkPVwic3Vic2NyaXB0aW9uLXVzZXJpZC17e2l9fVwiIGNsYXNzPVwic3Vic2NyaXB0aW9uLWluZm8tdmFsdWVcIj57e3N1YnNjcmlwdGlvbi51c2VyfX08L3NwYW4+XG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgPC9kaXY+XG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgPGRpdiBjbGFzcz1cInN1YnNjcmlwdGlvbi1pbmZvLWl0ZW1cIiAqbmdJZj1cIiFzdWJzY3JpcHRpb24udmFsaWRcIj5cbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgPGJ1dHRvbiBbZGlzYWJsZWRdPVwic3Vic2NyaXB0aW9uLmJ0bkRpc2FibGVcIiBpZD1cImJ0bi1hZG1pbmNvbnNlbnQte3tpfX1cIlxuICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIHN0eWxlPVwiZmxvYXQ6cmlnaHRcIlxuICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIHR5cGU9XCJidXR0b25cIlxuICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIGNsYXNzPVwiYnRuLWxpbmtcIiAoY2xpY2spPVwib25HZXRBZG1pbkNvbnNlbnRVcmwoc3Vic2NyaXB0aW9uKVwiXG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgdGl0bGU9XCJBbiBBenVyZSBBRCBhZG1pbmlzdHJhdG9yIGZyb20geW91ciBvcmdhbml6YXRpb24gbWlnaHQgbmVlZCB0byBzaWduIGluIHRocm91Z2ggYSBzcGVjaWZpYyBsaW5rIHRvIGdyYW50IHBlcm1pc3Npb25zIGZvciBCcmVha2luZ1BvaW50IENsb3VkIGFwcGxpY2F0aW9uLlwiPlxuICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgTmVlZCBBZG1pbiBDb25zZW50PzwvYnV0dG9uPlxuICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgPC9kaXY+XG4gICAgICAgICAgICAgICAgICAgICAgICA8L2Rpdj5cbiAgICAgICAgICAgICAgICAgICAgICAgIDxkaXYgY2xhc3M9XCJzdWJzY3JpcHRpb24tZm9vdGVyXCI+XG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgPGRpdiBjbGFzcz1cImZvb3Rlci1pdGVtIHN1YnNjcmlwdGlvbi1zdGF0dXNcIj5cbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgPHNwYW4gY2xhc3M9XCJnbHlwaGljb24gZ2x5cGhpY29uLW9rIGNsb3VkLW9rLWNvbG9yXCIgKm5nSWY9XCJzdWJzY3JpcHRpb24udmFsaWRcIj48L3NwYW4+XG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIDxzcGFuIGNsYXNzPVwiZ2x5cGhpY29uIGdseXBoaWNvbi1hbGVydCBjbG91ZC1hbGVydC1jb2xvclwiICpuZ0lmPVwiIXN1YnNjcmlwdGlvbi52YWxpZFwiPjwvc3Bhbj5cbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgPHNwYW4gKm5nSWY9XCIhc3Vic2NyaXB0aW9uLnBlbmRpbmdcIiBpZD1cInN1YnNjcmlwdGlvbi12YWxpZC17e2l9fVwiIGNsYXNzPVwic3RhdHVzLWxhYmVsXCI+e3tzdWJzY3JpcHRpb24udmFsaWQgPyBcIkF1dGhvcml6ZWRcIiA6IFwiTm90IEF1dGhvcml6ZWRcIn19PC9zcGFuPlxuICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICA8c3BhbiAqbmdJZj1cInN1YnNjcmlwdGlvbi5wZW5kaW5nXCIgaWQ9XCJzdWJzY3JpcHRpb24tcGVuZGluZy17e2l9fVwiIGNsYXNzPVwic3RhdHVzLWxhYmVsXCI+QXV0aG9yaXphdGlvbiBQZW5kaW5nPC9zcGFuPlxuICAgICAgICAgICAgICAgICAgICAgICAgICAgIDwvZGl2PlxuICAgICAgICAgICAgICAgICAgICAgICAgICAgIDxkaXYgY2xhc3M9XCJmb290ZXItaXRlbVwiPlxuICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICA8YnV0dG9uICBbZGlzYWJsZWRdPVwic3Vic2NyaXB0aW9uLmJ0bkRpc2FibGVcIiBpZD1cImJ0bi1yZWF1dGhvcml6ZS17e2l9fVwiIHR5cGU9XCJidXR0b25cIiBjbGFzcz1cImJ0biBidG4tbGlua1wiIChjbGljayk9XCJvblJlYXV0aG9yaXplKHN1YnNjcmlwdGlvbilcIj5SZS1hdXRob3JpemUgPC9idXR0b24+XG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgPC9kaXY+XG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgPGRpdiBjbGFzcz1cImZvb3Rlci1pdGVtXCI+XG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIDxidXR0b24gW2Rpc2FibGVkXT1cInN1YnNjcmlwdGlvbi5idG5EaXNhYmxlXCIgaWQ9XCJidG4tcmVtb3ZlLXt7aX19XCIgdHlwZT1cImJ1dHRvblwiIGNsYXNzPVwiYnRuIGJ0bi1saW5rXCIgKGNsaWNrKT1cIm9uUmVtb3ZlU3Vic2NyaXB0aW9uKHN1YnNjcmlwdGlvbilcIj5SZW1vdmUgc3Vic2NyaXB0aW9uPC9idXR0b24+XG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgPC9kaXY+XG4gICAgICAgICAgICAgICAgICAgICAgICA8L2Rpdj5cbiAgICAgICAgICAgICAgICAgICAgPC9kaXY+XG4gICAgICAgICAgICAgICAgPC9kaXY+XG4gICAgICAgICAgICA8L2Rpdj5cbiAgICAgICAgPC9kaXY+XG4gICAgICAgIDxkaXYgY2xhc3M9XCJmb290ZXIgZm9vdGVyX2JvcmRlclwiPlxuICAgICAgICAgICAgPGRpdiAqbmdJZj1cImxhc3RBdXRoekVycm9yXCIgY2xhc3M9XCJsYXN0LWF1dGh6LWVycm9yXCI+TGFzdCBBdXRob3JpemF0aW9uIEVycm9yOiB7e2xhc3RBdXRoekVycm9yfX08L2Rpdj5cbiAgICAgICAgICAgIDxkaXYgY2xhc3M9XCJvay1jYW5jZWwtYnV0dG9uc1wiPlxuICAgICAgICAgICAgICAgIDxidXR0b24gaWQ9XCJjbG9zZUJ1dHRvblwiIGNsYXNzPVwiY2xvc2UtYnV0dG9uXCIgKGNsaWNrKT1cIm9uQ2xvc2VDbGlja2VkKCRldmVudClcIj5cbiAgICAgICAgICAgICAgICAgICAgPHNwYW4+Q2xvc2U8L3NwYW4+XG4gICAgICAgICAgICAgICAgPC9idXR0b24+XG4gICAgICAgICAgICA8L2Rpdj5cbiAgICAgICAgPC9kaXY+XG4gICAgPC9kaXY+XG48L2Rpdj5cbjxkaWFsb2ctYWRtaW4tY29uc2VudCAjYWRtaW5Db25zZW50PjwvZGlhbG9nLWFkbWluLWNvbnNlbnQ+IiwiPGRpYWxvZy10YXJnZXQtdmFsaWRhdGlvbj48L2RpYWxvZy10YXJnZXQtdmFsaWRhdGlvbj4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7b0JDOEM0QjtNQUFBO01BQUEsZ0JBQWdFO01BQzVEO1VBQUE7VUFBQTtVQUFBO1lBQUE7WUFBQTtZQUdtQjtjQUFBO2NBQUE7WUFBQTtZQUhuQjtVQUFBLGdDQUltSztNQUNuSTs7UUFMeEI7UUFBcUM7WUFBQTtRQUE3QyxXQUFRLFVBQXFDLFNBQTdDOzs7O29CQVVBO01BQUE7TUFBQTs7O29CQUNBO01BQUE7TUFBQTs7O29CQUNBO01BQUE7TUFBdUY7SUFBbkQ7UUFBQTtJQUFwQyxXQUFvQyxTQUFwQztJQUF1RjtJQUFBOzs7O29CQUN2RjtNQUFBO01BQXdGOztJQUFyRDtRQUFBO0lBQW5DLFdBQW1DLFNBQW5DOzs7O29CQTVCWjtNQUFBO01BQW9GLCtEQUNoRjtVQUFBO1VBQUE7TUFBeUMsbUVBQ3JDO1VBQUE7VUFBQTtNQUFvQyx1RUFDaEM7aUJBQUE7Y0FBQTtNQUFzQyw0REFBOEI7VUFBQSx5Q0FDcEU7VUFBQTtVQUFBLDBEQUFpRTtVQUFBLFVBQTBCO01BQ3pGLG1FQUNOO1VBQUE7VUFBQTtNQUFvQyx1RUFDaEM7aUJBQUE7Y0FBQTtNQUFzQyx3REFBMEI7VUFBQSx5Q0FDaEU7VUFBQTtVQUFBLDBEQUFtRTtVQUFBLFVBQTRCO01BQzdGLG1FQUNOO1VBQUE7VUFBQTtNQUFvQyx1RUFDaEM7aUJBQUE7Y0FBQTtNQUFzQyw4Q0FBZ0I7VUFBQSx5Q0FDdEQ7VUFBQTtVQUFBLDBEQUFxRTtVQUFBLFVBQTRCO01BQy9GLG1FQUNOO1VBQUE7YUFBQTtVQUFBLHdCQU9RO01BQ04sK0RBQ047VUFBQTtVQUFBLDBEQUFpQztVQUFBLHFDQUM3QjtVQUFBO1VBQUEsNENBQTZDO1VBQUEseUNBQ3pDO1VBQUEscUVBQUE7VUFBQTtVQUFBLGVBQXNGO01BQ3RGO2FBQUE7VUFBQSx3QkFBNkY7TUFDN0Y7YUFBQTtVQUFBLHdCQUFzSjtNQUN0SjthQUFBO1VBQUEsd0JBQW9IO01BQ2xILG1FQUNOO1VBQUE7VUFBQSwwREFBeUI7VUFBQSx5Q0FDckI7VUFBQTtjQUFBO1lBQUE7WUFBQTtZQUE0RztjQUFBO2NBQUE7WUFBQTtZQUE1RztVQUFBLGdDQUFrSjtNQUFzQixtRUFDdEs7VUFBQSxxQ0FDTjtVQUFBO1VBQUEsOEJBQXlCO01BQ3JCO1VBQUE7VUFBQTtZQUFBO1lBQUE7WUFBc0c7Y0FBQTtjQUFBO1lBQUE7WUFBdEc7VUFBQSxnQ0FBbUo7TUFBNEIsbUVBQzdLO1VBQUEsaUNBQ0o7O1FBdEJrQztRQUFwQyxZQUFvQyxTQUFwQztRQVd3RDtRQUFwRCxZQUFvRCxTQUFwRDtRQUMwRDtRQUExRCxZQUEwRCxTQUExRDtRQUNNO1FBQU4sWUFBTSxTQUFOO1FBQ007UUFBTixZQUFNLFVBQU47O1FBeEJNO1lBQUE7UUFBTixXQUFNLFNBQU47UUFBaUU7UUFBQTtRQUkzRDtZQUFBO1FBQU4sWUFBTSxTQUFOO1FBQW1FO1FBQUE7UUFJN0Q7WUFBQTtRQUFOLFlBQU0sU0FBTjtRQUFxRTtRQUFBO1FBbUI1RDtRQUFxQztZQUFBO1FBQTlDLFlBQVMsV0FBcUMsVUFBOUM7UUFHUTtRQUFxQztZQUFBO1FBQTdDLFlBQVEsV0FBcUMsVUFBN0M7Ozs7b0JBUXBCO01BQUE7TUFBQSxnQkFBcUQ7TUFBQTs7SUFBQTtJQUFBOzs7O2dFQTFFakU7TUFBQTtNQUFBLGlFQUFBO01BQUE7TUFBQSw4Q0FBZ0M7TUFBa0UsMkNBQzlGO1VBQUE7VUFBQSwwREFBd0Q7VUFBQSxpQkFDcEQ7VUFBQTtVQUFBLGdCQUFrQyxtREFDOUI7aUJBQUE7Y0FBQTtNQUE2Qix3REFBNEI7VUFBQSxpQkFDdkQsK0NBQ047aUJBQUE7Y0FBQTtjQUFBLGdCQUFpRCxtREFDN0M7aUJBQUE7Y0FBQTtNQUE0Qix1REFDeEI7VUFBQTtVQUFBLDhCQUFpQjtNQUF5Qix1REFDMUM7VUFBQTtVQUFBLDRDQUF5QjtVQUFBLDZCQUNyQjtVQUFBO1VBQUEsZ0JBQUc7TUFHQywyREFDSjtVQUFBO1VBQUEsNENBQUc7VUFBQTtNQUlDLDJEQUNKO1VBQUE7VUFBQSw0Q0FBRztVQUFBO01BR0MsdURBQ0Y7VUFBQSx5QkFDTjtVQUFBO1VBQUEsNENBQXdDO1VBQUEsNkJBQ3BDO1VBQUE7Y0FBQTtVQUFBLDhCQUF3RjtNQUFpQywyREFDekg7VUFBQTtVQUFBLDBEQUE2QjtVQUFBLGlDQUN6QjtVQUFBO2NBQUE7Y0FBQTtjQUFBO2tCQUFBO1VBQUE7Y0FBQTtVQUFBO1lBQUE7WUFBQTtZQUFBO2NBQUE7Y0FBQTtZQUFBO1lBQUE7Y0FBQTtjQUFBO1lBQUE7WUFBQTtjQUFBO2NBQUE7WUFBQTtZQUFBO2NBQUE7Y0FBQTtZQUFBO1lBQWdDO2NBQUE7Y0FBQTtZQUFBO1lBQWhDO1VBQUEsdUNBQUE7VUFBQTtVQUFBLHNCQUFBO1FBQUE7TUFBQSxvQ0FBQTtVQUFBO1VBQUEsb0RBQUE7dUJBQUEsbUNBQUE7VUFBQSw0Q0FDcUQ7VUFBQSxpQ0FDckQ7VUFBQTtVQUFBO1lBQUE7WUFBQTtZQUFtRjtjQUFBO2NBQUE7WUFBQTtZQUFuRjtVQUFBLGdDQUFrTTtNQUF5QiwyREFDek47VUFBQSx5QkFDSjtNQUNOO1VBQUEsMERBQUs7VUFBQSw2QkFDRDtVQUFBLHVEQUFBO1VBQUE7Y0FBQSwyQkFxQ007TUFDSixtREFDSjtVQUFBLGlCQUNKLCtDQUNOO2lCQUFBO2NBQUE7TUFBa0MsbURBQzlCO1VBQUE7YUFBQTtVQUFBLHdCQUF1RztNQUN2RztVQUFBO01BQStCLHVEQUMzQjtVQUFBO1VBQUE7WUFBQTtZQUFBO1lBQThDO2NBQUE7Y0FBQTtZQUFBO1lBQTlDO1VBQUEsZ0NBQStFO01BQzNFO1VBQUEsMERBQU07VUFBQSxZQUFZLHVEQUNiO2lCQUFBLG9DQUNQO1VBQUEsaUJBQ0osMkNBQ0o7VUFBQSxTQUNKLHVDQUNOO1VBQUE7VUFBQTthQUFBO1VBQUE7O0lBbkZnQztJQUFoQyxXQUFnQyxTQUFoQztJQTBCK0I7SUFBeUI7SUFBaEMsWUFBTyxVQUF5QixTQUFoQztJQU1DO0lBQUwsWUFBSyxVQUFMO0lBMENIO0lBQUwsWUFBSyxVQUFMO0lBU1o7OztJQXpEd0I7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQSxZQUFBLHFFQUFBO0lBRWlIO0lBQWpILFlBQWlILFVBQWpIOzs7O29CQzVCeEI7TUFBQTt1Q0FBQSxVQUFBO01BQUE7O0lBQUE7Ozs7In0=
//# sourceMappingURL=target-validation-dialog.component.ngfactory.js.map

/***/ }),
/* 554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RenderType_AboutDialogComponent */
/* unused harmony export View_AboutDialogComponent_0 */
/* unused harmony export View_AboutDialogComponent_Host_0 */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AboutDialogComponentNgFactory; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__about_dialog_component_scss_shim_ngstyle__ = __webpack_require__(555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_bootstrap_dist_css_bootstrap_css_shim_ngstyle__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_core__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__angular_common__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_app_modals_about_about_dialog_component__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_app_aws_environment__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_app_systeminformation_systeminformation_service__ = __webpack_require__(46);
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */







var styles_AboutDialogComponent = [__WEBPACK_IMPORTED_MODULE_0__about_dialog_component_scss_shim_ngstyle__["a" /* styles */], __WEBPACK_IMPORTED_MODULE_1__node_modules_bootstrap_dist_css_bootstrap_css_shim_ngstyle__["a" /* styles */]];
var RenderType_AboutDialogComponent = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵcrt"]({ encapsulation: 0,
    styles: styles_AboutDialogComponent, data: {} });
function View_AboutDialogComponent_0(_l) {
    return __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 123, 'div', [['id',
                'aboutModal']], null, null, null, null, null)),
        __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](278528, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_common__["NgClass"], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["IterableDiffers"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["KeyValueDiffers"],
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ElementRef"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["Renderer"]], { ngClass: [0, 'ngClass'] }, null), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵpod"]({ 'modal-component': 0,
            'modal-component-off': 1 }), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n    '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 118, 'div', [['class', 'modal-container']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 4, 'div', [['class', 'header header_border']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'legend', [['class', 'dialog-title']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['About'])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n        '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 97, 'div', [['class', 'mainbody'], ['style',
                    'min-height: 190px;']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 94, 'div', [['class', 'main-container']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 88, 'div', [['class', 'description']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                  '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 10, 'div', [['class', 'row about-row']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                        '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'div', [['class', 'col-sm-7 about-label']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                          Deployment Version\n                        '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 4, 'div', [['class', 'col-sm-4'], ['id', 'about-deployment-version']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                          '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'b', [], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['', ''])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                        '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n\n                    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 10, 'div', [['class', 'row about-row']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                          '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'div', [['class', 'col-sm-7 about-label']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                            Deployment Region\n                          '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                          '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 4, 'div', [['class', 'col-sm-4 about-value'], ['id',
                'about-aws-deployment-region']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                            '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'b', [], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['', ''])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                          '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n\n                    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 10, 'div', [['class', 'row about-row']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                          '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'div', [['class', 'col-sm-7 about-label']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                            Azure Deployment Version\n                          '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                          '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 4, 'div', [['class', 'col-sm-4 about-value'], ['id',
                'about-azure-deployment-region']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                            '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'b', [], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['', ''])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                          '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n\n                    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 10, 'div', [['class', 'row about-row']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                          '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'div', [['class', 'col-sm-7 about-label']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                            Azure Deployment Region\n                          '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                          '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 4, 'div', [['class', 'col-sm-4 about-value'], ['id',
                'about-azure-deployment-region']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                            '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'b', [], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['', ''])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                          '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n\n                    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 10, 'div', [['class', 'row about-row']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                        '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'div', [['class', 'col-sm-7 about-label']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                            Source IP Container Version\n                        '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 4, 'div', [['class', 'col-sm-4 about-value'], ['id',
                'about-bot-container-version']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                            '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'b', [], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['', ''])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                        '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 7, 'div', [['class', 'row about-row']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                        '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 4, 'div', [['class', 'col-sm-7 about-label']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'a', [['href', '/release-notes'], ['target', '_blank']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['Release Notes'])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                    '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 7, 'div', [['class', 'row about-row']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 4, 'div', [['class', 'col-sm-7 about-label']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                            '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'a', [['href', '/assets/3rdparties.html'],
            ['target', '_blank']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['Third-Party Components'])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                    '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 7, 'div', [['class', 'row about-row']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 4, 'div', [['class', 'col-sm-7 about-label']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'a', [['href', 'mailto:bpcloud@keysight.com?subject=BreakingPoint%20Cloud%20DDoS%20Feedback']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['Contact Us'])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                    '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'div', [], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n        '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 10, 'div', [['class', 'footer footer_border']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 7, 'div', [['class', 'ok-cancel-buttons']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 4, 'button', [['class', 'close-button'], ['id', 'aboutCloseButton']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.onCloseClicked($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                    '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'span', [], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['Close'])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n'])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _ck(_v, 2, 0, _co.isOn, !_co.isOn);
        _ck(_v, 1, 0, currVal_0);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_1 = _co.deploymentVersion;
        _ck(_v, 26, 0, currVal_1);
        var currVal_2 = _co.awsDeploymentRegion;
        _ck(_v, 38, 0, currVal_2);
        var currVal_3 = _co.azureDeploymentVersion;
        _ck(_v, 50, 0, currVal_3);
        var currVal_4 = _co.azureDeploymentRegion;
        _ck(_v, 62, 0, currVal_4);
        var currVal_5 = _co.botContainerVersion;
        _ck(_v, 74, 0, currVal_5);
    });
}
function View_AboutDialogComponent_Host_0(_l) {
    return __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'about-dialog', [], null, null, null, View_AboutDialogComponent_0, RenderType_AboutDialogComponent)), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](114688, null, 0, __WEBPACK_IMPORTED_MODULE_4__src_app_modals_about_about_dialog_component__["a" /* AboutDialogComponent */], [__WEBPACK_IMPORTED_MODULE_5__src_app_aws_environment__["a" /* AwsEnvironment */], __WEBPACK_IMPORTED_MODULE_6__src_app_systeminformation_systeminformation_service__["a" /* SystemInformationService */]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var AboutDialogComponentNgFactory = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵccf"]('about-dialog', __WEBPACK_IMPORTED_MODULE_4__src_app_modals_about_about_dialog_component__["a" /* AboutDialogComponent */], View_AboutDialogComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=about-dialog.component.ngfactory.js.map

/***/ }),
/* 555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return styles; });
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */
var styles = ['.modal-container[_ngcontent-%COMP%] {\n  min-width: 450px; }\n\n.header[_ngcontent-%COMP%]   legend[_ngcontent-%COMP%] {\n  margin-bottom: 0; }\n\n.mainbody[_ngcontent-%COMP%] {\n  max-height: 640px;\n  overflow-y: auto; }\n\n.main-container[_ngcontent-%COMP%] {\n  margin: 40px; }\n\n.dialog-title[_ngcontent-%COMP%] {\n  padding-left: 20px;\n  padding-top: 10px;\n  font-weight: 800;\n  color: #5A5A64;\n  font-family: open_sans;\n  font-weight: bold;\n  font-size: 13px; }\n\n.close-button[_ngcontent-%COMP%] {\n  height: 20px;\n  width: 55px;\n  color: #5a5a64;\n  background-color: #FAFAFA;\n  background: -webkit-gradient(linear, 0% 0%, 0% 100%, from(#ffffff), to(#F1F1F1));\n  background: -webkit-linear-gradient(0% 0%, 0% 100%, from(#ffffff), to(#F1F1F1));\n  background: -moz-linear-gradient(center top, #ffffff, #F1F1F1);\n  border: 1px solid #bababa;\n  font-family: open_sans;\n  font-weight: bold;\n  font-size: 10px;\n  text-align: center;\n  cursor: pointer;\n  margin-right: 20px; }\n\n.description[_ngcontent-%COMP%] {\n  text-align: justify;\n  font-size: 14px; }\n\n.about-label[_ngcontent-%COMP%] {\n  text-align: right; }\n\n.about-value[_ngcontent-%COMP%] {\n  text-align: left; }\n\n.about-row[_ngcontent-%COMP%] {\n  margin-bottom: 10px; }'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3NyYy91aS9zcmMvYXBwL21vZGFscy9hYm91dC9hYm91dC1kaWFsb2cuY29tcG9uZW50LnNjc3Muc2hpbS5uZ3N0eWxlLnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vc3JjL3VpL3NyYy9hcHAvbW9kYWxzL2Fib3V0L2Fib3V0LWRpYWxvZy5jb21wb25lbnQuc2NzcyJdLCJzb3VyY2VzQ29udGVudCI6WyIgIl0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7In0=
//# sourceMappingURL=about-dialog.component.scss.shim.ngstyle.js.map

/***/ }),
/* 556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RenderType_BillingDialog */
/* unused harmony export View_BillingDialog_0 */
/* unused harmony export View_BillingDialog_Host_0 */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BillingDialogNgFactory; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_bootstrap_dist_css_bootstrap_css_shim_ngstyle__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__billing_dialog_component_scss_shim_ngstyle__ = __webpack_require__(557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_core__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__progress_progress_box_component_ngfactory__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_app_progress_progress_box_component__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__angular_forms__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__angular_common__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_app_modals_billing_billing_dialog_component__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_app_billing_billing_service__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_app_user_user_service__ = __webpack_require__(12);
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */










var styles_BillingDialog = [__WEBPACK_IMPORTED_MODULE_0__node_modules_bootstrap_dist_css_bootstrap_css_shim_ngstyle__["a" /* styles */], __WEBPACK_IMPORTED_MODULE_1__billing_dialog_component_scss_shim_ngstyle__["a" /* styles */]];
var RenderType_BillingDialog = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵcrt"]({ encapsulation: 0,
    styles: styles_BillingDialog, data: {} });
function View_BillingDialog_1(_l) {
    return __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'progress-box', [], null, null, null, __WEBPACK_IMPORTED_MODULE_3__progress_progress_box_component_ngfactory__["a" /* View_ProgressBoxComponent_0 */], __WEBPACK_IMPORTED_MODULE_3__progress_progress_box_component_ngfactory__["b" /* RenderType_ProgressBoxComponent */])), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](114688, null, 0, __WEBPACK_IMPORTED_MODULE_4__src_app_progress_progress_box_component__["a" /* ProgressBoxComponent */], [], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
function View_BillingDialog_3(_l) {
    return __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 3, 'option', [], null, null, null, null, null)), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](147456, null, 0, __WEBPACK_IMPORTED_MODULE_5__angular_forms__["t" /* NgSelectOption */], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["ElementRef"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["Renderer2"], [2, __WEBPACK_IMPORTED_MODULE_5__angular_forms__["u" /* SelectControlValueAccessor */]]], { ngValue: [0, 'ngValue'] }, null), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](147456, null, 0, __WEBPACK_IMPORTED_MODULE_5__angular_forms__["v" /* ɵq */], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["ElementRef"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["Renderer2"], [8, null]], { ngValue: [0, 'ngValue'] }, null),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['', '']))], function (_ck, _v) {
        var currVal_0 = _v.context.$implicit;
        _ck(_v, 1, 0, currVal_0);
        var currVal_1 = _v.context.$implicit;
        _ck(_v, 2, 0, currVal_1);
    }, function (_ck, _v) {
        var currVal_2 = _v.context.$implicit.name;
        _ck(_v, 3, 0, currVal_2);
    });
}
function View_BillingDialog_4(_l) {
    return __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'a', [['class',
                'btn btn-success cloud-btn-style download-button'], ['download', ''], ['target',
                '_blank']], [[8, 'href', 4]], null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['Download Invoice']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵinlineInterpolate"](1, '', (_co.currentCycle && _co.currentCycle.invoiceUrl), '');
        _ck(_v, 0, 0, currVal_0);
    });
}
function View_BillingDialog_5(_l) {
    return __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'a', [['class',
                'btn btn-success cloud-btn-style download-button disabled'], ['target', '_blank']], null, null, null, null, null)), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['Download Invoice']))], null, null);
}
function View_BillingDialog_2(_l) {
    return __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 45, 'div', [['class',
                'main-container']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 15, 'div', [], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                    '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'div', [['class', 'description']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['Usage metrics for the billing interval'])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 9, 'select', [['class', 'form-control cloud-label-style'], ['id',
                'billingInterval']], [[2, 'ng-untouched', null], [2, 'ng-touched',
                null], [2, 'ng-pristine', null], [2, 'ng-dirty', null],
            [2, 'ng-valid', null], [2, 'ng-invalid', null], [2, 'ng-pending',
                null]], [[null, 'ngModelChange'], [null,
                'change'], [null, 'blur']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('change' === en)) {
                var pd_0 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 8).onChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 8).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_2 = ((_co.currentCycle = $event) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_5__angular_forms__["u" /* SelectControlValueAccessor */], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["Renderer2"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["ElementRef"]], null, null), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵprd"](1024, null, __WEBPACK_IMPORTED_MODULE_5__angular_forms__["k" /* NG_VALUE_ACCESSOR */], function (p0_0) {
            return [p0_0];
        }, [__WEBPACK_IMPORTED_MODULE_5__angular_forms__["u" /* SelectControlValueAccessor */]]), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](671744, null, 0, __WEBPACK_IMPORTED_MODULE_5__angular_forms__["l" /* NgModel */], [[8, null], [8, null], [8, null], [2, __WEBPACK_IMPORTED_MODULE_5__angular_forms__["k" /* NG_VALUE_ACCESSOR */]]], { model: [0, 'model'] }, { update: 'ngModelChange' }), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵprd"](2048, null, __WEBPACK_IMPORTED_MODULE_5__angular_forms__["m" /* NgControl */], null, [__WEBPACK_IMPORTED_MODULE_5__angular_forms__["l" /* NgModel */]]), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_5__angular_forms__["n" /* NgControlStatus */], [__WEBPACK_IMPORTED_MODULE_5__angular_forms__["m" /* NgControl */]], null, null), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵand"](16777216, null, null, 1, null, View_BillingDialog_3)), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](802816, null, 0, __WEBPACK_IMPORTED_MODULE_6__angular_common__["NgForOf"], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["ViewContainerRef"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["TemplateRef"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["IterableDiffers"]], { ngForOf: [0,
                'ngForOf'] }, null), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                    '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 7, 'div', [['class', 'info-container']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                    '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'label', [['class', 'control-label']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['Traffic'])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                    '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'div', [['class', 'metric-value']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['', ''])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 7, 'div', [['class', 'info-container']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'label', [['class', 'control-label']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['Cost'])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'div', [['class', 'metric-value'], ['div', '']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['', ''])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 7, 'div', [['class', 'info-container']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵand"](16777216, null, null, 1, null, View_BillingDialog_4)), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_6__angular_common__["NgIf"], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["ViewContainerRef"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵand"](16777216, null, null, 1, null, View_BillingDialog_5)), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_6__angular_common__["NgIf"], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["ViewContainerRef"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_7 = _co.currentCycle;
        _ck(_v, 10, 0, currVal_7);
        var currVal_8 = _co.cycles;
        _ck(_v, 15, 0, currVal_8);
        var currVal_11 = (_co.currentCycle && _co.currentCycle.invoiceUrl);
        _ck(_v, 40, 0, currVal_11);
        var currVal_12 = (_co.currentCycle && !_co.currentCycle.invoiceUrl);
        _ck(_v, 43, 0, currVal_12);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 12).ngClassUntouched;
        var currVal_1 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 12).ngClassTouched;
        var currVal_2 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 12).ngClassPristine;
        var currVal_3 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 12).ngClassDirty;
        var currVal_4 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 12).ngClassValid;
        var currVal_5 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 12).ngClassInvalid;
        var currVal_6 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 12).ngClassPending;
        _ck(_v, 7, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6);
        var currVal_9 = (_co.currentCycle ? (_co.currentCycle.totalGb + ' GB') : '...');
        _ck(_v, 25, 0, currVal_9);
        var currVal_10 = (_co.currentCycle ? _co.currentCycle.cost : '...');
        _ck(_v, 34, 0, currVal_10);
    });
}
function View_BillingDialog_6(_l) {
    return __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'div', [['class',
                'dialog-error']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['Error: ', '']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.dialogError;
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_BillingDialog_0(_l) {
    return __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 39, 'div', [['id',
                'billingModal']], null, null, null, null, null)),
        __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](278528, null, 0, __WEBPACK_IMPORTED_MODULE_6__angular_common__["NgClass"], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["IterableDiffers"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["KeyValueDiffers"],
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ElementRef"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["Renderer"]], { ngClass: [0, 'ngClass'] }, null), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵpod"]({ 'modal-component': 0,
            'modal-component-off': 1 }), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n    '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 34, 'div', [['class', 'modal-container'],
                ['id', 'billingInformationBox']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n        '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 7, 'div', [['class', 'header header_border']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'p', [['class', 'dialog-title']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['Billing for: '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'p', [['class', 'dialog-title-email']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['', ''])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n        '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 7, 'div', [['class', 'mainbody'], ['style', 'min-height: 380px;']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵand"](16777216, null, null, 1, null, View_BillingDialog_1)), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_6__angular_common__["NgIf"], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["ViewContainerRef"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵand"](16777216, null, null, 1, null, View_BillingDialog_2)),
        __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_6__angular_common__["NgIf"], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["ViewContainerRef"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n        '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 13, 'div', [['class', 'footer footer_border']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵand"](16777216, null, null, 1, null, View_BillingDialog_6)), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_6__angular_common__["NgIf"], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["ViewContainerRef"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 7, 'div', [['class', 'ok-cancel-buttons']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 4, 'button', [['class', 'close-button'], ['id', 'closeButton']], null, [[null,
                'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.onCloseClicked($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                    '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'span', [], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['Close'])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n'])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _ck(_v, 2, 0, _co.isOn, !_co.isOn);
        _ck(_v, 1, 0, currVal_0);
        var currVal_2 = _co.loading;
        _ck(_v, 18, 0, currVal_2);
        var currVal_3 = !_co.loading;
        _ck(_v, 21, 0, currVal_3);
        var currVal_4 = _co.dialogError;
        _ck(_v, 27, 0, currVal_4);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_1 = _co.userEmail;
        _ck(_v, 12, 0, currVal_1);
    });
}
function View_BillingDialog_Host_0(_l) {
    return __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'dialog-billing', [], null, null, null, View_BillingDialog_0, RenderType_BillingDialog)), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](114688, null, 0, __WEBPACK_IMPORTED_MODULE_7__src_app_modals_billing_billing_dialog_component__["a" /* BillingDialog */], [__WEBPACK_IMPORTED_MODULE_8__src_app_billing_billing_service__["a" /* BillingService */],
            __WEBPACK_IMPORTED_MODULE_9__src_app_user_user_service__["a" /* UserService */]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var BillingDialogNgFactory = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵccf"]('dialog-billing', __WEBPACK_IMPORTED_MODULE_7__src_app_modals_billing_billing_dialog_component__["a" /* BillingDialog */], View_BillingDialog_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=billing-dialog.component.ngfactory.js.map

/***/ }),
/* 557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return styles; });
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */
var styles = ['.header[_ngcontent-%COMP%]   legend[_ngcontent-%COMP%] {\n  margin-bottom: 0; }\n\n.modal-container[_ngcontent-%COMP%] {\n  width: 360px; }\n  .modal-container[_ngcontent-%COMP%]   .mainbody[_ngcontent-%COMP%] {\n    max-height: 640px;\n    overflow-y: auto;\n    align-items: center;\n    justify-content: center; }\n    .modal-container[_ngcontent-%COMP%]   .mainbody[_ngcontent-%COMP%]   .main-container[_ngcontent-%COMP%] {\n      margin: 20px 40px 10px 40px; }\n    .modal-container[_ngcontent-%COMP%]   .mainbody[_ngcontent-%COMP%]   progress[_ngcontent-%COMP%] {\n      display: inline-block; }\n\n.dialog-title[_ngcontent-%COMP%] {\n  padding-left: 20px;\n  padding-top: 10px;\n  font-weight: 800;\n  color: #5A5A64;\n  font-family: open_sans;\n  font-weight: bold;\n  font-size: 13px;\n  white-space: nowrap; }\n\n.dialog-title-email[_ngcontent-%COMP%] {\n  padding-left: 5px;\n  padding-top: 10px;\n  font-weight: 800;\n  color: #50acda;\n  font-family: open_sans;\n  font-weight: bold;\n  font-size: 13px;\n  text-transform: none;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  margin-bottom: 0px !important; }\n\n.close-button[_ngcontent-%COMP%] {\n  height: 20px;\n  width: 55px;\n  color: #5a5a64;\n  background-color: #FAFAFA;\n  background: -webkit-gradient(linear, 0% 0%, 0% 100%, from(#ffffff), to(#F1F1F1));\n  background: -webkit-linear-gradient(0% 0%, 0% 100%, from(#ffffff), to(#F1F1F1));\n  background: -moz-linear-gradient(center top, #ffffff, #F1F1F1);\n  border: 1px solid #bababa;\n  font-family: open_sans;\n  font-weight: bold;\n  font-size: 10px;\n  text-align: center;\n  cursor: pointer;\n  margin-right: 20px; }\n\n.description[_ngcontent-%COMP%] {\n  text-align: justify;\n  font-size: 16px;\n  margin: 10px 0; }\n\n.download-button[_ngcontent-%COMP%] {\n  margin: 10px 0;\n  text-transform: uppercase; }\n\n.dialog-error[_ngcontent-%COMP%] {\n  width: 100%;\n  margin-top: 10px;\n  margin-left: 20px;\n  text-align: left;\n  font-size: 12px;\n  color: #af2816; }\n\n.info-container[_ngcontent-%COMP%] {\n  padding: 20px 0; }\n  .info-container[_ngcontent-%COMP%]:not(:last-child) {\n    border-bottom: 1px solid #D8D8D8; }\n  .info-container[_ngcontent-%COMP%]   .control-label[_ngcontent-%COMP%] {\n    font-size: 14px;\n    text-transform: uppercase; }\n  .info-container[_ngcontent-%COMP%]   .metric-value[_ngcontent-%COMP%] {\n    font-size: 28px;\n    color: #50acda; }'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3NyYy91aS9zcmMvYXBwL21vZGFscy9iaWxsaW5nL2JpbGxpbmctZGlhbG9nLmNvbXBvbmVudC5zY3NzLnNoaW0ubmdzdHlsZS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL3NyYy91aS9zcmMvYXBwL21vZGFscy9iaWxsaW5nL2JpbGxpbmctZGlhbG9nLmNvbXBvbmVudC5zY3NzIl0sInNvdXJjZXNDb250ZW50IjpbIiAiXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7OzsifQ==
//# sourceMappingURL=billing-dialog.component.scss.shim.ngstyle.js.map

/***/ }),
/* 558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RenderType_ShowErrorModal; });
/* harmony export (immutable) */ __webpack_exports__["a"] = View_ShowErrorModal_0;
/* unused harmony export View_ShowErrorModal_Host_0 */
/* unused harmony export ShowErrorModalNgFactory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modal_error_component_scss_shim_ngstyle__ = __webpack_require__(559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_common__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_app_modals_modal_error_component__ = __webpack_require__(321);
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */




var styles_ShowErrorModal = [__WEBPACK_IMPORTED_MODULE_0__modal_error_component_scss_shim_ngstyle__["a" /* styles */]];
var RenderType_ShowErrorModal = __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵcrt"]({ encapsulation: 0,
    styles: styles_ShowErrorModal, data: {} });
function View_ShowErrorModal_0(_l) {
    return __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵeld"](0, null, null, 39, 'div', [['id',
                'showErrorModal']], null, null, null, null, null)),
        __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵdid"](278528, null, 0, __WEBPACK_IMPORTED_MODULE_2__angular_common__["NgClass"], [__WEBPACK_IMPORTED_MODULE_1__angular_core__["IterableDiffers"], __WEBPACK_IMPORTED_MODULE_1__angular_core__["KeyValueDiffers"],
            __WEBPACK_IMPORTED_MODULE_1__angular_core__["ElementRef"], __WEBPACK_IMPORTED_MODULE_1__angular_core__["Renderer"]], { ngClass: [0, 'ngClass'] }, null), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵpod"]({ 'modal-component': 0,
            'modal-component-off': 1 }), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n    '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵeld"](0, null, null, 34, 'div', [['class', 'modal-container']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵeld"](0, null, null, 4, 'div', [['class', 'header header_border']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵeld"](0, null, null, 1, 'legend', [['class', 'dialog-title']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['', ''])), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n        '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵeld"](0, null, null, 13, 'div', [['class', 'mainbody']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵeld"](0, null, null, 4, 'div', [['class', 'error-icon']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n                '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵeld"](0, null, null, 0, 'img', [['src', '/assets/error.bdaf0008c084b16da681ad026a92d8d3.svg']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n                '])), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n            '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵeld"](0, null, null, 4, 'div', [['class', 'message']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n                '])), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵeld"](0, null, null, 1, 'span', [], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['', ''])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n        '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵeld"](0, null, null, 10, 'div', [['class', 'footer footer_border']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵeld"](0, null, null, 7, 'div', [['class', 'ok-cancel-buttons']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n                '])), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵeld"](0, null, null, 4, 'button', [['class', 'closeButton'], ['id', 'closeButton']], null, [[null,
                'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.onCloseClicked($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n                    '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵeld"](0, null, null, 1, 'span', [], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['Close'])), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n                '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵted"](null, ['\n']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _ck(_v, 2, 0, _co.isOn, !_co.isOn);
        _ck(_v, 1, 0, currVal_0);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_1 = _co.args.Title;
        _ck(_v, 9, 0, currVal_1);
        var currVal_2 = _co.args.Message;
        _ck(_v, 23, 0, currVal_2);
    });
}
function View_ShowErrorModal_Host_0(_l) {
    return __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵeld"](0, null, null, 1, 'modal-error', [], null, null, null, View_ShowErrorModal_0, RenderType_ShowErrorModal)), __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵdid"](114688, null, 0, __WEBPACK_IMPORTED_MODULE_3__src_app_modals_modal_error_component__["a" /* ShowErrorModal */], [], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var ShowErrorModalNgFactory = __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵccf"]('modal-error', __WEBPACK_IMPORTED_MODULE_3__src_app_modals_modal_error_component__["a" /* ShowErrorModal */], View_ShowErrorModal_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=modal-error.component.ngfactory.js.map

/***/ }),
/* 559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return styles; });
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */
var styles = ['.modal-container[_ngcontent-%COMP%] {\n  min-height: 150px;\n  min-width: 420px;\n  max-width: 600px; }\n\n.mainbody[_ngcontent-%COMP%] {\n  flex-direction: row; }\n\n.error-icon[_ngcontent-%COMP%] {\n  align-self: center;\n  padding-left: 20px;\n  padding-right: 10px; }\n\n.dialog-title[_ngcontent-%COMP%] {\n  padding-left: 20px;\n  padding-top: 10px;\n  font-weight: 800;\n  color: #5A5A64;\n  font-family: open_sans;\n  font-weight: bold;\n  font-size: 13px; }\n\n.message[_ngcontent-%COMP%] {\n  color: #5a5a64;\n  font-family: open_sans;\n  font-weight: 600;\n  font-size: 13px;\n  align-self: center;\n  word-break: break-word;\n  word-wrap: break-word; }\n\n.closeButton[_ngcontent-%COMP%] {\n  height: 20px;\n  width: 55px;\n  color: #5a5a64;\n  background-color: #FAFAFA;\n  background: -webkit-gradient(linear, 0% 0%, 0% 100%, from(#ffffff), to(#F1F1F1));\n  background: -webkit-linear-gradient(0% 0%, 0% 100%, from(#ffffff), to(#F1F1F1));\n  background: -moz-linear-gradient(center top, #ffffff, #F1F1F1);\n  border: 1px solid #bababa;\n  font-family: open_sans;\n  font-weight: bold;\n  font-size: 10px;\n  text-align: center;\n  cursor: pointer;\n  margin-right: 20px; }'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3NyYy91aS9zcmMvYXBwL21vZGFscy9tb2RhbC1lcnJvci5jb21wb25lbnQuc2Nzcy5zaGltLm5nc3R5bGUudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9zcmMvdWkvc3JjL2FwcC9tb2RhbHMvbW9kYWwtZXJyb3IuY29tcG9uZW50LnNjc3MiXSwic291cmNlc0NvbnRlbnQiOlsiICJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7OyJ9
//# sourceMappingURL=modal-error.component.scss.shim.ngstyle.js.map

/***/ }),
/* 560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return styles; });
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */
var styles = ['.progress-box[_ngcontent-%COMP%] {\n  position: relative;\n  display: flex;\n  width: 100%;\n  padding-top: 40px; }\n\n.dialog-title[_ngcontent-%COMP%] {\n  padding-left: 20px;\n  padding-top: 14px;\n  color: #5A5A64;\n  font-weight: bold;\n  font-size: 13px; }\n\n.border_radius[_ngcontent-%COMP%] {\n  border-bottom-left-radius: 4px;\n  border-bottom-right-radius: 4px; }\n\n.complete-label-style[_ngcontent-%COMP%] {\n  font-size: 20px; }'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3NyYy91aS9zcmMvYXBwL21vZGFscy9tb2RhbC1sb2FkaW5nLmNvbXBvbmVudC5zY3NzLnNoaW0ubmdzdHlsZS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL3NyYy91aS9zcmMvYXBwL21vZGFscy9tb2RhbC1sb2FkaW5nLmNvbXBvbmVudC5zY3NzIl0sInNvdXJjZXNDb250ZW50IjpbIiAiXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7OzsifQ==
//# sourceMappingURL=modal-loading.component.scss.shim.ngstyle.js.map

/***/ }),
/* 561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RenderType_SupportDialogComponent; });
/* harmony export (immutable) */ __webpack_exports__["a"] = View_SupportDialogComponent_0;
/* unused harmony export View_SupportDialogComponent_Host_0 */
/* unused harmony export SupportDialogComponentNgFactory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__support_dialog_component_scss_shim_ngstyle__ = __webpack_require__(562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_bootstrap_dist_css_bootstrap_css_shim_ngstyle__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_core__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__angular_common__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_app_modals_support_support_dialog_component__ = __webpack_require__(322);
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */





var styles_SupportDialogComponent = [__WEBPACK_IMPORTED_MODULE_0__support_dialog_component_scss_shim_ngstyle__["a" /* styles */], __WEBPACK_IMPORTED_MODULE_1__node_modules_bootstrap_dist_css_bootstrap_css_shim_ngstyle__["a" /* styles */]];
var RenderType_SupportDialogComponent = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵcrt"]({ encapsulation: 0,
    styles: styles_SupportDialogComponent, data: {} });
function View_SupportDialogComponent_0(_l) {
    return __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 62, 'div', [['id',
                'aboutModal']], null, null, null, null, null)),
        __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](278528, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_common__["NgClass"], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["IterableDiffers"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["KeyValueDiffers"],
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ElementRef"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["Renderer"]], { ngClass: [0, 'ngClass'] }, null), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵpod"]({ 'modal-component': 0,
            'modal-component-off': 1 }), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n    '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 57, 'div', [['class', 'modal-container']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 4, 'div', [['class', 'header header_border']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'legend', [['class', 'dialog-title']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['BreakingPoint Cloud Test Support'])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 36, 'div', [['class', 'mainbody']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 33, 'div', [['class', 'main-container']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 27, 'div', [['class', 'description']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n\n\n                    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 13, 'div', [['class', 'row ']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                      '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 10, 'i', [], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'div', [['class', 'col-sm-5 about-label']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                          BreakingPoint Cloud Test ID:\n                        '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 4, 'div', [['class', 'col-sm-6 about-value']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'b', [], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['', ''])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                      '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n\n\n                    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 9, 'div', [['class', 'row about-row']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                      '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 0, 'div', [['class', 'empty-space col-sm-12'],
            ['style', 'height: 25px;']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                        '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 4, 'div', [['class', 'col-sm-12 ']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                            For support or inquiries about this test run please contact Ixia at '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'a', [], [[8, 'href',
                4]], null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['support@ixiacom.com'])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['. The above value of the BreakingPoint Cloud Test ID is required to reference this test run.\n                        '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n\n\n\n                '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'div', [], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 10, 'div', [['class', 'footer footer_border']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 7, 'div', [['class', 'ok-cancel-buttons']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 4, 'button', [['class', 'close-button'], ['id', 'aboutCloseButton']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.onCloseClicked($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                    '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'span', [], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['Close'])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n'])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _ck(_v, 2, 0, _co.isOn, !_co.isOn);
        _ck(_v, 1, 0, currVal_0);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_1 = _co.supportId;
        _ck(_v, 28, 0, currVal_1);
        var currVal_2 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵinlineInterpolate"](1, '', _co.mailToString, '');
        _ck(_v, 39, 0, currVal_2);
    });
}
function View_SupportDialogComponent_Host_0(_l) {
    return __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'support-dialog', [], null, null, null, View_SupportDialogComponent_0, RenderType_SupportDialogComponent)), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](114688, null, 0, __WEBPACK_IMPORTED_MODULE_4__src_app_modals_support_support_dialog_component__["a" /* SupportDialogComponent */], [], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var SupportDialogComponentNgFactory = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵccf"]('support-dialog', __WEBPACK_IMPORTED_MODULE_4__src_app_modals_support_support_dialog_component__["a" /* SupportDialogComponent */], View_SupportDialogComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=support-dialog.component.ngfactory.js.map

/***/ }),
/* 562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return styles; });
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */
var styles = ['.modal-container[_ngcontent-%COMP%] {\n  min-width: 500px;\n  max-width: 500px; }\n\n.header[_ngcontent-%COMP%]   legend[_ngcontent-%COMP%] {\n  margin-bottom: 0; }\n\n.mainbody[_ngcontent-%COMP%] {\n  max-height: 640px;\n  overflow-y: auto; }\n\n.main-container[_ngcontent-%COMP%] {\n  margin: 20px; }\n\n.dialog-title[_ngcontent-%COMP%] {\n  padding-left: 20px;\n  padding-top: 10px;\n  font-weight: 800;\n  color: #5A5A64;\n  font-family: open_sans;\n  font-weight: bold;\n  font-size: 13px; }\n\n.close-button[_ngcontent-%COMP%] {\n  height: 20px;\n  width: 55px;\n  color: #5a5a64;\n  background-color: #FAFAFA;\n  background: -webkit-gradient(linear, 0% 0%, 0% 100%, from(#ffffff), to(#F1F1F1));\n  background: -webkit-linear-gradient(0% 0%, 0% 100%, from(#ffffff), to(#F1F1F1));\n  background: -moz-linear-gradient(center top, #ffffff, #F1F1F1);\n  border: 1px solid #bababa;\n  font-family: open_sans;\n  font-weight: bold;\n  font-size: 10px;\n  text-align: center;\n  cursor: pointer;\n  margin-right: 20px; }\n\n.description[_ngcontent-%COMP%] {\n  text-align: justify;\n  font-size: 14px; }\n\n.about-label[_ngcontent-%COMP%] {\n  text-align: right;\n  font-size: 12px; }\n\n.about-value[_ngcontent-%COMP%] {\n  text-align: left;\n  font-size: 12px; }\n\n.about-center[_ngcontent-%COMP%] {\n  text-align: center;\n  font-size: 12px; }\n\n.about-row[_ngcontent-%COMP%] {\n  margin-bottom: 10px; }'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3NyYy91aS9zcmMvYXBwL21vZGFscy9zdXBwb3J0L3N1cHBvcnQtZGlhbG9nLmNvbXBvbmVudC5zY3NzLnNoaW0ubmdzdHlsZS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL3NyYy91aS9zcmMvYXBwL21vZGFscy9zdXBwb3J0L3N1cHBvcnQtZGlhbG9nLmNvbXBvbmVudC5zY3NzIl0sInNvdXJjZXNDb250ZW50IjpbIiAiXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7OzsifQ==
//# sourceMappingURL=support-dialog.component.scss.shim.ngstyle.js.map

/***/ }),
/* 563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return styles; });
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */
var styles = ['.markersContainer[_ngcontent-%COMP%] {\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  margin-left: auto;\n  margin-right: auto; }\n\n.progressMarker[_ngcontent-%COMP%] {\n  background-color: white;\n  margin-right: 5px;\n  border: 1px solid #cacaca;\n  height: 16px;\n  width: 16px; }\n\n.coloredProgressMarker[_ngcontent-%COMP%] {\n  background-color: white;\n  height: 8px;\n  width: 8px;\n  margin-left: 4px;\n  margin-top: 4px; }'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3NyYy91aS9zcmMvYXBwL3Byb2dyZXNzL3Byb2dyZXNzLWJveC5jb21wb25lbnQuc2Nzcy5zaGltLm5nc3R5bGUudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9zcmMvdWkvc3JjL2FwcC9wcm9ncmVzcy9wcm9ncmVzcy1ib3guY29tcG9uZW50LnNjc3MiXSwic291cmNlc0NvbnRlbnQiOlsiICJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7OyJ9
//# sourceMappingURL=progress-box.component.scss.shim.ngstyle.js.map

/***/ }),
/* 564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RenderType_ReleaseNotesComponent */
/* unused harmony export View_ReleaseNotesComponent_0 */
/* unused harmony export View_ReleaseNotesComponent_Host_0 */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ReleaseNotesComponentNgFactory; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_app_release_notes_release_notes_component__ = __webpack_require__(326);
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */


var styles_ReleaseNotesComponent = [];
var RenderType_ReleaseNotesComponent = __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵcrt"]({ encapsulation: 2,
    styles: styles_ReleaseNotesComponent, data: {} });
function View_ReleaseNotesComponent_0(_l) {
    return __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵeld"](0, null, null, 1, 'h1', [], null, null, null, null, null)), (_l()(),
            __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵted"](null, ['Release Notes'])), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵted"](null, ['\n'])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵeld"](0, null, null, 7, 'ul', [], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵted"](null, ['\n    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵeld"](0, null, null, 1, 'li', [], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵted"](null, ['Before a user has run an initial test on the configuration screen, moving to activate subscription or to the history page will clear the Target IP.'])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵted"](null, ['\n    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵeld"](0, null, null, 1, 'li', [], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵted"](null, ['On the \'Contact Ixia Support\' page from the gear menu the user will be required to give a Hardware Serial Number, any value is acceptable. '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵted"](null, ['\n']))], null, null);
}
function View_ReleaseNotesComponent_Host_0(_l) {
    return __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵeld"](0, null, null, 1, 'release-notes', [], null, null, null, View_ReleaseNotesComponent_0, RenderType_ReleaseNotesComponent)), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵdid"](49152, null, 0, __WEBPACK_IMPORTED_MODULE_1__src_app_release_notes_release_notes_component__["a" /* ReleaseNotesComponent */], [], null, null)], null, null);
}
var ReleaseNotesComponentNgFactory = __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵccf"]('release-notes', __WEBPACK_IMPORTED_MODULE_1__src_app_release_notes_release_notes_component__["a" /* ReleaseNotesComponent */], View_ReleaseNotesComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3NyYy91aS9zcmMvYXBwL3JlbGVhc2Utbm90ZXMvcmVsZWFzZS1ub3Rlcy5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vc3JjL3VpL3NyYy9hcHAvcmVsZWFzZS1ub3Rlcy9yZWxlYXNlLW5vdGVzLmNvbXBvbmVudC50cyIsIm5nOi8vL3NyYy91aS9zcmMvYXBwL3JlbGVhc2Utbm90ZXMvcmVsZWFzZS1ub3Rlcy5jb21wb25lbnQuaHRtbCIsIm5nOi8vL3NyYy91aS9zcmMvYXBwL3JlbGVhc2Utbm90ZXMvcmVsZWFzZS1ub3Rlcy5jb21wb25lbnQudHMuUmVsZWFzZU5vdGVzQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPGgxPlJlbGVhc2UgTm90ZXM8L2gxPlxuPHVsPlxuICAgIDxsaT5CZWZvcmUgYSB1c2VyIGhhcyBydW4gYW4gaW5pdGlhbCB0ZXN0IG9uIHRoZSBjb25maWd1cmF0aW9uIHNjcmVlbiwgbW92aW5nIHRvIGFjdGl2YXRlIHN1YnNjcmlwdGlvbiBvciB0byB0aGUgaGlzdG9yeSBwYWdlIHdpbGwgY2xlYXIgdGhlIFRhcmdldCBJUC48L2xpPlxuICAgIDxsaT5PbiB0aGUgJ0NvbnRhY3QgSXhpYSBTdXBwb3J0JyBwYWdlIGZyb20gdGhlIGdlYXIgbWVudSB0aGUgdXNlciB3aWxsIGJlIHJlcXVpcmVkIHRvIGdpdmUgYSBIYXJkd2FyZSBTZXJpYWwgTnVtYmVyLCBhbnkgdmFsdWUgaXMgYWNjZXB0YWJsZS4gPC9saT5cbjwvdWw+IiwiPHJlbGVhc2Utbm90ZXM+PC9yZWxlYXNlLW5vdGVzPiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7O29CQ0FBO01BQUEsd0VBQUk7YUFBQSxtQ0FBa0I7TUFDdEI7VUFBQSwwREFBSTtVQUFBLGFBQ0E7VUFBQTtNQUFJO01BQXdKLDJDQUM1SjtVQUFBO1VBQUEsZ0JBQUk7TUFBZ0o7OztvQkNIeEo7TUFBQTtzQ0FBQSxVQUFBO01BQUE7OzsifQ==
//# sourceMappingURL=release-notes.component.ngfactory.js.map

/***/ }),
/* 565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RenderType_TrialComponent */
/* unused harmony export View_TrialComponent_0 */
/* unused harmony export View_TrialComponent_Host_0 */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TrialComponentNgFactory; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__trial_component_scss_shim_ngstyle__ = __webpack_require__(566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_bootstrap_dist_css_bootstrap_css_shim_ngstyle__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_core__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__angular_forms__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__angular_common__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_app_trial_trial_component__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_app_components_equal_validator_directive__ = __webpack_require__(573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modals_modal_loading_component_ngfactory__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_app_modals_modal_loading_component__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_app_modals_modal_service__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__licensing_licensing_component_ngfactory__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_app_licensing_licensing_component__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__angular_router__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_app_trial_trial_service__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_app_login_user_login_service__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__src_app_user_user_service__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__src_app_headerfooter_setting_entries_tos_entry__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__src_app_aws_environment__ = __webpack_require__(26);
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */


















var styles_TrialComponent = [__WEBPACK_IMPORTED_MODULE_0__trial_component_scss_shim_ngstyle__["a" /* styles */], __WEBPACK_IMPORTED_MODULE_1__node_modules_bootstrap_dist_css_bootstrap_css_shim_ngstyle__["a" /* styles */]];
var RenderType_TrialComponent = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵcrt"]({ encapsulation: 0,
    styles: styles_TrialComponent, data: {} });
function View_TrialComponent_3(_l) {
    return __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'button', [['class',
                'trial__btn btn'], ['id', 'btn-already-submit'], ['type', 'submit']], [[8, 'disabled',
                0]], null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['SIGNUP\n        ']))], null, function (_ck, _v) {
        var currVal_0 = (!__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v.parent, 2).valid || !__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v.parent, 35).checked);
        _ck(_v, 0, 0, currVal_0);
    });
}
function View_TrialComponent_2(_l) {
    return __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 55, 'form', [['class',
                'trial__form'], ['novalidate', '']], [[2, 'ng-untouched', null], [2, 'ng-touched',
                null], [2, 'ng-pristine', null], [2, 'ng-dirty', null],
            [2, 'ng-valid', null], [2, 'ng-invalid', null], [2, 'ng-pending',
                null]], [[null, 'ngSubmit'], [null, 'submit'], [null,
                'reset']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('submit' === en)) {
                var pd_0 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 2).onSubmit($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('reset' === en)) {
                var pd_1 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 2).onReset() !== false);
                ad = (pd_1 && ad);
            }
            if (('ngSubmit' === en)) {
                var pd_2 = (_co.submitTrial() !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["e" /* ɵbf */], [], null, null), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, [['alreadyUserForm', 4]], 0, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["f" /* NgForm */], [[8, null], [8, null]], null, { ngSubmit: 'ngSubmit' }), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵprd"](2048, null, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["g" /* ControlContainer */], null, [__WEBPACK_IMPORTED_MODULE_3__angular_forms__["f" /* NgForm */]]), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["h" /* NgControlStatusGroup */], [__WEBPACK_IMPORTED_MODULE_3__angular_forms__["g" /* ControlContainer */]], null, null),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 17, 'div', [['class', 'trial__box']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 5, 'input', [['class', 'trial__input'], ['id', 'txt-already-trial-email'], ['name', 'email'],
            ['placeholder', 'Email Address'], ['type', 'email']], [[2, 'ng-untouched',
                null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
            [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                null], [2, 'ng-pending', null]], [[null, 'ngModelChange'],
            [null, 'input'], [null, 'blur'], [null, 'compositionstart'],
            [null, 'compositionend']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('input' === en)) {
                var pd_0 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 9)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 9).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 9)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 9)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_4 = ((_co.trialParams.Email = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["i" /* DefaultValueAccessor */], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["Renderer2"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["ElementRef"], [2, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["j" /* COMPOSITION_BUFFER_MODE */]]], null, null), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵprd"](1024, null, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["k" /* NG_VALUE_ACCESSOR */], function (p0_0) {
            return [p0_0];
        }, [__WEBPACK_IMPORTED_MODULE_3__angular_forms__["i" /* DefaultValueAccessor */]]), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](671744, [['email', 4]], 0, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["l" /* NgModel */], [[2, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["g" /* ControlContainer */]],
            [8, null], [8, null], [2, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["k" /* NG_VALUE_ACCESSOR */]]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵprd"](2048, null, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["m" /* NgControl */], null, [__WEBPACK_IMPORTED_MODULE_3__angular_forms__["l" /* NgModel */]]), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["n" /* NgControlStatus */], [__WEBPACK_IMPORTED_MODULE_3__angular_forms__["m" /* NgControl */]], null, null), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 7, 'input', [['class', 'trial__input'], ['id', 'txt-trial-already-password'], ['name', 'pword'],
            ['placeholder', 'Password'], ['required', ''], ['type', 'password']], [[1,
                'required', 0], [2, 'ng-untouched', null], [2, 'ng-touched', null],
            [2, 'ng-pristine', null], [2, 'ng-dirty', null], [2, 'ng-valid',
                null], [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null, 'ngModelChange'], [null, 'input'], [null,
                'blur'], [null, 'compositionstart'], [null, 'compositionend']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('input' === en)) {
                var pd_0 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 16)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 16).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 16)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 16)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_4 = ((_co.trialParams.Password = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["i" /* DefaultValueAccessor */], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["Renderer2"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["ElementRef"], [2, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["j" /* COMPOSITION_BUFFER_MODE */]]], null, null), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["o" /* RequiredValidator */], [], { required: [0, 'required'] }, null), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵprd"](1024, null, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["p" /* NG_VALIDATORS */], function (p0_0) {
            return [p0_0];
        }, [__WEBPACK_IMPORTED_MODULE_3__angular_forms__["o" /* RequiredValidator */]]), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵprd"](1024, null, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["k" /* NG_VALUE_ACCESSOR */], function (p0_0) {
            return [p0_0];
        }, [__WEBPACK_IMPORTED_MODULE_3__angular_forms__["i" /* DefaultValueAccessor */]]), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](671744, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["l" /* NgModel */], [[2,
                __WEBPACK_IMPORTED_MODULE_3__angular_forms__["g" /* ControlContainer */]], [2, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["p" /* NG_VALIDATORS */]], [8, null], [2, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["k" /* NG_VALUE_ACCESSOR */]]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵprd"](2048, null, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["m" /* NgControl */], null, [__WEBPACK_IMPORTED_MODULE_3__angular_forms__["l" /* NgModel */]]), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["n" /* NgControlStatus */], [__WEBPACK_IMPORTED_MODULE_3__angular_forms__["m" /* NgControl */]], null, null), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n        '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 0, 'div', [['style', 'width:346px; height: 1px']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 4, 'div', [['class', 'trial__forgot-password'], ['style', 'padding-left:0;']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'a', [['class', 'login-link-style-sm'], ['target', '_blank']], [[8, 'href', 4]], null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['Forgot password?'])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n\n        '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 18, 'div', [['class', 'trial__checkbox']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, [['chkAlreadyTOS',
                1]], null, 7, 'input', [['id', 'chkAlreadyTOS'], ['name', 'chkAlreadyTOS'],
            ['ngModel', ''], ['required', ''], ['type', 'checkbox']], [[1, 'required', 0], [2,
                'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'change'], [null, 'blur']], function (_v, en, $event) {
            var ad = true;
            if (('change' === en)) {
                var pd_0 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 36).onChange($event.target.checked) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 36).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["q" /* CheckboxControlValueAccessor */], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["Renderer2"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["ElementRef"]], null, null), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["r" /* CheckboxRequiredValidator */], [], { required: [0,
                'required'] }, null), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵprd"](1024, null, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["p" /* NG_VALIDATORS */], function (p0_0) {
            return [p0_0];
        }, [__WEBPACK_IMPORTED_MODULE_3__angular_forms__["r" /* CheckboxRequiredValidator */]]), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵprd"](1024, null, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["k" /* NG_VALUE_ACCESSOR */], function (p0_0) {
            return [p0_0];
        }, [__WEBPACK_IMPORTED_MODULE_3__angular_forms__["q" /* CheckboxControlValueAccessor */]]), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](671744, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["l" /* NgModel */], [[2, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["g" /* ControlContainer */]], [2, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["p" /* NG_VALIDATORS */]], [8, null], [2, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["k" /* NG_VALUE_ACCESSOR */]]], { name: [0, 'name'], model: [1, 'model'] }, null), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵprd"](2048, null, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["m" /* NgControl */], null, [__WEBPACK_IMPORTED_MODULE_3__angular_forms__["l" /* NgModel */]]), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["n" /* NgControlStatus */], [__WEBPACK_IMPORTED_MODULE_3__angular_forms__["m" /* NgControl */]], null, null), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 0, 'label', [['for', 'chkAlreadyTOS']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'div', [['class', 'trial__checkbox-font']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['I agree with the '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'a', [['class', 'trial__checkbox-font'], ['style', 'color:#9abc7d; cursor:pointer']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.showTOS() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['Terms of Service'])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵand"](16777216, null, null, 1, null, View_TrialComponent_3)), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_4__angular_common__["NgIf"], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["ViewContainerRef"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n    ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_14 = 'email';
        var currVal_15 = _co.trialParams.Email;
        _ck(_v, 11, 0, currVal_14, currVal_15);
        var currVal_24 = '';
        _ck(_v, 17, 0, currVal_24);
        var currVal_25 = 'pword';
        var currVal_26 = _co.trialParams.Password;
        _ck(_v, 20, 0, currVal_25, currVal_26);
        var currVal_36 = '';
        _ck(_v, 37, 0, currVal_36);
        var currVal_37 = 'chkAlreadyTOS';
        var currVal_38 = '';
        _ck(_v, 40, 0, currVal_37, currVal_38);
        var currVal_39 = _co.showAlreadyUserLogin;
        _ck(_v, 54, 0, currVal_39);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 4).ngClassUntouched;
        var currVal_1 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 4).ngClassTouched;
        var currVal_2 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 4).ngClassPristine;
        var currVal_3 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 4).ngClassDirty;
        var currVal_4 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 4).ngClassValid;
        var currVal_5 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 4).ngClassInvalid;
        var currVal_6 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 4).ngClassPending;
        _ck(_v, 0, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6);
        var currVal_7 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 13).ngClassUntouched;
        var currVal_8 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 13).ngClassTouched;
        var currVal_9 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 13).ngClassPristine;
        var currVal_10 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 13).ngClassDirty;
        var currVal_11 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 13).ngClassValid;
        var currVal_12 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 13).ngClassInvalid;
        var currVal_13 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 13).ngClassPending;
        _ck(_v, 8, 0, currVal_7, currVal_8, currVal_9, currVal_10, currVal_11, currVal_12, currVal_13);
        var currVal_16 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 17).required ? '' : null);
        var currVal_17 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 22).ngClassUntouched;
        var currVal_18 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 22).ngClassTouched;
        var currVal_19 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 22).ngClassPristine;
        var currVal_20 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 22).ngClassDirty;
        var currVal_21 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 22).ngClassValid;
        var currVal_22 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 22).ngClassInvalid;
        var currVal_23 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 22).ngClassPending;
        _ck(_v, 15, 0, currVal_16, currVal_17, currVal_18, currVal_19, currVal_20, currVal_21, currVal_22, currVal_23);
        var currVal_27 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵinlineInterpolate"](1, '', _co.forgotPasswordUrl, '');
        _ck(_v, 29, 0, currVal_27);
        var currVal_28 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 37).required ? '' : null);
        var currVal_29 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 42).ngClassUntouched;
        var currVal_30 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 42).ngClassTouched;
        var currVal_31 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 42).ngClassPristine;
        var currVal_32 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 42).ngClassDirty;
        var currVal_33 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 42).ngClassValid;
        var currVal_34 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 42).ngClassInvalid;
        var currVal_35 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 42).ngClassPending;
        _ck(_v, 35, 0, currVal_28, currVal_29, currVal_30, currVal_31, currVal_32, currVal_33, currVal_34, currVal_35);
    });
}
function View_TrialComponent_4(_l) {
    return __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'div', [['class',
                'trial-alert'], ['id', 'first_name_alert']], [[8, 'hidden', 0]], null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                 First Name is required\n            ']))], null, function (_ck, _v) {
        var currVal_0 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v.parent, 41).pristine || __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v.parent, 41).valid);
        _ck(_v, 0, 0, currVal_0);
    });
}
function View_TrialComponent_5(_l) {
    return __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'div', [['id', 'email_alert']], null, null, null, null, null)), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                    Email required\n                ']))], null, null);
}
function View_TrialComponent_6(_l) {
    return __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'div', [['id', 'email_alert']], null, null, null, null, null)), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                    Invalid email format\n                ']))], null, null);
}
function View_TrialComponent_7(_l) {
    return __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 8, 'input', [['id',
                'txt-trial-regcode'], ['name', 'regcode'], ['ng-validate-on-dirty', ''], ['placeholder',
                'Registration Code'], ['type', 'text'], ['validateOnBlur', '']], [[2, 'ng-untouched',
                null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
            [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'ngModelChange'], [null,
                'input'], [null, 'blur'], [null, 'compositionstart'], [null,
                'compositionend'], [null, 'focus'], [null, 'focusout']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('input' === en)) {
                var pd_0 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 3)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 3).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 3)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 3)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('focus' === en)) {
                var pd_4 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 8).onFocus($event.target) !== false);
                ad = (pd_4 && ad);
            }
            if (('focusout' === en)) {
                var pd_5 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 8).onFocusout($event.target) !== false);
                ad = (pd_5 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_6 = ((_co.trialParams.RegCode = $event) !== false);
                ad = (pd_6 && ad);
            }
            return ad;
        }, null, null)), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](278528, null, 0, __WEBPACK_IMPORTED_MODULE_4__angular_common__["NgClass"], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["IterableDiffers"],
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["KeyValueDiffers"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["ElementRef"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["Renderer"]], { ngClass: [0, 'ngClass'] }, null),
        __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵpod"]({ 'trial__input': 0, 'trial__input__error': 1 }), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["i" /* DefaultValueAccessor */], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["Renderer2"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["ElementRef"], [2, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["j" /* COMPOSITION_BUFFER_MODE */]]], null, null), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵprd"](1024, null, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["k" /* NG_VALUE_ACCESSOR */], function (p0_0) {
            return [p0_0];
        }, [__WEBPACK_IMPORTED_MODULE_3__angular_forms__["i" /* DefaultValueAccessor */]]), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](671744, [['regcode', 4]], 0, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["l" /* NgModel */], [[2, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["g" /* ControlContainer */]], [8, null], [8, null], [2, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["k" /* NG_VALUE_ACCESSOR */]]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵprd"](2048, null, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["m" /* NgControl */], null, [__WEBPACK_IMPORTED_MODULE_3__angular_forms__["l" /* NgModel */]]), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["n" /* NgControlStatus */], [__WEBPACK_IMPORTED_MODULE_3__angular_forms__["m" /* NgControl */]], null, null), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_5__src_app_trial_trial_component__["b" /* ValidateOnBlur */], [], { model: [0, 'model'] }, null)], function (_ck, _v) {
        var _co = _v.component;
        var currVal_7 = _ck(_v, 2, 0, (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 5).pristine || (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 5).pristine || __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 5).valid)), !(__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 5).pristine || (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 5).pristine || __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 5).valid)));
        _ck(_v, 1, 0, currVal_7);
        var currVal_8 = 'regcode';
        var currVal_9 = _co.trialParams.RegCode;
        _ck(_v, 5, 0, currVal_8, currVal_9);
        var currVal_10 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 5);
        _ck(_v, 8, 0, currVal_10);
    }, function (_ck, _v) {
        var currVal_0 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 7).ngClassUntouched;
        var currVal_1 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 7).ngClassTouched;
        var currVal_2 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 7).ngClassPristine;
        var currVal_3 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 7).ngClassDirty;
        var currVal_4 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 7).ngClassValid;
        var currVal_5 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 7).ngClassInvalid;
        var currVal_6 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 7).ngClassPending;
        _ck(_v, 0, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6);
    });
}
function View_TrialComponent_8(_l) {
    return __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'div', [['class',
                'trial-alert'], ['id', 'regcode_alert']], [[8, 'hidden', 0]], null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                 Registration Code is required\n            ']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = (_co.regcode.pristine || (_co.regcode.pristine || _co.regcode.valid));
        _ck(_v, 0, 0, currVal_0);
    });
}
function View_TrialComponent_9(_l) {
    return __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 7, 'input', [['class',
                'trial__input'], ['id', 'txt-trial-promocode'], ['maxlength', '100'], ['name', 'promocode'],
            ['placeholder', 'Promotional Code']], [[1, 'maxlength', 0], [2, 'ng-untouched', null],
            [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'ngModelChange'], [null,
                'input'], [null, 'blur'], [null, 'compositionstart'], [null,
                'compositionend']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('input' === en)) {
                var pd_0 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 1)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 1).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 1)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 1)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_4 = ((_co.trialParams.PromoCode = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["i" /* DefaultValueAccessor */], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["Renderer2"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["ElementRef"], [2, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["j" /* COMPOSITION_BUFFER_MODE */]]], null, null),
        __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](540672, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["s" /* MaxLengthValidator */], [], { maxlength: [0,
                'maxlength'] }, null), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵprd"](1024, null, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["p" /* NG_VALIDATORS */], function (p0_0) {
            return [p0_0];
        }, [__WEBPACK_IMPORTED_MODULE_3__angular_forms__["s" /* MaxLengthValidator */]]), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵprd"](1024, null, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["k" /* NG_VALUE_ACCESSOR */], function (p0_0) {
            return [p0_0];
        }, [__WEBPACK_IMPORTED_MODULE_3__angular_forms__["i" /* DefaultValueAccessor */]]), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](671744, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["l" /* NgModel */], [[2,
                __WEBPACK_IMPORTED_MODULE_3__angular_forms__["g" /* ControlContainer */]], [2, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["p" /* NG_VALIDATORS */]], [8, null], [2, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["k" /* NG_VALUE_ACCESSOR */]]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵprd"](2048, null, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["m" /* NgControl */], null, [__WEBPACK_IMPORTED_MODULE_3__angular_forms__["l" /* NgModel */]]), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["n" /* NgControlStatus */], [__WEBPACK_IMPORTED_MODULE_3__angular_forms__["m" /* NgControl */]], null, null)], function (_ck, _v) {
        var _co = _v.component;
        var currVal_8 = '100';
        _ck(_v, 2, 0, currVal_8);
        var currVal_9 = 'promocode';
        var currVal_10 = _co.trialParams.PromoCode;
        _ck(_v, 5, 0, currVal_9, currVal_10);
    }, function (_ck, _v) {
        var currVal_0 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 2).maxlength ? __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 2).maxlength : null);
        var currVal_1 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 7).ngClassUntouched;
        var currVal_2 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 7).ngClassTouched;
        var currVal_3 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 7).ngClassPristine;
        var currVal_4 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 7).ngClassDirty;
        var currVal_5 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 7).ngClassValid;
        var currVal_6 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 7).ngClassInvalid;
        var currVal_7 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 7).ngClassPending;
        _ck(_v, 0, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7);
    });
}
function View_TrialComponent_10(_l) {
    return __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 9, 'div', [['class',
                'attack-error-div'], ['id', 'attack-error-div']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n        '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 0, 'div', [['class', 'attack-error-icon'],
            ['id', 'attack-error-icon']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 4, 'div', [['class', 'attack-error-label'], ['id',
                'attack-error-label']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'span', [], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['', ''])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n    ']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.error;
        _ck(_v, 7, 0, currVal_0);
    });
}
function View_TrialComponent_1(_l) {
    return __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 150, 'div', [['class',
                'container']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n\n    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'div', [['class', 'heading-0']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['Sign up for a free trial'])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n    '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'div', [['class', 'heading-1']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['And get 5 GB of free outbound traffic. No credit card required!'])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n\n    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 13, 'div', [['class', 'trial__false-top']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 8, 'div', [['class',
                'trial__checkbox']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 0, 'input', [['class', 'trial__checkbox'],
                ['id', 'chkAlreadyUser'], ['name', 'chkAlreadyUser'], ['type', 'checkbox']], null, [[null, 'change']], function (_v, en, $event) {
                var ad = true;
                var _co = _v.component;
                if (('change' === en)) {
                    var pd_0 = (_co.onAlreadyUserChange($event) !== false);
                    ad = (pd_0 && ad);
                }
                return ad;
            }, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 0, 'label', [['for', 'chkAlreadyUser']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'div', [['class', 'trial__checkbox-font']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['I already have an Ixia identity account'])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n        '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 0, 'div', [['style', 'width:304px']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n\n    '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵand"](16777216, null, null, 1, null, View_TrialComponent_2)),
        __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_4__angular_common__["NgIf"], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["ViewContainerRef"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n\n\n    '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 120, 'form', [['class', 'trial__form'],
                ['novalidate', '']], [[2, 'ng-untouched', null], [2, 'ng-touched',
                    null], [2, 'ng-pristine', null], [2, 'ng-dirty', null],
                [2, 'ng-valid', null], [2, 'ng-invalid', null], [2, 'ng-pending',
                    null]], [[null, 'ngSubmit'], [null, 'submit'],
                [null, 'reset']], function (_v, en, $event) {
                var ad = true;
                var _co = _v.component;
                if (('submit' === en)) {
                    var pd_0 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 30).onSubmit($event) !== false);
                    ad = (pd_0 && ad);
                }
                if (('reset' === en)) {
                    var pd_1 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 30).onReset() !== false);
                    ad = (pd_1 && ad);
                }
                if (('ngSubmit' === en)) {
                    var pd_2 = (_co.submitTrial() !== false);
                    ad = (pd_2 && ad);
                }
                return ad;
            }, null, null)), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](278528, null, 0, __WEBPACK_IMPORTED_MODULE_4__angular_common__["NgStyle"], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["KeyValueDiffers"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["ElementRef"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["Renderer"]], { ngStyle: [0, 'ngStyle'] }, null),
        __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵpod"]({ display: 0 }), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["e" /* ɵbf */], [], null, null), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, [[3, 4], ['trialForm', 4]], 0, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["f" /* NgForm */], [[8, null],
            [8, null]], null, { ngSubmit: 'ngSubmit' }), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵprd"](2048, null, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["g" /* ControlContainer */], null, [__WEBPACK_IMPORTED_MODULE_3__angular_forms__["f" /* NgForm */]]), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["h" /* NgControlStatusGroup */], [__WEBPACK_IMPORTED_MODULE_3__angular_forms__["g" /* ControlContainer */]], null, null),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 88, 'div', [['class', 'trial__box']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 8, 'input', [['id', 'txt-trial-fname'], ['name', 'fname'], ['ng-validate-on-dirty', ''], ['placeholder',
                'First Name'], ['type', 'text'], ['validateOnBlur', '']], [[2, 'ng-untouched',
                null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
            [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                null], [2, 'ng-pending', null]], [[null, 'ngModelChange'],
            [null, 'input'], [null, 'blur'], [null, 'compositionstart'],
            [null, 'compositionend'], [null, 'focus'], [null,
                'focusout']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('input' === en)) {
                var pd_0 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 39)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 39).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 39)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 39)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('focus' === en)) {
                var pd_4 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 44).onFocus($event.target) !== false);
                ad = (pd_4 && ad);
            }
            if (('focusout' === en)) {
                var pd_5 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 44).onFocusout($event.target) !== false);
                ad = (pd_5 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_6 = ((_co.trialParams.FirstName = $event) !== false);
                ad = (pd_6 && ad);
            }
            return ad;
        }, null, null)), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](278528, null, 0, __WEBPACK_IMPORTED_MODULE_4__angular_common__["NgClass"], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["IterableDiffers"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["KeyValueDiffers"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["ElementRef"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["Renderer"]], { ngClass: [0,
                'ngClass'] }, null), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵpod"]({ 'trial__input': 0, 'trial__input__error': 1 }),
        __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["i" /* DefaultValueAccessor */], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["Renderer2"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["ElementRef"],
            [2, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["j" /* COMPOSITION_BUFFER_MODE */]]], null, null), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵprd"](1024, null, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["k" /* NG_VALUE_ACCESSOR */], function (p0_0) {
            return [p0_0];
        }, [__WEBPACK_IMPORTED_MODULE_3__angular_forms__["i" /* DefaultValueAccessor */]]), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](671744, [['fname', 4]], 0, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["l" /* NgModel */], [[2,
                __WEBPACK_IMPORTED_MODULE_3__angular_forms__["g" /* ControlContainer */]], [8, null], [8, null], [2, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["k" /* NG_VALUE_ACCESSOR */]]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵprd"](2048, null, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["m" /* NgControl */], null, [__WEBPACK_IMPORTED_MODULE_3__angular_forms__["l" /* NgModel */]]), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["n" /* NgControlStatus */], [__WEBPACK_IMPORTED_MODULE_3__angular_forms__["m" /* NgControl */]], null, null), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_5__src_app_trial_trial_component__["b" /* ValidateOnBlur */], [], { model: [0, 'model'] }, null),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵand"](16777216, null, null, 1, null, View_TrialComponent_4)), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_4__angular_common__["NgIf"], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["ViewContainerRef"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 8, 'input', [['class', 'trial__input'],
                ['id', 'txt-trial-lname'], ['name', 'lname'], ['placeholder', 'Last Name'],
                ['type', 'text'], ['validateOnBlur', '']], [[2, 'ng-untouched', null],
                [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                    null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
                [2, 'ng-pending', null]], [[null, 'ngModelChange'], [null,
                    'input'], [null, 'blur'], [null, 'compositionstart'], [null,
                    'compositionend'], [null, 'focus'], [null, 'focusout']], function (_v, en, $event) {
                var ad = true;
                var _co = _v.component;
                if (('input' === en)) {
                    var pd_0 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 52)._handleInput($event.target.value) !== false);
                    ad = (pd_0 && ad);
                }
                if (('blur' === en)) {
                    var pd_1 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 52).onTouched() !== false);
                    ad = (pd_1 && ad);
                }
                if (('compositionstart' === en)) {
                    var pd_2 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 52)._compositionStart() !== false);
                    ad = (pd_2 && ad);
                }
                if (('compositionend' === en)) {
                    var pd_3 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 52)._compositionEnd($event.target.value) !== false);
                    ad = (pd_3 && ad);
                }
                if (('focus' === en)) {
                    var pd_4 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 57).onFocus($event.target) !== false);
                    ad = (pd_4 && ad);
                }
                if (('focusout' === en)) {
                    var pd_5 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 57).onFocusout($event.target) !== false);
                    ad = (pd_5 && ad);
                }
                if (('ngModelChange' === en)) {
                    var pd_6 = ((_co.trialParams.LastName = $event) !== false);
                    ad = (pd_6 && ad);
                }
                return ad;
            }, null, null)), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](278528, null, 0, __WEBPACK_IMPORTED_MODULE_4__angular_common__["NgClass"], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["IterableDiffers"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["KeyValueDiffers"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["ElementRef"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["Renderer"]], { klass: [0,
                'klass'], ngClass: [1, 'ngClass'] }, null), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵpod"]({ 'trial__input': 0,
            'trial__input__error': 1 }), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["i" /* DefaultValueAccessor */], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["Renderer2"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["ElementRef"], [2, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["j" /* COMPOSITION_BUFFER_MODE */]]], null, null), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵprd"](1024, null, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["k" /* NG_VALUE_ACCESSOR */], function (p0_0) {
            return [p0_0];
        }, [__WEBPACK_IMPORTED_MODULE_3__angular_forms__["i" /* DefaultValueAccessor */]]), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](671744, [['lname', 4]], 0, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["l" /* NgModel */], [[2, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["g" /* ControlContainer */]],
            [8, null], [8, null], [2, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["k" /* NG_VALUE_ACCESSOR */]]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵprd"](2048, null, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["m" /* NgControl */], null, [__WEBPACK_IMPORTED_MODULE_3__angular_forms__["l" /* NgModel */]]), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["n" /* NgControlStatus */], [__WEBPACK_IMPORTED_MODULE_3__angular_forms__["m" /* NgControl */]], null, null), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_5__src_app_trial_trial_component__["b" /* ValidateOnBlur */], [], { model: [0, 'model'] }, null), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'div', [['class', 'trial-alert'], ['id', 'last_name_alert']], [[8, 'hidden', 0]], null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                  Last Name is required\n            '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 8, 'input', [['class', 'trial__input'], ['id', 'txt-trial-email'],
            ['name', 'email'], ['placeholder', 'Email Address'], ['type', 'email'], ['validateOnBlur',
                '']], [[2, 'ng-untouched', null], [2, 'ng-touched', null],
            [2, 'ng-pristine', null], [2, 'ng-dirty', null], [2, 'ng-valid',
                null], [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null, 'ngModelChange'], [null, 'input'], [null,
                'blur'], [null, 'compositionstart'], [null, 'compositionend'],
            [null, 'focus'], [null, 'focusout']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('input' === en)) {
                var pd_0 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 65)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 65).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 65)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 65)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('focus' === en)) {
                var pd_4 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 70).onFocus($event.target) !== false);
                ad = (pd_4 && ad);
            }
            if (('focusout' === en)) {
                var pd_5 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 70).onFocusout($event.target) !== false);
                ad = (pd_5 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_6 = ((_co.trialParams.Email = $event) !== false);
                ad = (pd_6 && ad);
            }
            return ad;
        }, null, null)), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](278528, null, 0, __WEBPACK_IMPORTED_MODULE_4__angular_common__["NgClass"], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["IterableDiffers"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["KeyValueDiffers"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["ElementRef"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["Renderer"]], { klass: [0,
                'klass'], ngClass: [1, 'ngClass'] }, null), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵpod"]({ 'trial__input': 0,
            'trial__input__error': 1 }), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["i" /* DefaultValueAccessor */], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["Renderer2"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["ElementRef"], [2, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["j" /* COMPOSITION_BUFFER_MODE */]]], null, null), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵprd"](1024, null, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["k" /* NG_VALUE_ACCESSOR */], function (p0_0) {
            return [p0_0];
        }, [__WEBPACK_IMPORTED_MODULE_3__angular_forms__["i" /* DefaultValueAccessor */]]), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](671744, [['email', 4]], 0, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["l" /* NgModel */], [[2, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["g" /* ControlContainer */]],
            [8, null], [8, null], [2, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["k" /* NG_VALUE_ACCESSOR */]]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵprd"](2048, null, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["m" /* NgControl */], null, [__WEBPACK_IMPORTED_MODULE_3__angular_forms__["l" /* NgModel */]]), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["n" /* NgControlStatus */], [__WEBPACK_IMPORTED_MODULE_3__angular_forms__["m" /* NgControl */]], null, null), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_5__src_app_trial_trial_component__["b" /* ValidateOnBlur */], [], { model: [0, 'model'] }, null), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 7, 'div', [['class', 'trial-alert']], [[8, 'hidden', 0]], null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵand"](16777216, null, null, 1, null, View_TrialComponent_5)), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_4__angular_common__["NgIf"], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["ViewContainerRef"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵand"](16777216, null, null, 1, null, View_TrialComponent_6)), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_4__angular_common__["NgIf"], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["ViewContainerRef"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 11, 'input', [['id', 'txt-trial-password'], ['name', 'pword'], ['placeholder',
                'Choose a password'], ['required', ''], ['reverse', 'true'], ['title', 'Must contain 8 characters, at least one number, one capital letter and one special character.'],
            ['type', 'password'], ['validateEqual', 'pwordRetry'], ['validateOnBlur',
                '']], [[1, 'required', 0], [2, 'ng-untouched', null], [2, 'ng-touched',
                null], [2, 'ng-pristine', null], [2, 'ng-dirty', null],
            [2, 'ng-valid', null], [2, 'ng-invalid', null], [2, 'ng-pending',
                null]], [[null, 'ngModelChange'], [null,
                'input'], [null, 'blur'], [null, 'compositionstart'], [null,
                'compositionend'], [null, 'focus'], [null, 'focusout']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('input' === en)) {
                var pd_0 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 84)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 84).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 84)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 84)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('focus' === en)) {
                var pd_4 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 92).onFocus($event.target) !== false);
                ad = (pd_4 && ad);
            }
            if (('focusout' === en)) {
                var pd_5 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 92).onFocusout($event.target) !== false);
                ad = (pd_5 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_6 = ((_co.trialParams.Password = $event) !== false);
                ad = (pd_6 && ad);
            }
            return ad;
        }, null, null)), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](278528, null, 0, __WEBPACK_IMPORTED_MODULE_4__angular_common__["NgClass"], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["IterableDiffers"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["KeyValueDiffers"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["ElementRef"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["Renderer"]], { ngClass: [0,
                'ngClass'] }, null), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵpod"]({ 'trial__input': 0, 'trial__input__error': 1 }),
        __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["i" /* DefaultValueAccessor */], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["Renderer2"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["ElementRef"],
            [2, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["j" /* COMPOSITION_BUFFER_MODE */]]], null, null), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["o" /* RequiredValidator */], [], { required: [0, 'required'] }, null), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_6__src_app_components_equal_validator_directive__["a" /* EqualValidator */], [[8, 'pwordRetry'],
            [8, 'true']], null, null), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵprd"](1024, null, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["p" /* NG_VALIDATORS */], function (p0_0, p1_0) {
            return [p0_0, p1_0];
        }, [__WEBPACK_IMPORTED_MODULE_3__angular_forms__["o" /* RequiredValidator */], __WEBPACK_IMPORTED_MODULE_6__src_app_components_equal_validator_directive__["a" /* EqualValidator */]]), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵprd"](1024, null, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["k" /* NG_VALUE_ACCESSOR */], function (p0_0) {
            return [p0_0];
        }, [__WEBPACK_IMPORTED_MODULE_3__angular_forms__["i" /* DefaultValueAccessor */]]), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](671744, [['pword', 4]], 0, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["l" /* NgModel */], [[2,
                __WEBPACK_IMPORTED_MODULE_3__angular_forms__["g" /* ControlContainer */]], [2, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["p" /* NG_VALIDATORS */]], [8, null], [2, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["k" /* NG_VALUE_ACCESSOR */]]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵprd"](2048, null, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["m" /* NgControl */], null, [__WEBPACK_IMPORTED_MODULE_3__angular_forms__["l" /* NgModel */]]), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["n" /* NgControlStatus */], [__WEBPACK_IMPORTED_MODULE_3__angular_forms__["m" /* NgControl */]], null, null), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_5__src_app_trial_trial_component__["b" /* ValidateOnBlur */], [], { model: [0, 'model'] }, null),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n\n            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'div', [['class', 'trial-alert'], ['id', 'invalid_pass_alert']], [[8, 'hidden', 0]], null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                  Invalid password format\n            '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 8, 'input', [['id', 'txt-trial-password-retype'], ['name', 'pwordRetry'],
            ['ngModel', ''], ['placeholder', 'Re-type password'], ['type', 'password'],
            ['validateOnBlur', '']], [[2, 'ng-untouched', null], [2, 'ng-touched',
                null], [2, 'ng-pristine', null], [2, 'ng-dirty', null],
            [2, 'ng-valid', null], [2, 'ng-invalid', null], [2, 'ng-pending',
                null]], [[null, 'input'], [null, 'blur'],
            [null, 'compositionstart'], [null, 'compositionend'],
            [null, 'focus'], [null, 'focusout']], function (_v, en, $event) {
            var ad = true;
            if (('input' === en)) {
                var pd_0 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 100)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 100).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 100)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 100)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('focus' === en)) {
                var pd_4 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 105).onFocus($event.target) !== false);
                ad = (pd_4 && ad);
            }
            if (('focusout' === en)) {
                var pd_5 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 105).onFocusout($event.target) !== false);
                ad = (pd_5 && ad);
            }
            return ad;
        }, null, null)), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](278528, null, 0, __WEBPACK_IMPORTED_MODULE_4__angular_common__["NgClass"], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["IterableDiffers"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["KeyValueDiffers"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["ElementRef"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["Renderer"]], { ngClass: [0,
                'ngClass'] }, null), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵpod"]({ 'trial__input': 0, 'trial__input__error': 1 }),
        __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["i" /* DefaultValueAccessor */], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["Renderer2"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["ElementRef"],
            [2, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["j" /* COMPOSITION_BUFFER_MODE */]]], null, null), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵprd"](1024, null, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["k" /* NG_VALUE_ACCESSOR */], function (p0_0) {
            return [p0_0];
        }, [__WEBPACK_IMPORTED_MODULE_3__angular_forms__["i" /* DefaultValueAccessor */]]), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](671744, [['pwordRetry', 4]], 0, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["l" /* NgModel */], [[2, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["g" /* ControlContainer */]], [8, null], [8, null], [2, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["k" /* NG_VALUE_ACCESSOR */]]], { name: [0, 'name'], model: [1, 'model'] }, null), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵprd"](2048, null, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["m" /* NgControl */], null, [__WEBPACK_IMPORTED_MODULE_3__angular_forms__["l" /* NgModel */]]), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["n" /* NgControlStatus */], [__WEBPACK_IMPORTED_MODULE_3__angular_forms__["m" /* NgControl */]], null, null), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_5__src_app_trial_trial_component__["b" /* ValidateOnBlur */], [], { model: [0, 'model'] }, null), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'div', [['class', 'trial-alert'], ['id', 'pass_not_match_alert']], [[8, 'hidden', 0]], null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n                  Password does not match\n            '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵand"](16777216, null, null, 1, null, View_TrialComponent_7)), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_4__angular_common__["NgIf"], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["ViewContainerRef"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵand"](16777216, null, null, 1, null, View_TrialComponent_8)),
        __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_4__angular_common__["NgIf"], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["ViewContainerRef"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵand"](16777216, null, null, 1, null, View_TrialComponent_9)),
        __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_4__angular_common__["NgIf"], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["ViewContainerRef"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 0, 'div', [['class', 'trial__captcha'],
            ['id', 'create-account-captcha']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 0, 'div', [['style', 'width:304px']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 18, 'div', [['class', 'trial__checkbox']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, [['chkTOS', 1]], null, 7, 'input', [['id', 'chkTOS'], ['name',
                'chkTOS'], ['ngModel', ''], ['required', ''], ['type', 'checkbox']], [[1, 'required',
                0], [2, 'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'change'], [null, 'blur']], function (_v, en, $event) {
            var ad = true;
            if (('change' === en)) {
                var pd_0 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 127).onChange($event.target.checked) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 127).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["q" /* CheckboxControlValueAccessor */], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["Renderer2"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["ElementRef"]], null, null), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["r" /* CheckboxRequiredValidator */], [], { required: [0,
                'required'] }, null), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵprd"](1024, null, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["p" /* NG_VALIDATORS */], function (p0_0) {
            return [p0_0];
        }, [__WEBPACK_IMPORTED_MODULE_3__angular_forms__["r" /* CheckboxRequiredValidator */]]), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵprd"](1024, null, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["k" /* NG_VALUE_ACCESSOR */], function (p0_0) {
            return [p0_0];
        }, [__WEBPACK_IMPORTED_MODULE_3__angular_forms__["q" /* CheckboxControlValueAccessor */]]), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](671744, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["l" /* NgModel */], [[2, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["g" /* ControlContainer */]], [2, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["p" /* NG_VALIDATORS */]], [8, null], [2, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["k" /* NG_VALUE_ACCESSOR */]]], { name: [0, 'name'], model: [1, 'model'] }, null), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵprd"](2048, null, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["m" /* NgControl */], null, [__WEBPACK_IMPORTED_MODULE_3__angular_forms__["l" /* NgModel */]]), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["n" /* NgControlStatus */], [__WEBPACK_IMPORTED_MODULE_3__angular_forms__["m" /* NgControl */]], null, null), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 0, 'label', [['for', 'chkTOS']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'div', [['class', 'trial__checkbox-font']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['I agree with the '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n            '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'a', [['class', 'trial__checkbox-font'], ['style', 'color:#9abc7d; cursor:pointer']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.showTOS() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['Terms of Service'])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'button', [['class', 'trial__btn btn'], ['id', 'btn-trial-submit'], ['type', 'submit']], [[8, 'disabled', 0]], null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['SIGNUP'])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n    '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n\n    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵand"](16777216, null, null, 1, null, View_TrialComponent_10)), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_4__angular_common__["NgIf"], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["ViewContainerRef"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.showAlreadyUserLogin;
        _ck(_v, 24, 0, currVal_0);
        var currVal_8 = _ck(_v, 28, 0, _co.getShowAlreadyUser());
        _ck(_v, 27, 0, currVal_8);
        var currVal_16 = _ck(_v, 38, 0, (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 41).pristine || (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 41).pristine || __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 41).valid)), !(__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 41).pristine || (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 41).pristine || __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 41).valid)));
        _ck(_v, 37, 0, currVal_16);
        var currVal_17 = 'fname';
        var currVal_18 = _co.trialParams.FirstName;
        _ck(_v, 41, 0, currVal_17, currVal_18);
        var currVal_19 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 41);
        _ck(_v, 44, 0, currVal_19);
        var currVal_20 = !_co.showAlreadyUserLogin;
        _ck(_v, 47, 0, currVal_20);
        var currVal_28 = 'trial__input';
        var currVal_29 = _ck(_v, 51, 0, (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 54).pristine || (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 54).pristine || __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 54).valid)), !(__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 54).pristine || (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 54).pristine || __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 54).valid)));
        _ck(_v, 50, 0, currVal_28, currVal_29);
        var currVal_30 = 'lname';
        var currVal_31 = _co.trialParams.LastName;
        _ck(_v, 54, 0, currVal_30, currVal_31);
        var currVal_32 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 54);
        _ck(_v, 57, 0, currVal_32);
        var currVal_41 = 'trial__input';
        var currVal_42 = _ck(_v, 64, 0, (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 67).pristine || ((__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 67).pristine || __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 67).valid) || __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 67).pending)), (!__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 67).pending && !(__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 67).pristine || (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 67).pristine || __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 67).valid))));
        _ck(_v, 63, 0, currVal_41, currVal_42);
        var currVal_43 = 'email';
        var currVal_44 = _co.trialParams.Email;
        _ck(_v, 67, 0, currVal_43, currVal_44);
        var currVal_45 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 67);
        _ck(_v, 70, 0, currVal_45);
        var currVal_47 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 67).hasError('required');
        _ck(_v, 75, 0, currVal_47);
        var currVal_48 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 67).hasError('pattern') && !__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 67).hasError('required'));
        _ck(_v, 78, 0, currVal_48);
        var currVal_57 = _ck(_v, 83, 0, (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 89).pristine || (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 89).pristine || __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 89).valid)), !(__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 89).pristine || (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 89).pristine || __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 89).valid)));
        _ck(_v, 82, 0, currVal_57);
        var currVal_58 = '';
        _ck(_v, 85, 0, currVal_58);
        var currVal_59 = 'pword';
        var currVal_60 = _co.trialParams.Password;
        _ck(_v, 89, 0, currVal_59, currVal_60);
        var currVal_61 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 89);
        _ck(_v, 92, 0, currVal_61);
        var currVal_70 = _ck(_v, 99, 0, (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 102).pristine || __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 102).valid), !(__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 102).pristine || (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 102).pristine || __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 102).valid)));
        _ck(_v, 98, 0, currVal_70);
        var currVal_71 = 'pwordRetry';
        var currVal_72 = '';
        _ck(_v, 102, 0, currVal_71, currVal_72);
        var currVal_73 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 102);
        _ck(_v, 105, 0, currVal_73);
        var currVal_75 = _co.showRegCode;
        _ck(_v, 111, 0, currVal_75);
        var currVal_76 = _co.showRegCode;
        _ck(_v, 114, 0, currVal_76);
        var currVal_77 = _co.showPromoCode;
        _ck(_v, 117, 0, currVal_77);
        var currVal_86 = '';
        _ck(_v, 128, 0, currVal_86);
        var currVal_87 = 'chkTOS';
        var currVal_88 = '';
        _ck(_v, 131, 0, currVal_87, currVal_88);
        var currVal_90 = _co.error;
        _ck(_v, 149, 0, currVal_90);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_1 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 32).ngClassUntouched;
        var currVal_2 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 32).ngClassTouched;
        var currVal_3 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 32).ngClassPristine;
        var currVal_4 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 32).ngClassDirty;
        var currVal_5 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 32).ngClassValid;
        var currVal_6 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 32).ngClassInvalid;
        var currVal_7 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 32).ngClassPending;
        _ck(_v, 26, 0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7);
        var currVal_9 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 43).ngClassUntouched;
        var currVal_10 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 43).ngClassTouched;
        var currVal_11 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 43).ngClassPristine;
        var currVal_12 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 43).ngClassDirty;
        var currVal_13 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 43).ngClassValid;
        var currVal_14 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 43).ngClassInvalid;
        var currVal_15 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 43).ngClassPending;
        _ck(_v, 36, 0, currVal_9, currVal_10, currVal_11, currVal_12, currVal_13, currVal_14, currVal_15);
        var currVal_21 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 56).ngClassUntouched;
        var currVal_22 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 56).ngClassTouched;
        var currVal_23 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 56).ngClassPristine;
        var currVal_24 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 56).ngClassDirty;
        var currVal_25 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 56).ngClassValid;
        var currVal_26 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 56).ngClassInvalid;
        var currVal_27 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 56).ngClassPending;
        _ck(_v, 49, 0, currVal_21, currVal_22, currVal_23, currVal_24, currVal_25, currVal_26, currVal_27);
        var currVal_33 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 54).pristine || __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 54).valid);
        _ck(_v, 59, 0, currVal_33);
        var currVal_34 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 69).ngClassUntouched;
        var currVal_35 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 69).ngClassTouched;
        var currVal_36 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 69).ngClassPristine;
        var currVal_37 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 69).ngClassDirty;
        var currVal_38 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 69).ngClassValid;
        var currVal_39 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 69).ngClassInvalid;
        var currVal_40 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 69).ngClassPending;
        _ck(_v, 62, 0, currVal_34, currVal_35, currVal_36, currVal_37, currVal_38, currVal_39, currVal_40);
        var currVal_46 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 67).pristine || ((__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 67).pristine || __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 67).valid) || __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 67).pending));
        _ck(_v, 72, 0, currVal_46);
        var currVal_49 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 85).required ? '' : null);
        var currVal_50 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 91).ngClassUntouched;
        var currVal_51 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 91).ngClassTouched;
        var currVal_52 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 91).ngClassPristine;
        var currVal_53 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 91).ngClassDirty;
        var currVal_54 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 91).ngClassValid;
        var currVal_55 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 91).ngClassInvalid;
        var currVal_56 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 91).ngClassPending;
        _ck(_v, 81, 0, currVal_49, currVal_50, currVal_51, currVal_52, currVal_53, currVal_54, currVal_55, currVal_56);
        var currVal_62 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 89).pristine || (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 89).pristine || __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 89).valid));
        _ck(_v, 94, 0, currVal_62);
        var currVal_63 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 104).ngClassUntouched;
        var currVal_64 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 104).ngClassTouched;
        var currVal_65 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 104).ngClassPristine;
        var currVal_66 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 104).ngClassDirty;
        var currVal_67 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 104).ngClassValid;
        var currVal_68 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 104).ngClassInvalid;
        var currVal_69 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 104).ngClassPending;
        _ck(_v, 97, 0, currVal_63, currVal_64, currVal_65, currVal_66, currVal_67, currVal_68, currVal_69);
        var currVal_74 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 102).pristine || (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 102).pristine || __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 102).valid));
        _ck(_v, 107, 0, currVal_74);
        var currVal_78 = (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 128).required ? '' : null);
        var currVal_79 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 133).ngClassUntouched;
        var currVal_80 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 133).ngClassTouched;
        var currVal_81 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 133).ngClassPristine;
        var currVal_82 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 133).ngClassDirty;
        var currVal_83 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 133).ngClassValid;
        var currVal_84 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 133).ngClassInvalid;
        var currVal_85 = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 133).ngClassPending;
        _ck(_v, 126, 0, currVal_78, currVal_79, currVal_80, currVal_81, currVal_82, currVal_83, currVal_84, currVal_85);
        var currVal_89 = ((!_co.captchaResponse || !__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 30).valid) || !__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵnov"](_v, 126).checked);
        _ck(_v, 144, 0, currVal_89);
    });
}
function View_TrialComponent_12(_l) {
    return __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'div', [['class',
                'row heading-1']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['We have created an Ixia identity account for you and sent you an email with instructions on how ']))], null, null);
}
function View_TrialComponent_13(_l) {
    return __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'div', [['class',
                'row heading-1']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['to activate it (do so within the next 2 days to remain authenticated). You will use this account to ']))], null, null);
}
function View_TrialComponent_14(_l) {
    return __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'div', [['class',
                'row heading-1'], ['style', 'margin-bottom:48px;']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['login into BreakingPoint Cloud and all other Ixia cloud applications']))], null, null);
}
function View_TrialComponent_11(_l) {
    return __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 22, 'div', [['class',
                'col-sm-12'], ['style', ' text-align: center; margin-top: 145px;']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'div', [['class',
                'row heading-0']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['All set and ready to go!'])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'div', [['class',
                'row heading-1']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['You can start testing BreakingPoint Cloud right away.'])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵand"](16777216, null, null, 1, null, View_TrialComponent_12)), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_4__angular_common__["NgIf"], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["ViewContainerRef"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵand"](16777216, null, null, 1, null, View_TrialComponent_13)), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_4__angular_common__["NgIf"], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["ViewContainerRef"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵand"](16777216, null, null, 1, null, View_TrialComponent_14)), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_4__angular_common__["NgIf"], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["ViewContainerRef"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 4, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n      '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'button', [['class', 'btn cloud-btn-style'],
            ['style', 'width:200px;']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.startTrial() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['START TRIAL'])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = !_co.showAlreadyUserLogin;
        _ck(_v, 9, 0, currVal_0);
        var currVal_1 = !_co.showAlreadyUserLogin;
        _ck(_v, 12, 0, currVal_1);
        var currVal_2 = !_co.showAlreadyUserLogin;
        _ck(_v, 15, 0, currVal_2);
    }, null);
}
function View_TrialComponent_0(_l) {
    return __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵvid"](0, [__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵqud"](402653184, 1, { loading: 0 }), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵqud"](402653184, 2, { license: 0 }),
        __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵqud"](671088640, 3, { trialForm: 0 }), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'modal-loading', [], null, null, null, __WEBPACK_IMPORTED_MODULE_7__modals_modal_loading_component_ngfactory__["a" /* View_LoadingModal_0 */], __WEBPACK_IMPORTED_MODULE_7__modals_modal_loading_component_ngfactory__["b" /* RenderType_LoadingModal */])), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](114688, [[1, 4],
            ['loading', 4]], 0, __WEBPACK_IMPORTED_MODULE_8__src_app_modals_modal_loading_component__["a" /* LoadingModal */], [__WEBPACK_IMPORTED_MODULE_9__src_app_modals_modal_service__["a" /* ModalService */]], null, null),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n'])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 6, 'div', [['class', 'header-component']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n    '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 3, 'div', [['class', 'logo']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 0, 'img', [['class',
                'breakingpoint-cloud-logo'], ['src', '/assets/logo.ce16449cf57d7db95102b696b4a4355a.svg']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n'])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n'])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵand"](16777216, null, null, 1, null, View_TrialComponent_1)), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_4__angular_common__["NgIf"], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["ViewContainerRef"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n\n'])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵand"](16777216, null, null, 1, null, View_TrialComponent_11)), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](16384, null, 0, __WEBPACK_IMPORTED_MODULE_4__angular_common__["NgIf"], [__WEBPACK_IMPORTED_MODULE_2__angular_core__["ViewContainerRef"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null),
        (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n\n'])), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](0, null, null, 1, 'licensing-component', [], null, null, null, __WEBPACK_IMPORTED_MODULE_10__licensing_licensing_component_ngfactory__["b" /* View_LicensingComponent_0 */], __WEBPACK_IMPORTED_MODULE_10__licensing_licensing_component_ngfactory__["c" /* RenderType_LicensingComponent */])), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](114688, [[2, 4], ['license', 4]], 0, __WEBPACK_IMPORTED_MODULE_11__src_app_licensing_licensing_component__["a" /* LicensingComponent */], [__WEBPACK_IMPORTED_MODULE_12__angular_router__["a" /* Router */]], null, null), (_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵted"](null, ['\n']))], function (_ck, _v) {
        var _co = _v.component;
        _ck(_v, 4, 0);
        var currVal_0 = !_co.registered;
        _ck(_v, 15, 0, currVal_0);
        var currVal_1 = _co.registered;
        _ck(_v, 18, 0, currVal_1);
        _ck(_v, 21, 0);
    }, null);
}
function View_TrialComponent_Host_0(_l) {
    return __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵeld"](16777216, null, null, 1, 'trial', [], null, null, null, View_TrialComponent_0, RenderType_TrialComponent)), __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵdid"](114688, null, 0, __WEBPACK_IMPORTED_MODULE_5__src_app_trial_trial_component__["a" /* TrialComponent */], [__WEBPACK_IMPORTED_MODULE_13__src_app_trial_trial_service__["a" /* TrialService */], __WEBPACK_IMPORTED_MODULE_14__src_app_login_user_login_service__["a" /* LoginService */], __WEBPACK_IMPORTED_MODULE_15__src_app_user_user_service__["a" /* UserService */], __WEBPACK_IMPORTED_MODULE_12__angular_router__["a" /* Router */], __WEBPACK_IMPORTED_MODULE_12__angular_router__["b" /* ActivatedRoute */],
            __WEBPACK_IMPORTED_MODULE_16__src_app_headerfooter_setting_entries_tos_entry__["a" /* TOSEntry */], __WEBPACK_IMPORTED_MODULE_2__angular_core__["ViewContainerRef"], __WEBPACK_IMPORTED_MODULE_17__src_app_aws_environment__["a" /* AwsEnvironment */]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var TrialComponentNgFactory = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵccf"]('trial', __WEBPACK_IMPORTED_MODULE_5__src_app_trial_trial_component__["a" /* TrialComponent */], View_TrialComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=trial.component.ngfactory.js.map

/***/ }),
/* 566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return styles; });
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */
var styles = ['[_nghost-%COMP%] {\n  width: 100vw;\n  height: 100%;\n  background-color: #F1F1F1;\n  display: block; }\n\n.header-component[_ngcontent-%COMP%] {\n  width: 100%;\n  height: 58px;\n  background-color: #1D1D1D;\n  padding-top: 18px !important; }\n\n.heading-0[_ngcontent-%COMP%] {\n  font-size: 32px;\n  color: #4dacd7;\n  margin-bottom: 15px;\n  font-family: open_sans;\n  font-weight: lighter; }\n\n.heading-1[_ngcontent-%COMP%] {\n  font-size: 14px;\n  color: #a6a6a6;\n  margin-bottom: 15px; }\n\n.breakingpoint-cloud-logo[_ngcontent-%COMP%] {\n  width: 200px;\n  height: 40px; }\n\n.logo[_ngcontent-%COMP%] {\n  cursor: pointer; }\n\n.container[_ngcontent-%COMP%] {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  background-color: #F1F1F1;\n  width: 100%;\n  height: 85%;\n  margin-top: 50px; }\n\n.container2[_ngcontent-%COMP%] {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  background-color: #F1F1F1;\n  width: 85%;\n  height: 85%; }\n\n.trial__box[_ngcontent-%COMP%] {\n  border-left: thin lightgrey solid;\n  border-right: thin lightgrey solid;\n  border-bottom: thin lightgrey solid;\n  border-top: 0px red solid;\n  background-color: white;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 20px;\n  width: 100%; }\n\n.trial__false-top[_ngcontent-%COMP%] {\n  background-color: white;\n  border-left: thin lightgrey solid;\n  border-right: thin lightgrey solid;\n  border-top: thin lightgrey solid;\n  border-bottom: 0px red solid;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 20px 20px 0px 20px; }\n\n.trial__checkbox[_ngcontent-%COMP%] {\n  display: flex;\n  align-content: flex-start;\n  margin-bottom: 15px;\n  margin-top: 15px; }\n  .trial__checkbox-font[_ngcontent-%COMP%] {\n    font-size: 12px;\n    font-weight: normal;\n    margin-top: 3px;\n    margin-left: 5px;\n    margin-bottom: 0px !important; }\n\n.trial__form[_ngcontent-%COMP%] {\n  display: flex;\n  flex-direction: column;\n  min-width: 170px;\n  align-items: center; }\n\n.trial__captcha[_ngcontent-%COMP%] {\n  margin-bottom: 15px; }\n\n.trial__forgot-password[_ngcontent-%COMP%] {\n  align-self: flex-end; }\n\n.trial__input[_ngcontent-%COMP%] {\n  margin-bottom: 22px;\n  width: 100%;\n  text-indent: 10px;\n  height: 40px;\n  font-size: 14px;\n  color: #555;\n  border: 1px solid #ccc;\n  -webkit-box-shadow: inset 0 0px 1px rgba(0, 0, 0, 0.075);\n  box-shadow: inset 0 0px 1px rgba(0, 0, 0, 0.075); }\n\n.trial__input[_ngcontent-%COMP%]::-moz-placeholder {\n  color: #bababa;\n  opacity: 1; }\n\n.trial__input[_ngcontent-%COMP%]:-ms-input-placeholder {\n  color: #bababa; }\n\n.trial__input[_ngcontent-%COMP%]::-webkit-input-placeholder {\n  color: #bababa; }\n\n.trial__input__error[_ngcontent-%COMP%] {\n  width: 100%;\n  text-indent: 10px;\n  height: 40px;\n  font-size: 14px;\n  color: #555;\n  -webkit-box-shadow: inset 0 0px 1px rgba(0, 0, 0, 0.075);\n  box-shadow: inset 0 0px 1px rgba(0, 0, 0, 0.075);\n  margin-bottom: 0px !important;\n  border: 1px solid  #e93131 !important;\n  outline: none; }\n\n.trial__btn[_ngcontent-%COMP%] {\n  width: 280px;\n  height: 40px;\n  background: #9ABC7D;\n  color: #FFFFFF !important;\n  border-radius: 0px !important; }\n\n.trial__btn[_ngcontent-%COMP%]:hover {\n  color: #FFFFFF !important; }\n\n.trial__btn[disabled][_ngcontent-%COMP%]:hover {\n  background: #B8B8B8; }\n\n.trial__btn[disabled][_ngcontent-%COMP%]:active:focus {\n  color: #B8B8B8; }\n\n.trial__btn[disabled][_ngcontent-%COMP%] {\n  background: #D9D9D9;\n  color: #B8B8B8; }\n\ninput[type=checkbox][_ngcontent-%COMP%] {\n  display: none !important; }\n\ninput[type=checkbox][_ngcontent-%COMP%]    + label[_ngcontent-%COMP%] {\n  background: url(/assets/checkbox.99d257d74d91f2c9d71d775922462ba3.svg);\n  height: 16px;\n  width: 16px;\n  display: inline-block;\n  padding: 0 0 0 0px; }\n\ninput[type=checkbox][_ngcontent-%COMP%]:checked    + label[_ngcontent-%COMP%] {\n  background: url(/assets/checkbox_checked.f893b57a8f4a3914222435eea76e2474.svg);\n  height: 16px;\n  width: 16px;\n  display: inline-block;\n  padding: 0 0 0 0px; }\n\n.attack-error-div[_ngcontent-%COMP%] {\n  padding-top: 20px;\n  display: flex;\n  flex-direction: row; }\n\n.attack-error-icon[_ngcontent-%COMP%] {\n  height: 20px;\n  width: 20px;\n  min-width: 20px;\n  background-image: url(/assets/error.bdaf0008c084b16da681ad026a92d8d3.svg); }\n\n.attack-error-label[_ngcontent-%COMP%] {\n  word-wrap: break-word;\n  color: #666;\n  font-size: 13px;\n  margin-left: 10px;\n  line-height: 20px; }\n\n.login-link-style-sm[_ngcontent-%COMP%] {\n  font-size: 12px;\n  font-weight: normal;\n  color: #626262;\n  cursor: pointer;\n  margin-left: 4px; }\n\n.trial-alert[_ngcontent-%COMP%] {\n  font-size: 13px;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  color: #e93131;\n  margin: 4px 0px; }\n\n.ng-touched[_ngcontent-%COMP%]   .ng-invalid[_ngcontent-%COMP%]:not(form) {\n  display: flex;\n  flex-direction: column;\n  border-color: #cfcfcf;\n  flex-grow: 1;\n  outline: none; }'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3NyYy91aS9zcmMvYXBwL3RyaWFsL3RyaWFsLmNvbXBvbmVudC5zY3NzLnNoaW0ubmdzdHlsZS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL3NyYy91aS9zcmMvYXBwL3RyaWFsL3RyaWFsLmNvbXBvbmVudC5zY3NzIl0sInNvdXJjZXNDb250ZW50IjpbIiAiXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7OzsifQ==
//# sourceMappingURL=trial.component.scss.shim.ngstyle.js.map

/***/ }),
/* 567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ClipboardModule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__clipboard_directive__ = __webpack_require__(308);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__clipboard_service__ = __webpack_require__(134);
/* unused harmony namespace reexport */


var ClipboardModule = /** @class */ (function () {
    function ClipboardModule() {
    }
    return ClipboardModule;
}());

//# sourceMappingURL=index.js.map

/***/ }),
/* 568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AppModule; });
var AppModule = /** @class */ (function () {
    function AppModule() {
    }
    return AppModule;
}());

//# sourceMappingURL=app.module.js.map

/***/ }),
/* 569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AwsModule; });
var AwsModule = /** @class */ (function () {
    function AwsModule() {
    }
    return AwsModule;
}());

//# sourceMappingURL=aws.module.js.map

/***/ }),
/* 570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Credentials; });
var Credentials = /** @class */ (function () {
    function Credentials() {
    }
    return Credentials;
}());

//# sourceMappingURL=credentials.js.map

/***/ }),
/* 571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BillingModule; });
var BillingModule = /** @class */ (function () {
    function BillingModule() {
    }
    return BillingModule;
}());

//# sourceMappingURL=billing.module.js.map

/***/ }),
/* 572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BillingCycle */
/* unused harmony export BillingMetrics */
/* unused harmony export InvoiceInfo */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BillingInfo; });
var BillingCycle = /** @class */ (function () {
    function BillingCycle() {
        this.items = [];
        this.totalGb = 0;
        this.cost = 'N/A';
        this.invoiceUrl = '';
    }
    BillingCycle.prototype.calculateTotal = function () {
        for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
            var project = _a[_i];
            this.totalGb += parseFloat(((project.bytes / 1000000) / 1000).toFixed(3));
        }
    };
    return BillingCycle;
}());

var BillingMetrics = /** @class */ (function () {
    function BillingMetrics() {
    }
    return BillingMetrics;
}());

var InvoiceInfo = /** @class */ (function () {
    function InvoiceInfo() {
        this.invoiceForDate = '';
    }
    return InvoiceInfo;
}());

var BillingInfo = /** @class */ (function () {
    function BillingInfo(result) {
        var _this = this;
        this.monthNames = [
            '',
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December'
        ];
        this.cycles = Object.keys(result).map(function (date) {
            var cycle = result[date];
            var billingCycle = new BillingCycle();
            var _a = date.split('-'), year = _a[0], month = _a[1], remaining = _a.slice(2);
            var monthIndex = Number(month);
            billingCycle.monthIndex = monthIndex;
            billingCycle.year = Number(year);
            // get last day
            var lastDay = _this.daysInMonth(monthIndex, Number(year));
            var monthName = _this.monthNames[monthIndex];
            var startDate = monthName + ' 1st';
            var endDate = monthName + ' ' + String(lastDay) + _this.getSuffix(lastDay);
            billingCycle.name = startDate + ' - ' + endDate + ' ' + year;
            billingCycle.items = Object.keys(cycle).map(function (itemKey) {
                var item = cycle[itemKey];
                var hours = item.Hours;
                var bytes = item.Bytes;
                var billingMetrics = new BillingMetrics();
                billingMetrics.bytes = Number(bytes);
                return billingMetrics;
            });
            billingCycle.calculateTotal();
            return billingCycle;
        });
    }
    BillingInfo.prototype.daysInMonth = function (month, year) {
        return 32 - new Date(year, month - 1, 32).getDate();
    };
    BillingInfo.prototype.getSuffix = function (day) {
        var suffix = '';
        switch (day % 10) {
            case 1:
                suffix = 'st';
                break;
            case 2:
                suffix = 'nd';
                break;
            case 3:
                suffix = 'rd';
                break;
            default:
                suffix = 'th';
        }
        return suffix;
    };
    BillingInfo.prototype.orderDescending = function () {
        this.cycles.sort(function (firstCycle, secondCycle) {
            var firstDate = new Date(firstCycle.year, firstCycle.monthIndex - 1, 1);
            var secondDate = new Date(secondCycle.year, secondCycle.monthIndex - 1, 1);
            return firstDate > secondDate ? -1 : 1;
        });
    };
    //Return current month and any past month with an invoice
    BillingInfo.prototype.removePast2MonthsSansInvoice = function () {
        this.cycles = this.cycles.filter(function (cycle, index) {
            if (index === 0) {
                return cycle;
            }
            if (cycle.invoiceUrl) {
                return cycle;
            }
            return false;
        });
    };
    BillingInfo.prototype.updateCyclesWithCostInfo = function (invoices) {
        for (var _i = 0, invoices_1 = invoices; _i < invoices_1.length; _i++) {
            var invoice = invoices_1[_i];
            var _a = invoice.invoiceForDate.split('-'), year = _a[0], month = _a[1], remaining = _a.slice(2);
            var monthIndex = Number(month);
            for (var _b = 0, _c = this.cycles; _b < _c.length; _b++) {
                var cycle = _c[_b];
                if (cycle.monthIndex == monthIndex && cycle.year == Number(year)) {
                    cycle.cost = new Intl.NumberFormat('en-US', {
                        style: 'currency',
                        currency: 'USD',
                        minimumFractionDigits: 2
                    }).format(invoice.amount);
                    cycle.invoiceUrl = String(invoice.downloadObjectUrl);
                }
            }
        }
    };
    return BillingInfo;
}());

//# sourceMappingURL=billing.js.map

/***/ }),
/* 573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EqualValidator; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(2);

var EqualValidator = /** @class */ (function () {
    function EqualValidator(validateEqual, reverse) {
        this.validateEqual = validateEqual;
        this.reverse = reverse;
    }
    Object.defineProperty(EqualValidator.prototype, "isReverse", {
        get: function () {
            if (!this.reverse)
                return false;
            return this.reverse === 'true' ? true : false;
        },
        enumerable: true,
        configurable: true
    });
    EqualValidator.prototype.validate = function (c) {
        // self value
        var v = c.value;
        // control vlaue
        var e = c.root.get(this.validateEqual);
        // value not equal
        if (e && v !== e.value && !this.isReverse) {
            return {
                validateEqual: false
            };
        }
        // value equal and reverse
        if (e && v === e.value && this.isReverse) {
            delete e.errors['validateEqual'];
            if (!Object.keys(e.errors).length)
                e.setErrors(null);
        }
        // value not equal and reverse
        if (e && v !== e.value && this.isReverse) {
            e.setErrors({ validateEqual: false });
        }
        return null;
    };
    EqualValidator.ctorParameters = function () { return [{ type: null, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Attribute"], args: ['validateEqual'] }] }, { type: null, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Attribute"], args: ['reverse'] }] }]; };
    return EqualValidator;
}());

//# sourceMappingURL=equal-validator.directive.js.map

/***/ }),
/* 574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InputTrimDirective; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_forms__ = __webpack_require__(65);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var InputTrimDirective = /** @class */ (function (_super) {
    __extends(InputTrimDirective, _super);
    function InputTrimDirective(renderer, elementRef, compositionMode) {
        var _this = _super.call(this, renderer, elementRef, compositionMode) || this;
        /**
         * Keep the type of input element in a cache.
         *
         * @type {string}
         * @private
         */
        _this._type = 'text';
        _this._sourceRenderer = renderer;
        _this._sourceElementRef = elementRef;
        return _this;
    }
    Object.defineProperty(InputTrimDirective.prototype, "type", {
        // Get the element type
        get: function () {
            return this._type;
        },
        set: function (value) {
            this._type = value || 'text';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputTrimDirective.prototype, "value", {
        /**
         * Set a new value to the field and model.
         *
         */
        set: function (val) {
            // update element
            this.writeValue(val);
            // update model
            this.onChange(val);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Updates the value on the blur event.
     */
    InputTrimDirective.prototype.onBlur = function (event, value) {
        this.updateValue(event, value);
    };
    /**
     * Updates the value on the input event.
     */
    InputTrimDirective.prototype.onInput = function (event, value) {
        this.updateValue(event, value);
    };
    /**
     * Writes a new value to the element based on the type of input element.
     *
     * FIX: https://github.com/anein/angular2-trim-directive/issues/9
     *
     * @param {any} value - new value
     */
    InputTrimDirective.prototype.writeValue = function (value) {
        this._sourceRenderer.setProperty(this._sourceElementRef.nativeElement, 'value', value);
        // a dirty trick (or magic) goes here: it updates the element value if `setProperty` doesn't set it for some reason.
        if (this._type !== 'text') {
            this._sourceRenderer.setAttribute(this._sourceElementRef.nativeElement, 'value', value);
        }
    };
    /**
     * Trims an input value, and sets it to the model and element.
     *
     * @param {string} value - input value
     * @param {string} event - input event
     */
    InputTrimDirective.prototype.updateValue = function (event, value) {
        // check if the user has set an optional attribute. Trimmmm!!! Uhahahaha!
        this.value = (this.trim !== '' && event !== this.trim) ? value : value.trim();
    };
    InputTrimDirective.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer2"], decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer2"]] }] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"]] }] }, { type: null, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_1__angular_forms__["j" /* COMPOSITION_BUFFER_MODE */]] }] }]; };
    return InputTrimDirective;
}(__WEBPACK_IMPORTED_MODULE_1__angular_forms__["i" /* DefaultValueAccessor */]));

//# sourceMappingURL=input-trim.directive.js.map

/***/ }),
/* 575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HeaderFooterModule; });
var HeaderFooterModule = /** @class */ (function () {
    function HeaderFooterModule() {
    }
    return HeaderFooterModule;
}());

//# sourceMappingURL=headerfooter.module.js.map

/***/ }),
/* 576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AboutEntry; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modals_about_about_dialog_component__ = __webpack_require__(318);


var AboutEntry = /** @class */ (function () {
    function AboutEntry(componentFactoryResolver) {
        this.componentFactoryResolver = componentFactoryResolver;
        this.childComponent = this.componentFactoryResolver.resolveComponentFactory(__WEBPACK_IMPORTED_MODULE_1__modals_about_about_dialog_component__["a" /* AboutDialogComponent */]);
        this.label = 'About';
    }
    AboutEntry.prototype.activate = function (viewContainerRef) {
        var _this = this;
        if (!this.childComponent) {
            this.childComponent = this.componentFactoryResolver.resolveComponentFactory(__WEBPACK_IMPORTED_MODULE_1__modals_about_about_dialog_component__["a" /* AboutDialogComponent */]);
        }
        if (!this.compRef || viewContainerRef.indexOf(this.compRef.hostView) === -1) {
            this.compRef = viewContainerRef.createComponent(this.childComponent, 0);
        }
        setTimeout(function () {
            //  this.compRef.instance.preview = true;
            //  this.compRef.instance.okText = 'Ok';
            _this.compRef.instance.showDialog(true);
        }, 10);
    };
    AboutEntry.prototype.clean = function () {
        this.childComponent = null;
        this.compRef = null;
    };
    AboutEntry.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ComponentFactoryResolver"] }]; };
    return AboutEntry;
}());

//# sourceMappingURL=about-entry.js.map

/***/ }),
/* 577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ApiHelpEntry; });
var ApiHelpEntry = /** @class */ (function () {
    function ApiHelpEntry() {
        this.label = 'API Reference Guide (HTML)';
    }
    ApiHelpEntry.prototype.activate = function (viewContainerRef) {
        var url = window.location.protocol + '//' + window.location.hostname + ':' +
            window.location.port + '/api-help/BpcDdosAPI.htm';
        window.open(url, '_blank');
    };
    ApiHelpEntry.prototype.clean = function () { };
    ApiHelpEntry.ctorParameters = function () { return []; };
    return ApiHelpEntry;
}());

//# sourceMappingURL=api-help-entry.js.map

/***/ }),
/* 578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ApiHelpPdfEntry; });
var ApiHelpPdfEntry = /** @class */ (function () {
    function ApiHelpPdfEntry() {
        this.label = 'API Reference Guide (PDF)';
    }
    ApiHelpPdfEntry.prototype.activate = function (viewContainerRef) {
        var url = window.location.protocol + '//' + window.location.hostname + ':' +
            window.location.port + '/api-help/BpcDdosAPI.pdf';
        window.open(url, '_blank');
    };
    ApiHelpPdfEntry.prototype.clean = function () { };
    ApiHelpPdfEntry.ctorParameters = function () { return []; };
    return ApiHelpPdfEntry;
}());

//# sourceMappingURL=api-help-pdf-entry.js.map

/***/ }),
/* 579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BillingEntry; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modals_billing_billing_dialog_component__ = __webpack_require__(319);


var BillingEntry = /** @class */ (function () {
    function BillingEntry(componentFactoryResolver) {
        this.componentFactoryResolver = componentFactoryResolver;
        this.childComponent = this.componentFactoryResolver.resolveComponentFactory(__WEBPACK_IMPORTED_MODULE_1__modals_billing_billing_dialog_component__["a" /* BillingDialog */]);
        this.label = 'Billing';
    }
    BillingEntry.prototype.activate = function (viewContainerRef) {
        var _this = this;
        if (!this.childComponent) {
            this.childComponent = this.componentFactoryResolver.resolveComponentFactory(__WEBPACK_IMPORTED_MODULE_1__modals_billing_billing_dialog_component__["a" /* BillingDialog */]);
        }
        if (!this.compRef || viewContainerRef.indexOf(this.compRef.hostView) === -1) {
            this.compRef = viewContainerRef.createComponent(this.childComponent, 0);
        }
        setTimeout(function () {
            _this.compRef.instance.showDialog(new __WEBPACK_IMPORTED_MODULE_1__modals_billing_billing_dialog_component__["b" /* BillingDialogArgs */]());
        }, 10);
    };
    BillingEntry.prototype.clean = function () {
        this.childComponent = null;
        this.compRef = null;
    };
    BillingEntry.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ComponentFactoryResolver"] }]; };
    return BillingEntry;
}());

//# sourceMappingURL=billing-entry.js.map

/***/ }),
/* 580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HelpEntry; });
var HelpEntry = /** @class */ (function () {
    function HelpEntry() {
        this.label = 'User Guide (HTML)';
    }
    HelpEntry.prototype.activate = function (viewContainerRef) {
        var url = window.location.protocol + '//' + window.location.hostname + ':' +
            window.location.port + '/help/BPCloudDDoSUG.htm';
        window.open(url, '_blank');
    };
    HelpEntry.prototype.clean = function () { };
    HelpEntry.ctorParameters = function () { return []; };
    return HelpEntry;
}());

//# sourceMappingURL=help-entry.js.map

/***/ }),
/* 581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HelpPdfEntry; });
var HelpPdfEntry = /** @class */ (function () {
    function HelpPdfEntry() {
        this.label = 'User Guide (PDF)';
    }
    HelpPdfEntry.prototype.activate = function (viewContainerRef) {
        var url = window.location.protocol + '//' + window.location.hostname + ':' +
            window.location.port + '/help/BPCloudDDoSUG.pdf';
        window.open(url, '_blank');
    };
    HelpPdfEntry.prototype.clean = function () { };
    HelpPdfEntry.ctorParameters = function () { return []; };
    return HelpPdfEntry;
}());

//# sourceMappingURL=help-pdf-entry.js.map

/***/ }),
/* 582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LogOutEntry; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__user_user_service__ = __webpack_require__(12);

var LogOutEntry = /** @class */ (function () {
    function LogOutEntry(usrService) {
        this.userService = usrService;
        this.label = 'Logout';
    }
    LogOutEntry.prototype.activate = function (viewContainerRef) {
        this.userService.logOut();
    };
    LogOutEntry.prototype.clean = function () { };
    LogOutEntry.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_0__user_user_service__["a" /* UserService */] }]; };
    return LogOutEntry;
}());

//# sourceMappingURL=logout-entry.js.map

/***/ }),
/* 583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PythonApiEntry; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_http__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__restapi_error_handler__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__user_user_service__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__aws_http__ = __webpack_require__(66);




var PythonApiEntry = /** @class */ (function () {
    function PythonApiEntry(http, errorHandler, userService, awsHTTP) {
        this.http = http;
        this.errorHandler = errorHandler;
        this.userService = userService;
        this.awsHTTP = awsHTTP;
        this.label = 'Python API Client';
    }
    PythonApiEntry.prototype.activate = function (viewContainerRef) {
        var url = window.location.protocol + '//' + window.location.hostname + ':' +
            window.location.port + '/python-api/bpcddos.zip';
        window.open(url);
        //let headers = new Headers({
        //    'Content-Type': 'application/zip'
        //});
        //this.http.get(url, {headers: headers})
        //  .subscribe( (response: any) => {
        //       var file = new Blob([response], {type: 'application/zip'});
        //       var fileURL = URL.createObjectURL(file);
        //       window.open(url);
        //});
    };
    PythonApiEntry.prototype.clean = function () { };
    PythonApiEntry.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_http__["i" /* Http */] }, { type: __WEBPACK_IMPORTED_MODULE_1__restapi_error_handler__["a" /* ErrorHandler */] }, { type: __WEBPACK_IMPORTED_MODULE_2__user_user_service__["a" /* UserService */] }, { type: __WEBPACK_IMPORTED_MODULE_3__aws_http__["a" /* AwsHttp */] }]; };
    return PythonApiEntry;
}());

//# sourceMappingURL=python-api-entry.js.map

/***/ }),
/* 584 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SupportEntry; });
var SupportEntry = /** @class */ (function () {
    function SupportEntry() {
        this.label = 'Contact Ixia Support';
    }
    SupportEntry.prototype.activate = function (viewContainerRef) {
        var url = 'https://support.ixiacom.com/contact/support';
        window.open(url, '_blank');
    };
    SupportEntry.prototype.clean = function () { };
    SupportEntry.ctorParameters = function () { return []; };
    return SupportEntry;
}());

//# sourceMappingURL=support-entry.js.map

/***/ }),
/* 585 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TargetValidationEntry; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main_target_validation_target_validation_service__ = __webpack_require__(45);

var TargetValidationEntry = /** @class */ (function () {
    function TargetValidationEntry(targetValidationService) {
        this.targetValidationService = targetValidationService;
        this.label = 'Azure Subscriptions';
    }
    TargetValidationEntry.prototype.activate = function (viewContainerRef) {
        this.targetValidationService.showDialog();
    };
    TargetValidationEntry.prototype.clean = function () { };
    TargetValidationEntry.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_0__main_target_validation_target_validation_service__["a" /* TargetValidationService */] }]; };
    return TargetValidationEntry;
}());

//# sourceMappingURL=target-validation-entry.js.map

/***/ }),
/* 586 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LicensingModule; });
var LicensingModule = /** @class */ (function () {
    function LicensingModule() {
    }
    return LicensingModule;
}());

//# sourceMappingURL=licensing.module.js.map

/***/ }),
/* 587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LoginModule; });
var LoginModule = /** @class */ (function () {
    function LoginModule() {
    }
    return LoginModule;
}());

//# sourceMappingURL=login.module.js.map

/***/ }),
/* 588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MainRoutingModule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dashboard_component__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__history_history_component__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_config_component__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router_auth_guard_service__ = __webpack_require__(327);




var routes = [
    { path: '', component: __WEBPACK_IMPORTED_MODULE_0__dashboard_component__["a" /* DashboardComponent */], canActivate: [__WEBPACK_IMPORTED_MODULE_3__router_auth_guard_service__["a" /* AuthGuard */]], children: [
            { path: '', component: __WEBPACK_IMPORTED_MODULE_2__config_config_component__["a" /* ConfigComponent */] },
            { path: 'history', component: __WEBPACK_IMPORTED_MODULE_1__history_history_component__["a" /* HistoryComponent */] }
        ] }
];
var MainRoutingModule = /** @class */ (function () {
    function MainRoutingModule() {
    }
    return MainRoutingModule;
}());

//# sourceMappingURL=main-routing.module.js.map

/***/ }),
/* 589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MainModule; });
var MainModule = /** @class */ (function () {
    function MainModule() {
    }
    return MainModule;
}());

//# sourceMappingURL=main.module.js.map

/***/ }),
/* 590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ConfirmationBaseModal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modal_base__ = __webpack_require__(68);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var ConfirmationBaseModal = /** @class */ (function (_super) {
    __extends(ConfirmationBaseModal, _super);
    function ConfirmationBaseModal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.okText = 'OK';
        _this.cancelText = 'Cancel';
        return _this;
    }
    ConfirmationBaseModal.prototype.onOk = function (e) {
        e.preventDefault();
        if (this.isDataValid()) {
            this.closeDialog();
            this.onOkEvent(e);
        }
    };
    ConfirmationBaseModal.prototype.onCancel = function (e) {
        e.preventDefault();
        this.closeDialog();
        this.onCancelEvent(e);
    };
    ConfirmationBaseModal.prototype.showDialog = function (args) {
        var result = this.onActivate(args);
        this.initialize();
        return result;
    };
    return ConfirmationBaseModal;
}(__WEBPACK_IMPORTED_MODULE_0__modal_base__["a" /* BaseModal */]));

//# sourceMappingURL=confirmation-modal.js.map

/***/ }),
/* 591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ModalsModule; });
var ModalsModule = /** @class */ (function () {
    function ModalsModule() {
    }
    return ModalsModule;
}());

//# sourceMappingURL=modals.module.js.map

/***/ }),
/* 592 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MQTTModule; });
var MQTTModule = /** @class */ (function () {
    function MQTTModule() {
    }
    return MQTTModule;
}());

//# sourceMappingURL=mqtt.module.js.map

/***/ }),
/* 593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Notification; });
var Notification = /** @class */ (function () {
    function Notification(message, level) {
        this.message = message;
        this.level = level;
    }
    return Notification;
}());

//# sourceMappingURL=notification.model.js.map

/***/ }),
/* 594 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NotifierService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__notification_model__ = __webpack_require__(593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_Subject__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_Subject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs_Subject__);


var NotifierService = /** @class */ (function () {
    function NotifierService() {
        this.notifications = [];
        this.notificationAdded = new __WEBPACK_IMPORTED_MODULE_1_rxjs_Subject__["Subject"]();
    }
    NotifierService.prototype.notify = function (message, level) {
        var note = new __WEBPACK_IMPORTED_MODULE_0__notification_model__["a" /* Notification */](message, level);
        this.notifications.push(note);
        this.notificationAdded.next(this.notifications.slice());
    };
    return NotifierService;
}());

//# sourceMappingURL=notifier.service.js.map

/***/ }),
/* 595 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PipesModule; });
var PipesModule = /** @class */ (function () {
    function PipesModule() {
    }
    return PipesModule;
}());

//# sourceMappingURL=pipes.module.js.map

/***/ }),
/* 596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProgressMarker; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__uimodels_color__ = __webpack_require__(329);

var ProgressMarker = /** @class */ (function () {
    function ProgressMarker() {
        this.color = new __WEBPACK_IMPORTED_MODULE_0__uimodels_color__["a" /* Color */](255, 255, 255);
    }
    return ProgressMarker;
}());

//# sourceMappingURL=marker.js.map

/***/ }),
/* 597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProgressModule; });
var ProgressModule = /** @class */ (function () {
    function ProgressModule() {
    }
    return ProgressModule;
}());

//# sourceMappingURL=progress.module.js.map

/***/ }),
/* 598 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PublisherModule; });
var PublisherModule = /** @class */ (function () {
    function PublisherModule() {
    }
    return PublisherModule;
}());

//# sourceMappingURL=publisher.module.js.map

/***/ }),
/* 599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RestApiModule; });
var RestApiModule = /** @class */ (function () {
    function RestApiModule() {
    }
    return RestApiModule;
}());

//# sourceMappingURL=restapi.module.js.map

/***/ }),
/* 600 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TrialAuthGuardService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_router__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__user_user_service__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__trial_trial_service__ = __webpack_require__(39);



var TrialAuthGuardService = /** @class */ (function () {
    function TrialAuthGuardService(userService, router, trialService) {
        this.userService = userService;
        this.router = router;
        this.trialService = trialService;
    }
    TrialAuthGuardService.prototype.canActivate = function (route, state) {
        if (!this.userService.isLoggedIn() || (this.userService.isLoggedIn() && this.trialService.trialMode && this.trialService.max === 0)) {
            return true;
        }
        // Navigate to the login page
        this.router.navigate(['']);
        return false;
    };
    TrialAuthGuardService.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_1__user_user_service__["a" /* UserService */] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_router__["a" /* Router */] }, { type: __WEBPACK_IMPORTED_MODULE_2__trial_trial_service__["a" /* TrialService */] }]; };
    return TrialAuthGuardService;
}());

//# sourceMappingURL=trial-auth-guard.service.js.map

/***/ }),
/* 601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SystemInformationModule; });
var SystemInformationModule = /** @class */ (function () {
    function SystemInformationModule() {
    }
    return SystemInformationModule;
}());

//# sourceMappingURL=systeminformation.module.js.map

/***/ }),
/* 602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TreeModule; });
var TreeModule = /** @class */ (function () {
    function TreeModule() {
    }
    return TreeModule;
}());

//# sourceMappingURL=tree.module.js.map

/***/ }),
/* 603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UserModule; });
var UserModule = /** @class */ (function () {
    function UserModule() {
    }
    return UserModule;
}());

//# sourceMappingURL=user.module.js.map

/***/ }),
/* 604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export User */
/* unused harmony export Cognito */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Preferences; });
var User = /** @class */ (function () {
    function User() {
    }
    return User;
}());

var Cognito = /** @class */ (function () {
    function Cognito() {
    }
    return Cognito;
}());

var Preferences = /** @class */ (function () {
    function Preferences() {
        this.AgreedToEula = true; // TODO: replace with default false when real preferences are availbale
    }
    return Preferences;
}());

//# sourceMappingURL=user.js.map

/***/ }),
/* 605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UtilModule; });
var UtilModule = /** @class */ (function () {
    function UtilModule() {
    }
    return UtilModule;
}());

//# sourceMappingURL=util.module.js.map

/***/ }),
/* 606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__aot_output_src_app_app_module_ngfactory__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_platform_browser__ = __webpack_require__(38);



__webpack_require__(509);
if (true) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["enableProdMode"])();
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__angular_platform_browser__["platformBrowser"])().bootstrapModuleFactory(__WEBPACK_IMPORTED_MODULE_1__aot_output_src_app_app_module_ngfactory__["a" /* AppModuleNgFactory */]);
//# sourceMappingURL=main.js.map

/***/ }),
/* 607 */,
/* 608 */,
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(2);
var column_header_directive_1 = __webpack_require__(333);
var column_cell_directive_1 = __webpack_require__(332);
var DataTableColumnDirective = (function () {
    function DataTableColumnDirective() {
    }
    return DataTableColumnDirective;
}());
DataTableColumnDirective.decorators = [
    { type: core_1.Directive, args: [{ selector: 'ngx-datatable-column' },] },
];
/** @nocollapse */
DataTableColumnDirective.ctorParameters = function () { return []; };
DataTableColumnDirective.propDecorators = {
    'name': [{ type: core_1.Input },],
    'prop': [{ type: core_1.Input },],
    'frozenLeft': [{ type: core_1.Input },],
    'frozenRight': [{ type: core_1.Input },],
    'flexGrow': [{ type: core_1.Input },],
    'resizeable': [{ type: core_1.Input },],
    'comparator': [{ type: core_1.Input },],
    'pipe': [{ type: core_1.Input },],
    'sortable': [{ type: core_1.Input },],
    'draggable': [{ type: core_1.Input },],
    'canAutoResize': [{ type: core_1.Input },],
    'minWidth': [{ type: core_1.Input },],
    'width': [{ type: core_1.Input },],
    'maxWidth': [{ type: core_1.Input },],
    'checkboxable': [{ type: core_1.Input },],
    'headerCheckboxable': [{ type: core_1.Input },],
    'headerClass': [{ type: core_1.Input },],
    'cellClass': [{ type: core_1.Input },],
    'cellTemplate': [{ type: core_1.Input }, { type: core_1.ContentChild, args: [column_cell_directive_1.DataTableColumnCellDirective, { read: core_1.TemplateRef },] },],
    'headerTemplate': [{ type: core_1.Input }, { type: core_1.ContentChild, args: [column_header_directive_1.DataTableColumnHeaderDirective, { read: core_1.TemplateRef },] },],
};
exports.DataTableColumnDirective = DataTableColumnDirective;
//# sourceMappingURL=column.directive.js.map

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(2);
var footer_template_directive_1 = __webpack_require__(335);
var DatatableFooterDirective = (function () {
    function DatatableFooterDirective() {
    }
    return DatatableFooterDirective;
}());
DatatableFooterDirective.decorators = [
    { type: core_1.Directive, args: [{ selector: 'ngx-datatable-footer' },] },
];
/** @nocollapse */
DatatableFooterDirective.ctorParameters = function () { return []; };
DatatableFooterDirective.propDecorators = {
    'footerHeight': [{ type: core_1.Input },],
    'totalMessage': [{ type: core_1.Input },],
    'selectedMessage': [{ type: core_1.Input },],
    'pagerLeftArrowIcon': [{ type: core_1.Input },],
    'pagerRightArrowIcon': [{ type: core_1.Input },],
    'pagerPreviousIcon': [{ type: core_1.Input },],
    'pagerNextIcon': [{ type: core_1.Input },],
    'template': [{ type: core_1.Input }, { type: core_1.ContentChild, args: [footer_template_directive_1.DataTableFooterTemplateDirective, { read: core_1.TemplateRef },] },],
};
exports.DatatableFooterDirective = DatatableFooterDirective;
//# sourceMappingURL=footer.directive.js.map

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(201));
__export(__webpack_require__(200));
//# sourceMappingURL=index.js.map

/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(197));
__export(__webpack_require__(611));
__export(__webpack_require__(331));
__export(__webpack_require__(336));
__export(__webpack_require__(334));
__export(__webpack_require__(337));
//# sourceMappingURL=index.js.map

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(2);
var row_detail_template_directive_1 = __webpack_require__(338);
var DatatableRowDetailDirective = (function () {
    function DatatableRowDetailDirective() {
        /**
         * The detail row height is required especially
         * when virtual scroll is enabled.
         *
         * @type {number|function(row?:any,index?:number): number}
         * @memberOf DatatableComponent
         */
        this.rowHeight = 0;
        /**
         * Row detail row visbility was toggled.
         *
         * @type {EventEmitter<any>}
         * @memberOf DatatableComponent
         */
        this.toggle = new core_1.EventEmitter();
    }
    /**
     * Toggle the expansion of the row
     *
     * @param rowIndex
     */
    DatatableRowDetailDirective.prototype.toggleExpandRow = function (row) {
        this.toggle.emit({
            type: 'row',
            value: row
        });
    };
    /**
     * API method to expand all the rows.
     *
     * @memberOf DatatableComponent
     */
    DatatableRowDetailDirective.prototype.expandAllRows = function () {
        this.toggle.emit({
            type: 'all',
            value: true
        });
    };
    /**
     * API method to collapse all the rows.
     *
     * @memberOf DatatableComponent
     */
    DatatableRowDetailDirective.prototype.collapseAllRows = function () {
        this.toggle.emit({
            type: 'all',
            value: false
        });
    };
    return DatatableRowDetailDirective;
}());
DatatableRowDetailDirective.decorators = [
    { type: core_1.Directive, args: [{ selector: 'ngx-datatable-row-detail' },] },
];
/** @nocollapse */
DatatableRowDetailDirective.ctorParameters = function () { return []; };
DatatableRowDetailDirective.propDecorators = {
    'rowHeight': [{ type: core_1.Input },],
    'template': [{ type: core_1.Input }, { type: core_1.ContentChild, args: [row_detail_template_directive_1.DatatableRowDetailTemplateDirective, { read: core_1.TemplateRef },] },],
    'toggle': [{ type: core_1.Output },],
};
exports.DatatableRowDetailDirective = DatatableRowDetailDirective;
//# sourceMappingURL=row-detail.directive.js.map

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(2);
var common_1 = __webpack_require__(4);
__webpack_require__(466);
var components_1 = __webpack_require__(612);
var directives_1 = __webpack_require__(615);
var services_1 = __webpack_require__(203);
var NgxDatatableModule = (function () {
    function NgxDatatableModule() {
    }
    return NgxDatatableModule;
}());
NgxDatatableModule.decorators = [
    { type: core_1.NgModule, args: [{
                imports: [
                    common_1.CommonModule
                ],
                providers: [
                    services_1.ScrollbarHelper
                ],
                declarations: [
                    components_1.DataTableFooterTemplateDirective,
                    directives_1.VisibilityDirective,
                    directives_1.DraggableDirective,
                    directives_1.ResizeableDirective,
                    directives_1.OrderableDirective,
                    directives_1.LongPressDirective,
                    components_1.ScrollerComponent,
                    components_1.DatatableComponent,
                    components_1.DataTableColumnDirective,
                    components_1.DataTableHeaderComponent,
                    components_1.DataTableHeaderCellComponent,
                    components_1.DataTableBodyComponent,
                    components_1.DataTableFooterComponent,
                    components_1.DataTablePagerComponent,
                    components_1.ProgressBarComponent,
                    components_1.DataTableBodyRowComponent,
                    components_1.DataTableRowWrapperComponent,
                    components_1.DatatableRowDetailDirective,
                    components_1.DatatableRowDetailTemplateDirective,
                    components_1.DataTableBodyCellComponent,
                    components_1.DataTableSelectionComponent,
                    components_1.DataTableColumnHeaderDirective,
                    components_1.DataTableColumnCellDirective,
                    components_1.DatatableFooterDirective
                ],
                exports: [
                    components_1.DatatableComponent,
                    components_1.DatatableRowDetailDirective,
                    components_1.DatatableRowDetailTemplateDirective,
                    components_1.DataTableColumnDirective,
                    components_1.DataTableColumnHeaderDirective,
                    components_1.DataTableColumnCellDirective,
                    components_1.DataTableFooterTemplateDirective,
                    components_1.DatatableFooterDirective,
                    components_1.DataTablePagerComponent
                ]
            },] },
];
/** @nocollapse */
NgxDatatableModule.ctorParameters = function () { return []; };
exports.NgxDatatableModule = NgxDatatableModule;
//# sourceMappingURL=datatable.module.js.map

/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(202));
__export(__webpack_require__(339));
__export(__webpack_require__(340));
__export(__webpack_require__(341));
__export(__webpack_require__(342));
//# sourceMappingURL=index.js.map

/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ClickType;
(function (ClickType) {
    ClickType[ClickType["single"] = 'single'] = "single";
    ClickType[ClickType["double"] = 'double'] = "double";
})(ClickType = exports.ClickType || (exports.ClickType = {}));
//# sourceMappingURL=click.type.js.map

/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ColumnMode;
(function (ColumnMode) {
    ColumnMode[ColumnMode["standard"] = 'standard'] = "standard";
    ColumnMode[ColumnMode["flex"] = 'flex'] = "flex";
    ColumnMode[ColumnMode["force"] = 'force'] = "force";
})(ColumnMode = exports.ColumnMode || (exports.ColumnMode = {}));
//# sourceMappingURL=column-mode.type.js.map

/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ContextmenuType;
(function (ContextmenuType) {
    ContextmenuType[ContextmenuType["header"] = 'header'] = "header";
    ContextmenuType[ContextmenuType["body"] = 'body'] = "body";
})(ContextmenuType = exports.ContextmenuType || (exports.ContextmenuType = {}));
//# sourceMappingURL=contextmenu.type.js.map

/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var SelectionType;
(function (SelectionType) {
    SelectionType[SelectionType["single"] = 'single'] = "single";
    SelectionType[SelectionType["multi"] = 'multi'] = "multi";
    SelectionType[SelectionType["multiClick"] = 'multiClick'] = "multiClick";
    SelectionType[SelectionType["cell"] = 'cell'] = "cell";
    SelectionType[SelectionType["checkbox"] = 'checkbox'] = "checkbox";
})(SelectionType = exports.SelectionType || (exports.SelectionType = {}));
//# sourceMappingURL=selection.type.js.map

/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var SortDirection;
(function (SortDirection) {
    SortDirection[SortDirection["asc"] = 'asc'] = "asc";
    SortDirection[SortDirection["desc"] = 'desc'] = "desc";
})(SortDirection = exports.SortDirection || (exports.SortDirection = {}));
//# sourceMappingURL=sort-direction.type.js.map

/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var SortType;
(function (SortType) {
    SortType[SortType["single"] = 'single'] = "single";
    SortType[SortType["multi"] = 'multi'] = "multi";
})(SortType = exports.SortType || (exports.SortType = {}));
//# sourceMappingURL=sort.type.js.map

/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var camel_case_1 = __webpack_require__(138);
var id_1 = __webpack_require__(344);
var column_prop_getters_1 = __webpack_require__(204);
/**
 * Sets the column defaults
 *
 * @export
 * @param {any[]} columns
 * @returns
 */
function setColumnDefaults(columns) {
    if (!columns)
        return;
    for (var _i = 0, columns_1 = columns; _i < columns_1.length; _i++) {
        var column = columns_1[_i];
        if (!column.$$id) {
            column.$$id = id_1.id();
        }
        // prop can be numeric; zero is valid not a missing prop
        // translate name => prop
        if (column.prop == null && column.name) {
            column.prop = camel_case_1.camelCase(column.name);
        }
        if (!column.$$valueGetter) {
            column.$$valueGetter = column_prop_getters_1.getterForProp(column.prop);
        }
        // format props if no name passed
        if (column.prop != null && !column.name) {
            column.name = camel_case_1.deCamelCase(String(column.prop));
        }
        if (!column.hasOwnProperty('resizeable')) {
            column.resizeable = true;
        }
        if (!column.hasOwnProperty('sortable')) {
            column.sortable = true;
        }
        if (!column.hasOwnProperty('draggable')) {
            column.draggable = true;
        }
        if (!column.hasOwnProperty('canAutoResize')) {
            column.canAutoResize = true;
        }
        if (!column.hasOwnProperty('width')) {
            column.width = 150;
        }
    }
}
exports.setColumnDefaults = setColumnDefaults;
/**
 * Translates templates definitions to objects
 *
 * @export
 * @param {DataTableColumnDirective[]} templates
 * @returns {any[]}
 */
function translateTemplates(templates) {
    var result = [];
    for (var _i = 0, templates_1 = templates; _i < templates_1.length; _i++) {
        var temp = templates_1[_i];
        var col = {};
        var props = Object.getOwnPropertyNames(temp);
        for (var _a = 0, props_1 = props; _a < props_1.length; _a++) {
            var prop = props_1[_a];
            col[prop] = temp[prop];
        }
        if (temp.headerTemplate) {
            col.headerTemplate = temp.headerTemplate;
        }
        if (temp.cellTemplate) {
            col.cellTemplate = temp.cellTemplate;
        }
        result.push(col);
    }
    return result;
}
exports.translateTemplates = translateTemplates;
//# sourceMappingURL=column-helper.js.map

/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
if (document !== undefined && !document.elementsFromPoint) {
    document.elementsFromPoint = elementsFromPoint;
}
/*tslint:disable*/
/**
 * Polyfill for `elementsFromPoint`
 *
 * https://developer.mozilla.org/en-US/docs/Web/API/Document/elementsFromPoint
 * https://gist.github.com/iddan/54d5d9e58311b0495a91bf06de661380
 * https://gist.github.com/oslego/7265412
 *
 * @export
 * @param {any} x
 * @param {any} y
 * @returns
 */
function elementsFromPoint(x, y) {
    var elements = [];
    var previousPointerEvents = [];
    var current; // TODO: window.getComputedStyle should be used with inferred type (Element)
    var i;
    var d;
    //if (document === undefined) return elements;
    // get all elements via elementFromPoint, and remove them from hit-testing in order
    while ((current = document.elementFromPoint(x, y)) && elements.indexOf(current) === -1 && current != null) {
        // push the element and its current style
        elements.push(current);
        previousPointerEvents.push({
            value: current.style.getPropertyValue('pointer-events'),
            priority: current.style.getPropertyPriority('pointer-events')
        });
        // add "pointer-events: none", to get to the underlying element
        current.style.setProperty('pointer-events', 'none', 'important');
    }
    // restore the previous pointer-events values
    for (i = previousPointerEvents.length; d = previousPointerEvents[--i];) {
        elements[i].style.setProperty('pointer-events', d.value ? d.value : '', d.priority);
    }
    // return our results
    return elements;
}
exports.elementsFromPoint = elementsFromPoint;
/*tslint:enable*/
//# sourceMappingURL=elm-from-point.js.map

/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Keys;
(function (Keys) {
    Keys[Keys["up"] = 38] = "up";
    Keys[Keys["down"] = 40] = "down";
    Keys[Keys["return"] = 13] = "return";
    Keys[Keys["escape"] = 27] = "escape";
    Keys[Keys["left"] = 37] = "left";
    Keys[Keys["right"] = 39] = "right";
})(Keys = exports.Keys || (exports.Keys = {}));
//# sourceMappingURL=keys.js.map

/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var column_1 = __webpack_require__(343);
/**
 * Calculates the Total Flex Grow
 * @param {array}
 */
function getTotalFlexGrow(columns) {
    var totalFlexGrow = 0;
    for (var _i = 0, columns_1 = columns; _i < columns_1.length; _i++) {
        var c = columns_1[_i];
        totalFlexGrow += c.flexGrow || 0;
    }
    return totalFlexGrow;
}
exports.getTotalFlexGrow = getTotalFlexGrow;
/**
 * Adjusts the column widths.
 * Inspired by: https://github.com/facebook/fixed-data-table/blob/master/src/FixedDataTableWidthHelper.js
 * @param {array} all columns
 * @param {int} width
 */
function adjustColumnWidths(allColumns, expectedWidth) {
    var columnsWidth = column_1.columnsTotalWidth(allColumns);
    var totalFlexGrow = getTotalFlexGrow(allColumns);
    var colsByGroup = column_1.columnsByPin(allColumns);
    if (columnsWidth !== expectedWidth) {
        scaleColumns(colsByGroup, expectedWidth, totalFlexGrow);
    }
}
exports.adjustColumnWidths = adjustColumnWidths;
/**
 * Resizes columns based on the flexGrow property, while respecting manually set widths
 * @param {array} colsByGroup
 * @param {int} maxWidth
 * @param {int} totalFlexGrow
 */
function scaleColumns(colsByGroup, maxWidth, totalFlexGrow) {
    // calculate total width and flexgrow points for coulumns that can be resized
    for (var attr in colsByGroup) {
        for (var _i = 0, _a = colsByGroup[attr]; _i < _a.length; _i++) {
            var column = _a[_i];
            if (!column.canAutoResize) {
                maxWidth -= column.width;
                totalFlexGrow -= column.flexGrow;
            }
            else {
                column.width = 0;
            }
        }
    }
    var hasMinWidth = {};
    var remainingWidth = maxWidth;
    // resize columns until no width is left to be distributed
    do {
        var widthPerFlexPoint = remainingWidth / totalFlexGrow;
        remainingWidth = 0;
        for (var attr in colsByGroup) {
            for (var _b = 0, _c = colsByGroup[attr]; _b < _c.length; _b++) {
                var column = _c[_b];
                // if the column can be resize and it hasn't reached its minimum width yet
                if (column.canAutoResize && !hasMinWidth[column.prop]) {
                    var newWidth = column.width + column.flexGrow * widthPerFlexPoint;
                    if (column.minWidth !== undefined && newWidth < column.minWidth) {
                        remainingWidth += newWidth - column.minWidth;
                        column.width = column.minWidth;
                        hasMinWidth[column.prop] = true;
                    }
                    else {
                        column.width = newWidth;
                    }
                }
            }
        }
    } while (remainingWidth !== 0);
}
/**
 * Forces the width of the columns to
 * distribute equally but overflowing when necessary
 *
 * Rules:
 *
 *  - If combined withs are less than the total width of the grid,
 *    proportion the widths given the min / max / normal widths to fill the width.
 *
 *  - If the combined widths, exceed the total width of the grid,
 *    use the standard widths.
 *
 *  - If a column is resized, it should always use that width
 *
 *  - The proportional widths should never fall below min size if specified.
 *
 *  - If the grid starts off small but then becomes greater than the size ( + / - )
 *    the width should use the original width; not the newly proportioned widths.
 *
 * @param {array} allColumns
 * @param {int} expectedWidth
 * @param {int} startIdx
 * @param {boolean} allowBleed
 * @param {int} defaultColWidth
 */
function forceFillColumnWidths(allColumns, expectedWidth, startIdx, allowBleed, defaultColWidth) {
    if (defaultColWidth === void 0) { defaultColWidth = 300; }
    var columnsToResize = allColumns
        .slice(startIdx + 1, allColumns.length)
        .filter(function (c) {
        return c.canAutoResize !== false;
    });
    for (var _i = 0, columnsToResize_1 = columnsToResize; _i < columnsToResize_1.length; _i++) {
        var column = columnsToResize_1[_i];
        if (!column.$$oldWidth) {
            column.$$oldWidth = column.width;
        }
    }
    var additionWidthPerColumn = 0;
    var exceedsWindow = false;
    var contentWidth = getContentWidth(allColumns, defaultColWidth);
    var remainingWidth = expectedWidth - contentWidth;
    var columnsProcessed = [];
    // This loop takes care of the
    do {
        additionWidthPerColumn = remainingWidth / columnsToResize.length;
        exceedsWindow = contentWidth >= expectedWidth;
        for (var _a = 0, columnsToResize_2 = columnsToResize; _a < columnsToResize_2.length; _a++) {
            var column = columnsToResize_2[_a];
            if (exceedsWindow && allowBleed) {
                column.width = column.$$oldWidth || column.width || defaultColWidth;
            }
            else {
                var newSize = (column.width || defaultColWidth) + additionWidthPerColumn;
                if (column.minWidth && newSize < column.minWidth) {
                    column.width = column.minWidth;
                    columnsProcessed.push(column);
                }
                else if (column.maxWidth && newSize > column.maxWidth) {
                    column.width = column.maxWidth;
                    columnsProcessed.push(column);
                }
                else {
                    column.width = newSize;
                }
            }
            column.width = Math.max(0, column.width);
        }
        contentWidth = getContentWidth(allColumns);
        remainingWidth = expectedWidth - contentWidth;
        removeProcessedColumns(columnsToResize, columnsProcessed);
    } while (remainingWidth > 0 && columnsToResize.length !== 0);
}
exports.forceFillColumnWidths = forceFillColumnWidths;
/**
 * Remove the processed columns from the current active columns.
 *
 * @param columnsToResize  Array containing the columns that need to be resized.
 * @param columnsProcessed Array containing the columns that have already been processed.
 */
function removeProcessedColumns(columnsToResize, columnsProcessed) {
    for (var _i = 0, columnsProcessed_1 = columnsProcessed; _i < columnsProcessed_1.length; _i++) {
        var column = columnsProcessed_1[_i];
        var index = columnsToResize.indexOf(column);
        columnsToResize.splice(index, 1);
    }
}
/**
 * Gets the width of the columns
 *
 * @param {array} allColumns
 * @param {number} [defaultColWidth=300]
 * @returns {number}
 */
function getContentWidth(allColumns, defaultColWidth) {
    if (defaultColWidth === void 0) { defaultColWidth = 300; }
    var contentWidth = 0;
    for (var _i = 0, allColumns_1 = allColumns; _i < allColumns_1.length; _i++) {
        var column = allColumns_1[_i];
        contentWidth += (column.width || defaultColWidth);
    }
    return contentWidth;
}
//# sourceMappingURL=math.js.map

/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * This object contains the cache of the various row heights that are present inside
 * the data table.   Its based on Fenwick tree data structure that helps with
 * querying sums that have time complexity of log n.
 *
 * Fenwick Tree Credits: http://petr-mitrichev.blogspot.com/2013/05/fenwick-tree-range-updates.html
 * https://github.com/mikolalysenko/fenwick-tree
 *
 */
var RowHeightCache = (function () {
    function RowHeightCache() {
        /**
         * Tree Array stores the cumulative information of the row heights to perform efficient
         * range queries and updates.  Currently the tree is initialized to the base row
         * height instead of the detail row height.
         */
        this.treeArray = [];
    }
    /**
     * Clear the Tree array.
     */
    RowHeightCache.prototype.clearCache = function () {
        this.treeArray = [];
    };
    /**
     * Initialize the Fenwick tree with row Heights.
     *
     * @param rows The array of rows which contain the expanded status.
     * @param rowHeight The row height.
     * @param detailRowHeight The detail row height.
     */
    RowHeightCache.prototype.initCache = function (details) {
        var rows = details.rows, rowHeight = details.rowHeight, detailRowHeight = details.detailRowHeight, externalVirtual = details.externalVirtual, rowCount = details.rowCount;
        var isFn = typeof rowHeight === 'function';
        var isDetailFn = typeof detailRowHeight === 'function';
        if (!isFn && isNaN(rowHeight)) {
            throw new Error("Row Height cache initialization failed. Please ensure that 'rowHeight' is a\n        valid number or function value: (" + rowHeight + ") when 'scrollbarV' is enabled.");
        }
        // Add this additional guard in case detailRowHeight is set to 'auto' as it wont work.
        if (!isDetailFn && isNaN(detailRowHeight)) {
            throw new Error("Row Height cache initialization failed. Please ensure that 'detailRowHeight' is a\n        valid number or function value: (" + detailRowHeight + ") when 'scrollbarV' is enabled.");
        }
        var n = externalVirtual ? rowCount : rows.length;
        this.treeArray = new Array(n);
        for (var i = 0; i < n; ++i) {
            this.treeArray[i] = 0;
        }
        for (var i = 0; i < n; ++i) {
            var row = rows[i];
            var currentRowHeight = rowHeight;
            if (isFn) {
                currentRowHeight = rowHeight(row);
            }
            // Add the detail row height to the already expanded rows.
            // This is useful for the table that goes through a filter or sort.
            if (row && row.$$expanded === 1) {
                if (isDetailFn) {
                    currentRowHeight += detailRowHeight(row, row.$$index);
                }
                else {
                    currentRowHeight += detailRowHeight;
                }
            }
            this.update(i, currentRowHeight);
        }
    };
    /**
     * Given the ScrollY position i.e. sum, provide the rowIndex
     * that is present in the current view port.  Below handles edge cases.
     *
     * @param scrollY - The scrollY position.
     * @returns {number} - Index representing the first row visible in the viewport
     */
    RowHeightCache.prototype.getRowIndex = function (scrollY) {
        if (scrollY === 0)
            return 0;
        return this.calcRowIndex(scrollY);
    };
    /**
     * When a row is expanded or rowHeight is changed, update the height.  This can
     * be utilized in future when Angular Data table supports dynamic row heights.
     *
     *
     * @param atRowIndex Update the data at this index row in the grid.
     * @param byRowHeight Update by the rowHeight provided.
     */
    RowHeightCache.prototype.update = function (atRowIndex, byRowHeight) {
        if (!this.treeArray.length) {
            throw new Error("Update at index " + atRowIndex + " with value " + byRowHeight + " failed:\n        Row Height cache not initialized.");
        }
        var n = this.treeArray.length;
        atRowIndex |= 0;
        while (atRowIndex < n) {
            this.treeArray[atRowIndex] += byRowHeight;
            atRowIndex |= (atRowIndex + 1);
        }
    };
    /**
     * Range Sum query from 1 to the rowIndex
     *
     * @param atIndex The row index until which the total height needs to be obtained.
     * @returns {number} The total height from row 1 to the rowIndex.
     */
    RowHeightCache.prototype.query = function (atIndex) {
        if (!this.treeArray.length) {
            throw new Error("query at index " + atIndex + " failed: Fenwick tree array not initialized.");
        }
        var sum = 0;
        atIndex |= 0;
        while (atIndex >= 0) {
            sum += this.treeArray[atIndex];
            atIndex = (atIndex & (atIndex + 1)) - 1;
        }
        return sum;
    };
    /**
     * Find the total height between 2 row indexes
     * @param atIndexA The row index from
     * @param atIndexB The row index to
     * @returns {number} total pixel height between 2 row indexes.
     */
    RowHeightCache.prototype.queryBetween = function (atIndexA, atIndexB) {
        return this.query(atIndexB) - this.query(atIndexA - 1);
    };
    /**
     * Given the ScrollY position i.e. sum, provide the rowIndex
     * that is present in the current view port.
     *
     * @param sum - The scrollY position.
     * @returns {number} - Index representing the first row visible in the viewport
     */
    RowHeightCache.prototype.calcRowIndex = function (sum) {
        if (!this.treeArray.length)
            return 0;
        var pos = -1;
        var dataLength = this.treeArray.length;
        // Get the highest bit for the block size.
        var highestBit = Math.pow(2, dataLength.toString(2).length - 1);
        for (var blockSize = highestBit; blockSize !== 0; blockSize >>= 1) {
            var nextPos = pos + blockSize;
            if (nextPos < dataLength && sum >= this.treeArray[nextPos]) {
                sum -= this.treeArray[nextPos];
                pos = nextPos;
            }
        }
        return pos + 1;
    };
    return RowHeightCache;
}());
exports.RowHeightCache = RowHeightCache;
//# sourceMappingURL=row-height-cache.js.map

/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function selectRows(selected, row, comparefn) {
    var selectedIndex = comparefn(row, selected);
    if (selectedIndex > -1) {
        selected.splice(selectedIndex, 1);
    }
    else {
        selected.push(row);
    }
    return selected;
}
exports.selectRows = selectRows;
function selectRowsBetween(selected, rows, index, prevIndex, comparefn) {
    var reverse = index < prevIndex;
    for (var i = 0; i < rows.length; i++) {
        var row = rows[i];
        var greater = i >= prevIndex && i <= index;
        var lesser = i <= prevIndex && i >= index;
        var range = { start: 0, end: 0 };
        if (reverse) {
            range = {
                start: index,
                end: prevIndex
            };
        }
        else {
            range = {
                start: prevIndex,
                end: index + 1
            };
        }
        if ((reverse && lesser) || (!reverse && greater)) {
            // if in the positive range to be added to `selected`, and
            // not already in the selected array, add it
            if (i >= range.start && i <= range.end) {
                selected.push(row);
            }
        }
    }
    return selected;
}
exports.selectRowsBetween = selectRowsBetween;
//# sourceMappingURL=selection.js.map

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = __webpack_require__(96);
var column_prop_getters_1 = __webpack_require__(204);
/**
 * Gets the next sort direction
 * @param  {SortType}      sortType
 * @param  {SortDirection} currentSort
 * @return {SortDirection}
 */
function nextSortDir(sortType, current) {
    if (sortType === types_1.SortType.single) {
        if (current === types_1.SortDirection.asc) {
            return types_1.SortDirection.desc;
        }
        else {
            return types_1.SortDirection.asc;
        }
    }
    else {
        if (!current) {
            return types_1.SortDirection.asc;
        }
        else if (current === types_1.SortDirection.asc) {
            return types_1.SortDirection.desc;
        }
        else if (current === types_1.SortDirection.desc) {
            return undefined;
        }
    }
}
exports.nextSortDir = nextSortDir;
/**
 * Adapted from fueld-ui on 6/216
 * https://github.com/FuelInteractive/fuel-ui/tree/master/src/pipes/OrderBy
 * @param  {any}    a
 * @param  {any}    b
 * @return {number} position
 */
function orderByComparator(a, b) {
    if (a === null || typeof a === 'undefined')
        a = 0;
    if (b === null || typeof b === 'undefined')
        b = 0;
    if (a instanceof Date && b instanceof Date) {
        if (a < b)
            return -1;
        if (a > b)
            return 1;
    }
    else if ((isNaN(parseFloat(a)) || !isFinite(a)) || (isNaN(parseFloat(b)) || !isFinite(b))) {
        // Convert to string in case of a=0 or b=0
        a = String(a);
        b = String(b);
        // Isn't a number so lowercase the string to properly compare
        if (a.toLowerCase() < b.toLowerCase())
            return -1;
        if (a.toLowerCase() > b.toLowerCase())
            return 1;
    }
    else {
        // Parse strings as numbers to compare properly
        if (parseFloat(a) < parseFloat(b))
            return -1;
        if (parseFloat(a) > parseFloat(b))
            return 1;
    }
    // equal each other
    return 0;
}
exports.orderByComparator = orderByComparator;
/**
 * Sorts the rows
 *
 * @export
 * @param {any[]} rows
 * @param {any[]} columns
 * @param {any[]} dirs
 * @returns
 */
function sortRows(rows, columns, dirs) {
    if (!rows || !dirs || !dirs.length || !columns)
        return rows;
    var temp = rows.slice();
    var cols = columns.reduce(function (obj, col) {
        if (col.comparator && typeof col.comparator === 'function') {
            obj[col.prop] = col.comparator;
        }
        return obj;
    }, {});
    // cache valueGetter and compareFn so that they
    // do not need to be looked-up in the sort function body
    var cachedDirs = dirs.map(function (dir) {
        var prop = dir.prop;
        return {
            prop: prop,
            dir: dir.dir,
            valueGetter: column_prop_getters_1.getterForProp(prop),
            compareFn: cols[prop] || orderByComparator
        };
    });
    return temp.sort(function (a, b) {
        for (var _i = 0, cachedDirs_1 = cachedDirs; _i < cachedDirs_1.length; _i++) {
            var cachedDir = cachedDirs_1[_i];
            var prop = cachedDir.prop, valueGetter = cachedDir.valueGetter;
            var propA = valueGetter(a, prop);
            var propB = valueGetter(b, prop);
            var comparison = cachedDir.dir !== types_1.SortDirection.desc ?
                cachedDir.compareFn(propA, propB) :
                -cachedDir.compareFn(propA, propB);
            // Don't return 0 yet in case of needing to sort by next property
            if (comparison !== 0)
                return comparison;
        }
        // equal each other
        return 0;
    });
}
exports.sortRows = sortRows;
//# sourceMappingURL=sort.js.map

/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Throttle a function
 *
 * @export
 * @param {*} func
 * @param {number} wait
 * @param {*} [options]
 * @returns
 */
function throttle(func, wait, options) {
    options = options || {};
    var context;
    var args;
    var result;
    var timeout = null;
    var previous = 0;
    function later() {
        previous = options.leading === false ? 0 : +new Date();
        timeout = null;
        result = func.apply(context, args);
    }
    return function () {
        var now = +new Date();
        if (!previous && options.leading === false) {
            previous = now;
        }
        var remaining = wait - (now - previous);
        context = this;
        args = arguments;
        if (remaining <= 0) {
            clearTimeout(timeout);
            timeout = null;
            previous = now;
            result = func.apply(context, args);
        }
        else if (!timeout && options.trailing !== false) {
            timeout = setTimeout(later, remaining);
        }
        return result;
    };
}
exports.throttle = throttle;
/**
 * Throttle decorator
 *
 *  class MyClass {
 *    throttleable(10)
 *    myFn() { ... }
 *  }
 *
 * @export
 * @param {number} duration
 * @param {*} [options]
 * @returns
 */
function throttleable(duration, options) {
    return function innerDecorator(target, key, descriptor) {
        return {
            configurable: true,
            enumerable: descriptor.enumerable,
            get: function getter() {
                Object.defineProperty(this, key, {
                    configurable: true,
                    enumerable: descriptor.enumerable,
                    value: throttle(descriptor.value, duration, options)
                });
                return this[key];
            }
        };
    };
}
exports.throttleable = throttleable;
//# sourceMappingURL=throttle.js.map

/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var prefixes_1 = __webpack_require__(345);
var camel_case_1 = __webpack_require__(138);
// browser detection and prefixing tools
var transform = prefixes_1.getVendorPrefixedName('transform');
var backfaceVisibility = prefixes_1.getVendorPrefixedName('backfaceVisibility');
var hasCSSTransforms = !!prefixes_1.getVendorPrefixedName('transform');
var hasCSS3DTransforms = !!prefixes_1.getVendorPrefixedName('perspective');
var ua = window ? window.navigator.userAgent : "Chrome";
var isSafari = (/Safari\//).test(ua) && !(/Chrome\//).test(ua);
function translateXY(styles, x, y) {
    if (hasCSSTransforms) {
        if (!isSafari && hasCSS3DTransforms) {
            styles[transform] = "translate3d(" + x + "px, " + y + "px, 0)";
            styles[backfaceVisibility] = 'hidden';
        }
        else {
            styles[camel_case_1.camelCase(transform)] = "translate(" + x + "px, " + y + "px)";
        }
    }
    else {
        styles.top = y + "px";
        styles.left = x + "px";
    }
}
exports.translateXY = translateXY;
//# sourceMappingURL=translate.js.map

/***/ }),
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 802 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pairs__ = __webpack_require__(382);


/* unused harmony default export */ var _unused_webpack_default_export = (function(values0, values1, reduce) {
  var n0 = values0.length,
      n1 = values1.length,
      values = new Array(n0 * n1),
      i0,
      i1,
      i,
      value0;

  if (reduce == null) reduce = __WEBPACK_IMPORTED_MODULE_0__pairs__["a" /* pair */];

  for (i0 = i = 0; i0 < n0; ++i0) {
    for (value0 = values0[i0], i1 = 0; i1 < n1; ++i1, ++i) {
      values[i] = reduce(value0, values1[i1]);
    }
  }

  return values;
});


/***/ }),
/* 803 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(a, b) {
  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
});


/***/ }),
/* 804 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bisect__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constant__ = __webpack_require__(801);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__extent__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__identity__ = __webpack_require__(805);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__range__ = __webpack_require__(383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ticks__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__threshold_sturges__ = __webpack_require__(384);









/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var value = __WEBPACK_IMPORTED_MODULE_4__identity__["a" /* default */],
      domain = __WEBPACK_IMPORTED_MODULE_3__extent__["a" /* default */],
      threshold = __WEBPACK_IMPORTED_MODULE_7__threshold_sturges__["a" /* default */];

  function histogram(data) {
    var i,
        n = data.length,
        x,
        values = new Array(n);

    for (i = 0; i < n; ++i) {
      values[i] = value(data[i], i, data);
    }

    var xz = domain(values),
        x0 = xz[0],
        x1 = xz[1],
        tz = threshold(values, x0, x1);

    // Convert number of thresholds into uniform thresholds.
    if (!Array.isArray(tz)) {
      tz = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__ticks__["c" /* tickStep */])(x0, x1, tz);
      tz = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__range__["a" /* default */])(Math.ceil(x0 / tz) * tz, Math.floor(x1 / tz) * tz, tz); // exclusive
    }

    // Remove any thresholds outside the domain.
    var m = tz.length;
    while (tz[0] <= x0) tz.shift(), --m;
    while (tz[m - 1] > x1) tz.pop(), --m;

    var bins = new Array(m + 1),
        bin;

    // Initialize bins.
    for (i = 0; i <= m; ++i) {
      bin = bins[i] = [];
      bin.x0 = i > 0 ? tz[i - 1] : x0;
      bin.x1 = i < m ? tz[i] : x1;
    }

    // Assign data to bins by value, ignoring any outside the domain.
    for (i = 0; i < n; ++i) {
      x = values[i];
      if (x0 <= x && x <= x1) {
        bins[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__bisect__["a" /* default */])(tz, x, 0, m)].push(data[i]);
      }
    }

    return bins;
  }

  histogram.value = function(_) {
    return arguments.length ? (value = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(_), histogram) : value;
  };

  histogram.domain = function(_) {
    return arguments.length ? (domain = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])([_[0], _[1]]), histogram) : domain;
  };

  histogram.thresholds = function(_) {
    return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__array__["b" /* slice */].call(_)) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(_), histogram) : threshold;
  };

  return histogram;
});


/***/ }),
/* 805 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return x;
});


/***/ }),
/* 806 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      max;

  if (valueof == null) {
    while (++i < n) { // Find the first comparable value.
      if ((value = values[i]) != null && value >= value) {
        max = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = values[i]) != null && value > max) {
            max = value;
          }
        }
      }
    }
  }

  else {
    while (++i < n) { // Find the first comparable value.
      if ((value = valueof(values[i], i, values)) != null && value >= value) {
        max = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = valueof(values[i], i, values)) != null && value > max) {
            max = value;
          }
        }
      }
    }
  }

  return max;
});


/***/ }),
/* 807 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(113);


/* unused harmony default export */ var _unused_webpack_default_export = (function(values, valueof) {
  var n = values.length,
      m = n,
      i = -1,
      value,
      sum = 0;

  if (valueof == null) {
    while (++i < n) {
      if (!isNaN(value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(values[i]))) sum += value;
      else --m;
    }
  }

  else {
    while (++i < n) {
      if (!isNaN(value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(valueof(values[i], i, values)))) sum += value;
      else --m;
    }
  }

  if (m) return sum / m;
});


/***/ }),
/* 808 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ascending__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__number__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__quantile__ = __webpack_require__(229);




/* unused harmony default export */ var _unused_webpack_default_export = (function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      numbers = [];

  if (valueof == null) {
    while (++i < n) {
      if (!isNaN(value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__number__["a" /* default */])(values[i]))) {
        numbers.push(value);
      }
    }
  }

  else {
    while (++i < n) {
      if (!isNaN(value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__number__["a" /* default */])(valueof(values[i], i, values)))) {
        numbers.push(value);
      }
    }
  }

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__quantile__["a" /* default */])(numbers.sort(__WEBPACK_IMPORTED_MODULE_0__ascending__["a" /* default */]), 0.5);
});


/***/ }),
/* 809 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(arrays) {
  var n = arrays.length,
      m,
      i = -1,
      j = 0,
      merged,
      array;

  while (++i < n) j += arrays[i].length;
  merged = new Array(j);

  while (--n >= 0) {
    array = arrays[n];
    m = array.length;
    while (--m >= 0) {
      merged[--j] = array[m];
    }
  }

  return merged;
});


/***/ }),
/* 810 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(array, indexes) {
  var i = indexes.length, permutes = new Array(i);
  while (i--) permutes[i] = array[indexes[i]];
  return permutes;
});


/***/ }),
/* 811 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ascending__ = __webpack_require__(105);


/* unused harmony default export */ var _unused_webpack_default_export = (function(values, compare) {
  if (!(n = values.length)) return;
  var n,
      i = 0,
      j = 0,
      xi,
      xj = values[j];

  if (compare == null) compare = __WEBPACK_IMPORTED_MODULE_0__ascending__["a" /* default */];

  while (++i < n) {
    if (compare(xi = values[i], xj) < 0 || compare(xj, xj) !== 0) {
      xj = xi, j = i;
    }
  }

  if (compare(xj, xj) === 0) return j;
});


/***/ }),
/* 812 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(array, i0, i1) {
  var m = (i1 == null ? array.length : i1) - (i0 = i0 == null ? 0 : +i0),
      t,
      i;

  while (m) {
    i = Math.random() * m-- | 0;
    t = array[m + i0];
    array[m + i0] = array[i + i0];
    array[i + i0] = t;
  }

  return array;
});


/***/ }),
/* 813 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      sum = 0;

  if (valueof == null) {
    while (++i < n) {
      if (value = +values[i]) sum += value; // Note: zero and null are equivalent.
    }
  }

  else {
    while (++i < n) {
      if (value = +valueof(values[i], i, values)) sum += value;
    }
  }

  return sum;
});


/***/ }),
/* 814 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ascending__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__number__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__quantile__ = __webpack_require__(229);





/* unused harmony default export */ var _unused_webpack_default_export = (function(values, min, max) {
  values = __WEBPACK_IMPORTED_MODULE_0__array__["a" /* map */].call(values, __WEBPACK_IMPORTED_MODULE_2__number__["a" /* default */]).sort(__WEBPACK_IMPORTED_MODULE_1__ascending__["a" /* default */]);
  return Math.ceil((max - min) / (2 * (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__quantile__["a" /* default */])(values, 0.75) - __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__quantile__["a" /* default */])(values, 0.25)) * Math.pow(values.length, -1 / 3)));
});


/***/ }),
/* 815 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__deviation__ = __webpack_require__(379);


/* unused harmony default export */ var _unused_webpack_default_export = (function(values, min, max) {
  return Math.ceil((max - min) / (3.5 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__deviation__["a" /* default */])(values) * Math.pow(values.length, -1 / 3)));
});


/***/ }),
/* 816 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__transpose__ = __webpack_require__(386);


/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__transpose__["a" /* default */])(arguments);
});


/***/ }),
/* 817 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_axis__ = __webpack_require__(819);
/* unused harmony reexport axisTop */
/* unused harmony reexport axisRight */
/* unused harmony reexport axisBottom */
/* unused harmony reexport axisLeft */



/***/ }),
/* 818 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return slice; });
var slice = Array.prototype.slice;


/***/ }),
/* 819 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export axisTop */
/* unused harmony export axisRight */
/* unused harmony export axisBottom */
/* unused harmony export axisLeft */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(818);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__identity__ = __webpack_require__(820);



var top = 1,
    right = 2,
    bottom = 3,
    left = 4,
    epsilon = 1e-6;

function translateX(x) {
  return "translate(" + (x + 0.5) + ",0)";
}

function translateY(y) {
  return "translate(0," + (y + 0.5) + ")";
}

function number(scale) {
  return function(d) {
    return +scale(d);
  };
}

function center(scale) {
  var offset = Math.max(0, scale.bandwidth() - 1) / 2; // Adjust for 0.5px offset.
  if (scale.round()) offset = Math.round(offset);
  return function(d) {
    return +scale(d) + offset;
  };
}

function entering() {
  return !this.__axis;
}

function axis(orient, scale) {
  var tickArguments = [],
      tickValues = null,
      tickFormat = null,
      tickSizeInner = 6,
      tickSizeOuter = 6,
      tickPadding = 3,
      k = orient === top || orient === left ? -1 : 1,
      x = orient === left || orient === right ? "x" : "y",
      transform = orient === top || orient === bottom ? translateX : translateY;

  function axis(context) {
    var values = tickValues == null ? (scale.ticks ? scale.ticks.apply(scale, tickArguments) : scale.domain()) : tickValues,
        format = tickFormat == null ? (scale.tickFormat ? scale.tickFormat.apply(scale, tickArguments) : __WEBPACK_IMPORTED_MODULE_1__identity__["a" /* default */]) : tickFormat,
        spacing = Math.max(tickSizeInner, 0) + tickPadding,
        range = scale.range(),
        range0 = +range[0] + 0.5,
        range1 = +range[range.length - 1] + 0.5,
        position = (scale.bandwidth ? center : number)(scale.copy()),
        selection = context.selection ? context.selection() : context,
        path = selection.selectAll(".domain").data([null]),
        tick = selection.selectAll(".tick").data(values, scale).order(),
        tickExit = tick.exit(),
        tickEnter = tick.enter().append("g").attr("class", "tick"),
        line = tick.select("line"),
        text = tick.select("text");

    path = path.merge(path.enter().insert("path", ".tick")
        .attr("class", "domain")
        .attr("stroke", "#000"));

    tick = tick.merge(tickEnter);

    line = line.merge(tickEnter.append("line")
        .attr("stroke", "#000")
        .attr(x + "2", k * tickSizeInner));

    text = text.merge(tickEnter.append("text")
        .attr("fill", "#000")
        .attr(x, k * spacing)
        .attr("dy", orient === top ? "0em" : orient === bottom ? "0.71em" : "0.32em"));

    if (context !== selection) {
      path = path.transition(context);
      tick = tick.transition(context);
      line = line.transition(context);
      text = text.transition(context);

      tickExit = tickExit.transition(context)
          .attr("opacity", epsilon)
          .attr("transform", function(d) { return isFinite(d = position(d)) ? transform(d) : this.getAttribute("transform"); });

      tickEnter
          .attr("opacity", epsilon)
          .attr("transform", function(d) { var p = this.parentNode.__axis; return transform(p && isFinite(p = p(d)) ? p : position(d)); });
    }

    tickExit.remove();

    path
        .attr("d", orient === left || orient == right
            ? "M" + k * tickSizeOuter + "," + range0 + "H0.5V" + range1 + "H" + k * tickSizeOuter
            : "M" + range0 + "," + k * tickSizeOuter + "V0.5H" + range1 + "V" + k * tickSizeOuter);

    tick
        .attr("opacity", 1)
        .attr("transform", function(d) { return transform(position(d)); });

    line
        .attr(x + "2", k * tickSizeInner);

    text
        .attr(x, k * spacing)
        .text(format);

    selection.filter(entering)
        .attr("fill", "none")
        .attr("font-size", 10)
        .attr("font-family", "sans-serif")
        .attr("text-anchor", orient === right ? "start" : orient === left ? "end" : "middle");

    selection
        .each(function() { this.__axis = position; });
  }

  axis.scale = function(_) {
    return arguments.length ? (scale = _, axis) : scale;
  };

  axis.ticks = function() {
    return tickArguments = __WEBPACK_IMPORTED_MODULE_0__array__["a" /* slice */].call(arguments), axis;
  };

  axis.tickArguments = function(_) {
    return arguments.length ? (tickArguments = _ == null ? [] : __WEBPACK_IMPORTED_MODULE_0__array__["a" /* slice */].call(_), axis) : tickArguments.slice();
  };

  axis.tickValues = function(_) {
    return arguments.length ? (tickValues = _ == null ? null : __WEBPACK_IMPORTED_MODULE_0__array__["a" /* slice */].call(_), axis) : tickValues && tickValues.slice();
  };

  axis.tickFormat = function(_) {
    return arguments.length ? (tickFormat = _, axis) : tickFormat;
  };

  axis.tickSize = function(_) {
    return arguments.length ? (tickSizeInner = tickSizeOuter = +_, axis) : tickSizeInner;
  };

  axis.tickSizeInner = function(_) {
    return arguments.length ? (tickSizeInner = +_, axis) : tickSizeInner;
  };

  axis.tickSizeOuter = function(_) {
    return arguments.length ? (tickSizeOuter = +_, axis) : tickSizeOuter;
  };

  axis.tickPadding = function(_) {
    return arguments.length ? (tickPadding = +_, axis) : tickPadding;
  };

  return axis;
}

function axisTop(scale) {
  return axis(top, scale);
}

function axisRight(scale) {
  return axis(right, scale);
}

function axisBottom(scale) {
  return axis(bottom, scale);
}

function axisLeft(scale) {
  return axis(left, scale);
}


/***/ }),
/* 820 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return x;
});


/***/ }),
/* 821 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_brush__ = __webpack_require__(822);
/* unused harmony reexport brush */
/* unused harmony reexport brushX */
/* unused harmony reexport brushY */
/* unused harmony reexport brushSelection */



/***/ }),
/* 822 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export brushSelection */
/* unused harmony export brushX */
/* unused harmony export brushY */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_dispatch__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_drag__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_interpolate__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_d3_selection__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_d3_transition__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constant__ = __webpack_require__(823);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__event__ = __webpack_require__(824);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__noevent__ = __webpack_require__(825);









var MODE_DRAG = {name: "drag"},
    MODE_SPACE = {name: "space"},
    MODE_HANDLE = {name: "handle"},
    MODE_CENTER = {name: "center"};

var X = {
  name: "x",
  handles: ["e", "w"].map(type),
  input: function(x, e) { return x && [[x[0], e[0][1]], [x[1], e[1][1]]]; },
  output: function(xy) { return xy && [xy[0][0], xy[1][0]]; }
};

var Y = {
  name: "y",
  handles: ["n", "s"].map(type),
  input: function(y, e) { return y && [[e[0][0], y[0]], [e[1][0], y[1]]]; },
  output: function(xy) { return xy && [xy[0][1], xy[1][1]]; }
};

var XY = {
  name: "xy",
  handles: ["n", "e", "s", "w", "nw", "ne", "se", "sw"].map(type),
  input: function(xy) { return xy; },
  output: function(xy) { return xy; }
};

var cursors = {
  overlay: "crosshair",
  selection: "move",
  n: "ns-resize",
  e: "ew-resize",
  s: "ns-resize",
  w: "ew-resize",
  nw: "nwse-resize",
  ne: "nesw-resize",
  se: "nwse-resize",
  sw: "nesw-resize"
};

var flipX = {
  e: "w",
  w: "e",
  nw: "ne",
  ne: "nw",
  se: "sw",
  sw: "se"
};

var flipY = {
  n: "s",
  s: "n",
  nw: "sw",
  ne: "se",
  se: "ne",
  sw: "nw"
};

var signsX = {
  overlay: +1,
  selection: +1,
  n: null,
  e: +1,
  s: null,
  w: -1,
  nw: -1,
  ne: +1,
  se: +1,
  sw: -1
};

var signsY = {
  overlay: +1,
  selection: +1,
  n: -1,
  e: null,
  s: +1,
  w: null,
  nw: -1,
  ne: -1,
  se: +1,
  sw: +1
};

function type(t) {
  return {type: t};
}

// Ignore right-click, since that should open the context menu.
function defaultFilter() {
  return !__WEBPACK_IMPORTED_MODULE_3_d3_selection__["b" /* event */].button;
}

function defaultExtent() {
  var svg = this.ownerSVGElement || this;
  return [[0, 0], [svg.width.baseVal.value, svg.height.baseVal.value]];
}

// Like d3.local, but with the name “__brush” rather than auto-generated.
function local(node) {
  while (!node.__brush) if (!(node = node.parentNode)) return;
  return node.__brush;
}

function empty(extent) {
  return extent[0][0] === extent[1][0]
      || extent[0][1] === extent[1][1];
}

function brushSelection(node) {
  var state = node.__brush;
  return state ? state.dim.output(state.selection) : null;
}

function brushX() {
  return brush(X);
}

function brushY() {
  return brush(Y);
}

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  return brush(XY);
});

function brush(dim) {
  var extent = defaultExtent,
      filter = defaultFilter,
      listeners = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_dispatch__["a" /* dispatch */])(brush, "start", "brush", "end"),
      handleSize = 6,
      touchending;

  function brush(group) {
    var overlay = group
        .property("__brush", initialize)
      .selectAll(".overlay")
      .data([type("overlay")]);

    overlay.enter().append("rect")
        .attr("class", "overlay")
        .attr("pointer-events", "all")
        .attr("cursor", cursors.overlay)
      .merge(overlay)
        .each(function() {
          var extent = local(this).extent;
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["a" /* select */])(this)
              .attr("x", extent[0][0])
              .attr("y", extent[0][1])
              .attr("width", extent[1][0] - extent[0][0])
              .attr("height", extent[1][1] - extent[0][1]);
        });

    group.selectAll(".selection")
      .data([type("selection")])
      .enter().append("rect")
        .attr("class", "selection")
        .attr("cursor", cursors.selection)
        .attr("fill", "#777")
        .attr("fill-opacity", 0.3)
        .attr("stroke", "#fff")
        .attr("shape-rendering", "crispEdges");

    var handle = group.selectAll(".handle")
      .data(dim.handles, function(d) { return d.type; });

    handle.exit().remove();

    handle.enter().append("rect")
        .attr("class", function(d) { return "handle handle--" + d.type; })
        .attr("cursor", function(d) { return cursors[d.type]; });

    group
        .each(redraw)
        .attr("fill", "none")
        .attr("pointer-events", "all")
        .style("-webkit-tap-highlight-color", "rgba(0,0,0,0)")
        .on("mousedown.brush touchstart.brush", started);
  }

  brush.move = function(group, selection) {
    if (group.selection) {
      group
          .on("start.brush", function() { emitter(this, arguments).beforestart().start(); })
          .on("interrupt.brush end.brush", function() { emitter(this, arguments).end(); })
          .tween("brush", function() {
            var that = this,
                state = that.__brush,
                emit = emitter(that, arguments),
                selection0 = state.selection,
                selection1 = dim.input(typeof selection === "function" ? selection.apply(this, arguments) : selection, state.extent),
                i = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_d3_interpolate__["a" /* interpolate */])(selection0, selection1);

            function tween(t) {
              state.selection = t === 1 && empty(selection1) ? null : i(t);
              redraw.call(that);
              emit.brush();
            }

            return selection0 && selection1 ? tween : tween(1);
          });
    } else {
      group
          .each(function() {
            var that = this,
                args = arguments,
                state = that.__brush,
                selection1 = dim.input(typeof selection === "function" ? selection.apply(that, args) : selection, state.extent),
                emit = emitter(that, args).beforestart();

            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_d3_transition__["a" /* interrupt */])(that);
            state.selection = selection1 == null || empty(selection1) ? null : selection1;
            redraw.call(that);
            emit.start().brush().end();
          });
    }
  };

  function redraw() {
    var group = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["a" /* select */])(this),
        selection = local(this).selection;

    if (selection) {
      group.selectAll(".selection")
          .style("display", null)
          .attr("x", selection[0][0])
          .attr("y", selection[0][1])
          .attr("width", selection[1][0] - selection[0][0])
          .attr("height", selection[1][1] - selection[0][1]);

      group.selectAll(".handle")
          .style("display", null)
          .attr("x", function(d) { return d.type[d.type.length - 1] === "e" ? selection[1][0] - handleSize / 2 : selection[0][0] - handleSize / 2; })
          .attr("y", function(d) { return d.type[0] === "s" ? selection[1][1] - handleSize / 2 : selection[0][1] - handleSize / 2; })
          .attr("width", function(d) { return d.type === "n" || d.type === "s" ? selection[1][0] - selection[0][0] + handleSize : handleSize; })
          .attr("height", function(d) { return d.type === "e" || d.type === "w" ? selection[1][1] - selection[0][1] + handleSize : handleSize; });
    }

    else {
      group.selectAll(".selection,.handle")
          .style("display", "none")
          .attr("x", null)
          .attr("y", null)
          .attr("width", null)
          .attr("height", null);
    }
  }

  function emitter(that, args) {
    return that.__brush.emitter || new Emitter(that, args);
  }

  function Emitter(that, args) {
    this.that = that;
    this.args = args;
    this.state = that.__brush;
    this.active = 0;
  }

  Emitter.prototype = {
    beforestart: function() {
      if (++this.active === 1) this.state.emitter = this, this.starting = true;
      return this;
    },
    start: function() {
      if (this.starting) this.starting = false, this.emit("start");
      return this;
    },
    brush: function() {
      this.emit("brush");
      return this;
    },
    end: function() {
      if (--this.active === 0) delete this.state.emitter, this.emit("end");
      return this;
    },
    emit: function(type) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["c" /* customEvent */])(new __WEBPACK_IMPORTED_MODULE_6__event__["a" /* default */](brush, type, dim.output(this.state.selection)), listeners.apply, listeners, [type, this.that, this.args]);
    }
  };

  function started() {
    if (__WEBPACK_IMPORTED_MODULE_3_d3_selection__["b" /* event */].touches) { if (__WEBPACK_IMPORTED_MODULE_3_d3_selection__["b" /* event */].changedTouches.length < __WEBPACK_IMPORTED_MODULE_3_d3_selection__["b" /* event */].touches.length) return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__noevent__["a" /* default */])(); }
    else if (touchending) return;
    if (!filter.apply(this, arguments)) return;

    var that = this,
        type = __WEBPACK_IMPORTED_MODULE_3_d3_selection__["b" /* event */].target.__data__.type,
        mode = (__WEBPACK_IMPORTED_MODULE_3_d3_selection__["b" /* event */].metaKey ? type = "overlay" : type) === "selection" ? MODE_DRAG : (__WEBPACK_IMPORTED_MODULE_3_d3_selection__["b" /* event */].altKey ? MODE_CENTER : MODE_HANDLE),
        signX = dim === Y ? null : signsX[type],
        signY = dim === X ? null : signsY[type],
        state = local(that),
        extent = state.extent,
        selection = state.selection,
        W = extent[0][0], w0, w1,
        N = extent[0][1], n0, n1,
        E = extent[1][0], e0, e1,
        S = extent[1][1], s0, s1,
        dx,
        dy,
        moving,
        shifting = signX && signY && __WEBPACK_IMPORTED_MODULE_3_d3_selection__["b" /* event */].shiftKey,
        lockX,
        lockY,
        point0 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["d" /* mouse */])(that),
        point = point0,
        emit = emitter(that, arguments).beforestart();

    if (type === "overlay") {
      state.selection = selection = [
        [w0 = dim === Y ? W : point0[0], n0 = dim === X ? N : point0[1]],
        [e0 = dim === Y ? E : w0, s0 = dim === X ? S : n0]
      ];
    } else {
      w0 = selection[0][0];
      n0 = selection[0][1];
      e0 = selection[1][0];
      s0 = selection[1][1];
    }

    w1 = w0;
    n1 = n0;
    e1 = e0;
    s1 = s0;

    var group = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["a" /* select */])(that)
        .attr("pointer-events", "none");

    var overlay = group.selectAll(".overlay")
        .attr("cursor", cursors[type]);

    if (__WEBPACK_IMPORTED_MODULE_3_d3_selection__["b" /* event */].touches) {
      group
          .on("touchmove.brush", moved, true)
          .on("touchend.brush touchcancel.brush", ended, true);
    } else {
      var view = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["a" /* select */])(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["b" /* event */].view)
          .on("keydown.brush", keydowned, true)
          .on("keyup.brush", keyupped, true)
          .on("mousemove.brush", moved, true)
          .on("mouseup.brush", ended, true);

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_drag__["a" /* dragDisable */])(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["b" /* event */].view);
    }

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__noevent__["b" /* nopropagation */])();
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_d3_transition__["a" /* interrupt */])(that);
    redraw.call(that);
    emit.start();

    function moved() {
      var point1 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["d" /* mouse */])(that);
      if (shifting && !lockX && !lockY) {
        if (Math.abs(point1[0] - point[0]) > Math.abs(point1[1] - point[1])) lockY = true;
        else lockX = true;
      }
      point = point1;
      moving = true;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__noevent__["a" /* default */])();
      move();
    }

    function move() {
      var t;

      dx = point[0] - point0[0];
      dy = point[1] - point0[1];

      switch (mode) {
        case MODE_SPACE:
        case MODE_DRAG: {
          if (signX) dx = Math.max(W - w0, Math.min(E - e0, dx)), w1 = w0 + dx, e1 = e0 + dx;
          if (signY) dy = Math.max(N - n0, Math.min(S - s0, dy)), n1 = n0 + dy, s1 = s0 + dy;
          break;
        }
        case MODE_HANDLE: {
          if (signX < 0) dx = Math.max(W - w0, Math.min(E - w0, dx)), w1 = w0 + dx, e1 = e0;
          else if (signX > 0) dx = Math.max(W - e0, Math.min(E - e0, dx)), w1 = w0, e1 = e0 + dx;
          if (signY < 0) dy = Math.max(N - n0, Math.min(S - n0, dy)), n1 = n0 + dy, s1 = s0;
          else if (signY > 0) dy = Math.max(N - s0, Math.min(S - s0, dy)), n1 = n0, s1 = s0 + dy;
          break;
        }
        case MODE_CENTER: {
          if (signX) w1 = Math.max(W, Math.min(E, w0 - dx * signX)), e1 = Math.max(W, Math.min(E, e0 + dx * signX));
          if (signY) n1 = Math.max(N, Math.min(S, n0 - dy * signY)), s1 = Math.max(N, Math.min(S, s0 + dy * signY));
          break;
        }
      }

      if (e1 < w1) {
        signX *= -1;
        t = w0, w0 = e0, e0 = t;
        t = w1, w1 = e1, e1 = t;
        if (type in flipX) overlay.attr("cursor", cursors[type = flipX[type]]);
      }

      if (s1 < n1) {
        signY *= -1;
        t = n0, n0 = s0, s0 = t;
        t = n1, n1 = s1, s1 = t;
        if (type in flipY) overlay.attr("cursor", cursors[type = flipY[type]]);
      }

      if (state.selection) selection = state.selection; // May be set by brush.move!
      if (lockX) w1 = selection[0][0], e1 = selection[1][0];
      if (lockY) n1 = selection[0][1], s1 = selection[1][1];

      if (selection[0][0] !== w1
          || selection[0][1] !== n1
          || selection[1][0] !== e1
          || selection[1][1] !== s1) {
        state.selection = [[w1, n1], [e1, s1]];
        redraw.call(that);
        emit.brush();
      }
    }

    function ended() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__noevent__["b" /* nopropagation */])();
      if (__WEBPACK_IMPORTED_MODULE_3_d3_selection__["b" /* event */].touches) {
        if (__WEBPACK_IMPORTED_MODULE_3_d3_selection__["b" /* event */].touches.length) return;
        if (touchending) clearTimeout(touchending);
        touchending = setTimeout(function() { touchending = null; }, 500); // Ghost clicks are delayed!
        group.on("touchmove.brush touchend.brush touchcancel.brush", null);
      } else {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_drag__["b" /* dragEnable */])(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["b" /* event */].view, moving);
        view.on("keydown.brush keyup.brush mousemove.brush mouseup.brush", null);
      }
      group.attr("pointer-events", "all");
      overlay.attr("cursor", cursors.overlay);
      if (state.selection) selection = state.selection; // May be set by brush.move (on start)!
      if (empty(selection)) state.selection = null, redraw.call(that);
      emit.end();
    }

    function keydowned() {
      switch (__WEBPACK_IMPORTED_MODULE_3_d3_selection__["b" /* event */].keyCode) {
        case 16: { // SHIFT
          shifting = signX && signY;
          break;
        }
        case 18: { // ALT
          if (mode === MODE_HANDLE) {
            if (signX) e0 = e1 - dx * signX, w0 = w1 + dx * signX;
            if (signY) s0 = s1 - dy * signY, n0 = n1 + dy * signY;
            mode = MODE_CENTER;
            move();
          }
          break;
        }
        case 32: { // SPACE; takes priority over ALT
          if (mode === MODE_HANDLE || mode === MODE_CENTER) {
            if (signX < 0) e0 = e1 - dx; else if (signX > 0) w0 = w1 - dx;
            if (signY < 0) s0 = s1 - dy; else if (signY > 0) n0 = n1 - dy;
            mode = MODE_SPACE;
            overlay.attr("cursor", cursors.selection);
            move();
          }
          break;
        }
        default: return;
      }
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__noevent__["a" /* default */])();
    }

    function keyupped() {
      switch (__WEBPACK_IMPORTED_MODULE_3_d3_selection__["b" /* event */].keyCode) {
        case 16: { // SHIFT
          if (shifting) {
            lockX = lockY = shifting = false;
            move();
          }
          break;
        }
        case 18: { // ALT
          if (mode === MODE_CENTER) {
            if (signX < 0) e0 = e1; else if (signX > 0) w0 = w1;
            if (signY < 0) s0 = s1; else if (signY > 0) n0 = n1;
            mode = MODE_HANDLE;
            move();
          }
          break;
        }
        case 32: { // SPACE
          if (mode === MODE_SPACE) {
            if (__WEBPACK_IMPORTED_MODULE_3_d3_selection__["b" /* event */].altKey) {
              if (signX) e0 = e1 - dx * signX, w0 = w1 + dx * signX;
              if (signY) s0 = s1 - dy * signY, n0 = n1 + dy * signY;
              mode = MODE_CENTER;
            } else {
              if (signX < 0) e0 = e1; else if (signX > 0) w0 = w1;
              if (signY < 0) s0 = s1; else if (signY > 0) n0 = n1;
              mode = MODE_HANDLE;
            }
            overlay.attr("cursor", cursors[type]);
            move();
          }
          break;
        }
        default: return;
      }
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__noevent__["a" /* default */])();
    }
  }

  function initialize() {
    var state = this.__brush || {selection: null};
    state.extent = extent.apply(this, arguments);
    state.dim = dim;
    return state;
  }

  brush.extent = function(_) {
    return arguments.length ? (extent = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__constant__["a" /* default */])([[+_[0][0], +_[0][1]], [+_[1][0], +_[1][1]]]), brush) : extent;
  };

  brush.filter = function(_) {
    return arguments.length ? (filter = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__constant__["a" /* default */])(!!_), brush) : filter;
  };

  brush.handleSize = function(_) {
    return arguments.length ? (handleSize = +_, brush) : handleSize;
  };

  brush.on = function() {
    var value = listeners.on.apply(listeners, arguments);
    return value === listeners ? brush : value;
  };

  return brush;
}


/***/ }),
/* 823 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 824 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(target, type, selection) {
  this.target = target;
  this.type = type;
  this.selection = selection;
});


/***/ }),
/* 825 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = nopropagation;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_selection__ = __webpack_require__(21);


function nopropagation() {
  __WEBPACK_IMPORTED_MODULE_0_d3_selection__["b" /* event */].stopImmediatePropagation();
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  __WEBPACK_IMPORTED_MODULE_0_d3_selection__["b" /* event */].preventDefault();
  __WEBPACK_IMPORTED_MODULE_0_d3_selection__["b" /* event */].stopImmediatePropagation();
});


/***/ }),
/* 826 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_chord__ = __webpack_require__(828);
/* unused harmony reexport chord */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_ribbon__ = __webpack_require__(830);
/* unused harmony reexport ribbon */




/***/ }),
/* 827 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return slice; });
var slice = Array.prototype.slice;


/***/ }),
/* 828 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(388);



function compareValue(compare) {
  return function(a, b) {
    return compare(
      a.source.value + a.target.value,
      b.source.value + b.target.value
    );
  };
}

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var padAngle = 0,
      sortGroups = null,
      sortSubgroups = null,
      sortChords = null;

  function chord(matrix) {
    var n = matrix.length,
        groupSums = [],
        groupIndex = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["h" /* range */])(n),
        subgroupIndex = [],
        chords = [],
        groups = chords.groups = new Array(n),
        subgroups = new Array(n * n),
        k,
        x,
        x0,
        dx,
        i,
        j;

    // Compute the sum.
    k = 0, i = -1; while (++i < n) {
      x = 0, j = -1; while (++j < n) {
        x += matrix[i][j];
      }
      groupSums.push(x);
      subgroupIndex.push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["h" /* range */])(n));
      k += x;
    }

    // Sort groups…
    if (sortGroups) groupIndex.sort(function(a, b) {
      return sortGroups(groupSums[a], groupSums[b]);
    });

    // Sort subgroups…
    if (sortSubgroups) subgroupIndex.forEach(function(d, i) {
      d.sort(function(a, b) {
        return sortSubgroups(matrix[i][a], matrix[i][b]);
      });
    });

    // Convert the sum to scaling factor for [0, 2pi].
    // TODO Allow start and end angle to be specified?
    // TODO Allow padding to be specified as percentage?
    k = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["d" /* max */])(0, __WEBPACK_IMPORTED_MODULE_1__math__["e" /* tau */] - padAngle * n) / k;
    dx = k ? padAngle : __WEBPACK_IMPORTED_MODULE_1__math__["e" /* tau */] / n;

    // Compute the start and end angle for each group and subgroup.
    // Note: Opera has a bug reordering object literal properties!
    x = 0, i = -1; while (++i < n) {
      x0 = x, j = -1; while (++j < n) {
        var di = groupIndex[i],
            dj = subgroupIndex[di][j],
            v = matrix[di][dj],
            a0 = x,
            a1 = x += v * k;
        subgroups[dj * n + di] = {
          index: di,
          subindex: dj,
          startAngle: a0,
          endAngle: a1,
          value: v
        };
      }
      groups[di] = {
        index: di,
        startAngle: x0,
        endAngle: x,
        value: groupSums[di]
      };
      x += dx;
    }

    // Generate chords for each (non-empty) subgroup-subgroup link.
    i = -1; while (++i < n) {
      j = i - 1; while (++j < n) {
        var source = subgroups[j * n + i],
            target = subgroups[i * n + j];
        if (source.value || target.value) {
          chords.push(source.value < target.value
              ? {source: target, target: source}
              : {source: source, target: target});
        }
      }
    }

    return sortChords ? chords.sort(sortChords) : chords;
  }

  chord.padAngle = function(_) {
    return arguments.length ? (padAngle = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["d" /* max */])(0, _), chord) : padAngle;
  };

  chord.sortGroups = function(_) {
    return arguments.length ? (sortGroups = _, chord) : sortGroups;
  };

  chord.sortSubgroups = function(_) {
    return arguments.length ? (sortSubgroups = _, chord) : sortSubgroups;
  };

  chord.sortChords = function(_) {
    return arguments.length ? (_ == null ? sortChords = null : (sortChords = compareValue(_))._ = _, chord) : sortChords && sortChords._;
  };

  return chord;
});


/***/ }),
/* 829 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 830 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(827);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constant__ = __webpack_require__(829);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_d3_path__ = __webpack_require__(89);





function defaultSource(d) {
  return d.source;
}

function defaultTarget(d) {
  return d.target;
}

function defaultRadius(d) {
  return d.radius;
}

function defaultStartAngle(d) {
  return d.startAngle;
}

function defaultEndAngle(d) {
  return d.endAngle;
}

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var source = defaultSource,
      target = defaultTarget,
      radius = defaultRadius,
      startAngle = defaultStartAngle,
      endAngle = defaultEndAngle,
      context = null;

  function ribbon() {
    var buffer,
        argv = __WEBPACK_IMPORTED_MODULE_0__array__["a" /* slice */].call(arguments),
        s = source.apply(this, argv),
        t = target.apply(this, argv),
        sr = +radius.apply(this, (argv[0] = s, argv)),
        sa0 = startAngle.apply(this, argv) - __WEBPACK_IMPORTED_MODULE_2__math__["a" /* halfPi */],
        sa1 = endAngle.apply(this, argv) - __WEBPACK_IMPORTED_MODULE_2__math__["a" /* halfPi */],
        sx0 = sr * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["b" /* cos */])(sa0),
        sy0 = sr * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["c" /* sin */])(sa0),
        tr = +radius.apply(this, (argv[0] = t, argv)),
        ta0 = startAngle.apply(this, argv) - __WEBPACK_IMPORTED_MODULE_2__math__["a" /* halfPi */],
        ta1 = endAngle.apply(this, argv) - __WEBPACK_IMPORTED_MODULE_2__math__["a" /* halfPi */];

    if (!context) context = buffer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_d3_path__["a" /* path */])();

    context.moveTo(sx0, sy0);
    context.arc(0, 0, sr, sa0, sa1);
    if (sa0 !== ta0 || sa1 !== ta1) { // TODO sr !== tr?
      context.quadraticCurveTo(0, 0, tr * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["b" /* cos */])(ta0), tr * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["c" /* sin */])(ta0));
      context.arc(0, 0, tr, ta0, ta1);
    }
    context.quadraticCurveTo(0, 0, sx0, sy0);
    context.closePath();

    if (buffer) return context = null, buffer + "" || null;
  }

  ribbon.radius = function(_) {
    return arguments.length ? (radius = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), ribbon) : radius;
  };

  ribbon.startAngle = function(_) {
    return arguments.length ? (startAngle = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), ribbon) : startAngle;
  };

  ribbon.endAngle = function(_) {
    return arguments.length ? (endAngle = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), ribbon) : endAngle;
  };

  ribbon.source = function(_) {
    return arguments.length ? (source = _, ribbon) : source;
  };

  ribbon.target = function(_) {
    return arguments.length ? (target = _, ribbon) : target;
  };

  ribbon.context = function(_) {
    return arguments.length ? ((context = _ == null ? null : _), ribbon) : context;
  };

  return ribbon;
});


/***/ }),
/* 831 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(map) {
  var entries = [];
  for (var key in map) entries.push({key: key, value: map[key]});
  return entries;
});


/***/ }),
/* 832 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(map) {
  var keys = [];
  for (var key in map) keys.push(key);
  return keys;
});


/***/ }),
/* 833 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__map__ = __webpack_require__(230);


/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var keys = [],
      sortKeys = [],
      sortValues,
      rollup,
      nest;

  function apply(array, depth, createResult, setResult) {
    if (depth >= keys.length) {
      if (sortValues != null) array.sort(sortValues);
      return rollup != null ? rollup(array) : array;
    }

    var i = -1,
        n = array.length,
        key = keys[depth++],
        keyValue,
        value,
        valuesByKey = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__map__["a" /* default */])(),
        values,
        result = createResult();

    while (++i < n) {
      if (values = valuesByKey.get(keyValue = key(value = array[i]) + "")) {
        values.push(value);
      } else {
        valuesByKey.set(keyValue, [value]);
      }
    }

    valuesByKey.each(function(values, key) {
      setResult(result, key, apply(values, depth, createResult, setResult));
    });

    return result;
  }

  function entries(map, depth) {
    if (++depth > keys.length) return map;
    var array, sortKey = sortKeys[depth - 1];
    if (rollup != null && depth >= keys.length) array = map.entries();
    else array = [], map.each(function(v, k) { array.push({key: k, values: entries(v, depth)}); });
    return sortKey != null ? array.sort(function(a, b) { return sortKey(a.key, b.key); }) : array;
  }

  return nest = {
    object: function(array) { return apply(array, 0, createObject, setObject); },
    map: function(array) { return apply(array, 0, createMap, setMap); },
    entries: function(array) { return entries(apply(array, 0, createMap, setMap), 0); },
    key: function(d) { keys.push(d); return nest; },
    sortKeys: function(order) { sortKeys[keys.length - 1] = order; return nest; },
    sortValues: function(order) { sortValues = order; return nest; },
    rollup: function(f) { rollup = f; return nest; }
  };
});

function createObject() {
  return {};
}

function setObject(object, key, value) {
  object[key] = value;
}

function createMap() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__map__["a" /* default */])();
}

function setMap(map, key, value) {
  map.set(key, value);
}


/***/ }),
/* 834 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__map__ = __webpack_require__(230);


function Set() {}

var proto = __WEBPACK_IMPORTED_MODULE_0__map__["a" /* default */].prototype;

Set.prototype = set.prototype = {
  constructor: Set,
  has: proto.has,
  add: function(value) {
    value += "";
    this[__WEBPACK_IMPORTED_MODULE_0__map__["b" /* prefix */] + value] = value;
    return this;
  },
  remove: proto.remove,
  clear: proto.clear,
  values: proto.keys,
  size: proto.size,
  empty: proto.empty,
  each: proto.each
};

function set(object, f) {
  var set = new Set;

  // Copy constructor.
  if (object instanceof Set) object.each(function(value) { set.add(value); });

  // Otherwise, assume it’s an array.
  else if (object) {
    var i = -1, n = object.length;
    if (f == null) while (++i < n) set.add(object[i]);
    else while (++i < n) set.add(f(object[i], i, object));
  }

  return set;
}

/* unused harmony default export */ var _unused_webpack_default_export = (set);


/***/ }),
/* 835 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(map) {
  var values = [];
  for (var key in map) values.push(map[key]);
  return values;
});


/***/ }),
/* 836 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = cubehelix;
/* unused harmony export Cubehelix */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__define__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(389);




var A = -0.14861,
    B = +1.78277,
    C = -0.29227,
    D = -0.90649,
    E = +1.97294,
    ED = E * D,
    EB = E * B,
    BC_DA = B * C - D * A;

function cubehelixConvert(o) {
  if (o instanceof Cubehelix) return new Cubehelix(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof __WEBPACK_IMPORTED_MODULE_1__color__["b" /* Rgb */])) o = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["c" /* rgbConvert */])(o);
  var r = o.r / 255,
      g = o.g / 255,
      b = o.b / 255,
      l = (BC_DA * b + ED * r - EB * g) / (BC_DA + ED - EB),
      bl = b - l,
      k = (E * (g - l) - C * bl) / D,
      s = Math.sqrt(k * k + bl * bl) / (E * l * (1 - l)), // NaN if l=0 or l=1
      h = s ? Math.atan2(k, bl) * __WEBPACK_IMPORTED_MODULE_2__math__["a" /* rad2deg */] - 120 : NaN;
  return new Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
}

function cubehelix(h, s, l, opacity) {
  return arguments.length === 1 ? cubehelixConvert(h) : new Cubehelix(h, s, l, opacity == null ? 1 : opacity);
}

function Cubehelix(h, s, l, opacity) {
  this.h = +h;
  this.s = +s;
  this.l = +l;
  this.opacity = +opacity;
}

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Cubehelix, cubehelix, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define__["b" /* extend */])(__WEBPACK_IMPORTED_MODULE_1__color__["d" /* Color */], {
  brighter: function(k) {
    k = k == null ? __WEBPACK_IMPORTED_MODULE_1__color__["e" /* brighter */] : Math.pow(__WEBPACK_IMPORTED_MODULE_1__color__["e" /* brighter */], k);
    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? __WEBPACK_IMPORTED_MODULE_1__color__["f" /* darker */] : Math.pow(__WEBPACK_IMPORTED_MODULE_1__color__["f" /* darker */], k);
    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
  },
  rgb: function() {
    var h = isNaN(this.h) ? 0 : (this.h + 120) * __WEBPACK_IMPORTED_MODULE_2__math__["b" /* deg2rad */],
        l = +this.l,
        a = isNaN(this.s) ? 0 : this.s * l * (1 - l),
        cosh = Math.cos(h),
        sinh = Math.sin(h);
    return new __WEBPACK_IMPORTED_MODULE_1__color__["b" /* Rgb */](
      255 * (l + a * (A * cosh + B * sinh)),
      255 * (l + a * (C * cosh + D * sinh)),
      255 * (l + a * (E * cosh)),
      this.opacity
    );
  }
}));


/***/ }),
/* 837 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = lab;
/* unused harmony export Lab */
/* harmony export (immutable) */ __webpack_exports__["a"] = hcl;
/* unused harmony export Hcl */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__define__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(389);




var Kn = 18,
    Xn = 0.950470, // D65 standard referent
    Yn = 1,
    Zn = 1.088830,
    t0 = 4 / 29,
    t1 = 6 / 29,
    t2 = 3 * t1 * t1,
    t3 = t1 * t1 * t1;

function labConvert(o) {
  if (o instanceof Lab) return new Lab(o.l, o.a, o.b, o.opacity);
  if (o instanceof Hcl) {
    var h = o.h * __WEBPACK_IMPORTED_MODULE_2__math__["b" /* deg2rad */];
    return new Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
  }
  if (!(o instanceof __WEBPACK_IMPORTED_MODULE_1__color__["b" /* Rgb */])) o = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["c" /* rgbConvert */])(o);
  var b = rgb2xyz(o.r),
      a = rgb2xyz(o.g),
      l = rgb2xyz(o.b),
      x = xyz2lab((0.4124564 * b + 0.3575761 * a + 0.1804375 * l) / Xn),
      y = xyz2lab((0.2126729 * b + 0.7151522 * a + 0.0721750 * l) / Yn),
      z = xyz2lab((0.0193339 * b + 0.1191920 * a + 0.9503041 * l) / Zn);
  return new Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
}

function lab(l, a, b, opacity) {
  return arguments.length === 1 ? labConvert(l) : new Lab(l, a, b, opacity == null ? 1 : opacity);
}

function Lab(l, a, b, opacity) {
  this.l = +l;
  this.a = +a;
  this.b = +b;
  this.opacity = +opacity;
}

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Lab, lab, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define__["b" /* extend */])(__WEBPACK_IMPORTED_MODULE_1__color__["d" /* Color */], {
  brighter: function(k) {
    return new Lab(this.l + Kn * (k == null ? 1 : k), this.a, this.b, this.opacity);
  },
  darker: function(k) {
    return new Lab(this.l - Kn * (k == null ? 1 : k), this.a, this.b, this.opacity);
  },
  rgb: function() {
    var y = (this.l + 16) / 116,
        x = isNaN(this.a) ? y : y + this.a / 500,
        z = isNaN(this.b) ? y : y - this.b / 200;
    y = Yn * lab2xyz(y);
    x = Xn * lab2xyz(x);
    z = Zn * lab2xyz(z);
    return new __WEBPACK_IMPORTED_MODULE_1__color__["b" /* Rgb */](
      xyz2rgb( 3.2404542 * x - 1.5371385 * y - 0.4985314 * z), // D65 -> sRGB
      xyz2rgb(-0.9692660 * x + 1.8760108 * y + 0.0415560 * z),
      xyz2rgb( 0.0556434 * x - 0.2040259 * y + 1.0572252 * z),
      this.opacity
    );
  }
}));

function xyz2lab(t) {
  return t > t3 ? Math.pow(t, 1 / 3) : t / t2 + t0;
}

function lab2xyz(t) {
  return t > t1 ? t * t * t : t2 * (t - t0);
}

function xyz2rgb(x) {
  return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
}

function rgb2xyz(x) {
  return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
}

function hclConvert(o) {
  if (o instanceof Hcl) return new Hcl(o.h, o.c, o.l, o.opacity);
  if (!(o instanceof Lab)) o = labConvert(o);
  var h = Math.atan2(o.b, o.a) * __WEBPACK_IMPORTED_MODULE_2__math__["a" /* rad2deg */];
  return new Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
}

function hcl(h, c, l, opacity) {
  return arguments.length === 1 ? hclConvert(h) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
}

function Hcl(h, c, l, opacity) {
  this.h = +h;
  this.c = +c;
  this.l = +l;
  this.opacity = +opacity;
}

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Hcl, hcl, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define__["b" /* extend */])(__WEBPACK_IMPORTED_MODULE_1__color__["d" /* Color */], {
  brighter: function(k) {
    return new Hcl(this.h, this.c, this.l + Kn * (k == null ? 1 : k), this.opacity);
  },
  darker: function(k) {
    return new Hcl(this.h, this.c, this.l - Kn * (k == null ? 1 : k), this.opacity);
  },
  rgb: function() {
    return labConvert(this).rgb();
  }
}));


/***/ }),
/* 838 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var noop = {value: function() {}};

function dispatch() {
  for (var i = 0, n = arguments.length, _ = {}, t; i < n; ++i) {
    if (!(t = arguments[i] + "") || (t in _)) throw new Error("illegal type: " + t);
    _[t] = [];
  }
  return new Dispatch(_);
}

function Dispatch(_) {
  this._ = _;
}

function parseTypenames(typenames, types) {
  return typenames.trim().split(/^|\s+/).map(function(t) {
    var name = "", i = t.indexOf(".");
    if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
    if (t && !types.hasOwnProperty(t)) throw new Error("unknown type: " + t);
    return {type: t, name: name};
  });
}

Dispatch.prototype = dispatch.prototype = {
  constructor: Dispatch,
  on: function(typename, callback) {
    var _ = this._,
        T = parseTypenames(typename + "", _),
        t,
        i = -1,
        n = T.length;

    // If no callback was specified, return the callback of the given type and name.
    if (arguments.length < 2) {
      while (++i < n) if ((t = (typename = T[i]).type) && (t = get(_[t], typename.name))) return t;
      return;
    }

    // If a type was specified, set the callback for the given type and name.
    // Otherwise, if a null callback was specified, remove callbacks of the given name.
    if (callback != null && typeof callback !== "function") throw new Error("invalid callback: " + callback);
    while (++i < n) {
      if (t = (typename = T[i]).type) _[t] = set(_[t], typename.name, callback);
      else if (callback == null) for (t in _) _[t] = set(_[t], typename.name, null);
    }

    return this;
  },
  copy: function() {
    var copy = {}, _ = this._;
    for (var t in _) copy[t] = _[t].slice();
    return new Dispatch(copy);
  },
  call: function(type, that) {
    if ((n = arguments.length - 2) > 0) for (var args = new Array(n), i = 0, n, t; i < n; ++i) args[i] = arguments[i + 2];
    if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
    for (t = this._[type], i = 0, n = t.length; i < n; ++i) t[i].value.apply(that, args);
  },
  apply: function(type, that, args) {
    if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
    for (var t = this._[type], i = 0, n = t.length; i < n; ++i) t[i].value.apply(that, args);
  }
};

function get(type, name) {
  for (var i = 0, n = type.length, c; i < n; ++i) {
    if ((c = type[i]).name === name) {
      return c.value;
    }
  }
}

function set(type, name, callback) {
  for (var i = 0, n = type.length; i < n; ++i) {
    if (type[i].name === name) {
      type[i] = noop, type = type.slice(0, i).concat(type.slice(i + 1));
      break;
    }
  }
  if (callback != null) type.push({name: name, value: callback});
  return type;
}

/* harmony default export */ __webpack_exports__["a"] = (dispatch);


/***/ }),
/* 839 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 840 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_dispatch__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_selection__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nodrag__ = __webpack_require__(390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__noevent__ = __webpack_require__(391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constant__ = __webpack_require__(839);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__event__ = __webpack_require__(841);







// Ignore right-click, since that should open the context menu.
function defaultFilter() {
  return !__WEBPACK_IMPORTED_MODULE_1_d3_selection__["b" /* event */].button;
}

function defaultContainer() {
  return this.parentNode;
}

function defaultSubject(d) {
  return d == null ? {x: __WEBPACK_IMPORTED_MODULE_1_d3_selection__["b" /* event */].x, y: __WEBPACK_IMPORTED_MODULE_1_d3_selection__["b" /* event */].y} : d;
}

function defaultTouchable() {
  return "ontouchstart" in this;
}

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var filter = defaultFilter,
      container = defaultContainer,
      subject = defaultSubject,
      touchable = defaultTouchable,
      gestures = {},
      listeners = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_dispatch__["a" /* dispatch */])("start", "drag", "end"),
      active = 0,
      mousedownx,
      mousedowny,
      mousemoving,
      touchending,
      clickDistance2 = 0;

  function drag(selection) {
    selection
        .on("mousedown.drag", mousedowned)
      .filter(touchable)
        .on("touchstart.drag", touchstarted)
        .on("touchmove.drag", touchmoved)
        .on("touchend.drag touchcancel.drag", touchended)
        .style("touch-action", "none")
        .style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
  }

  function mousedowned() {
    if (touchending || !filter.apply(this, arguments)) return;
    var gesture = beforestart("mouse", container.apply(this, arguments), __WEBPACK_IMPORTED_MODULE_1_d3_selection__["d" /* mouse */], this, arguments);
    if (!gesture) return;
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["a" /* select */])(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["b" /* event */].view).on("mousemove.drag", mousemoved, true).on("mouseup.drag", mouseupped, true);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__nodrag__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["b" /* event */].view);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__noevent__["b" /* nopropagation */])();
    mousemoving = false;
    mousedownx = __WEBPACK_IMPORTED_MODULE_1_d3_selection__["b" /* event */].clientX;
    mousedowny = __WEBPACK_IMPORTED_MODULE_1_d3_selection__["b" /* event */].clientY;
    gesture("start");
  }

  function mousemoved() {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__noevent__["a" /* default */])();
    if (!mousemoving) {
      var dx = __WEBPACK_IMPORTED_MODULE_1_d3_selection__["b" /* event */].clientX - mousedownx, dy = __WEBPACK_IMPORTED_MODULE_1_d3_selection__["b" /* event */].clientY - mousedowny;
      mousemoving = dx * dx + dy * dy > clickDistance2;
    }
    gestures.mouse("drag");
  }

  function mouseupped() {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["a" /* select */])(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["b" /* event */].view).on("mousemove.drag mouseup.drag", null);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__nodrag__["b" /* yesdrag */])(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["b" /* event */].view, mousemoving);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__noevent__["a" /* default */])();
    gestures.mouse("end");
  }

  function touchstarted() {
    if (!filter.apply(this, arguments)) return;
    var touches = __WEBPACK_IMPORTED_MODULE_1_d3_selection__["b" /* event */].changedTouches,
        c = container.apply(this, arguments),
        n = touches.length, i, gesture;

    for (i = 0; i < n; ++i) {
      if (gesture = beforestart(touches[i].identifier, c, __WEBPACK_IMPORTED_MODULE_1_d3_selection__["e" /* touch */], this, arguments)) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__noevent__["b" /* nopropagation */])();
        gesture("start");
      }
    }
  }

  function touchmoved() {
    var touches = __WEBPACK_IMPORTED_MODULE_1_d3_selection__["b" /* event */].changedTouches,
        n = touches.length, i, gesture;

    for (i = 0; i < n; ++i) {
      if (gesture = gestures[touches[i].identifier]) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__noevent__["a" /* default */])();
        gesture("drag");
      }
    }
  }

  function touchended() {
    var touches = __WEBPACK_IMPORTED_MODULE_1_d3_selection__["b" /* event */].changedTouches,
        n = touches.length, i, gesture;

    if (touchending) clearTimeout(touchending);
    touchending = setTimeout(function() { touchending = null; }, 500); // Ghost clicks are delayed!
    for (i = 0; i < n; ++i) {
      if (gesture = gestures[touches[i].identifier]) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__noevent__["b" /* nopropagation */])();
        gesture("end");
      }
    }
  }

  function beforestart(id, container, point, that, args) {
    var p = point(container, id), s, dx, dy,
        sublisteners = listeners.copy();

    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["c" /* customEvent */])(new __WEBPACK_IMPORTED_MODULE_5__event__["a" /* default */](drag, "beforestart", s, id, active, p[0], p[1], 0, 0, sublisteners), function() {
      if ((__WEBPACK_IMPORTED_MODULE_1_d3_selection__["b" /* event */].subject = s = subject.apply(that, args)) == null) return false;
      dx = s.x - p[0] || 0;
      dy = s.y - p[1] || 0;
      return true;
    })) return;

    return function gesture(type) {
      var p0 = p, n;
      switch (type) {
        case "start": gestures[id] = gesture, n = active++; break;
        case "end": delete gestures[id], --active; // nobreak
        case "drag": p = point(container, id), n = active; break;
      }
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["c" /* customEvent */])(new __WEBPACK_IMPORTED_MODULE_5__event__["a" /* default */](drag, type, s, id, n, p[0] + dx, p[1] + dy, p[0] - p0[0], p[1] - p0[1], sublisteners), sublisteners.apply, sublisteners, [type, that, args]);
    };
  }

  drag.filter = function(_) {
    return arguments.length ? (filter = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__constant__["a" /* default */])(!!_), drag) : filter;
  };

  drag.container = function(_) {
    return arguments.length ? (container = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__constant__["a" /* default */])(_), drag) : container;
  };

  drag.subject = function(_) {
    return arguments.length ? (subject = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__constant__["a" /* default */])(_), drag) : subject;
  };

  drag.touchable = function(_) {
    return arguments.length ? (touchable = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__constant__["a" /* default */])(!!_), drag) : touchable;
  };

  drag.on = function() {
    var value = listeners.on.apply(listeners, arguments);
    return value === listeners ? drag : value;
  };

  drag.clickDistance = function(_) {
    return arguments.length ? (clickDistance2 = (_ = +_) * _, drag) : Math.sqrt(clickDistance2);
  };

  return drag;
});


/***/ }),
/* 841 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = DragEvent;
function DragEvent(target, type, subject, id, active, x, y, dx, dy, dispatch) {
  this.target = target;
  this.type = type;
  this.subject = subject;
  this.identifier = id;
  this.active = active;
  this.x = x;
  this.y = y;
  this.dx = dx;
  this.dy = dy;
  this._ = dispatch;
}

DragEvent.prototype.on = function() {
  var value = this._.on.apply(this._, arguments);
  return value === this._ ? this : value;
};


/***/ }),
/* 842 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return csvParse; });
/* unused harmony export csvParseRows */
/* unused harmony export csvFormat */
/* unused harmony export csvFormatRows */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dsv__ = __webpack_require__(235);


var csv = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__dsv__["a" /* default */])(",");

var csvParse = csv.parse;
var csvParseRows = csv.parseRows;
var csvFormat = csv.format;
var csvFormatRows = csv.formatRows;


/***/ }),
/* 843 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return tsvParse; });
/* unused harmony export tsvParseRows */
/* unused harmony export tsvFormat */
/* unused harmony export tsvFormatRows */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dsv__ = __webpack_require__(235);


var tsv = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__dsv__["a" /* default */])("\t");

var tsvParse = tsv.parse;
var tsvParseRows = tsv.parseRows;
var tsvFormat = tsv.format;
var tsvFormatRows = tsv.formatRows;


/***/ }),
/* 844 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export backIn */
/* unused harmony export backOut */
/* unused harmony export backInOut */
var overshoot = 1.70158;

var backIn = (function custom(s) {
  s = +s;

  function backIn(t) {
    return t * t * ((s + 1) * t - s);
  }

  backIn.overshoot = custom;

  return backIn;
})(overshoot);

var backOut = (function custom(s) {
  s = +s;

  function backOut(t) {
    return --t * t * ((s + 1) * t + s) + 1;
  }

  backOut.overshoot = custom;

  return backOut;
})(overshoot);

var backInOut = (function custom(s) {
  s = +s;

  function backInOut(t) {
    return ((t *= 2) < 1 ? t * t * ((s + 1) * t - s) : (t -= 2) * t * ((s + 1) * t + s) + 2) / 2;
  }

  backInOut.overshoot = custom;

  return backInOut;
})(overshoot);


/***/ }),
/* 845 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export bounceIn */
/* unused harmony export bounceOut */
/* unused harmony export bounceInOut */
var b1 = 4 / 11,
    b2 = 6 / 11,
    b3 = 8 / 11,
    b4 = 3 / 4,
    b5 = 9 / 11,
    b6 = 10 / 11,
    b7 = 15 / 16,
    b8 = 21 / 22,
    b9 = 63 / 64,
    b0 = 1 / b1 / b1;

function bounceIn(t) {
  return 1 - bounceOut(1 - t);
}

function bounceOut(t) {
  return (t = +t) < b1 ? b0 * t * t : t < b3 ? b0 * (t -= b2) * t + b4 : t < b6 ? b0 * (t -= b5) * t + b7 : b0 * (t -= b8) * t + b9;
}

function bounceInOut(t) {
  return ((t *= 2) <= 1 ? 1 - bounceOut(1 - t) : bounceOut(t - 1) + 1) / 2;
}


/***/ }),
/* 846 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export circleIn */
/* unused harmony export circleOut */
/* unused harmony export circleInOut */
function circleIn(t) {
  return 1 - Math.sqrt(1 - t * t);
}

function circleOut(t) {
  return Math.sqrt(1 - --t * t);
}

function circleInOut(t) {
  return ((t *= 2) <= 1 ? 1 - Math.sqrt(1 - t * t) : Math.sqrt(1 - (t -= 2) * t) + 1) / 2;
}


/***/ }),
/* 847 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export cubicIn */
/* unused harmony export cubicOut */
/* harmony export (immutable) */ __webpack_exports__["a"] = cubicInOut;
function cubicIn(t) {
  return t * t * t;
}

function cubicOut(t) {
  return --t * t * t + 1;
}

function cubicInOut(t) {
  return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
}


/***/ }),
/* 848 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export elasticIn */
/* unused harmony export elasticOut */
/* unused harmony export elasticInOut */
var tau = 2 * Math.PI,
    amplitude = 1,
    period = 0.3;

var elasticIn = (function custom(a, p) {
  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);

  function elasticIn(t) {
    return a * Math.pow(2, 10 * --t) * Math.sin((s - t) / p);
  }

  elasticIn.amplitude = function(a) { return custom(a, p * tau); };
  elasticIn.period = function(p) { return custom(a, p); };

  return elasticIn;
})(amplitude, period);

var elasticOut = (function custom(a, p) {
  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);

  function elasticOut(t) {
    return 1 - a * Math.pow(2, -10 * (t = +t)) * Math.sin((t + s) / p);
  }

  elasticOut.amplitude = function(a) { return custom(a, p * tau); };
  elasticOut.period = function(p) { return custom(a, p); };

  return elasticOut;
})(amplitude, period);

var elasticInOut = (function custom(a, p) {
  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);

  function elasticInOut(t) {
    return ((t = t * 2 - 1) < 0
        ? a * Math.pow(2, 10 * t) * Math.sin((s - t) / p)
        : 2 - a * Math.pow(2, -10 * t) * Math.sin((s + t) / p)) / 2;
  }

  elasticInOut.amplitude = function(a) { return custom(a, p * tau); };
  elasticInOut.period = function(p) { return custom(a, p); };

  return elasticInOut;
})(amplitude, period);


/***/ }),
/* 849 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export expIn */
/* unused harmony export expOut */
/* unused harmony export expInOut */
function expIn(t) {
  return Math.pow(2, 10 * t - 10);
}

function expOut(t) {
  return 1 - Math.pow(2, -10 * t);
}

function expInOut(t) {
  return ((t *= 2) <= 1 ? Math.pow(2, 10 * t - 10) : 2 - Math.pow(2, 10 - 10 * t)) / 2;
}


/***/ }),
/* 850 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export linear */
function linear(t) {
  return +t;
}


/***/ }),
/* 851 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export polyIn */
/* unused harmony export polyOut */
/* unused harmony export polyInOut */
var exponent = 3;

var polyIn = (function custom(e) {
  e = +e;

  function polyIn(t) {
    return Math.pow(t, e);
  }

  polyIn.exponent = custom;

  return polyIn;
})(exponent);

var polyOut = (function custom(e) {
  e = +e;

  function polyOut(t) {
    return 1 - Math.pow(1 - t, e);
  }

  polyOut.exponent = custom;

  return polyOut;
})(exponent);

var polyInOut = (function custom(e) {
  e = +e;

  function polyInOut(t) {
    return ((t *= 2) <= 1 ? Math.pow(t, e) : 2 - Math.pow(2 - t, e)) / 2;
  }

  polyInOut.exponent = custom;

  return polyInOut;
})(exponent);


/***/ }),
/* 852 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export quadIn */
/* unused harmony export quadOut */
/* unused harmony export quadInOut */
function quadIn(t) {
  return t * t;
}

function quadOut(t) {
  return t * (2 - t);
}

function quadInOut(t) {
  return ((t *= 2) <= 1 ? t * t : --t * (2 - t) + 1) / 2;
}


/***/ }),
/* 853 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export sinIn */
/* unused harmony export sinOut */
/* unused harmony export sinInOut */
var pi = Math.PI,
    halfPi = pi / 2;

function sinIn(t) {
  return 1 - Math.cos(t * halfPi);
}

function sinOut(t) {
  return Math.sin(t * halfPi);
}

function sinInOut(t) {
  return (1 - Math.cos(pi * t)) / 2;
}


/***/ }),
/* 854 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_center__ = __webpack_require__(855);
/* unused harmony reexport forceCenter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_collide__ = __webpack_require__(856);
/* unused harmony reexport forceCollide */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_link__ = __webpack_require__(857);
/* unused harmony reexport forceLink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_manyBody__ = __webpack_require__(858);
/* unused harmony reexport forceManyBody */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_radial__ = __webpack_require__(859);
/* unused harmony reexport forceRadial */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_simulation__ = __webpack_require__(393);
/* unused harmony reexport forceSimulation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_x__ = __webpack_require__(860);
/* unused harmony reexport forceX */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_y__ = __webpack_require__(861);
/* unused harmony reexport forceY */










/***/ }),
/* 855 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(x, y) {
  var nodes;

  if (x == null) x = 0;
  if (y == null) y = 0;

  function force() {
    var i,
        n = nodes.length,
        node,
        sx = 0,
        sy = 0;

    for (i = 0; i < n; ++i) {
      node = nodes[i], sx += node.x, sy += node.y;
    }

    for (sx = sx / n - x, sy = sy / n - y, i = 0; i < n; ++i) {
      node = nodes[i], node.x -= sx, node.y -= sy;
    }
  }

  force.initialize = function(_) {
    nodes = _;
  };

  force.x = function(_) {
    return arguments.length ? (x = +_, force) : x;
  };

  force.y = function(_) {
    return arguments.length ? (y = +_, force) : y;
  };

  return force;
});


/***/ }),
/* 856 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jiggle__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_quadtree__ = __webpack_require__(249);




function x(d) {
  return d.x + d.vx;
}

function y(d) {
  return d.y + d.vy;
}

/* unused harmony default export */ var _unused_webpack_default_export = (function(radius) {
  var nodes,
      radii,
      strength = 1,
      iterations = 1;

  if (typeof radius !== "function") radius = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(radius == null ? 1 : +radius);

  function force() {
    var i, n = nodes.length,
        tree,
        node,
        xi,
        yi,
        ri,
        ri2;

    for (var k = 0; k < iterations; ++k) {
      tree = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_d3_quadtree__["a" /* quadtree */])(nodes, x, y).visitAfter(prepare);
      for (i = 0; i < n; ++i) {
        node = nodes[i];
        ri = radii[node.index], ri2 = ri * ri;
        xi = node.x + node.vx;
        yi = node.y + node.vy;
        tree.visit(apply);
      }
    }

    function apply(quad, x0, y0, x1, y1) {
      var data = quad.data, rj = quad.r, r = ri + rj;
      if (data) {
        if (data.index > node.index) {
          var x = xi - data.x - data.vx,
              y = yi - data.y - data.vy,
              l = x * x + y * y;
          if (l < r * r) {
            if (x === 0) x = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__jiggle__["a" /* default */])(), l += x * x;
            if (y === 0) y = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__jiggle__["a" /* default */])(), l += y * y;
            l = (r - (l = Math.sqrt(l))) / l * strength;
            node.vx += (x *= l) * (r = (rj *= rj) / (ri2 + rj));
            node.vy += (y *= l) * r;
            data.vx -= x * (r = 1 - r);
            data.vy -= y * r;
          }
        }
        return;
      }
      return x0 > xi + r || x1 < xi - r || y0 > yi + r || y1 < yi - r;
    }
  }

  function prepare(quad) {
    if (quad.data) return quad.r = radii[quad.data.index];
    for (var i = quad.r = 0; i < 4; ++i) {
      if (quad[i] && quad[i].r > quad.r) {
        quad.r = quad[i].r;
      }
    }
  }

  function initialize() {
    if (!nodes) return;
    var i, n = nodes.length, node;
    radii = new Array(n);
    for (i = 0; i < n; ++i) node = nodes[i], radii[node.index] = +radius(node, i, nodes);
  }

  force.initialize = function(_) {
    nodes = _;
    initialize();
  };

  force.iterations = function(_) {
    return arguments.length ? (iterations = +_, force) : iterations;
  };

  force.strength = function(_) {
    return arguments.length ? (strength = +_, force) : strength;
  };

  force.radius = function(_) {
    return arguments.length ? (radius = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), initialize(), force) : radius;
  };

  return force;
});


/***/ }),
/* 857 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jiggle__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_collection__ = __webpack_require__(114);




function index(d) {
  return d.index;
}

function find(nodeById, nodeId) {
  var node = nodeById.get(nodeId);
  if (!node) throw new Error("missing: " + nodeId);
  return node;
}

/* unused harmony default export */ var _unused_webpack_default_export = (function(links) {
  var id = index,
      strength = defaultStrength,
      strengths,
      distance = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(30),
      distances,
      nodes,
      count,
      bias,
      iterations = 1;

  if (links == null) links = [];

  function defaultStrength(link) {
    return 1 / Math.min(count[link.source.index], count[link.target.index]);
  }

  function force(alpha) {
    for (var k = 0, n = links.length; k < iterations; ++k) {
      for (var i = 0, link, source, target, x, y, l, b; i < n; ++i) {
        link = links[i], source = link.source, target = link.target;
        x = target.x + target.vx - source.x - source.vx || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__jiggle__["a" /* default */])();
        y = target.y + target.vy - source.y - source.vy || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__jiggle__["a" /* default */])();
        l = Math.sqrt(x * x + y * y);
        l = (l - distances[i]) / l * alpha * strengths[i];
        x *= l, y *= l;
        target.vx -= x * (b = bias[i]);
        target.vy -= y * b;
        source.vx += x * (b = 1 - b);
        source.vy += y * b;
      }
    }
  }

  function initialize() {
    if (!nodes) return;

    var i,
        n = nodes.length,
        m = links.length,
        nodeById = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_d3_collection__["a" /* map */])(nodes, id),
        link;

    for (i = 0, count = new Array(n); i < m; ++i) {
      link = links[i], link.index = i;
      if (typeof link.source !== "object") link.source = find(nodeById, link.source);
      if (typeof link.target !== "object") link.target = find(nodeById, link.target);
      count[link.source.index] = (count[link.source.index] || 0) + 1;
      count[link.target.index] = (count[link.target.index] || 0) + 1;
    }

    for (i = 0, bias = new Array(m); i < m; ++i) {
      link = links[i], bias[i] = count[link.source.index] / (count[link.source.index] + count[link.target.index]);
    }

    strengths = new Array(m), initializeStrength();
    distances = new Array(m), initializeDistance();
  }

  function initializeStrength() {
    if (!nodes) return;

    for (var i = 0, n = links.length; i < n; ++i) {
      strengths[i] = +strength(links[i], i, links);
    }
  }

  function initializeDistance() {
    if (!nodes) return;

    for (var i = 0, n = links.length; i < n; ++i) {
      distances[i] = +distance(links[i], i, links);
    }
  }

  force.initialize = function(_) {
    nodes = _;
    initialize();
  };

  force.links = function(_) {
    return arguments.length ? (links = _, initialize(), force) : links;
  };

  force.id = function(_) {
    return arguments.length ? (id = _, force) : id;
  };

  force.iterations = function(_) {
    return arguments.length ? (iterations = +_, force) : iterations;
  };

  force.strength = function(_) {
    return arguments.length ? (strength = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), initializeStrength(), force) : strength;
  };

  force.distance = function(_) {
    return arguments.length ? (distance = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), initializeDistance(), force) : distance;
  };

  return force;
});


/***/ }),
/* 858 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jiggle__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_quadtree__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__simulation__ = __webpack_require__(393);





/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var nodes,
      node,
      alpha,
      strength = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(-30),
      strengths,
      distanceMin2 = 1,
      distanceMax2 = Infinity,
      theta2 = 0.81;

  function force(_) {
    var i, n = nodes.length, tree = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_d3_quadtree__["a" /* quadtree */])(nodes, __WEBPACK_IMPORTED_MODULE_3__simulation__["a" /* x */], __WEBPACK_IMPORTED_MODULE_3__simulation__["b" /* y */]).visitAfter(accumulate);
    for (alpha = _, i = 0; i < n; ++i) node = nodes[i], tree.visit(apply);
  }

  function initialize() {
    if (!nodes) return;
    var i, n = nodes.length, node;
    strengths = new Array(n);
    for (i = 0; i < n; ++i) node = nodes[i], strengths[node.index] = +strength(node, i, nodes);
  }

  function accumulate(quad) {
    var strength = 0, q, c, weight = 0, x, y, i;

    // For internal nodes, accumulate forces from child quadrants.
    if (quad.length) {
      for (x = y = i = 0; i < 4; ++i) {
        if ((q = quad[i]) && (c = Math.abs(q.value))) {
          strength += q.value, weight += c, x += c * q.x, y += c * q.y;
        }
      }
      quad.x = x / weight;
      quad.y = y / weight;
    }

    // For leaf nodes, accumulate forces from coincident quadrants.
    else {
      q = quad;
      q.x = q.data.x;
      q.y = q.data.y;
      do strength += strengths[q.data.index];
      while (q = q.next);
    }

    quad.value = strength;
  }

  function apply(quad, x1, _, x2) {
    if (!quad.value) return true;

    var x = quad.x - node.x,
        y = quad.y - node.y,
        w = x2 - x1,
        l = x * x + y * y;

    // Apply the Barnes-Hut approximation if possible.
    // Limit forces for very close nodes; randomize direction if coincident.
    if (w * w / theta2 < l) {
      if (l < distanceMax2) {
        if (x === 0) x = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__jiggle__["a" /* default */])(), l += x * x;
        if (y === 0) y = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__jiggle__["a" /* default */])(), l += y * y;
        if (l < distanceMin2) l = Math.sqrt(distanceMin2 * l);
        node.vx += x * quad.value * alpha / l;
        node.vy += y * quad.value * alpha / l;
      }
      return true;
    }

    // Otherwise, process points directly.
    else if (quad.length || l >= distanceMax2) return;

    // Limit forces for very close nodes; randomize direction if coincident.
    if (quad.data !== node || quad.next) {
      if (x === 0) x = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__jiggle__["a" /* default */])(), l += x * x;
      if (y === 0) y = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__jiggle__["a" /* default */])(), l += y * y;
      if (l < distanceMin2) l = Math.sqrt(distanceMin2 * l);
    }

    do if (quad.data !== node) {
      w = strengths[quad.data.index] * alpha / l;
      node.vx += x * w;
      node.vy += y * w;
    } while (quad = quad.next);
  }

  force.initialize = function(_) {
    nodes = _;
    initialize();
  };

  force.strength = function(_) {
    return arguments.length ? (strength = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), initialize(), force) : strength;
  };

  force.distanceMin = function(_) {
    return arguments.length ? (distanceMin2 = _ * _, force) : Math.sqrt(distanceMin2);
  };

  force.distanceMax = function(_) {
    return arguments.length ? (distanceMax2 = _ * _, force) : Math.sqrt(distanceMax2);
  };

  force.theta = function(_) {
    return arguments.length ? (theta2 = _ * _, force) : Math.sqrt(theta2);
  };

  return force;
});


/***/ }),
/* 859 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(106);


/* unused harmony default export */ var _unused_webpack_default_export = (function(radius, x, y) {
  var nodes,
      strength = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(0.1),
      strengths,
      radiuses;

  if (typeof radius !== "function") radius = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+radius);
  if (x == null) x = 0;
  if (y == null) y = 0;

  function force(alpha) {
    for (var i = 0, n = nodes.length; i < n; ++i) {
      var node = nodes[i],
          dx = node.x - x || 1e-6,
          dy = node.y - y || 1e-6,
          r = Math.sqrt(dx * dx + dy * dy),
          k = (radiuses[i] - r) * strengths[i] * alpha / r;
      node.vx += dx * k;
      node.vy += dy * k;
    }
  }

  function initialize() {
    if (!nodes) return;
    var i, n = nodes.length;
    strengths = new Array(n);
    radiuses = new Array(n);
    for (i = 0; i < n; ++i) {
      radiuses[i] = +radius(nodes[i], i, nodes);
      strengths[i] = isNaN(radiuses[i]) ? 0 : +strength(nodes[i], i, nodes);
    }
  }

  force.initialize = function(_) {
    nodes = _, initialize();
  };

  force.strength = function(_) {
    return arguments.length ? (strength = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), initialize(), force) : strength;
  };

  force.radius = function(_) {
    return arguments.length ? (radius = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), initialize(), force) : radius;
  };

  force.x = function(_) {
    return arguments.length ? (x = +_, force) : x;
  };

  force.y = function(_) {
    return arguments.length ? (y = +_, force) : y;
  };

  return force;
});


/***/ }),
/* 860 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(106);


/* unused harmony default export */ var _unused_webpack_default_export = (function(x) {
  var strength = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(0.1),
      nodes,
      strengths,
      xz;

  if (typeof x !== "function") x = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(x == null ? 0 : +x);

  function force(alpha) {
    for (var i = 0, n = nodes.length, node; i < n; ++i) {
      node = nodes[i], node.vx += (xz[i] - node.x) * strengths[i] * alpha;
    }
  }

  function initialize() {
    if (!nodes) return;
    var i, n = nodes.length;
    strengths = new Array(n);
    xz = new Array(n);
    for (i = 0; i < n; ++i) {
      strengths[i] = isNaN(xz[i] = +x(nodes[i], i, nodes)) ? 0 : +strength(nodes[i], i, nodes);
    }
  }

  force.initialize = function(_) {
    nodes = _;
    initialize();
  };

  force.strength = function(_) {
    return arguments.length ? (strength = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), initialize(), force) : strength;
  };

  force.x = function(_) {
    return arguments.length ? (x = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), initialize(), force) : x;
  };

  return force;
});


/***/ }),
/* 861 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(106);


/* unused harmony default export */ var _unused_webpack_default_export = (function(y) {
  var strength = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(0.1),
      nodes,
      strengths,
      yz;

  if (typeof y !== "function") y = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(y == null ? 0 : +y);

  function force(alpha) {
    for (var i = 0, n = nodes.length, node; i < n; ++i) {
      node = nodes[i], node.vy += (yz[i] - node.y) * strengths[i] * alpha;
    }
  }

  function initialize() {
    if (!nodes) return;
    var i, n = nodes.length;
    strengths = new Array(n);
    yz = new Array(n);
    for (i = 0; i < n; ++i) {
      strengths[i] = isNaN(yz[i] = +y(nodes[i], i, nodes)) ? 0 : +strength(nodes[i], i, nodes);
    }
  }

  force.initialize = function(_) {
    nodes = _;
    initialize();
  };

  force.strength = function(_) {
    return arguments.length ? (strength = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), initialize(), force) : strength;
  };

  force.y = function(_) {
    return arguments.length ? (y = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), initialize(), force) : y;
  };

  return force;
});


/***/ }),
/* 862 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return format; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return formatPrefix; });
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale__ = __webpack_require__(397);


var locale;
var format;
var formatPrefix;

defaultLocale({
  decimal: ".",
  thousands: ",",
  grouping: [3],
  currency: ["$", ""]
});

function defaultLocale(definition) {
  locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__locale__["a" /* default */])(definition);
  format = locale.format;
  formatPrefix = locale.formatPrefix;
  return locale;
}


/***/ }),
/* 863 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x, p) {
  x = x.toPrecision(p);

  out: for (var n = x.length, i = 1, i0 = -1, i1; i < n; ++i) {
    switch (x[i]) {
      case ".": i0 = i1 = i; break;
      case "0": if (i0 === 0) i0 = i; i1 = i; break;
      case "e": break out;
      default: if (i0 > 0) i0 = 0; break;
    }
  }

  return i0 > 0 ? x.slice(0, i0) + x.slice(i1 + 1) : x;
});


/***/ }),
/* 864 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(grouping, thousands) {
  return function(value, width) {
    var i = value.length,
        t = [],
        j = 0,
        g = grouping[0],
        length = 0;

    while (i > 0 && g > 0) {
      if (length + g + 1 > width) g = Math.max(1, width - length);
      t.push(value.substring(i -= g, i + g));
      if ((length += g + 1) > width) break;
      g = grouping[j = (j + 1) % grouping.length];
    }

    return t.reverse().join(thousands);
  };
});


/***/ }),
/* 865 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(numerals) {
  return function(value) {
    return value.replace(/[0-9]/g, function(i) {
      return numerals[+i];
    });
  };
});


/***/ }),
/* 866 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formatDecimal__ = __webpack_require__(238);


/* harmony default export */ __webpack_exports__["a"] = (function(x, p) {
  var d = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__formatDecimal__["a" /* default */])(x, p);
  if (!d) return x + "";
  var coefficient = d[0],
      exponent = d[1];
  return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient
      : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1)
      : coefficient + new Array(exponent - coefficient.length + 2).join("0");
});


/***/ }),
/* 867 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return x;
});


/***/ }),
/* 868 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exponent__ = __webpack_require__(149);


/* harmony default export */ __webpack_exports__["a"] = (function(step) {
  return Math.max(0, -__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__exponent__["a" /* default */])(Math.abs(step)));
});


/***/ }),
/* 869 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exponent__ = __webpack_require__(149);


/* harmony default export */ __webpack_exports__["a"] = (function(step, value) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__exponent__["a" /* default */])(value) / 3))) * 3 - __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__exponent__["a" /* default */])(Math.abs(step)));
});


/***/ }),
/* 870 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exponent__ = __webpack_require__(149);


/* harmony default export */ __webpack_exports__["a"] = (function(step, max) {
  step = Math.abs(step), max = Math.abs(max) - step;
  return Math.max(0, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__exponent__["a" /* default */])(max) - __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__exponent__["a" /* default */])(step)) + 1;
});


/***/ }),
/* 871 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_area__ = __webpack_require__(398);
/* unused harmony reexport geoArea */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_bounds__ = __webpack_require__(872);
/* unused harmony reexport geoBounds */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_centroid__ = __webpack_require__(873);
/* unused harmony reexport geoCentroid */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_circle__ = __webpack_require__(399);
/* unused harmony reexport geoCircle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_clip_antimeridian__ = __webpack_require__(400);
/* unused harmony reexport geoClipAntimeridian */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_clip_circle__ = __webpack_require__(402);
/* unused harmony reexport geoClipCircle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_clip_extent__ = __webpack_require__(874);
/* unused harmony reexport geoClipExtent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_clip_rectangle__ = __webpack_require__(150);
/* unused harmony reexport geoClipRectangle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_contains__ = __webpack_require__(877);
/* unused harmony reexport geoContains */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_distance__ = __webpack_require__(406);
/* unused harmony reexport geoDistance */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_graticule__ = __webpack_require__(878);
/* unused harmony reexport geoGraticule */
/* unused harmony reexport geoGraticule10 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_interpolate__ = __webpack_require__(879);
/* unused harmony reexport geoInterpolate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_length__ = __webpack_require__(407);
/* unused harmony reexport geoLength */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_path_index__ = __webpack_require__(883);
/* unused harmony reexport geoPath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_projection_albers__ = __webpack_require__(411);
/* unused harmony reexport geoAlbers */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__src_projection_albersUsa__ = __webpack_require__(886);
/* unused harmony reexport geoAlbersUsa */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__src_projection_azimuthalEqualArea__ = __webpack_require__(887);
/* unused harmony reexport geoAzimuthalEqualArea */
/* unused harmony reexport geoAzimuthalEqualAreaRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__src_projection_azimuthalEquidistant__ = __webpack_require__(888);
/* unused harmony reexport geoAzimuthalEquidistant */
/* unused harmony reexport geoAzimuthalEquidistantRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__src_projection_conicConformal__ = __webpack_require__(889);
/* unused harmony reexport geoConicConformal */
/* unused harmony reexport geoConicConformalRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__src_projection_conicEqualArea__ = __webpack_require__(241);
/* unused harmony reexport geoConicEqualArea */
/* unused harmony reexport geoConicEqualAreaRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__src_projection_conicEquidistant__ = __webpack_require__(890);
/* unused harmony reexport geoConicEquidistant */
/* unused harmony reexport geoConicEquidistantRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__src_projection_equirectangular__ = __webpack_require__(412);
/* unused harmony reexport geoEquirectangular */
/* unused harmony reexport geoEquirectangularRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__src_projection_gnomonic__ = __webpack_require__(892);
/* unused harmony reexport geoGnomonic */
/* unused harmony reexport geoGnomonicRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__src_projection_identity__ = __webpack_require__(893);
/* unused harmony reexport geoIdentity */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__src_projection_index__ = __webpack_require__(51);
/* unused harmony reexport geoProjection */
/* unused harmony reexport geoProjectionMutator */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__src_projection_mercator__ = __webpack_require__(243);
/* unused harmony reexport geoMercator */
/* unused harmony reexport geoMercatorRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__src_projection_naturalEarth1__ = __webpack_require__(894);
/* unused harmony reexport geoNaturalEarth1 */
/* unused harmony reexport geoNaturalEarth1Raw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__src_projection_orthographic__ = __webpack_require__(895);
/* unused harmony reexport geoOrthographic */
/* unused harmony reexport geoOrthographicRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__src_projection_stereographic__ = __webpack_require__(897);
/* unused harmony reexport geoStereographic */
/* unused harmony reexport geoStereographicRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__src_projection_transverseMercator__ = __webpack_require__(898);
/* unused harmony reexport geoTransverseMercator */
/* unused harmony reexport geoTransverseMercatorRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__src_rotation__ = __webpack_require__(151);
/* unused harmony reexport geoRotation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__src_stream__ = __webpack_require__(88);
/* unused harmony reexport geoStream */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__src_transform__ = __webpack_require__(152);
/* unused harmony reexport geoTransform */






 // DEPRECATED! Use d3.geoIdentity().clipExtent(…).




























/***/ }),
/* 872 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__adder__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__area__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cartesian__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__math__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__stream__ = __webpack_require__(88);






var lambda0, phi0, lambda1, phi1, // bounds
    lambda2, // previous lambda-coordinate
    lambda00, phi00, // first point
    p0, // previous 3D point
    deltaSum = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__adder__["a" /* default */])(),
    ranges,
    range;

var boundsStream = {
  point: boundsPoint,
  lineStart: boundsLineStart,
  lineEnd: boundsLineEnd,
  polygonStart: function() {
    boundsStream.point = boundsRingPoint;
    boundsStream.lineStart = boundsRingStart;
    boundsStream.lineEnd = boundsRingEnd;
    deltaSum.reset();
    __WEBPACK_IMPORTED_MODULE_1__area__["a" /* areaStream */].polygonStart();
  },
  polygonEnd: function() {
    __WEBPACK_IMPORTED_MODULE_1__area__["a" /* areaStream */].polygonEnd();
    boundsStream.point = boundsPoint;
    boundsStream.lineStart = boundsLineStart;
    boundsStream.lineEnd = boundsLineEnd;
    if (__WEBPACK_IMPORTED_MODULE_1__area__["b" /* areaRingSum */] < 0) lambda0 = -(lambda1 = 180), phi0 = -(phi1 = 90);
    else if (deltaSum > __WEBPACK_IMPORTED_MODULE_3__math__["p" /* epsilon */]) phi1 = 90;
    else if (deltaSum < -__WEBPACK_IMPORTED_MODULE_3__math__["p" /* epsilon */]) phi0 = -90;
    range[0] = lambda0, range[1] = lambda1;
  }
};

function boundsPoint(lambda, phi) {
  ranges.push(range = [lambda0 = lambda, lambda1 = lambda]);
  if (phi < phi0) phi0 = phi;
  if (phi > phi1) phi1 = phi;
}

function linePoint(lambda, phi) {
  var p = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cartesian__["a" /* cartesian */])([lambda * __WEBPACK_IMPORTED_MODULE_3__math__["g" /* radians */], phi * __WEBPACK_IMPORTED_MODULE_3__math__["g" /* radians */]]);
  if (p0) {
    var normal = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cartesian__["b" /* cartesianCross */])(p0, p),
        equatorial = [normal[1], -normal[0], 0],
        inflection = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cartesian__["b" /* cartesianCross */])(equatorial, normal);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cartesian__["g" /* cartesianNormalizeInPlace */])(inflection);
    inflection = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cartesian__["f" /* spherical */])(inflection);
    var delta = lambda - lambda2,
        sign = delta > 0 ? 1 : -1,
        lambdai = inflection[0] * __WEBPACK_IMPORTED_MODULE_3__math__["h" /* degrees */] * sign,
        phii,
        antimeridian = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__math__["o" /* abs */])(delta) > 180;
    if (antimeridian ^ (sign * lambda2 < lambdai && lambdai < sign * lambda)) {
      phii = inflection[1] * __WEBPACK_IMPORTED_MODULE_3__math__["h" /* degrees */];
      if (phii > phi1) phi1 = phii;
    } else if (lambdai = (lambdai + 360) % 360 - 180, antimeridian ^ (sign * lambda2 < lambdai && lambdai < sign * lambda)) {
      phii = -inflection[1] * __WEBPACK_IMPORTED_MODULE_3__math__["h" /* degrees */];
      if (phii < phi0) phi0 = phii;
    } else {
      if (phi < phi0) phi0 = phi;
      if (phi > phi1) phi1 = phi;
    }
    if (antimeridian) {
      if (lambda < lambda2) {
        if (angle(lambda0, lambda) > angle(lambda0, lambda1)) lambda1 = lambda;
      } else {
        if (angle(lambda, lambda1) > angle(lambda0, lambda1)) lambda0 = lambda;
      }
    } else {
      if (lambda1 >= lambda0) {
        if (lambda < lambda0) lambda0 = lambda;
        if (lambda > lambda1) lambda1 = lambda;
      } else {
        if (lambda > lambda2) {
          if (angle(lambda0, lambda) > angle(lambda0, lambda1)) lambda1 = lambda;
        } else {
          if (angle(lambda, lambda1) > angle(lambda0, lambda1)) lambda0 = lambda;
        }
      }
    }
  } else {
    ranges.push(range = [lambda0 = lambda, lambda1 = lambda]);
  }
  if (phi < phi0) phi0 = phi;
  if (phi > phi1) phi1 = phi;
  p0 = p, lambda2 = lambda;
}

function boundsLineStart() {
  boundsStream.point = linePoint;
}

function boundsLineEnd() {
  range[0] = lambda0, range[1] = lambda1;
  boundsStream.point = boundsPoint;
  p0 = null;
}

function boundsRingPoint(lambda, phi) {
  if (p0) {
    var delta = lambda - lambda2;
    deltaSum.add(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__math__["o" /* abs */])(delta) > 180 ? delta + (delta > 0 ? 360 : -360) : delta);
  } else {
    lambda00 = lambda, phi00 = phi;
  }
  __WEBPACK_IMPORTED_MODULE_1__area__["a" /* areaStream */].point(lambda, phi);
  linePoint(lambda, phi);
}

function boundsRingStart() {
  __WEBPACK_IMPORTED_MODULE_1__area__["a" /* areaStream */].lineStart();
}

function boundsRingEnd() {
  boundsRingPoint(lambda00, phi00);
  __WEBPACK_IMPORTED_MODULE_1__area__["a" /* areaStream */].lineEnd();
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__math__["o" /* abs */])(deltaSum) > __WEBPACK_IMPORTED_MODULE_3__math__["p" /* epsilon */]) lambda0 = -(lambda1 = 180);
  range[0] = lambda0, range[1] = lambda1;
  p0 = null;
}

// Finds the left-right distance between two longitudes.
// This is almost the same as (lambda1 - lambda0 + 360°) % 360°, except that we want
// the distance between ±180° to be 360°.
function angle(lambda0, lambda1) {
  return (lambda1 -= lambda0) < 0 ? lambda1 + 360 : lambda1;
}

function rangeCompare(a, b) {
  return a[0] - b[0];
}

function rangeContains(range, x) {
  return range[0] <= range[1] ? range[0] <= x && x <= range[1] : x < range[0] || range[1] < x;
}

/* unused harmony default export */ var _unused_webpack_default_export = (function(feature) {
  var i, n, a, b, merged, deltaMax, delta;

  phi1 = lambda1 = -(lambda0 = phi0 = Infinity);
  ranges = [];
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__stream__["a" /* default */])(feature, boundsStream);

  // First, sort ranges by their minimum longitudes.
  if (n = ranges.length) {
    ranges.sort(rangeCompare);

    // Then, merge any ranges that overlap.
    for (i = 1, a = ranges[0], merged = [a]; i < n; ++i) {
      b = ranges[i];
      if (rangeContains(a, b[0]) || rangeContains(a, b[1])) {
        if (angle(a[0], b[1]) > angle(a[0], a[1])) a[1] = b[1];
        if (angle(b[0], a[1]) > angle(a[0], a[1])) a[0] = b[0];
      } else {
        merged.push(a = b);
      }
    }

    // Finally, find the largest gap between the merged ranges.
    // The final bounding box will be the inverse of this gap.
    for (deltaMax = -Infinity, n = merged.length - 1, i = 0, a = merged[n]; i <= n; a = b, ++i) {
      b = merged[i];
      if ((delta = angle(a[1], b[0])) > deltaMax) deltaMax = delta, lambda0 = b[0], lambda1 = a[1];
    }
  }

  ranges = range = null;

  return lambda0 === Infinity || phi0 === Infinity
      ? [[NaN, NaN], [NaN, NaN]]
      : [[lambda0, phi0], [lambda1, phi1]];
});


/***/ }),
/* 873 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__noop__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stream__ = __webpack_require__(88);




var W0, W1,
    X0, Y0, Z0,
    X1, Y1, Z1,
    X2, Y2, Z2,
    lambda00, phi00, // first point
    x0, y0, z0; // previous point

var centroidStream = {
  sphere: __WEBPACK_IMPORTED_MODULE_1__noop__["a" /* default */],
  point: centroidPoint,
  lineStart: centroidLineStart,
  lineEnd: centroidLineEnd,
  polygonStart: function() {
    centroidStream.lineStart = centroidRingStart;
    centroidStream.lineEnd = centroidRingEnd;
  },
  polygonEnd: function() {
    centroidStream.lineStart = centroidLineStart;
    centroidStream.lineEnd = centroidLineEnd;
  }
};

// Arithmetic mean of Cartesian vectors.
function centroidPoint(lambda, phi) {
  lambda *= __WEBPACK_IMPORTED_MODULE_0__math__["g" /* radians */], phi *= __WEBPACK_IMPORTED_MODULE_0__math__["g" /* radians */];
  var cosPhi = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* cos */])(phi);
  centroidPointCartesian(cosPhi * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* cos */])(lambda), cosPhi * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* sin */])(lambda), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* sin */])(phi));
}

function centroidPointCartesian(x, y, z) {
  ++W0;
  X0 += (x - X0) / W0;
  Y0 += (y - Y0) / W0;
  Z0 += (z - Z0) / W0;
}

function centroidLineStart() {
  centroidStream.point = centroidLinePointFirst;
}

function centroidLinePointFirst(lambda, phi) {
  lambda *= __WEBPACK_IMPORTED_MODULE_0__math__["g" /* radians */], phi *= __WEBPACK_IMPORTED_MODULE_0__math__["g" /* radians */];
  var cosPhi = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* cos */])(phi);
  x0 = cosPhi * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* cos */])(lambda);
  y0 = cosPhi * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* sin */])(lambda);
  z0 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* sin */])(phi);
  centroidStream.point = centroidLinePoint;
  centroidPointCartesian(x0, y0, z0);
}

function centroidLinePoint(lambda, phi) {
  lambda *= __WEBPACK_IMPORTED_MODULE_0__math__["g" /* radians */], phi *= __WEBPACK_IMPORTED_MODULE_0__math__["g" /* radians */];
  var cosPhi = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* cos */])(phi),
      x = cosPhi * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* cos */])(lambda),
      y = cosPhi * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* sin */])(lambda),
      z = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* sin */])(phi),
      w = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["e" /* atan2 */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["n" /* sqrt */])((w = y0 * z - z0 * y) * w + (w = z0 * x - x0 * z) * w + (w = x0 * y - y0 * x) * w), x0 * x + y0 * y + z0 * z);
  W1 += w;
  X1 += w * (x0 + (x0 = x));
  Y1 += w * (y0 + (y0 = y));
  Z1 += w * (z0 + (z0 = z));
  centroidPointCartesian(x0, y0, z0);
}

function centroidLineEnd() {
  centroidStream.point = centroidPoint;
}

// See J. E. Brock, The Inertia Tensor for a Spherical Triangle,
// J. Applied Mechanics 42, 239 (1975).
function centroidRingStart() {
  centroidStream.point = centroidRingPointFirst;
}

function centroidRingEnd() {
  centroidRingPoint(lambda00, phi00);
  centroidStream.point = centroidPoint;
}

function centroidRingPointFirst(lambda, phi) {
  lambda00 = lambda, phi00 = phi;
  lambda *= __WEBPACK_IMPORTED_MODULE_0__math__["g" /* radians */], phi *= __WEBPACK_IMPORTED_MODULE_0__math__["g" /* radians */];
  centroidStream.point = centroidRingPoint;
  var cosPhi = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* cos */])(phi);
  x0 = cosPhi * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* cos */])(lambda);
  y0 = cosPhi * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* sin */])(lambda);
  z0 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* sin */])(phi);
  centroidPointCartesian(x0, y0, z0);
}

function centroidRingPoint(lambda, phi) {
  lambda *= __WEBPACK_IMPORTED_MODULE_0__math__["g" /* radians */], phi *= __WEBPACK_IMPORTED_MODULE_0__math__["g" /* radians */];
  var cosPhi = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* cos */])(phi),
      x = cosPhi * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* cos */])(lambda),
      y = cosPhi * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* sin */])(lambda),
      z = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* sin */])(phi),
      cx = y0 * z - z0 * y,
      cy = z0 * x - x0 * z,
      cz = x0 * y - y0 * x,
      m = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["n" /* sqrt */])(cx * cx + cy * cy + cz * cz),
      w = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["f" /* asin */])(m), // line weight = angle
      v = m && -w / m; // area weight multiplier
  X2 += v * cx;
  Y2 += v * cy;
  Z2 += v * cz;
  W1 += w;
  X1 += w * (x0 + (x0 = x));
  Y1 += w * (y0 + (y0 = y));
  Z1 += w * (z0 + (z0 = z));
  centroidPointCartesian(x0, y0, z0);
}

/* unused harmony default export */ var _unused_webpack_default_export = (function(object) {
  W0 = W1 =
  X0 = Y0 = Z0 =
  X1 = Y1 = Z1 =
  X2 = Y2 = Z2 = 0;
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__stream__["a" /* default */])(object, centroidStream);

  var x = X2,
      y = Y2,
      z = Z2,
      m = x * x + y * y + z * z;

  // If the area-weighted ccentroid is undefined, fall back to length-weighted ccentroid.
  if (m < __WEBPACK_IMPORTED_MODULE_0__math__["w" /* epsilon2 */]) {
    x = X1, y = Y1, z = Z1;
    // If the feature has zero length, fall back to arithmetic mean of point vectors.
    if (W1 < __WEBPACK_IMPORTED_MODULE_0__math__["p" /* epsilon */]) x = X0, y = Y0, z = Z0;
    m = x * x + y * y + z * z;
    // If the feature still has an undefined ccentroid, then return.
    if (m < __WEBPACK_IMPORTED_MODULE_0__math__["w" /* epsilon2 */]) return [NaN, NaN];
  }

  return [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["e" /* atan2 */])(y, x) * __WEBPACK_IMPORTED_MODULE_0__math__["h" /* degrees */], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["f" /* asin */])(z / __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["n" /* sqrt */])(m)) * __WEBPACK_IMPORTED_MODULE_0__math__["h" /* degrees */]];
});


/***/ }),
/* 874 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rectangle__ = __webpack_require__(150);


/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var x0 = 0,
      y0 = 0,
      x1 = 960,
      y1 = 500,
      cache,
      cacheStream,
      clip;

  return clip = {
    stream: function(stream) {
      return cache && cacheStream === stream ? cache : cache = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__rectangle__["a" /* default */])(x0, y0, x1, y1)(cacheStream = stream);
    },
    extent: function(_) {
      return arguments.length ? (x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1], cache = cacheStream = null, clip) : [[x0, y0], [x1, y1]];
    }
  };
});


/***/ }),
/* 875 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b, x0, y0, x1, y1) {
  var ax = a[0],
      ay = a[1],
      bx = b[0],
      by = b[1],
      t0 = 0,
      t1 = 1,
      dx = bx - ax,
      dy = by - ay,
      r;

  r = x0 - ax;
  if (!dx && r > 0) return;
  r /= dx;
  if (dx < 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  } else if (dx > 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  }

  r = x1 - ax;
  if (!dx && r < 0) return;
  r /= dx;
  if (dx < 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  } else if (dx > 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  }

  r = y0 - ay;
  if (!dy && r > 0) return;
  r /= dy;
  if (dy < 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  } else if (dy > 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  }

  r = y1 - ay;
  if (!dy && r < 0) return;
  r /= dy;
  if (dy < 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  } else if (dy > 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  }

  if (t0 > 0) a[0] = ax + t0 * dx, a[1] = ay + t0 * dy;
  if (t1 < 1) b[0] = ax + t1 * dx, b[1] = ay + t1 * dy;
  return true;
});


/***/ }),
/* 876 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 877 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__polygonContains__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__distance__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(5);




var containsObjectType = {
  Feature: function(object, point) {
    return containsGeometry(object.geometry, point);
  },
  FeatureCollection: function(object, point) {
    var features = object.features, i = -1, n = features.length;
    while (++i < n) if (containsGeometry(features[i].geometry, point)) return true;
    return false;
  }
};

var containsGeometryType = {
  Sphere: function() {
    return true;
  },
  Point: function(object, point) {
    return containsPoint(object.coordinates, point);
  },
  MultiPoint: function(object, point) {
    var coordinates = object.coordinates, i = -1, n = coordinates.length;
    while (++i < n) if (containsPoint(coordinates[i], point)) return true;
    return false;
  },
  LineString: function(object, point) {
    return containsLine(object.coordinates, point);
  },
  MultiLineString: function(object, point) {
    var coordinates = object.coordinates, i = -1, n = coordinates.length;
    while (++i < n) if (containsLine(coordinates[i], point)) return true;
    return false;
  },
  Polygon: function(object, point) {
    return containsPolygon(object.coordinates, point);
  },
  MultiPolygon: function(object, point) {
    var coordinates = object.coordinates, i = -1, n = coordinates.length;
    while (++i < n) if (containsPolygon(coordinates[i], point)) return true;
    return false;
  },
  GeometryCollection: function(object, point) {
    var geometries = object.geometries, i = -1, n = geometries.length;
    while (++i < n) if (containsGeometry(geometries[i], point)) return true;
    return false;
  }
};

function containsGeometry(geometry, point) {
  return geometry && containsGeometryType.hasOwnProperty(geometry.type)
      ? containsGeometryType[geometry.type](geometry, point)
      : false;
}

function containsPoint(coordinates, point) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__distance__["a" /* default */])(coordinates, point) === 0;
}

function containsLine(coordinates, point) {
  var ab = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__distance__["a" /* default */])(coordinates[0], coordinates[1]),
      ao = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__distance__["a" /* default */])(coordinates[0], point),
      ob = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__distance__["a" /* default */])(point, coordinates[1]);
  return ao + ob <= ab + __WEBPACK_IMPORTED_MODULE_2__math__["p" /* epsilon */];
}

function containsPolygon(coordinates, point) {
  return !!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__polygonContains__["a" /* default */])(coordinates.map(ringRadians), pointRadians(point));
}

function ringRadians(ring) {
  return ring = ring.map(pointRadians), ring.pop(), ring;
}

function pointRadians(point) {
  return [point[0] * __WEBPACK_IMPORTED_MODULE_2__math__["g" /* radians */], point[1] * __WEBPACK_IMPORTED_MODULE_2__math__["g" /* radians */]];
}

/* unused harmony default export */ var _unused_webpack_default_export = (function(object, point) {
  return (object && containsObjectType.hasOwnProperty(object.type)
      ? containsObjectType[object.type]
      : containsGeometry)(object, point);
});


/***/ }),
/* 878 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* unused harmony export graticule10 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(5);



function graticuleX(y0, y1, dy) {
  var y = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["h" /* range */])(y0, y1 - __WEBPACK_IMPORTED_MODULE_1__math__["p" /* epsilon */], dy).concat(y1);
  return function(x) { return y.map(function(y) { return [x, y]; }); };
}

function graticuleY(x0, x1, dx) {
  var x = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["h" /* range */])(x0, x1 - __WEBPACK_IMPORTED_MODULE_1__math__["p" /* epsilon */], dx).concat(x1);
  return function(y) { return x.map(function(x) { return [x, y]; }); };
}

function graticule() {
  var x1, x0, X1, X0,
      y1, y0, Y1, Y0,
      dx = 10, dy = dx, DX = 90, DY = 360,
      x, y, X, Y,
      precision = 2.5;

  function graticule() {
    return {type: "MultiLineString", coordinates: lines()};
  }

  function lines() {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["h" /* range */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["v" /* ceil */])(X0 / DX) * DX, X1, DX).map(X)
        .concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["h" /* range */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["v" /* ceil */])(Y0 / DY) * DY, Y1, DY).map(Y))
        .concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["h" /* range */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["v" /* ceil */])(x0 / dx) * dx, x1, dx).filter(function(x) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["o" /* abs */])(x % DX) > __WEBPACK_IMPORTED_MODULE_1__math__["p" /* epsilon */]; }).map(x))
        .concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["h" /* range */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["v" /* ceil */])(y0 / dy) * dy, y1, dy).filter(function(y) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["o" /* abs */])(y % DY) > __WEBPACK_IMPORTED_MODULE_1__math__["p" /* epsilon */]; }).map(y));
  }

  graticule.lines = function() {
    return lines().map(function(coordinates) { return {type: "LineString", coordinates: coordinates}; });
  };

  graticule.outline = function() {
    return {
      type: "Polygon",
      coordinates: [
        X(X0).concat(
        Y(Y1).slice(1),
        X(X1).reverse().slice(1),
        Y(Y0).reverse().slice(1))
      ]
    };
  };

  graticule.extent = function(_) {
    if (!arguments.length) return graticule.extentMinor();
    return graticule.extentMajor(_).extentMinor(_);
  };

  graticule.extentMajor = function(_) {
    if (!arguments.length) return [[X0, Y0], [X1, Y1]];
    X0 = +_[0][0], X1 = +_[1][0];
    Y0 = +_[0][1], Y1 = +_[1][1];
    if (X0 > X1) _ = X0, X0 = X1, X1 = _;
    if (Y0 > Y1) _ = Y0, Y0 = Y1, Y1 = _;
    return graticule.precision(precision);
  };

  graticule.extentMinor = function(_) {
    if (!arguments.length) return [[x0, y0], [x1, y1]];
    x0 = +_[0][0], x1 = +_[1][0];
    y0 = +_[0][1], y1 = +_[1][1];
    if (x0 > x1) _ = x0, x0 = x1, x1 = _;
    if (y0 > y1) _ = y0, y0 = y1, y1 = _;
    return graticule.precision(precision);
  };

  graticule.step = function(_) {
    if (!arguments.length) return graticule.stepMinor();
    return graticule.stepMajor(_).stepMinor(_);
  };

  graticule.stepMajor = function(_) {
    if (!arguments.length) return [DX, DY];
    DX = +_[0], DY = +_[1];
    return graticule;
  };

  graticule.stepMinor = function(_) {
    if (!arguments.length) return [dx, dy];
    dx = +_[0], dy = +_[1];
    return graticule;
  };

  graticule.precision = function(_) {
    if (!arguments.length) return precision;
    precision = +_;
    x = graticuleX(y0, y1, 90);
    y = graticuleY(x0, x1, precision);
    X = graticuleX(Y0, Y1, 90);
    Y = graticuleY(X0, X1, precision);
    return graticule;
  };

  return graticule
      .extentMajor([[-180, -90 + __WEBPACK_IMPORTED_MODULE_1__math__["p" /* epsilon */]], [180, 90 - __WEBPACK_IMPORTED_MODULE_1__math__["p" /* epsilon */]]])
      .extentMinor([[-180, -80 - __WEBPACK_IMPORTED_MODULE_1__math__["p" /* epsilon */]], [180, 80 + __WEBPACK_IMPORTED_MODULE_1__math__["p" /* epsilon */]]]);
}

function graticule10() {
  return graticule()();
}


/***/ }),
/* 879 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(5);


/* unused harmony default export */ var _unused_webpack_default_export = (function(a, b) {
  var x0 = a[0] * __WEBPACK_IMPORTED_MODULE_0__math__["g" /* radians */],
      y0 = a[1] * __WEBPACK_IMPORTED_MODULE_0__math__["g" /* radians */],
      x1 = b[0] * __WEBPACK_IMPORTED_MODULE_0__math__["g" /* radians */],
      y1 = b[1] * __WEBPACK_IMPORTED_MODULE_0__math__["g" /* radians */],
      cy0 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* cos */])(y0),
      sy0 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* sin */])(y0),
      cy1 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* cos */])(y1),
      sy1 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* sin */])(y1),
      kx0 = cy0 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* cos */])(x0),
      ky0 = cy0 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* sin */])(x0),
      kx1 = cy1 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* cos */])(x1),
      ky1 = cy1 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* sin */])(x1),
      d = 2 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["f" /* asin */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["n" /* sqrt */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["u" /* haversin */])(y1 - y0) + cy0 * cy1 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["u" /* haversin */])(x1 - x0))),
      k = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* sin */])(d);

  var interpolate = d ? function(t) {
    var B = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* sin */])(t *= d) / k,
        A = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* sin */])(d - t) / k,
        x = A * kx0 + B * kx1,
        y = A * ky0 + B * ky1,
        z = A * sy0 + B * sy1;
    return [
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["e" /* atan2 */])(y, x) * __WEBPACK_IMPORTED_MODULE_0__math__["h" /* degrees */],
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["e" /* atan2 */])(z, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["n" /* sqrt */])(x * x + y * y)) * __WEBPACK_IMPORTED_MODULE_0__math__["h" /* degrees */]
    ];
  } : function() {
    return [x0 * __WEBPACK_IMPORTED_MODULE_0__math__["h" /* degrees */], y0 * __WEBPACK_IMPORTED_MODULE_0__math__["h" /* degrees */]];
  };

  interpolate.distance = d;

  return interpolate;
});


/***/ }),
/* 880 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__adder__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__noop__ = __webpack_require__(73);




var areaSum = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__adder__["a" /* default */])(),
    areaRingSum = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__adder__["a" /* default */])(),
    x00,
    y00,
    x0,
    y0;

var areaStream = {
  point: __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */],
  lineStart: __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */],
  lineEnd: __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */],
  polygonStart: function() {
    areaStream.lineStart = areaRingStart;
    areaStream.lineEnd = areaRingEnd;
  },
  polygonEnd: function() {
    areaStream.lineStart = areaStream.lineEnd = areaStream.point = __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */];
    areaSum.add(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["o" /* abs */])(areaRingSum));
    areaRingSum.reset();
  },
  result: function() {
    var area = areaSum / 2;
    areaSum.reset();
    return area;
  }
};

function areaRingStart() {
  areaStream.point = areaPointFirst;
}

function areaPointFirst(x, y) {
  areaStream.point = areaPoint;
  x00 = x0 = x, y00 = y0 = y;
}

function areaPoint(x, y) {
  areaRingSum.add(y0 * x - x0 * y);
  x0 = x, y0 = y;
}

function areaRingEnd() {
  areaPoint(x00, y00);
}

/* harmony default export */ __webpack_exports__["a"] = (areaStream);


/***/ }),
/* 881 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(5);


// TODO Enforce positive area for exterior, negative area for interior?

var X0 = 0,
    Y0 = 0,
    Z0 = 0,
    X1 = 0,
    Y1 = 0,
    Z1 = 0,
    X2 = 0,
    Y2 = 0,
    Z2 = 0,
    x00,
    y00,
    x0,
    y0;

var centroidStream = {
  point: centroidPoint,
  lineStart: centroidLineStart,
  lineEnd: centroidLineEnd,
  polygonStart: function() {
    centroidStream.lineStart = centroidRingStart;
    centroidStream.lineEnd = centroidRingEnd;
  },
  polygonEnd: function() {
    centroidStream.point = centroidPoint;
    centroidStream.lineStart = centroidLineStart;
    centroidStream.lineEnd = centroidLineEnd;
  },
  result: function() {
    var centroid = Z2 ? [X2 / Z2, Y2 / Z2]
        : Z1 ? [X1 / Z1, Y1 / Z1]
        : Z0 ? [X0 / Z0, Y0 / Z0]
        : [NaN, NaN];
    X0 = Y0 = Z0 =
    X1 = Y1 = Z1 =
    X2 = Y2 = Z2 = 0;
    return centroid;
  }
};

function centroidPoint(x, y) {
  X0 += x;
  Y0 += y;
  ++Z0;
}

function centroidLineStart() {
  centroidStream.point = centroidPointFirstLine;
}

function centroidPointFirstLine(x, y) {
  centroidStream.point = centroidPointLine;
  centroidPoint(x0 = x, y0 = y);
}

function centroidPointLine(x, y) {
  var dx = x - x0, dy = y - y0, z = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["n" /* sqrt */])(dx * dx + dy * dy);
  X1 += z * (x0 + x) / 2;
  Y1 += z * (y0 + y) / 2;
  Z1 += z;
  centroidPoint(x0 = x, y0 = y);
}

function centroidLineEnd() {
  centroidStream.point = centroidPoint;
}

function centroidRingStart() {
  centroidStream.point = centroidPointFirstRing;
}

function centroidRingEnd() {
  centroidPointRing(x00, y00);
}

function centroidPointFirstRing(x, y) {
  centroidStream.point = centroidPointRing;
  centroidPoint(x00 = x0 = x, y00 = y0 = y);
}

function centroidPointRing(x, y) {
  var dx = x - x0,
      dy = y - y0,
      z = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["n" /* sqrt */])(dx * dx + dy * dy);

  X1 += z * (x0 + x) / 2;
  Y1 += z * (y0 + y) / 2;
  Z1 += z;

  z = y0 * x - x0 * y;
  X2 += z * (x0 + x);
  Y2 += z * (y0 + y);
  Z2 += z * 3;
  centroidPoint(x0 = x, y0 = y);
}

/* harmony default export */ __webpack_exports__["a"] = (centroidStream);


/***/ }),
/* 882 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = PathContext;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__noop__ = __webpack_require__(73);



function PathContext(context) {
  this._context = context;
}

PathContext.prototype = {
  _radius: 4.5,
  pointRadius: function(_) {
    return this._radius = _, this;
  },
  polygonStart: function() {
    this._line = 0;
  },
  polygonEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line === 0) this._context.closePath();
    this._point = NaN;
  },
  point: function(x, y) {
    switch (this._point) {
      case 0: {
        this._context.moveTo(x, y);
        this._point = 1;
        break;
      }
      case 1: {
        this._context.lineTo(x, y);
        break;
      }
      default: {
        this._context.moveTo(x + this._radius, y);
        this._context.arc(x, y, this._radius, 0, __WEBPACK_IMPORTED_MODULE_0__math__["b" /* tau */]);
        break;
      }
    }
  },
  result: __WEBPACK_IMPORTED_MODULE_1__noop__["a" /* default */]
};


/***/ }),
/* 883 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__identity__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stream__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__area__ = __webpack_require__(880);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bounds__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__centroid__ = __webpack_require__(881);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__context__ = __webpack_require__(882);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__measure__ = __webpack_require__(884);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__string__ = __webpack_require__(885);









/* unused harmony default export */ var _unused_webpack_default_export = (function(projection, context) {
  var pointRadius = 4.5,
      projectionStream,
      contextStream;

  function path(object) {
    if (object) {
      if (typeof pointRadius === "function") contextStream.pointRadius(+pointRadius.apply(this, arguments));
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__stream__["a" /* default */])(object, projectionStream(contextStream));
    }
    return contextStream.result();
  }

  path.area = function(object) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__stream__["a" /* default */])(object, projectionStream(__WEBPACK_IMPORTED_MODULE_2__area__["a" /* default */]));
    return __WEBPACK_IMPORTED_MODULE_2__area__["a" /* default */].result();
  };

  path.measure = function(object) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__stream__["a" /* default */])(object, projectionStream(__WEBPACK_IMPORTED_MODULE_6__measure__["a" /* default */]));
    return __WEBPACK_IMPORTED_MODULE_6__measure__["a" /* default */].result();
  };

  path.bounds = function(object) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__stream__["a" /* default */])(object, projectionStream(__WEBPACK_IMPORTED_MODULE_3__bounds__["a" /* default */]));
    return __WEBPACK_IMPORTED_MODULE_3__bounds__["a" /* default */].result();
  };

  path.centroid = function(object) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__stream__["a" /* default */])(object, projectionStream(__WEBPACK_IMPORTED_MODULE_4__centroid__["a" /* default */]));
    return __WEBPACK_IMPORTED_MODULE_4__centroid__["a" /* default */].result();
  };

  path.projection = function(_) {
    return arguments.length ? (projectionStream = _ == null ? (projection = null, __WEBPACK_IMPORTED_MODULE_0__identity__["a" /* default */]) : (projection = _).stream, path) : projection;
  };

  path.context = function(_) {
    if (!arguments.length) return context;
    contextStream = _ == null ? (context = null, new __WEBPACK_IMPORTED_MODULE_7__string__["a" /* default */]) : new __WEBPACK_IMPORTED_MODULE_5__context__["a" /* default */](context = _);
    if (typeof pointRadius !== "function") contextStream.pointRadius(pointRadius);
    return path;
  };

  path.pointRadius = function(_) {
    if (!arguments.length) return pointRadius;
    pointRadius = typeof _ === "function" ? _ : (contextStream.pointRadius(+_), +_);
    return path;
  };

  return path.projection(projection).context(context);
});


/***/ }),
/* 884 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__adder__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__noop__ = __webpack_require__(73);




var lengthSum = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__adder__["a" /* default */])(),
    lengthRing,
    x00,
    y00,
    x0,
    y0;

var lengthStream = {
  point: __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */],
  lineStart: function() {
    lengthStream.point = lengthPointFirst;
  },
  lineEnd: function() {
    if (lengthRing) lengthPoint(x00, y00);
    lengthStream.point = __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */];
  },
  polygonStart: function() {
    lengthRing = true;
  },
  polygonEnd: function() {
    lengthRing = null;
  },
  result: function() {
    var length = +lengthSum;
    lengthSum.reset();
    return length;
  }
};

function lengthPointFirst(x, y) {
  lengthStream.point = lengthPoint;
  x00 = x0 = x, y00 = y0 = y;
}

function lengthPoint(x, y) {
  x0 -= x, y0 -= y;
  lengthSum.add(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["n" /* sqrt */])(x0 * x0 + y0 * y0));
  x0 = x, y0 = y;
}

/* harmony default export */ __webpack_exports__["a"] = (lengthStream);


/***/ }),
/* 885 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = PathString;
function PathString() {
  this._string = [];
}

PathString.prototype = {
  _radius: 4.5,
  _circle: circle(4.5),
  pointRadius: function(_) {
    if ((_ = +_) !== this._radius) this._radius = _, this._circle = null;
    return this;
  },
  polygonStart: function() {
    this._line = 0;
  },
  polygonEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line === 0) this._string.push("Z");
    this._point = NaN;
  },
  point: function(x, y) {
    switch (this._point) {
      case 0: {
        this._string.push("M", x, ",", y);
        this._point = 1;
        break;
      }
      case 1: {
        this._string.push("L", x, ",", y);
        break;
      }
      default: {
        if (this._circle == null) this._circle = circle(this._radius);
        this._string.push("M", x, ",", y, this._circle);
        break;
      }
    }
  },
  result: function() {
    if (this._string.length) {
      var result = this._string.join("");
      this._string = [];
      return result;
    } else {
      return null;
    }
  }
};

function circle(radius) {
  return "m0," + radius
      + "a" + radius + "," + radius + " 0 1,1 0," + -2 * radius
      + "a" + radius + "," + radius + " 0 1,1 0," + 2 * radius
      + "z";
}


/***/ }),
/* 886 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__albers__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__conicEqualArea__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fit__ = __webpack_require__(242);





// The projections must have mutually exclusive clip regions on the sphere,
// as this will avoid emitting interleaving lines and polygons.
function multiplex(streams) {
  var n = streams.length;
  return {
    point: function(x, y) { var i = -1; while (++i < n) streams[i].point(x, y); },
    sphere: function() { var i = -1; while (++i < n) streams[i].sphere(); },
    lineStart: function() { var i = -1; while (++i < n) streams[i].lineStart(); },
    lineEnd: function() { var i = -1; while (++i < n) streams[i].lineEnd(); },
    polygonStart: function() { var i = -1; while (++i < n) streams[i].polygonStart(); },
    polygonEnd: function() { var i = -1; while (++i < n) streams[i].polygonEnd(); }
  };
}

// A composite projection for the United States, configured by default for
// 960×500. The projection also works quite well at 960×600 if you change the
// scale to 1285 and adjust the translate accordingly. The set of standard
// parallels for each region comes from USGS, which is published here:
// http://egsc.usgs.gov/isb/pubs/MapProjections/projections.html#albers
/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var cache,
      cacheStream,
      lower48 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__albers__["a" /* default */])(), lower48Point,
      alaska = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__conicEqualArea__["a" /* default */])().rotate([154, 0]).center([-2, 58.5]).parallels([55, 65]), alaskaPoint, // EPSG:3338
      hawaii = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__conicEqualArea__["a" /* default */])().rotate([157, 0]).center([-3, 19.9]).parallels([8, 18]), hawaiiPoint, // ESRI:102007
      point, pointStream = {point: function(x, y) { point = [x, y]; }};

  function albersUsa(coordinates) {
    var x = coordinates[0], y = coordinates[1];
    return point = null,
        (lower48Point.point(x, y), point)
        || (alaskaPoint.point(x, y), point)
        || (hawaiiPoint.point(x, y), point);
  }

  albersUsa.invert = function(coordinates) {
    var k = lower48.scale(),
        t = lower48.translate(),
        x = (coordinates[0] - t[0]) / k,
        y = (coordinates[1] - t[1]) / k;
    return (y >= 0.120 && y < 0.234 && x >= -0.425 && x < -0.214 ? alaska
        : y >= 0.166 && y < 0.234 && x >= -0.214 && x < -0.115 ? hawaii
        : lower48).invert(coordinates);
  };

  albersUsa.stream = function(stream) {
    return cache && cacheStream === stream ? cache : cache = multiplex([lower48.stream(cacheStream = stream), alaska.stream(stream), hawaii.stream(stream)]);
  };

  albersUsa.precision = function(_) {
    if (!arguments.length) return lower48.precision();
    lower48.precision(_), alaska.precision(_), hawaii.precision(_);
    return reset();
  };

  albersUsa.scale = function(_) {
    if (!arguments.length) return lower48.scale();
    lower48.scale(_), alaska.scale(_ * 0.35), hawaii.scale(_);
    return albersUsa.translate(lower48.translate());
  };

  albersUsa.translate = function(_) {
    if (!arguments.length) return lower48.translate();
    var k = lower48.scale(), x = +_[0], y = +_[1];

    lower48Point = lower48
        .translate(_)
        .clipExtent([[x - 0.455 * k, y - 0.238 * k], [x + 0.455 * k, y + 0.238 * k]])
        .stream(pointStream);

    alaskaPoint = alaska
        .translate([x - 0.307 * k, y + 0.201 * k])
        .clipExtent([[x - 0.425 * k + __WEBPACK_IMPORTED_MODULE_0__math__["p" /* epsilon */], y + 0.120 * k + __WEBPACK_IMPORTED_MODULE_0__math__["p" /* epsilon */]], [x - 0.214 * k - __WEBPACK_IMPORTED_MODULE_0__math__["p" /* epsilon */], y + 0.234 * k - __WEBPACK_IMPORTED_MODULE_0__math__["p" /* epsilon */]]])
        .stream(pointStream);

    hawaiiPoint = hawaii
        .translate([x - 0.205 * k, y + 0.212 * k])
        .clipExtent([[x - 0.214 * k + __WEBPACK_IMPORTED_MODULE_0__math__["p" /* epsilon */], y + 0.166 * k + __WEBPACK_IMPORTED_MODULE_0__math__["p" /* epsilon */]], [x - 0.115 * k - __WEBPACK_IMPORTED_MODULE_0__math__["p" /* epsilon */], y + 0.234 * k - __WEBPACK_IMPORTED_MODULE_0__math__["p" /* epsilon */]]])
        .stream(pointStream);

    return reset();
  };

  albersUsa.fitExtent = function(extent, object) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__fit__["a" /* fitExtent */])(albersUsa, extent, object);
  };

  albersUsa.fitSize = function(size, object) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__fit__["b" /* fitSize */])(albersUsa, size, object);
  };

  albersUsa.fitWidth = function(width, object) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__fit__["c" /* fitWidth */])(albersUsa, width, object);
  };

  albersUsa.fitHeight = function(height, object) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__fit__["d" /* fitHeight */])(albersUsa, height, object);
  };

  function reset() {
    cache = cacheStream = null;
    return albersUsa;
  }

  return albersUsa.scale(1070);
});


/***/ }),
/* 887 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export azimuthalEqualAreaRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__azimuthal__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index__ = __webpack_require__(51);




var azimuthalEqualAreaRaw = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__azimuthal__["b" /* azimuthalRaw */])(function(cxcy) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["n" /* sqrt */])(2 / (1 + cxcy));
});

azimuthalEqualAreaRaw.invert = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__azimuthal__["a" /* azimuthalInvert */])(function(z) {
  return 2 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["f" /* asin */])(z / 2);
});

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__index__["a" /* default */])(azimuthalEqualAreaRaw)
      .scale(124.75)
      .clipAngle(180 - 1e-3);
});


/***/ }),
/* 888 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export azimuthalEquidistantRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__azimuthal__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index__ = __webpack_require__(51);




var azimuthalEquidistantRaw = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__azimuthal__["b" /* azimuthalRaw */])(function(c) {
  return (c = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["r" /* acos */])(c)) && c / __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* sin */])(c);
});

azimuthalEquidistantRaw.invert = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__azimuthal__["a" /* azimuthalInvert */])(function(z) {
  return z;
});

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__index__["a" /* default */])(azimuthalEquidistantRaw)
      .scale(79.4188)
      .clipAngle(180 - 1e-3);
});


/***/ }),
/* 889 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export conicConformalRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__conic__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mercator__ = __webpack_require__(243);




function tany(y) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["j" /* tan */])((__WEBPACK_IMPORTED_MODULE_0__math__["k" /* halfPi */] + y) / 2);
}

function conicConformalRaw(y0, y1) {
  var cy0 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* cos */])(y0),
      n = y0 === y1 ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* sin */])(y0) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["i" /* log */])(cy0 / __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* cos */])(y1)) / __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["i" /* log */])(tany(y1) / tany(y0)),
      f = cy0 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* pow */])(tany(y0), n) / n;

  if (!n) return __WEBPACK_IMPORTED_MODULE_2__mercator__["b" /* mercatorRaw */];

  function project(x, y) {
    if (f > 0) { if (y < -__WEBPACK_IMPORTED_MODULE_0__math__["k" /* halfPi */] + __WEBPACK_IMPORTED_MODULE_0__math__["p" /* epsilon */]) y = -__WEBPACK_IMPORTED_MODULE_0__math__["k" /* halfPi */] + __WEBPACK_IMPORTED_MODULE_0__math__["p" /* epsilon */]; }
    else { if (y > __WEBPACK_IMPORTED_MODULE_0__math__["k" /* halfPi */] - __WEBPACK_IMPORTED_MODULE_0__math__["p" /* epsilon */]) y = __WEBPACK_IMPORTED_MODULE_0__math__["k" /* halfPi */] - __WEBPACK_IMPORTED_MODULE_0__math__["p" /* epsilon */]; }
    var r = f / __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* pow */])(tany(y), n);
    return [r * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* sin */])(n * x), f - r * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* cos */])(n * x)];
  }

  project.invert = function(x, y) {
    var fy = f - y, r = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["s" /* sign */])(n) * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["n" /* sqrt */])(x * x + fy * fy);
    return [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["e" /* atan2 */])(x, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["o" /* abs */])(fy)) / n * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["s" /* sign */])(fy), 2 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["l" /* atan */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* pow */])(f / r, 1 / n)) - __WEBPACK_IMPORTED_MODULE_0__math__["k" /* halfPi */]];
  };

  return project;
}

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__conic__["a" /* conicProjection */])(conicConformalRaw)
      .scale(109.5)
      .parallels([30, 30]);
});


/***/ }),
/* 890 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export conicEquidistantRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__conic__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__equirectangular__ = __webpack_require__(412);




function conicEquidistantRaw(y0, y1) {
  var cy0 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* cos */])(y0),
      n = y0 === y1 ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* sin */])(y0) : (cy0 - __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* cos */])(y1)) / (y1 - y0),
      g = cy0 / n + y0;

  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["o" /* abs */])(n) < __WEBPACK_IMPORTED_MODULE_0__math__["p" /* epsilon */]) return __WEBPACK_IMPORTED_MODULE_2__equirectangular__["a" /* equirectangularRaw */];

  function project(x, y) {
    var gy = g - y, nx = n * x;
    return [gy * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* sin */])(nx), g - gy * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* cos */])(nx)];
  }

  project.invert = function(x, y) {
    var gy = g - y;
    return [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["e" /* atan2 */])(x, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["o" /* abs */])(gy)) / n * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["s" /* sign */])(gy), g - __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["s" /* sign */])(n) * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["n" /* sqrt */])(x * x + gy * gy)];
  };

  return project;
}

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__conic__["a" /* conicProjection */])(conicEquidistantRaw)
      .scale(131.154)
      .center([0, 13.9389]);
});


/***/ }),
/* 891 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = cylindricalEqualAreaRaw;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(5);


function cylindricalEqualAreaRaw(phi0) {
  var cosPhi0 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* cos */])(phi0);

  function forward(lambda, phi) {
    return [lambda * cosPhi0, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* sin */])(phi) / cosPhi0];
  }

  forward.invert = function(x, y) {
    return [x / cosPhi0, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["f" /* asin */])(y * cosPhi0)];
  };

  return forward;
}


/***/ }),
/* 892 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export gnomonicRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__azimuthal__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index__ = __webpack_require__(51);




function gnomonicRaw(x, y) {
  var cy = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* cos */])(y), k = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* cos */])(x) * cy;
  return [cy * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* sin */])(x) / k, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* sin */])(y) / k];
}

gnomonicRaw.invert = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__azimuthal__["a" /* azimuthalInvert */])(__WEBPACK_IMPORTED_MODULE_0__math__["l" /* atan */]);

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__index__["a" /* default */])(gnomonicRaw)
      .scale(144.049)
      .clipAngle(60);
});


/***/ }),
/* 893 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__clip_rectangle__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__identity__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__transform__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fit__ = __webpack_require__(242);





function scaleTranslate(kx, ky, tx, ty) {
  return kx === 1 && ky === 1 && tx === 0 && ty === 0 ? __WEBPACK_IMPORTED_MODULE_1__identity__["a" /* default */] : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__transform__["a" /* transformer */])({
    point: function(x, y) {
      this.stream.point(x * kx + tx, y * ky + ty);
    }
  });
}

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var k = 1, tx = 0, ty = 0, sx = 1, sy = 1, transform = __WEBPACK_IMPORTED_MODULE_1__identity__["a" /* default */], // scale, translate and reflect
      x0 = null, y0, x1, y1, // clip extent
      postclip = __WEBPACK_IMPORTED_MODULE_1__identity__["a" /* default */],
      cache,
      cacheStream,
      projection;

  function reset() {
    cache = cacheStream = null;
    return projection;
  }

  return projection = {
    stream: function(stream) {
      return cache && cacheStream === stream ? cache : cache = transform(postclip(cacheStream = stream));
    },
    postclip: function(_) {
      return arguments.length ? (postclip = _, x0 = y0 = x1 = y1 = null, reset()) : postclip;
    },
    clipExtent: function(_) {
      return arguments.length ? (postclip = _ == null ? (x0 = y0 = x1 = y1 = null, __WEBPACK_IMPORTED_MODULE_1__identity__["a" /* default */]) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__clip_rectangle__["a" /* default */])(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reset()) : x0 == null ? null : [[x0, y0], [x1, y1]];
    },
    scale: function(_) {
      return arguments.length ? (transform = scaleTranslate((k = +_) * sx, k * sy, tx, ty), reset()) : k;
    },
    translate: function(_) {
      return arguments.length ? (transform = scaleTranslate(k * sx, k * sy, tx = +_[0], ty = +_[1]), reset()) : [tx, ty];
    },
    reflectX: function(_) {
      return arguments.length ? (transform = scaleTranslate(k * (sx = _ ? -1 : 1), k * sy, tx, ty), reset()) : sx < 0;
    },
    reflectY: function(_) {
      return arguments.length ? (transform = scaleTranslate(k * sx, k * (sy = _ ? -1 : 1), tx, ty), reset()) : sy < 0;
    },
    fitExtent: function(extent, object) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__fit__["a" /* fitExtent */])(projection, extent, object);
    },
    fitSize: function(size, object) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__fit__["b" /* fitSize */])(projection, size, object);
    },
    fitWidth: function(width, object) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__fit__["c" /* fitWidth */])(projection, width, object);
    },
    fitHeight: function(height, object) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__fit__["d" /* fitHeight */])(projection, height, object);
    }
  };
});


/***/ }),
/* 894 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export naturalEarth1Raw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(5);



function naturalEarth1Raw(lambda, phi) {
  var phi2 = phi * phi, phi4 = phi2 * phi2;
  return [
    lambda * (0.8707 - 0.131979 * phi2 + phi4 * (-0.013791 + phi4 * (0.003971 * phi2 - 0.001529 * phi4))),
    phi * (1.007226 + phi2 * (0.015085 + phi4 * (-0.044475 + 0.028874 * phi2 - 0.005916 * phi4)))
  ];
}

naturalEarth1Raw.invert = function(x, y) {
  var phi = y, i = 25, delta;
  do {
    var phi2 = phi * phi, phi4 = phi2 * phi2;
    phi -= delta = (phi * (1.007226 + phi2 * (0.015085 + phi4 * (-0.044475 + 0.028874 * phi2 - 0.005916 * phi4))) - y) /
        (1.007226 + phi2 * (0.015085 * 3 + phi4 * (-0.044475 * 7 + 0.028874 * 9 * phi2 - 0.005916 * 11 * phi4)));
  } while (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["o" /* abs */])(delta) > __WEBPACK_IMPORTED_MODULE_1__math__["p" /* epsilon */] && --i > 0);
  return [
    x / (0.8707 + (phi2 = phi * phi) * (-0.131979 + phi2 * (-0.013791 + phi2 * phi2 * phi2 * (0.003971 - 0.001529 * phi2)))),
    phi
  ];
};

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__index__["a" /* default */])(naturalEarth1Raw)
      .scale(175.295);
});


/***/ }),
/* 895 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export orthographicRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__azimuthal__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index__ = __webpack_require__(51);




function orthographicRaw(x, y) {
  return [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* cos */])(y) * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* sin */])(x), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* sin */])(y)];
}

orthographicRaw.invert = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__azimuthal__["a" /* azimuthalInvert */])(__WEBPACK_IMPORTED_MODULE_0__math__["f" /* asin */]);

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__index__["a" /* default */])(orthographicRaw)
      .scale(249.5)
      .clipAngle(90 + __WEBPACK_IMPORTED_MODULE_0__math__["p" /* epsilon */]);
});


/***/ }),
/* 896 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cartesian__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__transform__ = __webpack_require__(152);




var maxDepth = 16, // maximum depth of subdivision
    cosMinDistance = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["c" /* cos */])(30 * __WEBPACK_IMPORTED_MODULE_1__math__["g" /* radians */]); // cos(minimum angular distance)

/* harmony default export */ __webpack_exports__["a"] = (function(project, delta2) {
  return +delta2 ? resample(project, delta2) : resampleNone(project);
});

function resampleNone(project) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__transform__["a" /* transformer */])({
    point: function(x, y) {
      x = project(x, y);
      this.stream.point(x[0], x[1]);
    }
  });
}

function resample(project, delta2) {

  function resampleLineTo(x0, y0, lambda0, a0, b0, c0, x1, y1, lambda1, a1, b1, c1, depth, stream) {
    var dx = x1 - x0,
        dy = y1 - y0,
        d2 = dx * dx + dy * dy;
    if (d2 > 4 * delta2 && depth--) {
      var a = a0 + a1,
          b = b0 + b1,
          c = c0 + c1,
          m = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["n" /* sqrt */])(a * a + b * b + c * c),
          phi2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["f" /* asin */])(c /= m),
          lambda2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["o" /* abs */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["o" /* abs */])(c) - 1) < __WEBPACK_IMPORTED_MODULE_1__math__["p" /* epsilon */] || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["o" /* abs */])(lambda0 - lambda1) < __WEBPACK_IMPORTED_MODULE_1__math__["p" /* epsilon */] ? (lambda0 + lambda1) / 2 : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["e" /* atan2 */])(b, a),
          p = project(lambda2, phi2),
          x2 = p[0],
          y2 = p[1],
          dx2 = x2 - x0,
          dy2 = y2 - y0,
          dz = dy * dx2 - dx * dy2;
      if (dz * dz / d2 > delta2 // perpendicular projected distance
          || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["o" /* abs */])((dx * dx2 + dy * dy2) / d2 - 0.5) > 0.3 // midpoint close to an end
          || a0 * a1 + b0 * b1 + c0 * c1 < cosMinDistance) { // angular distance
        resampleLineTo(x0, y0, lambda0, a0, b0, c0, x2, y2, lambda2, a /= m, b /= m, c, depth, stream);
        stream.point(x2, y2);
        resampleLineTo(x2, y2, lambda2, a, b, c, x1, y1, lambda1, a1, b1, c1, depth, stream);
      }
    }
  }
  return function(stream) {
    var lambda00, x00, y00, a00, b00, c00, // first point
        lambda0, x0, y0, a0, b0, c0; // previous point

    var resampleStream = {
      point: point,
      lineStart: lineStart,
      lineEnd: lineEnd,
      polygonStart: function() { stream.polygonStart(); resampleStream.lineStart = ringStart; },
      polygonEnd: function() { stream.polygonEnd(); resampleStream.lineStart = lineStart; }
    };

    function point(x, y) {
      x = project(x, y);
      stream.point(x[0], x[1]);
    }

    function lineStart() {
      x0 = NaN;
      resampleStream.point = linePoint;
      stream.lineStart();
    }

    function linePoint(lambda, phi) {
      var c = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cartesian__["a" /* cartesian */])([lambda, phi]), p = project(lambda, phi);
      resampleLineTo(x0, y0, lambda0, a0, b0, c0, x0 = p[0], y0 = p[1], lambda0 = lambda, a0 = c[0], b0 = c[1], c0 = c[2], maxDepth, stream);
      stream.point(x0, y0);
    }

    function lineEnd() {
      resampleStream.point = point;
      stream.lineEnd();
    }

    function ringStart() {
      lineStart();
      resampleStream.point = ringPoint;
      resampleStream.lineEnd = ringEnd;
    }

    function ringPoint(lambda, phi) {
      linePoint(lambda00 = lambda, phi), x00 = x0, y00 = y0, a00 = a0, b00 = b0, c00 = c0;
      resampleStream.point = linePoint;
    }

    function ringEnd() {
      resampleLineTo(x0, y0, lambda0, a0, b0, c0, x00, y00, lambda00, a00, b00, c00, maxDepth, stream);
      resampleStream.lineEnd = lineEnd;
      lineEnd();
    }

    return resampleStream;
  };
}


/***/ }),
/* 897 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export stereographicRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__azimuthal__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index__ = __webpack_require__(51);




function stereographicRaw(x, y) {
  var cy = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* cos */])(y), k = 1 + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* cos */])(x) * cy;
  return [cy * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* sin */])(x) / k, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* sin */])(y) / k];
}

stereographicRaw.invert = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__azimuthal__["a" /* azimuthalInvert */])(function(z) {
  return 2 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["l" /* atan */])(z);
});

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__index__["a" /* default */])(stereographicRaw)
      .scale(250)
      .clipAngle(142);
});


/***/ }),
/* 898 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export transverseMercatorRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mercator__ = __webpack_require__(243);



function transverseMercatorRaw(lambda, phi) {
  return [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["i" /* log */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["j" /* tan */])((__WEBPACK_IMPORTED_MODULE_0__math__["k" /* halfPi */] + phi) / 2)), -lambda];
}

transverseMercatorRaw.invert = function(x, y) {
  return [-y, 2 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["l" /* atan */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["m" /* exp */])(x)) - __WEBPACK_IMPORTED_MODULE_0__math__["k" /* halfPi */]];
};

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var m = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__mercator__["a" /* mercatorProjection */])(transverseMercatorRaw),
      center = m.center,
      rotate = m.rotate;

  m.center = function(_) {
    return arguments.length ? center([-_[1], _[0]]) : (_ = center(), [_[1], -_[0]]);
  };

  m.rotate = function(_) {
    return arguments.length ? rotate([_[0], _[1], _.length > 2 ? _[2] + 90 : 90]) : (_ = rotate(), [_[0], _[1], _[2] - 90]);
  };

  return rotate([0, 0, 90])
      .scale(159.155);
});


/***/ }),
/* 899 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_cluster__ = __webpack_require__(901);
/* unused harmony reexport cluster */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_hierarchy_index__ = __webpack_require__(245);
/* unused harmony reexport hierarchy */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_pack_index__ = __webpack_require__(913);
/* unused harmony reexport pack */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_pack_siblings__ = __webpack_require__(415);
/* unused harmony reexport packSiblings */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_pack_enclose__ = __webpack_require__(414);
/* unused harmony reexport packEnclose */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_partition__ = __webpack_require__(914);
/* unused harmony reexport partition */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_stratify__ = __webpack_require__(915);
/* unused harmony reexport stratify */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_tree__ = __webpack_require__(916);
/* unused harmony reexport tree */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_treemap_index__ = __webpack_require__(918);
/* unused harmony reexport treemap */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_treemap_binary__ = __webpack_require__(917);
/* unused harmony reexport treemapBinary */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_treemap_dice__ = __webpack_require__(117);
/* unused harmony reexport treemapDice */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_treemap_slice__ = __webpack_require__(153);
/* unused harmony reexport treemapSlice */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_treemap_sliceDice__ = __webpack_require__(920);
/* unused harmony reexport treemapSliceDice */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_treemap_squarify__ = __webpack_require__(246);
/* unused harmony reexport treemapSquarify */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_treemap_resquarify__ = __webpack_require__(919);
/* unused harmony reexport treemapResquarify */

















/***/ }),
/* 900 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return slice; });
/* harmony export (immutable) */ __webpack_exports__["a"] = shuffle;
var slice = Array.prototype.slice;

function shuffle(array) {
  var m = array.length,
      t,
      i;

  while (m) {
    i = Math.random() * m-- | 0;
    t = array[m];
    array[m] = array[i];
    array[i] = t;
  }

  return array;
}


/***/ }),
/* 901 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function defaultSeparation(a, b) {
  return a.parent === b.parent ? 1 : 2;
}

function meanX(children) {
  return children.reduce(meanXReduce, 0) / children.length;
}

function meanXReduce(x, c) {
  return x + c.x;
}

function maxY(children) {
  return 1 + children.reduce(maxYReduce, 0);
}

function maxYReduce(y, c) {
  return Math.max(y, c.y);
}

function leafLeft(node) {
  var children;
  while (children = node.children) node = children[0];
  return node;
}

function leafRight(node) {
  var children;
  while (children = node.children) node = children[children.length - 1];
  return node;
}

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var separation = defaultSeparation,
      dx = 1,
      dy = 1,
      nodeSize = false;

  function cluster(root) {
    var previousNode,
        x = 0;

    // First walk, computing the initial x & y values.
    root.eachAfter(function(node) {
      var children = node.children;
      if (children) {
        node.x = meanX(children);
        node.y = maxY(children);
      } else {
        node.x = previousNode ? x += separation(node, previousNode) : 0;
        node.y = 0;
        previousNode = node;
      }
    });

    var left = leafLeft(root),
        right = leafRight(root),
        x0 = left.x - separation(left, right) / 2,
        x1 = right.x + separation(right, left) / 2;

    // Second walk, normalizing x & y to the desired size.
    return root.eachAfter(nodeSize ? function(node) {
      node.x = (node.x - root.x) * dx;
      node.y = (root.y - node.y) * dy;
    } : function(node) {
      node.x = (node.x - x0) / (x1 - x0) * dx;
      node.y = (1 - (root.y ? node.y / root.y : 1)) * dy;
    });
  }

  cluster.separation = function(x) {
    return arguments.length ? (separation = x, cluster) : separation;
  };

  cluster.size = function(x) {
    return arguments.length ? (nodeSize = false, dx = +x[0], dy = +x[1], cluster) : (nodeSize ? null : [dx, dy]);
  };

  cluster.nodeSize = function(x) {
    return arguments.length ? (nodeSize = true, dx = +x[0], dy = +x[1], cluster) : (nodeSize ? [dx, dy] : null);
  };

  return cluster;
});


/***/ }),
/* 902 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  var node = this, nodes = [node];
  while (node = node.parent) {
    nodes.push(node);
  }
  return nodes;
});


/***/ }),
/* 903 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function count(node) {
  var sum = 0,
      children = node.children,
      i = children && children.length;
  if (!i) sum = 1;
  else while (--i >= 0) sum += children[i].value;
  node.value = sum;
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return this.eachAfter(count);
});


/***/ }),
/* 904 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  var nodes = [];
  this.each(function(node) {
    nodes.push(node);
  });
  return nodes;
});


/***/ }),
/* 905 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(callback) {
  var node = this, current, next = [node], children, i, n;
  do {
    current = next.reverse(), next = [];
    while (node = current.pop()) {
      callback(node), children = node.children;
      if (children) for (i = 0, n = children.length; i < n; ++i) {
        next.push(children[i]);
      }
    }
  } while (next.length);
  return this;
});


/***/ }),
/* 906 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(callback) {
  var node = this, nodes = [node], next = [], children, i, n;
  while (node = nodes.pop()) {
    next.push(node), children = node.children;
    if (children) for (i = 0, n = children.length; i < n; ++i) {
      nodes.push(children[i]);
    }
  }
  while (node = next.pop()) {
    callback(node);
  }
  return this;
});


/***/ }),
/* 907 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(callback) {
  var node = this, nodes = [node], children, i;
  while (node = nodes.pop()) {
    callback(node), children = node.children;
    if (children) for (i = children.length - 1; i >= 0; --i) {
      nodes.push(children[i]);
    }
  }
  return this;
});


/***/ }),
/* 908 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  var leaves = [];
  this.eachBefore(function(node) {
    if (!node.children) {
      leaves.push(node);
    }
  });
  return leaves;
});


/***/ }),
/* 909 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  var root = this, links = [];
  root.each(function(node) {
    if (node !== root) { // Don’t include the root’s parent, if any.
      links.push({source: node.parent, target: node});
    }
  });
  return links;
});


/***/ }),
/* 910 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(end) {
  var start = this,
      ancestor = leastCommonAncestor(start, end),
      nodes = [start];
  while (start !== ancestor) {
    start = start.parent;
    nodes.push(start);
  }
  var k = nodes.length;
  while (end !== ancestor) {
    nodes.splice(k, 0, end);
    end = end.parent;
  }
  return nodes;
});

function leastCommonAncestor(a, b) {
  if (a === b) return a;
  var aNodes = a.ancestors(),
      bNodes = b.ancestors(),
      c = null;
  a = aNodes.pop();
  b = bNodes.pop();
  while (a === b) {
    c = a;
    a = aNodes.pop();
    b = bNodes.pop();
  }
  return c;
}


/***/ }),
/* 911 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(compare) {
  return this.eachBefore(function(node) {
    if (node.children) {
      node.children.sort(compare);
    }
  });
});


/***/ }),
/* 912 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(value) {
  return this.eachAfter(function(node) {
    var sum = +value(node.data) || 0,
        children = node.children,
        i = children && children.length;
    while (--i >= 0) sum += children[i].value;
    node.value = sum;
  });
});


/***/ }),
/* 913 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__siblings__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__accessors__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constant__ = __webpack_require__(413);




function defaultRadius(d) {
  return Math.sqrt(d.value);
}

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var radius = null,
      dx = 1,
      dy = 1,
      padding = __WEBPACK_IMPORTED_MODULE_2__constant__["a" /* constantZero */];

  function pack(root) {
    root.x = dx / 2, root.y = dy / 2;
    if (radius) {
      root.eachBefore(radiusLeaf(radius))
          .eachAfter(packChildren(padding, 0.5))
          .eachBefore(translateChild(1));
    } else {
      root.eachBefore(radiusLeaf(defaultRadius))
          .eachAfter(packChildren(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* constantZero */], 1))
          .eachAfter(packChildren(padding, root.r / Math.min(dx, dy)))
          .eachBefore(translateChild(Math.min(dx, dy) / (2 * root.r)));
    }
    return root;
  }

  pack.radius = function(x) {
    return arguments.length ? (radius = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__accessors__["b" /* optional */])(x), pack) : radius;
  };

  pack.size = function(x) {
    return arguments.length ? (dx = +x[0], dy = +x[1], pack) : [dx, dy];
  };

  pack.padding = function(x) {
    return arguments.length ? (padding = typeof x === "function" ? x : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__constant__["b" /* default */])(+x), pack) : padding;
  };

  return pack;
});

function radiusLeaf(radius) {
  return function(node) {
    if (!node.children) {
      node.r = Math.max(0, +radius(node) || 0);
    }
  };
}

function packChildren(padding, k) {
  return function(node) {
    if (children = node.children) {
      var children,
          i,
          n = children.length,
          r = padding(node) * k || 0,
          e;

      if (r) for (i = 0; i < n; ++i) children[i].r += r;
      e = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__siblings__["a" /* packEnclose */])(children);
      if (r) for (i = 0; i < n; ++i) children[i].r -= r;
      node.r = e + r;
    }
  };
}

function translateChild(k) {
  return function(node) {
    var parent = node.parent;
    node.r *= k;
    if (parent) {
      node.x = parent.x + k * node.x;
      node.y = parent.y + k * node.y;
    }
  };
}


/***/ }),
/* 914 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__treemap_round__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__treemap_dice__ = __webpack_require__(117);



/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var dx = 1,
      dy = 1,
      padding = 0,
      round = false;

  function partition(root) {
    var n = root.height + 1;
    root.x0 =
    root.y0 = padding;
    root.x1 = dx;
    root.y1 = dy / n;
    root.eachBefore(positionNode(dy, n));
    if (round) root.eachBefore(__WEBPACK_IMPORTED_MODULE_0__treemap_round__["a" /* default */]);
    return root;
  }

  function positionNode(dy, n) {
    return function(node) {
      if (node.children) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__treemap_dice__["a" /* default */])(node, node.x0, dy * (node.depth + 1) / n, node.x1, dy * (node.depth + 2) / n);
      }
      var x0 = node.x0,
          y0 = node.y0,
          x1 = node.x1 - padding,
          y1 = node.y1 - padding;
      if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
      if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
      node.x0 = x0;
      node.y0 = y0;
      node.x1 = x1;
      node.y1 = y1;
    };
  }

  partition.round = function(x) {
    return arguments.length ? (round = !!x, partition) : round;
  };

  partition.size = function(x) {
    return arguments.length ? (dx = +x[0], dy = +x[1], partition) : [dx, dy];
  };

  partition.padding = function(x) {
    return arguments.length ? (padding = +x, partition) : padding;
  };

  return partition;
});


/***/ }),
/* 915 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__accessors__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hierarchy_index__ = __webpack_require__(245);



var keyPrefix = "$", // Protect against keys like “__proto__”.
    preroot = {depth: -1},
    ambiguous = {};

function defaultId(d) {
  return d.id;
}

function defaultParentId(d) {
  return d.parentId;
}

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var id = defaultId,
      parentId = defaultParentId;

  function stratify(data) {
    var d,
        i,
        n = data.length,
        root,
        parent,
        node,
        nodes = new Array(n),
        nodeId,
        nodeKey,
        nodeByKey = {};

    for (i = 0; i < n; ++i) {
      d = data[i], node = nodes[i] = new __WEBPACK_IMPORTED_MODULE_1__hierarchy_index__["a" /* Node */](d);
      if ((nodeId = id(d, i, data)) != null && (nodeId += "")) {
        nodeKey = keyPrefix + (node.id = nodeId);
        nodeByKey[nodeKey] = nodeKey in nodeByKey ? ambiguous : node;
      }
    }

    for (i = 0; i < n; ++i) {
      node = nodes[i], nodeId = parentId(data[i], i, data);
      if (nodeId == null || !(nodeId += "")) {
        if (root) throw new Error("multiple roots");
        root = node;
      } else {
        parent = nodeByKey[keyPrefix + nodeId];
        if (!parent) throw new Error("missing: " + nodeId);
        if (parent === ambiguous) throw new Error("ambiguous: " + nodeId);
        if (parent.children) parent.children.push(node);
        else parent.children = [node];
        node.parent = parent;
      }
    }

    if (!root) throw new Error("no root");
    root.parent = preroot;
    root.eachBefore(function(node) { node.depth = node.parent.depth + 1; --n; }).eachBefore(__WEBPACK_IMPORTED_MODULE_1__hierarchy_index__["b" /* computeHeight */]);
    root.parent = null;
    if (n > 0) throw new Error("cycle");

    return root;
  }

  stratify.id = function(x) {
    return arguments.length ? (id = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__accessors__["a" /* required */])(x), stratify) : id;
  };

  stratify.parentId = function(x) {
    return arguments.length ? (parentId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__accessors__["a" /* required */])(x), stratify) : parentId;
  };

  return stratify;
});


/***/ }),
/* 916 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__hierarchy_index__ = __webpack_require__(245);


function defaultSeparation(a, b) {
  return a.parent === b.parent ? 1 : 2;
}

// function radialSeparation(a, b) {
//   return (a.parent === b.parent ? 1 : 2) / a.depth;
// }

// This function is used to traverse the left contour of a subtree (or
// subforest). It returns the successor of v on this contour. This successor is
// either given by the leftmost child of v or by the thread of v. The function
// returns null if and only if v is on the highest level of its subtree.
function nextLeft(v) {
  var children = v.children;
  return children ? children[0] : v.t;
}

// This function works analogously to nextLeft.
function nextRight(v) {
  var children = v.children;
  return children ? children[children.length - 1] : v.t;
}

// Shifts the current subtree rooted at w+. This is done by increasing
// prelim(w+) and mod(w+) by shift.
function moveSubtree(wm, wp, shift) {
  var change = shift / (wp.i - wm.i);
  wp.c -= change;
  wp.s += shift;
  wm.c += change;
  wp.z += shift;
  wp.m += shift;
}

// All other shifts, applied to the smaller subtrees between w- and w+, are
// performed by this function. To prepare the shifts, we have to adjust
// change(w+), shift(w+), and change(w-).
function executeShifts(v) {
  var shift = 0,
      change = 0,
      children = v.children,
      i = children.length,
      w;
  while (--i >= 0) {
    w = children[i];
    w.z += shift;
    w.m += shift;
    shift += w.s + (change += w.c);
  }
}

// If vi-’s ancestor is a sibling of v, returns vi-’s ancestor. Otherwise,
// returns the specified (default) ancestor.
function nextAncestor(vim, v, ancestor) {
  return vim.a.parent === v.parent ? vim.a : ancestor;
}

function TreeNode(node, i) {
  this._ = node;
  this.parent = null;
  this.children = null;
  this.A = null; // default ancestor
  this.a = this; // ancestor
  this.z = 0; // prelim
  this.m = 0; // mod
  this.c = 0; // change
  this.s = 0; // shift
  this.t = null; // thread
  this.i = i; // number
}

TreeNode.prototype = Object.create(__WEBPACK_IMPORTED_MODULE_0__hierarchy_index__["a" /* Node */].prototype);

function treeRoot(root) {
  var tree = new TreeNode(root, 0),
      node,
      nodes = [tree],
      child,
      children,
      i,
      n;

  while (node = nodes.pop()) {
    if (children = node._.children) {
      node.children = new Array(n = children.length);
      for (i = n - 1; i >= 0; --i) {
        nodes.push(child = node.children[i] = new TreeNode(children[i], i));
        child.parent = node;
      }
    }
  }

  (tree.parent = new TreeNode(null, 0)).children = [tree];
  return tree;
}

// Node-link tree diagram using the Reingold-Tilford "tidy" algorithm
/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var separation = defaultSeparation,
      dx = 1,
      dy = 1,
      nodeSize = null;

  function tree(root) {
    var t = treeRoot(root);

    // Compute the layout using Buchheim et al.’s algorithm.
    t.eachAfter(firstWalk), t.parent.m = -t.z;
    t.eachBefore(secondWalk);

    // If a fixed node size is specified, scale x and y.
    if (nodeSize) root.eachBefore(sizeNode);

    // If a fixed tree size is specified, scale x and y based on the extent.
    // Compute the left-most, right-most, and depth-most nodes for extents.
    else {
      var left = root,
          right = root,
          bottom = root;
      root.eachBefore(function(node) {
        if (node.x < left.x) left = node;
        if (node.x > right.x) right = node;
        if (node.depth > bottom.depth) bottom = node;
      });
      var s = left === right ? 1 : separation(left, right) / 2,
          tx = s - left.x,
          kx = dx / (right.x + s + tx),
          ky = dy / (bottom.depth || 1);
      root.eachBefore(function(node) {
        node.x = (node.x + tx) * kx;
        node.y = node.depth * ky;
      });
    }

    return root;
  }

  // Computes a preliminary x-coordinate for v. Before that, FIRST WALK is
  // applied recursively to the children of v, as well as the function
  // APPORTION. After spacing out the children by calling EXECUTE SHIFTS, the
  // node v is placed to the midpoint of its outermost children.
  function firstWalk(v) {
    var children = v.children,
        siblings = v.parent.children,
        w = v.i ? siblings[v.i - 1] : null;
    if (children) {
      executeShifts(v);
      var midpoint = (children[0].z + children[children.length - 1].z) / 2;
      if (w) {
        v.z = w.z + separation(v._, w._);
        v.m = v.z - midpoint;
      } else {
        v.z = midpoint;
      }
    } else if (w) {
      v.z = w.z + separation(v._, w._);
    }
    v.parent.A = apportion(v, w, v.parent.A || siblings[0]);
  }

  // Computes all real x-coordinates by summing up the modifiers recursively.
  function secondWalk(v) {
    v._.x = v.z + v.parent.m;
    v.m += v.parent.m;
  }

  // The core of the algorithm. Here, a new subtree is combined with the
  // previous subtrees. Threads are used to traverse the inside and outside
  // contours of the left and right subtree up to the highest common level. The
  // vertices used for the traversals are vi+, vi-, vo-, and vo+, where the
  // superscript o means outside and i means inside, the subscript - means left
  // subtree and + means right subtree. For summing up the modifiers along the
  // contour, we use respective variables si+, si-, so-, and so+. Whenever two
  // nodes of the inside contours conflict, we compute the left one of the
  // greatest uncommon ancestors using the function ANCESTOR and call MOVE
  // SUBTREE to shift the subtree and prepare the shifts of smaller subtrees.
  // Finally, we add a new thread (if necessary).
  function apportion(v, w, ancestor) {
    if (w) {
      var vip = v,
          vop = v,
          vim = w,
          vom = vip.parent.children[0],
          sip = vip.m,
          sop = vop.m,
          sim = vim.m,
          som = vom.m,
          shift;
      while (vim = nextRight(vim), vip = nextLeft(vip), vim && vip) {
        vom = nextLeft(vom);
        vop = nextRight(vop);
        vop.a = v;
        shift = vim.z + sim - vip.z - sip + separation(vim._, vip._);
        if (shift > 0) {
          moveSubtree(nextAncestor(vim, v, ancestor), v, shift);
          sip += shift;
          sop += shift;
        }
        sim += vim.m;
        sip += vip.m;
        som += vom.m;
        sop += vop.m;
      }
      if (vim && !nextRight(vop)) {
        vop.t = vim;
        vop.m += sim - sop;
      }
      if (vip && !nextLeft(vom)) {
        vom.t = vip;
        vom.m += sip - som;
        ancestor = v;
      }
    }
    return ancestor;
  }

  function sizeNode(node) {
    node.x *= dx;
    node.y = node.depth * dy;
  }

  tree.separation = function(x) {
    return arguments.length ? (separation = x, tree) : separation;
  };

  tree.size = function(x) {
    return arguments.length ? (nodeSize = false, dx = +x[0], dy = +x[1], tree) : (nodeSize ? null : [dx, dy]);
  };

  tree.nodeSize = function(x) {
    return arguments.length ? (nodeSize = true, dx = +x[0], dy = +x[1], tree) : (nodeSize ? [dx, dy] : null);
  };

  return tree;
});


/***/ }),
/* 917 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(parent, x0, y0, x1, y1) {
  var nodes = parent.children,
      i, n = nodes.length,
      sum, sums = new Array(n + 1);

  for (sums[0] = sum = i = 0; i < n; ++i) {
    sums[i + 1] = sum += nodes[i].value;
  }

  partition(0, n, parent.value, x0, y0, x1, y1);

  function partition(i, j, value, x0, y0, x1, y1) {
    if (i >= j - 1) {
      var node = nodes[i];
      node.x0 = x0, node.y0 = y0;
      node.x1 = x1, node.y1 = y1;
      return;
    }

    var valueOffset = sums[i],
        valueTarget = (value / 2) + valueOffset,
        k = i + 1,
        hi = j - 1;

    while (k < hi) {
      var mid = k + hi >>> 1;
      if (sums[mid] < valueTarget) k = mid + 1;
      else hi = mid;
    }

    if ((valueTarget - sums[k - 1]) < (sums[k] - valueTarget) && i + 1 < k) --k;

    var valueLeft = sums[k] - valueOffset,
        valueRight = value - valueLeft;

    if ((x1 - x0) > (y1 - y0)) {
      var xk = (x0 * valueRight + x1 * valueLeft) / value;
      partition(i, k, valueLeft, x0, y0, xk, y1);
      partition(k, j, valueRight, xk, y0, x1, y1);
    } else {
      var yk = (y0 * valueRight + y1 * valueLeft) / value;
      partition(i, k, valueLeft, x0, y0, x1, yk);
      partition(k, j, valueRight, x0, yk, x1, y1);
    }
  }
});


/***/ }),
/* 918 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__round__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__squarify__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__accessors__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constant__ = __webpack_require__(413);





/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var tile = __WEBPACK_IMPORTED_MODULE_1__squarify__["c" /* default */],
      round = false,
      dx = 1,
      dy = 1,
      paddingStack = [0],
      paddingInner = __WEBPACK_IMPORTED_MODULE_3__constant__["a" /* constantZero */],
      paddingTop = __WEBPACK_IMPORTED_MODULE_3__constant__["a" /* constantZero */],
      paddingRight = __WEBPACK_IMPORTED_MODULE_3__constant__["a" /* constantZero */],
      paddingBottom = __WEBPACK_IMPORTED_MODULE_3__constant__["a" /* constantZero */],
      paddingLeft = __WEBPACK_IMPORTED_MODULE_3__constant__["a" /* constantZero */];

  function treemap(root) {
    root.x0 =
    root.y0 = 0;
    root.x1 = dx;
    root.y1 = dy;
    root.eachBefore(positionNode);
    paddingStack = [0];
    if (round) root.eachBefore(__WEBPACK_IMPORTED_MODULE_0__round__["a" /* default */]);
    return root;
  }

  function positionNode(node) {
    var p = paddingStack[node.depth],
        x0 = node.x0 + p,
        y0 = node.y0 + p,
        x1 = node.x1 - p,
        y1 = node.y1 - p;
    if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
    if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
    node.x0 = x0;
    node.y0 = y0;
    node.x1 = x1;
    node.y1 = y1;
    if (node.children) {
      p = paddingStack[node.depth + 1] = paddingInner(node) / 2;
      x0 += paddingLeft(node) - p;
      y0 += paddingTop(node) - p;
      x1 -= paddingRight(node) - p;
      y1 -= paddingBottom(node) - p;
      if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
      if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
      tile(node, x0, y0, x1, y1);
    }
  }

  treemap.round = function(x) {
    return arguments.length ? (round = !!x, treemap) : round;
  };

  treemap.size = function(x) {
    return arguments.length ? (dx = +x[0], dy = +x[1], treemap) : [dx, dy];
  };

  treemap.tile = function(x) {
    return arguments.length ? (tile = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__accessors__["a" /* required */])(x), treemap) : tile;
  };

  treemap.padding = function(x) {
    return arguments.length ? treemap.paddingInner(x).paddingOuter(x) : treemap.paddingInner();
  };

  treemap.paddingInner = function(x) {
    return arguments.length ? (paddingInner = typeof x === "function" ? x : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__constant__["b" /* default */])(+x), treemap) : paddingInner;
  };

  treemap.paddingOuter = function(x) {
    return arguments.length ? treemap.paddingTop(x).paddingRight(x).paddingBottom(x).paddingLeft(x) : treemap.paddingTop();
  };

  treemap.paddingTop = function(x) {
    return arguments.length ? (paddingTop = typeof x === "function" ? x : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__constant__["b" /* default */])(+x), treemap) : paddingTop;
  };

  treemap.paddingRight = function(x) {
    return arguments.length ? (paddingRight = typeof x === "function" ? x : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__constant__["b" /* default */])(+x), treemap) : paddingRight;
  };

  treemap.paddingBottom = function(x) {
    return arguments.length ? (paddingBottom = typeof x === "function" ? x : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__constant__["b" /* default */])(+x), treemap) : paddingBottom;
  };

  treemap.paddingLeft = function(x) {
    return arguments.length ? (paddingLeft = typeof x === "function" ? x : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__constant__["b" /* default */])(+x), treemap) : paddingLeft;
  };

  return treemap;
});


/***/ }),
/* 919 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dice__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__slice__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__squarify__ = __webpack_require__(246);




/* unused harmony default export */ var _unused_webpack_default_export = ((function custom(ratio) {

  function resquarify(parent, x0, y0, x1, y1) {
    if ((rows = parent._squarify) && (rows.ratio === ratio)) {
      var rows,
          row,
          nodes,
          i,
          j = -1,
          n,
          m = rows.length,
          value = parent.value;

      while (++j < m) {
        row = rows[j], nodes = row.children;
        for (i = row.value = 0, n = nodes.length; i < n; ++i) row.value += nodes[i].value;
        if (row.dice) __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__dice__["a" /* default */])(row, x0, y0, x1, y0 += (y1 - y0) * row.value / value);
        else __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__slice__["a" /* default */])(row, x0, y0, x0 += (x1 - x0) * row.value / value, y1);
        value -= row.value;
      }
    } else {
      parent._squarify = rows = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__squarify__["a" /* squarifyRatio */])(ratio, parent, x0, y0, x1, y1);
      rows.ratio = ratio;
    }
  }

  resquarify.ratio = function(x) {
    return custom((x = +x) > 1 ? x : 1);
  };

  return resquarify;
})(__WEBPACK_IMPORTED_MODULE_2__squarify__["b" /* phi */]));


/***/ }),
/* 920 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dice__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__slice__ = __webpack_require__(153);



/* unused harmony default export */ var _unused_webpack_default_export = (function(parent, x0, y0, x1, y1) {
  (parent.depth & 1 ? __WEBPACK_IMPORTED_MODULE_1__slice__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_0__dice__["a" /* default */])(parent, x0, y0, x1, y1);
});


/***/ }),
/* 921 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return cubehelixLong; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(118);



function cubehelix(hue) {
  return (function cubehelixGamma(y) {
    y = +y;

    function cubehelix(start, end) {
      var h = hue((start = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["b" /* cubehelix */])(start)).h, (end = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["b" /* cubehelix */])(end)).h),
          s = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.s, end.s),
          l = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.l, end.l),
          opacity = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.opacity, end.opacity);
      return function(t) {
        start.h = h(t);
        start.s = s(t);
        start.l = l(Math.pow(t, y));
        start.opacity = opacity(t);
        return start + "";
      };
    }

    cubehelix.gamma = cubehelixGamma;

    return cubehelix;
  })(1);
}

/* unused harmony default export */ var _unused_webpack_default_export = (cubehelix(__WEBPACK_IMPORTED_MODULE_1__color__["b" /* hue */]));
var cubehelixLong = cubehelix(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */]);


/***/ }),
/* 922 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export hclLong */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(118);



function hcl(hue) {
  return function(start, end) {
    var h = hue((start = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["c" /* hcl */])(start)).h, (end = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["c" /* hcl */])(end)).h),
        c = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.c, end.c),
        l = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.l, end.l),
        opacity = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.opacity, end.opacity);
    return function(t) {
      start.h = h(t);
      start.c = c(t);
      start.l = l(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }
}

/* unused harmony default export */ var _unused_webpack_default_export = (hcl(__WEBPACK_IMPORTED_MODULE_1__color__["b" /* hue */]));
var hclLong = hcl(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */]);


/***/ }),
/* 923 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export hslLong */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(118);



function hsl(hue) {
  return function(start, end) {
    var h = hue((start = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["e" /* hsl */])(start)).h, (end = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["e" /* hsl */])(end)).h),
        s = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.s, end.s),
        l = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.l, end.l),
        opacity = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.opacity, end.opacity);
    return function(t) {
      start.h = h(t);
      start.s = s(t);
      start.l = l(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }
}

/* unused harmony default export */ var _unused_webpack_default_export = (hsl(__WEBPACK_IMPORTED_MODULE_1__color__["b" /* hue */]));
var hslLong = hsl(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */]);


/***/ }),
/* 924 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(118);



function lab(start, end) {
  var l = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])((start = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["d" /* lab */])(start)).l, (end = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["d" /* lab */])(end)).l),
      a = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.a, end.a),
      b = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.b, end.b),
      opacity = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.opacity, end.opacity);
  return function(t) {
    start.l = l(t);
    start.a = a(t);
    start.b = b(t);
    start.opacity = opacity(t);
    return start + "";
  };
}


/***/ }),
/* 925 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(interpolator, n) {
  var samples = new Array(n);
  for (var i = 0; i < n; ++i) samples[i] = interpolator(i / (n - 1));
  return samples;
});


/***/ }),
/* 926 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  return a = +a, b -= a, function(t) {
    return Math.round(a + b * t);
  };
});


/***/ }),
/* 927 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return identity; });
var degrees = 180 / Math.PI;

var identity = {
  translateX: 0,
  translateY: 0,
  rotate: 0,
  skewX: 0,
  scaleX: 1,
  scaleY: 1
};

/* harmony default export */ __webpack_exports__["b"] = (function(a, b, c, d, e, f) {
  var scaleX, scaleY, skewX;
  if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
  if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
  if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
  if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
  return {
    translateX: e,
    translateY: f,
    rotate: Math.atan2(b, a) * degrees,
    skewX: Math.atan(skewX) * degrees,
    scaleX: scaleX,
    scaleY: scaleY
  };
});


/***/ }),
/* 928 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return interpolateTransformCss; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return interpolateTransformSvg; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__parse__ = __webpack_require__(929);



function interpolateTransform(parse, pxComma, pxParen, degParen) {

  function pop(s) {
    return s.length ? s.pop() + " " : "";
  }

  function translate(xa, ya, xb, yb, s, q) {
    if (xa !== xb || ya !== yb) {
      var i = s.push("translate(", null, pxComma, null, pxParen);
      q.push({i: i - 4, x: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(xa, xb)}, {i: i - 2, x: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(ya, yb)});
    } else if (xb || yb) {
      s.push("translate(" + xb + pxComma + yb + pxParen);
    }
  }

  function rotate(a, b, s, q) {
    if (a !== b) {
      if (a - b > 180) b += 360; else if (b - a > 180) a += 360; // shortest path
      q.push({i: s.push(pop(s) + "rotate(", null, degParen) - 2, x: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(a, b)});
    } else if (b) {
      s.push(pop(s) + "rotate(" + b + degParen);
    }
  }

  function skewX(a, b, s, q) {
    if (a !== b) {
      q.push({i: s.push(pop(s) + "skewX(", null, degParen) - 2, x: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(a, b)});
    } else if (b) {
      s.push(pop(s) + "skewX(" + b + degParen);
    }
  }

  function scale(xa, ya, xb, yb, s, q) {
    if (xa !== xb || ya !== yb) {
      var i = s.push(pop(s) + "scale(", null, ",", null, ")");
      q.push({i: i - 4, x: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(xa, xb)}, {i: i - 2, x: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(ya, yb)});
    } else if (xb !== 1 || yb !== 1) {
      s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
  }

  return function(a, b) {
    var s = [], // string constants and placeholders
        q = []; // number interpolators
    a = parse(a), b = parse(b);
    translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
    rotate(a.rotate, b.rotate, s, q);
    skewX(a.skewX, b.skewX, s, q);
    scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
    a = b = null; // gc
    return function(t) {
      var i = -1, n = q.length, o;
      while (++i < n) s[(o = q[i]).i] = o.x(t);
      return s.join("");
    };
  };
}

var interpolateTransformCss = interpolateTransform(__WEBPACK_IMPORTED_MODULE_1__parse__["a" /* parseCss */], "px, ", "px)", "deg)");
var interpolateTransformSvg = interpolateTransform(__WEBPACK_IMPORTED_MODULE_1__parse__["b" /* parseSvg */], ", ", ")", ")");


/***/ }),
/* 929 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = parseCss;
/* harmony export (immutable) */ __webpack_exports__["b"] = parseSvg;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__decompose__ = __webpack_require__(927);


var cssNode,
    cssRoot,
    cssView,
    svgNode;

function parseCss(value) {
  if (value === "none") return __WEBPACK_IMPORTED_MODULE_0__decompose__["a" /* identity */];
  if (!cssNode) cssNode = document.createElement("DIV"), cssRoot = document.documentElement, cssView = document.defaultView;
  cssNode.style.transform = value;
  value = cssView.getComputedStyle(cssRoot.appendChild(cssNode), null).getPropertyValue("transform");
  cssRoot.removeChild(cssNode);
  value = value.slice(7, -1).split(",");
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__decompose__["b" /* default */])(+value[0], +value[1], +value[2], +value[3], +value[4], +value[5]);
}

function parseSvg(value) {
  if (value == null) return __WEBPACK_IMPORTED_MODULE_0__decompose__["a" /* identity */];
  if (!svgNode) svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
  svgNode.setAttribute("transform", value);
  if (!(value = svgNode.transform.baseVal.consolidate())) return __WEBPACK_IMPORTED_MODULE_0__decompose__["a" /* identity */];
  value = value.matrix;
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__decompose__["b" /* default */])(value.a, value.b, value.c, value.d, value.e, value.f);
}


/***/ }),
/* 930 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var rho = Math.SQRT2,
    rho2 = 2,
    rho4 = 4,
    epsilon2 = 1e-12;

function cosh(x) {
  return ((x = Math.exp(x)) + 1 / x) / 2;
}

function sinh(x) {
  return ((x = Math.exp(x)) - 1 / x) / 2;
}

function tanh(x) {
  return ((x = Math.exp(2 * x)) - 1) / (x + 1);
}

// p0 = [ux0, uy0, w0]
// p1 = [ux1, uy1, w1]
/* harmony default export */ __webpack_exports__["a"] = (function(p0, p1) {
  var ux0 = p0[0], uy0 = p0[1], w0 = p0[2],
      ux1 = p1[0], uy1 = p1[1], w1 = p1[2],
      dx = ux1 - ux0,
      dy = uy1 - uy0,
      d2 = dx * dx + dy * dy,
      i,
      S;

  // Special case for u0 ≅ u1.
  if (d2 < epsilon2) {
    S = Math.log(w1 / w0) / rho;
    i = function(t) {
      return [
        ux0 + t * dx,
        uy0 + t * dy,
        w0 * Math.exp(rho * t * S)
      ];
    }
  }

  // General case.
  else {
    var d1 = Math.sqrt(d2),
        b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1),
        b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1),
        r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0),
        r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
    S = (r1 - r0) / rho;
    i = function(t) {
      var s = t * S,
          coshr0 = cosh(r0),
          u = w0 / (rho2 * d1) * (coshr0 * tanh(rho * s + r0) - sinh(r0));
      return [
        ux0 + u * dx,
        uy0 + u * dy,
        w0 * coshr0 / cosh(rho * s + r0)
      ];
    }
  }

  i.duration = S * 1000;

  return i;
});


/***/ }),
/* 931 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var pi = Math.PI,
    tau = 2 * pi,
    epsilon = 1e-6,
    tauEpsilon = tau - epsilon;

function Path() {
  this._x0 = this._y0 = // start of current subpath
  this._x1 = this._y1 = null; // end of current subpath
  this._ = "";
}

function path() {
  return new Path;
}

Path.prototype = path.prototype = {
  constructor: Path,
  moveTo: function(x, y) {
    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
  },
  closePath: function() {
    if (this._x1 !== null) {
      this._x1 = this._x0, this._y1 = this._y0;
      this._ += "Z";
    }
  },
  lineTo: function(x, y) {
    this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
  },
  quadraticCurveTo: function(x1, y1, x, y) {
    this._ += "Q" + (+x1) + "," + (+y1) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
  },
  bezierCurveTo: function(x1, y1, x2, y2, x, y) {
    this._ += "C" + (+x1) + "," + (+y1) + "," + (+x2) + "," + (+y2) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
  },
  arcTo: function(x1, y1, x2, y2, r) {
    x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
    var x0 = this._x1,
        y0 = this._y1,
        x21 = x2 - x1,
        y21 = y2 - y1,
        x01 = x0 - x1,
        y01 = y0 - y1,
        l01_2 = x01 * x01 + y01 * y01;

    // Is the radius negative? Error.
    if (r < 0) throw new Error("negative radius: " + r);

    // Is this path empty? Move to (x1,y1).
    if (this._x1 === null) {
      this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
    }

    // Or, is (x1,y1) coincident with (x0,y0)? Do nothing.
    else if (!(l01_2 > epsilon)) {}

    // Or, are (x0,y0), (x1,y1) and (x2,y2) collinear?
    // Equivalently, is (x1,y1) coincident with (x2,y2)?
    // Or, is the radius zero? Line to (x1,y1).
    else if (!(Math.abs(y01 * x21 - y21 * x01) > epsilon) || !r) {
      this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
    }

    // Otherwise, draw an arc!
    else {
      var x20 = x2 - x0,
          y20 = y2 - y0,
          l21_2 = x21 * x21 + y21 * y21,
          l20_2 = x20 * x20 + y20 * y20,
          l21 = Math.sqrt(l21_2),
          l01 = Math.sqrt(l01_2),
          l = r * Math.tan((pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2),
          t01 = l / l01,
          t21 = l / l21;

      // If the start tangent is not coincident with (x0,y0), line to.
      if (Math.abs(t01 - 1) > epsilon) {
        this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
      }

      this._ += "A" + r + "," + r + ",0,0," + (+(y01 * x20 > x01 * y20)) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
    }
  },
  arc: function(x, y, r, a0, a1, ccw) {
    x = +x, y = +y, r = +r;
    var dx = r * Math.cos(a0),
        dy = r * Math.sin(a0),
        x0 = x + dx,
        y0 = y + dy,
        cw = 1 ^ ccw,
        da = ccw ? a0 - a1 : a1 - a0;

    // Is the radius negative? Error.
    if (r < 0) throw new Error("negative radius: " + r);

    // Is this path empty? Move to (x0,y0).
    if (this._x1 === null) {
      this._ += "M" + x0 + "," + y0;
    }

    // Or, is (x0,y0) not coincident with the previous point? Line to (x0,y0).
    else if (Math.abs(this._x1 - x0) > epsilon || Math.abs(this._y1 - y0) > epsilon) {
      this._ += "L" + x0 + "," + y0;
    }

    // Is this arc empty? We’re done.
    if (!r) return;

    // Does the angle go the wrong way? Flip the direction.
    if (da < 0) da = da % tau + tau;

    // Is this a complete circle? Draw two arcs to complete the circle.
    if (da > tauEpsilon) {
      this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
    }

    // Is this arc non-empty? Draw an arc!
    else if (da > epsilon) {
      this._ += "A" + r + "," + r + ",0," + (+(da >= pi)) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
    }
  },
  rect: function(x, y, w, h) {
    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + (+w) + "v" + (+h) + "h" + (-w) + "Z";
  },
  toString: function() {
    return this._;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (path);


/***/ }),
/* 932 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_area__ = __webpack_require__(933);
/* unused harmony reexport polygonArea */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_centroid__ = __webpack_require__(934);
/* unused harmony reexport polygonCentroid */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_hull__ = __webpack_require__(937);
/* unused harmony reexport polygonHull */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_contains__ = __webpack_require__(935);
/* unused harmony reexport polygonContains */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_length__ = __webpack_require__(938);
/* unused harmony reexport polygonLength */







/***/ }),
/* 933 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(polygon) {
  var i = -1,
      n = polygon.length,
      a,
      b = polygon[n - 1],
      area = 0;

  while (++i < n) {
    a = b;
    b = polygon[i];
    area += a[1] * b[0] - a[0] * b[1];
  }

  return area / 2;
});


/***/ }),
/* 934 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(polygon) {
  var i = -1,
      n = polygon.length,
      x = 0,
      y = 0,
      a,
      b = polygon[n - 1],
      c,
      k = 0;

  while (++i < n) {
    a = b;
    b = polygon[i];
    k += c = a[0] * b[1] - b[0] * a[1];
    x += (a[0] + b[0]) * c;
    y += (a[1] + b[1]) * c;
  }

  return k *= 3, [x / k, y / k];
});


/***/ }),
/* 935 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(polygon, point) {
  var n = polygon.length,
      p = polygon[n - 1],
      x = point[0], y = point[1],
      x0 = p[0], y0 = p[1],
      x1, y1,
      inside = false;

  for (var i = 0; i < n; ++i) {
    p = polygon[i], x1 = p[0], y1 = p[1];
    if (((y1 > y) !== (y0 > y)) && (x < (x0 - x1) * (y - y1) / (y0 - y1) + x1)) inside = !inside;
    x0 = x1, y0 = y1;
  }

  return inside;
});


/***/ }),
/* 936 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Returns the 2D cross product of AB and AC vectors, i.e., the z-component of
// the 3D cross product in a quadrant I Cartesian coordinate system (+x is
// right, +y is up). Returns a positive value if ABC is counter-clockwise,
// negative if clockwise, and zero if the points are collinear.
/* harmony default export */ __webpack_exports__["a"] = (function(a, b, c) {
  return (b[0] - a[0]) * (c[1] - a[1]) - (b[1] - a[1]) * (c[0] - a[0]);
});


/***/ }),
/* 937 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cross__ = __webpack_require__(936);


function lexicographicOrder(a, b) {
  return a[0] - b[0] || a[1] - b[1];
}

// Computes the upper convex hull per the monotone chain algorithm.
// Assumes points.length >= 3, is sorted by x, unique in y.
// Returns an array of indices into points in left-to-right order.
function computeUpperHullIndexes(points) {
  var n = points.length,
      indexes = [0, 1],
      size = 2;

  for (var i = 2; i < n; ++i) {
    while (size > 1 && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cross__["a" /* default */])(points[indexes[size - 2]], points[indexes[size - 1]], points[i]) <= 0) --size;
    indexes[size++] = i;
  }

  return indexes.slice(0, size); // remove popped points
}

/* unused harmony default export */ var _unused_webpack_default_export = (function(points) {
  if ((n = points.length) < 3) return null;

  var i,
      n,
      sortedPoints = new Array(n),
      flippedPoints = new Array(n);

  for (i = 0; i < n; ++i) sortedPoints[i] = [+points[i][0], +points[i][1], i];
  sortedPoints.sort(lexicographicOrder);
  for (i = 0; i < n; ++i) flippedPoints[i] = [sortedPoints[i][0], -sortedPoints[i][1]];

  var upperIndexes = computeUpperHullIndexes(sortedPoints),
      lowerIndexes = computeUpperHullIndexes(flippedPoints);

  // Construct the hull polygon, removing possible duplicate endpoints.
  var skipLeft = lowerIndexes[0] === upperIndexes[0],
      skipRight = lowerIndexes[lowerIndexes.length - 1] === upperIndexes[upperIndexes.length - 1],
      hull = [];

  // Add upper hull in right-to-l order.
  // Then add lower hull in left-to-right order.
  for (i = upperIndexes.length - 1; i >= 0; --i) hull.push(points[sortedPoints[upperIndexes[i]][2]]);
  for (i = +skipLeft; i < lowerIndexes.length - skipRight; ++i) hull.push(points[sortedPoints[lowerIndexes[i]][2]]);

  return hull;
});


/***/ }),
/* 938 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(polygon) {
  var i = -1,
      n = polygon.length,
      b = polygon[n - 1],
      xa,
      ya,
      xb = b[0],
      yb = b[1],
      perimeter = 0;

  while (++i < n) {
    xa = xb;
    ya = yb;
    b = polygon[i];
    xb = b[0];
    yb = b[1];
    xa -= xb;
    ya -= yb;
    perimeter += Math.sqrt(xa * xa + ya * ya);
  }

  return perimeter;
});


/***/ }),
/* 939 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = addAll;
/* harmony default export */ __webpack_exports__["a"] = (function(d) {
  var x = +this._x.call(null, d),
      y = +this._y.call(null, d);
  return add(this.cover(x, y), x, y, d);
});

function add(tree, x, y, d) {
  if (isNaN(x) || isNaN(y)) return tree; // ignore invalid points

  var parent,
      node = tree._root,
      leaf = {data: d},
      x0 = tree._x0,
      y0 = tree._y0,
      x1 = tree._x1,
      y1 = tree._y1,
      xm,
      ym,
      xp,
      yp,
      right,
      bottom,
      i,
      j;

  // If the tree is empty, initialize the root as a leaf.
  if (!node) return tree._root = leaf, tree;

  // Find the existing leaf for the new point, or add it.
  while (node.length) {
    if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm; else x1 = xm;
    if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym; else y1 = ym;
    if (parent = node, !(node = node[i = bottom << 1 | right])) return parent[i] = leaf, tree;
  }

  // Is the new point is exactly coincident with the existing point?
  xp = +tree._x.call(null, node.data);
  yp = +tree._y.call(null, node.data);
  if (x === xp && y === yp) return leaf.next = node, parent ? parent[i] = leaf : tree._root = leaf, tree;

  // Otherwise, split the leaf node until the old and new point are separated.
  do {
    parent = parent ? parent[i] = new Array(4) : tree._root = new Array(4);
    if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm; else x1 = xm;
    if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym; else y1 = ym;
  } while ((i = bottom << 1 | right) === (j = (yp >= ym) << 1 | (xp >= xm)));
  return parent[j] = node, parent[i] = leaf, tree;
}

function addAll(data) {
  var d, i, n = data.length,
      x,
      y,
      xz = new Array(n),
      yz = new Array(n),
      x0 = Infinity,
      y0 = Infinity,
      x1 = -Infinity,
      y1 = -Infinity;

  // Compute the points and their extent.
  for (i = 0; i < n; ++i) {
    if (isNaN(x = +this._x.call(null, d = data[i])) || isNaN(y = +this._y.call(null, d))) continue;
    xz[i] = x;
    yz[i] = y;
    if (x < x0) x0 = x;
    if (x > x1) x1 = x;
    if (y < y0) y0 = y;
    if (y > y1) y1 = y;
  }

  // If there were no (valid) points, inherit the existing extent.
  if (x1 < x0) x0 = this._x0, x1 = this._x1;
  if (y1 < y0) y0 = this._y0, y1 = this._y1;

  // Expand the tree to cover the new points.
  this.cover(x0, y0).cover(x1, y1);

  // Add the new points.
  for (i = 0; i < n; ++i) {
    add(this, xz[i], yz[i], data[i]);
  }

  return this;
}


/***/ }),
/* 940 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x, y) {
  if (isNaN(x = +x) || isNaN(y = +y)) return this; // ignore invalid points

  var x0 = this._x0,
      y0 = this._y0,
      x1 = this._x1,
      y1 = this._y1;

  // If the quadtree has no extent, initialize them.
  // Integer extent are necessary so that if we later double the extent,
  // the existing quadrant boundaries don’t change due to floating point error!
  if (isNaN(x0)) {
    x1 = (x0 = Math.floor(x)) + 1;
    y1 = (y0 = Math.floor(y)) + 1;
  }

  // Otherwise, double repeatedly to cover.
  else if (x0 > x || x > x1 || y0 > y || y > y1) {
    var z = x1 - x0,
        node = this._root,
        parent,
        i;

    switch (i = (y < (y0 + y1) / 2) << 1 | (x < (x0 + x1) / 2)) {
      case 0: {
        do parent = new Array(4), parent[i] = node, node = parent;
        while (z *= 2, x1 = x0 + z, y1 = y0 + z, x > x1 || y > y1);
        break;
      }
      case 1: {
        do parent = new Array(4), parent[i] = node, node = parent;
        while (z *= 2, x0 = x1 - z, y1 = y0 + z, x0 > x || y > y1);
        break;
      }
      case 2: {
        do parent = new Array(4), parent[i] = node, node = parent;
        while (z *= 2, x1 = x0 + z, y0 = y1 - z, x > x1 || y0 > y);
        break;
      }
      case 3: {
        do parent = new Array(4), parent[i] = node, node = parent;
        while (z *= 2, x0 = x1 - z, y0 = y1 - z, x0 > x || y0 > y);
        break;
      }
    }

    if (this._root && this._root.length) this._root = node;
  }

  // If the quadtree covers the point already, just return.
  else return this;

  this._x0 = x0;
  this._y0 = y0;
  this._x1 = x1;
  this._y1 = y1;
  return this;
});


/***/ }),
/* 941 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  var data = [];
  this.visit(function(node) {
    if (!node.length) do data.push(node.data); while (node = node.next)
  });
  return data;
});


/***/ }),
/* 942 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(_) {
  return arguments.length
      ? this.cover(+_[0][0], +_[0][1]).cover(+_[1][0], +_[1][1])
      : isNaN(this._x0) ? undefined : [[this._x0, this._y0], [this._x1, this._y1]];
});


/***/ }),
/* 943 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__quad__ = __webpack_require__(250);


/* harmony default export */ __webpack_exports__["a"] = (function(x, y, radius) {
  var data,
      x0 = this._x0,
      y0 = this._y0,
      x1,
      y1,
      x2,
      y2,
      x3 = this._x1,
      y3 = this._y1,
      quads = [],
      node = this._root,
      q,
      i;

  if (node) quads.push(new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](node, x0, y0, x3, y3));
  if (radius == null) radius = Infinity;
  else {
    x0 = x - radius, y0 = y - radius;
    x3 = x + radius, y3 = y + radius;
    radius *= radius;
  }

  while (q = quads.pop()) {

    // Stop searching if this quadrant can’t contain a closer node.
    if (!(node = q.node)
        || (x1 = q.x0) > x3
        || (y1 = q.y0) > y3
        || (x2 = q.x1) < x0
        || (y2 = q.y1) < y0) continue;

    // Bisect the current quadrant.
    if (node.length) {
      var xm = (x1 + x2) / 2,
          ym = (y1 + y2) / 2;

      quads.push(
        new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](node[3], xm, ym, x2, y2),
        new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](node[2], x1, ym, xm, y2),
        new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](node[1], xm, y1, x2, ym),
        new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](node[0], x1, y1, xm, ym)
      );

      // Visit the closest quadrant first.
      if (i = (y >= ym) << 1 | (x >= xm)) {
        q = quads[quads.length - 1];
        quads[quads.length - 1] = quads[quads.length - 1 - i];
        quads[quads.length - 1 - i] = q;
      }
    }

    // Visit this point. (Visiting coincident points isn’t necessary!)
    else {
      var dx = x - +this._x.call(null, node.data),
          dy = y - +this._y.call(null, node.data),
          d2 = dx * dx + dy * dy;
      if (d2 < radius) {
        var d = Math.sqrt(radius = d2);
        x0 = x - d, y0 = y - d;
        x3 = x + d, y3 = y + d;
        data = node.data;
      }
    }
  }

  return data;
});


/***/ }),
/* 944 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = quadtree;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__add__ = __webpack_require__(939);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cover__ = __webpack_require__(940);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data__ = __webpack_require__(941);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__extent__ = __webpack_require__(942);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__find__ = __webpack_require__(943);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__remove__ = __webpack_require__(945);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__root__ = __webpack_require__(946);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__size__ = __webpack_require__(947);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__visit__ = __webpack_require__(948);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__visitAfter__ = __webpack_require__(949);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__x__ = __webpack_require__(950);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__y__ = __webpack_require__(951);













function quadtree(nodes, x, y) {
  var tree = new Quadtree(x == null ? __WEBPACK_IMPORTED_MODULE_10__x__["a" /* defaultX */] : x, y == null ? __WEBPACK_IMPORTED_MODULE_11__y__["a" /* defaultY */] : y, NaN, NaN, NaN, NaN);
  return nodes == null ? tree : tree.addAll(nodes);
}

function Quadtree(x, y, x0, y0, x1, y1) {
  this._x = x;
  this._y = y;
  this._x0 = x0;
  this._y0 = y0;
  this._x1 = x1;
  this._y1 = y1;
  this._root = undefined;
}

function leaf_copy(leaf) {
  var copy = {data: leaf.data}, next = copy;
  while (leaf = leaf.next) next = next.next = {data: leaf.data};
  return copy;
}

var treeProto = quadtree.prototype = Quadtree.prototype;

treeProto.copy = function() {
  var copy = new Quadtree(this._x, this._y, this._x0, this._y0, this._x1, this._y1),
      node = this._root,
      nodes,
      child;

  if (!node) return copy;

  if (!node.length) return copy._root = leaf_copy(node), copy;

  nodes = [{source: node, target: copy._root = new Array(4)}];
  while (node = nodes.pop()) {
    for (var i = 0; i < 4; ++i) {
      if (child = node.source[i]) {
        if (child.length) nodes.push({source: child, target: node.target[i] = new Array(4)});
        else node.target[i] = leaf_copy(child);
      }
    }
  }

  return copy;
};

treeProto.add = __WEBPACK_IMPORTED_MODULE_0__add__["a" /* default */];
treeProto.addAll = __WEBPACK_IMPORTED_MODULE_0__add__["b" /* addAll */];
treeProto.cover = __WEBPACK_IMPORTED_MODULE_1__cover__["a" /* default */];
treeProto.data = __WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */];
treeProto.extent = __WEBPACK_IMPORTED_MODULE_3__extent__["a" /* default */];
treeProto.find = __WEBPACK_IMPORTED_MODULE_4__find__["a" /* default */];
treeProto.remove = __WEBPACK_IMPORTED_MODULE_5__remove__["a" /* default */];
treeProto.removeAll = __WEBPACK_IMPORTED_MODULE_5__remove__["b" /* removeAll */];
treeProto.root = __WEBPACK_IMPORTED_MODULE_6__root__["a" /* default */];
treeProto.size = __WEBPACK_IMPORTED_MODULE_7__size__["a" /* default */];
treeProto.visit = __WEBPACK_IMPORTED_MODULE_8__visit__["a" /* default */];
treeProto.visitAfter = __WEBPACK_IMPORTED_MODULE_9__visitAfter__["a" /* default */];
treeProto.x = __WEBPACK_IMPORTED_MODULE_10__x__["b" /* default */];
treeProto.y = __WEBPACK_IMPORTED_MODULE_11__y__["b" /* default */];


/***/ }),
/* 945 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = removeAll;
/* harmony default export */ __webpack_exports__["a"] = (function(d) {
  if (isNaN(x = +this._x.call(null, d)) || isNaN(y = +this._y.call(null, d))) return this; // ignore invalid points

  var parent,
      node = this._root,
      retainer,
      previous,
      next,
      x0 = this._x0,
      y0 = this._y0,
      x1 = this._x1,
      y1 = this._y1,
      x,
      y,
      xm,
      ym,
      right,
      bottom,
      i,
      j;

  // If the tree is empty, initialize the root as a leaf.
  if (!node) return this;

  // Find the leaf node for the point.
  // While descending, also retain the deepest parent with a non-removed sibling.
  if (node.length) while (true) {
    if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm; else x1 = xm;
    if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym; else y1 = ym;
    if (!(parent = node, node = node[i = bottom << 1 | right])) return this;
    if (!node.length) break;
    if (parent[(i + 1) & 3] || parent[(i + 2) & 3] || parent[(i + 3) & 3]) retainer = parent, j = i;
  }

  // Find the point to remove.
  while (node.data !== d) if (!(previous = node, node = node.next)) return this;
  if (next = node.next) delete node.next;

  // If there are multiple coincident points, remove just the point.
  if (previous) return (next ? previous.next = next : delete previous.next), this;

  // If this is the root point, remove it.
  if (!parent) return this._root = next, this;

  // Remove this leaf.
  next ? parent[i] = next : delete parent[i];

  // If the parent now contains exactly one leaf, collapse superfluous parents.
  if ((node = parent[0] || parent[1] || parent[2] || parent[3])
      && node === (parent[3] || parent[2] || parent[1] || parent[0])
      && !node.length) {
    if (retainer) retainer[j] = node;
    else this._root = node;
  }

  return this;
});

function removeAll(data) {
  for (var i = 0, n = data.length; i < n; ++i) this.remove(data[i]);
  return this;
}


/***/ }),
/* 946 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  return this._root;
});


/***/ }),
/* 947 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  var size = 0;
  this.visit(function(node) {
    if (!node.length) do ++size; while (node = node.next)
  });
  return size;
});


/***/ }),
/* 948 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__quad__ = __webpack_require__(250);


/* harmony default export */ __webpack_exports__["a"] = (function(callback) {
  var quads = [], q, node = this._root, child, x0, y0, x1, y1;
  if (node) quads.push(new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](node, this._x0, this._y0, this._x1, this._y1));
  while (q = quads.pop()) {
    if (!callback(node = q.node, x0 = q.x0, y0 = q.y0, x1 = q.x1, y1 = q.y1) && node.length) {
      var xm = (x0 + x1) / 2, ym = (y0 + y1) / 2;
      if (child = node[3]) quads.push(new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](child, xm, ym, x1, y1));
      if (child = node[2]) quads.push(new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](child, x0, ym, xm, y1));
      if (child = node[1]) quads.push(new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](child, xm, y0, x1, ym));
      if (child = node[0]) quads.push(new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](child, x0, y0, xm, ym));
    }
  }
  return this;
});


/***/ }),
/* 949 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__quad__ = __webpack_require__(250);


/* harmony default export */ __webpack_exports__["a"] = (function(callback) {
  var quads = [], next = [], q;
  if (this._root) quads.push(new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](this._root, this._x0, this._y0, this._x1, this._y1));
  while (q = quads.pop()) {
    var node = q.node;
    if (node.length) {
      var child, x0 = q.x0, y0 = q.y0, x1 = q.x1, y1 = q.y1, xm = (x0 + x1) / 2, ym = (y0 + y1) / 2;
      if (child = node[0]) quads.push(new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](child, x0, y0, xm, ym));
      if (child = node[1]) quads.push(new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](child, xm, y0, x1, ym));
      if (child = node[2]) quads.push(new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](child, x0, ym, xm, y1));
      if (child = node[3]) quads.push(new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](child, xm, ym, x1, y1));
    }
    next.push(q);
  }
  while (q = next.pop()) {
    callback(q.node, q.x0, q.y0, q.x1, q.y1);
  }
  return this;
});


/***/ }),
/* 950 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = defaultX;
function defaultX(d) {
  return d[0];
}

/* harmony default export */ __webpack_exports__["b"] = (function(_) {
  return arguments.length ? (this._x = _, this) : this._x;
});


/***/ }),
/* 951 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = defaultY;
function defaultY(d) {
  return d[1];
}

/* harmony default export */ __webpack_exports__["b"] = (function(_) {
  return arguments.length ? (this._y = _, this) : this._y;
});


/***/ }),
/* 952 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_queue__ = __webpack_require__(954);
/* unused harmony reexport queue */



/***/ }),
/* 953 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return slice; });
var slice = [].slice;


/***/ }),
/* 954 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(953);


var noabort = {};

function Queue(size) {
  this._size = size;
  this._call =
  this._error = null;
  this._tasks = [];
  this._data = [];
  this._waiting =
  this._active =
  this._ended =
  this._start = 0; // inside a synchronous task callback?
}

Queue.prototype = queue.prototype = {
  constructor: Queue,
  defer: function(callback) {
    if (typeof callback !== "function") throw new Error("invalid callback");
    if (this._call) throw new Error("defer after await");
    if (this._error != null) return this;
    var t = __WEBPACK_IMPORTED_MODULE_0__array__["a" /* slice */].call(arguments, 1);
    t.push(callback);
    ++this._waiting, this._tasks.push(t);
    poke(this);
    return this;
  },
  abort: function() {
    if (this._error == null) abort(this, new Error("abort"));
    return this;
  },
  await: function(callback) {
    if (typeof callback !== "function") throw new Error("invalid callback");
    if (this._call) throw new Error("multiple await");
    this._call = function(error, results) { callback.apply(null, [error].concat(results)); };
    maybeNotify(this);
    return this;
  },
  awaitAll: function(callback) {
    if (typeof callback !== "function") throw new Error("invalid callback");
    if (this._call) throw new Error("multiple await");
    this._call = callback;
    maybeNotify(this);
    return this;
  }
};

function poke(q) {
  if (!q._start) {
    try { start(q); } // let the current task complete
    catch (e) {
      if (q._tasks[q._ended + q._active - 1]) abort(q, e); // task errored synchronously
      else if (!q._data) throw e; // await callback errored synchronously
    }
  }
}

function start(q) {
  while (q._start = q._waiting && q._active < q._size) {
    var i = q._ended + q._active,
        t = q._tasks[i],
        j = t.length - 1,
        c = t[j];
    t[j] = end(q, i);
    --q._waiting, ++q._active;
    t = c.apply(null, t);
    if (!q._tasks[i]) continue; // task finished synchronously
    q._tasks[i] = t || noabort;
  }
}

function end(q, i) {
  return function(e, r) {
    if (!q._tasks[i]) return; // ignore multiple callbacks
    --q._active, ++q._ended;
    q._tasks[i] = null;
    if (q._error != null) return; // ignore secondary errors
    if (e != null) {
      abort(q, e);
    } else {
      q._data[i] = r;
      if (q._waiting) poke(q);
      else maybeNotify(q);
    }
  };
}

function abort(q, e) {
  var i = q._tasks.length, t;
  q._error = e; // ignore active callbacks
  q._data = undefined; // allow gc
  q._waiting = NaN; // prevent starting

  while (--i >= 0) {
    if (t = q._tasks[i]) {
      q._tasks[i] = null;
      if (t.abort) {
        try { t.abort(); }
        catch (e) { /* ignore */ }
      }
    }
  }

  q._active = NaN; // allow notification
  maybeNotify(q);
}

function maybeNotify(q) {
  if (!q._active && q._call) {
    var d = q._data;
    q._data = undefined; // allow gc
    q._call(q._error, d);
  }
}

function queue(concurrency) {
  if (concurrency == null) concurrency = Infinity;
  else if (!((concurrency = +concurrency) >= 1)) throw new Error("invalid concurrency");
  return new Queue(concurrency);
}


/***/ }),
/* 955 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_uniform__ = __webpack_require__(959);
/* unused harmony reexport randomUniform */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_normal__ = __webpack_require__(425);
/* unused harmony reexport randomNormal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_logNormal__ = __webpack_require__(958);
/* unused harmony reexport randomLogNormal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_bates__ = __webpack_require__(956);
/* unused harmony reexport randomBates */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_irwinHall__ = __webpack_require__(424);
/* unused harmony reexport randomIrwinHall */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_exponential__ = __webpack_require__(957);
/* unused harmony reexport randomExponential */








/***/ }),
/* 956 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defaultSource__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__irwinHall__ = __webpack_require__(424);



/* unused harmony default export */ var _unused_webpack_default_export = ((function sourceRandomBates(source) {
  function randomBates(n) {
    var randomIrwinHall = __WEBPACK_IMPORTED_MODULE_1__irwinHall__["a" /* default */].source(source)(n);
    return function() {
      return randomIrwinHall() / n;
    };
  }

  randomBates.source = sourceRandomBates;

  return randomBates;
})(__WEBPACK_IMPORTED_MODULE_0__defaultSource__["a" /* default */]));


/***/ }),
/* 957 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defaultSource__ = __webpack_require__(108);


/* unused harmony default export */ var _unused_webpack_default_export = ((function sourceRandomExponential(source) {
  function randomExponential(lambda) {
    return function() {
      return -Math.log(1 - source()) / lambda;
    };
  }

  randomExponential.source = sourceRandomExponential;

  return randomExponential;
})(__WEBPACK_IMPORTED_MODULE_0__defaultSource__["a" /* default */]));


/***/ }),
/* 958 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defaultSource__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__normal__ = __webpack_require__(425);



/* unused harmony default export */ var _unused_webpack_default_export = ((function sourceRandomLogNormal(source) {
  function randomLogNormal() {
    var randomNormal = __WEBPACK_IMPORTED_MODULE_1__normal__["a" /* default */].source(source).apply(this, arguments);
    return function() {
      return Math.exp(randomNormal());
    };
  }

  randomLogNormal.source = sourceRandomLogNormal;

  return randomLogNormal;
})(__WEBPACK_IMPORTED_MODULE_0__defaultSource__["a" /* default */]));


/***/ }),
/* 959 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defaultSource__ = __webpack_require__(108);


/* unused harmony default export */ var _unused_webpack_default_export = ((function sourceRandomUniform(source) {
  function randomUniform(min, max) {
    min = min == null ? 0 : +min;
    max = max == null ? 1 : +max;
    if (arguments.length === 1) max = min, min = 0;
    else max -= min;
    return function() {
      return source() * max + min;
    };
  }

  randomUniform.source = sourceRandomUniform;

  return randomUniform;
})(__WEBPACK_IMPORTED_MODULE_0__defaultSource__["a" /* default */]));


/***/ }),
/* 960 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_request__ = __webpack_require__(251);
/* unused harmony reexport request */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_html__ = __webpack_require__(962);
/* unused harmony reexport html */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_json__ = __webpack_require__(963);
/* unused harmony reexport json */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_text__ = __webpack_require__(964);
/* unused harmony reexport text */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_xml__ = __webpack_require__(966);
/* unused harmony reexport xml */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_csv__ = __webpack_require__(961);
/* unused harmony reexport csv */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_tsv__ = __webpack_require__(965);
/* unused harmony reexport tsv */









/***/ }),
/* 961 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_dsv__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dsv__ = __webpack_require__(426);



/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__dsv__["a" /* default */])("text/csv", __WEBPACK_IMPORTED_MODULE_0_d3_dsv__["b" /* csvParse */]));


/***/ }),
/* 962 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__type__ = __webpack_require__(155);


/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__type__["a" /* default */])("text/html", function(xhr) {
  return document.createRange().createContextualFragment(xhr.responseText);
}));


/***/ }),
/* 963 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__type__ = __webpack_require__(155);


/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__type__["a" /* default */])("application/json", function(xhr) {
  return JSON.parse(xhr.responseText);
}));


/***/ }),
/* 964 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__type__ = __webpack_require__(155);


/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__type__["a" /* default */])("text/plain", function(xhr) {
  return xhr.responseText;
}));


/***/ }),
/* 965 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_dsv__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dsv__ = __webpack_require__(426);



/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__dsv__["a" /* default */])("text/tab-separated-values", __WEBPACK_IMPORTED_MODULE_0_d3_dsv__["a" /* tsvParse */]));


/***/ }),
/* 966 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__type__ = __webpack_require__(155);


/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__type__["a" /* default */])("application/xml", function(xhr) {
  var xml = xhr.responseXML;
  if (!xml) throw new Error("parse error");
  return xml;
}));


/***/ }),
/* 967 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_band__ = __webpack_require__(968);
/* unused harmony reexport scaleBand */
/* unused harmony reexport scalePoint */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_identity__ = __webpack_require__(974);
/* unused harmony reexport scaleIdentity */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_linear__ = __webpack_require__(120);
/* unused harmony reexport scaleLinear */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_log__ = __webpack_require__(975);
/* unused harmony reexport scaleLog */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_ordinal__ = __webpack_require__(429);
/* unused harmony reexport scaleOrdinal */
/* unused harmony reexport scaleImplicit */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_pow__ = __webpack_require__(976);
/* unused harmony reexport scalePow */
/* unused harmony reexport scaleSqrt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_quantile__ = __webpack_require__(977);
/* unused harmony reexport scaleQuantile */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_quantize__ = __webpack_require__(978);
/* unused harmony reexport scaleQuantize */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_threshold__ = __webpack_require__(981);
/* unused harmony reexport scaleThreshold */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_time__ = __webpack_require__(430);
/* unused harmony reexport scaleTime */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_utcTime__ = __webpack_require__(983);
/* unused harmony reexport scaleUtc */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_category10__ = __webpack_require__(969);
/* unused harmony reexport schemeCategory10 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_category20b__ = __webpack_require__(971);
/* unused harmony reexport schemeCategory20b */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_category20c__ = __webpack_require__(972);
/* unused harmony reexport schemeCategory20c */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_category20__ = __webpack_require__(970);
/* unused harmony reexport schemeCategory20 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__src_cubehelix__ = __webpack_require__(973);
/* unused harmony reexport interpolateCubehelixDefault */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__src_rainbow__ = __webpack_require__(979);
/* unused harmony reexport interpolateRainbow */
/* unused harmony reexport interpolateWarm */
/* unused harmony reexport interpolateCool */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__src_viridis__ = __webpack_require__(984);
/* unused harmony reexport interpolateViridis */
/* unused harmony reexport interpolateMagma */
/* unused harmony reexport interpolateInferno */
/* unused harmony reexport interpolatePlasma */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__src_sequential__ = __webpack_require__(980);
/* unused harmony reexport scaleSequential */







































/***/ }),
/* 968 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* unused harmony export point */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ordinal__ = __webpack_require__(429);



function band() {
  var scale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__ordinal__["a" /* default */])().unknown(undefined),
      domain = scale.domain,
      ordinalRange = scale.range,
      range = [0, 1],
      step,
      bandwidth,
      round = false,
      paddingInner = 0,
      paddingOuter = 0,
      align = 0.5;

  delete scale.unknown;

  function rescale() {
    var n = domain().length,
        reverse = range[1] < range[0],
        start = range[reverse - 0],
        stop = range[1 - reverse];
    step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
    if (round) step = Math.floor(step);
    start += (stop - start - step * (n - paddingInner)) * align;
    bandwidth = step * (1 - paddingInner);
    if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
    var values = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["h" /* range */])(n).map(function(i) { return start + step * i; });
    return ordinalRange(reverse ? values.reverse() : values);
  }

  scale.domain = function(_) {
    return arguments.length ? (domain(_), rescale()) : domain();
  };

  scale.range = function(_) {
    return arguments.length ? (range = [+_[0], +_[1]], rescale()) : range.slice();
  };

  scale.rangeRound = function(_) {
    return range = [+_[0], +_[1]], round = true, rescale();
  };

  scale.bandwidth = function() {
    return bandwidth;
  };

  scale.step = function() {
    return step;
  };

  scale.round = function(_) {
    return arguments.length ? (round = !!_, rescale()) : round;
  };

  scale.padding = function(_) {
    return arguments.length ? (paddingInner = paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
  };

  scale.paddingInner = function(_) {
    return arguments.length ? (paddingInner = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
  };

  scale.paddingOuter = function(_) {
    return arguments.length ? (paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingOuter;
  };

  scale.align = function(_) {
    return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
  };

  scale.copy = function() {
    return band()
        .domain(domain())
        .range(range)
        .round(round)
        .paddingInner(paddingInner)
        .paddingOuter(paddingOuter)
        .align(align);
  };

  return rescale();
}

function pointish(scale) {
  var copy = scale.copy;

  scale.padding = scale.paddingOuter;
  delete scale.paddingInner;
  delete scale.paddingOuter;

  scale.copy = function() {
    return pointish(copy());
  };

  return scale;
}

function point() {
  return pointish(band().paddingInner(1));
}


/***/ }),
/* 969 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(119);


/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf"));


/***/ }),
/* 970 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(119);


/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("1f77b4aec7e8ff7f0effbb782ca02c98df8ad62728ff98969467bdc5b0d58c564bc49c94e377c2f7b6d27f7f7fc7c7c7bcbd22dbdb8d17becf9edae5"));


/***/ }),
/* 971 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(119);


/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("393b795254a36b6ecf9c9ede6379398ca252b5cf6bcedb9c8c6d31bd9e39e7ba52e7cb94843c39ad494ad6616be7969c7b4173a55194ce6dbdde9ed6"));


/***/ }),
/* 972 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(119);


/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("3182bd6baed69ecae1c6dbefe6550dfd8d3cfdae6bfdd0a231a35474c476a1d99bc7e9c0756bb19e9ac8bcbddcdadaeb636363969696bdbdbdd9d9d9"));


/***/ }),
/* 973 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__(42);



/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["i" /* interpolateCubehelixLong */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["b" /* cubehelix */])(300, 0.5, 0.0), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["b" /* cubehelix */])(-240, 0.5, 1.0)));


/***/ }),
/* 974 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__linear__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__number__ = __webpack_require__(428);




function identity() {
  var domain = [0, 1];

  function scale(x) {
    return +x;
  }

  scale.invert = scale;

  scale.domain = scale.range = function(_) {
    return arguments.length ? (domain = __WEBPACK_IMPORTED_MODULE_0__array__["a" /* map */].call(_, __WEBPACK_IMPORTED_MODULE_2__number__["a" /* default */]), scale) : domain.slice();
  };

  scale.copy = function() {
    return identity().domain(domain);
  };

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__linear__["a" /* linearish */])(scale);
}


/***/ }),
/* 975 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_format__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constant__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__nice__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__continuous__ = __webpack_require__(156);






function deinterpolate(a, b) {
  return (b = Math.log(b / a))
      ? function(x) { return Math.log(x / a) / b; }
      : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(b);
}

function reinterpolate(a, b) {
  return a < 0
      ? function(t) { return -Math.pow(-b, t) * Math.pow(-a, 1 - t); }
      : function(t) { return Math.pow(b, t) * Math.pow(a, 1 - t); };
}

function pow10(x) {
  return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
}

function powp(base) {
  return base === 10 ? pow10
      : base === Math.E ? Math.exp
      : function(x) { return Math.pow(base, x); };
}

function logp(base) {
  return base === Math.E ? Math.log
      : base === 10 && Math.log10
      || base === 2 && Math.log2
      || (base = Math.log(base), function(x) { return Math.log(x) / base; });
}

function reflect(f) {
  return function(x) {
    return -f(-x);
  };
}

function log() {
  var scale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__continuous__["a" /* default */])(deinterpolate, reinterpolate).domain([1, 10]),
      domain = scale.domain,
      base = 10,
      logs = logp(10),
      pows = powp(10);

  function rescale() {
    logs = logp(base), pows = powp(base);
    if (domain()[0] < 0) logs = reflect(logs), pows = reflect(pows);
    return scale;
  }

  scale.base = function(_) {
    return arguments.length ? (base = +_, rescale()) : base;
  };

  scale.domain = function(_) {
    return arguments.length ? (domain(_), rescale()) : domain();
  };

  scale.ticks = function(count) {
    var d = domain(),
        u = d[0],
        v = d[d.length - 1],
        r;

    if (r = v < u) i = u, u = v, v = i;

    var i = logs(u),
        j = logs(v),
        p,
        k,
        t,
        n = count == null ? 10 : +count,
        z = [];

    if (!(base % 1) && j - i < n) {
      i = Math.round(i) - 1, j = Math.round(j) + 1;
      if (u > 0) for (; i < j; ++i) {
        for (k = 1, p = pows(i); k < base; ++k) {
          t = p * k;
          if (t < u) continue;
          if (t > v) break;
          z.push(t);
        }
      } else for (; i < j; ++i) {
        for (k = base - 1, p = pows(i); k >= 1; --k) {
          t = p * k;
          if (t < u) continue;
          if (t > v) break;
          z.push(t);
        }
      }
    } else {
      z = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["a" /* ticks */])(i, j, Math.min(j - i, n)).map(pows);
    }

    return r ? z.reverse() : z;
  };

  scale.tickFormat = function(count, specifier) {
    if (specifier == null) specifier = base === 10 ? ".0e" : ",";
    if (typeof specifier !== "function") specifier = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_format__["f" /* format */])(specifier);
    if (count === Infinity) return specifier;
    if (count == null) count = 10;
    var k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
    return function(d) {
      var i = d / pows(Math.round(logs(d)));
      if (i * base < base - 0.5) i *= base;
      return i <= k ? specifier(d) : "";
    };
  };

  scale.nice = function() {
    return domain(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__nice__["a" /* default */])(domain(), {
      floor: function(x) { return pows(Math.floor(logs(x))); },
      ceil: function(x) { return pows(Math.ceil(logs(x))); }
    }));
  };

  scale.copy = function() {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__continuous__["c" /* copy */])(scale, log().base(base));
  };

  return scale;
}


/***/ }),
/* 976 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* unused harmony export sqrt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__linear__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__continuous__ = __webpack_require__(156);




function raise(x, exponent) {
  return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
}

function pow() {
  var exponent = 1,
      scale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__continuous__["a" /* default */])(deinterpolate, reinterpolate),
      domain = scale.domain;

  function deinterpolate(a, b) {
    return (b = raise(b, exponent) - (a = raise(a, exponent)))
        ? function(x) { return (raise(x, exponent) - a) / b; }
        : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(b);
  }

  function reinterpolate(a, b) {
    b = raise(b, exponent) - (a = raise(a, exponent));
    return function(t) { return raise(a + b * t, 1 / exponent); };
  }

  scale.exponent = function(_) {
    return arguments.length ? (exponent = +_, domain(domain())) : exponent;
  };

  scale.copy = function() {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__continuous__["c" /* copy */])(scale, pow().exponent(exponent));
  };

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__linear__["a" /* linearish */])(scale);
}

function sqrt() {
  return pow().exponent(0.5);
}


/***/ }),
/* 977 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(90);



function quantile() {
  var domain = [],
      range = [],
      thresholds = [];

  function rescale() {
    var i = 0, n = Math.max(1, range.length);
    thresholds = new Array(n - 1);
    while (++i < n) thresholds[i - 1] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["f" /* quantile */])(domain, i / n);
    return scale;
  }

  function scale(x) {
    if (!isNaN(x = +x)) return range[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["c" /* bisect */])(thresholds, x)];
  }

  scale.invertExtent = function(y) {
    var i = range.indexOf(y);
    return i < 0 ? [NaN, NaN] : [
      i > 0 ? thresholds[i - 1] : domain[0],
      i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
    ];
  };

  scale.domain = function(_) {
    if (!arguments.length) return domain.slice();
    domain = [];
    for (var i = 0, n = _.length, d; i < n; ++i) if (d = _[i], d != null && !isNaN(d = +d)) domain.push(d);
    domain.sort(__WEBPACK_IMPORTED_MODULE_0_d3_array__["g" /* ascending */]);
    return rescale();
  };

  scale.range = function(_) {
    return arguments.length ? (range = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_), rescale()) : range.slice();
  };

  scale.quantiles = function() {
    return thresholds.slice();
  };

  scale.copy = function() {
    return quantile()
        .domain(domain)
        .range(range);
  };

  return scale;
}


/***/ }),
/* 978 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__linear__ = __webpack_require__(120);




function quantize() {
  var x0 = 0,
      x1 = 1,
      n = 1,
      domain = [0.5],
      range = [0, 1];

  function scale(x) {
    if (x <= x) return range[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["c" /* bisect */])(domain, x, 0, n)];
  }

  function rescale() {
    var i = -1;
    domain = new Array(n);
    while (++i < n) domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
    return scale;
  }

  scale.domain = function(_) {
    return arguments.length ? (x0 = +_[0], x1 = +_[1], rescale()) : [x0, x1];
  };

  scale.range = function(_) {
    return arguments.length ? (n = (range = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_)).length - 1, rescale()) : range.slice();
  };

  scale.invertExtent = function(y) {
    var i = range.indexOf(y);
    return i < 0 ? [NaN, NaN]
        : i < 1 ? [x0, domain[0]]
        : i >= n ? [domain[n - 1], x1]
        : [domain[i - 1], domain[i]];
  };

  scale.copy = function() {
    return quantize()
        .domain([x0, x1])
        .range(range);
  };

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__linear__["a" /* linearish */])(scale);
}


/***/ }),
/* 979 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export warm */
/* unused harmony export cool */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__(42);



var warm = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["i" /* interpolateCubehelixLong */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["b" /* cubehelix */])(-100, 0.75, 0.35), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["b" /* cubehelix */])(80, 1.50, 0.8));

var cool = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["i" /* interpolateCubehelixLong */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["b" /* cubehelix */])(260, 0.75, 0.35), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["b" /* cubehelix */])(80, 1.50, 0.8));

var rainbow = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["b" /* cubehelix */])();

/* unused harmony default export */ var _unused_webpack_default_export = (function(t) {
  if (t < 0 || t > 1) t -= Math.floor(t);
  var ts = Math.abs(t - 0.5);
  rainbow.h = 360 * t - 100;
  rainbow.s = 1.5 - 1.5 * ts;
  rainbow.l = 0.8 - 0.9 * ts;
  return rainbow + "";
});


/***/ }),
/* 980 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__linear__ = __webpack_require__(120);


function sequential(interpolator) {
  var x0 = 0,
      x1 = 1,
      clamp = false;

  function scale(x) {
    var t = (x - x0) / (x1 - x0);
    return interpolator(clamp ? Math.max(0, Math.min(1, t)) : t);
  }

  scale.domain = function(_) {
    return arguments.length ? (x0 = +_[0], x1 = +_[1], scale) : [x0, x1];
  };

  scale.clamp = function(_) {
    return arguments.length ? (clamp = !!_, scale) : clamp;
  };

  scale.interpolator = function(_) {
    return arguments.length ? (interpolator = _, scale) : interpolator;
  };

  scale.copy = function() {
    return sequential(interpolator).domain([x0, x1]).clamp(clamp);
  };

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__linear__["a" /* linearish */])(scale);
}


/***/ }),
/* 981 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(90);



function threshold() {
  var domain = [0.5],
      range = [0, 1],
      n = 1;

  function scale(x) {
    if (x <= x) return range[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["c" /* bisect */])(domain, x, 0, n)];
  }

  scale.domain = function(_) {
    return arguments.length ? (domain = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_), n = Math.min(domain.length, range.length - 1), scale) : domain.slice();
  };

  scale.range = function(_) {
    return arguments.length ? (range = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_), n = Math.min(domain.length, range.length - 1), scale) : range.slice();
  };

  scale.invertExtent = function(y) {
    var i = range.indexOf(y);
    return [domain[i - 1], domain[i]];
  };

  scale.copy = function() {
    return threshold()
        .domain(domain)
        .range(range);
  };

  return scale;
}


/***/ }),
/* 982 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_format__ = __webpack_require__(237);



/* harmony default export */ __webpack_exports__["a"] = (function(domain, count, specifier) {
  var start = domain[0],
      stop = domain[domain.length - 1],
      step = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["d" /* tickStep */])(start, stop, count == null ? 10 : count),
      precision;
  specifier = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_format__["a" /* formatSpecifier */])(specifier == null ? ",f" : specifier);
  switch (specifier.type) {
    case "s": {
      var value = Math.max(Math.abs(start), Math.abs(stop));
      if (specifier.precision == null && !isNaN(precision = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_format__["b" /* precisionPrefix */])(step, value))) specifier.precision = precision;
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_format__["c" /* formatPrefix */])(specifier, value);
    }
    case "":
    case "e":
    case "g":
    case "p":
    case "r": {
      if (specifier.precision == null && !isNaN(precision = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_format__["d" /* precisionRound */])(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
      break;
    }
    case "f":
    case "%": {
      if (specifier.precision == null && !isNaN(precision = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_format__["e" /* precisionFixed */])(step))) specifier.precision = precision - (specifier.type === "%") * 2;
      break;
    }
  }
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_format__["f" /* format */])(specifier);
});


/***/ }),
/* 983 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__time__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_time_format__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_time__ = __webpack_require__(162);




/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__time__["a" /* calendar */])(__WEBPACK_IMPORTED_MODULE_2_d3_time__["h" /* utcYear */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["k" /* utcMonth */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["l" /* utcWeek */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["b" /* utcDay */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["m" /* utcHour */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["n" /* utcMinute */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["o" /* utcSecond */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["p" /* utcMillisecond */], __WEBPACK_IMPORTED_MODULE_1_d3_time_format__["a" /* utcFormat */]).domain([Date.UTC(2000, 0, 1), Date.UTC(2000, 0, 2)]);
});


/***/ }),
/* 984 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export magma */
/* unused harmony export inferno */
/* unused harmony export plasma */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(119);


function ramp(range) {
  var n = range.length;
  return function(t) {
    return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
  };
}

/* unused harmony default export */ var _unused_webpack_default_export = (ramp(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("44015444025645045745055946075a46085c460a5d460b5e470d60470e6147106347116447136548146748166848176948186a481a6c481b6d481c6e481d6f481f70482071482173482374482475482576482677482878482979472a7a472c7a472d7b472e7c472f7d46307e46327e46337f463480453581453781453882443983443a83443b84433d84433e85423f854240864241864142874144874045884046883f47883f48893e49893e4a893e4c8a3d4d8a3d4e8a3c4f8a3c508b3b518b3b528b3a538b3a548c39558c39568c38588c38598c375a8c375b8d365c8d365d8d355e8d355f8d34608d34618d33628d33638d32648e32658e31668e31678e31688e30698e306a8e2f6b8e2f6c8e2e6d8e2e6e8e2e6f8e2d708e2d718e2c718e2c728e2c738e2b748e2b758e2a768e2a778e2a788e29798e297a8e297b8e287c8e287d8e277e8e277f8e27808e26818e26828e26828e25838e25848e25858e24868e24878e23888e23898e238a8d228b8d228c8d228d8d218e8d218f8d21908d21918c20928c20928c20938c1f948c1f958b1f968b1f978b1f988b1f998a1f9a8a1e9b8a1e9c891e9d891f9e891f9f881fa0881fa1881fa1871fa28720a38620a48621a58521a68522a78522a88423a98324aa8325ab8225ac8226ad8127ad8128ae8029af7f2ab07f2cb17e2db27d2eb37c2fb47c31b57b32b67a34b67935b77937b87838b9773aba763bbb753dbc743fbc7340bd7242be7144bf7046c06f48c16e4ac16d4cc26c4ec36b50c46a52c56954c56856c66758c7655ac8645cc8635ec96260ca6063cb5f65cb5e67cc5c69cd5b6ccd5a6ece5870cf5773d05675d05477d1537ad1517cd2507fd34e81d34d84d44b86d54989d5488bd6468ed64590d74393d74195d84098d83e9bd93c9dd93ba0da39a2da37a5db36a8db34aadc32addc30b0dd2fb2dd2db5de2bb8de29bade28bddf26c0df25c2df23c5e021c8e020cae11fcde11dd0e11cd2e21bd5e21ad8e219dae319dde318dfe318e2e418e5e419e7e419eae51aece51befe51cf1e51df4e61ef6e620f8e621fbe723fde725")));

var magma = ramp(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("00000401000501010601010802010902020b02020d03030f03031204041405041606051806051a07061c08071e0907200a08220b09240c09260d0a290e0b2b100b2d110c2f120d31130d34140e36150e38160f3b180f3d19103f1a10421c10441d11471e114920114b21114e22115024125325125527125829115a2a115c2c115f2d11612f116331116533106734106936106b38106c390f6e3b0f703d0f713f0f72400f74420f75440f764510774710784910784a10794c117a4e117b4f127b51127c52137c54137d56147d57157e59157e5a167e5c167f5d177f5f187f601880621980641a80651a80671b80681c816a1c816b1d816d1d816e1e81701f81721f817320817521817621817822817922827b23827c23827e24828025828125818326818426818627818827818928818b29818c29818e2a81902a81912b81932b80942c80962c80982d80992d809b2e7f9c2e7f9e2f7fa02f7fa1307ea3307ea5317ea6317da8327daa337dab337cad347cae347bb0357bb2357bb3367ab5367ab73779b83779ba3878bc3978bd3977bf3a77c03a76c23b75c43c75c53c74c73d73c83e73ca3e72cc3f71cd4071cf4070d0416fd2426fd3436ed5446dd6456cd8456cd9466bdb476adc4869de4968df4a68e04c67e24d66e34e65e44f64e55064e75263e85362e95462ea5661eb5760ec5860ed5a5fee5b5eef5d5ef05f5ef1605df2625df2645cf3655cf4675cf4695cf56b5cf66c5cf66e5cf7705cf7725cf8745cf8765cf9785df9795df97b5dfa7d5efa7f5efa815ffb835ffb8560fb8761fc8961fc8a62fc8c63fc8e64fc9065fd9266fd9467fd9668fd9869fd9a6afd9b6bfe9d6cfe9f6dfea16efea36ffea571fea772fea973feaa74feac76feae77feb078feb27afeb47bfeb67cfeb77efeb97ffebb81febd82febf84fec185fec287fec488fec68afec88cfeca8dfecc8ffecd90fecf92fed194fed395fed597fed799fed89afdda9cfddc9efddea0fde0a1fde2a3fde3a5fde5a7fde7a9fde9aafdebacfcecaefceeb0fcf0b2fcf2b4fcf4b6fcf6b8fcf7b9fcf9bbfcfbbdfcfdbf"));

var inferno = ramp(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("00000401000501010601010802010a02020c02020e03021004031204031405041706041907051b08051d09061f0a07220b07240c08260d08290e092b10092d110a30120a32140b34150b37160b39180c3c190c3e1b0c411c0c431e0c451f0c48210c4a230c4c240c4f260c51280b53290b552b0b572d0b592f0a5b310a5c320a5e340a5f3609613809623909633b09643d09653e0966400a67420a68440a68450a69470b6a490b6a4a0c6b4c0c6b4d0d6c4f0d6c510e6c520e6d540f6d550f6d57106e59106e5a116e5c126e5d126e5f136e61136e62146e64156e65156e67166e69166e6a176e6c186e6d186e6f196e71196e721a6e741a6e751b6e771c6d781c6d7a1d6d7c1d6d7d1e6d7f1e6c801f6c82206c84206b85216b87216b88226a8a226a8c23698d23698f24699025689225689326679526679727669827669a28659b29649d29649f2a63a02a63a22b62a32c61a52c60a62d60a82e5fa92e5eab2f5ead305dae305cb0315bb1325ab3325ab43359b63458b73557b93556ba3655bc3754bd3853bf3952c03a51c13a50c33b4fc43c4ec63d4dc73e4cc83f4bca404acb4149cc4248ce4347cf4446d04545d24644d34743d44842d54a41d74b3fd84c3ed94d3dda4e3cdb503bdd513ade5238df5337e05536e15635e25734e35933e45a31e55c30e65d2fe75e2ee8602de9612bea632aeb6429eb6628ec6726ed6925ee6a24ef6c23ef6e21f06f20f1711ff1731df2741cf3761bf37819f47918f57b17f57d15f67e14f68013f78212f78410f8850ff8870ef8890cf98b0bf98c0af98e09fa9008fa9207fa9407fb9606fb9706fb9906fb9b06fb9d07fc9f07fca108fca309fca50afca60cfca80dfcaa0ffcac11fcae12fcb014fcb216fcb418fbb61afbb81dfbba1ffbbc21fbbe23fac026fac228fac42afac62df9c72ff9c932f9cb35f8cd37f8cf3af7d13df7d340f6d543f6d746f5d949f5db4cf4dd4ff4df53f4e156f3e35af3e55df2e661f2e865f2ea69f1ec6df1ed71f1ef75f1f179f2f27df2f482f3f586f3f68af4f88ef5f992f6fa96f8fb9af9fc9dfafda1fcffa4"));

var plasma = ramp(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("0d088710078813078916078a19068c1b068d1d068e20068f2206902406912605912805922a05932c05942e05952f059631059733059735049837049938049a3a049a3c049b3e049c3f049c41049d43039e44039e46039f48039f4903a04b03a14c02a14e02a25002a25102a35302a35502a45601a45801a45901a55b01a55c01a65e01a66001a66100a76300a76400a76600a76700a86900a86a00a86c00a86e00a86f00a87100a87201a87401a87501a87701a87801a87a02a87b02a87d03a87e03a88004a88104a78305a78405a78606a68707a68808a68a09a58b0aa58d0ba58e0ca48f0da4910ea3920fa39410a29511a19613a19814a099159f9a169f9c179e9d189d9e199da01a9ca11b9ba21d9aa31e9aa51f99a62098a72197a82296aa2395ab2494ac2694ad2793ae2892b02991b12a90b22b8fb32c8eb42e8db52f8cb6308bb7318ab83289ba3388bb3488bc3587bd3786be3885bf3984c03a83c13b82c23c81c33d80c43e7fc5407ec6417dc7427cc8437bc9447aca457acb4679cc4778cc4977cd4a76ce4b75cf4c74d04d73d14e72d24f71d35171d45270d5536fd5546ed6556dd7566cd8576bd9586ada5a6ada5b69db5c68dc5d67dd5e66de5f65de6164df6263e06363e16462e26561e26660e3685fe4695ee56a5de56b5de66c5ce76e5be76f5ae87059e97158e97257ea7457eb7556eb7655ec7754ed7953ed7a52ee7b51ef7c51ef7e50f07f4ff0804ef1814df1834cf2844bf3854bf3874af48849f48948f58b47f58c46f68d45f68f44f79044f79143f79342f89441f89540f9973ff9983ef99a3efa9b3dfa9c3cfa9e3bfb9f3afba139fba238fca338fca537fca636fca835fca934fdab33fdac33fdae32fdaf31fdb130fdb22ffdb42ffdb52efeb72dfeb82cfeba2cfebb2bfebd2afebe2afec029fdc229fdc328fdc527fdc627fdc827fdca26fdcb26fccd25fcce25fcd025fcd225fbd324fbd524fbd724fad824fada24f9dc24f9dd25f8df25f8e125f7e225f7e425f6e626f6e826f5e926f5eb27f4ed27f3ee27f3f027f2f227f1f426f1f525f0f724f0f921"));


/***/ }),
/* 985 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 986 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
var nextId = 0;

function local() {
  return new Local;
}

function Local() {
  this._ = "@" + (++nextId).toString(36);
}

Local.prototype = local.prototype = {
  constructor: Local,
  get: function(node) {
    var id = this._;
    while (!(id in node)) if (!(node = node.parentNode)) return;
    return node[id];
  },
  set: function(node, value) {
    return node[this._] = value;
  },
  remove: function(node) {
    return this._ in node && delete node[this._];
  },
  toString: function() {
    return this._;
  }
};


/***/ }),
/* 987 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sourceEvent__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__point__ = __webpack_require__(157);



/* harmony default export */ __webpack_exports__["a"] = (function(node) {
  var event = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__sourceEvent__["a" /* default */])();
  if (event.changedTouches) event = event.changedTouches[0];
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__point__["a" /* default */])(node, event);
});


/***/ }),
/* 988 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selection_index__ = __webpack_require__(43);


/* harmony default export */ __webpack_exports__["a"] = (function(selector) {
  return typeof selector === "string"
      ? new __WEBPACK_IMPORTED_MODULE_0__selection_index__["a" /* Selection */]([[document.querySelector(selector)]], [document.documentElement])
      : new __WEBPACK_IMPORTED_MODULE_0__selection_index__["a" /* Selection */]([[selector]], __WEBPACK_IMPORTED_MODULE_0__selection_index__["b" /* root */]);
});


/***/ }),
/* 989 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selection_index__ = __webpack_require__(43);


/* unused harmony default export */ var _unused_webpack_default_export = (function(selector) {
  return typeof selector === "string"
      ? new __WEBPACK_IMPORTED_MODULE_0__selection_index__["a" /* Selection */]([document.querySelectorAll(selector)], [document.documentElement])
      : new __WEBPACK_IMPORTED_MODULE_0__selection_index__["a" /* Selection */]([selector == null ? [] : selector], __WEBPACK_IMPORTED_MODULE_0__selection_index__["b" /* root */]);
});


/***/ }),
/* 990 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__creator__ = __webpack_require__(253);


/* harmony default export */ __webpack_exports__["a"] = (function(name) {
  var create = typeof name === "function" ? name : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__creator__["a" /* default */])(name);
  return this.select(function() {
    return this.appendChild(create.apply(this, arguments));
  });
});


/***/ }),
/* 991 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__namespace__ = __webpack_require__(254);


function attrRemove(name) {
  return function() {
    this.removeAttribute(name);
  };
}

function attrRemoveNS(fullname) {
  return function() {
    this.removeAttributeNS(fullname.space, fullname.local);
  };
}

function attrConstant(name, value) {
  return function() {
    this.setAttribute(name, value);
  };
}

function attrConstantNS(fullname, value) {
  return function() {
    this.setAttributeNS(fullname.space, fullname.local, value);
  };
}

function attrFunction(name, value) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null) this.removeAttribute(name);
    else this.setAttribute(name, v);
  };
}

function attrFunctionNS(fullname, value) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null) this.removeAttributeNS(fullname.space, fullname.local);
    else this.setAttributeNS(fullname.space, fullname.local, v);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(name, value) {
  var fullname = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__namespace__["a" /* default */])(name);

  if (arguments.length < 2) {
    var node = this.node();
    return fullname.local
        ? node.getAttributeNS(fullname.space, fullname.local)
        : node.getAttribute(fullname);
  }

  return this.each((value == null
      ? (fullname.local ? attrRemoveNS : attrRemove) : (typeof value === "function"
      ? (fullname.local ? attrFunctionNS : attrFunction)
      : (fullname.local ? attrConstantNS : attrConstant)))(fullname, value));
});


/***/ }),
/* 992 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  var callback = arguments[0];
  arguments[0] = this;
  callback.apply(null, arguments);
  return this;
});


/***/ }),
/* 993 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function classArray(string) {
  return string.trim().split(/^|\s+/);
}

function classList(node) {
  return node.classList || new ClassList(node);
}

function ClassList(node) {
  this._node = node;
  this._names = classArray(node.getAttribute("class") || "");
}

ClassList.prototype = {
  add: function(name) {
    var i = this._names.indexOf(name);
    if (i < 0) {
      this._names.push(name);
      this._node.setAttribute("class", this._names.join(" "));
    }
  },
  remove: function(name) {
    var i = this._names.indexOf(name);
    if (i >= 0) {
      this._names.splice(i, 1);
      this._node.setAttribute("class", this._names.join(" "));
    }
  },
  contains: function(name) {
    return this._names.indexOf(name) >= 0;
  }
};

function classedAdd(node, names) {
  var list = classList(node), i = -1, n = names.length;
  while (++i < n) list.add(names[i]);
}

function classedRemove(node, names) {
  var list = classList(node), i = -1, n = names.length;
  while (++i < n) list.remove(names[i]);
}

function classedTrue(names) {
  return function() {
    classedAdd(this, names);
  };
}

function classedFalse(names) {
  return function() {
    classedRemove(this, names);
  };
}

function classedFunction(names, value) {
  return function() {
    (value.apply(this, arguments) ? classedAdd : classedRemove)(this, names);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(name, value) {
  var names = classArray(name + "");

  if (arguments.length < 2) {
    var list = classList(this.node()), i = -1, n = names.length;
    while (++i < n) if (!list.contains(names[i])) return false;
    return true;
  }

  return this.each((typeof value === "function"
      ? classedFunction : value
      ? classedTrue
      : classedFalse)(names, value));
});


/***/ }),
/* 994 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__enter__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constant__ = __webpack_require__(985);




var keyPrefix = "$"; // Protect against keys like “__proto__”.

function bindIndex(parent, group, enter, update, exit, data) {
  var i = 0,
      node,
      groupLength = group.length,
      dataLength = data.length;

  // Put any non-null nodes that fit into update.
  // Put any null nodes into enter.
  // Put any remaining data into enter.
  for (; i < dataLength; ++i) {
    if (node = group[i]) {
      node.__data__ = data[i];
      update[i] = node;
    } else {
      enter[i] = new __WEBPACK_IMPORTED_MODULE_1__enter__["b" /* EnterNode */](parent, data[i]);
    }
  }

  // Put any non-null nodes that don’t fit into exit.
  for (; i < groupLength; ++i) {
    if (node = group[i]) {
      exit[i] = node;
    }
  }
}

function bindKey(parent, group, enter, update, exit, data, key) {
  var i,
      node,
      nodeByKeyValue = {},
      groupLength = group.length,
      dataLength = data.length,
      keyValues = new Array(groupLength),
      keyValue;

  // Compute the key for each node.
  // If multiple nodes have the same key, the duplicates are added to exit.
  for (i = 0; i < groupLength; ++i) {
    if (node = group[i]) {
      keyValues[i] = keyValue = keyPrefix + key.call(node, node.__data__, i, group);
      if (keyValue in nodeByKeyValue) {
        exit[i] = node;
      } else {
        nodeByKeyValue[keyValue] = node;
      }
    }
  }

  // Compute the key for each datum.
  // If there a node associated with this key, join and add it to update.
  // If there is not (or the key is a duplicate), add it to enter.
  for (i = 0; i < dataLength; ++i) {
    keyValue = keyPrefix + key.call(parent, data[i], i, data);
    if (node = nodeByKeyValue[keyValue]) {
      update[i] = node;
      node.__data__ = data[i];
      nodeByKeyValue[keyValue] = null;
    } else {
      enter[i] = new __WEBPACK_IMPORTED_MODULE_1__enter__["b" /* EnterNode */](parent, data[i]);
    }
  }

  // Add any remaining nodes that were not bound to data to exit.
  for (i = 0; i < groupLength; ++i) {
    if ((node = group[i]) && (nodeByKeyValue[keyValues[i]] === node)) {
      exit[i] = node;
    }
  }
}

/* harmony default export */ __webpack_exports__["a"] = (function(value, key) {
  if (!value) {
    data = new Array(this.size()), j = -1;
    this.each(function(d) { data[++j] = d; });
    return data;
  }

  var bind = key ? bindKey : bindIndex,
      parents = this._parents,
      groups = this._groups;

  if (typeof value !== "function") value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(value);

  for (var m = groups.length, update = new Array(m), enter = new Array(m), exit = new Array(m), j = 0; j < m; ++j) {
    var parent = parents[j],
        group = groups[j],
        groupLength = group.length,
        data = value.call(parent, parent && parent.__data__, j, parents),
        dataLength = data.length,
        enterGroup = enter[j] = new Array(dataLength),
        updateGroup = update[j] = new Array(dataLength),
        exitGroup = exit[j] = new Array(groupLength);

    bind(parent, group, enterGroup, updateGroup, exitGroup, data, key);

    // Now connect the enter nodes to their following update node, such that
    // appendChild can insert the materialized enter node before this node,
    // rather than at the end of the parent node.
    for (var i0 = 0, i1 = 0, previous, next; i0 < dataLength; ++i0) {
      if (previous = enterGroup[i0]) {
        if (i0 >= i1) i1 = i0 + 1;
        while (!(next = updateGroup[i1]) && ++i1 < dataLength);
        previous._next = next || null;
      }
    }
  }

  update = new __WEBPACK_IMPORTED_MODULE_0__index__["a" /* Selection */](update, parents);
  update._enter = enter;
  update._exit = exit;
  return update;
});


/***/ }),
/* 995 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(value) {
  return arguments.length
      ? this.property("__data__", value)
      : this.node().__data__;
});


/***/ }),
/* 996 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__window__ = __webpack_require__(259);


function dispatchEvent(node, type, params) {
  var window = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__window__["a" /* default */])(node),
      event = window.CustomEvent;

  if (typeof event === "function") {
    event = new event(type, params);
  } else {
    event = window.document.createEvent("Event");
    if (params) event.initEvent(type, params.bubbles, params.cancelable), event.detail = params.detail;
    else event.initEvent(type, false, false);
  }

  node.dispatchEvent(event);
}

function dispatchConstant(type, params) {
  return function() {
    return dispatchEvent(this, type, params);
  };
}

function dispatchFunction(type, params) {
  return function() {
    return dispatchEvent(this, type, params.apply(this, arguments));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(type, params) {
  return this.each((typeof params === "function"
      ? dispatchFunction
      : dispatchConstant)(type, params));
});


/***/ }),
/* 997 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(callback) {

  for (var groups = this._groups, j = 0, m = groups.length; j < m; ++j) {
    for (var group = groups[j], i = 0, n = group.length, node; i < n; ++i) {
      if (node = group[i]) callback.call(node, node.__data__, i, group);
    }
  }

  return this;
});


/***/ }),
/* 998 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  return !this.node();
});


/***/ }),
/* 999 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sparse__ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(43);



/* harmony default export */ __webpack_exports__["a"] = (function() {
  return new __WEBPACK_IMPORTED_MODULE_1__index__["a" /* Selection */](this._exit || this._groups.map(__WEBPACK_IMPORTED_MODULE_0__sparse__["a" /* default */]), this._parents);
});


/***/ }),
/* 1000 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__matcher__ = __webpack_require__(431);



/* harmony default export */ __webpack_exports__["a"] = (function(match) {
  if (typeof match !== "function") match = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__matcher__["a" /* default */])(match);

  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i) {
      if ((node = group[i]) && match.call(node, node.__data__, i, group)) {
        subgroup.push(node);
      }
    }
  }

  return new __WEBPACK_IMPORTED_MODULE_0__index__["a" /* Selection */](subgroups, this._parents);
});


/***/ }),
/* 1001 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function htmlRemove() {
  this.innerHTML = "";
}

function htmlConstant(value) {
  return function() {
    this.innerHTML = value;
  };
}

function htmlFunction(value) {
  return function() {
    var v = value.apply(this, arguments);
    this.innerHTML = v == null ? "" : v;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(value) {
  return arguments.length
      ? this.each(value == null
          ? htmlRemove : (typeof value === "function"
          ? htmlFunction
          : htmlConstant)(value))
      : this.node().innerHTML;
});


/***/ }),
/* 1002 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__creator__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selector__ = __webpack_require__(257);



function constantNull() {
  return null;
}

/* harmony default export */ __webpack_exports__["a"] = (function(name, before) {
  var create = typeof name === "function" ? name : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__creator__["a" /* default */])(name),
      select = before == null ? constantNull : typeof before === "function" ? before : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__selector__["a" /* default */])(before);
  return this.select(function() {
    return this.insertBefore(create.apply(this, arguments), select.apply(this, arguments) || null);
  });
});


/***/ }),
/* 1003 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function lower() {
  if (this.previousSibling) this.parentNode.insertBefore(this, this.parentNode.firstChild);
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return this.each(lower);
});


/***/ }),
/* 1004 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(43);


/* harmony default export */ __webpack_exports__["a"] = (function(selection) {

  for (var groups0 = this._groups, groups1 = selection._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j) {
    for (var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i) {
      if (node = group0[i] || group1[i]) {
        merge[i] = node;
      }
    }
  }

  for (; j < m0; ++j) {
    merges[j] = groups0[j];
  }

  return new __WEBPACK_IMPORTED_MODULE_0__index__["a" /* Selection */](merges, this._parents);
});


/***/ }),
/* 1005 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {

  for (var groups = this._groups, j = 0, m = groups.length; j < m; ++j) {
    for (var group = groups[j], i = 0, n = group.length; i < n; ++i) {
      var node = group[i];
      if (node) return node;
    }
  }

  return null;
});


/***/ }),
/* 1006 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  var nodes = new Array(this.size()), i = -1;
  this.each(function() { nodes[++i] = this; });
  return nodes;
});


/***/ }),
/* 1007 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {

  for (var groups = this._groups, j = -1, m = groups.length; ++j < m;) {
    for (var group = groups[j], i = group.length - 1, next = group[i], node; --i >= 0;) {
      if (node = group[i]) {
        if (next && next !== node.nextSibling) next.parentNode.insertBefore(node, next);
        next = node;
      }
    }
  }

  return this;
});


/***/ }),
/* 1008 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function propertyRemove(name) {
  return function() {
    delete this[name];
  };
}

function propertyConstant(name, value) {
  return function() {
    this[name] = value;
  };
}

function propertyFunction(name, value) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null) delete this[name];
    else this[name] = v;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(name, value) {
  return arguments.length > 1
      ? this.each((value == null
          ? propertyRemove : typeof value === "function"
          ? propertyFunction
          : propertyConstant)(name, value))
      : this.node()[name];
});


/***/ }),
/* 1009 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function raise() {
  if (this.nextSibling) this.parentNode.appendChild(this);
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return this.each(raise);
});


/***/ }),
/* 1010 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function remove() {
  var parent = this.parentNode;
  if (parent) parent.removeChild(this);
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return this.each(remove);
});


/***/ }),
/* 1011 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selector__ = __webpack_require__(257);



/* harmony default export */ __webpack_exports__["a"] = (function(select) {
  if (typeof select !== "function") select = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__selector__["a" /* default */])(select);

  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i) {
      if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
        if ("__data__" in node) subnode.__data__ = node.__data__;
        subgroup[i] = subnode;
      }
    }
  }

  return new __WEBPACK_IMPORTED_MODULE_0__index__["a" /* Selection */](subgroups, this._parents);
});


/***/ }),
/* 1012 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selectorAll__ = __webpack_require__(435);



/* harmony default export */ __webpack_exports__["a"] = (function(select) {
  if (typeof select !== "function") select = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__selectorAll__["a" /* default */])(select);

  for (var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        subgroups.push(select.call(node, node.__data__, i, group));
        parents.push(node);
      }
    }
  }

  return new __WEBPACK_IMPORTED_MODULE_0__index__["a" /* Selection */](subgroups, parents);
});


/***/ }),
/* 1013 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  var size = 0;
  this.each(function() { ++size; });
  return size;
});


/***/ }),
/* 1014 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(43);


/* harmony default export */ __webpack_exports__["a"] = (function(compare) {
  if (!compare) compare = ascending;

  function compareNode(a, b) {
    return a && b ? compare(a.__data__, b.__data__) : !a - !b;
  }

  for (var groups = this._groups, m = groups.length, sortgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, sortgroup = sortgroups[j] = new Array(n), node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        sortgroup[i] = node;
      }
    }
    sortgroup.sort(compareNode);
  }

  return new __WEBPACK_IMPORTED_MODULE_0__index__["a" /* Selection */](sortgroups, this._parents).order();
});

function ascending(a, b) {
  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}


/***/ }),
/* 1015 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function textRemove() {
  this.textContent = "";
}

function textConstant(value) {
  return function() {
    this.textContent = value;
  };
}

function textFunction(value) {
  return function() {
    var v = value.apply(this, arguments);
    this.textContent = v == null ? "" : v;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(value) {
  return arguments.length
      ? this.each(value == null
          ? textRemove : (typeof value === "function"
          ? textFunction
          : textConstant)(value))
      : this.node().textContent;
});


/***/ }),
/* 1016 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sourceEvent__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__point__ = __webpack_require__(157);



/* harmony default export */ __webpack_exports__["a"] = (function(node, touches, identifier) {
  if (arguments.length < 3) identifier = touches, touches = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__sourceEvent__["a" /* default */])().changedTouches;

  for (var i = 0, n = touches ? touches.length : 0, touch; i < n; ++i) {
    if ((touch = touches[i]).identifier === identifier) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__point__["a" /* default */])(node, touch);
    }
  }

  return null;
});


/***/ }),
/* 1017 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sourceEvent__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__point__ = __webpack_require__(157);



/* unused harmony default export */ var _unused_webpack_default_export = (function(node, touches) {
  if (touches == null) touches = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__sourceEvent__["a" /* default */])().touches;

  for (var i = 0, n = touches ? touches.length : 0, points = new Array(n); i < n; ++i) {
    points[i] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__point__["a" /* default */])(node, touches[i]);
  }

  return points;
});


/***/ }),
/* 1018 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_arc__ = __webpack_require__(1019);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_arc__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_area__ = __webpack_require__(436);
/* unused harmony reexport area */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_line__ = __webpack_require__(261);
/* unused harmony reexport line */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_pie__ = __webpack_require__(1040);
/* unused harmony reexport pie */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_areaRadial__ = __webpack_require__(1020);
/* unused harmony reexport areaRadial */
/* unused harmony reexport radialArea */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_lineRadial__ = __webpack_require__(441);
/* unused harmony reexport lineRadial */
/* unused harmony reexport radialLine */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_pointRadial__ = __webpack_require__(442);
/* unused harmony reexport pointRadial */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_link_index__ = __webpack_require__(1032);
/* unused harmony reexport linkHorizontal */
/* unused harmony reexport linkVertical */
/* unused harmony reexport linkRadial */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_symbol__ = __webpack_require__(1042);
/* unused harmony reexport symbol */
/* unused harmony reexport symbols */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_symbol_circle__ = __webpack_require__(443);
/* unused harmony reexport symbolCircle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_symbol_cross__ = __webpack_require__(444);
/* unused harmony reexport symbolCross */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_symbol_diamond__ = __webpack_require__(445);
/* unused harmony reexport symbolDiamond */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_symbol_square__ = __webpack_require__(446);
/* unused harmony reexport symbolSquare */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_symbol_star__ = __webpack_require__(447);
/* unused harmony reexport symbolStar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_symbol_triangle__ = __webpack_require__(448);
/* unused harmony reexport symbolTriangle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__src_symbol_wye__ = __webpack_require__(449);
/* unused harmony reexport symbolWye */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__src_curve_basisClosed__ = __webpack_require__(1021);
/* unused harmony reexport curveBasisClosed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__src_curve_basisOpen__ = __webpack_require__(1022);
/* unused harmony reexport curveBasisOpen */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__src_curve_basis__ = __webpack_require__(158);
/* unused harmony reexport curveBasis */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__src_curve_bundle__ = __webpack_require__(1023);
/* unused harmony reexport curveBundle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__src_curve_cardinalClosed__ = __webpack_require__(438);
/* unused harmony reexport curveCardinalClosed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__src_curve_cardinalOpen__ = __webpack_require__(439);
/* unused harmony reexport curveCardinalOpen */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__src_curve_cardinal__ = __webpack_require__(159);
/* unused harmony reexport curveCardinal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__src_curve_catmullRomClosed__ = __webpack_require__(1024);
/* unused harmony reexport curveCatmullRomClosed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__src_curve_catmullRomOpen__ = __webpack_require__(1025);
/* unused harmony reexport curveCatmullRomOpen */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__src_curve_catmullRom__ = __webpack_require__(260);
/* unused harmony reexport curveCatmullRom */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__src_curve_linearClosed__ = __webpack_require__(1026);
/* unused harmony reexport curveLinearClosed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__src_curve_linear__ = __webpack_require__(160);
/* unused harmony reexport curveLinear */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__src_curve_monotone__ = __webpack_require__(1027);
/* unused harmony reexport curveMonotoneX */
/* unused harmony reexport curveMonotoneY */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__src_curve_natural__ = __webpack_require__(1028);
/* unused harmony reexport curveNatural */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__src_curve_step__ = __webpack_require__(1029);
/* unused harmony reexport curveStep */
/* unused harmony reexport curveStepAfter */
/* unused harmony reexport curveStepBefore */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__src_stack__ = __webpack_require__(1041);
/* unused harmony reexport stack */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__src_offset_expand__ = __webpack_require__(1034);
/* unused harmony reexport stackOffsetExpand */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__src_offset_diverging__ = __webpack_require__(1033);
/* unused harmony reexport stackOffsetDiverging */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__src_offset_none__ = __webpack_require__(122);
/* unused harmony reexport stackOffsetNone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__src_offset_silhouette__ = __webpack_require__(1035);
/* unused harmony reexport stackOffsetSilhouette */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__src_offset_wiggle__ = __webpack_require__(1036);
/* unused harmony reexport stackOffsetWiggle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__src_order_ascending__ = __webpack_require__(262);
/* unused harmony reexport stackOrderAscending */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__src_order_descending__ = __webpack_require__(1037);
/* unused harmony reexport stackOrderDescending */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__src_order_insideOut__ = __webpack_require__(1038);
/* unused harmony reexport stackOrderInsideOut */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__src_order_none__ = __webpack_require__(123);
/* unused harmony reexport stackOrderNone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__src_order_reverse__ = __webpack_require__(1039);
/* unused harmony reexport stackOrderReverse */




 // Note: radialArea is deprecated!
 // Note: radialLine is deprecated!









































/***/ }),
/* 1019 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_path__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constant__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(121);




function arcInnerRadius(d) {
  return d.innerRadius;
}

function arcOuterRadius(d) {
  return d.outerRadius;
}

function arcStartAngle(d) {
  return d.startAngle;
}

function arcEndAngle(d) {
  return d.endAngle;
}

function arcPadAngle(d) {
  return d && d.padAngle; // Note: optional!
}

function intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
  var x10 = x1 - x0, y10 = y1 - y0,
      x32 = x3 - x2, y32 = y3 - y2,
      t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / (y32 * x10 - x32 * y10);
  return [x0 + t * x10, y0 + t * y10];
}

// Compute perpendicular offset line of length rc.
// http://mathworld.wolfram.com/Circle-LineIntersection.html
function cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
  var x01 = x0 - x1,
      y01 = y0 - y1,
      lo = (cw ? rc : -rc) / __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* sqrt */])(x01 * x01 + y01 * y01),
      ox = lo * y01,
      oy = -lo * x01,
      x11 = x0 + ox,
      y11 = y0 + oy,
      x10 = x1 + ox,
      y10 = y1 + oy,
      x00 = (x11 + x10) / 2,
      y00 = (y11 + y10) / 2,
      dx = x10 - x11,
      dy = y10 - y11,
      d2 = dx * dx + dy * dy,
      r = r1 - rc,
      D = x11 * y10 - x10 * y11,
      d = (dy < 0 ? -1 : 1) * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* sqrt */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["e" /* max */])(0, r * r * d2 - D * D)),
      cx0 = (D * dy - dx * d) / d2,
      cy0 = (-D * dx - dy * d) / d2,
      cx1 = (D * dy + dx * d) / d2,
      cy1 = (-D * dx + dy * d) / d2,
      dx0 = cx0 - x00,
      dy0 = cy0 - y00,
      dx1 = cx1 - x00,
      dy1 = cy1 - y00;

  // Pick the closer of the two intersection points.
  // TODO Is there a faster way to determine which intersection to use?
  if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;

  return {
    cx: cx0,
    cy: cy0,
    x01: -ox,
    y01: -oy,
    x11: cx0 * (r1 / r - 1),
    y11: cy0 * (r1 / r - 1)
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  var innerRadius = arcInnerRadius,
      outerRadius = arcOuterRadius,
      cornerRadius = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(0),
      padRadius = null,
      startAngle = arcStartAngle,
      endAngle = arcEndAngle,
      padAngle = arcPadAngle,
      context = null;

  function arc() {
    var buffer,
        r,
        r0 = +innerRadius.apply(this, arguments),
        r1 = +outerRadius.apply(this, arguments),
        a0 = startAngle.apply(this, arguments) - __WEBPACK_IMPORTED_MODULE_2__math__["f" /* halfPi */],
        a1 = endAngle.apply(this, arguments) - __WEBPACK_IMPORTED_MODULE_2__math__["f" /* halfPi */],
        da = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["g" /* abs */])(a1 - a0),
        cw = a1 > a0;

    if (!context) context = buffer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_path__["a" /* path */])();

    // Ensure that the outer radius is always larger than the inner radius.
    if (r1 < r0) r = r1, r1 = r0, r0 = r;

    // Is it a point?
    if (!(r1 > __WEBPACK_IMPORTED_MODULE_2__math__["a" /* epsilon */])) context.moveTo(0, 0);

    // Or is it a circle or annulus?
    else if (da > __WEBPACK_IMPORTED_MODULE_2__math__["c" /* tau */] - __WEBPACK_IMPORTED_MODULE_2__math__["a" /* epsilon */]) {
      context.moveTo(r1 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["h" /* cos */])(a0), r1 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["i" /* sin */])(a0));
      context.arc(0, 0, r1, a0, a1, !cw);
      if (r0 > __WEBPACK_IMPORTED_MODULE_2__math__["a" /* epsilon */]) {
        context.moveTo(r0 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["h" /* cos */])(a1), r0 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["i" /* sin */])(a1));
        context.arc(0, 0, r0, a1, a0, cw);
      }
    }

    // Or is it a circular or annular sector?
    else {
      var a01 = a0,
          a11 = a1,
          a00 = a0,
          a10 = a1,
          da0 = da,
          da1 = da,
          ap = padAngle.apply(this, arguments) / 2,
          rp = (ap > __WEBPACK_IMPORTED_MODULE_2__math__["a" /* epsilon */]) && (padRadius ? +padRadius.apply(this, arguments) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* sqrt */])(r0 * r0 + r1 * r1)),
          rc = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["j" /* min */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["g" /* abs */])(r1 - r0) / 2, +cornerRadius.apply(this, arguments)),
          rc0 = rc,
          rc1 = rc,
          t0,
          t1;

      // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
      if (rp > __WEBPACK_IMPORTED_MODULE_2__math__["a" /* epsilon */]) {
        var p0 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["k" /* asin */])(rp / r0 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["i" /* sin */])(ap)),
            p1 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["k" /* asin */])(rp / r1 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["i" /* sin */])(ap));
        if ((da0 -= p0 * 2) > __WEBPACK_IMPORTED_MODULE_2__math__["a" /* epsilon */]) p0 *= (cw ? 1 : -1), a00 += p0, a10 -= p0;
        else da0 = 0, a00 = a10 = (a0 + a1) / 2;
        if ((da1 -= p1 * 2) > __WEBPACK_IMPORTED_MODULE_2__math__["a" /* epsilon */]) p1 *= (cw ? 1 : -1), a01 += p1, a11 -= p1;
        else da1 = 0, a01 = a11 = (a0 + a1) / 2;
      }

      var x01 = r1 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["h" /* cos */])(a01),
          y01 = r1 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["i" /* sin */])(a01),
          x10 = r0 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["h" /* cos */])(a10),
          y10 = r0 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["i" /* sin */])(a10);

      // Apply rounded corners?
      if (rc > __WEBPACK_IMPORTED_MODULE_2__math__["a" /* epsilon */]) {
        var x11 = r1 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["h" /* cos */])(a11),
            y11 = r1 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["i" /* sin */])(a11),
            x00 = r0 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["h" /* cos */])(a00),
            y00 = r0 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["i" /* sin */])(a00);

        // Restrict the corner radius according to the sector angle.
        if (da < __WEBPACK_IMPORTED_MODULE_2__math__["b" /* pi */]) {
          var oc = da0 > __WEBPACK_IMPORTED_MODULE_2__math__["a" /* epsilon */] ? intersect(x01, y01, x00, y00, x11, y11, x10, y10) : [x10, y10],
              ax = x01 - oc[0],
              ay = y01 - oc[1],
              bx = x11 - oc[0],
              by = y11 - oc[1],
              kc = 1 / __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["i" /* sin */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["l" /* acos */])((ax * bx + ay * by) / (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* sqrt */])(ax * ax + ay * ay) * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* sqrt */])(bx * bx + by * by))) / 2),
              lc = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* sqrt */])(oc[0] * oc[0] + oc[1] * oc[1]);
          rc0 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["j" /* min */])(rc, (r0 - lc) / (kc - 1));
          rc1 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["j" /* min */])(rc, (r1 - lc) / (kc + 1));
        }
      }

      // Is the sector collapsed to a line?
      if (!(da1 > __WEBPACK_IMPORTED_MODULE_2__math__["a" /* epsilon */])) context.moveTo(x01, y01);

      // Does the sector’s outer ring have rounded corners?
      else if (rc1 > __WEBPACK_IMPORTED_MODULE_2__math__["a" /* epsilon */]) {
        t0 = cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
        t1 = cornerTangents(x11, y11, x10, y10, r1, rc1, cw);

        context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01);

        // Have the corners merged?
        if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["m" /* atan2 */])(t0.y01, t0.x01), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["m" /* atan2 */])(t1.y01, t1.x01), !cw);

        // Otherwise, draw the two corners and the ring.
        else {
          context.arc(t0.cx, t0.cy, rc1, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["m" /* atan2 */])(t0.y01, t0.x01), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["m" /* atan2 */])(t0.y11, t0.x11), !cw);
          context.arc(0, 0, r1, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["m" /* atan2 */])(t0.cy + t0.y11, t0.cx + t0.x11), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["m" /* atan2 */])(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
          context.arc(t1.cx, t1.cy, rc1, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["m" /* atan2 */])(t1.y11, t1.x11), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["m" /* atan2 */])(t1.y01, t1.x01), !cw);
        }
      }

      // Or is the outer ring just a circular arc?
      else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw);

      // Is there no inner ring, and it’s a circular sector?
      // Or perhaps it’s an annular sector collapsed due to padding?
      if (!(r0 > __WEBPACK_IMPORTED_MODULE_2__math__["a" /* epsilon */]) || !(da0 > __WEBPACK_IMPORTED_MODULE_2__math__["a" /* epsilon */])) context.lineTo(x10, y10);

      // Does the sector’s inner ring (or point) have rounded corners?
      else if (rc0 > __WEBPACK_IMPORTED_MODULE_2__math__["a" /* epsilon */]) {
        t0 = cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
        t1 = cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);

        context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01);

        // Have the corners merged?
        if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["m" /* atan2 */])(t0.y01, t0.x01), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["m" /* atan2 */])(t1.y01, t1.x01), !cw);

        // Otherwise, draw the two corners and the ring.
        else {
          context.arc(t0.cx, t0.cy, rc0, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["m" /* atan2 */])(t0.y01, t0.x01), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["m" /* atan2 */])(t0.y11, t0.x11), !cw);
          context.arc(0, 0, r0, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["m" /* atan2 */])(t0.cy + t0.y11, t0.cx + t0.x11), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["m" /* atan2 */])(t1.cy + t1.y11, t1.cx + t1.x11), cw);
          context.arc(t1.cx, t1.cy, rc0, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["m" /* atan2 */])(t1.y11, t1.x11), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["m" /* atan2 */])(t1.y01, t1.x01), !cw);
        }
      }

      // Or is the inner ring just a circular arc?
      else context.arc(0, 0, r0, a10, a00, cw);
    }

    context.closePath();

    if (buffer) return context = null, buffer + "" || null;
  }

  arc.centroid = function() {
    var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2,
        a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - __WEBPACK_IMPORTED_MODULE_2__math__["b" /* pi */] / 2;
    return [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["h" /* cos */])(a) * r, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["i" /* sin */])(a) * r];
  };

  arc.innerRadius = function(_) {
    return arguments.length ? (innerRadius = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : innerRadius;
  };

  arc.outerRadius = function(_) {
    return arguments.length ? (outerRadius = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : outerRadius;
  };

  arc.cornerRadius = function(_) {
    return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : cornerRadius;
  };

  arc.padRadius = function(_) {
    return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : padRadius;
  };

  arc.startAngle = function(_) {
    return arguments.length ? (startAngle = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : startAngle;
  };

  arc.endAngle = function(_) {
    return arguments.length ? (endAngle = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : endAngle;
  };

  arc.padAngle = function(_) {
    return arguments.length ? (padAngle = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : padAngle;
  };

  arc.context = function(_) {
    return arguments.length ? ((context = _ == null ? null : _), arc) : context;
  };

  return arc;
});


/***/ }),
/* 1020 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__curve_radial__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__area__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lineRadial__ = __webpack_require__(441);




/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var a = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__area__["a" /* default */])().curve(__WEBPACK_IMPORTED_MODULE_0__curve_radial__["b" /* curveRadialLinear */]),
      c = a.curve,
      x0 = a.lineX0,
      x1 = a.lineX1,
      y0 = a.lineY0,
      y1 = a.lineY1;

  a.angle = a.x, delete a.x;
  a.startAngle = a.x0, delete a.x0;
  a.endAngle = a.x1, delete a.x1;
  a.radius = a.y, delete a.y;
  a.innerRadius = a.y0, delete a.y0;
  a.outerRadius = a.y1, delete a.y1;
  a.lineStartAngle = function() { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lineRadial__["a" /* lineRadial */])(x0()); }, delete a.lineX0;
  a.lineEndAngle = function() { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lineRadial__["a" /* lineRadial */])(x1()); }, delete a.lineX1;
  a.lineInnerRadius = function() { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lineRadial__["a" /* lineRadial */])(y0()); }, delete a.lineY0;
  a.lineOuterRadius = function() { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lineRadial__["a" /* lineRadial */])(y1()); }, delete a.lineY1;

  a.curve = function(_) {
    return arguments.length ? c(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__curve_radial__["a" /* default */])(_)) : c()._curve;
  };

  return a;
});


/***/ }),
/* 1021 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__noop__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__basis__ = __webpack_require__(158);



function BasisClosed(context) {
  this._context = context;
}

BasisClosed.prototype = {
  areaStart: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  areaEnd: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 =
    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x2, this._y2);
        this._context.closePath();
        break;
      }
      case 2: {
        this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
        this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
        this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x2, this._y2);
        this.point(this._x3, this._y3);
        this.point(this._x4, this._y4);
        break;
      }
    }
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._x2 = x, this._y2 = y; break;
      case 1: this._point = 2; this._x3 = x, this._y3 = y; break;
      case 2: this._point = 3; this._x4 = x, this._y4 = y; this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6); break;
      default: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__basis__["b" /* point */])(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
  }
};

/* unused harmony default export */ var _unused_webpack_default_export = (function(context) {
  return new BasisClosed(context);
});


/***/ }),
/* 1022 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__basis__ = __webpack_require__(158);


function BasisOpen(context) {
  this._context = context;
}

BasisOpen.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 =
    this._y0 = this._y1 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6; this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0); break;
      case 3: this._point = 4; // proceed
      default: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__basis__["b" /* point */])(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
  }
};

/* unused harmony default export */ var _unused_webpack_default_export = (function(context) {
  return new BasisOpen(context);
});


/***/ }),
/* 1023 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__basis__ = __webpack_require__(158);


function Bundle(context, beta) {
  this._basis = new __WEBPACK_IMPORTED_MODULE_0__basis__["a" /* Basis */](context);
  this._beta = beta;
}

Bundle.prototype = {
  lineStart: function() {
    this._x = [];
    this._y = [];
    this._basis.lineStart();
  },
  lineEnd: function() {
    var x = this._x,
        y = this._y,
        j = x.length - 1;

    if (j > 0) {
      var x0 = x[0],
          y0 = y[0],
          dx = x[j] - x0,
          dy = y[j] - y0,
          i = -1,
          t;

      while (++i <= j) {
        t = i / j;
        this._basis.point(
          this._beta * x[i] + (1 - this._beta) * (x0 + t * dx),
          this._beta * y[i] + (1 - this._beta) * (y0 + t * dy)
        );
      }
    }

    this._x = this._y = null;
    this._basis.lineEnd();
  },
  point: function(x, y) {
    this._x.push(+x);
    this._y.push(+y);
  }
};

/* unused harmony default export */ var _unused_webpack_default_export = ((function custom(beta) {

  function bundle(context) {
    return beta === 1 ? new __WEBPACK_IMPORTED_MODULE_0__basis__["a" /* Basis */](context) : new Bundle(context, beta);
  }

  bundle.beta = function(beta) {
    return custom(+beta);
  };

  return bundle;
})(0.85));


/***/ }),
/* 1024 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cardinalClosed__ = __webpack_require__(438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__noop__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__catmullRom__ = __webpack_require__(260);




function CatmullRomClosed(context, alpha) {
  this._context = context;
  this._alpha = alpha;
}

CatmullRomClosed.prototype = {
  areaStart: __WEBPACK_IMPORTED_MODULE_1__noop__["a" /* default */],
  areaEnd: __WEBPACK_IMPORTED_MODULE_1__noop__["a" /* default */],
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 =
    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
    this._l01_a = this._l12_a = this._l23_a =
    this._l01_2a = this._l12_2a = this._l23_2a =
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 2: {
        this._context.lineTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x3, this._y3);
        this.point(this._x4, this._y4);
        this.point(this._x5, this._y5);
        break;
      }
    }
  },
  point: function(x, y) {
    x = +x, y = +y;

    if (this._point) {
      var x23 = this._x2 - x,
          y23 = this._y2 - y;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
    }

    switch (this._point) {
      case 0: this._point = 1; this._x3 = x, this._y3 = y; break;
      case 1: this._point = 2; this._context.moveTo(this._x4 = x, this._y4 = y); break;
      case 2: this._point = 3; this._x5 = x, this._y5 = y; break;
      default: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__catmullRom__["a" /* point */])(this, x, y); break;
    }

    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* unused harmony default export */ var _unused_webpack_default_export = ((function custom(alpha) {

  function catmullRom(context) {
    return alpha ? new CatmullRomClosed(context, alpha) : new __WEBPACK_IMPORTED_MODULE_0__cardinalClosed__["a" /* CardinalClosed */](context, 0);
  }

  catmullRom.alpha = function(alpha) {
    return custom(+alpha);
  };

  return catmullRom;
})(0.5));


/***/ }),
/* 1025 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cardinalOpen__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__catmullRom__ = __webpack_require__(260);



function CatmullRomOpen(context, alpha) {
  this._context = context;
  this._alpha = alpha;
}

CatmullRomOpen.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 =
    this._y0 = this._y1 = this._y2 = NaN;
    this._l01_a = this._l12_a = this._l23_a =
    this._l01_2a = this._l12_2a = this._l23_2a =
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;

    if (this._point) {
      var x23 = this._x2 - x,
          y23 = this._y2 - y;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
    }

    switch (this._point) {
      case 0: this._point = 1; break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2); break;
      case 3: this._point = 4; // proceed
      default: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__catmullRom__["a" /* point */])(this, x, y); break;
    }

    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* unused harmony default export */ var _unused_webpack_default_export = ((function custom(alpha) {

  function catmullRom(context) {
    return alpha ? new CatmullRomOpen(context, alpha) : new __WEBPACK_IMPORTED_MODULE_0__cardinalOpen__["a" /* CardinalOpen */](context, 0);
  }

  catmullRom.alpha = function(alpha) {
    return custom(+alpha);
  };

  return catmullRom;
})(0.5));


/***/ }),
/* 1026 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__noop__ = __webpack_require__(161);


function LinearClosed(context) {
  this._context = context;
}

LinearClosed.prototype = {
  areaStart: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  areaEnd: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._point) this._context.closePath();
  },
  point: function(x, y) {
    x = +x, y = +y;
    if (this._point) this._context.lineTo(x, y);
    else this._point = 1, this._context.moveTo(x, y);
  }
};

/* unused harmony default export */ var _unused_webpack_default_export = (function(context) {
  return new LinearClosed(context);
});


/***/ }),
/* 1027 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export monotoneX */
/* unused harmony export monotoneY */
function sign(x) {
  return x < 0 ? -1 : 1;
}

// Calculate the slopes of the tangents (Hermite-type interpolation) based on
// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
// NOV(II), P. 443, 1990.
function slope3(that, x2, y2) {
  var h0 = that._x1 - that._x0,
      h1 = x2 - that._x1,
      s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0),
      s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0),
      p = (s0 * h1 + s1 * h0) / (h0 + h1);
  return (sign(s0) + sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
}

// Calculate a one-sided slope.
function slope2(that, t) {
  var h = that._x1 - that._x0;
  return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
}

// According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
function point(that, t0, t1) {
  var x0 = that._x0,
      y0 = that._y0,
      x1 = that._x1,
      y1 = that._y1,
      dx = (x1 - x0) / 3;
  that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
}

function MonotoneX(context) {
  this._context = context;
}

MonotoneX.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 =
    this._y0 = this._y1 =
    this._t0 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2: this._context.lineTo(this._x1, this._y1); break;
      case 3: point(this, this._t0, slope2(this, this._t0)); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    var t1 = NaN;

    x = +x, y = +y;
    if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; point(this, slope2(this, t1 = slope3(this, x, y)), t1); break;
      default: point(this, this._t0, t1 = slope3(this, x, y)); break;
    }

    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
    this._t0 = t1;
  }
}

function MonotoneY(context) {
  this._context = new ReflectContext(context);
}

(MonotoneY.prototype = Object.create(MonotoneX.prototype)).point = function(x, y) {
  MonotoneX.prototype.point.call(this, y, x);
};

function ReflectContext(context) {
  this._context = context;
}

ReflectContext.prototype = {
  moveTo: function(x, y) { this._context.moveTo(y, x); },
  closePath: function() { this._context.closePath(); },
  lineTo: function(x, y) { this._context.lineTo(y, x); },
  bezierCurveTo: function(x1, y1, x2, y2, x, y) { this._context.bezierCurveTo(y1, x1, y2, x2, y, x); }
};

function monotoneX(context) {
  return new MonotoneX(context);
}

function monotoneY(context) {
  return new MonotoneY(context);
}


/***/ }),
/* 1028 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function Natural(context) {
  this._context = context;
}

Natural.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = [];
    this._y = [];
  },
  lineEnd: function() {
    var x = this._x,
        y = this._y,
        n = x.length;

    if (n) {
      this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
      if (n === 2) {
        this._context.lineTo(x[1], y[1]);
      } else {
        var px = controlPoints(x),
            py = controlPoints(y);
        for (var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1) {
          this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
        }
      }
    }

    if (this._line || (this._line !== 0 && n === 1)) this._context.closePath();
    this._line = 1 - this._line;
    this._x = this._y = null;
  },
  point: function(x, y) {
    this._x.push(+x);
    this._y.push(+y);
  }
};

// See https://www.particleincell.com/2012/bezier-splines/ for derivation.
function controlPoints(x) {
  var i,
      n = x.length - 1,
      m,
      a = new Array(n),
      b = new Array(n),
      r = new Array(n);
  a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
  for (i = 1; i < n - 1; ++i) a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
  a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
  for (i = 1; i < n; ++i) m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
  a[n - 1] = r[n - 1] / b[n - 1];
  for (i = n - 2; i >= 0; --i) a[i] = (r[i] - a[i + 1]) / b[i];
  b[n - 1] = (x[n] + a[n - 1]) / 2;
  for (i = 0; i < n - 1; ++i) b[i] = 2 * x[i + 1] - a[i + 1];
  return [a, b];
}

/* unused harmony default export */ var _unused_webpack_default_export = (function(context) {
  return new Natural(context);
});


/***/ }),
/* 1029 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export stepBefore */
/* unused harmony export stepAfter */
function Step(context, t) {
  this._context = context;
  this._t = t;
}

Step.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = this._y = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; // proceed
      default: {
        if (this._t <= 0) {
          this._context.lineTo(this._x, y);
          this._context.lineTo(x, y);
        } else {
          var x1 = this._x * (1 - this._t) + x * this._t;
          this._context.lineTo(x1, this._y);
          this._context.lineTo(x1, y);
        }
        break;
      }
    }
    this._x = x, this._y = y;
  }
};

/* unused harmony default export */ var _unused_webpack_default_export = (function(context) {
  return new Step(context, 0.5);
});

function stepBefore(context) {
  return new Step(context, 0);
}

function stepAfter(context) {
  return new Step(context, 1);
}


/***/ }),
/* 1030 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
});


/***/ }),
/* 1031 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(d) {
  return d;
});


/***/ }),
/* 1032 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export linkHorizontal */
/* unused harmony export linkVertical */
/* unused harmony export linkRadial */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_path__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constant__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__point__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pointRadial__ = __webpack_require__(442);






function linkSource(d) {
  return d.source;
}

function linkTarget(d) {
  return d.target;
}

function link(curve) {
  var source = linkSource,
      target = linkTarget,
      x = __WEBPACK_IMPORTED_MODULE_3__point__["a" /* x */],
      y = __WEBPACK_IMPORTED_MODULE_3__point__["b" /* y */],
      context = null;

  function link() {
    var buffer, argv = __WEBPACK_IMPORTED_MODULE_1__array__["a" /* slice */].call(arguments), s = source.apply(this, argv), t = target.apply(this, argv);
    if (!context) context = buffer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_path__["a" /* path */])();
    curve(context, +x.apply(this, (argv[0] = s, argv)), +y.apply(this, argv), +x.apply(this, (argv[0] = t, argv)), +y.apply(this, argv));
    if (buffer) return context = null, buffer + "" || null;
  }

  link.source = function(_) {
    return arguments.length ? (source = _, link) : source;
  };

  link.target = function(_) {
    return arguments.length ? (target = _, link) : target;
  };

  link.x = function(_) {
    return arguments.length ? (x = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(+_), link) : x;
  };

  link.y = function(_) {
    return arguments.length ? (y = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(+_), link) : y;
  };

  link.context = function(_) {
    return arguments.length ? ((context = _ == null ? null : _), link) : context;
  };

  return link;
}

function curveHorizontal(context, x0, y0, x1, y1) {
  context.moveTo(x0, y0);
  context.bezierCurveTo(x0 = (x0 + x1) / 2, y0, x0, y1, x1, y1);
}

function curveVertical(context, x0, y0, x1, y1) {
  context.moveTo(x0, y0);
  context.bezierCurveTo(x0, y0 = (y0 + y1) / 2, x1, y0, x1, y1);
}

function curveRadial(context, x0, y0, x1, y1) {
  var p0 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__pointRadial__["a" /* default */])(x0, y0),
      p1 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__pointRadial__["a" /* default */])(x0, y0 = (y0 + y1) / 2),
      p2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__pointRadial__["a" /* default */])(x1, y0),
      p3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__pointRadial__["a" /* default */])(x1, y1);
  context.moveTo(p0[0], p0[1]);
  context.bezierCurveTo(p1[0], p1[1], p2[0], p2[1], p3[0], p3[1]);
}

function linkHorizontal() {
  return link(curveHorizontal);
}

function linkVertical() {
  return link(curveVertical);
}

function linkRadial() {
  var l = link(curveRadial);
  l.angle = l.x, delete l.x;
  l.radius = l.y, delete l.y;
  return l;
}


/***/ }),
/* 1033 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(series, order) {
  if (!((n = series.length) > 1)) return;
  for (var i, j = 0, d, dy, yp, yn, n, m = series[order[0]].length; j < m; ++j) {
    for (yp = yn = 0, i = 0; i < n; ++i) {
      if ((dy = (d = series[order[i]][j])[1] - d[0]) >= 0) {
        d[0] = yp, d[1] = yp += dy;
      } else if (dy < 0) {
        d[1] = yn, d[0] = yn += dy;
      } else {
        d[0] = yp;
      }
    }
  }
});


/***/ }),
/* 1034 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__none__ = __webpack_require__(122);


/* unused harmony default export */ var _unused_webpack_default_export = (function(series, order) {
  if (!((n = series.length) > 0)) return;
  for (var i, n, j = 0, m = series[0].length, y; j < m; ++j) {
    for (y = i = 0; i < n; ++i) y += series[i][j][1] || 0;
    if (y) for (i = 0; i < n; ++i) series[i][j][1] /= y;
  }
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__none__["a" /* default */])(series, order);
});


/***/ }),
/* 1035 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__none__ = __webpack_require__(122);


/* unused harmony default export */ var _unused_webpack_default_export = (function(series, order) {
  if (!((n = series.length) > 0)) return;
  for (var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j) {
    for (var i = 0, y = 0; i < n; ++i) y += series[i][j][1] || 0;
    s0[j][1] += s0[j][0] = -y / 2;
  }
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__none__["a" /* default */])(series, order);
});


/***/ }),
/* 1036 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__none__ = __webpack_require__(122);


/* unused harmony default export */ var _unused_webpack_default_export = (function(series, order) {
  if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
  for (var y = 0, j = 1, s0, m, n; j < m; ++j) {
    for (var i = 0, s1 = 0, s2 = 0; i < n; ++i) {
      var si = series[order[i]],
          sij0 = si[j][1] || 0,
          sij1 = si[j - 1][1] || 0,
          s3 = (sij0 - sij1) / 2;
      for (var k = 0; k < i; ++k) {
        var sk = series[order[k]],
            skj0 = sk[j][1] || 0,
            skj1 = sk[j - 1][1] || 0;
        s3 += skj0 - skj1;
      }
      s1 += sij0, s2 += s3 * sij0;
    }
    s0[j - 1][1] += s0[j - 1][0] = y;
    if (s1) y -= s2 / s1;
  }
  s0[j - 1][1] += s0[j - 1][0] = y;
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__none__["a" /* default */])(series, order);
});


/***/ }),
/* 1037 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ascending__ = __webpack_require__(262);


/* unused harmony default export */ var _unused_webpack_default_export = (function(series) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__ascending__["b" /* default */])(series).reverse();
});


/***/ }),
/* 1038 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__none__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ascending__ = __webpack_require__(262);



/* unused harmony default export */ var _unused_webpack_default_export = (function(series) {
  var n = series.length,
      i,
      j,
      sums = series.map(__WEBPACK_IMPORTED_MODULE_1__ascending__["a" /* sum */]),
      order = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__none__["a" /* default */])(series).sort(function(a, b) { return sums[b] - sums[a]; }),
      top = 0,
      bottom = 0,
      tops = [],
      bottoms = [];

  for (i = 0; i < n; ++i) {
    j = order[i];
    if (top < bottom) {
      top += sums[j];
      tops.push(j);
    } else {
      bottom += sums[j];
      bottoms.push(j);
    }
  }

  return bottoms.reverse().concat(tops);
});


/***/ }),
/* 1039 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__none__ = __webpack_require__(123);


/* unused harmony default export */ var _unused_webpack_default_export = (function(series) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__none__["a" /* default */])(series).reverse();
});


/***/ }),
/* 1040 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__descending__ = __webpack_require__(1030);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__identity__ = __webpack_require__(1031);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__math__ = __webpack_require__(121);





/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var value = __WEBPACK_IMPORTED_MODULE_2__identity__["a" /* default */],
      sortValues = __WEBPACK_IMPORTED_MODULE_1__descending__["a" /* default */],
      sort = null,
      startAngle = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(0),
      endAngle = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_3__math__["c" /* tau */]),
      padAngle = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(0);

  function pie(data) {
    var i,
        n = data.length,
        j,
        k,
        sum = 0,
        index = new Array(n),
        arcs = new Array(n),
        a0 = +startAngle.apply(this, arguments),
        da = Math.min(__WEBPACK_IMPORTED_MODULE_3__math__["c" /* tau */], Math.max(-__WEBPACK_IMPORTED_MODULE_3__math__["c" /* tau */], endAngle.apply(this, arguments) - a0)),
        a1,
        p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)),
        pa = p * (da < 0 ? -1 : 1),
        v;

    for (i = 0; i < n; ++i) {
      if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) {
        sum += v;
      }
    }

    // Optionally sort the arcs by previously-computed values or by data.
    if (sortValues != null) index.sort(function(i, j) { return sortValues(arcs[i], arcs[j]); });
    else if (sort != null) index.sort(function(i, j) { return sort(data[i], data[j]); });

    // Compute the arcs! They are stored in the original data's order.
    for (i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1) {
      j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
        data: data[j],
        index: i,
        value: v,
        startAngle: a0,
        endAngle: a1,
        padAngle: p
      };
    }

    return arcs;
  }

  pie.value = function(_) {
    return arguments.length ? (value = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), pie) : value;
  };

  pie.sortValues = function(_) {
    return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
  };

  pie.sort = function(_) {
    return arguments.length ? (sort = _, sortValues = null, pie) : sort;
  };

  pie.startAngle = function(_) {
    return arguments.length ? (startAngle = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), pie) : startAngle;
  };

  pie.endAngle = function(_) {
    return arguments.length ? (endAngle = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), pie) : endAngle;
  };

  pie.padAngle = function(_) {
    return arguments.length ? (padAngle = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), pie) : padAngle;
  };

  return pie;
});


/***/ }),
/* 1041 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constant__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__offset_none__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__order_none__ = __webpack_require__(123);





function stackValue(d, key) {
  return d[key];
}

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var keys = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])([]),
      order = __WEBPACK_IMPORTED_MODULE_3__order_none__["a" /* default */],
      offset = __WEBPACK_IMPORTED_MODULE_2__offset_none__["a" /* default */],
      value = stackValue;

  function stack(data) {
    var kz = keys.apply(this, arguments),
        i,
        m = data.length,
        n = kz.length,
        sz = new Array(n),
        oz;

    for (i = 0; i < n; ++i) {
      for (var ki = kz[i], si = sz[i] = new Array(m), j = 0, sij; j < m; ++j) {
        si[j] = sij = [0, +value(data[j], ki, j, data)];
        sij.data = data[j];
      }
      si.key = ki;
    }

    for (i = 0, oz = order(sz); i < n; ++i) {
      sz[oz[i]].index = i;
    }

    offset(sz, oz);
    return sz;
  }

  stack.keys = function(_) {
    return arguments.length ? (keys = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__array__["a" /* slice */].call(_)), stack) : keys;
  };

  stack.value = function(_) {
    return arguments.length ? (value = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), stack) : value;
  };

  stack.order = function(_) {
    return arguments.length ? (order = _ == null ? __WEBPACK_IMPORTED_MODULE_3__order_none__["a" /* default */] : typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__array__["a" /* slice */].call(_)), stack) : order;
  };

  stack.offset = function(_) {
    return arguments.length ? (offset = _ == null ? __WEBPACK_IMPORTED_MODULE_2__offset_none__["a" /* default */] : _, stack) : offset;
  };

  return stack;
});


/***/ }),
/* 1042 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export symbols */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_path__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__symbol_circle__ = __webpack_require__(443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__symbol_cross__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__symbol_diamond__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__symbol_star__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__symbol_square__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__symbol_triangle__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__symbol_wye__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constant__ = __webpack_require__(91);










var symbols = [
  __WEBPACK_IMPORTED_MODULE_1__symbol_circle__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_2__symbol_cross__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_3__symbol_diamond__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_5__symbol_square__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_4__symbol_star__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_6__symbol_triangle__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_7__symbol_wye__["a" /* default */]
];

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var type = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__constant__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__symbol_circle__["a" /* default */]),
      size = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__constant__["a" /* default */])(64),
      context = null;

  function symbol() {
    var buffer;
    if (!context) context = buffer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_path__["a" /* path */])();
    type.apply(this, arguments).draw(context, +size.apply(this, arguments));
    if (buffer) return context = null, buffer + "" || null;
  }

  symbol.type = function(_) {
    return arguments.length ? (type = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__constant__["a" /* default */])(_), symbol) : type;
  };

  symbol.size = function(_) {
    return arguments.length ? (size = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__constant__["a" /* default */])(+_), symbol) : size;
  };

  symbol.context = function(_) {
    return arguments.length ? (context = _ == null ? null : _, symbol) : context;
  };

  return symbol;
});


/***/ }),
/* 1043 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isoFormat__ = __webpack_require__(450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__defaultLocale__ = __webpack_require__(265);



function parseIsoNative(string) {
  var date = new Date(string);
  return isNaN(date) ? null : date;
}

var parseIso = +new Date("2000-01-01T00:00:00.000Z")
    ? parseIsoNative
    : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__defaultLocale__["a" /* utcParse */])(__WEBPACK_IMPORTED_MODULE_0__isoFormat__["a" /* isoSpecifier */]);

/* unused harmony default export */ var _unused_webpack_default_export = (parseIso);


/***/ }),
/* 1044 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export days */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(60);



var day = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setHours(0, 0, 0, 0);
}, function(date, step) {
  date.setDate(date.getDate() + step);
}, function(start, end) {
  return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * __WEBPACK_IMPORTED_MODULE_1__duration__["d" /* durationMinute */]) / __WEBPACK_IMPORTED_MODULE_1__duration__["b" /* durationDay */];
}, function(date) {
  return date.getDate() - 1;
});

/* harmony default export */ __webpack_exports__["a"] = (day);
var days = day.range;


/***/ }),
/* 1045 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export hours */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(60);



var hour = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  var offset = date.getTimezoneOffset() * __WEBPACK_IMPORTED_MODULE_1__duration__["d" /* durationMinute */] % __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationHour */];
  if (offset < 0) offset += __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationHour */];
  date.setTime(Math.floor((+date - offset) / __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationHour */]) * __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationHour */] + offset);
}, function(date, step) {
  date.setTime(+date + step * __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationHour */]);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationHour */];
}, function(date) {
  return date.getHours();
});

/* harmony default export */ __webpack_exports__["a"] = (hour);
var hours = hour.range;


/***/ }),
/* 1046 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export milliseconds */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(27);


var millisecond = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function() {
  // noop
}, function(date, step) {
  date.setTime(+date + step);
}, function(start, end) {
  return end - start;
});

// An optimized implementation for this simple case.
millisecond.every = function(k) {
  k = Math.floor(k);
  if (!isFinite(k) || !(k > 0)) return null;
  if (!(k > 1)) return millisecond;
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
    date.setTime(Math.floor(date / k) * k);
  }, function(date, step) {
    date.setTime(+date + step * k);
  }, function(start, end) {
    return (end - start) / k;
  });
};

/* harmony default export */ __webpack_exports__["a"] = (millisecond);
var milliseconds = millisecond.range;


/***/ }),
/* 1047 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export minutes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(60);



var minute = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setTime(Math.floor(date / __WEBPACK_IMPORTED_MODULE_1__duration__["d" /* durationMinute */]) * __WEBPACK_IMPORTED_MODULE_1__duration__["d" /* durationMinute */]);
}, function(date, step) {
  date.setTime(+date + step * __WEBPACK_IMPORTED_MODULE_1__duration__["d" /* durationMinute */]);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["d" /* durationMinute */];
}, function(date) {
  return date.getMinutes();
});

/* harmony default export */ __webpack_exports__["a"] = (minute);
var minutes = minute.range;


/***/ }),
/* 1048 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export months */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(27);


var month = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setDate(1);
  date.setHours(0, 0, 0, 0);
}, function(date, step) {
  date.setMonth(date.getMonth() + step);
}, function(start, end) {
  return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, function(date) {
  return date.getMonth();
});

/* harmony default export */ __webpack_exports__["a"] = (month);
var months = month.range;


/***/ }),
/* 1049 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export seconds */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(60);



var second = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setTime(Math.floor(date / __WEBPACK_IMPORTED_MODULE_1__duration__["e" /* durationSecond */]) * __WEBPACK_IMPORTED_MODULE_1__duration__["e" /* durationSecond */]);
}, function(date, step) {
  date.setTime(+date + step * __WEBPACK_IMPORTED_MODULE_1__duration__["e" /* durationSecond */]);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["e" /* durationSecond */];
}, function(date) {
  return date.getUTCSeconds();
});

/* harmony default export */ __webpack_exports__["a"] = (second);
var seconds = second.range;


/***/ }),
/* 1050 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export utcDays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(60);



var utcDay = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
  date.setUTCDate(date.getUTCDate() + step);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["b" /* durationDay */];
}, function(date) {
  return date.getUTCDate() - 1;
});

/* harmony default export */ __webpack_exports__["a"] = (utcDay);
var utcDays = utcDay.range;


/***/ }),
/* 1051 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export utcHours */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(60);



var utcHour = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setUTCMinutes(0, 0, 0);
}, function(date, step) {
  date.setTime(+date + step * __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationHour */]);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationHour */];
}, function(date) {
  return date.getUTCHours();
});

/* harmony default export */ __webpack_exports__["a"] = (utcHour);
var utcHours = utcHour.range;


/***/ }),
/* 1052 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export utcMinutes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(60);



var utcMinute = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setUTCSeconds(0, 0);
}, function(date, step) {
  date.setTime(+date + step * __WEBPACK_IMPORTED_MODULE_1__duration__["d" /* durationMinute */]);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["d" /* durationMinute */];
}, function(date) {
  return date.getUTCMinutes();
});

/* harmony default export */ __webpack_exports__["a"] = (utcMinute);
var utcMinutes = utcMinute.range;


/***/ }),
/* 1053 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export utcMonths */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(27);


var utcMonth = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setUTCDate(1);
  date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
  date.setUTCMonth(date.getUTCMonth() + step);
}, function(start, end) {
  return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, function(date) {
  return date.getUTCMonth();
});

/* harmony default export */ __webpack_exports__["a"] = (utcMonth);
var utcMonths = utcMonth.range;


/***/ }),
/* 1054 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return utcSunday; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return utcMonday; });
/* unused harmony export utcTuesday */
/* unused harmony export utcWednesday */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return utcThursday; });
/* unused harmony export utcFriday */
/* unused harmony export utcSaturday */
/* unused harmony export utcSundays */
/* unused harmony export utcMondays */
/* unused harmony export utcTuesdays */
/* unused harmony export utcWednesdays */
/* unused harmony export utcThursdays */
/* unused harmony export utcFridays */
/* unused harmony export utcSaturdays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(60);



function utcWeekday(i) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
    date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
    date.setUTCHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setUTCDate(date.getUTCDate() + step * 7);
  }, function(start, end) {
    return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["a" /* durationWeek */];
  });
}

var utcSunday = utcWeekday(0);
var utcMonday = utcWeekday(1);
var utcTuesday = utcWeekday(2);
var utcWednesday = utcWeekday(3);
var utcThursday = utcWeekday(4);
var utcFriday = utcWeekday(5);
var utcSaturday = utcWeekday(6);

var utcSundays = utcSunday.range;
var utcMondays = utcMonday.range;
var utcTuesdays = utcTuesday.range;
var utcWednesdays = utcWednesday.range;
var utcThursdays = utcThursday.range;
var utcFridays = utcFriday.range;
var utcSaturdays = utcSaturday.range;


/***/ }),
/* 1055 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export utcYears */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(27);


var utcYear = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
  date.setUTCFullYear(date.getUTCFullYear() + step);
}, function(start, end) {
  return end.getUTCFullYear() - start.getUTCFullYear();
}, function(date) {
  return date.getUTCFullYear();
});

// An optimized implementation for this simple case.
utcYear.every = function(k) {
  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
    date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setUTCFullYear(date.getUTCFullYear() + step * k);
  });
};

/* harmony default export */ __webpack_exports__["a"] = (utcYear);
var utcYears = utcYear.range;


/***/ }),
/* 1056 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return sunday; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return monday; });
/* unused harmony export tuesday */
/* unused harmony export wednesday */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return thursday; });
/* unused harmony export friday */
/* unused harmony export saturday */
/* unused harmony export sundays */
/* unused harmony export mondays */
/* unused harmony export tuesdays */
/* unused harmony export wednesdays */
/* unused harmony export thursdays */
/* unused harmony export fridays */
/* unused harmony export saturdays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(60);



function weekday(i) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
    date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
    date.setHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setDate(date.getDate() + step * 7);
  }, function(start, end) {
    return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * __WEBPACK_IMPORTED_MODULE_1__duration__["d" /* durationMinute */]) / __WEBPACK_IMPORTED_MODULE_1__duration__["a" /* durationWeek */];
  });
}

var sunday = weekday(0);
var monday = weekday(1);
var tuesday = weekday(2);
var wednesday = weekday(3);
var thursday = weekday(4);
var friday = weekday(5);
var saturday = weekday(6);

var sundays = sunday.range;
var mondays = monday.range;
var tuesdays = tuesday.range;
var wednesdays = wednesday.range;
var thursdays = thursday.range;
var fridays = friday.range;
var saturdays = saturday.range;


/***/ }),
/* 1057 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export years */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(27);


var year = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setMonth(0, 1);
  date.setHours(0, 0, 0, 0);
}, function(date, step) {
  date.setFullYear(date.getFullYear() + step);
}, function(start, end) {
  return end.getFullYear() - start.getFullYear();
}, function(date) {
  return date.getFullYear();
});

// An optimized implementation for this simple case.
year.every = function(k) {
  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
    date.setFullYear(Math.floor(date.getFullYear() / k) * k);
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setFullYear(date.getFullYear() + step * k);
  });
};

/* harmony default export */ __webpack_exports__["a"] = (year);
var years = year.range;


/***/ }),
/* 1058 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__timer__ = __webpack_require__(266);


/* unused harmony default export */ var _unused_webpack_default_export = (function(callback, delay, time) {
  var t = new __WEBPACK_IMPORTED_MODULE_0__timer__["b" /* Timer */], total = delay;
  if (delay == null) return t.restart(callback, delay, time), t;
  delay = +delay, time = time == null ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__timer__["c" /* now */])() : +time;
  t.restart(function tick(elapsed) {
    elapsed += total;
    t.restart(tick, total += delay, time);
    callback(elapsed);
  }, delay, time);
  return t;
});


/***/ }),
/* 1059 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__timer__ = __webpack_require__(266);


/* harmony default export */ __webpack_exports__["a"] = (function(callback, delay, time) {
  var t = new __WEBPACK_IMPORTED_MODULE_0__timer__["b" /* Timer */];
  delay = delay == null ? 0 : +delay;
  t.restart(function(elapsed) {
    t.stop();
    callback(elapsed + delay);
  }, delay, time);
  return t;
});


/***/ }),
/* 1060 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__transition_index__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__transition_schedule__ = __webpack_require__(44);



var root = [null];

/* unused harmony default export */ var _unused_webpack_default_export = (function(node, name) {
  var schedules = node.__transition,
      schedule,
      i;

  if (schedules) {
    name = name == null ? null : name + "";
    for (i in schedules) {
      if ((schedule = schedules[i]).state > __WEBPACK_IMPORTED_MODULE_1__transition_schedule__["d" /* SCHEDULED */] && schedule.name === name) {
        return new __WEBPACK_IMPORTED_MODULE_0__transition_index__["a" /* Transition */]([[node]], root, name, +i);
      }
    }
  }

  return null;
});


/***/ }),
/* 1061 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_selection__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__interrupt__ = __webpack_require__(1062);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__transition__ = __webpack_require__(1063);




__WEBPACK_IMPORTED_MODULE_0_d3_selection__["f" /* selection */].prototype.interrupt = __WEBPACK_IMPORTED_MODULE_1__interrupt__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_0_d3_selection__["f" /* selection */].prototype.transition = __WEBPACK_IMPORTED_MODULE_2__transition__["a" /* default */];


/***/ }),
/* 1062 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interrupt__ = __webpack_require__(452);


/* harmony default export */ __webpack_exports__["a"] = (function(name) {
  return this.each(function() {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interrupt__["a" /* default */])(this, name);
  });
});


/***/ }),
/* 1063 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__transition_index__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__transition_schedule__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_ease__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_d3_timer__ = __webpack_require__(163);





var defaultTiming = {
  time: null, // Set on use.
  delay: 0,
  duration: 250,
  ease: __WEBPACK_IMPORTED_MODULE_2_d3_ease__["a" /* easeCubicInOut */]
};

function inherit(node, id) {
  var timing;
  while (!(timing = node.__transition) || !(timing = timing[id])) {
    if (!(node = node.parentNode)) {
      return defaultTiming.time = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_d3_timer__["c" /* now */])(), defaultTiming;
    }
  }
  return timing;
}

/* harmony default export */ __webpack_exports__["a"] = (function(name) {
  var id,
      timing;

  if (name instanceof __WEBPACK_IMPORTED_MODULE_0__transition_index__["a" /* Transition */]) {
    id = name._id, name = name._name;
  } else {
    id = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__transition_index__["b" /* newId */])(), (timing = defaultTiming).time = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_d3_timer__["c" /* now */])(), name = name == null ? null : name + "";
  }

  for (var groups = this._groups, m = groups.length, j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__transition_schedule__["h" /* default */])(node, name, id, i, group, timing || inherit(node, id));
      }
    }
  }

  return new __WEBPACK_IMPORTED_MODULE_0__transition_index__["a" /* Transition */](groups, this._parents, name, id);
});


/***/ }),
/* 1064 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_interpolate__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_selection__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tween__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__interpolate__ = __webpack_require__(453);





function attrRemove(name) {
  return function() {
    this.removeAttribute(name);
  };
}

function attrRemoveNS(fullname) {
  return function() {
    this.removeAttributeNS(fullname.space, fullname.local);
  };
}

function attrConstant(name, interpolate, value1) {
  var value00,
      interpolate0;
  return function() {
    var value0 = this.getAttribute(name);
    return value0 === value1 ? null
        : value0 === value00 ? interpolate0
        : interpolate0 = interpolate(value00 = value0, value1);
  };
}

function attrConstantNS(fullname, interpolate, value1) {
  var value00,
      interpolate0;
  return function() {
    var value0 = this.getAttributeNS(fullname.space, fullname.local);
    return value0 === value1 ? null
        : value0 === value00 ? interpolate0
        : interpolate0 = interpolate(value00 = value0, value1);
  };
}

function attrFunction(name, interpolate, value) {
  var value00,
      value10,
      interpolate0;
  return function() {
    var value0, value1 = value(this);
    if (value1 == null) return void this.removeAttribute(name);
    value0 = this.getAttribute(name);
    return value0 === value1 ? null
        : value0 === value00 && value1 === value10 ? interpolate0
        : interpolate0 = interpolate(value00 = value0, value10 = value1);
  };
}

function attrFunctionNS(fullname, interpolate, value) {
  var value00,
      value10,
      interpolate0;
  return function() {
    var value0, value1 = value(this);
    if (value1 == null) return void this.removeAttributeNS(fullname.space, fullname.local);
    value0 = this.getAttributeNS(fullname.space, fullname.local);
    return value0 === value1 ? null
        : value0 === value00 && value1 === value10 ? interpolate0
        : interpolate0 = interpolate(value00 = value0, value10 = value1);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(name, value) {
  var fullname = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["h" /* namespace */])(name), i = fullname === "transform" ? __WEBPACK_IMPORTED_MODULE_0_d3_interpolate__["g" /* interpolateTransformSvg */] : __WEBPACK_IMPORTED_MODULE_3__interpolate__["a" /* default */];
  return this.attrTween(name, typeof value === "function"
      ? (fullname.local ? attrFunctionNS : attrFunction)(fullname, i, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__tween__["b" /* tweenValue */])(this, "attr." + name, value))
      : value == null ? (fullname.local ? attrRemoveNS : attrRemove)(fullname)
      : (fullname.local ? attrConstantNS : attrConstant)(fullname, i, value + ""));
});


/***/ }),
/* 1065 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_selection__ = __webpack_require__(21);


function attrTweenNS(fullname, value) {
  function tween() {
    var node = this, i = value.apply(node, arguments);
    return i && function(t) {
      node.setAttributeNS(fullname.space, fullname.local, i(t));
    };
  }
  tween._value = value;
  return tween;
}

function attrTween(name, value) {
  function tween() {
    var node = this, i = value.apply(node, arguments);
    return i && function(t) {
      node.setAttribute(name, i(t));
    };
  }
  tween._value = value;
  return tween;
}

/* harmony default export */ __webpack_exports__["a"] = (function(name, value) {
  var key = "attr." + name;
  if (arguments.length < 2) return (key = this.tween(key)) && key._value;
  if (value == null) return this.tween(key, null);
  if (typeof value !== "function") throw new Error;
  var fullname = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_selection__["h" /* namespace */])(name);
  return this.tween(key, (fullname.local ? attrTweenNS : attrTween)(fullname, value));
});


/***/ }),
/* 1066 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__schedule__ = __webpack_require__(44);


function delayFunction(id, value) {
  return function() {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__schedule__["g" /* init */])(this, id).delay = +value.apply(this, arguments);
  };
}

function delayConstant(id, value) {
  return value = +value, function() {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__schedule__["g" /* init */])(this, id).delay = value;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(value) {
  var id = this._id;

  return arguments.length
      ? this.each((typeof value === "function"
          ? delayFunction
          : delayConstant)(id, value))
      : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__schedule__["f" /* get */])(this.node(), id).delay;
});


/***/ }),
/* 1067 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__schedule__ = __webpack_require__(44);


function durationFunction(id, value) {
  return function() {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__schedule__["e" /* set */])(this, id).duration = +value.apply(this, arguments);
  };
}

function durationConstant(id, value) {
  return value = +value, function() {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__schedule__["e" /* set */])(this, id).duration = value;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(value) {
  var id = this._id;

  return arguments.length
      ? this.each((typeof value === "function"
          ? durationFunction
          : durationConstant)(id, value))
      : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__schedule__["f" /* get */])(this.node(), id).duration;
});


/***/ }),
/* 1068 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__schedule__ = __webpack_require__(44);


function easeConstant(id, value) {
  if (typeof value !== "function") throw new Error;
  return function() {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__schedule__["e" /* set */])(this, id).ease = value;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(value) {
  var id = this._id;

  return arguments.length
      ? this.each(easeConstant(id, value))
      : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__schedule__["f" /* get */])(this.node(), id).ease;
});


/***/ }),
/* 1069 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_selection__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(74);



/* harmony default export */ __webpack_exports__["a"] = (function(match) {
  if (typeof match !== "function") match = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_selection__["i" /* matcher */])(match);

  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i) {
      if ((node = group[i]) && match.call(node, node.__data__, i, group)) {
        subgroup.push(node);
      }
    }
  }

  return new __WEBPACK_IMPORTED_MODULE_1__index__["a" /* Transition */](subgroups, this._parents, this._name, this._id);
});


/***/ }),
/* 1070 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(74);


/* harmony default export */ __webpack_exports__["a"] = (function(transition) {
  if (transition._id !== this._id) throw new Error;

  for (var groups0 = this._groups, groups1 = transition._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j) {
    for (var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i) {
      if (node = group0[i] || group1[i]) {
        merge[i] = node;
      }
    }
  }

  for (; j < m0; ++j) {
    merges[j] = groups0[j];
  }

  return new __WEBPACK_IMPORTED_MODULE_0__index__["a" /* Transition */](merges, this._parents, this._name, this._id);
});


/***/ }),
/* 1071 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__schedule__ = __webpack_require__(44);


function start(name) {
  return (name + "").trim().split(/^|\s+/).every(function(t) {
    var i = t.indexOf(".");
    if (i >= 0) t = t.slice(0, i);
    return !t || t === "start";
  });
}

function onFunction(id, name, listener) {
  var on0, on1, sit = start(name) ? __WEBPACK_IMPORTED_MODULE_0__schedule__["g" /* init */] : __WEBPACK_IMPORTED_MODULE_0__schedule__["e" /* set */];
  return function() {
    var schedule = sit(this, id),
        on = schedule.on;

    // If this node shared a dispatch with the previous node,
    // just assign the updated shared dispatch and we’re done!
    // Otherwise, copy-on-write.
    if (on !== on0) (on1 = (on0 = on).copy()).on(name, listener);

    schedule.on = on1;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(name, listener) {
  var id = this._id;

  return arguments.length < 2
      ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__schedule__["f" /* get */])(this.node(), id).on.on(name)
      : this.each(onFunction(id, name, listener));
});


/***/ }),
/* 1072 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function removeFunction(id) {
  return function() {
    var parent = this.parentNode;
    for (var i in this.__transition) if (+i !== id) return;
    if (parent) parent.removeChild(this);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return this.on("end.remove", removeFunction(this._id));
});


/***/ }),
/* 1073 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_selection__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__schedule__ = __webpack_require__(44);




/* harmony default export */ __webpack_exports__["a"] = (function(select) {
  var name = this._name,
      id = this._id;

  if (typeof select !== "function") select = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_selection__["k" /* selector */])(select);

  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i) {
      if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
        if ("__data__" in node) subnode.__data__ = node.__data__;
        subgroup[i] = subnode;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__schedule__["h" /* default */])(subgroup[i], name, id, i, subgroup, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__schedule__["f" /* get */])(node, id));
      }
    }
  }

  return new __WEBPACK_IMPORTED_MODULE_1__index__["a" /* Transition */](subgroups, this._parents, name, id);
});


/***/ }),
/* 1074 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_selection__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__schedule__ = __webpack_require__(44);




/* harmony default export */ __webpack_exports__["a"] = (function(select) {
  var name = this._name,
      id = this._id;

  if (typeof select !== "function") select = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_selection__["j" /* selectorAll */])(select);

  for (var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        for (var children = select.call(node, node.__data__, i, group), child, inherit = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__schedule__["f" /* get */])(node, id), k = 0, l = children.length; k < l; ++k) {
          if (child = children[k]) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__schedule__["h" /* default */])(child, name, id, k, children, inherit);
          }
        }
        subgroups.push(children);
        parents.push(node);
      }
    }
  }

  return new __WEBPACK_IMPORTED_MODULE_1__index__["a" /* Transition */](subgroups, parents, name, id);
});


/***/ }),
/* 1075 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_selection__ = __webpack_require__(21);


var Selection = __WEBPACK_IMPORTED_MODULE_0_d3_selection__["f" /* selection */].prototype.constructor;

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return new Selection(this._groups, this._parents);
});


/***/ }),
/* 1076 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_interpolate__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_selection__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tween__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__interpolate__ = __webpack_require__(453);





function styleRemove(name, interpolate) {
  var value00,
      value10,
      interpolate0;
  return function() {
    var value0 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["g" /* style */])(this, name),
        value1 = (this.style.removeProperty(name), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["g" /* style */])(this, name));
    return value0 === value1 ? null
        : value0 === value00 && value1 === value10 ? interpolate0
        : interpolate0 = interpolate(value00 = value0, value10 = value1);
  };
}

function styleRemoveEnd(name) {
  return function() {
    this.style.removeProperty(name);
  };
}

function styleConstant(name, interpolate, value1) {
  var value00,
      interpolate0;
  return function() {
    var value0 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["g" /* style */])(this, name);
    return value0 === value1 ? null
        : value0 === value00 ? interpolate0
        : interpolate0 = interpolate(value00 = value0, value1);
  };
}

function styleFunction(name, interpolate, value) {
  var value00,
      value10,
      interpolate0;
  return function() {
    var value0 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["g" /* style */])(this, name),
        value1 = value(this);
    if (value1 == null) value1 = (this.style.removeProperty(name), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["g" /* style */])(this, name));
    return value0 === value1 ? null
        : value0 === value00 && value1 === value10 ? interpolate0
        : interpolate0 = interpolate(value00 = value0, value10 = value1);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(name, value, priority) {
  var i = (name += "") === "transform" ? __WEBPACK_IMPORTED_MODULE_0_d3_interpolate__["c" /* interpolateTransformCss */] : __WEBPACK_IMPORTED_MODULE_3__interpolate__["a" /* default */];
  return value == null ? this
          .styleTween(name, styleRemove(name, i))
          .on("end.style." + name, styleRemoveEnd(name))
      : this.styleTween(name, typeof value === "function"
          ? styleFunction(name, i, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__tween__["b" /* tweenValue */])(this, "style." + name, value))
          : styleConstant(name, i, value + ""), priority);
});


/***/ }),
/* 1077 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function styleTween(name, value, priority) {
  function tween() {
    var node = this, i = value.apply(node, arguments);
    return i && function(t) {
      node.style.setProperty(name, i(t), priority);
    };
  }
  tween._value = value;
  return tween;
}

/* harmony default export */ __webpack_exports__["a"] = (function(name, value, priority) {
  var key = "style." + (name += "");
  if (arguments.length < 2) return (key = this.tween(key)) && key._value;
  if (value == null) return this.tween(key, null);
  if (typeof value !== "function") throw new Error;
  return this.tween(key, styleTween(name, value, priority == null ? "" : priority));
});


/***/ }),
/* 1078 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tween__ = __webpack_require__(164);


function textConstant(value) {
  return function() {
    this.textContent = value;
  };
}

function textFunction(value) {
  return function() {
    var value1 = value(this);
    this.textContent = value1 == null ? "" : value1;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(value) {
  return this.tween("text", typeof value === "function"
      ? textFunction(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__tween__["b" /* tweenValue */])(this, "text", value))
      : textConstant(value == null ? "" : value + ""));
});


/***/ }),
/* 1079 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__schedule__ = __webpack_require__(44);



/* harmony default export */ __webpack_exports__["a"] = (function() {
  var name = this._name,
      id0 = this._id,
      id1 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__index__["b" /* newId */])();

  for (var groups = this._groups, m = groups.length, j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        var inherit = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__schedule__["f" /* get */])(node, id0);
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__schedule__["h" /* default */])(node, name, id1, i, group, {
          time: inherit.time + inherit.delay + inherit.duration,
          delay: 0,
          duration: inherit.duration,
          ease: inherit.ease
        });
      }
    }
  }

  return new __WEBPACK_IMPORTED_MODULE_0__index__["a" /* Transition */](groups, this._parents, name, id1);
});


/***/ }),
/* 1080 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_voronoi__ = __webpack_require__(1084);
/* unused harmony reexport voronoi */



/***/ }),
/* 1081 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = removeBeach;
/* harmony export (immutable) */ __webpack_exports__["a"] = addBeach;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RedBlackTree__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Cell__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Circle__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Edge__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Diagram__ = __webpack_require__(124);






var beachPool = [];

function Beach() {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__RedBlackTree__["b" /* RedBlackNode */])(this);
  this.edge =
  this.site =
  this.circle = null;
}

function createBeach(site) {
  var beach = beachPool.pop() || new Beach;
  beach.site = site;
  return beach;
}

function detachBeach(beach) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__Circle__["b" /* detachCircle */])(beach);
  __WEBPACK_IMPORTED_MODULE_4__Diagram__["e" /* beaches */].remove(beach);
  beachPool.push(beach);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__RedBlackTree__["b" /* RedBlackNode */])(beach);
}

function removeBeach(beach) {
  var circle = beach.circle,
      x = circle.x,
      y = circle.cy,
      vertex = [x, y],
      previous = beach.P,
      next = beach.N,
      disappearing = [beach];

  detachBeach(beach);

  var lArc = previous;
  while (lArc.circle
      && Math.abs(x - lArc.circle.x) < __WEBPACK_IMPORTED_MODULE_4__Diagram__["b" /* epsilon */]
      && Math.abs(y - lArc.circle.cy) < __WEBPACK_IMPORTED_MODULE_4__Diagram__["b" /* epsilon */]) {
    previous = lArc.P;
    disappearing.unshift(lArc);
    detachBeach(lArc);
    lArc = previous;
  }

  disappearing.unshift(lArc);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__Circle__["b" /* detachCircle */])(lArc);

  var rArc = next;
  while (rArc.circle
      && Math.abs(x - rArc.circle.x) < __WEBPACK_IMPORTED_MODULE_4__Diagram__["b" /* epsilon */]
      && Math.abs(y - rArc.circle.cy) < __WEBPACK_IMPORTED_MODULE_4__Diagram__["b" /* epsilon */]) {
    next = rArc.N;
    disappearing.push(rArc);
    detachBeach(rArc);
    rArc = next;
  }

  disappearing.push(rArc);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__Circle__["b" /* detachCircle */])(rArc);

  var nArcs = disappearing.length,
      iArc;
  for (iArc = 1; iArc < nArcs; ++iArc) {
    rArc = disappearing[iArc];
    lArc = disappearing[iArc - 1];
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__Edge__["c" /* setEdgeEnd */])(rArc.edge, lArc.site, rArc.site, vertex);
  }

  lArc = disappearing[0];
  rArc = disappearing[nArcs - 1];
  rArc.edge = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__Edge__["d" /* createEdge */])(lArc.site, rArc.site, null, vertex);

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__Circle__["c" /* attachCircle */])(lArc);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__Circle__["c" /* attachCircle */])(rArc);
}

function addBeach(site) {
  var x = site[0],
      directrix = site[1],
      lArc,
      rArc,
      dxl,
      dxr,
      node = __WEBPACK_IMPORTED_MODULE_4__Diagram__["e" /* beaches */]._;

  while (node) {
    dxl = leftBreakPoint(node, directrix) - x;
    if (dxl > __WEBPACK_IMPORTED_MODULE_4__Diagram__["b" /* epsilon */]) node = node.L; else {
      dxr = x - rightBreakPoint(node, directrix);
      if (dxr > __WEBPACK_IMPORTED_MODULE_4__Diagram__["b" /* epsilon */]) {
        if (!node.R) {
          lArc = node;
          break;
        }
        node = node.R;
      } else {
        if (dxl > -__WEBPACK_IMPORTED_MODULE_4__Diagram__["b" /* epsilon */]) {
          lArc = node.P;
          rArc = node;
        } else if (dxr > -__WEBPACK_IMPORTED_MODULE_4__Diagram__["b" /* epsilon */]) {
          lArc = node;
          rArc = node.N;
        } else {
          lArc = rArc = node;
        }
        break;
      }
    }
  }

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__Cell__["d" /* createCell */])(site);
  var newArc = createBeach(site);
  __WEBPACK_IMPORTED_MODULE_4__Diagram__["e" /* beaches */].insert(lArc, newArc);

  if (!lArc && !rArc) return;

  if (lArc === rArc) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__Circle__["b" /* detachCircle */])(lArc);
    rArc = createBeach(lArc.site);
    __WEBPACK_IMPORTED_MODULE_4__Diagram__["e" /* beaches */].insert(newArc, rArc);
    newArc.edge = rArc.edge = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__Edge__["d" /* createEdge */])(lArc.site, newArc.site);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__Circle__["c" /* attachCircle */])(lArc);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__Circle__["c" /* attachCircle */])(rArc);
    return;
  }

  if (!rArc) { // && lArc
    newArc.edge = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__Edge__["d" /* createEdge */])(lArc.site, newArc.site);
    return;
  }

  // else lArc !== rArc
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__Circle__["b" /* detachCircle */])(lArc);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__Circle__["b" /* detachCircle */])(rArc);

  var lSite = lArc.site,
      ax = lSite[0],
      ay = lSite[1],
      bx = site[0] - ax,
      by = site[1] - ay,
      rSite = rArc.site,
      cx = rSite[0] - ax,
      cy = rSite[1] - ay,
      d = 2 * (bx * cy - by * cx),
      hb = bx * bx + by * by,
      hc = cx * cx + cy * cy,
      vertex = [(cy * hb - by * hc) / d + ax, (bx * hc - cx * hb) / d + ay];

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__Edge__["c" /* setEdgeEnd */])(rArc.edge, lSite, rSite, vertex);
  newArc.edge = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__Edge__["d" /* createEdge */])(lSite, site, null, vertex);
  rArc.edge = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__Edge__["d" /* createEdge */])(site, rSite, null, vertex);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__Circle__["c" /* attachCircle */])(lArc);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__Circle__["c" /* attachCircle */])(rArc);
}

function leftBreakPoint(arc, directrix) {
  var site = arc.site,
      rfocx = site[0],
      rfocy = site[1],
      pby2 = rfocy - directrix;

  if (!pby2) return rfocx;

  var lArc = arc.P;
  if (!lArc) return -Infinity;

  site = lArc.site;
  var lfocx = site[0],
      lfocy = site[1],
      plby2 = lfocy - directrix;

  if (!plby2) return lfocx;

  var hl = lfocx - rfocx,
      aby2 = 1 / pby2 - 1 / plby2,
      b = hl / plby2;

  if (aby2) return (-b + Math.sqrt(b * b - 2 * aby2 * (hl * hl / (-2 * plby2) - lfocy + plby2 / 2 + rfocy - pby2 / 2))) / aby2 + rfocx;

  return (rfocx + lfocx) / 2;
}

function rightBreakPoint(arc, directrix) {
  var rArc = arc.N;
  if (rArc) return leftBreakPoint(rArc, directrix);
  var site = arc.site;
  return site[1] === directrix ? site[0] : Infinity;
}


/***/ }),
/* 1082 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 1083 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = x;
/* harmony export (immutable) */ __webpack_exports__["b"] = y;
function x(d) {
  return d[0];
}

function y(d) {
  return d[1];
}


/***/ }),
/* 1084 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(1082);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__point__ = __webpack_require__(1083);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Diagram__ = __webpack_require__(124);




/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var x = __WEBPACK_IMPORTED_MODULE_1__point__["a" /* x */],
      y = __WEBPACK_IMPORTED_MODULE_1__point__["b" /* y */],
      extent = null;

  function voronoi(data) {
    return new __WEBPACK_IMPORTED_MODULE_2__Diagram__["a" /* default */](data.map(function(d, i) {
      var s = [Math.round(x(d, i, data) / __WEBPACK_IMPORTED_MODULE_2__Diagram__["b" /* epsilon */]) * __WEBPACK_IMPORTED_MODULE_2__Diagram__["b" /* epsilon */], Math.round(y(d, i, data) / __WEBPACK_IMPORTED_MODULE_2__Diagram__["b" /* epsilon */]) * __WEBPACK_IMPORTED_MODULE_2__Diagram__["b" /* epsilon */]];
      s.index = i;
      s.data = d;
      return s;
    }), extent);
  }

  voronoi.polygons = function(data) {
    return voronoi(data).polygons();
  };

  voronoi.links = function(data) {
    return voronoi(data).links();
  };

  voronoi.triangles = function(data) {
    return voronoi(data).triangles();
  };

  voronoi.x = function(_) {
    return arguments.length ? (x = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), voronoi) : x;
  };

  voronoi.y = function(_) {
    return arguments.length ? (y = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), voronoi) : y;
  };

  voronoi.extent = function(_) {
    return arguments.length ? (extent = _ == null ? null : [[+_[0][0], +_[0][1]], [+_[1][0], +_[1][1]]], voronoi) : extent && [[extent[0][0], extent[0][1]], [extent[1][0], extent[1][1]]];
  };

  voronoi.size = function(_) {
    return arguments.length ? (extent = _ == null ? null : [[0, 0], [+_[0], +_[1]]], voronoi) : extent && [extent[1][0] - extent[0][0], extent[1][1] - extent[0][1]];
  };

  return voronoi;
});


/***/ }),
/* 1085 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_zoom__ = __webpack_require__(1089);
/* unused harmony reexport zoom */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_transform__ = __webpack_require__(456);
/* unused harmony reexport zoomTransform */
/* unused harmony reexport zoomIdentity */




/***/ }),
/* 1086 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 1087 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ZoomEvent;
function ZoomEvent(target, type, transform) {
  this.target = target;
  this.type = type;
  this.transform = transform;
}


/***/ }),
/* 1088 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = nopropagation;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_selection__ = __webpack_require__(21);


function nopropagation() {
  __WEBPACK_IMPORTED_MODULE_0_d3_selection__["b" /* event */].stopImmediatePropagation();
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  __WEBPACK_IMPORTED_MODULE_0_d3_selection__["b" /* event */].preventDefault();
  __WEBPACK_IMPORTED_MODULE_0_d3_selection__["b" /* event */].stopImmediatePropagation();
});


/***/ }),
/* 1089 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_dispatch__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_drag__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_interpolate__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_d3_selection__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_d3_transition__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constant__ = __webpack_require__(1086);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__event__ = __webpack_require__(1087);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__transform__ = __webpack_require__(456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__noevent__ = __webpack_require__(1088);










// Ignore right-click, since that should open the context menu.
function defaultFilter() {
  return !__WEBPACK_IMPORTED_MODULE_3_d3_selection__["b" /* event */].button;
}

function defaultExtent() {
  var e = this, w, h;
  if (e instanceof SVGElement) {
    e = e.ownerSVGElement || e;
    w = e.width.baseVal.value;
    h = e.height.baseVal.value;
  } else {
    w = e.clientWidth;
    h = e.clientHeight;
  }
  return [[0, 0], [w, h]];
}

function defaultTransform() {
  return this.__zoom || __WEBPACK_IMPORTED_MODULE_7__transform__["a" /* identity */];
}

function defaultWheelDelta() {
  return -__WEBPACK_IMPORTED_MODULE_3_d3_selection__["b" /* event */].deltaY * (__WEBPACK_IMPORTED_MODULE_3_d3_selection__["b" /* event */].deltaMode ? 120 : 1) / 500;
}

function defaultTouchable() {
  return "ontouchstart" in this;
}

function defaultConstrain(transform, extent, translateExtent) {
  var dx0 = transform.invertX(extent[0][0]) - translateExtent[0][0],
      dx1 = transform.invertX(extent[1][0]) - translateExtent[1][0],
      dy0 = transform.invertY(extent[0][1]) - translateExtent[0][1],
      dy1 = transform.invertY(extent[1][1]) - translateExtent[1][1];
  return transform.translate(
    dx1 > dx0 ? (dx0 + dx1) / 2 : Math.min(0, dx0) || Math.max(0, dx1),
    dy1 > dy0 ? (dy0 + dy1) / 2 : Math.min(0, dy0) || Math.max(0, dy1)
  );
}

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var filter = defaultFilter,
      extent = defaultExtent,
      constrain = defaultConstrain,
      wheelDelta = defaultWheelDelta,
      touchable = defaultTouchable,
      scaleExtent = [0, Infinity],
      translateExtent = [[-Infinity, -Infinity], [Infinity, Infinity]],
      duration = 250,
      interpolate = __WEBPACK_IMPORTED_MODULE_2_d3_interpolate__["b" /* interpolateZoom */],
      gestures = [],
      listeners = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_dispatch__["a" /* dispatch */])("start", "zoom", "end"),
      touchstarting,
      touchending,
      touchDelay = 500,
      wheelDelay = 150,
      clickDistance2 = 0;

  function zoom(selection) {
    selection
        .property("__zoom", defaultTransform)
        .on("wheel.zoom", wheeled)
        .on("mousedown.zoom", mousedowned)
        .on("dblclick.zoom", dblclicked)
      .filter(touchable)
        .on("touchstart.zoom", touchstarted)
        .on("touchmove.zoom", touchmoved)
        .on("touchend.zoom touchcancel.zoom", touchended)
        .style("touch-action", "none")
        .style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
  }

  zoom.transform = function(collection, transform) {
    var selection = collection.selection ? collection.selection() : collection;
    selection.property("__zoom", defaultTransform);
    if (collection !== selection) {
      schedule(collection, transform);
    } else {
      selection.interrupt().each(function() {
        gesture(this, arguments)
            .start()
            .zoom(null, typeof transform === "function" ? transform.apply(this, arguments) : transform)
            .end();
      });
    }
  };

  zoom.scaleBy = function(selection, k) {
    zoom.scaleTo(selection, function() {
      var k0 = this.__zoom.k,
          k1 = typeof k === "function" ? k.apply(this, arguments) : k;
      return k0 * k1;
    });
  };

  zoom.scaleTo = function(selection, k) {
    zoom.transform(selection, function() {
      var e = extent.apply(this, arguments),
          t0 = this.__zoom,
          p0 = centroid(e),
          p1 = t0.invert(p0),
          k1 = typeof k === "function" ? k.apply(this, arguments) : k;
      return constrain(translate(scale(t0, k1), p0, p1), e, translateExtent);
    });
  };

  zoom.translateBy = function(selection, x, y) {
    zoom.transform(selection, function() {
      return constrain(this.__zoom.translate(
        typeof x === "function" ? x.apply(this, arguments) : x,
        typeof y === "function" ? y.apply(this, arguments) : y
      ), extent.apply(this, arguments), translateExtent);
    });
  };

  zoom.translateTo = function(selection, x, y) {
    zoom.transform(selection, function() {
      var e = extent.apply(this, arguments),
          t = this.__zoom,
          p = centroid(e);
      return constrain(__WEBPACK_IMPORTED_MODULE_7__transform__["a" /* identity */].translate(p[0], p[1]).scale(t.k).translate(
        typeof x === "function" ? -x.apply(this, arguments) : -x,
        typeof y === "function" ? -y.apply(this, arguments) : -y
      ), e, translateExtent);
    });
  };

  function scale(transform, k) {
    k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], k));
    return k === transform.k ? transform : new __WEBPACK_IMPORTED_MODULE_7__transform__["b" /* Transform */](k, transform.x, transform.y);
  }

  function translate(transform, p0, p1) {
    var x = p0[0] - p1[0] * transform.k, y = p0[1] - p1[1] * transform.k;
    return x === transform.x && y === transform.y ? transform : new __WEBPACK_IMPORTED_MODULE_7__transform__["b" /* Transform */](transform.k, x, y);
  }

  function centroid(extent) {
    return [(+extent[0][0] + +extent[1][0]) / 2, (+extent[0][1] + +extent[1][1]) / 2];
  }

  function schedule(transition, transform, center) {
    transition
        .on("start.zoom", function() { gesture(this, arguments).start(); })
        .on("interrupt.zoom end.zoom", function() { gesture(this, arguments).end(); })
        .tween("zoom", function() {
          var that = this,
              args = arguments,
              g = gesture(that, args),
              e = extent.apply(that, args),
              p = center || centroid(e),
              w = Math.max(e[1][0] - e[0][0], e[1][1] - e[0][1]),
              a = that.__zoom,
              b = typeof transform === "function" ? transform.apply(that, args) : transform,
              i = interpolate(a.invert(p).concat(w / a.k), b.invert(p).concat(w / b.k));
          return function(t) {
            if (t === 1) t = b; // Avoid rounding error on end.
            else { var l = i(t), k = w / l[2]; t = new __WEBPACK_IMPORTED_MODULE_7__transform__["b" /* Transform */](k, p[0] - l[0] * k, p[1] - l[1] * k); }
            g.zoom(null, t);
          };
        });
  }

  function gesture(that, args) {
    for (var i = 0, n = gestures.length, g; i < n; ++i) {
      if ((g = gestures[i]).that === that) {
        return g;
      }
    }
    return new Gesture(that, args);
  }

  function Gesture(that, args) {
    this.that = that;
    this.args = args;
    this.index = -1;
    this.active = 0;
    this.extent = extent.apply(that, args);
  }

  Gesture.prototype = {
    start: function() {
      if (++this.active === 1) {
        this.index = gestures.push(this) - 1;
        this.emit("start");
      }
      return this;
    },
    zoom: function(key, transform) {
      if (this.mouse && key !== "mouse") this.mouse[1] = transform.invert(this.mouse[0]);
      if (this.touch0 && key !== "touch") this.touch0[1] = transform.invert(this.touch0[0]);
      if (this.touch1 && key !== "touch") this.touch1[1] = transform.invert(this.touch1[0]);
      this.that.__zoom = transform;
      this.emit("zoom");
      return this;
    },
    end: function() {
      if (--this.active === 0) {
        gestures.splice(this.index, 1);
        this.index = -1;
        this.emit("end");
      }
      return this;
    },
    emit: function(type) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["c" /* customEvent */])(new __WEBPACK_IMPORTED_MODULE_6__event__["a" /* default */](zoom, type, this.that.__zoom), listeners.apply, listeners, [type, this.that, this.args]);
    }
  };

  function wheeled() {
    if (!filter.apply(this, arguments)) return;
    var g = gesture(this, arguments),
        t = this.__zoom,
        k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], t.k * Math.pow(2, wheelDelta.apply(this, arguments)))),
        p = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["d" /* mouse */])(this);

    // If the mouse is in the same location as before, reuse it.
    // If there were recent wheel events, reset the wheel idle timeout.
    if (g.wheel) {
      if (g.mouse[0][0] !== p[0] || g.mouse[0][1] !== p[1]) {
        g.mouse[1] = t.invert(g.mouse[0] = p);
      }
      clearTimeout(g.wheel);
    }

    // If this wheel event won’t trigger a transform change, ignore it.
    else if (t.k === k) return;

    // Otherwise, capture the mouse point and location at the start.
    else {
      g.mouse = [p, t.invert(p)];
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_d3_transition__["a" /* interrupt */])(this);
      g.start();
    }

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__noevent__["a" /* default */])();
    g.wheel = setTimeout(wheelidled, wheelDelay);
    g.zoom("mouse", constrain(translate(scale(t, k), g.mouse[0], g.mouse[1]), g.extent, translateExtent));

    function wheelidled() {
      g.wheel = null;
      g.end();
    }
  }

  function mousedowned() {
    if (touchending || !filter.apply(this, arguments)) return;
    var g = gesture(this, arguments),
        v = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["a" /* select */])(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["b" /* event */].view).on("mousemove.zoom", mousemoved, true).on("mouseup.zoom", mouseupped, true),
        p = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["d" /* mouse */])(this),
        x0 = __WEBPACK_IMPORTED_MODULE_3_d3_selection__["b" /* event */].clientX,
        y0 = __WEBPACK_IMPORTED_MODULE_3_d3_selection__["b" /* event */].clientY;

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_drag__["a" /* dragDisable */])(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["b" /* event */].view);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__noevent__["b" /* nopropagation */])();
    g.mouse = [p, this.__zoom.invert(p)];
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_d3_transition__["a" /* interrupt */])(this);
    g.start();

    function mousemoved() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__noevent__["a" /* default */])();
      if (!g.moved) {
        var dx = __WEBPACK_IMPORTED_MODULE_3_d3_selection__["b" /* event */].clientX - x0, dy = __WEBPACK_IMPORTED_MODULE_3_d3_selection__["b" /* event */].clientY - y0;
        g.moved = dx * dx + dy * dy > clickDistance2;
      }
      g.zoom("mouse", constrain(translate(g.that.__zoom, g.mouse[0] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["d" /* mouse */])(g.that), g.mouse[1]), g.extent, translateExtent));
    }

    function mouseupped() {
      v.on("mousemove.zoom mouseup.zoom", null);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_drag__["b" /* dragEnable */])(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["b" /* event */].view, g.moved);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__noevent__["a" /* default */])();
      g.end();
    }
  }

  function dblclicked() {
    if (!filter.apply(this, arguments)) return;
    var t0 = this.__zoom,
        p0 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["d" /* mouse */])(this),
        p1 = t0.invert(p0),
        k1 = t0.k * (__WEBPACK_IMPORTED_MODULE_3_d3_selection__["b" /* event */].shiftKey ? 0.5 : 2),
        t1 = constrain(translate(scale(t0, k1), p0, p1), extent.apply(this, arguments), translateExtent);

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__noevent__["a" /* default */])();
    if (duration > 0) __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["a" /* select */])(this).transition().duration(duration).call(schedule, t1, p0);
    else __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["a" /* select */])(this).call(zoom.transform, t1);
  }

  function touchstarted() {
    if (!filter.apply(this, arguments)) return;
    var g = gesture(this, arguments),
        touches = __WEBPACK_IMPORTED_MODULE_3_d3_selection__["b" /* event */].changedTouches,
        started,
        n = touches.length, i, t, p;

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__noevent__["b" /* nopropagation */])();
    for (i = 0; i < n; ++i) {
      t = touches[i], p = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["e" /* touch */])(this, touches, t.identifier);
      p = [p, this.__zoom.invert(p), t.identifier];
      if (!g.touch0) g.touch0 = p, started = true;
      else if (!g.touch1) g.touch1 = p;
    }

    // If this is a dbltap, reroute to the (optional) dblclick.zoom handler.
    if (touchstarting) {
      touchstarting = clearTimeout(touchstarting);
      if (!g.touch1) {
        g.end();
        p = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["a" /* select */])(this).on("dblclick.zoom");
        if (p) p.apply(this, arguments);
        return;
      }
    }

    if (started) {
      touchstarting = setTimeout(function() { touchstarting = null; }, touchDelay);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_d3_transition__["a" /* interrupt */])(this);
      g.start();
    }
  }

  function touchmoved() {
    var g = gesture(this, arguments),
        touches = __WEBPACK_IMPORTED_MODULE_3_d3_selection__["b" /* event */].changedTouches,
        n = touches.length, i, t, p, l;

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__noevent__["a" /* default */])();
    if (touchstarting) touchstarting = clearTimeout(touchstarting);
    for (i = 0; i < n; ++i) {
      t = touches[i], p = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["e" /* touch */])(this, touches, t.identifier);
      if (g.touch0 && g.touch0[2] === t.identifier) g.touch0[0] = p;
      else if (g.touch1 && g.touch1[2] === t.identifier) g.touch1[0] = p;
    }
    t = g.that.__zoom;
    if (g.touch1) {
      var p0 = g.touch0[0], l0 = g.touch0[1],
          p1 = g.touch1[0], l1 = g.touch1[1],
          dp = (dp = p1[0] - p0[0]) * dp + (dp = p1[1] - p0[1]) * dp,
          dl = (dl = l1[0] - l0[0]) * dl + (dl = l1[1] - l0[1]) * dl;
      t = scale(t, Math.sqrt(dp / dl));
      p = [(p0[0] + p1[0]) / 2, (p0[1] + p1[1]) / 2];
      l = [(l0[0] + l1[0]) / 2, (l0[1] + l1[1]) / 2];
    }
    else if (g.touch0) p = g.touch0[0], l = g.touch0[1];
    else return;
    g.zoom("touch", constrain(translate(t, p, l), g.extent, translateExtent));
  }

  function touchended() {
    var g = gesture(this, arguments),
        touches = __WEBPACK_IMPORTED_MODULE_3_d3_selection__["b" /* event */].changedTouches,
        n = touches.length, i, t;

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__noevent__["b" /* nopropagation */])();
    if (touchending) clearTimeout(touchending);
    touchending = setTimeout(function() { touchending = null; }, touchDelay);
    for (i = 0; i < n; ++i) {
      t = touches[i];
      if (g.touch0 && g.touch0[2] === t.identifier) delete g.touch0;
      else if (g.touch1 && g.touch1[2] === t.identifier) delete g.touch1;
    }
    if (g.touch1 && !g.touch0) g.touch0 = g.touch1, delete g.touch1;
    if (g.touch0) g.touch0[1] = this.__zoom.invert(g.touch0[0]);
    else g.end();
  }

  zoom.wheelDelta = function(_) {
    return arguments.length ? (wheelDelta = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__constant__["a" /* default */])(+_), zoom) : wheelDelta;
  };

  zoom.filter = function(_) {
    return arguments.length ? (filter = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__constant__["a" /* default */])(!!_), zoom) : filter;
  };

  zoom.touchable = function(_) {
    return arguments.length ? (touchable = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__constant__["a" /* default */])(!!_), zoom) : touchable;
  };

  zoom.extent = function(_) {
    return arguments.length ? (extent = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__constant__["a" /* default */])([[+_[0][0], +_[0][1]], [+_[1][0], +_[1][1]]]), zoom) : extent;
  };

  zoom.scaleExtent = function(_) {
    return arguments.length ? (scaleExtent[0] = +_[0], scaleExtent[1] = +_[1], zoom) : [scaleExtent[0], scaleExtent[1]];
  };

  zoom.translateExtent = function(_) {
    return arguments.length ? (translateExtent[0][0] = +_[0][0], translateExtent[1][0] = +_[1][0], translateExtent[0][1] = +_[0][1], translateExtent[1][1] = +_[1][1], zoom) : [[translateExtent[0][0], translateExtent[0][1]], [translateExtent[1][0], translateExtent[1][1]]];
  };

  zoom.constrain = function(_) {
    return arguments.length ? (constrain = _, zoom) : constrain;
  };

  zoom.duration = function(_) {
    return arguments.length ? (duration = +_, zoom) : duration;
  };

  zoom.interpolate = function(_) {
    return arguments.length ? (interpolate = _, zoom) : interpolate;
  };

  zoom.on = function() {
    var value = listeners.on.apply(listeners, arguments);
    return value === listeners ? zoom : value;
  };

  zoom.clickDistance = function(_) {
    return arguments.length ? (clickDistance2 = (_ = +_) * _, zoom) : Math.sqrt(clickDistance2);
  };

  return zoom;
});


/***/ }),
/* 1090 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export name */
/* unused harmony export version */
/* unused harmony export description */
/* unused harmony export keywords */
/* unused harmony export homepage */
/* unused harmony export license */
/* unused harmony export author */
/* unused harmony export main */
/* unused harmony export unpkg */
/* unused harmony export jsdelivr */
/* unused harmony export module */
/* unused harmony export repository */
/* unused harmony export scripts */
/* unused harmony export devDependencies */
/* unused harmony export dependencies */
var name = "d3";
var version = "4.12.0";
var description = "Data-Driven Documents";
var keywords = ["dom","visualization","svg","animation","canvas"];
var homepage = "https://d3js.org";
var license = "BSD-3-Clause";
var author = {"name":"Mike Bostock","url":"https://bost.ocks.org/mike"};
var main = "build/d3.node.js";
var unpkg = "build/d3.js";
var jsdelivr = "build/d3.js";
var module = "index";
var repository = {"type":"git","url":"https://github.com/d3/d3.git"};
var scripts = {"pretest":"rimraf build && mkdir build && json2module package.json > build/package.js && node rollup.node","test":"tape 'test/**/*-test.js'","prepublishOnly":"npm run test && rollup -c --banner \"$(preamble)\" && uglifyjs -b beautify=false,preamble=\"'$(preamble)'\" build/d3.js -c negate_iife=false -m -o build/d3.min.js","postpublish":"git push && git push --tags && cd ../d3.github.com && git pull && cp ../d3/build/d3.js d3.v4.js && cp ../d3/build/d3.min.js d3.v4.min.js && git add d3.v4.js d3.v4.min.js && git commit -m \"d3 ${npm_package_version}\" && git push && cd - && cd ../d3-bower && git pull && cp ../d3/LICENSE ../d3/README.md ../d3/build/d3.js ../d3/build/d3.min.js . && git add -- LICENSE README.md d3.js d3.min.js && git commit -m \"${npm_package_version}\" && git tag -am \"${npm_package_version}\" v${npm_package_version} && git push && git push --tags && cd - && zip -j build/d3.zip -- LICENSE README.md API.md CHANGES.md build/d3.js build/d3.min.js"};
var devDependencies = {"json2module":"0.0","package-preamble":"0.1","rimraf":"2","rollup":"0.51","rollup-plugin-ascii":"0.0","rollup-plugin-node-resolve":"3","tape":"4","uglify-js":"3"};
var dependencies = {"d3-array":"1.2.1","d3-axis":"1.0.8","d3-brush":"1.0.4","d3-chord":"1.0.4","d3-collection":"1.0.4","d3-color":"1.0.3","d3-dispatch":"1.0.3","d3-drag":"1.2.1","d3-dsv":"1.0.8","d3-ease":"1.0.3","d3-force":"1.1.0","d3-format":"1.2.1","d3-geo":"1.9.0","d3-hierarchy":"1.1.5","d3-interpolate":"1.1.6","d3-path":"1.0.5","d3-polygon":"1.0.3","d3-quadtree":"1.0.3","d3-queue":"3.0.7","d3-random":"1.1.0","d3-request":"1.0.6","d3-scale":"1.0.7","d3-selection":"1.2.0","d3-shape":"1.2.0","d3-time":"1.0.8","d3-time-format":"2.1.1","d3-timer":"1.0.7","d3-transition":"1.1.1","d3-voronoi":"1.1.2","d3-zoom":"1.7.1"};


/***/ }),
/* 1091 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_package__ = __webpack_require__(1090);
/* unused harmony reexport version */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_array__ = __webpack_require__(29);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_axis__ = __webpack_require__(817);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_d3_brush__ = __webpack_require__(821);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_d3_chord__ = __webpack_require__(826);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_d3_collection__ = __webpack_require__(114);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_d3_color__ = __webpack_require__(50);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_d3_dispatch__ = __webpack_require__(87);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_d3_drag__ = __webpack_require__(233);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_d3_dsv__ = __webpack_require__(234);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_d3_ease__ = __webpack_require__(392);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_d3_force__ = __webpack_require__(854);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_d3_format__ = __webpack_require__(237);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_d3_geo__ = __webpack_require__(871);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_d3_hierarchy__ = __webpack_require__(899);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_d3_interpolate__ = __webpack_require__(42);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_15_d3_interpolate__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_d3_path__ = __webpack_require__(89);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_d3_polygon__ = __webpack_require__(932);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_d3_quadtree__ = __webpack_require__(249);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_d3_queue__ = __webpack_require__(952);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_d3_random__ = __webpack_require__(955);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_d3_request__ = __webpack_require__(960);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_d3_scale__ = __webpack_require__(967);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_d3_selection__ = __webpack_require__(21);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_23_d3_selection__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_d3_shape__ = __webpack_require__(1018);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_shape__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_d3_time__ = __webpack_require__(162);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_d3_time_format__ = __webpack_require__(264);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_d3_timer__ = __webpack_require__(163);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_d3_transition__ = __webpack_require__(267);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_d3_voronoi__ = __webpack_require__(1080);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_d3_zoom__ = __webpack_require__(1085);
/* unused harmony namespace reexport */

































/***/ }),
/* 1092 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/BlueNoTex.8ff3ead969be05d3708a4ff87f641a9b.png";

/***/ }),
/* 1093 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/GreenNoTex.2470170d03d7c072e6931d6f76452a64.png";

/***/ }),
/* 1094 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/PurpleNoTx.2193a4d8cf152f80929a6e23ad057a27.png";

/***/ }),
/* 1095 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "licensing/tos.pdf";

/***/ }),
/* 1096 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_ngx_window_token__ = __webpack_require__(457);
/* unused harmony reexport WindowTokenModule */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_ngx_window_token__["a"]; });

//# sourceMappingURL=ngx-window-token.js.map

/***/ }),
/* 1097 */,
/* 1098 */,
/* 1099 */,
/* 1100 */,
/* 1101 */,
/* 1102 */,
/* 1103 */,
/* 1104 */,
/* 1105 */,
/* 1106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* tslint:disable:no-unused-variable */
// Subject imported before Observable to bypass circular dependency issue since
// Subject extends Observable and Observable references Subject in it's
// definition
var Subject_1 = __webpack_require__(11);
exports.Subject = Subject_1.Subject;
exports.AnonymousSubject = Subject_1.AnonymousSubject;
/* tslint:enable:no-unused-variable */
var Observable_1 = __webpack_require__(0);
exports.Observable = Observable_1.Observable;
// statics
/* tslint:disable:no-use-before-declare */
__webpack_require__(1108);
__webpack_require__(1109);
__webpack_require__(1110);
__webpack_require__(1111);
__webpack_require__(281);
__webpack_require__(282);
__webpack_require__(283);
__webpack_require__(1114);
__webpack_require__(466);
__webpack_require__(1115);
__webpack_require__(1116);
__webpack_require__(1117);
__webpack_require__(1118);
__webpack_require__(1119);
__webpack_require__(284);
__webpack_require__(1123);
__webpack_require__(1120);
__webpack_require__(285);
__webpack_require__(1121);
__webpack_require__(1122);
__webpack_require__(286);
__webpack_require__(1124);
__webpack_require__(287);
__webpack_require__(288);
__webpack_require__(1125);
//dom
__webpack_require__(1112);
__webpack_require__(1113);
//operators
__webpack_require__(1128);
__webpack_require__(1129);
__webpack_require__(1130);
__webpack_require__(1131);
__webpack_require__(1132);
__webpack_require__(289);
__webpack_require__(1133);
__webpack_require__(1134);
__webpack_require__(1135);
__webpack_require__(1136);
__webpack_require__(1137);
__webpack_require__(1138);
__webpack_require__(1139);
__webpack_require__(1145);
__webpack_require__(1140);
__webpack_require__(1141);
__webpack_require__(1142);
__webpack_require__(1143);
__webpack_require__(1144);
__webpack_require__(1146);
__webpack_require__(1147);
__webpack_require__(1148);
__webpack_require__(290);
__webpack_require__(1151);
__webpack_require__(1152);
__webpack_require__(1153);
__webpack_require__(1149);
__webpack_require__(291);
__webpack_require__(1154);
__webpack_require__(1155);
__webpack_require__(1156);
__webpack_require__(292);
__webpack_require__(1157);
__webpack_require__(1158);
__webpack_require__(1159);
__webpack_require__(1126);
__webpack_require__(1127);
__webpack_require__(1160);
__webpack_require__(1161);
__webpack_require__(1150);
__webpack_require__(293);
__webpack_require__(1162);
__webpack_require__(1163);
__webpack_require__(1164);
__webpack_require__(1165);
__webpack_require__(1166);
__webpack_require__(1167);
__webpack_require__(1168);
__webpack_require__(1169);
__webpack_require__(1170);
__webpack_require__(1171);
__webpack_require__(294);
__webpack_require__(1172);
__webpack_require__(1173);
__webpack_require__(1174);
__webpack_require__(1175);
__webpack_require__(1176);
__webpack_require__(1177);
__webpack_require__(1179);
__webpack_require__(1178);
__webpack_require__(1180);
__webpack_require__(1181);
__webpack_require__(1182);
__webpack_require__(1183);
__webpack_require__(295);
__webpack_require__(296);
__webpack_require__(1184);
__webpack_require__(1185);
__webpack_require__(1186);
__webpack_require__(1187);
__webpack_require__(133);
__webpack_require__(1188);
__webpack_require__(1189);
__webpack_require__(1190);
__webpack_require__(1191);
__webpack_require__(1192);
__webpack_require__(1193);
__webpack_require__(297);
__webpack_require__(1194);
__webpack_require__(1195);
__webpack_require__(298);
__webpack_require__(1196);
__webpack_require__(1197);
__webpack_require__(1198);
__webpack_require__(167);
__webpack_require__(1199);
__webpack_require__(1200);
__webpack_require__(1201);
__webpack_require__(1202);
__webpack_require__(1203);
__webpack_require__(1204);
__webpack_require__(1205);
__webpack_require__(1206);
__webpack_require__(299);
__webpack_require__(1207);
__webpack_require__(1208);
__webpack_require__(1209);
__webpack_require__(1210);
__webpack_require__(1211);
__webpack_require__(1212);
__webpack_require__(300);
__webpack_require__(1213);
/* tslint:disable:no-unused-variable */
var Subscription_1 = __webpack_require__(18);
exports.Subscription = Subscription_1.Subscription;
var Subscriber_1 = __webpack_require__(3);
exports.Subscriber = Subscriber_1.Subscriber;
var AsyncSubject_1 = __webpack_require__(165);
exports.AsyncSubject = AsyncSubject_1.AsyncSubject;
var ReplaySubject_1 = __webpack_require__(166);
exports.ReplaySubject = ReplaySubject_1.ReplaySubject;
var BehaviorSubject_1 = __webpack_require__(64);
exports.BehaviorSubject = BehaviorSubject_1.BehaviorSubject;
var ConnectableObservable_1 = __webpack_require__(467);
exports.ConnectableObservable = ConnectableObservable_1.ConnectableObservable;
var Notification_1 = __webpack_require__(125);
exports.Notification = Notification_1.Notification;
var EmptyError_1 = __webpack_require__(132);
exports.EmptyError = EmptyError_1.EmptyError;
var ArgumentOutOfRangeError_1 = __webpack_require__(131);
exports.ArgumentOutOfRangeError = ArgumentOutOfRangeError_1.ArgumentOutOfRangeError;
var ObjectUnsubscribedError_1 = __webpack_require__(171);
exports.ObjectUnsubscribedError = ObjectUnsubscribedError_1.ObjectUnsubscribedError;
var TimeoutError_1 = __webpack_require__(496);
exports.TimeoutError = TimeoutError_1.TimeoutError;
var UnsubscriptionError_1 = __webpack_require__(497);
exports.UnsubscriptionError = UnsubscriptionError_1.UnsubscriptionError;
var timeInterval_1 = __webpack_require__(489);
exports.TimeInterval = timeInterval_1.TimeInterval;
var timestamp_1 = __webpack_require__(490);
exports.Timestamp = timestamp_1.Timestamp;
var TestScheduler_1 = __webpack_require__(1341);
exports.TestScheduler = TestScheduler_1.TestScheduler;
var VirtualTimeScheduler_1 = __webpack_require__(491);
exports.VirtualTimeScheduler = VirtualTimeScheduler_1.VirtualTimeScheduler;
var AjaxObservable_1 = __webpack_require__(470);
exports.AjaxResponse = AjaxObservable_1.AjaxResponse;
exports.AjaxError = AjaxObservable_1.AjaxError;
exports.AjaxTimeoutError = AjaxObservable_1.AjaxTimeoutError;
var asap_1 = __webpack_require__(492);
var async_1 = __webpack_require__(30);
var queue_1 = __webpack_require__(493);
var animationFrame_1 = __webpack_require__(1338);
var rxSubscriber_1 = __webpack_require__(170);
var iterator_1 = __webpack_require__(130);
var observable_1 = __webpack_require__(169);
/* tslint:enable:no-unused-variable */
/**
 * @typedef {Object} Rx.Scheduler
 * @property {Scheduler} queue Schedules on a queue in the current event frame
 * (trampoline scheduler). Use this for iteration operations.
 * @property {Scheduler} asap Schedules on the micro task queue, which uses the
 * fastest transport mechanism available, either Node.js' `process.nextTick()`
 * or Web Worker MessageChannel or setTimeout or others. Use this for
 * asynchronous conversions.
 * @property {Scheduler} async Schedules work with `setInterval`. Use this for
 * time-based operations.
 * @property {Scheduler} animationFrame Schedules work with `requestAnimationFrame`.
 * Use this for synchronizing with the platform's painting
 */
var Scheduler = {
    asap: asap_1.asap,
    queue: queue_1.queue,
    animationFrame: animationFrame_1.animationFrame,
    async: async_1.async
};
exports.Scheduler = Scheduler;
/**
 * @typedef {Object} Rx.Symbol
 * @property {Symbol|string} rxSubscriber A symbol to use as a property name to
 * retrieve an "Rx safe" Observer from an object. "Rx safety" can be defined as
 * an object that has all of the traits of an Rx Subscriber, including the
 * ability to add and remove subscriptions to the subscription chain and
 * guarantees involving event triggering (can't "next" after unsubscription,
 * etc).
 * @property {Symbol|string} observable A symbol to use as a property name to
 * retrieve an Observable as defined by the [ECMAScript "Observable" spec](https://github.com/zenparsing/es-observable).
 * @property {Symbol|string} iterator The ES6 symbol to use as a property name
 * to retrieve an iterator from an object.
 */
var Symbol = {
    rxSubscriber: rxSubscriber_1.rxSubscriber,
    observable: observable_1.observable,
    iterator: iterator_1.iterator
};
exports.Symbol = Symbol;
//# sourceMappingURL=Rx.js.map

/***/ }),
/* 1107 */,
/* 1108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var bindCallback_1 = __webpack_require__(1232);
Observable_1.Observable.bindCallback = bindCallback_1.bindCallback;
//# sourceMappingURL=bindCallback.js.map

/***/ }),
/* 1109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var bindNodeCallback_1 = __webpack_require__(1233);
Observable_1.Observable.bindNodeCallback = bindNodeCallback_1.bindNodeCallback;
//# sourceMappingURL=bindNodeCallback.js.map

/***/ }),
/* 1110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var combineLatest_1 = __webpack_require__(1234);
Observable_1.Observable.combineLatest = combineLatest_1.combineLatest;
//# sourceMappingURL=combineLatest.js.map

/***/ }),
/* 1111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var concat_1 = __webpack_require__(1235);
Observable_1.Observable.concat = concat_1.concat;
//# sourceMappingURL=concat.js.map

/***/ }),
/* 1112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var ajax_1 = __webpack_require__(1238);
Observable_1.Observable.ajax = ajax_1.ajax;
//# sourceMappingURL=ajax.js.map

/***/ }),
/* 1113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var webSocket_1 = __webpack_require__(1239);
Observable_1.Observable.webSocket = webSocket_1.webSocket;
//# sourceMappingURL=webSocket.js.map

/***/ }),
/* 1114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var from_1 = __webpack_require__(472);
Observable_1.Observable.from = from_1.from;
//# sourceMappingURL=from.js.map

/***/ }),
/* 1115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var fromEventPattern_1 = __webpack_require__(1242);
Observable_1.Observable.fromEventPattern = fromEventPattern_1.fromEventPattern;
//# sourceMappingURL=fromEventPattern.js.map

/***/ }),
/* 1116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var fromPromise_1 = __webpack_require__(272);
Observable_1.Observable.fromPromise = fromPromise_1.fromPromise;
//# sourceMappingURL=fromPromise.js.map

/***/ }),
/* 1117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var generate_1 = __webpack_require__(1243);
Observable_1.Observable.generate = generate_1.generate;
//# sourceMappingURL=generate.js.map

/***/ }),
/* 1118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var if_1 = __webpack_require__(1244);
Observable_1.Observable.if = if_1._if;
//# sourceMappingURL=if.js.map

/***/ }),
/* 1119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var interval_1 = __webpack_require__(1245);
Observable_1.Observable.interval = interval_1.interval;
//# sourceMappingURL=interval.js.map

/***/ }),
/* 1120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var never_1 = __webpack_require__(1246);
Observable_1.Observable.never = never_1.never;
//# sourceMappingURL=never.js.map

/***/ }),
/* 1121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var onErrorResumeNext_1 = __webpack_require__(1247);
Observable_1.Observable.onErrorResumeNext = onErrorResumeNext_1.onErrorResumeNext;
//# sourceMappingURL=onErrorResumeNext.js.map

/***/ }),
/* 1122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var pairs_1 = __webpack_require__(1248);
Observable_1.Observable.pairs = pairs_1.pairs;
//# sourceMappingURL=pairs.js.map

/***/ }),
/* 1123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var race_1 = __webpack_require__(1249);
Observable_1.Observable.race = race_1.race;
//# sourceMappingURL=race.js.map

/***/ }),
/* 1124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var using_1 = __webpack_require__(1253);
Observable_1.Observable.using = using_1.using;
//# sourceMappingURL=using.js.map

/***/ }),
/* 1125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var zip_1 = __webpack_require__(1254);
Observable_1.Observable.zip = zip_1.zip;
//# sourceMappingURL=zip.js.map

/***/ }),
/* 1126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var audit_1 = __webpack_require__(1255);
Observable_1.Observable.prototype.audit = audit_1.audit;
//# sourceMappingURL=audit.js.map

/***/ }),
/* 1127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var auditTime_1 = __webpack_require__(1256);
Observable_1.Observable.prototype.auditTime = auditTime_1.auditTime;
//# sourceMappingURL=auditTime.js.map

/***/ }),
/* 1128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var buffer_1 = __webpack_require__(1257);
Observable_1.Observable.prototype.buffer = buffer_1.buffer;
//# sourceMappingURL=buffer.js.map

/***/ }),
/* 1129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var bufferCount_1 = __webpack_require__(1258);
Observable_1.Observable.prototype.bufferCount = bufferCount_1.bufferCount;
//# sourceMappingURL=bufferCount.js.map

/***/ }),
/* 1130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var bufferTime_1 = __webpack_require__(1259);
Observable_1.Observable.prototype.bufferTime = bufferTime_1.bufferTime;
//# sourceMappingURL=bufferTime.js.map

/***/ }),
/* 1131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var bufferToggle_1 = __webpack_require__(1260);
Observable_1.Observable.prototype.bufferToggle = bufferToggle_1.bufferToggle;
//# sourceMappingURL=bufferToggle.js.map

/***/ }),
/* 1132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var bufferWhen_1 = __webpack_require__(1261);
Observable_1.Observable.prototype.bufferWhen = bufferWhen_1.bufferWhen;
//# sourceMappingURL=bufferWhen.js.map

/***/ }),
/* 1133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var combineAll_1 = __webpack_require__(1262);
Observable_1.Observable.prototype.combineAll = combineAll_1.combineAll;
//# sourceMappingURL=combineAll.js.map

/***/ }),
/* 1134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var combineLatest_1 = __webpack_require__(273);
Observable_1.Observable.prototype.combineLatest = combineLatest_1.combineLatest;
//# sourceMappingURL=combineLatest.js.map

/***/ }),
/* 1135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var concat_1 = __webpack_require__(274);
Observable_1.Observable.prototype.concat = concat_1.concat;
//# sourceMappingURL=concat.js.map

/***/ }),
/* 1136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var concatAll_1 = __webpack_require__(476);
Observable_1.Observable.prototype.concatAll = concatAll_1.concatAll;
//# sourceMappingURL=concatAll.js.map

/***/ }),
/* 1137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var concatMap_1 = __webpack_require__(477);
Observable_1.Observable.prototype.concatMap = concatMap_1.concatMap;
//# sourceMappingURL=concatMap.js.map

/***/ }),
/* 1138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var concatMapTo_1 = __webpack_require__(1263);
Observable_1.Observable.prototype.concatMapTo = concatMapTo_1.concatMapTo;
//# sourceMappingURL=concatMapTo.js.map

/***/ }),
/* 1139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var count_1 = __webpack_require__(1264);
Observable_1.Observable.prototype.count = count_1.count;
//# sourceMappingURL=count.js.map

/***/ }),
/* 1140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var debounce_1 = __webpack_require__(1265);
Observable_1.Observable.prototype.debounce = debounce_1.debounce;
//# sourceMappingURL=debounce.js.map

/***/ }),
/* 1141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var debounceTime_1 = __webpack_require__(1266);
Observable_1.Observable.prototype.debounceTime = debounceTime_1.debounceTime;
//# sourceMappingURL=debounceTime.js.map

/***/ }),
/* 1142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var defaultIfEmpty_1 = __webpack_require__(1267);
Observable_1.Observable.prototype.defaultIfEmpty = defaultIfEmpty_1.defaultIfEmpty;
//# sourceMappingURL=defaultIfEmpty.js.map

/***/ }),
/* 1143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var delay_1 = __webpack_require__(1268);
Observable_1.Observable.prototype.delay = delay_1.delay;
//# sourceMappingURL=delay.js.map

/***/ }),
/* 1144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var delayWhen_1 = __webpack_require__(1269);
Observable_1.Observable.prototype.delayWhen = delayWhen_1.delayWhen;
//# sourceMappingURL=delayWhen.js.map

/***/ }),
/* 1145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var dematerialize_1 = __webpack_require__(1270);
Observable_1.Observable.prototype.dematerialize = dematerialize_1.dematerialize;
//# sourceMappingURL=dematerialize.js.map

/***/ }),
/* 1146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var distinct_1 = __webpack_require__(1271);
Observable_1.Observable.prototype.distinct = distinct_1.distinct;
//# sourceMappingURL=distinct.js.map

/***/ }),
/* 1147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var distinctUntilChanged_1 = __webpack_require__(478);
Observable_1.Observable.prototype.distinctUntilChanged = distinctUntilChanged_1.distinctUntilChanged;
//# sourceMappingURL=distinctUntilChanged.js.map

/***/ }),
/* 1148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var distinctUntilKeyChanged_1 = __webpack_require__(1272);
Observable_1.Observable.prototype.distinctUntilKeyChanged = distinctUntilKeyChanged_1.distinctUntilKeyChanged;
//# sourceMappingURL=distinctUntilKeyChanged.js.map

/***/ }),
/* 1149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var elementAt_1 = __webpack_require__(1274);
Observable_1.Observable.prototype.elementAt = elementAt_1.elementAt;
//# sourceMappingURL=elementAt.js.map

/***/ }),
/* 1150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var every_1 = __webpack_require__(479);
Observable_1.Observable.prototype.every = every_1.every;
//# sourceMappingURL=every.js.map

/***/ }),
/* 1151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var exhaust_1 = __webpack_require__(1275);
Observable_1.Observable.prototype.exhaust = exhaust_1.exhaust;
//# sourceMappingURL=exhaust.js.map

/***/ }),
/* 1152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var exhaustMap_1 = __webpack_require__(1276);
Observable_1.Observable.prototype.exhaustMap = exhaustMap_1.exhaustMap;
//# sourceMappingURL=exhaustMap.js.map

/***/ }),
/* 1153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var expand_1 = __webpack_require__(1277);
Observable_1.Observable.prototype.expand = expand_1.expand;
//# sourceMappingURL=expand.js.map

/***/ }),
/* 1154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var finally_1 = __webpack_require__(1278);
Observable_1.Observable.prototype.finally = finally_1._finally;
Observable_1.Observable.prototype._finally = finally_1._finally;
//# sourceMappingURL=finally.js.map

/***/ }),
/* 1155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var find_1 = __webpack_require__(480);
Observable_1.Observable.prototype.find = find_1.find;
//# sourceMappingURL=find.js.map

/***/ }),
/* 1156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var findIndex_1 = __webpack_require__(1279);
Observable_1.Observable.prototype.findIndex = findIndex_1.findIndex;
//# sourceMappingURL=findIndex.js.map

/***/ }),
/* 1157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var groupBy_1 = __webpack_require__(1280);
Observable_1.Observable.prototype.groupBy = groupBy_1.groupBy;
//# sourceMappingURL=groupBy.js.map

/***/ }),
/* 1158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var ignoreElements_1 = __webpack_require__(1281);
Observable_1.Observable.prototype.ignoreElements = ignoreElements_1.ignoreElements;
//# sourceMappingURL=ignoreElements.js.map

/***/ }),
/* 1159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var isEmpty_1 = __webpack_require__(1282);
Observable_1.Observable.prototype.isEmpty = isEmpty_1.isEmpty;
//# sourceMappingURL=isEmpty.js.map

/***/ }),
/* 1160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var last_1 = __webpack_require__(482);
Observable_1.Observable.prototype.last = last_1.last;
//# sourceMappingURL=last.js.map

/***/ }),
/* 1161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var let_1 = __webpack_require__(1283);
Observable_1.Observable.prototype.let = let_1.letProto;
Observable_1.Observable.prototype.letBind = let_1.letProto;
//# sourceMappingURL=let.js.map

/***/ }),
/* 1162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var mapTo_1 = __webpack_require__(1284);
Observable_1.Observable.prototype.mapTo = mapTo_1.mapTo;
//# sourceMappingURL=mapTo.js.map

/***/ }),
/* 1163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var materialize_1 = __webpack_require__(1285);
Observable_1.Observable.prototype.materialize = materialize_1.materialize;
//# sourceMappingURL=materialize.js.map

/***/ }),
/* 1164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var max_1 = __webpack_require__(1286);
Observable_1.Observable.prototype.max = max_1.max;
//# sourceMappingURL=max.js.map

/***/ }),
/* 1165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var merge_1 = __webpack_require__(483);
Observable_1.Observable.prototype.merge = merge_1.merge;
//# sourceMappingURL=merge.js.map

/***/ }),
/* 1166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var mergeAll_1 = __webpack_require__(127);
Observable_1.Observable.prototype.mergeAll = mergeAll_1.mergeAll;
//# sourceMappingURL=mergeAll.js.map

/***/ }),
/* 1167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var mergeMap_1 = __webpack_require__(276);
Observable_1.Observable.prototype.mergeMap = mergeMap_1.mergeMap;
Observable_1.Observable.prototype.flatMap = mergeMap_1.mergeMap;
//# sourceMappingURL=mergeMap.js.map

/***/ }),
/* 1168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var mergeMapTo_1 = __webpack_require__(484);
Observable_1.Observable.prototype.flatMapTo = mergeMapTo_1.mergeMapTo;
Observable_1.Observable.prototype.mergeMapTo = mergeMapTo_1.mergeMapTo;
//# sourceMappingURL=mergeMapTo.js.map

/***/ }),
/* 1169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var mergeScan_1 = __webpack_require__(1287);
Observable_1.Observable.prototype.mergeScan = mergeScan_1.mergeScan;
//# sourceMappingURL=mergeScan.js.map

/***/ }),
/* 1170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var min_1 = __webpack_require__(1288);
Observable_1.Observable.prototype.min = min_1.min;
//# sourceMappingURL=min.js.map

/***/ }),
/* 1171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var multicast_1 = __webpack_require__(92);
Observable_1.Observable.prototype.multicast = multicast_1.multicast;
//# sourceMappingURL=multicast.js.map

/***/ }),
/* 1172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var onErrorResumeNext_1 = __webpack_require__(485);
Observable_1.Observable.prototype.onErrorResumeNext = onErrorResumeNext_1.onErrorResumeNext;
//# sourceMappingURL=onErrorResumeNext.js.map

/***/ }),
/* 1173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var pairwise_1 = __webpack_require__(1289);
Observable_1.Observable.prototype.pairwise = pairwise_1.pairwise;
//# sourceMappingURL=pairwise.js.map

/***/ }),
/* 1174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var partition_1 = __webpack_require__(1290);
Observable_1.Observable.prototype.partition = partition_1.partition;
//# sourceMappingURL=partition.js.map

/***/ }),
/* 1175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var pluck_1 = __webpack_require__(1291);
Observable_1.Observable.prototype.pluck = pluck_1.pluck;
//# sourceMappingURL=pluck.js.map

/***/ }),
/* 1176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var publish_1 = __webpack_require__(1292);
Observable_1.Observable.prototype.publish = publish_1.publish;
//# sourceMappingURL=publish.js.map

/***/ }),
/* 1177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var publishBehavior_1 = __webpack_require__(1293);
Observable_1.Observable.prototype.publishBehavior = publishBehavior_1.publishBehavior;
//# sourceMappingURL=publishBehavior.js.map

/***/ }),
/* 1178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var publishLast_1 = __webpack_require__(1294);
Observable_1.Observable.prototype.publishLast = publishLast_1.publishLast;
//# sourceMappingURL=publishLast.js.map

/***/ }),
/* 1179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var publishReplay_1 = __webpack_require__(1295);
Observable_1.Observable.prototype.publishReplay = publishReplay_1.publishReplay;
//# sourceMappingURL=publishReplay.js.map

/***/ }),
/* 1180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var race_1 = __webpack_require__(486);
Observable_1.Observable.prototype.race = race_1.race;
//# sourceMappingURL=race.js.map

/***/ }),
/* 1181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var reduce_1 = __webpack_require__(168);
Observable_1.Observable.prototype.reduce = reduce_1.reduce;
//# sourceMappingURL=reduce.js.map

/***/ }),
/* 1182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var repeat_1 = __webpack_require__(1296);
Observable_1.Observable.prototype.repeat = repeat_1.repeat;
//# sourceMappingURL=repeat.js.map

/***/ }),
/* 1183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var repeatWhen_1 = __webpack_require__(1297);
Observable_1.Observable.prototype.repeatWhen = repeatWhen_1.repeatWhen;
//# sourceMappingURL=repeatWhen.js.map

/***/ }),
/* 1184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var sample_1 = __webpack_require__(1300);
Observable_1.Observable.prototype.sample = sample_1.sample;
//# sourceMappingURL=sample.js.map

/***/ }),
/* 1185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var sampleTime_1 = __webpack_require__(1301);
Observable_1.Observable.prototype.sampleTime = sampleTime_1.sampleTime;
//# sourceMappingURL=sampleTime.js.map

/***/ }),
/* 1186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var scan_1 = __webpack_require__(1302);
Observable_1.Observable.prototype.scan = scan_1.scan;
//# sourceMappingURL=scan.js.map

/***/ }),
/* 1187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var sequenceEqual_1 = __webpack_require__(1303);
Observable_1.Observable.prototype.sequenceEqual = sequenceEqual_1.sequenceEqual;
//# sourceMappingURL=sequenceEqual.js.map

/***/ }),
/* 1188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var shareReplay_1 = __webpack_require__(1304);
Observable_1.Observable.prototype.shareReplay = shareReplay_1.shareReplay;
//# sourceMappingURL=shareReplay.js.map

/***/ }),
/* 1189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var single_1 = __webpack_require__(1305);
Observable_1.Observable.prototype.single = single_1.single;
//# sourceMappingURL=single.js.map

/***/ }),
/* 1190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var skip_1 = __webpack_require__(1306);
Observable_1.Observable.prototype.skip = skip_1.skip;
//# sourceMappingURL=skip.js.map

/***/ }),
/* 1191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var skipLast_1 = __webpack_require__(1307);
Observable_1.Observable.prototype.skipLast = skipLast_1.skipLast;
//# sourceMappingURL=skipLast.js.map

/***/ }),
/* 1192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var skipUntil_1 = __webpack_require__(1308);
Observable_1.Observable.prototype.skipUntil = skipUntil_1.skipUntil;
//# sourceMappingURL=skipUntil.js.map

/***/ }),
/* 1193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var skipWhile_1 = __webpack_require__(1309);
Observable_1.Observable.prototype.skipWhile = skipWhile_1.skipWhile;
//# sourceMappingURL=skipWhile.js.map

/***/ }),
/* 1194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var subscribeOn_1 = __webpack_require__(1311);
Observable_1.Observable.prototype.subscribeOn = subscribeOn_1.subscribeOn;
//# sourceMappingURL=subscribeOn.js.map

/***/ }),
/* 1195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var switch_1 = __webpack_require__(1312);
Observable_1.Observable.prototype.switch = switch_1._switch;
Observable_1.Observable.prototype._switch = switch_1._switch;
//# sourceMappingURL=switch.js.map

/***/ }),
/* 1196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var switchMapTo_1 = __webpack_require__(1314);
Observable_1.Observable.prototype.switchMapTo = switchMapTo_1.switchMapTo;
//# sourceMappingURL=switchMapTo.js.map

/***/ }),
/* 1197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var take_1 = __webpack_require__(1315);
Observable_1.Observable.prototype.take = take_1.take;
//# sourceMappingURL=take.js.map

/***/ }),
/* 1198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var takeLast_1 = __webpack_require__(1316);
Observable_1.Observable.prototype.takeLast = takeLast_1.takeLast;
//# sourceMappingURL=takeLast.js.map

/***/ }),
/* 1199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var takeWhile_1 = __webpack_require__(1318);
Observable_1.Observable.prototype.takeWhile = takeWhile_1.takeWhile;
//# sourceMappingURL=takeWhile.js.map

/***/ }),
/* 1200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var throttle_1 = __webpack_require__(488);
Observable_1.Observable.prototype.throttle = throttle_1.throttle;
//# sourceMappingURL=throttle.js.map

/***/ }),
/* 1201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var throttleTime_1 = __webpack_require__(1319);
Observable_1.Observable.prototype.throttleTime = throttleTime_1.throttleTime;
//# sourceMappingURL=throttleTime.js.map

/***/ }),
/* 1202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var timeInterval_1 = __webpack_require__(489);
Observable_1.Observable.prototype.timeInterval = timeInterval_1.timeInterval;
//# sourceMappingURL=timeInterval.js.map

/***/ }),
/* 1203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var timeout_1 = __webpack_require__(1320);
Observable_1.Observable.prototype.timeout = timeout_1.timeout;
//# sourceMappingURL=timeout.js.map

/***/ }),
/* 1204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var timeoutWith_1 = __webpack_require__(1321);
Observable_1.Observable.prototype.timeoutWith = timeoutWith_1.timeoutWith;
//# sourceMappingURL=timeoutWith.js.map

/***/ }),
/* 1205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var timestamp_1 = __webpack_require__(490);
Observable_1.Observable.prototype.timestamp = timestamp_1.timestamp;
//# sourceMappingURL=timestamp.js.map

/***/ }),
/* 1206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var toArray_1 = __webpack_require__(1322);
Observable_1.Observable.prototype.toArray = toArray_1.toArray;
//# sourceMappingURL=toArray.js.map

/***/ }),
/* 1207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var window_1 = __webpack_require__(1324);
Observable_1.Observable.prototype.window = window_1.window;
//# sourceMappingURL=window.js.map

/***/ }),
/* 1208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var windowCount_1 = __webpack_require__(1325);
Observable_1.Observable.prototype.windowCount = windowCount_1.windowCount;
//# sourceMappingURL=windowCount.js.map

/***/ }),
/* 1209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var windowTime_1 = __webpack_require__(1326);
Observable_1.Observable.prototype.windowTime = windowTime_1.windowTime;
//# sourceMappingURL=windowTime.js.map

/***/ }),
/* 1210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var windowToggle_1 = __webpack_require__(1327);
Observable_1.Observable.prototype.windowToggle = windowToggle_1.windowToggle;
//# sourceMappingURL=windowToggle.js.map

/***/ }),
/* 1211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var windowWhen_1 = __webpack_require__(1328);
Observable_1.Observable.prototype.windowWhen = windowWhen_1.windowWhen;
//# sourceMappingURL=windowWhen.js.map

/***/ }),
/* 1212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var withLatestFrom_1 = __webpack_require__(1329);
Observable_1.Observable.prototype.withLatestFrom = withLatestFrom_1.withLatestFrom;
//# sourceMappingURL=withLatestFrom.js.map

/***/ }),
/* 1213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var zipAll_1 = __webpack_require__(1330);
Observable_1.Observable.prototype.zipAll = zipAll_1.zipAll;
//# sourceMappingURL=zipAll.js.map

/***/ }),
/* 1214 */,
/* 1215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Observable_1 = __webpack_require__(0);
var tryCatch_1 = __webpack_require__(25);
var errorObject_1 = __webpack_require__(22);
var AsyncSubject_1 = __webpack_require__(165);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var BoundCallbackObservable = (function (_super) {
    __extends(BoundCallbackObservable, _super);
    function BoundCallbackObservable(callbackFunc, selector, args, context, scheduler) {
        _super.call(this);
        this.callbackFunc = callbackFunc;
        this.selector = selector;
        this.args = args;
        this.context = context;
        this.scheduler = scheduler;
    }
    /* tslint:enable:max-line-length */
    /**
     * Converts a callback API to a function that returns an Observable.
     *
     * <span class="informal">Give it a function `f` of type `f(x, callback)` and
     * it will return a function `g` that when called as `g(x)` will output an
     * Observable.</span>
     *
     * `bindCallback` is not an operator because its input and output are not
     * Observables. The input is a function `func` with some parameters, but the
     * last parameter must be a callback function that `func` calls when it is
     * done.
     *
     * The output of `bindCallback` is a function that takes the same parameters
     * as `func`, except the last one (the callback). When the output function
     * is called with arguments, it will return an Observable. If `func` function
     * calls its callback with one argument, the Observable will emit that value.
     * If on the other hand callback is called with multiple values, resulting
     * Observable will emit an array with these arguments.
     *
     * It is very important to remember, that input function `func` is not called
     * when output function is, but rather when Observable returned by output
     * function is subscribed. This means if `func` makes AJAX request, that request
     * will be made every time someone subscribes to resulting Observable, but not before.
     *
     * Optionally, selector function can be passed to `bindObservable`. That function
     * takes the same arguments as callback, and returns value
     * that will be emitted by Observable instead of callback parameters themselves.
     * Even though by default multiple arguments passed to callback appear in the stream as array,
     * selector function will be called with arguments directly, just as callback would.
     * This means you can imagine default selector (when one is not provided explicitly)
     * as function that aggregates all its arguments into array, or simply returns first argument,
     * if there is only one.
     *
     * Last optional parameter - {@link Scheduler} - can be used to control when call
     * to `func` happens after someone subscribes to Observable, as well as when results
     * passed to callback will be emitted. By default subscription to Observable calls `func`
     * synchronously, but using `Scheduler.async` as last parameter will defer call to input function,
     * just like wrapping that call in `setTimeout` with time `0` would. So if you use async Scheduler
     * and call `subscribe` on output Observable, all function calls that are currently executing,
     * will end before `func` is invoked.
     *
     * When it comes to emitting results passed to callback, by default they are emitted
     * immediately after `func` invokes callback. In particular, if callback is called synchronously,
     * then subscription to resulting Observable will call `next` function synchronously as well.
     * If you want to defer that call, using `Scheduler.async` will, again, do the job.
     * This means that by using `Scheduler.async` you can, in a sense, ensure that `func`
     * always calls its callback asynchronously, thus avoiding terrifying Zalgo.
     *
     * Note that Observable created by output function will always emit only one value
     * and then complete right after. Even if `func` calls callback multiple times, values from
     * second and following calls will never appear in the stream. If you need to
     * listen for multiple calls, you probably want to use {@link fromEvent} or
     * {@link fromEventPattern} instead.
     *
     * If `func` depends on some context (`this` property), that context will be set
     * to the same context that output function has at call time. In particular, if `func`
     * is called as method of some object, in order to preserve proper behaviour,
     * it is recommended to set context of output function to that object as well,
     * provided `func` is not already bound.
     *
     * If input function calls its callback in "node style" (i.e. first argument to callback is
     * optional error parameter signaling whether call failed or not), {@link bindNodeCallback}
     * provides convenient error handling and probably is a better choice.
     * `bindCallback` will treat such functions without any difference and error parameter
     * (whether passed or not) will always be interpreted as regular callback argument.
     *
     *
     * @example <caption>Convert jQuery's getJSON to an Observable API</caption>
     * // Suppose we have jQuery.getJSON('/my/url', callback)
     * var getJSONAsObservable = Rx.Observable.bindCallback(jQuery.getJSON);
     * var result = getJSONAsObservable('/my/url');
     * result.subscribe(x => console.log(x), e => console.error(e));
     *
     *
     * @example <caption>Receive array of arguments passed to callback</caption>
     * someFunction((a, b, c) => {
     *   console.log(a); // 5
     *   console.log(b); // 'some string'
     *   console.log(c); // {someProperty: 'someValue'}
     * });
     *
     * const boundSomeFunction = Rx.Observable.bindCallback(someFunction);
     * boundSomeFunction().subscribe(values => {
     *   console.log(values) // [5, 'some string', {someProperty: 'someValue'}]
     * });
     *
     *
     * @example <caption>Use bindCallback with selector function</caption>
     * someFunction((a, b, c) => {
     *   console.log(a); // 'a'
     *   console.log(b); // 'b'
     *   console.log(c); // 'c'
     * });
     *
     * const boundSomeFunction = Rx.Observable.bindCallback(someFunction, (a, b, c) => a + b + c);
     * boundSomeFunction().subscribe(value => {
     *   console.log(value) // 'abc'
     * });
     *
     *
     * @example <caption>Compare behaviour with and without async Scheduler</caption>
     * function iCallMyCallbackSynchronously(cb) {
     *   cb();
     * }
     *
     * const boundSyncFn = Rx.Observable.bindCallback(iCallMyCallbackSynchronously);
     * const boundAsyncFn = Rx.Observable.bindCallback(iCallMyCallbackSynchronously, null, Rx.Scheduler.async);
     *
     * boundSyncFn().subscribe(() => console.log('I was sync!'));
     * boundAsyncFn().subscribe(() => console.log('I was async!'));
     * console.log('This happened...');
     *
     * // Logs:
     * // I was sync!
     * // This happened...
     * // I was async!
     *
     *
     * @example <caption>Use bindCallback on object method</caption>
     * const boundMethod = Rx.Observable.bindCallback(someObject.methodWithCallback);
     * boundMethod.call(someObject) // make sure methodWithCallback has access to someObject
     * .subscribe(subscriber);
     *
     *
     * @see {@link bindNodeCallback}
     * @see {@link from}
     * @see {@link fromPromise}
     *
     * @param {function} func Function with a callback as the last parameter.
     * @param {function} [selector] A function which takes the arguments from the
     * callback and maps those to a value to emit on the output Observable.
     * @param {Scheduler} [scheduler] The scheduler on which to schedule the
     * callbacks.
     * @return {function(...params: *): Observable} A function which returns the
     * Observable that delivers the same values the callback would deliver.
     * @static true
     * @name bindCallback
     * @owner Observable
     */
    BoundCallbackObservable.create = function (func, selector, scheduler) {
        if (selector === void 0) { selector = undefined; }
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i - 0] = arguments[_i];
            }
            return new BoundCallbackObservable(func, selector, args, this, scheduler);
        };
    };
    BoundCallbackObservable.prototype._subscribe = function (subscriber) {
        var callbackFunc = this.callbackFunc;
        var args = this.args;
        var scheduler = this.scheduler;
        var subject = this.subject;
        if (!scheduler) {
            if (!subject) {
                subject = this.subject = new AsyncSubject_1.AsyncSubject();
                var handler = function handlerFn() {
                    var innerArgs = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        innerArgs[_i - 0] = arguments[_i];
                    }
                    var source = handlerFn.source;
                    var selector = source.selector, subject = source.subject;
                    if (selector) {
                        var result_1 = tryCatch_1.tryCatch(selector).apply(this, innerArgs);
                        if (result_1 === errorObject_1.errorObject) {
                            subject.error(errorObject_1.errorObject.e);
                        }
                        else {
                            subject.next(result_1);
                            subject.complete();
                        }
                    }
                    else {
                        subject.next(innerArgs.length <= 1 ? innerArgs[0] : innerArgs);
                        subject.complete();
                    }
                };
                // use named function instance to avoid closure.
                handler.source = this;
                var result = tryCatch_1.tryCatch(callbackFunc).apply(this.context, args.concat(handler));
                if (result === errorObject_1.errorObject) {
                    subject.error(errorObject_1.errorObject.e);
                }
            }
            return subject.subscribe(subscriber);
        }
        else {
            return scheduler.schedule(BoundCallbackObservable.dispatch, 0, { source: this, subscriber: subscriber, context: this.context });
        }
    };
    BoundCallbackObservable.dispatch = function (state) {
        var self = this;
        var source = state.source, subscriber = state.subscriber, context = state.context;
        var callbackFunc = source.callbackFunc, args = source.args, scheduler = source.scheduler;
        var subject = source.subject;
        if (!subject) {
            subject = source.subject = new AsyncSubject_1.AsyncSubject();
            var handler = function handlerFn() {
                var innerArgs = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    innerArgs[_i - 0] = arguments[_i];
                }
                var source = handlerFn.source;
                var selector = source.selector, subject = source.subject;
                if (selector) {
                    var result_2 = tryCatch_1.tryCatch(selector).apply(this, innerArgs);
                    if (result_2 === errorObject_1.errorObject) {
                        self.add(scheduler.schedule(dispatchError, 0, { err: errorObject_1.errorObject.e, subject: subject }));
                    }
                    else {
                        self.add(scheduler.schedule(dispatchNext, 0, { value: result_2, subject: subject }));
                    }
                }
                else {
                    var value = innerArgs.length <= 1 ? innerArgs[0] : innerArgs;
                    self.add(scheduler.schedule(dispatchNext, 0, { value: value, subject: subject }));
                }
            };
            // use named function to pass values in without closure
            handler.source = source;
            var result = tryCatch_1.tryCatch(callbackFunc).apply(context, args.concat(handler));
            if (result === errorObject_1.errorObject) {
                subject.error(errorObject_1.errorObject.e);
            }
        }
        self.add(subject.subscribe(subscriber));
    };
    return BoundCallbackObservable;
}(Observable_1.Observable));
exports.BoundCallbackObservable = BoundCallbackObservable;
function dispatchNext(arg) {
    var value = arg.value, subject = arg.subject;
    subject.next(value);
    subject.complete();
}
function dispatchError(arg) {
    var err = arg.err, subject = arg.subject;
    subject.error(err);
}
//# sourceMappingURL=BoundCallbackObservable.js.map

/***/ }),
/* 1216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Observable_1 = __webpack_require__(0);
var tryCatch_1 = __webpack_require__(25);
var errorObject_1 = __webpack_require__(22);
var AsyncSubject_1 = __webpack_require__(165);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var BoundNodeCallbackObservable = (function (_super) {
    __extends(BoundNodeCallbackObservable, _super);
    function BoundNodeCallbackObservable(callbackFunc, selector, args, context, scheduler) {
        _super.call(this);
        this.callbackFunc = callbackFunc;
        this.selector = selector;
        this.args = args;
        this.context = context;
        this.scheduler = scheduler;
    }
    /* tslint:enable:max-line-length */
    /**
     * Converts a Node.js-style callback API to a function that returns an
     * Observable.
     *
     * <span class="informal">It's just like {@link bindCallback}, but the
     * callback is expected to be of type `callback(error, result)`.</span>
     *
     * `bindNodeCallback` is not an operator because its input and output are not
     * Observables. The input is a function `func` with some parameters, but the
     * last parameter must be a callback function that `func` calls when it is
     * done. The callback function is expected to follow Node.js conventions,
     * where the first argument to the callback is an error object, signaling
     * whether call was successful. If that object is passed to callback, it means
     * something went wrong.
     *
     * The output of `bindNodeCallback` is a function that takes the same
     * parameters as `func`, except the last one (the callback). When the output
     * function is called with arguments, it will return an Observable.
     * If `func` calls its callback with error parameter present, Observable will
     * error with that value as well. If error parameter is not passed, Observable will emit
     * second parameter. If there are more parameters (third and so on),
     * Observable will emit an array with all arguments, except first error argument.
     *
     * Optionally `bindNodeCallback` accepts selector function, which allows you to
     * make resulting Observable emit value computed by selector, instead of regular
     * callback arguments. It works similarly to {@link bindCallback} selector, but
     * Node.js-style error argument will never be passed to that function.
     *
     * Note that `func` will not be called at the same time output function is,
     * but rather whenever resulting Observable is subscribed. By default call to
     * `func` will happen synchronously after subscription, but that can be changed
     * with proper {@link Scheduler} provided as optional third parameter. Scheduler
     * can also control when values from callback will be emitted by Observable.
     * To find out more, check out documentation for {@link bindCallback}, where
     * Scheduler works exactly the same.
     *
     * As in {@link bindCallback}, context (`this` property) of input function will be set to context
     * of returned function, when it is called.
     *
     * After Observable emits value, it will complete immediately. This means
     * even if `func` calls callback again, values from second and consecutive
     * calls will never appear on the stream. If you need to handle functions
     * that call callbacks multiple times, check out {@link fromEvent} or
     * {@link fromEventPattern} instead.
     *
     * Note that `bindNodeCallback` can be used in non-Node.js environments as well.
     * "Node.js-style" callbacks are just a convention, so if you write for
     * browsers or any other environment and API you use implements that callback style,
     * `bindNodeCallback` can be safely used on that API functions as well.
     *
     * Remember that Error object passed to callback does not have to be an instance
     * of JavaScript built-in `Error` object. In fact, it does not even have to an object.
     * Error parameter of callback function is interpreted as "present", when value
     * of that parameter is truthy. It could be, for example, non-zero number, non-empty
     * string or boolean `true`. In all of these cases resulting Observable would error
     * with that value. This means usually regular style callbacks will fail very often when
     * `bindNodeCallback` is used. If your Observable errors much more often then you
     * would expect, check if callback really is called in Node.js-style and, if not,
     * switch to {@link bindCallback} instead.
     *
     * Note that even if error parameter is technically present in callback, but its value
     * is falsy, it still won't appear in array emitted by Observable or in selector function.
     *
     *
     * @example <caption>Read a file from the filesystem and get the data as an Observable</caption>
     * import * as fs from 'fs';
     * var readFileAsObservable = Rx.Observable.bindNodeCallback(fs.readFile);
     * var result = readFileAsObservable('./roadNames.txt', 'utf8');
     * result.subscribe(x => console.log(x), e => console.error(e));
     *
     *
     * @example <caption>Use on function calling callback with multiple arguments</caption>
     * someFunction((err, a, b) => {
     *   console.log(err); // null
     *   console.log(a); // 5
     *   console.log(b); // "some string"
     * });
     * var boundSomeFunction = Rx.Observable.bindNodeCallback(someFunction);
     * boundSomeFunction()
     * .subscribe(value => {
     *   console.log(value); // [5, "some string"]
     * });
     *
     *
     * @example <caption>Use with selector function</caption>
     * someFunction((err, a, b) => {
     *   console.log(err); // undefined
     *   console.log(a); // "abc"
     *   console.log(b); // "DEF"
     * });
     * var boundSomeFunction = Rx.Observable.bindNodeCallback(someFunction, (a, b) => a + b);
     * boundSomeFunction()
     * .subscribe(value => {
     *   console.log(value); // "abcDEF"
     * });
     *
     *
     * @example <caption>Use on function calling callback in regular style</caption>
     * someFunction(a => {
     *   console.log(a); // 5
     * });
     * var boundSomeFunction = Rx.Observable.bindNodeCallback(someFunction);
     * boundSomeFunction()
     * .subscribe(
     *   value => {}             // never gets called
     *   err => console.log(err) // 5
     *);
     *
     *
     * @see {@link bindCallback}
     * @see {@link from}
     * @see {@link fromPromise}
     *
     * @param {function} func Function with a Node.js-style callback as the last parameter.
     * @param {function} [selector] A function which takes the arguments from the
     * callback and maps those to a value to emit on the output Observable.
     * @param {Scheduler} [scheduler] The scheduler on which to schedule the
     * callbacks.
     * @return {function(...params: *): Observable} A function which returns the
     * Observable that delivers the same values the Node.js callback would
     * deliver.
     * @static true
     * @name bindNodeCallback
     * @owner Observable
     */
    BoundNodeCallbackObservable.create = function (func, selector, scheduler) {
        if (selector === void 0) { selector = undefined; }
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i - 0] = arguments[_i];
            }
            return new BoundNodeCallbackObservable(func, selector, args, this, scheduler);
        };
    };
    BoundNodeCallbackObservable.prototype._subscribe = function (subscriber) {
        var callbackFunc = this.callbackFunc;
        var args = this.args;
        var scheduler = this.scheduler;
        var subject = this.subject;
        if (!scheduler) {
            if (!subject) {
                subject = this.subject = new AsyncSubject_1.AsyncSubject();
                var handler = function handlerFn() {
                    var innerArgs = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        innerArgs[_i - 0] = arguments[_i];
                    }
                    var source = handlerFn.source;
                    var selector = source.selector, subject = source.subject;
                    var err = innerArgs.shift();
                    if (err) {
                        subject.error(err);
                    }
                    else if (selector) {
                        var result_1 = tryCatch_1.tryCatch(selector).apply(this, innerArgs);
                        if (result_1 === errorObject_1.errorObject) {
                            subject.error(errorObject_1.errorObject.e);
                        }
                        else {
                            subject.next(result_1);
                            subject.complete();
                        }
                    }
                    else {
                        subject.next(innerArgs.length <= 1 ? innerArgs[0] : innerArgs);
                        subject.complete();
                    }
                };
                // use named function instance to avoid closure.
                handler.source = this;
                var result = tryCatch_1.tryCatch(callbackFunc).apply(this.context, args.concat(handler));
                if (result === errorObject_1.errorObject) {
                    subject.error(errorObject_1.errorObject.e);
                }
            }
            return subject.subscribe(subscriber);
        }
        else {
            return scheduler.schedule(dispatch, 0, { source: this, subscriber: subscriber, context: this.context });
        }
    };
    return BoundNodeCallbackObservable;
}(Observable_1.Observable));
exports.BoundNodeCallbackObservable = BoundNodeCallbackObservable;
function dispatch(state) {
    var self = this;
    var source = state.source, subscriber = state.subscriber, context = state.context;
    // XXX: cast to `any` to access to the private field in `source`.
    var _a = source, callbackFunc = _a.callbackFunc, args = _a.args, scheduler = _a.scheduler;
    var subject = source.subject;
    if (!subject) {
        subject = source.subject = new AsyncSubject_1.AsyncSubject();
        var handler = function handlerFn() {
            var innerArgs = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                innerArgs[_i - 0] = arguments[_i];
            }
            var source = handlerFn.source;
            var selector = source.selector, subject = source.subject;
            var err = innerArgs.shift();
            if (err) {
                self.add(scheduler.schedule(dispatchError, 0, { err: err, subject: subject }));
            }
            else if (selector) {
                var result_2 = tryCatch_1.tryCatch(selector).apply(this, innerArgs);
                if (result_2 === errorObject_1.errorObject) {
                    self.add(scheduler.schedule(dispatchError, 0, { err: errorObject_1.errorObject.e, subject: subject }));
                }
                else {
                    self.add(scheduler.schedule(dispatchNext, 0, { value: result_2, subject: subject }));
                }
            }
            else {
                var value = innerArgs.length <= 1 ? innerArgs[0] : innerArgs;
                self.add(scheduler.schedule(dispatchNext, 0, { value: value, subject: subject }));
            }
        };
        // use named function to pass values in without closure
        handler.source = source;
        var result = tryCatch_1.tryCatch(callbackFunc).apply(context, args.concat(handler));
        if (result === errorObject_1.errorObject) {
            self.add(scheduler.schedule(dispatchError, 0, { err: errorObject_1.errorObject.e, subject: subject }));
        }
    }
    self.add(subject.subscribe(subscriber));
}
function dispatchNext(arg) {
    var value = arg.value, subject = arg.subject;
    subject.next(value);
    subject.complete();
}
function dispatchError(arg) {
    var err = arg.err, subject = arg.subject;
    subject.error(err);
}
//# sourceMappingURL=BoundNodeCallbackObservable.js.map

/***/ }),
/* 1217 */,
/* 1218 */,
/* 1219 */,
/* 1220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Observable_1 = __webpack_require__(0);
var tryCatch_1 = __webpack_require__(25);
var isFunction_1 = __webpack_require__(173);
var errorObject_1 = __webpack_require__(22);
var Subscription_1 = __webpack_require__(18);
var toString = Object.prototype.toString;
function isNodeStyleEventEmitter(sourceObj) {
    return !!sourceObj && typeof sourceObj.addListener === 'function' && typeof sourceObj.removeListener === 'function';
}
function isJQueryStyleEventEmitter(sourceObj) {
    return !!sourceObj && typeof sourceObj.on === 'function' && typeof sourceObj.off === 'function';
}
function isNodeList(sourceObj) {
    return !!sourceObj && toString.call(sourceObj) === '[object NodeList]';
}
function isHTMLCollection(sourceObj) {
    return !!sourceObj && toString.call(sourceObj) === '[object HTMLCollection]';
}
function isEventTarget(sourceObj) {
    return !!sourceObj && typeof sourceObj.addEventListener === 'function' && typeof sourceObj.removeEventListener === 'function';
}
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var FromEventObservable = (function (_super) {
    __extends(FromEventObservable, _super);
    function FromEventObservable(sourceObj, eventName, selector, options) {
        _super.call(this);
        this.sourceObj = sourceObj;
        this.eventName = eventName;
        this.selector = selector;
        this.options = options;
    }
    /* tslint:enable:max-line-length */
    /**
     * Creates an Observable that emits events of a specific type coming from the
     * given event target.
     *
     * <span class="informal">Creates an Observable from DOM events, or Node
     * EventEmitter events or others.</span>
     *
     * <img src="./img/fromEvent.png" width="100%">
     *
     * Creates an Observable by attaching an event listener to an "event target",
     * which may be an object with `addEventListener` and `removeEventListener`,
     * a Node.js EventEmitter, a jQuery style EventEmitter, a NodeList from the
     * DOM, or an HTMLCollection from the DOM. The event handler is attached when
     * the output Observable is subscribed, and removed when the Subscription is
     * unsubscribed.
     *
     * @example <caption>Emits clicks happening on the DOM document</caption>
     * var clicks = Rx.Observable.fromEvent(document, 'click');
     * clicks.subscribe(x => console.log(x));
     *
     * // Results in:
     * // MouseEvent object logged to console everytime a click
     * // occurs on the document.
     *
     * @see {@link from}
     * @see {@link fromEventPattern}
     *
     * @param {EventTargetLike} target The DOMElement, event target, Node.js
     * EventEmitter, NodeList or HTMLCollection to attach the event handler to.
     * @param {string} eventName The event name of interest, being emitted by the
     * `target`.
     * @param {EventListenerOptions} [options] Options to pass through to addEventListener
     * @param {SelectorMethodSignature<T>} [selector] An optional function to
     * post-process results. It takes the arguments from the event handler and
     * should return a single value.
     * @return {Observable<T>}
     * @static true
     * @name fromEvent
     * @owner Observable
     */
    FromEventObservable.create = function (target, eventName, options, selector) {
        if (isFunction_1.isFunction(options)) {
            selector = options;
            options = undefined;
        }
        return new FromEventObservable(target, eventName, selector, options);
    };
    FromEventObservable.setupSubscription = function (sourceObj, eventName, handler, subscriber, options) {
        var unsubscribe;
        if (isNodeList(sourceObj) || isHTMLCollection(sourceObj)) {
            for (var i = 0, len = sourceObj.length; i < len; i++) {
                FromEventObservable.setupSubscription(sourceObj[i], eventName, handler, subscriber, options);
            }
        }
        else if (isEventTarget(sourceObj)) {
            var source_1 = sourceObj;
            sourceObj.addEventListener(eventName, handler, options);
            unsubscribe = function () { return source_1.removeEventListener(eventName, handler); };
        }
        else if (isJQueryStyleEventEmitter(sourceObj)) {
            var source_2 = sourceObj;
            sourceObj.on(eventName, handler);
            unsubscribe = function () { return source_2.off(eventName, handler); };
        }
        else if (isNodeStyleEventEmitter(sourceObj)) {
            var source_3 = sourceObj;
            sourceObj.addListener(eventName, handler);
            unsubscribe = function () { return source_3.removeListener(eventName, handler); };
        }
        else {
            throw new TypeError('Invalid event target');
        }
        subscriber.add(new Subscription_1.Subscription(unsubscribe));
    };
    FromEventObservable.prototype._subscribe = function (subscriber) {
        var sourceObj = this.sourceObj;
        var eventName = this.eventName;
        var options = this.options;
        var selector = this.selector;
        var handler = selector ? function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i - 0] = arguments[_i];
            }
            var result = tryCatch_1.tryCatch(selector).apply(void 0, args);
            if (result === errorObject_1.errorObject) {
                subscriber.error(errorObject_1.errorObject.e);
            }
            else {
                subscriber.next(result);
            }
        } : function (e) { return subscriber.next(e); };
        FromEventObservable.setupSubscription(sourceObj, eventName, handler, subscriber, options);
    };
    return FromEventObservable;
}(Observable_1.Observable));
exports.FromEventObservable = FromEventObservable;
//# sourceMappingURL=FromEventObservable.js.map

/***/ }),
/* 1221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var isFunction_1 = __webpack_require__(173);
var Observable_1 = __webpack_require__(0);
var Subscription_1 = __webpack_require__(18);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var FromEventPatternObservable = (function (_super) {
    __extends(FromEventPatternObservable, _super);
    function FromEventPatternObservable(addHandler, removeHandler, selector) {
        _super.call(this);
        this.addHandler = addHandler;
        this.removeHandler = removeHandler;
        this.selector = selector;
    }
    /**
     * Creates an Observable from an API based on addHandler/removeHandler
     * functions.
     *
     * <span class="informal">Converts any addHandler/removeHandler API to an
     * Observable.</span>
     *
     * <img src="./img/fromEventPattern.png" width="100%">
     *
     * Creates an Observable by using the `addHandler` and `removeHandler`
     * functions to add and remove the handlers, with an optional selector
     * function to project the event arguments to a result. The `addHandler` is
     * called when the output Observable is subscribed, and `removeHandler` is
     * called when the Subscription is unsubscribed.
     *
     * @example <caption>Emits clicks happening on the DOM document</caption>
     * function addClickHandler(handler) {
     *   document.addEventListener('click', handler);
     * }
     *
     * function removeClickHandler(handler) {
     *   document.removeEventListener('click', handler);
     * }
     *
     * var clicks = Rx.Observable.fromEventPattern(
     *   addClickHandler,
     *   removeClickHandler
     * );
     * clicks.subscribe(x => console.log(x));
     *
     * @see {@link from}
     * @see {@link fromEvent}
     *
     * @param {function(handler: Function): any} addHandler A function that takes
     * a `handler` function as argument and attaches it somehow to the actual
     * source of events.
     * @param {function(handler: Function, signal?: any): void} [removeHandler] An optional function that
     * takes a `handler` function as argument and removes it in case it was
     * previously attached using `addHandler`. if addHandler returns signal to teardown when remove,
     * removeHandler function will forward it.
     * @param {function(...args: any): T} [selector] An optional function to
     * post-process results. It takes the arguments from the event handler and
     * should return a single value.
     * @return {Observable<T>}
     * @static true
     * @name fromEventPattern
     * @owner Observable
     */
    FromEventPatternObservable.create = function (addHandler, removeHandler, selector) {
        return new FromEventPatternObservable(addHandler, removeHandler, selector);
    };
    FromEventPatternObservable.prototype._subscribe = function (subscriber) {
        var _this = this;
        var removeHandler = this.removeHandler;
        var handler = !!this.selector ? function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i - 0] = arguments[_i];
            }
            _this._callSelector(subscriber, args);
        } : function (e) { subscriber.next(e); };
        var retValue = this._callAddHandler(handler, subscriber);
        if (!isFunction_1.isFunction(removeHandler)) {
            return;
        }
        subscriber.add(new Subscription_1.Subscription(function () {
            //TODO: determine whether or not to forward to error handler
            removeHandler(handler, retValue);
        }));
    };
    FromEventPatternObservable.prototype._callSelector = function (subscriber, args) {
        try {
            var result = this.selector.apply(this, args);
            subscriber.next(result);
        }
        catch (e) {
            subscriber.error(e);
        }
    };
    FromEventPatternObservable.prototype._callAddHandler = function (handler, errorSubscriber) {
        try {
            return this.addHandler(handler) || null;
        }
        catch (e) {
            errorSubscriber.error(e);
        }
    };
    return FromEventPatternObservable;
}(Observable_1.Observable));
exports.FromEventPatternObservable = FromEventPatternObservable;
//# sourceMappingURL=FromEventPatternObservable.js.map

/***/ }),
/* 1222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Observable_1 = __webpack_require__(0);
var isScheduler_1 = __webpack_require__(63);
var selfSelector = function (value) { return value; };
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var GenerateObservable = (function (_super) {
    __extends(GenerateObservable, _super);
    function GenerateObservable(initialState, condition, iterate, resultSelector, scheduler) {
        _super.call(this);
        this.initialState = initialState;
        this.condition = condition;
        this.iterate = iterate;
        this.resultSelector = resultSelector;
        this.scheduler = scheduler;
    }
    GenerateObservable.create = function (initialStateOrOptions, condition, iterate, resultSelectorOrObservable, scheduler) {
        if (arguments.length == 1) {
            return new GenerateObservable(initialStateOrOptions.initialState, initialStateOrOptions.condition, initialStateOrOptions.iterate, initialStateOrOptions.resultSelector || selfSelector, initialStateOrOptions.scheduler);
        }
        if (resultSelectorOrObservable === undefined || isScheduler_1.isScheduler(resultSelectorOrObservable)) {
            return new GenerateObservable(initialStateOrOptions, condition, iterate, selfSelector, resultSelectorOrObservable);
        }
        return new GenerateObservable(initialStateOrOptions, condition, iterate, resultSelectorOrObservable, scheduler);
    };
    GenerateObservable.prototype._subscribe = function (subscriber) {
        var state = this.initialState;
        if (this.scheduler) {
            return this.scheduler.schedule(GenerateObservable.dispatch, 0, {
                subscriber: subscriber,
                iterate: this.iterate,
                condition: this.condition,
                resultSelector: this.resultSelector,
                state: state });
        }
        var _a = this, condition = _a.condition, resultSelector = _a.resultSelector, iterate = _a.iterate;
        do {
            if (condition) {
                var conditionResult = void 0;
                try {
                    conditionResult = condition(state);
                }
                catch (err) {
                    subscriber.error(err);
                    return;
                }
                if (!conditionResult) {
                    subscriber.complete();
                    break;
                }
            }
            var value = void 0;
            try {
                value = resultSelector(state);
            }
            catch (err) {
                subscriber.error(err);
                return;
            }
            subscriber.next(value);
            if (subscriber.closed) {
                break;
            }
            try {
                state = iterate(state);
            }
            catch (err) {
                subscriber.error(err);
                return;
            }
        } while (true);
    };
    GenerateObservable.dispatch = function (state) {
        var subscriber = state.subscriber, condition = state.condition;
        if (subscriber.closed) {
            return;
        }
        if (state.needIterate) {
            try {
                state.state = state.iterate(state.state);
            }
            catch (err) {
                subscriber.error(err);
                return;
            }
        }
        else {
            state.needIterate = true;
        }
        if (condition) {
            var conditionResult = void 0;
            try {
                conditionResult = condition(state.state);
            }
            catch (err) {
                subscriber.error(err);
                return;
            }
            if (!conditionResult) {
                subscriber.complete();
                return;
            }
            if (subscriber.closed) {
                return;
            }
        }
        var value;
        try {
            value = state.resultSelector(state.state);
        }
        catch (err) {
            subscriber.error(err);
            return;
        }
        if (subscriber.closed) {
            return;
        }
        subscriber.next(value);
        if (subscriber.closed) {
            return;
        }
        return this.schedule(state);
    };
    return GenerateObservable;
}(Observable_1.Observable));
exports.GenerateObservable = GenerateObservable;
//# sourceMappingURL=GenerateObservable.js.map

/***/ }),
/* 1223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Observable_1 = __webpack_require__(0);
var subscribeToResult_1 = __webpack_require__(7);
var OuterSubscriber_1 = __webpack_require__(6);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var IfObservable = (function (_super) {
    __extends(IfObservable, _super);
    function IfObservable(condition, thenSource, elseSource) {
        _super.call(this);
        this.condition = condition;
        this.thenSource = thenSource;
        this.elseSource = elseSource;
    }
    IfObservable.create = function (condition, thenSource, elseSource) {
        return new IfObservable(condition, thenSource, elseSource);
    };
    IfObservable.prototype._subscribe = function (subscriber) {
        var _a = this, condition = _a.condition, thenSource = _a.thenSource, elseSource = _a.elseSource;
        return new IfSubscriber(subscriber, condition, thenSource, elseSource);
    };
    return IfObservable;
}(Observable_1.Observable));
exports.IfObservable = IfObservable;
var IfSubscriber = (function (_super) {
    __extends(IfSubscriber, _super);
    function IfSubscriber(destination, condition, thenSource, elseSource) {
        _super.call(this, destination);
        this.condition = condition;
        this.thenSource = thenSource;
        this.elseSource = elseSource;
        this.tryIf();
    }
    IfSubscriber.prototype.tryIf = function () {
        var _a = this, condition = _a.condition, thenSource = _a.thenSource, elseSource = _a.elseSource;
        var result;
        try {
            result = condition();
            var source = result ? thenSource : elseSource;
            if (source) {
                this.add(subscribeToResult_1.subscribeToResult(this, source));
            }
            else {
                this._complete();
            }
        }
        catch (err) {
            this._error(err);
        }
    };
    return IfSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
//# sourceMappingURL=IfObservable.js.map

/***/ }),
/* 1224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var isNumeric_1 = __webpack_require__(174);
var Observable_1 = __webpack_require__(0);
var async_1 = __webpack_require__(30);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var IntervalObservable = (function (_super) {
    __extends(IntervalObservable, _super);
    function IntervalObservable(period, scheduler) {
        if (period === void 0) { period = 0; }
        if (scheduler === void 0) { scheduler = async_1.async; }
        _super.call(this);
        this.period = period;
        this.scheduler = scheduler;
        if (!isNumeric_1.isNumeric(period) || period < 0) {
            this.period = 0;
        }
        if (!scheduler || typeof scheduler.schedule !== 'function') {
            this.scheduler = async_1.async;
        }
    }
    /**
     * Creates an Observable that emits sequential numbers every specified
     * interval of time, on a specified IScheduler.
     *
     * <span class="informal">Emits incremental numbers periodically in time.
     * </span>
     *
     * <img src="./img/interval.png" width="100%">
     *
     * `interval` returns an Observable that emits an infinite sequence of
     * ascending integers, with a constant interval of time of your choosing
     * between those emissions. The first emission is not sent immediately, but
     * only after the first period has passed. By default, this operator uses the
     * `async` IScheduler to provide a notion of time, but you may pass any
     * IScheduler to it.
     *
     * @example <caption>Emits ascending numbers, one every second (1000ms)</caption>
     * var numbers = Rx.Observable.interval(1000);
     * numbers.subscribe(x => console.log(x));
     *
     * @see {@link timer}
     * @see {@link delay}
     *
     * @param {number} [period=0] The interval size in milliseconds (by default)
     * or the time unit determined by the scheduler's clock.
     * @param {Scheduler} [scheduler=async] The IScheduler to use for scheduling
     * the emission of values, and providing a notion of "time".
     * @return {Observable} An Observable that emits a sequential number each time
     * interval.
     * @static true
     * @name interval
     * @owner Observable
     */
    IntervalObservable.create = function (period, scheduler) {
        if (period === void 0) { period = 0; }
        if (scheduler === void 0) { scheduler = async_1.async; }
        return new IntervalObservable(period, scheduler);
    };
    IntervalObservable.dispatch = function (state) {
        var index = state.index, subscriber = state.subscriber, period = state.period;
        subscriber.next(index);
        if (subscriber.closed) {
            return;
        }
        state.index += 1;
        this.schedule(state, period);
    };
    IntervalObservable.prototype._subscribe = function (subscriber) {
        var index = 0;
        var period = this.period;
        var scheduler = this.scheduler;
        subscriber.add(scheduler.schedule(IntervalObservable.dispatch, period, {
            index: index, subscriber: subscriber, period: period
        }));
    };
    return IntervalObservable;
}(Observable_1.Observable));
exports.IntervalObservable = IntervalObservable;
//# sourceMappingURL=IntervalObservable.js.map

/***/ }),
/* 1225 */,
/* 1226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Observable_1 = __webpack_require__(0);
var noop_1 = __webpack_require__(502);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var NeverObservable = (function (_super) {
    __extends(NeverObservable, _super);
    function NeverObservable() {
        _super.call(this);
    }
    /**
     * Creates an Observable that emits no items to the Observer.
     *
     * <span class="informal">An Observable that never emits anything.</span>
     *
     * <img src="./img/never.png" width="100%">
     *
     * This static operator is useful for creating a simple Observable that emits
     * neither values nor errors nor the completion notification. It can be used
     * for testing purposes or for composing with other Observables. Please note
     * that by never emitting a complete notification, this Observable keeps the
     * subscription from being disposed automatically. Subscriptions need to be
     * manually disposed.
     *
     * @example <caption>Emit the number 7, then never emit anything else (not even complete).</caption>
     * function info() {
     *   console.log('Will not be called');
     * }
     * var result = Rx.Observable.never().startWith(7);
     * result.subscribe(x => console.log(x), info, info);
     *
     * @see {@link create}
     * @see {@link empty}
     * @see {@link of}
     * @see {@link throw}
     *
     * @return {Observable} A "never" Observable: never emits anything.
     * @static true
     * @name never
     * @owner Observable
     */
    NeverObservable.create = function () {
        return new NeverObservable();
    };
    NeverObservable.prototype._subscribe = function (subscriber) {
        noop_1.noop();
    };
    return NeverObservable;
}(Observable_1.Observable));
exports.NeverObservable = NeverObservable;
//# sourceMappingURL=NeverObservable.js.map

/***/ }),
/* 1227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Observable_1 = __webpack_require__(0);
function dispatch(state) {
    var obj = state.obj, keys = state.keys, length = state.length, index = state.index, subscriber = state.subscriber;
    if (index === length) {
        subscriber.complete();
        return;
    }
    var key = keys[index];
    subscriber.next([key, obj[key]]);
    state.index = index + 1;
    this.schedule(state);
}
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var PairsObservable = (function (_super) {
    __extends(PairsObservable, _super);
    function PairsObservable(obj, scheduler) {
        _super.call(this);
        this.obj = obj;
        this.scheduler = scheduler;
        this.keys = Object.keys(obj);
    }
    /**
     * Convert an object into an observable sequence of [key, value] pairs
     * using an optional IScheduler to enumerate the object.
     *
     * @example <caption>Converts a javascript object to an Observable</caption>
     * var obj = {
     *   foo: 42,
     *   bar: 56,
     *   baz: 78
     * };
     *
     * var source = Rx.Observable.pairs(obj);
     *
     * var subscription = source.subscribe(
     *   function (x) {
     *     console.log('Next: %s', x);
     *   },
     *   function (err) {
     *     console.log('Error: %s', err);
     *   },
     *   function () {
     *     console.log('Completed');
     *   });
     *
     * @param {Object} obj The object to inspect and turn into an
     * Observable sequence.
     * @param {Scheduler} [scheduler] An optional IScheduler to run the
     * enumeration of the input sequence on.
     * @returns {(Observable<Array<string | T>>)} An observable sequence of
     * [key, value] pairs from the object.
     */
    PairsObservable.create = function (obj, scheduler) {
        return new PairsObservable(obj, scheduler);
    };
    PairsObservable.prototype._subscribe = function (subscriber) {
        var _a = this, keys = _a.keys, scheduler = _a.scheduler;
        var length = keys.length;
        if (scheduler) {
            return scheduler.schedule(dispatch, 0, {
                obj: this.obj, keys: keys, length: length, index: 0, subscriber: subscriber
            });
        }
        else {
            for (var idx = 0; idx < length; idx++) {
                var key = keys[idx];
                subscriber.next([key, this.obj[key]]);
            }
            subscriber.complete();
        }
    };
    return PairsObservable;
}(Observable_1.Observable));
exports.PairsObservable = PairsObservable;
//# sourceMappingURL=PairsObservable.js.map

/***/ }),
/* 1228 */,
/* 1229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Observable_1 = __webpack_require__(0);
var asap_1 = __webpack_require__(492);
var isNumeric_1 = __webpack_require__(174);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var SubscribeOnObservable = (function (_super) {
    __extends(SubscribeOnObservable, _super);
    function SubscribeOnObservable(source, delayTime, scheduler) {
        if (delayTime === void 0) { delayTime = 0; }
        if (scheduler === void 0) { scheduler = asap_1.asap; }
        _super.call(this);
        this.source = source;
        this.delayTime = delayTime;
        this.scheduler = scheduler;
        if (!isNumeric_1.isNumeric(delayTime) || delayTime < 0) {
            this.delayTime = 0;
        }
        if (!scheduler || typeof scheduler.schedule !== 'function') {
            this.scheduler = asap_1.asap;
        }
    }
    SubscribeOnObservable.create = function (source, delay, scheduler) {
        if (delay === void 0) { delay = 0; }
        if (scheduler === void 0) { scheduler = asap_1.asap; }
        return new SubscribeOnObservable(source, delay, scheduler);
    };
    SubscribeOnObservable.dispatch = function (arg) {
        var source = arg.source, subscriber = arg.subscriber;
        return this.add(source.subscribe(subscriber));
    };
    SubscribeOnObservable.prototype._subscribe = function (subscriber) {
        var delay = this.delayTime;
        var source = this.source;
        var scheduler = this.scheduler;
        return scheduler.schedule(SubscribeOnObservable.dispatch, delay, {
            source: source, subscriber: subscriber
        });
    };
    return SubscribeOnObservable;
}(Observable_1.Observable));
exports.SubscribeOnObservable = SubscribeOnObservable;
//# sourceMappingURL=SubscribeOnObservable.js.map

/***/ }),
/* 1230 */,
/* 1231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Observable_1 = __webpack_require__(0);
var subscribeToResult_1 = __webpack_require__(7);
var OuterSubscriber_1 = __webpack_require__(6);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var UsingObservable = (function (_super) {
    __extends(UsingObservable, _super);
    function UsingObservable(resourceFactory, observableFactory) {
        _super.call(this);
        this.resourceFactory = resourceFactory;
        this.observableFactory = observableFactory;
    }
    UsingObservable.create = function (resourceFactory, observableFactory) {
        return new UsingObservable(resourceFactory, observableFactory);
    };
    UsingObservable.prototype._subscribe = function (subscriber) {
        var _a = this, resourceFactory = _a.resourceFactory, observableFactory = _a.observableFactory;
        var resource;
        try {
            resource = resourceFactory();
            return new UsingSubscriber(subscriber, resource, observableFactory);
        }
        catch (err) {
            subscriber.error(err);
        }
    };
    return UsingObservable;
}(Observable_1.Observable));
exports.UsingObservable = UsingObservable;
var UsingSubscriber = (function (_super) {
    __extends(UsingSubscriber, _super);
    function UsingSubscriber(destination, resource, observableFactory) {
        _super.call(this, destination);
        this.resource = resource;
        this.observableFactory = observableFactory;
        destination.add(resource);
        this.tryUse();
    }
    UsingSubscriber.prototype.tryUse = function () {
        try {
            var source = this.observableFactory.call(this, this.resource);
            if (source) {
                this.add(subscribeToResult_1.subscribeToResult(this, source));
            }
        }
        catch (err) {
            this._error(err);
        }
    };
    return UsingSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
//# sourceMappingURL=UsingObservable.js.map

/***/ }),
/* 1232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var BoundCallbackObservable_1 = __webpack_require__(1215);
exports.bindCallback = BoundCallbackObservable_1.BoundCallbackObservable.create;
//# sourceMappingURL=bindCallback.js.map

/***/ }),
/* 1233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var BoundNodeCallbackObservable_1 = __webpack_require__(1216);
exports.bindNodeCallback = BoundNodeCallbackObservable_1.BoundNodeCallbackObservable.create;
//# sourceMappingURL=bindNodeCallback.js.map

/***/ }),
/* 1234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isScheduler_1 = __webpack_require__(63);
var isArray_1 = __webpack_require__(62);
var ArrayObservable_1 = __webpack_require__(61);
var combineLatest_1 = __webpack_require__(273);
/* tslint:enable:max-line-length */
/**
 * Combines multiple Observables to create an Observable whose values are
 * calculated from the latest values of each of its input Observables.
 *
 * <span class="informal">Whenever any input Observable emits a value, it
 * computes a formula using the latest values from all the inputs, then emits
 * the output of that formula.</span>
 *
 * <img src="./img/combineLatest.png" width="100%">
 *
 * `combineLatest` combines the values from all the Observables passed as
 * arguments. This is done by subscribing to each Observable in order and,
 * whenever any Observable emits, collecting an array of the most recent
 * values from each Observable. So if you pass `n` Observables to operator,
 * returned Observable will always emit an array of `n` values, in order
 * corresponding to order of passed Observables (value from the first Observable
 * on the first place and so on).
 *
 * Static version of `combineLatest` accepts either an array of Observables
 * or each Observable can be put directly as an argument. Note that array of
 * Observables is good choice, if you don't know beforehand how many Observables
 * you will combine. Passing empty array will result in Observable that
 * completes immediately.
 *
 * To ensure output array has always the same length, `combineLatest` will
 * actually wait for all input Observables to emit at least once,
 * before it starts emitting results. This means if some Observable emits
 * values before other Observables started emitting, all that values but last
 * will be lost. On the other hand, is some Observable does not emit value but
 * completes, resulting Observable will complete at the same moment without
 * emitting anything, since it will be now impossible to include value from
 * completed Observable in resulting array. Also, if some input Observable does
 * not emit any value and never completes, `combineLatest` will also never emit
 * and never complete, since, again, it will wait for all streams to emit some
 * value.
 *
 * If at least one Observable was passed to `combineLatest` and all passed Observables
 * emitted something, resulting Observable will complete when all combined
 * streams complete. So even if some Observable completes, result of
 * `combineLatest` will still emit values when other Observables do. In case
 * of completed Observable, its value from now on will always be the last
 * emitted value. On the other hand, if any Observable errors, `combineLatest`
 * will error immediately as well, and all other Observables will be unsubscribed.
 *
 * `combineLatest` accepts as optional parameter `project` function, which takes
 * as arguments all values that would normally be emitted by resulting Observable.
 * `project` can return any kind of value, which will be then emitted by Observable
 * instead of default array. Note that `project` does not take as argument that array
 * of values, but values themselves. That means default `project` can be imagined
 * as function that takes all its arguments and puts them into an array.
 *
 *
 * @example <caption>Combine two timer Observables</caption>
 * const firstTimer = Rx.Observable.timer(0, 1000); // emit 0, 1, 2... after every second, starting from now
 * const secondTimer = Rx.Observable.timer(500, 1000); // emit 0, 1, 2... after every second, starting 0,5s from now
 * const combinedTimers = Rx.Observable.combineLatest(firstTimer, secondTimer);
 * combinedTimers.subscribe(value => console.log(value));
 * // Logs
 * // [0, 0] after 0.5s
 * // [1, 0] after 1s
 * // [1, 1] after 1.5s
 * // [2, 1] after 2s
 *
 *
 * @example <caption>Combine an array of Observables</caption>
 * const observables = [1, 5, 10].map(
 *   n => Rx.Observable.of(n).delay(n * 1000).startWith(0) // emit 0 and then emit n after n seconds
 * );
 * const combined = Rx.Observable.combineLatest(observables);
 * combined.subscribe(value => console.log(value));
 * // Logs
 * // [0, 0, 0] immediately
 * // [1, 0, 0] after 1s
 * // [1, 5, 0] after 5s
 * // [1, 5, 10] after 10s
 *
 *
 * @example <caption>Use project function to dynamically calculate the Body-Mass Index</caption>
 * var weight = Rx.Observable.of(70, 72, 76, 79, 75);
 * var height = Rx.Observable.of(1.76, 1.77, 1.78);
 * var bmi = Rx.Observable.combineLatest(weight, height, (w, h) => w / (h * h));
 * bmi.subscribe(x => console.log('BMI is ' + x));
 *
 * // With output to console:
 * // BMI is 24.212293388429753
 * // BMI is 23.93948099205209
 * // BMI is 23.671253629592222
 *
 *
 * @see {@link combineAll}
 * @see {@link merge}
 * @see {@link withLatestFrom}
 *
 * @param {ObservableInput} observable1 An input Observable to combine with other Observables.
 * @param {ObservableInput} observable2 An input Observable to combine with other Observables.
 * More than one input Observables may be given as arguments
 * or an array of Observables may be given as the first argument.
 * @param {function} [project] An optional function to project the values from
 * the combined latest values into a new value on the output Observable.
 * @param {Scheduler} [scheduler=null] The IScheduler to use for subscribing to
 * each input Observable.
 * @return {Observable} An Observable of projected values from the most recent
 * values from each input Observable, or an array of the most recent values from
 * each input Observable.
 * @static true
 * @name combineLatest
 * @owner Observable
 */
function combineLatest() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i - 0] = arguments[_i];
    }
    var project = null;
    var scheduler = null;
    if (isScheduler_1.isScheduler(observables[observables.length - 1])) {
        scheduler = observables.pop();
    }
    if (typeof observables[observables.length - 1] === 'function') {
        project = observables.pop();
    }
    // if the first and only other argument besides the resultSelector is an array
    // assume it's been called with `combineLatest([obs1, obs2, obs3], project)`
    if (observables.length === 1 && isArray_1.isArray(observables[0])) {
        observables = observables[0];
    }
    return new ArrayObservable_1.ArrayObservable(observables, scheduler).lift(new combineLatest_1.CombineLatestOperator(project));
}
exports.combineLatest = combineLatest;
//# sourceMappingURL=combineLatest.js.map

/***/ }),
/* 1235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var concat_1 = __webpack_require__(274);
exports.concat = concat_1.concatStatic;
//# sourceMappingURL=concat.js.map

/***/ }),
/* 1236 */,
/* 1237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subject_1 = __webpack_require__(11);
var Subscriber_1 = __webpack_require__(3);
var Observable_1 = __webpack_require__(0);
var Subscription_1 = __webpack_require__(18);
var root_1 = __webpack_require__(24);
var ReplaySubject_1 = __webpack_require__(166);
var tryCatch_1 = __webpack_require__(25);
var errorObject_1 = __webpack_require__(22);
var assign_1 = __webpack_require__(1348);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var WebSocketSubject = (function (_super) {
    __extends(WebSocketSubject, _super);
    function WebSocketSubject(urlConfigOrSource, destination) {
        if (urlConfigOrSource instanceof Observable_1.Observable) {
            _super.call(this, destination, urlConfigOrSource);
        }
        else {
            _super.call(this);
            this.WebSocketCtor = root_1.root.WebSocket;
            this._output = new Subject_1.Subject();
            if (typeof urlConfigOrSource === 'string') {
                this.url = urlConfigOrSource;
            }
            else {
                // WARNING: config object could override important members here.
                assign_1.assign(this, urlConfigOrSource);
            }
            if (!this.WebSocketCtor) {
                throw new Error('no WebSocket constructor can be found');
            }
            this.destination = new ReplaySubject_1.ReplaySubject();
        }
    }
    WebSocketSubject.prototype.resultSelector = function (e) {
        return JSON.parse(e.data);
    };
    /**
     * Wrapper around the w3c-compatible WebSocket object provided by the browser.
     *
     * @example <caption>Wraps browser WebSocket</caption>
     *
     * let socket$ = Observable.webSocket('ws://localhost:8081');
     *
     * socket$.subscribe(
     *    (msg) => console.log('message received: ' + msg),
     *    (err) => console.log(err),
     *    () => console.log('complete')
     *  );
     *
     * socket$.next(JSON.stringify({ op: 'hello' }));
     *
     * @example <caption>Wraps WebSocket from nodejs-websocket (using node.js)</caption>
     *
     * import { w3cwebsocket } from 'websocket';
     *
     * let socket$ = Observable.webSocket({
     *   url: 'ws://localhost:8081',
     *   WebSocketCtor: w3cwebsocket
     * });
     *
     * socket$.subscribe(
     *    (msg) => console.log('message received: ' + msg),
     *    (err) => console.log(err),
     *    () => console.log('complete')
     *  );
     *
     * socket$.next(JSON.stringify({ op: 'hello' }));
     *
     * @param {string | WebSocketSubjectConfig} urlConfigOrSource the source of the websocket as an url or a structure defining the websocket object
     * @return {WebSocketSubject}
     * @static true
     * @name webSocket
     * @owner Observable
     */
    WebSocketSubject.create = function (urlConfigOrSource) {
        return new WebSocketSubject(urlConfigOrSource);
    };
    WebSocketSubject.prototype.lift = function (operator) {
        var sock = new WebSocketSubject(this, this.destination);
        sock.operator = operator;
        return sock;
    };
    WebSocketSubject.prototype._resetState = function () {
        this.socket = null;
        if (!this.source) {
            this.destination = new ReplaySubject_1.ReplaySubject();
        }
        this._output = new Subject_1.Subject();
    };
    // TODO: factor this out to be a proper Operator/Subscriber implementation and eliminate closures
    WebSocketSubject.prototype.multiplex = function (subMsg, unsubMsg, messageFilter) {
        var self = this;
        return new Observable_1.Observable(function (observer) {
            var result = tryCatch_1.tryCatch(subMsg)();
            if (result === errorObject_1.errorObject) {
                observer.error(errorObject_1.errorObject.e);
            }
            else {
                self.next(result);
            }
            var subscription = self.subscribe(function (x) {
                var result = tryCatch_1.tryCatch(messageFilter)(x);
                if (result === errorObject_1.errorObject) {
                    observer.error(errorObject_1.errorObject.e);
                }
                else if (result) {
                    observer.next(x);
                }
            }, function (err) { return observer.error(err); }, function () { return observer.complete(); });
            return function () {
                var result = tryCatch_1.tryCatch(unsubMsg)();
                if (result === errorObject_1.errorObject) {
                    observer.error(errorObject_1.errorObject.e);
                }
                else {
                    self.next(result);
                }
                subscription.unsubscribe();
            };
        });
    };
    WebSocketSubject.prototype._connectSocket = function () {
        var _this = this;
        var WebSocketCtor = this.WebSocketCtor;
        var observer = this._output;
        var socket = null;
        try {
            socket = this.protocol ?
                new WebSocketCtor(this.url, this.protocol) :
                new WebSocketCtor(this.url);
            this.socket = socket;
            if (this.binaryType) {
                this.socket.binaryType = this.binaryType;
            }
        }
        catch (e) {
            observer.error(e);
            return;
        }
        var subscription = new Subscription_1.Subscription(function () {
            _this.socket = null;
            if (socket && socket.readyState === 1) {
                socket.close();
            }
        });
        socket.onopen = function (e) {
            var openObserver = _this.openObserver;
            if (openObserver) {
                openObserver.next(e);
            }
            var queue = _this.destination;
            _this.destination = Subscriber_1.Subscriber.create(function (x) { return socket.readyState === 1 && socket.send(x); }, function (e) {
                var closingObserver = _this.closingObserver;
                if (closingObserver) {
                    closingObserver.next(undefined);
                }
                if (e && e.code) {
                    socket.close(e.code, e.reason);
                }
                else {
                    observer.error(new TypeError('WebSocketSubject.error must be called with an object with an error code, ' +
                        'and an optional reason: { code: number, reason: string }'));
                }
                _this._resetState();
            }, function () {
                var closingObserver = _this.closingObserver;
                if (closingObserver) {
                    closingObserver.next(undefined);
                }
                socket.close();
                _this._resetState();
            });
            if (queue && queue instanceof ReplaySubject_1.ReplaySubject) {
                subscription.add(queue.subscribe(_this.destination));
            }
        };
        socket.onerror = function (e) {
            _this._resetState();
            observer.error(e);
        };
        socket.onclose = function (e) {
            _this._resetState();
            var closeObserver = _this.closeObserver;
            if (closeObserver) {
                closeObserver.next(e);
            }
            if (e.wasClean) {
                observer.complete();
            }
            else {
                observer.error(e);
            }
        };
        socket.onmessage = function (e) {
            var result = tryCatch_1.tryCatch(_this.resultSelector)(e);
            if (result === errorObject_1.errorObject) {
                observer.error(errorObject_1.errorObject.e);
            }
            else {
                observer.next(result);
            }
        };
    };
    WebSocketSubject.prototype._subscribe = function (subscriber) {
        var _this = this;
        var source = this.source;
        if (source) {
            return source.subscribe(subscriber);
        }
        if (!this.socket) {
            this._connectSocket();
        }
        var subscription = new Subscription_1.Subscription();
        subscription.add(this._output.subscribe(subscriber));
        subscription.add(function () {
            var socket = _this.socket;
            if (_this._output.observers.length === 0) {
                if (socket && socket.readyState === 1) {
                    socket.close();
                }
                _this._resetState();
            }
        });
        return subscription;
    };
    WebSocketSubject.prototype.unsubscribe = function () {
        var _a = this, source = _a.source, socket = _a.socket;
        if (socket && socket.readyState === 1) {
            socket.close();
            this._resetState();
        }
        _super.prototype.unsubscribe.call(this);
        if (!source) {
            this.destination = new ReplaySubject_1.ReplaySubject();
        }
    };
    return WebSocketSubject;
}(Subject_1.AnonymousSubject));
exports.WebSocketSubject = WebSocketSubject;
//# sourceMappingURL=WebSocketSubject.js.map

/***/ }),
/* 1238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var AjaxObservable_1 = __webpack_require__(470);
exports.ajax = AjaxObservable_1.AjaxObservable.create;
//# sourceMappingURL=ajax.js.map

/***/ }),
/* 1239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var WebSocketSubject_1 = __webpack_require__(1237);
exports.webSocket = WebSocketSubject_1.WebSocketSubject.create;
//# sourceMappingURL=webSocket.js.map

/***/ }),
/* 1240 */,
/* 1241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var FromEventObservable_1 = __webpack_require__(1220);
exports.fromEvent = FromEventObservable_1.FromEventObservable.create;
//# sourceMappingURL=fromEvent.js.map

/***/ }),
/* 1242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var FromEventPatternObservable_1 = __webpack_require__(1221);
exports.fromEventPattern = FromEventPatternObservable_1.FromEventPatternObservable.create;
//# sourceMappingURL=fromEventPattern.js.map

/***/ }),
/* 1243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var GenerateObservable_1 = __webpack_require__(1222);
exports.generate = GenerateObservable_1.GenerateObservable.create;
//# sourceMappingURL=generate.js.map

/***/ }),
/* 1244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var IfObservable_1 = __webpack_require__(1223);
exports._if = IfObservable_1.IfObservable.create;
//# sourceMappingURL=if.js.map

/***/ }),
/* 1245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var IntervalObservable_1 = __webpack_require__(1224);
exports.interval = IntervalObservable_1.IntervalObservable.create;
//# sourceMappingURL=interval.js.map

/***/ }),
/* 1246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var NeverObservable_1 = __webpack_require__(1226);
exports.never = NeverObservable_1.NeverObservable.create;
//# sourceMappingURL=never.js.map

/***/ }),
/* 1247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var onErrorResumeNext_1 = __webpack_require__(485);
exports.onErrorResumeNext = onErrorResumeNext_1.onErrorResumeNextStatic;
//# sourceMappingURL=onErrorResumeNext.js.map

/***/ }),
/* 1248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var PairsObservable_1 = __webpack_require__(1227);
exports.pairs = PairsObservable_1.PairsObservable.create;
//# sourceMappingURL=pairs.js.map

/***/ }),
/* 1249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var race_1 = __webpack_require__(486);
exports.race = race_1.raceStatic;
//# sourceMappingURL=race.js.map

/***/ }),
/* 1250 */,
/* 1251 */,
/* 1252 */,
/* 1253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var UsingObservable_1 = __webpack_require__(1231);
exports.using = UsingObservable_1.UsingObservable.create;
//# sourceMappingURL=using.js.map

/***/ }),
/* 1254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var zip_1 = __webpack_require__(278);
exports.zip = zip_1.zipStatic;
//# sourceMappingURL=zip.js.map

/***/ }),
/* 1255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var tryCatch_1 = __webpack_require__(25);
var errorObject_1 = __webpack_require__(22);
var OuterSubscriber_1 = __webpack_require__(6);
var subscribeToResult_1 = __webpack_require__(7);
/**
 * Ignores source values for a duration determined by another Observable, then
 * emits the most recent value from the source Observable, then repeats this
 * process.
 *
 * <span class="informal">It's like {@link auditTime}, but the silencing
 * duration is determined by a second Observable.</span>
 *
 * <img src="./img/audit.png" width="100%">
 *
 * `audit` is similar to `throttle`, but emits the last value from the silenced
 * time window, instead of the first value. `audit` emits the most recent value
 * from the source Observable on the output Observable as soon as its internal
 * timer becomes disabled, and ignores source values while the timer is enabled.
 * Initially, the timer is disabled. As soon as the first source value arrives,
 * the timer is enabled by calling the `durationSelector` function with the
 * source value, which returns the "duration" Observable. When the duration
 * Observable emits a value or completes, the timer is disabled, then the most
 * recent source value is emitted on the output Observable, and this process
 * repeats for the next source value.
 *
 * @example <caption>Emit clicks at a rate of at most one click per second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.audit(ev => Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link auditTime}
 * @see {@link debounce}
 * @see {@link delayWhen}
 * @see {@link sample}
 * @see {@link throttle}
 *
 * @param {function(value: T): SubscribableOrPromise} durationSelector A function
 * that receives a value from the source Observable, for computing the silencing
 * duration, returned as an Observable or a Promise.
 * @return {Observable<T>} An Observable that performs rate-limiting of
 * emissions from the source Observable.
 * @method audit
 * @owner Observable
 */
function audit(durationSelector) {
    return this.lift(new AuditOperator(durationSelector));
}
exports.audit = audit;
var AuditOperator = (function () {
    function AuditOperator(durationSelector) {
        this.durationSelector = durationSelector;
    }
    AuditOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new AuditSubscriber(subscriber, this.durationSelector));
    };
    return AuditOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var AuditSubscriber = (function (_super) {
    __extends(AuditSubscriber, _super);
    function AuditSubscriber(destination, durationSelector) {
        _super.call(this, destination);
        this.durationSelector = durationSelector;
        this.hasValue = false;
    }
    AuditSubscriber.prototype._next = function (value) {
        this.value = value;
        this.hasValue = true;
        if (!this.throttled) {
            var duration = tryCatch_1.tryCatch(this.durationSelector)(value);
            if (duration === errorObject_1.errorObject) {
                this.destination.error(errorObject_1.errorObject.e);
            }
            else {
                var innerSubscription = subscribeToResult_1.subscribeToResult(this, duration);
                if (innerSubscription.closed) {
                    this.clearThrottle();
                }
                else {
                    this.add(this.throttled = innerSubscription);
                }
            }
        }
    };
    AuditSubscriber.prototype.clearThrottle = function () {
        var _a = this, value = _a.value, hasValue = _a.hasValue, throttled = _a.throttled;
        if (throttled) {
            this.remove(throttled);
            this.throttled = null;
            throttled.unsubscribe();
        }
        if (hasValue) {
            this.value = null;
            this.hasValue = false;
            this.destination.next(value);
        }
    };
    AuditSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex) {
        this.clearThrottle();
    };
    AuditSubscriber.prototype.notifyComplete = function () {
        this.clearThrottle();
    };
    return AuditSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
//# sourceMappingURL=audit.js.map

/***/ }),
/* 1256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var async_1 = __webpack_require__(30);
var Subscriber_1 = __webpack_require__(3);
/**
 * Ignores source values for `duration` milliseconds, then emits the most recent
 * value from the source Observable, then repeats this process.
 *
 * <span class="informal">When it sees a source values, it ignores that plus
 * the next ones for `duration` milliseconds, and then it emits the most recent
 * value from the source.</span>
 *
 * <img src="./img/auditTime.png" width="100%">
 *
 * `auditTime` is similar to `throttleTime`, but emits the last value from the
 * silenced time window, instead of the first value. `auditTime` emits the most
 * recent value from the source Observable on the output Observable as soon as
 * its internal timer becomes disabled, and ignores source values while the
 * timer is enabled. Initially, the timer is disabled. As soon as the first
 * source value arrives, the timer is enabled. After `duration` milliseconds (or
 * the time unit determined internally by the optional `scheduler`) has passed,
 * the timer is disabled, then the most recent source value is emitted on the
 * output Observable, and this process repeats for the next source value.
 * Optionally takes a {@link IScheduler} for managing timers.
 *
 * @example <caption>Emit clicks at a rate of at most one click per second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.auditTime(1000);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link audit}
 * @see {@link debounceTime}
 * @see {@link delay}
 * @see {@link sampleTime}
 * @see {@link throttleTime}
 *
 * @param {number} duration Time to wait before emitting the most recent source
 * value, measured in milliseconds or the time unit determined internally
 * by the optional `scheduler`.
 * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
 * managing the timers that handle the rate-limiting behavior.
 * @return {Observable<T>} An Observable that performs rate-limiting of
 * emissions from the source Observable.
 * @method auditTime
 * @owner Observable
 */
function auditTime(duration, scheduler) {
    if (scheduler === void 0) { scheduler = async_1.async; }
    return this.lift(new AuditTimeOperator(duration, scheduler));
}
exports.auditTime = auditTime;
var AuditTimeOperator = (function () {
    function AuditTimeOperator(duration, scheduler) {
        this.duration = duration;
        this.scheduler = scheduler;
    }
    AuditTimeOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new AuditTimeSubscriber(subscriber, this.duration, this.scheduler));
    };
    return AuditTimeOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var AuditTimeSubscriber = (function (_super) {
    __extends(AuditTimeSubscriber, _super);
    function AuditTimeSubscriber(destination, duration, scheduler) {
        _super.call(this, destination);
        this.duration = duration;
        this.scheduler = scheduler;
        this.hasValue = false;
    }
    AuditTimeSubscriber.prototype._next = function (value) {
        this.value = value;
        this.hasValue = true;
        if (!this.throttled) {
            this.add(this.throttled = this.scheduler.schedule(dispatchNext, this.duration, this));
        }
    };
    AuditTimeSubscriber.prototype.clearThrottle = function () {
        var _a = this, value = _a.value, hasValue = _a.hasValue, throttled = _a.throttled;
        if (throttled) {
            this.remove(throttled);
            this.throttled = null;
            throttled.unsubscribe();
        }
        if (hasValue) {
            this.value = null;
            this.hasValue = false;
            this.destination.next(value);
        }
    };
    return AuditTimeSubscriber;
}(Subscriber_1.Subscriber));
function dispatchNext(subscriber) {
    subscriber.clearThrottle();
}
//# sourceMappingURL=auditTime.js.map

/***/ }),
/* 1257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var OuterSubscriber_1 = __webpack_require__(6);
var subscribeToResult_1 = __webpack_require__(7);
/**
 * Buffers the source Observable values until `closingNotifier` emits.
 *
 * <span class="informal">Collects values from the past as an array, and emits
 * that array only when another Observable emits.</span>
 *
 * <img src="./img/buffer.png" width="100%">
 *
 * Buffers the incoming Observable values until the given `closingNotifier`
 * Observable emits a value, at which point it emits the buffer on the output
 * Observable and starts a new buffer internally, awaiting the next time
 * `closingNotifier` emits.
 *
 * @example <caption>On every click, emit array of most recent interval events</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var interval = Rx.Observable.interval(1000);
 * var buffered = interval.buffer(clicks);
 * buffered.subscribe(x => console.log(x));
 *
 * @see {@link bufferCount}
 * @see {@link bufferTime}
 * @see {@link bufferToggle}
 * @see {@link bufferWhen}
 * @see {@link window}
 *
 * @param {Observable<any>} closingNotifier An Observable that signals the
 * buffer to be emitted on the output Observable.
 * @return {Observable<T[]>} An Observable of buffers, which are arrays of
 * values.
 * @method buffer
 * @owner Observable
 */
function buffer(closingNotifier) {
    return this.lift(new BufferOperator(closingNotifier));
}
exports.buffer = buffer;
var BufferOperator = (function () {
    function BufferOperator(closingNotifier) {
        this.closingNotifier = closingNotifier;
    }
    BufferOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new BufferSubscriber(subscriber, this.closingNotifier));
    };
    return BufferOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var BufferSubscriber = (function (_super) {
    __extends(BufferSubscriber, _super);
    function BufferSubscriber(destination, closingNotifier) {
        _super.call(this, destination);
        this.buffer = [];
        this.add(subscribeToResult_1.subscribeToResult(this, closingNotifier));
    }
    BufferSubscriber.prototype._next = function (value) {
        this.buffer.push(value);
    };
    BufferSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        var buffer = this.buffer;
        this.buffer = [];
        this.destination.next(buffer);
    };
    return BufferSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
//# sourceMappingURL=buffer.js.map

/***/ }),
/* 1258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(3);
/**
 * Buffers the source Observable values until the size hits the maximum
 * `bufferSize` given.
 *
 * <span class="informal">Collects values from the past as an array, and emits
 * that array only when its size reaches `bufferSize`.</span>
 *
 * <img src="./img/bufferCount.png" width="100%">
 *
 * Buffers a number of values from the source Observable by `bufferSize` then
 * emits the buffer and clears it, and starts a new buffer each
 * `startBufferEvery` values. If `startBufferEvery` is not provided or is
 * `null`, then new buffers are started immediately at the start of the source
 * and when each buffer closes and is emitted.
 *
 * @example <caption>Emit the last two click events as an array</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var buffered = clicks.bufferCount(2);
 * buffered.subscribe(x => console.log(x));
 *
 * @example <caption>On every click, emit the last two click events as an array</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var buffered = clicks.bufferCount(2, 1);
 * buffered.subscribe(x => console.log(x));
 *
 * @see {@link buffer}
 * @see {@link bufferTime}
 * @see {@link bufferToggle}
 * @see {@link bufferWhen}
 * @see {@link pairwise}
 * @see {@link windowCount}
 *
 * @param {number} bufferSize The maximum size of the buffer emitted.
 * @param {number} [startBufferEvery] Interval at which to start a new buffer.
 * For example if `startBufferEvery` is `2`, then a new buffer will be started
 * on every other value from the source. A new buffer is started at the
 * beginning of the source by default.
 * @return {Observable<T[]>} An Observable of arrays of buffered values.
 * @method bufferCount
 * @owner Observable
 */
function bufferCount(bufferSize, startBufferEvery) {
    if (startBufferEvery === void 0) { startBufferEvery = null; }
    return this.lift(new BufferCountOperator(bufferSize, startBufferEvery));
}
exports.bufferCount = bufferCount;
var BufferCountOperator = (function () {
    function BufferCountOperator(bufferSize, startBufferEvery) {
        this.bufferSize = bufferSize;
        this.startBufferEvery = startBufferEvery;
        if (!startBufferEvery || bufferSize === startBufferEvery) {
            this.subscriberClass = BufferCountSubscriber;
        }
        else {
            this.subscriberClass = BufferSkipCountSubscriber;
        }
    }
    BufferCountOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new this.subscriberClass(subscriber, this.bufferSize, this.startBufferEvery));
    };
    return BufferCountOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var BufferCountSubscriber = (function (_super) {
    __extends(BufferCountSubscriber, _super);
    function BufferCountSubscriber(destination, bufferSize) {
        _super.call(this, destination);
        this.bufferSize = bufferSize;
        this.buffer = [];
    }
    BufferCountSubscriber.prototype._next = function (value) {
        var buffer = this.buffer;
        buffer.push(value);
        if (buffer.length == this.bufferSize) {
            this.destination.next(buffer);
            this.buffer = [];
        }
    };
    BufferCountSubscriber.prototype._complete = function () {
        var buffer = this.buffer;
        if (buffer.length > 0) {
            this.destination.next(buffer);
        }
        _super.prototype._complete.call(this);
    };
    return BufferCountSubscriber;
}(Subscriber_1.Subscriber));
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var BufferSkipCountSubscriber = (function (_super) {
    __extends(BufferSkipCountSubscriber, _super);
    function BufferSkipCountSubscriber(destination, bufferSize, startBufferEvery) {
        _super.call(this, destination);
        this.bufferSize = bufferSize;
        this.startBufferEvery = startBufferEvery;
        this.buffers = [];
        this.count = 0;
    }
    BufferSkipCountSubscriber.prototype._next = function (value) {
        var _a = this, bufferSize = _a.bufferSize, startBufferEvery = _a.startBufferEvery, buffers = _a.buffers, count = _a.count;
        this.count++;
        if (count % startBufferEvery === 0) {
            buffers.push([]);
        }
        for (var i = buffers.length; i--;) {
            var buffer = buffers[i];
            buffer.push(value);
            if (buffer.length === bufferSize) {
                buffers.splice(i, 1);
                this.destination.next(buffer);
            }
        }
    };
    BufferSkipCountSubscriber.prototype._complete = function () {
        var _a = this, buffers = _a.buffers, destination = _a.destination;
        while (buffers.length > 0) {
            var buffer = buffers.shift();
            if (buffer.length > 0) {
                destination.next(buffer);
            }
        }
        _super.prototype._complete.call(this);
    };
    return BufferSkipCountSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=bufferCount.js.map

/***/ }),
/* 1259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var async_1 = __webpack_require__(30);
var Subscriber_1 = __webpack_require__(3);
var isScheduler_1 = __webpack_require__(63);
/* tslint:enable:max-line-length */
/**
 * Buffers the source Observable values for a specific time period.
 *
 * <span class="informal">Collects values from the past as an array, and emits
 * those arrays periodically in time.</span>
 *
 * <img src="./img/bufferTime.png" width="100%">
 *
 * Buffers values from the source for a specific time duration `bufferTimeSpan`.
 * Unless the optional argument `bufferCreationInterval` is given, it emits and
 * resets the buffer every `bufferTimeSpan` milliseconds. If
 * `bufferCreationInterval` is given, this operator opens the buffer every
 * `bufferCreationInterval` milliseconds and closes (emits and resets) the
 * buffer every `bufferTimeSpan` milliseconds. When the optional argument
 * `maxBufferSize` is specified, the buffer will be closed either after
 * `bufferTimeSpan` milliseconds or when it contains `maxBufferSize` elements.
 *
 * @example <caption>Every second, emit an array of the recent click events</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var buffered = clicks.bufferTime(1000);
 * buffered.subscribe(x => console.log(x));
 *
 * @example <caption>Every 5 seconds, emit the click events from the next 2 seconds</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var buffered = clicks.bufferTime(2000, 5000);
 * buffered.subscribe(x => console.log(x));
 *
 * @see {@link buffer}
 * @see {@link bufferCount}
 * @see {@link bufferToggle}
 * @see {@link bufferWhen}
 * @see {@link windowTime}
 *
 * @param {number} bufferTimeSpan The amount of time to fill each buffer array.
 * @param {number} [bufferCreationInterval] The interval at which to start new
 * buffers.
 * @param {number} [maxBufferSize] The maximum buffer size.
 * @param {Scheduler} [scheduler=async] The scheduler on which to schedule the
 * intervals that determine buffer boundaries.
 * @return {Observable<T[]>} An observable of arrays of buffered values.
 * @method bufferTime
 * @owner Observable
 */
function bufferTime(bufferTimeSpan) {
    var length = arguments.length;
    var scheduler = async_1.async;
    if (isScheduler_1.isScheduler(arguments[arguments.length - 1])) {
        scheduler = arguments[arguments.length - 1];
        length--;
    }
    var bufferCreationInterval = null;
    if (length >= 2) {
        bufferCreationInterval = arguments[1];
    }
    var maxBufferSize = Number.POSITIVE_INFINITY;
    if (length >= 3) {
        maxBufferSize = arguments[2];
    }
    return this.lift(new BufferTimeOperator(bufferTimeSpan, bufferCreationInterval, maxBufferSize, scheduler));
}
exports.bufferTime = bufferTime;
var BufferTimeOperator = (function () {
    function BufferTimeOperator(bufferTimeSpan, bufferCreationInterval, maxBufferSize, scheduler) {
        this.bufferTimeSpan = bufferTimeSpan;
        this.bufferCreationInterval = bufferCreationInterval;
        this.maxBufferSize = maxBufferSize;
        this.scheduler = scheduler;
    }
    BufferTimeOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new BufferTimeSubscriber(subscriber, this.bufferTimeSpan, this.bufferCreationInterval, this.maxBufferSize, this.scheduler));
    };
    return BufferTimeOperator;
}());
var Context = (function () {
    function Context() {
        this.buffer = [];
    }
    return Context;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var BufferTimeSubscriber = (function (_super) {
    __extends(BufferTimeSubscriber, _super);
    function BufferTimeSubscriber(destination, bufferTimeSpan, bufferCreationInterval, maxBufferSize, scheduler) {
        _super.call(this, destination);
        this.bufferTimeSpan = bufferTimeSpan;
        this.bufferCreationInterval = bufferCreationInterval;
        this.maxBufferSize = maxBufferSize;
        this.scheduler = scheduler;
        this.contexts = [];
        var context = this.openContext();
        this.timespanOnly = bufferCreationInterval == null || bufferCreationInterval < 0;
        if (this.timespanOnly) {
            var timeSpanOnlyState = { subscriber: this, context: context, bufferTimeSpan: bufferTimeSpan };
            this.add(context.closeAction = scheduler.schedule(dispatchBufferTimeSpanOnly, bufferTimeSpan, timeSpanOnlyState));
        }
        else {
            var closeState = { subscriber: this, context: context };
            var creationState = { bufferTimeSpan: bufferTimeSpan, bufferCreationInterval: bufferCreationInterval, subscriber: this, scheduler: scheduler };
            this.add(context.closeAction = scheduler.schedule(dispatchBufferClose, bufferTimeSpan, closeState));
            this.add(scheduler.schedule(dispatchBufferCreation, bufferCreationInterval, creationState));
        }
    }
    BufferTimeSubscriber.prototype._next = function (value) {
        var contexts = this.contexts;
        var len = contexts.length;
        var filledBufferContext;
        for (var i = 0; i < len; i++) {
            var context = contexts[i];
            var buffer = context.buffer;
            buffer.push(value);
            if (buffer.length == this.maxBufferSize) {
                filledBufferContext = context;
            }
        }
        if (filledBufferContext) {
            this.onBufferFull(filledBufferContext);
        }
    };
    BufferTimeSubscriber.prototype._error = function (err) {
        this.contexts.length = 0;
        _super.prototype._error.call(this, err);
    };
    BufferTimeSubscriber.prototype._complete = function () {
        var _a = this, contexts = _a.contexts, destination = _a.destination;
        while (contexts.length > 0) {
            var context = contexts.shift();
            destination.next(context.buffer);
        }
        _super.prototype._complete.call(this);
    };
    BufferTimeSubscriber.prototype._unsubscribe = function () {
        this.contexts = null;
    };
    BufferTimeSubscriber.prototype.onBufferFull = function (context) {
        this.closeContext(context);
        var closeAction = context.closeAction;
        closeAction.unsubscribe();
        this.remove(closeAction);
        if (!this.closed && this.timespanOnly) {
            context = this.openContext();
            var bufferTimeSpan = this.bufferTimeSpan;
            var timeSpanOnlyState = { subscriber: this, context: context, bufferTimeSpan: bufferTimeSpan };
            this.add(context.closeAction = this.scheduler.schedule(dispatchBufferTimeSpanOnly, bufferTimeSpan, timeSpanOnlyState));
        }
    };
    BufferTimeSubscriber.prototype.openContext = function () {
        var context = new Context();
        this.contexts.push(context);
        return context;
    };
    BufferTimeSubscriber.prototype.closeContext = function (context) {
        this.destination.next(context.buffer);
        var contexts = this.contexts;
        var spliceIndex = contexts ? contexts.indexOf(context) : -1;
        if (spliceIndex >= 0) {
            contexts.splice(contexts.indexOf(context), 1);
        }
    };
    return BufferTimeSubscriber;
}(Subscriber_1.Subscriber));
function dispatchBufferTimeSpanOnly(state) {
    var subscriber = state.subscriber;
    var prevContext = state.context;
    if (prevContext) {
        subscriber.closeContext(prevContext);
    }
    if (!subscriber.closed) {
        state.context = subscriber.openContext();
        state.context.closeAction = this.schedule(state, state.bufferTimeSpan);
    }
}
function dispatchBufferCreation(state) {
    var bufferCreationInterval = state.bufferCreationInterval, bufferTimeSpan = state.bufferTimeSpan, subscriber = state.subscriber, scheduler = state.scheduler;
    var context = subscriber.openContext();
    var action = this;
    if (!subscriber.closed) {
        subscriber.add(context.closeAction = scheduler.schedule(dispatchBufferClose, bufferTimeSpan, { subscriber: subscriber, context: context }));
        action.schedule(state, bufferCreationInterval);
    }
}
function dispatchBufferClose(arg) {
    var subscriber = arg.subscriber, context = arg.context;
    subscriber.closeContext(context);
}
//# sourceMappingURL=bufferTime.js.map

/***/ }),
/* 1260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscription_1 = __webpack_require__(18);
var subscribeToResult_1 = __webpack_require__(7);
var OuterSubscriber_1 = __webpack_require__(6);
/**
 * Buffers the source Observable values starting from an emission from
 * `openings` and ending when the output of `closingSelector` emits.
 *
 * <span class="informal">Collects values from the past as an array. Starts
 * collecting only when `opening` emits, and calls the `closingSelector`
 * function to get an Observable that tells when to close the buffer.</span>
 *
 * <img src="./img/bufferToggle.png" width="100%">
 *
 * Buffers values from the source by opening the buffer via signals from an
 * Observable provided to `openings`, and closing and sending the buffers when
 * a Subscribable or Promise returned by the `closingSelector` function emits.
 *
 * @example <caption>Every other second, emit the click events from the next 500ms</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var openings = Rx.Observable.interval(1000);
 * var buffered = clicks.bufferToggle(openings, i =>
 *   i % 2 ? Rx.Observable.interval(500) : Rx.Observable.empty()
 * );
 * buffered.subscribe(x => console.log(x));
 *
 * @see {@link buffer}
 * @see {@link bufferCount}
 * @see {@link bufferTime}
 * @see {@link bufferWhen}
 * @see {@link windowToggle}
 *
 * @param {SubscribableOrPromise<O>} openings A Subscribable or Promise of notifications to start new
 * buffers.
 * @param {function(value: O): SubscribableOrPromise} closingSelector A function that takes
 * the value emitted by the `openings` observable and returns a Subscribable or Promise,
 * which, when it emits, signals that the associated buffer should be emitted
 * and cleared.
 * @return {Observable<T[]>} An observable of arrays of buffered values.
 * @method bufferToggle
 * @owner Observable
 */
function bufferToggle(openings, closingSelector) {
    return this.lift(new BufferToggleOperator(openings, closingSelector));
}
exports.bufferToggle = bufferToggle;
var BufferToggleOperator = (function () {
    function BufferToggleOperator(openings, closingSelector) {
        this.openings = openings;
        this.closingSelector = closingSelector;
    }
    BufferToggleOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new BufferToggleSubscriber(subscriber, this.openings, this.closingSelector));
    };
    return BufferToggleOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var BufferToggleSubscriber = (function (_super) {
    __extends(BufferToggleSubscriber, _super);
    function BufferToggleSubscriber(destination, openings, closingSelector) {
        _super.call(this, destination);
        this.openings = openings;
        this.closingSelector = closingSelector;
        this.contexts = [];
        this.add(subscribeToResult_1.subscribeToResult(this, openings));
    }
    BufferToggleSubscriber.prototype._next = function (value) {
        var contexts = this.contexts;
        var len = contexts.length;
        for (var i = 0; i < len; i++) {
            contexts[i].buffer.push(value);
        }
    };
    BufferToggleSubscriber.prototype._error = function (err) {
        var contexts = this.contexts;
        while (contexts.length > 0) {
            var context = contexts.shift();
            context.subscription.unsubscribe();
            context.buffer = null;
            context.subscription = null;
        }
        this.contexts = null;
        _super.prototype._error.call(this, err);
    };
    BufferToggleSubscriber.prototype._complete = function () {
        var contexts = this.contexts;
        while (contexts.length > 0) {
            var context = contexts.shift();
            this.destination.next(context.buffer);
            context.subscription.unsubscribe();
            context.buffer = null;
            context.subscription = null;
        }
        this.contexts = null;
        _super.prototype._complete.call(this);
    };
    BufferToggleSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        outerValue ? this.closeBuffer(outerValue) : this.openBuffer(innerValue);
    };
    BufferToggleSubscriber.prototype.notifyComplete = function (innerSub) {
        this.closeBuffer(innerSub.context);
    };
    BufferToggleSubscriber.prototype.openBuffer = function (value) {
        try {
            var closingSelector = this.closingSelector;
            var closingNotifier = closingSelector.call(this, value);
            if (closingNotifier) {
                this.trySubscribe(closingNotifier);
            }
        }
        catch (err) {
            this._error(err);
        }
    };
    BufferToggleSubscriber.prototype.closeBuffer = function (context) {
        var contexts = this.contexts;
        if (contexts && context) {
            var buffer = context.buffer, subscription = context.subscription;
            this.destination.next(buffer);
            contexts.splice(contexts.indexOf(context), 1);
            this.remove(subscription);
            subscription.unsubscribe();
        }
    };
    BufferToggleSubscriber.prototype.trySubscribe = function (closingNotifier) {
        var contexts = this.contexts;
        var buffer = [];
        var subscription = new Subscription_1.Subscription();
        var context = { buffer: buffer, subscription: subscription };
        contexts.push(context);
        var innerSubscription = subscribeToResult_1.subscribeToResult(this, closingNotifier, context);
        if (!innerSubscription || innerSubscription.closed) {
            this.closeBuffer(context);
        }
        else {
            innerSubscription.context = context;
            this.add(innerSubscription);
            subscription.add(innerSubscription);
        }
    };
    return BufferToggleSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
//# sourceMappingURL=bufferToggle.js.map

/***/ }),
/* 1261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscription_1 = __webpack_require__(18);
var tryCatch_1 = __webpack_require__(25);
var errorObject_1 = __webpack_require__(22);
var OuterSubscriber_1 = __webpack_require__(6);
var subscribeToResult_1 = __webpack_require__(7);
/**
 * Buffers the source Observable values, using a factory function of closing
 * Observables to determine when to close, emit, and reset the buffer.
 *
 * <span class="informal">Collects values from the past as an array. When it
 * starts collecting values, it calls a function that returns an Observable that
 * tells when to close the buffer and restart collecting.</span>
 *
 * <img src="./img/bufferWhen.png" width="100%">
 *
 * Opens a buffer immediately, then closes the buffer when the observable
 * returned by calling `closingSelector` function emits a value. When it closes
 * the buffer, it immediately opens a new buffer and repeats the process.
 *
 * @example <caption>Emit an array of the last clicks every [1-5] random seconds</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var buffered = clicks.bufferWhen(() =>
 *   Rx.Observable.interval(1000 + Math.random() * 4000)
 * );
 * buffered.subscribe(x => console.log(x));
 *
 * @see {@link buffer}
 * @see {@link bufferCount}
 * @see {@link bufferTime}
 * @see {@link bufferToggle}
 * @see {@link windowWhen}
 *
 * @param {function(): Observable} closingSelector A function that takes no
 * arguments and returns an Observable that signals buffer closure.
 * @return {Observable<T[]>} An observable of arrays of buffered values.
 * @method bufferWhen
 * @owner Observable
 */
function bufferWhen(closingSelector) {
    return this.lift(new BufferWhenOperator(closingSelector));
}
exports.bufferWhen = bufferWhen;
var BufferWhenOperator = (function () {
    function BufferWhenOperator(closingSelector) {
        this.closingSelector = closingSelector;
    }
    BufferWhenOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new BufferWhenSubscriber(subscriber, this.closingSelector));
    };
    return BufferWhenOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var BufferWhenSubscriber = (function (_super) {
    __extends(BufferWhenSubscriber, _super);
    function BufferWhenSubscriber(destination, closingSelector) {
        _super.call(this, destination);
        this.closingSelector = closingSelector;
        this.subscribing = false;
        this.openBuffer();
    }
    BufferWhenSubscriber.prototype._next = function (value) {
        this.buffer.push(value);
    };
    BufferWhenSubscriber.prototype._complete = function () {
        var buffer = this.buffer;
        if (buffer) {
            this.destination.next(buffer);
        }
        _super.prototype._complete.call(this);
    };
    BufferWhenSubscriber.prototype._unsubscribe = function () {
        this.buffer = null;
        this.subscribing = false;
    };
    BufferWhenSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.openBuffer();
    };
    BufferWhenSubscriber.prototype.notifyComplete = function () {
        if (this.subscribing) {
            this.complete();
        }
        else {
            this.openBuffer();
        }
    };
    BufferWhenSubscriber.prototype.openBuffer = function () {
        var closingSubscription = this.closingSubscription;
        if (closingSubscription) {
            this.remove(closingSubscription);
            closingSubscription.unsubscribe();
        }
        var buffer = this.buffer;
        if (this.buffer) {
            this.destination.next(buffer);
        }
        this.buffer = [];
        var closingNotifier = tryCatch_1.tryCatch(this.closingSelector)();
        if (closingNotifier === errorObject_1.errorObject) {
            this.error(errorObject_1.errorObject.e);
        }
        else {
            closingSubscription = new Subscription_1.Subscription();
            this.closingSubscription = closingSubscription;
            this.add(closingSubscription);
            this.subscribing = true;
            closingSubscription.add(subscribeToResult_1.subscribeToResult(this, closingNotifier));
            this.subscribing = false;
        }
    };
    return BufferWhenSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
//# sourceMappingURL=bufferWhen.js.map

/***/ }),
/* 1262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var combineLatest_1 = __webpack_require__(273);
/**
 * Converts a higher-order Observable into a first-order Observable by waiting
 * for the outer Observable to complete, then applying {@link combineLatest}.
 *
 * <span class="informal">Flattens an Observable-of-Observables by applying
 * {@link combineLatest} when the Observable-of-Observables completes.</span>
 *
 * <img src="./img/combineAll.png" width="100%">
 *
 * Takes an Observable of Observables, and collects all Observables from it.
 * Once the outer Observable completes, it subscribes to all collected
 * Observables and combines their values using the {@link combineLatest}
 * strategy, such that:
 * - Every time an inner Observable emits, the output Observable emits.
 * - When the returned observable emits, it emits all of the latest values by:
 *   - If a `project` function is provided, it is called with each recent value
 *     from each inner Observable in whatever order they arrived, and the result
 *     of the `project` function is what is emitted by the output Observable.
 *   - If there is no `project` function, an array of all of the most recent
 *     values is emitted by the output Observable.
 *
 * @example <caption>Map two click events to a finite interval Observable, then apply combineAll</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var higherOrder = clicks.map(ev =>
 *   Rx.Observable.interval(Math.random()*2000).take(3)
 * ).take(2);
 * var result = higherOrder.combineAll();
 * result.subscribe(x => console.log(x));
 *
 * @see {@link combineLatest}
 * @see {@link mergeAll}
 *
 * @param {function} [project] An optional function to map the most recent
 * values from each inner Observable into a new result. Takes each of the most
 * recent values from each collected inner Observable as arguments, in order.
 * @return {Observable} An Observable of projected results or arrays of recent
 * values.
 * @method combineAll
 * @owner Observable
 */
function combineAll(project) {
    return this.lift(new combineLatest_1.CombineLatestOperator(project));
}
exports.combineAll = combineAll;
//# sourceMappingURL=combineAll.js.map

/***/ }),
/* 1263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var mergeMapTo_1 = __webpack_require__(484);
/* tslint:enable:max-line-length */
/**
 * Projects each source value to the same Observable which is merged multiple
 * times in a serialized fashion on the output Observable.
 *
 * <span class="informal">It's like {@link concatMap}, but maps each value
 * always to the same inner Observable.</span>
 *
 * <img src="./img/concatMapTo.png" width="100%">
 *
 * Maps each source value to the given Observable `innerObservable` regardless
 * of the source value, and then flattens those resulting Observables into one
 * single Observable, which is the output Observable. Each new `innerObservable`
 * instance emitted on the output Observable is concatenated with the previous
 * `innerObservable` instance.
 *
 * __Warning:__ if source values arrive endlessly and faster than their
 * corresponding inner Observables can complete, it will result in memory issues
 * as inner Observables amass in an unbounded buffer waiting for their turn to
 * be subscribed to.
 *
 * Note: `concatMapTo` is equivalent to `mergeMapTo` with concurrency parameter
 * set to `1`.
 *
 * @example <caption>For each click event, tick every second from 0 to 3, with no concurrency</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.concatMapTo(Rx.Observable.interval(1000).take(4));
 * result.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // (results are not concurrent)
 * // For every click on the "document" it will emit values 0 to 3 spaced
 * // on a 1000ms interval
 * // one click = 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3
 *
 * @see {@link concat}
 * @see {@link concatAll}
 * @see {@link concatMap}
 * @see {@link mergeMapTo}
 * @see {@link switchMapTo}
 *
 * @param {ObservableInput} innerObservable An Observable to replace each value from
 * the source Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @return {Observable} An observable of values merged together by joining the
 * passed observable with itself, one after the other, for each value emitted
 * from the source.
 * @method concatMapTo
 * @owner Observable
 */
function concatMapTo(innerObservable, resultSelector) {
    return this.lift(new mergeMapTo_1.MergeMapToOperator(innerObservable, resultSelector, 1));
}
exports.concatMapTo = concatMapTo;
//# sourceMappingURL=concatMapTo.js.map

/***/ }),
/* 1264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(3);
/**
 * Counts the number of emissions on the source and emits that number when the
 * source completes.
 *
 * <span class="informal">Tells how many values were emitted, when the source
 * completes.</span>
 *
 * <img src="./img/count.png" width="100%">
 *
 * `count` transforms an Observable that emits values into an Observable that
 * emits a single value that represents the number of values emitted by the
 * source Observable. If the source Observable terminates with an error, `count`
 * will pass this error notification along without emitting a value first. If
 * the source Observable does not terminate at all, `count` will neither emit
 * a value nor terminate. This operator takes an optional `predicate` function
 * as argument, in which case the output emission will represent the number of
 * source values that matched `true` with the `predicate`.
 *
 * @example <caption>Counts how many seconds have passed before the first click happened</caption>
 * var seconds = Rx.Observable.interval(1000);
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var secondsBeforeClick = seconds.takeUntil(clicks);
 * var result = secondsBeforeClick.count();
 * result.subscribe(x => console.log(x));
 *
 * @example <caption>Counts how many odd numbers are there between 1 and 7</caption>
 * var numbers = Rx.Observable.range(1, 7);
 * var result = numbers.count(i => i % 2 === 1);
 * result.subscribe(x => console.log(x));
 *
 * // Results in:
 * // 4
 *
 * @see {@link max}
 * @see {@link min}
 * @see {@link reduce}
 *
 * @param {function(value: T, i: number, source: Observable<T>): boolean} [predicate] A
 * boolean function to select what values are to be counted. It is provided with
 * arguments of:
 * - `value`: the value from the source Observable.
 * - `index`: the (zero-based) "index" of the value from the source Observable.
 * - `source`: the source Observable instance itself.
 * @return {Observable} An Observable of one number that represents the count as
 * described above.
 * @method count
 * @owner Observable
 */
function count(predicate) {
    return this.lift(new CountOperator(predicate, this));
}
exports.count = count;
var CountOperator = (function () {
    function CountOperator(predicate, source) {
        this.predicate = predicate;
        this.source = source;
    }
    CountOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new CountSubscriber(subscriber, this.predicate, this.source));
    };
    return CountOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var CountSubscriber = (function (_super) {
    __extends(CountSubscriber, _super);
    function CountSubscriber(destination, predicate, source) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.source = source;
        this.count = 0;
        this.index = 0;
    }
    CountSubscriber.prototype._next = function (value) {
        if (this.predicate) {
            this._tryPredicate(value);
        }
        else {
            this.count++;
        }
    };
    CountSubscriber.prototype._tryPredicate = function (value) {
        var result;
        try {
            result = this.predicate(value, this.index++, this.source);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        if (result) {
            this.count++;
        }
    };
    CountSubscriber.prototype._complete = function () {
        this.destination.next(this.count);
        this.destination.complete();
    };
    return CountSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=count.js.map

/***/ }),
/* 1265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var OuterSubscriber_1 = __webpack_require__(6);
var subscribeToResult_1 = __webpack_require__(7);
/**
 * Emits a value from the source Observable only after a particular time span
 * determined by another Observable has passed without another source emission.
 *
 * <span class="informal">It's like {@link debounceTime}, but the time span of
 * emission silence is determined by a second Observable.</span>
 *
 * <img src="./img/debounce.png" width="100%">
 *
 * `debounce` delays values emitted by the source Observable, but drops previous
 * pending delayed emissions if a new value arrives on the source Observable.
 * This operator keeps track of the most recent value from the source
 * Observable, and spawns a duration Observable by calling the
 * `durationSelector` function. The value is emitted only when the duration
 * Observable emits a value or completes, and if no other value was emitted on
 * the source Observable since the duration Observable was spawned. If a new
 * value appears before the duration Observable emits, the previous value will
 * be dropped and will not be emitted on the output Observable.
 *
 * Like {@link debounceTime}, this is a rate-limiting operator, and also a
 * delay-like operator since output emissions do not necessarily occur at the
 * same time as they did on the source Observable.
 *
 * @example <caption>Emit the most recent click after a burst of clicks</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.debounce(() => Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link audit}
 * @see {@link debounceTime}
 * @see {@link delayWhen}
 * @see {@link throttle}
 *
 * @param {function(value: T): SubscribableOrPromise} durationSelector A function
 * that receives a value from the source Observable, for computing the timeout
 * duration for each source value, returned as an Observable or a Promise.
 * @return {Observable} An Observable that delays the emissions of the source
 * Observable by the specified duration Observable returned by
 * `durationSelector`, and may drop some values if they occur too frequently.
 * @method debounce
 * @owner Observable
 */
function debounce(durationSelector) {
    return this.lift(new DebounceOperator(durationSelector));
}
exports.debounce = debounce;
var DebounceOperator = (function () {
    function DebounceOperator(durationSelector) {
        this.durationSelector = durationSelector;
    }
    DebounceOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new DebounceSubscriber(subscriber, this.durationSelector));
    };
    return DebounceOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var DebounceSubscriber = (function (_super) {
    __extends(DebounceSubscriber, _super);
    function DebounceSubscriber(destination, durationSelector) {
        _super.call(this, destination);
        this.durationSelector = durationSelector;
        this.hasValue = false;
        this.durationSubscription = null;
    }
    DebounceSubscriber.prototype._next = function (value) {
        try {
            var result = this.durationSelector.call(this, value);
            if (result) {
                this._tryNext(value, result);
            }
        }
        catch (err) {
            this.destination.error(err);
        }
    };
    DebounceSubscriber.prototype._complete = function () {
        this.emitValue();
        this.destination.complete();
    };
    DebounceSubscriber.prototype._tryNext = function (value, duration) {
        var subscription = this.durationSubscription;
        this.value = value;
        this.hasValue = true;
        if (subscription) {
            subscription.unsubscribe();
            this.remove(subscription);
        }
        subscription = subscribeToResult_1.subscribeToResult(this, duration);
        if (!subscription.closed) {
            this.add(this.durationSubscription = subscription);
        }
    };
    DebounceSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.emitValue();
    };
    DebounceSubscriber.prototype.notifyComplete = function () {
        this.emitValue();
    };
    DebounceSubscriber.prototype.emitValue = function () {
        if (this.hasValue) {
            var value = this.value;
            var subscription = this.durationSubscription;
            if (subscription) {
                this.durationSubscription = null;
                subscription.unsubscribe();
                this.remove(subscription);
            }
            this.value = null;
            this.hasValue = false;
            _super.prototype._next.call(this, value);
        }
    };
    return DebounceSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
//# sourceMappingURL=debounce.js.map

/***/ }),
/* 1266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(3);
var async_1 = __webpack_require__(30);
/**
 * Emits a value from the source Observable only after a particular time span
 * has passed without another source emission.
 *
 * <span class="informal">It's like {@link delay}, but passes only the most
 * recent value from each burst of emissions.</span>
 *
 * <img src="./img/debounceTime.png" width="100%">
 *
 * `debounceTime` delays values emitted by the source Observable, but drops
 * previous pending delayed emissions if a new value arrives on the source
 * Observable. This operator keeps track of the most recent value from the
 * source Observable, and emits that only when `dueTime` enough time has passed
 * without any other value appearing on the source Observable. If a new value
 * appears before `dueTime` silence occurs, the previous value will be dropped
 * and will not be emitted on the output Observable.
 *
 * This is a rate-limiting operator, because it is impossible for more than one
 * value to be emitted in any time window of duration `dueTime`, but it is also
 * a delay-like operator since output emissions do not occur at the same time as
 * they did on the source Observable. Optionally takes a {@link IScheduler} for
 * managing timers.
 *
 * @example <caption>Emit the most recent click after a burst of clicks</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.debounceTime(1000);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link auditTime}
 * @see {@link debounce}
 * @see {@link delay}
 * @see {@link sampleTime}
 * @see {@link throttleTime}
 *
 * @param {number} dueTime The timeout duration in milliseconds (or the time
 * unit determined internally by the optional `scheduler`) for the window of
 * time required to wait for emission silence before emitting the most recent
 * source value.
 * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
 * managing the timers that handle the timeout for each value.
 * @return {Observable} An Observable that delays the emissions of the source
 * Observable by the specified `dueTime`, and may drop some values if they occur
 * too frequently.
 * @method debounceTime
 * @owner Observable
 */
function debounceTime(dueTime, scheduler) {
    if (scheduler === void 0) { scheduler = async_1.async; }
    return this.lift(new DebounceTimeOperator(dueTime, scheduler));
}
exports.debounceTime = debounceTime;
var DebounceTimeOperator = (function () {
    function DebounceTimeOperator(dueTime, scheduler) {
        this.dueTime = dueTime;
        this.scheduler = scheduler;
    }
    DebounceTimeOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new DebounceTimeSubscriber(subscriber, this.dueTime, this.scheduler));
    };
    return DebounceTimeOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var DebounceTimeSubscriber = (function (_super) {
    __extends(DebounceTimeSubscriber, _super);
    function DebounceTimeSubscriber(destination, dueTime, scheduler) {
        _super.call(this, destination);
        this.dueTime = dueTime;
        this.scheduler = scheduler;
        this.debouncedSubscription = null;
        this.lastValue = null;
        this.hasValue = false;
    }
    DebounceTimeSubscriber.prototype._next = function (value) {
        this.clearDebounce();
        this.lastValue = value;
        this.hasValue = true;
        this.add(this.debouncedSubscription = this.scheduler.schedule(dispatchNext, this.dueTime, this));
    };
    DebounceTimeSubscriber.prototype._complete = function () {
        this.debouncedNext();
        this.destination.complete();
    };
    DebounceTimeSubscriber.prototype.debouncedNext = function () {
        this.clearDebounce();
        if (this.hasValue) {
            this.destination.next(this.lastValue);
            this.lastValue = null;
            this.hasValue = false;
        }
    };
    DebounceTimeSubscriber.prototype.clearDebounce = function () {
        var debouncedSubscription = this.debouncedSubscription;
        if (debouncedSubscription !== null) {
            this.remove(debouncedSubscription);
            debouncedSubscription.unsubscribe();
            this.debouncedSubscription = null;
        }
    };
    return DebounceTimeSubscriber;
}(Subscriber_1.Subscriber));
function dispatchNext(subscriber) {
    subscriber.debouncedNext();
}
//# sourceMappingURL=debounceTime.js.map

/***/ }),
/* 1267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(3);
/* tslint:enable:max-line-length */
/**
 * Emits a given value if the source Observable completes without emitting any
 * `next` value, otherwise mirrors the source Observable.
 *
 * <span class="informal">If the source Observable turns out to be empty, then
 * this operator will emit a default value.</span>
 *
 * <img src="./img/defaultIfEmpty.png" width="100%">
 *
 * `defaultIfEmpty` emits the values emitted by the source Observable or a
 * specified default value if the source Observable is empty (completes without
 * having emitted any `next` value).
 *
 * @example <caption>If no clicks happen in 5 seconds, then emit "no clicks"</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var clicksBeforeFive = clicks.takeUntil(Rx.Observable.interval(5000));
 * var result = clicksBeforeFive.defaultIfEmpty('no clicks');
 * result.subscribe(x => console.log(x));
 *
 * @see {@link empty}
 * @see {@link last}
 *
 * @param {any} [defaultValue=null] The default value used if the source
 * Observable is empty.
 * @return {Observable} An Observable that emits either the specified
 * `defaultValue` if the source Observable emits no items, or the values emitted
 * by the source Observable.
 * @method defaultIfEmpty
 * @owner Observable
 */
function defaultIfEmpty(defaultValue) {
    if (defaultValue === void 0) { defaultValue = null; }
    return this.lift(new DefaultIfEmptyOperator(defaultValue));
}
exports.defaultIfEmpty = defaultIfEmpty;
var DefaultIfEmptyOperator = (function () {
    function DefaultIfEmptyOperator(defaultValue) {
        this.defaultValue = defaultValue;
    }
    DefaultIfEmptyOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new DefaultIfEmptySubscriber(subscriber, this.defaultValue));
    };
    return DefaultIfEmptyOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var DefaultIfEmptySubscriber = (function (_super) {
    __extends(DefaultIfEmptySubscriber, _super);
    function DefaultIfEmptySubscriber(destination, defaultValue) {
        _super.call(this, destination);
        this.defaultValue = defaultValue;
        this.isEmpty = true;
    }
    DefaultIfEmptySubscriber.prototype._next = function (value) {
        this.isEmpty = false;
        this.destination.next(value);
    };
    DefaultIfEmptySubscriber.prototype._complete = function () {
        if (this.isEmpty) {
            this.destination.next(this.defaultValue);
        }
        this.destination.complete();
    };
    return DefaultIfEmptySubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=defaultIfEmpty.js.map

/***/ }),
/* 1268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var async_1 = __webpack_require__(30);
var isDate_1 = __webpack_require__(172);
var Subscriber_1 = __webpack_require__(3);
var Notification_1 = __webpack_require__(125);
/**
 * Delays the emission of items from the source Observable by a given timeout or
 * until a given Date.
 *
 * <span class="informal">Time shifts each item by some specified amount of
 * milliseconds.</span>
 *
 * <img src="./img/delay.png" width="100%">
 *
 * If the delay argument is a Number, this operator time shifts the source
 * Observable by that amount of time expressed in milliseconds. The relative
 * time intervals between the values are preserved.
 *
 * If the delay argument is a Date, this operator time shifts the start of the
 * Observable execution until the given date occurs.
 *
 * @example <caption>Delay each click by one second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var delayedClicks = clicks.delay(1000); // each click emitted after 1 second
 * delayedClicks.subscribe(x => console.log(x));
 *
 * @example <caption>Delay all clicks until a future date happens</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var date = new Date('March 15, 2050 12:00:00'); // in the future
 * var delayedClicks = clicks.delay(date); // click emitted only after that date
 * delayedClicks.subscribe(x => console.log(x));
 *
 * @see {@link debounceTime}
 * @see {@link delayWhen}
 *
 * @param {number|Date} delay The delay duration in milliseconds (a `number`) or
 * a `Date` until which the emission of the source items is delayed.
 * @param {Scheduler} [scheduler=async] The IScheduler to use for
 * managing the timers that handle the time-shift for each item.
 * @return {Observable} An Observable that delays the emissions of the source
 * Observable by the specified timeout or Date.
 * @method delay
 * @owner Observable
 */
function delay(delay, scheduler) {
    if (scheduler === void 0) { scheduler = async_1.async; }
    var absoluteDelay = isDate_1.isDate(delay);
    var delayFor = absoluteDelay ? (+delay - scheduler.now()) : Math.abs(delay);
    return this.lift(new DelayOperator(delayFor, scheduler));
}
exports.delay = delay;
var DelayOperator = (function () {
    function DelayOperator(delay, scheduler) {
        this.delay = delay;
        this.scheduler = scheduler;
    }
    DelayOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new DelaySubscriber(subscriber, this.delay, this.scheduler));
    };
    return DelayOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var DelaySubscriber = (function (_super) {
    __extends(DelaySubscriber, _super);
    function DelaySubscriber(destination, delay, scheduler) {
        _super.call(this, destination);
        this.delay = delay;
        this.scheduler = scheduler;
        this.queue = [];
        this.active = false;
        this.errored = false;
    }
    DelaySubscriber.dispatch = function (state) {
        var source = state.source;
        var queue = source.queue;
        var scheduler = state.scheduler;
        var destination = state.destination;
        while (queue.length > 0 && (queue[0].time - scheduler.now()) <= 0) {
            queue.shift().notification.observe(destination);
        }
        if (queue.length > 0) {
            var delay_1 = Math.max(0, queue[0].time - scheduler.now());
            this.schedule(state, delay_1);
        }
        else {
            source.active = false;
        }
    };
    DelaySubscriber.prototype._schedule = function (scheduler) {
        this.active = true;
        this.add(scheduler.schedule(DelaySubscriber.dispatch, this.delay, {
            source: this, destination: this.destination, scheduler: scheduler
        }));
    };
    DelaySubscriber.prototype.scheduleNotification = function (notification) {
        if (this.errored === true) {
            return;
        }
        var scheduler = this.scheduler;
        var message = new DelayMessage(scheduler.now() + this.delay, notification);
        this.queue.push(message);
        if (this.active === false) {
            this._schedule(scheduler);
        }
    };
    DelaySubscriber.prototype._next = function (value) {
        this.scheduleNotification(Notification_1.Notification.createNext(value));
    };
    DelaySubscriber.prototype._error = function (err) {
        this.errored = true;
        this.queue = [];
        this.destination.error(err);
    };
    DelaySubscriber.prototype._complete = function () {
        this.scheduleNotification(Notification_1.Notification.createComplete());
    };
    return DelaySubscriber;
}(Subscriber_1.Subscriber));
var DelayMessage = (function () {
    function DelayMessage(time, notification) {
        this.time = time;
        this.notification = notification;
    }
    return DelayMessage;
}());
//# sourceMappingURL=delay.js.map

/***/ }),
/* 1269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(3);
var Observable_1 = __webpack_require__(0);
var OuterSubscriber_1 = __webpack_require__(6);
var subscribeToResult_1 = __webpack_require__(7);
/**
 * Delays the emission of items from the source Observable by a given time span
 * determined by the emissions of another Observable.
 *
 * <span class="informal">It's like {@link delay}, but the time span of the
 * delay duration is determined by a second Observable.</span>
 *
 * <img src="./img/delayWhen.png" width="100%">
 *
 * `delayWhen` time shifts each emitted value from the source Observable by a
 * time span determined by another Observable. When the source emits a value,
 * the `delayDurationSelector` function is called with the source value as
 * argument, and should return an Observable, called the "duration" Observable.
 * The source value is emitted on the output Observable only when the duration
 * Observable emits a value or completes.
 *
 * Optionally, `delayWhen` takes a second argument, `subscriptionDelay`, which
 * is an Observable. When `subscriptionDelay` emits its first value or
 * completes, the source Observable is subscribed to and starts behaving like
 * described in the previous paragraph. If `subscriptionDelay` is not provided,
 * `delayWhen` will subscribe to the source Observable as soon as the output
 * Observable is subscribed.
 *
 * @example <caption>Delay each click by a random amount of time, between 0 and 5 seconds</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var delayedClicks = clicks.delayWhen(event =>
 *   Rx.Observable.interval(Math.random() * 5000)
 * );
 * delayedClicks.subscribe(x => console.log(x));
 *
 * @see {@link debounce}
 * @see {@link delay}
 *
 * @param {function(value: T): Observable} delayDurationSelector A function that
 * returns an Observable for each value emitted by the source Observable, which
 * is then used to delay the emission of that item on the output Observable
 * until the Observable returned from this function emits a value.
 * @param {Observable} subscriptionDelay An Observable that triggers the
 * subscription to the source Observable once it emits any value.
 * @return {Observable} An Observable that delays the emissions of the source
 * Observable by an amount of time specified by the Observable returned by
 * `delayDurationSelector`.
 * @method delayWhen
 * @owner Observable
 */
function delayWhen(delayDurationSelector, subscriptionDelay) {
    if (subscriptionDelay) {
        return new SubscriptionDelayObservable(this, subscriptionDelay)
            .lift(new DelayWhenOperator(delayDurationSelector));
    }
    return this.lift(new DelayWhenOperator(delayDurationSelector));
}
exports.delayWhen = delayWhen;
var DelayWhenOperator = (function () {
    function DelayWhenOperator(delayDurationSelector) {
        this.delayDurationSelector = delayDurationSelector;
    }
    DelayWhenOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new DelayWhenSubscriber(subscriber, this.delayDurationSelector));
    };
    return DelayWhenOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var DelayWhenSubscriber = (function (_super) {
    __extends(DelayWhenSubscriber, _super);
    function DelayWhenSubscriber(destination, delayDurationSelector) {
        _super.call(this, destination);
        this.delayDurationSelector = delayDurationSelector;
        this.completed = false;
        this.delayNotifierSubscriptions = [];
        this.values = [];
    }
    DelayWhenSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.destination.next(outerValue);
        this.removeSubscription(innerSub);
        this.tryComplete();
    };
    DelayWhenSubscriber.prototype.notifyError = function (error, innerSub) {
        this._error(error);
    };
    DelayWhenSubscriber.prototype.notifyComplete = function (innerSub) {
        var value = this.removeSubscription(innerSub);
        if (value) {
            this.destination.next(value);
        }
        this.tryComplete();
    };
    DelayWhenSubscriber.prototype._next = function (value) {
        try {
            var delayNotifier = this.delayDurationSelector(value);
            if (delayNotifier) {
                this.tryDelay(delayNotifier, value);
            }
        }
        catch (err) {
            this.destination.error(err);
        }
    };
    DelayWhenSubscriber.prototype._complete = function () {
        this.completed = true;
        this.tryComplete();
    };
    DelayWhenSubscriber.prototype.removeSubscription = function (subscription) {
        subscription.unsubscribe();
        var subscriptionIdx = this.delayNotifierSubscriptions.indexOf(subscription);
        var value = null;
        if (subscriptionIdx !== -1) {
            value = this.values[subscriptionIdx];
            this.delayNotifierSubscriptions.splice(subscriptionIdx, 1);
            this.values.splice(subscriptionIdx, 1);
        }
        return value;
    };
    DelayWhenSubscriber.prototype.tryDelay = function (delayNotifier, value) {
        var notifierSubscription = subscribeToResult_1.subscribeToResult(this, delayNotifier, value);
        if (notifierSubscription && !notifierSubscription.closed) {
            this.add(notifierSubscription);
            this.delayNotifierSubscriptions.push(notifierSubscription);
        }
        this.values.push(value);
    };
    DelayWhenSubscriber.prototype.tryComplete = function () {
        if (this.completed && this.delayNotifierSubscriptions.length === 0) {
            this.destination.complete();
        }
    };
    return DelayWhenSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var SubscriptionDelayObservable = (function (_super) {
    __extends(SubscriptionDelayObservable, _super);
    function SubscriptionDelayObservable(source, subscriptionDelay) {
        _super.call(this);
        this.source = source;
        this.subscriptionDelay = subscriptionDelay;
    }
    SubscriptionDelayObservable.prototype._subscribe = function (subscriber) {
        this.subscriptionDelay.subscribe(new SubscriptionDelaySubscriber(subscriber, this.source));
    };
    return SubscriptionDelayObservable;
}(Observable_1.Observable));
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var SubscriptionDelaySubscriber = (function (_super) {
    __extends(SubscriptionDelaySubscriber, _super);
    function SubscriptionDelaySubscriber(parent, source) {
        _super.call(this);
        this.parent = parent;
        this.source = source;
        this.sourceSubscribed = false;
    }
    SubscriptionDelaySubscriber.prototype._next = function (unused) {
        this.subscribeToSource();
    };
    SubscriptionDelaySubscriber.prototype._error = function (err) {
        this.unsubscribe();
        this.parent.error(err);
    };
    SubscriptionDelaySubscriber.prototype._complete = function () {
        this.subscribeToSource();
    };
    SubscriptionDelaySubscriber.prototype.subscribeToSource = function () {
        if (!this.sourceSubscribed) {
            this.sourceSubscribed = true;
            this.unsubscribe();
            this.source.subscribe(this.parent);
        }
    };
    return SubscriptionDelaySubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=delayWhen.js.map

/***/ }),
/* 1270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(3);
/**
 * Converts an Observable of {@link Notification} objects into the emissions
 * that they represent.
 *
 * <span class="informal">Unwraps {@link Notification} objects as actual `next`,
 * `error` and `complete` emissions. The opposite of {@link materialize}.</span>
 *
 * <img src="./img/dematerialize.png" width="100%">
 *
 * `dematerialize` is assumed to operate an Observable that only emits
 * {@link Notification} objects as `next` emissions, and does not emit any
 * `error`. Such Observable is the output of a `materialize` operation. Those
 * notifications are then unwrapped using the metadata they contain, and emitted
 * as `next`, `error`, and `complete` on the output Observable.
 *
 * Use this operator in conjunction with {@link materialize}.
 *
 * @example <caption>Convert an Observable of Notifications to an actual Observable</caption>
 * var notifA = new Rx.Notification('N', 'A');
 * var notifB = new Rx.Notification('N', 'B');
 * var notifE = new Rx.Notification('E', void 0,
 *   new TypeError('x.toUpperCase is not a function')
 * );
 * var materialized = Rx.Observable.of(notifA, notifB, notifE);
 * var upperCase = materialized.dematerialize();
 * upperCase.subscribe(x => console.log(x), e => console.error(e));
 *
 * // Results in:
 * // A
 * // B
 * // TypeError: x.toUpperCase is not a function
 *
 * @see {@link Notification}
 * @see {@link materialize}
 *
 * @return {Observable} An Observable that emits items and notifications
 * embedded in Notification objects emitted by the source Observable.
 * @method dematerialize
 * @owner Observable
 */
function dematerialize() {
    return this.lift(new DeMaterializeOperator());
}
exports.dematerialize = dematerialize;
var DeMaterializeOperator = (function () {
    function DeMaterializeOperator() {
    }
    DeMaterializeOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new DeMaterializeSubscriber(subscriber));
    };
    return DeMaterializeOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var DeMaterializeSubscriber = (function (_super) {
    __extends(DeMaterializeSubscriber, _super);
    function DeMaterializeSubscriber(destination) {
        _super.call(this, destination);
    }
    DeMaterializeSubscriber.prototype._next = function (value) {
        value.observe(this.destination);
    };
    return DeMaterializeSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=dematerialize.js.map

/***/ }),
/* 1271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var OuterSubscriber_1 = __webpack_require__(6);
var subscribeToResult_1 = __webpack_require__(7);
var Set_1 = __webpack_require__(1347);
/**
 * Returns an Observable that emits all items emitted by the source Observable that are distinct by comparison from previous items.
 *
 * If a keySelector function is provided, then it will project each value from the source observable into a new value that it will
 * check for equality with previously projected values. If a keySelector function is not provided, it will use each value from the
 * source observable directly with an equality check against previous values.
 *
 * In JavaScript runtimes that support `Set`, this operator will use a `Set` to improve performance of the distinct value checking.
 *
 * In other runtimes, this operator will use a minimal implementation of `Set` that relies on an `Array` and `indexOf` under the
 * hood, so performance will degrade as more values are checked for distinction. Even in newer browsers, a long-running `distinct`
 * use might result in memory leaks. To help alleviate this in some scenarios, an optional `flushes` parameter is also provided so
 * that the internal `Set` can be "flushed", basically clearing it of values.
 *
 * @example <caption>A simple example with numbers</caption>
 * Observable.of(1, 1, 2, 2, 2, 1, 2, 3, 4, 3, 2, 1)
 *   .distinct()
 *   .subscribe(x => console.log(x)); // 1, 2, 3, 4
 *
 * @example <caption>An example using a keySelector function</caption>
 * interface Person {
 *    age: number,
 *    name: string
 * }
 *
 * Observable.of<Person>(
 *     { age: 4, name: 'Foo'},
 *     { age: 7, name: 'Bar'},
 *     { age: 5, name: 'Foo'})
 *     .distinct((p: Person) => p.name)
 *     .subscribe(x => console.log(x));
 *
 * // displays:
 * // { age: 4, name: 'Foo' }
 * // { age: 7, name: 'Bar' }
 *
 * @see {@link distinctUntilChanged}
 * @see {@link distinctUntilKeyChanged}
 *
 * @param {function} [keySelector] Optional function to select which value you want to check as distinct.
 * @param {Observable} [flushes] Optional Observable for flushing the internal HashSet of the operator.
 * @return {Observable} An Observable that emits items from the source Observable with distinct values.
 * @method distinct
 * @owner Observable
 */
function distinct(keySelector, flushes) {
    return this.lift(new DistinctOperator(keySelector, flushes));
}
exports.distinct = distinct;
var DistinctOperator = (function () {
    function DistinctOperator(keySelector, flushes) {
        this.keySelector = keySelector;
        this.flushes = flushes;
    }
    DistinctOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new DistinctSubscriber(subscriber, this.keySelector, this.flushes));
    };
    return DistinctOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var DistinctSubscriber = (function (_super) {
    __extends(DistinctSubscriber, _super);
    function DistinctSubscriber(destination, keySelector, flushes) {
        _super.call(this, destination);
        this.keySelector = keySelector;
        this.values = new Set_1.Set();
        if (flushes) {
            this.add(subscribeToResult_1.subscribeToResult(this, flushes));
        }
    }
    DistinctSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.values.clear();
    };
    DistinctSubscriber.prototype.notifyError = function (error, innerSub) {
        this._error(error);
    };
    DistinctSubscriber.prototype._next = function (value) {
        if (this.keySelector) {
            this._useKeySelector(value);
        }
        else {
            this._finalizeNext(value, value);
        }
    };
    DistinctSubscriber.prototype._useKeySelector = function (value) {
        var key;
        var destination = this.destination;
        try {
            key = this.keySelector(value);
        }
        catch (err) {
            destination.error(err);
            return;
        }
        this._finalizeNext(key, value);
    };
    DistinctSubscriber.prototype._finalizeNext = function (key, value) {
        var values = this.values;
        if (!values.has(key)) {
            values.add(key);
            this.destination.next(value);
        }
    };
    return DistinctSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
exports.DistinctSubscriber = DistinctSubscriber;
//# sourceMappingURL=distinct.js.map

/***/ }),
/* 1272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var distinctUntilChanged_1 = __webpack_require__(478);
/* tslint:enable:max-line-length */
/**
 * Returns an Observable that emits all items emitted by the source Observable that are distinct by comparison from the previous item,
 * using a property accessed by using the key provided to check if the two items are distinct.
 *
 * If a comparator function is provided, then it will be called for each item to test for whether or not that value should be emitted.
 *
 * If a comparator function is not provided, an equality check is used by default.
 *
 * @example <caption>An example comparing the name of persons</caption>
 *
 *  interface Person {
 *     age: number,
 *     name: string
 *  }
 *
 * Observable.of<Person>(
 *     { age: 4, name: 'Foo'},
 *     { age: 7, name: 'Bar'},
 *     { age: 5, name: 'Foo'},
 *     { age: 6, name: 'Foo'})
 *     .distinctUntilKeyChanged('name')
 *     .subscribe(x => console.log(x));
 *
 * // displays:
 * // { age: 4, name: 'Foo' }
 * // { age: 7, name: 'Bar' }
 * // { age: 5, name: 'Foo' }
 *
 * @example <caption>An example comparing the first letters of the name</caption>
 *
 * interface Person {
 *     age: number,
 *     name: string
 *  }
 *
 * Observable.of<Person>(
 *     { age: 4, name: 'Foo1'},
 *     { age: 7, name: 'Bar'},
 *     { age: 5, name: 'Foo2'},
 *     { age: 6, name: 'Foo3'})
 *     .distinctUntilKeyChanged('name', (x: string, y: string) => x.substring(0, 3) === y.substring(0, 3))
 *     .subscribe(x => console.log(x));
 *
 * // displays:
 * // { age: 4, name: 'Foo1' }
 * // { age: 7, name: 'Bar' }
 * // { age: 5, name: 'Foo2' }
 *
 * @see {@link distinct}
 * @see {@link distinctUntilChanged}
 *
 * @param {string} key String key for object property lookup on each item.
 * @param {function} [compare] Optional comparison function called to test if an item is distinct from the previous item in the source.
 * @return {Observable} An Observable that emits items from the source Observable with distinct values based on the key specified.
 * @method distinctUntilKeyChanged
 * @owner Observable
 */
function distinctUntilKeyChanged(key, compare) {
    return distinctUntilChanged_1.distinctUntilChanged.call(this, function (x, y) {
        if (compare) {
            return compare(x[key], y[key]);
        }
        return x[key] === y[key];
    });
}
exports.distinctUntilKeyChanged = distinctUntilKeyChanged;
//# sourceMappingURL=distinctUntilKeyChanged.js.map

/***/ }),
/* 1273 */,
/* 1274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(3);
var ArgumentOutOfRangeError_1 = __webpack_require__(131);
/**
 * Emits the single value at the specified `index` in a sequence of emissions
 * from the source Observable.
 *
 * <span class="informal">Emits only the i-th value, then completes.</span>
 *
 * <img src="./img/elementAt.png" width="100%">
 *
 * `elementAt` returns an Observable that emits the item at the specified
 * `index` in the source Observable, or a default value if that `index` is out
 * of range and the `default` argument is provided. If the `default` argument is
 * not given and the `index` is out of range, the output Observable will emit an
 * `ArgumentOutOfRangeError` error.
 *
 * @example <caption>Emit only the third click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.elementAt(2);
 * result.subscribe(x => console.log(x));
 *
 * // Results in:
 * // click 1 = nothing
 * // click 2 = nothing
 * // click 3 = MouseEvent object logged to console
 *
 * @see {@link first}
 * @see {@link last}
 * @see {@link skip}
 * @see {@link single}
 * @see {@link take}
 *
 * @throws {ArgumentOutOfRangeError} When using `elementAt(i)`, it delivers an
 * ArgumentOutOrRangeError to the Observer's `error` callback if `i < 0` or the
 * Observable has completed before emitting the i-th `next` notification.
 *
 * @param {number} index Is the number `i` for the i-th source emission that has
 * happened since the subscription, starting from the number `0`.
 * @param {T} [defaultValue] The default value returned for missing indices.
 * @return {Observable} An Observable that emits a single item, if it is found.
 * Otherwise, will emit the default value if given. If not, then emits an error.
 * @method elementAt
 * @owner Observable
 */
function elementAt(index, defaultValue) {
    return this.lift(new ElementAtOperator(index, defaultValue));
}
exports.elementAt = elementAt;
var ElementAtOperator = (function () {
    function ElementAtOperator(index, defaultValue) {
        this.index = index;
        this.defaultValue = defaultValue;
        if (index < 0) {
            throw new ArgumentOutOfRangeError_1.ArgumentOutOfRangeError;
        }
    }
    ElementAtOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new ElementAtSubscriber(subscriber, this.index, this.defaultValue));
    };
    return ElementAtOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var ElementAtSubscriber = (function (_super) {
    __extends(ElementAtSubscriber, _super);
    function ElementAtSubscriber(destination, index, defaultValue) {
        _super.call(this, destination);
        this.index = index;
        this.defaultValue = defaultValue;
    }
    ElementAtSubscriber.prototype._next = function (x) {
        if (this.index-- === 0) {
            this.destination.next(x);
            this.destination.complete();
        }
    };
    ElementAtSubscriber.prototype._complete = function () {
        var destination = this.destination;
        if (this.index >= 0) {
            if (typeof this.defaultValue !== 'undefined') {
                destination.next(this.defaultValue);
            }
            else {
                destination.error(new ArgumentOutOfRangeError_1.ArgumentOutOfRangeError);
            }
        }
        destination.complete();
    };
    return ElementAtSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=elementAt.js.map

/***/ }),
/* 1275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var OuterSubscriber_1 = __webpack_require__(6);
var subscribeToResult_1 = __webpack_require__(7);
/**
 * Converts a higher-order Observable into a first-order Observable by dropping
 * inner Observables while the previous inner Observable has not yet completed.
 *
 * <span class="informal">Flattens an Observable-of-Observables by dropping the
 * next inner Observables while the current inner is still executing.</span>
 *
 * <img src="./img/exhaust.png" width="100%">
 *
 * `exhaust` subscribes to an Observable that emits Observables, also known as a
 * higher-order Observable. Each time it observes one of these emitted inner
 * Observables, the output Observable begins emitting the items emitted by that
 * inner Observable. So far, it behaves like {@link mergeAll}. However,
 * `exhaust` ignores every new inner Observable if the previous Observable has
 * not yet completed. Once that one completes, it will accept and flatten the
 * next inner Observable and repeat this process.
 *
 * @example <caption>Run a finite timer for each click, only if there is no currently active timer</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000).take(5));
 * var result = higherOrder.exhaust();
 * result.subscribe(x => console.log(x));
 *
 * @see {@link combineAll}
 * @see {@link concatAll}
 * @see {@link switch}
 * @see {@link mergeAll}
 * @see {@link exhaustMap}
 * @see {@link zipAll}
 *
 * @return {Observable} An Observable that takes a source of Observables and propagates the first observable
 * exclusively until it completes before subscribing to the next.
 * @method exhaust
 * @owner Observable
 */
function exhaust() {
    return this.lift(new SwitchFirstOperator());
}
exports.exhaust = exhaust;
var SwitchFirstOperator = (function () {
    function SwitchFirstOperator() {
    }
    SwitchFirstOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new SwitchFirstSubscriber(subscriber));
    };
    return SwitchFirstOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var SwitchFirstSubscriber = (function (_super) {
    __extends(SwitchFirstSubscriber, _super);
    function SwitchFirstSubscriber(destination) {
        _super.call(this, destination);
        this.hasCompleted = false;
        this.hasSubscription = false;
    }
    SwitchFirstSubscriber.prototype._next = function (value) {
        if (!this.hasSubscription) {
            this.hasSubscription = true;
            this.add(subscribeToResult_1.subscribeToResult(this, value));
        }
    };
    SwitchFirstSubscriber.prototype._complete = function () {
        this.hasCompleted = true;
        if (!this.hasSubscription) {
            this.destination.complete();
        }
    };
    SwitchFirstSubscriber.prototype.notifyComplete = function (innerSub) {
        this.remove(innerSub);
        this.hasSubscription = false;
        if (this.hasCompleted) {
            this.destination.complete();
        }
    };
    return SwitchFirstSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
//# sourceMappingURL=exhaust.js.map

/***/ }),
/* 1276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var OuterSubscriber_1 = __webpack_require__(6);
var subscribeToResult_1 = __webpack_require__(7);
/* tslint:enable:max-line-length */
/**
 * Projects each source value to an Observable which is merged in the output
 * Observable only if the previous projected Observable has completed.
 *
 * <span class="informal">Maps each value to an Observable, then flattens all of
 * these inner Observables using {@link exhaust}.</span>
 *
 * <img src="./img/exhaustMap.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an (so-called "inner") Observable. When it projects a source value to
 * an Observable, the output Observable begins emitting the items emitted by
 * that projected Observable. However, `exhaustMap` ignores every new projected
 * Observable if the previous projected Observable has not yet completed. Once
 * that one completes, it will accept and flatten the next projected Observable
 * and repeat this process.
 *
 * @example <caption>Run a finite timer for each click, only if there is no currently active timer</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.exhaustMap((ev) => Rx.Observable.interval(1000).take(5));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link concatMap}
 * @see {@link exhaust}
 * @see {@link mergeMap}
 * @see {@link switchMap}
 *
 * @param {function(value: T, ?index: number): ObservableInput} project A function
 * that, when applied to an item emitted by the source Observable, returns an
 * Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @return {Observable} An Observable containing projected Observables
 * of each item of the source, ignoring projected Observables that start before
 * their preceding Observable has completed.
 * @method exhaustMap
 * @owner Observable
 */
function exhaustMap(project, resultSelector) {
    return this.lift(new SwitchFirstMapOperator(project, resultSelector));
}
exports.exhaustMap = exhaustMap;
var SwitchFirstMapOperator = (function () {
    function SwitchFirstMapOperator(project, resultSelector) {
        this.project = project;
        this.resultSelector = resultSelector;
    }
    SwitchFirstMapOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new SwitchFirstMapSubscriber(subscriber, this.project, this.resultSelector));
    };
    return SwitchFirstMapOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var SwitchFirstMapSubscriber = (function (_super) {
    __extends(SwitchFirstMapSubscriber, _super);
    function SwitchFirstMapSubscriber(destination, project, resultSelector) {
        _super.call(this, destination);
        this.project = project;
        this.resultSelector = resultSelector;
        this.hasSubscription = false;
        this.hasCompleted = false;
        this.index = 0;
    }
    SwitchFirstMapSubscriber.prototype._next = function (value) {
        if (!this.hasSubscription) {
            this.tryNext(value);
        }
    };
    SwitchFirstMapSubscriber.prototype.tryNext = function (value) {
        var index = this.index++;
        var destination = this.destination;
        try {
            var result = this.project(value, index);
            this.hasSubscription = true;
            this.add(subscribeToResult_1.subscribeToResult(this, result, value, index));
        }
        catch (err) {
            destination.error(err);
        }
    };
    SwitchFirstMapSubscriber.prototype._complete = function () {
        this.hasCompleted = true;
        if (!this.hasSubscription) {
            this.destination.complete();
        }
    };
    SwitchFirstMapSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        var _a = this, resultSelector = _a.resultSelector, destination = _a.destination;
        if (resultSelector) {
            this.trySelectResult(outerValue, innerValue, outerIndex, innerIndex);
        }
        else {
            destination.next(innerValue);
        }
    };
    SwitchFirstMapSubscriber.prototype.trySelectResult = function (outerValue, innerValue, outerIndex, innerIndex) {
        var _a = this, resultSelector = _a.resultSelector, destination = _a.destination;
        try {
            var result = resultSelector(outerValue, innerValue, outerIndex, innerIndex);
            destination.next(result);
        }
        catch (err) {
            destination.error(err);
        }
    };
    SwitchFirstMapSubscriber.prototype.notifyError = function (err) {
        this.destination.error(err);
    };
    SwitchFirstMapSubscriber.prototype.notifyComplete = function (innerSub) {
        this.remove(innerSub);
        this.hasSubscription = false;
        if (this.hasCompleted) {
            this.destination.complete();
        }
    };
    return SwitchFirstMapSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
//# sourceMappingURL=exhaustMap.js.map

/***/ }),
/* 1277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var tryCatch_1 = __webpack_require__(25);
var errorObject_1 = __webpack_require__(22);
var OuterSubscriber_1 = __webpack_require__(6);
var subscribeToResult_1 = __webpack_require__(7);
/* tslint:enable:max-line-length */
/**
 * Recursively projects each source value to an Observable which is merged in
 * the output Observable.
 *
 * <span class="informal">It's similar to {@link mergeMap}, but applies the
 * projection function to every source value as well as every output value.
 * It's recursive.</span>
 *
 * <img src="./img/expand.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an Observable, and then merging those resulting Observables and
 * emitting the results of this merger. *Expand* will re-emit on the output
 * Observable every source value. Then, each output value is given to the
 * `project` function which returns an inner Observable to be merged on the
 * output Observable. Those output values resulting from the projection are also
 * given to the `project` function to produce new output values. This is how
 * *expand* behaves recursively.
 *
 * @example <caption>Start emitting the powers of two on every click, at most 10 of them</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var powersOfTwo = clicks
 *   .mapTo(1)
 *   .expand(x => Rx.Observable.of(2 * x).delay(1000))
 *   .take(10);
 * powersOfTwo.subscribe(x => console.log(x));
 *
 * @see {@link mergeMap}
 * @see {@link mergeScan}
 *
 * @param {function(value: T, index: number) => Observable} project A function
 * that, when applied to an item emitted by the source or the output Observable,
 * returns an Observable.
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
 * Observables being subscribed to concurrently.
 * @param {Scheduler} [scheduler=null] The IScheduler to use for subscribing to
 * each projected inner Observable.
 * @return {Observable} An Observable that emits the source values and also
 * result of applying the projection function to each value emitted on the
 * output Observable and and merging the results of the Observables obtained
 * from this transformation.
 * @method expand
 * @owner Observable
 */
function expand(project, concurrent, scheduler) {
    if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
    if (scheduler === void 0) { scheduler = undefined; }
    concurrent = (concurrent || 0) < 1 ? Number.POSITIVE_INFINITY : concurrent;
    return this.lift(new ExpandOperator(project, concurrent, scheduler));
}
exports.expand = expand;
var ExpandOperator = (function () {
    function ExpandOperator(project, concurrent, scheduler) {
        this.project = project;
        this.concurrent = concurrent;
        this.scheduler = scheduler;
    }
    ExpandOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new ExpandSubscriber(subscriber, this.project, this.concurrent, this.scheduler));
    };
    return ExpandOperator;
}());
exports.ExpandOperator = ExpandOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var ExpandSubscriber = (function (_super) {
    __extends(ExpandSubscriber, _super);
    function ExpandSubscriber(destination, project, concurrent, scheduler) {
        _super.call(this, destination);
        this.project = project;
        this.concurrent = concurrent;
        this.scheduler = scheduler;
        this.index = 0;
        this.active = 0;
        this.hasCompleted = false;
        if (concurrent < Number.POSITIVE_INFINITY) {
            this.buffer = [];
        }
    }
    ExpandSubscriber.dispatch = function (arg) {
        var subscriber = arg.subscriber, result = arg.result, value = arg.value, index = arg.index;
        subscriber.subscribeToProjection(result, value, index);
    };
    ExpandSubscriber.prototype._next = function (value) {
        var destination = this.destination;
        if (destination.closed) {
            this._complete();
            return;
        }
        var index = this.index++;
        if (this.active < this.concurrent) {
            destination.next(value);
            var result = tryCatch_1.tryCatch(this.project)(value, index);
            if (result === errorObject_1.errorObject) {
                destination.error(errorObject_1.errorObject.e);
            }
            else if (!this.scheduler) {
                this.subscribeToProjection(result, value, index);
            }
            else {
                var state = { subscriber: this, result: result, value: value, index: index };
                this.add(this.scheduler.schedule(ExpandSubscriber.dispatch, 0, state));
            }
        }
        else {
            this.buffer.push(value);
        }
    };
    ExpandSubscriber.prototype.subscribeToProjection = function (result, value, index) {
        this.active++;
        this.add(subscribeToResult_1.subscribeToResult(this, result, value, index));
    };
    ExpandSubscriber.prototype._complete = function () {
        this.hasCompleted = true;
        if (this.hasCompleted && this.active === 0) {
            this.destination.complete();
        }
    };
    ExpandSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this._next(innerValue);
    };
    ExpandSubscriber.prototype.notifyComplete = function (innerSub) {
        var buffer = this.buffer;
        this.remove(innerSub);
        this.active--;
        if (buffer && buffer.length > 0) {
            this._next(buffer.shift());
        }
        if (this.hasCompleted && this.active === 0) {
            this.destination.complete();
        }
    };
    return ExpandSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
exports.ExpandSubscriber = ExpandSubscriber;
//# sourceMappingURL=expand.js.map

/***/ }),
/* 1278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(3);
var Subscription_1 = __webpack_require__(18);
/**
 * Returns an Observable that mirrors the source Observable, but will call a specified function when
 * the source terminates on complete or error.
 * @param {function} callback Function to be called when source terminates.
 * @return {Observable} An Observable that mirrors the source, but will call the specified function on termination.
 * @method finally
 * @owner Observable
 */
function _finally(callback) {
    return this.lift(new FinallyOperator(callback));
}
exports._finally = _finally;
var FinallyOperator = (function () {
    function FinallyOperator(callback) {
        this.callback = callback;
    }
    FinallyOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new FinallySubscriber(subscriber, this.callback));
    };
    return FinallyOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var FinallySubscriber = (function (_super) {
    __extends(FinallySubscriber, _super);
    function FinallySubscriber(destination, callback) {
        _super.call(this, destination);
        this.add(new Subscription_1.Subscription(callback));
    }
    return FinallySubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=finally.js.map

/***/ }),
/* 1279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var find_1 = __webpack_require__(480);
/**
 * Emits only the index of the first value emitted by the source Observable that
 * meets some condition.
 *
 * <span class="informal">It's like {@link find}, but emits the index of the
 * found value, not the value itself.</span>
 *
 * <img src="./img/findIndex.png" width="100%">
 *
 * `findIndex` searches for the first item in the source Observable that matches
 * the specified condition embodied by the `predicate`, and returns the
 * (zero-based) index of the first occurrence in the source. Unlike
 * {@link first}, the `predicate` is required in `findIndex`, and does not emit
 * an error if a valid value is not found.
 *
 * @example <caption>Emit the index of first click that happens on a DIV element</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.findIndex(ev => ev.target.tagName === 'DIV');
 * result.subscribe(x => console.log(x));
 *
 * @see {@link filter}
 * @see {@link find}
 * @see {@link first}
 * @see {@link take}
 *
 * @param {function(value: T, index: number, source: Observable<T>): boolean} predicate
 * A function called with each item to test for condition matching.
 * @param {any} [thisArg] An optional argument to determine the value of `this`
 * in the `predicate` function.
 * @return {Observable} An Observable of the index of the first item that
 * matches the condition.
 * @method find
 * @owner Observable
 */
function findIndex(predicate, thisArg) {
    return this.lift(new find_1.FindValueOperator(predicate, this, true, thisArg));
}
exports.findIndex = findIndex;
//# sourceMappingURL=findIndex.js.map

/***/ }),
/* 1280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(3);
var Subscription_1 = __webpack_require__(18);
var Observable_1 = __webpack_require__(0);
var Subject_1 = __webpack_require__(11);
var Map_1 = __webpack_require__(1345);
var FastMap_1 = __webpack_require__(1343);
/* tslint:enable:max-line-length */
/**
 * Groups the items emitted by an Observable according to a specified criterion,
 * and emits these grouped items as `GroupedObservables`, one
 * {@link GroupedObservable} per group.
 *
 * <img src="./img/groupBy.png" width="100%">
 *
 * @example <caption>Group objects by id and return as array</caption>
 * Observable.of<Obj>({id: 1, name: 'aze1'},
 *                    {id: 2, name: 'sf2'},
 *                    {id: 2, name: 'dg2'},
 *                    {id: 1, name: 'erg1'},
 *                    {id: 1, name: 'df1'},
 *                    {id: 2, name: 'sfqfb2'},
 *                    {id: 3, name: 'qfs3'},
 *                    {id: 2, name: 'qsgqsfg2'}
 *     )
 *     .groupBy(p => p.id)
 *     .flatMap( (group$) => group$.reduce((acc, cur) => [...acc, cur], []))
 *     .subscribe(p => console.log(p));
 *
 * // displays:
 * // [ { id: 1, name: 'aze1' },
 * //   { id: 1, name: 'erg1' },
 * //   { id: 1, name: 'df1' } ]
 * //
 * // [ { id: 2, name: 'sf2' },
 * //   { id: 2, name: 'dg2' },
 * //   { id: 2, name: 'sfqfb2' },
 * //   { id: 2, name: 'qsgqsfg2' } ]
 * //
 * // [ { id: 3, name: 'qfs3' } ]
 *
 * @example <caption>Pivot data on the id field</caption>
 * Observable.of<Obj>({id: 1, name: 'aze1'},
 *                    {id: 2, name: 'sf2'},
 *                    {id: 2, name: 'dg2'},
 *                    {id: 1, name: 'erg1'},
 *                    {id: 1, name: 'df1'},
 *                    {id: 2, name: 'sfqfb2'},
 *                    {id: 3, name: 'qfs1'},
 *                    {id: 2, name: 'qsgqsfg2'}
 *                   )
 *     .groupBy(p => p.id, p => p.name)
 *     .flatMap( (group$) => group$.reduce((acc, cur) => [...acc, cur], ["" + group$.key]))
 *     .map(arr => ({'id': parseInt(arr[0]), 'values': arr.slice(1)}))
 *     .subscribe(p => console.log(p));
 *
 * // displays:
 * // { id: 1, values: [ 'aze1', 'erg1', 'df1' ] }
 * // { id: 2, values: [ 'sf2', 'dg2', 'sfqfb2', 'qsgqsfg2' ] }
 * // { id: 3, values: [ 'qfs1' ] }
 *
 * @param {function(value: T): K} keySelector A function that extracts the key
 * for each item.
 * @param {function(value: T): R} [elementSelector] A function that extracts the
 * return element for each item.
 * @param {function(grouped: GroupedObservable<K,R>): Observable<any>} [durationSelector]
 * A function that returns an Observable to determine how long each group should
 * exist.
 * @return {Observable<GroupedObservable<K,R>>} An Observable that emits
 * GroupedObservables, each of which corresponds to a unique key value and each
 * of which emits those items from the source Observable that share that key
 * value.
 * @method groupBy
 * @owner Observable
 */
function groupBy(keySelector, elementSelector, durationSelector, subjectSelector) {
    return this.lift(new GroupByOperator(keySelector, elementSelector, durationSelector, subjectSelector));
}
exports.groupBy = groupBy;
var GroupByOperator = (function () {
    function GroupByOperator(keySelector, elementSelector, durationSelector, subjectSelector) {
        this.keySelector = keySelector;
        this.elementSelector = elementSelector;
        this.durationSelector = durationSelector;
        this.subjectSelector = subjectSelector;
    }
    GroupByOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new GroupBySubscriber(subscriber, this.keySelector, this.elementSelector, this.durationSelector, this.subjectSelector));
    };
    return GroupByOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var GroupBySubscriber = (function (_super) {
    __extends(GroupBySubscriber, _super);
    function GroupBySubscriber(destination, keySelector, elementSelector, durationSelector, subjectSelector) {
        _super.call(this, destination);
        this.keySelector = keySelector;
        this.elementSelector = elementSelector;
        this.durationSelector = durationSelector;
        this.subjectSelector = subjectSelector;
        this.groups = null;
        this.attemptedToUnsubscribe = false;
        this.count = 0;
    }
    GroupBySubscriber.prototype._next = function (value) {
        var key;
        try {
            key = this.keySelector(value);
        }
        catch (err) {
            this.error(err);
            return;
        }
        this._group(value, key);
    };
    GroupBySubscriber.prototype._group = function (value, key) {
        var groups = this.groups;
        if (!groups) {
            groups = this.groups = typeof key === 'string' ? new FastMap_1.FastMap() : new Map_1.Map();
        }
        var group = groups.get(key);
        var element;
        if (this.elementSelector) {
            try {
                element = this.elementSelector(value);
            }
            catch (err) {
                this.error(err);
            }
        }
        else {
            element = value;
        }
        if (!group) {
            group = this.subjectSelector ? this.subjectSelector() : new Subject_1.Subject();
            groups.set(key, group);
            var groupedObservable = new GroupedObservable(key, group, this);
            this.destination.next(groupedObservable);
            if (this.durationSelector) {
                var duration = void 0;
                try {
                    duration = this.durationSelector(new GroupedObservable(key, group));
                }
                catch (err) {
                    this.error(err);
                    return;
                }
                this.add(duration.subscribe(new GroupDurationSubscriber(key, group, this)));
            }
        }
        if (!group.closed) {
            group.next(element);
        }
    };
    GroupBySubscriber.prototype._error = function (err) {
        var groups = this.groups;
        if (groups) {
            groups.forEach(function (group, key) {
                group.error(err);
            });
            groups.clear();
        }
        this.destination.error(err);
    };
    GroupBySubscriber.prototype._complete = function () {
        var groups = this.groups;
        if (groups) {
            groups.forEach(function (group, key) {
                group.complete();
            });
            groups.clear();
        }
        this.destination.complete();
    };
    GroupBySubscriber.prototype.removeGroup = function (key) {
        this.groups.delete(key);
    };
    GroupBySubscriber.prototype.unsubscribe = function () {
        if (!this.closed) {
            this.attemptedToUnsubscribe = true;
            if (this.count === 0) {
                _super.prototype.unsubscribe.call(this);
            }
        }
    };
    return GroupBySubscriber;
}(Subscriber_1.Subscriber));
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var GroupDurationSubscriber = (function (_super) {
    __extends(GroupDurationSubscriber, _super);
    function GroupDurationSubscriber(key, group, parent) {
        _super.call(this, group);
        this.key = key;
        this.group = group;
        this.parent = parent;
    }
    GroupDurationSubscriber.prototype._next = function (value) {
        this.complete();
    };
    GroupDurationSubscriber.prototype._unsubscribe = function () {
        var _a = this, parent = _a.parent, key = _a.key;
        this.key = this.parent = null;
        if (parent) {
            parent.removeGroup(key);
        }
    };
    return GroupDurationSubscriber;
}(Subscriber_1.Subscriber));
/**
 * An Observable representing values belonging to the same group represented by
 * a common key. The values emitted by a GroupedObservable come from the source
 * Observable. The common key is available as the field `key` on a
 * GroupedObservable instance.
 *
 * @class GroupedObservable<K, T>
 */
var GroupedObservable = (function (_super) {
    __extends(GroupedObservable, _super);
    function GroupedObservable(key, groupSubject, refCountSubscription) {
        _super.call(this);
        this.key = key;
        this.groupSubject = groupSubject;
        this.refCountSubscription = refCountSubscription;
    }
    GroupedObservable.prototype._subscribe = function (subscriber) {
        var subscription = new Subscription_1.Subscription();
        var _a = this, refCountSubscription = _a.refCountSubscription, groupSubject = _a.groupSubject;
        if (refCountSubscription && !refCountSubscription.closed) {
            subscription.add(new InnerRefCountSubscription(refCountSubscription));
        }
        subscription.add(groupSubject.subscribe(subscriber));
        return subscription;
    };
    return GroupedObservable;
}(Observable_1.Observable));
exports.GroupedObservable = GroupedObservable;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var InnerRefCountSubscription = (function (_super) {
    __extends(InnerRefCountSubscription, _super);
    function InnerRefCountSubscription(parent) {
        _super.call(this);
        this.parent = parent;
        parent.count++;
    }
    InnerRefCountSubscription.prototype.unsubscribe = function () {
        var parent = this.parent;
        if (!parent.closed && !this.closed) {
            _super.prototype.unsubscribe.call(this);
            parent.count -= 1;
            if (parent.count === 0 && parent.attemptedToUnsubscribe) {
                parent.unsubscribe();
            }
        }
    };
    return InnerRefCountSubscription;
}(Subscription_1.Subscription));
//# sourceMappingURL=groupBy.js.map

/***/ }),
/* 1281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(3);
var noop_1 = __webpack_require__(502);
/**
 * Ignores all items emitted by the source Observable and only passes calls of `complete` or `error`.
 *
 * <img src="./img/ignoreElements.png" width="100%">
 *
 * @return {Observable} An empty Observable that only calls `complete`
 * or `error`, based on which one is called by the source Observable.
 * @method ignoreElements
 * @owner Observable
 */
function ignoreElements() {
    return this.lift(new IgnoreElementsOperator());
}
exports.ignoreElements = ignoreElements;
;
var IgnoreElementsOperator = (function () {
    function IgnoreElementsOperator() {
    }
    IgnoreElementsOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new IgnoreElementsSubscriber(subscriber));
    };
    return IgnoreElementsOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var IgnoreElementsSubscriber = (function (_super) {
    __extends(IgnoreElementsSubscriber, _super);
    function IgnoreElementsSubscriber() {
        _super.apply(this, arguments);
    }
    IgnoreElementsSubscriber.prototype._next = function (unused) {
        noop_1.noop();
    };
    return IgnoreElementsSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=ignoreElements.js.map

/***/ }),
/* 1282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(3);
/**
 * If the source Observable is empty it returns an Observable that emits true, otherwise it emits false.
 *
 * <img src="./img/isEmpty.png" width="100%">
 *
 * @return {Observable} An Observable that emits a Boolean.
 * @method isEmpty
 * @owner Observable
 */
function isEmpty() {
    return this.lift(new IsEmptyOperator());
}
exports.isEmpty = isEmpty;
var IsEmptyOperator = (function () {
    function IsEmptyOperator() {
    }
    IsEmptyOperator.prototype.call = function (observer, source) {
        return source.subscribe(new IsEmptySubscriber(observer));
    };
    return IsEmptyOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var IsEmptySubscriber = (function (_super) {
    __extends(IsEmptySubscriber, _super);
    function IsEmptySubscriber(destination) {
        _super.call(this, destination);
    }
    IsEmptySubscriber.prototype.notifyComplete = function (isEmpty) {
        var destination = this.destination;
        destination.next(isEmpty);
        destination.complete();
    };
    IsEmptySubscriber.prototype._next = function (value) {
        this.notifyComplete(false);
    };
    IsEmptySubscriber.prototype._complete = function () {
        this.notifyComplete(true);
    };
    return IsEmptySubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=isEmpty.js.map

/***/ }),
/* 1283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @param func
 * @return {Observable<R>}
 * @method let
 * @owner Observable
 */
function letProto(func) {
    return func(this);
}
exports.letProto = letProto;
//# sourceMappingURL=let.js.map

/***/ }),
/* 1284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(3);
/**
 * Emits the given constant value on the output Observable every time the source
 * Observable emits a value.
 *
 * <span class="informal">Like {@link map}, but it maps every source value to
 * the same output value every time.</span>
 *
 * <img src="./img/mapTo.png" width="100%">
 *
 * Takes a constant `value` as argument, and emits that whenever the source
 * Observable emits a value. In other words, ignores the actual source value,
 * and simply uses the emission moment to know when to emit the given `value`.
 *
 * @example <caption>Map every click to the string 'Hi'</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var greetings = clicks.mapTo('Hi');
 * greetings.subscribe(x => console.log(x));
 *
 * @see {@link map}
 *
 * @param {any} value The value to map each source value to.
 * @return {Observable} An Observable that emits the given `value` every time
 * the source Observable emits something.
 * @method mapTo
 * @owner Observable
 */
function mapTo(value) {
    return this.lift(new MapToOperator(value));
}
exports.mapTo = mapTo;
var MapToOperator = (function () {
    function MapToOperator(value) {
        this.value = value;
    }
    MapToOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new MapToSubscriber(subscriber, this.value));
    };
    return MapToOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var MapToSubscriber = (function (_super) {
    __extends(MapToSubscriber, _super);
    function MapToSubscriber(destination, value) {
        _super.call(this, destination);
        this.value = value;
    }
    MapToSubscriber.prototype._next = function (x) {
        this.destination.next(this.value);
    };
    return MapToSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=mapTo.js.map

/***/ }),
/* 1285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(3);
var Notification_1 = __webpack_require__(125);
/**
 * Represents all of the notifications from the source Observable as `next`
 * emissions marked with their original types within {@link Notification}
 * objects.
 *
 * <span class="informal">Wraps `next`, `error` and `complete` emissions in
 * {@link Notification} objects, emitted as `next` on the output Observable.
 * </span>
 *
 * <img src="./img/materialize.png" width="100%">
 *
 * `materialize` returns an Observable that emits a `next` notification for each
 * `next`, `error`, or `complete` emission of the source Observable. When the
 * source Observable emits `complete`, the output Observable will emit `next` as
 * a Notification of type "complete", and then it will emit `complete` as well.
 * When the source Observable emits `error`, the output will emit `next` as a
 * Notification of type "error", and then `complete`.
 *
 * This operator is useful for producing metadata of the source Observable, to
 * be consumed as `next` emissions. Use it in conjunction with
 * {@link dematerialize}.
 *
 * @example <caption>Convert a faulty Observable to an Observable of Notifications</caption>
 * var letters = Rx.Observable.of('a', 'b', 13, 'd');
 * var upperCase = letters.map(x => x.toUpperCase());
 * var materialized = upperCase.materialize();
 * materialized.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // - Notification {kind: "N", value: "A", error: undefined, hasValue: true}
 * // - Notification {kind: "N", value: "B", error: undefined, hasValue: true}
 * // - Notification {kind: "E", value: undefined, error: TypeError:
 * //   x.toUpperCase is not a function at MapSubscriber.letters.map.x
 * //   [as project] (http://1…, hasValue: false}
 *
 * @see {@link Notification}
 * @see {@link dematerialize}
 *
 * @return {Observable<Notification<T>>} An Observable that emits
 * {@link Notification} objects that wrap the original emissions from the source
 * Observable with metadata.
 * @method materialize
 * @owner Observable
 */
function materialize() {
    return this.lift(new MaterializeOperator());
}
exports.materialize = materialize;
var MaterializeOperator = (function () {
    function MaterializeOperator() {
    }
    MaterializeOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new MaterializeSubscriber(subscriber));
    };
    return MaterializeOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var MaterializeSubscriber = (function (_super) {
    __extends(MaterializeSubscriber, _super);
    function MaterializeSubscriber(destination) {
        _super.call(this, destination);
    }
    MaterializeSubscriber.prototype._next = function (value) {
        this.destination.next(Notification_1.Notification.createNext(value));
    };
    MaterializeSubscriber.prototype._error = function (err) {
        var destination = this.destination;
        destination.next(Notification_1.Notification.createError(err));
        destination.complete();
    };
    MaterializeSubscriber.prototype._complete = function () {
        var destination = this.destination;
        destination.next(Notification_1.Notification.createComplete());
        destination.complete();
    };
    return MaterializeSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=materialize.js.map

/***/ }),
/* 1286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var reduce_1 = __webpack_require__(168);
/**
 * The Max operator operates on an Observable that emits numbers (or items that can be compared with a provided function),
 * and when source Observable completes it emits a single item: the item with the largest value.
 *
 * <img src="./img/max.png" width="100%">
 *
 * @example <caption>Get the maximal value of a series of numbers</caption>
 * Rx.Observable.of(5, 4, 7, 2, 8)
 *   .max()
 *   .subscribe(x => console.log(x)); // -> 8
 *
 * @example <caption>Use a comparer function to get the maximal item</caption>
 * interface Person {
 *   age: number,
 *   name: string
 * }
 * Observable.of<Person>({age: 7, name: 'Foo'},
 *                       {age: 5, name: 'Bar'},
 *                       {age: 9, name: 'Beer'})
 *           .max<Person>((a: Person, b: Person) => a.age < b.age ? -1 : 1)
 *           .subscribe((x: Person) => console.log(x.name)); // -> 'Beer'
 * }
 *
 * @see {@link min}
 *
 * @param {Function} [comparer] - Optional comparer function that it will use instead of its default to compare the
 * value of two items.
 * @return {Observable} An Observable that emits item with the largest value.
 * @method max
 * @owner Observable
 */
function max(comparer) {
    var max = (typeof comparer === 'function')
        ? function (x, y) { return comparer(x, y) > 0 ? x : y; }
        : function (x, y) { return x > y ? x : y; };
    return this.lift(new reduce_1.ReduceOperator(max));
}
exports.max = max;
//# sourceMappingURL=max.js.map

/***/ }),
/* 1287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var tryCatch_1 = __webpack_require__(25);
var errorObject_1 = __webpack_require__(22);
var subscribeToResult_1 = __webpack_require__(7);
var OuterSubscriber_1 = __webpack_require__(6);
/**
 * Applies an accumulator function over the source Observable where the
 * accumulator function itself returns an Observable, then each intermediate
 * Observable returned is merged into the output Observable.
 *
 * <span class="informal">It's like {@link scan}, but the Observables returned
 * by the accumulator are merged into the outer Observable.</span>
 *
 * @example <caption>Count the number of click events</caption>
 * const click$ = Rx.Observable.fromEvent(document, 'click');
 * const one$ = click$.mapTo(1);
 * const seed = 0;
 * const count$ = one$.mergeScan((acc, one) => Rx.Observable.of(acc + one), seed);
 * count$.subscribe(x => console.log(x));
 *
 * // Results:
 * 1
 * 2
 * 3
 * 4
 * // ...and so on for each click
 *
 * @param {function(acc: R, value: T): Observable<R>} accumulator
 * The accumulator function called on each source value.
 * @param seed The initial accumulation value.
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of
 * input Observables being subscribed to concurrently.
 * @return {Observable<R>} An observable of the accumulated values.
 * @method mergeScan
 * @owner Observable
 */
function mergeScan(accumulator, seed, concurrent) {
    if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
    return this.lift(new MergeScanOperator(accumulator, seed, concurrent));
}
exports.mergeScan = mergeScan;
var MergeScanOperator = (function () {
    function MergeScanOperator(accumulator, seed, concurrent) {
        this.accumulator = accumulator;
        this.seed = seed;
        this.concurrent = concurrent;
    }
    MergeScanOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new MergeScanSubscriber(subscriber, this.accumulator, this.seed, this.concurrent));
    };
    return MergeScanOperator;
}());
exports.MergeScanOperator = MergeScanOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var MergeScanSubscriber = (function (_super) {
    __extends(MergeScanSubscriber, _super);
    function MergeScanSubscriber(destination, accumulator, acc, concurrent) {
        _super.call(this, destination);
        this.accumulator = accumulator;
        this.acc = acc;
        this.concurrent = concurrent;
        this.hasValue = false;
        this.hasCompleted = false;
        this.buffer = [];
        this.active = 0;
        this.index = 0;
    }
    MergeScanSubscriber.prototype._next = function (value) {
        if (this.active < this.concurrent) {
            var index = this.index++;
            var ish = tryCatch_1.tryCatch(this.accumulator)(this.acc, value);
            var destination = this.destination;
            if (ish === errorObject_1.errorObject) {
                destination.error(errorObject_1.errorObject.e);
            }
            else {
                this.active++;
                this._innerSub(ish, value, index);
            }
        }
        else {
            this.buffer.push(value);
        }
    };
    MergeScanSubscriber.prototype._innerSub = function (ish, value, index) {
        this.add(subscribeToResult_1.subscribeToResult(this, ish, value, index));
    };
    MergeScanSubscriber.prototype._complete = function () {
        this.hasCompleted = true;
        if (this.active === 0 && this.buffer.length === 0) {
            if (this.hasValue === false) {
                this.destination.next(this.acc);
            }
            this.destination.complete();
        }
    };
    MergeScanSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        var destination = this.destination;
        this.acc = innerValue;
        this.hasValue = true;
        destination.next(innerValue);
    };
    MergeScanSubscriber.prototype.notifyComplete = function (innerSub) {
        var buffer = this.buffer;
        this.remove(innerSub);
        this.active--;
        if (buffer.length > 0) {
            this._next(buffer.shift());
        }
        else if (this.active === 0 && this.hasCompleted) {
            if (this.hasValue === false) {
                this.destination.next(this.acc);
            }
            this.destination.complete();
        }
    };
    return MergeScanSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
exports.MergeScanSubscriber = MergeScanSubscriber;
//# sourceMappingURL=mergeScan.js.map

/***/ }),
/* 1288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var reduce_1 = __webpack_require__(168);
/**
 * The Min operator operates on an Observable that emits numbers (or items that can be compared with a provided function),
 * and when source Observable completes it emits a single item: the item with the smallest value.
 *
 * <img src="./img/min.png" width="100%">
 *
 * @example <caption>Get the minimal value of a series of numbers</caption>
 * Rx.Observable.of(5, 4, 7, 2, 8)
 *   .min()
 *   .subscribe(x => console.log(x)); // -> 2
 *
 * @example <caption>Use a comparer function to get the minimal item</caption>
 * interface Person {
 *   age: number,
 *   name: string
 * }
 * Observable.of<Person>({age: 7, name: 'Foo'},
 *                       {age: 5, name: 'Bar'},
 *                       {age: 9, name: 'Beer'})
 *           .min<Person>( (a: Person, b: Person) => a.age < b.age ? -1 : 1)
 *           .subscribe((x: Person) => console.log(x.name)); // -> 'Bar'
 * }
 *
 * @see {@link max}
 *
 * @param {Function} [comparer] - Optional comparer function that it will use instead of its default to compare the
 * value of two items.
 * @return {Observable<R>} An Observable that emits item with the smallest value.
 * @method min
 * @owner Observable
 */
function min(comparer) {
    var min = (typeof comparer === 'function')
        ? function (x, y) { return comparer(x, y) < 0 ? x : y; }
        : function (x, y) { return x < y ? x : y; };
    return this.lift(new reduce_1.ReduceOperator(min));
}
exports.min = min;
//# sourceMappingURL=min.js.map

/***/ }),
/* 1289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(3);
/**
 * Groups pairs of consecutive emissions together and emits them as an array of
 * two values.
 *
 * <span class="informal">Puts the current value and previous value together as
 * an array, and emits that.</span>
 *
 * <img src="./img/pairwise.png" width="100%">
 *
 * The Nth emission from the source Observable will cause the output Observable
 * to emit an array [(N-1)th, Nth] of the previous and the current value, as a
 * pair. For this reason, `pairwise` emits on the second and subsequent
 * emissions from the source Observable, but not on the first emission, because
 * there is no previous value in that case.
 *
 * @example <caption>On every click (starting from the second), emit the relative distance to the previous click</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var pairs = clicks.pairwise();
 * var distance = pairs.map(pair => {
 *   var x0 = pair[0].clientX;
 *   var y0 = pair[0].clientY;
 *   var x1 = pair[1].clientX;
 *   var y1 = pair[1].clientY;
 *   return Math.sqrt(Math.pow(x0 - x1, 2) + Math.pow(y0 - y1, 2));
 * });
 * distance.subscribe(x => console.log(x));
 *
 * @see {@link buffer}
 * @see {@link bufferCount}
 *
 * @return {Observable<Array<T>>} An Observable of pairs (as arrays) of
 * consecutive values from the source Observable.
 * @method pairwise
 * @owner Observable
 */
function pairwise() {
    return this.lift(new PairwiseOperator());
}
exports.pairwise = pairwise;
var PairwiseOperator = (function () {
    function PairwiseOperator() {
    }
    PairwiseOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new PairwiseSubscriber(subscriber));
    };
    return PairwiseOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var PairwiseSubscriber = (function (_super) {
    __extends(PairwiseSubscriber, _super);
    function PairwiseSubscriber(destination) {
        _super.call(this, destination);
        this.hasPrev = false;
    }
    PairwiseSubscriber.prototype._next = function (value) {
        if (this.hasPrev) {
            this.destination.next([this.prev, value]);
        }
        else {
            this.hasPrev = true;
        }
        this.prev = value;
    };
    return PairwiseSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=pairwise.js.map

/***/ }),
/* 1290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var not_1 = __webpack_require__(1349);
var filter_1 = __webpack_require__(275);
/**
 * Splits the source Observable into two, one with values that satisfy a
 * predicate, and another with values that don't satisfy the predicate.
 *
 * <span class="informal">It's like {@link filter}, but returns two Observables:
 * one like the output of {@link filter}, and the other with values that did not
 * pass the condition.</span>
 *
 * <img src="./img/partition.png" width="100%">
 *
 * `partition` outputs an array with two Observables that partition the values
 * from the source Observable through the given `predicate` function. The first
 * Observable in that array emits source values for which the predicate argument
 * returns true. The second Observable emits source values for which the
 * predicate returns false. The first behaves like {@link filter} and the second
 * behaves like {@link filter} with the predicate negated.
 *
 * @example <caption>Partition click events into those on DIV elements and those elsewhere</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var parts = clicks.partition(ev => ev.target.tagName === 'DIV');
 * var clicksOnDivs = parts[0];
 * var clicksElsewhere = parts[1];
 * clicksOnDivs.subscribe(x => console.log('DIV clicked: ', x));
 * clicksElsewhere.subscribe(x => console.log('Other clicked: ', x));
 *
 * @see {@link filter}
 *
 * @param {function(value: T, index: number): boolean} predicate A function that
 * evaluates each value emitted by the source Observable. If it returns `true`,
 * the value is emitted on the first Observable in the returned array, if
 * `false` the value is emitted on the second Observable in the array. The
 * `index` parameter is the number `i` for the i-th source emission that has
 * happened since the subscription, starting from the number `0`.
 * @param {any} [thisArg] An optional argument to determine the value of `this`
 * in the `predicate` function.
 * @return {[Observable<T>, Observable<T>]} An array with two Observables: one
 * with values that passed the predicate, and another with values that did not
 * pass the predicate.
 * @method partition
 * @owner Observable
 */
function partition(predicate, thisArg) {
    return [
        filter_1.filter.call(this, predicate, thisArg),
        filter_1.filter.call(this, not_1.not(predicate, thisArg))
    ];
}
exports.partition = partition;
//# sourceMappingURL=partition.js.map

/***/ }),
/* 1291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var map_1 = __webpack_require__(126);
/**
 * Maps each source value (an object) to its specified nested property.
 *
 * <span class="informal">Like {@link map}, but meant only for picking one of
 * the nested properties of every emitted object.</span>
 *
 * <img src="./img/pluck.png" width="100%">
 *
 * Given a list of strings describing a path to an object property, retrieves
 * the value of a specified nested property from all values in the source
 * Observable. If a property can't be resolved, it will return `undefined` for
 * that value.
 *
 * @example <caption>Map every click to the tagName of the clicked target element</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var tagNames = clicks.pluck('target', 'tagName');
 * tagNames.subscribe(x => console.log(x));
 *
 * @see {@link map}
 *
 * @param {...string} properties The nested properties to pluck from each source
 * value (an object).
 * @return {Observable} A new Observable of property values from the source values.
 * @method pluck
 * @owner Observable
 */
function pluck() {
    var properties = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        properties[_i - 0] = arguments[_i];
    }
    var length = properties.length;
    if (length === 0) {
        throw new Error('list of properties cannot be empty.');
    }
    return map_1.map.call(this, plucker(properties, length));
}
exports.pluck = pluck;
function plucker(props, length) {
    var mapper = function (x) {
        var currentProp = x;
        for (var i = 0; i < length; i++) {
            var p = currentProp[props[i]];
            if (typeof p !== 'undefined') {
                currentProp = p;
            }
            else {
                return undefined;
            }
        }
        return currentProp;
    };
    return mapper;
}
//# sourceMappingURL=pluck.js.map

/***/ }),
/* 1292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Subject_1 = __webpack_require__(11);
var multicast_1 = __webpack_require__(92);
/* tslint:enable:max-line-length */
/**
 * Returns a ConnectableObservable, which is a variety of Observable that waits until its connect method is called
 * before it begins emitting items to those Observers that have subscribed to it.
 *
 * <img src="./img/publish.png" width="100%">
 *
 * @param {Function} [selector] - Optional selector function which can use the multicasted source sequence as many times
 * as needed, without causing multiple subscriptions to the source sequence.
 * Subscribers to the given source will receive all notifications of the source from the time of the subscription on.
 * @return A ConnectableObservable that upon connection causes the source Observable to emit items to its Observers.
 * @method publish
 * @owner Observable
 */
function publish(selector) {
    return selector ? multicast_1.multicast.call(this, function () { return new Subject_1.Subject(); }, selector) :
        multicast_1.multicast.call(this, new Subject_1.Subject());
}
exports.publish = publish;
//# sourceMappingURL=publish.js.map

/***/ }),
/* 1293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var BehaviorSubject_1 = __webpack_require__(64);
var multicast_1 = __webpack_require__(92);
/**
 * @param value
 * @return {ConnectableObservable<T>}
 * @method publishBehavior
 * @owner Observable
 */
function publishBehavior(value) {
    return multicast_1.multicast.call(this, new BehaviorSubject_1.BehaviorSubject(value));
}
exports.publishBehavior = publishBehavior;
//# sourceMappingURL=publishBehavior.js.map

/***/ }),
/* 1294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var AsyncSubject_1 = __webpack_require__(165);
var multicast_1 = __webpack_require__(92);
/**
 * @return {ConnectableObservable<T>}
 * @method publishLast
 * @owner Observable
 */
function publishLast() {
    return multicast_1.multicast.call(this, new AsyncSubject_1.AsyncSubject());
}
exports.publishLast = publishLast;
//# sourceMappingURL=publishLast.js.map

/***/ }),
/* 1295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ReplaySubject_1 = __webpack_require__(166);
var multicast_1 = __webpack_require__(92);
/**
 * @param bufferSize
 * @param windowTime
 * @param scheduler
 * @return {ConnectableObservable<T>}
 * @method publishReplay
 * @owner Observable
 */
function publishReplay(bufferSize, windowTime, scheduler) {
    if (bufferSize === void 0) { bufferSize = Number.POSITIVE_INFINITY; }
    if (windowTime === void 0) { windowTime = Number.POSITIVE_INFINITY; }
    return multicast_1.multicast.call(this, new ReplaySubject_1.ReplaySubject(bufferSize, windowTime, scheduler));
}
exports.publishReplay = publishReplay;
//# sourceMappingURL=publishReplay.js.map

/***/ }),
/* 1296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(3);
var EmptyObservable_1 = __webpack_require__(76);
/**
 * Returns an Observable that repeats the stream of items emitted by the source Observable at most count times.
 *
 * <img src="./img/repeat.png" width="100%">
 *
 * @param {number} [count] The number of times the source Observable items are repeated, a count of 0 will yield
 * an empty Observable.
 * @return {Observable} An Observable that repeats the stream of items emitted by the source Observable at most
 * count times.
 * @method repeat
 * @owner Observable
 */
function repeat(count) {
    if (count === void 0) { count = -1; }
    if (count === 0) {
        return new EmptyObservable_1.EmptyObservable();
    }
    else if (count < 0) {
        return this.lift(new RepeatOperator(-1, this));
    }
    else {
        return this.lift(new RepeatOperator(count - 1, this));
    }
}
exports.repeat = repeat;
var RepeatOperator = (function () {
    function RepeatOperator(count, source) {
        this.count = count;
        this.source = source;
    }
    RepeatOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new RepeatSubscriber(subscriber, this.count, this.source));
    };
    return RepeatOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var RepeatSubscriber = (function (_super) {
    __extends(RepeatSubscriber, _super);
    function RepeatSubscriber(destination, count, source) {
        _super.call(this, destination);
        this.count = count;
        this.source = source;
    }
    RepeatSubscriber.prototype.complete = function () {
        if (!this.isStopped) {
            var _a = this, source = _a.source, count = _a.count;
            if (count === 0) {
                return _super.prototype.complete.call(this);
            }
            else if (count > -1) {
                this.count = count - 1;
            }
            source.subscribe(this._unsubscribeAndRecycle());
        }
    };
    return RepeatSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=repeat.js.map

/***/ }),
/* 1297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subject_1 = __webpack_require__(11);
var tryCatch_1 = __webpack_require__(25);
var errorObject_1 = __webpack_require__(22);
var OuterSubscriber_1 = __webpack_require__(6);
var subscribeToResult_1 = __webpack_require__(7);
/**
 * Returns an Observable that mirrors the source Observable with the exception of a `complete`. If the source
 * Observable calls `complete`, this method will emit to the Observable returned from `notifier`. If that Observable
 * calls `complete` or `error`, then this method will call `complete` or `error` on the child subscription. Otherwise
 * this method will resubscribe to the source Observable.
 *
 * <img src="./img/repeatWhen.png" width="100%">
 *
 * @param {function(notifications: Observable): Observable} notifier - Receives an Observable of notifications with
 * which a user can `complete` or `error`, aborting the repetition.
 * @return {Observable} The source Observable modified with repeat logic.
 * @method repeatWhen
 * @owner Observable
 */
function repeatWhen(notifier) {
    return this.lift(new RepeatWhenOperator(notifier));
}
exports.repeatWhen = repeatWhen;
var RepeatWhenOperator = (function () {
    function RepeatWhenOperator(notifier) {
        this.notifier = notifier;
    }
    RepeatWhenOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new RepeatWhenSubscriber(subscriber, this.notifier, source));
    };
    return RepeatWhenOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var RepeatWhenSubscriber = (function (_super) {
    __extends(RepeatWhenSubscriber, _super);
    function RepeatWhenSubscriber(destination, notifier, source) {
        _super.call(this, destination);
        this.notifier = notifier;
        this.source = source;
        this.sourceIsBeingSubscribedTo = true;
    }
    RepeatWhenSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.sourceIsBeingSubscribedTo = true;
        this.source.subscribe(this);
    };
    RepeatWhenSubscriber.prototype.notifyComplete = function (innerSub) {
        if (this.sourceIsBeingSubscribedTo === false) {
            return _super.prototype.complete.call(this);
        }
    };
    RepeatWhenSubscriber.prototype.complete = function () {
        this.sourceIsBeingSubscribedTo = false;
        if (!this.isStopped) {
            if (!this.retries) {
                this.subscribeToRetries();
            }
            else if (this.retriesSubscription.closed) {
                return _super.prototype.complete.call(this);
            }
            this._unsubscribeAndRecycle();
            this.notifications.next();
        }
    };
    RepeatWhenSubscriber.prototype._unsubscribe = function () {
        var _a = this, notifications = _a.notifications, retriesSubscription = _a.retriesSubscription;
        if (notifications) {
            notifications.unsubscribe();
            this.notifications = null;
        }
        if (retriesSubscription) {
            retriesSubscription.unsubscribe();
            this.retriesSubscription = null;
        }
        this.retries = null;
    };
    RepeatWhenSubscriber.prototype._unsubscribeAndRecycle = function () {
        var _a = this, notifications = _a.notifications, retries = _a.retries, retriesSubscription = _a.retriesSubscription;
        this.notifications = null;
        this.retries = null;
        this.retriesSubscription = null;
        _super.prototype._unsubscribeAndRecycle.call(this);
        this.notifications = notifications;
        this.retries = retries;
        this.retriesSubscription = retriesSubscription;
        return this;
    };
    RepeatWhenSubscriber.prototype.subscribeToRetries = function () {
        this.notifications = new Subject_1.Subject();
        var retries = tryCatch_1.tryCatch(this.notifier)(this.notifications);
        if (retries === errorObject_1.errorObject) {
            return _super.prototype.complete.call(this);
        }
        this.retries = retries;
        this.retriesSubscription = subscribeToResult_1.subscribeToResult(this, retries);
    };
    return RepeatWhenSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
//# sourceMappingURL=repeatWhen.js.map

/***/ }),
/* 1298 */,
/* 1299 */,
/* 1300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var OuterSubscriber_1 = __webpack_require__(6);
var subscribeToResult_1 = __webpack_require__(7);
/**
 * Emits the most recently emitted value from the source Observable whenever
 * another Observable, the `notifier`, emits.
 *
 * <span class="informal">It's like {@link sampleTime}, but samples whenever
 * the `notifier` Observable emits something.</span>
 *
 * <img src="./img/sample.png" width="100%">
 *
 * Whenever the `notifier` Observable emits a value or completes, `sample`
 * looks at the source Observable and emits whichever value it has most recently
 * emitted since the previous sampling, unless the source has not emitted
 * anything since the previous sampling. The `notifier` is subscribed to as soon
 * as the output Observable is subscribed.
 *
 * @example <caption>On every click, sample the most recent "seconds" timer</caption>
 * var seconds = Rx.Observable.interval(1000);
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = seconds.sample(clicks);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link audit}
 * @see {@link debounce}
 * @see {@link sampleTime}
 * @see {@link throttle}
 *
 * @param {Observable<any>} notifier The Observable to use for sampling the
 * source Observable.
 * @return {Observable<T>} An Observable that emits the results of sampling the
 * values emitted by the source Observable whenever the notifier Observable
 * emits value or completes.
 * @method sample
 * @owner Observable
 */
function sample(notifier) {
    return this.lift(new SampleOperator(notifier));
}
exports.sample = sample;
var SampleOperator = (function () {
    function SampleOperator(notifier) {
        this.notifier = notifier;
    }
    SampleOperator.prototype.call = function (subscriber, source) {
        var sampleSubscriber = new SampleSubscriber(subscriber);
        var subscription = source.subscribe(sampleSubscriber);
        subscription.add(subscribeToResult_1.subscribeToResult(sampleSubscriber, this.notifier));
        return subscription;
    };
    return SampleOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var SampleSubscriber = (function (_super) {
    __extends(SampleSubscriber, _super);
    function SampleSubscriber() {
        _super.apply(this, arguments);
        this.hasValue = false;
    }
    SampleSubscriber.prototype._next = function (value) {
        this.value = value;
        this.hasValue = true;
    };
    SampleSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.emitValue();
    };
    SampleSubscriber.prototype.notifyComplete = function () {
        this.emitValue();
    };
    SampleSubscriber.prototype.emitValue = function () {
        if (this.hasValue) {
            this.hasValue = false;
            this.destination.next(this.value);
        }
    };
    return SampleSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
//# sourceMappingURL=sample.js.map

/***/ }),
/* 1301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(3);
var async_1 = __webpack_require__(30);
/**
 * Emits the most recently emitted value from the source Observable within
 * periodic time intervals.
 *
 * <span class="informal">Samples the source Observable at periodic time
 * intervals, emitting what it samples.</span>
 *
 * <img src="./img/sampleTime.png" width="100%">
 *
 * `sampleTime` periodically looks at the source Observable and emits whichever
 * value it has most recently emitted since the previous sampling, unless the
 * source has not emitted anything since the previous sampling. The sampling
 * happens periodically in time every `period` milliseconds (or the time unit
 * defined by the optional `scheduler` argument). The sampling starts as soon as
 * the output Observable is subscribed.
 *
 * @example <caption>Every second, emit the most recent click at most once</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.sampleTime(1000);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link auditTime}
 * @see {@link debounceTime}
 * @see {@link delay}
 * @see {@link sample}
 * @see {@link throttleTime}
 *
 * @param {number} period The sampling period expressed in milliseconds or the
 * time unit determined internally by the optional `scheduler`.
 * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
 * managing the timers that handle the sampling.
 * @return {Observable<T>} An Observable that emits the results of sampling the
 * values emitted by the source Observable at the specified time interval.
 * @method sampleTime
 * @owner Observable
 */
function sampleTime(period, scheduler) {
    if (scheduler === void 0) { scheduler = async_1.async; }
    return this.lift(new SampleTimeOperator(period, scheduler));
}
exports.sampleTime = sampleTime;
var SampleTimeOperator = (function () {
    function SampleTimeOperator(period, scheduler) {
        this.period = period;
        this.scheduler = scheduler;
    }
    SampleTimeOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new SampleTimeSubscriber(subscriber, this.period, this.scheduler));
    };
    return SampleTimeOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var SampleTimeSubscriber = (function (_super) {
    __extends(SampleTimeSubscriber, _super);
    function SampleTimeSubscriber(destination, period, scheduler) {
        _super.call(this, destination);
        this.period = period;
        this.scheduler = scheduler;
        this.hasValue = false;
        this.add(scheduler.schedule(dispatchNotification, period, { subscriber: this, period: period }));
    }
    SampleTimeSubscriber.prototype._next = function (value) {
        this.lastValue = value;
        this.hasValue = true;
    };
    SampleTimeSubscriber.prototype.notifyNext = function () {
        if (this.hasValue) {
            this.hasValue = false;
            this.destination.next(this.lastValue);
        }
    };
    return SampleTimeSubscriber;
}(Subscriber_1.Subscriber));
function dispatchNotification(state) {
    var subscriber = state.subscriber, period = state.period;
    subscriber.notifyNext();
    this.schedule(state, period);
}
//# sourceMappingURL=sampleTime.js.map

/***/ }),
/* 1302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(3);
/* tslint:enable:max-line-length */
/**
 * Applies an accumulator function over the source Observable, and returns each
 * intermediate result, with an optional seed value.
 *
 * <span class="informal">It's like {@link reduce}, but emits the current
 * accumulation whenever the source emits a value.</span>
 *
 * <img src="./img/scan.png" width="100%">
 *
 * Combines together all values emitted on the source, using an accumulator
 * function that knows how to join a new source value into the accumulation from
 * the past. Is similar to {@link reduce}, but emits the intermediate
 * accumulations.
 *
 * Returns an Observable that applies a specified `accumulator` function to each
 * item emitted by the source Observable. If a `seed` value is specified, then
 * that value will be used as the initial value for the accumulator. If no seed
 * value is specified, the first item of the source is used as the seed.
 *
 * @example <caption>Count the number of click events</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var ones = clicks.mapTo(1);
 * var seed = 0;
 * var count = ones.scan((acc, one) => acc + one, seed);
 * count.subscribe(x => console.log(x));
 *
 * @see {@link expand}
 * @see {@link mergeScan}
 * @see {@link reduce}
 *
 * @param {function(acc: R, value: T, index: number): R} accumulator
 * The accumulator function called on each source value.
 * @param {T|R} [seed] The initial accumulation value.
 * @return {Observable<R>} An observable of the accumulated values.
 * @method scan
 * @owner Observable
 */
function scan(accumulator, seed) {
    var hasSeed = false;
    // providing a seed of `undefined` *should* be valid and trigger
    // hasSeed! so don't use `seed !== undefined` checks!
    // For this reason, we have to check it here at the original call site
    // otherwise inside Operator/Subscriber we won't know if `undefined`
    // means they didn't provide anything or if they literally provided `undefined`
    if (arguments.length >= 2) {
        hasSeed = true;
    }
    return this.lift(new ScanOperator(accumulator, seed, hasSeed));
}
exports.scan = scan;
var ScanOperator = (function () {
    function ScanOperator(accumulator, seed, hasSeed) {
        if (hasSeed === void 0) { hasSeed = false; }
        this.accumulator = accumulator;
        this.seed = seed;
        this.hasSeed = hasSeed;
    }
    ScanOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new ScanSubscriber(subscriber, this.accumulator, this.seed, this.hasSeed));
    };
    return ScanOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var ScanSubscriber = (function (_super) {
    __extends(ScanSubscriber, _super);
    function ScanSubscriber(destination, accumulator, _seed, hasSeed) {
        _super.call(this, destination);
        this.accumulator = accumulator;
        this._seed = _seed;
        this.hasSeed = hasSeed;
        this.index = 0;
    }
    Object.defineProperty(ScanSubscriber.prototype, "seed", {
        get: function () {
            return this._seed;
        },
        set: function (value) {
            this.hasSeed = true;
            this._seed = value;
        },
        enumerable: true,
        configurable: true
    });
    ScanSubscriber.prototype._next = function (value) {
        if (!this.hasSeed) {
            this.seed = value;
            this.destination.next(value);
        }
        else {
            return this._tryNext(value);
        }
    };
    ScanSubscriber.prototype._tryNext = function (value) {
        var index = this.index++;
        var result;
        try {
            result = this.accumulator(this.seed, value, index);
        }
        catch (err) {
            this.destination.error(err);
        }
        this.seed = result;
        this.destination.next(result);
    };
    return ScanSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=scan.js.map

/***/ }),
/* 1303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(3);
var tryCatch_1 = __webpack_require__(25);
var errorObject_1 = __webpack_require__(22);
/**
 * Compares all values of two observables in sequence using an optional comparor function
 * and returns an observable of a single boolean value representing whether or not the two sequences
 * are equal.
 *
 * <span class="informal">Checks to see of all values emitted by both observables are equal, in order.</span>
 *
 * <img src="./img/sequenceEqual.png" width="100%">
 *
 * `sequenceEqual` subscribes to two observables and buffers incoming values from each observable. Whenever either
 * observable emits a value, the value is buffered and the buffers are shifted and compared from the bottom
 * up; If any value pair doesn't match, the returned observable will emit `false` and complete. If one of the
 * observables completes, the operator will wait for the other observable to complete; If the other
 * observable emits before completing, the returned observable will emit `false` and complete. If one observable never
 * completes or emits after the other complets, the returned observable will never complete.
 *
 * @example <caption>figure out if the Konami code matches</caption>
 * var code = Rx.Observable.from([
 *  "ArrowUp",
 *  "ArrowUp",
 *  "ArrowDown",
 *  "ArrowDown",
 *  "ArrowLeft",
 *  "ArrowRight",
 *  "ArrowLeft",
 *  "ArrowRight",
 *  "KeyB",
 *  "KeyA",
 *  "Enter" // no start key, clearly.
 * ]);
 *
 * var keys = Rx.Observable.fromEvent(document, 'keyup')
 *  .map(e => e.code);
 * var matches = keys.bufferCount(11, 1)
 *  .mergeMap(
 *    last11 =>
 *      Rx.Observable.from(last11)
 *        .sequenceEqual(code)
 *   );
 * matches.subscribe(matched => console.log('Successful cheat at Contra? ', matched));
 *
 * @see {@link combineLatest}
 * @see {@link zip}
 * @see {@link withLatestFrom}
 *
 * @param {Observable} compareTo The observable sequence to compare the source sequence to.
 * @param {function} [comparor] An optional function to compare each value pair
 * @return {Observable} An Observable of a single boolean value representing whether or not
 * the values emitted by both observables were equal in sequence.
 * @method sequenceEqual
 * @owner Observable
 */
function sequenceEqual(compareTo, comparor) {
    return this.lift(new SequenceEqualOperator(compareTo, comparor));
}
exports.sequenceEqual = sequenceEqual;
var SequenceEqualOperator = (function () {
    function SequenceEqualOperator(compareTo, comparor) {
        this.compareTo = compareTo;
        this.comparor = comparor;
    }
    SequenceEqualOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new SequenceEqualSubscriber(subscriber, this.compareTo, this.comparor));
    };
    return SequenceEqualOperator;
}());
exports.SequenceEqualOperator = SequenceEqualOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var SequenceEqualSubscriber = (function (_super) {
    __extends(SequenceEqualSubscriber, _super);
    function SequenceEqualSubscriber(destination, compareTo, comparor) {
        _super.call(this, destination);
        this.compareTo = compareTo;
        this.comparor = comparor;
        this._a = [];
        this._b = [];
        this._oneComplete = false;
        this.add(compareTo.subscribe(new SequenceEqualCompareToSubscriber(destination, this)));
    }
    SequenceEqualSubscriber.prototype._next = function (value) {
        if (this._oneComplete && this._b.length === 0) {
            this.emit(false);
        }
        else {
            this._a.push(value);
            this.checkValues();
        }
    };
    SequenceEqualSubscriber.prototype._complete = function () {
        if (this._oneComplete) {
            this.emit(this._a.length === 0 && this._b.length === 0);
        }
        else {
            this._oneComplete = true;
        }
    };
    SequenceEqualSubscriber.prototype.checkValues = function () {
        var _c = this, _a = _c._a, _b = _c._b, comparor = _c.comparor;
        while (_a.length > 0 && _b.length > 0) {
            var a = _a.shift();
            var b = _b.shift();
            var areEqual = false;
            if (comparor) {
                areEqual = tryCatch_1.tryCatch(comparor)(a, b);
                if (areEqual === errorObject_1.errorObject) {
                    this.destination.error(errorObject_1.errorObject.e);
                }
            }
            else {
                areEqual = a === b;
            }
            if (!areEqual) {
                this.emit(false);
            }
        }
    };
    SequenceEqualSubscriber.prototype.emit = function (value) {
        var destination = this.destination;
        destination.next(value);
        destination.complete();
    };
    SequenceEqualSubscriber.prototype.nextB = function (value) {
        if (this._oneComplete && this._a.length === 0) {
            this.emit(false);
        }
        else {
            this._b.push(value);
            this.checkValues();
        }
    };
    return SequenceEqualSubscriber;
}(Subscriber_1.Subscriber));
exports.SequenceEqualSubscriber = SequenceEqualSubscriber;
var SequenceEqualCompareToSubscriber = (function (_super) {
    __extends(SequenceEqualCompareToSubscriber, _super);
    function SequenceEqualCompareToSubscriber(destination, parent) {
        _super.call(this, destination);
        this.parent = parent;
    }
    SequenceEqualCompareToSubscriber.prototype._next = function (value) {
        this.parent.nextB(value);
    };
    SequenceEqualCompareToSubscriber.prototype._error = function (err) {
        this.parent.error(err);
    };
    SequenceEqualCompareToSubscriber.prototype._complete = function () {
        this.parent._complete();
    };
    return SequenceEqualCompareToSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=sequenceEqual.js.map

/***/ }),
/* 1304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var multicast_1 = __webpack_require__(92);
var ReplaySubject_1 = __webpack_require__(166);
/**
 * @method shareReplay
 * @owner Observable
 */
function shareReplay(bufferSize, windowTime, scheduler) {
    var subject;
    var connectable = multicast_1.multicast.call(this, function shareReplaySubjectFactory() {
        if (this._isComplete) {
            return subject;
        }
        else {
            return (subject = new ReplaySubject_1.ReplaySubject(bufferSize, windowTime, scheduler));
        }
    });
    return connectable.refCount();
}
exports.shareReplay = shareReplay;
;
//# sourceMappingURL=shareReplay.js.map

/***/ }),
/* 1305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(3);
var EmptyError_1 = __webpack_require__(132);
/**
 * Returns an Observable that emits the single item emitted by the source Observable that matches a specified
 * predicate, if that Observable emits one such item. If the source Observable emits more than one such item or no
 * such items, notify of an IllegalArgumentException or NoSuchElementException respectively.
 *
 * <img src="./img/single.png" width="100%">
 *
 * @throws {EmptyError} Delivers an EmptyError to the Observer's `error`
 * callback if the Observable completes before any `next` notification was sent.
 * @param {Function} predicate - A predicate function to evaluate items emitted by the source Observable.
 * @return {Observable<T>} An Observable that emits the single item emitted by the source Observable that matches
 * the predicate.
 .
 * @method single
 * @owner Observable
 */
function single(predicate) {
    return this.lift(new SingleOperator(predicate, this));
}
exports.single = single;
var SingleOperator = (function () {
    function SingleOperator(predicate, source) {
        this.predicate = predicate;
        this.source = source;
    }
    SingleOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new SingleSubscriber(subscriber, this.predicate, this.source));
    };
    return SingleOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var SingleSubscriber = (function (_super) {
    __extends(SingleSubscriber, _super);
    function SingleSubscriber(destination, predicate, source) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.source = source;
        this.seenValue = false;
        this.index = 0;
    }
    SingleSubscriber.prototype.applySingleValue = function (value) {
        if (this.seenValue) {
            this.destination.error('Sequence contains more than one element');
        }
        else {
            this.seenValue = true;
            this.singleValue = value;
        }
    };
    SingleSubscriber.prototype._next = function (value) {
        var index = this.index++;
        if (this.predicate) {
            this.tryNext(value, index);
        }
        else {
            this.applySingleValue(value);
        }
    };
    SingleSubscriber.prototype.tryNext = function (value, index) {
        try {
            if (this.predicate(value, index, this.source)) {
                this.applySingleValue(value);
            }
        }
        catch (err) {
            this.destination.error(err);
        }
    };
    SingleSubscriber.prototype._complete = function () {
        var destination = this.destination;
        if (this.index > 0) {
            destination.next(this.seenValue ? this.singleValue : undefined);
            destination.complete();
        }
        else {
            destination.error(new EmptyError_1.EmptyError);
        }
    };
    return SingleSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=single.js.map

/***/ }),
/* 1306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(3);
/**
 * Returns an Observable that skips the first `count` items emitted by the source Observable.
 *
 * <img src="./img/skip.png" width="100%">
 *
 * @param {Number} count - The number of times, items emitted by source Observable should be skipped.
 * @return {Observable} An Observable that skips values emitted by the source Observable.
 *
 * @method skip
 * @owner Observable
 */
function skip(count) {
    return this.lift(new SkipOperator(count));
}
exports.skip = skip;
var SkipOperator = (function () {
    function SkipOperator(total) {
        this.total = total;
    }
    SkipOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new SkipSubscriber(subscriber, this.total));
    };
    return SkipOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var SkipSubscriber = (function (_super) {
    __extends(SkipSubscriber, _super);
    function SkipSubscriber(destination, total) {
        _super.call(this, destination);
        this.total = total;
        this.count = 0;
    }
    SkipSubscriber.prototype._next = function (x) {
        if (++this.count > this.total) {
            this.destination.next(x);
        }
    };
    return SkipSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=skip.js.map

/***/ }),
/* 1307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(3);
var ArgumentOutOfRangeError_1 = __webpack_require__(131);
/**
 * Skip the last `count` values emitted by the source Observable.
 *
 * <img src="./img/skipLast.png" width="100%">
 *
 * `skipLast` returns an Observable that accumulates a queue with a length
 * enough to store the first `count` values. As more values are received,
 * values are taken from the front of the queue and produced on the result
 * sequence. This causes values to be delayed.
 *
 * @example <caption>Skip the last 2 values of an Observable with many values</caption>
 * var many = Rx.Observable.range(1, 5);
 * var skipLastTwo = many.skipLast(2);
 * skipLastTwo.subscribe(x => console.log(x));
 *
 * // Results in:
 * // 1 2 3
 *
 * @see {@link skip}
 * @see {@link skipUntil}
 * @see {@link skipWhile}
 * @see {@link take}
 *
 * @throws {ArgumentOutOfRangeError} When using `skipLast(i)`, it throws
 * ArgumentOutOrRangeError if `i < 0`.
 *
 * @param {number} count Number of elements to skip from the end of the source Observable.
 * @returns {Observable<T>} An Observable that skips the last count values
 * emitted by the source Observable.
 * @method skipLast
 * @owner Observable
 */
function skipLast(count) {
    return this.lift(new SkipLastOperator(count));
}
exports.skipLast = skipLast;
var SkipLastOperator = (function () {
    function SkipLastOperator(_skipCount) {
        this._skipCount = _skipCount;
        if (this._skipCount < 0) {
            throw new ArgumentOutOfRangeError_1.ArgumentOutOfRangeError;
        }
    }
    SkipLastOperator.prototype.call = function (subscriber, source) {
        if (this._skipCount === 0) {
            // If we don't want to skip any values then just subscribe
            // to Subscriber without any further logic.
            return source.subscribe(new Subscriber_1.Subscriber(subscriber));
        }
        else {
            return source.subscribe(new SkipLastSubscriber(subscriber, this._skipCount));
        }
    };
    return SkipLastOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var SkipLastSubscriber = (function (_super) {
    __extends(SkipLastSubscriber, _super);
    function SkipLastSubscriber(destination, _skipCount) {
        _super.call(this, destination);
        this._skipCount = _skipCount;
        this._count = 0;
        this._ring = new Array(_skipCount);
    }
    SkipLastSubscriber.prototype._next = function (value) {
        var skipCount = this._skipCount;
        var count = this._count++;
        if (count < skipCount) {
            this._ring[count] = value;
        }
        else {
            var currentIndex = count % skipCount;
            var ring = this._ring;
            var oldValue = ring[currentIndex];
            ring[currentIndex] = value;
            this.destination.next(oldValue);
        }
    };
    return SkipLastSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=skipLast.js.map

/***/ }),
/* 1308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var OuterSubscriber_1 = __webpack_require__(6);
var subscribeToResult_1 = __webpack_require__(7);
/**
 * Returns an Observable that skips items emitted by the source Observable until a second Observable emits an item.
 *
 * <img src="./img/skipUntil.png" width="100%">
 *
 * @param {Observable} notifier - The second Observable that has to emit an item before the source Observable's elements begin to
 * be mirrored by the resulting Observable.
 * @return {Observable<T>} An Observable that skips items from the source Observable until the second Observable emits
 * an item, then emits the remaining items.
 * @method skipUntil
 * @owner Observable
 */
function skipUntil(notifier) {
    return this.lift(new SkipUntilOperator(notifier));
}
exports.skipUntil = skipUntil;
var SkipUntilOperator = (function () {
    function SkipUntilOperator(notifier) {
        this.notifier = notifier;
    }
    SkipUntilOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new SkipUntilSubscriber(subscriber, this.notifier));
    };
    return SkipUntilOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var SkipUntilSubscriber = (function (_super) {
    __extends(SkipUntilSubscriber, _super);
    function SkipUntilSubscriber(destination, notifier) {
        _super.call(this, destination);
        this.hasValue = false;
        this.isInnerStopped = false;
        this.add(subscribeToResult_1.subscribeToResult(this, notifier));
    }
    SkipUntilSubscriber.prototype._next = function (value) {
        if (this.hasValue) {
            _super.prototype._next.call(this, value);
        }
    };
    SkipUntilSubscriber.prototype._complete = function () {
        if (this.isInnerStopped) {
            _super.prototype._complete.call(this);
        }
        else {
            this.unsubscribe();
        }
    };
    SkipUntilSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.hasValue = true;
    };
    SkipUntilSubscriber.prototype.notifyComplete = function () {
        this.isInnerStopped = true;
        if (this.isStopped) {
            _super.prototype._complete.call(this);
        }
    };
    return SkipUntilSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
//# sourceMappingURL=skipUntil.js.map

/***/ }),
/* 1309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(3);
/**
 * Returns an Observable that skips all items emitted by the source Observable as long as a specified condition holds
 * true, but emits all further source items as soon as the condition becomes false.
 *
 * <img src="./img/skipWhile.png" width="100%">
 *
 * @param {Function} predicate - A function to test each item emitted from the source Observable.
 * @return {Observable<T>} An Observable that begins emitting items emitted by the source Observable when the
 * specified predicate becomes false.
 * @method skipWhile
 * @owner Observable
 */
function skipWhile(predicate) {
    return this.lift(new SkipWhileOperator(predicate));
}
exports.skipWhile = skipWhile;
var SkipWhileOperator = (function () {
    function SkipWhileOperator(predicate) {
        this.predicate = predicate;
    }
    SkipWhileOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new SkipWhileSubscriber(subscriber, this.predicate));
    };
    return SkipWhileOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var SkipWhileSubscriber = (function (_super) {
    __extends(SkipWhileSubscriber, _super);
    function SkipWhileSubscriber(destination, predicate) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.skipping = true;
        this.index = 0;
    }
    SkipWhileSubscriber.prototype._next = function (value) {
        var destination = this.destination;
        if (this.skipping) {
            this.tryCallPredicate(value);
        }
        if (!this.skipping) {
            destination.next(value);
        }
    };
    SkipWhileSubscriber.prototype.tryCallPredicate = function (value) {
        try {
            var result = this.predicate(value, this.index++);
            this.skipping = Boolean(result);
        }
        catch (err) {
            this.destination.error(err);
        }
    };
    return SkipWhileSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=skipWhile.js.map

/***/ }),
/* 1310 */,
/* 1311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var SubscribeOnObservable_1 = __webpack_require__(1229);
/**
 * Asynchronously subscribes Observers to this Observable on the specified IScheduler.
 *
 * <img src="./img/subscribeOn.png" width="100%">
 *
 * @param {Scheduler} scheduler - The IScheduler to perform subscription actions on.
 * @return {Observable<T>} The source Observable modified so that its subscriptions happen on the specified IScheduler.
 .
 * @method subscribeOn
 * @owner Observable
 */
function subscribeOn(scheduler, delay) {
    if (delay === void 0) { delay = 0; }
    return this.lift(new SubscribeOnOperator(scheduler, delay));
}
exports.subscribeOn = subscribeOn;
var SubscribeOnOperator = (function () {
    function SubscribeOnOperator(scheduler, delay) {
        this.scheduler = scheduler;
        this.delay = delay;
    }
    SubscribeOnOperator.prototype.call = function (subscriber, source) {
        return new SubscribeOnObservable_1.SubscribeOnObservable(source, this.delay, this.scheduler).subscribe(subscriber);
    };
    return SubscribeOnOperator;
}());
//# sourceMappingURL=subscribeOn.js.map

/***/ }),
/* 1312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var OuterSubscriber_1 = __webpack_require__(6);
var subscribeToResult_1 = __webpack_require__(7);
/**
 * Converts a higher-order Observable into a first-order Observable by
 * subscribing to only the most recently emitted of those inner Observables.
 *
 * <span class="informal">Flattens an Observable-of-Observables by dropping the
 * previous inner Observable once a new one appears.</span>
 *
 * <img src="./img/switch.png" width="100%">
 *
 * `switch` subscribes to an Observable that emits Observables, also known as a
 * higher-order Observable. Each time it observes one of these emitted inner
 * Observables, the output Observable subscribes to the inner Observable and
 * begins emitting the items emitted by that. So far, it behaves
 * like {@link mergeAll}. However, when a new inner Observable is emitted,
 * `switch` unsubscribes from the earlier-emitted inner Observable and
 * subscribes to the new inner Observable and begins emitting items from it. It
 * continues to behave like this for subsequent inner Observables.
 *
 * @example <caption>Rerun an interval Observable on every click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * // Each click event is mapped to an Observable that ticks every second
 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000));
 * var switched = higherOrder.switch();
 * // The outcome is that `switched` is essentially a timer that restarts
 * // on every click. The interval Observables from older clicks do not merge
 * // with the current interval Observable.
 * switched.subscribe(x => console.log(x));
 *
 * @see {@link combineAll}
 * @see {@link concatAll}
 * @see {@link exhaust}
 * @see {@link mergeAll}
 * @see {@link switchMap}
 * @see {@link switchMapTo}
 * @see {@link zipAll}
 *
 * @return {Observable<T>} An Observable that emits the items emitted by the
 * Observable most recently emitted by the source Observable.
 * @method switch
 * @name switch
 * @owner Observable
 */
function _switch() {
    return this.lift(new SwitchOperator());
}
exports._switch = _switch;
var SwitchOperator = (function () {
    function SwitchOperator() {
    }
    SwitchOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new SwitchSubscriber(subscriber));
    };
    return SwitchOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var SwitchSubscriber = (function (_super) {
    __extends(SwitchSubscriber, _super);
    function SwitchSubscriber(destination) {
        _super.call(this, destination);
        this.active = 0;
        this.hasCompleted = false;
    }
    SwitchSubscriber.prototype._next = function (value) {
        this.unsubscribeInner();
        this.active++;
        this.add(this.innerSubscription = subscribeToResult_1.subscribeToResult(this, value));
    };
    SwitchSubscriber.prototype._complete = function () {
        this.hasCompleted = true;
        if (this.active === 0) {
            this.destination.complete();
        }
    };
    SwitchSubscriber.prototype.unsubscribeInner = function () {
        this.active = this.active > 0 ? this.active - 1 : 0;
        var innerSubscription = this.innerSubscription;
        if (innerSubscription) {
            innerSubscription.unsubscribe();
            this.remove(innerSubscription);
        }
    };
    SwitchSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.destination.next(innerValue);
    };
    SwitchSubscriber.prototype.notifyError = function (err) {
        this.destination.error(err);
    };
    SwitchSubscriber.prototype.notifyComplete = function () {
        this.unsubscribeInner();
        if (this.hasCompleted && this.active === 0) {
            this.destination.complete();
        }
    };
    return SwitchSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
//# sourceMappingURL=switch.js.map

/***/ }),
/* 1313 */,
/* 1314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var OuterSubscriber_1 = __webpack_require__(6);
var subscribeToResult_1 = __webpack_require__(7);
/* tslint:enable:max-line-length */
/**
 * Projects each source value to the same Observable which is flattened multiple
 * times with {@link switch} in the output Observable.
 *
 * <span class="informal">It's like {@link switchMap}, but maps each value
 * always to the same inner Observable.</span>
 *
 * <img src="./img/switchMapTo.png" width="100%">
 *
 * Maps each source value to the given Observable `innerObservable` regardless
 * of the source value, and then flattens those resulting Observables into one
 * single Observable, which is the output Observable. The output Observables
 * emits values only from the most recently emitted instance of
 * `innerObservable`.
 *
 * @example <caption>Rerun an interval Observable on every click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.switchMapTo(Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link concatMapTo}
 * @see {@link switch}
 * @see {@link switchMap}
 * @see {@link mergeMapTo}
 *
 * @param {ObservableInput} innerObservable An Observable to replace each value from
 * the source Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @return {Observable} An Observable that emits items from the given
 * `innerObservable` (and optionally transformed through `resultSelector`) every
 * time a value is emitted on the source Observable, and taking only the values
 * from the most recently projected inner Observable.
 * @method switchMapTo
 * @owner Observable
 */
function switchMapTo(innerObservable, resultSelector) {
    return this.lift(new SwitchMapToOperator(innerObservable, resultSelector));
}
exports.switchMapTo = switchMapTo;
var SwitchMapToOperator = (function () {
    function SwitchMapToOperator(observable, resultSelector) {
        this.observable = observable;
        this.resultSelector = resultSelector;
    }
    SwitchMapToOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new SwitchMapToSubscriber(subscriber, this.observable, this.resultSelector));
    };
    return SwitchMapToOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var SwitchMapToSubscriber = (function (_super) {
    __extends(SwitchMapToSubscriber, _super);
    function SwitchMapToSubscriber(destination, inner, resultSelector) {
        _super.call(this, destination);
        this.inner = inner;
        this.resultSelector = resultSelector;
        this.index = 0;
    }
    SwitchMapToSubscriber.prototype._next = function (value) {
        var innerSubscription = this.innerSubscription;
        if (innerSubscription) {
            innerSubscription.unsubscribe();
        }
        this.add(this.innerSubscription = subscribeToResult_1.subscribeToResult(this, this.inner, value, this.index++));
    };
    SwitchMapToSubscriber.prototype._complete = function () {
        var innerSubscription = this.innerSubscription;
        if (!innerSubscription || innerSubscription.closed) {
            _super.prototype._complete.call(this);
        }
    };
    SwitchMapToSubscriber.prototype._unsubscribe = function () {
        this.innerSubscription = null;
    };
    SwitchMapToSubscriber.prototype.notifyComplete = function (innerSub) {
        this.remove(innerSub);
        this.innerSubscription = null;
        if (this.isStopped) {
            _super.prototype._complete.call(this);
        }
    };
    SwitchMapToSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        var _a = this, resultSelector = _a.resultSelector, destination = _a.destination;
        if (resultSelector) {
            this.tryResultSelector(outerValue, innerValue, outerIndex, innerIndex);
        }
        else {
            destination.next(innerValue);
        }
    };
    SwitchMapToSubscriber.prototype.tryResultSelector = function (outerValue, innerValue, outerIndex, innerIndex) {
        var _a = this, resultSelector = _a.resultSelector, destination = _a.destination;
        var result;
        try {
            result = resultSelector(outerValue, innerValue, outerIndex, innerIndex);
        }
        catch (err) {
            destination.error(err);
            return;
        }
        destination.next(result);
    };
    return SwitchMapToSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
//# sourceMappingURL=switchMapTo.js.map

/***/ }),
/* 1315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(3);
var ArgumentOutOfRangeError_1 = __webpack_require__(131);
var EmptyObservable_1 = __webpack_require__(76);
/**
 * Emits only the first `count` values emitted by the source Observable.
 *
 * <span class="informal">Takes the first `count` values from the source, then
 * completes.</span>
 *
 * <img src="./img/take.png" width="100%">
 *
 * `take` returns an Observable that emits only the first `count` values emitted
 * by the source Observable. If the source emits fewer than `count` values then
 * all of its values are emitted. After that, it completes, regardless if the
 * source completes.
 *
 * @example <caption>Take the first 5 seconds of an infinite 1-second interval Observable</caption>
 * var interval = Rx.Observable.interval(1000);
 * var five = interval.take(5);
 * five.subscribe(x => console.log(x));
 *
 * @see {@link takeLast}
 * @see {@link takeUntil}
 * @see {@link takeWhile}
 * @see {@link skip}
 *
 * @throws {ArgumentOutOfRangeError} When using `take(i)`, it delivers an
 * ArgumentOutOrRangeError to the Observer's `error` callback if `i < 0`.
 *
 * @param {number} count The maximum number of `next` values to emit.
 * @return {Observable<T>} An Observable that emits only the first `count`
 * values emitted by the source Observable, or all of the values from the source
 * if the source emits fewer than `count` values.
 * @method take
 * @owner Observable
 */
function take(count) {
    if (count === 0) {
        return new EmptyObservable_1.EmptyObservable();
    }
    else {
        return this.lift(new TakeOperator(count));
    }
}
exports.take = take;
var TakeOperator = (function () {
    function TakeOperator(total) {
        this.total = total;
        if (this.total < 0) {
            throw new ArgumentOutOfRangeError_1.ArgumentOutOfRangeError;
        }
    }
    TakeOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new TakeSubscriber(subscriber, this.total));
    };
    return TakeOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var TakeSubscriber = (function (_super) {
    __extends(TakeSubscriber, _super);
    function TakeSubscriber(destination, total) {
        _super.call(this, destination);
        this.total = total;
        this.count = 0;
    }
    TakeSubscriber.prototype._next = function (value) {
        var total = this.total;
        var count = ++this.count;
        if (count <= total) {
            this.destination.next(value);
            if (count === total) {
                this.destination.complete();
                this.unsubscribe();
            }
        }
    };
    return TakeSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=take.js.map

/***/ }),
/* 1316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(3);
var ArgumentOutOfRangeError_1 = __webpack_require__(131);
var EmptyObservable_1 = __webpack_require__(76);
/**
 * Emits only the last `count` values emitted by the source Observable.
 *
 * <span class="informal">Remembers the latest `count` values, then emits those
 * only when the source completes.</span>
 *
 * <img src="./img/takeLast.png" width="100%">
 *
 * `takeLast` returns an Observable that emits at most the last `count` values
 * emitted by the source Observable. If the source emits fewer than `count`
 * values then all of its values are emitted. This operator must wait until the
 * `complete` notification emission from the source in order to emit the `next`
 * values on the output Observable, because otherwise it is impossible to know
 * whether or not more values will be emitted on the source. For this reason,
 * all values are emitted synchronously, followed by the complete notification.
 *
 * @example <caption>Take the last 3 values of an Observable with many values</caption>
 * var many = Rx.Observable.range(1, 100);
 * var lastThree = many.takeLast(3);
 * lastThree.subscribe(x => console.log(x));
 *
 * @see {@link take}
 * @see {@link takeUntil}
 * @see {@link takeWhile}
 * @see {@link skip}
 *
 * @throws {ArgumentOutOfRangeError} When using `takeLast(i)`, it delivers an
 * ArgumentOutOrRangeError to the Observer's `error` callback if `i < 0`.
 *
 * @param {number} count The maximum number of values to emit from the end of
 * the sequence of values emitted by the source Observable.
 * @return {Observable<T>} An Observable that emits at most the last count
 * values emitted by the source Observable.
 * @method takeLast
 * @owner Observable
 */
function takeLast(count) {
    if (count === 0) {
        return new EmptyObservable_1.EmptyObservable();
    }
    else {
        return this.lift(new TakeLastOperator(count));
    }
}
exports.takeLast = takeLast;
var TakeLastOperator = (function () {
    function TakeLastOperator(total) {
        this.total = total;
        if (this.total < 0) {
            throw new ArgumentOutOfRangeError_1.ArgumentOutOfRangeError;
        }
    }
    TakeLastOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new TakeLastSubscriber(subscriber, this.total));
    };
    return TakeLastOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var TakeLastSubscriber = (function (_super) {
    __extends(TakeLastSubscriber, _super);
    function TakeLastSubscriber(destination, total) {
        _super.call(this, destination);
        this.total = total;
        this.ring = new Array();
        this.count = 0;
    }
    TakeLastSubscriber.prototype._next = function (value) {
        var ring = this.ring;
        var total = this.total;
        var count = this.count++;
        if (ring.length < total) {
            ring.push(value);
        }
        else {
            var index = count % total;
            ring[index] = value;
        }
    };
    TakeLastSubscriber.prototype._complete = function () {
        var destination = this.destination;
        var count = this.count;
        if (count > 0) {
            var total = this.count >= this.total ? this.total : this.count;
            var ring = this.ring;
            for (var i = 0; i < total; i++) {
                var idx = (count++) % total;
                destination.next(ring[idx]);
            }
        }
        destination.complete();
    };
    return TakeLastSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=takeLast.js.map

/***/ }),
/* 1317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var OuterSubscriber_1 = __webpack_require__(6);
var subscribeToResult_1 = __webpack_require__(7);
/**
 * Emits the values emitted by the source Observable until a `notifier`
 * Observable emits a value.
 *
 * <span class="informal">Lets values pass until a second Observable,
 * `notifier`, emits something. Then, it completes.</span>
 *
 * <img src="./img/takeUntil.png" width="100%">
 *
 * `takeUntil` subscribes and begins mirroring the source Observable. It also
 * monitors a second Observable, `notifier` that you provide. If the `notifier`
 * emits a value or a complete notification, the output Observable stops
 * mirroring the source Observable and completes.
 *
 * @example <caption>Tick every second until the first click happens</caption>
 * var interval = Rx.Observable.interval(1000);
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = interval.takeUntil(clicks);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link take}
 * @see {@link takeLast}
 * @see {@link takeWhile}
 * @see {@link skip}
 *
 * @param {Observable} notifier The Observable whose first emitted value will
 * cause the output Observable of `takeUntil` to stop emitting values from the
 * source Observable.
 * @return {Observable<T>} An Observable that emits the values from the source
 * Observable until such time as `notifier` emits its first value.
 * @method takeUntil
 * @owner Observable
 */
function takeUntil(notifier) {
    return this.lift(new TakeUntilOperator(notifier));
}
exports.takeUntil = takeUntil;
var TakeUntilOperator = (function () {
    function TakeUntilOperator(notifier) {
        this.notifier = notifier;
    }
    TakeUntilOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new TakeUntilSubscriber(subscriber, this.notifier));
    };
    return TakeUntilOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var TakeUntilSubscriber = (function (_super) {
    __extends(TakeUntilSubscriber, _super);
    function TakeUntilSubscriber(destination, notifier) {
        _super.call(this, destination);
        this.notifier = notifier;
        this.add(subscribeToResult_1.subscribeToResult(this, notifier));
    }
    TakeUntilSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.complete();
    };
    TakeUntilSubscriber.prototype.notifyComplete = function () {
        // noop
    };
    return TakeUntilSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
//# sourceMappingURL=takeUntil.js.map

/***/ }),
/* 1318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(3);
/**
 * Emits values emitted by the source Observable so long as each value satisfies
 * the given `predicate`, and then completes as soon as this `predicate` is not
 * satisfied.
 *
 * <span class="informal">Takes values from the source only while they pass the
 * condition given. When the first value does not satisfy, it completes.</span>
 *
 * <img src="./img/takeWhile.png" width="100%">
 *
 * `takeWhile` subscribes and begins mirroring the source Observable. Each value
 * emitted on the source is given to the `predicate` function which returns a
 * boolean, representing a condition to be satisfied by the source values. The
 * output Observable emits the source values until such time as the `predicate`
 * returns false, at which point `takeWhile` stops mirroring the source
 * Observable and completes the output Observable.
 *
 * @example <caption>Emit click events only while the clientX property is greater than 200</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.takeWhile(ev => ev.clientX > 200);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link take}
 * @see {@link takeLast}
 * @see {@link takeUntil}
 * @see {@link skip}
 *
 * @param {function(value: T, index: number): boolean} predicate A function that
 * evaluates a value emitted by the source Observable and returns a boolean.
 * Also takes the (zero-based) index as the second argument.
 * @return {Observable<T>} An Observable that emits the values from the source
 * Observable so long as each value satisfies the condition defined by the
 * `predicate`, then completes.
 * @method takeWhile
 * @owner Observable
 */
function takeWhile(predicate) {
    return this.lift(new TakeWhileOperator(predicate));
}
exports.takeWhile = takeWhile;
var TakeWhileOperator = (function () {
    function TakeWhileOperator(predicate) {
        this.predicate = predicate;
    }
    TakeWhileOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new TakeWhileSubscriber(subscriber, this.predicate));
    };
    return TakeWhileOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var TakeWhileSubscriber = (function (_super) {
    __extends(TakeWhileSubscriber, _super);
    function TakeWhileSubscriber(destination, predicate) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.index = 0;
    }
    TakeWhileSubscriber.prototype._next = function (value) {
        var destination = this.destination;
        var result;
        try {
            result = this.predicate(value, this.index++);
        }
        catch (err) {
            destination.error(err);
            return;
        }
        this.nextOrComplete(value, result);
    };
    TakeWhileSubscriber.prototype.nextOrComplete = function (value, predicateResult) {
        var destination = this.destination;
        if (Boolean(predicateResult)) {
            destination.next(value);
        }
        else {
            destination.complete();
        }
    };
    return TakeWhileSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=takeWhile.js.map

/***/ }),
/* 1319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(3);
var async_1 = __webpack_require__(30);
var throttle_1 = __webpack_require__(488);
/**
 * Emits a value from the source Observable, then ignores subsequent source
 * values for `duration` milliseconds, then repeats this process.
 *
 * <span class="informal">Lets a value pass, then ignores source values for the
 * next `duration` milliseconds.</span>
 *
 * <img src="./img/throttleTime.png" width="100%">
 *
 * `throttleTime` emits the source Observable values on the output Observable
 * when its internal timer is disabled, and ignores source values when the timer
 * is enabled. Initially, the timer is disabled. As soon as the first source
 * value arrives, it is forwarded to the output Observable, and then the timer
 * is enabled. After `duration` milliseconds (or the time unit determined
 * internally by the optional `scheduler`) has passed, the timer is disabled,
 * and this process repeats for the next source value. Optionally takes a
 * {@link IScheduler} for managing timers.
 *
 * @example <caption>Emit clicks at a rate of at most one click per second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.throttleTime(1000);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link auditTime}
 * @see {@link debounceTime}
 * @see {@link delay}
 * @see {@link sampleTime}
 * @see {@link throttle}
 *
 * @param {number} duration Time to wait before emitting another value after
 * emitting the last value, measured in milliseconds or the time unit determined
 * internally by the optional `scheduler`.
 * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
 * managing the timers that handle the throttling.
 * @return {Observable<T>} An Observable that performs the throttle operation to
 * limit the rate of emissions from the source.
 * @method throttleTime
 * @owner Observable
 */
function throttleTime(duration, scheduler, config) {
    if (scheduler === void 0) { scheduler = async_1.async; }
    if (config === void 0) { config = throttle_1.defaultThrottleConfig; }
    return this.lift(new ThrottleTimeOperator(duration, scheduler, config.leading, config.trailing));
}
exports.throttleTime = throttleTime;
var ThrottleTimeOperator = (function () {
    function ThrottleTimeOperator(duration, scheduler, leading, trailing) {
        this.duration = duration;
        this.scheduler = scheduler;
        this.leading = leading;
        this.trailing = trailing;
    }
    ThrottleTimeOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new ThrottleTimeSubscriber(subscriber, this.duration, this.scheduler, this.leading, this.trailing));
    };
    return ThrottleTimeOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var ThrottleTimeSubscriber = (function (_super) {
    __extends(ThrottleTimeSubscriber, _super);
    function ThrottleTimeSubscriber(destination, duration, scheduler, leading, trailing) {
        _super.call(this, destination);
        this.duration = duration;
        this.scheduler = scheduler;
        this.leading = leading;
        this.trailing = trailing;
        this._hasTrailingValue = false;
        this._trailingValue = null;
    }
    ThrottleTimeSubscriber.prototype._next = function (value) {
        if (this.throttled) {
            if (this.trailing) {
                this._trailingValue = value;
                this._hasTrailingValue = true;
            }
        }
        else {
            this.add(this.throttled = this.scheduler.schedule(dispatchNext, this.duration, { subscriber: this }));
            if (this.leading) {
                this.destination.next(value);
            }
        }
    };
    ThrottleTimeSubscriber.prototype.clearThrottle = function () {
        var throttled = this.throttled;
        if (throttled) {
            if (this.trailing && this._hasTrailingValue) {
                this.destination.next(this._trailingValue);
                this._trailingValue = null;
                this._hasTrailingValue = false;
            }
            throttled.unsubscribe();
            this.remove(throttled);
            this.throttled = null;
        }
    };
    return ThrottleTimeSubscriber;
}(Subscriber_1.Subscriber));
function dispatchNext(arg) {
    var subscriber = arg.subscriber;
    subscriber.clearThrottle();
}
//# sourceMappingURL=throttleTime.js.map

/***/ }),
/* 1320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var async_1 = __webpack_require__(30);
var isDate_1 = __webpack_require__(172);
var Subscriber_1 = __webpack_require__(3);
var TimeoutError_1 = __webpack_require__(496);
/**
 *
 * Errors if Observable does not emit a value in given time span.
 *
 * <span class="informal">Timeouts on Observable that doesn't emit values fast enough.</span>
 *
 * <img src="./img/timeout.png" width="100%">
 *
 * `timeout` operator accepts as an argument either a number or a Date.
 *
 * If number was provided, it returns an Observable that behaves like a source
 * Observable, unless there is a period of time where there is no value emitted.
 * So if you provide `100` as argument and first value comes after 50ms from
 * the moment of subscription, this value will be simply re-emitted by the resulting
 * Observable. If however after that 100ms passes without a second value being emitted,
 * stream will end with an error and source Observable will be unsubscribed.
 * These checks are performed throughout whole lifecycle of Observable - from the moment
 * it was subscribed to, until it completes or errors itself. Thus every value must be
 * emitted within specified period since previous value.
 *
 * If provided argument was Date, returned Observable behaves differently. It throws
 * if Observable did not complete before provided Date. This means that periods between
 * emission of particular values do not matter in this case. If Observable did not complete
 * before provided Date, source Observable will be unsubscribed. Other than that, resulting
 * stream behaves just as source Observable.
 *
 * `timeout` accepts also a Scheduler as a second parameter. It is used to schedule moment (or moments)
 * when returned Observable will check if source stream emitted value or completed.
 *
 * @example <caption>Check if ticks are emitted within certain timespan</caption>
 * const seconds = Rx.Observable.interval(1000);
 *
 * seconds.timeout(1100) // Let's use bigger timespan to be safe,
 *                       // since `interval` might fire a bit later then scheduled.
 * .subscribe(
 *     value => console.log(value), // Will emit numbers just as regular `interval` would.
 *     err => console.log(err) // Will never be called.
 * );
 *
 * seconds.timeout(900).subscribe(
 *     value => console.log(value), // Will never be called.
 *     err => console.log(err) // Will emit error before even first value is emitted,
 *                             // since it did not arrive within 900ms period.
 * );
 *
 * @example <caption>Use Date to check if Observable completed</caption>
 * const seconds = Rx.Observable.interval(1000);
 *
 * seconds.timeout(new Date("December 17, 2020 03:24:00"))
 * .subscribe(
 *     value => console.log(value), // Will emit values as regular `interval` would
 *                                  // until December 17, 2020 at 03:24:00.
 *     err => console.log(err) // On December 17, 2020 at 03:24:00 it will emit an error,
 *                             // since Observable did not complete by then.
 * );
 *
 * @see {@link timeoutWith}
 *
 * @param {number|Date} due Number specifying period within which Observable must emit values
 *                          or Date specifying before when Observable should complete
 * @param {Scheduler} [scheduler] Scheduler controlling when timeout checks occur.
 * @return {Observable<T>} Observable that mirrors behaviour of source, unless timeout checks fail.
 * @method timeout
 * @owner Observable
 */
function timeout(due, scheduler) {
    if (scheduler === void 0) { scheduler = async_1.async; }
    var absoluteTimeout = isDate_1.isDate(due);
    var waitFor = absoluteTimeout ? (+due - scheduler.now()) : Math.abs(due);
    return this.lift(new TimeoutOperator(waitFor, absoluteTimeout, scheduler, new TimeoutError_1.TimeoutError()));
}
exports.timeout = timeout;
var TimeoutOperator = (function () {
    function TimeoutOperator(waitFor, absoluteTimeout, scheduler, errorInstance) {
        this.waitFor = waitFor;
        this.absoluteTimeout = absoluteTimeout;
        this.scheduler = scheduler;
        this.errorInstance = errorInstance;
    }
    TimeoutOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new TimeoutSubscriber(subscriber, this.absoluteTimeout, this.waitFor, this.scheduler, this.errorInstance));
    };
    return TimeoutOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var TimeoutSubscriber = (function (_super) {
    __extends(TimeoutSubscriber, _super);
    function TimeoutSubscriber(destination, absoluteTimeout, waitFor, scheduler, errorInstance) {
        _super.call(this, destination);
        this.absoluteTimeout = absoluteTimeout;
        this.waitFor = waitFor;
        this.scheduler = scheduler;
        this.errorInstance = errorInstance;
        this.action = null;
        this.scheduleTimeout();
    }
    TimeoutSubscriber.dispatchTimeout = function (subscriber) {
        subscriber.error(subscriber.errorInstance);
    };
    TimeoutSubscriber.prototype.scheduleTimeout = function () {
        var action = this.action;
        if (action) {
            // Recycle the action if we've already scheduled one. All the production
            // Scheduler Actions mutate their state/delay time and return themeselves.
            // VirtualActions are immutable, so they create and return a clone. In this
            // case, we need to set the action reference to the most recent VirtualAction,
            // to ensure that's the one we clone from next time.
            this.action = action.schedule(this, this.waitFor);
        }
        else {
            this.add(this.action = this.scheduler.schedule(TimeoutSubscriber.dispatchTimeout, this.waitFor, this));
        }
    };
    TimeoutSubscriber.prototype._next = function (value) {
        if (!this.absoluteTimeout) {
            this.scheduleTimeout();
        }
        _super.prototype._next.call(this, value);
    };
    TimeoutSubscriber.prototype._unsubscribe = function () {
        this.action = null;
        this.scheduler = null;
        this.errorInstance = null;
    };
    return TimeoutSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=timeout.js.map

/***/ }),
/* 1321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var async_1 = __webpack_require__(30);
var isDate_1 = __webpack_require__(172);
var OuterSubscriber_1 = __webpack_require__(6);
var subscribeToResult_1 = __webpack_require__(7);
/* tslint:enable:max-line-length */
/**
 * @param due
 * @param withObservable
 * @param scheduler
 * @return {Observable<R>|WebSocketSubject<T>|Observable<T>}
 * @method timeoutWith
 * @owner Observable
 */
function timeoutWith(due, withObservable, scheduler) {
    if (scheduler === void 0) { scheduler = async_1.async; }
    var absoluteTimeout = isDate_1.isDate(due);
    var waitFor = absoluteTimeout ? (+due - scheduler.now()) : Math.abs(due);
    return this.lift(new TimeoutWithOperator(waitFor, absoluteTimeout, withObservable, scheduler));
}
exports.timeoutWith = timeoutWith;
var TimeoutWithOperator = (function () {
    function TimeoutWithOperator(waitFor, absoluteTimeout, withObservable, scheduler) {
        this.waitFor = waitFor;
        this.absoluteTimeout = absoluteTimeout;
        this.withObservable = withObservable;
        this.scheduler = scheduler;
    }
    TimeoutWithOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new TimeoutWithSubscriber(subscriber, this.absoluteTimeout, this.waitFor, this.withObservable, this.scheduler));
    };
    return TimeoutWithOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var TimeoutWithSubscriber = (function (_super) {
    __extends(TimeoutWithSubscriber, _super);
    function TimeoutWithSubscriber(destination, absoluteTimeout, waitFor, withObservable, scheduler) {
        _super.call(this, destination);
        this.absoluteTimeout = absoluteTimeout;
        this.waitFor = waitFor;
        this.withObservable = withObservable;
        this.scheduler = scheduler;
        this.action = null;
        this.scheduleTimeout();
    }
    TimeoutWithSubscriber.dispatchTimeout = function (subscriber) {
        var withObservable = subscriber.withObservable;
        subscriber._unsubscribeAndRecycle();
        subscriber.add(subscribeToResult_1.subscribeToResult(subscriber, withObservable));
    };
    TimeoutWithSubscriber.prototype.scheduleTimeout = function () {
        var action = this.action;
        if (action) {
            // Recycle the action if we've already scheduled one. All the production
            // Scheduler Actions mutate their state/delay time and return themeselves.
            // VirtualActions are immutable, so they create and return a clone. In this
            // case, we need to set the action reference to the most recent VirtualAction,
            // to ensure that's the one we clone from next time.
            this.action = action.schedule(this, this.waitFor);
        }
        else {
            this.add(this.action = this.scheduler.schedule(TimeoutWithSubscriber.dispatchTimeout, this.waitFor, this));
        }
    };
    TimeoutWithSubscriber.prototype._next = function (value) {
        if (!this.absoluteTimeout) {
            this.scheduleTimeout();
        }
        _super.prototype._next.call(this, value);
    };
    TimeoutWithSubscriber.prototype._unsubscribe = function () {
        this.action = null;
        this.scheduler = null;
        this.withObservable = null;
    };
    return TimeoutWithSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
//# sourceMappingURL=timeoutWith.js.map

/***/ }),
/* 1322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(3);
/**
 * @return {Observable<any[]>|WebSocketSubject<T>|Observable<T>}
 * @method toArray
 * @owner Observable
 */
function toArray() {
    return this.lift(new ToArrayOperator());
}
exports.toArray = toArray;
var ToArrayOperator = (function () {
    function ToArrayOperator() {
    }
    ToArrayOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new ToArraySubscriber(subscriber));
    };
    return ToArrayOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var ToArraySubscriber = (function (_super) {
    __extends(ToArraySubscriber, _super);
    function ToArraySubscriber(destination) {
        _super.call(this, destination);
        this.array = [];
    }
    ToArraySubscriber.prototype._next = function (x) {
        this.array.push(x);
    };
    ToArraySubscriber.prototype._complete = function () {
        this.destination.next(this.array);
        this.destination.complete();
    };
    return ToArraySubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=toArray.js.map

/***/ }),
/* 1323 */,
/* 1324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subject_1 = __webpack_require__(11);
var OuterSubscriber_1 = __webpack_require__(6);
var subscribeToResult_1 = __webpack_require__(7);
/**
 * Branch out the source Observable values as a nested Observable whenever
 * `windowBoundaries` emits.
 *
 * <span class="informal">It's like {@link buffer}, but emits a nested Observable
 * instead of an array.</span>
 *
 * <img src="./img/window.png" width="100%">
 *
 * Returns an Observable that emits windows of items it collects from the source
 * Observable. The output Observable emits connected, non-overlapping
 * windows. It emits the current window and opens a new one whenever the
 * Observable `windowBoundaries` emits an item. Because each window is an
 * Observable, the output is a higher-order Observable.
 *
 * @example <caption>In every window of 1 second each, emit at most 2 click events</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var interval = Rx.Observable.interval(1000);
 * var result = clicks.window(interval)
 *   .map(win => win.take(2)) // each window has at most 2 emissions
 *   .mergeAll(); // flatten the Observable-of-Observables
 * result.subscribe(x => console.log(x));
 *
 * @see {@link windowCount}
 * @see {@link windowTime}
 * @see {@link windowToggle}
 * @see {@link windowWhen}
 * @see {@link buffer}
 *
 * @param {Observable<any>} windowBoundaries An Observable that completes the
 * previous window and starts a new window.
 * @return {Observable<Observable<T>>} An Observable of windows, which are
 * Observables emitting values of the source Observable.
 * @method window
 * @owner Observable
 */
function window(windowBoundaries) {
    return this.lift(new WindowOperator(windowBoundaries));
}
exports.window = window;
var WindowOperator = (function () {
    function WindowOperator(windowBoundaries) {
        this.windowBoundaries = windowBoundaries;
    }
    WindowOperator.prototype.call = function (subscriber, source) {
        var windowSubscriber = new WindowSubscriber(subscriber);
        var sourceSubscription = source.subscribe(windowSubscriber);
        if (!sourceSubscription.closed) {
            windowSubscriber.add(subscribeToResult_1.subscribeToResult(windowSubscriber, this.windowBoundaries));
        }
        return sourceSubscription;
    };
    return WindowOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var WindowSubscriber = (function (_super) {
    __extends(WindowSubscriber, _super);
    function WindowSubscriber(destination) {
        _super.call(this, destination);
        this.window = new Subject_1.Subject();
        destination.next(this.window);
    }
    WindowSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.openWindow();
    };
    WindowSubscriber.prototype.notifyError = function (error, innerSub) {
        this._error(error);
    };
    WindowSubscriber.prototype.notifyComplete = function (innerSub) {
        this._complete();
    };
    WindowSubscriber.prototype._next = function (value) {
        this.window.next(value);
    };
    WindowSubscriber.prototype._error = function (err) {
        this.window.error(err);
        this.destination.error(err);
    };
    WindowSubscriber.prototype._complete = function () {
        this.window.complete();
        this.destination.complete();
    };
    WindowSubscriber.prototype._unsubscribe = function () {
        this.window = null;
    };
    WindowSubscriber.prototype.openWindow = function () {
        var prevWindow = this.window;
        if (prevWindow) {
            prevWindow.complete();
        }
        var destination = this.destination;
        var newWindow = this.window = new Subject_1.Subject();
        destination.next(newWindow);
    };
    return WindowSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
//# sourceMappingURL=window.js.map

/***/ }),
/* 1325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(3);
var Subject_1 = __webpack_require__(11);
/**
 * Branch out the source Observable values as a nested Observable with each
 * nested Observable emitting at most `windowSize` values.
 *
 * <span class="informal">It's like {@link bufferCount}, but emits a nested
 * Observable instead of an array.</span>
 *
 * <img src="./img/windowCount.png" width="100%">
 *
 * Returns an Observable that emits windows of items it collects from the source
 * Observable. The output Observable emits windows every `startWindowEvery`
 * items, each containing no more than `windowSize` items. When the source
 * Observable completes or encounters an error, the output Observable emits
 * the current window and propagates the notification from the source
 * Observable. If `startWindowEvery` is not provided, then new windows are
 * started immediately at the start of the source and when each window completes
 * with size `windowSize`.
 *
 * @example <caption>Ignore every 3rd click event, starting from the first one</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.windowCount(3)
 *   .map(win => win.skip(1)) // skip first of every 3 clicks
 *   .mergeAll(); // flatten the Observable-of-Observables
 * result.subscribe(x => console.log(x));
 *
 * @example <caption>Ignore every 3rd click event, starting from the third one</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.windowCount(2, 3)
 *   .mergeAll(); // flatten the Observable-of-Observables
 * result.subscribe(x => console.log(x));
 *
 * @see {@link window}
 * @see {@link windowTime}
 * @see {@link windowToggle}
 * @see {@link windowWhen}
 * @see {@link bufferCount}
 *
 * @param {number} windowSize The maximum number of values emitted by each
 * window.
 * @param {number} [startWindowEvery] Interval at which to start a new window.
 * For example if `startWindowEvery` is `2`, then a new window will be started
 * on every other value from the source. A new window is started at the
 * beginning of the source by default.
 * @return {Observable<Observable<T>>} An Observable of windows, which in turn
 * are Observable of values.
 * @method windowCount
 * @owner Observable
 */
function windowCount(windowSize, startWindowEvery) {
    if (startWindowEvery === void 0) { startWindowEvery = 0; }
    return this.lift(new WindowCountOperator(windowSize, startWindowEvery));
}
exports.windowCount = windowCount;
var WindowCountOperator = (function () {
    function WindowCountOperator(windowSize, startWindowEvery) {
        this.windowSize = windowSize;
        this.startWindowEvery = startWindowEvery;
    }
    WindowCountOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new WindowCountSubscriber(subscriber, this.windowSize, this.startWindowEvery));
    };
    return WindowCountOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var WindowCountSubscriber = (function (_super) {
    __extends(WindowCountSubscriber, _super);
    function WindowCountSubscriber(destination, windowSize, startWindowEvery) {
        _super.call(this, destination);
        this.destination = destination;
        this.windowSize = windowSize;
        this.startWindowEvery = startWindowEvery;
        this.windows = [new Subject_1.Subject()];
        this.count = 0;
        destination.next(this.windows[0]);
    }
    WindowCountSubscriber.prototype._next = function (value) {
        var startWindowEvery = (this.startWindowEvery > 0) ? this.startWindowEvery : this.windowSize;
        var destination = this.destination;
        var windowSize = this.windowSize;
        var windows = this.windows;
        var len = windows.length;
        for (var i = 0; i < len && !this.closed; i++) {
            windows[i].next(value);
        }
        var c = this.count - windowSize + 1;
        if (c >= 0 && c % startWindowEvery === 0 && !this.closed) {
            windows.shift().complete();
        }
        if (++this.count % startWindowEvery === 0 && !this.closed) {
            var window_1 = new Subject_1.Subject();
            windows.push(window_1);
            destination.next(window_1);
        }
    };
    WindowCountSubscriber.prototype._error = function (err) {
        var windows = this.windows;
        if (windows) {
            while (windows.length > 0 && !this.closed) {
                windows.shift().error(err);
            }
        }
        this.destination.error(err);
    };
    WindowCountSubscriber.prototype._complete = function () {
        var windows = this.windows;
        if (windows) {
            while (windows.length > 0 && !this.closed) {
                windows.shift().complete();
            }
        }
        this.destination.complete();
    };
    WindowCountSubscriber.prototype._unsubscribe = function () {
        this.count = 0;
        this.windows = null;
    };
    return WindowCountSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=windowCount.js.map

/***/ }),
/* 1326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subject_1 = __webpack_require__(11);
var async_1 = __webpack_require__(30);
var Subscriber_1 = __webpack_require__(3);
var isNumeric_1 = __webpack_require__(174);
var isScheduler_1 = __webpack_require__(63);
function windowTime(windowTimeSpan) {
    var scheduler = async_1.async;
    var windowCreationInterval = null;
    var maxWindowSize = Number.POSITIVE_INFINITY;
    if (isScheduler_1.isScheduler(arguments[3])) {
        scheduler = arguments[3];
    }
    if (isScheduler_1.isScheduler(arguments[2])) {
        scheduler = arguments[2];
    }
    else if (isNumeric_1.isNumeric(arguments[2])) {
        maxWindowSize = arguments[2];
    }
    if (isScheduler_1.isScheduler(arguments[1])) {
        scheduler = arguments[1];
    }
    else if (isNumeric_1.isNumeric(arguments[1])) {
        windowCreationInterval = arguments[1];
    }
    return this.lift(new WindowTimeOperator(windowTimeSpan, windowCreationInterval, maxWindowSize, scheduler));
}
exports.windowTime = windowTime;
var WindowTimeOperator = (function () {
    function WindowTimeOperator(windowTimeSpan, windowCreationInterval, maxWindowSize, scheduler) {
        this.windowTimeSpan = windowTimeSpan;
        this.windowCreationInterval = windowCreationInterval;
        this.maxWindowSize = maxWindowSize;
        this.scheduler = scheduler;
    }
    WindowTimeOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new WindowTimeSubscriber(subscriber, this.windowTimeSpan, this.windowCreationInterval, this.maxWindowSize, this.scheduler));
    };
    return WindowTimeOperator;
}());
var CountedSubject = (function (_super) {
    __extends(CountedSubject, _super);
    function CountedSubject() {
        _super.apply(this, arguments);
        this._numberOfNextedValues = 0;
    }
    CountedSubject.prototype.next = function (value) {
        this._numberOfNextedValues++;
        _super.prototype.next.call(this, value);
    };
    Object.defineProperty(CountedSubject.prototype, "numberOfNextedValues", {
        get: function () {
            return this._numberOfNextedValues;
        },
        enumerable: true,
        configurable: true
    });
    return CountedSubject;
}(Subject_1.Subject));
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var WindowTimeSubscriber = (function (_super) {
    __extends(WindowTimeSubscriber, _super);
    function WindowTimeSubscriber(destination, windowTimeSpan, windowCreationInterval, maxWindowSize, scheduler) {
        _super.call(this, destination);
        this.destination = destination;
        this.windowTimeSpan = windowTimeSpan;
        this.windowCreationInterval = windowCreationInterval;
        this.maxWindowSize = maxWindowSize;
        this.scheduler = scheduler;
        this.windows = [];
        var window = this.openWindow();
        if (windowCreationInterval !== null && windowCreationInterval >= 0) {
            var closeState = { subscriber: this, window: window, context: null };
            var creationState = { windowTimeSpan: windowTimeSpan, windowCreationInterval: windowCreationInterval, subscriber: this, scheduler: scheduler };
            this.add(scheduler.schedule(dispatchWindowClose, windowTimeSpan, closeState));
            this.add(scheduler.schedule(dispatchWindowCreation, windowCreationInterval, creationState));
        }
        else {
            var timeSpanOnlyState = { subscriber: this, window: window, windowTimeSpan: windowTimeSpan };
            this.add(scheduler.schedule(dispatchWindowTimeSpanOnly, windowTimeSpan, timeSpanOnlyState));
        }
    }
    WindowTimeSubscriber.prototype._next = function (value) {
        var windows = this.windows;
        var len = windows.length;
        for (var i = 0; i < len; i++) {
            var window_1 = windows[i];
            if (!window_1.closed) {
                window_1.next(value);
                if (window_1.numberOfNextedValues >= this.maxWindowSize) {
                    this.closeWindow(window_1);
                }
            }
        }
    };
    WindowTimeSubscriber.prototype._error = function (err) {
        var windows = this.windows;
        while (windows.length > 0) {
            windows.shift().error(err);
        }
        this.destination.error(err);
    };
    WindowTimeSubscriber.prototype._complete = function () {
        var windows = this.windows;
        while (windows.length > 0) {
            var window_2 = windows.shift();
            if (!window_2.closed) {
                window_2.complete();
            }
        }
        this.destination.complete();
    };
    WindowTimeSubscriber.prototype.openWindow = function () {
        var window = new CountedSubject();
        this.windows.push(window);
        var destination = this.destination;
        destination.next(window);
        return window;
    };
    WindowTimeSubscriber.prototype.closeWindow = function (window) {
        window.complete();
        var windows = this.windows;
        windows.splice(windows.indexOf(window), 1);
    };
    return WindowTimeSubscriber;
}(Subscriber_1.Subscriber));
function dispatchWindowTimeSpanOnly(state) {
    var subscriber = state.subscriber, windowTimeSpan = state.windowTimeSpan, window = state.window;
    if (window) {
        subscriber.closeWindow(window);
    }
    state.window = subscriber.openWindow();
    this.schedule(state, windowTimeSpan);
}
function dispatchWindowCreation(state) {
    var windowTimeSpan = state.windowTimeSpan, subscriber = state.subscriber, scheduler = state.scheduler, windowCreationInterval = state.windowCreationInterval;
    var window = subscriber.openWindow();
    var action = this;
    var context = { action: action, subscription: null };
    var timeSpanState = { subscriber: subscriber, window: window, context: context };
    context.subscription = scheduler.schedule(dispatchWindowClose, windowTimeSpan, timeSpanState);
    action.add(context.subscription);
    action.schedule(state, windowCreationInterval);
}
function dispatchWindowClose(state) {
    var subscriber = state.subscriber, window = state.window, context = state.context;
    if (context && context.action && context.subscription) {
        context.action.remove(context.subscription);
    }
    subscriber.closeWindow(window);
}
//# sourceMappingURL=windowTime.js.map

/***/ }),
/* 1327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subject_1 = __webpack_require__(11);
var Subscription_1 = __webpack_require__(18);
var tryCatch_1 = __webpack_require__(25);
var errorObject_1 = __webpack_require__(22);
var OuterSubscriber_1 = __webpack_require__(6);
var subscribeToResult_1 = __webpack_require__(7);
/**
 * Branch out the source Observable values as a nested Observable starting from
 * an emission from `openings` and ending when the output of `closingSelector`
 * emits.
 *
 * <span class="informal">It's like {@link bufferToggle}, but emits a nested
 * Observable instead of an array.</span>
 *
 * <img src="./img/windowToggle.png" width="100%">
 *
 * Returns an Observable that emits windows of items it collects from the source
 * Observable. The output Observable emits windows that contain those items
 * emitted by the source Observable between the time when the `openings`
 * Observable emits an item and when the Observable returned by
 * `closingSelector` emits an item.
 *
 * @example <caption>Every other second, emit the click events from the next 500ms</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var openings = Rx.Observable.interval(1000);
 * var result = clicks.windowToggle(openings, i =>
 *   i % 2 ? Rx.Observable.interval(500) : Rx.Observable.empty()
 * ).mergeAll();
 * result.subscribe(x => console.log(x));
 *
 * @see {@link window}
 * @see {@link windowCount}
 * @see {@link windowTime}
 * @see {@link windowWhen}
 * @see {@link bufferToggle}
 *
 * @param {Observable<O>} openings An observable of notifications to start new
 * windows.
 * @param {function(value: O): Observable} closingSelector A function that takes
 * the value emitted by the `openings` observable and returns an Observable,
 * which, when it emits (either `next` or `complete`), signals that the
 * associated window should complete.
 * @return {Observable<Observable<T>>} An observable of windows, which in turn
 * are Observables.
 * @method windowToggle
 * @owner Observable
 */
function windowToggle(openings, closingSelector) {
    return this.lift(new WindowToggleOperator(openings, closingSelector));
}
exports.windowToggle = windowToggle;
var WindowToggleOperator = (function () {
    function WindowToggleOperator(openings, closingSelector) {
        this.openings = openings;
        this.closingSelector = closingSelector;
    }
    WindowToggleOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new WindowToggleSubscriber(subscriber, this.openings, this.closingSelector));
    };
    return WindowToggleOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var WindowToggleSubscriber = (function (_super) {
    __extends(WindowToggleSubscriber, _super);
    function WindowToggleSubscriber(destination, openings, closingSelector) {
        _super.call(this, destination);
        this.openings = openings;
        this.closingSelector = closingSelector;
        this.contexts = [];
        this.add(this.openSubscription = subscribeToResult_1.subscribeToResult(this, openings, openings));
    }
    WindowToggleSubscriber.prototype._next = function (value) {
        var contexts = this.contexts;
        if (contexts) {
            var len = contexts.length;
            for (var i = 0; i < len; i++) {
                contexts[i].window.next(value);
            }
        }
    };
    WindowToggleSubscriber.prototype._error = function (err) {
        var contexts = this.contexts;
        this.contexts = null;
        if (contexts) {
            var len = contexts.length;
            var index = -1;
            while (++index < len) {
                var context = contexts[index];
                context.window.error(err);
                context.subscription.unsubscribe();
            }
        }
        _super.prototype._error.call(this, err);
    };
    WindowToggleSubscriber.prototype._complete = function () {
        var contexts = this.contexts;
        this.contexts = null;
        if (contexts) {
            var len = contexts.length;
            var index = -1;
            while (++index < len) {
                var context = contexts[index];
                context.window.complete();
                context.subscription.unsubscribe();
            }
        }
        _super.prototype._complete.call(this);
    };
    WindowToggleSubscriber.prototype._unsubscribe = function () {
        var contexts = this.contexts;
        this.contexts = null;
        if (contexts) {
            var len = contexts.length;
            var index = -1;
            while (++index < len) {
                var context = contexts[index];
                context.window.unsubscribe();
                context.subscription.unsubscribe();
            }
        }
    };
    WindowToggleSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        if (outerValue === this.openings) {
            var closingSelector = this.closingSelector;
            var closingNotifier = tryCatch_1.tryCatch(closingSelector)(innerValue);
            if (closingNotifier === errorObject_1.errorObject) {
                return this.error(errorObject_1.errorObject.e);
            }
            else {
                var window_1 = new Subject_1.Subject();
                var subscription = new Subscription_1.Subscription();
                var context = { window: window_1, subscription: subscription };
                this.contexts.push(context);
                var innerSubscription = subscribeToResult_1.subscribeToResult(this, closingNotifier, context);
                if (innerSubscription.closed) {
                    this.closeWindow(this.contexts.length - 1);
                }
                else {
                    innerSubscription.context = context;
                    subscription.add(innerSubscription);
                }
                this.destination.next(window_1);
            }
        }
        else {
            this.closeWindow(this.contexts.indexOf(outerValue));
        }
    };
    WindowToggleSubscriber.prototype.notifyError = function (err) {
        this.error(err);
    };
    WindowToggleSubscriber.prototype.notifyComplete = function (inner) {
        if (inner !== this.openSubscription) {
            this.closeWindow(this.contexts.indexOf(inner.context));
        }
    };
    WindowToggleSubscriber.prototype.closeWindow = function (index) {
        if (index === -1) {
            return;
        }
        var contexts = this.contexts;
        var context = contexts[index];
        var window = context.window, subscription = context.subscription;
        contexts.splice(index, 1);
        window.complete();
        subscription.unsubscribe();
    };
    return WindowToggleSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
//# sourceMappingURL=windowToggle.js.map

/***/ }),
/* 1328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subject_1 = __webpack_require__(11);
var tryCatch_1 = __webpack_require__(25);
var errorObject_1 = __webpack_require__(22);
var OuterSubscriber_1 = __webpack_require__(6);
var subscribeToResult_1 = __webpack_require__(7);
/**
 * Branch out the source Observable values as a nested Observable using a
 * factory function of closing Observables to determine when to start a new
 * window.
 *
 * <span class="informal">It's like {@link bufferWhen}, but emits a nested
 * Observable instead of an array.</span>
 *
 * <img src="./img/windowWhen.png" width="100%">
 *
 * Returns an Observable that emits windows of items it collects from the source
 * Observable. The output Observable emits connected, non-overlapping windows.
 * It emits the current window and opens a new one whenever the Observable
 * produced by the specified `closingSelector` function emits an item. The first
 * window is opened immediately when subscribing to the output Observable.
 *
 * @example <caption>Emit only the first two clicks events in every window of [1-5] random seconds</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks
 *   .windowWhen(() => Rx.Observable.interval(1000 + Math.random() * 4000))
 *   .map(win => win.take(2)) // each window has at most 2 emissions
 *   .mergeAll(); // flatten the Observable-of-Observables
 * result.subscribe(x => console.log(x));
 *
 * @see {@link window}
 * @see {@link windowCount}
 * @see {@link windowTime}
 * @see {@link windowToggle}
 * @see {@link bufferWhen}
 *
 * @param {function(): Observable} closingSelector A function that takes no
 * arguments and returns an Observable that signals (on either `next` or
 * `complete`) when to close the previous window and start a new one.
 * @return {Observable<Observable<T>>} An observable of windows, which in turn
 * are Observables.
 * @method windowWhen
 * @owner Observable
 */
function windowWhen(closingSelector) {
    return this.lift(new WindowOperator(closingSelector));
}
exports.windowWhen = windowWhen;
var WindowOperator = (function () {
    function WindowOperator(closingSelector) {
        this.closingSelector = closingSelector;
    }
    WindowOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new WindowSubscriber(subscriber, this.closingSelector));
    };
    return WindowOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var WindowSubscriber = (function (_super) {
    __extends(WindowSubscriber, _super);
    function WindowSubscriber(destination, closingSelector) {
        _super.call(this, destination);
        this.destination = destination;
        this.closingSelector = closingSelector;
        this.openWindow();
    }
    WindowSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.openWindow(innerSub);
    };
    WindowSubscriber.prototype.notifyError = function (error, innerSub) {
        this._error(error);
    };
    WindowSubscriber.prototype.notifyComplete = function (innerSub) {
        this.openWindow(innerSub);
    };
    WindowSubscriber.prototype._next = function (value) {
        this.window.next(value);
    };
    WindowSubscriber.prototype._error = function (err) {
        this.window.error(err);
        this.destination.error(err);
        this.unsubscribeClosingNotification();
    };
    WindowSubscriber.prototype._complete = function () {
        this.window.complete();
        this.destination.complete();
        this.unsubscribeClosingNotification();
    };
    WindowSubscriber.prototype.unsubscribeClosingNotification = function () {
        if (this.closingNotification) {
            this.closingNotification.unsubscribe();
        }
    };
    WindowSubscriber.prototype.openWindow = function (innerSub) {
        if (innerSub === void 0) { innerSub = null; }
        if (innerSub) {
            this.remove(innerSub);
            innerSub.unsubscribe();
        }
        var prevWindow = this.window;
        if (prevWindow) {
            prevWindow.complete();
        }
        var window = this.window = new Subject_1.Subject();
        this.destination.next(window);
        var closingNotifier = tryCatch_1.tryCatch(this.closingSelector)();
        if (closingNotifier === errorObject_1.errorObject) {
            var err = errorObject_1.errorObject.e;
            this.destination.error(err);
            this.window.error(err);
        }
        else {
            this.add(this.closingNotification = subscribeToResult_1.subscribeToResult(this, closingNotifier));
        }
    };
    return WindowSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
//# sourceMappingURL=windowWhen.js.map

/***/ }),
/* 1329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var OuterSubscriber_1 = __webpack_require__(6);
var subscribeToResult_1 = __webpack_require__(7);
/* tslint:enable:max-line-length */
/**
 * Combines the source Observable with other Observables to create an Observable
 * whose values are calculated from the latest values of each, only when the
 * source emits.
 *
 * <span class="informal">Whenever the source Observable emits a value, it
 * computes a formula using that value plus the latest values from other input
 * Observables, then emits the output of that formula.</span>
 *
 * <img src="./img/withLatestFrom.png" width="100%">
 *
 * `withLatestFrom` combines each value from the source Observable (the
 * instance) with the latest values from the other input Observables only when
 * the source emits a value, optionally using a `project` function to determine
 * the value to be emitted on the output Observable. All input Observables must
 * emit at least one value before the output Observable will emit a value.
 *
 * @example <caption>On every click event, emit an array with the latest timer event plus the click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var timer = Rx.Observable.interval(1000);
 * var result = clicks.withLatestFrom(timer);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link combineLatest}
 *
 * @param {ObservableInput} other An input Observable to combine with the source
 * Observable. More than one input Observables may be given as argument.
 * @param {Function} [project] Projection function for combining values
 * together. Receives all values in order of the Observables passed, where the
 * first parameter is a value from the source Observable. (e.g.
 * `a.withLatestFrom(b, c, (a1, b1, c1) => a1 + b1 + c1)`). If this is not
 * passed, arrays will be emitted on the output Observable.
 * @return {Observable} An Observable of projected values from the most recent
 * values from each input Observable, or an array of the most recent values from
 * each input Observable.
 * @method withLatestFrom
 * @owner Observable
 */
function withLatestFrom() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i - 0] = arguments[_i];
    }
    var project;
    if (typeof args[args.length - 1] === 'function') {
        project = args.pop();
    }
    var observables = args;
    return this.lift(new WithLatestFromOperator(observables, project));
}
exports.withLatestFrom = withLatestFrom;
var WithLatestFromOperator = (function () {
    function WithLatestFromOperator(observables, project) {
        this.observables = observables;
        this.project = project;
    }
    WithLatestFromOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new WithLatestFromSubscriber(subscriber, this.observables, this.project));
    };
    return WithLatestFromOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var WithLatestFromSubscriber = (function (_super) {
    __extends(WithLatestFromSubscriber, _super);
    function WithLatestFromSubscriber(destination, observables, project) {
        _super.call(this, destination);
        this.observables = observables;
        this.project = project;
        this.toRespond = [];
        var len = observables.length;
        this.values = new Array(len);
        for (var i = 0; i < len; i++) {
            this.toRespond.push(i);
        }
        for (var i = 0; i < len; i++) {
            var observable = observables[i];
            this.add(subscribeToResult_1.subscribeToResult(this, observable, observable, i));
        }
    }
    WithLatestFromSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.values[outerIndex] = innerValue;
        var toRespond = this.toRespond;
        if (toRespond.length > 0) {
            var found = toRespond.indexOf(outerIndex);
            if (found !== -1) {
                toRespond.splice(found, 1);
            }
        }
    };
    WithLatestFromSubscriber.prototype.notifyComplete = function () {
        // noop
    };
    WithLatestFromSubscriber.prototype._next = function (value) {
        if (this.toRespond.length === 0) {
            var args = [value].concat(this.values);
            if (this.project) {
                this._tryProject(args);
            }
            else {
                this.destination.next(args);
            }
        }
    };
    WithLatestFromSubscriber.prototype._tryProject = function (args) {
        var result;
        try {
            result = this.project.apply(this, args);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return WithLatestFromSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
//# sourceMappingURL=withLatestFrom.js.map

/***/ }),
/* 1330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var zip_1 = __webpack_require__(278);
/**
 * @param project
 * @return {Observable<R>|WebSocketSubject<T>|Observable<T>}
 * @method zipAll
 * @owner Observable
 */
function zipAll(project) {
    return this.lift(new zip_1.ZipOperator(project));
}
exports.zipAll = zipAll;
//# sourceMappingURL=zipAll.js.map

/***/ }),
/* 1331 */,
/* 1332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var AsyncAction_1 = __webpack_require__(128);
var AnimationFrame_1 = __webpack_require__(1342);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var AnimationFrameAction = (function (_super) {
    __extends(AnimationFrameAction, _super);
    function AnimationFrameAction(scheduler, work) {
        _super.call(this, scheduler, work);
        this.scheduler = scheduler;
        this.work = work;
    }
    AnimationFrameAction.prototype.requestAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) { delay = 0; }
        // If delay is greater than 0, request as an async action.
        if (delay !== null && delay > 0) {
            return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
        }
        // Push the action to the end of the scheduler queue.
        scheduler.actions.push(this);
        // If an animation frame has already been requested, don't request another
        // one. If an animation frame hasn't been requested yet, request one. Return
        // the current animation frame request id.
        return scheduler.scheduled || (scheduler.scheduled = AnimationFrame_1.AnimationFrame.requestAnimationFrame(scheduler.flush.bind(scheduler, null)));
    };
    AnimationFrameAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) { delay = 0; }
        // If delay exists and is greater than 0, or if the delay is null (the
        // action wasn't rescheduled) but was originally scheduled as an async
        // action, then recycle as an async action.
        if ((delay !== null && delay > 0) || (delay === null && this.delay > 0)) {
            return _super.prototype.recycleAsyncId.call(this, scheduler, id, delay);
        }
        // If the scheduler queue is empty, cancel the requested animation frame and
        // set the scheduled flag to undefined so the next AnimationFrameAction will
        // request its own.
        if (scheduler.actions.length === 0) {
            AnimationFrame_1.AnimationFrame.cancelAnimationFrame(id);
            scheduler.scheduled = undefined;
        }
        // Return undefined so the action knows to request a new async id if it's rescheduled.
        return undefined;
    };
    return AnimationFrameAction;
}(AsyncAction_1.AsyncAction));
exports.AnimationFrameAction = AnimationFrameAction;
//# sourceMappingURL=AnimationFrameAction.js.map

/***/ }),
/* 1333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var AsyncScheduler_1 = __webpack_require__(129);
var AnimationFrameScheduler = (function (_super) {
    __extends(AnimationFrameScheduler, _super);
    function AnimationFrameScheduler() {
        _super.apply(this, arguments);
    }
    AnimationFrameScheduler.prototype.flush = function (action) {
        this.active = true;
        this.scheduled = undefined;
        var actions = this.actions;
        var error;
        var index = -1;
        var count = actions.length;
        action = action || actions.shift();
        do {
            if (error = action.execute(action.state, action.delay)) {
                break;
            }
        } while (++index < count && (action = actions.shift()));
        this.active = false;
        if (error) {
            while (++index < count && (action = actions.shift())) {
                action.unsubscribe();
            }
            throw error;
        }
    };
    return AnimationFrameScheduler;
}(AsyncScheduler_1.AsyncScheduler));
exports.AnimationFrameScheduler = AnimationFrameScheduler;
//# sourceMappingURL=AnimationFrameScheduler.js.map

/***/ }),
/* 1334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Immediate_1 = __webpack_require__(1344);
var AsyncAction_1 = __webpack_require__(128);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var AsapAction = (function (_super) {
    __extends(AsapAction, _super);
    function AsapAction(scheduler, work) {
        _super.call(this, scheduler, work);
        this.scheduler = scheduler;
        this.work = work;
    }
    AsapAction.prototype.requestAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) { delay = 0; }
        // If delay is greater than 0, request as an async action.
        if (delay !== null && delay > 0) {
            return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
        }
        // Push the action to the end of the scheduler queue.
        scheduler.actions.push(this);
        // If a microtask has already been scheduled, don't schedule another
        // one. If a microtask hasn't been scheduled yet, schedule one now. Return
        // the current scheduled microtask id.
        return scheduler.scheduled || (scheduler.scheduled = Immediate_1.Immediate.setImmediate(scheduler.flush.bind(scheduler, null)));
    };
    AsapAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) { delay = 0; }
        // If delay exists and is greater than 0, or if the delay is null (the
        // action wasn't rescheduled) but was originally scheduled as an async
        // action, then recycle as an async action.
        if ((delay !== null && delay > 0) || (delay === null && this.delay > 0)) {
            return _super.prototype.recycleAsyncId.call(this, scheduler, id, delay);
        }
        // If the scheduler queue is empty, cancel the requested microtask and
        // set the scheduled flag to undefined so the next AsapAction will schedule
        // its own.
        if (scheduler.actions.length === 0) {
            Immediate_1.Immediate.clearImmediate(id);
            scheduler.scheduled = undefined;
        }
        // Return undefined so the action knows to request a new async id if it's rescheduled.
        return undefined;
    };
    return AsapAction;
}(AsyncAction_1.AsyncAction));
exports.AsapAction = AsapAction;
//# sourceMappingURL=AsapAction.js.map

/***/ }),
/* 1335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var AsyncScheduler_1 = __webpack_require__(129);
var AsapScheduler = (function (_super) {
    __extends(AsapScheduler, _super);
    function AsapScheduler() {
        _super.apply(this, arguments);
    }
    AsapScheduler.prototype.flush = function (action) {
        this.active = true;
        this.scheduled = undefined;
        var actions = this.actions;
        var error;
        var index = -1;
        var count = actions.length;
        action = action || actions.shift();
        do {
            if (error = action.execute(action.state, action.delay)) {
                break;
            }
        } while (++index < count && (action = actions.shift()));
        this.active = false;
        if (error) {
            while (++index < count && (action = actions.shift())) {
                action.unsubscribe();
            }
            throw error;
        }
    };
    return AsapScheduler;
}(AsyncScheduler_1.AsyncScheduler));
exports.AsapScheduler = AsapScheduler;
//# sourceMappingURL=AsapScheduler.js.map

/***/ }),
/* 1336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var AsyncAction_1 = __webpack_require__(128);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var QueueAction = (function (_super) {
    __extends(QueueAction, _super);
    function QueueAction(scheduler, work) {
        _super.call(this, scheduler, work);
        this.scheduler = scheduler;
        this.work = work;
    }
    QueueAction.prototype.schedule = function (state, delay) {
        if (delay === void 0) { delay = 0; }
        if (delay > 0) {
            return _super.prototype.schedule.call(this, state, delay);
        }
        this.delay = delay;
        this.state = state;
        this.scheduler.flush(this);
        return this;
    };
    QueueAction.prototype.execute = function (state, delay) {
        return (delay > 0 || this.closed) ?
            _super.prototype.execute.call(this, state, delay) :
            this._execute(state, delay);
    };
    QueueAction.prototype.requestAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) { delay = 0; }
        // If delay exists and is greater than 0, or if the delay is null (the
        // action wasn't rescheduled) but was originally scheduled as an async
        // action, then recycle as an async action.
        if ((delay !== null && delay > 0) || (delay === null && this.delay > 0)) {
            return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
        }
        // Otherwise flush the scheduler starting with this action.
        return scheduler.flush(this);
    };
    return QueueAction;
}(AsyncAction_1.AsyncAction));
exports.QueueAction = QueueAction;
//# sourceMappingURL=QueueAction.js.map

/***/ }),
/* 1337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var AsyncScheduler_1 = __webpack_require__(129);
var QueueScheduler = (function (_super) {
    __extends(QueueScheduler, _super);
    function QueueScheduler() {
        _super.apply(this, arguments);
    }
    return QueueScheduler;
}(AsyncScheduler_1.AsyncScheduler));
exports.QueueScheduler = QueueScheduler;
//# sourceMappingURL=QueueScheduler.js.map

/***/ }),
/* 1338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var AnimationFrameAction_1 = __webpack_require__(1332);
var AnimationFrameScheduler_1 = __webpack_require__(1333);
/**
 *
 * Animation Frame Scheduler
 *
 * <span class="informal">Perform task when `window.requestAnimationFrame` would fire</span>
 *
 * When `animationFrame` scheduler is used with delay, it will fall back to {@link async} scheduler
 * behaviour.
 *
 * Without delay, `animationFrame` scheduler can be used to create smooth browser animations.
 * It makes sure scheduled task will happen just before next browser content repaint,
 * thus performing animations as efficiently as possible.
 *
 * @example <caption>Schedule div height animation</caption>
 * const div = document.querySelector('.some-div');
 *
 * Rx.Scheduler.schedule(function(height) {
 *   div.style.height = height + "px";
 *
 *   this.schedule(height + 1);  // `this` references currently executing Action,
 *                               // which we reschedule with new state
 * }, 0, 0);
 *
 * // You will see .some-div element growing in height
 *
 *
 * @static true
 * @name animationFrame
 * @owner Scheduler
 */
exports.animationFrame = new AnimationFrameScheduler_1.AnimationFrameScheduler(AnimationFrameAction_1.AnimationFrameAction);
//# sourceMappingURL=animationFrame.js.map

/***/ }),
/* 1339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Observable_1 = __webpack_require__(0);
var Subscription_1 = __webpack_require__(18);
var SubscriptionLoggable_1 = __webpack_require__(495);
var applyMixins_1 = __webpack_require__(498);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var ColdObservable = (function (_super) {
    __extends(ColdObservable, _super);
    function ColdObservable(messages, scheduler) {
        _super.call(this, function (subscriber) {
            var observable = this;
            var index = observable.logSubscribedFrame();
            subscriber.add(new Subscription_1.Subscription(function () {
                observable.logUnsubscribedFrame(index);
            }));
            observable.scheduleMessages(subscriber);
            return subscriber;
        });
        this.messages = messages;
        this.subscriptions = [];
        this.scheduler = scheduler;
    }
    ColdObservable.prototype.scheduleMessages = function (subscriber) {
        var messagesLength = this.messages.length;
        for (var i = 0; i < messagesLength; i++) {
            var message = this.messages[i];
            subscriber.add(this.scheduler.schedule(function (_a) {
                var message = _a.message, subscriber = _a.subscriber;
                message.notification.observe(subscriber);
            }, message.frame, { message: message, subscriber: subscriber }));
        }
    };
    return ColdObservable;
}(Observable_1.Observable));
exports.ColdObservable = ColdObservable;
applyMixins_1.applyMixins(ColdObservable, [SubscriptionLoggable_1.SubscriptionLoggable]);
//# sourceMappingURL=ColdObservable.js.map

/***/ }),
/* 1340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subject_1 = __webpack_require__(11);
var Subscription_1 = __webpack_require__(18);
var SubscriptionLoggable_1 = __webpack_require__(495);
var applyMixins_1 = __webpack_require__(498);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var HotObservable = (function (_super) {
    __extends(HotObservable, _super);
    function HotObservable(messages, scheduler) {
        _super.call(this);
        this.messages = messages;
        this.subscriptions = [];
        this.scheduler = scheduler;
    }
    HotObservable.prototype._subscribe = function (subscriber) {
        var subject = this;
        var index = subject.logSubscribedFrame();
        subscriber.add(new Subscription_1.Subscription(function () {
            subject.logUnsubscribedFrame(index);
        }));
        return _super.prototype._subscribe.call(this, subscriber);
    };
    HotObservable.prototype.setup = function () {
        var subject = this;
        var messagesLength = subject.messages.length;
        /* tslint:disable:no-var-keyword */
        for (var i = 0; i < messagesLength; i++) {
            (function () {
                var message = subject.messages[i];
                /* tslint:enable */
                subject.scheduler.schedule(function () { message.notification.observe(subject); }, message.frame);
            })();
        }
    };
    return HotObservable;
}(Subject_1.Subject));
exports.HotObservable = HotObservable;
applyMixins_1.applyMixins(HotObservable, [SubscriptionLoggable_1.SubscriptionLoggable]);
//# sourceMappingURL=HotObservable.js.map

/***/ }),
/* 1341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Observable_1 = __webpack_require__(0);
var Notification_1 = __webpack_require__(125);
var ColdObservable_1 = __webpack_require__(1339);
var HotObservable_1 = __webpack_require__(1340);
var SubscriptionLog_1 = __webpack_require__(494);
var VirtualTimeScheduler_1 = __webpack_require__(491);
var defaultMaxFrame = 750;
var TestScheduler = (function (_super) {
    __extends(TestScheduler, _super);
    function TestScheduler(assertDeepEqual) {
        _super.call(this, VirtualTimeScheduler_1.VirtualAction, defaultMaxFrame);
        this.assertDeepEqual = assertDeepEqual;
        this.hotObservables = [];
        this.coldObservables = [];
        this.flushTests = [];
    }
    TestScheduler.prototype.createTime = function (marbles) {
        var indexOf = marbles.indexOf('|');
        if (indexOf === -1) {
            throw new Error('marble diagram for time should have a completion marker "|"');
        }
        return indexOf * TestScheduler.frameTimeFactor;
    };
    TestScheduler.prototype.createColdObservable = function (marbles, values, error) {
        if (marbles.indexOf('^') !== -1) {
            throw new Error('cold observable cannot have subscription offset "^"');
        }
        if (marbles.indexOf('!') !== -1) {
            throw new Error('cold observable cannot have unsubscription marker "!"');
        }
        var messages = TestScheduler.parseMarbles(marbles, values, error);
        var cold = new ColdObservable_1.ColdObservable(messages, this);
        this.coldObservables.push(cold);
        return cold;
    };
    TestScheduler.prototype.createHotObservable = function (marbles, values, error) {
        if (marbles.indexOf('!') !== -1) {
            throw new Error('hot observable cannot have unsubscription marker "!"');
        }
        var messages = TestScheduler.parseMarbles(marbles, values, error);
        var subject = new HotObservable_1.HotObservable(messages, this);
        this.hotObservables.push(subject);
        return subject;
    };
    TestScheduler.prototype.materializeInnerObservable = function (observable, outerFrame) {
        var _this = this;
        var messages = [];
        observable.subscribe(function (value) {
            messages.push({ frame: _this.frame - outerFrame, notification: Notification_1.Notification.createNext(value) });
        }, function (err) {
            messages.push({ frame: _this.frame - outerFrame, notification: Notification_1.Notification.createError(err) });
        }, function () {
            messages.push({ frame: _this.frame - outerFrame, notification: Notification_1.Notification.createComplete() });
        });
        return messages;
    };
    TestScheduler.prototype.expectObservable = function (observable, unsubscriptionMarbles) {
        var _this = this;
        if (unsubscriptionMarbles === void 0) { unsubscriptionMarbles = null; }
        var actual = [];
        var flushTest = { actual: actual, ready: false };
        var unsubscriptionFrame = TestScheduler
            .parseMarblesAsSubscriptions(unsubscriptionMarbles).unsubscribedFrame;
        var subscription;
        this.schedule(function () {
            subscription = observable.subscribe(function (x) {
                var value = x;
                // Support Observable-of-Observables
                if (x instanceof Observable_1.Observable) {
                    value = _this.materializeInnerObservable(value, _this.frame);
                }
                actual.push({ frame: _this.frame, notification: Notification_1.Notification.createNext(value) });
            }, function (err) {
                actual.push({ frame: _this.frame, notification: Notification_1.Notification.createError(err) });
            }, function () {
                actual.push({ frame: _this.frame, notification: Notification_1.Notification.createComplete() });
            });
        }, 0);
        if (unsubscriptionFrame !== Number.POSITIVE_INFINITY) {
            this.schedule(function () { return subscription.unsubscribe(); }, unsubscriptionFrame);
        }
        this.flushTests.push(flushTest);
        return {
            toBe: function (marbles, values, errorValue) {
                flushTest.ready = true;
                flushTest.expected = TestScheduler.parseMarbles(marbles, values, errorValue, true);
            }
        };
    };
    TestScheduler.prototype.expectSubscriptions = function (actualSubscriptionLogs) {
        var flushTest = { actual: actualSubscriptionLogs, ready: false };
        this.flushTests.push(flushTest);
        return {
            toBe: function (marbles) {
                var marblesArray = (typeof marbles === 'string') ? [marbles] : marbles;
                flushTest.ready = true;
                flushTest.expected = marblesArray.map(function (marbles) {
                    return TestScheduler.parseMarblesAsSubscriptions(marbles);
                });
            }
        };
    };
    TestScheduler.prototype.flush = function () {
        var hotObservables = this.hotObservables;
        while (hotObservables.length > 0) {
            hotObservables.shift().setup();
        }
        _super.prototype.flush.call(this);
        var readyFlushTests = this.flushTests.filter(function (test) { return test.ready; });
        while (readyFlushTests.length > 0) {
            var test = readyFlushTests.shift();
            this.assertDeepEqual(test.actual, test.expected);
        }
    };
    TestScheduler.parseMarblesAsSubscriptions = function (marbles) {
        if (typeof marbles !== 'string') {
            return new SubscriptionLog_1.SubscriptionLog(Number.POSITIVE_INFINITY);
        }
        var len = marbles.length;
        var groupStart = -1;
        var subscriptionFrame = Number.POSITIVE_INFINITY;
        var unsubscriptionFrame = Number.POSITIVE_INFINITY;
        for (var i = 0; i < len; i++) {
            var frame = i * this.frameTimeFactor;
            var c = marbles[i];
            switch (c) {
                case '-':
                case ' ':
                    break;
                case '(':
                    groupStart = frame;
                    break;
                case ')':
                    groupStart = -1;
                    break;
                case '^':
                    if (subscriptionFrame !== Number.POSITIVE_INFINITY) {
                        throw new Error('found a second subscription point \'^\' in a ' +
                            'subscription marble diagram. There can only be one.');
                    }
                    subscriptionFrame = groupStart > -1 ? groupStart : frame;
                    break;
                case '!':
                    if (unsubscriptionFrame !== Number.POSITIVE_INFINITY) {
                        throw new Error('found a second subscription point \'^\' in a ' +
                            'subscription marble diagram. There can only be one.');
                    }
                    unsubscriptionFrame = groupStart > -1 ? groupStart : frame;
                    break;
                default:
                    throw new Error('there can only be \'^\' and \'!\' markers in a ' +
                        'subscription marble diagram. Found instead \'' + c + '\'.');
            }
        }
        if (unsubscriptionFrame < 0) {
            return new SubscriptionLog_1.SubscriptionLog(subscriptionFrame);
        }
        else {
            return new SubscriptionLog_1.SubscriptionLog(subscriptionFrame, unsubscriptionFrame);
        }
    };
    TestScheduler.parseMarbles = function (marbles, values, errorValue, materializeInnerObservables) {
        if (materializeInnerObservables === void 0) { materializeInnerObservables = false; }
        if (marbles.indexOf('!') !== -1) {
            throw new Error('conventional marble diagrams cannot have the ' +
                'unsubscription marker "!"');
        }
        var len = marbles.length;
        var testMessages = [];
        var subIndex = marbles.indexOf('^');
        var frameOffset = subIndex === -1 ? 0 : (subIndex * -this.frameTimeFactor);
        var getValue = typeof values !== 'object' ?
            function (x) { return x; } :
            function (x) {
                // Support Observable-of-Observables
                if (materializeInnerObservables && values[x] instanceof ColdObservable_1.ColdObservable) {
                    return values[x].messages;
                }
                return values[x];
            };
        var groupStart = -1;
        for (var i = 0; i < len; i++) {
            var frame = i * this.frameTimeFactor + frameOffset;
            var notification = void 0;
            var c = marbles[i];
            switch (c) {
                case '-':
                case ' ':
                    break;
                case '(':
                    groupStart = frame;
                    break;
                case ')':
                    groupStart = -1;
                    break;
                case '|':
                    notification = Notification_1.Notification.createComplete();
                    break;
                case '^':
                    break;
                case '#':
                    notification = Notification_1.Notification.createError(errorValue || 'error');
                    break;
                default:
                    notification = Notification_1.Notification.createNext(getValue(c));
                    break;
            }
            if (notification) {
                testMessages.push({ frame: groupStart > -1 ? groupStart : frame, notification: notification });
            }
        }
        return testMessages;
    };
    return TestScheduler;
}(VirtualTimeScheduler_1.VirtualTimeScheduler));
exports.TestScheduler = TestScheduler;
//# sourceMappingURL=TestScheduler.js.map

/***/ }),
/* 1342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var root_1 = __webpack_require__(24);
var RequestAnimationFrameDefinition = (function () {
    function RequestAnimationFrameDefinition(root) {
        if (root.requestAnimationFrame) {
            this.cancelAnimationFrame = root.cancelAnimationFrame.bind(root);
            this.requestAnimationFrame = root.requestAnimationFrame.bind(root);
        }
        else if (root.mozRequestAnimationFrame) {
            this.cancelAnimationFrame = root.mozCancelAnimationFrame.bind(root);
            this.requestAnimationFrame = root.mozRequestAnimationFrame.bind(root);
        }
        else if (root.webkitRequestAnimationFrame) {
            this.cancelAnimationFrame = root.webkitCancelAnimationFrame.bind(root);
            this.requestAnimationFrame = root.webkitRequestAnimationFrame.bind(root);
        }
        else if (root.msRequestAnimationFrame) {
            this.cancelAnimationFrame = root.msCancelAnimationFrame.bind(root);
            this.requestAnimationFrame = root.msRequestAnimationFrame.bind(root);
        }
        else if (root.oRequestAnimationFrame) {
            this.cancelAnimationFrame = root.oCancelAnimationFrame.bind(root);
            this.requestAnimationFrame = root.oRequestAnimationFrame.bind(root);
        }
        else {
            this.cancelAnimationFrame = root.clearTimeout.bind(root);
            this.requestAnimationFrame = function (cb) { return root.setTimeout(cb, 1000 / 60); };
        }
    }
    return RequestAnimationFrameDefinition;
}());
exports.RequestAnimationFrameDefinition = RequestAnimationFrameDefinition;
exports.AnimationFrame = new RequestAnimationFrameDefinition(root_1.root);
//# sourceMappingURL=AnimationFrame.js.map

/***/ }),
/* 1343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var FastMap = (function () {
    function FastMap() {
        this.values = {};
    }
    FastMap.prototype.delete = function (key) {
        this.values[key] = null;
        return true;
    };
    FastMap.prototype.set = function (key, value) {
        this.values[key] = value;
        return this;
    };
    FastMap.prototype.get = function (key) {
        return this.values[key];
    };
    FastMap.prototype.forEach = function (cb, thisArg) {
        var values = this.values;
        for (var key in values) {
            if (values.hasOwnProperty(key) && values[key] !== null) {
                cb.call(thisArg, values[key], key);
            }
        }
    };
    FastMap.prototype.clear = function () {
        this.values = {};
    };
    return FastMap;
}());
exports.FastMap = FastMap;
//# sourceMappingURL=FastMap.js.map

/***/ }),
/* 1344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(clearImmediate, setImmediate) {/**
Some credit for this helper goes to http://github.com/YuzuJS/setImmediate
*/

var root_1 = __webpack_require__(24);
var ImmediateDefinition = (function () {
    function ImmediateDefinition(root) {
        this.root = root;
        if (root.setImmediate && typeof root.setImmediate === 'function') {
            this.setImmediate = root.setImmediate.bind(root);
            this.clearImmediate = root.clearImmediate.bind(root);
        }
        else {
            this.nextHandle = 1;
            this.tasksByHandle = {};
            this.currentlyRunningATask = false;
            // Don't get fooled by e.g. browserify environments.
            if (this.canUseProcessNextTick()) {
                // For Node.js before 0.9
                this.setImmediate = this.createProcessNextTickSetImmediate();
            }
            else if (this.canUsePostMessage()) {
                // For non-IE10 modern browsers
                this.setImmediate = this.createPostMessageSetImmediate();
            }
            else if (this.canUseMessageChannel()) {
                // For web workers, where supported
                this.setImmediate = this.createMessageChannelSetImmediate();
            }
            else if (this.canUseReadyStateChange()) {
                // For IE 6–8
                this.setImmediate = this.createReadyStateChangeSetImmediate();
            }
            else {
                // For older browsers
                this.setImmediate = this.createSetTimeoutSetImmediate();
            }
            var ci = function clearImmediate(handle) {
                delete clearImmediate.instance.tasksByHandle[handle];
            };
            ci.instance = this;
            this.clearImmediate = ci;
        }
    }
    ImmediateDefinition.prototype.identify = function (o) {
        return this.root.Object.prototype.toString.call(o);
    };
    ImmediateDefinition.prototype.canUseProcessNextTick = function () {
        return this.identify(this.root.process) === '[object process]';
    };
    ImmediateDefinition.prototype.canUseMessageChannel = function () {
        return Boolean(this.root.MessageChannel);
    };
    ImmediateDefinition.prototype.canUseReadyStateChange = function () {
        var document = this.root.document;
        return Boolean(document && 'onreadystatechange' in document.createElement('script'));
    };
    ImmediateDefinition.prototype.canUsePostMessage = function () {
        var root = this.root;
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `root.postMessage` means something completely different and can't be used for this purpose.
        if (root.postMessage && !root.importScripts) {
            var postMessageIsAsynchronous_1 = true;
            var oldOnMessage = root.onmessage;
            root.onmessage = function () {
                postMessageIsAsynchronous_1 = false;
            };
            root.postMessage('', '*');
            root.onmessage = oldOnMessage;
            return postMessageIsAsynchronous_1;
        }
        return false;
    };
    // This function accepts the same arguments as setImmediate, but
    // returns a function that requires no arguments.
    ImmediateDefinition.prototype.partiallyApplied = function (handler) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var fn = function result() {
            var _a = result, handler = _a.handler, args = _a.args;
            if (typeof handler === 'function') {
                handler.apply(undefined, args);
            }
            else {
                (new Function('' + handler))();
            }
        };
        fn.handler = handler;
        fn.args = args;
        return fn;
    };
    ImmediateDefinition.prototype.addFromSetImmediateArguments = function (args) {
        this.tasksByHandle[this.nextHandle] = this.partiallyApplied.apply(undefined, args);
        return this.nextHandle++;
    };
    ImmediateDefinition.prototype.createProcessNextTickSetImmediate = function () {
        var fn = function setImmediate() {
            var instance = setImmediate.instance;
            var handle = instance.addFromSetImmediateArguments(arguments);
            instance.root.process.nextTick(instance.partiallyApplied(instance.runIfPresent, handle));
            return handle;
        };
        fn.instance = this;
        return fn;
    };
    ImmediateDefinition.prototype.createPostMessageSetImmediate = function () {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
        var root = this.root;
        var messagePrefix = 'setImmediate$' + root.Math.random() + '$';
        var onGlobalMessage = function globalMessageHandler(event) {
            var instance = globalMessageHandler.instance;
            if (event.source === root &&
                typeof event.data === 'string' &&
                event.data.indexOf(messagePrefix) === 0) {
                instance.runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };
        onGlobalMessage.instance = this;
        root.addEventListener('message', onGlobalMessage, false);
        var fn = function setImmediate() {
            var _a = setImmediate, messagePrefix = _a.messagePrefix, instance = _a.instance;
            var handle = instance.addFromSetImmediateArguments(arguments);
            instance.root.postMessage(messagePrefix + handle, '*');
            return handle;
        };
        fn.instance = this;
        fn.messagePrefix = messagePrefix;
        return fn;
    };
    ImmediateDefinition.prototype.runIfPresent = function (handle) {
        // From the spec: 'Wait until any invocations of this algorithm started before this one have completed.'
        // So if we're currently running a task, we'll need to delay this invocation.
        if (this.currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // 'too much recursion' error.
            this.root.setTimeout(this.partiallyApplied(this.runIfPresent, handle), 0);
        }
        else {
            var task = this.tasksByHandle[handle];
            if (task) {
                this.currentlyRunningATask = true;
                try {
                    task();
                }
                finally {
                    this.clearImmediate(handle);
                    this.currentlyRunningATask = false;
                }
            }
        }
    };
    ImmediateDefinition.prototype.createMessageChannelSetImmediate = function () {
        var _this = this;
        var channel = new this.root.MessageChannel();
        channel.port1.onmessage = function (event) {
            var handle = event.data;
            _this.runIfPresent(handle);
        };
        var fn = function setImmediate() {
            var _a = setImmediate, channel = _a.channel, instance = _a.instance;
            var handle = instance.addFromSetImmediateArguments(arguments);
            channel.port2.postMessage(handle);
            return handle;
        };
        fn.channel = channel;
        fn.instance = this;
        return fn;
    };
    ImmediateDefinition.prototype.createReadyStateChangeSetImmediate = function () {
        var fn = function setImmediate() {
            var instance = setImmediate.instance;
            var root = instance.root;
            var doc = root.document;
            var html = doc.documentElement;
            var handle = instance.addFromSetImmediateArguments(arguments);
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement('script');
            script.onreadystatechange = function () {
                instance.runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
            return handle;
        };
        fn.instance = this;
        return fn;
    };
    ImmediateDefinition.prototype.createSetTimeoutSetImmediate = function () {
        var fn = function setImmediate() {
            var instance = setImmediate.instance;
            var handle = instance.addFromSetImmediateArguments(arguments);
            instance.root.setTimeout(instance.partiallyApplied(instance.runIfPresent, handle), 0);
            return handle;
        };
        fn.instance = this;
        return fn;
    };
    return ImmediateDefinition;
}());
exports.ImmediateDefinition = ImmediateDefinition;
exports.Immediate = new ImmediateDefinition(root_1.root);
//# sourceMappingURL=Immediate.js.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(503).clearImmediate, __webpack_require__(503).setImmediate))

/***/ }),
/* 1345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var root_1 = __webpack_require__(24);
var MapPolyfill_1 = __webpack_require__(1346);
exports.Map = root_1.root.Map || (function () { return MapPolyfill_1.MapPolyfill; })();
//# sourceMappingURL=Map.js.map

/***/ }),
/* 1346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var MapPolyfill = (function () {
    function MapPolyfill() {
        this.size = 0;
        this._values = [];
        this._keys = [];
    }
    MapPolyfill.prototype.get = function (key) {
        var i = this._keys.indexOf(key);
        return i === -1 ? undefined : this._values[i];
    };
    MapPolyfill.prototype.set = function (key, value) {
        var i = this._keys.indexOf(key);
        if (i === -1) {
            this._keys.push(key);
            this._values.push(value);
            this.size++;
        }
        else {
            this._values[i] = value;
        }
        return this;
    };
    MapPolyfill.prototype.delete = function (key) {
        var i = this._keys.indexOf(key);
        if (i === -1) {
            return false;
        }
        this._values.splice(i, 1);
        this._keys.splice(i, 1);
        this.size--;
        return true;
    };
    MapPolyfill.prototype.clear = function () {
        this._keys.length = 0;
        this._values.length = 0;
        this.size = 0;
    };
    MapPolyfill.prototype.forEach = function (cb, thisArg) {
        for (var i = 0; i < this.size; i++) {
            cb.call(thisArg, this._values[i], this._keys[i]);
        }
    };
    return MapPolyfill;
}());
exports.MapPolyfill = MapPolyfill;
//# sourceMappingURL=MapPolyfill.js.map

/***/ }),
/* 1347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var root_1 = __webpack_require__(24);
function minimalSetImpl() {
    // THIS IS NOT a full impl of Set, this is just the minimum
    // bits of functionality we need for this library.
    return (function () {
        function MinimalSet() {
            this._values = [];
        }
        MinimalSet.prototype.add = function (value) {
            if (!this.has(value)) {
                this._values.push(value);
            }
        };
        MinimalSet.prototype.has = function (value) {
            return this._values.indexOf(value) !== -1;
        };
        Object.defineProperty(MinimalSet.prototype, "size", {
            get: function () {
                return this._values.length;
            },
            enumerable: true,
            configurable: true
        });
        MinimalSet.prototype.clear = function () {
            this._values.length = 0;
        };
        return MinimalSet;
    }());
}
exports.minimalSetImpl = minimalSetImpl;
exports.Set = root_1.root.Set || minimalSetImpl();
//# sourceMappingURL=Set.js.map

/***/ }),
/* 1348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var root_1 = __webpack_require__(24);
function assignImpl(target) {
    var sources = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        sources[_i - 1] = arguments[_i];
    }
    var len = sources.length;
    for (var i = 0; i < len; i++) {
        var source = sources[i];
        for (var k in source) {
            if (source.hasOwnProperty(k)) {
                target[k] = source[k];
            }
        }
    }
    return target;
}
exports.assignImpl = assignImpl;
;
function getAssign(root) {
    return root.Object.assign || assignImpl;
}
exports.getAssign = getAssign;
exports.assign = getAssign(root_1.root);
//# sourceMappingURL=assign.js.map

/***/ }),
/* 1349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function not(pred, thisArg) {
    function notPred() {
        return !(notPred.pred.apply(notPred.thisArg, arguments));
    }
    notPred.pred = pred;
    notPred.thisArg = thisArg;
    return notPred;
}
exports.not = not;
//# sourceMappingURL=not.js.map

/***/ }),
/* 1350 */,
/* 1351 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(93), __webpack_require__(463)))

/***/ }),
/* 1352 */
/***/ (function(module, exports) {

/*******************************************************************************
 * Copyright (c) 2013 IBM Corp.
 *
 * All rights reserved. This program and the accompanying materials
 * are made available under the terms of the Eclipse Public License v1.0
 * and Eclipse Distribution License v1.0 which accompany this distribution. 
 *
 * The Eclipse Public License is available at 
 *    http://www.eclipse.org/legal/epl-v10.html
 * and the Eclipse Distribution License is available at 
 *   http://www.eclipse.org/org/documents/edl-v10.php.
 *
 * Contributors:
 *    Andrew Banks - initial API and implementation and initial documentation
 *******************************************************************************/


// Only expose a single object name in the global namespace.
// Everything must go through this module. Global Paho.MQTT module
// only has a single public function, client, which returns
// a Paho.MQTT client object given connection details.
 
/**
 * Send and receive messages using web browsers.
 * <p> 
 * This programming interface lets a JavaScript client application use the MQTT V3.1 or
 * V3.1.1 protocol to connect to an MQTT-supporting messaging server.
 *  
 * The function supported includes:
 * <ol>
 * <li>Connecting to and disconnecting from a server. The server is identified by its host name and port number. 
 * <li>Specifying options that relate to the communications link with the server, 
 * for example the frequency of keep-alive heartbeats, and whether SSL/TLS is required.
 * <li>Subscribing to and receiving messages from MQTT Topics.
 * <li>Publishing messages to MQTT Topics.
 * </ol>
 * <p>
 * The API consists of two main objects:
 * <dl>
 * <dt><b>{@link Paho.MQTT.Client}</b></dt>
 * <dd>This contains methods that provide the functionality of the API,
 * including provision of callbacks that notify the application when a message
 * arrives from or is delivered to the messaging server,
 * or when the status of its connection to the messaging server changes.</dd>
 * <dt><b>{@link Paho.MQTT.Message}</b></dt>
 * <dd>This encapsulates the payload of the message along with various attributes
 * associated with its delivery, in particular the destination to which it has
 * been (or is about to be) sent.</dd>
 * </dl> 
 * <p>
 * The programming interface validates parameters passed to it, and will throw
 * an Error containing an error message intended for developer use, if it detects
 * an error with any parameter.
 * <p>
 * Example:
 * 
 * <code><pre>
client = new Paho.MQTT.Client(location.hostname, Number(location.port), "clientId");
client.onConnectionLost = onConnectionLost;
client.onMessageArrived = onMessageArrived;
client.connect({onSuccess:onConnect});

function onConnect() {
  // Once a connection has been made, make a subscription and send a message.
  console.log("onConnect");
  client.subscribe("/World");
  message = new Paho.MQTT.Message("Hello");
  message.destinationName = "/World";
  client.send(message); 
};
function onConnectionLost(responseObject) {
  if (responseObject.errorCode !== 0)
	console.log("onConnectionLost:"+responseObject.errorMessage);
};
function onMessageArrived(message) {
  console.log("onMessageArrived:"+message.payloadString);
  client.disconnect(); 
};	
 * </pre></code>
 * @namespace Paho.MQTT 
 */

if (typeof Paho === "undefined") {
	Paho = {};
}

Paho.MQTT = (function (global) {

	// Private variables below, these are only visible inside the function closure
	// which is used to define the module. 

	var version = "@VERSION@";
	var buildLevel = "@BUILDLEVEL@";
	
	/** 
	 * Unique message type identifiers, with associated
	 * associated integer values.
	 * @private 
	 */
	var MESSAGE_TYPE = {
		CONNECT: 1, 
		CONNACK: 2, 
		PUBLISH: 3,
		PUBACK: 4,
		PUBREC: 5, 
		PUBREL: 6,
		PUBCOMP: 7,
		SUBSCRIBE: 8,
		SUBACK: 9,
		UNSUBSCRIBE: 10,
		UNSUBACK: 11,
		PINGREQ: 12,
		PINGRESP: 13,
		DISCONNECT: 14
	};
	
	// Collection of utility methods used to simplify module code 
	// and promote the DRY pattern.  

	/**
	 * Validate an object's parameter names to ensure they 
	 * match a list of expected variables name for this option
	 * type. Used to ensure option object passed into the API don't
	 * contain erroneous parameters.
	 * @param {Object} obj - User options object
	 * @param {Object} keys - valid keys and types that may exist in obj. 
	 * @throws {Error} Invalid option parameter found. 
	 * @private 
	 */
	var validate = function(obj, keys) {
		for (var key in obj) {
			if (obj.hasOwnProperty(key)) {       		
				if (keys.hasOwnProperty(key)) {
					if (typeof obj[key] !== keys[key])
					   throw new Error(format(ERROR.INVALID_TYPE, [typeof obj[key], key]));
				} else {	
					var errorStr = "Unknown property, " + key + ". Valid properties are:";
					for (var key in keys)
						if (keys.hasOwnProperty(key))
							errorStr = errorStr+" "+key;
					throw new Error(errorStr);
				}
			}
		}
	};

	/**
	 * Return a new function which runs the user function bound
	 * to a fixed scope. 
	 * @param {function} User function
	 * @param {object} Function scope  
	 * @return {function} User function bound to another scope
	 * @private 
	 */
	var scope = function (f, scope) {
		return function () {
			return f.apply(scope, arguments);
		};
	};
	
	/** 
	 * Unique message type identifiers, with associated
	 * associated integer values.
	 * @private 
	 */
	var ERROR = {
		OK: {code:0, text:"AMQJSC0000I OK."},
		CONNECT_TIMEOUT: {code:1, text:"AMQJSC0001E Connect timed out."},
		SUBSCRIBE_TIMEOUT: {code:2, text:"AMQJS0002E Subscribe timed out."}, 
		UNSUBSCRIBE_TIMEOUT: {code:3, text:"AMQJS0003E Unsubscribe timed out."},
		PING_TIMEOUT: {code:4, text:"AMQJS0004E Ping timed out."},
		INTERNAL_ERROR: {code:5, text:"AMQJS0005E Internal error. Error Message: {0}, Stack trace: {1}"},
		CONNACK_RETURNCODE: {code:6, text:"AMQJS0006E Bad Connack return code:{0} {1}."},
		SOCKET_ERROR: {code:7, text:"AMQJS0007E Socket error:{0}."},
		SOCKET_CLOSE: {code:8, text:"AMQJS0008I Socket closed."},
		MALFORMED_UTF: {code:9, text:"AMQJS0009E Malformed UTF data:{0} {1} {2}."},
		UNSUPPORTED: {code:10, text:"AMQJS0010E {0} is not supported by this browser."},
		INVALID_STATE: {code:11, text:"AMQJS0011E Invalid state {0}."},
		INVALID_TYPE: {code:12, text:"AMQJS0012E Invalid type {0} for {1}."},
		INVALID_ARGUMENT: {code:13, text:"AMQJS0013E Invalid argument {0} for {1}."},
		UNSUPPORTED_OPERATION: {code:14, text:"AMQJS0014E Unsupported operation."},
		INVALID_STORED_DATA: {code:15, text:"AMQJS0015E Invalid data in local storage key={0} value={1}."},
		INVALID_MQTT_MESSAGE_TYPE: {code:16, text:"AMQJS0016E Invalid MQTT message type {0}."},
		MALFORMED_UNICODE: {code:17, text:"AMQJS0017E Malformed Unicode string:{0} {1}."}
	};
	
	/** CONNACK RC Meaning. */
	var CONNACK_RC = {
		0:"Connection Accepted",
		1:"Connection Refused: unacceptable protocol version",
		2:"Connection Refused: identifier rejected",
		3:"Connection Refused: server unavailable",
		4:"Connection Refused: bad user name or password",
		5:"Connection Refused: not authorized"
	};

	/**
	 * Format an error message text.
	 * @private
	 * @param {error} ERROR.KEY value above.
	 * @param {substitutions} [array] substituted into the text.
	 * @return the text with the substitutions made.
	 */
	var format = function(error, substitutions) {
		var text = error.text;
		if (substitutions) {
		  var field,start;
		  for (var i=0; i<substitutions.length; i++) {
			field = "{"+i+"}";
			start = text.indexOf(field);
			if(start > 0) {
				var part1 = text.substring(0,start);
				var part2 = text.substring(start+field.length);
				text = part1+substitutions[i]+part2;
			}
		  }
		}
		return text;
	};
	
	//MQTT protocol and version          6    M    Q    I    s    d    p    3
	var MqttProtoIdentifierv3 = [0x00,0x06,0x4d,0x51,0x49,0x73,0x64,0x70,0x03];
	//MQTT proto/version for 311         4    M    Q    T    T    4
	var MqttProtoIdentifierv4 = [0x00,0x04,0x4d,0x51,0x54,0x54,0x04];
	
	/**
	 * Construct an MQTT wire protocol message.
	 * @param type MQTT packet type.
	 * @param options optional wire message attributes.
	 * 
	 * Optional properties
	 * 
	 * messageIdentifier: message ID in the range [0..65535]
	 * payloadMessage:	Application Message - PUBLISH only
	 * connectStrings:	array of 0 or more Strings to be put into the CONNECT payload
	 * topics:			array of strings (SUBSCRIBE, UNSUBSCRIBE)
	 * requestQoS:		array of QoS values [0..2]
	 *  
	 * "Flag" properties 
	 * cleanSession:	true if present / false if absent (CONNECT)
	 * willMessage:  	true if present / false if absent (CONNECT)
	 * isRetained:		true if present / false if absent (CONNECT)
	 * userName:		true if present / false if absent (CONNECT)
	 * password:		true if present / false if absent (CONNECT)
	 * keepAliveInterval:	integer [0..65535]  (CONNECT)
	 *
	 * @private
	 * @ignore
	 */
	var WireMessage = function (type, options) { 	
		this.type = type;
		for (var name in options) {
			if (options.hasOwnProperty(name)) {
				this[name] = options[name];
			}
		}
	};
	
	WireMessage.prototype.encode = function() {
		// Compute the first byte of the fixed header
		var first = ((this.type & 0x0f) << 4);
		
		/*
		 * Now calculate the length of the variable header + payload by adding up the lengths
		 * of all the component parts
		 */

		var remLength = 0;
		var topicStrLength = new Array();
		var destinationNameLength = 0;
		
		// if the message contains a messageIdentifier then we need two bytes for that
		if (this.messageIdentifier != undefined)
			remLength += 2;

		switch(this.type) {
			// If this a Connect then we need to include 12 bytes for its header
			case MESSAGE_TYPE.CONNECT:
				switch(this.mqttVersion) {
					case 3:
						remLength += MqttProtoIdentifierv3.length + 3;
						break;
					case 4:
						remLength += MqttProtoIdentifierv4.length + 3;
						break;
				}

				remLength += UTF8Length(this.clientId) + 2;
				if (this.willMessage != undefined) {
					remLength += UTF8Length(this.willMessage.destinationName) + 2;
					// Will message is always a string, sent as UTF-8 characters with a preceding length.
					var willMessagePayloadBytes = this.willMessage.payloadBytes;
					if (!(willMessagePayloadBytes instanceof Uint8Array))
						willMessagePayloadBytes = new Uint8Array(payloadBytes);
					remLength += willMessagePayloadBytes.byteLength +2;
				}
				if (this.userName != undefined)
					remLength += UTF8Length(this.userName) + 2;	
				if (this.password != undefined)
					remLength += UTF8Length(this.password) + 2;
			break;

			// Subscribe, Unsubscribe can both contain topic strings
			case MESSAGE_TYPE.SUBSCRIBE:	        	
				first |= 0x02; // Qos = 1;
				for ( var i = 0; i < this.topics.length; i++) {
					topicStrLength[i] = UTF8Length(this.topics[i]);
					remLength += topicStrLength[i] + 2;
				}
				remLength += this.requestedQos.length; // 1 byte for each topic's Qos
				// QoS on Subscribe only
				break;

			case MESSAGE_TYPE.UNSUBSCRIBE:
				first |= 0x02; // Qos = 1;
				for ( var i = 0; i < this.topics.length; i++) {
					topicStrLength[i] = UTF8Length(this.topics[i]);
					remLength += topicStrLength[i] + 2;
				}
				break;

			case MESSAGE_TYPE.PUBREL:
				first |= 0x02; // Qos = 1;
				break;

			case MESSAGE_TYPE.PUBLISH:
				if (this.payloadMessage.duplicate) first |= 0x08;
				first  = first |= (this.payloadMessage.qos << 1);
				if (this.payloadMessage.retained) first |= 0x01;
				destinationNameLength = UTF8Length(this.payloadMessage.destinationName);
				remLength += destinationNameLength + 2;	   
				var payloadBytes = this.payloadMessage.payloadBytes;
				remLength += payloadBytes.byteLength;  
				if (payloadBytes instanceof ArrayBuffer)
					payloadBytes = new Uint8Array(payloadBytes);
				else if (!(payloadBytes instanceof Uint8Array))
					payloadBytes = new Uint8Array(payloadBytes.buffer);
				break;

			case MESSAGE_TYPE.DISCONNECT:
				break;

			default:
				;
		}

		// Now we can allocate a buffer for the message

		var mbi = encodeMBI(remLength);  // Convert the length to MQTT MBI format
		var pos = mbi.length + 1;        // Offset of start of variable header
		var buffer = new ArrayBuffer(remLength + pos);
		var byteStream = new Uint8Array(buffer);    // view it as a sequence of bytes

		//Write the fixed header into the buffer
		byteStream[0] = first;
		byteStream.set(mbi,1);

		// If this is a PUBLISH then the variable header starts with a topic
		if (this.type == MESSAGE_TYPE.PUBLISH)
			pos = writeString(this.payloadMessage.destinationName, destinationNameLength, byteStream, pos);
		// If this is a CONNECT then the variable header contains the protocol name/version, flags and keepalive time
		
		else if (this.type == MESSAGE_TYPE.CONNECT) {
			switch (this.mqttVersion) {
				case 3:
					byteStream.set(MqttProtoIdentifierv3, pos);
					pos += MqttProtoIdentifierv3.length;
					break;
				case 4:
					byteStream.set(MqttProtoIdentifierv4, pos);
					pos += MqttProtoIdentifierv4.length;
					break;
			}
			var connectFlags = 0;
			if (this.cleanSession) 
				connectFlags = 0x02;
			if (this.willMessage != undefined ) {
				connectFlags |= 0x04;
				connectFlags |= (this.willMessage.qos<<3);
				if (this.willMessage.retained) {
					connectFlags |= 0x20;
				}
			}
			if (this.userName != undefined)
				connectFlags |= 0x80;
			if (this.password != undefined)
				connectFlags |= 0x40;
			byteStream[pos++] = connectFlags; 
			pos = writeUint16 (this.keepAliveInterval, byteStream, pos);
		}

		// Output the messageIdentifier - if there is one
		if (this.messageIdentifier != undefined)
			pos = writeUint16 (this.messageIdentifier, byteStream, pos);

		switch(this.type) {
			case MESSAGE_TYPE.CONNECT:
				pos = writeString(this.clientId, UTF8Length(this.clientId), byteStream, pos); 
				if (this.willMessage != undefined) {
					pos = writeString(this.willMessage.destinationName, UTF8Length(this.willMessage.destinationName), byteStream, pos);
					pos = writeUint16(willMessagePayloadBytes.byteLength, byteStream, pos);
					byteStream.set(willMessagePayloadBytes, pos);
					pos += willMessagePayloadBytes.byteLength;
					
				}
			if (this.userName != undefined)
				pos = writeString(this.userName, UTF8Length(this.userName), byteStream, pos);
			if (this.password != undefined) 
				pos = writeString(this.password, UTF8Length(this.password), byteStream, pos);
			break;

			case MESSAGE_TYPE.PUBLISH:	
				// PUBLISH has a text or binary payload, if text do not add a 2 byte length field, just the UTF characters.	
				byteStream.set(payloadBytes, pos);
					
				break;

//    	    case MESSAGE_TYPE.PUBREC:	
//    	    case MESSAGE_TYPE.PUBREL:	
//    	    case MESSAGE_TYPE.PUBCOMP:	
//    	    	break;

			case MESSAGE_TYPE.SUBSCRIBE:
				// SUBSCRIBE has a list of topic strings and request QoS
				for (var i=0; i<this.topics.length; i++) {
					pos = writeString(this.topics[i], topicStrLength[i], byteStream, pos);
					byteStream[pos++] = this.requestedQos[i];
				}
				break;

			case MESSAGE_TYPE.UNSUBSCRIBE:	
				// UNSUBSCRIBE has a list of topic strings
				for (var i=0; i<this.topics.length; i++)
					pos = writeString(this.topics[i], topicStrLength[i], byteStream, pos);
				break;

			default:
				// Do nothing.
		}

		return buffer;
	}	

	function decodeMessage(input,pos) {
	    var startingPos = pos;
		var first = input[pos];
		var type = first >> 4;
		var messageInfo = first &= 0x0f;
		pos += 1;
		

		// Decode the remaining length (MBI format)

		var digit;
		var remLength = 0;
		var multiplier = 1;
		do {
			if (pos == input.length) {
			    return [null,startingPos];
			}
			digit = input[pos++];
			remLength += ((digit & 0x7F) * multiplier);
			multiplier *= 128;
		} while ((digit & 0x80) != 0);
		
		var endPos = pos+remLength;
		if (endPos > input.length) {
		    return [null,startingPos];
		}

		var wireMessage = new WireMessage(type);
		switch(type) {
			case MESSAGE_TYPE.CONNACK:
				var connectAcknowledgeFlags = input[pos++];
				if (connectAcknowledgeFlags & 0x01)
					wireMessage.sessionPresent = true;
				wireMessage.returnCode = input[pos++];
				break;
			
			case MESSAGE_TYPE.PUBLISH:     	    	
				var qos = (messageInfo >> 1) & 0x03;
							
				var len = readUint16(input, pos);
				pos += 2;
				var topicName = parseUTF8(input, pos, len);
				pos += len;
				// If QoS 1 or 2 there will be a messageIdentifier
				if (qos > 0) {
					wireMessage.messageIdentifier = readUint16(input, pos);
					pos += 2;
				}
				
				var message = new Paho.MQTT.Message(input.subarray(pos, endPos));
				if ((messageInfo & 0x01) == 0x01) 
					message.retained = true;
				if ((messageInfo & 0x08) == 0x08)
					message.duplicate =  true;
				message.qos = qos;
				message.destinationName = topicName;
				wireMessage.payloadMessage = message;	
				break;
			
			case  MESSAGE_TYPE.PUBACK:
			case  MESSAGE_TYPE.PUBREC:	    
			case  MESSAGE_TYPE.PUBREL:    
			case  MESSAGE_TYPE.PUBCOMP:
			case  MESSAGE_TYPE.UNSUBACK:    	    	
				wireMessage.messageIdentifier = readUint16(input, pos);
				break;
				
			case  MESSAGE_TYPE.SUBACK:
				wireMessage.messageIdentifier = readUint16(input, pos);
				pos += 2;
				wireMessage.returnCode = input.subarray(pos, endPos);	
				break;
		
			default:
				;
		}
				
		return [wireMessage,endPos];	
	}

	function writeUint16(input, buffer, offset) {
		buffer[offset++] = input >> 8;      //MSB
		buffer[offset++] = input % 256;     //LSB 
		return offset;
	}	

	function writeString(input, utf8Length, buffer, offset) {
		offset = writeUint16(utf8Length, buffer, offset);
		stringToUTF8(input, buffer, offset);
		return offset + utf8Length;
	}	

	function readUint16(buffer, offset) {
		return 256*buffer[offset] + buffer[offset+1];
	}	

	/**
	 * Encodes an MQTT Multi-Byte Integer
	 * @private 
	 */
	function encodeMBI(number) {
		var output = new Array(1);
		var numBytes = 0;

		do {
			var digit = number % 128;
			number = number >> 7;
			if (number > 0) {
				digit |= 0x80;
			}
			output[numBytes++] = digit;
		} while ( (number > 0) && (numBytes<4) );

		return output;
	}

	/**
	 * Takes a String and calculates its length in bytes when encoded in UTF8.
	 * @private
	 */
	function UTF8Length(input) {
		var output = 0;
		for (var i = 0; i<input.length; i++) 
		{
			var charCode = input.charCodeAt(i);
				if (charCode > 0x7FF)
				   {
					  // Surrogate pair means its a 4 byte character
					  if (0xD800 <= charCode && charCode <= 0xDBFF)
						{
						  i++;
						  output++;
						}
				   output +=3;
				   }
			else if (charCode > 0x7F)
				output +=2;
			else
				output++;
		} 
		return output;
	}
	
	/**
	 * Takes a String and writes it into an array as UTF8 encoded bytes.
	 * @private
	 */
	function stringToUTF8(input, output, start) {
		var pos = start;
		for (var i = 0; i<input.length; i++) {
			var charCode = input.charCodeAt(i);
			
			// Check for a surrogate pair.
			if (0xD800 <= charCode && charCode <= 0xDBFF) {
				var lowCharCode = input.charCodeAt(++i);
				if (isNaN(lowCharCode)) {
					throw new Error(format(ERROR.MALFORMED_UNICODE, [charCode, lowCharCode]));
				}
				charCode = ((charCode - 0xD800)<<10) + (lowCharCode - 0xDC00) + 0x10000;
			
			}
			
			if (charCode <= 0x7F) {
				output[pos++] = charCode;
			} else if (charCode <= 0x7FF) {
				output[pos++] = charCode>>6  & 0x1F | 0xC0;
				output[pos++] = charCode     & 0x3F | 0x80;
			} else if (charCode <= 0xFFFF) {    				    
				output[pos++] = charCode>>12 & 0x0F | 0xE0;
				output[pos++] = charCode>>6  & 0x3F | 0x80;   
				output[pos++] = charCode     & 0x3F | 0x80;   
			} else {
				output[pos++] = charCode>>18 & 0x07 | 0xF0;
				output[pos++] = charCode>>12 & 0x3F | 0x80;
				output[pos++] = charCode>>6  & 0x3F | 0x80;
				output[pos++] = charCode     & 0x3F | 0x80;
			};
		} 
		return output;
	}
	
	function parseUTF8(input, offset, length) {
		var output = "";
		var utf16;
		var pos = offset;

		while (pos < offset+length)
		{
			var byte1 = input[pos++];
			if (byte1 < 128)
				utf16 = byte1;
			else 
			{
				var byte2 = input[pos++]-128;
				if (byte2 < 0) 
					throw new Error(format(ERROR.MALFORMED_UTF, [byte1.toString(16), byte2.toString(16),""]));
				if (byte1 < 0xE0)             // 2 byte character
					utf16 = 64*(byte1-0xC0) + byte2;
				else 
				{ 
					var byte3 = input[pos++]-128;
					if (byte3 < 0) 
						throw new Error(format(ERROR.MALFORMED_UTF, [byte1.toString(16), byte2.toString(16), byte3.toString(16)]));
					if (byte1 < 0xF0)        // 3 byte character
						utf16 = 4096*(byte1-0xE0) + 64*byte2 + byte3;
								else
								{
								   var byte4 = input[pos++]-128;
								   if (byte4 < 0) 
						throw new Error(format(ERROR.MALFORMED_UTF, [byte1.toString(16), byte2.toString(16), byte3.toString(16), byte4.toString(16)]));
								   if (byte1 < 0xF8)        // 4 byte character 
										   utf16 = 262144*(byte1-0xF0) + 4096*byte2 + 64*byte3 + byte4;
					   else                     // longer encodings are not supported  
						throw new Error(format(ERROR.MALFORMED_UTF, [byte1.toString(16), byte2.toString(16), byte3.toString(16), byte4.toString(16)]));
								}
				}
			}  

				if (utf16 > 0xFFFF)   // 4 byte character - express as a surrogate pair
				  {
					 utf16 -= 0x10000;
					 output += String.fromCharCode(0xD800 + (utf16 >> 10)); // lead character
					 utf16 = 0xDC00 + (utf16 & 0x3FF);  // trail character
				  }
			output += String.fromCharCode(utf16);
		}
		return output;
	}
	
	/** 
	 * Repeat keepalive requests, monitor responses.
	 * @ignore
	 */
	var Pinger = function(client, window, keepAliveInterval) { 
		this._client = client;        	
		this._window = window;
		this._keepAliveInterval = keepAliveInterval*1000;     	
		this.isReset = false;
		
		var pingReq = new WireMessage(MESSAGE_TYPE.PINGREQ).encode(); 
		
		var doTimeout = function (pinger) {
			return function () {
				return doPing.apply(pinger);
			};
		};
		
		/** @ignore */
		var doPing = function() { 
			if (!this.isReset) {
				this._client._trace("Pinger.doPing", "Timed out");
				this._client._disconnected( ERROR.PING_TIMEOUT.code , format(ERROR.PING_TIMEOUT));
			} else {
				this.isReset = false;
				this._client._trace("Pinger.doPing", "send PINGREQ");
				this._client.socket.send(pingReq); 
				this.timeout = this._window.setTimeout(doTimeout(this), this._keepAliveInterval);
			}
		}

		this.reset = function() {
			this.isReset = true;
			this._window.clearTimeout(this.timeout);
			if (this._keepAliveInterval > 0)
				this.timeout = setTimeout(doTimeout(this), this._keepAliveInterval);
		}

		this.cancel = function() {
			this._window.clearTimeout(this.timeout);
		}
	 }; 

	/**
	 * Monitor request completion.
	 * @ignore
	 */
	var Timeout = function(client, window, timeoutSeconds, action, args) {
		this._window = window;
		if (!timeoutSeconds)
			timeoutSeconds = 30;
		
		var doTimeout = function (action, client, args) {
			return function () {
				return action.apply(client, args);
			};
		};
		this.timeout = setTimeout(doTimeout(action, client, args), timeoutSeconds * 1000);
		
		this.cancel = function() {
			this._window.clearTimeout(this.timeout);
		}
	}; 
	
	/*
	 * Internal implementation of the Websockets MQTT V3.1 client.
	 * 
	 * @name Paho.MQTT.ClientImpl @constructor 
	 * @param {String} host the DNS nameof the webSocket host. 
	 * @param {Number} port the port number for that host.
	 * @param {String} clientId the MQ client identifier.
	 */
	var ClientImpl = function (uri, host, port, path, clientId) {
		// Check dependencies are satisfied in this browser.
		if (!("WebSocket" in global && global["WebSocket"] !== null)) {
			throw new Error(format(ERROR.UNSUPPORTED, ["WebSocket"]));
		}
		if (!("localStorage" in global && global["localStorage"] !== null)) {
			throw new Error(format(ERROR.UNSUPPORTED, ["localStorage"]));
		}
		if (!("ArrayBuffer" in global && global["ArrayBuffer"] !== null)) {
			throw new Error(format(ERROR.UNSUPPORTED, ["ArrayBuffer"]));
		}
		this._trace("Paho.MQTT.Client", uri, host, port, path, clientId);

		this.host = host;
		this.port = port;
		this.path = path;
		this.uri = uri;
		this.clientId = clientId;

		// Local storagekeys are qualified with the following string.
		// The conditional inclusion of path in the key is for backward
		// compatibility to when the path was not configurable and assumed to
		// be /mqtt
		this._localKey=host+":"+port+(path!="/mqtt"?":"+path:"")+":"+clientId+":";

		// Create private instance-only message queue
		// Internal queue of messages to be sent, in sending order. 
		this._msg_queue = [];

		// Messages we have sent and are expecting a response for, indexed by their respective message ids. 
		this._sentMessages = {};

		// Messages we have received and acknowleged and are expecting a confirm message for
		// indexed by their respective message ids. 
		this._receivedMessages = {};

		// Internal list of callbacks to be executed when messages
		// have been successfully sent over web socket, e.g. disconnect
		// when it doesn't have to wait for ACK, just message is dispatched.
		this._notify_msg_sent = {};

		// Unique identifier for SEND messages, incrementing
		// counter as messages are sent.
		this._message_identifier = 1;
		
		// Used to determine the transmission sequence of stored sent messages.
		this._sequence = 0;
		

		// Load the local state, if any, from the saved version, only restore state relevant to this client.   	
		for (var key in localStorage)
			if (   key.indexOf("Sent:"+this._localKey) == 0  		    
				|| key.indexOf("Received:"+this._localKey) == 0)
			this.restore(key);
	};

	// Messaging Client public instance members. 
	ClientImpl.prototype.host;
	ClientImpl.prototype.port;
	ClientImpl.prototype.path;
	ClientImpl.prototype.uri;
	ClientImpl.prototype.clientId;

	// Messaging Client private instance members.
	ClientImpl.prototype.socket;
	/* true once we have received an acknowledgement to a CONNECT packet. */
	ClientImpl.prototype.connected = false;
	/* The largest message identifier allowed, may not be larger than 2**16 but 
	 * if set smaller reduces the maximum number of outbound messages allowed.
	 */ 
	ClientImpl.prototype.maxMessageIdentifier = 65536;
	ClientImpl.prototype.connectOptions;
	ClientImpl.prototype.hostIndex;
	ClientImpl.prototype.onConnectionLost;
	ClientImpl.prototype.onMessageDelivered;
	ClientImpl.prototype.onMessageArrived;
	ClientImpl.prototype.traceFunction;
	ClientImpl.prototype._msg_queue = null;
	ClientImpl.prototype._connectTimeout;
	/* The sendPinger monitors how long we allow before we send data to prove to the server that we are alive. */
	ClientImpl.prototype.sendPinger = null;
	/* The receivePinger monitors how long we allow before we require evidence that the server is alive. */
	ClientImpl.prototype.receivePinger = null;
	
	ClientImpl.prototype.receiveBuffer = null;
	
	ClientImpl.prototype._traceBuffer = null;
	ClientImpl.prototype._MAX_TRACE_ENTRIES = 100;

	ClientImpl.prototype.connect = function (connectOptions) {
		var connectOptionsMasked = this._traceMask(connectOptions, "password"); 
		this._trace("Client.connect", connectOptionsMasked, this.socket, this.connected);
		
		if (this.connected) 
			throw new Error(format(ERROR.INVALID_STATE, ["already connected"]));
		if (this.socket)
			throw new Error(format(ERROR.INVALID_STATE, ["already connected"]));
		
		this.connectOptions = connectOptions;
		
		if (connectOptions.uris) {
			this.hostIndex = 0;
			this._doConnect(connectOptions.uris[0]);  
		} else {
			this._doConnect(this.uri);  		
		}
		
	};

	ClientImpl.prototype.subscribe = function (filter, subscribeOptions) {
		this._trace("Client.subscribe", filter, subscribeOptions);
			  
		if (!this.connected)
			throw new Error(format(ERROR.INVALID_STATE, ["not connected"]));
		
		var wireMessage = new WireMessage(MESSAGE_TYPE.SUBSCRIBE);
		wireMessage.topics=[filter];
		if (subscribeOptions.qos != undefined)
			wireMessage.requestedQos = [subscribeOptions.qos];
		else 
			wireMessage.requestedQos = [0];
		
		if (subscribeOptions.onSuccess) {
			wireMessage.onSuccess = function(grantedQos) {subscribeOptions.onSuccess({invocationContext:subscribeOptions.invocationContext,grantedQos:grantedQos});};
		}

		if (subscribeOptions.onFailure) {
			wireMessage.onFailure = function(errorCode) {subscribeOptions.onFailure({invocationContext:subscribeOptions.invocationContext,errorCode:errorCode});};
		}

		if (subscribeOptions.timeout) {
			wireMessage.timeOut = new Timeout(this, window, subscribeOptions.timeout, subscribeOptions.onFailure
					, [{invocationContext:subscribeOptions.invocationContext, 
						errorCode:ERROR.SUBSCRIBE_TIMEOUT.code, 
						errorMessage:format(ERROR.SUBSCRIBE_TIMEOUT)}]);
		}
		
		// All subscriptions return a SUBACK. 
		this._requires_ack(wireMessage);
		this._schedule_message(wireMessage);
	};

	/** @ignore */
	ClientImpl.prototype.unsubscribe = function(filter, unsubscribeOptions) {  
		this._trace("Client.unsubscribe", filter, unsubscribeOptions);
		
		if (!this.connected)
		   throw new Error(format(ERROR.INVALID_STATE, ["not connected"]));
		
		var wireMessage = new WireMessage(MESSAGE_TYPE.UNSUBSCRIBE);
		wireMessage.topics = [filter];
		
		if (unsubscribeOptions.onSuccess) {
			wireMessage.callback = function() {unsubscribeOptions.onSuccess({invocationContext:unsubscribeOptions.invocationContext});};
		}
		if (unsubscribeOptions.timeout) {
			wireMessage.timeOut = new Timeout(this, window, unsubscribeOptions.timeout, unsubscribeOptions.onFailure
					, [{invocationContext:unsubscribeOptions.invocationContext,
						errorCode:ERROR.UNSUBSCRIBE_TIMEOUT.code,
						errorMessage:format(ERROR.UNSUBSCRIBE_TIMEOUT)}]);
		}
	 
		// All unsubscribes return a SUBACK.         
		this._requires_ack(wireMessage);
		this._schedule_message(wireMessage);
	};
	 
	ClientImpl.prototype.send = function (message) {
		this._trace("Client.send", message);

		if (!this.connected)
		   throw new Error(format(ERROR.INVALID_STATE, ["not connected"]));
		
		wireMessage = new WireMessage(MESSAGE_TYPE.PUBLISH);
		wireMessage.payloadMessage = message;
		
		if (message.qos > 0)
			this._requires_ack(wireMessage);
		else if (this.onMessageDelivered)
			this._notify_msg_sent[wireMessage] = this.onMessageDelivered(wireMessage.payloadMessage);
		this._schedule_message(wireMessage);
	};
	
	ClientImpl.prototype.disconnect = function () {
		this._trace("Client.disconnect");

		if (!this.socket)
			throw new Error(format(ERROR.INVALID_STATE, ["not connecting or connected"]));
		
		wireMessage = new WireMessage(MESSAGE_TYPE.DISCONNECT);

		// Run the disconnected call back as soon as the message has been sent,
		// in case of a failure later on in the disconnect processing.
		// as a consequence, the _disconected call back may be run several times.
		this._notify_msg_sent[wireMessage] = scope(this._disconnected, this);

		this._schedule_message(wireMessage);
	};
	
	ClientImpl.prototype.getTraceLog = function () {
		if ( this._traceBuffer !== null ) {
			this._trace("Client.getTraceLog", new Date());
			this._trace("Client.getTraceLog in flight messages", this._sentMessages.length);
			for (var key in this._sentMessages)
				this._trace("_sentMessages ",key, this._sentMessages[key]);
			for (var key in this._receivedMessages)
				this._trace("_receivedMessages ",key, this._receivedMessages[key]);
			
			return this._traceBuffer;
		}
	};
	
	ClientImpl.prototype.startTrace = function () {
		if ( this._traceBuffer === null ) {
			this._traceBuffer = [];
		}
		this._trace("Client.startTrace", new Date(), version);
	};
	
	ClientImpl.prototype.stopTrace = function () {
		delete this._traceBuffer;
	};

	ClientImpl.prototype._doConnect = function (wsurl) { 	        
		// When the socket is open, this client will send the CONNECT WireMessage using the saved parameters. 
		if (this.connectOptions.useSSL) {
		    var uriParts = wsurl.split(":");
		    uriParts[0] = "wss";
		    wsurl = uriParts.join(":");
		}
		this.connected = false;
		if (this.connectOptions.mqttVersion < 4) {
			this.socket = new WebSocket(wsurl, ["mqttv3.1"]);
		} else {
			this.socket = new WebSocket(wsurl, ["mqtt"]);
		}
		this.socket.binaryType = 'arraybuffer';
		
		this.socket.onopen = scope(this._on_socket_open, this);
		this.socket.onmessage = scope(this._on_socket_message, this);
		this.socket.onerror = scope(this._on_socket_error, this);
		this.socket.onclose = scope(this._on_socket_close, this);
		
		this.sendPinger = new Pinger(this, window, this.connectOptions.keepAliveInterval);
		this.receivePinger = new Pinger(this, window, this.connectOptions.keepAliveInterval);
		
		this._connectTimeout = new Timeout(this, window, this.connectOptions.timeout, this._disconnected,  [ERROR.CONNECT_TIMEOUT.code, format(ERROR.CONNECT_TIMEOUT)]);
	};

	
	// Schedule a new message to be sent over the WebSockets
	// connection. CONNECT messages cause WebSocket connection
	// to be started. All other messages are queued internally
	// until this has happened. When WS connection starts, process
	// all outstanding messages. 
	ClientImpl.prototype._schedule_message = function (message) {
		this._msg_queue.push(message);
		// Process outstanding messages in the queue if we have an  open socket, and have received CONNACK. 
		if (this.connected) {
			this._process_queue();
		}
	};

	ClientImpl.prototype.store = function(prefix, wireMessage) {
		var storedMessage = {type:wireMessage.type, messageIdentifier:wireMessage.messageIdentifier, version:1};
		
		switch(wireMessage.type) {
		  case MESSAGE_TYPE.PUBLISH:
			  if(wireMessage.pubRecReceived)
				  storedMessage.pubRecReceived = true;
			  
			  // Convert the payload to a hex string.
			  storedMessage.payloadMessage = {};
			  var hex = "";
			  var messageBytes = wireMessage.payloadMessage.payloadBytes;
			  for (var i=0; i<messageBytes.length; i++) {
				if (messageBytes[i] <= 0xF)
				  hex = hex+"0"+messageBytes[i].toString(16);
				else 
				  hex = hex+messageBytes[i].toString(16);
			  }
			  storedMessage.payloadMessage.payloadHex = hex;
			  
			  storedMessage.payloadMessage.qos = wireMessage.payloadMessage.qos;
			  storedMessage.payloadMessage.destinationName = wireMessage.payloadMessage.destinationName;
			  if (wireMessage.payloadMessage.duplicate) 
				  storedMessage.payloadMessage.duplicate = true;
			  if (wireMessage.payloadMessage.retained) 
				  storedMessage.payloadMessage.retained = true;	   
			  
			  // Add a sequence number to sent messages.
			  if ( prefix.indexOf("Sent:") == 0 ) {
				  if ( wireMessage.sequence === undefined )
					  wireMessage.sequence = ++this._sequence;
				  storedMessage.sequence = wireMessage.sequence;
			  }
			  break;    
			  
			default:
				throw Error(format(ERROR.INVALID_STORED_DATA, [key, storedMessage]));
		}
		localStorage.setItem(prefix+this._localKey+wireMessage.messageIdentifier, JSON.stringify(storedMessage));
	};
	
	ClientImpl.prototype.restore = function(key) {    	
		var value = localStorage.getItem(key);
		var storedMessage = JSON.parse(value);
		
		var wireMessage = new WireMessage(storedMessage.type, storedMessage);
		
		switch(storedMessage.type) {
		  case MESSAGE_TYPE.PUBLISH:
			  // Replace the payload message with a Message object.
			  var hex = storedMessage.payloadMessage.payloadHex;
			  var buffer = new ArrayBuffer((hex.length)/2);
			  var byteStream = new Uint8Array(buffer); 
			  var i = 0;
			  while (hex.length >= 2) { 
				  var x = parseInt(hex.substring(0, 2), 16);
				  hex = hex.substring(2, hex.length);
				  byteStream[i++] = x;
			  }
			  var payloadMessage = new Paho.MQTT.Message(byteStream);
			  
			  payloadMessage.qos = storedMessage.payloadMessage.qos;
			  payloadMessage.destinationName = storedMessage.payloadMessage.destinationName;
			  if (storedMessage.payloadMessage.duplicate) 
				  payloadMessage.duplicate = true;
			  if (storedMessage.payloadMessage.retained) 
				  payloadMessage.retained = true;	 
			  wireMessage.payloadMessage = payloadMessage;
			  
			  break;    
			  
			default:
			  throw Error(format(ERROR.INVALID_STORED_DATA, [key, value]));
		}
							
		if (key.indexOf("Sent:"+this._localKey) == 0) {
			wireMessage.payloadMessage.duplicate = true;
			this._sentMessages[wireMessage.messageIdentifier] = wireMessage;    		    
		} else if (key.indexOf("Received:"+this._localKey) == 0) {
			this._receivedMessages[wireMessage.messageIdentifier] = wireMessage;
		}
	};
	
	ClientImpl.prototype._process_queue = function () {
		var message = null;
		// Process messages in order they were added
		var fifo = this._msg_queue.reverse();

		// Send all queued messages down socket connection
		while ((message = fifo.pop())) {
			this._socket_send(message);
			// Notify listeners that message was successfully sent
			if (this._notify_msg_sent[message]) {
				this._notify_msg_sent[message]();
				delete this._notify_msg_sent[message];
			}
		}
	};

	/**
	 * Expect an ACK response for this message. Add message to the set of in progress
	 * messages and set an unused identifier in this message.
	 * @ignore
	 */
	ClientImpl.prototype._requires_ack = function (wireMessage) {
		var messageCount = Object.keys(this._sentMessages).length;
		if (messageCount > this.maxMessageIdentifier)
			throw Error ("Too many messages:"+messageCount);

		while(this._sentMessages[this._message_identifier] !== undefined) {
			this._message_identifier++;
		}
		wireMessage.messageIdentifier = this._message_identifier;
		this._sentMessages[wireMessage.messageIdentifier] = wireMessage;
		if (wireMessage.type === MESSAGE_TYPE.PUBLISH) {
			this.store("Sent:", wireMessage);
		}
		if (this._message_identifier === this.maxMessageIdentifier) {
			this._message_identifier = 1;
		}
	};

	/** 
	 * Called when the underlying websocket has been opened.
	 * @ignore
	 */
	ClientImpl.prototype._on_socket_open = function () {      
		// Create the CONNECT message object.
		var wireMessage = new WireMessage(MESSAGE_TYPE.CONNECT, this.connectOptions); 
		wireMessage.clientId = this.clientId;
		this._socket_send(wireMessage);
	};

	/** 
	 * Called when the underlying websocket has received a complete packet.
	 * @ignore
	 */
	ClientImpl.prototype._on_socket_message = function (event) {
		this._trace("Client._on_socket_message", event.data);
		var messages = this._deframeMessages(event.data);
		for (var i = 0; i < messages.length; i+=1) {
		    this._handleMessage(messages[i]);
		}
	}
	
	ClientImpl.prototype._deframeMessages = function(data) {
		var byteArray = new Uint8Array(data);
	    if (this.receiveBuffer) {
	        var newData = new Uint8Array(this.receiveBuffer.length+byteArray.length);
	        newData.set(this.receiveBuffer);
	        newData.set(byteArray,this.receiveBuffer.length);
	        byteArray = newData;
	        delete this.receiveBuffer;
	    }
		try {
		    var offset = 0;
		    var messages = [];
		    while(offset < byteArray.length) {
		        var result = decodeMessage(byteArray,offset);
		        var wireMessage = result[0];
		        offset = result[1];
		        if (wireMessage !== null) {
		            messages.push(wireMessage);
		        } else {
		            break;
		        }
		    }
		    if (offset < byteArray.length) {
		    	this.receiveBuffer = byteArray.subarray(offset);
		    }
		} catch (error) {
			this._disconnected(ERROR.INTERNAL_ERROR.code , format(ERROR.INTERNAL_ERROR, [error.message,error.stack.toString()]));
			return;
		}
		return messages;
	}
	
	ClientImpl.prototype._handleMessage = function(wireMessage) {
		
		this._trace("Client._handleMessage", wireMessage);

		try {
			switch(wireMessage.type) {
			case MESSAGE_TYPE.CONNACK:
				this._connectTimeout.cancel();
				
				// If we have started using clean session then clear up the local state.
				if (this.connectOptions.cleanSession) {
					for (var key in this._sentMessages) {	    		
						var sentMessage = this._sentMessages[key];
						localStorage.removeItem("Sent:"+this._localKey+sentMessage.messageIdentifier);
					}
					this._sentMessages = {};

					for (var key in this._receivedMessages) {
						var receivedMessage = this._receivedMessages[key];
						localStorage.removeItem("Received:"+this._localKey+receivedMessage.messageIdentifier);
					}
					this._receivedMessages = {};
				}
				// Client connected and ready for business.
				if (wireMessage.returnCode === 0) {
					this.connected = true;
					// Jump to the end of the list of uris and stop looking for a good host.
					if (this.connectOptions.uris)
						this.hostIndex = this.connectOptions.uris.length;
				} else {
					this._disconnected(ERROR.CONNACK_RETURNCODE.code , format(ERROR.CONNACK_RETURNCODE, [wireMessage.returnCode, CONNACK_RC[wireMessage.returnCode]]));
					break;
				}
				
				// Resend messages.
				var sequencedMessages = new Array();
				for (var msgId in this._sentMessages) {
					if (this._sentMessages.hasOwnProperty(msgId))
						sequencedMessages.push(this._sentMessages[msgId]);
				}
		  
				// Sort sentMessages into the original sent order.
				var sequencedMessages = sequencedMessages.sort(function(a,b) {return a.sequence - b.sequence;} );
				for (var i=0, len=sequencedMessages.length; i<len; i++) {
					var sentMessage = sequencedMessages[i];
					if (sentMessage.type == MESSAGE_TYPE.PUBLISH && sentMessage.pubRecReceived) {
						var pubRelMessage = new WireMessage(MESSAGE_TYPE.PUBREL, {messageIdentifier:sentMessage.messageIdentifier});
						this._schedule_message(pubRelMessage);
					} else {
						this._schedule_message(sentMessage);
					};
				}

				// Execute the connectOptions.onSuccess callback if there is one.
				if (this.connectOptions.onSuccess) {
					this.connectOptions.onSuccess({invocationContext:this.connectOptions.invocationContext});
				}

				// Process all queued messages now that the connection is established. 
				this._process_queue();
				break;
		
			case MESSAGE_TYPE.PUBLISH:
				this._receivePublish(wireMessage);
				break;

			case MESSAGE_TYPE.PUBACK:
				var sentMessage = this._sentMessages[wireMessage.messageIdentifier];
				 // If this is a re flow of a PUBACK after we have restarted receivedMessage will not exist.
				if (sentMessage) {
					delete this._sentMessages[wireMessage.messageIdentifier];
					localStorage.removeItem("Sent:"+this._localKey+wireMessage.messageIdentifier);
					if (this.onMessageDelivered)
						this.onMessageDelivered(sentMessage.payloadMessage);
				}
				break;
			
			case MESSAGE_TYPE.PUBREC:
				var sentMessage = this._sentMessages[wireMessage.messageIdentifier];
				// If this is a re flow of a PUBREC after we have restarted receivedMessage will not exist.
				if (sentMessage) {
					sentMessage.pubRecReceived = true;
					var pubRelMessage = new WireMessage(MESSAGE_TYPE.PUBREL, {messageIdentifier:wireMessage.messageIdentifier});
					this.store("Sent:", sentMessage);
					this._schedule_message(pubRelMessage);
				}
				break;
								
			case MESSAGE_TYPE.PUBREL:
				var receivedMessage = this._receivedMessages[wireMessage.messageIdentifier];
				localStorage.removeItem("Received:"+this._localKey+wireMessage.messageIdentifier);
				// If this is a re flow of a PUBREL after we have restarted receivedMessage will not exist.
				if (receivedMessage) {
					this._receiveMessage(receivedMessage);
					delete this._receivedMessages[wireMessage.messageIdentifier];
				}
				// Always flow PubComp, we may have previously flowed PubComp but the server lost it and restarted.
				var pubCompMessage = new WireMessage(MESSAGE_TYPE.PUBCOMP, {messageIdentifier:wireMessage.messageIdentifier});
				this._schedule_message(pubCompMessage);                    
				break;

			case MESSAGE_TYPE.PUBCOMP: 
				var sentMessage = this._sentMessages[wireMessage.messageIdentifier];
				delete this._sentMessages[wireMessage.messageIdentifier];
				localStorage.removeItem("Sent:"+this._localKey+wireMessage.messageIdentifier);
				if (this.onMessageDelivered)
					this.onMessageDelivered(sentMessage.payloadMessage);
				break;
				
			case MESSAGE_TYPE.SUBACK:
				var sentMessage = this._sentMessages[wireMessage.messageIdentifier];
				if (sentMessage) {
					if(sentMessage.timeOut)
						sentMessage.timeOut.cancel();
					// This will need to be fixed when we add multiple topic support
          			if (wireMessage.returnCode[0] === 0x80) {
						if (sentMessage.onFailure) {
							sentMessage.onFailure(wireMessage.returnCode);
						} 
					} else if (sentMessage.onSuccess) {
						sentMessage.onSuccess(wireMessage.returnCode);
					}
					delete this._sentMessages[wireMessage.messageIdentifier];
				}
				break;
				
			case MESSAGE_TYPE.UNSUBACK:
				var sentMessage = this._sentMessages[wireMessage.messageIdentifier];
				if (sentMessage) { 
					if (sentMessage.timeOut)
						sentMessage.timeOut.cancel();
					if (sentMessage.callback) {
						sentMessage.callback();
					}
					delete this._sentMessages[wireMessage.messageIdentifier];
				}

				break;
				
			case MESSAGE_TYPE.PINGRESP:
				/* The sendPinger or receivePinger may have sent a ping, the receivePinger has already been reset. */
				this.sendPinger.reset();
				break;
				
			case MESSAGE_TYPE.DISCONNECT:
				// Clients do not expect to receive disconnect packets.
				this._disconnected(ERROR.INVALID_MQTT_MESSAGE_TYPE.code , format(ERROR.INVALID_MQTT_MESSAGE_TYPE, [wireMessage.type]));
				break;

			default:
				this._disconnected(ERROR.INVALID_MQTT_MESSAGE_TYPE.code , format(ERROR.INVALID_MQTT_MESSAGE_TYPE, [wireMessage.type]));
			};
		} catch (error) {
			this._disconnected(ERROR.INTERNAL_ERROR.code , format(ERROR.INTERNAL_ERROR, [error.message,error.stack.toString()]));
			return;
		}
	};
	
	/** @ignore */
	ClientImpl.prototype._on_socket_error = function (error) {
		this._disconnected(ERROR.SOCKET_ERROR.code , format(ERROR.SOCKET_ERROR, [error.data]));
	};

	/** @ignore */
	ClientImpl.prototype._on_socket_close = function () {
		this._disconnected(ERROR.SOCKET_CLOSE.code , format(ERROR.SOCKET_CLOSE));
	};

	/** @ignore */
	ClientImpl.prototype._socket_send = function (wireMessage) {
		
		if (wireMessage.type == 1) {
			var wireMessageMasked = this._traceMask(wireMessage, "password"); 
			this._trace("Client._socket_send", wireMessageMasked);
		}
		else this._trace("Client._socket_send", wireMessage);
		
		this.socket.send(wireMessage.encode());
		/* We have proved to the server we are alive. */
		this.sendPinger.reset();
	};
	
	/** @ignore */
	ClientImpl.prototype._receivePublish = function (wireMessage) {
		switch(wireMessage.payloadMessage.qos) {
			case "undefined":
			case 0:
				this._receiveMessage(wireMessage);
				break;

			case 1:
				var pubAckMessage = new WireMessage(MESSAGE_TYPE.PUBACK, {messageIdentifier:wireMessage.messageIdentifier});
				this._schedule_message(pubAckMessage);
				this._receiveMessage(wireMessage);
				break;

			case 2:
				this._receivedMessages[wireMessage.messageIdentifier] = wireMessage;
				this.store("Received:", wireMessage);
				var pubRecMessage = new WireMessage(MESSAGE_TYPE.PUBREC, {messageIdentifier:wireMessage.messageIdentifier});
				this._schedule_message(pubRecMessage);

				break;

			default:
				throw Error("Invaild qos="+wireMmessage.payloadMessage.qos);
		};
	};

	/** @ignore */
	ClientImpl.prototype._receiveMessage = function (wireMessage) {
		if (this.onMessageArrived) {
			this.onMessageArrived(wireMessage.payloadMessage);
		}
	};

	/**
	 * Client has disconnected either at its own request or because the server
	 * or network disconnected it. Remove all non-durable state.
	 * @param {errorCode} [number] the error number.
	 * @param {errorText} [string] the error text.
	 * @ignore
	 */
	ClientImpl.prototype._disconnected = function (errorCode, errorText) {
		this._trace("Client._disconnected", errorCode, errorText);
		
		this.sendPinger.cancel();
		this.receivePinger.cancel();
		if (this._connectTimeout)
			this._connectTimeout.cancel();
		// Clear message buffers.
		this._msg_queue = [];
		this._notify_msg_sent = {};
	   
		if (this.socket) {
			// Cancel all socket callbacks so that they cannot be driven again by this socket.
			this.socket.onopen = null;
			this.socket.onmessage = null;
			this.socket.onerror = null;
			this.socket.onclose = null;
			if (this.socket.readyState === 1)
				this.socket.close();
			delete this.socket;           
		}
		
		if (this.connectOptions.uris && this.hostIndex < this.connectOptions.uris.length-1) {
			// Try the next host.
			this.hostIndex++;
			this._doConnect(this.connectOptions.uris[this.hostIndex]);
		
		} else {
		
			if (errorCode === undefined) {
				errorCode = ERROR.OK.code;
				errorText = format(ERROR.OK);
			}
			
			// Run any application callbacks last as they may attempt to reconnect and hence create a new socket.
			if (this.connected) {
				this.connected = false;
				// Execute the connectionLostCallback if there is one, and we were connected.       
				if (this.onConnectionLost)
					this.onConnectionLost({errorCode:errorCode, errorMessage:errorText});      	
			} else {
				// Otherwise we never had a connection, so indicate that the connect has failed.
				if (this.connectOptions.mqttVersion === 4 && this.connectOptions.mqttVersionExplicit === false) {
					this._trace("Failed to connect V4, dropping back to V3")
					this.connectOptions.mqttVersion = 3;
					if (this.connectOptions.uris) {
						this.hostIndex = 0;
						this._doConnect(this.connectOptions.uris[0]);  
					} else {
						this._doConnect(this.uri);
					}	
				} else if(this.connectOptions.onFailure) {
					this.connectOptions.onFailure({invocationContext:this.connectOptions.invocationContext, errorCode:errorCode, errorMessage:errorText});
				}
			}
		}
	};

	/** @ignore */
	ClientImpl.prototype._trace = function () {
		// Pass trace message back to client's callback function
		if (this.traceFunction) {
			for (var i in arguments)
			{	
				if (typeof arguments[i] !== "undefined")
					arguments[i] = JSON.stringify(arguments[i]);
			}
			var record = Array.prototype.slice.call(arguments).join("");
			this.traceFunction ({severity: "Debug", message: record	});
		}

		//buffer style trace
		if ( this._traceBuffer !== null ) {  
			for (var i = 0, max = arguments.length; i < max; i++) {
				if ( this._traceBuffer.length == this._MAX_TRACE_ENTRIES ) {    
					this._traceBuffer.shift();              
				}
				if (i === 0) this._traceBuffer.push(arguments[i]);
				else if (typeof arguments[i] === "undefined" ) this._traceBuffer.push(arguments[i]);
				else this._traceBuffer.push("  "+JSON.stringify(arguments[i]));
		   };
		};
	};
	
	/** @ignore */
	ClientImpl.prototype._traceMask = function (traceObject, masked) {
		var traceObjectMasked = {};
		for (var attr in traceObject) {
			if (traceObject.hasOwnProperty(attr)) {
				if (attr == masked) 
					traceObjectMasked[attr] = "******";
				else
					traceObjectMasked[attr] = traceObject[attr];
			} 
		}
		return traceObjectMasked;
	};

	// ------------------------------------------------------------------------
	// Public Programming interface.
	// ------------------------------------------------------------------------
	
	/** 
	 * The JavaScript application communicates to the server using a {@link Paho.MQTT.Client} object. 
	 * <p>
	 * Most applications will create just one Client object and then call its connect() method,
	 * however applications can create more than one Client object if they wish. 
	 * In this case the combination of host, port and clientId attributes must be different for each Client object.
	 * <p>
	 * The send, subscribe and unsubscribe methods are implemented as asynchronous JavaScript methods 
	 * (even though the underlying protocol exchange might be synchronous in nature). 
	 * This means they signal their completion by calling back to the application, 
	 * via Success or Failure callback functions provided by the application on the method in question. 
	 * Such callbacks are called at most once per method invocation and do not persist beyond the lifetime 
	 * of the script that made the invocation.
	 * <p>
	 * In contrast there are some callback functions, most notably <i>onMessageArrived</i>, 
	 * that are defined on the {@link Paho.MQTT.Client} object.  
	 * These may get called multiple times, and aren't directly related to specific method invocations made by the client. 
	 *
	 * @name Paho.MQTT.Client    
	 * 
	 * @constructor
	 *  
	 * @param {string} host - the address of the messaging server, as a fully qualified WebSocket URI, as a DNS name or dotted decimal IP address.
	 * @param {number} port - the port number to connect to - only required if host is not a URI
	 * @param {string} path - the path on the host to connect to - only used if host is not a URI. Default: '/mqtt'.
	 * @param {string} clientId - the Messaging client identifier, between 1 and 23 characters in length.
	 * 
	 * @property {string} host - <i>read only</i> the server's DNS hostname or dotted decimal IP address.
	 * @property {number} port - <i>read only</i> the server's port.
	 * @property {string} path - <i>read only</i> the server's path.
	 * @property {string} clientId - <i>read only</i> used when connecting to the server.
	 * @property {function} onConnectionLost - called when a connection has been lost. 
	 *                            after a connect() method has succeeded.
	 *                            Establish the call back used when a connection has been lost. The connection may be
	 *                            lost because the client initiates a disconnect or because the server or network 
	 *                            cause the client to be disconnected. The disconnect call back may be called without 
	 *                            the connectionComplete call back being invoked if, for example the client fails to 
	 *                            connect.
	 *                            A single response object parameter is passed to the onConnectionLost callback containing the following fields:
	 *                            <ol>   
	 *                            <li>errorCode
	 *                            <li>errorMessage       
	 *                            </ol>
	 * @property {function} onMessageDelivered called when a message has been delivered. 
	 *                            All processing that this Client will ever do has been completed. So, for example,
	 *                            in the case of a Qos=2 message sent by this client, the PubComp flow has been received from the server
	 *                            and the message has been removed from persistent storage before this callback is invoked. 
	 *                            Parameters passed to the onMessageDelivered callback are:
	 *                            <ol>   
	 *                            <li>{@link Paho.MQTT.Message} that was delivered.
	 *                            </ol>    
	 * @property {function} onMessageArrived called when a message has arrived in this Paho.MQTT.client. 
	 *                            Parameters passed to the onMessageArrived callback are:
	 *                            <ol>   
	 *                            <li>{@link Paho.MQTT.Message} that has arrived.
	 *                            </ol>    
	 */
	var Client = function (host, port, path, clientId) {
	    
	    var uri;
	    
		if (typeof host !== "string")
			throw new Error(format(ERROR.INVALID_TYPE, [typeof host, "host"]));
	    
	    if (arguments.length == 2) {
	        // host: must be full ws:// uri
	        // port: clientId
	        clientId = port;
	        uri = host;
	        var match = uri.match(/^(wss?):\/\/((\[(.+)\])|([^\/]+?))(:(\d+))?(\/.*)$/);
	        if (match) {
	            host = match[4]||match[2];
	            port = parseInt(match[7]);
	            path = match[8];
	        } else {
	            throw new Error(format(ERROR.INVALID_ARGUMENT,[host,"host"]));
	        }
	    } else {
	        if (arguments.length == 3) {
				clientId = path;
				path = "/mqtt";
			}
			if (typeof port !== "number" || port < 0)
				throw new Error(format(ERROR.INVALID_TYPE, [typeof port, "port"]));
			if (typeof path !== "string")
				throw new Error(format(ERROR.INVALID_TYPE, [typeof path, "path"]));
			
			var ipv6AddSBracket = (host.indexOf(":") != -1 && host.slice(0,1) != "[" && host.slice(-1) != "]");
			uri = "ws://"+(ipv6AddSBracket?"["+host+"]":host)+":"+port+path;
		}

		var clientIdLength = 0;
		for (var i = 0; i<clientId.length; i++) {
			var charCode = clientId.charCodeAt(i);                   
			if (0xD800 <= charCode && charCode <= 0xDBFF)  {    			
				 i++; // Surrogate pair.
			}   		   
			clientIdLength++;
		}     	   	
		if (typeof clientId !== "string" || clientIdLength > 65535)
			throw new Error(format(ERROR.INVALID_ARGUMENT, [clientId, "clientId"])); 
		
		var client = new ClientImpl(uri, host, port, path, clientId);
		this._getHost =  function() { return host; };
		this._setHost = function() { throw new Error(format(ERROR.UNSUPPORTED_OPERATION)); };
			
		this._getPort = function() { return port; };
		this._setPort = function() { throw new Error(format(ERROR.UNSUPPORTED_OPERATION)); };

		this._getPath = function() { return path; };
		this._setPath = function() { throw new Error(format(ERROR.UNSUPPORTED_OPERATION)); };

		this._getURI = function() { return uri; };
		this._setURI = function() { throw new Error(format(ERROR.UNSUPPORTED_OPERATION)); };
		
		this._getClientId = function() { return client.clientId; };
		this._setClientId = function() { throw new Error(format(ERROR.UNSUPPORTED_OPERATION)); };
		
		this._getOnConnectionLost = function() { return client.onConnectionLost; };
		this._setOnConnectionLost = function(newOnConnectionLost) { 
			if (typeof newOnConnectionLost === "function")
				client.onConnectionLost = newOnConnectionLost;
			else 
				throw new Error(format(ERROR.INVALID_TYPE, [typeof newOnConnectionLost, "onConnectionLost"]));
		};

		this._getOnMessageDelivered = function() { return client.onMessageDelivered; };
		this._setOnMessageDelivered = function(newOnMessageDelivered) { 
			if (typeof newOnMessageDelivered === "function")
				client.onMessageDelivered = newOnMessageDelivered;
			else 
				throw new Error(format(ERROR.INVALID_TYPE, [typeof newOnMessageDelivered, "onMessageDelivered"]));
		};
	   
		this._getOnMessageArrived = function() { return client.onMessageArrived; };
		this._setOnMessageArrived = function(newOnMessageArrived) { 
			if (typeof newOnMessageArrived === "function")
				client.onMessageArrived = newOnMessageArrived;
			else 
				throw new Error(format(ERROR.INVALID_TYPE, [typeof newOnMessageArrived, "onMessageArrived"]));
		};

		this._getTrace = function() { return client.traceFunction; };
		this._setTrace = function(trace) {
			if(typeof trace === "function"){
				client.traceFunction = trace;
			}else{
				throw new Error(format(ERROR.INVALID_TYPE, [typeof trace, "onTrace"]));
			}
		};
		
		/** 
		 * Connect this Messaging client to its server. 
		 * 
		 * @name Paho.MQTT.Client#connect
		 * @function
		 * @param {Object} connectOptions - attributes used with the connection. 
		 * @param {number} connectOptions.timeout - If the connect has not succeeded within this 
		 *                    number of seconds, it is deemed to have failed.
		 *                    The default is 30 seconds.
		 * @param {string} connectOptions.userName - Authentication username for this connection.
		 * @param {string} connectOptions.password - Authentication password for this connection.
		 * @param {Paho.MQTT.Message} connectOptions.willMessage - sent by the server when the client
		 *                    disconnects abnormally.
		 * @param {Number} connectOptions.keepAliveInterval - the server disconnects this client if
		 *                    there is no activity for this number of seconds.
		 *                    The default value of 60 seconds is assumed if not set.
		 * @param {boolean} connectOptions.cleanSession - if true(default) the client and server 
		 *                    persistent state is deleted on successful connect.
		 * @param {boolean} connectOptions.useSSL - if present and true, use an SSL Websocket connection.
		 * @param {object} connectOptions.invocationContext - passed to the onSuccess callback or onFailure callback.
		 * @param {function} connectOptions.onSuccess - called when the connect acknowledgement 
		 *                    has been received from the server.
		 * A single response object parameter is passed to the onSuccess callback containing the following fields:
		 * <ol>
		 * <li>invocationContext as passed in to the onSuccess method in the connectOptions.       
		 * </ol>
		 * @config {function} [onFailure] called when the connect request has failed or timed out.
		 * A single response object parameter is passed to the onFailure callback containing the following fields:
		 * <ol>
		 * <li>invocationContext as passed in to the onFailure method in the connectOptions.       
		 * <li>errorCode a number indicating the nature of the error.
		 * <li>errorMessage text describing the error.      
		 * </ol>
		 * @config {Array} [hosts] If present this contains either a set of hostnames or fully qualified
		 * WebSocket URIs (ws://example.com:1883/mqtt), that are tried in order in place 
		 * of the host and port paramater on the construtor. The hosts are tried one at at time in order until
		 * one of then succeeds.
		 * @config {Array} [ports] If present the set of ports matching the hosts. If hosts contains URIs, this property
		 * is not used.
		 * @throws {InvalidState} if the client is not in disconnected state. The client must have received connectionLost
		 * or disconnected before calling connect for a second or subsequent time.
		 */
		this.connect = function (connectOptions) {
			connectOptions = connectOptions || {} ;
			validate(connectOptions,  {timeout:"number",
									   userName:"string", 
									   password:"string", 
									   willMessage:"object", 
									   keepAliveInterval:"number", 
									   cleanSession:"boolean", 
									   useSSL:"boolean",
									   invocationContext:"object", 
									   onSuccess:"function", 
									   onFailure:"function",
									   hosts:"object",
									   ports:"object",
									   mqttVersion:"number",
									   mqttVersionExplicit:"boolean",
									   uris: "object"});
			
			// If no keep alive interval is set, assume 60 seconds.
			if (connectOptions.keepAliveInterval === undefined)
				connectOptions.keepAliveInterval = 60;

			if (connectOptions.mqttVersion > 4 || connectOptions.mqttVersion < 3) {
				throw new Error(format(ERROR.INVALID_ARGUMENT, [connectOptions.mqttVersion, "connectOptions.mqttVersion"]));
			}

			if (connectOptions.mqttVersion === undefined) {
				connectOptions.mqttVersionExplicit = false;
				connectOptions.mqttVersion = 4;
			} else {
				connectOptions.mqttVersionExplicit = true;
			}

			//Check that if password is set, so is username
			if (connectOptions.password !== undefined && connectOptions.userName === undefined)
				throw new Error(format(ERROR.INVALID_ARGUMENT, [connectOptions.password, "connectOptions.password"]))

			if (connectOptions.willMessage) {
				if (!(connectOptions.willMessage instanceof Message))
					throw new Error(format(ERROR.INVALID_TYPE, [connectOptions.willMessage, "connectOptions.willMessage"]));
				// The will message must have a payload that can be represented as a string.
				// Cause the willMessage to throw an exception if this is not the case.
				connectOptions.willMessage.stringPayload;
				
				if (typeof connectOptions.willMessage.destinationName === "undefined")
					throw new Error(format(ERROR.INVALID_TYPE, [typeof connectOptions.willMessage.destinationName, "connectOptions.willMessage.destinationName"]));
			}
			if (typeof connectOptions.cleanSession === "undefined")
				connectOptions.cleanSession = true;
			if (connectOptions.hosts) {
			    
				if (!(connectOptions.hosts instanceof Array) )
					throw new Error(format(ERROR.INVALID_ARGUMENT, [connectOptions.hosts, "connectOptions.hosts"]));
				if (connectOptions.hosts.length <1 )
					throw new Error(format(ERROR.INVALID_ARGUMENT, [connectOptions.hosts, "connectOptions.hosts"]));
				
				var usingURIs = false;
				for (var i = 0; i<connectOptions.hosts.length; i++) {
					if (typeof connectOptions.hosts[i] !== "string")
						throw new Error(format(ERROR.INVALID_TYPE, [typeof connectOptions.hosts[i], "connectOptions.hosts["+i+"]"]));
					if (/^(wss?):\/\/((\[(.+)\])|([^\/]+?))(:(\d+))?(\/.*)$/.test(connectOptions.hosts[i])) {
						if (i == 0) {
							usingURIs = true;
						} else if (!usingURIs) {
							throw new Error(format(ERROR.INVALID_ARGUMENT, [connectOptions.hosts[i], "connectOptions.hosts["+i+"]"]));
						}
					} else if (usingURIs) {
						throw new Error(format(ERROR.INVALID_ARGUMENT, [connectOptions.hosts[i], "connectOptions.hosts["+i+"]"]));
					}
				}
				
				if (!usingURIs) {
					if (!connectOptions.ports)
						throw new Error(format(ERROR.INVALID_ARGUMENT, [connectOptions.ports, "connectOptions.ports"]));
					if (!(connectOptions.ports instanceof Array) )
						throw new Error(format(ERROR.INVALID_ARGUMENT, [connectOptions.ports, "connectOptions.ports"]));
					if (connectOptions.hosts.length != connectOptions.ports.length)
						throw new Error(format(ERROR.INVALID_ARGUMENT, [connectOptions.ports, "connectOptions.ports"]));
					
					connectOptions.uris = [];
					
					for (var i = 0; i<connectOptions.hosts.length; i++) {
						if (typeof connectOptions.ports[i] !== "number" || connectOptions.ports[i] < 0)
							throw new Error(format(ERROR.INVALID_TYPE, [typeof connectOptions.ports[i], "connectOptions.ports["+i+"]"]));
						var host = connectOptions.hosts[i];
						var port = connectOptions.ports[i];
						
						var ipv6 = (host.indexOf(":") != -1);
						uri = "ws://"+(ipv6?"["+host+"]":host)+":"+port+path;
						connectOptions.uris.push(uri);
					}
				} else {
					connectOptions.uris = connectOptions.hosts;
				}
			}
			
			client.connect(connectOptions);
		};
	 
		/** 
		 * Subscribe for messages, request receipt of a copy of messages sent to the destinations described by the filter.
		 * 
		 * @name Paho.MQTT.Client#subscribe
		 * @function
		 * @param {string} filter describing the destinations to receive messages from.
		 * <br>
		 * @param {object} subscribeOptions - used to control the subscription
		 *
		 * @param {number} subscribeOptions.qos - the maiximum qos of any publications sent 
		 *                                  as a result of making this subscription.
		 * @param {object} subscribeOptions.invocationContext - passed to the onSuccess callback 
		 *                                  or onFailure callback.
		 * @param {function} subscribeOptions.onSuccess - called when the subscribe acknowledgement
		 *                                  has been received from the server.
		 *                                  A single response object parameter is passed to the onSuccess callback containing the following fields:
		 *                                  <ol>
		 *                                  <li>invocationContext if set in the subscribeOptions.       
		 *                                  </ol>
		 * @param {function} subscribeOptions.onFailure - called when the subscribe request has failed or timed out.
		 *                                  A single response object parameter is passed to the onFailure callback containing the following fields:
		 *                                  <ol>
		 *                                  <li>invocationContext - if set in the subscribeOptions.       
		 *                                  <li>errorCode - a number indicating the nature of the error.
		 *                                  <li>errorMessage - text describing the error.      
		 *                                  </ol>
		 * @param {number} subscribeOptions.timeout - which, if present, determines the number of
		 *                                  seconds after which the onFailure calback is called.
		 *                                  The presence of a timeout does not prevent the onSuccess
		 *                                  callback from being called when the subscribe completes.         
		 * @throws {InvalidState} if the client is not in connected state.
		 */
		this.subscribe = function (filter, subscribeOptions) {
			if (typeof filter !== "string")
				throw new Error("Invalid argument:"+filter);
			subscribeOptions = subscribeOptions || {} ;
			validate(subscribeOptions,  {qos:"number", 
										 invocationContext:"object", 
										 onSuccess:"function", 
										 onFailure:"function",
										 timeout:"number"
										});
			if (subscribeOptions.timeout && !subscribeOptions.onFailure)
				throw new Error("subscribeOptions.timeout specified with no onFailure callback.");
			if (typeof subscribeOptions.qos !== "undefined" 
				&& !(subscribeOptions.qos === 0 || subscribeOptions.qos === 1 || subscribeOptions.qos === 2 ))
				throw new Error(format(ERROR.INVALID_ARGUMENT, [subscribeOptions.qos, "subscribeOptions.qos"]));
			client.subscribe(filter, subscribeOptions);
		};

		/**
		 * Unsubscribe for messages, stop receiving messages sent to destinations described by the filter.
		 * 
		 * @name Paho.MQTT.Client#unsubscribe
		 * @function
		 * @param {string} filter - describing the destinations to receive messages from.
		 * @param {object} unsubscribeOptions - used to control the subscription
		 * @param {object} unsubscribeOptions.invocationContext - passed to the onSuccess callback 
		                                      or onFailure callback.
		 * @param {function} unsubscribeOptions.onSuccess - called when the unsubscribe acknowledgement has been received from the server.
		 *                                    A single response object parameter is passed to the 
		 *                                    onSuccess callback containing the following fields:
		 *                                    <ol>
		 *                                    <li>invocationContext - if set in the unsubscribeOptions.     
		 *                                    </ol>
		 * @param {function} unsubscribeOptions.onFailure called when the unsubscribe request has failed or timed out.
		 *                                    A single response object parameter is passed to the onFailure callback containing the following fields:
		 *                                    <ol>
		 *                                    <li>invocationContext - if set in the unsubscribeOptions.       
		 *                                    <li>errorCode - a number indicating the nature of the error.
		 *                                    <li>errorMessage - text describing the error.      
		 *                                    </ol>
		 * @param {number} unsubscribeOptions.timeout - which, if present, determines the number of seconds
		 *                                    after which the onFailure callback is called. The presence of
		 *                                    a timeout does not prevent the onSuccess callback from being
		 *                                    called when the unsubscribe completes
		 * @throws {InvalidState} if the client is not in connected state.
		 */
		this.unsubscribe = function (filter, unsubscribeOptions) {
			if (typeof filter !== "string")
				throw new Error("Invalid argument:"+filter);
			unsubscribeOptions = unsubscribeOptions || {} ;
			validate(unsubscribeOptions,  {invocationContext:"object", 
										   onSuccess:"function", 
										   onFailure:"function",
										   timeout:"number"
										  });
			if (unsubscribeOptions.timeout && !unsubscribeOptions.onFailure)
				throw new Error("unsubscribeOptions.timeout specified with no onFailure callback.");
			client.unsubscribe(filter, unsubscribeOptions);
		};

		/**
		 * Send a message to the consumers of the destination in the Message.
		 * 
		 * @name Paho.MQTT.Client#send
		 * @function 
		 * @param {string|Paho.MQTT.Message} topic - <b>mandatory</b> The name of the destination to which the message is to be sent. 
		 * 					   - If it is the only parameter, used as Paho.MQTT.Message object.
		 * @param {String|ArrayBuffer} payload - The message data to be sent. 
		 * @param {number} qos The Quality of Service used to deliver the message.
		 * 		<dl>
		 * 			<dt>0 Best effort (default).
		 *     			<dt>1 At least once.
		 *     			<dt>2 Exactly once.     
		 * 		</dl>
		 * @param {Boolean} retained If true, the message is to be retained by the server and delivered 
		 *                     to both current and future subscriptions.
		 *                     If false the server only delivers the message to current subscribers, this is the default for new Messages. 
		 *                     A received message has the retained boolean set to true if the message was published 
		 *                     with the retained boolean set to true
		 *                     and the subscrption was made after the message has been published. 
		 * @throws {InvalidState} if the client is not connected.
		 */   
		this.send = function (topic,payload,qos,retained) {   
			var message ;  
			
			if(arguments.length == 0){
				throw new Error("Invalid argument."+"length");

			}else if(arguments.length == 1) {

				if (!(topic instanceof Message) && (typeof topic !== "string"))
					throw new Error("Invalid argument:"+ typeof topic);

				message = topic;
				if (typeof message.destinationName === "undefined")
					throw new Error(format(ERROR.INVALID_ARGUMENT,[message.destinationName,"Message.destinationName"]));
				client.send(message); 

			}else {
				//parameter checking in Message object 
				message = new Message(payload);
				message.destinationName = topic;
				if(arguments.length >= 3)
					message.qos = qos;
				if(arguments.length >= 4)
					message.retained = retained;
				client.send(message); 
			}
		};
		
		/** 
		 * Normal disconnect of this Messaging client from its server.
		 * 
		 * @name Paho.MQTT.Client#disconnect
		 * @function
		 * @throws {InvalidState} if the client is already disconnected.     
		 */
		this.disconnect = function () {
			client.disconnect();
		};
		
		/** 
		 * Get the contents of the trace log.
		 * 
		 * @name Paho.MQTT.Client#getTraceLog
		 * @function
		 * @return {Object[]} tracebuffer containing the time ordered trace records.
		 */
		this.getTraceLog = function () {
			return client.getTraceLog();
		}
		
		/** 
		 * Start tracing.
		 * 
		 * @name Paho.MQTT.Client#startTrace
		 * @function
		 */
		this.startTrace = function () {
			client.startTrace();
		};
		
		/** 
		 * Stop tracing.
		 * 
		 * @name Paho.MQTT.Client#stopTrace
		 * @function
		 */
		this.stopTrace = function () {
			client.stopTrace();
		};

		this.isConnected = function() {
			return client.connected;
		};
	};

	Client.prototype = {
		get host() { return this._getHost(); },
		set host(newHost) { this._setHost(newHost); },
			
		get port() { return this._getPort(); },
		set port(newPort) { this._setPort(newPort); },

		get path() { return this._getPath(); },
		set path(newPath) { this._setPath(newPath); },
			
		get clientId() { return this._getClientId(); },
		set clientId(newClientId) { this._setClientId(newClientId); },

		get onConnectionLost() { return this._getOnConnectionLost(); },
		set onConnectionLost(newOnConnectionLost) { this._setOnConnectionLost(newOnConnectionLost); },

		get onMessageDelivered() { return this._getOnMessageDelivered(); },
		set onMessageDelivered(newOnMessageDelivered) { this._setOnMessageDelivered(newOnMessageDelivered); },
		
		get onMessageArrived() { return this._getOnMessageArrived(); },
		set onMessageArrived(newOnMessageArrived) { this._setOnMessageArrived(newOnMessageArrived); },

		get trace() { return this._getTrace(); },
		set trace(newTraceFunction) { this._setTrace(newTraceFunction); }	

	};
	
	/** 
	 * An application message, sent or received.
	 * <p>
	 * All attributes may be null, which implies the default values.
	 * 
	 * @name Paho.MQTT.Message
	 * @constructor
	 * @param {String|ArrayBuffer} payload The message data to be sent.
	 * <p>
	 * @property {string} payloadString <i>read only</i> The payload as a string if the payload consists of valid UTF-8 characters.
	 * @property {ArrayBuffer} payloadBytes <i>read only</i> The payload as an ArrayBuffer.
	 * <p>
	 * @property {string} destinationName <b>mandatory</b> The name of the destination to which the message is to be sent
	 *                    (for messages about to be sent) or the name of the destination from which the message has been received.
	 *                    (for messages received by the onMessage function).
	 * <p>
	 * @property {number} qos The Quality of Service used to deliver the message.
	 * <dl>
	 *     <dt>0 Best effort (default).
	 *     <dt>1 At least once.
	 *     <dt>2 Exactly once.     
	 * </dl>
	 * <p>
	 * @property {Boolean} retained If true, the message is to be retained by the server and delivered 
	 *                     to both current and future subscriptions.
	 *                     If false the server only delivers the message to current subscribers, this is the default for new Messages. 
	 *                     A received message has the retained boolean set to true if the message was published 
	 *                     with the retained boolean set to true
	 *                     and the subscrption was made after the message has been published. 
	 * <p>
	 * @property {Boolean} duplicate <i>read only</i> If true, this message might be a duplicate of one which has already been received. 
	 *                     This is only set on messages received from the server.
	 *                     
	 */
	var Message = function (newPayload) {  
		var payload;
		if (   typeof newPayload === "string" 
			|| newPayload instanceof ArrayBuffer
			|| newPayload instanceof Int8Array
			|| newPayload instanceof Uint8Array
			|| newPayload instanceof Int16Array
			|| newPayload instanceof Uint16Array
			|| newPayload instanceof Int32Array
			|| newPayload instanceof Uint32Array
			|| newPayload instanceof Float32Array
			|| newPayload instanceof Float64Array
		   ) {
			payload = newPayload;
		} else {
			throw (format(ERROR.INVALID_ARGUMENT, [newPayload, "newPayload"]));
		}

		this._getPayloadString = function () {
			if (typeof payload === "string")
				return payload;
			else
				return parseUTF8(payload, 0, payload.length); 
		};

		this._getPayloadBytes = function() {
			if (typeof payload === "string") {
				var buffer = new ArrayBuffer(UTF8Length(payload));
				var byteStream = new Uint8Array(buffer); 
				stringToUTF8(payload, byteStream, 0);

				return byteStream;
			} else {
				return payload;
			};
		};

		var destinationName = undefined;
		this._getDestinationName = function() { return destinationName; };
		this._setDestinationName = function(newDestinationName) { 
			if (typeof newDestinationName === "string")
				destinationName = newDestinationName;
			else 
				throw new Error(format(ERROR.INVALID_ARGUMENT, [newDestinationName, "newDestinationName"]));
		};
				
		var qos = 0;
		this._getQos = function() { return qos; };
		this._setQos = function(newQos) { 
			if (newQos === 0 || newQos === 1 || newQos === 2 )
				qos = newQos;
			else 
				throw new Error("Invalid argument:"+newQos);
		};

		var retained = false;
		this._getRetained = function() { return retained; };
		this._setRetained = function(newRetained) { 
			if (typeof newRetained === "boolean")
				retained = newRetained;
			else 
				throw new Error(format(ERROR.INVALID_ARGUMENT, [newRetained, "newRetained"]));
		};
		
		var duplicate = false;
		this._getDuplicate = function() { return duplicate; };
		this._setDuplicate = function(newDuplicate) { duplicate = newDuplicate; };
	};
	
	Message.prototype = {
		get payloadString() { return this._getPayloadString(); },
		get payloadBytes() { return this._getPayloadBytes(); },
		
		get destinationName() { return this._getDestinationName(); },
		set destinationName(newDestinationName) { this._setDestinationName(newDestinationName); },
		
		get qos() { return this._getQos(); },
		set qos(newQos) { this._setQos(newQos); },

		get retained() { return this._getRetained(); },
		set retained(newRetained) { this._setRetained(newRetained); },

		get duplicate() { return this._getDuplicate(); },
		set duplicate(newDuplicate) { this._setDuplicate(newDuplicate); }
	};
	   
	// Module contents.
	return {
		Client: Client,
		Message: Message
	};
})(window);


/***/ })
],[606]);


// WEBPACK FOOTER //
// app.8ee609d13d5c1ff11997.js